(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
(function (global){
/**
 * @license
 * lodash 3.10.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern -d -o ./index.js`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '3.10.1';

  /** Used to compose bitmasks for wrapper metadata. */
  var BIND_FLAG = 1,
      BIND_KEY_FLAG = 2,
      CURRY_BOUND_FLAG = 4,
      CURRY_FLAG = 8,
      CURRY_RIGHT_FLAG = 16,
      PARTIAL_FLAG = 32,
      PARTIAL_RIGHT_FLAG = 64,
      ARY_FLAG = 128,
      REARG_FLAG = 256;

  /** Used as default options for `_.trunc`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect when a function becomes hot. */
  var HOT_COUNT = 150,
      HOT_SPAN = 16;

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2;

  /** Used as the `TypeError` message for "Functions" methods. */
  var FUNC_ERROR_TEXT = 'Expected a function';

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      objectTag = '[object Object]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      weakMapTag = '[object WeakMap]';

  var arrayBufferTag = '[object ArrayBuffer]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39|#96);/g,
      reUnescapedHtml = /[&<>"'`]/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\n\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\n\\]|\\.)*?)\2)\]/g;

  /**
   * Used to match `RegExp` [syntax characters](http://ecma-international.org/ecma-262/6.0/#sec-patterns)
   * and those outlined by [`EscapeRegExpPattern`](http://ecma-international.org/ecma-262/6.0/#sec-escaperegexppattern).
   */
  var reRegExpChars = /^[:!,]|[\\^$.*+?()[\]{}|\/]|(^[0-9a-fA-Fnrtuvx])|([\n\r\u2028\u2029])/g,
      reHasRegExpChars = RegExp(reRegExpChars.source);

  /** Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks). */
  var reComboMark = /[\u0300-\u036f\ufe20-\ufe23]/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /** Used to match [ES template delimiters](http://ecma-international.org/ecma-262/6.0/#sec-template-literal-lexical-components). */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect hexadecimal string values. */
  var reHasHexPrefix = /^0[xX]/;

  /** Used to detect host constructors (Safari > 5). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^\d+$/;

  /** Used to match latin-1 supplementary letters (excluding mathematical operators). */
  var reLatin1 = /[\xc0-\xd6\xd8-\xde\xdf-\xf6\xf8-\xff]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to match words to create compound words. */
  var reWords = (function() {
    var upper = '[A-Z\\xc0-\\xd6\\xd8-\\xde]',
        lower = '[a-z\\xdf-\\xf6\\xf8-\\xff]+';

    return RegExp(upper + '+(?=' + upper + lower + ')|' + upper + '?' + lower + '|' + upper + '+|[0-9]+', 'g');
  }());

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'ArrayBuffer', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Math', 'Number',
    'Object', 'RegExp', 'Set', 'String', '_', 'clearTimeout', 'isFinite',
    'parseFloat', 'parseInt', 'setTimeout', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dateTag] = typedArrayTags[errorTag] =
  typedArrayTags[funcTag] = typedArrayTags[mapTag] =
  typedArrayTags[numberTag] = typedArrayTags[objectTag] =
  typedArrayTags[regexpTag] = typedArrayTags[setTag] =
  typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[boolTag] =
  cloneableTags[dateTag] = cloneableTags[float32Tag] =
  cloneableTags[float64Tag] = cloneableTags[int8Tag] =
  cloneableTags[int16Tag] = cloneableTags[int32Tag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[stringTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[mapTag] = cloneableTags[setTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map latin-1 supplementary letters to basic latin letters. */
  var deburredLetters = {
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcC': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xeC': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '`': '&#96;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'",
    '&#96;': '`'
  };

  /** Used to determine if values are of the language type `Object`. */
  var objectTypes = {
    'function': true,
    'object': true
  };

  /** Used to escape characters for inclusion in compiled regexes. */
  var regexpEscapes = {
    '0': 'x30', '1': 'x31', '2': 'x32', '3': 'x33', '4': 'x34',
    '5': 'x35', '6': 'x36', '7': 'x37', '8': 'x38', '9': 'x39',
    'A': 'x41', 'B': 'x42', 'C': 'x43', 'D': 'x44', 'E': 'x45', 'F': 'x46',
    'a': 'x61', 'b': 'x62', 'c': 'x63', 'd': 'x64', 'e': 'x65', 'f': 'x66',
    'n': 'x6e', 'r': 'x72', 't': 'x74', 'u': 'x75', 'v': 'x76', 'x': 'x78'
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Detect free variable `exports`. */
  var freeExports = objectTypes[typeof exports] && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = objectTypes[typeof module] && module && !module.nodeType && module;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = freeExports && freeModule && typeof global == 'object' && global && global.Object && global;

  /** Detect free variable `self`. */
  var freeSelf = objectTypes[typeof self] && self && self.Object && self;

  /** Detect free variable `window`. */
  var freeWindow = objectTypes[typeof window] && window && window.Object && window;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports && freeExports;

  /**
   * Used as a reference to the global object.
   *
   * The `this` value is used if it's the global object to avoid Greasemonkey's
   * restricted `window` object, otherwise the `window` object is used.
   */
  var root = freeGlobal || ((freeWindow !== (this && this.window)) && freeWindow) || freeSelf || this;

  /*--------------------------------------------------------------------------*/

  /**
   * The base implementation of `compareAscending` which compares values and
   * sorts them in ascending order without guaranteeing a stable sort.
   *
   * @private
   * @param {*} value The value to compare.
   * @param {*} other The other value to compare.
   * @returns {number} Returns the sort order indicator for `value`.
   */
  function baseCompareAscending(value, other) {
    if (value !== other) {
      var valIsNull = value === null,
          valIsUndef = value === undefined,
          valIsReflexive = value === value;

      var othIsNull = other === null,
          othIsUndef = other === undefined,
          othIsReflexive = other === other;

      if ((value > other && !othIsNull) || !valIsReflexive ||
          (valIsNull && !othIsUndef && othIsReflexive) ||
          (valIsUndef && othIsReflexive)) {
        return 1;
      }
      if ((value < other && !valIsNull) || !othIsReflexive ||
          (othIsNull && !valIsUndef && valIsReflexive) ||
          (othIsUndef && valIsReflexive)) {
        return -1;
      }
    }
    return 0;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for callback shorthands and `this` binding.
   *
   * @private
   * @param {Array} array The array to search.
   * @param {Function} predicate The function invoked per iteration.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromRight) {
    var length = array.length,
        index = fromRight ? length : -1;

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without support for binary searches.
   *
   * @private
   * @param {Array} array The array to search.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    if (value !== value) {
      return indexOfNaN(array, fromIndex);
    }
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isFunction` without support for environments
   * with incorrect `typeof` results.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
   */
  function baseIsFunction(value) {
    // Avoid a Chakra JIT bug in compatibility modes of IE 11.
    // See https://github.com/jashkenas/underscore/issues/1621 for more details.
    return typeof value == 'function' || false;
  }

  /**
   * Converts `value` to a string if it's not one. An empty string is returned
   * for `null` or `undefined` values.
   *
   * @private
   * @param {*} value The value to process.
   * @returns {string} Returns the string.
   */
  function baseToString(value) {
    return value == null ? '' : (value + '');
  }

  /**
   * Used by `_.trim` and `_.trimLeft` to get the index of the first character
   * of `string` that is not found in `chars`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @param {string} chars The characters to find.
   * @returns {number} Returns the index of the first character not found in `chars`.
   */
  function charsLeftIndex(string, chars) {
    var index = -1,
        length = string.length;

    while (++index < length && chars.indexOf(string.charAt(index)) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimRight` to get the index of the last character
   * of `string` that is not found in `chars`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @param {string} chars The characters to find.
   * @returns {number} Returns the index of the last character not found in `chars`.
   */
  function charsRightIndex(string, chars) {
    var index = string.length;

    while (index-- && chars.indexOf(string.charAt(index)) > -1) {}
    return index;
  }

  /**
   * Used by `_.sortBy` to compare transformed elements of a collection and stable
   * sort them in ascending order.
   *
   * @private
   * @param {Object} object The object to compare.
   * @param {Object} other The other object to compare.
   * @returns {number} Returns the sort order indicator for `object`.
   */
  function compareAscending(object, other) {
    return baseCompareAscending(object.criteria, other.criteria) || (object.index - other.index);
  }

  /**
   * Used by `_.sortByOrder` to compare multiple properties of a value to another
   * and stable sort them.
   *
   * If `orders` is unspecified, all valuess are sorted in ascending order. Otherwise,
   * a value is sorted in ascending order if its corresponding order is "asc", and
   * descending if "desc".
   *
   * @private
   * @param {Object} object The object to compare.
   * @param {Object} other The other object to compare.
   * @param {boolean[]} orders The order to sort by for each property.
   * @returns {number} Returns the sort order indicator for `object`.
   */
  function compareMultiple(object, other, orders) {
    var index = -1,
        objCriteria = object.criteria,
        othCriteria = other.criteria,
        length = objCriteria.length,
        ordersLength = orders.length;

    while (++index < length) {
      var result = baseCompareAscending(objCriteria[index], othCriteria[index]);
      if (result) {
        if (index >= ordersLength) {
          return result;
        }
        var order = orders[index];
        return result * ((order === 'asc' || order === true) ? 1 : -1);
      }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://code.google.com/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
  }

  /**
   * Used by `_.deburr` to convert latin-1 supplementary letters to basic latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  function deburrLetter(letter) {
    return deburredLetters[letter];
  }

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeHtmlChar(chr) {
    return htmlEscapes[chr];
  }

  /**
   * Used by `_.escapeRegExp` to escape characters for inclusion in compiled regexes.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @param {string} leadingChar The capture group for a leading character.
   * @param {string} whitespaceChar The capture group for a whitespace character.
   * @returns {string} Returns the escaped character.
   */
  function escapeRegExpChar(chr, leadingChar, whitespaceChar) {
    if (leadingChar) {
      chr = regexpEscapes[chr];
    } else if (whitespaceChar) {
      chr = stringEscapes[chr];
    }
    return '\\' + chr;
  }

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the index at which the first occurrence of `NaN` is found in `array`.
   *
   * @private
   * @param {Array} array The array to search.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched `NaN`, else `-1`.
   */
  function indexOfNaN(array, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 0 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      var other = array[index];
      if (other !== other) {
        return index;
      }
    }
    return -1;
  }

  /**
   * Checks if `value` is object-like.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
   */
  function isObjectLike(value) {
    return !!value && typeof value == 'object';
  }

  /**
   * Used by `trimmedLeftIndex` and `trimmedRightIndex` to determine if a
   * character code is whitespace.
   *
   * @private
   * @param {number} charCode The character code to inspect.
   * @returns {boolean} Returns `true` if `charCode` is whitespace, else `false`.
   */
  function isSpace(charCode) {
    return ((charCode <= 160 && (charCode >= 9 && charCode <= 13) || charCode == 32 || charCode == 160) || charCode == 5760 || charCode == 6158 ||
      (charCode >= 8192 && (charCode <= 8202 || charCode == 8232 || charCode == 8233 || charCode == 8239 || charCode == 8287 || charCode == 12288 || charCode == 65279)));
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = -1,
        result = [];

    while (++index < length) {
      if (array[index] === placeholder) {
        array[index] = PLACEHOLDER;
        result[++resIndex] = index;
      }
    }
    return result;
  }

  /**
   * An implementation of `_.uniq` optimized for sorted arrays without support
   * for callback shorthands and `this` binding.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} [iteratee] The function invoked per iteration.
   * @returns {Array} Returns the new duplicate-value-free array.
   */
  function sortedUniq(array, iteratee) {
    var seen,
        index = -1,
        length = array.length,
        resIndex = -1,
        result = [];

    while (++index < length) {
      var value = array[index],
          computed = iteratee ? iteratee(value, index, array) : value;

      if (!index || seen !== computed) {
        seen = computed;
        result[++resIndex] = value;
      }
    }
    return result;
  }

  /**
   * Used by `_.trim` and `_.trimLeft` to get the index of the first non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the first non-whitespace character.
   */
  function trimmedLeftIndex(string) {
    var index = -1,
        length = string.length;

    while (++index < length && isSpace(string.charCodeAt(index))) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimRight` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedRightIndex(string) {
    var index = string.length;

    while (index-- && isSpace(string.charCodeAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  function unescapeHtmlChar(chr) {
    return htmlUnescapes[chr];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the given `context` object.
   *
   * @static
   * @memberOf _
   * @category Utility
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // using `context` to mock `Date#getTime` use in `_.now`
   * var mock = _.runInContext({
   *   'Date': function() {
   *     return { 'getTime': getTimeMock };
   *   }
   * });
   *
   * // or creating a suped-up `defer` in Node.js
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  function runInContext(context) {
    // Avoid issues with some ES3 environments that attempt to use values, named
    // after built-in constructors like `Object`, for the creation of literals.
    // ES5 clears this up by stating that literals must use built-in constructors.
    // See https://es5.github.io/#x11.1.5 for more details.
    context = context ? _.defaults(root.Object(), context, _.pick(root, contextProps)) : root;

    /** Native constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Number = context.Number,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for native method references. */
    var arrayProto = Array.prototype,
        objectProto = Object.prototype,
        stringProto = String.prototype;

    /** Used to resolve the decompiled source of functions. */
    var fnToString = Function.prototype.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /**
     * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
     * of values.
     */
    var objToString = objectProto.toString;

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Native method references. */
    var ArrayBuffer = context.ArrayBuffer,
        clearTimeout = context.clearTimeout,
        parseFloat = context.parseFloat,
        pow = Math.pow,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        Set = getNative(context, 'Set'),
        setTimeout = context.setTimeout,
        splice = arrayProto.splice,
        Uint8Array = context.Uint8Array,
        WeakMap = getNative(context, 'WeakMap');

    /* Native method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeCreate = getNative(Object, 'create'),
        nativeFloor = Math.floor,
        nativeIsArray = getNative(Array, 'isArray'),
        nativeIsFinite = context.isFinite,
        nativeKeys = getNative(Object, 'keys'),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = getNative(Date, 'now'),
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random;

    /** Used as references for `-Infinity` and `Infinity`. */
    var NEGATIVE_INFINITY = Number.NEGATIVE_INFINITY,
        POSITIVE_INFINITY = Number.POSITIVE_INFINITY;

    /** Used as references for the maximum length and index of an array. */
    var MAX_ARRAY_LENGTH = 4294967295,
        MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
        HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

    /**
     * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
     * of an array-like value.
     */
    var MAX_SAFE_INTEGER = 9007199254740991;

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit chaining.
     * Methods that operate on and return arrays, collections, and functions can
     * be chained together. Methods that retrieve a single value or may return a
     * primitive value will automatically end the chain returning the unwrapped
     * value. Explicit chaining may be enabled using `_.chain`. The execution of
     * chained methods is lazy, that is, execution is deferred until `_#value`
     * is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion. Shortcut
     * fusion is an optimization strategy which merge iteratee calls; this can help
     * to avoid the creation of intermediate data structures and greatly reduce the
     * number of iteratee executions.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `reverse`, `shift`, `slice`, `sort`,
     * `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `compact`, `drop`, `dropRight`, `dropRightWhile`, `dropWhile`, `filter`,
     * `first`, `initial`, `last`, `map`, `pluck`, `reject`, `rest`, `reverse`,
     * `slice`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, `toArray`,
     * and `where`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `at`, `before`, `bind`, `bindAll`, `bindKey`,
     * `callback`, `chain`, `chunk`, `commit`, `compact`, `concat`, `constant`,
     * `countBy`, `create`, `curry`, `debounce`, `defaults`, `defaultsDeep`,
     * `defer`, `delay`, `difference`, `drop`, `dropRight`, `dropRightWhile`,
     * `dropWhile`, `fill`, `filter`, `flatten`, `flattenDeep`, `flow`, `flowRight`,
     * `forEach`, `forEachRight`, `forIn`, `forInRight`, `forOwn`, `forOwnRight`,
     * `functions`, `groupBy`, `indexBy`, `initial`, `intersection`, `invert`,
     * `invoke`, `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`,
     * `matchesProperty`, `memoize`, `merge`, `method`, `methodOf`, `mixin`,
     * `modArgs`, `negate`, `omit`, `once`, `pairs`, `partial`, `partialRight`,
     * `partition`, `pick`, `plant`, `pluck`, `property`, `propertyOf`, `pull`,
     * `pullAt`, `push`, `range`, `rearg`, `reject`, `remove`, `rest`, `restParam`,
     * `reverse`, `set`, `shuffle`, `slice`, `sort`, `sortBy`, `sortByAll`,
     * `sortByOrder`, `splice`, `spread`, `take`, `takeRight`, `takeRightWhile`,
     * `takeWhile`, `tap`, `throttle`, `thru`, `times`, `toArray`, `toPlainObject`,
     * `transform`, `union`, `uniq`, `unshift`, `unzip`, `unzipWith`, `values`,
     * `valuesIn`, `where`, `without`, `wrap`, `xor`, `zip`, `zipObject`, `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clone`, `cloneDeep`,
     * `deburr`, `endsWith`, `escape`, `escapeRegExp`, `every`, `find`, `findIndex`,
     * `findKey`, `findLast`, `findLastIndex`, `findLastKey`, `findWhere`, `first`,
     * `floor`, `get`, `gt`, `gte`, `has`, `identity`, `includes`, `indexOf`,
     * `inRange`, `isArguments`, `isArray`, `isBoolean`, `isDate`, `isElement`,
     * `isEmpty`, `isEqual`, `isError`, `isFinite` `isFunction`, `isMatch`,
     * `isNative`, `isNaN`, `isNull`, `isNumber`, `isObject`, `isPlainObject`,
     * `isRegExp`, `isString`, `isUndefined`, `isTypedArray`, `join`, `kebabCase`,
     * `last`, `lastIndexOf`, `lt`, `lte`, `max`, `min`, `noConflict`, `noop`,
     * `now`, `pad`, `padLeft`, `padRight`, `parseInt`, `pop`, `random`, `reduce`,
     * `reduceRight`, `repeat`, `result`, `round`, `runInContext`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedLastIndex`, `startCase`,
     * `startsWith`, `sum`, `template`, `trim`, `trimLeft`, `trimRight`, `trunc`,
     * `unescape`, `uniqueId`, `value`, and `words`
     *
     * The wrapper method `sample` will return a wrapped value when `n` is provided,
     * otherwise an unwrapped value is returned.
     *
     * @name _
     * @constructor
     * @category Chain
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // returns an unwrapped value
     * wrapped.reduce(function(total, n) {
     *   return total + n;
     * });
     * // => 6
     *
     * // returns a wrapped value
     * var squares = wrapped.map(function(n) {
     *   return n * n;
     * });
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__chain__') && hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The function whose prototype all chaining wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable chaining for all wrapper methods.
     * @param {Array} [actions=[]] Actions to peform to resolve the unwrapped value.
     */
    function LodashWrapper(value, chainAll, actions) {
      this.__wrapped__ = value;
      this.__actions__ = actions || [];
      this.__chain__ = !!chainAll;
    }

    /**
     * An object environment feature flags.
     *
     * @static
     * @memberOf _
     * @type Object
     */
    var support = lodash.support = {};

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB). Change the following template settings to use
     * alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type Object
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type RegExp
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type RegExp
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type RegExp
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type string
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type Object
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type Function
         */
        '_': lodash
      }
    };

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = POSITIVE_INFINITY;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = arrayCopy(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = arrayCopy(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = arrayCopy(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || arrLength < LARGE_ARRAY_SIZE || (arrLength == length && takeCount == length)) {
        return baseWrapperValue((isRight && isArr) ? array.reverse() : array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates a cache object to store key/value pairs.
     *
     * @private
     * @static
     * @name Cache
     * @memberOf _.memoize
     */
    function MapCache() {
      this.__data__ = {};
    }

    /**
     * Removes `key` and its value from the cache.
     *
     * @private
     * @name delete
     * @memberOf _.memoize.Cache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed successfully, else `false`.
     */
    function mapDelete(key) {
      return this.has(key) && delete this.__data__[key];
    }

    /**
     * Gets the cached value for `key`.
     *
     * @private
     * @name get
     * @memberOf _.memoize.Cache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the cached value.
     */
    function mapGet(key) {
      return key == '__proto__' ? undefined : this.__data__[key];
    }

    /**
     * Checks if a cached value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf _.memoize.Cache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapHas(key) {
      return key != '__proto__' && hasOwnProperty.call(this.__data__, key);
    }

    /**
     * Sets `value` to `key` of the cache.
     *
     * @private
     * @name set
     * @memberOf _.memoize.Cache
     * @param {string} key The key of the value to cache.
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache object.
     */
    function mapSet(key, value) {
      if (key != '__proto__') {
        this.__data__[key] = value;
      }
      return this;
    }

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates a cache object to store unique values.
     *
     * @private
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var length = values ? values.length : 0;

      this.data = { 'hash': nativeCreate(null), 'set': new Set };
      while (length--) {
        this.push(values[length]);
      }
    }

    /**
     * Checks if `value` is in `cache` mimicking the return signature of
     * `_.indexOf` by returning `0` if the value is found, else `-1`.
     *
     * @private
     * @param {Object} cache The cache to search.
     * @param {*} value The value to search for.
     * @returns {number} Returns `0` if `value` is found, else `-1`.
     */
    function cacheIndexOf(cache, value) {
      var data = cache.data,
          result = (typeof value == 'string' || isObject(value)) ? data.set.has(value) : data.hash[value];

      return result ? 0 : -1;
    }

    /**
     * Adds `value` to the cache.
     *
     * @private
     * @name push
     * @memberOf SetCache
     * @param {*} value The value to cache.
     */
    function cachePush(value) {
      var data = this.data;
      if (typeof value == 'string' || isObject(value)) {
        data.set.add(value);
      } else {
        data.hash[value] = true;
      }
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates a new array joining `array` with `other`.
     *
     * @private
     * @param {Array} array The array to join.
     * @param {Array} other The other array to join.
     * @returns {Array} Returns the new concatenated array.
     */
    function arrayConcat(array, other) {
      var index = -1,
          length = array.length,
          othIndex = -1,
          othLength = other.length,
          result = Array(length + othLength);

      while (++index < length) {
        result[index] = array[index];
      }
      while (++othIndex < othLength) {
        result[index++] = other[othIndex];
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function arrayCopy(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * A specialized version of `_.forEach` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns `array`.
     */
    function arrayEach(array, iteratee) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        if (iteratee(array[index], index, array) === false) {
          break;
        }
      }
      return array;
    }

    /**
     * A specialized version of `_.forEachRight` for arrays without support for
     * callback shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns `array`.
     */
    function arrayEachRight(array, iteratee) {
      var length = array.length;

      while (length--) {
        if (iteratee(array[length], length, array) === false) {
          break;
        }
      }
      return array;
    }

    /**
     * A specialized version of `_.every` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     */
    function arrayEvery(array, predicate) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        if (!predicate(array[index], index, array)) {
          return false;
        }
      }
      return true;
    }

    /**
     * A specialized version of `baseExtremum` for arrays which invokes `iteratee`
     * with one argument: (value).
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} comparator The function used to compare values.
     * @param {*} exValue The initial extremum value.
     * @returns {*} Returns the extremum value.
     */
    function arrayExtremum(array, iteratee, comparator, exValue) {
      var index = -1,
          length = array.length,
          computed = exValue,
          result = computed;

      while (++index < length) {
        var value = array[index],
            current = +iteratee(value);

        if (comparator(current, computed)) {
          computed = current;
          result = value;
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.filter` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function arrayFilter(array, predicate) {
      var index = -1,
          length = array.length,
          resIndex = -1,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result[++resIndex] = value;
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.map` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function arrayMap(array, iteratee) {
      var index = -1,
          length = array.length,
          result = Array(length);

      while (++index < length) {
        result[index] = iteratee(array[index], index, array);
      }
      return result;
    }

    /**
     * Appends the elements of `values` to `array`.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to append.
     * @returns {Array} Returns `array`.
     */
    function arrayPush(array, values) {
      var index = -1,
          length = values.length,
          offset = array.length;

      while (++index < length) {
        array[offset + index] = values[index];
      }
      return array;
    }

    /**
     * A specialized version of `_.reduce` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @param {boolean} [initFromArray] Specify using the first element of `array`
     *  as the initial value.
     * @returns {*} Returns the accumulated value.
     */
    function arrayReduce(array, iteratee, accumulator, initFromArray) {
      var index = -1,
          length = array.length;

      if (initFromArray && length) {
        accumulator = array[++index];
      }
      while (++index < length) {
        accumulator = iteratee(accumulator, array[index], index, array);
      }
      return accumulator;
    }

    /**
     * A specialized version of `_.reduceRight` for arrays without support for
     * callback shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @param {boolean} [initFromArray] Specify using the last element of `array`
     *  as the initial value.
     * @returns {*} Returns the accumulated value.
     */
    function arrayReduceRight(array, iteratee, accumulator, initFromArray) {
      var length = array.length;
      if (initFromArray && length) {
        accumulator = array[--length];
      }
      while (length--) {
        accumulator = iteratee(accumulator, array[length], length, array);
      }
      return accumulator;
    }

    /**
     * A specialized version of `_.some` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function arraySome(array, predicate) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        if (predicate(array[index], index, array)) {
          return true;
        }
      }
      return false;
    }

    /**
     * A specialized version of `_.sum` for arrays without support for callback
     * shorthands and `this` binding..
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {number} Returns the sum.
     */
    function arraySum(array, iteratee) {
      var length = array.length,
          result = 0;

      while (length--) {
        result += +iteratee(array[length]) || 0;
      }
      return result;
    }

    /**
     * Used by `_.defaults` to customize its `_.assign` use.
     *
     * @private
     * @param {*} objectValue The destination object property value.
     * @param {*} sourceValue The source object property value.
     * @returns {*} Returns the value to assign to the destination object.
     */
    function assignDefaults(objectValue, sourceValue) {
      return objectValue === undefined ? sourceValue : objectValue;
    }

    /**
     * Used by `_.template` to customize its `_.assign` use.
     *
     * **Note:** This function is like `assignDefaults` except that it ignores
     * inherited property values when checking if a property is `undefined`.
     *
     * @private
     * @param {*} objectValue The destination object property value.
     * @param {*} sourceValue The source object property value.
     * @param {string} key The key associated with the object and source values.
     * @param {Object} object The destination object.
     * @returns {*} Returns the value to assign to the destination object.
     */
    function assignOwnDefaults(objectValue, sourceValue, key, object) {
      return (objectValue === undefined || !hasOwnProperty.call(object, key))
        ? sourceValue
        : objectValue;
    }

    /**
     * A specialized version of `_.assign` for customizing assigned values without
     * support for argument juggling, multiple sources, and `this` binding `customizer`
     * functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     */
    function assignWith(object, source, customizer) {
      var index = -1,
          props = keys(source),
          length = props.length;

      while (++index < length) {
        var key = props[index],
            value = object[key],
            result = customizer(value, source[key], key, object, source);

        if ((result === result ? (result !== value) : (value === value)) ||
            (value === undefined && !(key in object))) {
          object[key] = result;
        }
      }
      return object;
    }

    /**
     * The base implementation of `_.assign` without support for argument juggling,
     * multiple sources, and `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return source == null
        ? object
        : baseCopy(source, keys(source), object);
    }

    /**
     * The base implementation of `_.at` without support for string collections
     * and individual key arguments.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {number[]|string[]} props The property names or indexes of elements to pick.
     * @returns {Array} Returns the new array of picked elements.
     */
    function baseAt(collection, props) {
      var index = -1,
          isNil = collection == null,
          isArr = !isNil && isArrayLike(collection),
          length = isArr ? collection.length : 0,
          propsLength = props.length,
          result = Array(propsLength);

      while(++index < propsLength) {
        var key = props[index];
        if (isArr) {
          result[index] = isIndex(key, length) ? collection[key] : undefined;
        } else {
          result[index] = isNil ? undefined : collection[key];
        }
      }
      return result;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property names to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @returns {Object} Returns `object`.
     */
    function baseCopy(source, props, object) {
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];
        object[key] = source[key];
      }
      return object;
    }

    /**
     * The base implementation of `_.callback` which supports specifying the
     * number of arguments to provide to `func`.
     *
     * @private
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {number} [argCount] The number of arguments to provide to `func`.
     * @returns {Function} Returns the callback.
     */
    function baseCallback(func, thisArg, argCount) {
      var type = typeof func;
      if (type == 'function') {
        return thisArg === undefined
          ? func
          : bindCallback(func, thisArg, argCount);
      }
      if (func == null) {
        return identity;
      }
      if (type == 'object') {
        return baseMatches(func);
      }
      return thisArg === undefined
        ? property(func)
        : baseMatchesProperty(func, thisArg);
    }

    /**
     * The base implementation of `_.clone` without support for argument juggling
     * and `this` binding `customizer` functions.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @param {Function} [customizer] The function to customize cloning values.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The object `value` belongs to.
     * @param {Array} [stackA=[]] Tracks traversed source objects.
     * @param {Array} [stackB=[]] Associates clones with source counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, isDeep, customizer, key, object, stackA, stackB) {
      var result;
      if (customizer) {
        result = object ? customizer(value, key, object) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return arrayCopy(value, result);
        }
      } else {
        var tag = objToString.call(value),
            isFunc = tag == funcTag;

        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = initCloneObject(isFunc ? {} : value);
          if (!isDeep) {
            return baseAssign(result, value);
          }
        } else {
          return cloneableTags[tag]
            ? initCloneByTag(value, tag, isDeep)
            : (object ? value : {});
        }
      }
      // Check for circular references and return its corresponding clone.
      stackA || (stackA = []);
      stackB || (stackB = []);

      var length = stackA.length;
      while (length--) {
        if (stackA[length] == value) {
          return stackB[length];
        }
      }
      // Add the source value to the stack of traversed objects and associate it with its clone.
      stackA.push(value);
      stackB.push(result);

      // Recursively populate clone (susceptible to call stack limits).
      (isArr ? arrayEach : baseForOwn)(value, function(subValue, key) {
        result[key] = baseClone(subValue, isDeep, customizer, key, value, stackA, stackB);
      });
      return result;
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} prototype The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(prototype) {
        if (isObject(prototype)) {
          object.prototype = prototype;
          var result = new object;
          object.prototype = undefined;
        }
        return result || {};
      };
    }());

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts an index
     * of where to slice the arguments to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Object} args The arguments provide to `func`.
     * @returns {number} Returns the timer id.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of `_.difference` which accepts a single array
     * of values to exclude.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values) {
      var length = array ? array.length : 0,
          result = [];

      if (!length) {
        return result;
      }
      var index = -1,
          indexOf = getIndexOf(),
          isCommon = indexOf == baseIndexOf,
          cache = (isCommon && values.length >= LARGE_ARRAY_SIZE) ? createCache(values) : null,
          valuesLength = values.length;

      if (cache) {
        indexOf = cacheIndexOf;
        isCommon = false;
        values = cache;
      }
      outer:
      while (++index < length) {
        var value = array[index];

        if (isCommon && value === value) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === value) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (indexOf(values, value, 0) < 0) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object|string} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object|string} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * Gets the extremum value of `collection` invoking `iteratee` for each value
     * in `collection` to generate the criterion by which the value is ranked.
     * The `iteratee` is invoked with three arguments: (value, index|key, collection).
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} comparator The function used to compare values.
     * @param {*} exValue The initial extremum value.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(collection, iteratee, comparator, exValue) {
      var computed = exValue,
          result = computed;

      baseEach(collection, function(value, index, collection) {
        var current = +iteratee(value, index, collection);
        if (comparator(current, computed) || (current === exValue && current === result)) {
          computed = current;
          result = value;
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = start == null ? 0 : (+start || 0);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : (+end || 0);
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : (end >>> 0);
      start >>>= 0;

      while (start < length) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.find`, `_.findLast`, `_.findKey`, and `_.findLastKey`,
     * without support for callback shorthands and `this` binding, which iterates
     * over `collection` using the provided `eachFunc`.
     *
     * @private
     * @param {Array|Object|string} collection The collection to search.
     * @param {Function} predicate The function invoked per iteration.
     * @param {Function} eachFunc The function to iterate over `collection`.
     * @param {boolean} [retKey] Specify returning the key of the found element
     *  instead of the element itself.
     * @returns {*} Returns the found element or its key, else `undefined`.
     */
    function baseFind(collection, predicate, eachFunc, retKey) {
      var result;
      eachFunc(collection, function(value, key, collection) {
        if (predicate(value, key, collection)) {
          result = retKey ? key : value;
          return false;
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with added support for restricting
     * flattening and specifying the start index.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {boolean} [isDeep] Specify a deep flatten.
     * @param {boolean} [isStrict] Restrict flattening to arrays-like objects.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, isDeep, isStrict, result) {
      result || (result = []);

      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index];
        if (isObjectLike(value) && isArrayLike(value) &&
            (isStrict || isArray(value) || isArguments(value))) {
          if (isDeep) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, isDeep, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForIn` and `baseForOwn` which iterates
     * over `object` properties returned by `keysFunc` invoking `iteratee` for
     * each property. Iteratee functions may exit iteration early by explicitly
     * returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forIn` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForIn(object, iteratee) {
      return baseFor(object, iteratee, keysIn);
    }

    /**
     * The base implementation of `_.forOwn` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from those provided.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the new array of filtered property names.
     */
    function baseFunctions(object, props) {
      var index = -1,
          length = props.length,
          resIndex = -1,
          result = [];

      while (++index < length) {
        var key = props[index];
        if (isFunction(object[key])) {
          result[++resIndex] = key;
        }
      }
      return result;
    }

    /**
     * The base implementation of `get` without support for string paths
     * and default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path of the property to get.
     * @param {string} [pathKey] The key representation of path.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path, pathKey) {
      if (object == null) {
        return;
      }
      if (pathKey !== undefined && pathKey in toObject(object)) {
        path = [pathKey];
      }
      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[path[index++]];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `_.isEqual` without support for `this` binding
     * `customizer` functions.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparing values.
     * @param {boolean} [isLoose] Specify performing partial comparisons.
     * @param {Array} [stackA] Tracks traversed `value` objects.
     * @param {Array} [stackB] Tracks traversed `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, customizer, isLoose, stackA, stackB) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, baseIsEqual, customizer, isLoose, stackA, stackB);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Function} [customizer] The function to customize comparing objects.
     * @param {boolean} [isLoose] Specify performing partial comparisons.
     * @param {Array} [stackA=[]] Tracks traversed `value` objects.
     * @param {Array} [stackB=[]] Tracks traversed `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = arrayTag,
          othTag = arrayTag;

      if (!objIsArr) {
        objTag = objToString.call(object);
        if (objTag == argsTag) {
          objTag = objectTag;
        } else if (objTag != objectTag) {
          objIsArr = isTypedArray(object);
        }
      }
      if (!othIsArr) {
        othTag = objToString.call(other);
        if (othTag == argsTag) {
          othTag = objectTag;
        } else if (othTag != objectTag) {
          othIsArr = isTypedArray(other);
        }
      }
      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && !(objIsArr || objIsObj)) {
        return equalByTag(object, other, objTag);
      }
      if (!isLoose) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          return equalFunc(objIsWrapped ? object.value() : object, othIsWrapped ? other.value() : other, customizer, isLoose, stackA, stackB);
        }
      }
      if (!isSameTag) {
        return false;
      }
      // Assume cyclic values are equal.
      // For more information on detecting circular references see https://es5.github.io/#JO.
      stackA || (stackA = []);
      stackB || (stackB = []);

      var length = stackA.length;
      while (length--) {
        if (stackA[length] == object) {
          return stackB[length] == other;
        }
      }
      // Add `object` and `other` to the stack of traversed objects.
      stackA.push(object);
      stackB.push(other);

      var result = (objIsArr ? equalArrays : equalObjects)(object, other, equalFunc, customizer, isLoose, stackA, stackB);

      stackA.pop();
      stackB.pop();

      return result;
    }

    /**
     * The base implementation of `_.isMatch` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} matchData The propery names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparing objects.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = toObject(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var result = customizer ? customizer(objValue, srcValue, key) : undefined;
          if (!(result === undefined ? baseIsEqual(srcValue, objValue, customizer, true) : result)) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.map` without support for callback shorthands
     * and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which does not clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        var key = matchData[0][0],
            value = matchData[0][1];

        return function(object) {
          if (object == null) {
            return false;
          }
          return object[key] === value && (value !== undefined || (key in toObject(object)));
        };
      }
      return function(object) {
        return baseIsMatch(object, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which does not clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to compare.
     * @returns {Function} Returns the new function.
     */
    function baseMatchesProperty(path, srcValue) {
      var isArr = isArray(path),
          isCommon = isKey(path) && isStrictComparable(srcValue),
          pathKey = (path + '');

      path = toPath(path);
      return function(object) {
        if (object == null) {
          return false;
        }
        var key = pathKey;
        object = toObject(object);
        if ((isArr || !isCommon) && !(key in object)) {
          object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
          if (object == null) {
            return false;
          }
          key = last(path);
          object = toObject(object);
        }
        return object[key] === srcValue
          ? (srcValue !== undefined || (key in object))
          : baseIsEqual(srcValue, object[key], undefined, true);
      };
    }

    /**
     * The base implementation of `_.merge` without support for argument juggling,
     * multiple sources, and `this` binding `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Array} [stackA=[]] Tracks traversed source objects.
     * @param {Array} [stackB=[]] Associates values with source counterparts.
     * @returns {Object} Returns `object`.
     */
    function baseMerge(object, source, customizer, stackA, stackB) {
      if (!isObject(object)) {
        return object;
      }
      var isSrcArr = isArrayLike(source) && (isArray(source) || isTypedArray(source)),
          props = isSrcArr ? undefined : keys(source);

      arrayEach(props || source, function(srcValue, key) {
        if (props) {
          key = srcValue;
          srcValue = source[key];
        }
        if (isObjectLike(srcValue)) {
          stackA || (stackA = []);
          stackB || (stackB = []);
          baseMergeDeep(object, source, key, baseMerge, customizer, stackA, stackB);
        }
        else {
          var value = object[key],
              result = customizer ? customizer(value, srcValue, key, object, source) : undefined,
              isCommon = result === undefined;

          if (isCommon) {
            result = srcValue;
          }
          if ((result !== undefined || (isSrcArr && !(key in object))) &&
              (isCommon || (result === result ? (result !== value) : (value === value)))) {
            object[key] = result;
          }
        }
      });
      return object;
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Array} [stackA=[]] Tracks traversed source objects.
     * @param {Array} [stackB=[]] Associates values with source counterparts.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseMergeDeep(object, source, key, mergeFunc, customizer, stackA, stackB) {
      var length = stackA.length,
          srcValue = source[key];

      while (length--) {
        if (stackA[length] == srcValue) {
          object[key] = stackB[length];
          return;
        }
      }
      var value = object[key],
          result = customizer ? customizer(value, srcValue, key, object, source) : undefined,
          isCommon = result === undefined;

      if (isCommon) {
        result = srcValue;
        if (isArrayLike(srcValue) && (isArray(srcValue) || isTypedArray(srcValue))) {
          result = isArray(value)
            ? value
            : (isArrayLike(value) ? arrayCopy(value) : []);
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          result = isArguments(value)
            ? toPlainObject(value)
            : (isPlainObject(value) ? value : {});
        }
        else {
          isCommon = false;
        }
      }
      // Add the source value to the stack of traversed objects and associate
      // it with its merged value.
      stackA.push(srcValue);
      stackB.push(result);

      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        object[key] = mergeFunc(result, srcValue, customizer, stackA, stackB);
      } else if (result === result ? (result !== value) : (value === value)) {
        object[key] = result;
      }
    }

    /**
     * The base implementation of `_.property` without support for deep paths.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @returns {Function} Returns the new function.
     */
    function baseProperty(key) {
      return function(object) {
        return object == null ? undefined : object[key];
      };
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new function.
     */
    function basePropertyDeep(path) {
      var pathKey = (path + '');
      path = toPath(path);
      return function(object) {
        return baseGet(object, path, pathKey);
      };
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * index arguments and capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0;
      while (length--) {
        var index = indexes[length];
        if (index != previous && isIndex(index)) {
          var previous = index;
          splice.call(array, index, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for argument juggling
     * and returning floating-point numbers.
     *
     * @private
     * @param {number} min The minimum possible value.
     * @param {number} max The maximum possible value.
     * @returns {number} Returns the random number.
     */
    function baseRandom(min, max) {
      return min + nativeFloor(nativeRandom() * (max - min + 1));
    }

    /**
     * The base implementation of `_.reduce` and `_.reduceRight` without support
     * for callback shorthands and `this` binding, which iterates over `collection`
     * using the provided `eachFunc`.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {*} accumulator The initial value.
     * @param {boolean} initFromCollection Specify using the first or last element
     *  of `collection` as the initial value.
     * @param {Function} eachFunc The function to iterate over `collection`.
     * @returns {*} Returns the accumulated value.
     */
    function baseReduce(collection, iteratee, accumulator, initFromCollection, eachFunc) {
      eachFunc(collection, function(value, index, collection) {
        accumulator = initFromCollection
          ? (initFromCollection = false, value)
          : iteratee(accumulator, value, index, collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `setData` without support for hot loop detection.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      start = start == null ? 0 : (+start || 0);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : (+end || 0);
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for callback shorthands
     * and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortBy` which uses `comparer` to define
     * the sort order of `array` and replaces criteria objects with their
     * corresponding values.
     *
     * @private
     * @param {Array} array The array to sort.
     * @param {Function} comparer The function to define sort order.
     * @returns {Array} Returns `array`.
     */
    function baseSortBy(array, comparer) {
      var length = array.length;

      array.sort(comparer);
      while (length--) {
        array[length] = array[length].value;
      }
      return array;
    }

    /**
     * The base implementation of `_.sortByOrder` without param guards.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {boolean[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseSortByOrder(collection, iteratees, orders) {
      var callback = getCallback(),
          index = -1;

      iteratees = arrayMap(iteratees, function(iteratee) { return callback(iteratee); });

      var result = baseMap(collection, function(value) {
        var criteria = arrayMap(iteratees, function(iteratee) { return iteratee(value); });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.sum` without support for callback shorthands
     * and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {number} Returns the sum.
     */
    function baseSum(collection, iteratee) {
      var result = 0;
      baseEach(collection, function(value, index, collection) {
        result += +iteratee(value, index, collection) || 0;
      });
      return result;
    }

    /**
     * The base implementation of `_.uniq` without support for callback shorthands
     * and `this` binding.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The function invoked per iteration.
     * @returns {Array} Returns the new duplicate-value-free array.
     */
    function baseUniq(array, iteratee) {
      var index = -1,
          indexOf = getIndexOf(),
          length = array.length,
          isCommon = indexOf == baseIndexOf,
          isLarge = isCommon && length >= LARGE_ARRAY_SIZE,
          seen = isLarge ? createCache() : null,
          result = [];

      if (seen) {
        indexOf = cacheIndexOf;
        isCommon = false;
      } else {
        isLarge = false;
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value, index, array) : value;

        if (isCommon && value === value) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (indexOf(seen, computed, 0) < 0) {
          if (iteratee || isLarge) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.values` and `_.valuesIn` which creates an
     * array of `object` property values corresponding to the property names
     * of `props`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} props The property names to get values for.
     * @returns {Object} Returns the array of property values.
     */
    function baseValues(object, props) {
      var index = -1,
          length = props.length,
          result = Array(length);

      while (++index < length) {
        result[index] = object[props[index]];
      }
      return result;
    }

    /**
     * The base implementation of `_.dropRightWhile`, `_.dropWhile`, `_.takeRightWhile`,
     * and `_.takeWhile` without support for callback shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) && predicate(array[index], index, array)) {}
      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to peform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      var index = -1,
          length = actions.length;

      while (++index < length) {
        var action = actions[index];
        result = action.func.apply(action.thisArg, arrayPush([result], action.args));
      }
      return result;
    }

    /**
     * Performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function binaryIndex(array, value, retHighest) {
      var low = 0,
          high = array ? array.length : low;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if ((retHighest ? (computed <= value) : (computed < value)) && computed !== null) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return binaryIndexBy(array, value, identity, retHighest);
    }

    /**
     * This function is like `binaryIndex` except that it invokes `iteratee` for
     * `value` and each element of `array` to compute their sort ranking. The
     * iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function binaryIndexBy(array, value, iteratee, retHighest) {
      value = iteratee(value);

      var low = 0,
          high = array ? array.length : 0,
          valIsNaN = value !== value,
          valIsNull = value === null,
          valIsUndef = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            isDef = computed !== undefined,
            isReflexive = computed === computed;

        if (valIsNaN) {
          var setLow = isReflexive || retHighest;
        } else if (valIsNull) {
          setLow = isReflexive && isDef && (retHighest || computed != null);
        } else if (valIsUndef) {
          setLow = isReflexive && (retHighest || isDef);
        } else if (computed == null) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * A specialized version of `baseCallback` which only supports `this` binding
     * and specifying the number of arguments to provide to `func`.
     *
     * @private
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {number} [argCount] The number of arguments to provide to `func`.
     * @returns {Function} Returns the callback.
     */
    function bindCallback(func, thisArg, argCount) {
      if (typeof func != 'function') {
        return identity;
      }
      if (thisArg === undefined) {
        return func;
      }
      switch (argCount) {
        case 1: return function(value) {
          return func.call(thisArg, value);
        };
        case 3: return function(value, index, collection) {
          return func.call(thisArg, value, index, collection);
        };
        case 4: return function(accumulator, value, index, collection) {
          return func.call(thisArg, accumulator, value, index, collection);
        };
        case 5: return function(value, other, key, object, source) {
          return func.call(thisArg, value, other, key, object, source);
        };
      }
      return function() {
        return func.apply(thisArg, arguments);
      };
    }

    /**
     * Creates a clone of the given array buffer.
     *
     * @private
     * @param {ArrayBuffer} buffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function bufferClone(buffer) {
      var result = new ArrayBuffer(buffer.byteLength),
          view = new Uint8Array(result);

      view.set(new Uint8Array(buffer));
      return result;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array|Object} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders) {
      var holdersLength = holders.length,
          argsIndex = -1,
          argsLength = nativeMax(args.length - holdersLength, 0),
          leftIndex = -1,
          leftLength = partials.length,
          result = Array(leftLength + argsLength);

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        result[holders[argsIndex]] = args[argsIndex];
      }
      while (argsLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array|Object} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders) {
      var holdersIndex = -1,
          holdersLength = holders.length,
          argsIndex = -1,
          argsLength = nativeMax(args.length - holdersLength, 0),
          rightIndex = -1,
          rightLength = partials.length,
          result = Array(argsLength + rightLength);

      while (++argsIndex < argsLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        result[offset + holders[holdersIndex]] = args[argsIndex++];
      }
      return result;
    }

    /**
     * Creates a `_.countBy`, `_.groupBy`, `_.indexBy`, or `_.partition` function.
     *
     * @private
     * @param {Function} setter The function to set keys and values of the accumulator object.
     * @param {Function} [initializer] The function to initialize the accumulator object.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee, thisArg) {
        var result = initializer ? initializer() : {};
        iteratee = getCallback(iteratee, thisArg, 3);

        if (isArray(collection)) {
          var index = -1,
              length = collection.length;

          while (++index < length) {
            var value = collection[index];
            setter(result, value, iteratee(value, index, collection), collection);
          }
        } else {
          baseEach(collection, function(value, key, collection) {
            setter(result, value, iteratee(value, key, collection), collection);
          });
        }
        return result;
      };
    }

    /**
     * Creates a `_.assign`, `_.defaults`, or `_.merge` function.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return restParam(function(object, sources) {
        var index = -1,
            length = object == null ? 0 : sources.length,
            customizer = length > 2 ? sources[length - 2] : undefined,
            guard = length > 2 ? sources[2] : undefined,
            thisArg = length > 1 ? sources[length - 1] : undefined;

        if (typeof customizer == 'function') {
          customizer = bindCallback(customizer, thisArg, 5);
          length -= 2;
        } else {
          customizer = typeof thisArg == 'function' ? thisArg : undefined;
          length -= (customizer ? 1 : 0);
        }
        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        var length = collection ? getLength(collection) : 0;
        if (!isLength(length)) {
          return eachFunc(collection, iteratee);
        }
        var index = fromRight ? length : -1,
            iterable = toObject(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for `_.forIn` or `_.forInRight`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var iterable = toObject(object),
            props = keysFunc(object),
            length = props.length,
            index = fromRight ? length : -1;

        while ((fromRight ? index-- : ++index < length)) {
          var key = props[index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` and invokes it with the `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to bind.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new bound function.
     */
    function createBindWrapper(func, thisArg) {
      var Ctor = createCtorWrapper(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(thisArg, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a `Set` cache object to optimize linear searches of large arrays.
     *
     * @private
     * @param {Array} [values] The values to cache.
     * @returns {null|Object} Returns the new cache object if `Set` is supported, else `null`.
     */
    function createCache(values) {
      return (nativeCreate && Set) ? new SetCache(values) : null;
    }

    /**
     * Creates a function that produces compound words out of the words in a
     * given string.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        var index = -1,
            array = words(deburr(string)),
            length = array.length,
            result = '';

        while (++index < length) {
          result = callback(result, array[index], index);
        }
        return result;
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtorWrapper(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors.
        // See http://ecma-international.org/ecma-262/6.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a `_.curry` or `_.curryRight` function.
     *
     * @private
     * @param {boolean} flag The curry bit flag.
     * @returns {Function} Returns the new curry function.
     */
    function createCurry(flag) {
      function curryFunc(func, arity, guard) {
        if (guard && isIterateeCall(func, arity, guard)) {
          arity = undefined;
        }
        var result = createWrapper(func, flag, undefined, undefined, undefined, undefined, undefined, arity);
        result.placeholder = curryFunc.placeholder;
        return result;
      }
      return curryFunc;
    }

    /**
     * Creates a `_.defaults` or `_.defaultsDeep` function.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Function} Returns the new defaults function.
     */
    function createDefaults(assigner, customizer) {
      return restParam(function(args) {
        var object = args[0];
        if (object == null) {
          return object;
        }
        args.push(customizer);
        return assigner.apply(undefined, args);
      });
    }

    /**
     * Creates a `_.max` or `_.min` function.
     *
     * @private
     * @param {Function} comparator The function used to compare values.
     * @param {*} exValue The initial extremum value.
     * @returns {Function} Returns the new extremum function.
     */
    function createExtremum(comparator, exValue) {
      return function(collection, iteratee, thisArg) {
        if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
          iteratee = undefined;
        }
        iteratee = getCallback(iteratee, thisArg, 3);
        if (iteratee.length == 1) {
          collection = isArray(collection) ? collection : toIterable(collection);
          var result = arrayExtremum(collection, iteratee, comparator, exValue);
          if (!(collection.length && result === exValue)) {
            return result;
          }
        }
        return baseExtremum(collection, iteratee, comparator, exValue);
      };
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new find function.
     */
    function createFind(eachFunc, fromRight) {
      return function(collection, predicate, thisArg) {
        predicate = getCallback(predicate, thisArg, 3);
        if (isArray(collection)) {
          var index = baseFindIndex(collection, predicate, fromRight);
          return index > -1 ? collection[index] : undefined;
        }
        return baseFind(collection, predicate, eachFunc);
      };
    }

    /**
     * Creates a `_.findIndex` or `_.findLastIndex` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new find function.
     */
    function createFindIndex(fromRight) {
      return function(array, predicate, thisArg) {
        if (!(array && array.length)) {
          return -1;
        }
        predicate = getCallback(predicate, thisArg, 3);
        return baseFindIndex(array, predicate, fromRight);
      };
    }

    /**
     * Creates a `_.findKey` or `_.findLastKey` function.
     *
     * @private
     * @param {Function} objectFunc The function to iterate over an object.
     * @returns {Function} Returns the new find function.
     */
    function createFindKey(objectFunc) {
      return function(object, predicate, thisArg) {
        predicate = getCallback(predicate, thisArg, 3);
        return baseFind(object, predicate, objectFunc, true);
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return function() {
        var wrapper,
            length = arguments.length,
            index = fromRight ? length : -1,
            leftIndex = 0,
            funcs = Array(length);

        while ((fromRight ? index-- : ++index < length)) {
          var func = funcs[leftIndex++] = arguments[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (!wrapper && LodashWrapper.prototype.thru && getFuncName(func) == 'wrapper') {
            wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? -1 : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) && data[1] == (ARY_FLAG | CURRY_FLAG | PARTIAL_FLAG | REARG_FLAG) && !data[4].length && data[9] == 1) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func)) ? wrapper[funcName]() : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value) && value.length >= LARGE_ARRAY_SIZE) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      };
    }

    /**
     * Creates a function for `_.forEach` or `_.forEachRight`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over an array.
     * @param {Function} eachFunc The function to iterate over a collection.
     * @returns {Function} Returns the new each function.
     */
    function createForEach(arrayFunc, eachFunc) {
      return function(collection, iteratee, thisArg) {
        return (typeof iteratee == 'function' && thisArg === undefined && isArray(collection))
          ? arrayFunc(collection, iteratee)
          : eachFunc(collection, bindCallback(iteratee, thisArg, 3));
      };
    }

    /**
     * Creates a function for `_.forIn` or `_.forInRight`.
     *
     * @private
     * @param {Function} objectFunc The function to iterate over an object.
     * @returns {Function} Returns the new each function.
     */
    function createForIn(objectFunc) {
      return function(object, iteratee, thisArg) {
        if (typeof iteratee != 'function' || thisArg !== undefined) {
          iteratee = bindCallback(iteratee, thisArg, 3);
        }
        return objectFunc(object, iteratee, keysIn);
      };
    }

    /**
     * Creates a function for `_.forOwn` or `_.forOwnRight`.
     *
     * @private
     * @param {Function} objectFunc The function to iterate over an object.
     * @returns {Function} Returns the new each function.
     */
    function createForOwn(objectFunc) {
      return function(object, iteratee, thisArg) {
        if (typeof iteratee != 'function' || thisArg !== undefined) {
          iteratee = bindCallback(iteratee, thisArg, 3);
        }
        return objectFunc(object, iteratee);
      };
    }

    /**
     * Creates a function for `_.mapKeys` or `_.mapValues`.
     *
     * @private
     * @param {boolean} [isMapKeys] Specify mapping keys instead of values.
     * @returns {Function} Returns the new map function.
     */
    function createObjectMapper(isMapKeys) {
      return function(object, iteratee, thisArg) {
        var result = {};
        iteratee = getCallback(iteratee, thisArg, 3);

        baseForOwn(object, function(value, key, object) {
          var mapped = iteratee(value, key, object);
          key = isMapKeys ? mapped : key;
          value = isMapKeys ? value : mapped;
          result[key] = value;
        });
        return result;
      };
    }

    /**
     * Creates a function for `_.padLeft` or `_.padRight`.
     *
     * @private
     * @param {boolean} [fromRight] Specify padding from the right.
     * @returns {Function} Returns the new pad function.
     */
    function createPadDir(fromRight) {
      return function(string, length, chars) {
        string = baseToString(string);
        return (fromRight ? string : '') + createPadding(string, length, chars) + (fromRight ? '' : string);
      };
    }

    /**
     * Creates a `_.partial` or `_.partialRight` function.
     *
     * @private
     * @param {boolean} flag The partial bit flag.
     * @returns {Function} Returns the new partial function.
     */
    function createPartial(flag) {
      var partialFunc = restParam(function(func, partials) {
        var holders = replaceHolders(partials, partialFunc.placeholder);
        return createWrapper(func, flag, undefined, partials, holders);
      });
      return partialFunc;
    }

    /**
     * Creates a function for `_.reduce` or `_.reduceRight`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over an array.
     * @param {Function} eachFunc The function to iterate over a collection.
     * @returns {Function} Returns the new each function.
     */
    function createReduce(arrayFunc, eachFunc) {
      return function(collection, iteratee, accumulator, thisArg) {
        var initFromArray = arguments.length < 3;
        return (typeof iteratee == 'function' && thisArg === undefined && isArray(collection))
          ? arrayFunc(collection, iteratee, accumulator, initFromArray)
          : baseReduce(collection, getCallback(iteratee, thisArg, 4), accumulator, initFromArray, eachFunc);
      };
    }

    /**
     * Creates a function that wraps `func` and invokes it with optional `this`
     * binding of, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to reference.
     * @param {number} bitmask The bitmask of flags. See `createWrapper` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybridWrapper(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & ARY_FLAG,
          isBind = bitmask & BIND_FLAG,
          isBindKey = bitmask & BIND_KEY_FLAG,
          isCurry = bitmask & CURRY_FLAG,
          isCurryBound = bitmask & CURRY_BOUND_FLAG,
          isCurryRight = bitmask & CURRY_RIGHT_FLAG,
          Ctor = isBindKey ? undefined : createCtorWrapper(func);

      function wrapper() {
        // Avoid `arguments` object use disqualifying optimizations by
        // converting it to an array before providing it to other functions.
        var length = arguments.length,
            index = length,
            args = Array(length);

        while (index--) {
          args[index] = arguments[index];
        }
        if (partials) {
          args = composeArgs(args, partials, holders);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight);
        }
        if (isCurry || isCurryRight) {
          var placeholder = wrapper.placeholder,
              argsHolders = replaceHolders(args, placeholder);

          length -= argsHolders.length;
          if (length < arity) {
            var newArgPos = argPos ? arrayCopy(argPos) : undefined,
                newArity = nativeMax(arity - length, 0),
                newsHolders = isCurry ? argsHolders : undefined,
                newHoldersRight = isCurry ? undefined : argsHolders,
                newPartials = isCurry ? args : undefined,
                newPartialsRight = isCurry ? undefined : args;

            bitmask |= (isCurry ? PARTIAL_FLAG : PARTIAL_RIGHT_FLAG);
            bitmask &= ~(isCurry ? PARTIAL_RIGHT_FLAG : PARTIAL_FLAG);

            if (!isCurryBound) {
              bitmask &= ~(BIND_FLAG | BIND_KEY_FLAG);
            }
            var newData = [func, bitmask, thisArg, newPartials, newsHolders, newPartialsRight, newHoldersRight, newArgPos, ary, newArity],
                result = createHybridWrapper.apply(undefined, newData);

            if (isLaziable(func)) {
              setData(result, newData);
            }
            result.placeholder = placeholder;
            return result;
          }
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        if (argPos) {
          args = reorder(args, argPos);
        }
        if (isAry && ary < args.length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtorWrapper(func);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates the padding required for `string` based on the given `length`.
     * The `chars` string is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {string} string The string to create padding for.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the pad for `string`.
     */
    function createPadding(string, length, chars) {
      var strLength = string.length;
      length = +length;

      if (strLength >= length || !nativeIsFinite(length)) {
        return '';
      }
      var padLength = length - strLength;
      chars = chars == null ? ' ' : (chars + '');
      return repeat(chars, nativeCeil(padLength / chars.length)).slice(0, padLength);
    }

    /**
     * Creates a function that wraps `func` and invokes it with the optional `this`
     * binding of `thisArg` and the `partials` prepended to those provided to
     * the wrapper.
     *
     * @private
     * @param {Function} func The function to partially apply arguments to.
     * @param {number} bitmask The bitmask of flags. See `createWrapper` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to the new function.
     * @returns {Function} Returns the new bound function.
     */
    function createPartialWrapper(func, bitmask, thisArg, partials) {
      var isBind = bitmask & BIND_FLAG,
          Ctor = createCtorWrapper(func);

      function wrapper() {
        // Avoid `arguments` object use disqualifying optimizations by
        // converting it to an array before providing it `func`.
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength);

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.ceil`, `_.floor`, or `_.round` function.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        precision = precision === undefined ? 0 : (+precision || 0);
        if (precision) {
          precision = pow(10, precision);
          return func(number * precision) / precision;
        }
        return func(number);
      };
    }

    /**
     * Creates a `_.sortedIndex` or `_.sortedLastIndex` function.
     *
     * @private
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {Function} Returns the new index function.
     */
    function createSortedIndex(retHighest) {
      return function(array, value, iteratee, thisArg) {
        var callback = getCallback(iteratee);
        return (iteratee == null && callback === baseCallback)
          ? binaryIndex(array, value, retHighest)
          : binaryIndexBy(array, value, callback(iteratee, thisArg, 1), retHighest);
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to reference.
     * @param {number} bitmask The bitmask of flags.
     *  The bitmask may be composed of the following flags:
     *     1 - `_.bind`
     *     2 - `_.bindKey`
     *     4 - `_.curry` or `_.curryRight` of a bound function
     *     8 - `_.curry`
     *    16 - `_.curryRight`
     *    32 - `_.partial`
     *    64 - `_.partialRight`
     *   128 - `_.rearg`
     *   256 - `_.ary`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrapper(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(PARTIAL_FLAG | PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      length -= (holders ? holders.length : 0);
      if (bitmask & PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func),
          newData = [func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity];

      if (data) {
        mergeData(newData, data);
        bitmask = newData[1];
        arity = newData[9];
      }
      newData[9] = arity == null
        ? (isBindKey ? 0 : func.length)
        : (nativeMax(arity - length, 0) || 0);

      if (bitmask == BIND_FLAG) {
        var result = createBindWrapper(newData[0], newData[2]);
      } else if ((bitmask == PARTIAL_FLAG || bitmask == (BIND_FLAG | PARTIAL_FLAG)) && !newData[4].length) {
        result = createPartialWrapper.apply(undefined, newData);
      } else {
        result = createHybridWrapper.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setter(result, newData);
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Function} [customizer] The function to customize comparing arrays.
     * @param {boolean} [isLoose] Specify performing partial comparisons.
     * @param {Array} [stackA] Tracks traversed `value` objects.
     * @param {Array} [stackB] Tracks traversed `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, equalFunc, customizer, isLoose, stackA, stackB) {
      var index = -1,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isLoose && othLength > arrLength)) {
        return false;
      }
      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index],
            result = customizer ? customizer(isLoose ? othValue : arrValue, isLoose ? arrValue : othValue, index) : undefined;

        if (result !== undefined) {
          if (result) {
            continue;
          }
          return false;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (isLoose) {
          if (!arraySome(other, function(othValue) {
                return arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB);
              })) {
            return false;
          }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB))) {
          return false;
        }
      }
      return true;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag) {
      switch (tag) {
        case boolTag:
        case dateTag:
          // Coerce dates and booleans to numbers, dates to milliseconds and booleans
          // to `1` or `0` treating invalid dates coerced to `NaN` as not equal.
          return +object == +other;

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case numberTag:
          // Treat `NaN` vs. `NaN` as equal.
          return (object != +object)
            ? other != +other
            : object == +other;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings primitives and string
          // objects as equal. See https://es5.github.io/#x15.10.6.4 for more details.
          return object == (other + '');
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Function} [customizer] The function to customize comparing values.
     * @param {boolean} [isLoose] Specify performing partial comparisons.
     * @param {Array} [stackA] Tracks traversed `value` objects.
     * @param {Array} [stackB] Tracks traversed `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
      var objProps = keys(object),
          objLength = objProps.length,
          othProps = keys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isLoose) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isLoose ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      var skipCtor = isLoose;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key],
            result = customizer ? customizer(isLoose ? othValue : objValue, isLoose? objValue : othValue, key) : undefined;

        // Recursively compare objects (susceptible to call stack limits).
        if (!(result === undefined ? equalFunc(objValue, othValue, customizer, isLoose, stackA, stackB) : result)) {
          return false;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (!skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Gets the appropriate "callback" function. If the `_.callback` method is
     * customized this function returns the custom method, otherwise it returns
     * the `baseCallback` function. If arguments are provided the chosen function
     * is invoked with them and its result is returned.
     *
     * @private
     * @returns {Function} Returns the chosen function or its result.
     */
    function getCallback(func, thisArg, argCount) {
      var result = lodash.callback || callback;
      result = result === callback ? baseCallback : result;
      return argCount ? result(func, thisArg, argCount) : result;
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = func.name,
          array = realNames[result],
          length = array ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the appropriate "indexOf" function. If the `_.indexOf` method is
     * customized this function returns the custom method, otherwise it returns
     * the `baseIndexOf` function. If arguments are provided the chosen function
     * is invoked with them and its result is returned.
     *
     * @private
     * @returns {Function|number} Returns the chosen function or its result.
     */
    function getIndexOf(collection, target, fromIndex) {
      var result = lodash.indexOf || indexOf;
      result = result === indexOf ? baseIndexOf : result;
      return collection ? result(collection, target, fromIndex) : result;
    }

    /**
     * Gets the "length" property value of `object`.
     *
     * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
     * that affects Safari on at least iOS 8.1-8.3 ARM64.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {*} Returns the "length" value.
     */
    var getLength = baseProperty('length');

    /**
     * Gets the propery names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = pairs(object),
          length = result.length;

      while (length--) {
        result[length][2] = isStrictComparable(result[length][1]);
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = object == null ? undefined : object[key];
      return isNative(value) ? value : undefined;
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add array properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      var Ctor = object.constructor;
      if (!(typeof Ctor == 'function' && Ctor instanceof Ctor)) {
        Ctor = Object;
      }
      return new Ctor;
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return bufferClone(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          var buffer = object.buffer;
          return new Ctor(isDeep ? bufferClone(buffer) : buffer, object.byteOffset, object.length);

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          var result = new Ctor(object.source, reFlags.exec(object));
          result.lastIndex = object.lastIndex;
      }
      return result;
    }

    /**
     * Invokes the method at `path` on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function invokePath(object, path, args) {
      if (object != null && !isKey(path, object)) {
        path = toPath(path);
        object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
        path = last(path);
      }
      var func = object == null ? object : object[path];
      return func == null ? undefined : func.apply(object, args);
    }

    /**
     * Checks if `value` is array-like.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     */
    function isArrayLike(value) {
      return value != null && isLength(getLength(value));
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
      length = length == null ? MAX_SAFE_INTEGER : length;
      return value > -1 && value % 1 == 0 && value < length;
    }

    /**
     * Checks if the provided arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call, else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
          ? (isArrayLike(object) && isIndex(index, object.length))
          : (type == 'string' && index in object)) {
        var other = object[index];
        return value === value ? (value === other) : (other !== other);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      var type = typeof value;
      if ((type == 'string' && reIsPlainProp.test(value)) || type == 'number') {
        return true;
      }
      if (isArray(value)) {
        return false;
      }
      var result = !reIsDeepProp.test(value);
      return result || (object != null && value in toObject(object));
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart, else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func);
      if (!(funcName in LazyWrapper.prototype)) {
        return false;
      }
      var other = lodash[funcName];
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     */
    function isLength(value) {
      return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers required to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and `_.rearg`
     * augment function arguments, making the order in which they are executed important,
     * preventing the merging of metadata. However, we make an exception for a safe
     * common case where curried functions have `_.ary` and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < ARY_FLAG;

      var isCombo =
        (srcBitmask == ARY_FLAG && bitmask == CURRY_FLAG) ||
        (srcBitmask == ARY_FLAG && bitmask == REARG_FLAG && data[7].length <= source[8]) ||
        (srcBitmask == (ARY_FLAG | REARG_FLAG) && bitmask == CURRY_FLAG);

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= (bitmask & BIND_FLAG) ? 0 : CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : arrayCopy(value);
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : arrayCopy(source[4]);
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : arrayCopy(value);
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : arrayCopy(source[6]);
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = arrayCopy(value);
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use.
     *
     * @private
     * @param {*} objectValue The destination object property value.
     * @param {*} sourceValue The source object property value.
     * @returns {*} Returns the value to assign to the destination object.
     */
    function mergeDefaults(objectValue, sourceValue) {
      return objectValue === undefined ? sourceValue : merge(objectValue, sourceValue, mergeDefaults);
    }

    /**
     * A specialized version of `_.pick` which picks `object` properties specified
     * by `props`.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} props The property names to pick.
     * @returns {Object} Returns the new object.
     */
    function pickByArray(object, props) {
      object = toObject(object);

      var index = -1,
          length = props.length,
          result = {};

      while (++index < length) {
        var key = props[index];
        if (key in object) {
          result[key] = object[key];
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.pick` which picks `object` properties `predicate`
     * returns truthy for.
     *
     * @private
     * @param {Object} object The source object.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Object} Returns the new object.
     */
    function pickByCallback(object, predicate) {
      var result = {};
      baseForIn(object, function(value, key, object) {
        if (predicate(value, key, object)) {
          result[key] = value;
        }
      });
      return result;
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = arrayCopy(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity function
     * to avoid garbage collection pauses in V8. See [V8 issue 2070](https://code.google.com/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = (function() {
      var count = 0,
          lastCalled = 0;

      return function(key, value) {
        var stamp = now(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return key;
          }
        } else {
          count = 0;
        }
        return baseSetData(key, value);
      };
    }());

    /**
     * A fallback implementation of `Object.keys` which creates an array of the
     * own enumerable property names of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function shimKeys(object) {
      var props = keysIn(object),
          propsLength = props.length,
          length = propsLength && object.length;

      var allowIndexes = !!length && isLength(length) &&
        (isArray(object) || isArguments(object));

      var index = -1,
          result = [];

      while (++index < propsLength) {
        var key = props[index];
        if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to an array-like object if it's not one.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {Array|Object} Returns the array-like object.
     */
    function toIterable(value) {
      if (value == null) {
        return [];
      }
      if (!isArrayLike(value)) {
        return values(value);
      }
      return isObject(value) ? value : Object(value);
    }

    /**
     * Converts `value` to an object if it's not one.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {Object} Returns the object.
     */
    function toObject(value) {
      return isObject(value) ? value : Object(value);
    }

    /**
     * Converts `value` to property path array if it's not one.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {Array} Returns the property path array.
     */
    function toPath(value) {
      if (isArray(value)) {
        return value;
      }
      var result = [];
      baseToString(value).replace(rePropName, function(match, number, quote, string) {
        result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      return wrapper instanceof LazyWrapper
        ? wrapper.clone()
        : new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__, arrayCopy(wrapper.__actions__));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `collection` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the new array containing chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if (guard ? isIterateeCall(array, size, guard) : size == null) {
        size = 1;
      } else {
        size = nativeMax(nativeFloor(size) || 1, 1);
      }
      var index = 0,
          length = array ? array.length : 0,
          resIndex = -1,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[++resIndex] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array ? array.length : 0,
          resIndex = -1,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[++resIndex] = value;
        }
      }
      return result;
    }

    /**
     * Creates an array of unique `array` values not included in the other
     * provided arrays using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The arrays of values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.difference([1, 2, 3], [4, 2]);
     * // => [1, 3]
     */
    var difference = restParam(function(array, values) {
      return (isObjectLike(array) && isArrayLike(array))
        ? baseDifference(array, baseFlatten(values, false, true))
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (guard ? isIterateeCall(array, n, guard) : n == null) {
        n = 1;
      }
      return baseSlice(array, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (guard ? isIterateeCall(array, n, guard) : n == null) {
        n = 1;
      }
      n = length - (+n || 0);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * bound to `thisArg` and invoked with three arguments: (value, index, array).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that match the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRightWhile([1, 2, 3], function(n) {
     *   return n > 1;
     * });
     * // => [1]
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.dropRightWhile(users, { 'user': 'pebbles', 'active': false }), 'user');
     * // => ['barney', 'fred']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.dropRightWhile(users, 'active', false), 'user');
     * // => ['barney']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.dropRightWhile(users, 'active'), 'user');
     * // => ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate, thisArg) {
      return (array && array.length)
        ? baseWhile(array, getCallback(predicate, thisArg, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * bound to `thisArg` and invoked with three arguments: (value, index, array).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropWhile([1, 2, 3], function(n) {
     *   return n < 3;
     * });
     * // => [3]
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.dropWhile(users, { 'user': 'barney', 'active': false }), 'user');
     * // => ['fred', 'pebbles']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.dropWhile(users, 'active', false), 'user');
     * // => ['pebbles']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.dropWhile(users, 'active'), 'user');
     * // => ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate, thisArg) {
      return (array && array.length)
        ? baseWhile(array, getCallback(predicate, thisArg, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8], '*', 1, 2);
     * // => [4, '*', 8]
     */
    function fill(array, value, start, end) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(chr) {
     *   return chr.user == 'barney';
     * });
     * // => 0
     *
     * // using the `_.matches` callback shorthand
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.findIndex(users, 'active', false);
     * // => 0
     *
     * // using the `_.property` callback shorthand
     * _.findIndex(users, 'active');
     * // => 2
     */
    var findIndex = createFindIndex();

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(chr) {
     *   return chr.user == 'pebbles';
     * });
     * // => 2
     *
     * // using the `_.matches` callback shorthand
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.findLastIndex(users, 'active', false);
     * // => 2
     *
     * // using the `_.property` callback shorthand
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    var findLastIndex = createFindIndex(true);

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @alias head
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.first([1, 2, 3]);
     * // => 1
     *
     * _.first([]);
     * // => undefined
     */
    function first(array) {
      return array ? array[0] : undefined;
    }

    /**
     * Flattens a nested array. If `isDeep` is `true` the array is recursively
     * flattened, otherwise it is only flattened a single level.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {boolean} [isDeep] Specify a deep flatten.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, 3, [4]]]);
     * // => [1, 2, 3, [4]]
     *
     * // using `isDeep`
     * _.flatten([1, [2, 3, [4]]], true);
     * // => [1, 2, 3, 4]
     */
    function flatten(array, isDeep, guard) {
      var length = array ? array.length : 0;
      if (guard && isIterateeCall(array, isDeep, guard)) {
        isDeep = false;
      }
      return length ? baseFlatten(array, isDeep) : [];
    }

    /**
     * Recursively flattens a nested array.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to recursively flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, 3, [4]]]);
     * // => [1, 2, 3, 4]
     */
    function flattenDeep(array) {
      var length = array ? array.length : 0;
      return length ? baseFlatten(array, true) : [];
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it is used as the offset
     * from the end of `array`. If `array` is sorted providing `true` for `fromIndex`
     * performs a faster binary search.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to search.
     * @param {*} value The value to search for.
     * @param {boolean|number} [fromIndex=0] The index to search from or `true`
     *  to perform a binary search on a sorted array.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // using `fromIndex`
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     *
     * // performing a binary search
     * _.indexOf([1, 1, 2, 2], 2, true);
     * // => 2
     */
    function indexOf(array, value, fromIndex) {
      var length = array ? array.length : 0;
      if (!length) {
        return -1;
      }
      if (typeof fromIndex == 'number') {
        fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : fromIndex;
      } else if (fromIndex) {
        var index = binaryIndex(array, value);
        if (index < length &&
            (value === value ? (value === array[index]) : (array[index] !== array[index]))) {
          return index;
        }
        return -1;
      }
      return baseIndexOf(array, value, fromIndex || 0);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      return dropRight(array, 1);
    }

    /**
     * Creates an array of unique values that are included in all of the provided
     * arrays using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of shared values.
     * @example
     * _.intersection([1, 2], [4, 2], [2, 1]);
     * // => [2]
     */
    var intersection = restParam(function(arrays) {
      var othLength = arrays.length,
          othIndex = othLength,
          caches = Array(length),
          indexOf = getIndexOf(),
          isCommon = indexOf == baseIndexOf,
          result = [];

      while (othIndex--) {
        var value = arrays[othIndex] = isArrayLike(value = arrays[othIndex]) ? value : [];
        caches[othIndex] = (isCommon && value.length >= 120) ? createCache(othIndex && value) : null;
      }
      var array = arrays[0],
          index = -1,
          length = array ? array.length : 0,
          seen = caches[0];

      outer:
      while (++index < length) {
        value = array[index];
        if ((seen ? cacheIndexOf(seen, value) : indexOf(result, value, 0)) < 0) {
          var othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if ((cache ? cacheIndexOf(cache, value) : indexOf(arrays[othIndex], value, 0)) < 0) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(value);
          }
          result.push(value);
        }
      }
      return result;
    });

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array ? array.length : 0;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to search.
     * @param {*} value The value to search for.
     * @param {boolean|number} [fromIndex=array.length-1] The index to search from
     *  or `true` to perform a binary search on a sorted array.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // using `fromIndex`
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     *
     * // performing a binary search
     * _.lastIndexOf([1, 1, 2, 2], 2, true);
     * // => 3
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array ? array.length : 0;
      if (!length) {
        return -1;
      }
      var index = length;
      if (typeof fromIndex == 'number') {
        index = (fromIndex < 0 ? nativeMax(length + fromIndex, 0) : nativeMin(fromIndex || 0, length - 1)) + 1;
      } else if (fromIndex) {
        index = binaryIndex(array, value, true) - 1;
        var other = array[index];
        if (value === value ? (value === other) : (other !== other)) {
          return index;
        }
        return -1;
      }
      if (value !== value) {
        return indexOfNaN(array, index, true);
      }
      while (index--) {
        if (array[index] === value) {
          return index;
        }
      }
      return -1;
    }

    /**
     * Removes all provided values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3, 1, 2, 3];
     *
     * _.pull(array, 2, 3);
     * console.log(array);
     * // => [1, 1]
     */
    function pull() {
      var args = arguments,
          array = args[0];

      if (!(array && array.length)) {
        return array;
      }
      var index = 0,
          indexOf = getIndexOf(),
          length = args.length;

      while (++index < length) {
        var fromIndex = 0,
            value = args[index];

        while ((fromIndex = indexOf(array, value, fromIndex)) > -1) {
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * Removes elements from `array` corresponding to the given indexes and returns
     * an array of the removed elements. Indexes may be specified as an array of
     * indexes or as individual arguments.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove,
     *  specified as individual indexes or arrays of indexes.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [5, 10, 15, 20];
     * var evens = _.pullAt(array, 1, 3);
     *
     * console.log(array);
     * // => [5, 15]
     *
     * console.log(evens);
     * // => [10, 20]
     */
    var pullAt = restParam(function(array, indexes) {
      indexes = baseFlatten(indexes);

      var result = baseAt(array, indexes);
      basePullAt(array, indexes.sort(baseCompareAscending));
      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is bound to
     * `thisArg` and invoked with three arguments: (value, index, array).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate, thisArg) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getCallback(predicate, thisArg, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @alias tail
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.rest([1, 2, 3]);
     * // => [2, 3]
     */
    function rest(array) {
      return drop(array, 1);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of `Array#slice` to support node
     * lists in IE < 9 and to ensure dense arrays are returned.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value` should
     * be inserted into `array` in order to maintain its sort order. If an iteratee
     * function is provided it is invoked for `value` and each element of `array`
     * to compute their sort ranking. The iteratee is bound to `thisArg` and
     * invoked with one argument; (value).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     *
     * _.sortedIndex([4, 4, 5, 5], 5);
     * // => 2
     *
     * var dict = { 'data': { 'thirty': 30, 'forty': 40, 'fifty': 50 } };
     *
     * // using an iteratee function
     * _.sortedIndex(['thirty', 'fifty'], 'forty', function(word) {
     *   return this.data[word];
     * }, dict);
     * // => 1
     *
     * // using the `_.property` callback shorthand
     * _.sortedIndex([{ 'x': 30 }, { 'x': 50 }], { 'x': 40 }, 'x');
     * // => 1
     */
    var sortedIndex = createSortedIndex();

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 4, 5, 5], 5);
     * // => 4
     */
    var sortedLastIndex = createSortedIndex(true);

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (guard ? isIterateeCall(array, n, guard) : n == null) {
        n = 1;
      }
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (guard ? isIterateeCall(array, n, guard) : n == null) {
        n = 1;
      }
      n = length - (+n || 0);
      return baseSlice(array, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is bound to `thisArg`
     * and invoked with three arguments: (value, index, array).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRightWhile([1, 2, 3], function(n) {
     *   return n > 1;
     * });
     * // => [2, 3]
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.takeRightWhile(users, { 'user': 'pebbles', 'active': false }), 'user');
     * // => ['pebbles']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.takeRightWhile(users, 'active', false), 'user');
     * // => ['fred', 'pebbles']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.takeRightWhile(users, 'active'), 'user');
     * // => []
     */
    function takeRightWhile(array, predicate, thisArg) {
      return (array && array.length)
        ? baseWhile(array, getCallback(predicate, thisArg, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is bound to
     * `thisArg` and invoked with three arguments: (value, index, array).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeWhile([1, 2, 3], function(n) {
     *   return n < 3;
     * });
     * // => [1, 2]
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false},
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.takeWhile(users, { 'user': 'barney', 'active': false }), 'user');
     * // => ['barney']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.takeWhile(users, 'active', false), 'user');
     * // => ['barney', 'fred']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.takeWhile(users, 'active'), 'user');
     * // => []
     */
    function takeWhile(array, predicate, thisArg) {
      return (array && array.length)
        ? baseWhile(array, getCallback(predicate, thisArg, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all of the provided arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([1, 2], [4, 2], [2, 1]);
     * // => [1, 2, 4]
     */
    var union = restParam(function(arrays) {
      return baseUniq(baseFlatten(arrays, false, true));
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurence of each element
     * is kept. Providing `true` for `isSorted` performs a faster search algorithm
     * for sorted arrays. If an iteratee function is provided it is invoked for
     * each element in the array to generate the criterion by which uniqueness
     * is computed. The `iteratee` is bound to `thisArg` and invoked with three
     * arguments: (value, index, array).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @alias unique
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {boolean} [isSorted] Specify the array is sorted.
     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the new duplicate-value-free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     *
     * // using `isSorted`
     * _.uniq([1, 1, 2], true);
     * // => [1, 2]
     *
     * // using an iteratee function
     * _.uniq([1, 2.5, 1.5, 2], function(n) {
     *   return this.floor(n);
     * }, Math);
     * // => [1, 2.5]
     *
     * // using the `_.property` callback shorthand
     * _.uniq([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniq(array, isSorted, iteratee, thisArg) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (isSorted != null && typeof isSorted != 'boolean') {
        thisArg = iteratee;
        iteratee = isIterateeCall(array, isSorted, thisArg) ? undefined : isSorted;
        isSorted = false;
      }
      var callback = getCallback();
      if (!(iteratee == null && callback === baseCallback)) {
        iteratee = callback(iteratee, thisArg, 3);
      }
      return (isSorted && getIndexOf() == baseIndexOf)
        ? sortedUniq(array, iteratee)
        : baseUniq(array, iteratee);
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['fred', 'barney'], [30, 40], [true, false]);
     * // => [['fred', 30, true], ['barney', 40, false]]
     *
     * _.unzip(zipped);
     * // => [['fred', 'barney'], [30, 40], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var index = -1,
          length = 0;

      array = arrayFilter(array, function(group) {
        if (isArrayLike(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      var result = Array(length);
      while (++index < length) {
        result[index] = arrayMap(array, baseProperty(index));
      }
      return result;
    }

    /**
     * This method is like `_.unzip` except that it accepts an iteratee to specify
     * how regrouped values should be combined. The `iteratee` is bound to `thisArg`
     * and invoked with four arguments: (accumulator, value, index, group).
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee] The function to combine regrouped values.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee, thisArg) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      iteratee = bindCallback(iteratee, thisArg, 4);
      return arrayMap(result, function(group) {
        return arrayReduce(group, iteratee, undefined, true);
      });
    }

    /**
     * Creates an array excluding all provided values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to filter.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.without([1, 2, 1, 3], 1, 2);
     * // => [3]
     */
    var without = restParam(function(array, values) {
      return isArrayLike(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the provided arrays.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of values.
     * @example
     *
     * _.xor([1, 2], [4, 2]);
     * // => [1, 4]
     */
    function xor() {
      var index = -1,
          length = arguments.length;

      while (++index < length) {
        var array = arguments[index];
        if (isArrayLike(array)) {
          var result = result
            ? arrayPush(baseDifference(result, array), baseDifference(array, result))
            : array;
        }
      }
      return result ? baseUniq(result) : [];
    }

    /**
     * Creates an array of grouped elements, the first of which contains the first
     * elements of the given arrays, the second of which contains the second elements
     * of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['fred', 'barney'], [30, 40], [true, false]);
     * // => [['fred', 30, true], ['barney', 40, false]]
     */
    var zip = restParam(unzip);

    /**
     * The inverse of `_.pairs`; this method returns an object composed from arrays
     * of property names and values. Provide either a single two dimensional array,
     * e.g. `[[key1, value1], [key2, value2]]` or two arrays, one of property names
     * and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @alias object
     * @category Array
     * @param {Array} props The property names.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject([['fred', 30], ['barney', 40]]);
     * // => { 'fred': 30, 'barney': 40 }
     *
     * _.zipObject(['fred', 'barney'], [30, 40]);
     * // => { 'fred': 30, 'barney': 40 }
     */
    function zipObject(props, values) {
      var index = -1,
          length = props ? props.length : 0,
          result = {};

      if (length && !values && !isArray(props[0])) {
        values = [];
      }
      while (++index < length) {
        var key = props[index];
        if (values) {
          result[key] = values[index];
        } else if (key) {
          result[key[0]] = key[1];
        }
      }
      return result;
    }

    /**
     * This method is like `_.zip` except that it accepts an iteratee to specify
     * how grouped values should be combined. The `iteratee` is bound to `thisArg`
     * and invoked with four arguments: (accumulator, value, index, group).
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee] The function to combine grouped values.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], _.add);
     * // => [111, 222]
     */
    var zipWith = restParam(function(arrays) {
      var length = arrays.length,
          iteratee = length > 2 ? arrays[length - 2] : undefined,
          thisArg = length > 1 ? arrays[length - 1] : undefined;

      if (length > 2 && typeof iteratee == 'function') {
        length -= 2;
      } else {
        iteratee = (length > 1 && typeof thisArg == 'function') ? (--length, thisArg) : undefined;
        thisArg = undefined;
      }
      arrays.length = length;
      return unzipWith(arrays, iteratee, thisArg);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object that wraps `value` with explicit method
     * chaining enabled.
     *
     * @static
     * @memberOf _
     * @category Chain
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _.chain(users)
     *   .sortBy('age')
     *   .map(function(chr) {
     *     return chr.user + ' is ' + chr.age;
     *   })
     *   .first()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor is
     * bound to `thisArg` and invoked with one argument; (value). The purpose of
     * this method is to "tap into" a method chain in order to perform operations
     * on intermediate results within the chain.
     *
     * @static
     * @memberOf _
     * @category Chain
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @param {*} [thisArg] The `this` binding of `interceptor`.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor, thisArg) {
      interceptor.call(thisArg, value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     *
     * @static
     * @memberOf _
     * @category Chain
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @param {*} [thisArg] The `this` binding of `interceptor`.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor, thisArg) {
      return interceptor.call(thisArg, value);
    }

    /**
     * Enables explicit method chaining on the wrapper object.
     *
     * @name chain
     * @memberOf _
     * @category Chain
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // without explicit chaining
     * _(users).first();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // with explicit chaining
     * _(users).chain()
     *   .first()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chained sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @category Chain
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Creates a new array joining a wrapped array with any additional arrays
     * and/or values.
     *
     * @name concat
     * @memberOf _
     * @category Chain
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var wrapped = _(array).concat(2, [3], [[4]]);
     *
     * console.log(wrapped.value());
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    var wrapperConcat = restParam(function(values) {
      values = baseFlatten(values);
      return this.thru(function(array) {
        return arrayConcat(isArray(array) ? array : [toObject(array)], values);
      });
    });

    /**
     * Creates a clone of the chained sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @category Chain
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).map(function(value) {
     *   return Math.pow(value, 2);
     * });
     *
     * var other = [3, 4];
     * var otherWrapped = wrapped.plant(other);
     *
     * otherWrapped.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * Reverses the wrapped array so the first element becomes the last, the
     * second element becomes the second to last, and so on.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @category Chain
     * @returns {Object} Returns the new reversed `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;

      var interceptor = function(value) {
        return (wrapped && wrapped.__dir__ < 0) ? value : value.reverse();
      };
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(interceptor);
    }

    /**
     * Produces the result of coercing the unwrapped value to a string.
     *
     * @name toString
     * @memberOf _
     * @category Chain
     * @returns {string} Returns the coerced string value.
     * @example
     *
     * _([1, 2, 3]).toString();
     * // => '1,2,3'
     */
    function wrapperToString() {
      return (this.value() + '');
    }

    /**
     * Executes the chained sequence to extract the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @alias run, toJSON, valueOf
     * @category Chain
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements corresponding to the given keys, or indexes,
     * of `collection`. Keys may be specified as individual arguments or as arrays
     * of keys.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {...(number|number[]|string|string[])} [props] The property names
     *  or indexes of elements to pick, specified individually or in arrays.
     * @returns {Array} Returns the new array of picked elements.
     * @example
     *
     * _.at(['a', 'b', 'c'], [0, 2]);
     * // => ['a', 'c']
     *
     * _.at(['barney', 'fred', 'pebbles'], 0, 2);
     * // => ['barney', 'pebbles']
     */
    var at = restParam(function(collection, props) {
      return baseAt(collection, baseFlatten(props));
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` through `iteratee`. The corresponding value
     * of each key is the number of times the key was returned by `iteratee`.
     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([4.3, 6.1, 6.4], function(n) {
     *   return Math.floor(n);
     * });
     * // => { '4': 1, '6': 2 }
     *
     * _.countBy([4.3, 6.1, 6.4], function(n) {
     *   return this.floor(n);
     * }, Math);
     * // => { '4': 1, '6': 2 }
     *
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      hasOwnProperty.call(result, key) ? ++result[key] : (result[key] = 1);
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * The predicate is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @alias all
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'active': false },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.every(users, 'active', false);
     * // => true
     *
     * // using the `_.property` callback shorthand
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, thisArg) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (thisArg && isIterateeCall(collection, predicate, thisArg)) {
        predicate = undefined;
      }
      if (typeof predicate != 'function' || thisArg !== undefined) {
        predicate = getCallback(predicate, thisArg, 3);
      }
      return func(collection, predicate);
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is bound to `thisArg` and
     * invoked with three arguments: (value, index|key, collection).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @alias select
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the new filtered array.
     * @example
     *
     * _.filter([4, 5, 6], function(n) {
     *   return n % 2 == 0;
     * });
     * // => [4, 6]
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.filter(users, { 'age': 36, 'active': true }), 'user');
     * // => ['barney']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.filter(users, 'active', false), 'user');
     * // => ['fred']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.filter(users, 'active'), 'user');
     * // => ['barney']
     */
    function filter(collection, predicate, thisArg) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      predicate = getCallback(predicate, thisArg, 3);
      return func(collection, predicate);
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is bound to `thisArg` and
     * invoked with three arguments: (value, index|key, collection).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @alias detect
     * @category Collection
     * @param {Array|Object|string} collection The collection to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.result(_.find(users, function(chr) {
     *   return chr.age < 40;
     * }), 'user');
     * // => 'barney'
     *
     * // using the `_.matches` callback shorthand
     * _.result(_.find(users, { 'age': 1, 'active': true }), 'user');
     * // => 'pebbles'
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.result(_.find(users, 'active', false), 'user');
     * // => 'fred'
     *
     * // using the `_.property` callback shorthand
     * _.result(_.find(users, 'active'), 'user');
     * // => 'barney'
     */
    var find = createFind(baseEach);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(baseEachRight, true);

    /**
     * Performs a deep comparison between each element in `collection` and the
     * source object, returning the first element that has equivalent property
     * values.
     *
     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
     * numbers, `Object` objects, regexes, and strings. Objects are compared by
     * their own, not inherited, enumerable properties. For comparing a single
     * own or inherited property value see `_.matchesProperty`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to search.
     * @param {Object} source The object of property values to match.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.result(_.findWhere(users, { 'age': 36, 'active': true }), 'user');
     * // => 'barney'
     *
     * _.result(_.findWhere(users, { 'age': 40, 'active': false }), 'user');
     * // => 'fred'
     */
    function findWhere(collection, source) {
      return find(collection, baseMatches(source));
    }

    /**
     * Iterates over elements of `collection` invoking `iteratee` for each element.
     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection). Iteratee functions may exit iteration early
     * by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length" property
     * are iterated like arrays. To avoid this behavior `_.forIn` or `_.forOwn`
     * may be used for object iteration.
     *
     * @static
     * @memberOf _
     * @alias each
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array|Object|string} Returns `collection`.
     * @example
     *
     * _([1, 2]).forEach(function(n) {
     *   console.log(n);
     * }).value();
     * // => logs each value from left to right and returns the array
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(n, key) {
     *   console.log(n, key);
     * });
     * // => logs each value-key pair and returns the object (iteration order is not guaranteed)
     */
    var forEach = createForEach(arrayEach, baseEach);

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @alias eachRight
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array|Object|string} Returns `collection`.
     * @example
     *
     * _([1, 2]).forEachRight(function(n) {
     *   console.log(n);
     * }).value();
     * // => logs each value from right to left and returns the array
     */
    var forEachRight = createForEach(arrayEachRight, baseEachRight);

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` through `iteratee`. The corresponding value
     * of each key is an array of the elements responsible for generating the key.
     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([4.2, 6.1, 6.4], function(n) {
     *   return Math.floor(n);
     * });
     * // => { '4': [4.2], '6': [6.1, 6.4] }
     *
     * _.groupBy([4.2, 6.1, 6.4], function(n) {
     *   return this.floor(n);
     * }, Math);
     * // => { '4': [4.2], '6': [6.1, 6.4] }
     *
     * // using the `_.property` callback shorthand
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        result[key] = [value];
      }
    });

    /**
     * Checks if `value` is in `collection` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it is used as the offset
     * from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @alias contains, include
     * @category Collection
     * @param {Array|Object|string} collection The collection to search.
     * @param {*} target The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.reduce`.
     * @returns {boolean} Returns `true` if a matching element is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'user': 'fred', 'age': 40 }, 'fred');
     * // => true
     *
     * _.includes('pebbles', 'eb');
     * // => true
     */
    function includes(collection, target, fromIndex, guard) {
      var length = collection ? getLength(collection) : 0;
      if (!isLength(length)) {
        collection = values(collection);
        length = collection.length;
      }
      if (typeof fromIndex != 'number' || (guard && isIterateeCall(target, fromIndex, guard))) {
        fromIndex = 0;
      } else {
        fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : (fromIndex || 0);
      }
      return (typeof collection == 'string' || !isArray(collection) && isString(collection))
        ? (fromIndex <= length && collection.indexOf(target, fromIndex) > -1)
        : (!!length && getIndexOf(collection, target, fromIndex) > -1);
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` through `iteratee`. The corresponding value
     * of each key is the last element responsible for generating the key. The
     * iteratee function is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var keyData = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.indexBy(keyData, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     *
     * _.indexBy(keyData, function(object) {
     *   return String.fromCharCode(object.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.indexBy(keyData, function(object) {
     *   return this.fromCharCode(object.code);
     * }, String);
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     */
    var indexBy = createAggregator(function(result, value, key) {
      result[key] = value;
    });

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `methodName` is a function it is
     * invoked for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invoke([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invoke([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invoke = restParam(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          isProp = isKey(path),
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        var func = isFunc ? path : ((isProp && value != null) ? value[path] : undefined);
        result[++index] = func ? func.apply(value, args) : invokePath(value, path, args);
      });
      return result;
    });

    /**
     * Creates an array of values by running each element in `collection` through
     * `iteratee`. The `iteratee` is bound to `thisArg` and invoked with three
     * arguments: (value, index|key, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `callback`, `chunk`, `clone`, `create`, `curry`, `curryRight`,
     * `drop`, `dropRight`, `every`, `fill`, `flatten`, `invert`, `max`, `min`,
     * `parseInt`, `slice`, `sortBy`, `take`, `takeRight`, `template`, `trim`,
     * `trimLeft`, `trimRight`, `trunc`, `random`, `range`, `sample`, `some`,
     * `sum`, `uniq`, and `words`
     *
     * @static
     * @memberOf _
     * @alias collect
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function timesThree(n) {
     *   return n * 3;
     * }
     *
     * _.map([1, 2], timesThree);
     * // => [3, 6]
     *
     * _.map({ 'a': 1, 'b': 2 }, timesThree);
     * // => [3, 6] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // using the `_.property` callback shorthand
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee, thisArg) {
      var func = isArray(collection) ? arrayMap : baseMap;
      iteratee = getCallback(iteratee, thisArg, 3);
      return func(collection, iteratee);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, while the second of which
     * contains elements `predicate` returns falsey for. The predicate is bound
     * to `thisArg` and invoked with three arguments: (value, index|key, collection).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * _.partition([1, 2, 3], function(n) {
     *   return n % 2;
     * });
     * // => [[1, 3], [2]]
     *
     * _.partition([1.2, 2.3, 3.4], function(n) {
     *   return this.floor(n) % 2;
     * }, Math);
     * // => [[1.2, 3.4], [2.3]]
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * var mapper = function(array) {
     *   return _.pluck(array, 'user');
     * };
     *
     * // using the `_.matches` callback shorthand
     * _.map(_.partition(users, { 'age': 1, 'active': false }), mapper);
     * // => [['pebbles'], ['barney', 'fred']]
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.map(_.partition(users, 'active', false), mapper);
     * // => [['barney', 'pebbles'], ['fred']]
     *
     * // using the `_.property` callback shorthand
     * _.map(_.partition(users, 'active'), mapper);
     * // => [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Gets the property value of `path` from all elements in `collection`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Array|string} path The path of the property to pluck.
     * @returns {Array} Returns the property values.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * _.pluck(users, 'user');
     * // => ['barney', 'fred']
     *
     * var userIndex = _.indexBy(users, 'user');
     * _.pluck(userIndex, 'age');
     * // => [36, 40] (iteration order is not guaranteed)
     */
    function pluck(collection, path) {
      return map(collection, property(path));
    }

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` through `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not provided the first element of `collection` is used as the initial
     * value. The `iteratee` is bound to `thisArg` and invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `sortByAll`,
     * and `sortByOrder`
     *
     * @static
     * @memberOf _
     * @alias foldl, inject
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.reduce([1, 2], function(total, n) {
     *   return total + n;
     * });
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2 }, function(result, n, key) {
     *   result[key] = n * 3;
     *   return result;
     * }, {});
     * // => { 'a': 3, 'b': 6 } (iteration order is not guaranteed)
     */
    var reduce = createReduce(arrayReduce, baseEach);

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @alias foldr
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    var reduceRight = createReduce(arrayReduceRight, baseEachRight);

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the new filtered array.
     * @example
     *
     * _.reject([1, 2, 3, 4], function(n) {
     *   return n % 2 == 0;
     * });
     * // => [1, 3]
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.reject(users, { 'age': 40, 'active': true }), 'user');
     * // => ['barney']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.reject(users, 'active', false), 'user');
     * // => ['fred']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.reject(users, 'active'), 'user');
     * // => ['barney']
     */
    function reject(collection, predicate, thisArg) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      predicate = getCallback(predicate, thisArg, 3);
      return func(collection, function(value, index, collection) {
        return !predicate(value, index, collection);
      });
    }

    /**
     * Gets a random element or `n` random elements from a collection.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to sample.
     * @param {number} [n] The number of elements to sample.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {*} Returns the random sample(s).
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     *
     * _.sample([1, 2, 3, 4], 2);
     * // => [3, 1]
     */
    function sample(collection, n, guard) {
      if (guard ? isIterateeCall(collection, n, guard) : n == null) {
        collection = toIterable(collection);
        var length = collection.length;
        return length > 0 ? collection[baseRandom(0, length - 1)] : undefined;
      }
      var index = -1,
          result = toArray(collection),
          length = result.length,
          lastIndex = length - 1;

      n = nativeMin(n < 0 ? 0 : (+n || 0), length);
      while (++index < n) {
        var rand = baseRandom(index, lastIndex),
            value = result[rand];

        result[rand] = result[index];
        result[index] = value;
      }
      result.length = n;
      return result;
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      return sample(collection, POSITIVE_INFINITY);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable properties for objects.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the size of `collection`.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      var length = collection ? getLength(collection) : 0;
      return isLength(length) ? length : keys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * The function returns as soon as it finds a passing value and does not iterate
     * over the entire collection. The predicate is bound to `thisArg` and invoked
     * with three arguments: (value, index|key, collection).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @alias any
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.some(users, 'active', false);
     * // => true
     *
     * // using the `_.property` callback shorthand
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, thisArg) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (thisArg && isIterateeCall(collection, predicate, thisArg)) {
        predicate = undefined;
      }
      if (typeof predicate != 'function' || thisArg !== undefined) {
        predicate = getCallback(predicate, thisArg, 3);
      }
      return func(collection, predicate);
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection through `iteratee`. This method performs
     * a stable sort, that is, it preserves the original sort order of equal elements.
     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * _.sortBy([1, 2, 3], function(n) {
     *   return Math.sin(n);
     * });
     * // => [3, 1, 2]
     *
     * _.sortBy([1, 2, 3], function(n) {
     *   return this.sin(n);
     * }, Math);
     * // => [3, 1, 2]
     *
     * var users = [
     *   { 'user': 'fred' },
     *   { 'user': 'pebbles' },
     *   { 'user': 'barney' }
     * ];
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.sortBy(users, 'user'), 'user');
     * // => ['barney', 'fred', 'pebbles']
     */
    function sortBy(collection, iteratee, thisArg) {
      if (collection == null) {
        return [];
      }
      if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
        iteratee = undefined;
      }
      var index = -1;
      iteratee = getCallback(iteratee, thisArg, 3);

      var result = baseMap(collection, function(value, key, collection) {
        return { 'criteria': iteratee(value, key, collection), 'index': ++index, 'value': value };
      });
      return baseSortBy(result, compareAscending);
    }

    /**
     * This method is like `_.sortBy` except that it can sort by multiple iteratees
     * or property names.
     *
     * If a property name is provided for an iteratee the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If an object is provided for an iteratee the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {...(Function|Function[]|Object|Object[]|string|string[])} iteratees
     *  The iteratees to sort by, specified as individual values or arrays of values.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 42 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.map(_.sortByAll(users, ['user', 'age']), _.values);
     * // => [['barney', 34], ['barney', 36], ['fred', 42], ['fred', 48]]
     *
     * _.map(_.sortByAll(users, 'user', function(chr) {
     *   return Math.floor(chr.age / 10);
     * }), _.values);
     * // => [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
     */
    var sortByAll = restParam(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var guard = iteratees[2];
      if (guard && isIterateeCall(iteratees[0], iteratees[1], guard)) {
        iteratees.length = 1;
      }
      return baseSortByOrder(collection, baseFlatten(iteratees), []);
    });

    /**
     * This method is like `_.sortByAll` except that it allows specifying the
     * sort orders of the iteratees to sort by. If `orders` is unspecified, all
     * values are sorted in ascending order. Otherwise, a value is sorted in
     * ascending order if its corresponding order is "asc", and descending if "desc".
     *
     * If a property name is provided for an iteratee the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If an object is provided for an iteratee the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {boolean[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 42 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // sort by `user` in ascending order and by `age` in descending order
     * _.map(_.sortByOrder(users, ['user', 'age'], ['asc', 'desc']), _.values);
     * // => [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
     */
    function sortByOrder(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (guard && isIterateeCall(iteratees, orders, guard)) {
        orders = undefined;
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseSortByOrder(collection, iteratees, orders);
    }

    /**
     * Performs a deep comparison between each element in `collection` and the
     * source object, returning an array of all elements that have equivalent
     * property values.
     *
     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
     * numbers, `Object` objects, regexes, and strings. Objects are compared by
     * their own, not inherited, enumerable properties. For comparing a single
     * own or inherited property value see `_.matchesProperty`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to search.
     * @param {Object} source The object of property values to match.
     * @returns {Array} Returns the new filtered array.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false, 'pets': ['hoppy'] },
     *   { 'user': 'fred',   'age': 40, 'active': true, 'pets': ['baby puss', 'dino'] }
     * ];
     *
     * _.pluck(_.where(users, { 'age': 36, 'active': false }), 'user');
     * // => ['barney']
     *
     * _.pluck(_.where(users, { 'pets': ['dino'] }), 'user');
     * // => ['fred']
     */
    function where(collection, source) {
      return filter(collection, baseMatches(source));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Gets the number of milliseconds that have elapsed since the Unix epoch
     * (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @category Date
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => logs the number of milliseconds it took for the deferred function to be invoked
     */
    var now = nativeNow || function() {
      return new Date().getTime();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it is called `n` or more times.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => logs 'done saving!' after the two async saves have completed
     */
    function after(n, func) {
      if (typeof func != 'function') {
        if (typeof n == 'function') {
          var temp = n;
          n = func;
          func = temp;
        } else {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
      }
      n = nativeIsFinite(n = +n) ? n : 0;
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that accepts up to `n` arguments ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Function} Returns the new function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      if (guard && isIterateeCall(func, n, guard)) {
        n = undefined;
      }
      n = (func && n == null) ? func.length : nativeMax(+n || 0, 0);
      return createWrapper(func, ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it is called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery('#add').on('click', _.before(5, addContactToList));
     * // => allows adding up to 4 contacts to the list
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        if (typeof n == 'function') {
          var temp = n;
          n = func;
          func = temp;
        } else {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
      }
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and prepends any additional `_.bind` arguments to those provided to the
     * bound function.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind` this method does not set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var greet = function(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * };
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // using placeholders
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = restParam(function(func, thisArg, partials) {
      var bitmask = BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, bind.placeholder);
        bitmask |= PARTIAL_FLAG;
      }
      return createWrapper(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method. Method names may be specified as individual arguments or as arrays
     * of method names. If no method names are provided all enumerable function
     * properties, own and inherited, of `object` are bound.
     *
     * **Note:** This method does not set the "length" property of bound functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} [methodNames] The object method names to bind,
     *  specified as individual method names or arrays of method names.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'onClick': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view);
     * jQuery('#docs').on('click', view.onClick);
     * // => logs 'clicked docs' when the element is clicked
     */
    var bindAll = restParam(function(object, methodNames) {
      methodNames = methodNames.length ? baseFlatten(methodNames) : functions(object);

      var index = -1,
          length = methodNames.length;

      while (++index < length) {
        var key = methodNames[index];
        object[key] = createWrapper(object[key], BIND_FLAG, object);
      }
      return object;
    });

    /**
     * Creates a function that invokes the method at `object[key]` and prepends
     * any additional `_.bindKey` arguments to those provided to the bound function.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist.
     * See [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Object} object The object the method belongs to.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // using placeholders
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = restParam(function(object, key, partials) {
      var bitmask = BIND_FLAG | BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, bindKey.placeholder);
        bitmask |= PARTIAL_FLAG;
      }
      return createWrapper(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts one or more arguments of `func` that when
     * called either invokes `func` returning its result, if all `func` arguments
     * have been provided, or returns a function that accepts one or more of the
     * remaining `func` arguments, and so on. The arity of `func` may be specified
     * if `func.length` is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method does not set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // using placeholders
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    var curry = createCurry(CURRY_FLAG);

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method does not set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // using placeholders
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    var curryRight = createCurry(CURRY_RIGHT_FLAG);

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed invocations. Provide an options object to indicate that `func`
     * should be invoked on the leading and/or trailing edge of the `wait` timeout.
     * Subsequent calls to the debounced function return the result of the last
     * `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
     * on the trailing edge of the timeout only if the the debounced function is
     * invoked more than once during the `wait` timeout.
     *
     * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options] The options object.
     * @param {boolean} [options.leading=false] Specify invoking on the leading
     *  edge of the timeout.
     * @param {number} [options.maxWait] The maximum time `func` is allowed to be
     *  delayed before it is invoked.
     * @param {boolean} [options.trailing=true] Specify invoking on the trailing
     *  edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // avoid costly calculations while the window size is in flux
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // invoke `sendMail` when the click event is fired, debouncing subsequent calls
     * jQuery('#postbox').on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // ensure `batchLog` is invoked once after 1 second of debounced calls
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', _.debounce(batchLog, 250, {
     *   'maxWait': 1000
     * }));
     *
     * // cancel a debounced call
     * var todoChanges = _.debounce(batchLog, 1000);
     * Object.observe(models.todo, todoChanges);
     *
     * Object.observe(models, function(changes) {
     *   if (_.find(changes, { 'user': 'todo', 'type': 'delete'})) {
     *     todoChanges.cancel();
     *   }
     * }, ['delete']);
     *
     * // ...at some point `models.todo` is changed
     * models.todo.completed = true;
     *
     * // ...before 1 second has passed `models.todo` is deleted
     * // which cancels the debounced `todoChanges` call
     * delete models.todo;
     */
    function debounce(func, wait, options) {
      var args,
          maxTimeoutId,
          result,
          stamp,
          thisArg,
          timeoutId,
          trailingCall,
          lastCalled = 0,
          maxWait = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = wait < 0 ? 0 : (+wait || 0);
      if (options === true) {
        var leading = true;
        trailing = false;
      } else if (isObject(options)) {
        leading = !!options.leading;
        maxWait = 'maxWait' in options && nativeMax(+options.maxWait || 0, wait);
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function cancel() {
        if (timeoutId) {
          clearTimeout(timeoutId);
        }
        if (maxTimeoutId) {
          clearTimeout(maxTimeoutId);
        }
        lastCalled = 0;
        maxTimeoutId = timeoutId = trailingCall = undefined;
      }

      function complete(isCalled, id) {
        if (id) {
          clearTimeout(id);
        }
        maxTimeoutId = timeoutId = trailingCall = undefined;
        if (isCalled) {
          lastCalled = now();
          result = func.apply(thisArg, args);
          if (!timeoutId && !maxTimeoutId) {
            args = thisArg = undefined;
          }
        }
      }

      function delayed() {
        var remaining = wait - (now() - stamp);
        if (remaining <= 0 || remaining > wait) {
          complete(trailingCall, maxTimeoutId);
        } else {
          timeoutId = setTimeout(delayed, remaining);
        }
      }

      function maxDelayed() {
        complete(trailing, timeoutId);
      }

      function debounced() {
        args = arguments;
        stamp = now();
        thisArg = this;
        trailingCall = trailing && (timeoutId || !leading);

        if (maxWait === false) {
          var leadingCall = leading && !timeoutId;
        } else {
          if (!maxTimeoutId && !leading) {
            lastCalled = stamp;
          }
          var remaining = maxWait - (stamp - lastCalled),
              isCalled = remaining <= 0 || remaining > maxWait;

          if (isCalled) {
            if (maxTimeoutId) {
              maxTimeoutId = clearTimeout(maxTimeoutId);
            }
            lastCalled = stamp;
            result = func.apply(thisArg, args);
          }
          else if (!maxTimeoutId) {
            maxTimeoutId = setTimeout(maxDelayed, remaining);
          }
        }
        if (isCalled && timeoutId) {
          timeoutId = clearTimeout(timeoutId);
        }
        else if (!timeoutId && wait !== maxWait) {
          timeoutId = setTimeout(delayed, wait);
        }
        if (leadingCall) {
          isCalled = true;
          result = func.apply(thisArg, args);
        }
        if (isCalled && !timeoutId && !maxTimeoutId) {
          args = thisArg = undefined;
        }
        return result;
      }
      debounced.cancel = cancel;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it is invoked.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke the function with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // logs 'deferred' after one or more milliseconds
     */
    var defer = restParam(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it is invoked.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke the function with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => logs 'later' after one second
     */
    var delay = restParam(function(func, wait, args) {
      return baseDelay(func, wait, args);
    });

    /**
     * Creates a function that returns the result of invoking the provided
     * functions with the `this` binding of the created function, where each
     * successive invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {...Function} [funcs] Functions to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow(_.add, square);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the provided functions from right to left.
     *
     * @static
     * @memberOf _
     * @alias backflow, compose
     * @category Function
     * @param {...Function} [funcs] Functions to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight(square, _.add);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is coerced to a string and used as the
     * cache key. The `func` is invoked with the `this` binding of the memoized
     * function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the [`Map`](http://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoizing function.
     * @example
     *
     * var upperCase = _.memoize(function(string) {
     *   return string.toUpperCase();
     * });
     *
     * upperCase('fred');
     * // => 'FRED'
     *
     * // modifying the result cache
     * upperCase.cache.set('fred', 'BARNEY');
     * upperCase('fred');
     * // => 'BARNEY'
     *
     * // replacing `_.memoize.Cache`
     * var object = { 'user': 'fred' };
     * var other = { 'user': 'barney' };
     * var identity = _.memoize(_.identity);
     *
     * identity(object);
     * // => { 'user': 'fred' }
     * identity(other);
     * // => { 'user': 'fred' }
     *
     * _.memoize.Cache = WeakMap;
     * var identity = _.memoize(_.identity);
     *
     * identity(object);
     * // => { 'user': 'fred' }
     * identity(other);
     * // => { 'user': 'barney' }
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result);
        return result;
      };
      memoized.cache = new memoize.Cache;
      return memoized;
    }

    /**
     * Creates a function that runs each argument through a corresponding
     * transform function.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms] The functions to transform
     * arguments, specified as individual functions or arrays of functions.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var modded = _.modArgs(function(x, y) {
     *   return [x, y];
     * }, square, doubled);
     *
     * modded(1, 2);
     * // => [1, 4]
     *
     * modded(5, 10);
     * // => [25, 20]
     */
    var modArgs = restParam(function(func, transforms) {
      transforms = baseFlatten(transforms);
      if (typeof func != 'function' || !arrayEvery(transforms, baseIsFunction)) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = transforms.length;
      return restParam(function(args) {
        var index = nativeMin(args.length, length);
        while (index--) {
          args[index] = transforms[index](args[index]);
        }
        return func.apply(this, args);
      });
    });

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        return !predicate.apply(this, arguments);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first call. The `func` is invoked
     * with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // `initialize` invokes `createApplication` once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with `partial` arguments prepended
     * to those provided to the new function. This method is like `_.bind` except
     * it does **not** alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method does not set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * var greet = function(greeting, name) {
     *   return greeting + ' ' + name;
     * };
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // using placeholders
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = createPartial(PARTIAL_FLAG);

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to those provided to the new function.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method does not set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * var greet = function(greeting, name) {
     *   return greeting + ' ' + name;
     * };
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // using placeholders
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = createPartial(PARTIAL_RIGHT_FLAG);

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified indexes where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes,
     *  specified as individual indexes or arrays of indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, 2, 0, 1);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     *
     * var map = _.rearg(_.map, [1, 0]);
     * map(function(n) {
     *   return n * 3;
     * }, [1, 2, 3]);
     * // => [3, 6, 9]
     */
    var rearg = restParam(function(func, indexes) {
      return createWrapper(func, REARG_FLAG, undefined, undefined, undefined, baseFlatten(indexes));
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as an array.
     *
     * **Note:** This method is based on the [rest parameter](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/rest_parameters).
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.restParam(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function restParam(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = nativeMax(start === undefined ? (func.length - 1) : (+start || 0), 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            rest = Array(length);

        while (++index < length) {
          rest[index] = args[start + index];
        }
        switch (start) {
          case 0: return func.call(this, rest);
          case 1: return func.call(this, args[0], rest);
          case 2: return func.call(this, args[0], args[1], rest);
        }
        var otherArgs = Array(start + 1);
        index = -1;
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = rest;
        return func.apply(this, otherArgs);
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the created
     * function and an array of arguments much like [`Function#apply`](https://es5.github.io/#x15.3.4.3).
     *
     * **Note:** This method is based on the [spread operator](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Spread_operator).
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * // with a Promise
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function(array) {
        return func.apply(this, array);
      };
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed invocations. Provide an options object to indicate
     * that `func` should be invoked on the leading and/or trailing edge of the
     * `wait` timeout. Subsequent calls to the throttled function return the
     * result of the last `func` call.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
     * on the trailing edge of the timeout only if the the throttled function is
     * invoked more than once during the `wait` timeout.
     *
     * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options] The options object.
     * @param {boolean} [options.leading=true] Specify invoking on the leading
     *  edge of the timeout.
     * @param {boolean} [options.trailing=true] Specify invoking on the trailing
     *  edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // avoid excessively updating the position while scrolling
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // invoke `renewToken` when the click event is fired, but not more than once every 5 minutes
     * jQuery('.interactive').on('click', _.throttle(renewToken, 300000, {
     *   'trailing': false
     * }));
     *
     * // cancel a trailing throttled call
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (options === false) {
        leading = false;
      } else if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, { 'leading': leading, 'maxWait': +wait, 'trailing': trailing });
    }

    /**
     * Creates a function that provides `value` to the wrapper function as its
     * first argument. Any additional arguments provided to the function are
     * appended to those provided to the wrapper function. The wrapper is invoked
     * with the `this` binding of the created function.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} wrapper The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      wrapper = wrapper == null ? identity : wrapper;
      return createWrapper(wrapper, PARTIAL_FLAG, undefined, [value], []);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates a clone of `value`. If `isDeep` is `true` nested objects are cloned,
     * otherwise they are assigned by reference. If `customizer` is provided it is
     * invoked to produce the cloned values. If `customizer` returns `undefined`
     * cloning is handled by the method instead. The `customizer` is bound to
     * `thisArg` and invoked with two argument; (value [, index|key, object]).
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm).
     * The enumerable properties of `arguments` objects and objects created by
     * constructors other than `Object` are cloned to plain `Object` objects. An
     * empty object is returned for uncloneable values such as functions, DOM nodes,
     * Maps, Sets, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @param {Function} [customizer] The function to customize cloning values.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {*} Returns the cloned value.
     * @example
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * var shallow = _.clone(users);
     * shallow[0] === users[0];
     * // => true
     *
     * var deep = _.clone(users, true);
     * deep[0] === users[0];
     * // => false
     *
     * // using a customizer callback
     * var el = _.clone(document.body, function(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * });
     *
     * el === document.body
     * // => false
     * el.nodeName
     * // => BODY
     * el.childNodes.length;
     * // => 0
     */
    function clone(value, isDeep, customizer, thisArg) {
      if (isDeep && typeof isDeep != 'boolean' && isIterateeCall(value, isDeep, customizer)) {
        isDeep = false;
      }
      else if (typeof isDeep == 'function') {
        thisArg = customizer;
        customizer = isDeep;
        isDeep = false;
      }
      return typeof customizer == 'function'
        ? baseClone(value, isDeep, bindCallback(customizer, thisArg, 1))
        : baseClone(value, isDeep);
    }

    /**
     * Creates a deep clone of `value`. If `customizer` is provided it is invoked
     * to produce the cloned values. If `customizer` returns `undefined` cloning
     * is handled by the method instead. The `customizer` is bound to `thisArg`
     * and invoked with two argument; (value [, index|key, object]).
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm).
     * The enumerable properties of `arguments` objects and objects created by
     * constructors other than `Object` are cloned to plain `Object` objects. An
     * empty object is returned for uncloneable values such as functions, DOM nodes,
     * Maps, Sets, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to deep clone.
     * @param {Function} [customizer] The function to customize cloning values.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {*} Returns the deep cloned value.
     * @example
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * var deep = _.cloneDeep(users);
     * deep[0] === users[0];
     * // => false
     *
     * // using a customizer callback
     * var el = _.cloneDeep(document.body, function(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * });
     *
     * el === document.body
     * // => false
     * el.nodeName
     * // => BODY
     * el.childNodes.length;
     * // => 20
     */
    function cloneDeep(value, customizer, thisArg) {
      return typeof customizer == 'function'
        ? baseClone(value, true, bindCallback(customizer, thisArg, 1))
        : baseClone(value, true);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`, else `false`.
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    function gt(value, other) {
      return value > other;
    }

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to `other`, else `false`.
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    function gte(value, other) {
      return value >= other;
    }

    /**
     * Checks if `value` is classified as an `arguments` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    function isArguments(value) {
      return isObjectLike(value) && isArrayLike(value) &&
        hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
    }

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(function() { return arguments; }());
     * // => false
     */
    var isArray = nativeIsArray || function(value) {
      return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
    };

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false || (isObjectLike(value) && objToString.call(value) == boolTag);
    }

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    function isDate(value) {
      return isObjectLike(value) && objToString.call(value) == dateTag;
    }

    /**
     * Checks if `value` is a DOM element.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return !!value && value.nodeType === 1 && isObjectLike(value) && !isPlainObject(value);
    }

    /**
     * Checks if `value` is empty. A value is considered empty unless it is an
     * `arguments` object, array, string, or jQuery-like collection with a length
     * greater than `0` or an object with own enumerable properties.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {Array|Object|string} value The value to inspect.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) && (isArray(value) || isString(value) || isArguments(value) ||
          (isObjectLike(value) && isFunction(value.splice)))) {
        return !value.length;
      }
      return !keys(value).length;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent. If `customizer` is provided it is invoked to compare values.
     * If `customizer` returns `undefined` comparisons are handled by the method
     * instead. The `customizer` is bound to `thisArg` and invoked with three
     * arguments: (value, other [, index|key]).
     *
     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
     * numbers, `Object` objects, regexes, and strings. Objects are compared by
     * their own, not inherited, enumerable properties. Functions and DOM nodes
     * are **not** supported. Provide a customizer function to extend support
     * for comparing other values.
     *
     * @static
     * @memberOf _
     * @alias eq
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize value comparisons.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'user': 'fred' };
     * var other = { 'user': 'fred' };
     *
     * object == other;
     * // => false
     *
     * _.isEqual(object, other);
     * // => true
     *
     * // using a customizer callback
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqual(array, other, function(value, other) {
     *   if (_.every([value, other], RegExp.prototype.test, /^h(?:i|ello)$/)) {
     *     return true;
     *   }
     * });
     * // => true
     */
    function isEqual(value, other, customizer, thisArg) {
      customizer = typeof customizer == 'function' ? bindCallback(customizer, thisArg, 3) : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return  result === undefined ? baseIsEqual(value, other, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      return isObjectLike(value) && typeof value.message == 'string' && objToString.call(value) == errorTag;
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on [`Number.isFinite`](http://ecma-international.org/ecma-262/6.0/#sec-number.isfinite).
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(10);
     * // => true
     *
     * _.isFinite('10');
     * // => false
     *
     * _.isFinite(true);
     * // => false
     *
     * _.isFinite(Object(10));
     * // => false
     *
     * _.isFinite(Infinity);
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in older versions of Chrome and Safari which return 'function' for regexes
      // and Safari 8 equivalents which return 'object' for typed array constructors.
      return isObject(value) && objToString.call(value) == funcTag;
    }

    /**
     * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
     * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(1);
     * // => false
     */
    function isObject(value) {
      // Avoid a V8 JIT bug in Chrome 19-20.
      // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
      var type = typeof value;
      return !!value && (type == 'object' || type == 'function');
    }

    /**
     * Performs a deep comparison between `object` and `source` to determine if
     * `object` contains equivalent property values. If `customizer` is provided
     * it is invoked to compare values. If `customizer` returns `undefined`
     * comparisons are handled by the method instead. The `customizer` is bound
     * to `thisArg` and invoked with three arguments: (value, other, index|key).
     *
     * **Note:** This method supports comparing properties of arrays, booleans,
     * `Date` objects, numbers, `Object` objects, regexes, and strings. Functions
     * and DOM nodes are **not** supported. Provide a customizer function to extend
     * support for comparing other values.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize value comparisons.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'user': 'fred', 'age': 40 };
     *
     * _.isMatch(object, { 'age': 40 });
     * // => true
     *
     * _.isMatch(object, { 'age': 36 });
     * // => false
     *
     * // using a customizer callback
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatch(object, source, function(value, other) {
     *   return _.every([value, other], RegExp.prototype.test, /^h(?:i|ello)$/) || undefined;
     * });
     * // => true
     */
    function isMatch(object, source, customizer, thisArg) {
      customizer = typeof customizer == 'function' ? bindCallback(customizer, thisArg, 3) : undefined;
      return baseIsMatch(object, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is not the same as [`isNaN`](https://es5.github.io/#x15.1.2.4)
     * which returns `true` for `undefined` and other non-numeric values.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some host objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a native function.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (value == null) {
        return false;
      }
      if (isFunction(value)) {
        return reIsNative.test(fnToString.call(value));
      }
      return isObjectLike(value) && reIsHostCtor.test(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are classified
     * as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isNumber(8.4);
     * // => true
     *
     * _.isNumber(NaN);
     * // => true
     *
     * _.isNumber('8.4');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' || (isObjectLike(value) && objToString.call(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * **Note:** This method assumes objects created by the `Object` constructor
     * have no inherited enumerable properties.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      var Ctor;

      // Exit early for non `Object` objects.
      if (!(isObjectLike(value) && objToString.call(value) == objectTag && !isArguments(value)) ||
          (!hasOwnProperty.call(value, 'constructor') && (Ctor = value.constructor, typeof Ctor == 'function' && !(Ctor instanceof Ctor)))) {
        return false;
      }
      // IE < 9 iterates inherited properties before own properties. If the first
      // iterated property is an object's own property then there are no inherited
      // enumerable properties.
      var result;
      // In most environments an object's own properties are iterated before
      // its inherited properties. If the last iterated property is an object's
      // own property then there are no inherited enumerable properties.
      baseForIn(value, function(subValue, key) {
        result = key;
      });
      return result === undefined || hasOwnProperty.call(value, result);
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    function isRegExp(value) {
      return isObject(value) && objToString.call(value) == regexpTag;
    }

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' || (isObjectLike(value) && objToString.call(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    function isTypedArray(value) {
      return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objToString.call(value)];
    }

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`, else `false`.
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    function lt(value, other) {
      return value < other;
    }

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to `other`, else `false`.
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    function lte(value, other) {
      return value <= other;
    }

    /**
     * Converts `value` to an array.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * (function() {
     *   return _.toArray(arguments).slice(1);
     * }(1, 2, 3));
     * // => [2, 3]
     */
    function toArray(value) {
      var length = value ? getLength(value) : 0;
      if (!isLength(length)) {
        return values(value);
      }
      if (!length) {
        return [];
      }
      return arrayCopy(value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable
     * properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return baseCopy(value, keysIn(value));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Recursively merges own enumerable properties of the source object(s), that
     * don't resolve to `undefined` into the destination object. Subsequent sources
     * overwrite property assignments of previous sources. If `customizer` is
     * provided it is invoked to produce the merged values of the destination and
     * source properties. If `customizer` returns `undefined` merging is handled
     * by the method instead. The `customizer` is bound to `thisArg` and invoked
     * with five arguments: (objectValue, sourceValue, key, object, source).
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var users = {
     *   'data': [{ 'user': 'barney' }, { 'user': 'fred' }]
     * };
     *
     * var ages = {
     *   'data': [{ 'age': 36 }, { 'age': 40 }]
     * };
     *
     * _.merge(users, ages);
     * // => { 'data': [{ 'user': 'barney', 'age': 36 }, { 'user': 'fred', 'age': 40 }] }
     *
     * // using a customizer callback
     * var object = {
     *   'fruits': ['apple'],
     *   'vegetables': ['beet']
     * };
     *
     * var other = {
     *   'fruits': ['banana'],
     *   'vegetables': ['carrot']
     * };
     *
     * _.merge(object, other, function(a, b) {
     *   if (_.isArray(a)) {
     *     return a.concat(b);
     *   }
     * });
     * // => { 'fruits': ['apple', 'banana'], 'vegetables': ['beet', 'carrot'] }
     */
    var merge = createAssigner(baseMerge);

    /**
     * Assigns own enumerable properties of source object(s) to the destination
     * object. Subsequent sources overwrite property assignments of previous sources.
     * If `customizer` is provided it is invoked to produce the assigned values.
     * The `customizer` is bound to `thisArg` and invoked with five arguments:
     * (objectValue, sourceValue, key, object, source).
     *
     * **Note:** This method mutates `object` and is based on
     * [`Object.assign`](http://ecma-international.org/ecma-262/6.0/#sec-object.assign).
     *
     * @static
     * @memberOf _
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * _.assign({ 'user': 'barney' }, { 'age': 40 }, { 'user': 'fred' });
     * // => { 'user': 'fred', 'age': 40 }
     *
     * // using a customizer callback
     * var defaults = _.partialRight(_.assign, function(value, other) {
     *   return _.isUndefined(value) ? other : value;
     * });
     *
     * defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
     * // => { 'user': 'barney', 'age': 36 }
     */
    var assign = createAssigner(function(object, source, customizer) {
      return customizer
        ? assignWith(object, source, customizer)
        : baseAssign(object, source);
    });

    /**
     * Creates an object that inherits from the given `prototype` object. If a
     * `properties` object is provided its own enumerable properties are assigned
     * to the created object.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties, guard) {
      var result = baseCreate(prototype);
      if (guard && isIterateeCall(prototype, properties, guard)) {
        properties = undefined;
      }
      return properties ? baseAssign(result, properties) : result;
    }

    /**
     * Assigns own enumerable properties of source object(s) to the destination
     * object for all destination properties that resolve to `undefined`. Once a
     * property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * _.defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
     * // => { 'user': 'barney', 'age': 36 }
     */
    var defaults = createDefaults(assign, assignDefaults);

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * _.defaultsDeep({ 'user': { 'name': 'barney' } }, { 'user': { 'name': 'fred', 'age': 36 } });
     * // => { 'user': { 'name': 'barney', 'age': 36 } }
     *
     */
    var defaultsDeep = createDefaults(merge, mergeDefaults);

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {string|undefined} Returns the key of the matched element, else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(chr) {
     *   return chr.age < 40;
     * });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // using the `_.matches` callback shorthand
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.findKey(users, 'active', false);
     * // => 'fred'
     *
     * // using the `_.property` callback shorthand
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    var findKey = createFindKey(baseForOwn);

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {string|undefined} Returns the key of the matched element, else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(chr) {
     *   return chr.age < 40;
     * });
     * // => returns `pebbles` assuming `_.findKey` returns `barney`
     *
     * // using the `_.matches` callback shorthand
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.findLastKey(users, 'active', false);
     * // => 'fred'
     *
     * // using the `_.property` callback shorthand
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    var findLastKey = createFindKey(baseForOwnRight);

    /**
     * Iterates over own and inherited enumerable properties of an object invoking
     * `iteratee` for each property. The `iteratee` is bound to `thisArg` and invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => logs 'a', 'b', and 'c' (iteration order is not guaranteed)
     */
    var forIn = createForIn(baseFor);

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => logs 'c', 'b', and 'a' assuming `_.forIn ` logs 'a', 'b', and 'c'
     */
    var forInRight = createForIn(baseForRight);

    /**
     * Iterates over own enumerable properties of an object invoking `iteratee`
     * for each property. The `iteratee` is bound to `thisArg` and invoked with
     * three arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => logs 'a' and 'b' (iteration order is not guaranteed)
     */
    var forOwn = createForOwn(baseForOwn);

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => logs 'b' and 'a' assuming `_.forOwn` logs 'a' and 'b'
     */
    var forOwnRight = createForOwn(baseForOwnRight);

    /**
     * Creates an array of function property names from all enumerable properties,
     * own and inherited, of `object`.
     *
     * @static
     * @memberOf _
     * @alias methods
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the new array of property names.
     * @example
     *
     * _.functions(_);
     * // => ['after', 'ary', 'assign', ...]
     */
    function functions(object) {
      return baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the property value at `path` of `object`. If the resolved value is
     * `undefined` the `defaultValue` is used in its place.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, toPath(path), path + '');
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` is a direct property, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': { 'c': 3 } } };
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b.c');
     * // => true
     *
     * _.has(object, ['a', 'b', 'c']);
     * // => true
     */
    function has(object, path) {
      if (object == null) {
        return false;
      }
      var result = hasOwnProperty.call(object, path);
      if (!result && !isKey(path)) {
        path = toPath(path);
        object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
        if (object == null) {
          return false;
        }
        path = last(path);
        result = hasOwnProperty.call(object, path);
      }
      return result || (isLength(object.length) && isIndex(path, object.length) &&
        (isArray(object) || isArguments(object)));
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite property
     * assignments of previous values unless `multiValue` is `true`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to invert.
     * @param {boolean} [multiValue] Allow multiple values per key.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     *
     * // with `multiValue`
     * _.invert(object, true);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function invert(object, multiValue, guard) {
      if (guard && isIterateeCall(object, multiValue, guard)) {
        multiValue = undefined;
      }
      var index = -1,
          props = keys(object),
          length = props.length,
          result = {};

      while (++index < length) {
        var key = props[index],
            value = object[key];

        if (multiValue) {
          if (hasOwnProperty.call(result, value)) {
            result[value].push(key);
          } else {
            result[value] = [key];
          }
        }
        else {
          result[value] = key;
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    var keys = !nativeKeys ? shimKeys : function(object) {
      var Ctor = object == null ? undefined : object.constructor;
      if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
          (typeof object != 'function' && isArrayLike(object))) {
        return shimKeys(object);
      }
      return isObject(object) ? nativeKeys(object) : [];
    };

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      if (object == null) {
        return [];
      }
      if (!isObject(object)) {
        object = Object(object);
      }
      var length = object.length;
      length = (length && isLength(length) &&
        (isArray(object) || isArguments(object)) && length) || 0;

      var Ctor = object.constructor,
          index = -1,
          isProto = typeof Ctor == 'function' && Ctor.prototype === object,
          result = Array(length),
          skipIndexes = length > 0;

      while (++index < length) {
        result[index] = (index + '');
      }
      for (var key in object) {
        if (!(skipIndexes && isIndex(key, length)) &&
            !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * property of `object` through `iteratee`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns the new mapped object.
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    var mapKeys = createObjectMapper(true);

    /**
     * Creates an object with the same keys as `object` and values generated by
     * running each own enumerable property of `object` through `iteratee`. The
     * iteratee function is bound to `thisArg` and invoked with three arguments:
     * (value, key, object).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns the new mapped object.
     * @example
     *
     * _.mapValues({ 'a': 1, 'b': 2 }, function(n) {
     *   return n * 3;
     * });
     * // => { 'a': 3, 'b': 6 }
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * // using the `_.property` callback shorthand
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    var mapValues = createObjectMapper();

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable properties of `object` that are not omitted.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {Function|...(string|string[])} [predicate] The function invoked per
     *  iteration or property names to omit, specified as individual property
     *  names or arrays of property names.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'user': 'fred', 'age': 40 };
     *
     * _.omit(object, 'age');
     * // => { 'user': 'fred' }
     *
     * _.omit(object, _.isNumber);
     * // => { 'user': 'fred' }
     */
    var omit = restParam(function(object, props) {
      if (object == null) {
        return {};
      }
      if (typeof props[0] != 'function') {
        var props = arrayMap(baseFlatten(props), String);
        return pickByArray(object, baseDifference(keysIn(object), props));
      }
      var predicate = bindCallback(props[0], props[1], 3);
      return pickByCallback(object, function(value, key, object) {
        return !predicate(value, key, object);
      });
    });

    /**
     * Creates a two dimensional array of the key-value pairs for `object`,
     * e.g. `[[key1, value1], [key2, value2]]`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the new array of key-value pairs.
     * @example
     *
     * _.pairs({ 'barney': 36, 'fred': 40 });
     * // => [['barney', 36], ['fred', 40]] (iteration order is not guaranteed)
     */
    function pairs(object) {
      object = toObject(object);

      var index = -1,
          props = keys(object),
          length = props.length,
          result = Array(length);

      while (++index < length) {
        var key = props[index];
        result[index] = [key, object[key]];
      }
      return result;
    }

    /**
     * Creates an object composed of the picked `object` properties. Property
     * names may be specified as individual arguments or as arrays of property
     * names. If `predicate` is provided it is invoked for each property of `object`
     * picking the properties `predicate` returns truthy for. The predicate is
     * bound to `thisArg` and invoked with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {Function|...(string|string[])} [predicate] The function invoked per
     *  iteration or property names to pick, specified as individual property
     *  names or arrays of property names.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'user': 'fred', 'age': 40 };
     *
     * _.pick(object, 'user');
     * // => { 'user': 'fred' }
     *
     * _.pick(object, _.isString);
     * // => { 'user': 'fred' }
     */
    var pick = restParam(function(object, props) {
      if (object == null) {
        return {};
      }
      return typeof props[0] == 'function'
        ? pickByCallback(object, bindCallback(props[0], props[1], 3))
        : pickByArray(object, baseFlatten(props));
    });

    /**
     * This method is like `_.get` except that if the resolved value is a function
     * it is invoked with the `this` binding of its parent object and its result
     * is returned.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a.b.c', 'default');
     * // => 'default'
     *
     * _.result(object, 'a.b.c', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      var result = object == null ? undefined : object[path];
      if (result === undefined) {
        if (object != null && !isKey(path, object)) {
          path = toPath(path);
          object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
          result = object == null ? undefined : object[last(path)];
        }
        result = result === undefined ? defaultValue : result;
      }
      return isFunction(result) ? result.call(object) : result;
    }

    /**
     * Sets the property value of `path` on `object`. If a portion of `path`
     * does not exist it is created.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to augment.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, 'x[0].y.z', 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      if (object == null) {
        return object;
      }
      var pathKey = (path + '');
      path = (object[pathKey] != null || isKey(path, object)) ? [pathKey] : toPath(path);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = path[index];
        if (isObject(nested)) {
          if (index == lastIndex) {
            nested[key] = value;
          } else if (nested[key] == null) {
            nested[key] = isIndex(path[index + 1]) ? [] : {};
          }
        }
        nested = nested[key];
      }
      return object;
    }

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own enumerable
     * properties through `iteratee`, with each invocation potentially mutating
     * the `accumulator` object. The `iteratee` is bound to `thisArg` and invoked
     * with four arguments: (accumulator, value, key, object). Iteratee functions
     * may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Array|Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * });
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2 }, function(result, n, key) {
     *   result[key] = n * 3;
     * });
     * // => { 'a': 3, 'b': 6 }
     */
    function transform(object, iteratee, accumulator, thisArg) {
      var isArr = isArray(object) || isTypedArray(object);
      iteratee = getCallback(iteratee, thisArg, 4);

      if (accumulator == null) {
        if (isArr || isObject(object)) {
          var Ctor = object.constructor;
          if (isArr) {
            accumulator = isArray(object) ? new Ctor : [];
          } else {
            accumulator = baseCreate(isFunction(Ctor) ? Ctor.prototype : undefined);
          }
        } else {
          accumulator = {};
        }
      }
      (isArr ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Creates an array of the own enumerable property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable property values
     * of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Checks if `n` is between `start` and up to but not including, `end`. If
     * `end` is not specified it is set to `start` with `start` then set to `0`.
     *
     * @static
     * @memberOf _
     * @category Number
     * @param {number} n The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `n` is in the range, else `false`.
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     */
    function inRange(value, start, end) {
      start = +start || 0;
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = +end || 0;
      }
      return value >= nativeMin(start, end) && value < nativeMax(start, end);
    }

    /**
     * Produces a random number between `min` and `max` (inclusive). If only one
     * argument is provided a number between `0` and the given number is returned.
     * If `floating` is `true`, or either `min` or `max` are floats, a floating-point
     * number is returned instead of an integer.
     *
     * @static
     * @memberOf _
     * @category Number
     * @param {number} [min=0] The minimum possible value.
     * @param {number} [max=1] The maximum possible value.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(min, max, floating) {
      if (floating && isIterateeCall(min, max, floating)) {
        max = floating = undefined;
      }
      var noMin = min == null,
          noMax = max == null;

      if (floating == null) {
        if (noMax && typeof min == 'boolean') {
          floating = min;
          min = 1;
        }
        else if (typeof max == 'boolean') {
          floating = max;
          noMax = true;
        }
      }
      if (noMin && noMax) {
        max = 1;
        noMax = false;
      }
      min = +min || 0;
      if (noMax) {
        max = min;
        min = 0;
      } else {
        max = +max || 0;
      }
      if (floating || min % 1 || max % 1) {
        var rand = nativeRandom();
        return nativeMin(min + (rand * (max - min + parseFloat('1e-' + ((rand + '').length - 1)))), max);
      }
      return baseRandom(min, max);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar');
     * // => 'fooBar'
     *
     * _.camelCase('__foo_bar__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? (word.charAt(0).toUpperCase() + word.slice(1)) : word);
    });

    /**
     * Capitalizes the first character of `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('fred');
     * // => 'Fred'
     */
    function capitalize(string) {
      string = baseToString(string);
      return string && (string.charAt(0).toUpperCase() + string.slice(1));
    }

    /**
     * Deburrs `string` by converting [latin-1 supplementary letters](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * to basic latin letters and removing [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = baseToString(string);
      return string && string.replace(reLatin1, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to search.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search from.
     * @returns {boolean} Returns `true` if `string` ends with `target`, else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = baseToString(string);
      target = (target + '');

      var length = string.length;
      position = position === undefined
        ? length
        : nativeMin(position < 0 ? 0 : (+position || 0), length);

      position -= target.length;
      return position >= 0 && string.indexOf(target, position) == position;
    }

    /**
     * Converts the characters "&", "<", ">", '"', "'", and "\`", in `string` to
     * their corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional characters
     * use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value.
     * See [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * Backticks are escaped because in Internet Explorer < 9, they can break out
     * of attribute values or HTML comments. See [#59](https://html5sec.org/#59),
     * [#102](https://html5sec.org/#102), [#108](https://html5sec.org/#108), and
     * [#133](https://html5sec.org/#133) of the [HTML5 Security Cheatsheet](https://html5sec.org/)
     * for more details.
     *
     * When working with HTML you should always [quote attribute values](http://wonko.com/post/html-escaping)
     * to reduce XSS vectors.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      // Reset `lastIndex` because in IE < 9 `String#replace` does not.
      string = baseToString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "\", "/", "^", "$", ".", "|", "?",
     * "*", "+", "(", ")", "[", "]", "{" and "}" in `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https:\/\/lodash\.com\/\)'
     */
    function escapeRegExp(string) {
      string = baseToString(string);
      return (string && reHasRegExpChars.test(string))
        ? string.replace(reRegExpChars, escapeRegExpChar)
        : (string || '(?:)');
    }

    /**
     * Converts `string` to [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__foo_bar__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = baseToString(string);
      length = +length;

      var strLength = string.length;
      if (strLength >= length || !nativeIsFinite(length)) {
        return string;
      }
      var mid = (length - strLength) / 2,
          leftLength = nativeFloor(mid),
          rightLength = nativeCeil(mid);

      chars = createPadding('', rightLength, chars);
      return chars.slice(0, leftLength) + string + chars;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padLeft('abc', 6);
     * // => '   abc'
     *
     * _.padLeft('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padLeft('abc', 3);
     * // => 'abc'
     */
    var padLeft = createPadDir();

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padRight('abc', 6);
     * // => 'abc   '
     *
     * _.padRight('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padRight('abc', 3);
     * // => 'abc'
     */
    var padRight = createPadDir(true);

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a hexadecimal,
     * in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the [ES5 implementation](https://es5.github.io/#E)
     * of `parseInt`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      // Firefox < 21 and Opera < 15 follow ES3 for `parseInt`.
      // Chrome fails to trim leading <BOM> whitespace characters.
      // See https://code.google.com/p/v8/issues/detail?id=3109 for more details.
      if (guard ? isIterateeCall(string, radix, guard) : radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      string = trim(string);
      return nativeParseInt(string, radix || (reHasHexPrefix.test(string) ? 16 : 10));
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=0] The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n) {
      var result = '';
      string = baseToString(string);
      n = +n;
      if (n < 1 || !string || !nativeIsFinite(n)) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        string += string;
      } while (n);

      return result;
    }

    /**
     * Converts `string` to [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--foo-bar');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Converts `string` to [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__foo_bar__');
     * // => 'Foo Bar'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + (word.charAt(0).toUpperCase() + word.slice(1));
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to search.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`, else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = baseToString(string);
      position = position == null
        ? 0
        : nativeMin(position < 0 ? 0 : (+position || 0), string.length);

      return string.lastIndexOf(target, position) == position;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is provided it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options] The options object.
     * @param {RegExp} [options.escape] The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate] The "evaluate" delimiter.
     * @param {Object} [options.imports] An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate] The "interpolate" delimiter.
     * @param {string} [options.sourceURL] The sourceURL of the template's compiled source.
     * @param {string} [options.variable] The data object variable name.
     * @param- {Object} [otherOptions] Enables the legacy `options` param signature.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // using the "interpolate" delimiter to create a compiled template
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // using the HTML "escape" delimiter to escape data property values
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // using the "evaluate" delimiter to execute JavaScript and generate HTML
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // using the internal `print` function in "evaluate" delimiters
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // using the ES delimiter as an alternative to the default "interpolate" delimiter
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // using custom template delimiters
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // using backslashes to treat delimiters as plain text
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // using the `imports` option to import `jQuery` as `jq`
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // using the `sourceURL` option to specify a custom sourceURL for the template
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector
     *
     * // using the `variable` option to ensure a with-statement isn't used in the compiled template
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // using the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and a stack trace
     * fs.writeFileSync(path.join(cwd, 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, otherOptions) {
      // Based on John Resig's `tmpl` implementation (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (otherOptions && isIterateeCall(string, options, otherOptions)) {
        options = otherOptions = undefined;
      }
      string = baseToString(string);
      options = assignWith(baseAssign({}, otherOptions || options), settings, assignOwnDefaults);

      var imports = assignWith(baseAssign({}, options.imports), settings.imports, assignOwnDefaults),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      var sourceURL = '//# sourceURL=' +
        ('sourceURL' in options
          ? options.sourceURL
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products requires returning the `match`
        // string in order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      var value = string;
      string = baseToString(string);
      if (!string) {
        return string;
      }
      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
        return string.slice(trimmedLeftIndex(string), trimmedRightIndex(string) + 1);
      }
      chars = (chars + '');
      return string.slice(charsLeftIndex(string, chars), charsRightIndex(string, chars) + 1);
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimLeft('  abc  ');
     * // => 'abc  '
     *
     * _.trimLeft('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimLeft(string, chars, guard) {
      var value = string;
      string = baseToString(string);
      if (!string) {
        return string;
      }
      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
        return string.slice(trimmedLeftIndex(string));
      }
      return string.slice(charsLeftIndex(string, (chars + '')));
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimRight('  abc  ');
     * // => '  abc'
     *
     * _.trimRight('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimRight(string, chars, guard) {
      var value = string;
      string = baseToString(string);
      if (!string) {
        return string;
      }
      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
        return string.slice(0, trimmedRightIndex(string) + 1);
      }
      return string.slice(0, charsRightIndex(string, (chars + '')) + 1);
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object|number} [options] The options object or maximum string length.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.trunc('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.trunc('hi-diddly-ho there, neighborino', 24);
     * // => 'hi-diddly-ho there, n...'
     *
     * _.trunc('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.trunc('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.trunc('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function trunc(string, options, guard) {
      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (options != null) {
        if (isObject(options)) {
          var separator = 'separator' in options ? options.separator : separator;
          length = 'length' in options ? (+options.length || 0) : length;
          omission = 'omission' in options ? baseToString(options.omission) : omission;
        } else {
          length = +options || 0;
        }
      }
      string = baseToString(string);
      if (length >= string.length) {
        return string;
      }
      var end = length - omission.length;
      if (end < 1) {
        return omission;
      }
      var result = string.slice(0, end);
      if (separator == null) {
        return result + omission;
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              newEnd,
              substring = string.slice(0, end);

          if (!separator.global) {
            separator = RegExp(separator.source, (reFlags.exec(separator) || '') + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            newEnd = match.index;
          }
          result = result.slice(0, newEnd == null ? end : newEnd);
        }
      } else if (string.indexOf(separator, end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, `&#39;`, and `&#96;` in `string` to their
     * corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional HTML
     * entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = baseToString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      if (guard && isIterateeCall(string, pattern, guard)) {
        pattern = undefined;
      }
      string = baseToString(string);
      return string.match(pattern || reWords) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it is invoked.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Function} func The function to attempt.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // avoid throwing errors for invalid selectors
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = restParam(function(func, args) {
      try {
        return func.apply(undefined, args);
      } catch(e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and arguments of the created function. If `func` is a property name the
     * created callback returns the property value for a given element. If `func`
     * is an object the created callback returns `true` for elements that contain
     * the equivalent object properties, otherwise it returns `false`.
     *
     * @static
     * @memberOf _
     * @alias iteratee
     * @category Utility
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // wrap to create custom callback shorthands
     * _.callback = _.wrap(_.callback, function(callback, func, thisArg) {
     *   var match = /^(.+?)__([gl]t)(.+)$/.exec(func);
     *   if (!match) {
     *     return callback(func, thisArg);
     *   }
     *   return function(object) {
     *     return match[2] == 'gt'
     *       ? object[match[1]] > match[3]
     *       : object[match[1]] < match[3];
     *   };
     * });
     *
     * _.filter(users, 'age__gt36');
     * // => [{ 'user': 'fred', 'age': 40 }]
     */
    function callback(func, thisArg, guard) {
      if (guard && isIterateeCall(func, thisArg, guard)) {
        thisArg = undefined;
      }
      return isObjectLike(func)
        ? matches(func)
        : baseCallback(func, thisArg);
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var object = { 'user': 'fred' };
     * var getter = _.constant(object);
     *
     * getter() === object;
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * This method returns the first argument provided to it.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'user': 'fred' };
     *
     * _.identity(object) === object;
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that performs a deep comparison between a given object
     * and `source`, returning `true` if the given object has equivalent property
     * values, else `false`.
     *
     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
     * numbers, `Object` objects, regexes, and strings. Objects are compared by
     * their own, not inherited, enumerable properties. For comparing a single
     * own or inherited property value see `_.matchesProperty`.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, _.matches({ 'age': 40, 'active': false }));
     * // => [{ 'user': 'fred', 'age': 40, 'active': false }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, true));
    }

    /**
     * Creates a function that compares the property value of `path` on a given
     * object to `value`.
     *
     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
     * numbers, `Object` objects, regexes, and strings. Objects are compared by
     * their own, not inherited, enumerable properties.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * _.find(users, _.matchesProperty('user', 'fred'));
     * // => { 'user': 'fred' }
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, true));
    }

    /**
     * Creates a function that invokes the method at `path` on a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': { 'c': _.constant(2) } } },
     *   { 'a': { 'b': { 'c': _.constant(1) } } }
     * ];
     *
     * _.map(objects, _.method('a.b.c'));
     * // => [2, 1]
     *
     * _.invoke(_.sortBy(objects, _.method(['a', 'b', 'c'])), 'a.b.c');
     * // => [1, 2]
     */
    var method = restParam(function(path, args) {
      return function(object) {
        return invokePath(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path on `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = restParam(function(object, args) {
      return function(path) {
        return invokePath(object, path, args);
      };
    });

    /**
     * Adds all own enumerable function properties of a source object to the
     * destination object. If `object` is a function then methods are added to
     * its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options] The options object.
     * @param {boolean} [options.chain=true] Specify whether the functions added
     *  are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      if (options == null) {
        var isObj = isObject(source),
            props = isObj ? keys(source) : undefined,
            methodNames = (props && props.length) ? baseFunctions(source, props) : undefined;

        if (!(methodNames ? methodNames.length : isObj)) {
          methodNames = false;
          options = source;
          source = object;
          object = this;
        }
      }
      if (!methodNames) {
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = true,
          index = -1,
          isFunc = isFunction(object),
          length = methodNames.length;

      if (options === false) {
        chain = false;
      } else if (isObject(options) && 'chain' in options) {
        chain = options.chain;
      }
      while (++index < length) {
        var methodName = methodNames[index],
            func = source[methodName];

        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = (function(func) {
            return function() {
              var chainAll = this.__chain__;
              if (chain || chainAll) {
                var result = object(this.__wrapped__),
                    actions = result.__actions__ = arrayCopy(this.__actions__);

                actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
                result.__chain__ = chainAll;
                return result;
              }
              return func.apply(object, arrayPush([this.value()], arguments));
            };
          }(func));
        }
      }
      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      root._ = oldDash;
      return this;
    }

    /**
     * A no-operation function that returns `undefined` regardless of the
     * arguments it receives.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @example
     *
     * var object = { 'user': 'fred' };
     *
     * _.noop(object) === undefined;
     * // => true
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that returns the property value at `path` on a
     * given object.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': { 'c': 2 } } },
     *   { 'a': { 'b': { 'c': 1 } } }
     * ];
     *
     * _.map(objects, _.property('a.b.c'));
     * // => [2, 1]
     *
     * _.pluck(_.sortBy(objects, _.property(['a', 'b', 'c'])), 'a.b.c');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(path) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the property value at a given path on `object`.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return baseGet(object, toPath(path), path + '');
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. If `end` is not specified it is
     * set to `start` with `start` then set to `0`. If `end` is less than `start`
     * a zero-length range is created unless a negative `step` is specified.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the new array of numbers.
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    function range(start, end, step) {
      if (step && isIterateeCall(start, end, step)) {
        end = step = undefined;
      }
      start = +start || 0;
      step = step == null ? 1 : (+step || 0);

      if (end == null) {
        end = start;
        start = 0;
      } else {
        end = +end || 0;
      }
      // Use `Array(length)` so engines like Chakra and V8 avoid slower modes.
      // See https://youtu.be/XAqIpGU8ZZk#t=17m25s for more details.
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (++index < length) {
        result[index] = start;
        start += step;
      }
      return result;
    }

    /**
     * Invokes the iteratee function `n` times, returning an array of the results
     * of each invocation. The `iteratee` is bound to `thisArg` and invoked with
     * one argument; (index).
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * var diceRolls = _.times(3, _.partial(_.random, 1, 6, false));
     * // => [3, 6, 4]
     *
     * _.times(3, function(n) {
     *   mage.castSpell(n);
     * });
     * // => invokes `mage.castSpell(n)` three times with `n` of `0`, `1`, and `2`
     *
     * _.times(3, function(n) {
     *   this.cast(n);
     * }, mage);
     * // => also invokes `mage.castSpell(n)` three times
     */
    function times(n, iteratee, thisArg) {
      n = nativeFloor(n);

      // Exit early to avoid a JSC JIT bug in Safari 8
      // where `Array(0)` is treated as `Array(1)`.
      if (n < 1 || !nativeIsFinite(n)) {
        return [];
      }
      var index = -1,
          result = Array(nativeMin(n, MAX_ARRAY_LENGTH));

      iteratee = bindCallback(iteratee, thisArg, 1);
      while (++index < n) {
        if (index < MAX_ARRAY_LENGTH) {
          result[index] = iteratee(index);
        } else {
          iteratee(index);
        }
      }
      return result;
    }

    /**
     * Generates a unique ID. If `prefix` is provided the ID is appended to it.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {string} [prefix] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return baseToString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {number} augend The first number to add.
     * @param {number} addend The second number to add.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    function add(augend, addend) {
      return (+augend || 0) + (+addend || 0);
    }

    /**
     * Calculates `n` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {number} n The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Calculates `n` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {number} n The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Gets the maximum value of `collection`. If `collection` is empty or falsey
     * `-Infinity` is returned. If an iteratee function is provided it is invoked
     * for each value in `collection` to generate the criterion by which the value
     * is ranked. The `iteratee` is bound to `thisArg` and invoked with three
     * arguments: (value, index, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => -Infinity
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * _.max(users, function(chr) {
     *   return chr.age;
     * });
     * // => { 'user': 'fred', 'age': 40 }
     *
     * // using the `_.property` callback shorthand
     * _.max(users, 'age');
     * // => { 'user': 'fred', 'age': 40 }
     */
    var max = createExtremum(gt, NEGATIVE_INFINITY);

    /**
     * Gets the minimum value of `collection`. If `collection` is empty or falsey
     * `Infinity` is returned. If an iteratee function is provided it is invoked
     * for each value in `collection` to generate the criterion by which the value
     * is ranked. The `iteratee` is bound to `thisArg` and invoked with three
     * arguments: (value, index, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => Infinity
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * _.min(users, function(chr) {
     *   return chr.age;
     * });
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // using the `_.property` callback shorthand
     * _.min(users, 'age');
     * // => { 'user': 'barney', 'age': 36 }
     */
    var min = createExtremum(lt, POSITIVE_INFINITY);

    /**
     * Calculates `n` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {number} n The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Gets the sum of the values in `collection`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 6]);
     * // => 10
     *
     * _.sum({ 'a': 4, 'b': 6 });
     * // => 10
     *
     * var objects = [
     *   { 'n': 4 },
     *   { 'n': 6 }
     * ];
     *
     * _.sum(objects, function(object) {
     *   return object.n;
     * });
     * // => 10
     *
     * // using the `_.property` callback shorthand
     * _.sum(objects, 'n');
     * // => 10
     */
    function sum(collection, iteratee, thisArg) {
      if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
        iteratee = undefined;
      }
      iteratee = getCallback(iteratee, thisArg, 3);
      return iteratee.length == 1
        ? arraySum(isArray(collection) ? collection : toIterable(collection), iteratee)
        : baseSum(collection, iteratee);
    }

    /*------------------------------------------------------------------------*/

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    // Add functions to the `Map` cache.
    MapCache.prototype['delete'] = mapDelete;
    MapCache.prototype.get = mapGet;
    MapCache.prototype.has = mapHas;
    MapCache.prototype.set = mapSet;

    // Add functions to the `Set` cache.
    SetCache.prototype.push = cachePush;

    // Assign cache to `_.memoize`.
    memoize.Cache = MapCache;

    // Add functions that return wrapped values when chaining.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.callback = callback;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.functions = functions;
    lodash.groupBy = groupBy;
    lodash.indexBy = indexBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.invert = invert;
    lodash.invoke = invoke;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.modArgs = modArgs;
    lodash.negate = negate;
    lodash.omit = omit;
    lodash.once = once;
    lodash.pairs = pairs;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pluck = pluck;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.restParam = restParam;
    lodash.set = set;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortByAll = sortByAll;
    lodash.sortByOrder = sortByOrder;
    lodash.spread = spread;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.times = times;
    lodash.toArray = toArray;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.union = union;
    lodash.uniq = uniq;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.where = where;
    lodash.without = without;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.backflow = flowRight;
    lodash.collect = map;
    lodash.compose = flowRight;
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.extend = assign;
    lodash.iteratee = callback;
    lodash.methods = functions;
    lodash.object = zipObject;
    lodash.select = filter;
    lodash.tail = rest;
    lodash.unique = uniq;

    // Add functions to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add functions that return unwrapped values when chaining.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.deburr = deburr;
    lodash.endsWith = endsWith;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.findWhere = findWhere;
    lodash.first = first;
    lodash.floor = floor;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isBoolean = isBoolean;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isMatch = isMatch;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isString = isString;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.min = min;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padLeft = padLeft;
    lodash.padRight = padRight;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.sum = sum;
    lodash.template = template;
    lodash.trim = trim;
    lodash.trimLeft = trimLeft;
    lodash.trimRight = trimRight;
    lodash.trunc = trunc;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.words = words;

    // Add aliases.
    lodash.all = every;
    lodash.any = some;
    lodash.contains = includes;
    lodash.eq = isEqual;
    lodash.detect = find;
    lodash.foldl = reduce;
    lodash.foldr = reduceRight;
    lodash.head = first;
    lodash.include = includes;
    lodash.inject = reduce;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!lodash.prototype[methodName]) {
          source[methodName] = func;
        }
      });
      return source;
    }()), false);

    /*------------------------------------------------------------------------*/

    // Add functions capable of returning wrapped and unwrapped values when chaining.
    lodash.sample = sample;

    lodash.prototype.sample = function(n) {
      if (!this.__chain__ && n == null) {
        return sample(this.value());
      }
      return this.thru(function(value) {
        return sample(value, n);
      });
    };

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type string
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        var filtered = this.__filtered__;
        if (filtered && !index) {
          return new LazyWrapper(this);
        }
        n = n == null ? 1 : nativeMax(nativeFloor(n) || 0, 0);

        var result = this.clone();
        if (filtered) {
          result.__takeCount__ = nativeMin(result.__takeCount__, n);
        } else {
          result.__views__.push({ 'size': n, 'type': methodName + (result.__dir__ < 0 ? 'Right' : '') });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type != LAZY_MAP_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee, thisArg) {
        var result = this.clone();
        result.__iteratees__.push({ 'iteratee': getCallback(iteratee, thisArg, 1), 'type': type });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.first` and `_.last`.
    arrayEach(['first', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.rest`.
    arrayEach(['initial', 'rest'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    // Add `LazyWrapper` methods for `_.pluck` and `_.where`.
    arrayEach(['pluck', 'where'], function(methodName, index) {
      var operationName = index ? 'filter' : 'map',
          createCallback = index ? baseMatches : property;

      LazyWrapper.prototype[methodName] = function(value) {
        return this[operationName](createCallback(value));
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.reject = function(predicate, thisArg) {
      predicate = getCallback(predicate, thisArg, 1);
      return this.filter(function(value) {
        return !predicate(value);
      });
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = start == null ? 0 : (+start || 0);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = (+end || 0);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate, thisArg) {
      return this.reverse().takeWhile(predicate, thisArg).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(POSITIVE_INFINITY);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|map|reject)|While$/.test(methodName),
          retUnwrapped = /^(?:first|last)$/.test(methodName),
          lodashFunc = lodash[retUnwrapped ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName];

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var args = retUnwrapped ? [1] : arguments,
            chainAll = this.__chain__,
            value = this.__wrapped__,
            isHybrid = !!this.__actions__.length,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var interceptor = function(value) {
          return (retUnwrapped && chainAll)
            ? lodashFunc(value, 1)[0]
            : lodashFunc.apply(undefined, arrayPush([value], args));
        };

        var action = { 'func': thru, 'args': [interceptor], 'thisArg': undefined },
            onlyLazy = isLazy && !isHybrid;

        if (retUnwrapped && !chainAll) {
          if (onlyLazy) {
            value = value.clone();
            value.__actions__.push(action);
            return func.call(value);
          }
          return lodashFunc.call(undefined, this.value())[0];
        }
        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push(action);
          return new LodashWrapper(result, chainAll);
        }
        return this.thru(interceptor);
      };
    });

    // Add `Array` and `String` methods to `lodash.prototype`.
    arrayEach(['join', 'pop', 'push', 'replace', 'shift', 'sort', 'splice', 'split', 'unshift'], function(methodName) {
      var func = (/^(?:replace|split)$/.test(methodName) ? stringProto : arrayProto)[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:join|pop|replace|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          return func.apply(this.value(), args);
        }
        return this[chainName](function(value) {
          return func.apply(value, args);
        });
      };
    });

    // Map minified function names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name,
            names = realNames[key] || (realNames[key] = []);

        names.push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybridWrapper(undefined, BIND_KEY_FLAG).name] = [{ 'name': 'wrapper', 'func': undefined }];

    // Add functions to the lazy wrapper.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chaining functions to the `lodash` wrapper.
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.concat = wrapperConcat;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toString = wrapperToString;
    lodash.prototype.run = lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add function aliases to the `lodash` wrapper.
    lodash.prototype.collect = lodash.prototype.map;
    lodash.prototype.head = lodash.prototype.first;
    lodash.prototype.select = lodash.prototype.filter;
    lodash.prototype.tail = lodash.prototype.rest;

    return lodash;
  }

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers like r.js check for condition patterns like the following:
  if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
    // Expose lodash to the global object when an AMD loader is present to avoid
    // errors in cases where lodash is loaded by a script tag and not intended
    // as an AMD module. See http://requirejs.org/docs/errors.html#mismatch for
    // more details.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    define(function() {
      return _;
    });
  }
  // Check for `exports` after `define` in case a build optimizer adds an `exports` object.
  else if (freeExports && freeModule) {
    // Export for Node.js or RingoJS.
    if (moduleExports) {
      (freeModule.exports = _)._ = _;
    }
    // Export for Rhino with CommonJS support.
    else {
      freeExports._ = _;
    }
  }
  else {
    // Export for a browser or Rhino.
    root._ = _;
  }
}.call(this));

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],2:[function(require,module,exports){
//  Trapeze.Placeholder 1.0

(function (global, factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define(['jquery'], function ($) {
            // Also create a global in case some scripts
            // that are loaded still are looking for
            // a global even when an AMD loader is in use.
            return (global.Placeholder = factory($));
        });
    } else {
        // Browser globals
        global.Placeholder = factory(global.jQuery);
    }
}(this, function ($) {
    // Initial setup
    // =============

    var NAME    = 'Placeholder',
        VERSION = '1.0.2';

    // Placeholder
    // ===========

    Placeholder = function (options) {
        var defaults = {
                selector : "[placeholder]",
                enabled  : true,

                classnames : {
                    active : 'phr',
                    state_active : 'active',
                    state_inactive : 'inactive'
                }
            },

            extended_defaults = this._extendDefaults();

        if (typeof extended_defaults !== 'object') extended_defaults = { };

        this.config     = $.extend(true, defaults, extended_defaults, options || { });
        this.enabled    = this.config.enabled;

        this._initialize();
    };

    Placeholder.prototype._extendDefaults = function () {
    };

    Placeholder.prototype._initialize = function () {
        this.selectElements();
    };

    Placeholder.prototype._testForPlaceholder = function () {
        // Thanks to Michael Taylor for his input attribute tests:
        // http://miketaylr.com/code/input-type-attr.html
        var el = document.createElement('input');

        return !!(el.placeholder === '') && !!(el.placeholder !== undefined);
    };

    Placeholder.prototype.selectElements = function () {
        var config = this.config,
            selector = config.selector,

            // Fix for Safari 5.1.5 and lower, where textarea placeholder
            // attributes have no word wrap and run off the ends of the input
            agent = navigator.userAgent,
            regex = /([0-9\.]+) Safari/,
            match = agent.match(regex);

        if (!this._testForPlaceholder()) {
            this.$elements = $(selector);
            this.$form = this.$elements.parents('form');

            // Add textareas to list of elements in Safari
            if (match) {
                var version = match[1].replace(/\./g,'');
                if ( version <= 515 ) {
                    this.$elements.add('textarea');
                }
            }

            this.applyPlaceholders();
        }
    };

    Placeholder.prototype.applyPlaceholders = function () {
        var classnames = this.config.classnames;

        this.$elements.each($.proxy(function (i, obj) {
            var $obj = $(obj);

            if ($obj.val() === '') {
                $obj.val($obj.attr('placeholder'))
                    .addClass(classnames.state_inactive);
            }

            this.bindEvents($obj);
        }, this));

        this.bindForms();
    };

    Placeholder.prototype.bindEvents = function ($obj) {
        var classnames = this.config.classnames;

        $obj.on('focus', function(evt) {
            if ($obj.val() == $obj.attr('placeholder')) {
                $obj.val('').removeClass(classnames.state_inactive)
                    .addClass(classnames.state_active);
            }
        });

        $obj.on('blur', function(evt) {
            if ($obj.val() == $obj.attr('placeholder') || $obj.val() === '') {
                $obj.val($obj.attr('placeholder')).removeClass(classnames.state_active)
                    .addClass(classnames.state_inactive);
            }
        });
    };

    Placeholder.prototype.bindForms = function () {
        var $elements = this.$elements;
        var selector = this.config.selector;

        $elements.parents('form').on('submit.placeholder', function (evt) {
            $(evt.currentTarget).find(selector).each(
            //$elements.each(
                function (i, obj) {
                var $obj = $(obj);
                if ($obj.val() == $obj.attr('placeholder')) {
                    $obj.val('');
                }
            });
        });
    };

    return Placeholder;

}));

},{}],3:[function(require,module,exports){
// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };

},{}],4:[function(require,module,exports){
var Vue // late bind
var map = Object.create(null)
var shimmed = false
var isBrowserify = false

/**
 * Determine compatibility and apply patch.
 *
 * @param {Function} vue
 * @param {Boolean} browserify
 */

exports.install = function (vue, browserify) {
  if (shimmed) return
  shimmed = true

  Vue = vue
  isBrowserify = browserify

  exports.compatible = !!Vue.internalDirectives
  if (!exports.compatible) {
    console.warn(
      '[HMR] vue-loader hot reload is only compatible with ' +
      'Vue.js 1.0.0+.'
    )
    return
  }

  // patch view directive
  patchView(Vue.internalDirectives.component)
  console.log('[HMR] Vue component hot reload shim applied.')
  // shim router-view if present
  var routerView = Vue.elementDirective('router-view')
  if (routerView) {
    patchView(routerView)
    console.log('[HMR] vue-router <router-view> hot reload shim applied.')
  }
}

/**
 * Shim the view directive (component or router-view).
 *
 * @param {Object} View
 */

function patchView (View) {
  var unbuild = View.unbuild
  View.unbuild = function (defer) {
    if (!this.hotUpdating) {
      var prevComponent = this.childVM && this.childVM.constructor
      removeView(prevComponent, this)
      // defer = true means we are transitioning to a new
      // Component. Register this new component to the list.
      if (defer) {
        addView(this.Component, this)
      }
    }
    // call original
    return unbuild.call(this, defer)
  }
}

/**
 * Add a component view to a Component's hot list
 *
 * @param {Function} Component
 * @param {Directive} view - view directive instance
 */

function addView (Component, view) {
  var id = Component && Component.options.hotID
  if (id) {
    if (!map[id]) {
      map[id] = {
        Component: Component,
        views: [],
        instances: []
      }
    }
    map[id].views.push(view)
  }
}

/**
 * Remove a component view from a Component's hot list
 *
 * @param {Function} Component
 * @param {Directive} view - view directive instance
 */

function removeView (Component, view) {
  var id = Component && Component.options.hotID
  if (id) {
    map[id].views.$remove(view)
  }
}

/**
 * Create a record for a hot module, which keeps track of its construcotr,
 * instnaces and views (component directives or router-views).
 *
 * @param {String} id
 * @param {Object} options
 */

exports.createRecord = function (id, options) {
  if (typeof options === 'function') {
    options = options.options
  }
  if (typeof options.el !== 'string' && typeof options.data !== 'object') {
    makeOptionsHot(id, options)
    map[id] = {
      Component: null,
      views: [],
      instances: []
    }
  }
}

/**
 * Make a Component options object hot.
 *
 * @param {String} id
 * @param {Object} options
 */

function makeOptionsHot (id, options) {
  options.hotID = id
  injectHook(options, 'created', function () {
    var record = map[id]
    if (!record.Component) {
      record.Component = this.constructor
    }
    record.instances.push(this)
  })
  injectHook(options, 'beforeDestroy', function () {
    map[id].instances.$remove(this)
  })
}

/**
 * Inject a hook to a hot reloadable component so that
 * we can keep track of it.
 *
 * @param {Object} options
 * @param {String} name
 * @param {Function} hook
 */

function injectHook (options, name, hook) {
  var existing = options[name]
  options[name] = existing
    ? Array.isArray(existing)
      ? existing.concat(hook)
      : [existing, hook]
    : [hook]
}

/**
 * Update a hot component.
 *
 * @param {String} id
 * @param {Object|null} newOptions
 * @param {String|null} newTemplate
 */

exports.update = function (id, newOptions, newTemplate) {
  var record = map[id]
  // force full-reload if an instance of the component is active but is not
  // managed by a view
  if (!record || (record.instances.length && !record.views.length)) {
    console.log('[HMR] Root or manually-mounted instance modified. Full reload may be required.')
    if (!isBrowserify) {
      window.location.reload()
    } else {
      // browserify-hmr somehow sends incomplete bundle if we reload here
      return
    }
  }
  if (!isBrowserify) {
    // browserify-hmr already logs this
    console.log('[HMR] Updating component: ' + format(id))
  }
  var Component = record.Component
  // update constructor
  if (newOptions) {
    // in case the user exports a constructor
    Component = record.Component = typeof newOptions === 'function'
      ? newOptions
      : Vue.extend(newOptions)
    makeOptionsHot(id, Component.options)
  }
  if (newTemplate) {
    Component.options.template = newTemplate
  }
  // handle recursive lookup
  if (Component.options.name) {
    Component.options.components[Component.options.name] = Component
  }
  // reset constructor cached linker
  Component.linker = null
  // reload all views
  record.views.forEach(function (view) {
    updateView(view, Component)
  })
  // flush devtools
  if (window.__VUE_DEVTOOLS_GLOBAL_HOOK__) {
    window.__VUE_DEVTOOLS_GLOBAL_HOOK__.emit('flush')
  }
}

/**
 * Update a component view instance
 *
 * @param {Directive} view
 * @param {Function} Component
 */

function updateView (view, Component) {
  if (!view._bound) {
    return
  }
  view.Component = Component
  view.hotUpdating = true
  // disable transitions
  view.vm._isCompiled = false
  // save state
  var state = extractState(view.childVM)
  // remount, make sure to disable keep-alive
  var keepAlive = view.keepAlive
  view.keepAlive = false
  view.mountComponent()
  view.keepAlive = keepAlive
  // restore state
  restoreState(view.childVM, state, true)
  // re-eanble transitions
  view.vm._isCompiled = true
  view.hotUpdating = false
}

/**
 * Extract state from a Vue instance.
 *
 * @param {Vue} vm
 * @return {Object}
 */

function extractState (vm) {
  return {
    cid: vm.constructor.cid,
    data: vm.$data,
    children: vm.$children.map(extractState)
  }
}

/**
 * Restore state to a reloaded Vue instance.
 *
 * @param {Vue} vm
 * @param {Object} state
 */

function restoreState (vm, state, isRoot) {
  var oldAsyncConfig
  if (isRoot) {
    // set Vue into sync mode during state rehydration
    oldAsyncConfig = Vue.config.async
    Vue.config.async = false
  }
  // actual restore
  if (isRoot || !vm._props) {
    vm.$data = state.data
  } else {
    Object.keys(state.data).forEach(function (key) {
      if (!vm._props[key]) {
        // for non-root, only restore non-props fields
        vm.$data[key] = state.data[key]
      }
    })
  }
  // verify child consistency
  var hasSameChildren = vm.$children.every(function (c, i) {
    return state.children[i] && state.children[i].cid === c.constructor.cid
  })
  if (hasSameChildren) {
    // rehydrate children
    vm.$children.forEach(function (c, i) {
      restoreState(c, state.children[i])
    })
  }
  if (isRoot) {
    Vue.config.async = oldAsyncConfig
  }
}

function format (id) {
  var match = id.match(/[^\/]+\.vue$/)
  return match ? match[0] : id
}

},{}],5:[function(require,module,exports){
(function (process){
/*!
 * Vue.js v1.0.28
 * (c) 2016 Evan You
 * Released under the MIT License.
 */
'use strict';

function set(obj, key, val) {
  if (hasOwn(obj, key)) {
    obj[key] = val;
    return;
  }
  if (obj._isVue) {
    set(obj._data, key, val);
    return;
  }
  var ob = obj.__ob__;
  if (!ob) {
    obj[key] = val;
    return;
  }
  ob.convert(key, val);
  ob.dep.notify();
  if (ob.vms) {
    var i = ob.vms.length;
    while (i--) {
      var vm = ob.vms[i];
      vm._proxy(key);
      vm._digest();
    }
  }
  return val;
}

/**
 * Delete a property and trigger change if necessary.
 *
 * @param {Object} obj
 * @param {String} key
 */

function del(obj, key) {
  if (!hasOwn(obj, key)) {
    return;
  }
  delete obj[key];
  var ob = obj.__ob__;
  if (!ob) {
    if (obj._isVue) {
      delete obj._data[key];
      obj._digest();
    }
    return;
  }
  ob.dep.notify();
  if (ob.vms) {
    var i = ob.vms.length;
    while (i--) {
      var vm = ob.vms[i];
      vm._unproxy(key);
      vm._digest();
    }
  }
}

var hasOwnProperty = Object.prototype.hasOwnProperty;
/**
 * Check whether the object has the property.
 *
 * @param {Object} obj
 * @param {String} key
 * @return {Boolean}
 */

function hasOwn(obj, key) {
  return hasOwnProperty.call(obj, key);
}

/**
 * Check if an expression is a literal value.
 *
 * @param {String} exp
 * @return {Boolean}
 */

var literalValueRE = /^\s?(true|false|-?[\d\.]+|'[^']*'|"[^"]*")\s?$/;

function isLiteral(exp) {
  return literalValueRE.test(exp);
}

/**
 * Check if a string starts with $ or _
 *
 * @param {String} str
 * @return {Boolean}
 */

function isReserved(str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F;
}

/**
 * Guard text output, make sure undefined outputs
 * empty string
 *
 * @param {*} value
 * @return {String}
 */

function _toString(value) {
  return value == null ? '' : value.toString();
}

/**
 * Check and convert possible numeric strings to numbers
 * before setting back to data
 *
 * @param {*} value
 * @return {*|Number}
 */

function toNumber(value) {
  if (typeof value !== 'string') {
    return value;
  } else {
    var parsed = Number(value);
    return isNaN(parsed) ? value : parsed;
  }
}

/**
 * Convert string boolean literals into real booleans.
 *
 * @param {*} value
 * @return {*|Boolean}
 */

function toBoolean(value) {
  return value === 'true' ? true : value === 'false' ? false : value;
}

/**
 * Strip quotes from a string
 *
 * @param {String} str
 * @return {String | false}
 */

function stripQuotes(str) {
  var a = str.charCodeAt(0);
  var b = str.charCodeAt(str.length - 1);
  return a === b && (a === 0x22 || a === 0x27) ? str.slice(1, -1) : str;
}

/**
 * Camelize a hyphen-delimited string.
 *
 * @param {String} str
 * @return {String}
 */

var camelizeRE = /-(\w)/g;

function camelize(str) {
  return str.replace(camelizeRE, toUpper);
}

function toUpper(_, c) {
  return c ? c.toUpperCase() : '';
}

/**
 * Hyphenate a camelCase string.
 *
 * @param {String} str
 * @return {String}
 */

var hyphenateRE = /([^-])([A-Z])/g;

function hyphenate(str) {
  return str.replace(hyphenateRE, '$1-$2').replace(hyphenateRE, '$1-$2').toLowerCase();
}

/**
 * Converts hyphen/underscore/slash delimitered names into
 * camelized classNames.
 *
 * e.g. my-component => MyComponent
 *      some_else    => SomeElse
 *      some/comp    => SomeComp
 *
 * @param {String} str
 * @return {String}
 */

var classifyRE = /(?:^|[-_\/])(\w)/g;

function classify(str) {
  return str.replace(classifyRE, toUpper);
}

/**
 * Simple bind, faster than native
 *
 * @param {Function} fn
 * @param {Object} ctx
 * @return {Function}
 */

function bind(fn, ctx) {
  return function (a) {
    var l = arguments.length;
    return l ? l > 1 ? fn.apply(ctx, arguments) : fn.call(ctx, a) : fn.call(ctx);
  };
}

/**
 * Convert an Array-like object to a real Array.
 *
 * @param {Array-like} list
 * @param {Number} [start] - start index
 * @return {Array}
 */

function toArray(list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret;
}

/**
 * Mix properties into target object.
 *
 * @param {Object} to
 * @param {Object} from
 */

function extend(to, from) {
  var keys = Object.keys(from);
  var i = keys.length;
  while (i--) {
    to[keys[i]] = from[keys[i]];
  }
  return to;
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 *
 * @param {*} obj
 * @return {Boolean}
 */

function isObject(obj) {
  return obj !== null && typeof obj === 'object';
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 *
 * @param {*} obj
 * @return {Boolean}
 */

var toString = Object.prototype.toString;
var OBJECT_STRING = '[object Object]';

function isPlainObject(obj) {
  return toString.call(obj) === OBJECT_STRING;
}

/**
 * Array type check.
 *
 * @param {*} obj
 * @return {Boolean}
 */

var isArray = Array.isArray;

/**
 * Define a property.
 *
 * @param {Object} obj
 * @param {String} key
 * @param {*} val
 * @param {Boolean} [enumerable]
 */

function def(obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Debounce a function so it only gets called after the
 * input stops arriving after the given wait period.
 *
 * @param {Function} func
 * @param {Number} wait
 * @return {Function} - the debounced function
 */

function _debounce(func, wait) {
  var timeout, args, context, timestamp, result;
  var later = function later() {
    var last = Date.now() - timestamp;
    if (last < wait && last >= 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    }
  };
  return function () {
    context = this;
    args = arguments;
    timestamp = Date.now();
    if (!timeout) {
      timeout = setTimeout(later, wait);
    }
    return result;
  };
}

/**
 * Manual indexOf because it's slightly faster than
 * native.
 *
 * @param {Array} arr
 * @param {*} obj
 */

function indexOf(arr, obj) {
  var i = arr.length;
  while (i--) {
    if (arr[i] === obj) return i;
  }
  return -1;
}

/**
 * Make a cancellable version of an async callback.
 *
 * @param {Function} fn
 * @return {Function}
 */

function cancellable(fn) {
  var cb = function cb() {
    if (!cb.cancelled) {
      return fn.apply(this, arguments);
    }
  };
  cb.cancel = function () {
    cb.cancelled = true;
  };
  return cb;
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 *
 * @param {*} a
 * @param {*} b
 * @return {Boolean}
 */

function looseEqual(a, b) {
  /* eslint-disable eqeqeq */
  return a == b || (isObject(a) && isObject(b) ? JSON.stringify(a) === JSON.stringify(b) : false);
  /* eslint-enable eqeqeq */
}

var hasProto = ('__proto__' in {});

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined' && Object.prototype.toString.call(window) !== '[object Object]';

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

// UA sniffing for working around browser-specific quirks
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && UA.indexOf('trident') > 0;
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isAndroid = UA && UA.indexOf('android') > 0;
var isIOS = UA && /iphone|ipad|ipod|ios/.test(UA);

var transitionProp = undefined;
var transitionEndEvent = undefined;
var animationProp = undefined;
var animationEndEvent = undefined;

// Transition property/event sniffing
if (inBrowser && !isIE9) {
  var isWebkitTrans = window.ontransitionend === undefined && window.onwebkittransitionend !== undefined;
  var isWebkitAnim = window.onanimationend === undefined && window.onwebkitanimationend !== undefined;
  transitionProp = isWebkitTrans ? 'WebkitTransition' : 'transition';
  transitionEndEvent = isWebkitTrans ? 'webkitTransitionEnd' : 'transitionend';
  animationProp = isWebkitAnim ? 'WebkitAnimation' : 'animation';
  animationEndEvent = isWebkitAnim ? 'webkitAnimationEnd' : 'animationend';
}

/* istanbul ignore next */
function isNative(Ctor) {
  return (/native code/.test(Ctor.toString())
  );
}

/**
 * Defer a task to execute it asynchronously. Ideally this
 * should be executed as a microtask, so we leverage
 * MutationObserver if it's available, and fallback to
 * setTimeout(0).
 *
 * @param {Function} cb
 * @param {Object} ctx
 */

var nextTick = (function () {
  var callbacks = [];
  var pending = false;
  var timerFunc = undefined;

  function nextTickHandler() {
    pending = false;
    var copies = callbacks.slice(0);
    callbacks.length = 0;
    for (var i = 0; i < copies.length; i++) {
      copies[i]();
    }
  }

  // the nextTick behavior leverages the microtask queue, which can be accessed
  // via either native Promise.then or MutationObserver.
  // MutationObserver has wider support, however it is seriously bugged in
  // UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
  // completely stops working after triggering a few times... so, if native
  // Promise is available, we will use it:
  /* istanbul ignore if */
  if (typeof Promise !== 'undefined' && isNative(Promise)) {
    var p = Promise.resolve();
    var noop = function noop() {};
    timerFunc = function () {
      p.then(nextTickHandler);
      // in problematic UIWebViews, Promise.then doesn't completely break, but
      // it can get stuck in a weird state where callbacks are pushed into the
      // microtask queue but the queue isn't being flushed, until the browser
      // needs to do some other work, e.g. handle a timer. Therefore we can
      // "force" the microtask queue to be flushed by adding an empty timer.
      if (isIOS) setTimeout(noop);
    };
  } else if (typeof MutationObserver !== 'undefined') {
    // use MutationObserver where native Promise is not available,
    // e.g. IE11, iOS7, Android 4.4
    var counter = 1;
    var observer = new MutationObserver(nextTickHandler);
    var textNode = document.createTextNode(String(counter));
    observer.observe(textNode, {
      characterData: true
    });
    timerFunc = function () {
      counter = (counter + 1) % 2;
      textNode.data = String(counter);
    };
  } else {
    // fallback to setTimeout
    /* istanbul ignore next */
    timerFunc = setTimeout;
  }

  return function (cb, ctx) {
    var func = ctx ? function () {
      cb.call(ctx);
    } : cb;
    callbacks.push(func);
    if (pending) return;
    pending = true;
    timerFunc(nextTickHandler, 0);
  };
})();

var _Set = undefined;
/* istanbul ignore if */
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = function () {
    this.set = Object.create(null);
  };
  _Set.prototype.has = function (key) {
    return this.set[key] !== undefined;
  };
  _Set.prototype.add = function (key) {
    this.set[key] = 1;
  };
  _Set.prototype.clear = function () {
    this.set = Object.create(null);
  };
}

function Cache(limit) {
  this.size = 0;
  this.limit = limit;
  this.head = this.tail = undefined;
  this._keymap = Object.create(null);
}

var p = Cache.prototype;

/**
 * Put <value> into the cache associated with <key>.
 * Returns the entry which was removed to make room for
 * the new entry. Otherwise undefined is returned.
 * (i.e. if there was enough room already).
 *
 * @param {String} key
 * @param {*} value
 * @return {Entry|undefined}
 */

p.put = function (key, value) {
  var removed;

  var entry = this.get(key, true);
  if (!entry) {
    if (this.size === this.limit) {
      removed = this.shift();
    }
    entry = {
      key: key
    };
    this._keymap[key] = entry;
    if (this.tail) {
      this.tail.newer = entry;
      entry.older = this.tail;
    } else {
      this.head = entry;
    }
    this.tail = entry;
    this.size++;
  }
  entry.value = value;

  return removed;
};

/**
 * Purge the least recently used (oldest) entry from the
 * cache. Returns the removed entry or undefined if the
 * cache was empty.
 */

p.shift = function () {
  var entry = this.head;
  if (entry) {
    this.head = this.head.newer;
    this.head.older = undefined;
    entry.newer = entry.older = undefined;
    this._keymap[entry.key] = undefined;
    this.size--;
  }
  return entry;
};

/**
 * Get and register recent use of <key>. Returns the value
 * associated with <key> or undefined if not in cache.
 *
 * @param {String} key
 * @param {Boolean} returnEntry
 * @return {Entry|*}
 */

p.get = function (key, returnEntry) {
  var entry = this._keymap[key];
  if (entry === undefined) return;
  if (entry === this.tail) {
    return returnEntry ? entry : entry.value;
  }
  // HEAD--------------TAIL
  //   <.older   .newer>
  //  <--- add direction --
  //   A  B  C  <D>  E
  if (entry.newer) {
    if (entry === this.head) {
      this.head = entry.newer;
    }
    entry.newer.older = entry.older; // C <-- E.
  }
  if (entry.older) {
    entry.older.newer = entry.newer; // C. --> E
  }
  entry.newer = undefined; // D --x
  entry.older = this.tail; // D. --> E
  if (this.tail) {
    this.tail.newer = entry; // E. <-- D
  }
  this.tail = entry;
  return returnEntry ? entry : entry.value;
};

var cache$1 = new Cache(1000);
var reservedArgRE = /^in$|^-?\d+/;

/**
 * Parser state
 */

var str;
var dir;
var len;
var index;
var chr;
var state;
var startState = 0;
var filterState = 1;
var filterNameState = 2;
var filterArgState = 3;

var doubleChr = 0x22;
var singleChr = 0x27;
var pipeChr = 0x7C;
var escapeChr = 0x5C;
var spaceChr = 0x20;

var expStartChr = { 0x5B: 1, 0x7B: 1, 0x28: 1 };
var expChrPair = { 0x5B: 0x5D, 0x7B: 0x7D, 0x28: 0x29 };

function peek() {
  return str.charCodeAt(index + 1);
}

function next() {
  return str.charCodeAt(++index);
}

function eof() {
  return index >= len;
}

function eatSpace() {
  while (peek() === spaceChr) {
    next();
  }
}

function isStringStart(chr) {
  return chr === doubleChr || chr === singleChr;
}

function isExpStart(chr) {
  return expStartChr[chr];
}

function isExpEnd(start, chr) {
  return expChrPair[start] === chr;
}

function parseString() {
  var stringQuote = next();
  var chr;
  while (!eof()) {
    chr = next();
    // escape char
    if (chr === escapeChr) {
      next();
    } else if (chr === stringQuote) {
      break;
    }
  }
}

function parseSpecialExp(chr) {
  var inExp = 0;
  var startChr = chr;

  while (!eof()) {
    chr = peek();
    if (isStringStart(chr)) {
      parseString();
      continue;
    }

    if (startChr === chr) {
      inExp++;
    }
    if (isExpEnd(startChr, chr)) {
      inExp--;
    }

    next();

    if (inExp === 0) {
      break;
    }
  }
}

/**
 * syntax:
 * expression | filterName  [arg  arg [| filterName arg arg]]
 */

function parseExpression() {
  var start = index;
  while (!eof()) {
    chr = peek();
    if (isStringStart(chr)) {
      parseString();
    } else if (isExpStart(chr)) {
      parseSpecialExp(chr);
    } else if (chr === pipeChr) {
      next();
      chr = peek();
      if (chr === pipeChr) {
        next();
      } else {
        if (state === startState || state === filterArgState) {
          state = filterState;
        }
        break;
      }
    } else if (chr === spaceChr && (state === filterNameState || state === filterArgState)) {
      eatSpace();
      break;
    } else {
      if (state === filterState) {
        state = filterNameState;
      }
      next();
    }
  }

  return str.slice(start + 1, index) || null;
}

function parseFilterList() {
  var filters = [];
  while (!eof()) {
    filters.push(parseFilter());
  }
  return filters;
}

function parseFilter() {
  var filter = {};
  var args;

  state = filterState;
  filter.name = parseExpression().trim();

  state = filterArgState;
  args = parseFilterArguments();

  if (args.length) {
    filter.args = args;
  }
  return filter;
}

function parseFilterArguments() {
  var args = [];
  while (!eof() && state !== filterState) {
    var arg = parseExpression();
    if (!arg) {
      break;
    }
    args.push(processFilterArg(arg));
  }

  return args;
}

/**
 * Check if an argument is dynamic and strip quotes.
 *
 * @param {String} arg
 * @return {Object}
 */

function processFilterArg(arg) {
  if (reservedArgRE.test(arg)) {
    return {
      value: toNumber(arg),
      dynamic: false
    };
  } else {
    var stripped = stripQuotes(arg);
    var dynamic = stripped === arg;
    return {
      value: dynamic ? arg : stripped,
      dynamic: dynamic
    };
  }
}

/**
 * Parse a directive value and extract the expression
 * and its filters into a descriptor.
 *
 * Example:
 *
 * "a + 1 | uppercase" will yield:
 * {
 *   expression: 'a + 1',
 *   filters: [
 *     { name: 'uppercase', args: null }
 *   ]
 * }
 *
 * @param {String} s
 * @return {Object}
 */

function parseDirective(s) {
  var hit = cache$1.get(s);
  if (hit) {
    return hit;
  }

  // reset parser state
  str = s;
  dir = {};
  len = str.length;
  index = -1;
  chr = '';
  state = startState;

  var filters;

  if (str.indexOf('|') < 0) {
    dir.expression = str.trim();
  } else {
    dir.expression = parseExpression().trim();
    filters = parseFilterList();
    if (filters.length) {
      dir.filters = filters;
    }
  }

  cache$1.put(s, dir);
  return dir;
}

var directive = Object.freeze({
  parseDirective: parseDirective
});

var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;
var cache = undefined;
var tagRE = undefined;
var htmlRE = undefined;
/**
 * Escape a string so it can be used in a RegExp
 * constructor.
 *
 * @param {String} str
 */

function escapeRegex(str) {
  return str.replace(regexEscapeRE, '\\$&');
}

function compileRegex() {
  var open = escapeRegex(config.delimiters[0]);
  var close = escapeRegex(config.delimiters[1]);
  var unsafeOpen = escapeRegex(config.unsafeDelimiters[0]);
  var unsafeClose = escapeRegex(config.unsafeDelimiters[1]);
  tagRE = new RegExp(unsafeOpen + '((?:.|\\n)+?)' + unsafeClose + '|' + open + '((?:.|\\n)+?)' + close, 'g');
  htmlRE = new RegExp('^' + unsafeOpen + '((?:.|\\n)+?)' + unsafeClose + '$');
  // reset cache
  cache = new Cache(1000);
}

/**
 * Parse a template text string into an array of tokens.
 *
 * @param {String} text
 * @return {Array<Object> | null}
 *               - {String} type
 *               - {String} value
 *               - {Boolean} [html]
 *               - {Boolean} [oneTime]
 */

function parseText(text) {
  if (!cache) {
    compileRegex();
  }
  var hit = cache.get(text);
  if (hit) {
    return hit;
  }
  if (!tagRE.test(text)) {
    return null;
  }
  var tokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, html, value, first, oneTime;
  /* eslint-disable no-cond-assign */
  while (match = tagRE.exec(text)) {
    /* eslint-enable no-cond-assign */
    index = match.index;
    // push text token
    if (index > lastIndex) {
      tokens.push({
        value: text.slice(lastIndex, index)
      });
    }
    // tag token
    html = htmlRE.test(match[0]);
    value = html ? match[1] : match[2];
    first = value.charCodeAt(0);
    oneTime = first === 42; // *
    value = oneTime ? value.slice(1) : value;
    tokens.push({
      tag: true,
      value: value.trim(),
      html: html,
      oneTime: oneTime
    });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    tokens.push({
      value: text.slice(lastIndex)
    });
  }
  cache.put(text, tokens);
  return tokens;
}

/**
 * Format a list of tokens into an expression.
 * e.g. tokens parsed from 'a {{b}} c' can be serialized
 * into one single expression as '"a " + b + " c"'.
 *
 * @param {Array} tokens
 * @param {Vue} [vm]
 * @return {String}
 */

function tokensToExp(tokens, vm) {
  if (tokens.length > 1) {
    return tokens.map(function (token) {
      return formatToken(token, vm);
    }).join('+');
  } else {
    return formatToken(tokens[0], vm, true);
  }
}

/**
 * Format a single token.
 *
 * @param {Object} token
 * @param {Vue} [vm]
 * @param {Boolean} [single]
 * @return {String}
 */

function formatToken(token, vm, single) {
  return token.tag ? token.oneTime && vm ? '"' + vm.$eval(token.value) + '"' : inlineFilters(token.value, single) : '"' + token.value + '"';
}

/**
 * For an attribute with multiple interpolation tags,
 * e.g. attr="some-{{thing | filter}}", in order to combine
 * the whole thing into a single watchable expression, we
 * have to inline those filters. This function does exactly
 * that. This is a bit hacky but it avoids heavy changes
 * to directive parser and watcher mechanism.
 *
 * @param {String} exp
 * @param {Boolean} single
 * @return {String}
 */

var filterRE = /[^|]\|[^|]/;
function inlineFilters(exp, single) {
  if (!filterRE.test(exp)) {
    return single ? exp : '(' + exp + ')';
  } else {
    var dir = parseDirective(exp);
    if (!dir.filters) {
      return '(' + exp + ')';
    } else {
      return 'this._applyFilters(' + dir.expression + // value
      ',null,' + // oldValue (null for read)
      JSON.stringify(dir.filters) + // filter descriptors
      ',false)'; // write?
    }
  }
}

var text = Object.freeze({
  compileRegex: compileRegex,
  parseText: parseText,
  tokensToExp: tokensToExp
});

var delimiters = ['{{', '}}'];
var unsafeDelimiters = ['{{{', '}}}'];

var config = Object.defineProperties({

  /**
   * Whether to print debug messages.
   * Also enables stack trace for warnings.
   *
   * @type {Boolean}
   */

  debug: false,

  /**
   * Whether to suppress warnings.
   *
   * @type {Boolean}
   */

  silent: false,

  /**
   * Whether to use async rendering.
   */

  async: true,

  /**
   * Whether to warn against errors caught when evaluating
   * expressions.
   */

  warnExpressionErrors: true,

  /**
   * Whether to allow devtools inspection.
   * Disabled by default in production builds.
   */

  devtools: process.env.NODE_ENV !== 'production',

  /**
   * Internal flag to indicate the delimiters have been
   * changed.
   *
   * @type {Boolean}
   */

  _delimitersChanged: true,

  /**
   * List of asset types that a component can own.
   *
   * @type {Array}
   */

  _assetTypes: ['component', 'directive', 'elementDirective', 'filter', 'transition', 'partial'],

  /**
   * prop binding modes
   */

  _propBindingModes: {
    ONE_WAY: 0,
    TWO_WAY: 1,
    ONE_TIME: 2
  },

  /**
   * Max circular updates allowed in a batcher flush cycle.
   */

  _maxUpdateCount: 100

}, {
  delimiters: { /**
                 * Interpolation delimiters. Changing these would trigger
                 * the text parser to re-compile the regular expressions.
                 *
                 * @type {Array<String>}
                 */

    get: function get() {
      return delimiters;
    },
    set: function set(val) {
      delimiters = val;
      compileRegex();
    },
    configurable: true,
    enumerable: true
  },
  unsafeDelimiters: {
    get: function get() {
      return unsafeDelimiters;
    },
    set: function set(val) {
      unsafeDelimiters = val;
      compileRegex();
    },
    configurable: true,
    enumerable: true
  }
});

var warn = undefined;
var formatComponentName = undefined;

if (process.env.NODE_ENV !== 'production') {
  (function () {
    var hasConsole = typeof console !== 'undefined';

    warn = function (msg, vm) {
      if (hasConsole && !config.silent) {
        console.error('[Vue warn]: ' + msg + (vm ? formatComponentName(vm) : ''));
      }
    };

    formatComponentName = function (vm) {
      var name = vm._isVue ? vm.$options.name : vm.name;
      return name ? ' (found in component: <' + hyphenate(name) + '>)' : '';
    };
  })();
}

/**
 * Append with transition.
 *
 * @param {Element} el
 * @param {Element} target
 * @param {Vue} vm
 * @param {Function} [cb]
 */

function appendWithTransition(el, target, vm, cb) {
  applyTransition(el, 1, function () {
    target.appendChild(el);
  }, vm, cb);
}

/**
 * InsertBefore with transition.
 *
 * @param {Element} el
 * @param {Element} target
 * @param {Vue} vm
 * @param {Function} [cb]
 */

function beforeWithTransition(el, target, vm, cb) {
  applyTransition(el, 1, function () {
    before(el, target);
  }, vm, cb);
}

/**
 * Remove with transition.
 *
 * @param {Element} el
 * @param {Vue} vm
 * @param {Function} [cb]
 */

function removeWithTransition(el, vm, cb) {
  applyTransition(el, -1, function () {
    remove(el);
  }, vm, cb);
}

/**
 * Apply transitions with an operation callback.
 *
 * @param {Element} el
 * @param {Number} direction
 *                  1: enter
 *                 -1: leave
 * @param {Function} op - the actual DOM operation
 * @param {Vue} vm
 * @param {Function} [cb]
 */

function applyTransition(el, direction, op, vm, cb) {
  var transition = el.__v_trans;
  if (!transition ||
  // skip if there are no js hooks and CSS transition is
  // not supported
  !transition.hooks && !transitionEndEvent ||
  // skip transitions for initial compile
  !vm._isCompiled ||
  // if the vm is being manipulated by a parent directive
  // during the parent's compilation phase, skip the
  // animation.
  vm.$parent && !vm.$parent._isCompiled) {
    op();
    if (cb) cb();
    return;
  }
  var action = direction > 0 ? 'enter' : 'leave';
  transition[action](op, cb);
}

var transition = Object.freeze({
  appendWithTransition: appendWithTransition,
  beforeWithTransition: beforeWithTransition,
  removeWithTransition: removeWithTransition,
  applyTransition: applyTransition
});

/**
 * Query an element selector if it's not an element already.
 *
 * @param {String|Element} el
 * @return {Element}
 */

function query(el) {
  if (typeof el === 'string') {
    var selector = el;
    el = document.querySelector(el);
    if (!el) {
      process.env.NODE_ENV !== 'production' && warn('Cannot find element: ' + selector);
    }
  }
  return el;
}

/**
 * Check if a node is in the document.
 * Note: document.documentElement.contains should work here
 * but always returns false for comment nodes in phantomjs,
 * making unit tests difficult. This is fixed by doing the
 * contains() check on the node's parentNode instead of
 * the node itself.
 *
 * @param {Node} node
 * @return {Boolean}
 */

function inDoc(node) {
  if (!node) return false;
  var doc = node.ownerDocument.documentElement;
  var parent = node.parentNode;
  return doc === node || doc === parent || !!(parent && parent.nodeType === 1 && doc.contains(parent));
}

/**
 * Get and remove an attribute from a node.
 *
 * @param {Node} node
 * @param {String} _attr
 */

function getAttr(node, _attr) {
  var val = node.getAttribute(_attr);
  if (val !== null) {
    node.removeAttribute(_attr);
  }
  return val;
}

/**
 * Get an attribute with colon or v-bind: prefix.
 *
 * @param {Node} node
 * @param {String} name
 * @return {String|null}
 */

function getBindAttr(node, name) {
  var val = getAttr(node, ':' + name);
  if (val === null) {
    val = getAttr(node, 'v-bind:' + name);
  }
  return val;
}

/**
 * Check the presence of a bind attribute.
 *
 * @param {Node} node
 * @param {String} name
 * @return {Boolean}
 */

function hasBindAttr(node, name) {
  return node.hasAttribute(name) || node.hasAttribute(':' + name) || node.hasAttribute('v-bind:' + name);
}

/**
 * Insert el before target
 *
 * @param {Element} el
 * @param {Element} target
 */

function before(el, target) {
  target.parentNode.insertBefore(el, target);
}

/**
 * Insert el after target
 *
 * @param {Element} el
 * @param {Element} target
 */

function after(el, target) {
  if (target.nextSibling) {
    before(el, target.nextSibling);
  } else {
    target.parentNode.appendChild(el);
  }
}

/**
 * Remove el from DOM
 *
 * @param {Element} el
 */

function remove(el) {
  el.parentNode.removeChild(el);
}

/**
 * Prepend el to target
 *
 * @param {Element} el
 * @param {Element} target
 */

function prepend(el, target) {
  if (target.firstChild) {
    before(el, target.firstChild);
  } else {
    target.appendChild(el);
  }
}

/**
 * Replace target with el
 *
 * @param {Element} target
 * @param {Element} el
 */

function replace(target, el) {
  var parent = target.parentNode;
  if (parent) {
    parent.replaceChild(el, target);
  }
}

/**
 * Add event listener shorthand.
 *
 * @param {Element} el
 * @param {String} event
 * @param {Function} cb
 * @param {Boolean} [useCapture]
 */

function on(el, event, cb, useCapture) {
  el.addEventListener(event, cb, useCapture);
}

/**
 * Remove event listener shorthand.
 *
 * @param {Element} el
 * @param {String} event
 * @param {Function} cb
 */

function off(el, event, cb) {
  el.removeEventListener(event, cb);
}

/**
 * For IE9 compat: when both class and :class are present
 * getAttribute('class') returns wrong value...
 *
 * @param {Element} el
 * @return {String}
 */

function getClass(el) {
  var classname = el.className;
  if (typeof classname === 'object') {
    classname = classname.baseVal || '';
  }
  return classname;
}

/**
 * In IE9, setAttribute('class') will result in empty class
 * if the element also has the :class attribute; However in
 * PhantomJS, setting `className` does not work on SVG elements...
 * So we have to do a conditional check here.
 *
 * @param {Element} el
 * @param {String} cls
 */

function setClass(el, cls) {
  /* istanbul ignore if */
  if (isIE9 && !/svg$/.test(el.namespaceURI)) {
    el.className = cls;
  } else {
    el.setAttribute('class', cls);
  }
}

/**
 * Add class with compatibility for IE & SVG
 *
 * @param {Element} el
 * @param {String} cls
 */

function addClass(el, cls) {
  if (el.classList) {
    el.classList.add(cls);
  } else {
    var cur = ' ' + getClass(el) + ' ';
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      setClass(el, (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for IE & SVG
 *
 * @param {Element} el
 * @param {String} cls
 */

function removeClass(el, cls) {
  if (el.classList) {
    el.classList.remove(cls);
  } else {
    var cur = ' ' + getClass(el) + ' ';
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    setClass(el, cur.trim());
  }
  if (!el.className) {
    el.removeAttribute('class');
  }
}

/**
 * Extract raw content inside an element into a temporary
 * container div
 *
 * @param {Element} el
 * @param {Boolean} asFragment
 * @return {Element|DocumentFragment}
 */

function extractContent(el, asFragment) {
  var child;
  var rawContent;
  /* istanbul ignore if */
  if (isTemplate(el) && isFragment(el.content)) {
    el = el.content;
  }
  if (el.hasChildNodes()) {
    trimNode(el);
    rawContent = asFragment ? document.createDocumentFragment() : document.createElement('div');
    /* eslint-disable no-cond-assign */
    while (child = el.firstChild) {
      /* eslint-enable no-cond-assign */
      rawContent.appendChild(child);
    }
  }
  return rawContent;
}

/**
 * Trim possible empty head/tail text and comment
 * nodes inside a parent.
 *
 * @param {Node} node
 */

function trimNode(node) {
  var child;
  /* eslint-disable no-sequences */
  while ((child = node.firstChild, isTrimmable(child))) {
    node.removeChild(child);
  }
  while ((child = node.lastChild, isTrimmable(child))) {
    node.removeChild(child);
  }
  /* eslint-enable no-sequences */
}

function isTrimmable(node) {
  return node && (node.nodeType === 3 && !node.data.trim() || node.nodeType === 8);
}

/**
 * Check if an element is a template tag.
 * Note if the template appears inside an SVG its tagName
 * will be in lowercase.
 *
 * @param {Element} el
 */

function isTemplate(el) {
  return el.tagName && el.tagName.toLowerCase() === 'template';
}

/**
 * Create an "anchor" for performing dom insertion/removals.
 * This is used in a number of scenarios:
 * - fragment instance
 * - v-html
 * - v-if
 * - v-for
 * - component
 *
 * @param {String} content
 * @param {Boolean} persist - IE trashes empty textNodes on
 *                            cloneNode(true), so in certain
 *                            cases the anchor needs to be
 *                            non-empty to be persisted in
 *                            templates.
 * @return {Comment|Text}
 */

function createAnchor(content, persist) {
  var anchor = config.debug ? document.createComment(content) : document.createTextNode(persist ? ' ' : '');
  anchor.__v_anchor = true;
  return anchor;
}

/**
 * Find a component ref attribute that starts with $.
 *
 * @param {Element} node
 * @return {String|undefined}
 */

var refRE = /^v-ref:/;

function findRef(node) {
  if (node.hasAttributes()) {
    var attrs = node.attributes;
    for (var i = 0, l = attrs.length; i < l; i++) {
      var name = attrs[i].name;
      if (refRE.test(name)) {
        return camelize(name.replace(refRE, ''));
      }
    }
  }
}

/**
 * Map a function to a range of nodes .
 *
 * @param {Node} node
 * @param {Node} end
 * @param {Function} op
 */

function mapNodeRange(node, end, op) {
  var next;
  while (node !== end) {
    next = node.nextSibling;
    op(node);
    node = next;
  }
  op(end);
}

/**
 * Remove a range of nodes with transition, store
 * the nodes in a fragment with correct ordering,
 * and call callback when done.
 *
 * @param {Node} start
 * @param {Node} end
 * @param {Vue} vm
 * @param {DocumentFragment} frag
 * @param {Function} cb
 */

function removeNodeRange(start, end, vm, frag, cb) {
  var done = false;
  var removed = 0;
  var nodes = [];
  mapNodeRange(start, end, function (node) {
    if (node === end) done = true;
    nodes.push(node);
    removeWithTransition(node, vm, onRemoved);
  });
  function onRemoved() {
    removed++;
    if (done && removed >= nodes.length) {
      for (var i = 0; i < nodes.length; i++) {
        frag.appendChild(nodes[i]);
      }
      cb && cb();
    }
  }
}

/**
 * Check if a node is a DocumentFragment.
 *
 * @param {Node} node
 * @return {Boolean}
 */

function isFragment(node) {
  return node && node.nodeType === 11;
}

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 *
 * @param {Element} el
 * @return {String}
 */

function getOuterHTML(el) {
  if (el.outerHTML) {
    return el.outerHTML;
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML;
  }
}

var commonTagRE = /^(div|p|span|img|a|b|i|br|ul|ol|li|h1|h2|h3|h4|h5|h6|code|pre|table|th|td|tr|form|label|input|select|option|nav|article|section|header|footer)$/i;
var reservedTagRE = /^(slot|partial|component)$/i;

var isUnknownElement = undefined;
if (process.env.NODE_ENV !== 'production') {
  isUnknownElement = function (el, tag) {
    if (tag.indexOf('-') > -1) {
      // http://stackoverflow.com/a/28210364/1070244
      return el.constructor === window.HTMLUnknownElement || el.constructor === window.HTMLElement;
    } else {
      return (/HTMLUnknownElement/.test(el.toString()) &&
        // Chrome returns unknown for several HTML5 elements.
        // https://code.google.com/p/chromium/issues/detail?id=540526
        // Firefox returns unknown for some "Interactive elements."
        !/^(data|time|rtc|rb|details|dialog|summary)$/.test(tag)
      );
    }
  };
}

/**
 * Check if an element is a component, if yes return its
 * component id.
 *
 * @param {Element} el
 * @param {Object} options
 * @return {Object|undefined}
 */

function checkComponentAttr(el, options) {
  var tag = el.tagName.toLowerCase();
  var hasAttrs = el.hasAttributes();
  if (!commonTagRE.test(tag) && !reservedTagRE.test(tag)) {
    if (resolveAsset(options, 'components', tag)) {
      return { id: tag };
    } else {
      var is = hasAttrs && getIsBinding(el, options);
      if (is) {
        return is;
      } else if (process.env.NODE_ENV !== 'production') {
        var expectedTag = options._componentNameMap && options._componentNameMap[tag];
        if (expectedTag) {
          warn('Unknown custom element: <' + tag + '> - ' + 'did you mean <' + expectedTag + '>? ' + 'HTML is case-insensitive, remember to use kebab-case in templates.');
        } else if (isUnknownElement(el, tag)) {
          warn('Unknown custom element: <' + tag + '> - did you ' + 'register the component correctly? For recursive components, ' + 'make sure to provide the "name" option.');
        }
      }
    }
  } else if (hasAttrs) {
    return getIsBinding(el, options);
  }
}

/**
 * Get "is" binding from an element.
 *
 * @param {Element} el
 * @param {Object} options
 * @return {Object|undefined}
 */

function getIsBinding(el, options) {
  // dynamic syntax
  var exp = el.getAttribute('is');
  if (exp != null) {
    if (resolveAsset(options, 'components', exp)) {
      el.removeAttribute('is');
      return { id: exp };
    }
  } else {
    exp = getBindAttr(el, 'is');
    if (exp != null) {
      return { id: exp, dynamic: true };
    }
  }
}

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 *
 * All strategy functions follow the same signature:
 *
 * @param {*} parentVal
 * @param {*} childVal
 * @param {Vue} [vm]
 */

var strats = config.optionMergeStrategies = Object.create(null);

/**
 * Helper that recursively merges two data objects together.
 */

function mergeData(to, from) {
  var key, toVal, fromVal;
  for (key in from) {
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (isObject(toVal) && isObject(fromVal)) {
      mergeData(toVal, fromVal);
    }
  }
  return to;
}

/**
 * Data
 */

strats.data = function (parentVal, childVal, vm) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal;
    }
    if (typeof childVal !== 'function') {
      process.env.NODE_ENV !== 'production' && warn('The "data" option should be a function ' + 'that returns a per-instance value in component ' + 'definitions.', vm);
      return parentVal;
    }
    if (!parentVal) {
      return childVal;
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn() {
      return mergeData(childVal.call(this), parentVal.call(this));
    };
  } else if (parentVal || childVal) {
    return function mergedInstanceDataFn() {
      // instance merge
      var instanceData = typeof childVal === 'function' ? childVal.call(vm) : childVal;
      var defaultData = typeof parentVal === 'function' ? parentVal.call(vm) : undefined;
      if (instanceData) {
        return mergeData(instanceData, defaultData);
      } else {
        return defaultData;
      }
    };
  }
};

/**
 * El
 */

strats.el = function (parentVal, childVal, vm) {
  if (!vm && childVal && typeof childVal !== 'function') {
    process.env.NODE_ENV !== 'production' && warn('The "el" option should be a function ' + 'that returns a per-instance value in component ' + 'definitions.', vm);
    return;
  }
  var ret = childVal || parentVal;
  // invoke the element factory if this is instance merge
  return vm && typeof ret === 'function' ? ret.call(vm) : ret;
};

/**
 * Hooks and param attributes are merged as arrays.
 */

strats.init = strats.created = strats.ready = strats.attached = strats.detached = strats.beforeCompile = strats.compiled = strats.beforeDestroy = strats.destroyed = strats.activate = function (parentVal, childVal) {
  return childVal ? parentVal ? parentVal.concat(childVal) : isArray(childVal) ? childVal : [childVal] : parentVal;
};

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */

function mergeAssets(parentVal, childVal) {
  var res = Object.create(parentVal || null);
  return childVal ? extend(res, guardArrayAssets(childVal)) : res;
}

config._assetTypes.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Events & Watchers.
 *
 * Events & watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */

strats.watch = strats.events = function (parentVal, childVal) {
  if (!childVal) return parentVal;
  if (!parentVal) return childVal;
  var ret = {};
  extend(ret, parentVal);
  for (var key in childVal) {
    var parent = ret[key];
    var child = childVal[key];
    if (parent && !isArray(parent)) {
      parent = [parent];
    }
    ret[key] = parent ? parent.concat(child) : [child];
  }
  return ret;
};

/**
 * Other object hashes.
 */

strats.props = strats.methods = strats.computed = function (parentVal, childVal) {
  if (!childVal) return parentVal;
  if (!parentVal) return childVal;
  var ret = Object.create(null);
  extend(ret, parentVal);
  extend(ret, childVal);
  return ret;
};

/**
 * Default strategy.
 */

var defaultStrat = function defaultStrat(parentVal, childVal) {
  return childVal === undefined ? parentVal : childVal;
};

/**
 * Make sure component options get converted to actual
 * constructors.
 *
 * @param {Object} options
 */

function guardComponents(options) {
  if (options.components) {
    var components = options.components = guardArrayAssets(options.components);
    var ids = Object.keys(components);
    var def;
    if (process.env.NODE_ENV !== 'production') {
      var map = options._componentNameMap = {};
    }
    for (var i = 0, l = ids.length; i < l; i++) {
      var key = ids[i];
      if (commonTagRE.test(key) || reservedTagRE.test(key)) {
        process.env.NODE_ENV !== 'production' && warn('Do not use built-in or reserved HTML elements as component ' + 'id: ' + key);
        continue;
      }
      // record a all lowercase <-> kebab-case mapping for
      // possible custom element case error warning
      if (process.env.NODE_ENV !== 'production') {
        map[key.replace(/-/g, '').toLowerCase()] = hyphenate(key);
      }
      def = components[key];
      if (isPlainObject(def)) {
        components[key] = Vue.extend(def);
      }
    }
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 *
 * @param {Object} options
 */

function guardProps(options) {
  var props = options.props;
  var i, val;
  if (isArray(props)) {
    options.props = {};
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        options.props[val] = null;
      } else if (val.name) {
        options.props[val.name] = val;
      }
    }
  } else if (isPlainObject(props)) {
    var keys = Object.keys(props);
    i = keys.length;
    while (i--) {
      val = props[keys[i]];
      if (typeof val === 'function') {
        props[keys[i]] = { type: val };
      }
    }
  }
}

/**
 * Guard an Array-format assets option and converted it
 * into the key-value Object format.
 *
 * @param {Object|Array} assets
 * @return {Object}
 */

function guardArrayAssets(assets) {
  if (isArray(assets)) {
    var res = {};
    var i = assets.length;
    var asset;
    while (i--) {
      asset = assets[i];
      var id = typeof asset === 'function' ? asset.options && asset.options.name || asset.id : asset.name || asset.id;
      if (!id) {
        process.env.NODE_ENV !== 'production' && warn('Array-syntax assets must provide a "name" or "id" field.');
      } else {
        res[id] = asset;
      }
    }
    return res;
  }
  return assets;
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 *
 * @param {Object} parent
 * @param {Object} child
 * @param {Vue} [vm] - if vm is present, indicates this is
 *                     an instantiation merge.
 */

function mergeOptions(parent, child, vm) {
  guardComponents(child);
  guardProps(child);
  if (process.env.NODE_ENV !== 'production') {
    if (child.propsData && !vm) {
      warn('propsData can only be used as an instantiation option.');
    }
  }
  var options = {};
  var key;
  if (child['extends']) {
    parent = typeof child['extends'] === 'function' ? mergeOptions(parent, child['extends'].options, vm) : mergeOptions(parent, child['extends'], vm);
  }
  if (child.mixins) {
    for (var i = 0, l = child.mixins.length; i < l; i++) {
      var mixin = child.mixins[i];
      var mixinOptions = mixin.prototype instanceof Vue ? mixin.options : mixin;
      parent = mergeOptions(parent, mixinOptions, vm);
    }
  }
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField(key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options;
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 *
 * @param {Object} options
 * @param {String} type
 * @param {String} id
 * @param {Boolean} warnMissing
 * @return {Object|Function}
 */

function resolveAsset(options, type, id, warnMissing) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return;
  }
  var assets = options[type];
  var camelizedId;
  var res = assets[id] ||
  // camelCase ID
  assets[camelizedId = camelize(id)] ||
  // Pascal Case ID
  assets[camelizedId.charAt(0).toUpperCase() + camelizedId.slice(1)];
  if (process.env.NODE_ENV !== 'production' && warnMissing && !res) {
    warn('Failed to resolve ' + type.slice(0, -1) + ': ' + id, options);
  }
  return res;
}

var uid$1 = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 *
 * @constructor
 */
function Dep() {
  this.id = uid$1++;
  this.subs = [];
}

// the current target watcher being evaluated.
// this is globally unique because there could be only one
// watcher being evaluated at any time.
Dep.target = null;

/**
 * Add a directive subscriber.
 *
 * @param {Directive} sub
 */

Dep.prototype.addSub = function (sub) {
  this.subs.push(sub);
};

/**
 * Remove a directive subscriber.
 *
 * @param {Directive} sub
 */

Dep.prototype.removeSub = function (sub) {
  this.subs.$remove(sub);
};

/**
 * Add self as a dependency to the target watcher.
 */

Dep.prototype.depend = function () {
  Dep.target.addDep(this);
};

/**
 * Notify all subscribers of a new value.
 */

Dep.prototype.notify = function () {
  // stablize the subscriber list first
  var subs = toArray(this.subs);
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto)

/**
 * Intercept mutating methods and emit events
 */

;['push', 'pop', 'shift', 'unshift', 'splice', 'sort', 'reverse'].forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator() {
    // avoid leaking arguments:
    // http://jsperf.com/closure-with-arguments
    var i = arguments.length;
    var args = new Array(i);
    while (i--) {
      args[i] = arguments[i];
    }
    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
        inserted = args;
        break;
      case 'unshift':
        inserted = args;
        break;
      case 'splice':
        inserted = args.slice(2);
        break;
    }
    if (inserted) ob.observeArray(inserted);
    // notify change
    ob.dep.notify();
    return result;
  });
});

/**
 * Swap the element at the given index with a new value
 * and emits corresponding event.
 *
 * @param {Number} index
 * @param {*} val
 * @return {*} - replaced element
 */

def(arrayProto, '$set', function $set(index, val) {
  if (index >= this.length) {
    this.length = Number(index) + 1;
  }
  return this.splice(index, 1, val)[0];
});

/**
 * Convenience method to remove the element at given index or target element reference.
 *
 * @param {*} item
 */

def(arrayProto, '$remove', function $remove(item) {
  /* istanbul ignore if */
  if (!this.length) return;
  var index = indexOf(this, item);
  if (index > -1) {
    return this.splice(index, 1);
  }
});

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * By default, when a reactive property is set, the new value is
 * also converted to become reactive. However in certain cases, e.g.
 * v-for scope alias and props, we don't want to force conversion
 * because the value may be a nested value under a frozen data structure.
 *
 * So whenever we want to set a reactive property without forcing
 * conversion on the new value, we wrap that call inside this function.
 */

var shouldConvert = true;

function withoutConversion(fn) {
  shouldConvert = false;
  fn();
  shouldConvert = true;
}

/**
 * Observer class that are attached to each observed
 * object. Once attached, the observer converts target
 * object's property keys into getter/setters that
 * collect dependencies and dispatches updates.
 *
 * @param {Array|Object} value
 * @constructor
 */

function Observer(value) {
  this.value = value;
  this.dep = new Dep();
  def(value, '__ob__', this);
  if (isArray(value)) {
    var augment = hasProto ? protoAugment : copyAugment;
    augment(value, arrayMethods, arrayKeys);
    this.observeArray(value);
  } else {
    this.walk(value);
  }
}

// Instance methods

/**
 * Walk through each property and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 *
 * @param {Object} obj
 */

Observer.prototype.walk = function (obj) {
  var keys = Object.keys(obj);
  for (var i = 0, l = keys.length; i < l; i++) {
    this.convert(keys[i], obj[keys[i]]);
  }
};

/**
 * Observe a list of Array items.
 *
 * @param {Array} items
 */

Observer.prototype.observeArray = function (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

/**
 * Convert a property into getter/setter so we can emit
 * the events when the property is accessed/changed.
 *
 * @param {String} key
 * @param {*} val
 */

Observer.prototype.convert = function (key, val) {
  defineReactive(this.value, key, val);
};

/**
 * Add an owner vm, so that when $set/$delete mutations
 * happen we can notify owner vms to proxy the keys and
 * digest the watchers. This is only called when the object
 * is observed as an instance's root $data.
 *
 * @param {Vue} vm
 */

Observer.prototype.addVm = function (vm) {
  (this.vms || (this.vms = [])).push(vm);
};

/**
 * Remove an owner vm. This is called when the object is
 * swapped out as an instance's $data object.
 *
 * @param {Vue} vm
 */

Observer.prototype.removeVm = function (vm) {
  this.vms.$remove(vm);
};

// helpers

/**
 * Augment an target Object or Array by intercepting
 * the prototype chain using __proto__
 *
 * @param {Object|Array} target
 * @param {Object} src
 */

function protoAugment(target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment an target Object or Array by defining
 * hidden properties.
 *
 * @param {Object|Array} target
 * @param {Object} proto
 */

function copyAugment(target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 *
 * @param {*} value
 * @param {Vue} [vm]
 * @return {Observer|undefined}
 * @static
 */

function observe(value, vm) {
  if (!value || typeof value !== 'object') {
    return;
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (shouldConvert && (isArray(value) || isPlainObject(value)) && Object.isExtensible(value) && !value._isVue) {
    ob = new Observer(value);
  }
  if (ob && vm) {
    ob.addVm(vm);
  }
  return ob;
}

/**
 * Define a reactive property on an Object.
 *
 * @param {Object} obj
 * @param {String} key
 * @param {*} val
 */

function defineReactive(obj, key, val) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return;
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;

  var childOb = observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter() {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
        }
        if (isArray(value)) {
          for (var e, i = 0, l = value.length; i < l; i++) {
            e = value[i];
            e && e.__ob__ && e.__ob__.dep.depend();
          }
        }
      }
      return value;
    },
    set: function reactiveSetter(newVal) {
      var value = getter ? getter.call(obj) : val;
      if (newVal === value) {
        return;
      }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = observe(newVal);
      dep.notify();
    }
  });
}



var util = Object.freeze({
	defineReactive: defineReactive,
	set: set,
	del: del,
	hasOwn: hasOwn,
	isLiteral: isLiteral,
	isReserved: isReserved,
	_toString: _toString,
	toNumber: toNumber,
	toBoolean: toBoolean,
	stripQuotes: stripQuotes,
	camelize: camelize,
	hyphenate: hyphenate,
	classify: classify,
	bind: bind,
	toArray: toArray,
	extend: extend,
	isObject: isObject,
	isPlainObject: isPlainObject,
	def: def,
	debounce: _debounce,
	indexOf: indexOf,
	cancellable: cancellable,
	looseEqual: looseEqual,
	isArray: isArray,
	hasProto: hasProto,
	inBrowser: inBrowser,
	devtools: devtools,
	isIE: isIE,
	isIE9: isIE9,
	isAndroid: isAndroid,
	isIOS: isIOS,
	get transitionProp () { return transitionProp; },
	get transitionEndEvent () { return transitionEndEvent; },
	get animationProp () { return animationProp; },
	get animationEndEvent () { return animationEndEvent; },
	nextTick: nextTick,
	get _Set () { return _Set; },
	query: query,
	inDoc: inDoc,
	getAttr: getAttr,
	getBindAttr: getBindAttr,
	hasBindAttr: hasBindAttr,
	before: before,
	after: after,
	remove: remove,
	prepend: prepend,
	replace: replace,
	on: on,
	off: off,
	setClass: setClass,
	addClass: addClass,
	removeClass: removeClass,
	extractContent: extractContent,
	trimNode: trimNode,
	isTemplate: isTemplate,
	createAnchor: createAnchor,
	findRef: findRef,
	mapNodeRange: mapNodeRange,
	removeNodeRange: removeNodeRange,
	isFragment: isFragment,
	getOuterHTML: getOuterHTML,
	mergeOptions: mergeOptions,
	resolveAsset: resolveAsset,
	checkComponentAttr: checkComponentAttr,
	commonTagRE: commonTagRE,
	reservedTagRE: reservedTagRE,
	get warn () { return warn; }
});

var uid = 0;

function initMixin (Vue) {
  /**
   * The main init sequence. This is called for every
   * instance, including ones that are created from extended
   * constructors.
   *
   * @param {Object} options - this options object should be
   *                           the result of merging class
   *                           options and the options passed
   *                           in to the constructor.
   */

  Vue.prototype._init = function (options) {
    options = options || {};

    this.$el = null;
    this.$parent = options.parent;
    this.$root = this.$parent ? this.$parent.$root : this;
    this.$children = [];
    this.$refs = {}; // child vm references
    this.$els = {}; // element references
    this._watchers = []; // all watchers as an array
    this._directives = []; // all directives

    // a uid
    this._uid = uid++;

    // a flag to avoid this being observed
    this._isVue = true;

    // events bookkeeping
    this._events = {}; // registered callbacks
    this._eventsCount = {}; // for $broadcast optimization

    // fragment instance properties
    this._isFragment = false;
    this._fragment = // @type {DocumentFragment}
    this._fragmentStart = // @type {Text|Comment}
    this._fragmentEnd = null; // @type {Text|Comment}

    // lifecycle state
    this._isCompiled = this._isDestroyed = this._isReady = this._isAttached = this._isBeingDestroyed = this._vForRemoving = false;
    this._unlinkFn = null;

    // context:
    // if this is a transcluded component, context
    // will be the common parent vm of this instance
    // and its host.
    this._context = options._context || this.$parent;

    // scope:
    // if this is inside an inline v-for, the scope
    // will be the intermediate scope created for this
    // repeat fragment. this is used for linking props
    // and container directives.
    this._scope = options._scope;

    // fragment:
    // if this instance is compiled inside a Fragment, it
    // needs to register itself as a child of that fragment
    // for attach/detach to work properly.
    this._frag = options._frag;
    if (this._frag) {
      this._frag.children.push(this);
    }

    // push self into parent / transclusion host
    if (this.$parent) {
      this.$parent.$children.push(this);
    }

    // merge options.
    options = this.$options = mergeOptions(this.constructor.options, options, this);

    // set ref
    this._updateRef();

    // initialize data as empty object.
    // it will be filled up in _initData().
    this._data = {};

    // call init hook
    this._callHook('init');

    // initialize data observation and scope inheritance.
    this._initState();

    // setup event system and option events.
    this._initEvents();

    // call created hook
    this._callHook('created');

    // if `el` option is passed, start compilation.
    if (options.el) {
      this.$mount(options.el);
    }
  };
}

var pathCache = new Cache(1000);

// actions
var APPEND = 0;
var PUSH = 1;
var INC_SUB_PATH_DEPTH = 2;
var PUSH_SUB_PATH = 3;

// states
var BEFORE_PATH = 0;
var IN_PATH = 1;
var BEFORE_IDENT = 2;
var IN_IDENT = 3;
var IN_SUB_PATH = 4;
var IN_SINGLE_QUOTE = 5;
var IN_DOUBLE_QUOTE = 6;
var AFTER_PATH = 7;
var ERROR = 8;

var pathStateMachine = [];

pathStateMachine[BEFORE_PATH] = {
  'ws': [BEFORE_PATH],
  'ident': [IN_IDENT, APPEND],
  '[': [IN_SUB_PATH],
  'eof': [AFTER_PATH]
};

pathStateMachine[IN_PATH] = {
  'ws': [IN_PATH],
  '.': [BEFORE_IDENT],
  '[': [IN_SUB_PATH],
  'eof': [AFTER_PATH]
};

pathStateMachine[BEFORE_IDENT] = {
  'ws': [BEFORE_IDENT],
  'ident': [IN_IDENT, APPEND]
};

pathStateMachine[IN_IDENT] = {
  'ident': [IN_IDENT, APPEND],
  '0': [IN_IDENT, APPEND],
  'number': [IN_IDENT, APPEND],
  'ws': [IN_PATH, PUSH],
  '.': [BEFORE_IDENT, PUSH],
  '[': [IN_SUB_PATH, PUSH],
  'eof': [AFTER_PATH, PUSH]
};

pathStateMachine[IN_SUB_PATH] = {
  "'": [IN_SINGLE_QUOTE, APPEND],
  '"': [IN_DOUBLE_QUOTE, APPEND],
  '[': [IN_SUB_PATH, INC_SUB_PATH_DEPTH],
  ']': [IN_PATH, PUSH_SUB_PATH],
  'eof': ERROR,
  'else': [IN_SUB_PATH, APPEND]
};

pathStateMachine[IN_SINGLE_QUOTE] = {
  "'": [IN_SUB_PATH, APPEND],
  'eof': ERROR,
  'else': [IN_SINGLE_QUOTE, APPEND]
};

pathStateMachine[IN_DOUBLE_QUOTE] = {
  '"': [IN_SUB_PATH, APPEND],
  'eof': ERROR,
  'else': [IN_DOUBLE_QUOTE, APPEND]
};

/**
 * Determine the type of a character in a keypath.
 *
 * @param {Char} ch
 * @return {String} type
 */

function getPathCharType(ch) {
  if (ch === undefined) {
    return 'eof';
  }

  var code = ch.charCodeAt(0);

  switch (code) {
    case 0x5B: // [
    case 0x5D: // ]
    case 0x2E: // .
    case 0x22: // "
    case 0x27: // '
    case 0x30:
      // 0
      return ch;

    case 0x5F: // _
    case 0x24:
      // $
      return 'ident';

    case 0x20: // Space
    case 0x09: // Tab
    case 0x0A: // Newline
    case 0x0D: // Return
    case 0xA0: // No-break space
    case 0xFEFF: // Byte Order Mark
    case 0x2028: // Line Separator
    case 0x2029:
      // Paragraph Separator
      return 'ws';
  }

  // a-z, A-Z
  if (code >= 0x61 && code <= 0x7A || code >= 0x41 && code <= 0x5A) {
    return 'ident';
  }

  // 1-9
  if (code >= 0x31 && code <= 0x39) {
    return 'number';
  }

  return 'else';
}

/**
 * Format a subPath, return its plain form if it is
 * a literal string or number. Otherwise prepend the
 * dynamic indicator (*).
 *
 * @param {String} path
 * @return {String}
 */

function formatSubPath(path) {
  var trimmed = path.trim();
  // invalid leading 0
  if (path.charAt(0) === '0' && isNaN(path)) {
    return false;
  }
  return isLiteral(trimmed) ? stripQuotes(trimmed) : '*' + trimmed;
}

/**
 * Parse a string path into an array of segments
 *
 * @param {String} path
 * @return {Array|undefined}
 */

function parse(path) {
  var keys = [];
  var index = -1;
  var mode = BEFORE_PATH;
  var subPathDepth = 0;
  var c, newChar, key, type, transition, action, typeMap;

  var actions = [];

  actions[PUSH] = function () {
    if (key !== undefined) {
      keys.push(key);
      key = undefined;
    }
  };

  actions[APPEND] = function () {
    if (key === undefined) {
      key = newChar;
    } else {
      key += newChar;
    }
  };

  actions[INC_SUB_PATH_DEPTH] = function () {
    actions[APPEND]();
    subPathDepth++;
  };

  actions[PUSH_SUB_PATH] = function () {
    if (subPathDepth > 0) {
      subPathDepth--;
      mode = IN_SUB_PATH;
      actions[APPEND]();
    } else {
      subPathDepth = 0;
      key = formatSubPath(key);
      if (key === false) {
        return false;
      } else {
        actions[PUSH]();
      }
    }
  };

  function maybeUnescapeQuote() {
    var nextChar = path[index + 1];
    if (mode === IN_SINGLE_QUOTE && nextChar === "'" || mode === IN_DOUBLE_QUOTE && nextChar === '"') {
      index++;
      newChar = '\\' + nextChar;
      actions[APPEND]();
      return true;
    }
  }

  while (mode != null) {
    index++;
    c = path[index];

    if (c === '\\' && maybeUnescapeQuote()) {
      continue;
    }

    type = getPathCharType(c);
    typeMap = pathStateMachine[mode];
    transition = typeMap[type] || typeMap['else'] || ERROR;

    if (transition === ERROR) {
      return; // parse error
    }

    mode = transition[0];
    action = actions[transition[1]];
    if (action) {
      newChar = transition[2];
      newChar = newChar === undefined ? c : newChar;
      if (action() === false) {
        return;
      }
    }

    if (mode === AFTER_PATH) {
      keys.raw = path;
      return keys;
    }
  }
}

/**
 * External parse that check for a cache hit first
 *
 * @param {String} path
 * @return {Array|undefined}
 */

function parsePath(path) {
  var hit = pathCache.get(path);
  if (!hit) {
    hit = parse(path);
    if (hit) {
      pathCache.put(path, hit);
    }
  }
  return hit;
}

/**
 * Get from an object from a path string
 *
 * @param {Object} obj
 * @param {String} path
 */

function getPath(obj, path) {
  return parseExpression$1(path).get(obj);
}

/**
 * Warn against setting non-existent root path on a vm.
 */

var warnNonExistent;
if (process.env.NODE_ENV !== 'production') {
  warnNonExistent = function (path, vm) {
    warn('You are setting a non-existent path "' + path.raw + '" ' + 'on a vm instance. Consider pre-initializing the property ' + 'with the "data" option for more reliable reactivity ' + 'and better performance.', vm);
  };
}

/**
 * Set on an object from a path
 *
 * @param {Object} obj
 * @param {String | Array} path
 * @param {*} val
 */

function setPath(obj, path, val) {
  var original = obj;
  if (typeof path === 'string') {
    path = parse(path);
  }
  if (!path || !isObject(obj)) {
    return false;
  }
  var last, key;
  for (var i = 0, l = path.length; i < l; i++) {
    last = obj;
    key = path[i];
    if (key.charAt(0) === '*') {
      key = parseExpression$1(key.slice(1)).get.call(original, original);
    }
    if (i < l - 1) {
      obj = obj[key];
      if (!isObject(obj)) {
        obj = {};
        if (process.env.NODE_ENV !== 'production' && last._isVue) {
          warnNonExistent(path, last);
        }
        set(last, key, obj);
      }
    } else {
      if (isArray(obj)) {
        obj.$set(key, val);
      } else if (key in obj) {
        obj[key] = val;
      } else {
        if (process.env.NODE_ENV !== 'production' && obj._isVue) {
          warnNonExistent(path, obj);
        }
        set(obj, key, val);
      }
    }
  }
  return true;
}

var path = Object.freeze({
  parsePath: parsePath,
  getPath: getPath,
  setPath: setPath
});

var expressionCache = new Cache(1000);

var allowedKeywords = 'Math,Date,this,true,false,null,undefined,Infinity,NaN,' + 'isNaN,isFinite,decodeURI,decodeURIComponent,encodeURI,' + 'encodeURIComponent,parseInt,parseFloat';
var allowedKeywordsRE = new RegExp('^(' + allowedKeywords.replace(/,/g, '\\b|') + '\\b)');

// keywords that don't make sense inside expressions
var improperKeywords = 'break,case,class,catch,const,continue,debugger,default,' + 'delete,do,else,export,extends,finally,for,function,if,' + 'import,in,instanceof,let,return,super,switch,throw,try,' + 'var,while,with,yield,enum,await,implements,package,' + 'protected,static,interface,private,public';
var improperKeywordsRE = new RegExp('^(' + improperKeywords.replace(/,/g, '\\b|') + '\\b)');

var wsRE = /\s/g;
var newlineRE = /\n/g;
var saveRE = /[\{,]\s*[\w\$_]+\s*:|('(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\"']|\\.)*`|`(?:[^`\\]|\\.)*`)|new |typeof |void /g;
var restoreRE = /"(\d+)"/g;
var pathTestRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['.*?'\]|\[".*?"\]|\[\d+\]|\[[A-Za-z_$][\w$]*\])*$/;
var identRE = /[^\w$\.](?:[A-Za-z_$][\w$]*)/g;
var literalValueRE$1 = /^(?:true|false|null|undefined|Infinity|NaN)$/;

function noop() {}

/**
 * Save / Rewrite / Restore
 *
 * When rewriting paths found in an expression, it is
 * possible for the same letter sequences to be found in
 * strings and Object literal property keys. Therefore we
 * remove and store these parts in a temporary array, and
 * restore them after the path rewrite.
 */

var saved = [];

/**
 * Save replacer
 *
 * The save regex can match two possible cases:
 * 1. An opening object literal
 * 2. A string
 * If matched as a plain string, we need to escape its
 * newlines, since the string needs to be preserved when
 * generating the function body.
 *
 * @param {String} str
 * @param {String} isString - str if matched as a string
 * @return {String} - placeholder with index
 */

function save(str, isString) {
  var i = saved.length;
  saved[i] = isString ? str.replace(newlineRE, '\\n') : str;
  return '"' + i + '"';
}

/**
 * Path rewrite replacer
 *
 * @param {String} raw
 * @return {String}
 */

function rewrite(raw) {
  var c = raw.charAt(0);
  var path = raw.slice(1);
  if (allowedKeywordsRE.test(path)) {
    return raw;
  } else {
    path = path.indexOf('"') > -1 ? path.replace(restoreRE, restore) : path;
    return c + 'scope.' + path;
  }
}

/**
 * Restore replacer
 *
 * @param {String} str
 * @param {String} i - matched save index
 * @return {String}
 */

function restore(str, i) {
  return saved[i];
}

/**
 * Rewrite an expression, prefixing all path accessors with
 * `scope.` and generate getter/setter functions.
 *
 * @param {String} exp
 * @return {Function}
 */

function compileGetter(exp) {
  if (improperKeywordsRE.test(exp)) {
    process.env.NODE_ENV !== 'production' && warn('Avoid using reserved keywords in expression: ' + exp);
  }
  // reset state
  saved.length = 0;
  // save strings and object literal keys
  var body = exp.replace(saveRE, save).replace(wsRE, '');
  // rewrite all paths
  // pad 1 space here because the regex matches 1 extra char
  body = (' ' + body).replace(identRE, rewrite).replace(restoreRE, restore);
  return makeGetterFn(body);
}

/**
 * Build a getter function. Requires eval.
 *
 * We isolate the try/catch so it doesn't affect the
 * optimization of the parse function when it is not called.
 *
 * @param {String} body
 * @return {Function|undefined}
 */

function makeGetterFn(body) {
  try {
    /* eslint-disable no-new-func */
    return new Function('scope', 'return ' + body + ';');
    /* eslint-enable no-new-func */
  } catch (e) {
    if (process.env.NODE_ENV !== 'production') {
      /* istanbul ignore if */
      if (e.toString().match(/unsafe-eval|CSP/)) {
        warn('It seems you are using the default build of Vue.js in an environment ' + 'with Content Security Policy that prohibits unsafe-eval. ' + 'Use the CSP-compliant build instead: ' + 'http://vuejs.org/guide/installation.html#CSP-compliant-build');
      } else {
        warn('Invalid expression. ' + 'Generated function body: ' + body);
      }
    }
    return noop;
  }
}

/**
 * Compile a setter function for the expression.
 *
 * @param {String} exp
 * @return {Function|undefined}
 */

function compileSetter(exp) {
  var path = parsePath(exp);
  if (path) {
    return function (scope, val) {
      setPath(scope, path, val);
    };
  } else {
    process.env.NODE_ENV !== 'production' && warn('Invalid setter expression: ' + exp);
  }
}

/**
 * Parse an expression into re-written getter/setters.
 *
 * @param {String} exp
 * @param {Boolean} needSet
 * @return {Function}
 */

function parseExpression$1(exp, needSet) {
  exp = exp.trim();
  // try cache
  var hit = expressionCache.get(exp);
  if (hit) {
    if (needSet && !hit.set) {
      hit.set = compileSetter(hit.exp);
    }
    return hit;
  }
  var res = { exp: exp };
  res.get = isSimplePath(exp) && exp.indexOf('[') < 0
  // optimized super simple getter
  ? makeGetterFn('scope.' + exp)
  // dynamic getter
  : compileGetter(exp);
  if (needSet) {
    res.set = compileSetter(exp);
  }
  expressionCache.put(exp, res);
  return res;
}

/**
 * Check if an expression is a simple path.
 *
 * @param {String} exp
 * @return {Boolean}
 */

function isSimplePath(exp) {
  return pathTestRE.test(exp) &&
  // don't treat literal values as paths
  !literalValueRE$1.test(exp) &&
  // Math constants e.g. Math.PI, Math.E etc.
  exp.slice(0, 5) !== 'Math.';
}

var expression = Object.freeze({
  parseExpression: parseExpression$1,
  isSimplePath: isSimplePath
});

// we have two separate queues: one for directive updates
// and one for user watcher registered via $watch().
// we want to guarantee directive updates to be called
// before user watchers so that when user watchers are
// triggered, the DOM would have already been in updated
// state.

var queue = [];
var userQueue = [];
var has = {};
var circular = {};
var waiting = false;

/**
 * Reset the batcher's state.
 */

function resetBatcherState() {
  queue.length = 0;
  userQueue.length = 0;
  has = {};
  circular = {};
  waiting = false;
}

/**
 * Flush both queues and run the watchers.
 */

function flushBatcherQueue() {
  var _again = true;

  _function: while (_again) {
    _again = false;

    runBatcherQueue(queue);
    runBatcherQueue(userQueue);
    // user watchers triggered more watchers,
    // keep flushing until it depletes
    if (queue.length) {
      _again = true;
      continue _function;
    }
    // dev tool hook
    /* istanbul ignore if */
    if (devtools && config.devtools) {
      devtools.emit('flush');
    }
    resetBatcherState();
  }
}

/**
 * Run the watchers in a single queue.
 *
 * @param {Array} queue
 */

function runBatcherQueue(queue) {
  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (var i = 0; i < queue.length; i++) {
    var watcher = queue[i];
    var id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (process.env.NODE_ENV !== 'production' && has[id] != null) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > config._maxUpdateCount) {
        warn('You may have an infinite update loop for watcher ' + 'with expression "' + watcher.expression + '"', watcher.vm);
        break;
      }
    }
  }
  queue.length = 0;
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 *
 * @param {Watcher} watcher
 *   properties:
 *   - {Number} id
 *   - {Function} run
 */

function pushWatcher(watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    // push watcher into appropriate queue
    var q = watcher.user ? userQueue : queue;
    has[id] = q.length;
    q.push(watcher);
    // queue the flush
    if (!waiting) {
      waiting = true;
      nextTick(flushBatcherQueue);
    }
  }
}

var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 *
 * @param {Vue} vm
 * @param {String|Function} expOrFn
 * @param {Function} cb
 * @param {Object} options
 *                 - {Array} filters
 *                 - {Boolean} twoWay
 *                 - {Boolean} deep
 *                 - {Boolean} user
 *                 - {Boolean} sync
 *                 - {Boolean} lazy
 *                 - {Function} [preProcess]
 *                 - {Function} [postProcess]
 * @constructor
 */
function Watcher(vm, expOrFn, cb, options) {
  // mix in options
  if (options) {
    extend(this, options);
  }
  var isFn = typeof expOrFn === 'function';
  this.vm = vm;
  vm._watchers.push(this);
  this.expression = expOrFn;
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.prevError = null; // for async error stacks
  // parse expression for getter/setter
  if (isFn) {
    this.getter = expOrFn;
    this.setter = undefined;
  } else {
    var res = parseExpression$1(expOrFn, this.twoWay);
    this.getter = res.get;
    this.setter = res.set;
  }
  this.value = this.lazy ? undefined : this.get();
  // state for avoiding false triggers for deep and Array
  // watchers during vm._digest()
  this.queued = this.shallow = false;
}

/**
 * Evaluate the getter, and re-collect dependencies.
 */

Watcher.prototype.get = function () {
  this.beforeGet();
  var scope = this.scope || this.vm;
  var value;
  try {
    value = this.getter.call(scope, scope);
  } catch (e) {
    if (process.env.NODE_ENV !== 'production' && config.warnExpressionErrors) {
      warn('Error when evaluating expression ' + '"' + this.expression + '": ' + e.toString(), this.vm);
    }
  }
  // "touch" every property so they are all tracked as
  // dependencies for deep watching
  if (this.deep) {
    traverse(value);
  }
  if (this.preProcess) {
    value = this.preProcess(value);
  }
  if (this.filters) {
    value = scope._applyFilters(value, null, this.filters, false);
  }
  if (this.postProcess) {
    value = this.postProcess(value);
  }
  this.afterGet();
  return value;
};

/**
 * Set the corresponding value with the setter.
 *
 * @param {*} value
 */

Watcher.prototype.set = function (value) {
  var scope = this.scope || this.vm;
  if (this.filters) {
    value = scope._applyFilters(value, this.value, this.filters, true);
  }
  try {
    this.setter.call(scope, scope, value);
  } catch (e) {
    if (process.env.NODE_ENV !== 'production' && config.warnExpressionErrors) {
      warn('Error when evaluating setter ' + '"' + this.expression + '": ' + e.toString(), this.vm);
    }
  }
  // two-way sync for v-for alias
  var forContext = scope.$forContext;
  if (forContext && forContext.alias === this.expression) {
    if (forContext.filters) {
      process.env.NODE_ENV !== 'production' && warn('It seems you are using two-way binding on ' + 'a v-for alias (' + this.expression + '), and the ' + 'v-for has filters. This will not work properly. ' + 'Either remove the filters or use an array of ' + 'objects and bind to object properties instead.', this.vm);
      return;
    }
    forContext._withLock(function () {
      if (scope.$key) {
        // original is an object
        forContext.rawValue[scope.$key] = value;
      } else {
        forContext.rawValue.$set(scope.$index, value);
      }
    });
  }
};

/**
 * Prepare for dependency collection.
 */

Watcher.prototype.beforeGet = function () {
  Dep.target = this;
};

/**
 * Add a dependency to this directive.
 *
 * @param {Dep} dep
 */

Watcher.prototype.addDep = function (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */

Watcher.prototype.afterGet = function () {
  Dep.target = null;
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 *
 * @param {Boolean} shallow
 */

Watcher.prototype.update = function (shallow) {
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync || !config.async) {
    this.run();
  } else {
    // if queued, only overwrite shallow with non-shallow,
    // but not the other way around.
    this.shallow = this.queued ? shallow ? this.shallow : false : !!shallow;
    this.queued = true;
    // record before-push error stack in debug mode
    /* istanbul ignore if */
    if (process.env.NODE_ENV !== 'production' && config.debug) {
      this.prevError = new Error('[vue] async stack trace');
    }
    pushWatcher(this);
  }
};

/**
 * Batcher job interface.
 * Will be called by the batcher.
 */

Watcher.prototype.run = function () {
  if (this.active) {
    var value = this.get();
    if (value !== this.value ||
    // Deep watchers and watchers on Object/Arrays should fire even
    // when the value is the same, because the value may
    // have mutated; but only do so if this is a
    // non-shallow update (caused by a vm digest).
    (isObject(value) || this.deep) && !this.shallow) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      // in debug + async mode, when a watcher callbacks
      // throws, we also throw the saved before-push error
      // so the full cross-tick stack trace is available.
      var prevError = this.prevError;
      /* istanbul ignore if */
      if (process.env.NODE_ENV !== 'production' && config.debug && prevError) {
        this.prevError = null;
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          nextTick(function () {
            throw prevError;
          }, 0);
          throw e;
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
    this.queued = this.shallow = false;
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */

Watcher.prototype.evaluate = function () {
  // avoid overwriting another watcher that is being
  // collected.
  var current = Dep.target;
  this.value = this.get();
  this.dirty = false;
  Dep.target = current;
};

/**
 * Depend on all deps collected by this watcher.
 */

Watcher.prototype.depend = function () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subcriber list.
 */

Watcher.prototype.teardown = function () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed or is performing a v-for
    // re-render (the watcher list is then filtered by v-for).
    if (!this.vm._isBeingDestroyed && !this.vm._vForRemoving) {
      this.vm._watchers.$remove(this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
    this.vm = this.cb = this.value = null;
  }
};

/**
 * Recrusively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 *
 * @param {*} val
 */

var seenObjects = new _Set();
function traverse(val, seen) {
  var i = undefined,
      keys = undefined;
  if (!seen) {
    seen = seenObjects;
    seen.clear();
  }
  var isA = isArray(val);
  var isO = isObject(val);
  if ((isA || isO) && Object.isExtensible(val)) {
    if (val.__ob__) {
      var depId = val.__ob__.dep.id;
      if (seen.has(depId)) {
        return;
      } else {
        seen.add(depId);
      }
    }
    if (isA) {
      i = val.length;
      while (i--) traverse(val[i], seen);
    } else if (isO) {
      keys = Object.keys(val);
      i = keys.length;
      while (i--) traverse(val[keys[i]], seen);
    }
  }
}

var text$1 = {

  bind: function bind() {
    this.attr = this.el.nodeType === 3 ? 'data' : 'textContent';
  },

  update: function update(value) {
    this.el[this.attr] = _toString(value);
  }
};

var templateCache = new Cache(1000);
var idSelectorCache = new Cache(1000);

var map = {
  efault: [0, '', ''],
  legend: [1, '<fieldset>', '</fieldset>'],
  tr: [2, '<table><tbody>', '</tbody></table>'],
  col: [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>']
};

map.td = map.th = [3, '<table><tbody><tr>', '</tr></tbody></table>'];

map.option = map.optgroup = [1, '<select multiple="multiple">', '</select>'];

map.thead = map.tbody = map.colgroup = map.caption = map.tfoot = [1, '<table>', '</table>'];

map.g = map.defs = map.symbol = map.use = map.image = map.text = map.circle = map.ellipse = map.line = map.path = map.polygon = map.polyline = map.rect = [1, '<svg ' + 'xmlns="http://www.w3.org/2000/svg" ' + 'xmlns:xlink="http://www.w3.org/1999/xlink" ' + 'xmlns:ev="http://www.w3.org/2001/xml-events"' + 'version="1.1">', '</svg>'];

/**
 * Check if a node is a supported template node with a
 * DocumentFragment content.
 *
 * @param {Node} node
 * @return {Boolean}
 */

function isRealTemplate(node) {
  return isTemplate(node) && isFragment(node.content);
}

var tagRE$1 = /<([\w:-]+)/;
var entityRE = /&#?\w+?;/;
var commentRE = /<!--/;

/**
 * Convert a string template to a DocumentFragment.
 * Determines correct wrapping by tag types. Wrapping
 * strategy found in jQuery & component/domify.
 *
 * @param {String} templateString
 * @param {Boolean} raw
 * @return {DocumentFragment}
 */

function stringToFragment(templateString, raw) {
  // try a cache hit first
  var cacheKey = raw ? templateString : templateString.trim();
  var hit = templateCache.get(cacheKey);
  if (hit) {
    return hit;
  }

  var frag = document.createDocumentFragment();
  var tagMatch = templateString.match(tagRE$1);
  var entityMatch = entityRE.test(templateString);
  var commentMatch = commentRE.test(templateString);

  if (!tagMatch && !entityMatch && !commentMatch) {
    // text only, return a single text node.
    frag.appendChild(document.createTextNode(templateString));
  } else {
    var tag = tagMatch && tagMatch[1];
    var wrap = map[tag] || map.efault;
    var depth = wrap[0];
    var prefix = wrap[1];
    var suffix = wrap[2];
    var node = document.createElement('div');

    node.innerHTML = prefix + templateString + suffix;
    while (depth--) {
      node = node.lastChild;
    }

    var child;
    /* eslint-disable no-cond-assign */
    while (child = node.firstChild) {
      /* eslint-enable no-cond-assign */
      frag.appendChild(child);
    }
  }
  if (!raw) {
    trimNode(frag);
  }
  templateCache.put(cacheKey, frag);
  return frag;
}

/**
 * Convert a template node to a DocumentFragment.
 *
 * @param {Node} node
 * @return {DocumentFragment}
 */

function nodeToFragment(node) {
  // if its a template tag and the browser supports it,
  // its content is already a document fragment. However, iOS Safari has
  // bug when using directly cloned template content with touch
  // events and can cause crashes when the nodes are removed from DOM, so we
  // have to treat template elements as string templates. (#2805)
  /* istanbul ignore if */
  if (isRealTemplate(node)) {
    return stringToFragment(node.innerHTML);
  }
  // script template
  if (node.tagName === 'SCRIPT') {
    return stringToFragment(node.textContent);
  }
  // normal node, clone it to avoid mutating the original
  var clonedNode = cloneNode(node);
  var frag = document.createDocumentFragment();
  var child;
  /* eslint-disable no-cond-assign */
  while (child = clonedNode.firstChild) {
    /* eslint-enable no-cond-assign */
    frag.appendChild(child);
  }
  trimNode(frag);
  return frag;
}

// Test for the presence of the Safari template cloning bug
// https://bugs.webkit.org/showug.cgi?id=137755
var hasBrokenTemplate = (function () {
  /* istanbul ignore else */
  if (inBrowser) {
    var a = document.createElement('div');
    a.innerHTML = '<template>1</template>';
    return !a.cloneNode(true).firstChild.innerHTML;
  } else {
    return false;
  }
})();

// Test for IE10/11 textarea placeholder clone bug
var hasTextareaCloneBug = (function () {
  /* istanbul ignore else */
  if (inBrowser) {
    var t = document.createElement('textarea');
    t.placeholder = 't';
    return t.cloneNode(true).value === 't';
  } else {
    return false;
  }
})();

/**
 * 1. Deal with Safari cloning nested <template> bug by
 *    manually cloning all template instances.
 * 2. Deal with IE10/11 textarea placeholder bug by setting
 *    the correct value after cloning.
 *
 * @param {Element|DocumentFragment} node
 * @return {Element|DocumentFragment}
 */

function cloneNode(node) {
  /* istanbul ignore if */
  if (!node.querySelectorAll) {
    return node.cloneNode();
  }
  var res = node.cloneNode(true);
  var i, original, cloned;
  /* istanbul ignore if */
  if (hasBrokenTemplate) {
    var tempClone = res;
    if (isRealTemplate(node)) {
      node = node.content;
      tempClone = res.content;
    }
    original = node.querySelectorAll('template');
    if (original.length) {
      cloned = tempClone.querySelectorAll('template');
      i = cloned.length;
      while (i--) {
        cloned[i].parentNode.replaceChild(cloneNode(original[i]), cloned[i]);
      }
    }
  }
  /* istanbul ignore if */
  if (hasTextareaCloneBug) {
    if (node.tagName === 'TEXTAREA') {
      res.value = node.value;
    } else {
      original = node.querySelectorAll('textarea');
      if (original.length) {
        cloned = res.querySelectorAll('textarea');
        i = cloned.length;
        while (i--) {
          cloned[i].value = original[i].value;
        }
      }
    }
  }
  return res;
}

/**
 * Process the template option and normalizes it into a
 * a DocumentFragment that can be used as a partial or a
 * instance template.
 *
 * @param {*} template
 *        Possible values include:
 *        - DocumentFragment object
 *        - Node object of type Template
 *        - id selector: '#some-template-id'
 *        - template string: '<div><span>{{msg}}</span></div>'
 * @param {Boolean} shouldClone
 * @param {Boolean} raw
 *        inline HTML interpolation. Do not check for id
 *        selector and keep whitespace in the string.
 * @return {DocumentFragment|undefined}
 */

function parseTemplate(template, shouldClone, raw) {
  var node, frag;

  // if the template is already a document fragment,
  // do nothing
  if (isFragment(template)) {
    trimNode(template);
    return shouldClone ? cloneNode(template) : template;
  }

  if (typeof template === 'string') {
    // id selector
    if (!raw && template.charAt(0) === '#') {
      // id selector can be cached too
      frag = idSelectorCache.get(template);
      if (!frag) {
        node = document.getElementById(template.slice(1));
        if (node) {
          frag = nodeToFragment(node);
          // save selector to cache
          idSelectorCache.put(template, frag);
        }
      }
    } else {
      // normal string template
      frag = stringToFragment(template, raw);
    }
  } else if (template.nodeType) {
    // a direct node
    frag = nodeToFragment(template);
  }

  return frag && shouldClone ? cloneNode(frag) : frag;
}

var template = Object.freeze({
  cloneNode: cloneNode,
  parseTemplate: parseTemplate
});

var html = {

  bind: function bind() {
    // a comment node means this is a binding for
    // {{{ inline unescaped html }}}
    if (this.el.nodeType === 8) {
      // hold nodes
      this.nodes = [];
      // replace the placeholder with proper anchor
      this.anchor = createAnchor('v-html');
      replace(this.el, this.anchor);
    }
  },

  update: function update(value) {
    value = _toString(value);
    if (this.nodes) {
      this.swap(value);
    } else {
      this.el.innerHTML = value;
    }
  },

  swap: function swap(value) {
    // remove old nodes
    var i = this.nodes.length;
    while (i--) {
      remove(this.nodes[i]);
    }
    // convert new value to a fragment
    // do not attempt to retrieve from id selector
    var frag = parseTemplate(value, true, true);
    // save a reference to these nodes so we can remove later
    this.nodes = toArray(frag.childNodes);
    before(frag, this.anchor);
  }
};

/**
 * Abstraction for a partially-compiled fragment.
 * Can optionally compile content with a child scope.
 *
 * @param {Function} linker
 * @param {Vue} vm
 * @param {DocumentFragment} frag
 * @param {Vue} [host]
 * @param {Object} [scope]
 * @param {Fragment} [parentFrag]
 */
function Fragment(linker, vm, frag, host, scope, parentFrag) {
  this.children = [];
  this.childFrags = [];
  this.vm = vm;
  this.scope = scope;
  this.inserted = false;
  this.parentFrag = parentFrag;
  if (parentFrag) {
    parentFrag.childFrags.push(this);
  }
  this.unlink = linker(vm, frag, host, scope, this);
  var single = this.single = frag.childNodes.length === 1 &&
  // do not go single mode if the only node is an anchor
  !frag.childNodes[0].__v_anchor;
  if (single) {
    this.node = frag.childNodes[0];
    this.before = singleBefore;
    this.remove = singleRemove;
  } else {
    this.node = createAnchor('fragment-start');
    this.end = createAnchor('fragment-end');
    this.frag = frag;
    prepend(this.node, frag);
    frag.appendChild(this.end);
    this.before = multiBefore;
    this.remove = multiRemove;
  }
  this.node.__v_frag = this;
}

/**
 * Call attach/detach for all components contained within
 * this fragment. Also do so recursively for all child
 * fragments.
 *
 * @param {Function} hook
 */

Fragment.prototype.callHook = function (hook) {
  var i, l;
  for (i = 0, l = this.childFrags.length; i < l; i++) {
    this.childFrags[i].callHook(hook);
  }
  for (i = 0, l = this.children.length; i < l; i++) {
    hook(this.children[i]);
  }
};

/**
 * Insert fragment before target, single node version
 *
 * @param {Node} target
 * @param {Boolean} withTransition
 */

function singleBefore(target, withTransition) {
  this.inserted = true;
  var method = withTransition !== false ? beforeWithTransition : before;
  method(this.node, target, this.vm);
  if (inDoc(this.node)) {
    this.callHook(attach);
  }
}

/**
 * Remove fragment, single node version
 */

function singleRemove() {
  this.inserted = false;
  var shouldCallRemove = inDoc(this.node);
  var self = this;
  this.beforeRemove();
  removeWithTransition(this.node, this.vm, function () {
    if (shouldCallRemove) {
      self.callHook(detach);
    }
    self.destroy();
  });
}

/**
 * Insert fragment before target, multi-nodes version
 *
 * @param {Node} target
 * @param {Boolean} withTransition
 */

function multiBefore(target, withTransition) {
  this.inserted = true;
  var vm = this.vm;
  var method = withTransition !== false ? beforeWithTransition : before;
  mapNodeRange(this.node, this.end, function (node) {
    method(node, target, vm);
  });
  if (inDoc(this.node)) {
    this.callHook(attach);
  }
}

/**
 * Remove fragment, multi-nodes version
 */

function multiRemove() {
  this.inserted = false;
  var self = this;
  var shouldCallRemove = inDoc(this.node);
  this.beforeRemove();
  removeNodeRange(this.node, this.end, this.vm, this.frag, function () {
    if (shouldCallRemove) {
      self.callHook(detach);
    }
    self.destroy();
  });
}

/**
 * Prepare the fragment for removal.
 */

Fragment.prototype.beforeRemove = function () {
  var i, l;
  for (i = 0, l = this.childFrags.length; i < l; i++) {
    // call the same method recursively on child
    // fragments, depth-first
    this.childFrags[i].beforeRemove(false);
  }
  for (i = 0, l = this.children.length; i < l; i++) {
    // Call destroy for all contained instances,
    // with remove:false and defer:true.
    // Defer is necessary because we need to
    // keep the children to call detach hooks
    // on them.
    this.children[i].$destroy(false, true);
  }
  var dirs = this.unlink.dirs;
  for (i = 0, l = dirs.length; i < l; i++) {
    // disable the watchers on all the directives
    // so that the rendered content stays the same
    // during removal.
    dirs[i]._watcher && dirs[i]._watcher.teardown();
  }
};

/**
 * Destroy the fragment.
 */

Fragment.prototype.destroy = function () {
  if (this.parentFrag) {
    this.parentFrag.childFrags.$remove(this);
  }
  this.node.__v_frag = null;
  this.unlink();
};

/**
 * Call attach hook for a Vue instance.
 *
 * @param {Vue} child
 */

function attach(child) {
  if (!child._isAttached && inDoc(child.$el)) {
    child._callHook('attached');
  }
}

/**
 * Call detach hook for a Vue instance.
 *
 * @param {Vue} child
 */

function detach(child) {
  if (child._isAttached && !inDoc(child.$el)) {
    child._callHook('detached');
  }
}

var linkerCache = new Cache(5000);

/**
 * A factory that can be used to create instances of a
 * fragment. Caches the compiled linker if possible.
 *
 * @param {Vue} vm
 * @param {Element|String} el
 */
function FragmentFactory(vm, el) {
  this.vm = vm;
  var template;
  var isString = typeof el === 'string';
  if (isString || isTemplate(el) && !el.hasAttribute('v-if')) {
    template = parseTemplate(el, true);
  } else {
    template = document.createDocumentFragment();
    template.appendChild(el);
  }
  this.template = template;
  // linker can be cached, but only for components
  var linker;
  var cid = vm.constructor.cid;
  if (cid > 0) {
    var cacheId = cid + (isString ? el : getOuterHTML(el));
    linker = linkerCache.get(cacheId);
    if (!linker) {
      linker = compile(template, vm.$options, true);
      linkerCache.put(cacheId, linker);
    }
  } else {
    linker = compile(template, vm.$options, true);
  }
  this.linker = linker;
}

/**
 * Create a fragment instance with given host and scope.
 *
 * @param {Vue} host
 * @param {Object} scope
 * @param {Fragment} parentFrag
 */

FragmentFactory.prototype.create = function (host, scope, parentFrag) {
  var frag = cloneNode(this.template);
  return new Fragment(this.linker, this.vm, frag, host, scope, parentFrag);
};

var ON = 700;
var MODEL = 800;
var BIND = 850;
var TRANSITION = 1100;
var EL = 1500;
var COMPONENT = 1500;
var PARTIAL = 1750;
var IF = 2100;
var FOR = 2200;
var SLOT = 2300;

var uid$3 = 0;

var vFor = {

  priority: FOR,
  terminal: true,

  params: ['track-by', 'stagger', 'enter-stagger', 'leave-stagger'],

  bind: function bind() {
    if (process.env.NODE_ENV !== 'production' && this.el.hasAttribute('v-if')) {
      warn('<' + this.el.tagName.toLowerCase() + ' v-for="' + this.expression + '" v-if="' + this.el.getAttribute('v-if') + '">: ' + 'Using v-if and v-for on the same element is not recommended - ' + 'consider filtering the source Array instead.', this.vm);
    }

    // support "item in/of items" syntax
    var inMatch = this.expression.match(/(.*) (?:in|of) (.*)/);
    if (inMatch) {
      var itMatch = inMatch[1].match(/\((.*),(.*)\)/);
      if (itMatch) {
        this.iterator = itMatch[1].trim();
        this.alias = itMatch[2].trim();
      } else {
        this.alias = inMatch[1].trim();
      }
      this.expression = inMatch[2];
    }

    if (!this.alias) {
      process.env.NODE_ENV !== 'production' && warn('Invalid v-for expression "' + this.descriptor.raw + '": ' + 'alias is required.', this.vm);
      return;
    }

    // uid as a cache identifier
    this.id = '__v-for__' + ++uid$3;

    // check if this is an option list,
    // so that we know if we need to update the <select>'s
    // v-model when the option list has changed.
    // because v-model has a lower priority than v-for,
    // the v-model is not bound here yet, so we have to
    // retrive it in the actual updateModel() function.
    var tag = this.el.tagName;
    this.isOption = (tag === 'OPTION' || tag === 'OPTGROUP') && this.el.parentNode.tagName === 'SELECT';

    // setup anchor nodes
    this.start = createAnchor('v-for-start');
    this.end = createAnchor('v-for-end');
    replace(this.el, this.end);
    before(this.start, this.end);

    // cache
    this.cache = Object.create(null);

    // fragment factory
    this.factory = new FragmentFactory(this.vm, this.el);
  },

  update: function update(data) {
    this.diff(data);
    this.updateRef();
    this.updateModel();
  },

  /**
   * Diff, based on new data and old data, determine the
   * minimum amount of DOM manipulations needed to make the
   * DOM reflect the new data Array.
   *
   * The algorithm diffs the new data Array by storing a
   * hidden reference to an owner vm instance on previously
   * seen data. This allows us to achieve O(n) which is
   * better than a levenshtein distance based algorithm,
   * which is O(m * n).
   *
   * @param {Array} data
   */

  diff: function diff(data) {
    // check if the Array was converted from an Object
    var item = data[0];
    var convertedFromObject = this.fromObject = isObject(item) && hasOwn(item, '$key') && hasOwn(item, '$value');

    var trackByKey = this.params.trackBy;
    var oldFrags = this.frags;
    var frags = this.frags = new Array(data.length);
    var alias = this.alias;
    var iterator = this.iterator;
    var start = this.start;
    var end = this.end;
    var inDocument = inDoc(start);
    var init = !oldFrags;
    var i, l, frag, key, value, primitive;

    // First pass, go through the new Array and fill up
    // the new frags array. If a piece of data has a cached
    // instance for it, we reuse it. Otherwise build a new
    // instance.
    for (i = 0, l = data.length; i < l; i++) {
      item = data[i];
      key = convertedFromObject ? item.$key : null;
      value = convertedFromObject ? item.$value : item;
      primitive = !isObject(value);
      frag = !init && this.getCachedFrag(value, i, key);
      if (frag) {
        // reusable fragment
        frag.reused = true;
        // update $index
        frag.scope.$index = i;
        // update $key
        if (key) {
          frag.scope.$key = key;
        }
        // update iterator
        if (iterator) {
          frag.scope[iterator] = key !== null ? key : i;
        }
        // update data for track-by, object repeat &
        // primitive values.
        if (trackByKey || convertedFromObject || primitive) {
          withoutConversion(function () {
            frag.scope[alias] = value;
          });
        }
      } else {
        // new instance
        frag = this.create(value, alias, i, key);
        frag.fresh = !init;
      }
      frags[i] = frag;
      if (init) {
        frag.before(end);
      }
    }

    // we're done for the initial render.
    if (init) {
      return;
    }

    // Second pass, go through the old fragments and
    // destroy those who are not reused (and remove them
    // from cache)
    var removalIndex = 0;
    var totalRemoved = oldFrags.length - frags.length;
    // when removing a large number of fragments, watcher removal
    // turns out to be a perf bottleneck, so we batch the watcher
    // removals into a single filter call!
    this.vm._vForRemoving = true;
    for (i = 0, l = oldFrags.length; i < l; i++) {
      frag = oldFrags[i];
      if (!frag.reused) {
        this.deleteCachedFrag(frag);
        this.remove(frag, removalIndex++, totalRemoved, inDocument);
      }
    }
    this.vm._vForRemoving = false;
    if (removalIndex) {
      this.vm._watchers = this.vm._watchers.filter(function (w) {
        return w.active;
      });
    }

    // Final pass, move/insert new fragments into the
    // right place.
    var targetPrev, prevEl, currentPrev;
    var insertionIndex = 0;
    for (i = 0, l = frags.length; i < l; i++) {
      frag = frags[i];
      // this is the frag that we should be after
      targetPrev = frags[i - 1];
      prevEl = targetPrev ? targetPrev.staggerCb ? targetPrev.staggerAnchor : targetPrev.end || targetPrev.node : start;
      if (frag.reused && !frag.staggerCb) {
        currentPrev = findPrevFrag(frag, start, this.id);
        if (currentPrev !== targetPrev && (!currentPrev ||
        // optimization for moving a single item.
        // thanks to suggestions by @livoras in #1807
        findPrevFrag(currentPrev, start, this.id) !== targetPrev)) {
          this.move(frag, prevEl);
        }
      } else {
        // new instance, or still in stagger.
        // insert with updated stagger index.
        this.insert(frag, insertionIndex++, prevEl, inDocument);
      }
      frag.reused = frag.fresh = false;
    }
  },

  /**
   * Create a new fragment instance.
   *
   * @param {*} value
   * @param {String} alias
   * @param {Number} index
   * @param {String} [key]
   * @return {Fragment}
   */

  create: function create(value, alias, index, key) {
    var host = this._host;
    // create iteration scope
    var parentScope = this._scope || this.vm;
    var scope = Object.create(parentScope);
    // ref holder for the scope
    scope.$refs = Object.create(parentScope.$refs);
    scope.$els = Object.create(parentScope.$els);
    // make sure point $parent to parent scope
    scope.$parent = parentScope;
    // for two-way binding on alias
    scope.$forContext = this;
    // define scope properties
    // important: define the scope alias without forced conversion
    // so that frozen data structures remain non-reactive.
    withoutConversion(function () {
      defineReactive(scope, alias, value);
    });
    defineReactive(scope, '$index', index);
    if (key) {
      defineReactive(scope, '$key', key);
    } else if (scope.$key) {
      // avoid accidental fallback
      def(scope, '$key', null);
    }
    if (this.iterator) {
      defineReactive(scope, this.iterator, key !== null ? key : index);
    }
    var frag = this.factory.create(host, scope, this._frag);
    frag.forId = this.id;
    this.cacheFrag(value, frag, index, key);
    return frag;
  },

  /**
   * Update the v-ref on owner vm.
   */

  updateRef: function updateRef() {
    var ref = this.descriptor.ref;
    if (!ref) return;
    var hash = (this._scope || this.vm).$refs;
    var refs;
    if (!this.fromObject) {
      refs = this.frags.map(findVmFromFrag);
    } else {
      refs = {};
      this.frags.forEach(function (frag) {
        refs[frag.scope.$key] = findVmFromFrag(frag);
      });
    }
    hash[ref] = refs;
  },

  /**
   * For option lists, update the containing v-model on
   * parent <select>.
   */

  updateModel: function updateModel() {
    if (this.isOption) {
      var parent = this.start.parentNode;
      var model = parent && parent.__v_model;
      if (model) {
        model.forceUpdate();
      }
    }
  },

  /**
   * Insert a fragment. Handles staggering.
   *
   * @param {Fragment} frag
   * @param {Number} index
   * @param {Node} prevEl
   * @param {Boolean} inDocument
   */

  insert: function insert(frag, index, prevEl, inDocument) {
    if (frag.staggerCb) {
      frag.staggerCb.cancel();
      frag.staggerCb = null;
    }
    var staggerAmount = this.getStagger(frag, index, null, 'enter');
    if (inDocument && staggerAmount) {
      // create an anchor and insert it synchronously,
      // so that we can resolve the correct order without
      // worrying about some elements not inserted yet
      var anchor = frag.staggerAnchor;
      if (!anchor) {
        anchor = frag.staggerAnchor = createAnchor('stagger-anchor');
        anchor.__v_frag = frag;
      }
      after(anchor, prevEl);
      var op = frag.staggerCb = cancellable(function () {
        frag.staggerCb = null;
        frag.before(anchor);
        remove(anchor);
      });
      setTimeout(op, staggerAmount);
    } else {
      var target = prevEl.nextSibling;
      /* istanbul ignore if */
      if (!target) {
        // reset end anchor position in case the position was messed up
        // by an external drag-n-drop library.
        after(this.end, prevEl);
        target = this.end;
      }
      frag.before(target);
    }
  },

  /**
   * Remove a fragment. Handles staggering.
   *
   * @param {Fragment} frag
   * @param {Number} index
   * @param {Number} total
   * @param {Boolean} inDocument
   */

  remove: function remove(frag, index, total, inDocument) {
    if (frag.staggerCb) {
      frag.staggerCb.cancel();
      frag.staggerCb = null;
      // it's not possible for the same frag to be removed
      // twice, so if we have a pending stagger callback,
      // it means this frag is queued for enter but removed
      // before its transition started. Since it is already
      // destroyed, we can just leave it in detached state.
      return;
    }
    var staggerAmount = this.getStagger(frag, index, total, 'leave');
    if (inDocument && staggerAmount) {
      var op = frag.staggerCb = cancellable(function () {
        frag.staggerCb = null;
        frag.remove();
      });
      setTimeout(op, staggerAmount);
    } else {
      frag.remove();
    }
  },

  /**
   * Move a fragment to a new position.
   * Force no transition.
   *
   * @param {Fragment} frag
   * @param {Node} prevEl
   */

  move: function move(frag, prevEl) {
    // fix a common issue with Sortable:
    // if prevEl doesn't have nextSibling, this means it's
    // been dragged after the end anchor. Just re-position
    // the end anchor to the end of the container.
    /* istanbul ignore if */
    if (!prevEl.nextSibling) {
      this.end.parentNode.appendChild(this.end);
    }
    frag.before(prevEl.nextSibling, false);
  },

  /**
   * Cache a fragment using track-by or the object key.
   *
   * @param {*} value
   * @param {Fragment} frag
   * @param {Number} index
   * @param {String} [key]
   */

  cacheFrag: function cacheFrag(value, frag, index, key) {
    var trackByKey = this.params.trackBy;
    var cache = this.cache;
    var primitive = !isObject(value);
    var id;
    if (key || trackByKey || primitive) {
      id = getTrackByKey(index, key, value, trackByKey);
      if (!cache[id]) {
        cache[id] = frag;
      } else if (trackByKey !== '$index') {
        process.env.NODE_ENV !== 'production' && this.warnDuplicate(value);
      }
    } else {
      id = this.id;
      if (hasOwn(value, id)) {
        if (value[id] === null) {
          value[id] = frag;
        } else {
          process.env.NODE_ENV !== 'production' && this.warnDuplicate(value);
        }
      } else if (Object.isExtensible(value)) {
        def(value, id, frag);
      } else if (process.env.NODE_ENV !== 'production') {
        warn('Frozen v-for objects cannot be automatically tracked, make sure to ' + 'provide a track-by key.');
      }
    }
    frag.raw = value;
  },

  /**
   * Get a cached fragment from the value/index/key
   *
   * @param {*} value
   * @param {Number} index
   * @param {String} key
   * @return {Fragment}
   */

  getCachedFrag: function getCachedFrag(value, index, key) {
    var trackByKey = this.params.trackBy;
    var primitive = !isObject(value);
    var frag;
    if (key || trackByKey || primitive) {
      var id = getTrackByKey(index, key, value, trackByKey);
      frag = this.cache[id];
    } else {
      frag = value[this.id];
    }
    if (frag && (frag.reused || frag.fresh)) {
      process.env.NODE_ENV !== 'production' && this.warnDuplicate(value);
    }
    return frag;
  },

  /**
   * Delete a fragment from cache.
   *
   * @param {Fragment} frag
   */

  deleteCachedFrag: function deleteCachedFrag(frag) {
    var value = frag.raw;
    var trackByKey = this.params.trackBy;
    var scope = frag.scope;
    var index = scope.$index;
    // fix #948: avoid accidentally fall through to
    // a parent repeater which happens to have $key.
    var key = hasOwn(scope, '$key') && scope.$key;
    var primitive = !isObject(value);
    if (trackByKey || key || primitive) {
      var id = getTrackByKey(index, key, value, trackByKey);
      this.cache[id] = null;
    } else {
      value[this.id] = null;
      frag.raw = null;
    }
  },

  /**
   * Get the stagger amount for an insertion/removal.
   *
   * @param {Fragment} frag
   * @param {Number} index
   * @param {Number} total
   * @param {String} type
   */

  getStagger: function getStagger(frag, index, total, type) {
    type = type + 'Stagger';
    var trans = frag.node.__v_trans;
    var hooks = trans && trans.hooks;
    var hook = hooks && (hooks[type] || hooks.stagger);
    return hook ? hook.call(frag, index, total) : index * parseInt(this.params[type] || this.params.stagger, 10);
  },

  /**
   * Pre-process the value before piping it through the
   * filters. This is passed to and called by the watcher.
   */

  _preProcess: function _preProcess(value) {
    // regardless of type, store the un-filtered raw value.
    this.rawValue = value;
    return value;
  },

  /**
   * Post-process the value after it has been piped through
   * the filters. This is passed to and called by the watcher.
   *
   * It is necessary for this to be called during the
   * watcher's dependency collection phase because we want
   * the v-for to update when the source Object is mutated.
   */

  _postProcess: function _postProcess(value) {
    if (isArray(value)) {
      return value;
    } else if (isPlainObject(value)) {
      // convert plain object to array.
      var keys = Object.keys(value);
      var i = keys.length;
      var res = new Array(i);
      var key;
      while (i--) {
        key = keys[i];
        res[i] = {
          $key: key,
          $value: value[key]
        };
      }
      return res;
    } else {
      if (typeof value === 'number' && !isNaN(value)) {
        value = range(value);
      }
      return value || [];
    }
  },

  unbind: function unbind() {
    if (this.descriptor.ref) {
      (this._scope || this.vm).$refs[this.descriptor.ref] = null;
    }
    if (this.frags) {
      var i = this.frags.length;
      var frag;
      while (i--) {
        frag = this.frags[i];
        this.deleteCachedFrag(frag);
        frag.destroy();
      }
    }
  }
};

/**
 * Helper to find the previous element that is a fragment
 * anchor. This is necessary because a destroyed frag's
 * element could still be lingering in the DOM before its
 * leaving transition finishes, but its inserted flag
 * should have been set to false so we can skip them.
 *
 * If this is a block repeat, we want to make sure we only
 * return frag that is bound to this v-for. (see #929)
 *
 * @param {Fragment} frag
 * @param {Comment|Text} anchor
 * @param {String} id
 * @return {Fragment}
 */

function findPrevFrag(frag, anchor, id) {
  var el = frag.node.previousSibling;
  /* istanbul ignore if */
  if (!el) return;
  frag = el.__v_frag;
  while ((!frag || frag.forId !== id || !frag.inserted) && el !== anchor) {
    el = el.previousSibling;
    /* istanbul ignore if */
    if (!el) return;
    frag = el.__v_frag;
  }
  return frag;
}

/**
 * Create a range array from given number.
 *
 * @param {Number} n
 * @return {Array}
 */

function range(n) {
  var i = -1;
  var ret = new Array(Math.floor(n));
  while (++i < n) {
    ret[i] = i;
  }
  return ret;
}

/**
 * Get the track by key for an item.
 *
 * @param {Number} index
 * @param {String} key
 * @param {*} value
 * @param {String} [trackByKey]
 */

function getTrackByKey(index, key, value, trackByKey) {
  return trackByKey ? trackByKey === '$index' ? index : trackByKey.charAt(0).match(/\w/) ? getPath(value, trackByKey) : value[trackByKey] : key || value;
}

if (process.env.NODE_ENV !== 'production') {
  vFor.warnDuplicate = function (value) {
    warn('Duplicate value found in v-for="' + this.descriptor.raw + '": ' + JSON.stringify(value) + '. Use track-by="$index" if ' + 'you are expecting duplicate values.', this.vm);
  };
}

/**
 * Find a vm from a fragment.
 *
 * @param {Fragment} frag
 * @return {Vue|undefined}
 */

function findVmFromFrag(frag) {
  var node = frag.node;
  // handle multi-node frag
  if (frag.end) {
    while (!node.__vue__ && node !== frag.end && node.nextSibling) {
      node = node.nextSibling;
    }
  }
  return node.__vue__;
}

var vIf = {

  priority: IF,
  terminal: true,

  bind: function bind() {
    var el = this.el;
    if (!el.__vue__) {
      // check else block
      var next = el.nextElementSibling;
      if (next && getAttr(next, 'v-else') !== null) {
        remove(next);
        this.elseEl = next;
      }
      // check main block
      this.anchor = createAnchor('v-if');
      replace(el, this.anchor);
    } else {
      process.env.NODE_ENV !== 'production' && warn('v-if="' + this.expression + '" cannot be ' + 'used on an instance root element.', this.vm);
      this.invalid = true;
    }
  },

  update: function update(value) {
    if (this.invalid) return;
    if (value) {
      if (!this.frag) {
        this.insert();
      }
    } else {
      this.remove();
    }
  },

  insert: function insert() {
    if (this.elseFrag) {
      this.elseFrag.remove();
      this.elseFrag = null;
    }
    // lazy init factory
    if (!this.factory) {
      this.factory = new FragmentFactory(this.vm, this.el);
    }
    this.frag = this.factory.create(this._host, this._scope, this._frag);
    this.frag.before(this.anchor);
  },

  remove: function remove() {
    if (this.frag) {
      this.frag.remove();
      this.frag = null;
    }
    if (this.elseEl && !this.elseFrag) {
      if (!this.elseFactory) {
        this.elseFactory = new FragmentFactory(this.elseEl._context || this.vm, this.elseEl);
      }
      this.elseFrag = this.elseFactory.create(this._host, this._scope, this._frag);
      this.elseFrag.before(this.anchor);
    }
  },

  unbind: function unbind() {
    if (this.frag) {
      this.frag.destroy();
    }
    if (this.elseFrag) {
      this.elseFrag.destroy();
    }
  }
};

var show = {

  bind: function bind() {
    // check else block
    var next = this.el.nextElementSibling;
    if (next && getAttr(next, 'v-else') !== null) {
      this.elseEl = next;
    }
  },

  update: function update(value) {
    this.apply(this.el, value);
    if (this.elseEl) {
      this.apply(this.elseEl, !value);
    }
  },

  apply: function apply(el, value) {
    if (inDoc(el)) {
      applyTransition(el, value ? 1 : -1, toggle, this.vm);
    } else {
      toggle();
    }
    function toggle() {
      el.style.display = value ? '' : 'none';
    }
  }
};

var text$2 = {

  bind: function bind() {
    var self = this;
    var el = this.el;
    var isRange = el.type === 'range';
    var lazy = this.params.lazy;
    var number = this.params.number;
    var debounce = this.params.debounce;

    // handle composition events.
    //   http://blog.evanyou.me/2014/01/03/composition-event/
    // skip this for Android because it handles composition
    // events quite differently. Android doesn't trigger
    // composition events for language input methods e.g.
    // Chinese, but instead triggers them for spelling
    // suggestions... (see Discussion/#162)
    var composing = false;
    if (!isAndroid && !isRange) {
      this.on('compositionstart', function () {
        composing = true;
      });
      this.on('compositionend', function () {
        composing = false;
        // in IE11 the "compositionend" event fires AFTER
        // the "input" event, so the input handler is blocked
        // at the end... have to call it here.
        //
        // #1327: in lazy mode this is unecessary.
        if (!lazy) {
          self.listener();
        }
      });
    }

    // prevent messing with the input when user is typing,
    // and force update on blur.
    this.focused = false;
    if (!isRange && !lazy) {
      this.on('focus', function () {
        self.focused = true;
      });
      this.on('blur', function () {
        self.focused = false;
        // do not sync value after fragment removal (#2017)
        if (!self._frag || self._frag.inserted) {
          self.rawListener();
        }
      });
    }

    // Now attach the main listener
    this.listener = this.rawListener = function () {
      if (composing || !self._bound) {
        return;
      }
      var val = number || isRange ? toNumber(el.value) : el.value;
      self.set(val);
      // force update on next tick to avoid lock & same value
      // also only update when user is not typing
      nextTick(function () {
        if (self._bound && !self.focused) {
          self.update(self._watcher.value);
        }
      });
    };

    // apply debounce
    if (debounce) {
      this.listener = _debounce(this.listener, debounce);
    }

    // Support jQuery events, since jQuery.trigger() doesn't
    // trigger native events in some cases and some plugins
    // rely on $.trigger()
    //
    // We want to make sure if a listener is attached using
    // jQuery, it is also removed with jQuery, that's why
    // we do the check for each directive instance and
    // store that check result on itself. This also allows
    // easier test coverage control by unsetting the global
    // jQuery variable in tests.
    this.hasjQuery = typeof jQuery === 'function';
    if (this.hasjQuery) {
      var method = jQuery.fn.on ? 'on' : 'bind';
      jQuery(el)[method]('change', this.rawListener);
      if (!lazy) {
        jQuery(el)[method]('input', this.listener);
      }
    } else {
      this.on('change', this.rawListener);
      if (!lazy) {
        this.on('input', this.listener);
      }
    }

    // IE9 doesn't fire input event on backspace/del/cut
    if (!lazy && isIE9) {
      this.on('cut', function () {
        nextTick(self.listener);
      });
      this.on('keyup', function (e) {
        if (e.keyCode === 46 || e.keyCode === 8) {
          self.listener();
        }
      });
    }

    // set initial value if present
    if (el.hasAttribute('value') || el.tagName === 'TEXTAREA' && el.value.trim()) {
      this.afterBind = this.listener;
    }
  },

  update: function update(value) {
    // #3029 only update when the value changes. This prevent
    // browsers from overwriting values like selectionStart
    value = _toString(value);
    if (value !== this.el.value) this.el.value = value;
  },

  unbind: function unbind() {
    var el = this.el;
    if (this.hasjQuery) {
      var method = jQuery.fn.off ? 'off' : 'unbind';
      jQuery(el)[method]('change', this.listener);
      jQuery(el)[method]('input', this.listener);
    }
  }
};

var radio = {

  bind: function bind() {
    var self = this;
    var el = this.el;

    this.getValue = function () {
      // value overwrite via v-bind:value
      if (el.hasOwnProperty('_value')) {
        return el._value;
      }
      var val = el.value;
      if (self.params.number) {
        val = toNumber(val);
      }
      return val;
    };

    this.listener = function () {
      self.set(self.getValue());
    };
    this.on('change', this.listener);

    if (el.hasAttribute('checked')) {
      this.afterBind = this.listener;
    }
  },

  update: function update(value) {
    this.el.checked = looseEqual(value, this.getValue());
  }
};

var select = {

  bind: function bind() {
    var _this = this;

    var self = this;
    var el = this.el;

    // method to force update DOM using latest value.
    this.forceUpdate = function () {
      if (self._watcher) {
        self.update(self._watcher.get());
      }
    };

    // check if this is a multiple select
    var multiple = this.multiple = el.hasAttribute('multiple');

    // attach listener
    this.listener = function () {
      var value = getValue(el, multiple);
      value = self.params.number ? isArray(value) ? value.map(toNumber) : toNumber(value) : value;
      self.set(value);
    };
    this.on('change', this.listener);

    // if has initial value, set afterBind
    var initValue = getValue(el, multiple, true);
    if (multiple && initValue.length || !multiple && initValue !== null) {
      this.afterBind = this.listener;
    }

    // All major browsers except Firefox resets
    // selectedIndex with value -1 to 0 when the element
    // is appended to a new parent, therefore we have to
    // force a DOM update whenever that happens...
    this.vm.$on('hook:attached', function () {
      nextTick(_this.forceUpdate);
    });
    if (!inDoc(el)) {
      nextTick(this.forceUpdate);
    }
  },

  update: function update(value) {
    var el = this.el;
    el.selectedIndex = -1;
    var multi = this.multiple && isArray(value);
    var options = el.options;
    var i = options.length;
    var op, val;
    while (i--) {
      op = options[i];
      val = op.hasOwnProperty('_value') ? op._value : op.value;
      /* eslint-disable eqeqeq */
      op.selected = multi ? indexOf$1(value, val) > -1 : looseEqual(value, val);
      /* eslint-enable eqeqeq */
    }
  },

  unbind: function unbind() {
    /* istanbul ignore next */
    this.vm.$off('hook:attached', this.forceUpdate);
  }
};

/**
 * Get select value
 *
 * @param {SelectElement} el
 * @param {Boolean} multi
 * @param {Boolean} init
 * @return {Array|*}
 */

function getValue(el, multi, init) {
  var res = multi ? [] : null;
  var op, val, selected;
  for (var i = 0, l = el.options.length; i < l; i++) {
    op = el.options[i];
    selected = init ? op.hasAttribute('selected') : op.selected;
    if (selected) {
      val = op.hasOwnProperty('_value') ? op._value : op.value;
      if (multi) {
        res.push(val);
      } else {
        return val;
      }
    }
  }
  return res;
}

/**
 * Native Array.indexOf uses strict equal, but in this
 * case we need to match string/numbers with custom equal.
 *
 * @param {Array} arr
 * @param {*} val
 */

function indexOf$1(arr, val) {
  var i = arr.length;
  while (i--) {
    if (looseEqual(arr[i], val)) {
      return i;
    }
  }
  return -1;
}

var checkbox = {

  bind: function bind() {
    var self = this;
    var el = this.el;

    this.getValue = function () {
      return el.hasOwnProperty('_value') ? el._value : self.params.number ? toNumber(el.value) : el.value;
    };

    function getBooleanValue() {
      var val = el.checked;
      if (val && el.hasOwnProperty('_trueValue')) {
        return el._trueValue;
      }
      if (!val && el.hasOwnProperty('_falseValue')) {
        return el._falseValue;
      }
      return val;
    }

    this.listener = function () {
      var model = self._watcher.get();
      if (isArray(model)) {
        var val = self.getValue();
        var i = indexOf(model, val);
        if (el.checked) {
          if (i < 0) {
            self.set(model.concat(val));
          }
        } else if (i > -1) {
          self.set(model.slice(0, i).concat(model.slice(i + 1)));
        }
      } else {
        self.set(getBooleanValue());
      }
    };

    this.on('change', this.listener);
    if (el.hasAttribute('checked')) {
      this.afterBind = this.listener;
    }
  },

  update: function update(value) {
    var el = this.el;
    if (isArray(value)) {
      el.checked = indexOf(value, this.getValue()) > -1;
    } else {
      if (el.hasOwnProperty('_trueValue')) {
        el.checked = looseEqual(value, el._trueValue);
      } else {
        el.checked = !!value;
      }
    }
  }
};

var handlers = {
  text: text$2,
  radio: radio,
  select: select,
  checkbox: checkbox
};

var model = {

  priority: MODEL,
  twoWay: true,
  handlers: handlers,
  params: ['lazy', 'number', 'debounce'],

  /**
   * Possible elements:
   *   <select>
   *   <textarea>
   *   <input type="*">
   *     - text
   *     - checkbox
   *     - radio
   *     - number
   */

  bind: function bind() {
    // friendly warning...
    this.checkFilters();
    if (this.hasRead && !this.hasWrite) {
      process.env.NODE_ENV !== 'production' && warn('It seems you are using a read-only filter with ' + 'v-model="' + this.descriptor.raw + '". ' + 'You might want to use a two-way filter to ensure correct behavior.', this.vm);
    }
    var el = this.el;
    var tag = el.tagName;
    var handler;
    if (tag === 'INPUT') {
      handler = handlers[el.type] || handlers.text;
    } else if (tag === 'SELECT') {
      handler = handlers.select;
    } else if (tag === 'TEXTAREA') {
      handler = handlers.text;
    } else {
      process.env.NODE_ENV !== 'production' && warn('v-model does not support element type: ' + tag, this.vm);
      return;
    }
    el.__v_model = this;
    handler.bind.call(this);
    this.update = handler.update;
    this._unbind = handler.unbind;
  },

  /**
   * Check read/write filter stats.
   */

  checkFilters: function checkFilters() {
    var filters = this.filters;
    if (!filters) return;
    var i = filters.length;
    while (i--) {
      var filter = resolveAsset(this.vm.$options, 'filters', filters[i].name);
      if (typeof filter === 'function' || filter.read) {
        this.hasRead = true;
      }
      if (filter.write) {
        this.hasWrite = true;
      }
    }
  },

  unbind: function unbind() {
    this.el.__v_model = null;
    this._unbind && this._unbind();
  }
};

// keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  'delete': [8, 46],
  up: 38,
  left: 37,
  right: 39,
  down: 40
};

function keyFilter(handler, keys) {
  var codes = keys.map(function (key) {
    var charCode = key.charCodeAt(0);
    if (charCode > 47 && charCode < 58) {
      return parseInt(key, 10);
    }
    if (key.length === 1) {
      charCode = key.toUpperCase().charCodeAt(0);
      if (charCode > 64 && charCode < 91) {
        return charCode;
      }
    }
    return keyCodes[key];
  });
  codes = [].concat.apply([], codes);
  return function keyHandler(e) {
    if (codes.indexOf(e.keyCode) > -1) {
      return handler.call(this, e);
    }
  };
}

function stopFilter(handler) {
  return function stopHandler(e) {
    e.stopPropagation();
    return handler.call(this, e);
  };
}

function preventFilter(handler) {
  return function preventHandler(e) {
    e.preventDefault();
    return handler.call(this, e);
  };
}

function selfFilter(handler) {
  return function selfHandler(e) {
    if (e.target === e.currentTarget) {
      return handler.call(this, e);
    }
  };
}

var on$1 = {

  priority: ON,
  acceptStatement: true,
  keyCodes: keyCodes,

  bind: function bind() {
    // deal with iframes
    if (this.el.tagName === 'IFRAME' && this.arg !== 'load') {
      var self = this;
      this.iframeBind = function () {
        on(self.el.contentWindow, self.arg, self.handler, self.modifiers.capture);
      };
      this.on('load', this.iframeBind);
    }
  },

  update: function update(handler) {
    // stub a noop for v-on with no value,
    // e.g. @mousedown.prevent
    if (!this.descriptor.raw) {
      handler = function () {};
    }

    if (typeof handler !== 'function') {
      process.env.NODE_ENV !== 'production' && warn('v-on:' + this.arg + '="' + this.expression + '" expects a function value, ' + 'got ' + handler, this.vm);
      return;
    }

    // apply modifiers
    if (this.modifiers.stop) {
      handler = stopFilter(handler);
    }
    if (this.modifiers.prevent) {
      handler = preventFilter(handler);
    }
    if (this.modifiers.self) {
      handler = selfFilter(handler);
    }
    // key filter
    var keys = Object.keys(this.modifiers).filter(function (key) {
      return key !== 'stop' && key !== 'prevent' && key !== 'self' && key !== 'capture';
    });
    if (keys.length) {
      handler = keyFilter(handler, keys);
    }

    this.reset();
    this.handler = handler;

    if (this.iframeBind) {
      this.iframeBind();
    } else {
      on(this.el, this.arg, this.handler, this.modifiers.capture);
    }
  },

  reset: function reset() {
    var el = this.iframeBind ? this.el.contentWindow : this.el;
    if (this.handler) {
      off(el, this.arg, this.handler);
    }
  },

  unbind: function unbind() {
    this.reset();
  }
};

var prefixes = ['-webkit-', '-moz-', '-ms-'];
var camelPrefixes = ['Webkit', 'Moz', 'ms'];
var importantRE = /!important;?$/;
var propCache = Object.create(null);

var testEl = null;

var style = {

  deep: true,

  update: function update(value) {
    if (typeof value === 'string') {
      this.el.style.cssText = value;
    } else if (isArray(value)) {
      this.handleObject(value.reduce(extend, {}));
    } else {
      this.handleObject(value || {});
    }
  },

  handleObject: function handleObject(value) {
    // cache object styles so that only changed props
    // are actually updated.
    var cache = this.cache || (this.cache = {});
    var name, val;
    for (name in cache) {
      if (!(name in value)) {
        this.handleSingle(name, null);
        delete cache[name];
      }
    }
    for (name in value) {
      val = value[name];
      if (val !== cache[name]) {
        cache[name] = val;
        this.handleSingle(name, val);
      }
    }
  },

  handleSingle: function handleSingle(prop, value) {
    prop = normalize(prop);
    if (!prop) return; // unsupported prop
    // cast possible numbers/booleans into strings
    if (value != null) value += '';
    if (value) {
      var isImportant = importantRE.test(value) ? 'important' : '';
      if (isImportant) {
        /* istanbul ignore if */
        if (process.env.NODE_ENV !== 'production') {
          warn('It\'s probably a bad idea to use !important with inline rules. ' + 'This feature will be deprecated in a future version of Vue.');
        }
        value = value.replace(importantRE, '').trim();
        this.el.style.setProperty(prop.kebab, value, isImportant);
      } else {
        this.el.style[prop.camel] = value;
      }
    } else {
      this.el.style[prop.camel] = '';
    }
  }

};

/**
 * Normalize a CSS property name.
 * - cache result
 * - auto prefix
 * - camelCase -> dash-case
 *
 * @param {String} prop
 * @return {String}
 */

function normalize(prop) {
  if (propCache[prop]) {
    return propCache[prop];
  }
  var res = prefix(prop);
  propCache[prop] = propCache[res] = res;
  return res;
}

/**
 * Auto detect the appropriate prefix for a CSS property.
 * https://gist.github.com/paulirish/523692
 *
 * @param {String} prop
 * @return {String}
 */

function prefix(prop) {
  prop = hyphenate(prop);
  var camel = camelize(prop);
  var upper = camel.charAt(0).toUpperCase() + camel.slice(1);
  if (!testEl) {
    testEl = document.createElement('div');
  }
  var i = prefixes.length;
  var prefixed;
  if (camel !== 'filter' && camel in testEl.style) {
    return {
      kebab: prop,
      camel: camel
    };
  }
  while (i--) {
    prefixed = camelPrefixes[i] + upper;
    if (prefixed in testEl.style) {
      return {
        kebab: prefixes[i] + prop,
        camel: prefixed
      };
    }
  }
}

// xlink
var xlinkNS = 'http://www.w3.org/1999/xlink';
var xlinkRE = /^xlink:/;

// check for attributes that prohibit interpolations
var disallowedInterpAttrRE = /^v-|^:|^@|^(?:is|transition|transition-mode|debounce|track-by|stagger|enter-stagger|leave-stagger)$/;
// these attributes should also set their corresponding properties
// because they only affect the initial state of the element
var attrWithPropsRE = /^(?:value|checked|selected|muted)$/;
// these attributes expect enumrated values of "true" or "false"
// but are not boolean attributes
var enumeratedAttrRE = /^(?:draggable|contenteditable|spellcheck)$/;

// these attributes should set a hidden property for
// binding v-model to object values
var modelProps = {
  value: '_value',
  'true-value': '_trueValue',
  'false-value': '_falseValue'
};

var bind$1 = {

  priority: BIND,

  bind: function bind() {
    var attr = this.arg;
    var tag = this.el.tagName;
    // should be deep watch on object mode
    if (!attr) {
      this.deep = true;
    }
    // handle interpolation bindings
    var descriptor = this.descriptor;
    var tokens = descriptor.interp;
    if (tokens) {
      // handle interpolations with one-time tokens
      if (descriptor.hasOneTime) {
        this.expression = tokensToExp(tokens, this._scope || this.vm);
      }

      // only allow binding on native attributes
      if (disallowedInterpAttrRE.test(attr) || attr === 'name' && (tag === 'PARTIAL' || tag === 'SLOT')) {
        process.env.NODE_ENV !== 'production' && warn(attr + '="' + descriptor.raw + '": ' + 'attribute interpolation is not allowed in Vue.js ' + 'directives and special attributes.', this.vm);
        this.el.removeAttribute(attr);
        this.invalid = true;
      }

      /* istanbul ignore if */
      if (process.env.NODE_ENV !== 'production') {
        var raw = attr + '="' + descriptor.raw + '": ';
        // warn src
        if (attr === 'src') {
          warn(raw + 'interpolation in "src" attribute will cause ' + 'a 404 request. Use v-bind:src instead.', this.vm);
        }

        // warn style
        if (attr === 'style') {
          warn(raw + 'interpolation in "style" attribute will cause ' + 'the attribute to be discarded in Internet Explorer. ' + 'Use v-bind:style instead.', this.vm);
        }
      }
    }
  },

  update: function update(value) {
    if (this.invalid) {
      return;
    }
    var attr = this.arg;
    if (this.arg) {
      this.handleSingle(attr, value);
    } else {
      this.handleObject(value || {});
    }
  },

  // share object handler with v-bind:class
  handleObject: style.handleObject,

  handleSingle: function handleSingle(attr, value) {
    var el = this.el;
    var interp = this.descriptor.interp;
    if (this.modifiers.camel) {
      attr = camelize(attr);
    }
    if (!interp && attrWithPropsRE.test(attr) && attr in el) {
      var attrValue = attr === 'value' ? value == null // IE9 will set input.value to "null" for null...
      ? '' : value : value;

      if (el[attr] !== attrValue) {
        el[attr] = attrValue;
      }
    }
    // set model props
    var modelProp = modelProps[attr];
    if (!interp && modelProp) {
      el[modelProp] = value;
      // update v-model if present
      var model = el.__v_model;
      if (model) {
        model.listener();
      }
    }
    // do not set value attribute for textarea
    if (attr === 'value' && el.tagName === 'TEXTAREA') {
      el.removeAttribute(attr);
      return;
    }
    // update attribute
    if (enumeratedAttrRE.test(attr)) {
      el.setAttribute(attr, value ? 'true' : 'false');
    } else if (value != null && value !== false) {
      if (attr === 'class') {
        // handle edge case #1960:
        // class interpolation should not overwrite Vue transition class
        if (el.__v_trans) {
          value += ' ' + el.__v_trans.id + '-transition';
        }
        setClass(el, value);
      } else if (xlinkRE.test(attr)) {
        el.setAttributeNS(xlinkNS, attr, value === true ? '' : value);
      } else {
        el.setAttribute(attr, value === true ? '' : value);
      }
    } else {
      el.removeAttribute(attr);
    }
  }
};

var el = {

  priority: EL,

  bind: function bind() {
    /* istanbul ignore if */
    if (!this.arg) {
      return;
    }
    var id = this.id = camelize(this.arg);
    var refs = (this._scope || this.vm).$els;
    if (hasOwn(refs, id)) {
      refs[id] = this.el;
    } else {
      defineReactive(refs, id, this.el);
    }
  },

  unbind: function unbind() {
    var refs = (this._scope || this.vm).$els;
    if (refs[this.id] === this.el) {
      refs[this.id] = null;
    }
  }
};

var ref = {
  bind: function bind() {
    process.env.NODE_ENV !== 'production' && warn('v-ref:' + this.arg + ' must be used on a child ' + 'component. Found on <' + this.el.tagName.toLowerCase() + '>.', this.vm);
  }
};

var cloak = {
  bind: function bind() {
    var el = this.el;
    this.vm.$once('pre-hook:compiled', function () {
      el.removeAttribute('v-cloak');
    });
  }
};

// logic control
// two-way binding
// event handling
// attributes
// ref & el
// cloak
// must export plain object
var directives = {
  text: text$1,
  html: html,
  'for': vFor,
  'if': vIf,
  show: show,
  model: model,
  on: on$1,
  bind: bind$1,
  el: el,
  ref: ref,
  cloak: cloak
};

var vClass = {

  deep: true,

  update: function update(value) {
    if (!value) {
      this.cleanup();
    } else if (typeof value === 'string') {
      this.setClass(value.trim().split(/\s+/));
    } else {
      this.setClass(normalize$1(value));
    }
  },

  setClass: function setClass(value) {
    this.cleanup(value);
    for (var i = 0, l = value.length; i < l; i++) {
      var val = value[i];
      if (val) {
        apply(this.el, val, addClass);
      }
    }
    this.prevKeys = value;
  },

  cleanup: function cleanup(value) {
    var prevKeys = this.prevKeys;
    if (!prevKeys) return;
    var i = prevKeys.length;
    while (i--) {
      var key = prevKeys[i];
      if (!value || value.indexOf(key) < 0) {
        apply(this.el, key, removeClass);
      }
    }
  }
};

/**
 * Normalize objects and arrays (potentially containing objects)
 * into array of strings.
 *
 * @param {Object|Array<String|Object>} value
 * @return {Array<String>}
 */

function normalize$1(value) {
  var res = [];
  if (isArray(value)) {
    for (var i = 0, l = value.length; i < l; i++) {
      var _key = value[i];
      if (_key) {
        if (typeof _key === 'string') {
          res.push(_key);
        } else {
          for (var k in _key) {
            if (_key[k]) res.push(k);
          }
        }
      }
    }
  } else if (isObject(value)) {
    for (var key in value) {
      if (value[key]) res.push(key);
    }
  }
  return res;
}

/**
 * Add or remove a class/classes on an element
 *
 * @param {Element} el
 * @param {String} key The class name. This may or may not
 *                     contain a space character, in such a
 *                     case we'll deal with multiple class
 *                     names at once.
 * @param {Function} fn
 */

function apply(el, key, fn) {
  key = key.trim();
  if (key.indexOf(' ') === -1) {
    fn(el, key);
    return;
  }
  // The key contains one or more space characters.
  // Since a class name doesn't accept such characters, we
  // treat it as multiple classes.
  var keys = key.split(/\s+/);
  for (var i = 0, l = keys.length; i < l; i++) {
    fn(el, keys[i]);
  }
}

var component = {

  priority: COMPONENT,

  params: ['keep-alive', 'transition-mode', 'inline-template'],

  /**
   * Setup. Two possible usages:
   *
   * - static:
   *   <comp> or <div v-component="comp">
   *
   * - dynamic:
   *   <component :is="view">
   */

  bind: function bind() {
    if (!this.el.__vue__) {
      // keep-alive cache
      this.keepAlive = this.params.keepAlive;
      if (this.keepAlive) {
        this.cache = {};
      }
      // check inline-template
      if (this.params.inlineTemplate) {
        // extract inline template as a DocumentFragment
        this.inlineTemplate = extractContent(this.el, true);
      }
      // component resolution related state
      this.pendingComponentCb = this.Component = null;
      // transition related state
      this.pendingRemovals = 0;
      this.pendingRemovalCb = null;
      // create a ref anchor
      this.anchor = createAnchor('v-component');
      replace(this.el, this.anchor);
      // remove is attribute.
      // this is removed during compilation, but because compilation is
      // cached, when the component is used elsewhere this attribute
      // will remain at link time.
      this.el.removeAttribute('is');
      this.el.removeAttribute(':is');
      // remove ref, same as above
      if (this.descriptor.ref) {
        this.el.removeAttribute('v-ref:' + hyphenate(this.descriptor.ref));
      }
      // if static, build right now.
      if (this.literal) {
        this.setComponent(this.expression);
      }
    } else {
      process.env.NODE_ENV !== 'production' && warn('cannot mount component "' + this.expression + '" ' + 'on already mounted element: ' + this.el);
    }
  },

  /**
   * Public update, called by the watcher in the dynamic
   * literal scenario, e.g. <component :is="view">
   */

  update: function update(value) {
    if (!this.literal) {
      this.setComponent(value);
    }
  },

  /**
   * Switch dynamic components. May resolve the component
   * asynchronously, and perform transition based on
   * specified transition mode. Accepts a few additional
   * arguments specifically for vue-router.
   *
   * The callback is called when the full transition is
   * finished.
   *
   * @param {String} value
   * @param {Function} [cb]
   */

  setComponent: function setComponent(value, cb) {
    this.invalidatePending();
    if (!value) {
      // just remove current
      this.unbuild(true);
      this.remove(this.childVM, cb);
      this.childVM = null;
    } else {
      var self = this;
      this.resolveComponent(value, function () {
        self.mountComponent(cb);
      });
    }
  },

  /**
   * Resolve the component constructor to use when creating
   * the child vm.
   *
   * @param {String|Function} value
   * @param {Function} cb
   */

  resolveComponent: function resolveComponent(value, cb) {
    var self = this;
    this.pendingComponentCb = cancellable(function (Component) {
      self.ComponentName = Component.options.name || (typeof value === 'string' ? value : null);
      self.Component = Component;
      cb();
    });
    this.vm._resolveComponent(value, this.pendingComponentCb);
  },

  /**
   * Create a new instance using the current constructor and
   * replace the existing instance. This method doesn't care
   * whether the new component and the old one are actually
   * the same.
   *
   * @param {Function} [cb]
   */

  mountComponent: function mountComponent(cb) {
    // actual mount
    this.unbuild(true);
    var self = this;
    var activateHooks = this.Component.options.activate;
    var cached = this.getCached();
    var newComponent = this.build();
    if (activateHooks && !cached) {
      this.waitingFor = newComponent;
      callActivateHooks(activateHooks, newComponent, function () {
        if (self.waitingFor !== newComponent) {
          return;
        }
        self.waitingFor = null;
        self.transition(newComponent, cb);
      });
    } else {
      // update ref for kept-alive component
      if (cached) {
        newComponent._updateRef();
      }
      this.transition(newComponent, cb);
    }
  },

  /**
   * When the component changes or unbinds before an async
   * constructor is resolved, we need to invalidate its
   * pending callback.
   */

  invalidatePending: function invalidatePending() {
    if (this.pendingComponentCb) {
      this.pendingComponentCb.cancel();
      this.pendingComponentCb = null;
    }
  },

  /**
   * Instantiate/insert a new child vm.
   * If keep alive and has cached instance, insert that
   * instance; otherwise build a new one and cache it.
   *
   * @param {Object} [extraOptions]
   * @return {Vue} - the created instance
   */

  build: function build(extraOptions) {
    var cached = this.getCached();
    if (cached) {
      return cached;
    }
    if (this.Component) {
      // default options
      var options = {
        name: this.ComponentName,
        el: cloneNode(this.el),
        template: this.inlineTemplate,
        // make sure to add the child with correct parent
        // if this is a transcluded component, its parent
        // should be the transclusion host.
        parent: this._host || this.vm,
        // if no inline-template, then the compiled
        // linker can be cached for better performance.
        _linkerCachable: !this.inlineTemplate,
        _ref: this.descriptor.ref,
        _asComponent: true,
        _isRouterView: this._isRouterView,
        // if this is a transcluded component, context
        // will be the common parent vm of this instance
        // and its host.
        _context: this.vm,
        // if this is inside an inline v-for, the scope
        // will be the intermediate scope created for this
        // repeat fragment. this is used for linking props
        // and container directives.
        _scope: this._scope,
        // pass in the owner fragment of this component.
        // this is necessary so that the fragment can keep
        // track of its contained components in order to
        // call attach/detach hooks for them.
        _frag: this._frag
      };
      // extra options
      // in 1.0.0 this is used by vue-router only
      /* istanbul ignore if */
      if (extraOptions) {
        extend(options, extraOptions);
      }
      var child = new this.Component(options);
      if (this.keepAlive) {
        this.cache[this.Component.cid] = child;
      }
      /* istanbul ignore if */
      if (process.env.NODE_ENV !== 'production' && this.el.hasAttribute('transition') && child._isFragment) {
        warn('Transitions will not work on a fragment instance. ' + 'Template: ' + child.$options.template, child);
      }
      return child;
    }
  },

  /**
   * Try to get a cached instance of the current component.
   *
   * @return {Vue|undefined}
   */

  getCached: function getCached() {
    return this.keepAlive && this.cache[this.Component.cid];
  },

  /**
   * Teardown the current child, but defers cleanup so
   * that we can separate the destroy and removal steps.
   *
   * @param {Boolean} defer
   */

  unbuild: function unbuild(defer) {
    if (this.waitingFor) {
      if (!this.keepAlive) {
        this.waitingFor.$destroy();
      }
      this.waitingFor = null;
    }
    var child = this.childVM;
    if (!child || this.keepAlive) {
      if (child) {
        // remove ref
        child._inactive = true;
        child._updateRef(true);
      }
      return;
    }
    // the sole purpose of `deferCleanup` is so that we can
    // "deactivate" the vm right now and perform DOM removal
    // later.
    child.$destroy(false, defer);
  },

  /**
   * Remove current destroyed child and manually do
   * the cleanup after removal.
   *
   * @param {Function} cb
   */

  remove: function remove(child, cb) {
    var keepAlive = this.keepAlive;
    if (child) {
      // we may have a component switch when a previous
      // component is still being transitioned out.
      // we want to trigger only one lastest insertion cb
      // when the existing transition finishes. (#1119)
      this.pendingRemovals++;
      this.pendingRemovalCb = cb;
      var self = this;
      child.$remove(function () {
        self.pendingRemovals--;
        if (!keepAlive) child._cleanup();
        if (!self.pendingRemovals && self.pendingRemovalCb) {
          self.pendingRemovalCb();
          self.pendingRemovalCb = null;
        }
      });
    } else if (cb) {
      cb();
    }
  },

  /**
   * Actually swap the components, depending on the
   * transition mode. Defaults to simultaneous.
   *
   * @param {Vue} target
   * @param {Function} [cb]
   */

  transition: function transition(target, cb) {
    var self = this;
    var current = this.childVM;
    // for devtool inspection
    if (current) current._inactive = true;
    target._inactive = false;
    this.childVM = target;
    switch (self.params.transitionMode) {
      case 'in-out':
        target.$before(self.anchor, function () {
          self.remove(current, cb);
        });
        break;
      case 'out-in':
        self.remove(current, function () {
          target.$before(self.anchor, cb);
        });
        break;
      default:
        self.remove(current);
        target.$before(self.anchor, cb);
    }
  },

  /**
   * Unbind.
   */

  unbind: function unbind() {
    this.invalidatePending();
    // Do not defer cleanup when unbinding
    this.unbuild();
    // destroy all keep-alive cached instances
    if (this.cache) {
      for (var key in this.cache) {
        this.cache[key].$destroy();
      }
      this.cache = null;
    }
  }
};

/**
 * Call activate hooks in order (asynchronous)
 *
 * @param {Array} hooks
 * @param {Vue} vm
 * @param {Function} cb
 */

function callActivateHooks(hooks, vm, cb) {
  var total = hooks.length;
  var called = 0;
  hooks[0].call(vm, next);
  function next() {
    if (++called >= total) {
      cb();
    } else {
      hooks[called].call(vm, next);
    }
  }
}

var propBindingModes = config._propBindingModes;
var empty = {};

// regexes
var identRE$1 = /^[$_a-zA-Z]+[\w$]*$/;
var settablePathRE = /^[A-Za-z_$][\w$]*(\.[A-Za-z_$][\w$]*|\[[^\[\]]+\])*$/;

/**
 * Compile props on a root element and return
 * a props link function.
 *
 * @param {Element|DocumentFragment} el
 * @param {Array} propOptions
 * @param {Vue} vm
 * @return {Function} propsLinkFn
 */

function compileProps(el, propOptions, vm) {
  var props = [];
  var propsData = vm.$options.propsData;
  var names = Object.keys(propOptions);
  var i = names.length;
  var options, name, attr, value, path, parsed, prop;
  while (i--) {
    name = names[i];
    options = propOptions[name] || empty;

    if (process.env.NODE_ENV !== 'production' && name === '$data') {
      warn('Do not use $data as prop.', vm);
      continue;
    }

    // props could contain dashes, which will be
    // interpreted as minus calculations by the parser
    // so we need to camelize the path here
    path = camelize(name);
    if (!identRE$1.test(path)) {
      process.env.NODE_ENV !== 'production' && warn('Invalid prop key: "' + name + '". Prop keys ' + 'must be valid identifiers.', vm);
      continue;
    }

    prop = {
      name: name,
      path: path,
      options: options,
      mode: propBindingModes.ONE_WAY,
      raw: null
    };

    attr = hyphenate(name);
    // first check dynamic version
    if ((value = getBindAttr(el, attr)) === null) {
      if ((value = getBindAttr(el, attr + '.sync')) !== null) {
        prop.mode = propBindingModes.TWO_WAY;
      } else if ((value = getBindAttr(el, attr + '.once')) !== null) {
        prop.mode = propBindingModes.ONE_TIME;
      }
    }
    if (value !== null) {
      // has dynamic binding!
      prop.raw = value;
      parsed = parseDirective(value);
      value = parsed.expression;
      prop.filters = parsed.filters;
      // check binding type
      if (isLiteral(value) && !parsed.filters) {
        // for expressions containing literal numbers and
        // booleans, there's no need to setup a prop binding,
        // so we can optimize them as a one-time set.
        prop.optimizedLiteral = true;
      } else {
        prop.dynamic = true;
        // check non-settable path for two-way bindings
        if (process.env.NODE_ENV !== 'production' && prop.mode === propBindingModes.TWO_WAY && !settablePathRE.test(value)) {
          prop.mode = propBindingModes.ONE_WAY;
          warn('Cannot bind two-way prop with non-settable ' + 'parent path: ' + value, vm);
        }
      }
      prop.parentPath = value;

      // warn required two-way
      if (process.env.NODE_ENV !== 'production' && options.twoWay && prop.mode !== propBindingModes.TWO_WAY) {
        warn('Prop "' + name + '" expects a two-way binding type.', vm);
      }
    } else if ((value = getAttr(el, attr)) !== null) {
      // has literal binding!
      prop.raw = value;
    } else if (propsData && (value = propsData[name] || propsData[path]) !== null) {
      // has propsData
      prop.raw = value;
    } else if (process.env.NODE_ENV !== 'production') {
      // check possible camelCase prop usage
      var lowerCaseName = path.toLowerCase();
      value = /[A-Z\-]/.test(name) && (el.getAttribute(lowerCaseName) || el.getAttribute(':' + lowerCaseName) || el.getAttribute('v-bind:' + lowerCaseName) || el.getAttribute(':' + lowerCaseName + '.once') || el.getAttribute('v-bind:' + lowerCaseName + '.once') || el.getAttribute(':' + lowerCaseName + '.sync') || el.getAttribute('v-bind:' + lowerCaseName + '.sync'));
      if (value) {
        warn('Possible usage error for prop `' + lowerCaseName + '` - ' + 'did you mean `' + attr + '`? HTML is case-insensitive, remember to use ' + 'kebab-case for props in templates.', vm);
      } else if (options.required && (!propsData || !(name in propsData) && !(path in propsData))) {
        // warn missing required
        warn('Missing required prop: ' + name, vm);
      }
    }
    // push prop
    props.push(prop);
  }
  return makePropsLinkFn(props);
}

/**
 * Build a function that applies props to a vm.
 *
 * @param {Array} props
 * @return {Function} propsLinkFn
 */

function makePropsLinkFn(props) {
  return function propsLinkFn(vm, scope) {
    // store resolved props info
    vm._props = {};
    var inlineProps = vm.$options.propsData;
    var i = props.length;
    var prop, path, options, value, raw;
    while (i--) {
      prop = props[i];
      raw = prop.raw;
      path = prop.path;
      options = prop.options;
      vm._props[path] = prop;
      if (inlineProps && hasOwn(inlineProps, path)) {
        initProp(vm, prop, inlineProps[path]);
      }if (raw === null) {
        // initialize absent prop
        initProp(vm, prop, undefined);
      } else if (prop.dynamic) {
        // dynamic prop
        if (prop.mode === propBindingModes.ONE_TIME) {
          // one time binding
          value = (scope || vm._context || vm).$get(prop.parentPath);
          initProp(vm, prop, value);
        } else {
          if (vm._context) {
            // dynamic binding
            vm._bindDir({
              name: 'prop',
              def: propDef,
              prop: prop
            }, null, null, scope); // el, host, scope
          } else {
              // root instance
              initProp(vm, prop, vm.$get(prop.parentPath));
            }
        }
      } else if (prop.optimizedLiteral) {
        // optimized literal, cast it and just set once
        var stripped = stripQuotes(raw);
        value = stripped === raw ? toBoolean(toNumber(raw)) : stripped;
        initProp(vm, prop, value);
      } else {
        // string literal, but we need to cater for
        // Boolean props with no value, or with same
        // literal value (e.g. disabled="disabled")
        // see https://github.com/vuejs/vue-loader/issues/182
        value = options.type === Boolean && (raw === '' || raw === hyphenate(prop.name)) ? true : raw;
        initProp(vm, prop, value);
      }
    }
  };
}

/**
 * Process a prop with a rawValue, applying necessary coersions,
 * default values & assertions and call the given callback with
 * processed value.
 *
 * @param {Vue} vm
 * @param {Object} prop
 * @param {*} rawValue
 * @param {Function} fn
 */

function processPropValue(vm, prop, rawValue, fn) {
  var isSimple = prop.dynamic && isSimplePath(prop.parentPath);
  var value = rawValue;
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop);
  }
  value = coerceProp(prop, value, vm);
  var coerced = value !== rawValue;
  if (!assertProp(prop, value, vm)) {
    value = undefined;
  }
  if (isSimple && !coerced) {
    withoutConversion(function () {
      fn(value);
    });
  } else {
    fn(value);
  }
}

/**
 * Set a prop's initial value on a vm and its data object.
 *
 * @param {Vue} vm
 * @param {Object} prop
 * @param {*} value
 */

function initProp(vm, prop, value) {
  processPropValue(vm, prop, value, function (value) {
    defineReactive(vm, prop.path, value);
  });
}

/**
 * Update a prop's value on a vm.
 *
 * @param {Vue} vm
 * @param {Object} prop
 * @param {*} value
 */

function updateProp(vm, prop, value) {
  processPropValue(vm, prop, value, function (value) {
    vm[prop.path] = value;
  });
}

/**
 * Get the default value of a prop.
 *
 * @param {Vue} vm
 * @param {Object} prop
 * @return {*}
 */

function getPropDefaultValue(vm, prop) {
  // no default, return undefined
  var options = prop.options;
  if (!hasOwn(options, 'default')) {
    // absent boolean value defaults to false
    return options.type === Boolean ? false : undefined;
  }
  var def = options['default'];
  // warn against non-factory defaults for Object & Array
  if (isObject(def)) {
    process.env.NODE_ENV !== 'production' && warn('Invalid default value for prop "' + prop.name + '": ' + 'Props with type Object/Array must use a factory function ' + 'to return the default value.', vm);
  }
  // call factory function for non-Function types
  return typeof def === 'function' && options.type !== Function ? def.call(vm) : def;
}

/**
 * Assert whether a prop is valid.
 *
 * @param {Object} prop
 * @param {*} value
 * @param {Vue} vm
 */

function assertProp(prop, value, vm) {
  if (!prop.options.required && ( // non-required
  prop.raw === null || // abscent
  value == null) // null or undefined
  ) {
      return true;
    }
  var options = prop.options;
  var type = options.type;
  var valid = !type;
  var expectedTypes = [];
  if (type) {
    if (!isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType);
      valid = assertedType.valid;
    }
  }
  if (!valid) {
    if (process.env.NODE_ENV !== 'production') {
      warn('Invalid prop: type check failed for prop "' + prop.name + '".' + ' Expected ' + expectedTypes.map(formatType).join(', ') + ', got ' + formatValue(value) + '.', vm);
    }
    return false;
  }
  var validator = options.validator;
  if (validator) {
    if (!validator(value)) {
      process.env.NODE_ENV !== 'production' && warn('Invalid prop: custom validator check failed for prop "' + prop.name + '".', vm);
      return false;
    }
  }
  return true;
}

/**
 * Force parsing value with coerce option.
 *
 * @param {*} value
 * @param {Object} options
 * @return {*}
 */

function coerceProp(prop, value, vm) {
  var coerce = prop.options.coerce;
  if (!coerce) {
    return value;
  }
  if (typeof coerce === 'function') {
    return coerce(value);
  } else {
    process.env.NODE_ENV !== 'production' && warn('Invalid coerce for prop "' + prop.name + '": expected function, got ' + typeof coerce + '.', vm);
    return value;
  }
}

/**
 * Assert the type of a value
 *
 * @param {*} value
 * @param {Function} type
 * @return {Object}
 */

function assertType(value, type) {
  var valid;
  var expectedType;
  if (type === String) {
    expectedType = 'string';
    valid = typeof value === expectedType;
  } else if (type === Number) {
    expectedType = 'number';
    valid = typeof value === expectedType;
  } else if (type === Boolean) {
    expectedType = 'boolean';
    valid = typeof value === expectedType;
  } else if (type === Function) {
    expectedType = 'function';
    valid = typeof value === expectedType;
  } else if (type === Object) {
    expectedType = 'object';
    valid = isPlainObject(value);
  } else if (type === Array) {
    expectedType = 'array';
    valid = isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  };
}

/**
 * Format type for output
 *
 * @param {String} type
 * @return {String}
 */

function formatType(type) {
  return type ? type.charAt(0).toUpperCase() + type.slice(1) : 'custom type';
}

/**
 * Format value
 *
 * @param {*} value
 * @return {String}
 */

function formatValue(val) {
  return Object.prototype.toString.call(val).slice(8, -1);
}

var bindingModes = config._propBindingModes;

var propDef = {

  bind: function bind() {
    var child = this.vm;
    var parent = child._context;
    // passed in from compiler directly
    var prop = this.descriptor.prop;
    var childKey = prop.path;
    var parentKey = prop.parentPath;
    var twoWay = prop.mode === bindingModes.TWO_WAY;

    var parentWatcher = this.parentWatcher = new Watcher(parent, parentKey, function (val) {
      updateProp(child, prop, val);
    }, {
      twoWay: twoWay,
      filters: prop.filters,
      // important: props need to be observed on the
      // v-for scope if present
      scope: this._scope
    });

    // set the child initial value.
    initProp(child, prop, parentWatcher.value);

    // setup two-way binding
    if (twoWay) {
      // important: defer the child watcher creation until
      // the created hook (after data observation)
      var self = this;
      child.$once('pre-hook:created', function () {
        self.childWatcher = new Watcher(child, childKey, function (val) {
          parentWatcher.set(val);
        }, {
          // ensure sync upward before parent sync down.
          // this is necessary in cases e.g. the child
          // mutates a prop array, then replaces it. (#1683)
          sync: true
        });
      });
    }
  },

  unbind: function unbind() {
    this.parentWatcher.teardown();
    if (this.childWatcher) {
      this.childWatcher.teardown();
    }
  }
};

var queue$1 = [];
var queued = false;

/**
 * Push a job into the queue.
 *
 * @param {Function} job
 */

function pushJob(job) {
  queue$1.push(job);
  if (!queued) {
    queued = true;
    nextTick(flush);
  }
}

/**
 * Flush the queue, and do one forced reflow before
 * triggering transitions.
 */

function flush() {
  // Force layout
  var f = document.documentElement.offsetHeight;
  for (var i = 0; i < queue$1.length; i++) {
    queue$1[i]();
  }
  queue$1 = [];
  queued = false;
  // dummy return, so js linters don't complain about
  // unused variable f
  return f;
}

var TYPE_TRANSITION = 'transition';
var TYPE_ANIMATION = 'animation';
var transDurationProp = transitionProp + 'Duration';
var animDurationProp = animationProp + 'Duration';

/**
 * If a just-entered element is applied the
 * leave class while its enter transition hasn't started yet,
 * and the transitioned property has the same value for both
 * enter/leave, then the leave transition will be skipped and
 * the transitionend event never fires. This function ensures
 * its callback to be called after a transition has started
 * by waiting for double raf.
 *
 * It falls back to setTimeout on devices that support CSS
 * transitions but not raf (e.g. Android 4.2 browser) - since
 * these environments are usually slow, we are giving it a
 * relatively large timeout.
 */

var raf = inBrowser && window.requestAnimationFrame;
var waitForTransitionStart = raf
/* istanbul ignore next */
? function (fn) {
  raf(function () {
    raf(fn);
  });
} : function (fn) {
  setTimeout(fn, 50);
};

/**
 * A Transition object that encapsulates the state and logic
 * of the transition.
 *
 * @param {Element} el
 * @param {String} id
 * @param {Object} hooks
 * @param {Vue} vm
 */
function Transition(el, id, hooks, vm) {
  this.id = id;
  this.el = el;
  this.enterClass = hooks && hooks.enterClass || id + '-enter';
  this.leaveClass = hooks && hooks.leaveClass || id + '-leave';
  this.hooks = hooks;
  this.vm = vm;
  // async state
  this.pendingCssEvent = this.pendingCssCb = this.cancel = this.pendingJsCb = this.op = this.cb = null;
  this.justEntered = false;
  this.entered = this.left = false;
  this.typeCache = {};
  // check css transition type
  this.type = hooks && hooks.type;
  /* istanbul ignore if */
  if (process.env.NODE_ENV !== 'production') {
    if (this.type && this.type !== TYPE_TRANSITION && this.type !== TYPE_ANIMATION) {
      warn('invalid CSS transition type for transition="' + this.id + '": ' + this.type, vm);
    }
  }
  // bind
  var self = this;['enterNextTick', 'enterDone', 'leaveNextTick', 'leaveDone'].forEach(function (m) {
    self[m] = bind(self[m], self);
  });
}

var p$1 = Transition.prototype;

/**
 * Start an entering transition.
 *
 * 1. enter transition triggered
 * 2. call beforeEnter hook
 * 3. add enter class
 * 4. insert/show element
 * 5. call enter hook (with possible explicit js callback)
 * 6. reflow
 * 7. based on transition type:
 *    - transition:
 *        remove class now, wait for transitionend,
 *        then done if there's no explicit js callback.
 *    - animation:
 *        wait for animationend, remove class,
 *        then done if there's no explicit js callback.
 *    - no css transition:
 *        done now if there's no explicit js callback.
 * 8. wait for either done or js callback, then call
 *    afterEnter hook.
 *
 * @param {Function} op - insert/show the element
 * @param {Function} [cb]
 */

p$1.enter = function (op, cb) {
  this.cancelPending();
  this.callHook('beforeEnter');
  this.cb = cb;
  addClass(this.el, this.enterClass);
  op();
  this.entered = false;
  this.callHookWithCb('enter');
  if (this.entered) {
    return; // user called done synchronously.
  }
  this.cancel = this.hooks && this.hooks.enterCancelled;
  pushJob(this.enterNextTick);
};

/**
 * The "nextTick" phase of an entering transition, which is
 * to be pushed into a queue and executed after a reflow so
 * that removing the class can trigger a CSS transition.
 */

p$1.enterNextTick = function () {
  var _this = this;

  // prevent transition skipping
  this.justEntered = true;
  waitForTransitionStart(function () {
    _this.justEntered = false;
  });
  var enterDone = this.enterDone;
  var type = this.getCssTransitionType(this.enterClass);
  if (!this.pendingJsCb) {
    if (type === TYPE_TRANSITION) {
      // trigger transition by removing enter class now
      removeClass(this.el, this.enterClass);
      this.setupCssCb(transitionEndEvent, enterDone);
    } else if (type === TYPE_ANIMATION) {
      this.setupCssCb(animationEndEvent, enterDone);
    } else {
      enterDone();
    }
  } else if (type === TYPE_TRANSITION) {
    removeClass(this.el, this.enterClass);
  }
};

/**
 * The "cleanup" phase of an entering transition.
 */

p$1.enterDone = function () {
  this.entered = true;
  this.cancel = this.pendingJsCb = null;
  removeClass(this.el, this.enterClass);
  this.callHook('afterEnter');
  if (this.cb) this.cb();
};

/**
 * Start a leaving transition.
 *
 * 1. leave transition triggered.
 * 2. call beforeLeave hook
 * 3. add leave class (trigger css transition)
 * 4. call leave hook (with possible explicit js callback)
 * 5. reflow if no explicit js callback is provided
 * 6. based on transition type:
 *    - transition or animation:
 *        wait for end event, remove class, then done if
 *        there's no explicit js callback.
 *    - no css transition:
 *        done if there's no explicit js callback.
 * 7. wait for either done or js callback, then call
 *    afterLeave hook.
 *
 * @param {Function} op - remove/hide the element
 * @param {Function} [cb]
 */

p$1.leave = function (op, cb) {
  this.cancelPending();
  this.callHook('beforeLeave');
  this.op = op;
  this.cb = cb;
  addClass(this.el, this.leaveClass);
  this.left = false;
  this.callHookWithCb('leave');
  if (this.left) {
    return; // user called done synchronously.
  }
  this.cancel = this.hooks && this.hooks.leaveCancelled;
  // only need to handle leaveDone if
  // 1. the transition is already done (synchronously called
  //    by the user, which causes this.op set to null)
  // 2. there's no explicit js callback
  if (this.op && !this.pendingJsCb) {
    // if a CSS transition leaves immediately after enter,
    // the transitionend event never fires. therefore we
    // detect such cases and end the leave immediately.
    if (this.justEntered) {
      this.leaveDone();
    } else {
      pushJob(this.leaveNextTick);
    }
  }
};

/**
 * The "nextTick" phase of a leaving transition.
 */

p$1.leaveNextTick = function () {
  var type = this.getCssTransitionType(this.leaveClass);
  if (type) {
    var event = type === TYPE_TRANSITION ? transitionEndEvent : animationEndEvent;
    this.setupCssCb(event, this.leaveDone);
  } else {
    this.leaveDone();
  }
};

/**
 * The "cleanup" phase of a leaving transition.
 */

p$1.leaveDone = function () {
  this.left = true;
  this.cancel = this.pendingJsCb = null;
  this.op();
  removeClass(this.el, this.leaveClass);
  this.callHook('afterLeave');
  if (this.cb) this.cb();
  this.op = null;
};

/**
 * Cancel any pending callbacks from a previously running
 * but not finished transition.
 */

p$1.cancelPending = function () {
  this.op = this.cb = null;
  var hasPending = false;
  if (this.pendingCssCb) {
    hasPending = true;
    off(this.el, this.pendingCssEvent, this.pendingCssCb);
    this.pendingCssEvent = this.pendingCssCb = null;
  }
  if (this.pendingJsCb) {
    hasPending = true;
    this.pendingJsCb.cancel();
    this.pendingJsCb = null;
  }
  if (hasPending) {
    removeClass(this.el, this.enterClass);
    removeClass(this.el, this.leaveClass);
  }
  if (this.cancel) {
    this.cancel.call(this.vm, this.el);
    this.cancel = null;
  }
};

/**
 * Call a user-provided synchronous hook function.
 *
 * @param {String} type
 */

p$1.callHook = function (type) {
  if (this.hooks && this.hooks[type]) {
    this.hooks[type].call(this.vm, this.el);
  }
};

/**
 * Call a user-provided, potentially-async hook function.
 * We check for the length of arguments to see if the hook
 * expects a `done` callback. If true, the transition's end
 * will be determined by when the user calls that callback;
 * otherwise, the end is determined by the CSS transition or
 * animation.
 *
 * @param {String} type
 */

p$1.callHookWithCb = function (type) {
  var hook = this.hooks && this.hooks[type];
  if (hook) {
    if (hook.length > 1) {
      this.pendingJsCb = cancellable(this[type + 'Done']);
    }
    hook.call(this.vm, this.el, this.pendingJsCb);
  }
};

/**
 * Get an element's transition type based on the
 * calculated styles.
 *
 * @param {String} className
 * @return {Number}
 */

p$1.getCssTransitionType = function (className) {
  /* istanbul ignore if */
  if (!transitionEndEvent ||
  // skip CSS transitions if page is not visible -
  // this solves the issue of transitionend events not
  // firing until the page is visible again.
  // pageVisibility API is supported in IE10+, same as
  // CSS transitions.
  document.hidden ||
  // explicit js-only transition
  this.hooks && this.hooks.css === false ||
  // element is hidden
  isHidden(this.el)) {
    return;
  }
  var type = this.type || this.typeCache[className];
  if (type) return type;
  var inlineStyles = this.el.style;
  var computedStyles = window.getComputedStyle(this.el);
  var transDuration = inlineStyles[transDurationProp] || computedStyles[transDurationProp];
  if (transDuration && transDuration !== '0s') {
    type = TYPE_TRANSITION;
  } else {
    var animDuration = inlineStyles[animDurationProp] || computedStyles[animDurationProp];
    if (animDuration && animDuration !== '0s') {
      type = TYPE_ANIMATION;
    }
  }
  if (type) {
    this.typeCache[className] = type;
  }
  return type;
};

/**
 * Setup a CSS transitionend/animationend callback.
 *
 * @param {String} event
 * @param {Function} cb
 */

p$1.setupCssCb = function (event, cb) {
  this.pendingCssEvent = event;
  var self = this;
  var el = this.el;
  var onEnd = this.pendingCssCb = function (e) {
    if (e.target === el) {
      off(el, event, onEnd);
      self.pendingCssEvent = self.pendingCssCb = null;
      if (!self.pendingJsCb && cb) {
        cb();
      }
    }
  };
  on(el, event, onEnd);
};

/**
 * Check if an element is hidden - in that case we can just
 * skip the transition alltogether.
 *
 * @param {Element} el
 * @return {Boolean}
 */

function isHidden(el) {
  if (/svg$/.test(el.namespaceURI)) {
    // SVG elements do not have offset(Width|Height)
    // so we need to check the client rect
    var rect = el.getBoundingClientRect();
    return !(rect.width || rect.height);
  } else {
    return !(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
  }
}

var transition$1 = {

  priority: TRANSITION,

  update: function update(id, oldId) {
    var el = this.el;
    // resolve on owner vm
    var hooks = resolveAsset(this.vm.$options, 'transitions', id);
    id = id || 'v';
    oldId = oldId || 'v';
    el.__v_trans = new Transition(el, id, hooks, this.vm);
    removeClass(el, oldId + '-transition');
    addClass(el, id + '-transition');
  }
};

var internalDirectives = {
  style: style,
  'class': vClass,
  component: component,
  prop: propDef,
  transition: transition$1
};

// special binding prefixes
var bindRE = /^v-bind:|^:/;
var onRE = /^v-on:|^@/;
var dirAttrRE = /^v-([^:]+)(?:$|:(.*)$)/;
var modifierRE = /\.[^\.]+/g;
var transitionRE = /^(v-bind:|:)?transition$/;

// default directive priority
var DEFAULT_PRIORITY = 1000;
var DEFAULT_TERMINAL_PRIORITY = 2000;

/**
 * Compile a template and return a reusable composite link
 * function, which recursively contains more link functions
 * inside. This top level compile function would normally
 * be called on instance root nodes, but can also be used
 * for partial compilation if the partial argument is true.
 *
 * The returned composite link function, when called, will
 * return an unlink function that tearsdown all directives
 * created during the linking phase.
 *
 * @param {Element|DocumentFragment} el
 * @param {Object} options
 * @param {Boolean} partial
 * @return {Function}
 */

function compile(el, options, partial) {
  // link function for the node itself.
  var nodeLinkFn = partial || !options._asComponent ? compileNode(el, options) : null;
  // link function for the childNodes
  var childLinkFn = !(nodeLinkFn && nodeLinkFn.terminal) && !isScript(el) && el.hasChildNodes() ? compileNodeList(el.childNodes, options) : null;

  /**
   * A composite linker function to be called on a already
   * compiled piece of DOM, which instantiates all directive
   * instances.
   *
   * @param {Vue} vm
   * @param {Element|DocumentFragment} el
   * @param {Vue} [host] - host vm of transcluded content
   * @param {Object} [scope] - v-for scope
   * @param {Fragment} [frag] - link context fragment
   * @return {Function|undefined}
   */

  return function compositeLinkFn(vm, el, host, scope, frag) {
    // cache childNodes before linking parent, fix #657
    var childNodes = toArray(el.childNodes);
    // link
    var dirs = linkAndCapture(function compositeLinkCapturer() {
      if (nodeLinkFn) nodeLinkFn(vm, el, host, scope, frag);
      if (childLinkFn) childLinkFn(vm, childNodes, host, scope, frag);
    }, vm);
    return makeUnlinkFn(vm, dirs);
  };
}

/**
 * Apply a linker to a vm/element pair and capture the
 * directives created during the process.
 *
 * @param {Function} linker
 * @param {Vue} vm
 */

function linkAndCapture(linker, vm) {
  /* istanbul ignore if */
  if (process.env.NODE_ENV === 'production') {
    // reset directives before every capture in production
    // mode, so that when unlinking we don't need to splice
    // them out (which turns out to be a perf hit).
    // they are kept in development mode because they are
    // useful for Vue's own tests.
    vm._directives = [];
  }
  var originalDirCount = vm._directives.length;
  linker();
  var dirs = vm._directives.slice(originalDirCount);
  sortDirectives(dirs);
  for (var i = 0, l = dirs.length; i < l; i++) {
    dirs[i]._bind();
  }
  return dirs;
}

/**
 * sort directives by priority (stable sort)
 *
 * @param {Array} dirs
 */
function sortDirectives(dirs) {
  if (dirs.length === 0) return;

  var groupedMap = {};
  var i, j, k, l;
  var index = 0;
  var priorities = [];
  for (i = 0, j = dirs.length; i < j; i++) {
    var dir = dirs[i];
    var priority = dir.descriptor.def.priority || DEFAULT_PRIORITY;
    var array = groupedMap[priority];
    if (!array) {
      array = groupedMap[priority] = [];
      priorities.push(priority);
    }
    array.push(dir);
  }

  priorities.sort(function (a, b) {
    return a > b ? -1 : a === b ? 0 : 1;
  });
  for (i = 0, j = priorities.length; i < j; i++) {
    var group = groupedMap[priorities[i]];
    for (k = 0, l = group.length; k < l; k++) {
      dirs[index++] = group[k];
    }
  }
}

/**
 * Linker functions return an unlink function that
 * tearsdown all directives instances generated during
 * the process.
 *
 * We create unlink functions with only the necessary
 * information to avoid retaining additional closures.
 *
 * @param {Vue} vm
 * @param {Array} dirs
 * @param {Vue} [context]
 * @param {Array} [contextDirs]
 * @return {Function}
 */

function makeUnlinkFn(vm, dirs, context, contextDirs) {
  function unlink(destroying) {
    teardownDirs(vm, dirs, destroying);
    if (context && contextDirs) {
      teardownDirs(context, contextDirs);
    }
  }
  // expose linked directives
  unlink.dirs = dirs;
  return unlink;
}

/**
 * Teardown partial linked directives.
 *
 * @param {Vue} vm
 * @param {Array} dirs
 * @param {Boolean} destroying
 */

function teardownDirs(vm, dirs, destroying) {
  var i = dirs.length;
  while (i--) {
    dirs[i]._teardown();
    if (process.env.NODE_ENV !== 'production' && !destroying) {
      vm._directives.$remove(dirs[i]);
    }
  }
}

/**
 * Compile link props on an instance.
 *
 * @param {Vue} vm
 * @param {Element} el
 * @param {Object} props
 * @param {Object} [scope]
 * @return {Function}
 */

function compileAndLinkProps(vm, el, props, scope) {
  var propsLinkFn = compileProps(el, props, vm);
  var propDirs = linkAndCapture(function () {
    propsLinkFn(vm, scope);
  }, vm);
  return makeUnlinkFn(vm, propDirs);
}

/**
 * Compile the root element of an instance.
 *
 * 1. attrs on context container (context scope)
 * 2. attrs on the component template root node, if
 *    replace:true (child scope)
 *
 * If this is a fragment instance, we only need to compile 1.
 *
 * @param {Element} el
 * @param {Object} options
 * @param {Object} contextOptions
 * @return {Function}
 */

function compileRoot(el, options, contextOptions) {
  var containerAttrs = options._containerAttrs;
  var replacerAttrs = options._replacerAttrs;
  var contextLinkFn, replacerLinkFn;

  // only need to compile other attributes for
  // non-fragment instances
  if (el.nodeType !== 11) {
    // for components, container and replacer need to be
    // compiled separately and linked in different scopes.
    if (options._asComponent) {
      // 2. container attributes
      if (containerAttrs && contextOptions) {
        contextLinkFn = compileDirectives(containerAttrs, contextOptions);
      }
      if (replacerAttrs) {
        // 3. replacer attributes
        replacerLinkFn = compileDirectives(replacerAttrs, options);
      }
    } else {
      // non-component, just compile as a normal element.
      replacerLinkFn = compileDirectives(el.attributes, options);
    }
  } else if (process.env.NODE_ENV !== 'production' && containerAttrs) {
    // warn container directives for fragment instances
    var names = containerAttrs.filter(function (attr) {
      // allow vue-loader/vueify scoped css attributes
      return attr.name.indexOf('_v-') < 0 &&
      // allow event listeners
      !onRE.test(attr.name) &&
      // allow slots
      attr.name !== 'slot';
    }).map(function (attr) {
      return '"' + attr.name + '"';
    });
    if (names.length) {
      var plural = names.length > 1;

      var componentName = options.el.tagName.toLowerCase();
      if (componentName === 'component' && options.name) {
        componentName += ':' + options.name;
      }

      warn('Attribute' + (plural ? 's ' : ' ') + names.join(', ') + (plural ? ' are' : ' is') + ' ignored on component ' + '<' + componentName + '> because ' + 'the component is a fragment instance: ' + 'http://vuejs.org/guide/components.html#Fragment-Instance');
    }
  }

  options._containerAttrs = options._replacerAttrs = null;
  return function rootLinkFn(vm, el, scope) {
    // link context scope dirs
    var context = vm._context;
    var contextDirs;
    if (context && contextLinkFn) {
      contextDirs = linkAndCapture(function () {
        contextLinkFn(context, el, null, scope);
      }, context);
    }

    // link self
    var selfDirs = linkAndCapture(function () {
      if (replacerLinkFn) replacerLinkFn(vm, el);
    }, vm);

    // return the unlink function that tearsdown context
    // container directives.
    return makeUnlinkFn(vm, selfDirs, context, contextDirs);
  };
}

/**
 * Compile a node and return a nodeLinkFn based on the
 * node type.
 *
 * @param {Node} node
 * @param {Object} options
 * @return {Function|null}
 */

function compileNode(node, options) {
  var type = node.nodeType;
  if (type === 1 && !isScript(node)) {
    return compileElement(node, options);
  } else if (type === 3 && node.data.trim()) {
    return compileTextNode(node, options);
  } else {
    return null;
  }
}

/**
 * Compile an element and return a nodeLinkFn.
 *
 * @param {Element} el
 * @param {Object} options
 * @return {Function|null}
 */

function compileElement(el, options) {
  // preprocess textareas.
  // textarea treats its text content as the initial value.
  // just bind it as an attr directive for value.
  if (el.tagName === 'TEXTAREA') {
    // a textarea which has v-pre attr should skip complie.
    if (getAttr(el, 'v-pre') !== null) {
      return skip;
    }
    var tokens = parseText(el.value);
    if (tokens) {
      el.setAttribute(':value', tokensToExp(tokens));
      el.value = '';
    }
  }
  var linkFn;
  var hasAttrs = el.hasAttributes();
  var attrs = hasAttrs && toArray(el.attributes);
  // check terminal directives (for & if)
  if (hasAttrs) {
    linkFn = checkTerminalDirectives(el, attrs, options);
  }
  // check element directives
  if (!linkFn) {
    linkFn = checkElementDirectives(el, options);
  }
  // check component
  if (!linkFn) {
    linkFn = checkComponent(el, options);
  }
  // normal directives
  if (!linkFn && hasAttrs) {
    linkFn = compileDirectives(attrs, options);
  }
  return linkFn;
}

/**
 * Compile a textNode and return a nodeLinkFn.
 *
 * @param {TextNode} node
 * @param {Object} options
 * @return {Function|null} textNodeLinkFn
 */

function compileTextNode(node, options) {
  // skip marked text nodes
  if (node._skip) {
    return removeText;
  }

  var tokens = parseText(node.wholeText);
  if (!tokens) {
    return null;
  }

  // mark adjacent text nodes as skipped,
  // because we are using node.wholeText to compile
  // all adjacent text nodes together. This fixes
  // issues in IE where sometimes it splits up a single
  // text node into multiple ones.
  var next = node.nextSibling;
  while (next && next.nodeType === 3) {
    next._skip = true;
    next = next.nextSibling;
  }

  var frag = document.createDocumentFragment();
  var el, token;
  for (var i = 0, l = tokens.length; i < l; i++) {
    token = tokens[i];
    el = token.tag ? processTextToken(token, options) : document.createTextNode(token.value);
    frag.appendChild(el);
  }
  return makeTextNodeLinkFn(tokens, frag, options);
}

/**
 * Linker for an skipped text node.
 *
 * @param {Vue} vm
 * @param {Text} node
 */

function removeText(vm, node) {
  remove(node);
}

/**
 * Process a single text token.
 *
 * @param {Object} token
 * @param {Object} options
 * @return {Node}
 */

function processTextToken(token, options) {
  var el;
  if (token.oneTime) {
    el = document.createTextNode(token.value);
  } else {
    if (token.html) {
      el = document.createComment('v-html');
      setTokenType('html');
    } else {
      // IE will clean up empty textNodes during
      // frag.cloneNode(true), so we have to give it
      // something here...
      el = document.createTextNode(' ');
      setTokenType('text');
    }
  }
  function setTokenType(type) {
    if (token.descriptor) return;
    var parsed = parseDirective(token.value);
    token.descriptor = {
      name: type,
      def: directives[type],
      expression: parsed.expression,
      filters: parsed.filters
    };
  }
  return el;
}

/**
 * Build a function that processes a textNode.
 *
 * @param {Array<Object>} tokens
 * @param {DocumentFragment} frag
 */

function makeTextNodeLinkFn(tokens, frag) {
  return function textNodeLinkFn(vm, el, host, scope) {
    var fragClone = frag.cloneNode(true);
    var childNodes = toArray(fragClone.childNodes);
    var token, value, node;
    for (var i = 0, l = tokens.length; i < l; i++) {
      token = tokens[i];
      value = token.value;
      if (token.tag) {
        node = childNodes[i];
        if (token.oneTime) {
          value = (scope || vm).$eval(value);
          if (token.html) {
            replace(node, parseTemplate(value, true));
          } else {
            node.data = _toString(value);
          }
        } else {
          vm._bindDir(token.descriptor, node, host, scope);
        }
      }
    }
    replace(el, fragClone);
  };
}

/**
 * Compile a node list and return a childLinkFn.
 *
 * @param {NodeList} nodeList
 * @param {Object} options
 * @return {Function|undefined}
 */

function compileNodeList(nodeList, options) {
  var linkFns = [];
  var nodeLinkFn, childLinkFn, node;
  for (var i = 0, l = nodeList.length; i < l; i++) {
    node = nodeList[i];
    nodeLinkFn = compileNode(node, options);
    childLinkFn = !(nodeLinkFn && nodeLinkFn.terminal) && node.tagName !== 'SCRIPT' && node.hasChildNodes() ? compileNodeList(node.childNodes, options) : null;
    linkFns.push(nodeLinkFn, childLinkFn);
  }
  return linkFns.length ? makeChildLinkFn(linkFns) : null;
}

/**
 * Make a child link function for a node's childNodes.
 *
 * @param {Array<Function>} linkFns
 * @return {Function} childLinkFn
 */

function makeChildLinkFn(linkFns) {
  return function childLinkFn(vm, nodes, host, scope, frag) {
    var node, nodeLinkFn, childrenLinkFn;
    for (var i = 0, n = 0, l = linkFns.length; i < l; n++) {
      node = nodes[n];
      nodeLinkFn = linkFns[i++];
      childrenLinkFn = linkFns[i++];
      // cache childNodes before linking parent, fix #657
      var childNodes = toArray(node.childNodes);
      if (nodeLinkFn) {
        nodeLinkFn(vm, node, host, scope, frag);
      }
      if (childrenLinkFn) {
        childrenLinkFn(vm, childNodes, host, scope, frag);
      }
    }
  };
}

/**
 * Check for element directives (custom elements that should
 * be resovled as terminal directives).
 *
 * @param {Element} el
 * @param {Object} options
 */

function checkElementDirectives(el, options) {
  var tag = el.tagName.toLowerCase();
  if (commonTagRE.test(tag)) {
    return;
  }
  var def = resolveAsset(options, 'elementDirectives', tag);
  if (def) {
    return makeTerminalNodeLinkFn(el, tag, '', options, def);
  }
}

/**
 * Check if an element is a component. If yes, return
 * a component link function.
 *
 * @param {Element} el
 * @param {Object} options
 * @return {Function|undefined}
 */

function checkComponent(el, options) {
  var component = checkComponentAttr(el, options);
  if (component) {
    var ref = findRef(el);
    var descriptor = {
      name: 'component',
      ref: ref,
      expression: component.id,
      def: internalDirectives.component,
      modifiers: {
        literal: !component.dynamic
      }
    };
    var componentLinkFn = function componentLinkFn(vm, el, host, scope, frag) {
      if (ref) {
        defineReactive((scope || vm).$refs, ref, null);
      }
      vm._bindDir(descriptor, el, host, scope, frag);
    };
    componentLinkFn.terminal = true;
    return componentLinkFn;
  }
}

/**
 * Check an element for terminal directives in fixed order.
 * If it finds one, return a terminal link function.
 *
 * @param {Element} el
 * @param {Array} attrs
 * @param {Object} options
 * @return {Function} terminalLinkFn
 */

function checkTerminalDirectives(el, attrs, options) {
  // skip v-pre
  if (getAttr(el, 'v-pre') !== null) {
    return skip;
  }
  // skip v-else block, but only if following v-if
  if (el.hasAttribute('v-else')) {
    var prev = el.previousElementSibling;
    if (prev && prev.hasAttribute('v-if')) {
      return skip;
    }
  }

  var attr, name, value, modifiers, matched, dirName, rawName, arg, def, termDef;
  for (var i = 0, j = attrs.length; i < j; i++) {
    attr = attrs[i];
    name = attr.name.replace(modifierRE, '');
    if (matched = name.match(dirAttrRE)) {
      def = resolveAsset(options, 'directives', matched[1]);
      if (def && def.terminal) {
        if (!termDef || (def.priority || DEFAULT_TERMINAL_PRIORITY) > termDef.priority) {
          termDef = def;
          rawName = attr.name;
          modifiers = parseModifiers(attr.name);
          value = attr.value;
          dirName = matched[1];
          arg = matched[2];
        }
      }
    }
  }

  if (termDef) {
    return makeTerminalNodeLinkFn(el, dirName, value, options, termDef, rawName, arg, modifiers);
  }
}

function skip() {}
skip.terminal = true;

/**
 * Build a node link function for a terminal directive.
 * A terminal link function terminates the current
 * compilation recursion and handles compilation of the
 * subtree in the directive.
 *
 * @param {Element} el
 * @param {String} dirName
 * @param {String} value
 * @param {Object} options
 * @param {Object} def
 * @param {String} [rawName]
 * @param {String} [arg]
 * @param {Object} [modifiers]
 * @return {Function} terminalLinkFn
 */

function makeTerminalNodeLinkFn(el, dirName, value, options, def, rawName, arg, modifiers) {
  var parsed = parseDirective(value);
  var descriptor = {
    name: dirName,
    arg: arg,
    expression: parsed.expression,
    filters: parsed.filters,
    raw: value,
    attr: rawName,
    modifiers: modifiers,
    def: def
  };
  // check ref for v-for, v-if and router-view
  if (dirName === 'for' || dirName === 'router-view') {
    descriptor.ref = findRef(el);
  }
  var fn = function terminalNodeLinkFn(vm, el, host, scope, frag) {
    if (descriptor.ref) {
      defineReactive((scope || vm).$refs, descriptor.ref, null);
    }
    vm._bindDir(descriptor, el, host, scope, frag);
  };
  fn.terminal = true;
  return fn;
}

/**
 * Compile the directives on an element and return a linker.
 *
 * @param {Array|NamedNodeMap} attrs
 * @param {Object} options
 * @return {Function}
 */

function compileDirectives(attrs, options) {
  var i = attrs.length;
  var dirs = [];
  var attr, name, value, rawName, rawValue, dirName, arg, modifiers, dirDef, tokens, matched;
  while (i--) {
    attr = attrs[i];
    name = rawName = attr.name;
    value = rawValue = attr.value;
    tokens = parseText(value);
    // reset arg
    arg = null;
    // check modifiers
    modifiers = parseModifiers(name);
    name = name.replace(modifierRE, '');

    // attribute interpolations
    if (tokens) {
      value = tokensToExp(tokens);
      arg = name;
      pushDir('bind', directives.bind, tokens);
      // warn against mixing mustaches with v-bind
      if (process.env.NODE_ENV !== 'production') {
        if (name === 'class' && Array.prototype.some.call(attrs, function (attr) {
          return attr.name === ':class' || attr.name === 'v-bind:class';
        })) {
          warn('class="' + rawValue + '": Do not mix mustache interpolation ' + 'and v-bind for "class" on the same element. Use one or the other.', options);
        }
      }
    } else

      // special attribute: transition
      if (transitionRE.test(name)) {
        modifiers.literal = !bindRE.test(name);
        pushDir('transition', internalDirectives.transition);
      } else

        // event handlers
        if (onRE.test(name)) {
          arg = name.replace(onRE, '');
          pushDir('on', directives.on);
        } else

          // attribute bindings
          if (bindRE.test(name)) {
            dirName = name.replace(bindRE, '');
            if (dirName === 'style' || dirName === 'class') {
              pushDir(dirName, internalDirectives[dirName]);
            } else {
              arg = dirName;
              pushDir('bind', directives.bind);
            }
          } else

            // normal directives
            if (matched = name.match(dirAttrRE)) {
              dirName = matched[1];
              arg = matched[2];

              // skip v-else (when used with v-show)
              if (dirName === 'else') {
                continue;
              }

              dirDef = resolveAsset(options, 'directives', dirName, true);
              if (dirDef) {
                pushDir(dirName, dirDef);
              }
            }
  }

  /**
   * Push a directive.
   *
   * @param {String} dirName
   * @param {Object|Function} def
   * @param {Array} [interpTokens]
   */

  function pushDir(dirName, def, interpTokens) {
    var hasOneTimeToken = interpTokens && hasOneTime(interpTokens);
    var parsed = !hasOneTimeToken && parseDirective(value);
    dirs.push({
      name: dirName,
      attr: rawName,
      raw: rawValue,
      def: def,
      arg: arg,
      modifiers: modifiers,
      // conversion from interpolation strings with one-time token
      // to expression is differed until directive bind time so that we
      // have access to the actual vm context for one-time bindings.
      expression: parsed && parsed.expression,
      filters: parsed && parsed.filters,
      interp: interpTokens,
      hasOneTime: hasOneTimeToken
    });
  }

  if (dirs.length) {
    return makeNodeLinkFn(dirs);
  }
}

/**
 * Parse modifiers from directive attribute name.
 *
 * @param {String} name
 * @return {Object}
 */

function parseModifiers(name) {
  var res = Object.create(null);
  var match = name.match(modifierRE);
  if (match) {
    var i = match.length;
    while (i--) {
      res[match[i].slice(1)] = true;
    }
  }
  return res;
}

/**
 * Build a link function for all directives on a single node.
 *
 * @param {Array} directives
 * @return {Function} directivesLinkFn
 */

function makeNodeLinkFn(directives) {
  return function nodeLinkFn(vm, el, host, scope, frag) {
    // reverse apply because it's sorted low to high
    var i = directives.length;
    while (i--) {
      vm._bindDir(directives[i], el, host, scope, frag);
    }
  };
}

/**
 * Check if an interpolation string contains one-time tokens.
 *
 * @param {Array} tokens
 * @return {Boolean}
 */

function hasOneTime(tokens) {
  var i = tokens.length;
  while (i--) {
    if (tokens[i].oneTime) return true;
  }
}

function isScript(el) {
  return el.tagName === 'SCRIPT' && (!el.hasAttribute('type') || el.getAttribute('type') === 'text/javascript');
}

var specialCharRE = /[^\w\-:\.]/;

/**
 * Process an element or a DocumentFragment based on a
 * instance option object. This allows us to transclude
 * a template node/fragment before the instance is created,
 * so the processed fragment can then be cloned and reused
 * in v-for.
 *
 * @param {Element} el
 * @param {Object} options
 * @return {Element|DocumentFragment}
 */

function transclude(el, options) {
  // extract container attributes to pass them down
  // to compiler, because they need to be compiled in
  // parent scope. we are mutating the options object here
  // assuming the same object will be used for compile
  // right after this.
  if (options) {
    options._containerAttrs = extractAttrs(el);
  }
  // for template tags, what we want is its content as
  // a documentFragment (for fragment instances)
  if (isTemplate(el)) {
    el = parseTemplate(el);
  }
  if (options) {
    if (options._asComponent && !options.template) {
      options.template = '<slot></slot>';
    }
    if (options.template) {
      options._content = extractContent(el);
      el = transcludeTemplate(el, options);
    }
  }
  if (isFragment(el)) {
    // anchors for fragment instance
    // passing in `persist: true` to avoid them being
    // discarded by IE during template cloning
    prepend(createAnchor('v-start', true), el);
    el.appendChild(createAnchor('v-end', true));
  }
  return el;
}

/**
 * Process the template option.
 * If the replace option is true this will swap the $el.
 *
 * @param {Element} el
 * @param {Object} options
 * @return {Element|DocumentFragment}
 */

function transcludeTemplate(el, options) {
  var template = options.template;
  var frag = parseTemplate(template, true);
  if (frag) {
    var replacer = frag.firstChild;
    if (!replacer) {
      return frag;
    }
    var tag = replacer.tagName && replacer.tagName.toLowerCase();
    if (options.replace) {
      /* istanbul ignore if */
      if (el === document.body) {
        process.env.NODE_ENV !== 'production' && warn('You are mounting an instance with a template to ' + '<body>. This will replace <body> entirely. You ' + 'should probably use `replace: false` here.');
      }
      // there are many cases where the instance must
      // become a fragment instance: basically anything that
      // can create more than 1 root nodes.
      if (
      // multi-children template
      frag.childNodes.length > 1 ||
      // non-element template
      replacer.nodeType !== 1 ||
      // single nested component
      tag === 'component' || resolveAsset(options, 'components', tag) || hasBindAttr(replacer, 'is') ||
      // element directive
      resolveAsset(options, 'elementDirectives', tag) ||
      // for block
      replacer.hasAttribute('v-for') ||
      // if block
      replacer.hasAttribute('v-if')) {
        return frag;
      } else {
        options._replacerAttrs = extractAttrs(replacer);
        mergeAttrs(el, replacer);
        return replacer;
      }
    } else {
      el.appendChild(frag);
      return el;
    }
  } else {
    process.env.NODE_ENV !== 'production' && warn('Invalid template option: ' + template);
  }
}

/**
 * Helper to extract a component container's attributes
 * into a plain object array.
 *
 * @param {Element} el
 * @return {Array}
 */

function extractAttrs(el) {
  if (el.nodeType === 1 && el.hasAttributes()) {
    return toArray(el.attributes);
  }
}

/**
 * Merge the attributes of two elements, and make sure
 * the class names are merged properly.
 *
 * @param {Element} from
 * @param {Element} to
 */

function mergeAttrs(from, to) {
  var attrs = from.attributes;
  var i = attrs.length;
  var name, value;
  while (i--) {
    name = attrs[i].name;
    value = attrs[i].value;
    if (!to.hasAttribute(name) && !specialCharRE.test(name)) {
      to.setAttribute(name, value);
    } else if (name === 'class' && !parseText(value) && (value = value.trim())) {
      value.split(/\s+/).forEach(function (cls) {
        addClass(to, cls);
      });
    }
  }
}

/**
 * Scan and determine slot content distribution.
 * We do this during transclusion instead at compile time so that
 * the distribution is decoupled from the compilation order of
 * the slots.
 *
 * @param {Element|DocumentFragment} template
 * @param {Element} content
 * @param {Vue} vm
 */

function resolveSlots(vm, content) {
  if (!content) {
    return;
  }
  var contents = vm._slotContents = Object.create(null);
  var el, name;
  for (var i = 0, l = content.children.length; i < l; i++) {
    el = content.children[i];
    /* eslint-disable no-cond-assign */
    if (name = el.getAttribute('slot')) {
      (contents[name] || (contents[name] = [])).push(el);
    }
    /* eslint-enable no-cond-assign */
    if (process.env.NODE_ENV !== 'production' && getBindAttr(el, 'slot')) {
      warn('The "slot" attribute must be static.', vm.$parent);
    }
  }
  for (name in contents) {
    contents[name] = extractFragment(contents[name], content);
  }
  if (content.hasChildNodes()) {
    var nodes = content.childNodes;
    if (nodes.length === 1 && nodes[0].nodeType === 3 && !nodes[0].data.trim()) {
      return;
    }
    contents['default'] = extractFragment(content.childNodes, content);
  }
}

/**
 * Extract qualified content nodes from a node list.
 *
 * @param {NodeList} nodes
 * @return {DocumentFragment}
 */

function extractFragment(nodes, parent) {
  var frag = document.createDocumentFragment();
  nodes = toArray(nodes);
  for (var i = 0, l = nodes.length; i < l; i++) {
    var node = nodes[i];
    if (isTemplate(node) && !node.hasAttribute('v-if') && !node.hasAttribute('v-for')) {
      parent.removeChild(node);
      node = parseTemplate(node, true);
    }
    frag.appendChild(node);
  }
  return frag;
}



var compiler = Object.freeze({
	compile: compile,
	compileAndLinkProps: compileAndLinkProps,
	compileRoot: compileRoot,
	transclude: transclude,
	resolveSlots: resolveSlots
});

function stateMixin (Vue) {
  /**
   * Accessor for `$data` property, since setting $data
   * requires observing the new object and updating
   * proxied properties.
   */

  Object.defineProperty(Vue.prototype, '$data', {
    get: function get() {
      return this._data;
    },
    set: function set(newData) {
      if (newData !== this._data) {
        this._setData(newData);
      }
    }
  });

  /**
   * Setup the scope of an instance, which contains:
   * - observed data
   * - computed properties
   * - user methods
   * - meta properties
   */

  Vue.prototype._initState = function () {
    this._initProps();
    this._initMeta();
    this._initMethods();
    this._initData();
    this._initComputed();
  };

  /**
   * Initialize props.
   */

  Vue.prototype._initProps = function () {
    var options = this.$options;
    var el = options.el;
    var props = options.props;
    if (props && !el) {
      process.env.NODE_ENV !== 'production' && warn('Props will not be compiled if no `el` option is ' + 'provided at instantiation.', this);
    }
    // make sure to convert string selectors into element now
    el = options.el = query(el);
    this._propsUnlinkFn = el && el.nodeType === 1 && props
    // props must be linked in proper scope if inside v-for
    ? compileAndLinkProps(this, el, props, this._scope) : null;
  };

  /**
   * Initialize the data.
   */

  Vue.prototype._initData = function () {
    var dataFn = this.$options.data;
    var data = this._data = dataFn ? dataFn() : {};
    if (!isPlainObject(data)) {
      data = {};
      process.env.NODE_ENV !== 'production' && warn('data functions should return an object.', this);
    }
    var props = this._props;
    // proxy data on instance
    var keys = Object.keys(data);
    var i, key;
    i = keys.length;
    while (i--) {
      key = keys[i];
      // there are two scenarios where we can proxy a data key:
      // 1. it's not already defined as a prop
      // 2. it's provided via a instantiation option AND there are no
      //    template prop present
      if (!props || !hasOwn(props, key)) {
        this._proxy(key);
      } else if (process.env.NODE_ENV !== 'production') {
        warn('Data field "' + key + '" is already defined ' + 'as a prop. To provide default value for a prop, use the "default" ' + 'prop option; if you want to pass prop values to an instantiation ' + 'call, use the "propsData" option.', this);
      }
    }
    // observe data
    observe(data, this);
  };

  /**
   * Swap the instance's $data. Called in $data's setter.
   *
   * @param {Object} newData
   */

  Vue.prototype._setData = function (newData) {
    newData = newData || {};
    var oldData = this._data;
    this._data = newData;
    var keys, key, i;
    // unproxy keys not present in new data
    keys = Object.keys(oldData);
    i = keys.length;
    while (i--) {
      key = keys[i];
      if (!(key in newData)) {
        this._unproxy(key);
      }
    }
    // proxy keys not already proxied,
    // and trigger change for changed values
    keys = Object.keys(newData);
    i = keys.length;
    while (i--) {
      key = keys[i];
      if (!hasOwn(this, key)) {
        // new property
        this._proxy(key);
      }
    }
    oldData.__ob__.removeVm(this);
    observe(newData, this);
    this._digest();
  };

  /**
   * Proxy a property, so that
   * vm.prop === vm._data.prop
   *
   * @param {String} key
   */

  Vue.prototype._proxy = function (key) {
    if (!isReserved(key)) {
      // need to store ref to self here
      // because these getter/setters might
      // be called by child scopes via
      // prototype inheritance.
      var self = this;
      Object.defineProperty(self, key, {
        configurable: true,
        enumerable: true,
        get: function proxyGetter() {
          return self._data[key];
        },
        set: function proxySetter(val) {
          self._data[key] = val;
        }
      });
    }
  };

  /**
   * Unproxy a property.
   *
   * @param {String} key
   */

  Vue.prototype._unproxy = function (key) {
    if (!isReserved(key)) {
      delete this[key];
    }
  };

  /**
   * Force update on every watcher in scope.
   */

  Vue.prototype._digest = function () {
    for (var i = 0, l = this._watchers.length; i < l; i++) {
      this._watchers[i].update(true); // shallow updates
    }
  };

  /**
   * Setup computed properties. They are essentially
   * special getter/setters
   */

  function noop() {}
  Vue.prototype._initComputed = function () {
    var computed = this.$options.computed;
    if (computed) {
      for (var key in computed) {
        var userDef = computed[key];
        var def = {
          enumerable: true,
          configurable: true
        };
        if (typeof userDef === 'function') {
          def.get = makeComputedGetter(userDef, this);
          def.set = noop;
        } else {
          def.get = userDef.get ? userDef.cache !== false ? makeComputedGetter(userDef.get, this) : bind(userDef.get, this) : noop;
          def.set = userDef.set ? bind(userDef.set, this) : noop;
        }
        Object.defineProperty(this, key, def);
      }
    }
  };

  function makeComputedGetter(getter, owner) {
    var watcher = new Watcher(owner, getter, null, {
      lazy: true
    });
    return function computedGetter() {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value;
    };
  }

  /**
   * Setup instance methods. Methods must be bound to the
   * instance since they might be passed down as a prop to
   * child components.
   */

  Vue.prototype._initMethods = function () {
    var methods = this.$options.methods;
    if (methods) {
      for (var key in methods) {
        this[key] = bind(methods[key], this);
      }
    }
  };

  /**
   * Initialize meta information like $index, $key & $value.
   */

  Vue.prototype._initMeta = function () {
    var metas = this.$options._meta;
    if (metas) {
      for (var key in metas) {
        defineReactive(this, key, metas[key]);
      }
    }
  };
}

var eventRE = /^v-on:|^@/;

function eventsMixin (Vue) {
  /**
   * Setup the instance's option events & watchers.
   * If the value is a string, we pull it from the
   * instance's methods by name.
   */

  Vue.prototype._initEvents = function () {
    var options = this.$options;
    if (options._asComponent) {
      registerComponentEvents(this, options.el);
    }
    registerCallbacks(this, '$on', options.events);
    registerCallbacks(this, '$watch', options.watch);
  };

  /**
   * Register v-on events on a child component
   *
   * @param {Vue} vm
   * @param {Element} el
   */

  function registerComponentEvents(vm, el) {
    var attrs = el.attributes;
    var name, value, handler;
    for (var i = 0, l = attrs.length; i < l; i++) {
      name = attrs[i].name;
      if (eventRE.test(name)) {
        name = name.replace(eventRE, '');
        // force the expression into a statement so that
        // it always dynamically resolves the method to call (#2670)
        // kinda ugly hack, but does the job.
        value = attrs[i].value;
        if (isSimplePath(value)) {
          value += '.apply(this, $arguments)';
        }
        handler = (vm._scope || vm._context).$eval(value, true);
        handler._fromParent = true;
        vm.$on(name.replace(eventRE), handler);
      }
    }
  }

  /**
   * Register callbacks for option events and watchers.
   *
   * @param {Vue} vm
   * @param {String} action
   * @param {Object} hash
   */

  function registerCallbacks(vm, action, hash) {
    if (!hash) return;
    var handlers, key, i, j;
    for (key in hash) {
      handlers = hash[key];
      if (isArray(handlers)) {
        for (i = 0, j = handlers.length; i < j; i++) {
          register(vm, action, key, handlers[i]);
        }
      } else {
        register(vm, action, key, handlers);
      }
    }
  }

  /**
   * Helper to register an event/watch callback.
   *
   * @param {Vue} vm
   * @param {String} action
   * @param {String} key
   * @param {Function|String|Object} handler
   * @param {Object} [options]
   */

  function register(vm, action, key, handler, options) {
    var type = typeof handler;
    if (type === 'function') {
      vm[action](key, handler, options);
    } else if (type === 'string') {
      var methods = vm.$options.methods;
      var method = methods && methods[handler];
      if (method) {
        vm[action](key, method, options);
      } else {
        process.env.NODE_ENV !== 'production' && warn('Unknown method: "' + handler + '" when ' + 'registering callback for ' + action + ': "' + key + '".', vm);
      }
    } else if (handler && type === 'object') {
      register(vm, action, key, handler.handler, handler);
    }
  }

  /**
   * Setup recursive attached/detached calls
   */

  Vue.prototype._initDOMHooks = function () {
    this.$on('hook:attached', onAttached);
    this.$on('hook:detached', onDetached);
  };

  /**
   * Callback to recursively call attached hook on children
   */

  function onAttached() {
    if (!this._isAttached) {
      this._isAttached = true;
      this.$children.forEach(callAttach);
    }
  }

  /**
   * Iterator to call attached hook
   *
   * @param {Vue} child
   */

  function callAttach(child) {
    if (!child._isAttached && inDoc(child.$el)) {
      child._callHook('attached');
    }
  }

  /**
   * Callback to recursively call detached hook on children
   */

  function onDetached() {
    if (this._isAttached) {
      this._isAttached = false;
      this.$children.forEach(callDetach);
    }
  }

  /**
   * Iterator to call detached hook
   *
   * @param {Vue} child
   */

  function callDetach(child) {
    if (child._isAttached && !inDoc(child.$el)) {
      child._callHook('detached');
    }
  }

  /**
   * Trigger all handlers for a hook
   *
   * @param {String} hook
   */

  Vue.prototype._callHook = function (hook) {
    this.$emit('pre-hook:' + hook);
    var handlers = this.$options[hook];
    if (handlers) {
      for (var i = 0, j = handlers.length; i < j; i++) {
        handlers[i].call(this);
      }
    }
    this.$emit('hook:' + hook);
  };
}

function noop$1() {}

/**
 * A directive links a DOM element with a piece of data,
 * which is the result of evaluating an expression.
 * It registers a watcher with the expression and calls
 * the DOM update function when a change is triggered.
 *
 * @param {Object} descriptor
 *                 - {String} name
 *                 - {Object} def
 *                 - {String} expression
 *                 - {Array<Object>} [filters]
 *                 - {Object} [modifiers]
 *                 - {Boolean} literal
 *                 - {String} attr
 *                 - {String} arg
 *                 - {String} raw
 *                 - {String} [ref]
 *                 - {Array<Object>} [interp]
 *                 - {Boolean} [hasOneTime]
 * @param {Vue} vm
 * @param {Node} el
 * @param {Vue} [host] - transclusion host component
 * @param {Object} [scope] - v-for scope
 * @param {Fragment} [frag] - owner fragment
 * @constructor
 */
function Directive(descriptor, vm, el, host, scope, frag) {
  this.vm = vm;
  this.el = el;
  // copy descriptor properties
  this.descriptor = descriptor;
  this.name = descriptor.name;
  this.expression = descriptor.expression;
  this.arg = descriptor.arg;
  this.modifiers = descriptor.modifiers;
  this.filters = descriptor.filters;
  this.literal = this.modifiers && this.modifiers.literal;
  // private
  this._locked = false;
  this._bound = false;
  this._listeners = null;
  // link context
  this._host = host;
  this._scope = scope;
  this._frag = frag;
  // store directives on node in dev mode
  if (process.env.NODE_ENV !== 'production' && this.el) {
    this.el._vue_directives = this.el._vue_directives || [];
    this.el._vue_directives.push(this);
  }
}

/**
 * Initialize the directive, mixin definition properties,
 * setup the watcher, call definition bind() and update()
 * if present.
 */

Directive.prototype._bind = function () {
  var name = this.name;
  var descriptor = this.descriptor;

  // remove attribute
  if ((name !== 'cloak' || this.vm._isCompiled) && this.el && this.el.removeAttribute) {
    var attr = descriptor.attr || 'v-' + name;
    this.el.removeAttribute(attr);
  }

  // copy def properties
  var def = descriptor.def;
  if (typeof def === 'function') {
    this.update = def;
  } else {
    extend(this, def);
  }

  // setup directive params
  this._setupParams();

  // initial bind
  if (this.bind) {
    this.bind();
  }
  this._bound = true;

  if (this.literal) {
    this.update && this.update(descriptor.raw);
  } else if ((this.expression || this.modifiers) && (this.update || this.twoWay) && !this._checkStatement()) {
    // wrapped updater for context
    var dir = this;
    if (this.update) {
      this._update = function (val, oldVal) {
        if (!dir._locked) {
          dir.update(val, oldVal);
        }
      };
    } else {
      this._update = noop$1;
    }
    var preProcess = this._preProcess ? bind(this._preProcess, this) : null;
    var postProcess = this._postProcess ? bind(this._postProcess, this) : null;
    var watcher = this._watcher = new Watcher(this.vm, this.expression, this._update, // callback
    {
      filters: this.filters,
      twoWay: this.twoWay,
      deep: this.deep,
      preProcess: preProcess,
      postProcess: postProcess,
      scope: this._scope
    });
    // v-model with inital inline value need to sync back to
    // model instead of update to DOM on init. They would
    // set the afterBind hook to indicate that.
    if (this.afterBind) {
      this.afterBind();
    } else if (this.update) {
      this.update(watcher.value);
    }
  }
};

/**
 * Setup all param attributes, e.g. track-by,
 * transition-mode, etc...
 */

Directive.prototype._setupParams = function () {
  if (!this.params) {
    return;
  }
  var params = this.params;
  // swap the params array with a fresh object.
  this.params = Object.create(null);
  var i = params.length;
  var key, val, mappedKey;
  while (i--) {
    key = hyphenate(params[i]);
    mappedKey = camelize(key);
    val = getBindAttr(this.el, key);
    if (val != null) {
      // dynamic
      this._setupParamWatcher(mappedKey, val);
    } else {
      // static
      val = getAttr(this.el, key);
      if (val != null) {
        this.params[mappedKey] = val === '' ? true : val;
      }
    }
  }
};

/**
 * Setup a watcher for a dynamic param.
 *
 * @param {String} key
 * @param {String} expression
 */

Directive.prototype._setupParamWatcher = function (key, expression) {
  var self = this;
  var called = false;
  var unwatch = (this._scope || this.vm).$watch(expression, function (val, oldVal) {
    self.params[key] = val;
    // since we are in immediate mode,
    // only call the param change callbacks if this is not the first update.
    if (called) {
      var cb = self.paramWatchers && self.paramWatchers[key];
      if (cb) {
        cb.call(self, val, oldVal);
      }
    } else {
      called = true;
    }
  }, {
    immediate: true,
    user: false
  });(this._paramUnwatchFns || (this._paramUnwatchFns = [])).push(unwatch);
};

/**
 * Check if the directive is a function caller
 * and if the expression is a callable one. If both true,
 * we wrap up the expression and use it as the event
 * handler.
 *
 * e.g. on-click="a++"
 *
 * @return {Boolean}
 */

Directive.prototype._checkStatement = function () {
  var expression = this.expression;
  if (expression && this.acceptStatement && !isSimplePath(expression)) {
    var fn = parseExpression$1(expression).get;
    var scope = this._scope || this.vm;
    var handler = function handler(e) {
      scope.$event = e;
      fn.call(scope, scope);
      scope.$event = null;
    };
    if (this.filters) {
      handler = scope._applyFilters(handler, null, this.filters);
    }
    this.update(handler);
    return true;
  }
};

/**
 * Set the corresponding value with the setter.
 * This should only be used in two-way directives
 * e.g. v-model.
 *
 * @param {*} value
 * @public
 */

Directive.prototype.set = function (value) {
  /* istanbul ignore else */
  if (this.twoWay) {
    this._withLock(function () {
      this._watcher.set(value);
    });
  } else if (process.env.NODE_ENV !== 'production') {
    warn('Directive.set() can only be used inside twoWay' + 'directives.');
  }
};

/**
 * Execute a function while preventing that function from
 * triggering updates on this directive instance.
 *
 * @param {Function} fn
 */

Directive.prototype._withLock = function (fn) {
  var self = this;
  self._locked = true;
  fn.call(self);
  nextTick(function () {
    self._locked = false;
  });
};

/**
 * Convenience method that attaches a DOM event listener
 * to the directive element and autometically tears it down
 * during unbind.
 *
 * @param {String} event
 * @param {Function} handler
 * @param {Boolean} [useCapture]
 */

Directive.prototype.on = function (event, handler, useCapture) {
  on(this.el, event, handler, useCapture);(this._listeners || (this._listeners = [])).push([event, handler]);
};

/**
 * Teardown the watcher and call unbind.
 */

Directive.prototype._teardown = function () {
  if (this._bound) {
    this._bound = false;
    if (this.unbind) {
      this.unbind();
    }
    if (this._watcher) {
      this._watcher.teardown();
    }
    var listeners = this._listeners;
    var i;
    if (listeners) {
      i = listeners.length;
      while (i--) {
        off(this.el, listeners[i][0], listeners[i][1]);
      }
    }
    var unwatchFns = this._paramUnwatchFns;
    if (unwatchFns) {
      i = unwatchFns.length;
      while (i--) {
        unwatchFns[i]();
      }
    }
    if (process.env.NODE_ENV !== 'production' && this.el) {
      this.el._vue_directives.$remove(this);
    }
    this.vm = this.el = this._watcher = this._listeners = null;
  }
};

function lifecycleMixin (Vue) {
  /**
   * Update v-ref for component.
   *
   * @param {Boolean} remove
   */

  Vue.prototype._updateRef = function (remove) {
    var ref = this.$options._ref;
    if (ref) {
      var refs = (this._scope || this._context).$refs;
      if (remove) {
        if (refs[ref] === this) {
          refs[ref] = null;
        }
      } else {
        refs[ref] = this;
      }
    }
  };

  /**
   * Transclude, compile and link element.
   *
   * If a pre-compiled linker is available, that means the
   * passed in element will be pre-transcluded and compiled
   * as well - all we need to do is to call the linker.
   *
   * Otherwise we need to call transclude/compile/link here.
   *
   * @param {Element} el
   */

  Vue.prototype._compile = function (el) {
    var options = this.$options;

    // transclude and init element
    // transclude can potentially replace original
    // so we need to keep reference; this step also injects
    // the template and caches the original attributes
    // on the container node and replacer node.
    var original = el;
    el = transclude(el, options);
    this._initElement(el);

    // handle v-pre on root node (#2026)
    if (el.nodeType === 1 && getAttr(el, 'v-pre') !== null) {
      return;
    }

    // root is always compiled per-instance, because
    // container attrs and props can be different every time.
    var contextOptions = this._context && this._context.$options;
    var rootLinker = compileRoot(el, options, contextOptions);

    // resolve slot distribution
    resolveSlots(this, options._content);

    // compile and link the rest
    var contentLinkFn;
    var ctor = this.constructor;
    // component compilation can be cached
    // as long as it's not using inline-template
    if (options._linkerCachable) {
      contentLinkFn = ctor.linker;
      if (!contentLinkFn) {
        contentLinkFn = ctor.linker = compile(el, options);
      }
    }

    // link phase
    // make sure to link root with prop scope!
    var rootUnlinkFn = rootLinker(this, el, this._scope);
    var contentUnlinkFn = contentLinkFn ? contentLinkFn(this, el) : compile(el, options)(this, el);

    // register composite unlink function
    // to be called during instance destruction
    this._unlinkFn = function () {
      rootUnlinkFn();
      // passing destroying: true to avoid searching and
      // splicing the directives
      contentUnlinkFn(true);
    };

    // finally replace original
    if (options.replace) {
      replace(original, el);
    }

    this._isCompiled = true;
    this._callHook('compiled');
  };

  /**
   * Initialize instance element. Called in the public
   * $mount() method.
   *
   * @param {Element} el
   */

  Vue.prototype._initElement = function (el) {
    if (isFragment(el)) {
      this._isFragment = true;
      this.$el = this._fragmentStart = el.firstChild;
      this._fragmentEnd = el.lastChild;
      // set persisted text anchors to empty
      if (this._fragmentStart.nodeType === 3) {
        this._fragmentStart.data = this._fragmentEnd.data = '';
      }
      this._fragment = el;
    } else {
      this.$el = el;
    }
    this.$el.__vue__ = this;
    this._callHook('beforeCompile');
  };

  /**
   * Create and bind a directive to an element.
   *
   * @param {Object} descriptor - parsed directive descriptor
   * @param {Node} node   - target node
   * @param {Vue} [host] - transclusion host component
   * @param {Object} [scope] - v-for scope
   * @param {Fragment} [frag] - owner fragment
   */

  Vue.prototype._bindDir = function (descriptor, node, host, scope, frag) {
    this._directives.push(new Directive(descriptor, this, node, host, scope, frag));
  };

  /**
   * Teardown an instance, unobserves the data, unbind all the
   * directives, turn off all the event listeners, etc.
   *
   * @param {Boolean} remove - whether to remove the DOM node.
   * @param {Boolean} deferCleanup - if true, defer cleanup to
   *                                 be called later
   */

  Vue.prototype._destroy = function (remove, deferCleanup) {
    if (this._isBeingDestroyed) {
      if (!deferCleanup) {
        this._cleanup();
      }
      return;
    }

    var destroyReady;
    var pendingRemoval;

    var self = this;
    // Cleanup should be called either synchronously or asynchronoysly as
    // callback of this.$remove(), or if remove and deferCleanup are false.
    // In any case it should be called after all other removing, unbinding and
    // turning of is done
    var cleanupIfPossible = function cleanupIfPossible() {
      if (destroyReady && !pendingRemoval && !deferCleanup) {
        self._cleanup();
      }
    };

    // remove DOM element
    if (remove && this.$el) {
      pendingRemoval = true;
      this.$remove(function () {
        pendingRemoval = false;
        cleanupIfPossible();
      });
    }

    this._callHook('beforeDestroy');
    this._isBeingDestroyed = true;
    var i;
    // remove self from parent. only necessary
    // if parent is not being destroyed as well.
    var parent = this.$parent;
    if (parent && !parent._isBeingDestroyed) {
      parent.$children.$remove(this);
      // unregister ref (remove: true)
      this._updateRef(true);
    }
    // destroy all children.
    i = this.$children.length;
    while (i--) {
      this.$children[i].$destroy();
    }
    // teardown props
    if (this._propsUnlinkFn) {
      this._propsUnlinkFn();
    }
    // teardown all directives. this also tearsdown all
    // directive-owned watchers.
    if (this._unlinkFn) {
      this._unlinkFn();
    }
    i = this._watchers.length;
    while (i--) {
      this._watchers[i].teardown();
    }
    // remove reference to self on $el
    if (this.$el) {
      this.$el.__vue__ = null;
    }

    destroyReady = true;
    cleanupIfPossible();
  };

  /**
   * Clean up to ensure garbage collection.
   * This is called after the leave transition if there
   * is any.
   */

  Vue.prototype._cleanup = function () {
    if (this._isDestroyed) {
      return;
    }
    // remove self from owner fragment
    // do it in cleanup so that we can call $destroy with
    // defer right when a fragment is about to be removed.
    if (this._frag) {
      this._frag.children.$remove(this);
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (this._data && this._data.__ob__) {
      this._data.__ob__.removeVm(this);
    }
    // Clean up references to private properties and other
    // instances. preserve reference to _data so that proxy
    // accessors still work. The only potential side effect
    // here is that mutating the instance after it's destroyed
    // may affect the state of other components that are still
    // observing the same object, but that seems to be a
    // reasonable responsibility for the user rather than
    // always throwing an error on them.
    this.$el = this.$parent = this.$root = this.$children = this._watchers = this._context = this._scope = this._directives = null;
    // call the last hook...
    this._isDestroyed = true;
    this._callHook('destroyed');
    // turn off all instance listeners.
    this.$off();
  };
}

function miscMixin (Vue) {
  /**
   * Apply a list of filter (descriptors) to a value.
   * Using plain for loops here because this will be called in
   * the getter of any watcher with filters so it is very
   * performance sensitive.
   *
   * @param {*} value
   * @param {*} [oldValue]
   * @param {Array} filters
   * @param {Boolean} write
   * @return {*}
   */

  Vue.prototype._applyFilters = function (value, oldValue, filters, write) {
    var filter, fn, args, arg, offset, i, l, j, k;
    for (i = 0, l = filters.length; i < l; i++) {
      filter = filters[write ? l - i - 1 : i];
      fn = resolveAsset(this.$options, 'filters', filter.name, true);
      if (!fn) continue;
      fn = write ? fn.write : fn.read || fn;
      if (typeof fn !== 'function') continue;
      args = write ? [value, oldValue] : [value];
      offset = write ? 2 : 1;
      if (filter.args) {
        for (j = 0, k = filter.args.length; j < k; j++) {
          arg = filter.args[j];
          args[j + offset] = arg.dynamic ? this.$get(arg.value) : arg.value;
        }
      }
      value = fn.apply(this, args);
    }
    return value;
  };

  /**
   * Resolve a component, depending on whether the component
   * is defined normally or using an async factory function.
   * Resolves synchronously if already resolved, otherwise
   * resolves asynchronously and caches the resolved
   * constructor on the factory.
   *
   * @param {String|Function} value
   * @param {Function} cb
   */

  Vue.prototype._resolveComponent = function (value, cb) {
    var factory;
    if (typeof value === 'function') {
      factory = value;
    } else {
      factory = resolveAsset(this.$options, 'components', value, true);
    }
    /* istanbul ignore if */
    if (!factory) {
      return;
    }
    // async component factory
    if (!factory.options) {
      if (factory.resolved) {
        // cached
        cb(factory.resolved);
      } else if (factory.requested) {
        // pool callbacks
        factory.pendingCallbacks.push(cb);
      } else {
        factory.requested = true;
        var cbs = factory.pendingCallbacks = [cb];
        factory.call(this, function resolve(res) {
          if (isPlainObject(res)) {
            res = Vue.extend(res);
          }
          // cache resolved
          factory.resolved = res;
          // invoke callbacks
          for (var i = 0, l = cbs.length; i < l; i++) {
            cbs[i](res);
          }
        }, function reject(reason) {
          process.env.NODE_ENV !== 'production' && warn('Failed to resolve async component' + (typeof value === 'string' ? ': ' + value : '') + '. ' + (reason ? '\nReason: ' + reason : ''));
        });
      }
    } else {
      // normal component
      cb(factory);
    }
  };
}

var filterRE$1 = /[^|]\|[^|]/;

function dataAPI (Vue) {
  /**
   * Get the value from an expression on this vm.
   *
   * @param {String} exp
   * @param {Boolean} [asStatement]
   * @return {*}
   */

  Vue.prototype.$get = function (exp, asStatement) {
    var res = parseExpression$1(exp);
    if (res) {
      if (asStatement) {
        var self = this;
        return function statementHandler() {
          self.$arguments = toArray(arguments);
          var result = res.get.call(self, self);
          self.$arguments = null;
          return result;
        };
      } else {
        try {
          return res.get.call(this, this);
        } catch (e) {}
      }
    }
  };

  /**
   * Set the value from an expression on this vm.
   * The expression must be a valid left-hand
   * expression in an assignment.
   *
   * @param {String} exp
   * @param {*} val
   */

  Vue.prototype.$set = function (exp, val) {
    var res = parseExpression$1(exp, true);
    if (res && res.set) {
      res.set.call(this, this, val);
    }
  };

  /**
   * Delete a property on the VM
   *
   * @param {String} key
   */

  Vue.prototype.$delete = function (key) {
    del(this._data, key);
  };

  /**
   * Watch an expression, trigger callback when its
   * value changes.
   *
   * @param {String|Function} expOrFn
   * @param {Function} cb
   * @param {Object} [options]
   *                 - {Boolean} deep
   *                 - {Boolean} immediate
   * @return {Function} - unwatchFn
   */

  Vue.prototype.$watch = function (expOrFn, cb, options) {
    var vm = this;
    var parsed;
    if (typeof expOrFn === 'string') {
      parsed = parseDirective(expOrFn);
      expOrFn = parsed.expression;
    }
    var watcher = new Watcher(vm, expOrFn, cb, {
      deep: options && options.deep,
      sync: options && options.sync,
      filters: parsed && parsed.filters,
      user: !options || options.user !== false
    });
    if (options && options.immediate) {
      cb.call(vm, watcher.value);
    }
    return function unwatchFn() {
      watcher.teardown();
    };
  };

  /**
   * Evaluate a text directive, including filters.
   *
   * @param {String} text
   * @param {Boolean} [asStatement]
   * @return {String}
   */

  Vue.prototype.$eval = function (text, asStatement) {
    // check for filters.
    if (filterRE$1.test(text)) {
      var dir = parseDirective(text);
      // the filter regex check might give false positive
      // for pipes inside strings, so it's possible that
      // we don't get any filters here
      var val = this.$get(dir.expression, asStatement);
      return dir.filters ? this._applyFilters(val, null, dir.filters) : val;
    } else {
      // no filter
      return this.$get(text, asStatement);
    }
  };

  /**
   * Interpolate a piece of template text.
   *
   * @param {String} text
   * @return {String}
   */

  Vue.prototype.$interpolate = function (text) {
    var tokens = parseText(text);
    var vm = this;
    if (tokens) {
      if (tokens.length === 1) {
        return vm.$eval(tokens[0].value) + '';
      } else {
        return tokens.map(function (token) {
          return token.tag ? vm.$eval(token.value) : token.value;
        }).join('');
      }
    } else {
      return text;
    }
  };

  /**
   * Log instance data as a plain JS object
   * so that it is easier to inspect in console.
   * This method assumes console is available.
   *
   * @param {String} [path]
   */

  Vue.prototype.$log = function (path) {
    var data = path ? getPath(this._data, path) : this._data;
    if (data) {
      data = clean(data);
    }
    // include computed fields
    if (!path) {
      var key;
      for (key in this.$options.computed) {
        data[key] = clean(this[key]);
      }
      if (this._props) {
        for (key in this._props) {
          data[key] = clean(this[key]);
        }
      }
    }
    console.log(data);
  };

  /**
   * "clean" a getter/setter converted object into a plain
   * object copy.
   *
   * @param {Object} - obj
   * @return {Object}
   */

  function clean(obj) {
    return JSON.parse(JSON.stringify(obj));
  }
}

function domAPI (Vue) {
  /**
   * Convenience on-instance nextTick. The callback is
   * auto-bound to the instance, and this avoids component
   * modules having to rely on the global Vue.
   *
   * @param {Function} fn
   */

  Vue.prototype.$nextTick = function (fn) {
    nextTick(fn, this);
  };

  /**
   * Append instance to target
   *
   * @param {Node} target
   * @param {Function} [cb]
   * @param {Boolean} [withTransition] - defaults to true
   */

  Vue.prototype.$appendTo = function (target, cb, withTransition) {
    return insert(this, target, cb, withTransition, append, appendWithTransition);
  };

  /**
   * Prepend instance to target
   *
   * @param {Node} target
   * @param {Function} [cb]
   * @param {Boolean} [withTransition] - defaults to true
   */

  Vue.prototype.$prependTo = function (target, cb, withTransition) {
    target = query(target);
    if (target.hasChildNodes()) {
      this.$before(target.firstChild, cb, withTransition);
    } else {
      this.$appendTo(target, cb, withTransition);
    }
    return this;
  };

  /**
   * Insert instance before target
   *
   * @param {Node} target
   * @param {Function} [cb]
   * @param {Boolean} [withTransition] - defaults to true
   */

  Vue.prototype.$before = function (target, cb, withTransition) {
    return insert(this, target, cb, withTransition, beforeWithCb, beforeWithTransition);
  };

  /**
   * Insert instance after target
   *
   * @param {Node} target
   * @param {Function} [cb]
   * @param {Boolean} [withTransition] - defaults to true
   */

  Vue.prototype.$after = function (target, cb, withTransition) {
    target = query(target);
    if (target.nextSibling) {
      this.$before(target.nextSibling, cb, withTransition);
    } else {
      this.$appendTo(target.parentNode, cb, withTransition);
    }
    return this;
  };

  /**
   * Remove instance from DOM
   *
   * @param {Function} [cb]
   * @param {Boolean} [withTransition] - defaults to true
   */

  Vue.prototype.$remove = function (cb, withTransition) {
    if (!this.$el.parentNode) {
      return cb && cb();
    }
    var inDocument = this._isAttached && inDoc(this.$el);
    // if we are not in document, no need to check
    // for transitions
    if (!inDocument) withTransition = false;
    var self = this;
    var realCb = function realCb() {
      if (inDocument) self._callHook('detached');
      if (cb) cb();
    };
    if (this._isFragment) {
      removeNodeRange(this._fragmentStart, this._fragmentEnd, this, this._fragment, realCb);
    } else {
      var op = withTransition === false ? removeWithCb : removeWithTransition;
      op(this.$el, this, realCb);
    }
    return this;
  };

  /**
   * Shared DOM insertion function.
   *
   * @param {Vue} vm
   * @param {Element} target
   * @param {Function} [cb]
   * @param {Boolean} [withTransition]
   * @param {Function} op1 - op for non-transition insert
   * @param {Function} op2 - op for transition insert
   * @return vm
   */

  function insert(vm, target, cb, withTransition, op1, op2) {
    target = query(target);
    var targetIsDetached = !inDoc(target);
    var op = withTransition === false || targetIsDetached ? op1 : op2;
    var shouldCallHook = !targetIsDetached && !vm._isAttached && !inDoc(vm.$el);
    if (vm._isFragment) {
      mapNodeRange(vm._fragmentStart, vm._fragmentEnd, function (node) {
        op(node, target, vm);
      });
      cb && cb();
    } else {
      op(vm.$el, target, vm, cb);
    }
    if (shouldCallHook) {
      vm._callHook('attached');
    }
    return vm;
  }

  /**
   * Check for selectors
   *
   * @param {String|Element} el
   */

  function query(el) {
    return typeof el === 'string' ? document.querySelector(el) : el;
  }

  /**
   * Append operation that takes a callback.
   *
   * @param {Node} el
   * @param {Node} target
   * @param {Vue} vm - unused
   * @param {Function} [cb]
   */

  function append(el, target, vm, cb) {
    target.appendChild(el);
    if (cb) cb();
  }

  /**
   * InsertBefore operation that takes a callback.
   *
   * @param {Node} el
   * @param {Node} target
   * @param {Vue} vm - unused
   * @param {Function} [cb]
   */

  function beforeWithCb(el, target, vm, cb) {
    before(el, target);
    if (cb) cb();
  }

  /**
   * Remove operation that takes a callback.
   *
   * @param {Node} el
   * @param {Vue} vm - unused
   * @param {Function} [cb]
   */

  function removeWithCb(el, vm, cb) {
    remove(el);
    if (cb) cb();
  }
}

function eventsAPI (Vue) {
  /**
   * Listen on the given `event` with `fn`.
   *
   * @param {String} event
   * @param {Function} fn
   */

  Vue.prototype.$on = function (event, fn) {
    (this._events[event] || (this._events[event] = [])).push(fn);
    modifyListenerCount(this, event, 1);
    return this;
  };

  /**
   * Adds an `event` listener that will be invoked a single
   * time then automatically removed.
   *
   * @param {String} event
   * @param {Function} fn
   */

  Vue.prototype.$once = function (event, fn) {
    var self = this;
    function on() {
      self.$off(event, on);
      fn.apply(this, arguments);
    }
    on.fn = fn;
    this.$on(event, on);
    return this;
  };

  /**
   * Remove the given callback for `event` or all
   * registered callbacks.
   *
   * @param {String} event
   * @param {Function} fn
   */

  Vue.prototype.$off = function (event, fn) {
    var cbs;
    // all
    if (!arguments.length) {
      if (this.$parent) {
        for (event in this._events) {
          cbs = this._events[event];
          if (cbs) {
            modifyListenerCount(this, event, -cbs.length);
          }
        }
      }
      this._events = {};
      return this;
    }
    // specific event
    cbs = this._events[event];
    if (!cbs) {
      return this;
    }
    if (arguments.length === 1) {
      modifyListenerCount(this, event, -cbs.length);
      this._events[event] = null;
      return this;
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        modifyListenerCount(this, event, -1);
        cbs.splice(i, 1);
        break;
      }
    }
    return this;
  };

  /**
   * Trigger an event on self.
   *
   * @param {String|Object} event
   * @return {Boolean} shouldPropagate
   */

  Vue.prototype.$emit = function (event) {
    var isSource = typeof event === 'string';
    event = isSource ? event : event.name;
    var cbs = this._events[event];
    var shouldPropagate = isSource || !cbs;
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      // this is a somewhat hacky solution to the question raised
      // in #2102: for an inline component listener like <comp @test="doThis">,
      // the propagation handling is somewhat broken. Therefore we
      // need to treat these inline callbacks differently.
      var hasParentCbs = isSource && cbs.some(function (cb) {
        return cb._fromParent;
      });
      if (hasParentCbs) {
        shouldPropagate = false;
      }
      var args = toArray(arguments, 1);
      for (var i = 0, l = cbs.length; i < l; i++) {
        var cb = cbs[i];
        var res = cb.apply(this, args);
        if (res === true && (!hasParentCbs || cb._fromParent)) {
          shouldPropagate = true;
        }
      }
    }
    return shouldPropagate;
  };

  /**
   * Recursively broadcast an event to all children instances.
   *
   * @param {String|Object} event
   * @param {...*} additional arguments
   */

  Vue.prototype.$broadcast = function (event) {
    var isSource = typeof event === 'string';
    event = isSource ? event : event.name;
    // if no child has registered for this event,
    // then there's no need to broadcast.
    if (!this._eventsCount[event]) return;
    var children = this.$children;
    var args = toArray(arguments);
    if (isSource) {
      // use object event to indicate non-source emit
      // on children
      args[0] = { name: event, source: this };
    }
    for (var i = 0, l = children.length; i < l; i++) {
      var child = children[i];
      var shouldPropagate = child.$emit.apply(child, args);
      if (shouldPropagate) {
        child.$broadcast.apply(child, args);
      }
    }
    return this;
  };

  /**
   * Recursively propagate an event up the parent chain.
   *
   * @param {String} event
   * @param {...*} additional arguments
   */

  Vue.prototype.$dispatch = function (event) {
    var shouldPropagate = this.$emit.apply(this, arguments);
    if (!shouldPropagate) return;
    var parent = this.$parent;
    var args = toArray(arguments);
    // use object event to indicate non-source emit
    // on parents
    args[0] = { name: event, source: this };
    while (parent) {
      shouldPropagate = parent.$emit.apply(parent, args);
      parent = shouldPropagate ? parent.$parent : null;
    }
    return this;
  };

  /**
   * Modify the listener counts on all parents.
   * This bookkeeping allows $broadcast to return early when
   * no child has listened to a certain event.
   *
   * @param {Vue} vm
   * @param {String} event
   * @param {Number} count
   */

  var hookRE = /^hook:/;
  function modifyListenerCount(vm, event, count) {
    var parent = vm.$parent;
    // hooks do not get broadcasted so no need
    // to do bookkeeping for them
    if (!parent || !count || hookRE.test(event)) return;
    while (parent) {
      parent._eventsCount[event] = (parent._eventsCount[event] || 0) + count;
      parent = parent.$parent;
    }
  }
}

function lifecycleAPI (Vue) {
  /**
   * Set instance target element and kick off the compilation
   * process. The passed in `el` can be a selector string, an
   * existing Element, or a DocumentFragment (for block
   * instances).
   *
   * @param {Element|DocumentFragment|string} el
   * @public
   */

  Vue.prototype.$mount = function (el) {
    if (this._isCompiled) {
      process.env.NODE_ENV !== 'production' && warn('$mount() should be called only once.', this);
      return;
    }
    el = query(el);
    if (!el) {
      el = document.createElement('div');
    }
    this._compile(el);
    this._initDOMHooks();
    if (inDoc(this.$el)) {
      this._callHook('attached');
      ready.call(this);
    } else {
      this.$once('hook:attached', ready);
    }
    return this;
  };

  /**
   * Mark an instance as ready.
   */

  function ready() {
    this._isAttached = true;
    this._isReady = true;
    this._callHook('ready');
  }

  /**
   * Teardown the instance, simply delegate to the internal
   * _destroy.
   *
   * @param {Boolean} remove
   * @param {Boolean} deferCleanup
   */

  Vue.prototype.$destroy = function (remove, deferCleanup) {
    this._destroy(remove, deferCleanup);
  };

  /**
   * Partially compile a piece of DOM and return a
   * decompile function.
   *
   * @param {Element|DocumentFragment} el
   * @param {Vue} [host]
   * @param {Object} [scope]
   * @param {Fragment} [frag]
   * @return {Function}
   */

  Vue.prototype.$compile = function (el, host, scope, frag) {
    return compile(el, this.$options, true)(this, el, host, scope, frag);
  };
}

/**
 * The exposed Vue constructor.
 *
 * API conventions:
 * - public API methods/properties are prefixed with `$`
 * - internal methods/properties are prefixed with `_`
 * - non-prefixed properties are assumed to be proxied user
 *   data.
 *
 * @constructor
 * @param {Object} [options]
 * @public
 */

function Vue(options) {
  this._init(options);
}

// install internals
initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
miscMixin(Vue);

// install instance APIs
dataAPI(Vue);
domAPI(Vue);
eventsAPI(Vue);
lifecycleAPI(Vue);

var slot = {

  priority: SLOT,
  params: ['name'],

  bind: function bind() {
    // this was resolved during component transclusion
    var name = this.params.name || 'default';
    var content = this.vm._slotContents && this.vm._slotContents[name];
    if (!content || !content.hasChildNodes()) {
      this.fallback();
    } else {
      this.compile(content.cloneNode(true), this.vm._context, this.vm);
    }
  },

  compile: function compile(content, context, host) {
    if (content && context) {
      if (this.el.hasChildNodes() && content.childNodes.length === 1 && content.childNodes[0].nodeType === 1 && content.childNodes[0].hasAttribute('v-if')) {
        // if the inserted slot has v-if
        // inject fallback content as the v-else
        var elseBlock = document.createElement('template');
        elseBlock.setAttribute('v-else', '');
        elseBlock.innerHTML = this.el.innerHTML;
        // the else block should be compiled in child scope
        elseBlock._context = this.vm;
        content.appendChild(elseBlock);
      }
      var scope = host ? host._scope : this._scope;
      this.unlink = context.$compile(content, host, scope, this._frag);
    }
    if (content) {
      replace(this.el, content);
    } else {
      remove(this.el);
    }
  },

  fallback: function fallback() {
    this.compile(extractContent(this.el, true), this.vm);
  },

  unbind: function unbind() {
    if (this.unlink) {
      this.unlink();
    }
  }
};

var partial = {

  priority: PARTIAL,

  params: ['name'],

  // watch changes to name for dynamic partials
  paramWatchers: {
    name: function name(value) {
      vIf.remove.call(this);
      if (value) {
        this.insert(value);
      }
    }
  },

  bind: function bind() {
    this.anchor = createAnchor('v-partial');
    replace(this.el, this.anchor);
    this.insert(this.params.name);
  },

  insert: function insert(id) {
    var partial = resolveAsset(this.vm.$options, 'partials', id, true);
    if (partial) {
      this.factory = new FragmentFactory(this.vm, partial);
      vIf.insert.call(this);
    }
  },

  unbind: function unbind() {
    if (this.frag) {
      this.frag.destroy();
    }
  }
};

var elementDirectives = {
  slot: slot,
  partial: partial
};

var convertArray = vFor._postProcess;

/**
 * Limit filter for arrays
 *
 * @param {Number} n
 * @param {Number} offset (Decimal expected)
 */

function limitBy(arr, n, offset) {
  offset = offset ? parseInt(offset, 10) : 0;
  n = toNumber(n);
  return typeof n === 'number' ? arr.slice(offset, offset + n) : arr;
}

/**
 * Filter filter for arrays
 *
 * @param {String} search
 * @param {String} [delimiter]
 * @param {String} ...dataKeys
 */

function filterBy(arr, search, delimiter) {
  arr = convertArray(arr);
  if (search == null) {
    return arr;
  }
  if (typeof search === 'function') {
    return arr.filter(search);
  }
  // cast to lowercase string
  search = ('' + search).toLowerCase();
  // allow optional `in` delimiter
  // because why not
  var n = delimiter === 'in' ? 3 : 2;
  // extract and flatten keys
  var keys = Array.prototype.concat.apply([], toArray(arguments, n));
  var res = [];
  var item, key, val, j;
  for (var i = 0, l = arr.length; i < l; i++) {
    item = arr[i];
    val = item && item.$value || item;
    j = keys.length;
    if (j) {
      while (j--) {
        key = keys[j];
        if (key === '$key' && contains(item.$key, search) || contains(getPath(val, key), search)) {
          res.push(item);
          break;
        }
      }
    } else if (contains(item, search)) {
      res.push(item);
    }
  }
  return res;
}

/**
 * Order filter for arrays
 *
 * @param {String|Array<String>|Function} ...sortKeys
 * @param {Number} [order]
 */

function orderBy(arr) {
  var comparator = null;
  var sortKeys = undefined;
  arr = convertArray(arr);

  // determine order (last argument)
  var args = toArray(arguments, 1);
  var order = args[args.length - 1];
  if (typeof order === 'number') {
    order = order < 0 ? -1 : 1;
    args = args.length > 1 ? args.slice(0, -1) : args;
  } else {
    order = 1;
  }

  // determine sortKeys & comparator
  var firstArg = args[0];
  if (!firstArg) {
    return arr;
  } else if (typeof firstArg === 'function') {
    // custom comparator
    comparator = function (a, b) {
      return firstArg(a, b) * order;
    };
  } else {
    // string keys. flatten first
    sortKeys = Array.prototype.concat.apply([], args);
    comparator = function (a, b, i) {
      i = i || 0;
      return i >= sortKeys.length - 1 ? baseCompare(a, b, i) : baseCompare(a, b, i) || comparator(a, b, i + 1);
    };
  }

  function baseCompare(a, b, sortKeyIndex) {
    var sortKey = sortKeys[sortKeyIndex];
    if (sortKey) {
      if (sortKey !== '$key') {
        if (isObject(a) && '$value' in a) a = a.$value;
        if (isObject(b) && '$value' in b) b = b.$value;
      }
      a = isObject(a) ? getPath(a, sortKey) : a;
      b = isObject(b) ? getPath(b, sortKey) : b;
    }
    return a === b ? 0 : a > b ? order : -order;
  }

  // sort on a copy to avoid mutating original array
  return arr.slice().sort(comparator);
}

/**
 * String contain helper
 *
 * @param {*} val
 * @param {String} search
 */

function contains(val, search) {
  var i;
  if (isPlainObject(val)) {
    var keys = Object.keys(val);
    i = keys.length;
    while (i--) {
      if (contains(val[keys[i]], search)) {
        return true;
      }
    }
  } else if (isArray(val)) {
    i = val.length;
    while (i--) {
      if (contains(val[i], search)) {
        return true;
      }
    }
  } else if (val != null) {
    return val.toString().toLowerCase().indexOf(search) > -1;
  }
}

var digitsRE = /(\d{3})(?=\d)/g;

// asset collections must be a plain object.
var filters = {

  orderBy: orderBy,
  filterBy: filterBy,
  limitBy: limitBy,

  /**
   * Stringify value.
   *
   * @param {Number} indent
   */

  json: {
    read: function read(value, indent) {
      return typeof value === 'string' ? value : JSON.stringify(value, null, arguments.length > 1 ? indent : 2);
    },
    write: function write(value) {
      try {
        return JSON.parse(value);
      } catch (e) {
        return value;
      }
    }
  },

  /**
   * 'abc' => 'Abc'
   */

  capitalize: function capitalize(value) {
    if (!value && value !== 0) return '';
    value = value.toString();
    return value.charAt(0).toUpperCase() + value.slice(1);
  },

  /**
   * 'abc' => 'ABC'
   */

  uppercase: function uppercase(value) {
    return value || value === 0 ? value.toString().toUpperCase() : '';
  },

  /**
   * 'AbC' => 'abc'
   */

  lowercase: function lowercase(value) {
    return value || value === 0 ? value.toString().toLowerCase() : '';
  },

  /**
   * 12345 => $12,345.00
   *
   * @param {String} sign
   * @param {Number} decimals Decimal places
   */

  currency: function currency(value, _currency, decimals) {
    value = parseFloat(value);
    if (!isFinite(value) || !value && value !== 0) return '';
    _currency = _currency != null ? _currency : '$';
    decimals = decimals != null ? decimals : 2;
    var stringified = Math.abs(value).toFixed(decimals);
    var _int = decimals ? stringified.slice(0, -1 - decimals) : stringified;
    var i = _int.length % 3;
    var head = i > 0 ? _int.slice(0, i) + (_int.length > 3 ? ',' : '') : '';
    var _float = decimals ? stringified.slice(-1 - decimals) : '';
    var sign = value < 0 ? '-' : '';
    return sign + _currency + head + _int.slice(i).replace(digitsRE, '$1,') + _float;
  },

  /**
   * 'item' => 'items'
   *
   * @params
   *  an array of strings corresponding to
   *  the single, double, triple ... forms of the word to
   *  be pluralized. When the number to be pluralized
   *  exceeds the length of the args, it will use the last
   *  entry in the array.
   *
   *  e.g. ['single', 'double', 'triple', 'multiple']
   */

  pluralize: function pluralize(value) {
    var args = toArray(arguments, 1);
    var length = args.length;
    if (length > 1) {
      var index = value % 10 - 1;
      return index in args ? args[index] : args[length - 1];
    } else {
      return args[0] + (value === 1 ? '' : 's');
    }
  },

  /**
   * Debounce a handler function.
   *
   * @param {Function} handler
   * @param {Number} delay = 300
   * @return {Function}
   */

  debounce: function debounce(handler, delay) {
    if (!handler) return;
    if (!delay) {
      delay = 300;
    }
    return _debounce(handler, delay);
  }
};

function installGlobalAPI (Vue) {
  /**
   * Vue and every constructor that extends Vue has an
   * associated options object, which can be accessed during
   * compilation steps as `this.constructor.options`.
   *
   * These can be seen as the default options of every
   * Vue instance.
   */

  Vue.options = {
    directives: directives,
    elementDirectives: elementDirectives,
    filters: filters,
    transitions: {},
    components: {},
    partials: {},
    replace: true
  };

  /**
   * Expose useful internals
   */

  Vue.util = util;
  Vue.config = config;
  Vue.set = set;
  Vue['delete'] = del;
  Vue.nextTick = nextTick;

  /**
   * The following are exposed for advanced usage / plugins
   */

  Vue.compiler = compiler;
  Vue.FragmentFactory = FragmentFactory;
  Vue.internalDirectives = internalDirectives;
  Vue.parsers = {
    path: path,
    text: text,
    template: template,
    directive: directive,
    expression: expression
  };

  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */

  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   *
   * @param {Object} extendOptions
   */

  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var isFirstExtend = Super.cid === 0;
    if (isFirstExtend && extendOptions._Ctor) {
      return extendOptions._Ctor;
    }
    var name = extendOptions.name || Super.options.name;
    if (process.env.NODE_ENV !== 'production') {
      if (!/^[a-zA-Z][\w-]*$/.test(name)) {
        warn('Invalid component name: "' + name + '". Component names ' + 'can only contain alphanumeric characaters and the hyphen.');
        name = null;
      }
    }
    var Sub = createClass(name || 'VueComponent');
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(Super.options, extendOptions);
    Sub['super'] = Super;
    // allow further extension
    Sub.extend = Super.extend;
    // create asset registers, so extended classes
    // can have their private assets too.
    config._assetTypes.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }
    // cache constructor
    if (isFirstExtend) {
      extendOptions._Ctor = Sub;
    }
    return Sub;
  };

  /**
   * A function that returns a sub-class constructor with the
   * given name. This gives us much nicer output when
   * logging instances in the console.
   *
   * @param {String} name
   * @return {Function}
   */

  function createClass(name) {
    /* eslint-disable no-new-func */
    return new Function('return function ' + classify(name) + ' (options) { this._init(options) }')();
    /* eslint-enable no-new-func */
  }

  /**
   * Plugin system
   *
   * @param {Object} plugin
   */

  Vue.use = function (plugin) {
    /* istanbul ignore if */
    if (plugin.installed) {
      return;
    }
    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else {
      plugin.apply(null, args);
    }
    plugin.installed = true;
    return this;
  };

  /**
   * Apply a global mixin by merging it into the default
   * options.
   */

  Vue.mixin = function (mixin) {
    Vue.options = mergeOptions(Vue.options, mixin);
  };

  /**
   * Create asset registration methods with the following
   * signature:
   *
   * @param {String} id
   * @param {*} definition
   */

  config._assetTypes.forEach(function (type) {
    Vue[type] = function (id, definition) {
      if (!definition) {
        return this.options[type + 's'][id];
      } else {
        /* istanbul ignore if */
        if (process.env.NODE_ENV !== 'production') {
          if (type === 'component' && (commonTagRE.test(id) || reservedTagRE.test(id))) {
            warn('Do not use built-in or reserved HTML elements as component ' + 'id: ' + id);
          }
        }
        if (type === 'component' && isPlainObject(definition)) {
          if (!definition.name) {
            definition.name = id;
          }
          definition = Vue.extend(definition);
        }
        this.options[type + 's'][id] = definition;
        return definition;
      }
    };
  });

  // expose internal transition API
  extend(Vue.transition, transition);
}

installGlobalAPI(Vue);

Vue.version = '1.0.28';

// devtools global hook
/* istanbul ignore next */
setTimeout(function () {
  if (config.devtools) {
    if (devtools) {
      devtools.emit('init', Vue);
    } else if (process.env.NODE_ENV !== 'production' && inBrowser && /Chrome\/\d+/.test(window.navigator.userAgent)) {
      console.log('Download the Vue Devtools for a better development experience:\n' + 'https://github.com/vuejs/vue-devtools');
    }
  }
}, 0);

module.exports = Vue;
}).call(this,require('_process'))
},{"_process":3}],6:[function(require,module,exports){
var inserted = exports.cache = {}

exports.insert = function (css) {
  if (inserted[css]) return
  inserted[css] = true

  var elem = document.createElement('style')
  elem.setAttribute('type', 'text/css')

  if ('textContent' in elem) {
    elem.textContent = css
  } else {
    elem.styleSheet.cssText = css
  }

  document.getElementsByTagName('head')[0].appendChild(elem)
  return elem
}

},{}],7:[function(require,module,exports){
'use strict';

var init = require('./init');

init.libraries();
// init.scripts();
// init.pjax();
init.vue();
//init.onReady();

},{"./init":9}],8:[function(require,module,exports){
'use strict';

var components = require('./../vue/components.js');

/** Lodash mixins. All global level helpers should be put there */
_.mixin({
    /**
     * Removes item from an array of objects.
     * @example _.removeById(5, [{id: 2}, {id: 5}]);
     * @param id
     * @param items
     * @returns {*}
     */
    removeById: function removeById(id, items) {
        return _.reduce(items, function (res, item) {
            if (item.id != id) res.push(item);
            return res;
        }, []);
    },
    findById: function findById(id, items) {
        var field = arguments.length <= 2 || arguments[2] === undefined ? 'id' : arguments[2];

        return items[_.findIndex(items, function (item) {
            return item[field] == id;
        })];
    },
    /**
     * Generates random string
     * @example _.randomStr()
     * @param length Default value: 6
     * @returns {string}
     */
    randomStr: function randomStr() {
        var length = arguments.length <= 0 || arguments[0] === undefined ? 6 : arguments[0];

        var text = "e";
        var possible = "abcdefghijklmnopqrstuvwxyz0123456789";

        for (var i = 0; i < length - 1; i++) text += possible.charAt(Math.floor(Math.random() * possible.length));

        return text;
    },
    /**
     * JS analogue for PHP's array_column
     * @example _.column([{name: 'John'}, {name: 'Jack'}], 'name') => ['John', 'Jack']
     * @param items
     * @param column
     * @return {array}
     */
    column: function column(items, _column) {
        return items.map(function (item) {
            return item[_column];
        });
    },
    /**
     * @example _.pluralize(4, 'file', 'files') -> '4 files'
     * @param count
     * @param single
     * @param plural
     */
    pluralize: function pluralize(count, single, plural) {
        return count == 1 ? count + ' ' + single : count + ' ' + plural;
    },

    /**
     * @param mountPoint
     * @param name
     * @param data
     */
    mountComponent: function mountComponent(mountPoint, name) {
        var data = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];

        var component = components[name](data);
        return new component().$mount().$appendTo(mountPoint);
    },

    removeEmpty: function removeEmpty(object) {
        return _.reduce(object, function (res, value, key) {
            if (value) res[key] = value;
            return res;
        }, {});
    },

    firstNotEmpty: function firstNotEmpty() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        for (var i = 0; i < args.length; i++) {
            if (args[i]) return args[i];
        }

        return null;
    }
});

},{"./../vue/components.js":12}],9:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});
var client = new ClientJS();
// window.store = new Persist.Store('es');
// if (store.get('fp') == null) {
//     store.set('fp', client.getFingerprint());
// } else {
//     console.log(store.get('fp'))
// }
window.val = client.getFingerprint();
window.ec = new evercookie();
window.devicePrint = '';

window.bus = new Vue();
// ec.get("fingerprint", function (value) {
//     if (typeof value == 'undefined') {
//         ec.set("fingerprint", val);
//         window.devicePrint = val;
//     } else {
//         window.devicePrint = value;
//     }
// });

$(document).ready(function () {

    /**
     * move to previous scroll position
     */
    if (typeof Cookies.get('scrollY') !== 'undefined') {
        var _scrollY = Cookies.get('scrollY');
        if (Cookies.get('url') === window.location.href) {
            $('html, body').animate({
                scrollTop: _scrollY
            }, 2000);
        }
    }
    recordScrollPosition();
});

/**
 * record scroll position
 */
function recordScrollPosition() {
    $(window).scroll(function () {
        var scrolledVal = $(document).scrollTop().valueOf();
        Cookies.set('scrollY', scrolledVal);
        Cookies.set('url', window.location.href);
    });
}

var controllers = require('./vue/controllers');
var inittedControllers = {};
var notify = require('./mixed/notify');

var mountControllers = function mountControllers(selector) {
    $(selector).each(function (i, el) {
        var cName = $(el).attr('data-controller');
        el.id = _.randomStr();
        if (controllers[cName] === undefined) console.warn('Controller ' + cName + ' is not found');
        inittedControllers[cName] = new controllers[cName]({
            el: '#' + el.id
        });
    });
};

var unmountControllers = function unmountControllers(selector) {
    $(selector).each(function (i, el) {
        var cName = $(el).attr('data-controller');
        if (inittedControllers[cName] !== undefined) {
            inittedControllers[cName].$destroy(true);
        }
    });
};

var _exports = {
    libraries: function libraries() {
        window.placeholder = require('placeholder');
        window._ = require('lodash');
        require('./extensions/lodash');
    },

    vue: function vue() {
        Vue.http.headers.common['X-CSRF-TOKEN'] = document.querySelector('#token').getAttribute('content');

        // function refreshToken() {
        //   this.$http.get('/api/token', '', (response) => {
        //     $("#token").attr('content', response);
        //   }).always(() => {});
        // }

        // setInterval(refreshToken, 3600000);
        $('.modal').on('shown.bs.modal', function () {
            $(".focus-field").focus();
        });

        // set tab index
        $(":input:not(:hidden)").each(function (i) {
            $(this).attr('tabindex', i + 1);
        });
        Vue.http.options.beforeSend = function () {
            // ..
        };

        Vue.http.options.onComplete = function (req) {
            var exception;
            try {
                var res = JSON.parse(req.response);
            } catch (exception) {
                var res = {};
            }

            switch (req.status) {
                case 400:
                    if (res.error) notify.error(res.error);
                    break;
                case 422:

                    // show errors if server-side validation failed
                    notify.validation(res);
                    break;
                case 200:
                    if (res.status == 'ok' && res.success) {
                        notify.success(res.success);
                    }
                    break;

                case 500:
                    notify.error('Token Expired. Please refresh the page.');
                    break;

                case 404:
                    notify.error('Unable to find data');
                    break;
            }
        };

        require('./vue/init');

        mountControllers('[data-controller]');
    }

};

// onReady() {
//   var hash = window.location.hash;
//   if (hash) {
//     var $link = $(`a[href='${hash}']`);
//     if ($link.length) $link.click();
//   }
// },
exports['default'] = _exports;
module.exports = exports['default'];

},{"./extensions/lodash":8,"./mixed/notify":11,"./vue/controllers":96,"./vue/init":153,"lodash":1,"placeholder":2}],10:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = {

  showStrict: function showStrict(element) {
    $(element).modal({
      backdrop: 'static',
      keyboard: false
    });
  },

  show: function show(element) {
    $(element).modal('show');
  },

  hide: function hide(element) {
    $(element).modal('hide');
  }
};
module.exports = exports['default'];

},{}],11:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});
exports['default'] = {
    validation: function validation(messages) {
        var template = _.template('<ul class="list-unstyled">\n                    <% _.forEach(data, function(errors) { %>\n                        <% _.forEach(errors, function(error) {%>\n                        <li><%- error %></li>\n                        <% }); %>\n                    <% }); %>\n                </ul>');

        swal({
            title: 'Errors occurred!',
            text: template({
                data: messages
            }),
            html: true,
            type: 'warning',
            confirmButtonColor: '#DD6B55',
            confirmButtonText: 'Ok',
            closeOnConfirm: true
        });
    },

    error: function error(message) {
        var title = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1];

        swal({
            title: title ? title : 'Error occurred!',
            type: 'warning',
            text: message,
            html: true
        });
    },

    success: function success(message) {
        var title = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1];

        swal({
            text: message,
            title: title ? title : 'Success',
            type: 'success',
            html: true
        });
    },

    info: function info(message) {
        var title = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1];
        var location = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];

        swal({
            text: message,
            title: title,
            html: true
        }, function () {
            location ? window.location.href = location : '';
        });
    },

    confirm: function confirm(title, text, onConfirm) {
        swal({
            title: title,
            text: "You will not be able to recover this record!",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "No, cancel please!",
            closeOnConfirm: false,
            closeOnCancel: false
        }, function (isConfirm) {
            if (isConfirm) {
                onConfirm();
                swal("Deleted!", "Your record has been deleted.", "success");
            } else {
                swal("Cancelled", "Your data is safe :)", "error");
            }
        });
    },

    prompt: function prompt(title, text, onConfirm) {
        if (text === undefined) text = "You will not be able to undo this action!";

        swal({
            title: title,
            text: text,
            type: "info",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Yes",
            cancelButtonText: "No",
            closeOnConfirm: false,
            closeOnCancel: false
        }, function (isConfirm) {
            if (isConfirm) {
                onConfirm();
                swal("Done!", "", "success");
            } else {
                swal("Cancelled", "", "error");
            }
        });
    },

    promptArg: function promptArg(title, text, onConfirm) {
        if (text === undefined) text = "You will not be able to undo this action!";
        var param1 = arguments.length <= 3 || arguments[3] === undefined ? '' : arguments[3];
        var param2 = arguments.length <= 4 || arguments[4] === undefined ? '' : arguments[4];

        swal({
            title: title,
            html: title,
            text: text,
            type: "info",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Yes",
            cancelButtonText: "No",
            closeOnConfirm: false,
            closeOnCancel: false
        }, function (isConfirm) {
            if (isConfirm) {
                onConfirm(param1, param2);
                swal("Done!", "", "success");
            } else {
                swal("Cancelled", "", "error");
            }
        });
    },

    loading: function loading(status) {
        if (status) {
            $('body').addClass('loading');
        } else {
            $('body').removeClass('loading');
        }
    }
};
module.exports = exports['default'];

},{}],12:[function(require,module,exports){
'use strict';

Vue.component('completed-orders', require('./components/completedOrders.vue'));
Vue.component('employee-search-job', require('./components/employeeSearchJob.vue'));
Vue.component('accounting-scheduled-employees', require('./components/accounting-scheduled-employee.vue'));
Vue.component('accounting-collection-log', require('./components/acounting-collection-log.vue'));
Vue.component('data-entry', require('./components/data-entry.vue'));
Vue.component('accounting-entree-match', require('./components/accounting-entree-match.vue'));
Vue.component('data-entry-list', require('./components/data-entry-list.vue'));
Vue.component('scheduled-employees-error', require('./components/scheduled-employees-errors.vue'));
Vue.component('accounting-high-low', require('./components/accounting-high-low.vue'));
Vue.component('accounting-completed', require('./components/accounting-completed.vue'));
Vue.component('accounting-submitted-payroll', require('./components/accounting-submitted-payroll.vue'));
Vue.component('accounting-advanced-pay', require('./components/accounting-advanced-pay.vue'));
Vue.component('accounting-pending-payroll', require('./components/accounting-pending-payroll.vue'));
Vue.component('accounting-cash-paid', require('./components/accounting-cash-paid.vue'));
Vue.component('accounting-no-show', require('./components/accounting-no-show.vue'));
Vue.component('accounting-unscheduled-shifts', require('./components/accounting-unscheduled-shifts.vue'));
Vue.component('employee-report', require('./components/employee-report.vue'));
Vue.component('re-confirmed-employees', require('./components/re-confirmed-employees.vue'));
Vue.component('no-show-employees', require('./components/no-show-employees.vue'));
Vue.component('worked-employees', require('./components/worked-employees.vue'));
Vue.component('schedule-rule-report', require('./components/schedule-rule-report.vue'));
Vue.component('no-show-verification', require('./components/no-show-verification.vue'));
Vue.component('no-show-verification-updated', require('./components/no-show-verification-updated.vue'));
Vue.component('no-show-verification-approval', require('./components/no-show-verification-approval.vue'));
Vue.component('missing-timecards', require('./components/missing-timecards.vue'));
Vue.component('submitted-timecards', require('./components/submitted-timecards.vue'));
Vue.component('no-show-dispute', require('./components/no-show-dispute.vue'));
Vue.component('no-response-log', require('./components/no-response-log.vue'));
Vue.component('action-board-log', require('./components/action-board-log.vue'));
Vue.component('create-invoice', require('./components/create-invoice.vue'));
Vue.component('recent-invoices', require('./components/recent-invoices.vue'));
Vue.component('notes', require('./components/notes.vue'));
Vue.component('employee-performance-data', require('./components/employee-performance-data.vue'));
Vue.component('employee-no-job-offer-log', require('./components/no-job-offer-log.vue'));
Vue.component('no-show-conflicts', require('./components/no-show-conflicts.vue'));
Vue.component('time-sheet', require('./components/timesheet.vue'));
Vue.component('user-access', require('./components/user-access.vue'));
Vue.component('ab-call-log', require('./components/ab-call-log.vue'));
Vue.component('employee-status-log-report', require('./components/employee-status-log-report.vue'));
Vue.component('call-out-log', require('./components/call-out-log.vue'));
Vue.component('active-employee-list', require('./components/active-employee-list.vue'));
Vue.component('recruiter-board', require('./components/recruiter-board.vue'));
Vue.component('recruiment-verification-board', require('./components/recruiment-verification-board.vue'));
Vue.component('settings-employee', require('./components/settings-employee.vue'));
Vue.component('settings-client', require('./components/settings-client.vue'));
Vue.component('settings-time-clock', require('./components/settings-time-clock.vue'));
Vue.component('settings-time-clock-report-log', require('./components/settings-time-clock-report-log.vue'));
Vue.component('field-manager-nav', require('./components/field-manager-nav.vue'));
Vue.component('order', require('./components/order.vue'));
Vue.component('field-manager-dashboard', require('./components/field-manager-dashboard.vue'));
Vue.component('client-board', require('./components/client-board.vue'));
Vue.component('broadcast-sms', require('./components/broadcast-sms.vue'));
Vue.component('time-clock-accounting-team-1-pending', require('./components/time-clock-accounting-team-1-pending.vue'));
Vue.component('time-clock-accounting-team-1-on-the-clock', require('./components/time-clock-accounting-team-1-on-the-clock.vue'));
Vue.component('time-clock-accounting-pending-approval', require('./components/time-clock-accounting-pending-approval.vue'));
Vue.component('time-clock-accounting-team-2-pending', require('./components/time-clock-accounting-team-2-pending.vue'));
Vue.component('time-clock-accounting-team-1-processed', require('./components/time-clock-accounting-team-1-processed.vue'));
Vue.component('time-clock-accounting-team-2-processed', require('./components/time-clock-accounting-team-2-processed.vue'));
Vue.component('tickets-dashboard', require('./components/tickets-dashboard.vue'));
Vue.component('employee-history', require('./components/employee-history.vue'));
Vue.component('employee-details', require('./components/employee-details.vue'));
Vue.component('employee-image-review', require('./components/employee-image-review.vue'));
Vue.component('employee-image-review-processed', require('./components/employee-image-review-processed.vue'));

},{"./components/ab-call-log.vue":13,"./components/accounting-advanced-pay.vue":14,"./components/accounting-cash-paid.vue":15,"./components/accounting-completed.vue":16,"./components/accounting-entree-match.vue":17,"./components/accounting-high-low.vue":18,"./components/accounting-no-show.vue":19,"./components/accounting-pending-payroll.vue":20,"./components/accounting-scheduled-employee.vue":21,"./components/accounting-submitted-payroll.vue":22,"./components/accounting-unscheduled-shifts.vue":23,"./components/acounting-collection-log.vue":24,"./components/action-board-log.vue":25,"./components/active-employee-list.vue":26,"./components/broadcast-sms.vue":27,"./components/call-out-log.vue":30,"./components/client-board.vue":39,"./components/completedOrders.vue":40,"./components/create-invoice.vue":41,"./components/data-entry-list.vue":42,"./components/data-entry.vue":43,"./components/employee-details.vue":44,"./components/employee-history.vue":45,"./components/employee-image-review-processed.vue":46,"./components/employee-image-review.vue":47,"./components/employee-performance-data.vue":48,"./components/employee-report.vue":49,"./components/employee-status-log-report.vue":50,"./components/employeeSearchJob.vue":51,"./components/field-manager-dashboard.vue":52,"./components/field-manager-nav.vue":53,"./components/missing-timecards.vue":54,"./components/no-job-offer-log.vue":55,"./components/no-response-log.vue":56,"./components/no-show-conflicts.vue":57,"./components/no-show-dispute.vue":58,"./components/no-show-employees.vue":59,"./components/no-show-verification-approval.vue":60,"./components/no-show-verification-updated.vue":61,"./components/no-show-verification.vue":62,"./components/notes.vue":63,"./components/order.vue":64,"./components/re-confirmed-employees.vue":65,"./components/recent-invoices.vue":66,"./components/recruiment-verification-board.vue":67,"./components/recruiter-board.vue":68,"./components/schedule-rule-report.vue":69,"./components/scheduled-employees-errors.vue":70,"./components/settings-client.vue":71,"./components/settings-employee.vue":72,"./components/settings-time-clock-report-log.vue":73,"./components/settings-time-clock.vue":74,"./components/submitted-timecards.vue":75,"./components/tickets-dashboard.vue":86,"./components/time-clock-accounting-pending-approval.vue":87,"./components/time-clock-accounting-team-1-on-the-clock.vue":88,"./components/time-clock-accounting-team-1-pending.vue":89,"./components/time-clock-accounting-team-1-processed.vue":90,"./components/time-clock-accounting-team-2-pending.vue":91,"./components/time-clock-accounting-team-2-processed.vue":92,"./components/timesheet.vue":93,"./components/user-access.vue":94,"./components/worked-employees.vue":95}],13:[function(require,module,exports){
var __vueify_style__ = require("vueify-insert-css").insert("\ntable .header-fixed {\n  position: fixed;\n  top: 40px;\n  /*left: 0;*/\n  /*right: 0;*/\n  z-index: 1020; /* 10 less than .navbar-fixed to prevent any overlap */\n  border-bottom: 1px solid #d5d5d5;\n  -webkit-border-radius: 0;\n  -moz-border-radius: 0;\n  border-radius: 0;\n}\n\nthead {\n  background-color: #eaeaea;\n}\n\ntbody {\n  background-color: #fcfcfc;\n}\n\n.table-log tbody {\n  display: block;\n  max-height: 80vh;\n  overflow: auto;\n}\n\n.table-log thead,\n.table-log tbody tr {\n  display: table;\n  width: 100%;\n  table-layout: fixed;\n}\n\n.table-log thead th.name,\n.table-log tbody td.name {\n  width: 175px !important;\n}\n")
"use strict";

exports.__esModule = true;
var modals = require("./../../mixed/modals");
var notify = require("./../../mixed/notify");

exports["default"] = {
  data: function data() {
    return {
      state: false,
      employees: {},
      appEmployees: {},
      activeEmployee: {},
      sortOrders: true,
      sortKey: "action",
      employees: [],
      appEmployees: [],
      dates: {},
      currentTime: null
    };
  },
  props: ["app"],
  filters: {
    employeeName: function employeeName(val) {
      return val.split("-")[1];
    }
  },
  watch: {},
  ready: function ready() {
    //$(".table-log").fixedHeader();
    this.showTime();
    this.getNonAppCallLog();
  },
  events: {},
  methods: {
    showTime: function showTime() {
      this.currentTime = moment.utc().utcOffset("-0400").format("MMM D hh:mm A");
      setTimeout(this.showTime, 1000);
    },

    employeeClass: function employeeClass(orders) {
      var employeeOrders = _.cloneDeep(orders);
      var allData = _.filter(employeeOrders, function (order) {
        return order.date == moment().format("MMM D") || order.date == moment().add(1, "days").format("MMM D");
      });

      var className = "demo";
      var confirm = 0;
      var reConfirm = 0;
      var change = 0;
      var entered = "no";
      for (var j = 0; j < allData.length; j++) {
        for (var i = 0; i < allData[j].data.length; i++) {
          if (allData[j].data[i].status == "confirm") {
            confirm++;
          }
          if (allData[j].data[i].time_change || allData[j].data[i].time_conflict) {
            change++;
          }
        }
      }
      if (change) {
        className = "change";
      } else if (confirm) {
        className = "confirm";
      } else if (reConfirm) {
        className = "re-confirm";
      }
      return "employee-text-" + className;
    },

    getNonAppCallLog: function getNonAppCallLog() {
      var _this = this;

      notify.loading(true);
      this.$http.get("/api/ab-call-log?is_app=" + this.app, "", function (response) {
        _this.employees = response.employees;
        _this.dates = response.dates;
      }).always(function () {
        notify.loading(false);
      });
    },

    getAppCallLog: function getAppCallLog() {
      var _this2 = this;

      notify.loading(true);
      this.$http.get("/api/ab-call-log?is_app=1", "", function (response) {
        _this2.appEmployees = response.employees;
      }).always(function () {
        notify.loading(false);
      });
    },

    showEmployeeCalender: function showEmployeeCalender(val) {
      window.bus.$emit("showEmployeeRecords", val);
    }
  }
};
module.exports = exports["default"];
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n  <div class=\"row\">\n    <div class=\"col-md-12 no-padding\">\n      <h4 class=\"bg-black no-margin text-semibold pl-15 pr-15\">\n        <span class=\"text-left\">{{ app == 1 ? 'CALL LOG - APP USER':'CALL LOG - NON APP USER'}}</span>\n        <span class=\"pull-right\">{{ currentTime }}</span>\n      </h4>\n      <div class=\"table-responsive\">\n        <table class=\"table table-xxs table-bordered table-log\">\n          <thead class=\"header\">\n            <tr>\n              <th class=\"bg-slate-800 text-black text-left name\">Employee Name</th>\n              <th class=\"bg-slate-800 text-black\">Last Call</th>\n              <th class=\"bg-slate-800 text-black p-2\" v-for=\"(index,date) in dates\" :key=\"index\">{{{date}}}</th>\n            </tr>\n          </thead>\n          <tbody>\n            <tr v-for=\"(index,employee) in employees\" :key=\"index\">\n              <td class=\"text-black text-left cursor-pointer name\" :class=\"employeeClass(employee.allOrders)\" @click=\"showEmployeeCalender(employee.id)\">{{employee.first_name+' '+employee.last_name}}</td>\n              <td>\n                <span class=\"display-block text-center text-size-mini text-italic no-margin-bottom\">{{employee.responseTime}}</span>\n              </td>\n              <td v-for=\"(index,employeeOrder) in employee.allOrders\" :key=\"index\" class=\"p-2\">\n                <label v-for=\"(index,o) in employeeOrder.data\" :key=\"index\" class=\"display-block text-center text-size-mini text-black no-margin-bottom\" :class=\"'text-'+o.status\">\n                  {{ o.company_code }}\n                  <span v-show=\"o.time_change || o.time_conflict || o.job_canceled\">\n                    (\n                    <span v-show=\"o.time_change\" class=\"text-danger-300 font-9\">T</span>\n                    <span v-show=\"o.time_conflict\" class=\"text-danger-300 font-9\">C</span>\n                    <span v-show=\"o.job_canceled\" class=\"text-danger-300 font-9\">D</span>\n                    )\n                  </span>\n                </label>\n              </td>\n            </tr>\n          </tbody>\n        </table>\n      </div>\n    </div>\n  </div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  var id = "/home/shoieb/sites/elegant/resources/assets/js/vue/components/ab-call-log.vue"
  module.hot.dispose(function () {
    require("vueify-insert-css").cache["\ntable .header-fixed {\n  position: fixed;\n  top: 40px;\n  /*left: 0;*/\n  /*right: 0;*/\n  z-index: 1020; /* 10 less than .navbar-fixed to prevent any overlap */\n  border-bottom: 1px solid #d5d5d5;\n  -webkit-border-radius: 0;\n  -moz-border-radius: 0;\n  border-radius: 0;\n}\n\nthead {\n  background-color: #eaeaea;\n}\n\ntbody {\n  background-color: #fcfcfc;\n}\n\n.table-log tbody {\n  display: block;\n  max-height: 80vh;\n  overflow: auto;\n}\n\n.table-log thead,\n.table-log tbody tr {\n  display: table;\n  width: 100%;\n  table-layout: fixed;\n}\n\n.table-log thead th.name,\n.table-log tbody td.name {\n  width: 175px !important;\n}\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, module.exports.template)
  }
})()}
},{"./../../mixed/modals":10,"./../../mixed/notify":11,"vue":5,"vue-hot-reload-api":4,"vueify-insert-css":6}],14:[function(require,module,exports){
"use strict";

exports.__esModule = true;
var modals = require("./../../mixed/modals");
var notify = require("./../../mixed/notify");
exports["default"] = {
  data: function data() {
    return {
      employees: {}
    };
  },
  filters: {
    totalAmount: function totalAmount(employees) {
      var amount = null;
      _.forEach(employees, function (employee) {
        amount = Number(amount) + Number((Number(employee.duration) / 60).toFixed(2) * employee.rate);
      });
      return amount.toFixed(2);
    }
  },
  watch: {},
  ready: function ready() {
    this.fetchSubmittedPayroll();
    var that = this;
    window.bus.$on("refreshAdvancedPay", function () {
      that.fetchSubmittedPayroll();
    });
  },
  events: {
    refreshData: function refreshData() {
      console.log("refreshed accounting completed");
    }
  },
  methods: {
    /**
     * fetch data for data-entry forms
     */
    fetchSubmittedPayroll: function fetchSubmittedPayroll() {
      var _this = this;

      this.$http.get("/api/accounting-advanced-pay", "", function (response) {
        _this.employees = _.groupBy(response.employees, function (value) {
          return value.employee_id;
        });
      }).always(function () {});
    }
  },
  props: ["bg"]
};
module.exports = exports["default"];
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n  <div class=\"row\">\n    <div class=\"col-md-12 table-body\">\n      <h5 class=\"text-center no-margin-top no-margin-bottom bg-primary-300 text-black text-color-black\">ADVANCED PAY</h5>\n      <div class=\"table-responsive\">\n        <table class=\"table table-xxs table-bordered\">\n          <thead>\n            <tr>\n              <th class=\"bg-black col-md-1\">Client</th>\n              <th class=\"bg-black col-md-1\">Job</th>\n              <th class=\"bg-black col-md-1\">ID</th>\n              <th class=\"bg-black col-md-2\">Name</th>\n              <th class=\"bg-black col-md-1\">Date</th>\n              <th class=\"bg-black col-md-1\">Hour</th>\n              <th class=\"bg-black col-md-1\">Reg/OT</th>\n              <th class=\"bg-black col-md-1\">Rate</th>\n              <th class=\"bg-black col-md-1\">Amount</th>\n              <th class=\"bg-black col-md-1\"></th>\n              <th class=\"bg-black col-md-2\"></th>\n            </tr>\n          </thead>\n          <tbody v-for=\"emp in employees\">\n            <tr v-for=\"employee in emp\">\n              <td class=\"col-md-1\">{{ employee.name}}</td>\n              <td class=\"col-md-1\">{{ employee.title }}</td>\n              <td class=\"col-md-1\">{{ employee.employee_code }}</td>\n              <td class=\"col-md-2\">{{ employee.first_name + ' ' + employee.last_name }}</td>\n              <td class=\"col-md-1\">{{ employee.date }}</td>\n              <td class=\"col-md-1\">{{ employee.duration | minuteToHour }}</td>\n              <td class=\"col-md-1\">Reg</td>\n              <td class=\"col-md-1\">{{ employee.rate }}</td>\n              <td class=\"col-md-1\">\n                {{ employee.duration | amountPaid\n                employee.rate }}\n              </td>\n              <td class=\"col-md-1\"></td>\n              <td class=\"col-md-2\">{{ employee.advanced_pay_note }}</td>\n            </tr>\n            <tr>\n              <td class=\"col-md-1\"></td>\n              <td class=\"col-md-1\"></td>\n              <td class=\"col-md-1\"></td>\n              <td class=\"col-md-2\"></td>\n              <td class=\"col-md-1\"></td>\n              <td class=\"col-md-1\"></td>\n              <td class=\"col-md-1\"></td>\n              <td class=\"col-md-1 text-black text-color-black\">Total Paid</td>\n              <td class=\"col-md-1 text-black text-color-black\">{{ emp | totalAmount }}</td>\n              <td class=\"col-md-2\">\n                <span class=\"text-primary-300 text-black\">Paid</span>\n              </td>\n            </tr>\n          </tbody>\n        </table>\n      </div>\n    </div>\n  </div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  var id = "/home/shoieb/sites/elegant/resources/assets/js/vue/components/accounting-advanced-pay.vue"
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, module.exports.template)
  }
})()}
},{"./../../mixed/modals":10,"./../../mixed/notify":11,"vue":5,"vue-hot-reload-api":4}],15:[function(require,module,exports){
'use strict';

exports.__esModule = true;
var modals = require('./../../mixed/modals');
var notify = require('./../../mixed/notify');
exports['default'] = {
    data: function data() {
        return {
            employees: {},
            clients: {},
            entry: {
                client_id: '',
                employee_id: 0,
                date: '',
                amount: ''
            }
        };
    },
    filters: {},
    watch: {

        'activeClient': function activeClient() {
            $('#position-code').selectric('refresh');
        },

        'clients': function clients() {
            $('#data-entry-client').selectric('refresh');
        }
    },
    ready: function ready() {
        this.fetchDataEntryData();
    },
    events: {},
    methods: {
        /**
         * fetch data for data-entry forms
         */
        fetchDataEntryData: function fetchDataEntryData() {
            var _this = this;

            this.$http.get('/api/data-entry-data?team=' + this.team, '', function (response) {
                _this.employees = response.employees;
                _this.clients = response.clients;
            }).always(function () {});
        },

        /**
         * clear the entry data on modal close
         */
        clearEntryData: function clearEntryData() {
            this.entry = {
                client_id: '',
                employee_id: '',
                date: '',
                amount: ''
            };
        }
    },
    props: ['team']
};
module.exports = exports['default'];
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n    <div class=\"row\">\n        <div class=\"col-md-12 no-padding\">\n            <h4 class=\"bg-green-600 text-center no-margin-top no-margin-bottom text-capitalize\">Cash Paid Entry</h4>\n            <div class=\"col-md-12 grey-bg-200\">\n                <div class=\"row\">\n                    <div class=\"col-md-12\">\n                        <div class=\"col-md-6 padding-top-2\">\n                            <div class=\"form-group\">\n                                <label>Client:</label>\n                                <select name=\"\" id=\"data-entry-client\" class=\"form-control select2\" v-model=\"entry.client_id\" v-vue-selectric=\"entry.client_id\">\n                                    <option value=\"\">Client</option>\n                                    <option v-for=\"client in clients\" :value=\"client.id\">{{ client.name }}\n                                    </option>\n                                </select>\n                            </div>\n                        </div>\n                        <div class=\"col-md-6\">\n                            <div class=\"form-group\">\n                                <label>Date:</label>\n                                <input type=\"text\" name=\"username\" v-model=\"entry.date\" class=\"form-control pickadate-year-normal text-black\" required=\"required\">\n                            </div>\n                        </div>\n                    </div>\n\n                    <div class=\"col-md-12\">\n                        <div class=\"col-md-6\">\n                            <div class=\"form-group\">\n                                <label>Employee Name:</label>\n                                <select name=\"\" id=\"\" class=\"form-control select2\" v-model=\"entry.employee_id\" v-select-no-parse=\"entry.employee_id\">\n                                    <option value=\"0\"> Employee</option>\n                                    <optgroup v-for=\"(index,emp) in employees\" label=\"{{ index }}\">\n                                        <option v-for=\"e in emp\" value=\"{{ e.id }}\">{{ e.fullName }}</option>\n                                    </optgroup>\n                                </select>\n                            </div>\n                        </div>\n                        <div class=\"col-md-6\">\n                            <div class=\"form-group\">\n                                <label>Amount:</label>\n                                <input type=\"text\" name=\"username\" v-model=\"entry.amount\" class=\"form-control text-black\" required=\"required\">\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"col-md-12\">\n                        <div class=\"col-md-12 form-group\">\n                            <label>Note:</label>\n                            <textarea v-model=\"entry.note\" name=\"\" id=\"entry-note\" cols=\"30\" rows=\"5\" class=\"form-control\"></textarea>\n                        </div>\n                    </div>\n                </div>\n                <button type=\"button\" class=\"btn btn-primary pull-right mr-15 mb-20\" v-on:click=\"create\">Submit\n                </button>\n            </div>\n        </div>\n        <div class=\"col-md-12 no-padding mb-20\">\n            <table class=\"table table-xxs table-bordered\">\n                <thead>\n                <tr>\n                    <th class=\"bg-black col-md-2\">Note</th>\n                    <th class=\"bg-black col-md-3\">Employee</th>\n                    <th class=\"bg-black col-md-3\">Client</th>\n                    <th class=\"bg-black col-md-2\">Date</th>\n                    <th class=\"bg-black col-md-2\">Amount</th>\n                </tr>\n                </thead>\n                <tbody>\n\n                </tbody>\n            </table>\n        </div>\n\n        <div class=\"col-md-12 no-padding mt-20\">\n            <h4 class=\"bg-grey-600 text-center no-margin-top no-margin-bottom text-capitalize\">Previous Cash Paid</h4>\n        </div>\n    </div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  var id = "/home/shoieb/sites/elegant/resources/assets/js/vue/components/accounting-cash-paid.vue"
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, module.exports.template)
  }
})()}
},{"./../../mixed/modals":10,"./../../mixed/notify":11,"vue":5,"vue-hot-reload-api":4}],16:[function(require,module,exports){
"use strict";

exports.__esModule = true;
var modals = require("./../../mixed/modals");
var notify = require("./../../mixed/notify");
exports["default"] = {
  data: function data() {
    return {
      employees: {},
      scheduledEmployees: {},
      activeEmployee: {},
      clients: {},
      activeClient: {},
      entryEmployees: {},
      allEmployees: {},
      entry: {
        client_id: "",
        employee_id: 0,
        position_code: "",
        in_time: "",
        out_time: "",
        date: "",
        break_time: "",
        note: "",
        team: 1,
        duration: ""
      },
      ids: [],
      note: null,
      selectAll: 0,
      amount: null
    };
  },
  filters: {},
  watch: {
    selectAll: function selectAll(val) {
      if (val) {
        this.ids = _.pluck(this.entryEmployees, "accounting_data_entry_id").map(Number);
      } else {
        this.ids = [];
      }
    },
    "entry.client_id": function entryClient_id(val) {
      this.activeClient = _.clone(_.find(this.clients, function (o) {
        return o.id == val;
      }));
    },
    activeClient: function activeClient() {
      $("#position-code").selectric("refresh");
    },
    clients: function clients() {
      $("#data-entry-client").selectric("refresh");
    },
    employee: function employee(val) {
      var employees = _.cloneDeep(this.allEmployees);
      if (val) {
        this.entryEmployees = employees.filter(function (employee) {
          var name = employee.first_name + " " + employee.last_name;
          return name.indexOf(val) !== -1 || name.toLowerCase().indexOf(val) !== -1;
        });
      } else {
        this.entryEmployees = employees;
      }
    }
  },
  ready: function ready() {
    this.fetchDataEntryLists();
    var that = this;
    window.bus.$on("refreshCompleted", function () {
      that.fetchDataEntryLists();
    });
  },
  events: {
    refreshData: function refreshData() {
      console.log("refreshed accounting completed");
    }
  },
  methods: {
    isNumber: function isNumber(n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    },

    /**
     * fetch data for data-entry forms
     */
    fetchDataEntryLists: function fetchDataEntryLists() {
      var _this = this;

      this.$http.get("/api/accounting-completed", "", function (response) {
        _this.scheduledEmployees = response.scheduledEmployees;
        _this.entryEmployees = response.entryEmployees;
        _this.allEmployees = response.entryEmployees;
      }).always(function () {});
    },

    /**
     * show note modal
     */
    showNoteModal: function showNoteModal(employee) {
      this.activeEmployee = employee;
      modals.showStrict("#advanced-pay-modal");
    },

    /**
     * process advanced pay
     */
    processAdvancedPay: function processAdvancedPay() {
      var _this2 = this;

      if (!this.note || !this.amount || !this.isNumber(this.amount)) {
        notify.info("Please insert both amount and note");
        return false;
      }
      var data = {
        id: this.activeEmployee.accounting_data_entry_id,
        note: this.note,
        amount: this.amount
      };
      this.$http.post("/api/accounting-advanced-pay", data, function (response) {
        _this2.note = "";
        modals.hide("#advanced-pay-modal");
        _this2.fetchDataEntryLists();
        window.bus.$emit("refreshAdvancedPay");
        window.bus.$emit("refreshSubmittedPayroll");
      }).always(function () {});
    },

    /**
     * submit payrolls
     */
    submitPayroll: function submitPayroll() {
      var _this3 = this;

      this.$http.post("/api/accounting-submit-payroll", { ids: this.ids }, function (response) {
        _this3.fetchDataEntryLists();
        window.bus.$emit("refreshPendingPayroll");
      }).always(function () {});
    }
  },
  props: ["bg"]
};
module.exports = exports["default"];
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n  <div class=\"row\">\n    <div class=\"col-md-12 table-body\">\n      <div class=\"row mb-10\">\n        <div class=\"col-md-4\"></div>\n        <div class=\"col-md-2\">\n          <input type=\"text\" class=\"form-control\" v-model=\"employee\" placeholder=\"Search\">\n        </div>\n        <div class=\"col-md-4\"></div>\n      </div>\n      <div class=\"table-responsive\">\n        <table class=\"table table-xxs table-bordered\">\n          <thead>\n            <tr>\n              <th class=\"col-md-1 text-left\">\n                <input type=\"checkbox\" name=\"\" v-model=\"selectAll\" id=\"select-all\">\n              </th>\n              <th class=\"bg-black col-md-1\">Client</th>\n              <th class=\"bg-black col-md-1\">Date</th>\n              <th class=\"bg-black col-md-1\">Job</th>\n              <th class=\"bg-black col-md-2\">Employee Name</th>\n              <th class=\"bg-danger col-md-1\">In</th>\n              <th class=\"bg-danger col-md-1\">Out</th>\n              <th class=\"bg-danger col-md-1\">Break</th>\n              <th class=\"bg-danger col-md-1\">Total Hour</th>\n              <th class=\"bg-black col-md-1\">Reg/OT</th>\n              <th class=\"bg-success-600 col-md-1\">Rate</th>\n              <th class=\"bg-success-600 col-md-1\">Advance Pay</th>\n            </tr>\n          </thead>\n          <tbody>\n            <tr v-for=\"employee in entryEmployees\">\n              <td class=\"col-md-1\">\n                <input type=\"checkbox\" name=\"\" id=\"\" v-model=\"ids\" :value=\"employee.accounting_data_entry_id\">\n              </td>\n              <td class=\"col-md-1\">{{ employee.name }}</td>\n              <td class=\"col-md-1\">{{ employee.date | customDateFormat 'YYYY-MM-DD' 'DD - MMM' }}</td>\n              <td class=\"col-md-1\">{{ employee.title }}</td>\n              <td class=\"col-md-2\">{{ employee.first_name + ' ' + employee.last_name}}</td>\n              <td class=\"col-md-1\">{{ employee.in_time }}</td>\n              <td class=\"col-md-1\">{{ employee.out_time }}</td>\n              <td class=\"col-md-1\">{{ employee.break_time }}</td>\n              <td class=\"col-md-1\">{{ employee.duration_team_2 | minuteToHour}}</td>\n              <td class=\"col-md-1\">Reg</td>\n              <td class=\"col-md-1\">{{ employee.rate }}</td>\n              <td class=\"col-md-1\">\n                <a href=\"#\" class=\"label label-flat text-primary-600 text-bold\" v-on:click=\"showNoteModal(employee)\">Pay Now</a>\n              </td>\n            </tr>\n          </tbody>\n        </table>\n        <button class=\"btn btn-primary btn btn-primary pull-right mt-20\" v-on:click=\"submitPayroll\">Submit</button>\n      </div>\n    </div>\n\n    <div class=\"modal fade\" id=\"advanced-pay-modal\">\n      <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n          <div class=\"modal-header\">\n            <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\">×</button>\n            <h4 class=\"modal-title\">{{ activeEmployee.first_name + ' ' + activeEmployee.last_name}} - Advanced Pay - Note</h4>\n          </div>\n          <div class=\"modal-body\">\n            <div class=\"col-md-12\">\n              <div class=\"col-md-4 no-padding\">\n                <span class=\"text-black\">Rate:</span>\n                {{ activeEmployee.rate }}\n              </div>\n              <div class=\"col-md-4 no-padding\">\n                <span class=\"text-black\">Hour:</span>\n                {{ activeEmployee.duration_team_2 | minuteToHour }}\n              </div>\n              <div class=\"col-md-4 no-padding\">\n                <span class=\"text-black\">Amount:</span>\n                {{ (activeEmployee.duration_team_2/60)*activeEmployee.rate }}\n              </div>\n            </div>\n            <hr>\n            <div class=\"col-md-12\">\n              <div class=\"form-group\">\n                <label for=\"amount\">Amount</label>\n                <input type=\"text\" class=\"form-control\" name=\"amount\" id=\"amount\" v-model=\"amount\">\n              </div>\n            </div>\n            <div class=\"col-md-12\">\n              <div class=\"form-group\">\n                <label>Note:</label>\n                <textarea v-model=\"note\" name=\"\" id=\"entry-note\" cols=\"30\" rows=\"5\" class=\"form-control\"></textarea>\n              </div>\n            </div>\n          </div>\n          <div class=\"modal-footer\">\n            <button type=\"button\" class=\"btn btn-primary mr-10\" v-on:click=\"processAdvancedPay\">Submit</button>\n          </div>\n        </div>\n        <!-- /.modal-content -->\n      </div>\n      <!-- /.modal-dialog -->\n    </div>\n    <!-- /.modal -->\n  </div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  var id = "/home/shoieb/sites/elegant/resources/assets/js/vue/components/accounting-completed.vue"
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, module.exports.template)
  }
})()}
},{"./../../mixed/modals":10,"./../../mixed/notify":11,"vue":5,"vue-hot-reload-api":4}],17:[function(require,module,exports){
var __vueify_style__ = require("vueify-insert-css").insert("\n.table-body {\n  height: 650px;\n  overflow-y: scroll;\n}\n")
"use strict";

exports.__esModule = true;
var modals = require("./../../mixed/modals");
var notify = require("./../../mixed/notify");

exports["default"] = {
  data: function data() {
    return {
      employees: {},
      activeEmployee: {},
      listedJobs: [],
      entryDelay: entryDelay,
      entreeMatchStartDate: moment().format("YYYY-MM-DD")
    };
  },
  filters: {},
  ready: function ready() {
    var _this = this;

    if (typeof Cookies.get("entreeMatchStartDate") === "undefined") {
      Cookies.set("entreeMatchStartDate", moment().format("YYYY-MM-DD"));
    } else {
      this.entreeMatchStartDate = Cookies.get("entreeMatchStartDate");
    }

    this.fetchScheduledEmployees();
    window.bus.$on("refreshEntreeMatchData", function () {
      _this.fetchScheduledEmployees();
    });
  },
  events: {
    refreshData: function refreshData() {
      console.log("refreshed accounting entree match");
    }
  },
  methods: {
    /**
     * set date for previous week and fetch orders
     */
    prevWeek: function prevWeek() {
      this.entreeMatchStartDate = moment(this.entreeMatchStartDate, "YYYY-MM-DD").subtract(7, "days").format("YYYY-MM-DD");
      Cookies.set("entreeMatchStartDate", this.entreeMatchStartDate);
      this.fetchScheduledEmployees();
    },

    /**
     * set date for next week and fetch data
     */
    nextWeek: function nextWeek() {
      this.entreeMatchStartDate = moment(this.entreeMatchStartDate, "YYYY-MM-DD").add(7, "days").format("YYYY-MM-DD");
      Cookies.set("entreeMatchStartDate", this.entreeMatchStartDate);
      this.fetchScheduledEmployees();
    },

    /**
     * fetch scheduled employees for the current week
     */
    fetchScheduledEmployees: function fetchScheduledEmployees() {
      var _this2 = this;

      this.$http.get("/api/accounting-entree-match?entreeMatchStartDate=" + Cookies.get("entreeMatchStartDate"), "", function (response) {
        _this2.employees = _.groupBy(response.employees, function (value) {
          return value.name + " --- " + value.department_name;
        });
        _this2.listedJobs = response.listedJobs;
      }).always(function () {
        //window.bus.$emit('refreshData');
      });
    },

    /**
     * set the active employee
     * @param employee
     */
    setEmployee: function setEmployee(employee) {
      this.activeEmployee = employee;
    },

    editEntryMatch: function editEntryMatch(employee) {
      this.activeEmployee = _.cloneDeep(employee);
      modals.showStrict("#modal-edit-entry-match");
    }
  }
};
module.exports = exports["default"];
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n  <div class=\"row\">\n    <div class=\"col-md-12\">\n      <div class=\"col-md-1 text-center\">\n        <i class=\"fa fa-angle-double-left font-40 cursor-pointer text-default\" v-on:click=\"prevWeek\"></i>\n      </div>\n      <div class=\"col-md-10\"></div>\n      <div class=\"col-md-1 text-center\">\n        <i class=\"fa fa-angle-double-right font-40 cursor-pointer text-default\" v-on:click=\"nextWeek\"></i>\n      </div>\n    </div>\n    <div class=\"col-md-12\">\n      <div class=\"col-md-12 no-padding\">\n        <div class=\"bg-black col-md-2 p-5\">Client</div>\n        <div class=\"bg-black col-md-1 p-5\">Date</div>\n        <div class=\"bg-black col-md-2 p-5\">Job</div>\n        <div class=\"bg-black col-md-3 p-5\">Employee</div>\n        <div class=\"bg-danger col-md-1 p-5\">Team - 1</div>\n        <div class=\"bg-danger col-md-1 p-5\">UNSCHEDULED</div>\n        <div class=\"bg-danger col-md-1 p-5\">Team - 2</div>\n        <div class=\"bg-danger col-md-1 p-5\">Check</div>\n      </div>\n      <div class=\"col-md-12 no-padding\">\n        <div class=\"table-responsive\">\n          <table class=\"table table-xxs table-fixed table-bordered\">\n            <tbody v-for=\"(index, groups) in employees\">\n              <tr class=\"\">\n                <td colspan=\"7\" class=\"col-md-12\"></td>\n              </tr>\n              <tr v-for=\"employee in groups\">\n                <td class=\"col-md-2\">{{ employee.company_code }}</td>\n                <td class=\"col-md-1\">\n                  {{ employee.date | customDateFormat\n                  'YYYY-MM-DD'\n                  'DD - MMM' }}\n                </td>\n                <td class=\"col-md-2\">{{ employee.title }}</td>\n                <td class=\"col-md-3\" v-bind:class=\"[!employee.employee_order_id ? 'error' : '']\">{{ employee.first_name + ' ' + employee.last_name }}</td>\n                <td class=\"col-md-1 text-center\">\n                  <!--<i v-if=\"employee.data_entry_team_1 == 1 || employee.team == 1\"-->\n                  <!--class=\"glyphicon glyphicon-ok text-blue\"></i>-->\n                  {{ (employee.duration/60).toFixed(2) }}\n                </td>\n                <td class=\"col-md-1 text-center\">\n                  <i v-if=\"!employee.employee_order_id\" class=\"fa fa-circle text-danger\"></i>\n                </td>\n                <td class=\"col-md-1 text-center\">{{ employee.duration_team_2?(employee.duration_team_2/60).toFixed(2):'' }}</td>\n                <td class=\"col-md-1 text-center\">\n                  <button type=\"button\" class=\"btn btn-primary text-uppercase text-bold\" @click=\"editEntryMatch(employee)\">Check</button>\n                </td>\n              </tr>\n            </tbody>\n          </table>\n        </div>\n      </div>\n    </div>\n    <div class=\"col-md-12 pt-15\">\n      <button type=\"button\" class=\"btn btn-primary pull-right\">Submit</button>\n    </div>\n\n    <div class=\"modal fade\" id=\"modal-edit-entry-match\">\n      <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n          <div class=\"modal-header bg-blue\">\n            <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\">×</button>\n            <h4 class=\"modal-title text-black text-center\">Correction</h4>\n          </div>\n          <div class=\"modal-body\">\n            <table class=\"table table-xxs table-fixed\">\n              <tbody>\n                <tr>\n                  <td class=\"text-right\">Client:</td>\n                  <td>{{activeEmployee.name}}</td>\n                  <td></td>\n                  <td></td>\n                </tr>\n                <tr>\n                  <td class=\"text-right\">Date:</td>\n                  <td>{{activeEmployee.date}}</td>\n                  <td></td>\n                  <td></td>\n                </tr>\n                <tr>\n                  <td class=\"text-right\">Employee:</td>\n                  <td>{{activeEmployee.first_name+' '+activeEmployee.last_name}}</td>\n                  <td></td>\n                  <td></td>\n                </tr>\n              </tbody>\n            </table>\n            <table class=\"table table-xxs table-fixed\">\n              <thead>\n                <tr class=\"bg-grey-300\">\n                  <th class=\"text-center\"></th>\n                  <th class=\"text-center\">Schedule</th>\n                  <th class=\"text-center\">Team - 1</th>\n                  <th class=\"text-center\">Team - 2</th>\n                </tr>\n              </thead>\n              <tbody>\n                <tr>\n                  <td class=\"text-center\">Job:</td>\n                  <td class=\"text-center\">{{activeEmployee.title}}</td>\n                  <td class=\"text-center\">{{activeEmployee.title}}</td>\n                  <td class=\"text-center\">{{activeEmployee.title}}</td>\n                </tr>\n                <tr>\n                  <td class=\"text-center\">Time:</td>\n                  <td class=\"text-center\"></td>\n                  <td class=\"text-center\">{{activeEmployee.in_time +'-'+ activeEmployee.out_time}}</td>\n                  <td class=\"text-center\">{{ (activeEmployee.duration_team_2/60).toFixed(2) }}</td>\n                </tr>\n              </tbody>\n            </table>\n          </div>\n          <div class=\"modal-footer\">\n            <button type=\"button\" class=\"btn btn-primary\">Submit</button>\n          </div>\n        </div>\n        <!-- /.modal-content -->\n      </div>\n      <!-- /.modal-dialog -->\n    </div>\n    <!-- /.modal -->\n  </div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  var id = "/home/shoieb/sites/elegant/resources/assets/js/vue/components/accounting-entree-match.vue"
  module.hot.dispose(function () {
    require("vueify-insert-css").cache["\n.table-body {\n  height: 650px;\n  overflow-y: scroll;\n}\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, module.exports.template)
  }
})()}
},{"./../../mixed/modals":10,"./../../mixed/notify":11,"vue":5,"vue-hot-reload-api":4,"vueify-insert-css":6}],18:[function(require,module,exports){
'use strict';

exports.__esModule = true;
var modals = require('./../../mixed/modals');
var notify = require('./../../mixed/notify');
exports['default'] = {
    data: function data() {
        return {
            employees: {},
            scheduledEmployees: {},
            activeEmployee: {},
            clients: {},
            activeClient: {},
            entryEmployees: {},
            entry: {
                client_id: '',
                employee_id: 0,
                position_code: '',
                in_time: '',
                out_time: '',
                date: '',
                break_time: '',
                note: '',
                team: 1,
                duration: ''
            }
        };
    },
    filters: {},
    watch: {
        'entry.client_id': function entryClient_id(val) {
            this.activeClient = _.clone(_.find(this.clients, function (o) {
                return o.id == val;
            }));
        },

        'activeClient': function activeClient() {
            $('#position-code').selectric('refresh');
        },

        'clients': function clients() {
            $('#data-entry-client').selectric('refresh');
        }
    },
    ready: function ready() {
        this.fetchDataEntryLists();
        window.bus.$on('refreshData', function () {
            alert('high-low');
        });
    },
    events: {
        refreshData: function refreshData() {
            console.log('refreshed accounting high low');
        }
    },
    methods: {
        /**
         * fetch data for data-entry forms
         */
        fetchDataEntryLists: function fetchDataEntryLists() {
            var _this = this;

            this.$http.get('/api/accounting-high-low', '', function (response) {
                _this.scheduledEmployees = response.scheduledEmployees;
                _this.entryEmployees = response.entryEmployees;
            }).always(function () {});
        },

        approveEntry: function approveEntry(id) {
            var _this2 = this;

            this.$http.post('/api/accounting-high-low-approve/' + id, '', function (response) {
                _this2.fetchDataEntryLists();
                window.bus.$emit('refreshCompleted');
            }).always(function () {});
        }
    },
    props: ['bg']
};
module.exports = exports['default'];
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n    <div class=\"row\">\n        <div class=\"col-md-12 table-body\">\n            <!--<h5 :class=\"bg\" class=\"text-center no-margin-top no-margin-bottom\">Entry By Team - {{ team }}</h5>-->\n            <div class=\"table-responsive\">\n                <table class=\"table table-xxs table-bordered\">\n                    <thead>\n                    <tr>\n                        <th class=\"bg-black col-md-2\">Client</th>\n                        <th class=\"bg-black col-md-1\">Date</th>\n                        <th class=\"bg-black col-md-1\">Job</th>\n                        <th class=\"bg-black col-md-2\">Employee Name</th>\n                        <th class=\"bg-danger col-md-1\">In</th>\n                        <th class=\"bg-danger col-md-1\">Out</th>\n                        <th class=\"bg-danger col-md-1\">Break</th>\n                        <th class=\"bg-danger col-md-1\">Total Hour</th>\n                        <th class=\" col-md-1\"></th>\n                        <th class=\" col-md-1\"></th>\n                    </tr>\n                    </thead>\n                    <tbody>\n                    <tr v-for=\"employee in entryEmployees\">\n                        <td class=\"col-md-2\">{{ employee.name }}</td>\n                        <td class=\"col-md-1\">{{ employee.date | customDateFormat 'YYYY-MM-DD' 'DD - MMM' }}</td>\n                        <td class=\"col-md-1\">{{ employee.title }}</td>\n                        <td class=\"col-md-2\">\n                            {{ employee.first_name + ' ' + employee.last_name}}\n                        </td>\n                        <td class=\"col-md-1\">{{ employee.in_time }}</td>\n                        <td class=\"col-md-1\">{{ employee.out_time }}</td>\n                        <td class=\"col-md-1\">{{ employee.break_time }}</td>\n                        <td class=\"col-md-1\" v-bind:class=\"[employee.duration_team_2 < 180 ? 'bg-grey-300' : '',employee.duration_team_2 > 720 ? 'bg-pink-300' : '']\">\n                            {{ employee.duration | minuteToHour}}\n                        </td>\n                        <td class=\"col-md-1\">\n                            <button class=\"btn btn-primary btn-xs\" v-on:click=\"approveEntry(employee.entry_id)\">\n                                Approve\n                            </button>\n                        </td>\n                        <td class=\"col-md-1\">\n                            <button class=\"btn btn-Danger btn-xs\">Edit</button>\n                        </td>\n                    </tr>\n                    </tbody>\n                </table>\n            </div>\n        </div>\n    </div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  var id = "/home/shoieb/sites/elegant/resources/assets/js/vue/components/accounting-high-low.vue"
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, module.exports.template)
  }
})()}
},{"./../../mixed/modals":10,"./../../mixed/notify":11,"vue":5,"vue-hot-reload-api":4}],19:[function(require,module,exports){
var __vueify_style__ = require("vueify-insert-css").insert("\n.table-body {\n  height: 650px;\n  overflow-y: scroll;\n}\n")
"use strict";

exports.__esModule = true;
var modals = require("./../../mixed/modals");
var notify = require("./../../mixed/notify");

exports["default"] = {
  data: function data() {
    return {
      employees: {},
      activeEmployee: {},
      pastEmployees: {},
      responses: [],
      noShow: {
        reason: "",
        confirmed: "",
        action: "",
        action_count_calls: null,
        action_count_days: null
      }
    };
  },

  ready: function ready() {
    var _this = this;

    this.fetchNoShowList();
    window.bus.$on("refreshScheduledEmployeeError", function () {
      _this.fetchNoShowList();
    });
  },

  events: {},

  methods: {
    noShowModal: function noShowModal(employee) {
      var _this2 = this;

      notify.loading(true);
      this.$http.get("/api/accounting-no-show/" + employee.id, "", function (response) {
        var lists = _.groupBy(response, function (data) {
          return data.confirmed;
        });
        _this2.activeEmployee = lists[0];
        _this2.pastEmployees = lists[1];
        modals.showStrict("#no-show-modal");
      }).always(function () {
        notify.loading(false);
      });
    },

    fetchNoShowList: function fetchNoShowList() {
      var _this3 = this;

      this.$http.get("/api/accounting-no-show", "", function (response) {
        _this3.employees = response;
      }).always(function () {});
    },

    formattedText: function formattedText(employee) {
      var text = "";

      text += '<div class="col-md-4">' + employee.client_name + "</div>";
      text += '<div class="col-md-4">' + moment(employee.date, "yyyy-mm-dd").format("ddd DD/MM/YY") + "</div>";
      text += '<div class="col-md-2">' + employee.title + "</div>";
      text += '<div class="col-md-2">' + moment(employee.date, "YYYY-MM-DD HH:mm:ss").format("hh:mm a") + "</div>";

      return text;
    },

    submitReport: function submitReport() {
      var _this4 = this;

      var employees = _.cloneDeep(this.activeEmployee).filter(function (employee) {
        return employee.confirmed;
      }).map(function (employee) {
        return _.pick(employee, "employee_order_id", "reason", "no_show_id", "id");
      });

      if (employees.length === 0 || employees.length > 1) {
        notify.info("Select single record for processing.");
      } else {
        if (this.noShow.action) {
          notify.loading(true);
          this.$http.post("/api/accounting-no-show", {
            employees: employees,
            noShow: this.noShow,
            responses: this.responses
          }, function (response) {
            _this4.fetchNoShowList();
            _this4.noShow = {
              reason: "",
              confirmed: "",
              action: "",
              action_count_calls: null,
              action_count_days: null
            };
            _this4.responses = [];
            modals.hide("#no-show-modal");
          }).always(function () {
            notify.loading(false);
          });
        } else {
          notify.info("Select an action to complete the process.");
        }
      }
    }
  }
};
module.exports = exports["default"];
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n    <div class=\"row\">\n        <div class=\"col-md-12\">\n            <div class=\"col-md-12 no-padding\">\n                <div class=\"bg-black col-md-1 p-5\">Client</div>\n                <div class=\"bg-black col-md-1 p-5\">Work</div>\n                <div class=\"bg-black col-md-1 p-5\">Job</div>\n                <div class=\"bg-black col-md-2 p-5\">Employee</div>\n                <div class=\"bg-black col-md-2 p-5\">N/S This Week</div>\n                <div class=\"bg-danger col-md-2 p-5\">N/S 3 Months</div>\n                <div class=\"bg-danger col-md-2 p-5\">S/C 3 Months</div>\n                <div class=\"bg-danger col-md-1 p-5\">Call Text</div>\n            </div>\n            <div class=\"col-md-12 no-padding\">\n                <div class=\"table-responsive\">\n                    <table class=\"table table-xxs table-bordered \">\n                        <tbody>\n                        <tr v-for=\"(index,employee) in employees\" :key=\"index\">\n                            <td class=\"col-md-1 p-5\">{{ employee.company_code }}</td>\n                            <td class=\"col-md-1 p-5\">{{ employee.date }}</td>\n                            <td class=\"col-md-1 p-5\">{{ employee.title }}</td>\n                            <td class=\"col-md-2 p-5 cursor-pointer\" @click.prevent=\"noShowModal(employee)\">\n                                {{ employee.fullName }}\n                            </td>\n                            <td class=\"col-md-2 p-5\">{{ employee.ns.length }}</td>\n                            <td class=\"col-md-2 p-5\">{{ employee.ns3.length }}</td>\n                            <td class=\"col-md-2 p-5\">{{ employee.sc3.length }}</td>\n                            <td class=\"col-md-1 p-5\">Call Text</td>\n                        </tr>\n                        </tbody>\n                    </table>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"modal fade\" id=\"no-show-modal\">\n            <div class=\"modal-dialog modal-medium\">\n                <div class=\"modal-content\">\n                    <div class=\"modal-header\">\n                        <div class=\"row\">\n                            <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\">×</button>\n                        </div>\n                    </div>\n                    <div class=\"modal-body\">\n                        <div class=\"row bg-light-blue mb-15\">\n                            <div class=\"col-md-6\">\n                                <h5 class=\"text-black text-danger\">{{ activeEmployee[0].fullName }}</h5>\n                                <h6 class=\"text-black text-color-black\">{{ activeEmployee[0].primary_phone }}</h6>\n                                <h6 class=\"text-black text-color-black\">{{ activeEmployee[0].secondary_phone }}</h6>\n                                <h6 class=\"text-black text-blue-800\">{{ activeEmployee[0].email }}</h6>\n                            </div>\n                            <div class=\"col-md-6 no-padding-right\">\n                                <div class=\"col-md-2\">\n                                    <div class=\"mb-20\"></div>\n                                    <div class=\"pt-20 mt-20\">\n                                        <h6 class=\"text-color-black text-uppercase\">Contacted</h6>\n                                    </div>\n                                </div>\n                                <div class=\"col-md-7\">\n                                    <div class=\"col-md-3 border-left-white\" v-for=\"response in activeEmployee[0].no_show_responses\">\n                                        <div class=\"text-uppercase text-color-black mb-20\">{{ response.type }}</div>\n                                        <div class=\"text-uppercase text-color-black mb-20\">\n                                            {{ response.created_at | customDateFormat\n                                        'YYYY-MM-DD h:m:s'\n                                        'ddd M/D' }}\n                                        </div>\n                                        <div class=\"text-uppercase text-color-black mb-20\">\n                                            {{ response.created_at | customDateFormat\n                                        'YYYY-MM-DD h:m:s'\n                                        'h:m A' }}\n                                        </div>\n                                    </div>\n                                </div>\n                                <div class=\"col-md-1 border-left-white pt-10\">\n                                    <div class=\"text-right\">\n                                        <label for=\"vm\" class=\"text-color-black\">\n                                            <input type=\"checkbox\" name=\"\" v-model=\"responses\" value=\"vm\" class=\"no-margin\">\n                                        </label>\n                                    </div>\n                                    <div class=\"text-right\">\n                                        <label for=\"na\" class=\"text-color-black\">\n                                            <input type=\"checkbox\" name=\"\" v-model=\"responses\" value=\"na\" class=\"no-margin\">\n                                        </label>\n                                    </div>\n                                    <div class=\"text-right\">\n                                        <label for=\"text\" class=\"text-color-black\">\n                                            <input type=\"checkbox\" name=\"\" v-model=\"responses\" value=\"text\" class=\"no-margin\">\n                                        </label>\n                                    </div>\n                                    <div class=\"text-right\">\n                                        <label for=\"disconnected\" class=\"text-color-black\">\n                                            <input type=\"checkbox\" name=\"\" v-model=\"responses\" value=\"disconnected\" class=\"no-margin\">\n                                        </label>\n                                    </div>\n                                </div>\n                                <div class=\"col-md-2 border-left-white pt-10 bg-primary-300\">\n                                    <div>\n                                        <label for=\"vm\" class=\"text-color-black\">\n                                            Left Voice-mail\n                                        </label>\n                                    </div>\n                                    <div>\n                                        <label for=\"na\" class=\"text-color-black\">\n                                            No Answer\n                                        </label>\n                                    </div>\n                                    <div>\n                                        <label for=\"text\" class=\"text-color-black\">\n                                            Send Text\n                                        </label>\n                                    </div>\n                                    <div>\n                                        <label for=\"disconnected\" class=\"text-color-black\">\n                                            Disconnected\n                                        </label>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"row\">\n                            <div class=\"col-md-9 no-padding\">\n                                <div class=\"col-md-12 no-padding\">\n                                    <div class=\"bg-black-center text-black col-md-12 p-5\">Current No Show</div>\n                                    <div class=\"bg-danger text-black text-center col-md-7 p-5\">Scheduled</div>\n                                    <div class=\"bg-danger text-black text-center col-md-4 p-5\">Reason</div>\n                                    <div class=\"bg-danger text-black text-center col-md-1 p-5\">Confirmed</div>\n                                </div>\n                                <div class=\"col-md-12 no-padding\">\n                                    <div class=\"table-responsive\">\n                                        <table class=\"table table-xxs table-bordered \">\n                                            <tbody>\n                                            <tr v-for=\"(index,employee) in activeEmployee\" :key=\"index\">\n                                                <td class=\"col-md-7 p-5\">{{{formattedText(employee) }}}</td>\n                                                <td class=\"col-md-4 p-5\">\n                                                    <input type=\"text\" class=\"form-control\" v-model=\"employee.reason\">\n                                                </td>\n                                                <td class=\"col-md-1 text-center p-5\">\n                                                    <input type=\"checkbox\" name=\"confirmed\" :value=\"employee.id\" v-model=\"employee.confirmed\" :disabled=\"!employee.reason\">\n                                                </td>\n                                            </tr>\n                                            </tbody>\n                                        </table>\n                                    </div>\n                                </div>\n                            </div>\n\n                            <div class=\"col-md-3 no-padding\">\n                                <div class=\"col-md-12 no-padding\">\n                                    <div class=\"bg-green text-black text-center col-md-12 p-5\">DISPUTE</div>\n                                    <div class=\"bg-black text-black text-center col-md-3 p-5\">IN</div>\n                                    <div class=\"bg-black text-black text-center col-md-3 p-5\">OUT</div>\n                                    <div class=\"bg-black text-black text-center col-md-3 p-5\">BREAK</div>\n                                    <div class=\"bg-black text-black text-center col-md-3 p-5\">NOTE</div>\n                                </div>\n                            </div>\n                        </div>\n\n\n                        <div class=\"row\">\n                            <div class=\"col-md-12 no-padding\">\n                                <div class=\"bg-purple text-black text-center col-md-12 no-padding\">FURTHER ACTION</div>\n                                <div class=\"col-md-7 no-padding\">\n                                    <div class=\"table-responsive\">\n                                        <table class=\"table table-xxs table-bordered \">\n                                            <tbody>\n                                            <tr>\n                                                <td class=\"col-md-7 p-5\">NO RESPONSE</td>\n                                                <td class=\"col-md-4 p-5\">\n                                                    <input type=\"text\" class=\"form-control\" placeholder=\"# of calls\" v-model=\"noShow.action_count_calls\" :readonly=\"noShow.action !== 'no response'\">\n                                                </td>\n                                                <td class=\"col-md-1 p-5\">\n                                                    <input type=\"radio\" name=\"action\" v-model=\"noShow.action\" value=\"no response\">\n                                                </td>\n                                            </tr>\n                                            <tr>\n                                                <td class=\"col-md-7 p-5\">EXCUSED</td>\n                                                <td class=\"col-md-4 p-5\">\n\n                                                </td>\n                                                <td class=\"col-md-1 p-5\">\n                                                    <input type=\"radio\" name=\"action\" v-model=\"noShow.action\" value=\"excused\">\n                                                </td>\n                                            </tr>\n                                            <tr>\n                                                <td class=\"col-md-7 p-5\">WARNING</td>\n                                                <td class=\"col-md-4 p-5\">\n\n                                                </td>\n                                                <td class=\"col-md-1 p-5\">\n                                                    <input type=\"radio\" name=\"action\" v-model=\"noShow.action\" value=\"warning\">\n                                                </td>\n                                            </tr>\n                                            <tr>\n                                                <td class=\"col-md-7 p-5\">SUSPENDED</td>\n                                                <td class=\"col-md-4 p-5\">\n                                                    <input type=\"text\" class=\"form-control\" placeholder=\"# of days\" v-model=\"noShow.action_count_days\" :readonly=\"noShow.action !== 'suspended'\">\n                                                </td>\n                                                <td class=\"col-md-1 p-5\">\n                                                    <input type=\"radio\" name=\"action\" v-model=\"noShow.action\" value=\"suspended\">\n                                                </td>\n                                            </tr>\n                                            <tr>\n                                                <td class=\"col-md-7 p-5\">TERMINATED</td>\n                                                <td class=\"col-md-4 p-5\">\n\n                                                </td>\n                                                <td class=\"col-md-1 p-5\">\n                                                    <input type=\"radio\" name=\"action\" v-model=\"noShow.action\" value=\"terminated\">\n                                                </td>\n                                            </tr>\n                                            </tbody>\n                                        </table>\n                                    </div>\n                                </div>\n                                <div class=\"col-md-5\">\n\n                                </div>\n                            </div>\n\n                            <div class=\"col-md-12 no-padding pt-20\">\n                                <button type=\"button\" class=\"btn bg-primary-300 pull-right\" @click.prevent=\"submitReport\">Submit\n                                </button>\n                            </div>\n                        </div>\n\n                        <div class=\"row mt-20\">\n                            <div class=\"bg-black-center text-black col-md-12 p-5\">Previous No Show</div>\n                            <div class=\"bg-primary-300 text-black text-center col-md-2 p-5\">Date</div>\n                            <div class=\"bg-primary-300 text-black text-center col-md-2 p-5\">Client</div>\n                            <div class=\"bg-primary-300 text-black text-center col-md-2 p-5\">Job</div>\n                            <div class=\"bg-primary-300 text-black text-center col-md-4 p-5\">Reason</div>\n                            <div class=\"bg-primary-300 text-black text-center col-md-2 p-5\">Action</div>\n                            <div class=\"col-md-12 no-padding\">\n                                <div class=\"table-responsive\">\n                                    <table class=\"table table-xxs table-bordered \">\n                                        <tbody>\n                                        <tr v-for=\"(index,employee) in pastEmployees\" :key=\"index\">\n                                            <td class=\"col-md-2 p-5 text-center\">{{ employee.date | customDateFormat\n                                            'YYYY-MM-DD'\n                                            'M-ddd-YY'}}\n                                            </td>\n                                            <td class=\"col-md-2 p-5 text-center\">{{ employee.client_name }}</td>\n                                            <td class=\"col-md-2 p-5 text-center\">{{ employee.title }}</td>\n                                            <td class=\"col-md-4 p-5 text-center\">{{ employee.reason }}</td>\n                                            <td class=\"col-md-2 p-5 text-center text-uppercase\">{{ employee.action\n                                                }} {{ employee.action_count ? ' - ' + employee.action_count : ''}}\n                                            </td>\n                                        </tr>\n                                        </tbody>\n                                    </table>\n                                </div>\n                            </div>\n                        </div>\n\n\n                    </div>\n                    <div class=\"modal-footer\">\n                        <!--<button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button>-->\n                        <!--<button type=\"button\" class=\"btn btn-primary\" v-on:click=\"submitErrors\">Save changes</button>-->\n                    </div>\n                </div><!-- /.modal-content -->\n            </div><!-- /.modal-dialog -->\n        </div><!-- /.modal -->\n    </div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  var id = "/home/shoieb/sites/elegant/resources/assets/js/vue/components/accounting-no-show.vue"
  module.hot.dispose(function () {
    require("vueify-insert-css").cache["\n.table-body {\n  height: 650px;\n  overflow-y: scroll;\n}\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, module.exports.template)
  }
})()}
},{"./../../mixed/modals":10,"./../../mixed/notify":11,"vue":5,"vue-hot-reload-api":4,"vueify-insert-css":6}],20:[function(require,module,exports){
"use strict";

exports.__esModule = true;
var modals = require("./../../mixed/modals");
var notify = require("./../../mixed/notify");
exports["default"] = {
  data: function data() {
    return {
      employees: {},
      group: "",
      groupEmployees: {}
    };
  },
  filters: {
    totalAmount: function totalAmount(employees) {
      var amount = 0;
      _.forEach(employees, function (employee) {
        console.log(employee);
        amount = Number(amount) + Number((Number(employee.duration) / 60).toFixed(2) * employee.rate);
      });
      return amount.toFixed(2);
    }
  },
  watch: {},
  ready: function ready() {
    var _this = this;

    this.fetchSubmittedPayroll();
    var that = this;
    window.bus.$on("refreshPendingPayroll", function () {
      _this.fetchSubmittedPayroll();
    });
  },
  events: {
    refreshData: function refreshData() {
      console.log("refreshed accounting completed");
    }
  },
  methods: {
    /**
     * fetch data for data-entry forms
     */
    fetchSubmittedPayroll: function fetchSubmittedPayroll() {
      var _this2 = this;

      this.$http.get("/api/accounting-pending-payroll", "", function (response) {
        _this2.employees = response.employees;
      }).always(function () {});
    },

    calculatePayrollAmount: function calculatePayrollAmount(group) {
      var amount = 0;
      var employees = _.cloneDeep(this.employees);
      var groupedEmployees = _.filter(employees, function (employee) {
        return employee.payroll_group === group;
      });
      groupedEmployees.map(function (employee) {
        amount += employee.duration / 60 * employee.rate;
      });

      return amount;
    },

    fetchSubmittedPayrollGroup: function fetchSubmittedPayrollGroup(group) {
      var _this3 = this;

      this.group = group;
      this.$http.get("/api/accounting-pending-payroll/" + group, "", function (response) {
        _this3.groupEmployees = _.groupBy(response.employees, function (value) {
          return value.employee_id;
        });
        modals.showStrict("#pending-payroll-group");
      }).always(function () {});
    },

    submitPendingPayroll: function submitPendingPayroll() {
      var _this4 = this;

      notify.loading(true);
      var ids = _.pluck(this.employees, "accounting_data_entry_id").map(Number);
      this.$http.post("/api/accounting-submit-pending-payroll", { ids: ids }, function (response) {
        _this4.fetchSubmittedPayroll();
        window.bus.$emit("refreshSubmittedPayroll");
      }).always(function () {
        notify.loading(false);
      });
    }
  },
  props: ["bg"]
};
module.exports = exports["default"];
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n  <div class=\"row\">\n    <div class=\"col-md-10 no-padding\">\n      <h5 class=\"text-center no-margin-top no-margin-bottom bg-success text-black text-color-black\">PENDING PAYROLL</h5>\n      <div class=\"table-responsive\">\n        <table class=\"table table-xxs table-bordered\">\n          <thead>\n            <tr>\n              <th class=\"bg-black col-md-2\">Client</th>\n              <th class=\"bg-black col-md-2\">Job</th>\n              <th class=\"bg-black col-md-1\">ID</th>\n              <th class=\"bg-black col-md-2\">Name</th>\n              <th class=\"bg-black col-md-1\">Date</th>\n              <th class=\"bg-black col-md-1\">Hour</th>\n              <th class=\"bg-black col-md-1\">Reg/OT</th>\n              <th class=\"bg-black col-md-1\">Rate</th>\n              <th class=\"bg-black col-md-1\">Amount</th>\n            </tr>\n          </thead>\n          <tbody>\n            <tr v-for=\"employee in employees\">\n              <td class=\"col-md-2\">{{ employee.name}}</td>\n              <td class=\"col-md-2\">{{ employee.title }}</td>\n              <td class=\"col-md-1\">{{ employee.employee_code }}</td>\n              <td class=\"col-md-2\">{{ employee.first_name + ' ' + employee.last_name }}</td>\n              <td class=\"col-md-1\">{{ employee.date }}</td>\n              <td class=\"col-md-1\">{{ employee.duration | minuteToHour }}</td>\n              <td class=\"col-md-1\">Reg</td>\n              <td class=\"col-md-1\">{{ employee.rate }}</td>\n              <td class=\"col-md-1\">\n                {{ employee.duration | amountPaid\n                employee.rate }}\n              </td>\n            </tr>\n          </tbody>\n        </table>\n      </div>\n      <div class=\"col-md-12 text-center mt-20\" v-if=\"employees.length\">\n        <button class=\"btn btn-primary text-uppercase\" @click.prevent=\"submitPendingPayroll\">Submit Payroll</button>\n      </div>\n    </div>\n\n    <div class=\"col-md-2 no-padding\">\n      <h5 class=\"text-center no-margin-top no-margin-bottom bg-danger text-black text-color-black\">Payroll Group</h5>\n      <h5 v-for=\"(group, index) in 10\" class=\"text-left no-margin-top no-margin-bottom bg-success text-color-black\" @click.prevent=\"fetchSubmittedPayrollGroup(index+1)\">\n        Group - {{ index + 1}} -\n        <span class=\"text-black pull-right pr-20\">{{ calculatePayrollAmount(index+1) }}</span>\n      </h5>\n    </div>\n\n    <div class=\"modal fade\" id=\"pending-payroll-group\">\n      <div class=\"modal-dialog modal-full\">\n        <div class=\"modal-content\">\n          <div class=\"modal-header p-10\">\n            <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\">×</button>\n            <h5 class=\"modal-title text-center bg-slate-700 p-10\">Payroll Group {{ group }}</h5>\n          </div>\n          <div class=\"modal-body\">\n            <div class=\"row\">\n              <div class=\"table-responsive\">\n                <table class=\"table table-xxs table-bordered\">\n                  <thead>\n                    <tr>\n                      <th class=\"bg-slate-300 col-md-2\">ID</th>\n                      <th class=\"bg-slate-300 col-md-2\">Name</th>\n                      <th class=\"bg-slate-300 col-md-2\">Date</th>\n                      <th class=\"bg-slate-300 col-md-2\">Hour</th>\n                      <th class=\"bg-slate-300 col-md-2\">Rate</th>\n                      <th class=\"bg-slate-300 col-md-2\">Amount</th>\n                    </tr>\n                  </thead>\n                  <tbody v-for=\"employee in groupEmployees\">\n                    <tr v-for=\"emp in employee\">\n                      <td class=\"col-md-2\">{{ emp.employee_code }}</td>\n                      <td class=\"col-md-2\">{{ emp.first_name + ' ' + emp.last_name }}</td>\n                      <td class=\"col-md-2\">{{ emp.date }}</td>\n                      <td class=\"col-md-2\">{{ emp.duration | minuteToHour }}</td>\n                      <td class=\"col-md-2\">{{ emp.rate }}</td>\n                      <td class=\"col-md-2\">\n                        {{ emp.duration | amountPaid\n                        emp.rate }}\n                      </td>\n                    </tr>\n                    <tr>\n                      <td class=\"col-md-2\"></td>\n                      <td class=\"col-md-2\"></td>\n                      <td class=\"col-md-2\"></td>\n                      <td class=\"col-md-2\"></td>\n                      <td class=\"col-md-2\">TOTAL</td>\n                      <td class=\"col-md-2\">={{ employee | totalAmount }}</td>\n                    </tr>\n                  </tbody>\n                </table>\n              </div>\n            </div>\n          </div>\n          <div class=\"modal-footer\">\n            <!--<button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button>-->\n            <!--<button type=\"button\" class=\"btn btn-primary\">Save changes</button>-->\n          </div>\n        </div>\n        <!-- /.modal-content -->\n      </div>\n      <!-- /.modal-dialog -->\n    </div>\n    <!-- /.modal -->\n  </div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  var id = "/home/shoieb/sites/elegant/resources/assets/js/vue/components/accounting-pending-payroll.vue"
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, module.exports.template)
  }
})()}
},{"./../../mixed/modals":10,"./../../mixed/notify":11,"vue":5,"vue-hot-reload-api":4}],21:[function(require,module,exports){
var __vueify_style__ = require("vueify-insert-css").insert("\n.table-body {\n  height: 650px;\n  overflow-y: scroll;\n}\n")
"use strict";

exports.__esModule = true;
var modals = require("./../../mixed/modals");
var notify = require("./../../mixed/notify");
exports["default"] = {
  data: function data() {
    return {
      employees: {},
      allEmployees: {},
      activeEmployee: {},
      error: {
        in_time: false,
        out_time: false,
        am_pm: false,
        no_job: false
      },
      clients: {},
      client_id: "0",
      scheduledStartSate: moment().format("YYYY-MM-DD"),
      employeeReceiveList: {}
    };
  },
  watch: {
    client_id: function client_id(val) {
      var employees = _.cloneDeep(this.allEmployees);
      if (val == 0) {
        this.employees = _.groupBy(employees, function (value) {
          return value.name + " --- " + value.department_name;
        });
      } else {
        var filteredEmployees = employees.filter(function (employee) {
          return employee.client_id == val;
        });
        this.employees = _.groupBy(filteredEmployees, function (value) {
          return value.name + " --- " + value.department_name;
        });
      }
    }
  },
  filters: {},
  ready: function ready() {
    if (typeof Cookies.get("scheduledStartSate") === "undefined") {
      Cookies.set("scheduledStartSate", moment().format("YYYY-MM-DD"));
    } else {
      this.scheduledStartSate = Cookies.get("scheduledStartSate");
    }

    $(".table-fixed-header").fixedHeader();
    $(".header-copy").hide();
    this.fetchScheduledEmployees();
    this.getClientList();
    var that = this;
    window.bus.$on("refreshScheduledEmployee", function () {
      that.fetchScheduledEmployees();
    });
  },
  events: {},

  methods: {
    /**
     * set date for previous week and fetch orders
     */
    prevWeek: function prevWeek() {
      this.scheduledStartSate = moment(this.scheduledStartSate, "YYYY-MM-DD").subtract(7, "days").format("YYYY-MM-DD");
      Cookies.set("scheduledStartSate", this.scheduledStartSate);
      this.fetchScheduledEmployees();
    },

    /**
     * set date for next week and fetch data
     */
    nextWeek: function nextWeek() {
      this.scheduledStartSate = moment(this.scheduledStartSate, "YYYY-MM-DD").add(7, "days").format("YYYY-MM-DD");
      Cookies.set("scheduledStartSate", this.scheduledStartSate);
      this.fetchScheduledEmployees();
    },

    /**
     * get list of clients
     */
    getClientList: function getClientList() {
      var _this = this;

      this.$http.get("/api/order-data", "", function (response) {
        _this.clients = response;
      }).always(function () {});
    },

    checkEmployeeValue: function checkEmployeeValue(employee, key) {
      return !employee[key];
    },
    /**
     * fetch scheduled employees for the current week
     */
    fetchScheduledEmployees: function fetchScheduledEmployees() {
      var _this2 = this;

      this.$http.get("/api/accounting-scheduled-employee?scheduledStartSate=" + Cookies.get("scheduledStartSate"), "", function (response) {
        var employees = _.uniq(response.sortedEmployees, "employee_position_date");
        _this2.employees = _.groupBy(employees, function (value) {
          return value.name + " --- " + value.department_name;
        });
        _this2.allEmployees = _.cloneDeep(employees);
        _this2.employeeReceiveList = response.employeeReceiveList;
      }).always(function () {});
    },

    /**
     * count data for received column
     */
    countReceived: function countReceived(date, positionCode) {
      var entries = _.cloneDeep(this.employeeReceiveList);

      var total = _.filter(entries, function (entry) {
        return entry.date === date && entry.position_code === positionCode;
      });

      var accepted = _.filter(entries, function (entry) {
        return entry.date === date && entry.position_code === positionCode && (entry.blank == 1 || entry.corrected == 1 || entry.created_at != null);
      });

      var groupedTotal = _.uniq(total, "employee_id");

      var groupedAccepted = _.uniq(accepted, "employee_id");

      return groupedAccepted.length + "  of  " + groupedTotal.length;
    },

    /**
     * submit error for a employee order entry
     */
    submitErrors: function submitErrors() {
      var _this3 = this;

      if (!this.activeEmployee.error.in_time && !this.activeEmployee.error.out_time && !this.activeEmployee.error.am_pm && !this.activeEmployee.error.no_job) {
        notify.error("Please select errors before submitting.");
        return;
      }
      notify.loading(true);
      this.$http.put("/api/accounting-submit-error/" + this.activeEmployee.employee_position_date, this.activeEmployee.error, function (response) {
        modals.hide("#error-modal");
        _this3.fetchScheduledEmployees();
        window.bus.$emit("refreshCollectionLog");
        window.bus.$emit("refreshScheduledEmployeeError");
        window.bus.$emit("refreshEntreeMatchData");
      }).always(function () {
        notify.loading(false);
      });
    },

    /**
     * submit error for a employee order entry
     */
    submitData: function submitData() {
      var _this4 = this;

      notify.loading(true);
      this.$http.put("/api/accounting-submit-data/", { employees: this.employees }, function (response) {
        _this4.fetchScheduledEmployees();
        window.bus.$emit("refreshCollectionLog");
        window.bus.$emit("refreshScheduledEmployeeError");
        window.bus.$emit("refreshEntreeMatchData");
      }).always(function () {
        notify.loading(false);
      });
    },

    /**
     * set the active employee
     * @param employee
     */
    setEmployee: function setEmployee(employee) {
      this.activeEmployee = _.cloneDeep(employee);
      this.activeEmployee.error = _.cloneDeep(this.error);
    }
  }
};
module.exports = exports["default"];
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n  <div>\n    <div class=\"row\">\n      <div class=\"col-md-12 no-padding\">\n        <div class=\"table-responsive\">\n          <table class=\"table table-xxs table-fixed-header table-bordered\">\n            <thead class=\"header\">\n              <tr>\n                <th colspan=\"1\" class=\"no-border text-left\">\n                  <i class=\"fa fa-angle-double-left font-40 cursor-pointer text-default\" v-on:click=\"prevWeek\"></i>\n                </th>\n                <th colspan=\"2\" class=\"text-center no-border\">\n                  <select class=\"form-control\" name=\"client\" v-select2=\"client_id\" v-model=\"client_id\">\n                    <option value=\"0\">Show All</option>\n                    <option v-for=\"(index,client) in clients\" :key=\"index\" :value=\"client.id\">{{ client.name }}</option>\n                  </select>\n                </th>\n                <th colspan=\"2\" class=\"no-border text-right\">\n                  <button type=\"button\" class=\"btn btn-primary pr-20\" v-on:click=\"submitData\">Submit</button>\n                  <!-- <button type=\"button\" class=\"btn btn-primary\" v-on:click=\"submitErrors\">Save changes</button> -->\n                </th>\n                <th colspan=\"2\" class=\"no-border text-right\">\n                  <i class=\"fa fa-angle-double-right font-40 cursor-pointer text-default\" v-on:click=\"nextWeek\"></i>\n                </th>\n              </tr>\n              <!-- <tr>\n                                <th colspan=\"1\" class=\"no-border\"></th>\n                                <th colspan=\"4\" class=\"text-center no-border\">\n                                    <select class=\"form-control \" name=\"client\"\n                                            v-select2=\"client_id\"\n                                            v-model=\"client_id\">\n                                        <option value=\"0\">Show All</option>\n                                        <option v-for=\"(index,client) in clients\" :key=\"index\"\n                                                :value=\"client.id\">{{ client.name }}\n                                        </option>\n                                    </select>\n                                </th>\n                                <th colspan=\"2\" class=\"no-border text-right\">\n                                    <button type=\"button\" class=\"btn btn-primary\" v-on:click=\"submitErrors\">Save changes</button>\n                                </th>\n              </tr>-->\n              <tr>\n                <th class=\"bg-black col-md-3 p-5\">Client</th>\n                <th class=\"bg-black col-md-1 p-5\">Date</th>\n                <th class=\"bg-black col-md-1 p-5\">Job</th>\n                <th class=\"bg-danger col-md-1\">Received</th>\n                <th class=\"bg-black col-md-3 p-5\">Employee</th>\n                <th class=\"bg-danger col-md-1 p-5\">Correct</th>\n                <th class=\"bg-danger col-md-1 p-5\">Error</th>\n                <th class=\"bg-danger col-md-1 p-5\">Blank</th>\n              </tr>\n            </thead>\n            <tbody v-for=\"(index, groups) in employees\" :key=\"index\">\n              <tr class=\"warning\">\n                <td colspan=\"7\" class=\"col-md-12\">{{ index }}</td>\n              </tr>\n              <tr v-for=\"(index,employee) in groups\" :key=\"index\">\n                <td class=\"col-md-3\">{{ employee.company_code }}</td>\n                <td class=\"col-md-1\">\n                  <span v-if=\"!employee.blank &amp;&amp; !employee.corrected\">\n                    {{ employee.date | customDateFormat\n                    'YYYY-MM-DD'\n                    'DD - MMM' }}\n                  </span>\n                </td>\n                <td class=\"col-md-1\">{{ employee.title }}</td>\n                <td class=\"col-md-1 text-danger text-black\">{{ countReceived(employee.date,employee.position_code) }}</td>\n                <td class=\"col-md-3\">{{ employee.first_name + ' ' + employee.last_name }}</td>\n                <td class=\"col-md-1\">\n                  <input v-show=\"!employee.blank\" type=\"checkbox\" name=\"\" id=\"accounting-received\" value=\"1\" v-model=\"employee.corrected\">\n                </td>\n                <td class=\"col-md-1\">\n                  <button v-show=\"!employee.blank &amp;&amp; !employee.corrected\" type=\"button\" href=\"#error-modal\" class=\"btn btn-danger btn-xs\" data-toggle=\"modal\" data-backdrop=\"static\" data-keyboard=\"false\" v-on:click=\"setEmployee(employee)\">Error</button>\n                </td>\n                <td class=\"col-md-1\">\n                  <input v-show=\"!employee.corrected\" type=\"checkbox\" name=\"\" id=\"accounting-blank\" value=\"1\" v-model=\"employee.blank\">\n                </td>\n              </tr>\n            </tbody>\n          </table>\n        </div>\n      </div>\n      <div class=\"col-md-12 pt-15\">\n        <button type=\"button\" class=\"btn btn-primary pull-right\" v-on:click=\"submitData\">Submit</button>\n      </div>\n    </div>\n\n    <div class=\"modal fade\" id=\"error-modal\">\n      <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n          <div class=\"modal-header\">\n            <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\">×</button>\n            <h4 class=\"modal-title\">Error - {{ activeEmployee.first_name + ' ' + activeEmployee.last_name }}</h4>\n          </div>\n          <div class=\"modal-body\">\n            <div class=\"row\">\n              <div class=\"col-md-12\">\n                <div class=\"form-group\">\n                  <label class=\"checkbox-inline\">\n                    <input type=\"checkbox\" v-model=\"activeEmployee.error.in_time\" value=\"1\" class=\"\">\n                    No In Time\n                  </label>\n                </div>\n              </div>\n              <div class=\"col-md-12\">\n                <div class=\"form-group\">\n                  <label class=\"checkbox-inline\">\n                    <input type=\"checkbox\" v-model=\"activeEmployee.error.out_time\" value=\"1\" class=\"\">\n                    No Out Time\n                  </label>\n                </div>\n              </div>\n              <div class=\"col-md-12\">\n                <div class=\"form-group\">\n                  <label class=\"checkbox-inline\">\n                    <input type=\"checkbox\" v-model=\"activeEmployee.error.am_pm\" value=\"1\" class=\"\">\n                    No AM/PM\n                  </label>\n                </div>\n              </div>\n              <div class=\"col-md-12\">\n                <div class=\"form-group\">\n                  <label class=\"checkbox-inline\">\n                    <input type=\"checkbox\" v-model=\"activeEmployee.error.no_job\" value=\"1\" class=\"\">\n                    No Job\n                  </label>\n                </div>\n              </div>\n            </div>\n          </div>\n          <div class=\"modal-footer\">\n            <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button>\n            <button type=\"button\" class=\"btn btn-primary\" v-on:click=\"submitErrors\">Save changes</button>\n          </div>\n        </div>\n        <!-- /.modal-content -->\n      </div>\n      <!-- /.modal-dialog -->\n    </div>\n    <!-- /.modal -->\n  </div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  var id = "/home/shoieb/sites/elegant/resources/assets/js/vue/components/accounting-scheduled-employee.vue"
  module.hot.dispose(function () {
    require("vueify-insert-css").cache["\n.table-body {\n  height: 650px;\n  overflow-y: scroll;\n}\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, module.exports.template)
  }
})()}
},{"./../../mixed/modals":10,"./../../mixed/notify":11,"vue":5,"vue-hot-reload-api":4,"vueify-insert-css":6}],22:[function(require,module,exports){
"use strict";

exports.__esModule = true;
var modals = require("./../../mixed/modals");
var notify = require("./../../mixed/notify");
exports["default"] = {
  data: function data() {
    return {
      employees: {},
      searchedEmployees: {},
      search: {
        date_from: "",
        date_to: ""
      }
    };
  },
  filters: {},
  watch: {},
  ready: function ready() {
    this.fetchSubmittedPayroll();
    var that = this;
    window.bus.$on("refreshSubmittedPayroll", function () {
      that.fetchSubmittedPayroll();
    });
  },
  events: {
    refreshData: function refreshData() {
      console.log("refreshed accounting completed");
    }
  },
  methods: {
    /**
     * fetch data for data-entry forms
     */
    fetchSubmittedPayroll: function fetchSubmittedPayroll() {
      var _this = this;

      this.$http.get("/api/accounting-submitted-payroll", "", function (response) {
        _this.employees = response.employees;
      }).always(function () {});
    },

    /**
     * fetch data for data-entry forms
     */
    searchSubmittedPayroll: function searchSubmittedPayroll() {
      var _this2 = this;

      this.$http.put("/api/accounting-search-submitted-payroll", this.search, function (response) {
        _this2.searchedEmployees = response.employees;
      }).always(function () {});
    },

    confirmSubmission: function confirmSubmission() {
      notify.prompt("Are you sure you want to submit?", "", this.submitCompletedPayroll);
    },

    submitCompletedPayroll: function submitCompletedPayroll() {
      var _this3 = this;

      notify.loading(true);
      var ids = _.pluck(this.employees, "accounting_data_entry_id").map(Number);
      this.$http.post("/api/accounting-submitted-payroll", { ids: ids }, function (response) {
        _this3.fetchSubmittedPayroll();
      }).always(function () {
        notify.loading(false);
      });
    },

    showSearchModal: function showSearchModal() {
      modals.showStrict("#submitted-payroll-search");
    }
  },
  props: ["bg"]
};
module.exports = exports["default"];
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n  <div class=\"row\">\n    <div class=\"col-md-12 table-body\">\n      <h5 class=\"text-center no-margin-top no-margin-bottom bg-orange text-black text-color-black\">SUBMITTED PAYROLL</h5>\n      <div class=\"table-responsive\">\n        <table class=\"table table-xxs table-bordered\">\n          <thead>\n            <tr>\n              <th class=\"bg-black col-md-2\">Client</th>\n              <th class=\"bg-black col-md-1\">Job</th>\n              <th class=\"bg-black col-md-1\">ID</th>\n              <th class=\"bg-black col-md-2\">Name</th>\n              <th class=\"bg-black col-md-1\">Date</th>\n              <th class=\"bg-black col-md-1\">Hour</th>\n              <th class=\"bg-black col-md-1\">Reg/OT</th>\n              <th class=\"bg-black col-md-1\">Rate</th>\n              <th class=\"bg-black col-md-1\">Amount</th>\n              <th class=\"bg-black col-md-2\">Payment Method</th>\n            </tr>\n          </thead>\n          <tbody>\n            <tr v-for=\"employee in employees\">\n              <td class=\"col-md-2\">{{ employee.name}}</td>\n              <td class=\"col-md-1\">{{ employee.title }}</td>\n              <td class=\"col-md-1\">{{ employee.employee_code }}</td>\n              <td class=\"col-md-2\">{{ employee.first_name + ' ' + employee.last_name }}</td>\n              <td class=\"col-md-1\">{{ employee.date }}</td>\n              <td class=\"col-md-1\">{{ employee.duration | minuteToHour }}</td>\n              <th class=\"col-md-1\">Reg</th>\n              <td class=\"col-md-1\">{{ employee.rate }}</td>\n              <td class=\"col-md-1\">\n                {{ employee.duration | amountPaid\n                employee.rate }}\n              </td>\n              <td class=\"col-md-2\">{{ employee.payment_group_id | payrollGroup }}</td>\n            </tr>\n          </tbody>\n        </table>\n      </div>\n\n      <div class=\"col-md-12 text-center mt-20 text-right\" v-if=\"employees.length\">\n        <button class=\"btn btn-primary text-uppercase ml-20 pull-right\" @click.prevent=\"showSearchModal()\">Search</button>\n        <button class=\"btn btn-primary text-uppercase pull-right\" @click.prevent=\"confirmSubmission\">Submit Complete</button>\n      </div>\n    </div>\n\n    <div class=\"modal fade\" id=\"submitted-payroll-search\">\n      <div class=\"modal-dialog modal-full\">\n        <div class=\"modal-content\">\n          <div class=\"modal-header\">\n            <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\">×</button>\n            <!--<h4 class=\"modal-title\">Modal title</h4>-->\n          </div>\n          <div class=\"modal-body\">\n            <div class=\"col-md-12 table-body\">\n              <h5 class=\"text-center no-margin-top no-margin-bottom bg-orange text-black text-color-black\">SEARCH PAYROLL</h5>\n              <div class=\"row\">\n                <div class=\"col-md-12\">\n                  <div class=\"col-md-6\">\n                    <div class=\"form-group\">\n                      <label>Date From:</label>\n                      <input type=\"text\" name=\"username\" v-model=\"search.date_from\" class=\"form-control pickadate-year-normal text-black\" required=\"required\">\n                    </div>\n                  </div>\n\n                  <div class=\"col-md-6\">\n                    <div class=\"form-group\">\n                      <label>Date To:</label>\n                      <input type=\"text\" name=\"username\" v-model=\"search.date_to\" class=\"form-control pickadate-year-normal text-black\" required=\"required\">\n                    </div>\n                  </div>\n                </div>\n                <div class=\"col-md-12 text-right\">\n                  <button class=\"btn btn-primary text-uppercase ml-20\" @click.prevent=\"searchSubmittedPayroll()()\">Search</button>\n                </div>\n              </div>\n              <div class=\"table-responsive mt-20\">\n                <table class=\"table table-xxs table-bordered\">\n                  <thead>\n                    <tr>\n                      <th class=\"bg-black col-md-2\">Client</th>\n                      <th class=\"bg-black col-md-1\">Job</th>\n                      <th class=\"bg-black col-md-1\">ID</th>\n                      <th class=\"bg-black col-md-2\">Name</th>\n                      <th class=\"bg-black col-md-1\">Date</th>\n                      <th class=\"bg-black col-md-1\">Hour</th>\n                      <th class=\"bg-black col-md-1\">Rate</th>\n                      <th class=\"bg-black col-md-1\">Amount</th>\n                      <th class=\"bg-black col-md-1\">Payment Method</th>\n                      <th class=\"bg-danger col-md-1\">Dispute</th>\n                    </tr>\n                  </thead>\n                  <tbody>\n                    <tr v-for=\"employee in searchedEmployees\">\n                      <td class=\"col-md-2\">{{ employee.name}}</td>\n                      <td class=\"col-md-1\">{{ employee.title }}</td>\n                      <td class=\"col-md-1\">{{ employee.employee_code }}</td>\n                      <td class=\"col-md-2\">{{ employee.first_name + ' ' + employee.last_name }}</td>\n                      <td class=\"col-md-1\">{{ employee.date }}</td>\n                      <td class=\"col-md-1\">{{ employee.duration | minuteToHour }}</td>\n                      <td class=\"col-md-1\">{{ employee.rate }}</td>\n                      <td class=\"col-md-1\">\n                        {{ employee.duration | amountPaid\n                        employee.rate }}\n                      </td>\n                      <td class=\"col-md-1\">{{ employee.payroll_group | payrollGroup }}</td>\n                      <td class=\"col-md-1\">\n                        <button class=\"btn btn-danger\">Dispute</button>\n                      </td>\n                    </tr>\n                  </tbody>\n                </table>\n              </div>\n            </div>\n          </div>\n          <div class=\"modal-footer\">\n            <!--<button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button>-->\n            <!--<button type=\"button\" class=\"btn btn-primary\">Save changes</button>-->\n          </div>\n        </div>\n        <!-- /.modal-content -->\n      </div>\n      <!-- /.modal-dialog -->\n    </div>\n    <!-- /.modal -->\n  </div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  var id = "/home/shoieb/sites/elegant/resources/assets/js/vue/components/accounting-submitted-payroll.vue"
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, module.exports.template)
  }
})()}
},{"./../../mixed/modals":10,"./../../mixed/notify":11,"vue":5,"vue-hot-reload-api":4}],23:[function(require,module,exports){
var __vueify_style__ = require("vueify-insert-css").insert("\n    .table-body {\n        height: 650px;\n        overflow-y: scroll;\n    }\n")
'use strict';

exports.__esModule = true;
exports['default'] = {
    data: function data() {
        return {
            employees: {},
            activeOrder: {}
        };
    },

    ready: function ready() {
        this.fetchUnscheduledShifts();
    },
    events: {},
    methods: {
        /**
         * fetch scheduled employees for the current week
         */
        fetchUnscheduledShifts: function fetchUnscheduledShifts() {
            var _this = this;

            this.$http.get('/api/accounting-unscheduled-shifts', '', function (response) {
                _this.employees = response;
            }).always(function () {});
        },

        /**
         * set the active employee
         * @param order
         */
        setEmployee: function setEmployee(order) {
            this.activeOrder = order;
        }
    }
};
module.exports = exports['default'];
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n    <div class=\"row\">\n        <div class=\"col-md-10 no-padding\">\n            <h5 class=\"text-center no-margin-top no-margin-bottom bg-black-center text-white text-center\">\n                UNSCHEDULED SHIFTS</h5>\n            <div class=\"table-responsive\">\n                <table class=\"table table-xxs table-bordered\">\n                    <thead>\n                    <tr>\n                        <th class=\"bg-grey-800 col-md-2\">Employee</th>\n                        <th class=\"bg-grey-800 col-md-2\">Last</th>\n                        <th class=\"bg-grey-800 col-md-1\">Last 2</th>\n                        <th class=\"bg-grey-800 col-md-2\">Last 3</th>\n                    </tr>\n                    </thead>\n                    <tbody>\n                    <tr v-for=\"employee in employees\">\n                        <th class=\"bg-grey-800 col-md-2\">{{employee.first_name+' '+employee.last_name }}</th>\n                        <th class=\"bg-grey-800 col-md-2\">Last</th>\n                        <th class=\"bg-grey-800 col-md-1\">Last 2</th>\n                        <th class=\"bg-grey-800 col-md-2\">Last 3</th>\n                    </tr>\n                    </tbody>\n                </table>\n            </div>\n        </div>\n    </div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  var id = "/home/shoieb/sites/elegant/resources/assets/js/vue/components/accounting-unscheduled-shifts.vue"
  module.hot.dispose(function () {
    require("vueify-insert-css").cache["\n    .table-body {\n        height: 650px;\n        overflow-y: scroll;\n    }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, module.exports.template)
  }
})()}
},{"vue":5,"vue-hot-reload-api":4,"vueify-insert-css":6}],24:[function(require,module,exports){
var __vueify_style__ = require("vueify-insert-css").insert("\n.table-body {\n  height: 650px;\n  overflow-y: scroll;\n}\n")
"use strict";

exports.__esModule = true;
exports["default"] = {
  data: function data() {
    return {
      orders: {},
      activeOrder: {},
      collectionStartDate: moment().format("YYYY-MM-DD")
    };
  },

  ready: function ready() {
    if (typeof Cookies.get("collectionStartDate") === "undefined") {
      Cookies.set("collectionStartDate", moment().format("YYYY-MM-DD"));
    } else {
      this.collectionStartDate = Cookies.get("collectionStartDate");
    }
    this.fetchCollectionLog();
    var that = this;
    window.bus.$on("refreshCollectionLog", function () {
      that.fetchCollectionLog();
    });
  },
  events: {},
  methods: {
    /**
     * set date for previous week and fetch orders
     */
    prevWeek: function prevWeek() {
      this.collectionStartDate = moment(this.collectionStartDate, "YYYY-MM-DD").subtract(7, "days").format("YYYY-MM-DD");
      Cookies.set("collectionStartDate", this.collectionStartDate);
      this.fetchCollectionLog();
    },

    /**
     * set date for next week and fetch data
     */
    nextWeek: function nextWeek() {
      this.collectionStartDate = moment(this.collectionStartDate, "YYYY-MM-DD").add(7, "days").format("YYYY-MM-DD");
      Cookies.set("collectionStartDate", this.collectionStartDate);
      this.fetchCollectionLog();
    },
    /**
     * fetch scheduled employees for the current week
     */
    fetchCollectionLog: function fetchCollectionLog() {
      var _this = this;

      this.$http.get("/api/accounting-collection-log?collectionStartDate=" + Cookies.get("collectionStartDate"), "", function (response) {
        _this.orders = _.groupBy(response, function (value) {
          return value.name;
        });
      }).always(function () {});
    },

    /**
     * set the active employee
     * @param order
     */
    setEmployee: function setEmployee(order) {
      this.activeOrder = order;
    },

    /**
     * count if employee left for that order
     * @param clientOrders
     * @returns {number}
     */
    totalConfirmedCount: function totalConfirmedCount(clientOrders) {
      var orders = _.cloneDeep(clientOrders);
      var count = 0;
      orders.map(function (order) {
        count += order.confirmed_count[0].count != (order.accepted_count.length ? order.accepted_count[0].count : 0);
      });

      return count;
    }
  }
};
module.exports = exports["default"];
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n  <div class=\"row\">\n    <div class=\"col-md-12\">\n      <div class=\"col-md-1 text-center\">\n        <i class=\"fa fa-angle-double-left font-40 cursor-pointer text-default\" v-on:click=\"prevWeek\"></i>\n      </div>\n      <div class=\"col-md-10 mt-5 font-20 text-center\">{{ collectionStartDate | customDateFormat 'YYYY-MM-DD' 'DD - MMM YYYY' }}</div>\n      <div class=\"col-md-1 text-center\">\n        <i class=\"fa fa-angle-double-right font-40 cursor-pointer text-default\" v-on:click=\"nextWeek\"></i>\n      </div>\n    </div>\n    <div class=\"col-md-12\">\n      <div class=\"col-md-12 no-padding\">\n        <div class=\"bg-black col-md-2 p-5\">Company</div>\n        <div class=\"bg-black col-md-2 p-5\">Department</div>\n        <div class=\"bg-black col-md-2 p-5\">Date</div>\n        <div class=\"bg-black col-md-2 p-5\">Job</div>\n        <div class=\"bg-black col-md-2 p-5\">Scheduled</div>\n        <div class=\"bg-danger col-md-1 p-5\">Received</div>\n        <div class=\"bg-danger col-md-1 p-5\">Due</div>\n      </div>\n      <div class=\"col-md-12 no-padding\">\n        <div class=\"table-responsive\">\n          <table class=\"table table-xxs table-bordered\">\n            <tbody v-for=\"(index,clientOrders) in orders\" v-if=\"totalConfirmedCount(clientOrders)\">\n              <tr class=\"\">\n                <td colspan=\"7\" class=\"col-md-12\"></td>\n              </tr>\n              <tr v-for=\"order in clientOrders\" v-if=\"order.confirmed_count[0].count != (order.accepted_count.length ? order.accepted_count[0].count : 0)\">\n                <td class=\"col-md-2\">{{ order.name }}</td>\n                <td class=\"col-md-2\">{{ order.department_name }}</td>\n                <td class=\"col-md-2\">\n                  {{ order.date | customDateFormat\n                  'YYYY-MM-DD'\n                  'DD - MMM' }}\n                </td>\n                <td class=\"col-md-2\">{{ order.title }}</td>\n                <td class=\"col-md-2\">{{ order.confirmed_count[0].count }}</td>\n                <td class=\"col-md-1\">{{ (order.accepted_count.length ? order.accepted_count[0].count : 0) }}</td>\n                <td class=\"col-md-1\">{{ order.confirmed_count[0].count - (order.accepted_count.length ? order.accepted_count[0].count : 0) }}</td>\n              </tr>\n            </tbody>\n          </table>\n        </div>\n      </div>\n    </div>\n    <!--<div class=\"col-md-12 pt-15\">-->\n    <!--<button type=\"button\" class=\"btn btn-primary pull-right\">Submit</button>-->\n    <!--</div>-->\n  </div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  var id = "/home/shoieb/sites/elegant/resources/assets/js/vue/components/acounting-collection-log.vue"
  module.hot.dispose(function () {
    require("vueify-insert-css").cache["\n.table-body {\n  height: 650px;\n  overflow-y: scroll;\n}\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, module.exports.template)
  }
})()}
},{"vue":5,"vue-hot-reload-api":4,"vueify-insert-css":6}],25:[function(require,module,exports){
var __vueify_style__ = require("vueify-insert-css").insert("\n\n")
"use strict";

exports.__esModule = true;
var modals = require("./../../mixed/modals");
var notify = require("./../../mixed/notify");

exports["default"] = {
    data: function data() {
        return {
            orders: {},
            order: null,
            order_id: '',
            statuses: {
                'Left VM': 'LV',
                'Left Voice Mail': 'LV',
                'Answered': 'ANSWERED',
                'Called': 'CALLED',
                'Disc': 'LD',
                'Hang Up': 'HU',
                "Wrong No": "WN",
                "VM Full": "VF",
                "No VM": "NV",
                'delete': 'DELETE',
                'Call': 'Call'
            },
            response: '',
            date: '',
            logs: {}
        };
    },
    filters: {},
    watch: {
        'date': function date(val) {
            this.getOrders();
        },
        'order_id': function order_id(val) {
            this.getLogs();
        }
    },
    ready: function ready() {
        //this.getOrders();
    },
    events: {},
    methods: {
        getOrders: function getOrders() {
            var _this = this;

            notify.loading(true);
            this.$http.get("/api/action-board-log-orders/" + this.date, function (response) {
                _this.orders = response;
            }).always(function () {
                notify.loading(false);
            });
        },

        getLogs: function getLogs() {
            var _this2 = this;

            notify.loading(true);
            this.$http.get("/api/action-board-log-order/" + this.order_id, function (response) {
                _this2.logs = response;
            }).always(function () {
                notify.loading(false);
            });
        }

    }
};
module.exports = exports["default"];
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n    <div class=\"row\">\n        <div class=\"col-md-12 no-padding\">\n            <div class=\"col-md-6 no-padding-left\">\n                <div class=\"form-group\">\n                    <label for=\"date\">Date</label>\n                    <input type=\"text\" class=\"form-control pickadate-year text-black\" v-model=\"date\" id=\"date\">\n                </div>\n            </div>\n            <div class=\"col-md-6 no-padding-right\">\n                <div class=\"form-group\">\n                    <label>Select Order</label>\n                    <select class=\"form-control \" name=\"\" id=\"order\" v-select2=\"order_id\" v-model=\"order_id\">\n                        <option value=\"\">Show All</option>\n                        <option v-for=\"order in orders\" :value=\"order.id\">{{ order.company_code+' '+order.no_of_employee+' '+order.title}}</option>\n                    </select>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"col-md-12 no-padding\">\n            <div class=\"table-responsive\">\n                <table class=\"table table-bordered table-xxs\">\n                    <thead class=\"header\">\n                    <tr>\n                        <th class=\"text-left\">Employee</th>\n                        <th class=\"text-left\">Action Board</th>\n                        <th class=\"text-left\">Employee Responses</th>\n                    </tr>\n                    </thead>\n\n                    <tbody>\n                    <tr v-for=\"log in logs\">\n                        <td> {{ log.employee.fullName }}</td>\n                        <td>\n                            <ul>\n                                <li v-for=\"queue in log.action_board_queue\" class=\"text-capitalize\">{{ queue.type}} {{ queue.user ? ' - '+queue.user.name : ''}}</li>\n                            </ul>\n                        </td>\n                        <td>\n                            <ul>\n                                <li v-for=\"response in log.responses\">{{ response.type+' - '+response.user.name}}</li>\n                            </ul>\n                        </td>\n                    </tr>\n                    </tbody>\n                </table>\n            </div>\n        </div>\n\n    </div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  var id = "/home/shoieb/sites/elegant/resources/assets/js/vue/components/action-board-log.vue"
  module.hot.dispose(function () {
    require("vueify-insert-css").cache["\n\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, module.exports.template)
  }
})()}
},{"./../../mixed/modals":10,"./../../mixed/notify":11,"vue":5,"vue-hot-reload-api":4,"vueify-insert-css":6}],26:[function(require,module,exports){
var __vueify_style__ = require("vueify-insert-css").insert("\n    .min-height-60[_v-0a33281a] {\n        min-height: 60px !important;\n    }\n\n    .border-black[_v-0a33281a] {\n        border-color: #000 !important;\n    }\n\n    .font-20[_v-0a33281a] {\n        font-size: 20px;\n    }\n\n    .font-14[_v-0a33281a] {\n        font-size: 14px;\n    }\n\n    .select2-results__option[aria-selected=true][_v-0a33281a] {\n        background-color: #2196F3;\n        color: #fff;\n        font-weight: 700;\n    }\n\n    ul#select2-jobId-results > li[_v-0a33281a] {\n        margin-top: 1px;\n        font-weight: 700 !important;\n    }\n\n")
"use strict";

exports.__esModule = true;
var modals = require("./../../mixed/modals");
var notify = require("./../../mixed/notify");

exports["default"] = {
    data: function data() {
        return {
            state: false,
            employees: {},
            jobs: {},
            activeEmployee: {},
            jobId: 1,
            sortOrder: 'asc',
            sortField: 'hire_date',
            orders: {},
            clientOrders: {},
            clientName: '',
            status: 0,
            currentOrder: {}
        };
    },
    props: ["app"],
    filters: {},
    computed: {
        // clients: function () {
        //     return _.pluck(this.orders, 'name');
        // }
    },
    watch: {
        'jobId': function jobId(val) {
            if (val) {
                this.sortField = 'hire_date';
                this.sortOrder = false;
                this.getActiveEmployeeList();
            }
        }
    },
    ready: function ready() {
        var _this = this;

        this.getJobs();
        $('#employee-order-details').on('hidden.bs.modal', function () {
            _this.clientOrders = {};
            _this.clientName = '';
        });
    },
    events: {},
    methods: {
        /**
         * get list of active employees
         */
        getActiveEmployeeList: function getActiveEmployeeList() {
            var _this2 = this;

            notify.loading(true);
            this.$http.get("/api/active-employee-list/" + this.jobId + "?sortOrder=asc&sortField=" + this.sortField, function (response) {
                _this2.employees = response;
            }).always(function () {
                notify.loading(false);
            });
        },

        getEmployeeOrders: function getEmployeeOrders(employee) {
            var _this3 = this;

            var client = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1];

            notify.loading(true);
            this.activeEmployee = _.cloneDeep(employee);
            this.$http.get("/api/employee-job-search/" + this.activeEmployee.id, function (response) {
                if (response) {
                    _this3.orders = response;
                    if (client) {
                        _this3.clientName = client;
                        _this3.clientOrders = _.cloneDeep(_this3.orders)[client];
                    } else {
                        modals.showStrict("#employee-order-details");
                    }
                } else {
                    notify.info('No Jobs Available');
                }
            }).always(function () {
                notify.loading(false);
            });
        },

        getJobs: function getJobs() {
            var _this4 = this;

            this.$http.get('/api/jobs', function (response) {
                var jobs = response;
                var filteredJobs = _.filter(response, function (job) {
                    return job.title === 'Server' || job.title === 'Cook' || job.title === 'Dishwasher' || job.title === 'Bartender';
                });
                var otherJobs = jobs.filter(function (x) {
                    return filteredJobs.indexOf(x) < 0;
                });
                _this4.jobs = filteredJobs.concat(otherJobs);
            });
        },

        employeeDetails: function employeeDetails(employee) {
            var _this5 = this;

            notify.loading(true);
            this.$http.get("/api/active-employee-list-single/" + employee.id, function (response) {
                _this5.activeEmployee = response;
                modals.showStrict("#employee-details");
            }).always(function () {
                notify.loading(false);
            });
        },

        sortEmployees: function sortEmployees(field, order) {
            var primer = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];

            this.sortField = field;
            this.sortOrder = !(field === 'hire_date' || field === 'employee_favourite_status');
            this.getActiveEmployeeList();
        },

        calculateClientOrders: function calculateClientOrders(clientName) {
            this.clientName = clientName;
            this.clientOrders = _.cloneDeep(this.orders)[clientName];
        },

        updateFavouriteStatus: function updateFavouriteStatus(activeEmployee) {
            notify.loading(true);
            var employee = _.findWhere(this.employees, {
                id: activeEmployee.id
            });
            employee.employee_favourite_status = this.activeEmployee.employee_favourite_status;
            this.$http.post('/api/update-employee-favourite-status', {
                status: this.activeEmployee.employee_favourite_status,
                employee_id: this.activeEmployee.id
            }, function (response) {
                notify.loading(false);
                notify.info("Employee Favourite Status Updated");
            });
        },

        /**
         * show confirmation modal before sending delete request
         * @param order
         */
        confirmAssignOrder: function confirmAssignOrder(order) {
            this.currentOrder = _.cloneDeep(order);
            notify.promptArg("Do you want to add <span class=\"text-black text-blue\">" + this.activeEmployee.name + "</span> to <br>\n                    <span class=\"mr-20 font-14\">" + order.date + "</span> <span class=\"mr-20 font-14\">" + order.in_time + "</span> <span class=\"font-14\">" + order.company_code + "  " + order.title + "</span>", '', this.addEmployeeToOrder);
        },

        addEmployeeToOrder: function addEmployeeToOrder() {
            var _this6 = this;

            notify.loading(true);
            this.activeEmployee.rate = this.currentOrder.rate;
            this.activeEmployee.type = this.currentOrder.type;
            this.$http.post("/api/add-employee-order/" + this.currentOrder.order_id, {
                employees: [this.activeEmployee]
            }, function (response) {
                notify.info("Employee Favourite Status Updated");
                _this6.getEmployeeOrders(_this6.activeEmployee, _this6.currentOrder.name);
            });
        }
    }
};
module.exports = exports["default"];
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n    <div class=\"active-employee-list\" _v-0a33281a=\"\">\n        <div class=\"col-md-12 pt-20 pb-0\" _v-0a33281a=\"\">\n            <div class=\"col-md-4 text-center bg-slate-300 min-height-60 pt-15 text-color-black\" _v-0a33281a=\"\">\n                <h4 class=\"no-margin text-semibold text-center\" _v-0a33281a=\"\">Active Employee List</h4>\n            </div>\n            <div class=\"col-md-4 bg-slate-300 min-height-60 pt-10\" _v-0a33281a=\"\">\n                <select class=\"form-control select\" id=\"jobId\" name=\"role\" v-model=\"jobId\" v-select2=\"jobId\" _v-0a33281a=\"\">\n                    <option value=\"\" _v-0a33281a=\"\">Select Job</option>\n                    <option :key=\"job.id\" :value=\"job.id\" v-for=\"job in jobs\" _v-0a33281a=\"\">{{ job.title }}</option>\n                </select>\n            </div>\n            <div class=\"col-md-1 bg-green-400 min-height-60 pt-15 text-color-black\" _v-0a33281a=\"\">\n                <h4 @click=\"sortEmployees('hire_date',!sortOrder)\" class=\"no-margin text-semibold text-center cursor-pointer\" _v-0a33281a=\"\">Hire Date\n                    <i :class=\"sortOrder ? 'fa fa-arrow-down':'fa fa-arrow-up'\" v-if=\"sortField === 'hire_date'\" _v-0a33281a=\"\"></i>\n                </h4>\n            </div>\n            <div class=\"col-md-1 bg-danger-700 min-height-60 pt-15\" _v-0a33281a=\"\">\n                <h4 @click=\"sortEmployees('first_name',!sortOrder)\" class=\"no-margin text-semibold text-center  cursor-pointer\" _v-0a33281a=\"\">\n                    Name\n                    <i :class=\"sortOrder ? 'fa fa-arrow-down':'fa fa-arrow-up'\" v-if=\"sortField === 'first_name'\" _v-0a33281a=\"\"></i>\n                </h4>\n            </div>\n            <div class=\"col-md-1 bg-brown min-height-60 pt-15\" _v-0a33281a=\"\">\n                <h4 @click=\"sortEmployees('employee_favourite_status',!sortOrder)\" class=\"no-margin text-semibold text-center cursor-pointer\" _v-0a33281a=\"\">\n                    Favourite\n                    <i :class=\"sortOrder ? 'fa fa-arrow-down':'fa fa-arrow-up'\" v-if=\"sortField === 'employee_favourite_status'\" _v-0a33281a=\"\"></i></h4>\n            </div>\n            <div class=\"col-md-1 bg-blue min-height-60 pt-15\" _v-0a33281a=\"\">\n                <h4 @click=\"sortEmployees('city',!sortOrder)\" class=\"no-margin text-semibold text-center  cursor-pointer\" _v-0a33281a=\"\">City\n                    <i :class=\"sortOrder ? 'fa fa-arrow-down':'fa fa-arrow-up'\" v-if=\"sortField === 'city'\" _v-0a33281a=\"\"></i>\n                </h4>\n            </div>\n        </div>\n\n        <div class=\"col-md-12\" _v-0a33281a=\"\">\n            <div class=\"table-responsive\" _v-0a33281a=\"\">\n                <table class=\"table table-xxs table-bordered\" _v-0a33281a=\"\">\n                    <thead _v-0a33281a=\"\">\n                    <tr _v-0a33281a=\"\">\n                        <th class=\"text-center bg-black-center text-black\" _v-0a33281a=\"\">Hire Date</th>\n                        <th class=\"text-center bg-black-center text-black\" _v-0a33281a=\"\">G.A.R</th>\n                        <th class=\"text-center bg-black-center text-black\" _v-0a33281a=\"\">Skill</th>\n                        <th class=\"text-left bg-black text-black\" _v-0a33281a=\"\">Employee Name</th>\n                        <th class=\"text-center bg-black-center text-black\" _v-0a33281a=\"\">City</th>\n                        <th class=\"text-center bg-black-center text-black\" _v-0a33281a=\"\">Phone</th>\n                        <th class=\"text-center bg-black-center text-black\" _v-0a33281a=\"\">Apps</th>\n                        <th class=\"text-center bg-black-center text-black\" _v-0a33281a=\"\">Add to Job</th>\n                    </tr>\n                    </thead>\n\n                    <tbody _v-0a33281a=\"\">\n                    <tr :key=\"employee.id\" v-for=\"employee in employees\" _v-0a33281a=\"\">\n                        <td class=\"text-center\" _v-0a33281a=\"\">{{ employee.date }}</td>\n                        <td class=\"text-center\" _v-0a33281a=\"\">{{ employee.grooming +\n                            '.'+employee.attitude+'.'+employee.reliability}}\n                        </td>\n                        <td class=\"text-center\" _v-0a33281a=\"\">{{ employee.skill }}</td>\n                        <td @click=\"employeeDetails(employee)\" class=\"text-left cursor-pointer\" _v-0a33281a=\"\">{{ employee.name }} <i class=\"fa fa-heart text-brown-400 font-12\" v-if=\"employee.employee_favourite_status\" _v-0a33281a=\"\"></i></td>\n                        <td class=\"text-center\" _v-0a33281a=\"\">{{ employee.city }}</td>\n                        <td class=\"text-center\" _v-0a33281a=\"\">{{ employee.primary_phone }}</td>\n                        <td class=\"text-center\" _v-0a33281a=\"\">{{ employee.app_login }}</td>\n                        <td class=\"text-center\" _v-0a33281a=\"\">\n                            <i @click=\"getEmployeeOrders(employee)\" class=\"fa fa-search-plus text-primary font-20 cursor-pointer\" _v-0a33281a=\"\"></i>\n                        </td>\n                    </tr>\n                    </tbody>\n                </table>\n            </div>\n        </div>\n\n        <!--        employee information details modal-->\n        <div class=\"modal\" id=\"employee-details\" role=\"dialog\" tabindex=\"-1\" _v-0a33281a=\"\">\n            <div class=\"modal-dialog modal-sm\" role=\"document\" _v-0a33281a=\"\">\n                <div class=\"modal-content\" _v-0a33281a=\"\">\n                    <div class=\"modal-header bg-slate-300 text-color-black\" _v-0a33281a=\"\">\n                        <div class=\"col-md-12\" _v-0a33281a=\"\">\n                            <div class=\"col-md-12 text-right no-padding\" _v-0a33281a=\"\">\n                                <i aria-hidden=\"true\" class=\"fa fa-times font-20 pull-right cursor-pointer\" data-dismiss=\"modal\" _v-0a33281a=\"\"></i>\n                            </div>\n                            <div class=\"col-md-12 pl-10\" _v-0a33281a=\"\">\n                                <h6 class=\"text-left\" _v-0a33281a=\"\">{{ activeEmployee.name }} </h6>\n                                <h6 class=\"text-left\" _v-0a33281a=\"\">{{ activeEmployee.primary_phone }}</h6>\n                                <h6 class=\"text-left\" _v-0a33281a=\"\">{{ activeEmployee.email }}</h6>\n                                <div class=\"col-md-12 no-padding-left\" _v-0a33281a=\"\">\n                                    <div class=\"col-md-4 text-left no-padding-left text-black col-sm-6 col-xs-6\" _v-0a33281a=\"\">\n                                        My Favourite\n                                    </div>\n                                    <div class=\"col-md-4\" _v-0a33281a=\"\">\n                                        <input @change=\"updateFavouriteStatus(activeEmployee)\" class=\"form-check-inline\" type=\"checkbox\" v-model=\"activeEmployee.employee_favourite_status\" value=\"1\" _v-0a33281a=\"\">\n                                    </div>\n                                </div>\n\n                            </div>\n\n                        </div>\n\n                        <div class=\"col-md-12\" _v-0a33281a=\"\">\n\n                            <h6 class=\"text-center bg-slate-400\" _v-0a33281a=\"\">Last 180 Days</h6>\n                            <div class=\"col-md-12\" _v-0a33281a=\"\">\n                                <div class=\"col-md-6 col-sm-6 col-xs-6 text-right text-color-black\" _v-0a33281a=\"\">Worked</div>\n                                <div class=\"col-md-6 col-sm-6 col-xs-6 text-center\" _v-0a33281a=\"\">{{\n                                    activeEmployee.worked_half_year_count }}\n                                </div>\n                                <div class=\"col-md-6 col-sm-6 col-xs-6 text-right text-color-black\" _v-0a33281a=\"\">Call Out</div>\n                                <div class=\"col-md-6 col-sm-6 col-xs-6 text-center\" _v-0a33281a=\"\">{{\n                                    activeEmployee.call_out_half_year_count }}\n                                </div>\n                                <div class=\"col-md-6 col-sm-6 col-xs-6 text-right text-color-black\" _v-0a33281a=\"\">No Show</div>\n                                <div class=\"col-md-6 col-sm-6 col-xs-6 text-center\" _v-0a33281a=\"\">{{\n                                    activeEmployee.no_show_half_year_count }}\n                                </div>\n                                <div class=\"col-md-6 col-sm-6 col-xs-6 text-right text-color-black\" _v-0a33281a=\"\">Last Work</div>\n                                <div class=\"col-md-6 col-sm-6 col-xs-6 text-center\" _v-0a33281a=\"\">{{ activeEmployee.worked }}</div>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"modal-body bg-slate-300\" _v-0a33281a=\"\">\n\n                    </div>\n                    <!--                    <div class=\"modal-footer\">-->\n                    <!--                        <button class=\"btn btn-primary\" type=\"button\">Save changes</button>-->\n                    <!--                        <button class=\"btn btn-secondary\" data-dismiss=\"modal\" type=\"button\">Close</button>-->\n                    <!--                    </div>-->\n                </div>\n            </div>\n        </div>\n\n        <!--        order list modal-->\n        <div class=\"modal\" id=\"employee-order-details\" role=\"dialog\" tabindex=\"-1\" _v-0a33281a=\"\">\n            <div class=\"modal-dialog modal-medium\" role=\"document\" _v-0a33281a=\"\">\n                <div class=\"modal-content\" _v-0a33281a=\"\">\n                    <div class=\"modal-header bg-slate-300 text-color-black\" _v-0a33281a=\"\">\n                        <div class=\"col-md-12 no-padding\" _v-0a33281a=\"\">\n                            <div class=\"col-md-12 no-padding\" _v-0a33281a=\"\">\n                                <div class=\"col-md-12 text-right no-padding pb-10\" _v-0a33281a=\"\">\n                                    <i aria-hidden=\"true\" class=\"fa fa-times font-20 pull-right cursor-pointer\" data-dismiss=\"modal\" _v-0a33281a=\"\"></i>\n                                </div>\n                                <div class=\"col-md-12 no-padding\" _v-0a33281a=\"\">\n                                    <table class=\"table table-bordered table-xxs\" _v-0a33281a=\"\">\n                                        <tbody _v-0a33281a=\"\">\n                                        <tr class=\"\" v-for=\"(client,order) in orders\" _v-0a33281a=\"\">\n                                            <td @click=\"calculateClientOrders(client)\" class=\"text-center text-bold no-margin-top no-margin-bottom cursor-pointer bg-slate-300 text-color-black border-black\" _v-0a33281a=\"\">\n                                                {{client}}\n                                            </td>\n                                        </tr>\n                                        </tbody>\n                                    </table>\n                                </div>\n\n                            </div>\n                        </div>\n\n                    </div>\n                    <div class=\"modal-body bg-slate-300\" _v-0a33281a=\"\">\n                        <table class=\"table table-bordered table-xxs\" _v-0a33281a=\"\">\n                            <tbody _v-0a33281a=\"\">\n                            <tr class=\"bg-slate-300\" v-show=\"clientName\" _v-0a33281a=\"\">\n                                <td class=\"text-center text-black bg-slate-800 border-black\" colspan=\"5\" _v-0a33281a=\"\">\n                                    {{ clientName }}\n                                </td>\n                            </tr>\n                            <tr class=\"bg-slate-300\" v-for=\"order in clientOrders\" _v-0a33281a=\"\">\n                                <td class=\"text-center text-center text-bold bg-slate-300 text-color-black border-black\" _v-0a33281a=\"\">\n                                    {{order.date}}\n                                </td>\n                                <td class=\"text-center text-center text-bold bg-slate-300 text-color-black border-black\" _v-0a33281a=\"\">\n                                    {{order.in_time}}\n                                </td>\n                                <td class=\"text-center text-center text-bold bg-slate-300 text-color-black border-black\" _v-0a33281a=\"\">\n                                    {{order.title}}\n                                </td>\n                                <td class=\"text-center text-center text-bold bg-slate-300 text-color-black border-black\" _v-0a33281a=\"\">\n                                    {{order.no_of_employee}}\n                                </td>\n                                <td class=\"text-center text-center text-bold bg-slate-300 text-color-black border-black\" _v-0a33281a=\"\">\n                                    <span @click=\"confirmAssignOrder(order)\" class=\"cursor-pointer\" v-if=\"order.no_of_employee != 'Full' \" _v-0a33281a=\"\">Add <i class=\"fa fa-plus-square-o\" _v-0a33281a=\"\"></i></span>\n                                </td>\n                            </tr>\n                            </tbody>\n                        </table>\n                    </div>\n                    <div class=\"modal-footer no-padding\" _v-0a33281a=\"\">\n                        <!--                        <button class=\"btn btn-primary\" type=\"button\">Save changes</button>-->\n                        <!--                        <button class=\"btn btn-secondary\" data-dismiss=\"modal\" type=\"button\">Close</button>-->\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <!--        <ul class=\"hidden\">-->\n        <!--            <li v-for=\"order in orders\">{{order.name}}</li>-->\n        <!--        </ul>-->\n    </div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  var id = "/home/shoieb/sites/elegant/resources/assets/js/vue/components/active-employee-list.vue"
  module.hot.dispose(function () {
    require("vueify-insert-css").cache["\n    .min-height-60[_v-0a33281a] {\n        min-height: 60px !important;\n    }\n\n    .border-black[_v-0a33281a] {\n        border-color: #000 !important;\n    }\n\n    .font-20[_v-0a33281a] {\n        font-size: 20px;\n    }\n\n    .font-14[_v-0a33281a] {\n        font-size: 14px;\n    }\n\n    .select2-results__option[aria-selected=true][_v-0a33281a] {\n        background-color: #2196F3;\n        color: #fff;\n        font-weight: 700;\n    }\n\n    ul#select2-jobId-results > li[_v-0a33281a] {\n        margin-top: 1px;\n        font-weight: 700 !important;\n    }\n\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, module.exports.template)
  }
})()}
},{"./../../mixed/modals":10,"./../../mixed/notify":11,"vue":5,"vue-hot-reload-api":4,"vueify-insert-css":6}],27:[function(require,module,exports){
var __vueify_style__ = require("vueify-insert-css").insert("\n.text-1[_v-713bc539] {\n  color: mediumseagreen;\n}\n\n.text-2[_v-713bc539] {\n  color: red;\n}\n")
"use strict";

exports.__esModule = true;
var modals = require("./../../mixed/modals");
var notify = require("./../../mixed/notify");

exports["default"] = {
  data: function data() {
    return {
      message: '',
      type: 1
    };
  },
  props: ["app"],
  filters: {},
  computed: {},
  watch: {},
  ready: function ready() {
    //this.getCallOutLogData();
  },
  events: {},
  methods: {
    sendSms: function sendSms() {
      var _this = this;

      notify.loading(true);
      this.$http.post("/api/broadcast-sms", {
        message: this.message,
        type: this.type
      }, function (response) {
        _this.message = '';
        _this.type = 1;
      }).always(function () {
        notify.loading(false);
      });
    }
  }
};
module.exports = exports["default"];
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n  <div class=\"row\" _v-713bc539=\"\">\n    <div class=\"col-md-8\" _v-713bc539=\"\">\n      <textarea name=\"\" id=\"\" cols=\"30\" rows=\"5\" class=\"form-control\" v-model=\"message\" placeholder=\"your text here\" _v-713bc539=\"\"></textarea>\n    </div>\n    <div class=\"col-md-4\" _v-713bc539=\"\">\n      <select name=\"\" id=\"\" v-model=\"type\" class=\"form-control\" _v-713bc539=\"\">\n        <option value=\"1\" _v-713bc539=\"\">Active &amp; Watchlist</option>\n        <option value=\"2\" _v-713bc539=\"\">Active &amp; Watchlist &amp; Reconfirmed/Worked</option>\n        <option value=\"3\" _v-713bc539=\"\">Active &amp; Watchlist &amp; Not Reconfirmed/Worked</option>\n      </select>\n    </div>\n    <div class=\"col-md-12 text-right pt-15\" _v-713bc539=\"\">\n      <button class=\"btn btn-primary\" @click=\"sendSms\" _v-713bc539=\"\">Broadcast SMS</button>\n    </div>\n  </div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  var id = "/home/shoieb/sites/elegant/resources/assets/js/vue/components/broadcast-sms.vue"
  module.hot.dispose(function () {
    require("vueify-insert-css").cache["\n.text-1[_v-713bc539] {\n  color: mediumseagreen;\n}\n\n.text-2[_v-713bc539] {\n  color: red;\n}\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, module.exports.template)
  }
})()}
},{"./../../mixed/modals":10,"./../../mixed/notify":11,"vue":5,"vue-hot-reload-api":4,"vueify-insert-css":6}],28:[function(require,module,exports){
var __vueify_style__ = require("vueify-insert-css").insert("\n\n    table tr th {\n        text-align: center;\n    }\n\n    table thead tr th {\n        border-width: 1px;\n    }\n\n    table thead tr th {\n        border-width: 1px;\n    }\n\n    .employee-info {\n        cursor: pointer;\n        background-color: #fff;\n    }\n\n    .employee-info td:not(:first-child) {\n        text-align: center;\n    }\n\n    .employee-info:hover, .activated {\n        background-color: #ddd !important;\n    }\n\n    .selected-info {\n        font-size: 14px;\n    }\n")
'use strict';

exports.__esModule = true;
var notify = require('./../../mixed/notify');
var modals = require('./../../mixed/modals');

exports['default'] = {
    data: function data() {
        return {
            jobs: [],
            currentJob: null,
            logs: [],
            btnStatus: true,
            picked: null,
            employeeOrder: false,
            employeeOrders: {},
            activeOrder: '',
            previousWeek: false,
            activeEmployee: {},
            activeNotes: {},
            orders: {},
            startDate: '',
            weekDates: [],
            showStatus: 0,
            responseAdd: false,
            statuses: {
                'contact': 'CONTACT',
                'confirm': 'CONFIRM',
                're-confirm': 'RE-CONFIRM',
                'need-change': 'NEED-CHANGE',
                'did-not-re-confirm': 'D.N.Rc',
                "cant-work-time": "CAN'T(this time)",
                "cant-work-job": "CAN'T(this job)",
                'delete': 'DELETE'
            },
            notes: {
                accounting: '',
                personal: '',
                shifts: '',
                referral: '',
                comments: ''
            }

        };
    },
    filters: {
        parseDate: function parseDate(date) {
            return moment(date, "YYYY-MM-DD").format('dddd, MM DD');
        },
        momentTime: function momentTime(time) {
            return moment(time, "YYYY-MM-DD HH:mm:ss").format('h:mm a');
        },
        parseDateEmployeeOrder: function parseDateEmployeeOrder(date) {
            return moment(date, "YYYY-MM-DD").format('dddd, MMMM DD');
        },
        oldtimeformate: function oldtimeformate(date) {
            var time = undefined;
            if (moment.duration(moment().diff(moment(date).startOf('day'))).asDays() < 7 && moment.duration(moment().diff(moment(date).startOf('day'))).asDays() >= 0) time = moment(date).format('ddd');else time = moment(date).format('MM/DD');

            return time;
        },
        timeEarly: function timeEarly(time, early) {
            return moment(time, "YYYY-MM-DD HH:mm:ss").subtract(early, 'minutes').format('h:mm a');
        },
        formateCategory: function formateCategory(category) {
            return category.replace(/\w\S*/g, function (txt) {
                return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
            });
        }
    },
    props: ['call1', 'call2'],
    ready: function ready() {
        var that = this;
        $('#employee-order-records').on('hidden.bs.modal', function () {
            that.employeeOrders = {};
        });
        if (typeof Cookies.get('startDate') === 'undefined') {
            Cookies.set('startDate', '');
        }
    },
    methods: {
        calledCompleted: function calledCompleted() {

            $("#modal_called").modal();
        },

        openCalenderParent: function openCalenderParent() {
            var _this = this;

            var self = this;

            self.$http.get('/api/action-board-calendar/' + this.employeeInfo.id + '/' + this.jobs[0].orderId, '', function (response) {
                self.orders = response.orders;
                self.startDate = response.startDate;
                self.weekDates = response.dates;

                var first = undefined;
                for (first in response.orders) {
                    if (response.orders[first].hasOwnProperty("data") && response.orders[first].data.length > 0) break;
                }

                // self.activeEmployee = response["orders"][first][0].employees[0];
                self.activeEmployee = response.employees;
                self.responseAdd = true;
                self.employeeOrderRecords(_this.activeEmployee, _this.jobs[0].orderId, response.date);
            }).always(function () {
                notify.loading(false);
            });

            //
        },
        calledCompletedProcess: function calledCompletedProcess(job) {

            var self = this;
            var queueList = null;
            var status = 1;
            if (job != null) {
                queueList = self.jobs;
                status = 2;
            } else queueList = self.jobs;

            if (self.picked == null) notify.error('Select a response of the call');else {
                self.$http.post('/api/completeCall', {
                    'id': self.activeEmployee.id,
                    'choice': self.picked,
                    'queue': queueList,
                    'status': status,
                    'responseAdd': self.responseAdd
                }, function (response) {

                    self.$http.get('/api/employee-order-records/' + self.employeeInfo.id + '?previous_week=' + self.previousWeek + '&startDate=', '', function (response) {
                        self.employeeOrders = _.groupBy(response.orders, 'day');
                    }).always(function () {});
                    self.employeeInfo.name = null;
                    self.employeeInfo.primary_phone = null;
                    self.employeeInfo.secondary_phone = null;
                    self.employeeInfo.email = null;
                    self.jobs = [];
                    self.logs = [];
                    self.picked = null;
                    self.btnStatus = true;
                    self.responseAdd = false;
                    $("#modal_called").modal('hide');

                    self.$dispatch('callReloadData');
                    self.$broadcast('clearCommonData');
                }).always(function () {});
            }
        },
        formateDate: function formateDate(datetime) {
            var dated = null;

            var selection_time = moment(datetime).startOf('day');

            if (moment.duration(selection_time.diff(moment().startOf('day'))).asDays() < 1) dated = "Today";else if (moment.duration(selection_time.diff(moment().startOf('day'))).asDays() < 2) dated = "Tomorrow";else if (moment.duration(selection_time.diff(moment().startOf('day'))).asWeeks() < 1) dated = moment(datetime).format("dddd MM-DD");else dated = moment(datetime).format("MM/DD");

            return dated;
        },
        formateTime: function formateTime(datetime) {
            return moment(datetime).format("hh:mm a");
        },
        formateLog: function formateLog(response, pos) {
            if (response.length > pos) return this.$options.filters.oldtimeformate(response[pos].created_at);else return "";
        },
        /**
         * show employee records
         * @param employee
         * @param orderId
         * @param orderDate
         * @param showModal
         * @param previousWeek
         */
        employeeOrderRecords: function employeeOrderRecords(employee, orderId) {
            var orderDate = arguments.length <= 2 || arguments[2] === undefined ? '' : arguments[2];

            var _this2 = this;

            var showModal = arguments.length <= 3 || arguments[3] === undefined ? true : arguments[3];
            var previousWeek = arguments.length <= 4 || arguments[4] === undefined ? false : arguments[4];

            this.previousWeek = previousWeek ? 1 : 0;
            this.activeEmployee = _.cloneDeep(employee);

            this.$http.get('/api/employee-order-records/' + this.employeeInfo.id + '?previous_week=' + this.previousWeek + '&startDate=', '', function (response) {
                _this2.employeeOrders = _.groupBy(response.orders, 'day');

                if (orderId) {
                    var activeOrder = _.find(response.orders[orderDate].data, {
                        order_id: orderId
                    });
                    _this2.setEmployeeOrder(activeOrder, moment(activeOrder.order.date, "YYYY-MM-DD").format('MMM DD'));
                    _this2.setActiveDate(orderDate, false);
                }
                _this2.activeNotes = _.groupBy(response.employee.notes, 'category');

                if (showModal) {
                    modals.showStrict("#employee-order-records");
                    // $('#employee-list').prop('selectedIndex', 0).selectric('refresh');
                }
            }).always(function () {
                notify.loading(false);
            });
        },
        /**
         * set a date as active on employee order calender
         * @param string
         */
        setActiveDate: function setActiveDate(string) {
            var status = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];

            this.activeDate = string;
            if (status) {
                this.employeeOrder = false;
                this.activeOrder = '';
            }
        },
        /**
         * set an order as active for employee orders
         * @param employeeOrder
         * @param date
         */
        setEmployeeOrder: function setEmployeeOrder(employeeOrder, date) {

            employeeOrder.status == 'move' ? this.showStatus = 0 : this.showStatus = 1;
            this.activeOrder = employeeOrder.order_id;
            this.employeeOrder = _.cloneDeep(employeeOrder);
            if (this.employeeOrder.order.uniforms.length > 0) {
                this.employeeOrder.uniforms = _.map(this.employeeOrder.order.uniforms, 'uniform');
            } else {
                this.employeeOrder.uniforms = _.map(this.employeeOrder.order.positions.uniforms, 'title');
            }
            this.activeDate = moment(this.employeeOrder.order.date, "YYYY-MM-DD").format('MMM DD');
            this.setActiveDate(date, false);
        },
        /**
         * update status for an employee of an order
         */
        updateEmployeeOrderStatus: function updateEmployeeOrderStatus() {
            var _this3 = this;

            notify.loading(true);
            this.$http.post('/api/employee-order-status-update/' + this.employeeOrder.employee_order_id, {
                status: this.employeeOrder.status,
                pay_rate: this.employeeOrder.pay_rate
            }, function (response) {
                _this3.activeDate = '';
                _this3.activeOrder = '';

                var queue = null;
                var currentID = _this3.employeeOrder.order.id;

                queue = _this3.jobs.filter(function (item) {
                    return item.orderId == currentID;
                });
                _this3.picked = "Answered";
                _this3.calledCompletedProcess(queue);
                _this3.getOrders();
                _this3.employeeOrder = false;

                _this3.currentOrder = response;
                //this.employeeOrderRecords(this.activeEmployee, response.id, response.date);

                //$("#employee-order-records").modal('hide');
            }).always(function () {
                notify.loading(false);
            });
        },

        /**
         * get orders for a week
         */
        getOrders: function getOrders() {
            var _this4 = this;

            orderIdDate = new Array();
            orderIdTime = new Array();
            notify.loading(true);
            this.$http.get('/api/dashboard-data?startDate=' + Cookies.get('startDate'), '', function (response) {
                _this4.orders = response.orders;
                if (!_this4.employees) {
                    _this4.employees = response.employees;
                }
                _this4.startDate = response.startDate;
                _this4.weekDates = response.dates;
            }).always(function () {
                notify.loading(false);
            });
        },

        /**
         * add notes for an employee for an order
         * @param note
         * @param category
         */
        addNote: function addNote(note, category) {
            var _this5 = this;

            notify.loading(true);
            this.$http.post('/api/employee-add-note', {
                note: note,
                employeeId: this.activeEmployee.pivot.employee_id,
                category: category
            }, function (response) {
                note = '';
            }).always(function () {
                _this5.employeeOrderRecords(_this5.activeEmployee);
            });
        },
        /**
         * close notes modal
         */
        closeNotes: function closeNotes() {
            modals.hide("#notes-modal");
        }

    },
    events: {
        'loadCalledModal': function loadCalledModal(jobs, employeeInfo) {
            this.jobs = jobs;
            this.responseAdd = true;
            this.employeeInfo = employeeInfo;
            this.activeEmployee = employeeInfo;
        },
        'loadOpenCalender': function loadOpenCalender(jobs, employeeInfo) {

            this.employeeInfo = employeeInfo;
            this.jobs = jobs;
            this.openCalenderParent();
        }
    }
};
module.exports = exports['default'];
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n    <div class=\"tab-pane\" id=\"call\">\n        <call-board :employee=\"call1\" flag=\"true\"></call-board>\n    </div>\n    <div class=\"tab-pane\" id=\"call2\">\n        <call-board :employee=\"call2\" flag=\"true\"></call-board>\n    </div>\n\n    <div id=\"modal_called\" class=\"modal fade\">\n        <div class=\"modal-dialog modal-xs\">\n            <div class=\"modal-content\">\n                <div class=\"modal-header bg-indigo-800\">\n                    Called\n                </div>\n                <div class=\"modal-body\">\n                    <form action=\"#\">\n                        <div class=\"col-md-12\">\n                            <div class=\"form-group\">\n                                <div class=\"radio\">\n                                    <label><input type=\"radio\" value=\"Left VM\" v-model=\"picked\" name=\"callledStatus\">Left Voicemail</label>\n                                </div>\n                                <div class=\"radio\">\n                                    <label><input type=\"radio\" value=\"No VM\" v-model=\"picked\" name=\"callledStatus\">Did'nt Leave Voicemail</label>\n                                </div>\n                                <div class=\"radio\">\n                                    <label><input type=\"radio\" value=\"VM Full\" v-model=\"picked\" name=\"callledStatus\">Voicemail Full</label>\n                                </div>\n                                <div class=\"radio\">\n                                    <label><input type=\"radio\" value=\"Hang Up\" v-model=\"picked\" name=\"callledStatus\">Hang Up</label>\n                                </div>\n                                <div class=\"radio\">\n                                    <label><input type=\"radio\" value=\"Disc\" v-model=\"picked\" name=\"callledStatus\">Line Disconnected</label>\n                                </div>\n                                <div class=\"radio\">\n                                    <label><input type=\"radio\" value=\"Wrong No\" v-model=\"picked\" name=\"callledStatus\">Wrong Number</label>\n                                </div>\n                            </div>\n                            <div class=\"text-right\">\n                                <button type=\"button\" class=\"btn btn-primary\" @click=\"calledCompletedProcess(null)\">Save\n                                </button>\n                            </div>\n                        </div>\n                    </form>\n                </div>\n\n                <div class=\"modal-footer\">\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"modal fade\" id=\"employee-order-records\">\n        <div class=\"modal-dialog modal-full\">\n            <div class=\"modal-content\">\n                <div class=\"modal-header pt-5\">\n                    <div class=\"row\">\n\n                        <div class=\"col-md-2 no-padding\">\n                            <div class=\"col-md-12 no-padding border-bottom border-bottom-grey-700\">\n                            <span class=\"text-black text-primary-600 pull-left underlined\">{{ activeEmployee.fullName + ' '}}\n                            </span>\n                                <label for=\"\" class=\"pl-20 ml-20 text-black text-grey-600 pull-right\">{{\n                                    activeEmployee.grooming+activeEmployee.attitude+activeEmployee.reliability+'-'+activeEmployee.background}}</label>\n                            </div>\n                            <div class=\"col-md-12 no-padding\">\n                            <span class=\"pull-left display-block text-grey-600\" id=\"primary-phone\" v-on:click=\"selectText('primary-phone')\">\n                            {{ activeEmployee.primary_phone | filterPhone}}\n                            </span>\n                                <span class=\"pull-right display-block text-grey-600\" id=\"secondary-phone\" v-on:click=\"selectText('secondary-phone')\">\n                                 {{ activeEmployee.secondary_phone | filterPhone}}\n                            </span>\n                            </div>\n                            <span class=\"text-grey-600 pull-left\" id=\"employee-email\" v-on:click=\"selectText('employee-email')\">\n                            {{ activeEmployee.email }}\n                        </span>\n                        </div>\n                        <div class=\"col-md-7\">\n                            <h6 v-show=\"employeeOrder\" class=\"text-center text-black text-primary-600\">\n                                {{ employeeOrder.company_code }} {{ employeeOrder.order.positions.title }}\n                                ({{ employeeOrder.date | momentMonthDay}})\n                            </h6>\n                        </div>\n                        <div class=\"col-md-3\">\n                            <i class=\"fa fa-times font-40  pull-right cursor-pointer\" data-dismiss=\"modal\" aria-hidden=\"true\"></i>\n                            <span v-if=\"employeeOrder.selection_type\" class=\"pt-20 text-black text-danger-700 text-capitalize pull-right mr-20\">{{ employeeOrder.selection_type }}\n                            Selection</span>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"modal-body no-padding-top\">\n                    <hr>\n                    <div class=\"row mb-10\" v-if=\"!showStatus\">\n                        <div class=\"col-md-4\"></div>\n                        <div class=\"col-md-4\" v-show=\"employeeOrder\">\n                            <button type=\"submit\" class=\"btn btn-success mr-20\" v-on:click.prevent=\"confirmProcessMove(1,'accept')\">Accept Move <i class=\"icon-checkmark4 position-right\"></i></button>\n\n                            <button type=\"submit\" class=\"btn btn-danger mr-20\" v-on:click.prevent=\"confirmProcessMove(0,'deny')\">Deny Move <i class=\"icon-cross2 position-right\"></i></button>\n\n                            <button type=\"submit\" class=\"btn btn-grey\" v-on:click.prevent=\"confirmProcessMove(2,'cancel')\">Cancel Move <i class=\"icon-minus3 position-right\"></i></button>\n                        </div>\n                        <div class=\"col-md-4\"></div>\n                    </div>\n\n                    <div class=\"panel panel-flat no-border\">\n                        <div class=\"row\">\n                            <div class=\"col-md-9\">\n                                <div class=\"row mb-10\" v-if=\"showStatus\">\n                                    <div class=\"col-md-12\">\n                                        <div class=\"col-md-10 col-sm-12 col-xs-12 no-padding pt-20\">\n                                            <div class=\"col-md-8th col-sm-8th col-xs-8th\" v-for=\"(index,status) in statuses\">\n                                                <div class=\"radio pull-left\">\n                                                    <label class=\"no-padding-left\">\n                                                        <input type=\"radio\" name=\"status\" v-model=\"employeeOrder.status\" class=\"control-primary radio-big\" value=\"{{ index }}\">\n                                                        <div></div>\n                                                        <span class=\"text-{{ index | removeQuote }} text-black text-size-mini\">{{ status }}</span>\n                                                    </label>\n                                                </div>\n                                            </div>\n                                        </div>\n                                        <div class=\"col-md-1 col-sm-3 col-xs-4\">\n                                            <div class=\"form-group\">\n                                                <label for=\"max_rate\">Pay Rate</label>\n                                                <input type=\"text\" class=\"form-control input-xs\" v-model=\"employeeOrder.pay_rate\">\n                                            </div>\n                                        </div>\n                                        <div class=\"col-md-1 pt-5 col-sm-3 col-xs-4\">\n                                            <br>\n                                            <button type=\"submit\" class=\"btn btn-primary\" v-on:click.prevent=\"updateEmployeeOrderStatus\">Update <i class=\"icon-arrow-right14 position-right\"></i></button>\n                                        </div>\n                                    </div>\n                                </div>\n                                <div class=\"col-md-12 no-padding\">\n                                    <div class=\"col-md-7th col-sm-7th col-xs-7th\" v-for=\"(index,o) in employeeOrders\">\n                                        <div class=\"panel order-grid\">\n                                            <div class=\"\">\n                                                <div class=\"panel invoice-grid bg-grey-600 panel-bordered no-margin-bottom\">\n                                                    <div class=\"text-center\">\n                                                        <h6 class=\"no-margin text-bold\">\n                                                            <span>{{ index }}</span>\n                                                        </h6>\n                                                    </div>\n                                                </div>\n                                            </div>\n                                        </div>\n                                        <div class=\"col-md-12 no-padding\" v-for=\"order in o\">\n                                            <div class=\"panel panel-flat border-2 border-slate-400\" v-bind:class=\"[ activeDate == order.date ? 'bg-active-order':'']\">\n                                                <div class=\"panel-heading pt-5 pr-5 mb-5\">\n                                                    <span class=\"badge badge-flat border-grey text-grey-600 font-11 pull-right pr-20\">{{ order.date }}</span>\n                                                </div>\n\n                                                <div class=\"panel-body height-100 no-padding text-center\">\n                                                    <div v-if=\"order.data\">\n                                                        <div class=\"height-100\" v-on:click=\"setActiveDate(order.date)\">\n                                                            <label v-for=\"o in order.data\" href=\"#\" v-on:click.stop=\"setEmployeeOrder(o,order.date)\" class=\"text-{{ o.status }} display-block mb-5 text-size-mini set-employee-order\">\n                                                                <label class=\"font-10\" v-bind:class=\"{'bg-active-order-label': ( o.order_id === activeOrder )}\">\n                                                                    {{ o.company_code }}\n                                                                    {{ o.order.positions.title }}\n                                                                    -{{ o.order.in_time | timeEarly\n                                                                    o.order.positions.minutes_early }}\n                                                                </label>\n                                                            </label>\n                                                        </div>\n                                                    </div>\n                                                    <div class=\"height-full\" v-else=\"\">\n                                                        <div class=\"col-md-12 height-full\" v-on:click=\"setActiveDate(order.date)\">\n\n                                                        </div>\n                                                    </div>\n                                                </div>\n                                            </div>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n\n\n                            <div class=\"col-md-3 col-sm-6 col-xs-12\" v-show=\"employeeOrder\">\n                                <div class=\"mb-10\">\n                                    <h5 class=\"display-block text-slate-800 text-semibold no-padding-top no-margin-top\">{{\n                                        employeeOrder.order.client.name }}</h5>\n                                    <span class=\"display-block text-size-small\">{{ employeeOrder.order.client.address_line_1 }}</span>\n                                    <h6>\n                                        <hr class=\"no-margin no-padding p-5\">\n                                        <span class=\"display-block\">{{ employeeOrder.order.positions.title }}</span>\n                                        <span class=\"display-block\">{{ employeeOrder.order.date | parseDateEmployeeOrder }}</span>\n                                        <span class=\"display-block\">{{ employeeOrder.order.in_time | timeEarly employeeOrder.order.positions.minutes_early }}\n                                        - {{ employeeOrder.order.out_time | momentTime }}</span>\n                                        <span class=\"display-block\">$ {{ employeeOrder.pay_rate | parseNumber}}\n                                </span>\n                                    </h6>\n                                    <hr class=\"no-margin no-padding mb-5\">\n                                    <h6 v-show=\"employeeOrder.uniforms.length\">\n                                    <span class=\"display-block text-slate-800 text-semibold\">\n                                        {{--<i class=\"icon-people\"></i> --}}\n                                        Uniforms</span>\n                                        <span class=\"display-block text-size-small\">\n                                    <span v-for=\"( index, uniform) in employeeOrder.uniforms\">\n                                        <span v-if=\"index+1 < employeeOrder.uniforms.length\">{{ uniform }},</span>\n                                        <span v-else=\"\">{{ uniform }}</span>\n                                    </span>\n                                </span>\n                                    </h6>\n                                    <h6 v-show=\"employeeOrder.order.positions.tools.length\">\n                                    <span class=\"display-block text-slate-800 text-semibold\">\n                                        {{--<i class=\"fa fa-cogs\"></i>--}}\n                                        Tools</span>\n                                        <span class=\"display-block text-size-small\">\n                                    <span v-for=\"(index, tool) in employeeOrder.order.positions.tools\">\n                                        <span v-if=\"index+1 < employeeOrder.order.positions.tools.length\">{{ tool.title }}\n                                            ,</span>\n                                        <span v-else=\"\">{{ tool.title }}</span>\n                                    </span>\n                                    </span>\n                                    </h6>\n                                    <hr class=\"no-margin no-padding mb-5\">\n                                    <span class=\"display-block text-slate-800 text-semibold\" v-show=\"employeeOrder.order.text_instruction\">Text Instruction</span>\n                                    <span v-show=\"employeeOrder.order.text_instruction\" class=\"display-block text-size-small\">\n                                {{{employeeOrder.order.text_instruction}}}\n                                </span>\n                                    <span class=\"display-block text-slate-800 text-semibold\" v-show=\"employeeOrder.order.positions.employee_note\">Employee Note</span>\n                                    <span v-show=\"employeeOrder.order.positions.employee_note\" class=\"display-block text-size-small\">\n                                {{{employeeOrder.order.positions.employee_note}}}\n                                </span>\n\n\n                                    <h6 class=\"text-slate-800 text-semibold\">Contacts</h6>\n                                    <ul class=\"media-list content-group\">\n                                        <li class=\"media stack-media-on-mobile no-margin\" v-for=\"contact in employeeOrder.order.positions.contacts\" v-if=\"contact.contact.main_phone\">\n                                            <div class=\"media-body\">\n                                            <span class=\"media-heading\">\n                                                <i class=\"fa fa-user\"></i> {{ contact.contact.first_name +' ' + contact.contact.last_name }}\n                                                - {{ contact.contact.main_phone | filterPhone }}\n                                            </span>\n                                            </div>\n                                        </li>\n                                    </ul>\n                                    <hr class=\"no-margin no-padding mb-5\">\n                                </div>\n\n                                <span class=\"display-block text-slate-800 text-semibold\" v-show=\"employeeOrder.order.special_instruction\">Special Instruction</span>\n                                <span v-show=\"employeeOrder.order.special_instruction\" class=\"display-block text-size-small\">\n                                {{{employeeOrder.order.special_instruction}}}\n                            </span>\n                                <span class=\"display-block text-slate-800 text-semibold\" v-show=\"employeeOrder.order.positions.admin_note\">Admin Note</span>\n                                <span v-show=\"employeeOrder.order.positions.admin_note\" class=\"display-block text-size-small\">\n                                {{{employeeOrder.order.positions.admin_note}}}\n                            </span>\n                            </div>\n                        </div>\n                        <div class=\"row\">\n                            <div class=\"col-md-2\">\n                                <a class=\"btn btn-primary pull-left ml-10\" data-toggle=\"modal\" href=\"#notes-modal\" data-backdrop=\"static\" data-keyboard=\"false\">Notes</a>\n                            </div>\n                            <div class=\"col-md-8 text-center pt-10\">\n                                <div class=\"col-md-4\">\n                                    <label for=\"\" class=\"col-md-4 control-label text-black text-slate-700 text-right\">Set\n                                        Date:</label>\n                                    <div class=\"col-md-8\">\n                                        <input type=\"text\" class=\"form-control pickadate-year-normal\" v-model=\"previousRecordStartDate\">\n                                    </div>\n                                </div>\n                                <div class=\"col-md-4\">\n                                <span class=\"text-black text-slate-300 ml-5 cursor-pointer\" v-on:click.prevent=\"employeeRecordsPreviousWeek(1)\">\n                                    <span v-if=\"previousWeek\">Current Week</span>\n                                    <span v-else=\"\">Previous Week </span>\n                                </span>\n                                </div>\n                                <div class=\"col-md-4 pr-30\">\n                                <span v-on:click.prevent=\"employeeJobSearch()\" class=\"text-black text-danger-600 ml-10 cursor-pointer\">Job Requested</span>\n                                </div>\n                            </div>\n                            <div class=\"col-md-2\">\n                                <a class=\"btn btn-primary pull-right\" data-toggle=\"modal\" href=\"#no-answer\" data-backdrop=\"static\" data-keyboard=\"false\">No Answer</a>\n                            </div>\n                        </div>\n\n\n                    </div>\n                </div>\n            </div><!-- /.modal-content -->\n        </div><!-- /.modal-dialog -->\n    </div><!-- /.modal -->\n    <div class=\"modal fade\" id=\"notes-modal\">\n        <div class=\"modal-dialog modal-full\">\n            <div class=\"modal-content\">\n                <div class=\"modal-body\">\n                    <div class=\"col-md-12\">\n                        <div class=\"panel panel-flat\">\n                            <div class=\"panel-heading\">\n                                <h6 class=\"panel-title\">@{{ activeEmployee.fullName }}\n                                    <i class=\"fa fa-times font-40  pull-right cursor-pointer\" v-on:click=\"closeNotes\"></i>\n                                </h6>\n                            </div>\n\n                            <div class=\"panel-body\">\n                                <div class=\"tabbable\">\n                                    <ul class=\"nav nav-tabs nav-tabs-highlight\">\n                                        <li class=\"active\"><a href=\"#accounting-payroll\" data-toggle=\"tab\">\n                                            Accounting and Payroll</a></li>\n                                        <li><a href=\"#personal-information\" data-toggle=\"tab\">Personal\n                                            Information</a></li>\n                                        <li><a href=\"#shift-requests\" data-toggle=\"tab\">Shift Requests</a>\n                                        </li>\n                                        <li><a href=\"#referral-recommendations\" data-toggle=\"tab\">Referral and\n                                            Recommendations</a></li>\n                                        <li><a href=\"#comments\" data-toggle=\"tab\">Comments</a></li>\n                                    </ul>\n\n                                    <div class=\"tab-content\">\n                                        <div class=\"tab-pane active\" id=\"accounting-payroll\">\n                                            <div class=\"row\">\n                                                <div class=\"col-md-6\">\n                                                    <div class=\"form-group\">\n                                                        <label for=\"\"> Note:</label>\n                                                        <textarea name=\"\" id=\"\" cols=\"30\" rows=\"8\" class=\"form-control\" v-model=\"notes.accounting\"></textarea>\n                                                        <br><br>\n                                                        <button type=\"submit\" class=\"btn btn-primary\" v-on:click.prevent=\"addNote(notes.accounting,'accounting')\">\n                                                            Save Notes <i class=\"icon-arrow-right14 position-right\"></i>\n                                                        </button>\n                                                    </div>\n                                                </div>\n                                                <div class=\"col-md-6\">\n                                                    <ul class=\"media-list\">\n                                                        <li class=\"media\" v-for=\"note in activeNotes.accounting\">\n                                                            <div class=\"media-left\">\n                                                                <a href=\"#\" class=\"btn border-pink text-pink btn-flat btn-rounded btn-icon btn-xs\">\n                                                                    <i class=\"fa fa-comments\"></i>\n                                                                </a>\n                                                            </div>\n\n                                                            <div class=\"media-body\">\n                                                                @{{ note.note }}\n                                                                <div class=\"media-annotation\">@{{ note.created_at | momentDateTime}}\n                                                                    by @{{ note.user.name }}\n                                                                </div>\n                                                            </div>\n                                                        </li>\n                                                    </ul>\n                                                </div>\n\n                                            </div>\n                                        </div>\n                                        <div class=\"tab-pane\" id=\"personal-information\">\n                                            <div class=\"row\">\n                                                <div class=\"col-md-6\">\n                                                    <div class=\"form-group\">\n                                                        <label for=\"\"> Note:</label>\n                                                        <textarea name=\"\" id=\"\" cols=\"30\" rows=\"8\" class=\"form-control\" v-model=\"notes.personal\"></textarea>\n                                                        <br><br>\n                                                        <button type=\"submit\" class=\"btn btn-primary\" v-on:click.prevent=\"addNote(notes.personal,'personal')\">\n                                                            Save Notes <i class=\"icon-arrow-right14 position-right\"></i>\n                                                        </button>\n                                                    </div>\n                                                </div>\n                                                <div class=\"col-md-6\">\n                                                    <ul class=\"media-list\">\n                                                        <li class=\"media\" v-for=\"note in activeNotes.personal\">\n                                                            <div class=\"media-left\">\n                                                                <a href=\"#\" class=\"btn border-pink text-pink btn-flat btn-rounded btn-icon btn-xs\">\n                                                                    <i class=\"fa fa-comments\"></i>\n                                                                </a>\n                                                            </div>\n\n                                                            <div class=\"media-body\">\n                                                                @{{ note.note }}\n                                                                <div class=\"media-annotation\">@{{ note.created_at | momentDateTime}}\n                                                                    by @{{ note.user.name }}\n                                                                </div>\n                                                            </div>\n                                                        </li>\n                                                    </ul>\n                                                </div>\n                                            </div>\n                                        </div>\n                                        <div class=\"tab-pane\" id=\"shift-requests\">\n                                            <div class=\"row\">\n                                                <div class=\"col-md-6\">\n                                                    <div class=\"form-group\">\n                                                        <label for=\"\"> Note:</label>\n                                                        <textarea name=\"\" id=\"\" cols=\"30\" rows=\"8\" class=\"form-control\" v-model=\"notes.shifts\"></textarea>\n                                                        <br><br>\n                                                        <button type=\"submit\" class=\"btn btn-primary\" v-on:click.prevent=\"addNote(notes.shifts,'shifts')\">\n                                                            Save Notes <i class=\"icon-arrow-right14 position-right\"></i>\n                                                        </button>\n                                                    </div>\n                                                </div>\n                                                <div class=\"col-md-6\">\n                                                    <ul class=\"media-list\">\n                                                        <li class=\"media\" v-for=\"note in activeNotes.shifts\">\n                                                            <div class=\"media-left\">\n                                                                <a href=\"#\" class=\"btn border-pink text-pink btn-flat btn-rounded btn-icon btn-xs\">\n                                                                    <i class=\"fa fa-comments\"></i>\n                                                                </a>\n                                                            </div>\n\n                                                            <div class=\"media-body\">\n                                                                @{{ note.note }}\n                                                                <div class=\"media-annotation\">@{{ note.created_at | momentDateTime}}\n                                                                    by @{{ note.user.name }}\n                                                                </div>\n                                                            </div>\n                                                        </li>\n                                                    </ul>\n                                                </div>\n                                            </div>\n                                        </div>\n                                        <div class=\"tab-pane\" id=\"referral-recommendations\">\n                                            <div class=\"row\">\n                                                <div class=\"col-md-6\">\n                                                    <div class=\"form-group\">\n                                                        <label for=\"\"> Note:</label>\n                                                        <textarea name=\"\" id=\"\" cols=\"30\" rows=\"8\" class=\"form-control\" v-model=\"notes.referral\"></textarea>\n                                                        <br><br>\n                                                        <button type=\"submit\" class=\"btn btn-primary\" v-on:click.prevent=\"addNote(notes.referral,'referral')\">\n                                                            Save Notes <i class=\"icon-arrow-right14 position-right\"></i>\n                                                        </button>\n                                                    </div>\n                                                </div>\n                                                <div class=\"col-md-6\">\n                                                    <ul class=\"media-list\">\n                                                        <li class=\"media\" v-for=\"note in activeNotes.referral\">\n                                                            <div class=\"media-left\">\n                                                                <a href=\"#\" class=\"btn border-pink text-pink btn-flat btn-rounded btn-icon btn-xs\">\n                                                                    <i class=\"fa fa-comments\"></i>\n                                                                </a>\n                                                            </div>\n\n                                                            <div class=\"media-body\">\n                                                                @{{ note.note }}\n                                                                <div class=\"media-annotation\">@{{ note.created_at | momentDateTime}}\n                                                                    by @{{ note.user.name }}\n                                                                </div>\n                                                            </div>\n                                                        </li>\n                                                    </ul>\n                                                </div>\n                                            </div>\n                                        </div>\n                                        <div class=\"tab-pane\" id=\"comments\">\n                                            <div class=\"row\">\n                                                <div class=\"col-md-6\">\n                                                    <div class=\"form-group\">\n                                                        <label for=\"\"> Note:</label>\n                                                        <textarea name=\"\" id=\"\" cols=\"30\" rows=\"8\" class=\"form-control\" v-model=\"notes.comments\"></textarea>\n                                                        <br><br>\n                                                        <button type=\"submit\" class=\"btn btn-primary\" v-on:click.prevent=\"addNote(notes.comments,'comments')\">\n                                                            Save Notes <i class=\"icon-arrow-right14 position-right\"></i>\n                                                        </button>\n                                                    </div>\n                                                </div>\n                                                <div class=\"col-md-6\">\n                                                    <ul class=\"media-list\">\n                                                        <li class=\"media\" v-for=\"note in activeNotes.comments\">\n                                                            <div class=\"media-left\">\n                                                                <a href=\"#\" class=\"btn border-pink text-pink btn-flat btn-rounded btn-icon btn-xs\">\n                                                                    <i class=\"fa fa-comments\"></i>\n                                                                </a>\n                                                            </div>\n\n                                                            <div class=\"media-body\">\n                                                                @{{ note.note }}\n                                                                <div class=\"media-annotation\">@{{ note.created_at | momentDateTime}}\n                                                                    by @{{ note.user.name }}\n                                                                </div>\n                                                            </div>\n                                                        </li>\n                                                    </ul>\n                                                </div>\n                                            </div>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"modal-footer\">\n\n                </div>\n            </div><!-- /.modal-content -->\n        </div><!-- /.modal-dialog -->\n    </div><!-- /.modal -->\n\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  var id = "/home/shoieb/sites/elegant/resources/assets/js/vue/components/call-action-board.vue"
  module.hot.dispose(function () {
    require("vueify-insert-css").cache["\n\n    table tr th {\n        text-align: center;\n    }\n\n    table thead tr th {\n        border-width: 1px;\n    }\n\n    table thead tr th {\n        border-width: 1px;\n    }\n\n    .employee-info {\n        cursor: pointer;\n        background-color: #fff;\n    }\n\n    .employee-info td:not(:first-child) {\n        text-align: center;\n    }\n\n    .employee-info:hover, .activated {\n        background-color: #ddd !important;\n    }\n\n    .selected-info {\n        font-size: 14px;\n    }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, module.exports.template)
  }
})()}
},{"./../../mixed/modals":10,"./../../mixed/notify":11,"vue":5,"vue-hot-reload-api":4,"vueify-insert-css":6}],29:[function(require,module,exports){
var __vueify_style__ = require("vueify-insert-css").insert("\n\n    table tr th {\n        text-align: center;\n    }\n\n    table thead tr th {\n        border-width: 1px;\n    }\n\n    table thead tr th {\n        border-width: 1px;\n    }\n\n    .employee-info {\n        cursor: pointer;\n        background-color: #fff;\n    }\n\n    .employee-info td:not(:first-child) {\n        text-align: center;\n    }\n\n    .employee-info:hover, .activated {\n        background-color: #ddd !important;\n    }\n\n    .selected-info {\n        font-size: 14px;\n    }\n")
'use strict';

exports.__esModule = true;
var notify = require('./../../mixed/notify');
var modals = require('./../../mixed/modals');

exports['default'] = {
    data: function data() {
        return {
            employeeInfo: {
                id: null,
                name: null,
                primary_phone: null,
                secondary_phone: null,
                email: null
            },
            jobs: [],
            currentJob: null,
            logs: [],
            btnStatus: true,
            picked: null,
            employeeOrder: false,
            employeeOrders: {},
            activeOrder: '',
            previousWeek: false,
            activeEmployee: {},
            activeNotes: {},
            orders: {},
            startDate: '',
            weekDates: [],
            showStatus: 0,
            statuses: {
                'contact': 'CONTACT',
                'confirm': 'CONFIRM',
                're-confirm': 'RE-CONFIRM',
                'need-change': 'NEED-CHANGE',
                'did-not-re-confirm': 'D.N.Rc',
                "cant-work-time": "CAN'T(this time)",
                "cant-work-job": "CAN'T(this job)",
                'delete': 'DELETE'
            },
            notes: {
                accounting: '',
                personal: '',
                shifts: '',
                referral: '',
                comments: ''
            },
            currentUser: window.current_user
        };
    },
    filters: {
        parseDate: function parseDate(date) {
            return moment(date, "YYYY-MM-DD").format('dddd, MM DD');
        },
        momentTime: function momentTime(time) {
            return moment(time, "YYYY-MM-DD HH:mm:ss").format('h:mm a');
        },
        parseDateEmployeeOrder: function parseDateEmployeeOrder(date) {
            return moment(date, "YYYY-MM-DD").format('dddd, MMMM DD');
        },
        oldtimeformate: function oldtimeformate(date) {
            var time = undefined;
            if (moment.duration(moment().diff(moment(date).startOf('day'))).asDays() < 7 && moment.duration(moment().diff(moment(date).startOf('day'))).asDays() >= 0) time = moment(date).format('ddd');else time = moment(date).format('MM/DD');

            return time;
        },
        timeEarly: function timeEarly(time, early) {
            return moment(time, "YYYY-MM-DD HH:mm:ss").subtract(early, 'minutes').format('h:mm a');
        },
        formateCategory: function formateCategory(category) {
            if (category == "move") return "Move From \n" + " To";else return category.replace("-", " ").replace("-", " ").replace(/\w\S*/g, function (txt) {
                return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
            });
        }
    },
    props: ['employee'],

    ready: function ready() {},
    watch: {
        employee: function employee(n, o) {
            for (index = 0, len = n.length; index < len; ++index) {
                if (n[index].user_id == current_user) this.loadEmployee(n[index], null);
            }
        }
    },
    methods: {
        checkUser: function checkUser(userId) {
            //let cl = parseInt(a) == parseInt(current_user);
            //return cl;
            if (userId) {
                if (userId == this.currentUser) {
                    return 'bg-blue-300-custom';
                } else {
                    return 'activated';
                }
            } else {
                return 'employee-info';
            }
        },
        loadEmployee: function loadEmployee(user, event) {

            if (event) {
                $(".bg-blue-300-custom").removeClass("bg-blue-300-custom");
                el = event.target;
                el.parentNode = event.target.parentNode;
            }
            var self = this;
            self.employeeInfo.id = null;
            self.employeeInfo.name = null;
            self.employeeInfo.primary_phone = null;
            self.employeeInfo.secondary_phone = null;
            self.employeeInfo.email = null;
            self.jobs = [];
            self.logs = [];

            self.$http.get('/api/get-employee-task-list/' + user.id, function (response) {
                self.employeeInfo.id = user.id;
                self.employeeInfo.name = user.name;
                self.employeeInfo.primary_phone = user.primary_phone;
                self.employeeInfo.secondary_phone = user.secondary_phone;
                self.employeeInfo.email = user.email;
                self.jobs = response.task;
                self.logs = response.logs;
                self.btnStatus = false;

                if (event) {
                    while (el && el.parentNode) {
                        el = el.parentNode;
                        if (el.tagName && el.tagName.toLowerCase() == "tr") {
                            el.className = " bg-blue-300-custom";
                            break;
                        }
                    }
                }
            }).always(function () {});
        },
        calledCompleted: function calledCompleted() {
            this.$dispatch('loadCalledModal', this.jobs, this.employeeInfo);
            $("#modal_called").modal();
        },
        openCalender: function openCalender() {
            this.$dispatch('loadOpenCalender', this.jobs, this.employeeInfo);
        },
        calledCompletedProcess: function calledCompletedProcess(job) {
            var self = this;
            var queueList = null;
            var status = 1;
            if (job != null) {
                queueList = self.jobs;
                status = 2;
            } else queueList = self.jobs;

            if (self.picked == null) notify.error('Select a response of the call');else {
                self.$http.post('/api/completeCall', {
                    'id': self.employeeInfo.id,
                    'choice': self.picked,
                    'queue': queueList,
                    'status': status
                }, function (response) {
                    self.employeeInfo.id = null;
                    self.employeeInfo.name = null;
                    self.employeeInfo.primary_phone = null;
                    self.employeeInfo.secondary_phone = null;
                    self.employeeInfo.email = null;
                    self.jobs = [];
                    self.logs = [];
                    self.picked = null;
                    self.btnStatus = true;
                    $("#modal_called").modal('hide');

                    self.$dispatch('callReloadData');
                }).always(function () {});
            }
        },
        jobDescription: function jobDescription(row) {
            if (row.title == "time-change") return this.formateDate(row.date) + ", " + row.name + ", " + row.position + ". OLD " + this.formateTime(row.base_in_time) + "-" + this.formateTime(row.base_out_time) + ". NEW " + this.formateTime(row.in_time) + "-" + this.formateTime(row.out_time) + ".";else if (row.title == "move") return this.formateDate(row.date) + " " + this.formateTime(row.in_time) + "-" + this.formateTime(row.out_time) + ", " + row.name + ", " + row.position + ", " + row.pay_rate + " / hour";else return this.formateDate(row.date) + " " + this.formateTime(row.in_time) + "-" + this.formateTime(row.out_time) + ", " + row.name + ", " + row.position + ", " + row.pay_rate + " / hour";
        },

        moveDescription: function moveDescription(from) {

            return this.formateDate(from.date) + " " + this.formateTime(from.in_time) + "-" + this.formateTime(from.out_time) + ", " + from.order.client.name + ", " + from.order.position.title + ", " + from.pay_rate + " / hour";
        },

        formateDate: function formateDate(datetime) {
            var dated = null;

            var selection_time = moment(datetime).startOf('day');

            if (moment.duration(selection_time.diff(moment().startOf('day'))).asDays() < 1) dated = "Today";else if (moment.duration(selection_time.diff(moment().startOf('day'))).asDays() < 2) dated = "Tomorrow";else if (moment.duration(selection_time.diff(moment().startOf('day'))).asWeeks() < 1) dated = moment(datetime).format("dddd MM-DD");else dated = moment(datetime).format("MM/DD");

            return dated;
        },
        formateTime: function formateTime(datetime) {
            return moment(datetime).format("hh:mm a");
        },
        formateLog: function formateLog(response, pos) {
            if (response.length > pos) return this.$options.filters.oldtimeformate(response[pos].created_at);else return "";
        },

        /**
         * add notes for an employee for an order
         * @param note
         * @param category
         */
        addNote: function addNote(note, category) {
            var _this = this;

            notify.loading(true);
            this.$http.post('/api/employee-add-note', {
                note: note,
                employeeId: this.activeEmployee.pivot.employee_id,
                category: category
            }, function (response) {
                note = '';
            }).always(function () {
                _this.employeeOrderRecords(_this.activeEmployee);
            });
        },
        /**
         * close notes modal
         */
        closeNotes: function closeNotes() {
            modals.hide("#notes-modal");
        }

    },
    events: {
        'clearCommonData': function clearCommonData() {
            this.jobs = null;
            this.logs = null;
            this.picked = null;
            this.btnStatus = true;
        }
    }
};
module.exports = exports['default'];
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n    <div class=\"panel panel-flat no-border\">\n        <div class=\"row mb-15\">\n            <div class=\"col-md-offset-8 col-md-4 mb-5\" align=\"center\">\n                <button type=\"button\" class=\"btn bg-danger bg-darken-4 btn-xs\" @click=\"openCalender\">Open Calendar</button>\n            </div>\n            <div class=\"col-md-12 bg-primary-300\">\n                <div class=\"col-md-9\">\n                    <div class=\"row selected-info\">\n                        <div class=\"col-md-3\"><strong>{{employeeInfo.name}}</strong></div>\n                        <div class=\"col-md-2\">{{employeeInfo.primary_phone}}</div>\n                        <div class=\"col-md-2\">{{employeeInfo.secondary_phone}}</div>\n                        <div class=\"col-md-3\">{{employeeInfo.email}}</div>\n                    </div>\n                </div>\n                <div class=\"col-md-3\">\n                    <div class=\"col-md-4\">Time</div>\n                    <div class=\"col-md-4\">Called By</div>\n                    <div class=\"col-md-4\">Remarks</div>\n                </div>\n            </div>\n            <div class=\"col-md-12 no-padding-right\">\n                <div class=\"col-md-9\">\n                    <div class=\"row mt-5 mb-5\" v-for=\"row in jobs\">\n                        <div v-if=\"row.title !='move'\">\n                            <div class=\"col-md-4 pt-5 pb-5\" v-bind:class=\"{ 'bg-danger-700': row.status ==0,  'bg-orange-600': row.status ==1,  'bg-yellow': row.status ==2 }\">{{row.title\n                                | formateCategory}}\n                            </div>\n                            <div class=\"col-md-8 mt-5 mb-5\">{{jobDescription(row)}}</div>\n                        </div>\n                        <div v-else=\"\">\n                            <div class=\"col-md-4 pt-5\" align=\"center\" v-bind:class=\"{ 'bg-danger-700': row.status ==0,  'bg-orange-600': row.status ==1,  'bg-yellow': row.status ==2 }\">Move From\n                            </div>\n                            <div class=\"col-md-8 mt-5\">{{moveDescription(row.from)}}</div>\n                            <div class=\"col-md-4 pb-5\" align=\"center\" v-bind:class=\"{ 'bg-danger-700': row.status ==0,  'bg-orange-600': row.status ==1,  'bg-yellow': row.status ==2 }\">To\n                            </div>\n                            <div class=\"col-md-8 mb-5\">{{jobDescription(row)}}</div>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"col-md-3\">\n                    <div class=\"row bg-slate-300\" v-for=\"log in logs\">\n                        <div class=\"col-md-4\">{{log.created_at | oldtimeformate}}</div>\n                        <div class=\"col-md-4\">{{log.user.name}}</div>\n                        <div class=\"col-md-4\">{{log.type}}</div>\n                    </div>\n                    <button type=\"button\" class=\"btn bg-primary btn-xs pull-right m-10\" @click=\"calledCompleted\" :disabled=\"btnStatus\">Called</button>\n\n                </div>\n            </div>\n            <div class=\"col-md-12\">\n                <table class=\"table\">\n                    <thead>\n                    <tr>\n                        <th rowspan=\"2\" class=\"col-md-2 bg-success-600 no-padding\" align=\"center\">Employee Name</th>\n                        <th rowspan=\"2\" class=\"col-md-1 no-padding bg-slate-600\">Time Change</th>\n                        <th rowspan=\"2\" class=\"col-md-1 no-padding bg-slate-600\">Time Conflict</th>\n                        <th rowspan=\"2\" class=\"col-md-1 no-padding bg-slate-600\">Other Change</th>\n                        <th rowspan=\"2\" class=\"col-md-1 no-padding bg-slate-600\">Job Cancel</th>\n                        <th rowspan=\"2\" class=\"col-md-1 no-padding bg-slate-600\">Client Request</th>\n                        <th rowspan=\"2\" class=\"col-md-1 no-padding bg-slate-600\">Move</th>\n                        <th rowspan=\"2\" class=\"col-md-1 no-padding bg-slate-600\">Reconfirm</th>\n                        <th rowspan=\"2\" class=\"col-md-1 no-padding bg-slate-600\">New Job</th>\n                        <th colspan=\"4\" class=\"col-md-2 no-padding bg-success-600\" align=\"center\">Call Log</th>\n                    </tr>\n                    <tr class=\"bg-success bg-success-800\">\n                        <th class=\"blue-grey darken-4 no-padding\" align=\"center\">1st</th>\n                        <th class=\"blue-grey darken-4 no-padding\" align=\"center\">2nd</th>\n                        <th class=\"blue-grey darken-4 no-padding\" align=\"center\">3rd</th>\n                        <th class=\"blue-grey darken-4 no-padding\" lign=\"center\">4th</th>\n                    </tr>\n                    </thead>\n                </table>\n            </div>\n            <div class=\"col-md-12 pre-scrollable-500\">\n                <table class=\"table\" width=\"100%\" cellspacing=\"1\" cellpadding=\"0\">\n                    <tbody><tr v-for=\"row in employee\" v-bind:class=\"[ checkUser(row.user_id) ,'' ]\" @click=\"loadEmployee(row, $event)\">\n                        <td class=\"pl-5\">{{row.name}}</td>\n                        <td v-bind:class=\"{ 'bg-danger-700': row.timeChange.state ==0,  'bg-orange-600': row.timeChange.state ==1,  'bg-yellow': row.timeChange.state ==2 }\">\n                            <span v-if=\"row.timeChange.count\">\n                                {{row.timeChange.count}} {{row.timeChange.earlyTime}}\n                            </span>\n                        </td>\n                        <td v-bind:class=\"{ 'bg-danger-700': row.timeConflict.state ==0,  'bg-orange-600': row.timeConflict.state ==1,  'bg-yellow': row.timeConflict.state ==2 }\">\n                            <span v-if=\"row.timeConflict.count\">\n                                {{row.timeConflict.count}} {{row.timeConflict.earlyTime}}\n                            </span>\n                        </td>\n                        <td v-bind:class=\"{ 'bg-danger-700': row.otherChange.state ==0,  'bg-orange-600': row.otherChange.state ==1,  'bg-yellow': row.otherChange.state ==2 }\">\n                            <span v-if=\"row.otherChange.count\">\n                                {{row.otherChange.count}} {{row.otherChange.earlyTime}}\n                            </span>\n                        </td>\n                        <td v-bind:class=\"{ 'bg-danger-700': row.jobCancel.state ==0,  'bg-orange-600': row.jobCancel.state ==1,  'bg-yellow': row.jobCancel.state ==2 }\">\n                            <span v-if=\"row.jobCancel.count\">\n                                {{row.jobCancel.count}} {{row.jobCancel.earlyTime}}\n                            </span>\n                        </td>\n                        <td v-bind:class=\"{ 'bg-danger-700': row.clientRequest.state ==0,  'bg-orange-600': row.clientRequest.state ==1,  'bg-yellow': row.clientRequest.state ==2 }\">\n                            <span v-if=\"row.clientRequest.count\">\n                                {{row.clientRequest.count}} {{row.clientRequest.earlyTime}}\n                            </span>\n                        </td>\n                        <td v-bind:class=\"{ 'bg-danger-700': row.move.state ==0,  'bg-orange-600': row.move.state ==1,  'bg-yellow': row.move.state ==2 }\">\n                            <span v-if=\"row.move.count\">\n                                {{row.move.count}} {{row.move.earlyTime}}\n                            </span>\n                        </td>\n                        <td v-bind:class=\"{ 'bg-danger-700': row.reconfirmationJob.state ==0,  'bg-orange-600': row.reconfirmationJob.state ==1,  'bg-yellow': row.reconfirmationJob.state ==2 }\">\n                            <span v-if=\"row.reconfirmationJob.count\">\n                                {{row.reconfirmationJob.count}} {{row.reconfirmationJob.earlyTime}}\n                            </span>\n                        </td>\n                        <td v-bind:class=\"{ 'bg-danger-700': row.newJob.state ==0,  'bg-orange-600': row.newJob.state ==1,  'bg-yellow': row.newJob.state ==2 }\">\n                            <span v-if=\"row.newJob.count\">\n                                {{row.newJob.count}} {{row.newJob.earlyTime}}\n                            </span>\n                        </td>\n                        <td>{{formateLog(row.response,0)}}</td>\n                        <td>{{formateLog(row.response,1)}}</td>\n                        <td>{{formateLog(row.response,2)}}</td>\n                        <td>{{formateLog(row.response,3)}}</td>\n                    </tr>\n                </tbody></table>\n            </div>\n        </div>\n    </div>\n\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  var id = "/home/shoieb/sites/elegant/resources/assets/js/vue/components/call-board.vue"
  module.hot.dispose(function () {
    require("vueify-insert-css").cache["\n\n    table tr th {\n        text-align: center;\n    }\n\n    table thead tr th {\n        border-width: 1px;\n    }\n\n    table thead tr th {\n        border-width: 1px;\n    }\n\n    .employee-info {\n        cursor: pointer;\n        background-color: #fff;\n    }\n\n    .employee-info td:not(:first-child) {\n        text-align: center;\n    }\n\n    .employee-info:hover, .activated {\n        background-color: #ddd !important;\n    }\n\n    .selected-info {\n        font-size: 14px;\n    }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, module.exports.template)
  }
})()}
},{"./../../mixed/modals":10,"./../../mixed/notify":11,"vue":5,"vue-hot-reload-api":4,"vueify-insert-css":6}],30:[function(require,module,exports){
var __vueify_style__ = require("vueify-insert-css").insert("\n    .text-1[_v-50140e1a] {\n        color: mediumseagreen;\n    }\n\n    .text-2[_v-50140e1a] {\n        color: red;\n    }\n")
"use strict";

exports.__esModule = true;
var modals = require("./../../mixed/modals");
var notify = require("./../../mixed/notify");

exports["default"] = {
    data: function data() {
        return {
            state: false,
            employees: {},
            orders: {},
            activeOrder: {},
            response: "",
            latestResponses: {},
            callOutStatus: 0
        };
    },
    props: ["app"],
    filters: {},
    computed: {
        pendingOrders: function pendingOrders() {
            return this.orders.filter(function (e) {
                return e.call_out_verification_status == 0;
            });
        },
        resolvedOrders: function resolvedOrders() {
            return this.orders.filter(function (e) {
                return e.call_out_verification_status != 0;
            });
        }
    },
    watch: {
        'callOutStatus': function callOutStatus(val) {
            this.getCallOutLogData();
        }
    },
    ready: function ready() {
        //this.getCallOutLogData();
    },
    events: {},
    methods: {
        /**
         * get employee report data
         */
        getCallOutLogData: function getCallOutLogData() {
            var _this = this;

            notify.loading(true);
            this.$http.post("/api/call-out-log", {
                callOutStatus: this.callOutStatus == 0 ? [0] : [1, 2]
            }, function (response) {
                _this.employees = response;
                _this.$nextTick(function () {
                    $('[data-popup="popover"]').popover();
                });
            }).always(function () {
                notify.loading(false);
            });
        },

        /**
         * get single employee report data
         */
        getCallOutLogDataEmployee: function getCallOutLogDataEmployee(employeeId) {
            var _this2 = this;

            notify.loading(true);
            this.$http.post("/api/call-out-log/" + employeeId, {
                callOutStatus: this.callOutStatus == 0 ? [0] : [1, 2]
            }, function (response) {
                _this2.orders = response.logs;
                _this2.latestResponses = response.responses;
                modals.showStrict("#employee-call-out");
                _this2.$nextTick(function () {
                    $('[data-popup="popover"]').popover();
                });
            }).always(function () {
                notify.loading(false);
            });
        },

        callOutActionModal: function callOutActionModal(order) {
            this.activeOrder = _.cloneDeep(order);
            modals.showStrict("#call-out-action");
        },

        updateCallOutStatus: function updateCallOutStatus() {
            var _this3 = this;

            notify.loading(true);
            this.$http.post("/api/update-call-out-status/", this.activeOrder, function (response) {
                _this3.getCallOutLogDataEmployee(_this3.activeOrder.employee_id);

                modals.hide("#call-out-action");
            }).always(function () {
                notify.loading(false);
            });
        },

        saveResponse: function saveResponse() {
            var _this4 = this;

            notify.loading(true);
            var orderIds = _.pluck(this.orders, "order_id");
            this.$http.post("/api/save-employee-call-out-response/", {
                employee_id: this.orders[0].employee_id,
                type: this.response,
                entry_point: "Call Out Log",
                orderIds: orderIds
            }, function (response) {
                _this4.response = "";
                notify.info("Response saved successfully");
                _this4.getCallOutLogDataEmployee(_this4.orders[0].employee_id);
                _this4.getCallOutLogData();
            }).always(function () {
                notify.loading(false);
            });
        }
    }
};
module.exports = exports["default"];
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n    <div class=\"row\" _v-50140e1a=\"\">\n        <div class=\"col-md-11\" _v-50140e1a=\"\">\n            <h4 class=\"no-margin text-semibold text-center text-black text-color-black\" _v-50140e1a=\"\">CALL OUT LOG REPORT</h4>\n        </div>\n        <div class=\"col-md-1\" _v-50140e1a=\"\">\n            <select class=\"form-control select\" name=\"role\" v-model=\"callOutStatus\" v-select2=\"callOutStatus\" _v-50140e1a=\"\">\n                <option :value=\"0\" _v-50140e1a=\"\">Pending</option>\n                <option :value=\"1\" _v-50140e1a=\"\">Resolved</option>\n            </select>\n        </div>\n        <div class=\"col-md-12 p-5\" _v-50140e1a=\"\">\n            <div class=\"table-responsive\" _v-50140e1a=\"\">\n                <table class=\"table table-xxs table-bordered\" _v-50140e1a=\"\">\n                    <thead _v-50140e1a=\"\">\n                    <tr _v-50140e1a=\"\">\n                        <th class=\"text-uppercase text-left text-black bg-slate-700\" _v-50140e1a=\"\">Name</th>\n                        <th class=\"text-uppercase text-left text-black bg-slate-700\" _v-50140e1a=\"\">Shift</th>\n                        <th class=\"text-uppercase text-left text-black bg-slate-700\" _v-50140e1a=\"\">Job Date</th>\n                        <th class=\"text-uppercase text-left text-black bg-slate-700\" _v-50140e1a=\"\">Time</th>\n                        <th class=\"text-uppercase text-left text-black bg-slate-700\" _v-50140e1a=\"\">Call Out</th>\n                        <th class=\"text-uppercase text-left text-black bg-slate-700\" _v-50140e1a=\"\">Reason</th>\n                        <th class=\"text-uppercase text-left text-black bg-slate-700\" _v-50140e1a=\"\">Other CO</th>\n                        <th class=\"text-uppercase text-left text-black bg-slate-700\" _v-50140e1a=\"\">Worked 180</th>\n                        <th class=\"text-uppercase text-left text-black bg-slate-700\" _v-50140e1a=\"\">Call/VM</th>\n                        <th class=\"text-uppercase text-left text-black bg-slate-700\" _v-50140e1a=\"\">Last Call</th>\n                        <th class=\"text-uppercase text-left text-black bg-slate-700\" _v-50140e1a=\"\">Action</th>\n                    </tr>\n                    </thead>\n                    <tbody _v-50140e1a=\"\">\n                    <tr :key=\"index\" v-for=\"(index, employee) in employees\" _v-50140e1a=\"\">\n                        <td class=\"text-left\" _v-50140e1a=\"\">{{employee.name}}</td>\n                        <td class=\"text-left\" _v-50140e1a=\"\">{{employee.company_code+' '+employee.title}}</td>\n                        <td class=\"text-left\" _v-50140e1a=\"\">{{ employee.date }}</td>\n                        <td class=\"text-left\" _v-50140e1a=\"\">{{ employee.in_time }}</td>\n                        <td class=\"text-left\" _v-50140e1a=\"\">{{ employee.call_out_at }}</td>\n                        <td class=\"text-left\" _v-50140e1a=\"\">\n                            <button :data-content=\"employee.employee_note\" class=\"btn btn-default btn-sm text-slate-300\" data-html=\"true\" data-popup=\"popover\" data-title=\"\" data-trigger=\"hover\" type=\"button\" v-if=\"employee.employee_note\" _v-50140e1a=\"\">\n                                <i class=\"icon-notebook position-right\" _v-50140e1a=\"\"></i>\n                            </button>\n                        </td>\n                        <td class=\"text-left text-danger-400 text-black\" _v-50140e1a=\"\">{{ employee.call_outs_count &gt; 1 ? employee.call_outs_count:null}}\n                        </td>\n                        <td class=\"text-center\" _v-50140e1a=\"\">{{ employee.worked_half_year_count }}</td>\n                        <td class=\"text-left\" _v-50140e1a=\"\">{{ }}</td>\n                        <td class=\"text-left\" _v-50140e1a=\"\">{{ employee.last_call }}</td>\n                        <td class=\"text-left\" _v-50140e1a=\"\">\n                            <button @click=\"getCallOutLogDataEmployee(employee.employee_id)\" class=\"btn bg-success-300 text-center\" _v-50140e1a=\"\">Details\n                            </button>\n                        </td>\n                    </tr>\n                    </tbody>\n                </table>\n            </div>\n        </div>\n\n        <div class=\"modal\" id=\"employee-call-out\" role=\"dialog\" tabindex=\"-1\" _v-50140e1a=\"\">\n            <div class=\"modal-dialog modal-medium\" role=\"document\" _v-50140e1a=\"\">\n                <div class=\"modal-content\" _v-50140e1a=\"\">\n                    <div class=\"modal-header pt-0 bg-slate-300\" _v-50140e1a=\"\">\n                        <div class=\"row\" _v-50140e1a=\"\">\n                            <div class=\"col-md-12 mb-10 overflow-hidden pt-10\" _v-50140e1a=\"\">\n                                <div class=\"col-md-4 text-left\" _v-50140e1a=\"\">\n                                    <span class=\"display-block text-color-black text-black\" _v-50140e1a=\"\">{{ orders[0].name }}</span>\n                                    <span class=\"display-block text-black text-color-black\" _v-50140e1a=\"\">{{ orders[0].primary_phone }}</span>\n                                    <span class=\"display-block text-black text-color-black\" _v-50140e1a=\"\">{{ orders[0].secondary_phone }}</span>\n                                    <span class=\"display-block text-color-black\" _v-50140e1a=\"\">{{ orders[0].email }}</span>\n                                </div>\n                                <div class=\"col-md-3\" _v-50140e1a=\"\">\n                                    <span class=\"text-center bg-slate-400 text-black display-block\" _v-50140e1a=\"\">Call Log</span>\n                                    <p :key=\"response.created_at\" class=\"bg-slate-300 text-black display-block text-slate\" v-for=\"response in latestResponses\" _v-50140e1a=\"\">\n                                        <span class=\"text-left pr-20 mr-20\" _v-50140e1a=\"\">{{ response.date }}</span>\n                                        <span class=\"text-right pl-20 ml-20\" _v-50140e1a=\"\">{{ response.type }}</span>\n                                    </p>\n                                </div>\n                                <div class=\"col-md-3 text-right\" _v-50140e1a=\"\">\n                  <span class=\"display-block\" _v-50140e1a=\"\">\n                    <label class=\"text-black text-color-black\" for=\"\" _v-50140e1a=\"\">Just Called</label>\n                    <input type=\"radio\" v-model=\"response\" value=\"Call\" _v-50140e1a=\"\">\n                  </span>\n                                    <span class=\"display-block\" _v-50140e1a=\"\">\n                    <label class=\"text-black text-color-black\" for=\"\" _v-50140e1a=\"\">Left VM</label>\n                    <input type=\"radio\" v-model=\"response\" value=\"VM\" _v-50140e1a=\"\">\n                  </span>\n                                    <span class=\"display-block\" _v-50140e1a=\"\">\n                    <input @click=\"saveResponse()\" class=\"btn btn-primary\" type=\"submit\" value=\"Submit\" _v-50140e1a=\"\">\n                  </span>\n                                </div>\n                                <div class=\"col-md-2 text-right\" _v-50140e1a=\"\">\n                                    <i aria-hidden=\"true\" class=\"fa fa-times font-40 pull-right cursor-pointer\" data-dismiss=\"modal\" _v-50140e1a=\"\"></i>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"modal-body\" _v-50140e1a=\"\">\n                        <div class=\"table-responsive\" _v-50140e1a=\"\">\n                            <table class=\"table table-xss table-bordered table-condensed\" _v-50140e1a=\"\">\n                                <thead _v-50140e1a=\"\">\n                                <tr _v-50140e1a=\"\">\n                                    <th class=\"text-center bg-slate-600 text-black text-uppercase\" _v-50140e1a=\"\">Job Date</th>\n                                    <th class=\"text-center bg-slate-600 text-black text-uppercase\" _v-50140e1a=\"\">Shift</th>\n                                    <th class=\"text-center bg-slate-600 text-black text-uppercase\" _v-50140e1a=\"\">Time</th>\n                                    <th class=\"text-center bg-slate-600 text-black text-uppercase\" _v-50140e1a=\"\">Call Out</th>\n                                    <th class=\"text-center bg-slate-600 text-black text-uppercase\" _v-50140e1a=\"\">Reason</th>\n                                    <th class=\"text-center bg-slate-600 text-black text-uppercase\" _v-50140e1a=\"\">Comment</th>\n                                    <th class=\"text-center bg-slate-600 text-black text-uppercase\" _v-50140e1a=\"\">Action</th>\n                                </tr>\n                                </thead>\n                                <tbody _v-50140e1a=\"\">\n                                <tr :key=\"index\" v-for=\"(index,order) in pendingOrders\" _v-50140e1a=\"\">\n                                    <td class=\"text-center p-5\" _v-50140e1a=\"\">{{ order.date }}</td>\n                                    <td class=\"text-center p-5\" _v-50140e1a=\"\">{{ order.company_code+' '+order.title }}</td>\n                                    <td class=\"text-center p-5\" _v-50140e1a=\"\">{{ order.in_time }}</td>\n                                    <td class=\"text-center p-5\" _v-50140e1a=\"\">{{ order.call_out_at }}</td>\n                                    <td class=\"text-center p-5\" _v-50140e1a=\"\">\n                                        <button :data-content=\"order.employee_note\" class=\"btn btn-default btn-sm text-slate-300\" data-html=\"true\" data-popup=\"popover\" data-title=\"\" data-trigger=\"hover\" type=\"button\" v-if=\"order.employee_note\" _v-50140e1a=\"\">\n                                            <i class=\"icon-notebook position-right\" _v-50140e1a=\"\"></i>\n                                        </button>\n                                    </td>\n                                    <td class=\"text-center p-5\" _v-50140e1a=\"\">\n                                        <button :data-content=\"order.call_out_verification_note\" class=\"btn btn-default btn-sm text-slate-300\" data-html=\"true\" data-popup=\"popover\" data-title=\"\" data-trigger=\"hover\" type=\"button\" v-if=\"order.call_out_verification_note\" _v-50140e1a=\"\">\n                                            <i class=\"icon-notebook position-right\" _v-50140e1a=\"\"></i>\n                                        </button>\n                                    </td>\n                                    <td class=\"text-center p-5\" _v-50140e1a=\"\">\n                                        <button @click=\"callOutActionModal(order)\" class=\"btn btn-info text-center\" _v-50140e1a=\"\">Action\n                                        </button>\n                                    </td>\n                                </tr>\n                                <tr _v-50140e1a=\"\">\n                                    <td class=\"bg-slate-300 text-center\" colspan=\"7\" _v-50140e1a=\"\">PAST CALL OUTS</td>\n                                </tr>\n                                <tr :key=\"index\" v-for=\"(index,order) in resolvedOrders\" _v-50140e1a=\"\">\n                                    <td class=\"text-center p-5\" _v-50140e1a=\"\">{{ order.date }}</td>\n                                    <td class=\"text-center p-5\" _v-50140e1a=\"\">{{ order.company_code+' '+order.title }}</td>\n                                    <td class=\"text-center p-5\" _v-50140e1a=\"\">{{ order.in_time }}</td>\n                                    <td class=\"text-center p-5\" _v-50140e1a=\"\">{{ order.call_out_at }}</td>\n                                    <td class=\"text-center p-5\" _v-50140e1a=\"\">\n                                        <button :data-content=\"order.employee_note\" class=\"btn btn-default btn-sm text-slate-300\" data-html=\"true\" data-popup=\"popover\" data-title=\"\" data-trigger=\"hover\" type=\"button\" v-if=\"order.employee_note\" _v-50140e1a=\"\">\n                                            <i class=\"icon-notebook position-right\" _v-50140e1a=\"\"></i>\n                                        </button>\n                                    </td>\n                                    <td class=\"text-center p-5\" _v-50140e1a=\"\">\n                                        <button :data-content=\"order.call_out_verification_note\" class=\"btn btn-default btn-sm text-slate-300\" data-html=\"true\" data-popup=\"popover\" data-title=\"\" data-trigger=\"hover\" type=\"button\" v-if=\"order.call_out_verification_note\" _v-50140e1a=\"\">\n                                            <i class=\"icon-notebook position-right\" _v-50140e1a=\"\"></i>\n                                        </button>\n                                    </td>\n                                    <td :class=\"'text-'+order.call_out_verification_status\" class=\"text-center p-5\" _v-50140e1a=\"\">{{order.call_out_verification_status === 1 ? 'Clear':'In Record'}}\n                                    </td>\n                                </tr>\n                                </tbody>\n                            </table>\n                        </div>\n                    </div>\n                    <div class=\"modal-footer\" _v-50140e1a=\"\">\n                        <!-- <button type=\"button\" class=\"btn btn-primary\">Save changes</button>\n                        <button type=\"button\" class=\"btn btn-secondary\" data-dismiss=\"modal\">Close</button>-->\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"modal\" id=\"call-out-action\" role=\"dialog\" tabindex=\"-1\" _v-50140e1a=\"\">\n            <div class=\"modal-dialog\" role=\"document\" _v-50140e1a=\"\">\n                <div class=\"modal-content no-padding\" _v-50140e1a=\"\">\n                    <div class=\"modal-header no-padding\" _v-50140e1a=\"\">\n                        <button aria-label=\"Close\" class=\"close\" data-dismiss=\"modal\" type=\"button\" _v-50140e1a=\"\">\n                            <span aria-hidden=\"true\" _v-50140e1a=\"\">×</span>\n                        </button>\n                    </div>\n                    <div class=\"modal-body no-padding\" _v-50140e1a=\"\">\n                        <div class=\"row bg-slate-600 row text-center pb-10 pt-10\" _v-50140e1a=\"\">\n                            <span class=\"text-center font-20\" _v-50140e1a=\"\">Action</span>\n                            <span class=\"text-right\" _v-50140e1a=\"\">\n                <i aria-hidden=\"true\" class=\"fa fa-times font-40 pull-right pr-10 cursor-pointer\" data-dismiss=\"modal\" _v-50140e1a=\"\"></i>\n              </span>\n                        </div>\n                        <div class=\"row bg-grey-300\" _v-50140e1a=\"\">\n                            <p class=\"text-center bg-grey-300 text-black text-color-black pt-10 pb-10\" _v-50140e1a=\"\">\n                                <span class=\"mr-20\" _v-50140e1a=\"\">{{ activeOrder.company_code+' '+activeOrder.title }}</span>\n                                <span class=\"mr-20\" _v-50140e1a=\"\">{{ activeOrder.date}}</span>\n                                <span class=\"\" _v-50140e1a=\"\">{{ activeOrder.in_time}}</span>\n                            </p>\n                            <div class=\"col-md-6 pb-10\" _v-50140e1a=\"\">\n                <span class=\"display-block\" _v-50140e1a=\"\">\n                  <label class=\"text-black text-danger-700\" for=\"\" _v-50140e1a=\"\">Sent To Record</label>\n                  <input :value=\"2\" name=\"call-out-status\" type=\"radio\" v-model=\"activeOrder.call_out_verification_status\" _v-50140e1a=\"\">\n                </span>\n                                <span class=\"display-block\" _v-50140e1a=\"\">\n                  <label class=\"text-black text-green-400\" for=\"\" _v-50140e1a=\"\">Clear Record</label>\n                  <input :value=\"1\" name=\"call-out-status\" type=\"radio\" v-model=\"activeOrder.call_out_verification_status\" _v-50140e1a=\"\">\n                </span>\n                            </div>\n                            <div class=\"col-md-6 pb-10\" _v-50140e1a=\"\">\n                <span class=\"display-block\" _v-50140e1a=\"\">\n                  <label class=\"text-black\" for=\"\" _v-50140e1a=\"\">Still Pending</label>\n                  <input :value=\"0\" name=\"call-out-status\" type=\"radio\" v-model=\"activeOrder.call_out_verification_status\" _v-50140e1a=\"\">\n                </span>\n                                <button @click=\"updateCallOutStatus()\" class=\"btn btn-primary text-center\" _v-50140e1a=\"\">Submit\n                                </button>\n                            </div>\n                            <div class=\"cool-md-12\" _v-50140e1a=\"\">\n                <textarea class=\"form-control\" cols=\"30\" id=\"\" name=\"\" placeholder=\"Comment\" rows=\"3\" v-model=\"activeOrder.call_out_verification_note\" _v-50140e1a=\"\"></textarea>\n                            </div>\n                        </div>\n                    </div>\n                    <!-- <div class=\"modal-footer\">\n                      <button type=\"button\" class=\"btn btn-primary\">Save changes</button>\n                      <button type=\"button\" class=\"btn btn-secondary\" data-dismiss=\"modal\">Close</button>\n                    </div>-->\n                </div>\n            </div>\n        </div>\n    </div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  var id = "/home/shoieb/sites/elegant/resources/assets/js/vue/components/call-out-log.vue"
  module.hot.dispose(function () {
    require("vueify-insert-css").cache["\n    .text-1[_v-50140e1a] {\n        color: mediumseagreen;\n    }\n\n    .text-2[_v-50140e1a] {\n        color: red;\n    }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, module.exports.template)
  }
})()}
},{"./../../mixed/modals":10,"./../../mixed/notify":11,"vue":5,"vue-hot-reload-api":4,"vueify-insert-css":6}],31:[function(require,module,exports){
var __vueify_style__ = require("vueify-insert-css").insert("\n\n\t.task-list span{\n\t\tdisplay: inline-block;\n\t\twidth: 33%;\n\t}\n\t.task-list{\n\t\ttext-align: center;\n\t}\n")
'use strict';

exports.__esModule = true;
var notify = require('./../../mixed/notify');

exports['default'] = {
    data: function data() {
        return {
            employees: [],
            jobSummaryMessage: '',
            jobTitle: null,
            jobDate: null,
            jobTime: null,
            salary: null,
            currentOrder: null
        };
    },
    props: ['joblist'],
    ready: function ready() {},
    methods: {
        updateActiveList: function updateActiveList() {
            var _this = this;

            var self = this;
            self.$http.post('/api/completeTask', { 'employees': this.employees }, function (response) {
                var rem = 0;
                var i = 0;

                self.employees = self.employees.filter(function (item) {
                    i++;
                    if (item.status == 1 || item.status == true) rem++;
                    return item.status == 0 || item.status == false;
                });

                for (job in _this.joblist) {
                    if (_this.joblist[job].orderId == self.currentOrder.orderId && _this.joblist[job].rate == self.salary && _this.joblist[job].grp == self.currentOrder.grp && _this.joblist[job].user != null) {
                        if (_this.joblist[job].recipent != rem) _this.joblist[job].recipent -= rem;else {
                            self.joblist = self.joblist.filter(function (item) {
                                if (item.separator == self.currentOrder.separator) {
                                    return false;
                                } else return true;
                            });

                            _this.$dispatch('counterRecount', 13);
                            _this.jobSummaryMessage = '';
                            _this.jobTitle = null;
                            _this.jobDate = null;
                            _this.jobTime = null;
                            _this.salary = null;
                            _this.employees = null;
                        }
                        break;
                    }
                }
            }).always(function () {});
        }
    },
    events: {
        'loadNew': function loadNew(task) {

            notify.loading(true);
            var self = this;
            self.jobTitle = task.employee + ' ' + task.needed + ' ' + task.post;

            self.jobTime = task.inTime + "-" + task.outTime;
            self.currentOrder = task;

            if (moment.duration(moment(task.date).diff(moment().startOf('day'))).asDays() < 1) self.jobDate = "Today";else if (moment.duration(moment(task.date).diff(moment().startOf('day'))).asDays() < 2) self.jobDate = "Tomorrow";else self.jobDate = moment(task.date).format("dddd, MMMM Do,");

            self.$http.put('/api/get-employee-list/', { list: task.empList, orderId: task.orderId, type: 'client-request', service: 'call-broadcast', rate: task.rate, limit: task.recipent }, function (response) {
                self.employees = response;
                for (var pos in self.employees) {
                    self.employees[pos].status = Boolean(parseInt(self.employees[pos].status));
                }
                self.salary = response[0].pay_rate;
                self.jobSummaryMessage = "hi this is……\n" + self.jobDate + "\n" + "at, " + task.employeeName + "\n" + "to confrm, please call…";
            }).always(function () {
                notify.loading(false);
            });
        },
        'clearMessage': function clearMessage(task) {
            var flag = false;
            for (var pos in this.joblist) {
                if (this.joblist[pos].user == current_user) flag = true;
            }
            if (flag == false) {
                this.employees = null;
                this.jobSummaryMessage = '';
                this.jobTitle = null;
                this.jobDate = null;
                this.jobTime = null;
                this.salary = null;
            }
        }
    }
};
module.exports = exports['default'];
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"row mb-15\">\n    <div class=\"col-md-4\">\n        <div class=\"col-md-12 bg-slate no-padding\">\n            <div class=\"col-md-5 small\">{{jobTitle}}</div>\n            <div class=\"col-md-2 no-padding small\">{{jobDate}}</div>\n            <div class=\"col-md-5 small\" align=\"center\">{{jobTime}}</div>\n        </div>\n        <textarea name=\"jobSummaryMessage\" id=\"jobSummaryMessage\" cols=\"30\" rows=\"18\" class=\"form-control\" v-model=\"jobSummaryMessage\"></textarea>\n    </div>\n    <div class=\"col-md-8\">\n        <div class=\"col-md-12\">\n            <button type=\"button\" class=\"btn btn-primary btn-xs pull-right\" v-on:click=\"updateActiveList\">Complete</button>\n        </div>\n        <div class=\"col-md-12\">\n            <div class=\"table-responsive\">\n                <table class=\"table table-xxs\">\n                    <thead>\n                    <tr>\n\n                        <th>Name</th>\n                        <th>Phone 1</th>\n                        <th>Phone 2</th>\n                        <th>Email</th>\n                        <th></th>\n                    </tr>\n                    </thead>\n                    <tbody>\n                    <tr v-for=\"employee in employees\">\n                        <td>{{employee.first_name}} {{employee.last_name}}</td>\n                        <td>{{employee.primary_phone}}</td>\n                        <td>{{employee.secondary_phone}}</td>\n                        <td>{{employee.email}}</td>\n                        <td><input type=\"checkbox\" v-model=\"employee.status\" value=\"1\"></td>\n                    </tr>\n\n                    </tbody>\n                </table>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"col-md-12\">\n        <div class=\"row task-list\">\n        \t<div class=\"col-md-2\" v-for=\"item of joblist\">\n        \t\t<new-job-task :task=\"item\"></new-job-task>\n        \t</div>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  var id = "/home/shoieb/sites/elegant/resources/assets/js/vue/components/callb-client-request.vue"
  module.hot.dispose(function () {
    require("vueify-insert-css").cache["\n\n\t.task-list span{\n\t\tdisplay: inline-block;\n\t\twidth: 33%;\n\t}\n\t.task-list{\n\t\ttext-align: center;\n\t}\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, module.exports.template)
  }
})()}
},{"./../../mixed/notify":11,"vue":5,"vue-hot-reload-api":4,"vueify-insert-css":6}],32:[function(require,module,exports){
var __vueify_style__ = require("vueify-insert-css").insert("\n\n\t.task-list span{\n\t\tdisplay: inline-block;\n\t\twidth: 33%;\n\t}\n\t.task-list{\n\t\ttext-align: center;\n\t}\n")
'use strict';

exports.__esModule = true;
var notify = require('./../../mixed/notify');

exports['default'] = {
    data: function data() {
        return {
            employees: [],
            jobSummaryMessage: '',
            jobTitle: null,
            jobDate: null,
            jobTime: null,
            salary: null,
            currentOrder: null
        };
    },
    props: ['joblist'],
    ready: function ready() {},
    methods: {
        updateActiveList: function updateActiveList() {
            var _this = this;

            var self = this;
            self.$http.post('/api/completeTask', { 'employees': this.employees }, function (response) {
                var rem = 0;
                var i = 0;

                self.employees = self.employees.filter(function (item) {
                    i++;
                    if (item.status == 1 || item.status == true) rem++;
                    return item.status == 0 || item.status == false;
                });

                for (job in _this.joblist) {
                    if (_this.joblist[job].orderId == self.currentOrder.orderId && _this.joblist[job].rate == self.salary && _this.joblist[job].grp == self.currentOrder.grp && _this.joblist[job].user != null) {
                        if (_this.joblist[job].recipent != rem) _this.joblist[job].recipent -= rem;else {
                            self.joblist = self.joblist.filter(function (item) {
                                if (item.separator == self.currentOrder.separator) {
                                    return false;
                                } else return true;
                            });

                            _this.$dispatch('counterRecount', 18);
                            _this.jobSummaryMessage = '';
                            _this.jobTitle = null;
                            _this.jobDate = null;
                            _this.jobTime = null;
                            _this.salary = null;
                            _this.employees = null;
                        }
                        break;
                    }
                }
            }).always(function () {});
        }
    },
    events: {
        'loadNew': function loadNew(task) {
            notify.loading(true);
            var self = this;
            self.jobTitle = task.employee + ' ' + task.needed + ' ' + task.post;

            self.jobTime = task.inTime + "-" + task.outTime;
            self.currentOrder = task;

            if (moment.duration(moment(task.date).diff(moment().startOf('day'))).asDays() < 1) self.jobDate = "Today";else if (moment.duration(moment(task.date).diff(moment().startOf('day'))).asDays() < 2) self.jobDate = "Tomorrow";else self.jobDate = moment(task.date).format("dddd, MMMM Do,");

            self.$http.put('/api/get-employee-list/', { list: task.empList, orderId: task.orderId, type: 'job-cancel', service: 'call-broadcast', rate: task.rate, limit: task.recipent }, function (response) {
                self.employees = response;
                for (var pos in self.employees) {
                    self.employees[pos].status = Boolean(parseInt(self.employees[pos].status));
                }
                self.salary = response[0].pay_rate;
                self.jobSummaryMessage = "The following shift has been\n" + self.jobDate + "\n" + task.employeeName + "\n" + "For the details, please call\n" + "ELEGANT STAFFING\n" + "800-807-8503 ext.2";
            }).always(function () {
                notify.loading(false);
            });
        },
        'clearMessage': function clearMessage(task) {
            var flag = false;
            for (var pos in this.joblist) {
                if (this.joblist[pos].user == current_user) flag = true;
            }
            if (flag == false) {
                this.employees = null;
                this.jobSummaryMessage = '';
                this.jobTitle = null;
                this.jobDate = null;
                this.jobTime = null;
                this.salary = null;
            }
        }
    }
};
module.exports = exports['default'];
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"row mb-15\">\n    <div class=\"col-md-4\">\n        <div class=\"col-md-12 bg-slate no-padding\">\n            <div class=\"col-md-5 small\">{{jobTitle}}</div>\n            <div class=\"col-md-2 no-padding small\">{{jobDate}}</div>\n            <div class=\"col-md-5 small\" align=\"center\">{{jobTime}}</div>\n        </div>\n        <textarea name=\"jobSummaryMessage\" id=\"jobSummaryMessage\" cols=\"30\" rows=\"18\" class=\"form-control\" v-model=\"jobSummaryMessage\"></textarea>\n    </div>\n    <div class=\"col-md-8\">\n        <div class=\"col-md-12\">\n            <button type=\"button\" class=\"btn btn-primary btn-xs pull-right\" v-on:click=\"updateActiveList\">Complete</button>\n        </div>\n        <div class=\"col-md-12\">\n            <div class=\"table-responsive\">\n                <table class=\"table table-xxs\">\n                    <thead>\n                    <tr>\n\n                        <th>Name</th>\n                        <th>Phone 1</th>\n                        <th>Phone 2</th>\n                        <th>Email</th>\n                        <th></th>\n                    </tr>\n                    </thead>\n                    <tbody>\n                    <tr v-for=\"employee in employees\">\n                        <td>{{employee.first_name}} {{employee.last_name}}</td>\n                        <td>{{employee.primary_phone}}</td>\n                        <td>{{employee.secondary_phone}}</td>\n                        <td>{{employee.email}}</td>\n                        <td><input type=\"checkbox\" v-model=\"employee.status\" value=\"1\"></td>\n                    </tr>\n\n                    </tbody>\n                </table>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"col-md-12\">\n        <div class=\"row task-list\">\n        \t<div class=\"col-md-2\" v-for=\"item of joblist\">\n        \t\t<new-job-task :task=\"item\"></new-job-task>\n        \t</div>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  var id = "/home/shoieb/sites/elegant/resources/assets/js/vue/components/callb-job-cancel.vue"
  module.hot.dispose(function () {
    require("vueify-insert-css").cache["\n\n\t.task-list span{\n\t\tdisplay: inline-block;\n\t\twidth: 33%;\n\t}\n\t.task-list{\n\t\ttext-align: center;\n\t}\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, module.exports.template)
  }
})()}
},{"./../../mixed/notify":11,"vue":5,"vue-hot-reload-api":4,"vueify-insert-css":6}],33:[function(require,module,exports){
var __vueify_style__ = require("vueify-insert-css").insert("\n\n\t.task-list span{\n\t\tdisplay: inline-block;\n\t\twidth: 33%;\n\t}\n\t.task-list{\n\t\ttext-align: center;\n\t}\n")
'use strict';

exports.__esModule = true;
var notify = require('./../../mixed/notify');

exports['default'] = {
    data: function data() {
        return {
            employees: [],
            jobSummaryMessage: '',
            jobTitle: null,
            jobDate: null,
            jobTime: null,
            salary: null,
            currentOrder: null
        };
    },
    props: ['joblist'],
    ready: function ready() {},
    methods: {
        updateActiveList: function updateActiveList() {
            var _this = this;

            var self = this;
            self.$http.post('/api/completeTask', { 'employees': this.employees }, function (response) {
                var rem = 0;
                var i = 0;

                self.employees = self.employees.filter(function (item) {
                    i++;
                    if (item.status == 1 || item.status == true) rem++;
                    return item.status == 0 || item.status == false;
                });

                for (job in _this.joblist) {
                    if (_this.joblist[job].orderId == self.currentOrder.orderId && _this.joblist[job].rate == self.salary && _this.joblist[job].grp == self.currentOrder.grp && _this.joblist[job].user != null) {
                        if (_this.joblist[job].recipent != rem) _this.joblist[job].recipent -= rem;else {
                            self.joblist = self.joblist.filter(function (item) {
                                if (item.separator == self.currentOrder.separator) {
                                    return false;
                                } else return true;
                            });

                            _this.$dispatch('counterRecount', 14);
                            _this.jobSummaryMessage = '';
                            _this.jobTitle = null;
                            _this.jobDate = null;
                            _this.jobTime = null;
                            _this.salary = null;
                            _this.employees = null;
                        }
                        break;
                    }
                }
            }).always(function () {});
        }
    },
    events: {
        'loadNew': function loadNew(task) {
            notify.loading(true);

            var self = this;
            self.jobTitle = task.employee + ' ' + task.needed + ' ' + task.post;

            self.jobTime = task.inTime + "-" + task.outTime;
            self.currentOrder = task;

            if (moment.duration(moment(task.date).diff(moment().startOf('day'))).asDays() < 1) self.jobDate = "Today";else if (moment.duration(moment(task.date).diff(moment().startOf('day'))).asDays() < 2) self.jobDate = "Tomorrow";else self.jobDate = moment(task.date).format("dddd, MMMM Do,");

            self.$http.put('/api/get-employee-list/', { list: task.empList, orderId: task.orderId, type: 'move', service: 'call-broadcast', rate: task.rate, limit: task.recipent }, function (response) {
                self.employees = response;
                for (var pos in self.employees) {
                    self.employees[pos].status = Boolean(parseInt(self.employees[pos].status));
                }
                self.salary = response[0].pay_rate;
                self.jobSummaryMessage = "We have a new job opening at,\n" + task.employeeName + "\n" + "at, " + self.jobDate + "\n" + "If you are interested to switch your shift. Call\n" + "ELEGANT STAFFING\n" + "800-807-8503 ext.2";
            }).always(function () {
                notify.loading(false);
            });
        },
        'clearMessage': function clearMessage(task) {
            var flag = false;
            for (var pos in this.joblist) {
                if (this.joblist[pos].user == current_user) flag = true;
            }
            if (flag == false) {
                this.employees = null;
                this.jobSummaryMessage = '';
                this.jobTitle = null;
                this.jobDate = null;
                this.jobTime = null;
                this.salary = null;
            }
        }
    }
};
module.exports = exports['default'];
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"row mb-15\">\n    <div class=\"col-md-4\">\n        <div class=\"col-md-12 bg-slate no-padding\">\n            <div class=\"col-md-5 small\">{{jobTitle}}</div>\n            <div class=\"col-md-2 no-padding small\">{{jobDate}}</div>\n            <div class=\"col-md-5 small\" align=\"center\">{{jobTime}}</div>\n        </div>\n        <textarea name=\"jobSummaryMessage\" id=\"jobSummaryMessage\" cols=\"30\" rows=\"18\" class=\"form-control\" v-model=\"jobSummaryMessage\"></textarea>\n    </div>\n    <div class=\"col-md-8\">\n        <div class=\"col-md-12\">\n            <button type=\"button\" class=\"btn btn-primary btn-xs pull-right\" v-on:click=\"updateActiveList\">Complete</button>\n        </div>\n        <div class=\"col-md-12\">\n            <div class=\"table-responsive\">\n                <table class=\"table table-xxs\">\n                    <thead>\n                    <tr>\n\n                        <th>Name</th>\n                        <th>Phone 1</th>\n                        <th>Phone 2</th>\n                        <th>Email</th>\n                        <th></th>\n                    </tr>\n                    </thead>\n                    <tbody>\n                    <tr v-for=\"employee in employees\">\n                        <td>{{employee.first_name}} {{employee.last_name}}</td>\n                        <td>{{employee.primary_phone}}</td>\n                        <td>{{employee.secondary_phone}}</td>\n                        <td>{{employee.email}}</td>\n                        <td><input type=\"checkbox\" v-model=\"employee.status\" value=\"1\"></td>\n                    </tr>\n\n                    </tbody>\n                </table>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"col-md-12\">\n        <div class=\"row task-list\">\n        \t<div class=\"col-md-2\" v-for=\"item of joblist\">\n        \t\t<new-job-task :task=\"item\"></new-job-task>\n        \t</div>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  var id = "/home/shoieb/sites/elegant/resources/assets/js/vue/components/callb-move.vue"
  module.hot.dispose(function () {
    require("vueify-insert-css").cache["\n\n\t.task-list span{\n\t\tdisplay: inline-block;\n\t\twidth: 33%;\n\t}\n\t.task-list{\n\t\ttext-align: center;\n\t}\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, module.exports.template)
  }
})()}
},{"./../../mixed/notify":11,"vue":5,"vue-hot-reload-api":4,"vueify-insert-css":6}],34:[function(require,module,exports){
var __vueify_style__ = require("vueify-insert-css").insert("\n\n\t.task-list span{\n\t\tdisplay: inline-block;\n\t\twidth: 33%;\n\t}\n\t.task-list{\n\t\ttext-align: center;\n\t}\n")
'use strict';

exports.__esModule = true;
var notify = require('./../../mixed/notify');

exports['default'] = {
    data: function data() {
        return {
            employees: [],
            jobSummaryMessage: '',
            jobTitle: null,
            jobDate: null,
            jobTime: null,
            salary: null,
            currentOrder: null
        };
    },
    props: ['joblist'],
    ready: function ready() {},
    methods: {
        updateActiveList: function updateActiveList() {
            var _this = this;

            var self = this;
            self.$http.post('/api/completeTask', { 'employees': this.employees }, function (response) {
                var rem = 0;
                var i = 0;

                self.employees = self.employees.filter(function (item) {
                    i++;
                    if (item.status == 1 || item.status == true) rem++;
                    return item.status == 0 || item.status == false;
                });

                for (job in _this.joblist) {
                    if (_this.joblist[job].orderId == self.currentOrder.orderId && _this.joblist[job].rate == self.salary && _this.joblist[job].grp == self.currentOrder.grp && _this.joblist[job].user != null) {
                        if (_this.joblist[job].recipent != rem) _this.joblist[job].recipent -= rem;else {
                            self.joblist = self.joblist.filter(function (item) {
                                if (item.separator == self.currentOrder.separator) {
                                    return false;
                                } else return true;
                            });

                            _this.$dispatch('counterRecount', 11);
                            _this.jobSummaryMessage = '';
                            _this.jobTitle = null;
                            _this.jobDate = null;
                            _this.jobTime = null;
                            _this.salary = null;
                            _this.employees = null;
                        }
                        break;
                    }
                }
            }).always(function () {});
        }
    },
    events: {
        'loadNew': function loadNew(task) {
            notify.loading(true);
            var self = this;
            self.jobTitle = task.employee + ' ' + task.needed + ' ' + task.post;

            self.jobTime = task.inTime + "-" + task.outTime;
            self.currentOrder = task;

            if (moment.duration(moment(task.date).diff(moment().startOf('day'))).asDays() < 1) self.jobDate = "Today";else if (moment.duration(moment(task.date).diff(moment().startOf('day'))).asDays() < 2) self.jobDate = "Tomorrow";else self.jobDate = moment(task.date).format("dddd, MMMM Do,");

            self.$http.put('/api/get-employee-list/', { list: task.empList, orderId: task.orderId, type: 'new-job-offer', service: 'call-broadcast', rate: task.rate, limit: task.recipent }, function (response) {
                self.employees = response;
                for (var pos in self.employees) {
                    self.employees[pos].status = Boolean(parseInt(self.employees[pos].status));
                }
                self.salary = response[0].pay_rate;
                self.jobSummaryMessage = "hi this is……\n" + self.jobDate + "\n" + "at, " + task.employeeName + "\n" + "to confrm, please call…";
            }).always(function () {
                notify.loading(false);
            });
        },
        'clearMessage': function clearMessage(task) {
            var flag = false;
            for (var pos in this.joblist) {
                if (this.joblist[pos].user == current_user) flag = true;
            }
            if (flag == false) {
                this.employees = null;
                this.jobSummaryMessage = '';
                this.jobTitle = null;
                this.jobDate = null;
                this.jobTime = null;
                this.salary = null;
            }
        }
    }
};
module.exports = exports['default'];
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"row mb-15\">\n    <div class=\"col-md-4\">\n        <div class=\"col-md-12 bg-slate no-padding\">\n            <div class=\"col-md-5 small\">{{jobTitle}}</div>\n            <div class=\"col-md-2 no-padding small\">{{jobDate}}</div>\n            <div class=\"col-md-5 small\" align=\"center\">{{jobTime}}</div>\n        </div>\n        <textarea name=\"jobSummaryMessage\" id=\"jobSummaryMessage\" cols=\"30\" rows=\"18\" class=\"form-control\" v-model=\"jobSummaryMessage\"></textarea>\n    </div>\n    <div class=\"col-md-8\">\n        <div class=\"col-md-12\">\n            <button type=\"button\" class=\"btn btn-primary btn-xs pull-right\" v-on:click=\"updateActiveList\">Complete</button>\n        </div>\n        <div class=\"col-md-12\">\n            <div class=\"table-responsive\">\n                <table class=\"table table-xxs\">\n                    <thead>\n                    <tr>\n\n                        <th>Name</th>\n                        <th>Phone 1</th>\n                        <th>Phone 2</th>\n                        <th>Email</th>\n                        <th></th>\n                    </tr>\n                    </thead>\n                    <tbody>\n                    <tr v-for=\"employee in employees\">\n                        <td>{{employee.first_name}} {{employee.last_name}}</td>\n                        <td>{{employee.primary_phone}}</td>\n                        <td>{{employee.secondary_phone}}</td>\n                        <td>{{employee.email}}</td>\n                        <td><input type=\"checkbox\" v-model=\"employee.status\" value=\"1\"></td>\n                    </tr>\n\n                    </tbody>\n                </table>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"col-md-12\">\n        <div class=\"row task-list\">\n        \t<div class=\"col-md-2\" v-for=\"item of joblist\">\n        \t\t<new-job-task :task=\"item\"></new-job-task>\n        \t</div>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  var id = "/home/shoieb/sites/elegant/resources/assets/js/vue/components/callb-new-job.vue"
  module.hot.dispose(function () {
    require("vueify-insert-css").cache["\n\n\t.task-list span{\n\t\tdisplay: inline-block;\n\t\twidth: 33%;\n\t}\n\t.task-list{\n\t\ttext-align: center;\n\t}\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, module.exports.template)
  }
})()}
},{"./../../mixed/notify":11,"vue":5,"vue-hot-reload-api":4,"vueify-insert-css":6}],35:[function(require,module,exports){
var __vueify_style__ = require("vueify-insert-css").insert("\n\n\t.task-list span{\n\t\tdisplay: inline-block;\n\t\twidth: 33%;\n\t}\n\t.task-list{\n\t\ttext-align: center;\n\t}\n")
'use strict';

exports.__esModule = true;
var notify = require('./../../mixed/notify');

exports['default'] = {
    data: function data() {
        return {
            employees: [],
            jobSummaryMessage: '',
            jobTitle: null,
            jobDate: null,
            jobTime: null,
            salary: null,
            currentOrder: null
        };
    },
    props: ['joblist'],
    ready: function ready() {},
    methods: {
        updateActiveList: function updateActiveList() {
            var _this = this;

            var self = this;
            self.$http.post('/api/completeTask', { 'employees': this.employees }, function (response) {
                var rem = 0;
                var i = 0;

                self.employees = self.employees.filter(function (item) {
                    i++;
                    if (item.status == 1 || item.status == true) rem++;
                    return item.status == 0 || item.status == false;
                });

                for (job in _this.joblist) {
                    if (_this.joblist[job].orderId == self.currentOrder.orderId && _this.joblist[job].rate == self.salary && _this.joblist[job].grp == self.currentOrder.grp && _this.joblist[job].user != null) {
                        if (_this.joblist[job].recipent != rem) _this.joblist[job].recipent -= rem;else {
                            self.joblist = self.joblist.filter(function (item) {
                                if (item.separator == self.currentOrder.separator) {
                                    return false;
                                } else return true;
                            });

                            _this.$dispatch('counterRecount', 17);
                            _this.jobSummaryMessage = '';
                            _this.jobTitle = null;
                            _this.jobDate = null;
                            _this.jobTime = null;
                            _this.salary = null;
                            _this.employees = null;
                        }
                        break;
                    }
                }
            }).always(function () {});
        }
    },
    events: {
        'loadNew': function loadNew(task) {
            notify.loading(true);
            var self = this;
            self.jobTitle = task.employee + ' ' + task.needed + ' ' + task.post;

            self.jobTime = task.inTime + "-" + task.outTime;
            self.currentOrder = task;

            if (moment.duration(moment(task.date).diff(moment().startOf('day'))).asDays() < 1) self.jobDate = "Today";else if (moment.duration(moment(task.date).diff(moment().startOf('day'))).asDays() < 2) self.jobDate = "Tomorrow";else self.jobDate = moment(task.date).format("dddd, MMMM Do,");

            self.$http.put('/api/get-employee-list/', { list: task.empList, orderId: task.orderId, type: 'other-changes', service: 'call-broadcast', rate: task.rate, limit: task.recipent }, function (response) {
                self.employees = response;
                for (var pos in self.employees) {
                    self.employees[pos].status = Boolean(parseInt(self.employees[pos].status));
                }
                self.salary = response[0].pay_rate;
                self.jobSummaryMessage = "There are some changes made on the…\n" + self.jobDate + "\n" + task.employeeName + "\n" + "For the details, please call\n" + "ELEGANT STAFFING\n" + "800-807-8503 ext.2";
            }).always(function () {
                notify.loading(false);
            });
        },
        'clearMessage': function clearMessage(task) {
            var flag = false;
            for (var pos in this.joblist) {
                if (this.joblist[pos].user == current_user) flag = true;
            }
            if (flag == false) {
                this.employees = null;
                this.jobSummaryMessage = '';
                this.jobTitle = null;
                this.jobDate = null;
                this.jobTime = null;
                this.salary = null;
            }
        }
    }
};
module.exports = exports['default'];
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"row mb-15\">\n    <div class=\"col-md-4\">\n        <div class=\"col-md-12 bg-slate no-padding\">\n            <div class=\"col-md-5 small\">{{jobTitle}}</div>\n            <div class=\"col-md-2 no-padding small\">{{jobDate}}</div>\n            <div class=\"col-md-5 small\" align=\"center\">{{jobTime}}</div>\n        </div>\n        <textarea name=\"jobSummaryMessage\" id=\"jobSummaryMessage\" cols=\"30\" rows=\"18\" class=\"form-control\" v-model=\"jobSummaryMessage\"></textarea>\n    </div>\n    <div class=\"col-md-8\">\n        <div class=\"col-md-12\">\n            <button type=\"button\" class=\"btn btn-primary btn-xs pull-right\" v-on:click=\"updateActiveList\">Complete</button>\n        </div>\n        <div class=\"col-md-12\">\n            <div class=\"table-responsive\">\n                <table class=\"table table-xxs\">\n                    <thead>\n                    <tr>\n\n                        <th>Name</th>\n                        <th>Phone 1</th>\n                        <th>Phone 2</th>\n                        <th>Email</th>\n                        <th></th>\n                    </tr>\n                    </thead>\n                    <tbody>\n                    <tr v-for=\"employee in employees\">\n                        <td>{{employee.first_name}} {{employee.last_name}}</td>\n                        <td>{{employee.primary_phone}}</td>\n                        <td>{{employee.secondary_phone}}</td>\n                        <td>{{employee.email}}</td>\n                        <td><input type=\"checkbox\" v-model=\"employee.status\" value=\"1\"></td>\n                    </tr>\n\n                    </tbody>\n                </table>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"col-md-12\">\n        <div class=\"row task-list\">\n        \t<div class=\"col-md-2\" v-for=\"item of joblist\">\n        \t\t<new-job-task :task=\"item\"></new-job-task>\n        \t</div>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  var id = "/home/shoieb/sites/elegant/resources/assets/js/vue/components/callb-other-changes.vue"
  module.hot.dispose(function () {
    require("vueify-insert-css").cache["\n\n\t.task-list span{\n\t\tdisplay: inline-block;\n\t\twidth: 33%;\n\t}\n\t.task-list{\n\t\ttext-align: center;\n\t}\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, module.exports.template)
  }
})()}
},{"./../../mixed/notify":11,"vue":5,"vue-hot-reload-api":4,"vueify-insert-css":6}],36:[function(require,module,exports){
var __vueify_style__ = require("vueify-insert-css").insert("\n\n\t.task-list span{\n\t\tdisplay: inline-block;\n\t\twidth: 33%;\n\t}\n\t.task-list{\n\t\ttext-align: center;\n\t}\n")
'use strict';

exports.__esModule = true;
var notify = require('./../../mixed/notify');

exports['default'] = {
    data: function data() {
        return {
            employees: [],
            jobSummaryMessage: '',
            jobTitle: null,
            jobDate: null,
            jobTime: null,
            salary: null,
            currentOrder: null
        };
    },
    props: ['joblist'],
    ready: function ready() {},
    methods: {
        updateActiveList: function updateActiveList() {
            var _this = this;

            var self = this;
            self.$http.post('/api/completeTask', { 'employees': this.employees }, function (response) {
                var rem = 0;
                var i = 0;

                self.employees = self.employees.filter(function (item) {
                    i++;
                    if (item.status == 1 || item.status == true) rem++;
                    return item.status == 0 || item.status == false;
                });

                for (job in _this.joblist) {
                    if (_this.joblist[job].orderId == self.currentOrder.orderId && _this.joblist[job].rate == self.salary && _this.joblist[job].grp == self.currentOrder.grp && _this.joblist[job].user != null) {
                        if (_this.joblist[job].recipent != rem) _this.joblist[job].recipent -= rem;else {
                            self.joblist = self.joblist.filter(function (item) {
                                if (item.separator == self.currentOrder.separator) {
                                    return false;
                                } else return true;
                            });

                            _this.$dispatch('counterRecount', 12);
                            _this.jobSummaryMessage = '';
                            _this.jobTitle = null;
                            _this.jobDate = null;
                            _this.jobTime = null;
                            _this.salary = null;
                            _this.employees = null;
                        }
                        break;
                    }
                }
            }).always(function () {});
        }
    },
    events: {
        'loadNew': function loadNew(task) {
            notify.loading(true);
            var self = this;
            self.jobTitle = task.employee + ' ' + task.needed + ' ' + task.post;

            self.jobTime = task.inTime + "-" + task.outTime;
            self.currentOrder = task;

            if (moment.duration(moment(task.date).diff(moment().startOf('day'))).asDays() < 1) self.jobDate = "Today";else if (moment.duration(moment(task.date).diff(moment().startOf('day'))).asDays() < 2) self.jobDate = "Tomorrow";else self.jobDate = moment(task.date).format("dddd, MMMM Do,");

            self.$http.put('/api/get-employee-list/', { list: task.empList, orderId: task.orderId, type: 'reconfirmation-job', service: 'call-broadcast', rate: task.rate, limit: task.recipent }, function (response) {
                self.employees = response;
                for (var pos in self.employees) {
                    self.employees[pos].status = Boolean(parseInt(self.employees[pos].status));
                }
                self.salary = response[0].pay_rate;
                self.jobSummaryMessage = "You are scheduled….\n" + self.jobDate + "\n" + "at, " + task.employeeName + "\n" + "Please call to….";
            }).always(function () {
                notify.loading(false);
            });
        },
        'clearMessage': function clearMessage(task) {
            var flag = false;
            for (var pos in this.joblist) {
                if (this.joblist[pos].user == current_user) flag = true;
            }
            if (flag == false) {
                this.employees = null;
                this.jobSummaryMessage = '';
                this.jobTitle = null;
                this.jobDate = null;
                this.jobTime = null;
                this.salary = null;
            }
        }
    }
};
module.exports = exports['default'];
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"row mb-15\">\n    <div class=\"col-md-4\">\n        <div class=\"col-md-12 bg-slate no-padding\">\n            <div class=\"col-md-5 small\">{{jobTitle}}</div>\n            <div class=\"col-md-2 no-padding small\">{{jobDate}}</div>\n            <div class=\"col-md-5 small\" align=\"center\">{{jobTime}}</div>\n        </div>\n        <textarea name=\"jobSummaryMessage\" id=\"jobSummaryMessage\" cols=\"30\" rows=\"18\" class=\"form-control\" v-model=\"jobSummaryMessage\"></textarea>\n    </div>\n    <div class=\"col-md-8\">\n        <div class=\"col-md-12\">\n            <button type=\"button\" class=\"btn btn-primary btn-xs pull-right\" v-on:click=\"updateActiveList\">Complete</button>\n        </div>\n        <div class=\"col-md-12\">\n            <div class=\"table-responsive\">\n                <table class=\"table table-xxs\">\n                    <thead>\n                    <tr>\n\n                        <th>Name</th>\n                        <th>Phone 1</th>\n                        <th>Phone 2</th>\n                        <th>Email</th>\n                        <th></th>\n                    </tr>\n                    </thead>\n                    <tbody>\n                    <tr v-for=\"employee in employees\">\n                        <td>{{employee.first_name}} {{employee.last_name}}</td>\n                        <td>{{employee.primary_phone}}</td>\n                        <td>{{employee.secondary_phone}}</td>\n                        <td>{{employee.email}}</td>\n                        <td><input type=\"checkbox\" v-model=\"employee.status\" value=\"1\"></td>\n                    </tr>\n\n                    </tbody>\n                </table>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"col-md-12\">\n        <div class=\"row task-list\">\n        \t<div class=\"col-md-2\" v-for=\"item of joblist\">\n        \t\t<new-job-task :task=\"item\"></new-job-task>\n        \t</div>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  var id = "/home/shoieb/sites/elegant/resources/assets/js/vue/components/callb-reconfirmation-job.vue"
  module.hot.dispose(function () {
    require("vueify-insert-css").cache["\n\n\t.task-list span{\n\t\tdisplay: inline-block;\n\t\twidth: 33%;\n\t}\n\t.task-list{\n\t\ttext-align: center;\n\t}\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, module.exports.template)
  }
})()}
},{"./../../mixed/notify":11,"vue":5,"vue-hot-reload-api":4,"vueify-insert-css":6}],37:[function(require,module,exports){
var __vueify_style__ = require("vueify-insert-css").insert("\n\n\t.task-list span{\n\t\tdisplay: inline-block;\n\t\twidth: 33%;\n\t}\n\t.task-list{\n\t\ttext-align: center;\n\t}\n")
'use strict';

exports.__esModule = true;
var notify = require('./../../mixed/notify');

exports['default'] = {
    data: function data() {
        return {
            employees: [],
            jobSummaryMessage: '',
            jobTitle: null,
            jobDate: null,
            jobTime: null,
            salary: null,
            currentOrder: null
        };
    },
    props: ['joblist'],
    ready: function ready() {},
    methods: {
        updateActiveList: function updateActiveList() {
            var _this = this;

            var self = this;
            self.$http.post('/api/completeTask', { 'employees': this.employees }, function (response) {
                var rem = 0;
                var i = 0;

                self.employees = self.employees.filter(function (item) {
                    i++;
                    if (item.status == 1 || item.status == true) rem++;
                    return item.status == 0 || item.status == false;
                });

                for (job in _this.joblist) {
                    if (_this.joblist[job].orderId == self.currentOrder.orderId && _this.joblist[job].rate == self.salary && _this.joblist[job].grp == self.currentOrder.grp && _this.joblist[job].user != null) {
                        if (_this.joblist[job].recipent != rem) _this.joblist[job].recipent -= rem;else {
                            self.joblist = self.joblist.filter(function (item) {
                                if (item.separator == self.currentOrder.separator) {
                                    return false;
                                } else return true;
                            });

                            _this.$dispatch('counterRecount', 15);
                            _this.jobSummaryMessage = '';
                            _this.jobTitle = null;
                            _this.jobDate = null;
                            _this.jobTime = null;
                            _this.salary = null;
                            _this.employees = null;
                        }
                        break;
                    }
                }
            }).always(function () {});
        }
    },
    events: {
        'loadNew': function loadNew(task) {
            notify.loading(true);
            var self = this;
            self.jobTitle = task.employee + ' ' + task.needed + ' ' + task.post;

            self.jobTime = task.inTime + "-" + task.outTime;
            self.currentOrder = task;

            if (moment.duration(moment(task.date).diff(moment().startOf('day'))).asDays() < 1) self.jobDate = "Today";else if (moment.duration(moment(task.date).diff(moment().startOf('day'))).asDays() < 2) self.jobDate = "Tomorrow";else self.jobDate = moment(task.date).format("ddd, MM-DD");

            self.$http.put('/api/get-employee-list/', { list: task.empList, orderId: task.orderId, type: 'time-change', service: 'call-broadcast', rate: task.rate, limit: task.recipent }, function (response) {
                self.employees = response;
                for (var pos in self.employees) {
                    self.employees[pos].status = Boolean(parseInt(self.employees[pos].status));
                }
                self.salary = response[0].pay_rate;
                self.jobSummaryMessage = "Your scheduled time has been changed.\n" + self.jobDate + "\n" + task.employeeName + "\n" + "The old time was,\n" + moment(response[0].base_in_time).format("h:mm a") + ", till " + moment(response[0].base_out_time).format("h:mm a") + ".\n" + "The new time is,\n" + task.inTime + ", till " + task.outTime + ".\n" + "Please call elegant staffing";
            }).always(function () {
                notify.loading(false);
            });
        },
        'clearMessage': function clearMessage(task) {
            this.employees = null;
            this.jobSummaryMessage = '';
            this.jobTitle = null;
            this.jobDate = null;
            this.jobTime = null;
            this.salary = null;
        }
    }
};
module.exports = exports['default'];
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"row mb-15\">\n    <div class=\"col-md-4\">\n        <div class=\"col-md-12 bg-slate no-padding\">\n            <div class=\"col-md-5 small\">{{jobTitle}}</div>\n            <div class=\"col-md-2 no-padding small\">{{jobDate}}</div>\n            <div class=\"col-md-5 small\" align=\"center\">{{jobTime}}</div>\n        </div>\n        <textarea name=\"jobSummaryMessage\" id=\"jobSummaryMessage\" cols=\"30\" rows=\"18\" class=\"form-control\" v-model=\"jobSummaryMessage\"></textarea>\n    </div>\n    <div class=\"col-md-8\">\n        <div class=\"col-md-12\">\n            <button type=\"button\" class=\"btn btn-primary btn-xs pull-right\" v-on:click=\"updateActiveList\">Complete</button>\n        </div>\n        <div class=\"col-md-12\">\n            <div class=\"table-responsive\">\n                <table class=\"table table-xxs\">\n                    <thead>\n                    <tr>\n\n                        <th>Name</th>\n                        <th>Phone 1</th>\n                        <th>Phone 2</th>\n                        <th>Email</th>\n                        <th></th>\n                    </tr>\n                    </thead>\n                    <tbody>\n                    <tr v-for=\"employee in employees\">\n                        <td>{{employee.first_name}} {{employee.last_name}}</td>\n                        <td>{{employee.primary_phone}}</td>\n                        <td>{{employee.secondary_phone}}</td>\n                        <td>{{employee.email}}</td>\n                        <td><input type=\"checkbox\" v-model=\"employee.status\" value=\"1\"></td>\n                    </tr>\n\n                    </tbody>\n                </table>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"col-md-12\">\n        <div class=\"row task-list\">\n        \t<div class=\"col-md-2\" v-for=\"item of joblist\">\n        \t\t<new-job-task :task=\"item\"></new-job-task>\n        \t</div>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  var id = "/home/shoieb/sites/elegant/resources/assets/js/vue/components/callb-time-change.vue"
  module.hot.dispose(function () {
    require("vueify-insert-css").cache["\n\n\t.task-list span{\n\t\tdisplay: inline-block;\n\t\twidth: 33%;\n\t}\n\t.task-list{\n\t\ttext-align: center;\n\t}\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, module.exports.template)
  }
})()}
},{"./../../mixed/notify":11,"vue":5,"vue-hot-reload-api":4,"vueify-insert-css":6}],38:[function(require,module,exports){
var __vueify_style__ = require("vueify-insert-css").insert("\n\n\t.task-list span{\n\t\tdisplay: inline-block;\n\t\twidth: 33%;\n\t}\n\t.task-list{\n\t\ttext-align: center;\n\t}\n")
'use strict';

exports.__esModule = true;
var notify = require('./../../mixed/notify');

exports['default'] = {
    data: function data() {
        return {
            employees: [],
            jobSummaryMessage: '',
            jobTitle: null,
            jobDate: null,
            jobTime: null,
            salary: null,
            currentOrder: null
        };
    },
    props: ['joblist'],
    ready: function ready() {},
    methods: {
        updateActiveList: function updateActiveList() {
            var _this = this;

            var self = this;
            self.$http.post('/api/completeTask', { 'employees': this.employees }, function (response) {
                var rem = 0;
                var i = 0;

                self.employees = self.employees.filter(function (item) {
                    i++;
                    if (item.status == 1 || item.status == true) rem++;
                    return item.status == 0 || item.status == false;
                });

                for (job in _this.joblist) {
                    if (_this.joblist[job].orderId == self.currentOrder.orderId && _this.joblist[job].rate == self.salary && _this.joblist[job].grp == self.currentOrder.grp && _this.joblist[job].user != null) {
                        if (_this.joblist[job].recipent != rem) _this.joblist[job].recipent -= rem;else {
                            self.joblist = self.joblist.filter(function (item) {
                                if (item.separator == self.currentOrder.separator) {
                                    return false;
                                } else return true;
                            });

                            _this.$dispatch('counterRecount', 16);
                            _this.jobSummaryMessage = '';
                            _this.jobTitle = null;
                            _this.jobDate = null;
                            _this.jobTime = null;
                            _this.salary = null;
                            _this.employees = null;
                        }
                        break;
                    }
                }
            }).always(function () {});
        }
    },
    events: {
        'loadNew': function loadNew(task) {
            notify.loading(true);
            var self = this;
            self.jobTitle = task.employee + ' ' + task.needed + ' ' + task.post;

            self.jobTime = task.inTime + "-" + task.outTime;
            self.currentOrder = task;

            if (moment.duration(moment(task.date).diff(moment().startOf('day'))).asDays() < 1) self.jobDate = "Today";else if (moment.duration(moment(task.date).diff(moment().startOf('day'))).asDays() < 2) self.jobDate = "Tomorrow " + moment(task.date).format("MM-DD");else self.jobDate = moment(task.date).format("ddd, MM-DD");

            self.$http.put('/api/get-employee-list/', { list: task.empList, orderId: task.orderId, type: 'time-conflict', service: 'call-broadcast', rate: task.rate, limit: task.recipent }, function (response) {

                self.employees = response;
                for (var pos in self.employees) {
                    self.employees[pos].status = Boolean(parseInt(self.employees[pos].status));
                }
                self.salary = response[0].pay_rate;
                self.jobSummaryMessage = "Due to changes made by client, two of…\n" + self.jobDate + "\n" + "to resolve this issue, please call\n" + "ELEGANT STAFFING\n" + "800-807-8503 ext.2";
            }).always(function () {
                notify.loading(false);
            });
        },
        'clearMessage': function clearMessage(task) {
            var flag = false;
            for (var pos in this.joblist) {
                if (this.joblist[pos].user == current_user) flag = true;
            }
            if (flag == false) {
                this.employees = null;
                this.jobSummaryMessage = '';
                this.jobTitle = null;
                this.jobDate = null;
                this.jobTime = null;
                this.salary = null;
            }
        }
    }
};
module.exports = exports['default'];
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"row mb-15\">\n    <div class=\"col-md-4\">\n        <div class=\"col-md-12 bg-slate no-padding\">\n            <div class=\"col-md-5 small\">{{jobTitle}}</div>\n            <div class=\"col-md-2 no-padding small\">{{jobDate}}</div>\n            <div class=\"col-md-5 small\" align=\"center\">{{jobTime}}</div>\n        </div>\n        <textarea name=\"jobSummaryMessage\" id=\"jobSummaryMessage\" cols=\"30\" rows=\"18\" class=\"form-control\" v-model=\"jobSummaryMessage\"></textarea>\n    </div>\n    <div class=\"col-md-8\">\n        <div class=\"col-md-12\">\n            <button type=\"button\" class=\"btn btn-primary btn-xs pull-right\" v-on:click=\"updateActiveList\">Complete</button>\n        </div>\n        <div class=\"col-md-12\">\n            <div class=\"table-responsive\">\n                <table class=\"table table-xxs\">\n                    <thead>\n                    <tr>\n\n                        <th>Name</th>\n                        <th>Phone 1</th>\n                        <th>Phone 2</th>\n                        <th>Email</th>\n                        <th></th>\n                    </tr>\n                    </thead>\n                    <tbody>\n                    <tr v-for=\"employee in employees\">\n                        <td>{{employee.first_name}} {{employee.last_name}}</td>\n                        <td>{{employee.primary_phone}}</td>\n                        <td>{{employee.secondary_phone}}</td>\n                        <td>{{employee.email}}</td>\n                        <td><input type=\"checkbox\" v-model=\"employee.status\" value=\"1\"></td>\n                    </tr>\n\n                    </tbody>\n                </table>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"col-md-12\">\n        <div class=\"row task-list\">\n        \t<div class=\"col-md-2\" v-for=\"item of joblist\">\n        \t\t<new-job-task :task=\"item\"></new-job-task>\n        \t</div>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  var id = "/home/shoieb/sites/elegant/resources/assets/js/vue/components/callb-time-conflict.vue"
  module.hot.dispose(function () {
    require("vueify-insert-css").cache["\n\n\t.task-list span{\n\t\tdisplay: inline-block;\n\t\twidth: 33%;\n\t}\n\t.task-list{\n\t\ttext-align: center;\n\t}\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, module.exports.template)
  }
})()}
},{"./../../mixed/notify":11,"vue":5,"vue-hot-reload-api":4,"vueify-insert-css":6}],39:[function(require,module,exports){
var __vueify_style__ = require("vueify-insert-css").insert("\na[_v-438b39a8]:hover, a[_v-438b39a8]:focus {\n  color: #fff;\n  text-decoration: none;\n}\n\n.radius-div[_v-438b39a8] {\n  border-radius: 5px;\n}\n\n.font-32[_v-438b39a8] {\n  font-size: 30px;\n}\n")
"use strict";

exports.__esModule = true;
var modals = require("./../../mixed/modals");
var notify = require("./../../mixed/notify");

exports["default"] = {
  data: function data() {
    return {
      employees: {}
    };
  },
  props: ['orders'],
  filters: {},
  watch: {},
  ready: function ready() {},

  events: {},

  methods: {
    orderModal: function orderModal() {
      window.bus.$emit("showAddOrderModal");
    },

    parse: function parse(data) {
      return JSON.parse(data);
    }
  }
};
module.exports = exports["default"];
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n  <div _v-438b39a8=\"\">\n    <!-- Content area -->\n    <div class=\"content p-5\" _v-438b39a8=\"\">\n      <div class=\"row\" _v-438b39a8=\"\">\n        <div class=\"col-md-12 col-sm-12 no-padding-left no-padding-right text-center client-header-bg font-white p-5 border-2 border-top border-white mt-10 font-32 font-weight-500\" _v-438b39a8=\"\">\n          Cobb Energy Center\n        </div>\n      </div>\n\n      <div class=\"row\" _v-438b39a8=\"\">\n        <div class=\"col-md-12 col-sm-12 mt-10\" v-for=\"(index,order) in orders\" _v-438b39a8=\"\">\n          <div class=\"col-md-2 col-sm-2 client-header-bg font-32 font-white p-10 text-center font-weight-500 h-80 pt-15 radius-left radius-right\" _v-438b39a8=\"\">\n            {{ index }}\n          </div>\n\n          <div class=\"col-md-10 col-sm-10  \" _v-438b39a8=\"\">\n\n            <div v-for=\"dateOrder in order\" class=\"col-md-3 col-sm-3 font-20 font-white text-center font-weight-500 h-80 mb-10  no-padding-left pr-10 \" _v-438b39a8=\"\">\n              <div class=\"col-md-12 col-sm-12 no-padding-left no-padding-right radius-div manager-client-bg\" _v-438b39a8=\"\">\n                <div class=\"col-md-9 col-sm-9 h-80  \" _v-438b39a8=\"\">\n                  <div class=\"col-md-12 col-sm-12 p-0 text-orange-400 no-padding-left no-padding-right\" _v-438b39a8=\"\">\n                    <div class=\"col-md-6 col-sm-6 p-0 font-40 h-60 pt-5 text-right no-padding-left pr-5\" _v-438b39a8=\"\">\n                      {{ dateOrder.no_of_employee }}\n                    </div>\n                    <div class=\"col-md-6 col-sm-6 p-0 font-18 h-60 text-center pt-20 no-padding-left no-padding-left no-padding-right\" _v-438b39a8=\"\">\n                      {{ dateOrder.title }}\n                    </div>\n                  </div>\n                  <div class=\"col-md-12 col-sm-12 ml-5 font-13 text-right no-padding-left no-padding-right mt--5\" _v-438b39a8=\"\">\n                    {{ dateOrder.in_time }} - {{ dateOrder.out_time }}\n                  </div>\n                </div>\n                <div class=\"col-md-3 col-sm-3 text-primary-400 h-80 font-32 text-center pt-15 no-padding-left no-padding-right\" _v-438b39a8=\"\">\n                  {{ dateOrder.confirmed_employees_count }}\n                </div>\n              </div>\n            </div>\n\n\n          </div>\n        </div>\n      </div>\n\n\n    </div>\n  </div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  var id = "/home/shoieb/sites/elegant/resources/assets/js/vue/components/client-board.vue"
  module.hot.dispose(function () {
    require("vueify-insert-css").cache["\na[_v-438b39a8]:hover, a[_v-438b39a8]:focus {\n  color: #fff;\n  text-decoration: none;\n}\n\n.radius-div[_v-438b39a8] {\n  border-radius: 5px;\n}\n\n.font-32[_v-438b39a8] {\n  font-size: 30px;\n}\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, module.exports.template)
  }
})()}
},{"./../../mixed/modals":10,"./../../mixed/notify":11,"vue":5,"vue-hot-reload-api":4,"vueify-insert-css":6}],40:[function(require,module,exports){
var __vueify_style__ = require("vueify-insert-css").insert("\ntd {\n  text-align: center;\n}\n")
"use strict";

exports.__esModule = true;
var modals = require("./../../mixed/modals");
var notify = require("./../../mixed/notify");
exports["default"] = {
  data: function data() {
    return {
      orders: {},
      orderIds: [],
      autoSelectionOrders: [],
      autoSelectionTotals: [],
      pendingOrders: [],
      pendingOrdersAuto: [],
      pendingOrdersManual: [],
      partialOrders: [],
      partialRemoveOrdersIds: [],
      partialOrderLength: 0
    };
  },
  filters: {
    momentDate: function momentDate(date) {
      return moment(date, "YYYY-MM-DD").format("MM  DD");
    },
    momentDay: function momentDay(date) {
      return moment(date, "YYYY-MM-DD").format("ddd");
    },
    parseTime: function parseTime(dateTime) {
      return moment(dateTime, "YYYY-MM-DD HH:mm:ss").format("h:m a");
    }
  },
  ready: function ready() {
    //this.fetchCompletedOrders();
  },
  events: {
    fetchCompletedOrders: function fetchCompletedOrders() {
      this.fetchOrders();
      this.fetchPendingOrders();
      this.fetchPartialOrders();
    },
    clearFetchOrderFields: function clearFetchOrderFields() {
      this.orders = {};
      this.orderIds = [];
    }
  },
  methods: {
    /**
     * fetch orders which has required confirmed employees
     */
    fetchOrders: function fetchOrders() {
      var _this = this;

      this.$http.get("/api/completed-orders", "", function (response) {
        _this.orders = response;
      }).always(function () {});
    },

    fetchPartialOrders: function fetchPartialOrders() {
      var _this2 = this;

      this.$http.get("/api/partial-completed-orders", "", function (response) {
        _this2.partialOrders = response.orders;
        _this2.partialOrderLength = response.OrderLength;
      }).always(function () {});
    },

    /**
     * fetch list of orders which needs to add employees
     */
    fetchPendingOrders: function fetchPendingOrders() {
      var _this3 = this;

      this.$http.get("/api/dashboard-employee-add-pending", "", function (response) {
        _this3.pendingOrdersAuto = response[1];
        _this3.pendingOrdersManual = response[0];
      }).always(function () {});
    },
    /**
     * automatically add employee based on auto selection rules
     */
    processAutoSelection: function processAutoSelection() {
      var _this4 = this;

      notify.loading(true);
      var data = {
        ids: this.autoSelectionOrders,
        orders: this.pendingOrdersAuto
      };
      this.$http.put("/api/assign-employee-order", data, function (response) {
        _this4.autoSelectionOrders = [];
        window.bus.$emit("refreshDashboard");
        _this4.fetchPendingOrders();
        notify.success("Employee Added");
      }).always(function () {
        notify.loading(false);
      });
    },

    /**
     * send request to free up un-confirmed employees
     */
    freeUnconfirmedEmployees: function freeUnconfirmedEmployees() {
      var _this5 = this;

      this.$http.post("/api/free-unconfirmed-employees", { ids: this.orderIds }, function (response) {
        _this5.fetchOrders();
        window.bus.$emit("refreshDashboard");
        _this5.orderIds = [];
      }).always(function () {});
    },

    clearPartialSelection: function clearPartialSelection() {
      var _this6 = this;

      this.$http.post("/api/clear-partial-completed-orders", { orders: this.partialOrders, ids: this.partialRemoveOrdersIds }, function (response) {
        _this6.fetchPartialOrders();
        window.bus.$emit("refreshDashboard");
        _this6.partialRemoveOrdersIds = [];
      }).always(function () {});
    },

    /**
     * show status details
     * @param id
     * @param date
     */
    statusDetails: function statusDetails(id, date) {
      window.bus.$emit("statusDetails", id, date);
    },

    manualSelection: function manualSelection(id) {
      window.bus.$emit("manualSelection", id);
    }
  },
  props: ["message"]
};
module.exports = exports["default"];
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n    <div class=\"tabbable\">\n        <ul class=\"nav nav-tabs nav-tabs-bottom bottom-divided nav-justified\">\n            <li class=\"active\"><a class=\"text-uppercase text-black text-primary-600\" href=\"#tab-auto-select\" data-toggle=\"tab\">\n                <span v-if=\"pendingOrdersAuto\" class=\"badge bg-danger-400 heading-text\">{{pendingOrdersAuto.length}}</span>\n                AutoSelect\n            </a>\n            </li>\n            <li><a class=\"text-uppercase text-black text-danger-600\" href=\"#tab-auto-remove\" data-toggle=\"tab\">\n                <span v-if=\"orders[1].length > 0\" class=\"badge bg-danger-400 heading-text\">{{orders[1].length}}</span>\n                Auto\n                Remove</a></li>\n            <li><a class=\"text-uppercase text-black text-brown-600\" href=\"#tab-partial-remove\" data-toggle=\"tab\">\n                <span v-if=\"partialOrderLength\" class=\"badge bg-danger-400 heading-text\">{{ partialOrderLength }}</span>\n                Partial\n                Remove</a></li>\n            <li><a class=\"text-uppercase text-black\" href=\"#tab-manual-select\" data-toggle=\"tab\">\n                <span v-if=\"pendingOrdersManual\" class=\"badge bg-danger-400 heading-text\">{{pendingOrdersManual.length}}</span>\n                Manual\n                Select</a></li>\n            <li><a class=\"text-uppercase text-black\" href=\"#tab-manual-remove\" data-toggle=\"tab\">\n                <span v-if=\"orders[0].length > 0\" class=\"badge bg-danger-400 heading-text\">{{orders[0].length}}</span>\n                Manual\n                Remove</a></li>\n        </ul>\n\n        <div class=\"tab-content\">\n            <div class=\"tab-pane active\" id=\"tab-auto-select\">\n                <h4 class=\"modal-title bg-indigo no-padding text-uppercase\">Auto\n                    Selection</h4>\n                <table class=\"table table-xxs table-bordered\">\n                    <thead>\n                    <tr class=\"bg-black\">\n                        <th class=\"col-md-5 text-uppercase text-black\">Order Details</th>\n                        <th class=\"col-md-1  text-uppercase text-black\">Order</th>\n                        <th class=\"col-md-1  text-uppercase text-black\">Conf</th>\n                        <th class=\"col-md-1  text-uppercase text-black\">Need</th>\n                        <th class=\"col-md-1  text-uppercase text-black\">Selected</th>\n                        <th class=\"col-md-2  text-uppercase text-black\">Add</th>\n                        <th class=\"col-md-1  text-uppercase text-black\">Select</th>\n                    </tr>\n                    </thead>\n                    <tbody>\n                    <tr v-for=\"order in pendingOrdersAuto\">\n                        <td class=\"col-md-5 text-center\">\n                            <span class=\"text-black\">{{ order.company_code+' '+order.title }}</span>,\n                            {{ order.date |customDateFormat 'YYYY-MM-DD' 'ddd M/D' }}\n                            {{ order.in_time | parseTime }} - {{ order.out_time | parseTime }}\n                        </td>\n                        <td class=\"col-md-1 active  text-center\">{{ order.no_of_employee }}</td>\n                        <td class=\"col-md-1 active  text-center\">{{ order.confirmed }}</td>\n                        <td class=\"col-md-1 active text-center\">{{ order.remaining }}</td>\n                        <td class=\"col-md-1 text-center\">{{ order.un_confirmed_count[0].count }}</td>\n                        <td class=\"col-md-2 text-center\">\n                            <div class=\"form-group no-margin no-padding\">\n                                <input type=\"text\" class=\"form-control\" value=\"{{ order.total }}\" v-model=\"order.total\">\n                            </div>\n                        </td>\n                        <td class=\"col-md-1 text-center\">\n                            <div class=\"col-md-12\">\n                                <input type=\"checkbox\" name=\"\" v-model=\"autoSelectionOrders\" value=\"{{ order.id }}\">\n                            </div>\n                        </td>\n                    </tr>\n                    </tbody>\n                </table>\n                <button v-if=\"pendingOrdersAuto.length\" v-on:click.prevent=\"processAutoSelection\" type=\"button\" class=\"btn btn-primary pull-right mr-20 mt-10 mb-10\">Add\n                </button>\n            </div>\n            <div class=\"tab-pane\" id=\"tab-auto-remove\">\n                <h4 class=\"modal-title bg-danger no-padding text-uppercase\">Auto Selection</h4>\n                <table class=\"table table-xxs table-bordered\">\n                    <thead>\n                    <tr class=\"bg-black\">\n                        <th class=\"col-md-5 text-uppercase text-black\">Order Details</th>\n                        <th class=\"col-md-1  text-uppercase text-black\">Order</th>\n                        <th class=\"col-md-1  text-uppercase text-black\">Conf</th>\n                        <th class=\"col-md-1  text-uppercase text-black\">Need</th>\n                        <th class=\"col-md-1  text-uppercase text-black\">Selected</th>\n                        <th class=\"col-md-2  text-uppercase text-black\">Remove</th>\n                        <th class=\"col-md-1  text-uppercase text-black\">Select</th>\n                    </tr>\n                    </thead>\n                    <tbody>\n                    <tr v-for=\"order in orders[1]\">\n                        <td class=\"col-md-5\">\n                            <span class=\"text-black text-center\">{{ order.company_code + ' ' + order.title }}</span>,\n                            {{ order.date | customDateFormat\n                            'YYYY-MM-DD'\n                            'ddd M/D' }}\n                            {{ order.in_time | parseTime }} - {{ order.out_time | parseTime }}\n                        </td>\n                        <td class=\"col-md-1 active text-center\">{{ order.no_of_employee }}</td>\n                        <td class=\"col-md-1 active text-center\">{{ order.confirmed }}</td>\n                        <td class=\"col-md-1 active text-center\">{{ order.remaining }}</td>\n                        <td class=\"col-md-1 text-center\">{{ order.un_confirmed_count[0].count }}</td>\n                        <td class=\"col-md-2 text-center\">{{ order.un_confirmed_count_auto[0].count }}</td>\n                        <td class=\" text-center\">\n                            <input type=\"checkbox\" name=\"\" id=\"\" v-model=\"orderIds\" value=\"{{ order.id }}\">\n                        </td>\n                    </tr>\n                    </tbody>\n                </table>\n                <button v-if=\"orders[1].length\" v-on:click.prevent=\"freeUnconfirmedEmployees\" type=\"button\" class=\"btn btn-primary pull-right pull-right mr-20 mt-10 mb-10\">Clear Unconfirmed Employees\n                </button>\n            </div>\n            <div class=\"tab-pane\" id=\"tab-partial-remove\">\n                <h4 class=\"modal-title bg-brown no-padding text-uppercase\">Partial Remove</h4>\n                <table class=\"table table-xxs table-bordered\">\n                    <thead>\n                    <tr class=\"bg-black\">\n                        <th class=\"col-md-5 text-uppercase text-black\">Order Details</th>\n                        <th class=\"col-md-1  text-uppercase text-black\">Order</th>\n                        <th class=\"col-md-1  text-uppercase text-black\">Conf</th>\n                        <th class=\"col-md-1  text-uppercase text-black\">Need</th>\n                        <th class=\"col-md-1  text-uppercase text-black\">Selected</th>\n                        <th class=\"col-md-2  text-uppercase text-black\">Remove</th>\n                        <th class=\"col-md-1  text-uppercase text-black\">Select</th>\n                    </tr>\n                    </thead>\n                    <tbody>\n                    <tr v-for=\"order in partialOrders\">\n                        <td class=\"col-md-5 text-center\">\n                            <span class=\"text-black\">{{ order.company_code + ' ' + order.title }}</span>,\n                            {{ order.date | customDateFormat\n                            'YYYY-MM-DD'\n                            'ddd M/D' }}\n                            {{ order.in_time | parseTime }} - {{ order.out_time | parseTime }}\n                        </td>\n                        <td class=\"col-md-1 active text-center\">{{ order.no_of_employee }}</td>\n                        <td class=\"col-md-1 active text-center\">{{ order.confirmed }}</td>\n                        <td class=\"col-md-1 active text-center\">{{ order.remaining }}</td>\n                        <td class=\"col-md-1 text-center\">{{ order.un_confirmed_count[0].count }}</td>\n                        <td class=\"col-md-2 text-center\">{{ order.partial_string }}</td>\n                        <td class=\" text-center\">\n                            <input type=\"checkbox\" name=\"\" v-model=\"partialRemoveOrdersIds\" value=\"{{ order.id }}\">\n                        </td>\n                    </tr>\n                    </tbody>\n                </table>\n                <button type=\"button\" @click=\"clearPartialSelection\" class=\"btn btn-primary pull-right mr-20 mt-10 mb-10\">Clear Unconfirmed Employees\n                </button>\n            </div>\n            <div class=\"tab-pane\" id=\"tab-manual-select\">\n                <div class=\"col-md-12 no-padding\">\n                    <h4 class=\"modal-title bg-black-center no-padding text-uppercase\">Manual\n                        Selection</h4>\n                    <table class=\"table table-xxs table-bordered\">\n                        <thead>\n                        <tr class=\"bg-black\">\n                            <th class=\"col-md-5 text-uppercase text-black\">Order Details</th>\n                            <th class=\"col-md-1  text-uppercase text-black\">Order</th>\n                            <th class=\"col-md-1  text-uppercase text-black\">Conf</th>\n                            <th class=\"col-md-1  text-uppercase text-black\">Need</th>\n                            <th class=\"col-md-1  text-uppercase text-black\">Selected</th>\n                            <th class=\"col-md-2  text-uppercase text-black\">Add</th>\n                            <th class=\"col-md-1  text-uppercase text-black\">Select</th>\n                        </tr>\n                        </thead>\n                        <tbody class=\"\">\n                        <tr v-for=\"order in pendingOrdersManual\">\n                            <td class=\"col-md-5 text-center\">\n                                <span class=\"text-black\">{{ order.company_code+' '+order.title }}</span>,\n                                {{ order.date |customDateFormat 'YYYY-MM-DD' 'ddd M/D' }}\n                                {{ order.in_time | parseTime }} - {{ order.out_time | parseTime }}\n                            </td>\n                            <td class=\"col-md-1 active text-center\">{{ order.no_of_employee }}</td>\n                            <td class=\"col-md-1 active text-center\">{{ order.confirmed }}</td>\n                            <td class=\"col-md-1 active text-center\">{{ order.remaining }}</td>\n                            <td class=\"col-md-1 text-center\">{{ order.un_confirmed_count[0].count }}</td>\n                            <td class=\"col-md-2 text-center\"><span class=\"text-danger-600 text-black\">{{ order.total }}</span>\n                            </td>\n                            <td class=\"col-md-1 text-center\">\n                                <button v-on:click.prevent=\"manualSelection(order.id)\" class=\"btn btn-info btn-xs\">Select\n                                </button>\n                            </td>\n                        </tr>\n                        </tbody>\n                    </table>\n                    <button v-if=\"pendingOrdersAuto.length\" type=\"button\" class=\"btn btn-white color-white pull-right mr-20 mt-10 mb-10\">Add\n                    </button>\n                </div>\n            </div>\n            <div class=\"tab-pane\" id=\"tab-manual-remove\">\n                <h4 class=\"modal-title bg-black-center no-padding text-uppercase\">Manual Selection</h4>\n                <table class=\"table table-xxs table-bordered\">\n                    <thead>\n                    <tr class=\"bg-black\">\n                        <th class=\"col-md-5 text-uppercase text-black\">Order Details</th>\n                        <th class=\"col-md-1  text-uppercase text-black\">Order</th>\n                        <th class=\"col-md-1  text-uppercase text-black\">Conf</th>\n                        <th class=\"col-md-1  text-uppercase text-black\">Need</th>\n                        <th class=\"col-md-1  text-uppercase text-black\">Selected</th>\n                        <th class=\"col-md-2  text-uppercase text-black\">Remove</th>\n                        <th class=\"col-md-1  text-uppercase text-black\">Select</th>\n                    </tr>\n                    </thead>\n                    <tbody>\n                    <tr v-for=\"order in orders[0]\">\n                        <td class=\"col-md-5 text-center\">\n                            <span class=\"text-black\">{{ order.company_code + ' ' + order.title }}</span>,\n                            {{ order.date | customDateFormat\n                            'YYYY-MM-DD'\n                            'ddd M/D' }}\n                            {{ order.in_time | parseTime }} - {{ order.out_time | parseTime }}\n                        </td>\n                        <td class=\"col-md-1 active text-center\">{{ order.no_of_employee }}</td>\n                        <td class=\"col-md-1 active text-center\">{{ order.confirmed }}</td>\n                        <td class=\"col-md-1 active text-center\">{{ order.remaining }}</td>\n                        <td class=\"col-md-1 text-center\">{{ order.un_confirmed_count[0].count }}</td>\n                        <td class=\"col-md-2 text-center\">{{ order.un_confirmed_count_manual[0].count }}</td>\n                        <td class=\" text-center\">\n                            <button v-on:click.prevent=\"statusDetails(order.id,order.date)\" class=\"btn btn-info btn-xs\">Select\n                            </button>\n                        </td>\n                    </tr>\n                    </tbody>\n                </table>\n                <button type=\"button\" class=\"btn btn-white color-white pull-right mr-20 mt-10 mb-10\">Clear Unconfirmed Employees\n                </button>\n            </div>\n        </div>\n    </div>\n\n\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  var id = "/home/shoieb/sites/elegant/resources/assets/js/vue/components/completedOrders.vue"
  module.hot.dispose(function () {
    require("vueify-insert-css").cache["\ntd {\n  text-align: center;\n}\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, module.exports.template)
  }
})()}
},{"./../../mixed/modals":10,"./../../mixed/notify":11,"vue":5,"vue-hot-reload-api":4,"vueify-insert-css":6}],41:[function(require,module,exports){
"use strict";

exports.__esModule = true;
var modals = require("./../../mixed/modals");
var notify = require("./../../mixed/notify");
exports["default"] = {
  data: function data() {
    return {
      invoices: {},
      invoicesByDepartment: {},
      activeInvoice: {},
      activeMasterInvoice: {},
      newInvoice: {
        employee_id: "",
        position_code: "",
        rate: "",
        duration: "",
        date: "",
        employee_name: ""
      },
      employees: {},
      positions: {},
      allPositions: {},
      referenceIndex: {},
      ids: [],
      selectAll: 0
    };
  },
  filters: {},
  watch: {},
  ready: function ready() {
    this.fetchInvoiceData();
    this.fetchPendingInvoice();
    $(".pickadate-year-invoice").pickadate({
      format: "yyyy-mm-dd",
      selectYears: 70,
      max: true,
      firstDay: 1
    });
  },
  events: {
    refreshData: function refreshData() {}
  },
  methods: {
    /**
     * select all invoices checkbox
     */
    selectAllInvoices: function selectAllInvoices() {
      var _this = this;

      this.ids = [];
      if (!this.selectAll) {
        var invoices = _.cloneDeep(this.invoicesByDepartment);
        invoices.map(function (obj, key) {
          _this.ids.push(key);
        });
      }
    },
    /**
     * fetch invoice data
     */
    fetchInvoiceData: function fetchInvoiceData() {
      var _this2 = this;

      this.$http.get("/api/invoice-data", "", function (response) {
        _this2.employees = response.employees;
        _this2.allPositions = response.positions;
      }).always(function () {});
    },

    /**
     * fetch data for data-entry forms
     */
    fetchPendingInvoice: function fetchPendingInvoice() {
      var _this3 = this;

      this.$http.get("/api/pending-invoice-list", "", function (response) {
        _this3.invoices = response;
      }).always(function () {});
    },

    /**
     * fetch invoice details
     * @param departmentId
     */
    invoiceDetails: function invoiceDetails(invoice) {
      var _this4 = this;

      this.activeMasterInvoice = _.cloneDeep(invoice);
      this.$http.get("/api/pending-invoice-details/" + this.activeMasterInvoice.department_id, "", function (response) {
        _this4.invoicesByDepartment = response;
        modals.showStrict("#invoice-details");
      }).always(function () {});
    },

    /**
     * calculate total invoice amount
     * @returns {number}
     */
    calculateTotalAmount: function calculateTotalAmount() {
      var invoices = _.cloneDeep(this.invoicesByDepartment);
      var amount = 0;
      invoices.map(function (invoice) {
        amount += invoice.duration / 60 * invoice.rate;
      });

      return amount;
    },

    /**
     * show edit invoice modal
     * @param index
     */
    showEditInvoiceModal: function showEditInvoiceModal(index) {
      var _this5 = this;

      this.activeInvoice = _.cloneDeep(this.invoicesByDepartment[index]);
      this.referenceIndex = index;
      var positions = _.cloneDeep(this.allPositions);
      this.positions = positions.filter(function (position) {
        return position.department_id === _this5.activeInvoice.department_id;
      });
      modals.showStrict("#edit-invoice");
    },

    /**
     * edit invoice entry
     */
    editInvoice: function editInvoice() {
      this.invoicesByDepartment.splice(this.referenceIndex, 1, this.activeInvoice);
      modals.hide("#edit-invoice");
      //this.invoicesByDepartment[this.referenceIndex] = _.cloneDeep(this.activeInvoice);
    },

    /**
     * show modal for new invoice entry
     */
    newInvoiceEntryModal: function newInvoiceEntryModal() {
      var _this6 = this;

      var positions = _.cloneDeep(this.allPositions);
      this.positions = positions.filter(function (position) {
        return position.department_id === _this6.invoicesByDepartment[0].department_id;
      });
      modals.showStrict("#new-invoice");
    },

    /**
     * add new entry to invoice
     */
    addInvoiceEntry: function addInvoiceEntry() {
      var _this7 = this;

      var employee = this.employees.filter(function (employee) {
        return employee.id == _this7.newInvoice.employee_id;
      });

      var position = this.positions.filter(function (position) {
        return position.position_code == _this7.newInvoice.position_code;
      });
      this.invoicesByDepartment.push({
        employee_id: this.newInvoice.employee_id,
        position_code: this.newInvoice.position_code,
        position_name: position[0].title,
        date: this.newInvoice.date,
        duration: this.newInvoice.duration * 60,
        rate: this.newInvoice.rate,
        employee_name: employee[0].fullName,
        department_id: this.invoicesByDepartment[0].department_id
      });
      this.resetNewInvoice();
    },

    /**
     * reset newInvoice object
     */
    resetNewInvoice: function resetNewInvoice() {
      this.newInvoice = {
        employee_id: "",
        position_code: "",
        rate: "",
        duration: "",
        date: "",
        employee_name: ""
      };
    },

    /**
     * send request to create new invoices
     */
    createInvoice: function createInvoice() {
      var _this8 = this;

      var invoices = this.invoicesByDepartment.filter(function (obj, key) {
        return _this8.ids.includes(key);
      });
      var data = {
        client_id: this.activeMasterInvoice.client_id,
        department_id: this.activeMasterInvoice.department_id,
        invoice_format: this.activeMasterInvoice.default_invoice_format,
        company_number: this.activeMasterInvoice.company_number,
        invoices: invoices
      };

      this.$http.post("/api/create-invoices", data, function (response) {
        _this8.fetchPendingInvoice();
        modals.hide("#invoice-details");
        _this8.ids = [];
      }).always(function () {});
    }
  },
  props: ["bg"]
};
module.exports = exports["default"];
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n    <div class=\"row\">\n        <h4 class=\"bg-black-center text-center no-margin-top no-margin-bottom text-uppercase\">List of invoices to be created</h4>\n        <div class=\"col-md-12 no-padding table-body\">\n            <div class=\"col-md-12 no-padding\">\n                <table class=\"table table-xxs table-bordered\">\n                    <thead>\n                    <tr>\n                        <th class=\"bg-slate-300 text-black text-color-black text-center col-md-2\">CODE</th>\n                        <th class=\"bg-slate-300 text-black text-color-black text-center col-md-2\">CLIENT NAME</th>\n                        <th class=\"bg-slate-300 text-black text-color-black text-center col-md-2\">DEPARTMENT</th>\n                        <th class=\"bg-slate-300 text-black text-color-black text-center col-md-2\">CONTACT</th>\n                        <th class=\"bg-slate-300 text-black text-color-black text-center col-md-2\">CLIENT GROUP</th>\n                        <th class=\"bg-danger-400 text-center text-black col-md-2\"> ACTION</th>\n                    </tr>\n                    </thead>\n                    <tbody>\n                    <tr v-for=\"invoice in invoices\">\n                        <td class=\" text-center col-md-2\">{{ invoice.company_code}}</td>\n                        <td class=\" text-center col-md-2\">{{ invoice.name }}</td>\n                        <td class=\" text-center col-md-2\">{{ invoice.department_name }}</td>\n                        <td class=\" text-center col-md-2\">{{ invoice.first_name + ' ' + invoice.last_name}}</td>\n                        <td class=\" text-center col-md-2\">{{ invoice.title }}</td>\n                        <td class=\" text-center text-black col-md-2 cursor-pointer\" @click=\"invoiceDetails(invoice)\"> Create Invoice</td>\n                    </tr>\n                    </tbody>\n                </table>\n            </div>\n        </div>\n\n\n        <div class=\"modal fade\" id=\"invoice-details\">\n            <div class=\"modal-dialog modal-lg\">\n                <div class=\"modal-content\">\n                    <div class=\"modal-header no-padding\">\n                        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\">×</button>\n                        <h4 class=\"bg-slate-600 text-center no-margin-top no-margin-bottom text-uppercase\">Create Invoice</h4>\n                    </div>\n                    <div class=\"modal-body\">\n                        <div class=\"col-md-12 no-padding\">\n                            <div class=\"col-md-12 no-padding\">\n                                <div class=\"col-md-2 height-36 bg-indigo-300 no-padding text-black text-color-black text-right\">Client Name:</div>\n                                <div class=\"col-md-4 height-36 bg-grey-300 no-padding text-black text-color-black text-center\">{{ invoicesByDepartment[0].name }}</div>\n                                <div class=\"col-md-2 height-36 bg-indigo-300 no-padding text-black text-color-black text-right\">Format:</div>\n                                <div class=\"col-md-4 height-36 bg-grey-300 no-padding text-black text-color-black text-left\">\n                                    <select class=\"form-control\" name=\"invoice_format\" v-model=\"activeMasterInvoice.default_invoice_format\">\n                                        <option value=\"1\">Format 1</option>\n                                        <option value=\"2\">Format 2</option>\n                                    </select>\n                                </div>\n                            </div>\n                            <div class=\"col-md-12 no-padding\">\n                                <div class=\"col-md-2 height-36 bg-indigo-300 no-padding text-black text-color-black text-right\">Department:</div>\n                                <div class=\"col-md-4 height-36 bg-grey-300 no-padding text-black text-color-black text-center\">{{ invoicesByDepartment[0].department_name }}</div>\n                                <div class=\"col-md-2 height-36 bg-indigo-300 no-padding text-black text-color-black text-right\">Invoice Date:</div>\n                                <div class=\"col-md-4 height-36 bg-grey-300 no-padding text-black text-color-black text-left\">\n                                    <input type=\"text\" name=\"\" class=\"form-control pickadate-year\">\n                                </div>\n                            </div>\n                            <div class=\"col-md-12 no-padding\">\n                                <div class=\"col-md-2 height-36 bg-indigo-300 no-padding text-black text-color-black text-right\">Contact:</div>\n                                <div class=\"col-md-4 height-36 bg-grey-300 no-padding text-black text-color-black text-center\">\n                                    {{ invoicesByDepartment[0].first_name + ' ' + invoicesByDepartment[0].last_name }}\n                                </div>\n                                <div class=\"col-md-2 height-36 bg-indigo-300 no-padding text-black text-color-black text-right\">Invoice#:</div>\n                                <div class=\"col-md-4 height-36 bg-grey-300 no-padding text-black text-color-black text-center\">{{ invoicesByDepartment[0].client_id }}</div>\n                            </div>\n                            <div class=\"col-md-12 no-padding\">\n                                <div class=\"col-md-2 height-36 bg-indigo-300 no-padding text-black text-color-black text-right\">PO#:</div>\n                                <div class=\"col-md-4 height-36 bg-grey-300 no-padding text-black text-color-black text-left\">\n                                    <input type=\"text\" name=\"\" class=\"form-control\">\n                                </div>\n                                <div class=\"col-md-2 height-36 bg-indigo-300 no-padding text-black text-color-black text-right\">Amount:</div>\n                                <div class=\"col-md-4 height-36 bg-grey-300 no-padding text-black text-color-black text-center\">{{ calculateTotalAmount() }}</div>\n                            </div>\n                            <div class=\"col-md-12 mt-20 mb-20\">\n                                <button type=\"button\" class=\"btn btn-danger pull-left\" data-dismiss=\"modal\">Cancel</button>\n                                <button type=\"button\" class=\"btn btn-primary pull-right\" @click=\"createInvoice\">Create Invoice</button>\n                            </div>\n                        </div>\n                        <div class=\"col-md-12 no-padding\">\n                            <table class=\"table table-xxs table-bordered\">\n                                <thead>\n                                <tr>\n                                    <th class=\"bg-slate-300 text-black text-color-black text-center\"><input type=\"checkbox\" :value=\"1\" v-model=\"selectAll\" @click=\"selectAllInvoices\"></th>\n                                    <th class=\"bg-slate-300 text-black text-color-black text-center\">Job</th>\n                                    <th class=\"bg-slate-300 text-black text-color-black text-center\">Employee</th>\n                                    <th class=\"bg-slate-300 text-black text-color-black text-center\">Date</th>\n                                    <th class=\"bg-slate-300 text-black text-color-black text-center\">Hour</th>\n                                    <th class=\"bg-slate-300 text-black text-color-black text-center\">Rate</th>\n                                    <th class=\"bg-slate-300 text-black text-color-black text-center\">Amount</th>\n                                    <th class=\"bg-slate-300 text-black text-color-black text-center\">Edit</th>\n                                </tr>\n                                </thead>\n                                <tbody>\n                                <tr v-for=\"(index,invoice) in invoicesByDepartment\" :key=\"index\">\n                                    <th class=\"text-color-black text-center\"><input type=\"checkbox\" v-model=\"ids\" :value=\"index\"></th>\n                                    <th class=\"text-color-black text-center\">{{ invoice.position_name }}</th>\n                                    <th class=\"text-color-black text-center\">{{ invoice.employee_name }}</th>\n                                    <th class=\"text-color-black text-center\">{{ invoice.date }}</th>\n                                    <th class=\"text-color-black text-center\">{{ invoice.duration/60 }}</th>\n                                    <th class=\"text-color-black text-center\">{{ invoice.rate }}</th>\n                                    <th class=\"text-color-black text-center\">{{ (invoice.duration/60)*invoice.rate }}</th>\n                                    <th class=\"text-color-black text-black text-center cursor-pointer\" @click=\"showEditInvoiceModal(index)\">Edit</th>\n                                </tr>\n                                </tbody>\n                            </table>\n\n                            <button type=\"button\" class=\"btn bg-green-700 mt-20 pull-right\" @click=\"newInvoiceEntryModal\">Add Data</button>\n                        </div>\n                    </div>\n                    <div class=\"modal-footer\">\n                        <!--<button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button>-->\n                        <!--<button type=\"button\" class=\"btn btn-primary\">Save changes</button>-->\n                    </div>\n                </div><!-- /.modal-content -->\n            </div><!-- /.modal-dialog -->\n        </div><!-- /.modal -->\n\n        <!-- edit invoice modal -->\n        <div class=\"modal fade\" id=\"edit-invoice\">\n            <div class=\"modal-dialog\">\n                <div class=\"modal-content bg-grey-300\">\n                    <div class=\"modal-header no-padding\">\n                        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\">×</button>\n                        <h4 class=\"bg-slate-800 text-center no-margin-top no-margin-bottom text-uppercase\">Edit Information</h4>\n                    </div>\n                    <div class=\"modal-body\">\n                        <div class=\"col-md-12 text-black text-color-black mb-20\">\n                            {{ activeInvoice.date }}\n                        </div>\n                        <div class=\"col-md-12 no-padding\">\n                            <div class=\"col-md-6 height-36 bg-grey-300 no-padding text-color-black text-left\">\n                                <div class=\"form-group pr-10\">\n                                    <input type=\"text\" name=\"\" class=\"form-control text-black text-blue-400\" v-model=\"activeInvoice.employee_name\">\n                                </div>\n                            </div>\n                            <div class=\"col-md-6 height-36 bg-grey-300 no-padding text-color-black text-left\">\n                                <div class=\"form-group\">\n                                    <select name=\"\" class=\"form-control text-blue-400\" v-model=\"activeInvoice.position_code\">\n                                        <option v-for=\"position in positions\" :value=\"position.position_code\">{{ position.title }}</option>\n                                    </select>\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"col-md-12 no-padding\">\n                            <div class=\"col-md-6 height-36 bg-grey-300 no-padding text-color-black text-left\">\n                                <div class=\"form-group pr-10\">\n                                    <label>Hour</label>\n                                    <input type=\"text\" name=\"\" class=\"form-control text-black text-blue-400\" v-model=\"activeInvoice.duration\">\n                                </div>\n                            </div>\n                            <div class=\"col-md-6 height-36 bg-grey-300 no-padding text-color-black text-left\">\n                                <div class=\"form-group\">\n                                    <label>Rate</label>\n                                    <input type=\"text\" name=\"\" class=\"form-control text-black text-blue-400\" v-model=\"activeInvoice.rate\">\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"modal-footer\">\n                        <button type=\"button\" class=\"btn btn-danger pull-left\">Delete</button>\n                        <button type=\"button\" class=\"btn btn-primary pull-right\" @click=\"editInvoice\">Update</button>\n                    </div>\n                </div><!-- /.modal-content -->\n            </div><!-- /.modal-dialog -->\n        </div><!-- /.modal -->\n\n\n        <!-- edit invoice modal -->\n        <div class=\"modal fade\" id=\"new-invoice\">\n            <div class=\"modal-dialog\">\n                <div class=\"modal-content bg-grey-300\">\n                    <div class=\"modal-header no-padding\">\n                        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\">×</button>\n                        <h4 class=\"bg-green-700 text-center no-margin-top no-margin-bottom text-uppercase\">Add Information</h4>\n                    </div>\n                    <div class=\"modal-body\">\n                        <div class=\"col-md-12 text-black text-color-black mb-20\">\n                            {{ activeInvoice.date }}\n                        </div>\n                        <div class=\"col-md-12 no-padding\">\n                            <div class=\"col-md-6 height-36 bg-grey-300 no-padding text-color-black text-left\">\n                                <div class=\"form-group pr-10\">\n                                    <select name=\"\" class=\"form-control text-blue-400\" v-model=\"newInvoice.employee_id\" v-select2=\"newInvoice.employee_id\" data-placeholder=\"Search Employee\">\n                                        <option value=\"\">Select Employee</option>\n                                        <option v-for=\"employee in employees\" :value=\"employee.id\">{{ employee.fullName }}</option>\n                                    </select>\n                                </div>\n                            </div>\n                            <div class=\"col-md-6 height-36 bg-grey-300 no-padding text-color-black text-left\">\n                                <div class=\"form-group\">\n                                    <select name=\"\" class=\"form-control text-blue-400\" v-model=\"newInvoice.position_code\">\n                                        <option v-for=\"position in positions\" :value=\"position.position_code\">{{ position.title }}</option>\n                                    </select>\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"col-md-12 no-padding text-center\">\n                            <div class=\"col-md-2\"></div>\n                            <div class=\"col-md-8\">\n                                <div class=\"form-group pr-10\">\n                                    <input type=\"text\" name=\"\" class=\"form-control text-black pickadate-year-invoice\" v-model=\"newInvoice.date\">\n                                </div>\n                            </div>\n                            <div class=\"col-md-2\"></div>\n                        </div>\n                        <div class=\"col-md-12 no-padding\">\n                            <div class=\"col-md-6 height-36 bg-grey-300 no-padding text-color-black text-left\">\n                                <div class=\"form-group pr-10\">\n                                    <label>Hour</label>\n                                    <input type=\"text\" name=\"\" class=\"form-control text-black\" v-model=\"newInvoice.duration\">\n                                </div>\n                            </div>\n                            <div class=\"col-md-6 height-36 bg-grey-300 no-padding text-color-black text-left\">\n                                <div class=\"form-group\">\n                                    <label>Rate</label>\n                                    <input type=\"text\" name=\"\" class=\"form-control text-black\" v-model=\"newInvoice.rate\">\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"modal-footer\">\n                        <button type=\"button\" class=\"btn btn-primary pull-right\" @click=\"addInvoiceEntry\">Add</button>\n                    </div>\n                </div><!-- /.modal-content -->\n            </div><!-- /.modal-dialog -->\n        </div><!-- /.modal -->\n    </div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  var id = "/home/shoieb/sites/elegant/resources/assets/js/vue/components/create-invoice.vue"
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, module.exports.template)
  }
})()}
},{"./../../mixed/modals":10,"./../../mixed/notify":11,"vue":5,"vue-hot-reload-api":4}],42:[function(require,module,exports){
'use strict';

exports.__esModule = true;
var modals = require('./../../mixed/modals');
var notify = require('./../../mixed/notify');
exports['default'] = {
    data: function data() {
        return {
            employees: {},
            scheduledEmployees: {},
            activeEmployee: {},
            clients: {},
            activeClient: {},
            entryEmployees: {},
            entry: {
                client_id: '',
                employee_id: 0,
                position_code: '',
                in_time: '',
                out_time: '',
                date: '',
                break_time: '',
                note: '',
                team: 1,
                duration: ''
            }
        };
    },
    filters: {},
    watch: {
        'entry.client_id': function entryClient_id(val) {
            this.activeClient = _.clone(_.find(this.clients, function (o) {
                return o.id == val;
            }));
        },

        'activeClient': function activeClient() {
            $('#position-code').selectric('refresh');
        },

        'clients': function clients() {
            $('#data-entry-client').selectric('refresh');
        }
    },
    ready: function ready() {
        this.fetchDataEntryLists();
    },
    events: {},
    methods: {
        /**
         * fetch data for data-entry forms
         */
        fetchDataEntryLists: function fetchDataEntryLists() {
            var _this = this;

            this.$http.get('/api/data-entry-list?team=' + this.team, '', function (response) {
                _this.scheduledEmployees = response.scheduledEmployees;
                _this.entryEmployees = response.entryEmployees;
            }).always(function () {});
        }
    },
    props: ['team', 'bg']
};
module.exports = exports['default'];
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n    <div class=\"row\">\n        <div class=\"col-md-12\">\n            <h5 :class=\"bg\" class=\"text-center no-margin-top no-margin-bottom\">Entry By Team - {{ team }}</h5>\n            <div class=\"table-responsive\">\n                <table class=\"table table-xxs table-bordered\">\n                    <thead>\n                    <tr>\n                        <th class=\"bg-grey col-md-4\">Employee Name</th>\n                        <th class=\"bg-grey col-md-4\">Position</th>\n                        <th v-if=\"team == 1\" class=\"bg-grey col-md-1\">In</th>\n                        <th v-if=\"team == 1\" class=\"bg-grey col-md-1\">Out</th>\n                        <th v-if=\"team == 1\" class=\"bg-grey col-md-1\">Break</th>\n                        <th v-if=\"team == 2\" class=\"bg-grey col-md-3\">Duration</th>\n                    </tr>\n                    </thead>\n                    <tbody>\n                    <tr v-for=\"employee in entryEmployees\">\n                        <td class=\"col-md-4\">\n                            {{ employee.first_name + ' ' + employee.last_name}}\n                        </td>\n                        <td class=\"col-md-4\">{{ employee.title }}</td>\n                        <td v-if=\"team == 1\" class=\"col-md-1\">{{ employee.in_time }}</td>\n                        <td v-if=\"team == 1\" class=\"col-md-1\">{{ employee.out_time }}</td>\n                        <td v-if=\"team == 1\" class=\"col-md-1\">{{ employee.break_time }}</td>\n                        <td v-if=\"team == 2\" class=\"col-md-1\">{{ employee.duration_team_2 | minuteToHour}}</td>\n                    </tr>\n                    </tbody>\n                </table>\n            </div>\n        </div>\n    </div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  var id = "/home/shoieb/sites/elegant/resources/assets/js/vue/components/data-entry-list.vue"
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, module.exports.template)
  }
})()}
},{"./../../mixed/modals":10,"./../../mixed/notify":11,"vue":5,"vue-hot-reload-api":4}],43:[function(require,module,exports){
"use strict";

exports.__esModule = true;
var modals = require("./../../mixed/modals");
var notify = require("./../../mixed/notify");
exports["default"] = {
  data: function data() {
    return {
      employees: {},
      scheduledEmployees: {},
      listedEmployees: {},
      activeEmployee: {},
      clients: {},
      activeClient: {},
      entryEmployees: {},
      listedEntryEmployees: {},
      entry: {
        client_id: "",
        employee_id: 0,
        position_code: "0",
        in_time: "",
        out_time: "",
        date: "",
        break_time: "",
        note: "",
        team: 1,
        duration: ""
      },
      action: "create",
      start_date: ""
    };
  },
  filters: {},
  watch: {
    "entry.client_id": function entryClient_id(val) {
      var that = this;
      this.activeClient = _.clone(_.find(this.clients, function (o) {
        return o.id == val;
      }));
      var formattedDate = moment(that.entry.date).format("YYYY-MM-DD");
      var scheduledEmployees = _.cloneDeep(this.scheduledEmployees);
      this.listedEmployees = _.filter(scheduledEmployees, function (o) {
        return o.client_id + "" === that.entry.client_id + "" && o.date === formattedDate && o.employee_order_id;
      });

      var entryEmployees = _.cloneDeep(this.entryEmployees);
      this.listedEntryEmployees = _.filter(entryEmployees, function (o) {
        return o.client_id + "" === that.entry.client_id + "" && o.date === formattedDate;
      });

      $("#all-employee").val(null).trigger("change.select2");
    },

    "entry.date": function entryDate(val) {
      var that = this;
      var formattedDate = moment(val, "D-MMM").format("YYYY-MM-DD");
      this.start_date = formattedDate;
      this.fetchDataEntryLists();
      // let scheduledEmployees = _.cloneDeep(this.scheduledEmployees);
      // this.listedEmployees = _.filter(scheduledEmployees, function(o) {
      //   return (
      //     o.client_id + "" === that.entry.client_id + "" &&
      //     o.date === formattedDate
      //   );
      // });

      // let entryEmployees = _.cloneDeep(this.entryEmployees);
      // this.listedEntryEmployees = _.filter(entryEmployees, function(o) {
      //   return (
      //     o.client_id + "" === that.entry.client_id + "" &&
      //     o.date === formattedDate
      //   );
      // });
    },

    activeClient: function activeClient() {
      // $("#position-code").selectric("refresh");
    },

    clients: function clients() {
      $("#data-entry-client").selectric("refresh");
    },

    listedEmployees: function listedEmployees() {
      this.checkEmployees(1);
    }
  },
  ready: function ready() {
    this.entry.team = this.team;
    $(".pickadate-year-entry").pickadate({
      format: "d-mmmm",
      firstDay: 1,
      max: new Date()
    });
    this.fetchDataEntryData();
    this.fetchDataEntryLists();
    $("#modal-data-entry").on("hidden.bs.modal", function () {
      $("#data-entry-client").prop("selectedIndex", 0).selectric("refresh");
    });
    $("#modal-data-entry").on("shown.bs.modal", function () {
      //this.clearEntryData();
    });
  },
  events: {},
  methods: {
    checkEmployees: function checkEmployees(employeeId) {
      var employees = _.pluck(_.cloneDeep(this.listedEmployees), "employee_id");
      return !employees.includes(employeeId);
    },

    refreshEntryDate: function refreshEntryDate() {
      var that = this;
      var formattedDate = moment(this.entry.date, "D-MMM").format("YYYY-MM-DD");
      this.listedEmployees = _.filter(this.scheduledEmployees, function (o) {
        return o.client_id + "" === that.entry.client_id + "" && o.date === formattedDate && o.employee_order_id;
      });

      this.listedEntryEmployees = _.filter(this.entryEmployees, function (o) {
        return o.client_id + "" === that.entry.client_id + "" && o.date === formattedDate;
      });

      $("#all-employee").select2();
    },

    refreshEntryClientId: function refreshEntryClientId() {
      var that = this;
      var formattedDate = moment(this.entry.date, "D-MMM").format("YYYY-MM-DD");
      this.activeClient = _.clone(_.find(this.clients, function (o) {
        return o.id == that.entry.client_id;
      }));

      this.listedEmployees = _.filter(this.scheduledEmployees, function (o) {
        return o.client_id + "" === that.entry.client_id + "" && o.date === formattedDate && o.employee_order_id;
      });

      this.listedEntryEmployees = _.filter(this.entryEmployees, function (o) {
        return o.client_id + "" === that.entry.client_id + "" && o.date === formattedDate;
      });

      $("#all-employee").select2();
    },
    /**
     * fetch data for data-entry forms
     */
    fetchDataEntryData: function fetchDataEntryData() {
      var _this = this;

      this.$http.get("/api/data-entry-data?team=" + this.team, "", function (response) {
        _this.employees = response.employees;
        _this.clients = response.clients;
      }).always(function () {});
    },

    /**
     * fetch data for data-entry forms
     */
    fetchDataEntryLists: function fetchDataEntryLists() {
      var _this2 = this;

      this.$http.get("/api/data-entry-list?team=" + this.team + "&start_date=" + this.start_date, "", function (response) {
        _this2.scheduledEmployees = response.scheduledEmployees;
        _this2.entryEmployees = response.entryEmployees;
        _this2.refreshEntryDate();
        _this2.refreshEntryClientId();
      }).always(function () {});
    },

    submitEntryForm: function submitEntryForm() {
      if (this.action == "create") {
        this.create();
      } else {
        this.submitEditEntry();
      }
    },

    /**
     * create entry data
     */
    create: function create() {
      var _this3 = this;

      var inTime = this.entry.in_time.slice(0, -1);
      var outTime = this.entry.out_time.slice(0, -1);
      var newEntry = _.cloneDeep(this.entry);
      newEntry.date = moment(newEntry.date, "D-MMM").format("YYYY-MM-DD");

      if (this.team == 1) {
        if (["a", "p"].includes(this.entry.in_time[this.entry.in_time.length - 1]) && ["a", "p"].includes(this.entry.out_time[this.entry.out_time.length - 1]) && inTime <= 12 && outTime <= 12) {} else {
          notify.error("Please provide correct time format");
          return false;
        }
      }
      if (this.team == 1 && (this.entry.client_id === "" || this.entry.employee_id === "" || this.entry.position_code === "" || this.entry.date === "" || this.entry.in_time === "" || this.entry.out_time === "" || this.entry.break_time === "") && this.entry.note === "") {
        notify.error("Please provide a note for incomplete data");
      } else if (this.team == 2 && (this.entry.client_id === "" || this.entry.employee_id === "" || this.entry.position_code === "" || this.entry.date === "" || this.entry.duration === "") && this.entry.note === "") {
        notify.error("Please provide a note for incomplete data");
      } else {
        this.entry.team = this.team;
        this.$http.post("/api/entry-data", newEntry, function (response) {
          _this3.clearEntryData();
          _this3.fetchDataEntryLists();
          modals.hide("#modal-data-entry");
        }).always(function () {});
      }
    },

    /**
     * delete an accounting data entry id
     */
    deleteEntry: function deleteEntry(accountingEntry) {
      var _this4 = this;

      var entry = _.cloneDeep(accountingEntry);
      this.$http["delete"]("/api/delete-accounting-entry/" + this.team, entry, function (response) {
        _this4.fetchDataEntryLists();
      }).always(function () {});
    },

    /**
     * edit an entry
     */
    editEntry: function editEntry(accountingEntry) {
      this.action = "edit";
      var entry = _.cloneDeep(accountingEntry);
      this.entry.client_id = entry.client_id;
      this.entry.employee_id = entry.employee_id;
      this.entry.position_code = entry.position_code;
      this.entry.date = moment(entry.date, "YYYY-MM-DD").format("D-MMM");
      this.entry.id = entry.id;
      if (this.team == 1) {
        this.entry.in_time = entry.in_time;
        this.entry.out_time = entry.out_time;
        this.entry.break_time = entry.break_time;
        this.entry.note = entry.note;
        this.entry.duration = entry.duration;
      } else {
        this.entry.note = entry.note_team_2;
        this.entry.duration = (entry.duration_team_2 / 60).toFixed(2);
      }
    },

    submitEditEntry: function submitEditEntry() {
      var _this5 = this;

      var entry = _.cloneDeep(this.entry);
      entry.date = moment(entry.date, "D-MMM").format("YYYY-MM-DD");
      this.$http.put("/api/update-accounting-entry/" + this.team, entry, function (response) {
        _this5.action = "create";
        _this5.clearEntryData();
        _this5.fetchDataEntryLists();
      }).always(function () {});
    },

    /**
     * clear the entry data on modal close
     */
    clearEntryData: function clearEntryData() {
      // this.entry = {
      //     in_time: '',
      //     out_time: '',
      //     break_time: '',
      //     note: '',
      //     team: 1,
      //     duration: ''
      // };

      this.entry.duration = "";
      this.entry.in_time = "";
      this.entry.out_time = "";
      this.entry.break_time = "";
      this.entry.note = "";
      this.entry.employee_id = 0;
      this.entry.position_code = 0;
      // $("#employee_list")
      //   .val("0")
      //   .trigger("change");
      // $("#position-code")
      //   .val("0")
      //   .trigger("change");
      // $("#position-code")
      //     .prop("selectedIndex", 0)
      //     .selectric("refresh");
    }
  },
  props: ["team"]
};
module.exports = exports["default"];
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n  <div class=\"row\">\n    <div class=\"col-md-12\">\n      <div class=\"col-md-5 no-padding\">\n        <h4 v-if=\"entry.client_id &amp;&amp; entry.date\" class=\"dark-bg text-center no-margin-top no-margin-bottom\">Scheduled</h4>\n        <div v-if=\"entry.client_id &amp;&amp; entry.date\" class=\"table-responsive\">\n          <table class=\"table table-xxs table-bordered\">\n            <thead>\n              <tr>\n                <th class=\"bg-grey col-md-6\">Position</th>\n                <th class=\"bg-grey col-md-6\">Employee</th>\n              </tr>\n            </thead>\n            <tbody>\n              <tr v-for=\"employee in listedEmployees\">\n                <td class=\"col-md-6\">{{ employee.title }}</td>\n                <td class=\"col-md-6\">{{ employee.first_name + ' ' + employee.last_name }}</td>\n              </tr>\n            </tbody>\n          </table>\n        </div>\n      </div>\n      <div class=\"col-md-7 no-padding\">\n        <h4 class=\"bg-blue-600 text-center no-margin-top no-margin-bottom\">Accounting Team - {{ team }}</h4>\n        <div class=\"col-md-12 grey-bg-200\">\n          <div class=\"row\">\n            <div class=\"col-md-12\">\n              <div class=\"col-md-6 padding-top-2\">\n                <div class=\"form-group\">\n                  <label>Client:</label>\n                  <select name=\"\" id=\"data-entry-client\" class=\"form-control select2\" v-model=\"entry.client_id\" v-vue-selectric=\"entry.client_id\">\n                    <option value=\"\">Client</option>\n                    <option v-for=\"client in clients\" :value=\"client.id\">{{ client.name }}</option>\n                  </select>\n                </div>\n              </div>\n              <div class=\"col-md-6\">\n                <div class=\"form-group\">\n                  <label>Date:</label>\n                  <input type=\"text\" name=\"username\" v-model=\"entry.date\" class=\"form-control pickadate-year-entry text-black\" required=\"required\">\n                </div>\n              </div>\n            </div>\n\n            <div class=\"col-md-12\">\n              <div class=\"col-md-6\">\n                <div class=\"form-group\">\n                  <label>Employee Name:</label>\n                  <select class=\"form-control\" v-model=\"entry.employee_id\" v-select2=\"entry.employee_id\" id=\"all-employee\" name=\"all-employee\">\n                    <option :value=\"0\">Select Employee</option>\n                    <optgroup label=\"Scheduled Employees\">\n                      <option v-for=\"employee in listedEmployees\" value=\"{{ employee.employee_id}}\">{{ employee.first_name + ' ' + employee.last_name }}</option>\n                    </optgroup>\n                    <optgroup v-for=\"(index,emp) in employees\" label=\"{{ index }}\">\n                      <option v-for=\"e in emp\" value=\"{{ e.id }}\" v-if=\"checkEmployees(e.id)\">{{ e.fullName }}</option>\n                    </optgroup>\n                  </select>\n                </div>\n              </div>\n              <div class=\"col-md-6\">\n                <div class=\"form-group\">\n                  <label>Position:</label>\n                  <select class=\"form-control select2\" name=\"position_code\" v-select-no-parse=\"entry.position_code\" v-model=\"entry.position_code\">\n                    <option :value=\"0\">Select Position</option>\n                    <option v-for=\"position in activeClient.positions\" :value=\"position.position_code\">{{ position.title }}</option>\n                  </select>\n                </div>\n              </div>\n            </div>\n\n            <div v-if=\"team == 1\" class=\"col-md-12\">\n              <div class=\"col-md-4\">\n                <div class=\"form-group\">\n                  <label>In Time:</label>\n                  <input type=\"text\" name=\"username\" v-model=\"entry.in_time\" class=\"form-control text-black\" required=\"required\">\n                </div>\n              </div>\n              <div class=\"col-md-4\">\n                <div class=\"form-group\">\n                  <label>Out Time:</label>\n                  <input type=\"text\" name=\"username\" v-model=\"entry.out_time\" class=\"form-control text-black\" required=\"required\">\n                </div>\n              </div>\n              <div class=\"col-md-4\">\n                <div class=\"form-group\">\n                  <label>Break:</label>\n                  <input type=\"text\" name=\"username\" v-model=\"entry.break_time\" class=\"form-control text-black\" required=\"required\">\n                </div>\n              </div>\n            </div>\n            <div v-if=\"team == 2\" class=\"col-md-12\">\n              <div class=\"col-md-12\">\n                <div class=\"form-group\">\n                  <label>Duration:</label>\n                  <input type=\"text\" name=\"duration\" v-model=\"entry.duration\" class=\"form-control text-black\" required=\"required\">\n                </div>\n              </div>\n            </div>\n            <div class=\"col-md-12\">\n              <div class=\"col-md-12 form-group\">\n                <label>Note:</label>\n                <textarea v-model=\"entry.note\" name=\"\" id=\"entry-note\" cols=\"30\" rows=\"5\" class=\"form-control\"></textarea>\n              </div>\n            </div>\n          </div>\n          <button type=\"button\" class=\"btn btn-primary pull-right mr-15 mb-20 text-capitalize\" v-on:click=\"submitEntryForm\">{{ action }}</button>\n        </div>\n\n        <div class=\"col-md-12 no-padding-left\">\n          <h4 v-if=\"entry.client_id &amp;&amp; entry.date\" class=\"bg-blue-600 text-center no-margin-top no-margin-bottom\">Entry By Team - {{ team }}</h4>\n          <div v-if=\"entry.client_id &amp;&amp; entry.date\" class=\"table-responsive\">\n            <table class=\"table table-xxs table-bordered\">\n              <thead>\n                <tr>\n                  <th class=\"bg-grey col-md-4\">Employee Name</th>\n                  <th class=\"bg-grey col-md-4\">Position</th>\n                  <th v-if=\"team == 1\" class=\"bg-grey col-md-1\">In</th>\n                  <th v-if=\"team == 1\" class=\"bg-grey col-md-1\">Out</th>\n                  <th v-if=\"team == 1\" class=\"bg-grey col-md-1\">Break</th>\n                  <th v-if=\"team == 2\" class=\"bg-grey col-md-3\">Duration</th>\n                  <th class=\"bg-grey col-md-1\">Edit</th>\n                  <th class=\"bg-grey col-md-1\">Delete</th>\n                </tr>\n              </thead>\n              <tbody>\n                <tr v-for=\"employee in listedEntryEmployees\">\n                  <td class=\"col-md-4\">{{ employee.first_name + ' ' + employee.last_name}}</td>\n                  <td class=\"col-md-4\">{{ employee.title }}</td>\n                  <td v-if=\"team == 1\" class=\"col-md-1\">{{ employee.in_time }}</td>\n                  <td v-if=\"team == 1\" class=\"col-md-1\">{{ employee.out_time }}</td>\n                  <td v-if=\"team == 1\" class=\"col-md-1\">{{ employee.break_time }}</td>\n                  <td v-if=\"team == 2\" class=\"col-md-1\">{{ employee.duration_team_2 | minuteToHour }}</td>\n                  <td class=\"col-md-1\">\n                    <button class=\"btn btn-primary\" @click=\"editEntry(employee)\">Edit</button>\n                  </td>\n                  <td class=\"col-md-1\">\n                    <button class=\"btn btn-danger\" @click=\"deleteEntry(employee)\">Delete</button>\n                  </td>\n                </tr>\n              </tbody>\n            </table>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"modal fade\" id=\"modal-data-entry\">\n      <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n          <div class=\"modal-header\">\n            <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\">×</button>\n            <h4 class=\"modal-title\">Accounting Team {{ team }}</h4>\n          </div>\n          <div class=\"modal-body\"></div>\n          <div class=\"modal-footer\">\n            <button type=\"button\" class=\"btn btn-primary\" v-on:click=\"create\">Submit</button>\n          </div>\n        </div>\n        <!-- /.modal-content -->\n      </div>\n      <!-- /.modal-dialog -->\n    </div>\n    <!-- /.modal -->\n  </div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  var id = "/home/shoieb/sites/elegant/resources/assets/js/vue/components/data-entry.vue"
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, module.exports.template)
  }
})()}
},{"./../../mixed/modals":10,"./../../mixed/notify":11,"vue":5,"vue-hot-reload-api":4}],44:[function(require,module,exports){
"use strict";

exports.__esModule = true;
var modals = require("./../../mixed/modals");
var notify = require("./../../mixed/notify");
exports["default"] = {
  data: function data() {
    return {
      employee: {},
      files: null,
      documents: null,
      notes: null,
      orders: null
    };
  },
  props: ['id'],
  filters: {},
  watch: {
    'employee': function employee(val) {
      if (val && val !== '0') {
        var activeEmployees = this.allEmployees['Active & Watch List'];
        var otherEmployees = this.allEmployees['Others'];
        var localEmployee = _.find(activeEmployees.concat(otherEmployees), {
          id: parseInt(val)
        });
        localEmployee.pivot = {};
        localEmployee.pivot.employee_id = parseInt(val);
        this.getEmployeeHistory(localEmployee.id);
      }
    }
  },
  ready: function ready() {
    this.getEmployeeDetails();
  },
  events: {},
  methods: {
    /**
     * fetch notes data
     */
    getEmployeeList: function getEmployeeList() {
      var _this = this;

      this.$http.get("/api/all-employee-list-data", "", function (response) {
        _this.allEmployees = response.employees;
      }).always(function () {});
    },

    getEmployeeDetails: function getEmployeeDetails(id) {
      var _this2 = this;

      notify.loading(true);
      this.$http.get("/api/employee-details-data/" + this.id, "", function (response) {
        _this2.employee = response.employee;
        _this2.files = response.files;
        _this2.documents = response.documents;
        _this2.notes = response.notes;
        _this2.orders = response.orders;
        notify.loading(false);
      }).always(function () {});
    }
  }
};
module.exports = exports["default"];
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n  <div class=\"row\">\n    <div class=\"col-md-12 no-padding\">\n            <div class=\"panel panel-flat\">\n                <div class=\"panel-body\">\n                    <div class=\"row\">\n                        <div class=\"col-md-2\">\n                            <img :src=\"'https://4bf7552dfc1a54163577-fc6d27d9aae55eef9b8e919dcfe05229.ssl.cf5.rackcdn.com/profile/'+employee.image\" width=\"260\">\n                        </div>\n\n                        <div class=\"col-md-5 text-center\">\n                            <h3>{{employee.fullName}}</h3>\n                            <p class=\"font-16\">{{employee.city+','+employee+state+','+employee.zip_code}}</p>\n                            <p class=\"font-16\">{{employee.email}}, {{employee.primary_phone}}</p>\n                            <p class=\"text-danger font-18 font-weight-bold\">{{employee.grooming}}\n                                .{{employee.attitude}}.{{employee.reliability}}\n                                .{{employee.background}}</p>\n                        </div>\n\n                        <div class=\"col-md-5 text-center pt-10\">\n                            <p class=\"p-2 pb-2 font-16 text-black text-left\">Job Offered: {{employee.jo_full_count}}</p>\n                            <p class=\"p-2 pb-2  font-16 text-black text-left\">\n                                Confirmed: {{employee.confirmed_full_count}}</p>\n                            <p class=\"p-2 pb-2  font-16 text-black text-left\">Worked: {{employee.worked_full_count}}</p>\n                            <p class=\"p-2 pb-2  font-16 text-black text-left\">Call Out: {{employee.call_out_full_count}}</p>\n                            <p class=\"p-2 pb-2  font-16 text-black text-left\">No Show: {{employee.no_show_full_count}}</p>\n                        </div>\n                    </div>\n                    <div class=\"row m-5\">\n\n                    </div>\n                    <div class=\"row mt-10 mb-50\">\n                        <div class=\"col-md-12 no-padding border-top border-bottom border-left border-right border-grey-300 border-2\">\n                            <div class=\"col-md-12 text-center font-18 text-black p-10 sticky-top bg-slate-300\">Employee Job History</div>\n                        <div class=\"col-md-12 text-center call-out-table no-padding\">\n                            <table class=\"table table-condensed job-history-table\">\n                                <thead>\n                                <tr>\n                                    <th class=\"text-left\">Client</th>\n                                    <th class=\"text-center\">Position</th>\n                                    <th class=\"text-center\">Date</th>\n                                    <th class=\"text-center\">In Time</th>\n                                    <th class=\"text-center\">Out Time</th>\n                                    <th class=\"text-center\">Status</th>\n                                </tr>\n                                </thead>\n                                <tbody>\n                                    <tr v-for=\"entry in employee.workHistoryTwoYear\">\n                                        <td class=\"text-left\">{{entry.order.client.name}}</td>\n                                        <td class=\"text-center\">\n                                            {{entry.order.position.title}}</td>\n                                        <td class=\"text-center\">{{ entry.order_date }}</td>\n                                        <td class=\"text-center\">{{entry.in}}</td>\n                                        <td class=\"text-center\">{{entry.out}}</td>\n                                        <td class=\"text-center\" :class=\"entry.bg\">\n                                                <p :title=\"entry.employee_note\">{{entry.type}}</p>\n                                                    <p v-if=\"entry.type === 'Call Out'\" class=\"font-12\">{{entry.diff}}</p>\n                                        </td>\n\n                                    </tr>\n                                </tbody>\n                            </table>\n                        </div>\n                        </div>\n\n                        <div class=\"col-md-12 no-padding border-top border-bottom border-left border-right border-grey-300 border-2 mt-20\">\n                            <div class=\"col-md-12 text-center font-18 text-black p-10 sticky-top bg-slate-300\">Employee Future Jobs</div>\n                        <div class=\"col-md-12 text-center call-out-table no-padding\">\n                            \n                                @foreach(orders as order)\n                                    \n                                        {{--{{\\Carbon\\Carbon::parse(callOut.created_at).diffForHumans(\\Carbon\\Carbon::parse(callOut.order.in_time))}}                                   --}}\n                                    \n                                @endforeach\n                                <table class=\"table table-condensed job-history-table\">\n                                <thead>\n                                <tr>\n                                    <th class=\"text-left\">Client</th>\n                                    <th class=\"text-center\">Position</th>\n                                    <th class=\"text-center\">Date</th>\n                                    <th class=\"text-center\">In Time</th>\n                                    <th class=\"text-center\">Out Time</th>\n                                    <th class=\"text-center\">Status</th>\n                                </tr></thead>\n                                <tbody><tr>\n                                        <td class=\"text-left\">{{order.client_name}}</td>\n                                        <td class=\"text-center\">\n                                            {{order.order.positions.title}}</td>\n                                        <td class=\"text-center\">{{\\Carbon\\Carbon::parse(order.order.date).toDateString()}}</td>\n                                        <td class=\"text-center\">{{\\Carbon\\Carbon::parse(order.order.in_time).format('h:i A')}}</td>\n                                        <td class=\"text-center\">{{\\Carbon\\Carbon::parse(order.order.out_time).format('h:i A')}}</td>\n                                        <td class=\"text-center text-capitalize\">{{order.status}}</td></tr></tbody>\n                            </table>\n                        </div>\n                        </div>\n                    </div>\n\n                    <div class=\"row mt-10 mb-10\"></div>\n                    <div class=\"row mt-20\">\n                        <div class=\"col-md-6 text-center\">\n                            <div class=\"row pr-0 mb-10\">\n                                <div class=\"col-md-10 text-center font-18 text-danger\">Employee Files</div>\n                                <div class=\"col-md-2 text-right font-16 font-black pr-1\">\n                                    <button type=\"button\" class=\"btn btn-primary\" data-toggle=\"modal\" data-target=\"#exampleModal\">\n                                        Upload New File\n                                    </button>\n                                </div>\n                            </div>\n                            \n                                {{--                                    --}}\n                                \n                                @foreach(files as file)\n                                    \n                                        {{--                                        --}}\n                                        {{--{{\\Carbon\\Carbon::parse(callOut.created_at).diffForHumans(\\Carbon\\Carbon::parse(callOut.order.in_time))}}                                   --}}\n                                    \n                                @endforeach\n                                <table class=\"table table-bordered table-condensed\">\n                                <thead>\n                                <tr>\n                                    <th class=\"text-left\">Document Name</th>\n                                    <th class=\"text-center\">Category</th>\n                                    <th class=\"text-center\">Added By</th>\n                                    <th class=\"text-center\">Expiery Date</th>\n                                    <th class=\"text-center\">View</th><th class=\"text-center\">Download</th></tr></thead>\n                                <tbody><tr>\n                                        <td class=\"text-left\">{{file.document.document_name}}</td>\n                                        <td class=\"text-center\">{{file.type}}</td>\n                                        <td class=\"text-center\">{{file.user.name}}</td>\n                                        <td class=\"text-center\">{{file.expiry_date}}</td>\n                                        <td class=\"text-center\">\n                                            <a target=\"_blank\" href=\"{{eployeeFileLink().file.file_name}}\">View</a>\n                                        </td><td class=\"text-center\">--}}\n                                        {{--                                            <a target=\"_blank\" --}}=\"\" {{--=\"\" href=\"{{eployeeFileLink().file.file_name}}\">Download</a>--}}\n                                        {{--                                        </td></tr></tbody>\n                            </table>\n                        </div>\n\n\n                        <div class=\"col-md-6 text-center\">\n                            <div class=\"row pr-0 mb-10\">\n                                <div class=\"col-md-10 text-center font-18 text-danger\">Employee Notes</div>\n                                <div class=\"col-md-2 text-right font-16 font-black pr-1\">\n                                    <button type=\"button\" class=\"btn btn-primary\" data-toggle=\"modal\" data-target=\"#noteModal\">\n                                        Add New Note\n                                    </button>\n                                </div>\n                            </div>\n                            \n                                @foreach(notes as note)\n                                    \n                                        {{--{{\\Carbon\\Carbon::parse(callOut.created_at).diffForHumans(\\Carbon\\Carbon::parse(callOut.order.in_time))}}                                   --}}\n                                    \n                                @endforeach\n                                <table class=\"table table-bordered table-condensed\">\n                                <thead>\n                                <tr>\n                                    <th class=\"text-left\">Note</th>\n                                    <th class=\"text-center\">Added By</th>\n                                    <th class=\"text-center\">Created At</th>\n                                </tr></thead>\n                                <tbody><tr>\n                                        <td class=\"text-left\">{{note.note}}</td>\n                                        <td class=\"text-center\">{{note.user.name}}</td>\n                                        <td class=\"text-center\">{{note.created_at}}</td></tr></tbody>\n                            </table>\n                        </div>\n\n\n                        <div class=\"modal fade\" id=\"exampleModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"exampleModalLabel\" aria-hidden=\"true\">\n                            <div class=\"modal-dialog\" role=\"document\">\n                                <div class=\"modal-content\">\n                                    <div class=\"modal-header\">\n                                        <h5 class=\"modal-title\" id=\"exampleModalLabel\">Upload File</h5>\n                                        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\">\n                                            <span aria-hidden=\"true\">×</span>\n                                        </button>\n                                    </div>\n                                    <div class=\"modal-body\">\n                                        <form method=\"post\" enctype=\"multipart/form-data\" action=\"/admin/upload-employee-file\">\n                                            <div class=\"form-row\">\n                                                <div class=\"form-group col-md-6\">\n                                                    <label for=\"name\">Document Name</label>\n                                                    <select id=\"name\" class=\"form-control\" name=\"category_id\" required=\"\">\n                                                        @foreach(documents as document)\n                                                            <option value=\"{{document.id}}\">{{document.document_name}}</option>\n                                                        @endforeach\n                                                    </select>\n                                                </div>\n                                                <div class=\"form-group col-md-6\">\n                                                    <label for=\"type\">Document Type</label>\n                                                    <select id=\"type\" class=\"form-control\" name=\"type\" required=\"\">\n                                                        <option value=\"primary\" selected=\"\">Primary</option>\n                                                        <option value=\"secondary\">Secondary</option>\n                                                    </select>\n                                                </div>\n                                            </div>\n                                            <div class=\"form-row\">\n                                                <div class=\"form-group col-md-6\">\n                                                    <label for=\"inputCity\">Expiry Date</label>\n                                                    <input type=\"date\" class=\"form-control\" id=\"expiry_date\" name=\"expiry_date\" placeholder=\"dd-mm-yyyy\" value=\"\" min=\"1997-01-01\" max=\"2035-12-31\">\n                                                </div>\n                                                <div class=\"form-group col-md-6\">\n                                                    <label for=\"inputZip\">File</label>\n                                                    <input type=\"file\" class=\"form-control\" id=\"inputFile\" required=\"\" accept=\"image/png, image/jpeg\" name=\"file_name\">\n                                                </div>\n                                            </div>\n                                            <button type=\"submit\" class=\"btn btn-primary ml-10\">Upload File</button>\n                                            <input type=\"hidden\" name=\"employee_id\" value=\"{{employee.id}}\">\n                                            {!! csrf_field() !!}\n                                        </form>\n                                    </div>\n                                    <div class=\"modal-footer\">\n                                        {{--                                    <button type=\"button\" class=\"btn btn-secondary\" data-dismiss=\"modal\">Close</button>--}}\n                                        {{--                                    <button type=\"submit\" class=\"btn btn-primary\">Upload File</button>--}}\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n\n\n                        <div class=\"modal fade\" id=\"noteModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"exampleModalLabel\" aria-hidden=\"true\">\n                            <div class=\"modal-dialog\" role=\"document\">\n                                <div class=\"modal-content\">\n                                    <div class=\"modal-header\">\n                                        <h5 class=\"modal-title\" id=\"exampleModalLabel\">Add New Note</h5>\n                                        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\">\n                                            <span aria-hidden=\"true\">×</span>\n                                        </button>\n                                    </div>\n                                    <div class=\"modal-body\">\n                                        <form method=\"post\" enctype=\"multipart/form-data\" action=\"/admin/add-employee-note\">\n                                            <div class=\"form-row\">\n                                                <div class=\"form-group col-md-12\">\n                                                    <label for=\"name\">Note</label>\n                                                    <textarea class=\"form-control\" id=\"note\" name=\"note\" rows=\"10\"></textarea>\n                                                </div>\n                                            </div>\n                                            <button type=\"submit\" class=\"btn btn-primary ml-10\">Add Note</button>\n                                            <input type=\"hidden\" name=\"employee_id\" value=\"{{employee.id}}\">\n                                            {!! csrf_field() !!}\n                                        </form>\n                                    </div>\n                                    <div class=\"modal-footer\">\n                                        {{--                                    <button type=\"button\" class=\"btn btn-secondary\" data-dismiss=\"modal\">Close</button>--}}\n                                        {{--                                    <button type=\"submit\" class=\"btn btn-primary\">Upload File</button>--}}\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n\n                </div>\n            </div>\n        </div>\n  </div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  var id = "/home/shoieb/sites/elegant/resources/assets/js/vue/components/employee-details.vue"
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, module.exports.template)
  }
})()}
},{"./../../mixed/modals":10,"./../../mixed/notify":11,"vue":5,"vue-hot-reload-api":4}],45:[function(require,module,exports){
"use strict";

exports.__esModule = true;
var modals = require("./../../mixed/modals");
var notify = require("./../../mixed/notify");
exports["default"] = {
  data: function data() {
    return {
      allEmployees: {},
      employee: null,
      activeEmployee: null
    };
  },
  filters: {},
  watch: {
    'employee': function employee(val) {
      if (val && val !== '0') {
        var activeEmployees = this.allEmployees['Active & Watch List'];
        var otherEmployees = this.allEmployees['Others'];
        var localEmployee = _.find(activeEmployees.concat(otherEmployees), {
          id: parseInt(val)
        });
        localEmployee.pivot = {};
        localEmployee.pivot.employee_id = parseInt(val);
        this.getEmployeeHistory(localEmployee.id);
      }
    }
  },
  ready: function ready() {
    this.getEmployeeList();
  },
  events: {},
  methods: {
    /**
     * fetch notes data
     */
    getEmployeeList: function getEmployeeList() {
      var _this = this;

      this.$http.get("/api/all-employee-list-data", "", function (response) {
        _this.allEmployees = response.employees;
      }).always(function () {});
    },

    getEmployeeHistory: function getEmployeeHistory(id) {
      var _this2 = this;

      notify.loading(true);
      this.$http.get("/api/employee-history-data/" + id, "", function (response) {
        _this2.activeEmployee = response;
        notify.loading(false);
      }).always(function () {});
    }
  }
};
module.exports = exports["default"];
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n  <div class=\"row p-10\">\n    <div class=\"panel panel-flat p-5\">\n      <div class=\"panel-body\">\n        <div class=\"row p-15 mb-10\">\n          <div class=\"col-md-4\">\n            <select name=\"\" id=\"employee-list\" class=\"form-control\" v-model=\"employee\" v-select2=\"employee\" data-placeholder=\"Search Employee\">\n              <option value=\"0\">Search Employee</option>\n              <optgroup v-for=\"(index,emp) in allEmployees\" :label=\"index\">\n                <option v-for=\"e in emp\" value=\"{{ e.id }}\">{{ e.fullName }}</option>\n              </optgroup>\n            </select>\n          </div>\n          <div class=\"col-md-4\"></div>\n          <div class=\"col-md-4\"></div>\n        </div>\n\n\n        <div class=\"row\" v-if=\"activeEmployee\">\n          <div class=\"row\">\n            <div class=\"col-md-4 col-lg-4 col-sm-4 text-center\">\n              <a href=\"#\" class=\"me-3\">\n                <img :src=\"'https://4bf7552dfc1a54163577-fc6d27d9aae55eef9b8e919dcfe05229.ssl.cf5.rackcdn.com//profile/'+activeEmployee.employee.image\" class=\"rounded\" width=\"144\" height=\"144\" alt=\"\">\n              </a>\n              <div class=\"text-bold mt-5 font-18\">{{ activeEmployee.employee.fullName }}(<span class=\"text-danger font-16\">{{ activeEmployee.employee.status }}</span>)\n              </div>\n              <div class=\"text-bold mt-5 font-16\">{{ activeEmployee.employee.email }}</div>\n              <div class=\"text-bold mt-5 font-16\">{{ activeEmployee.employee.primary_phone }}</div>\n            </div>\n            <div class=\"col-md-4 col-lg-4 col-sm-4\">\n\n              <div class=\"card card-body font-16\">\n                <div class=\"d-flex\">\n                  <div class=\"flex-fill\">\n                    <div>\n                      <span class=\"text-slate-700 text-bold\">Address:</span>\n                      <span class=\"\">{{\n                          activeEmployee.employee.street + ',' + activeEmployee.employee.city + ',' + activeEmployee.employee.state + ',' + activeEmployee.employee.zip_code\n                        }}</span>\n                    </div>\n                    <div>\n                      <span class=\"text-slate-700 text-bold\">App Last Used:</span>\n                      <span class=\"\">{{\n                          activeEmployee.employee.app\n                        }}</span>\n                    </div>\n                    <div>\n                      <span class=\"text-slate-700 text-bold\">Shift Required:</span>\n                      <span class=\"\">{{\n                          activeEmployee.employee.shift_required\n                        }}</span>\n                    </div>\n                    <div>\n                      <span class=\"text-slate-700 text-bold\">Minimum Salary:</span>\n                      <span class=\"\">{{\n                          activeEmployee.employee.minimum_salary\n                        }}</span>\n                    </div>\n                    <div>\n                      <span class=\"text-slate-700 text-bold\">Gender:</span>\n                      <span class=\"\">{{\n                          activeEmployee.employee.gender\n                        }}</span>\n                    </div>\n                    <div>\n                      <span class=\"text-slate-700 text-bold\">Desired Position:</span>\n                      <span class=\"\">{{\n                          activeEmployee.employee.position_desired\n                        }}</span>\n                    </div>\n                    <div>\n                      <span class=\"text-slate-700 text-bold\">Legal Status:</span>\n                      <span class=\"\">{{\n                          activeEmployee.employee.legal_status\n                        }}</span>\n                    </div>\n\n                  </div>\n\n                  <div class=\"ms-3 align-self-center\">\n                    <div class=\"bg-success rounded-circle p-1\"></div>\n                  </div>\n                </div>\n              </div>\n\n            </div>\n\n            <div class=\"col-md-4 col-lg-4 col-sm-4\">\n\n              <div class=\"card card-body font-16\">\n                <div class=\"d-flex\">\n                  <div class=\"flex-fill\">\n                    <div>\n                      <span class=\"text-slate-700 text-bold\">Hire Date:</span>\n                      <span class=\"\">{{\n                          activeEmployee.employee.hire\n                        }}</span>\n                    </div>\n                    <div>\n                      <span class=\"text-slate-700 text-bold\">G.A.R.B:</span>\n                      <span class=\"\">{{\n                          activeEmployee.employee.grooming + '.' + activeEmployee.employee.attitude + '. ' + activeEmployee.employee.reliability + '. ' + activeEmployee.employee.background\n                        }}</span>\n                    </div>\n                    <div>\n                      <span class=\"text-slate-700 text-bold\">Confirmed:</span>\n                      <span class=\"\">{{\n                          activeEmployee.counts.confirmed\n                        }}</span>\n                    </div>\n                    <div>\n                      <span class=\"text-slate-700 text-bold\">Worked:</span>\n                      <span class=\"\">{{\n                          activeEmployee.counts.worked\n                        }}</span>\n                    </div>\n                    <div>\n                      <span class=\"text-slate-700 text-bold\">Call Out:</span>\n                      <span class=\"\">{{\n                          activeEmployee.counts.callOut\n                        }}</span>\n                    </div>\n                    <div>\n                      <span class=\"text-slate-700 text-bold\">No Show:</span>\n                      <span class=\"\">{{\n                          activeEmployee.counts.noShow\n                        }}</span>\n                    </div>\n                  </div>\n\n                  <div class=\"ms-3 align-self-center\">\n                    <div class=\"bg-success rounded-circle p-1\"></div>\n                  </div>\n                </div>\n              </div>\n\n\n            </div>\n          </div>\n\n\n          <div class=\"row\">\n            <div class=\"col-md-4 col-lg-4 mt-15\">\n              <div class=\"card card-body font-16\">\n                <div class=\"d-flex\">\n                  <table class=\"table table-xxs\">\n                    <tbody><tr>\n                      <td colspan=\"2\" class=\"text-center text-bold text-white bg-primary font-18\">Confirms</td>\n                    </tr>\n                    <tr v-for=\"(index,client) in activeEmployee.confirms\">\n                      <td>{{ client.client_name }} - <span class=\" font-12 text-bold\" :class=\"{'text-success': client.zone === 'A',\n                                                            'text-orange': client.zone === 'B',\n                                                            'text-danger': client.zone === 'C'\n                                                            }\">\n                        {{ client.zone }}</span></td>\n                      <td>{{ client.count }}</td>\n                    </tr>\n                  </tbody></table>\n                </div>\n              </div>\n            </div>\n\n            <div class=\"col-md-4 col-lg-4 mt-15\">\n              <div class=\"card card-body font-16\">\n                <div class=\"d-flex\">\n                  <table class=\"table table-xxs\">\n                    <tbody><tr>\n                      <td colspan=\"2\" class=\"text-center text-bold bg-green text-white font-18\">Worked</td>\n                    </tr>\n                    <tr v-for=\"(index,client) in activeEmployee.worked\">\n                      <td>{{ client.client_name }} - <span class=\" font-12 text-bold\" :class=\"{'text-success': client.zone === 'A',\n                                                            'text-orange': client.zone === 'B',\n                                                            'text-danger': client.zone === 'C'\n                                                            }\">\n                        {{ client.zone }}</span></td>\n                      <td>{{ client.count }}</td>\n                    </tr>\n                  </tbody></table>\n                </div>\n              </div>\n            </div>\n\n            <div class=\"col-md-4 col-lg-4 mt-15\">\n              <div class=\"card card-body font-16\">\n                <div class=\"d-flex\">\n                  <table class=\"table table-togglable table-hover table-xxs\">\n                    <tbody><tr>\n                      <td colspan=\"2\" class=\"text-center text-bold bg-danger text-white font-18\">Call Out</td>\n                    </tr>\n                    <tr v-for=\"(index,client) in activeEmployee.callouts\">\n                      <td>{{ client.client_name }} - <span class=\" font-12 text-bold\" :class=\"{'text-success': client.zone === 'A',\n                                                            'text-orange': client.zone === 'B',\n                                                            'text-danger': client.zone === 'C'\n                                                            }\">\n                        {{ client.zone }}</span></td>\n                      <td>{{ client.count }}</td>\n                    </tr>\n                  </tbody></table>\n                </div>\n              </div>\n\n              <div class=\"card card-body font-16\">\n                <div class=\"d-flex\">\n                  <table class=\"table table-togglable table-hover table-xxs\">\n                    <tbody><tr>\n                      <td colspan=\"2\" class=\"text-center text-bold bg-danger text-white font-18\">No Show</td>\n                    </tr>\n                    <tr v-for=\"(index,client) in activeEmployee.noShow\">\n                      <td>{{ client.client_name }} - <span class=\" font-12 text-bold\" :class=\"{'text-success': client.zone === 'A',\n                                                            'text-orange': client.zone === 'B',\n                                                            'text-danger': client.zone === 'C'\n                                                            }\">\n                        {{ client.zone }}</span></td>\n                      <td>{{ client.count }}</td>\n                    </tr>\n                  </tbody></table>\n                </div>\n              </div>\n            </div>\n          </div>\n\n\n          <div class=\"row\">\n\n            <div class=\"col-md-6 col-lg-6 mt-15\">\n              <div class=\"card card-body font-16\">\n                <div class=\"d-flex\">\n                  <table class=\"table table-xxs\">\n                    <tbody><tr>\n                      <td colspan=\"5\" class=\"text-center text-bold bg-blue-300 text-white font-18\">Records by\n                        Positions\n                      </td>\n                    </tr>\n                    <tr>\n                      <td class=\"text-bold text-left font-18\">Position</td>\n                      <td class=\"text-bold text-center font-18\">Confirmed</td>\n                      <td class=\"text-bold text-center font-18\">Worked</td>\n                      <td class=\"text-bold text-center font-18\">Call Out</td>\n                      <td class=\"text-bold text-center font-18\">No Show</td>\n                    </tr>\n                    <tr v-for=\"(index,client) in activeEmployee.positions\">\n                      <td class=\"text-left\">{{ client.position }}</td>\n                      <td class=\"text-center\">{{ client.confirms }}</td>\n                      <td class=\"text-center\">{{ client.worked }}</td>\n                      <td class=\"text-center\">{{ client.callouts }}</td>\n                      <td class=\"text-center\">{{ client.noShow }}</td>\n                    </tr>\n                  </tbody></table>\n                </div>\n              </div>\n            </div>\n\n\n            <div class=\"col-md-6 col-lg-6 mt-15\">\n              <div class=\"card card-body font-16\">\n                <div class=\"d-flex\">\n                  <table class=\"table  table-xxs\">\n                    <tbody><tr>\n                      <td colspan=\"5\" class=\"text-center text-bold text-white bg-blue-300 font-18\">Records by Day</td>\n                    </tr>\n                    <tr>\n                      <td class=\"text-bold text-left font-18\">Day</td>\n                      <td class=\"text-bold text-center font-18\">Confirmed</td>\n                      <td class=\"text-bold text-center font-18\">Worked</td>\n                      <td class=\"text-bold text-center font-18\">Call Out</td>\n                      <td class=\"text-bold text-center font-18\">No Show</td>\n                    </tr>\n                    <tr v-for=\"(index,client) in activeEmployee.days\">\n                      <td class=\"text-left\">{{ client.day }}</td>\n                      <td class=\"text-center\">{{ client.confirms }}</td>\n                      <td class=\"text-center\">{{ client.worked }}</td>\n                      <td class=\"text-center\">{{ client.callouts }}</td>\n                      <td class=\"text-center\">{{ client.noShow }}</td>\n                    </tr>\n                  </tbody></table>\n                </div>\n              </div>\n            </div>\n\n          </div>\n\n\n          <div class=\"row\">\n\n            <div class=\"col-md-6\">\n              <div class=\"col-md-12 col-lg-12 mt-15\">\n                <div class=\"card card-body font-16\">\n                  <div class=\"d-flex\">\n                    <table class=\"table table-xxs\">\n                      <tbody><tr>\n                        <td colspan=\"7\" class=\"text-center text-bold text-white bg-blue-300 font-18\">Records by Shift\n                          Duration\n                        </td>\n                      </tr>\n                      <tr>\n                        <td class=\"text-bold text-left font-18\">Month</td>\n                        <td class=\"text-bold text-center font-18\">Hours</td>\n                        <td class=\"text-bold text-center font-18\">Confirmed</td>\n                        <td class=\"text-bold text-center font-18\">Worked</td>\n                        <td class=\"text-bold text-center font-18\">Call Out</td>\n                        <td class=\"text-bold text-center font-18\">No Show</td>\n                        <td class=\"text-bold text-center font-18\">Avg. Rate</td>\n                      </tr>\n                      <tr v-for=\"(index,client) in activeEmployee.months\">\n                        <td class=\"text-left\">{{ client.month }}</td>\n                        <td class=\"text-center\">{{ client.hours }}</td>\n                        <td class=\"text-center\">{{ client.confirms }}</td>\n                        <td class=\"text-center\">{{ client.worked }}</td>\n                        <td class=\"text-center\">{{ client.callouts }}</td>\n                        <td class=\"text-center\">{{ client.noShow }}</td>\n                        <td class=\"text-center\">{{ client.avg_pay_rate }}</td>\n                      </tr>\n                    </tbody></table>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n\n      </div>\n    </div>\n  </div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  var id = "/home/shoieb/sites/elegant/resources/assets/js/vue/components/employee-history.vue"
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, module.exports.template)
  }
})()}
},{"./../../mixed/modals":10,"./../../mixed/notify":11,"vue":5,"vue-hot-reload-api":4}],46:[function(require,module,exports){
var __vueify_style__ = require("vueify-insert-css").insert("\n.close-modal[_v-85888a94] {\n  font-size: 30px;\n  margin-top: -14.75px;\n  font-weight: 500;\n}\n\n.close-modal-29[_v-85888a94] {\n  font-size: 30px;\n  margin-top: -29.75px !important;\n  font-weight: 500;\n}\n\n.close-modal-0[_v-85888a94] {\n  font-size: 35px;\n  margin-top: 0 !important;\n  font-weight: 500;\n  z-index: 100;\n  color: #656565 !important;\n}\n\n.font-20[_v-85888a94] {\n  font-size: 20px;\n}\n\n.bg-slate-custom[_v-85888a94] {\n  background-color: #d6dce5;\n  border-color: #d6dce5;\n}\n\n.custom-header[_v-85888a94] {\n  position: -webkit-sticky;\n  position: sticky;\n  top: 48px;\n  z-index: 100;\n}\n\n.top-65[_v-85888a94] {\n  top: 65px;\n}\n\n.bg-top-1[_v-85888a94] {\n  background-color: #8497b0;\n  border-color: #8497b0;\n  color: #fff;\n}\n\n.bg-top-2[_v-85888a94] {\n  background-color: #adb9ca;\n  border-color: #adb9ca;\n  color: #fff;\n}\n\n.bg-top-3[_v-85888a94] {\n  background-color: #44546a;\n  border-color: #44546a;\n  color: #fff;\n}\n\n.bg-top-4[_v-85888a94] {\n  background-color: #d6dce5;\n  border-color: #d6dce5;\n  color: #fff;\n}\n\n[_v-85888a94]::-webkit-input-placeholder {\n  text-align: center;\n}\n\n[_v-85888a94]:-moz-placeholder { /* Firefox 18- */\n  text-align: center;\n}\n\n[_v-85888a94]::-moz-placeholder { /* Firefox 19+ */\n  text-align: center;\n}\n\n[_v-85888a94]:-ms-input-placeholder {\n  text-align: center;\n}\n\n.w-200[_v-85888a94] {\n  width: 200px !important;\n}\n\n@media (min-width: 769px) {\n  .modal-sm-custom[_v-85888a94] {\n    width: 500px;\n  }\n}\n\n\n")
"use strict";

exports.__esModule = true;
var modals = require("./../../mixed/modals");
var notify = require("./../../mixed/notify");

exports["default"] = {
  data: function data() {
    return {
      employees: {},
      searchedClients: {},
      activeEmployee: {},
      jobs: {},
      type: 0,
      availableJobs: {},
      selectedJObs: {},
      ids: [],
      query: '',
      password: ''
    };
  },
  props: ['user'],
  filters: {},
  watch: {
    'query': function query(val, oldVal) {
      var regex = this.convertWildcardStringToRegExp(val);
      this.searchedClients = this.clients.filter(function (item) {
        return regex.test(item.name);
      });
    }
  },
  ready: function ready() {
    this.getImageList();
  },

  events: {},

  methods: {

    getImageList: function getImageList() {
      var _this = this;

      notify.loading(true);
      this.$http.get("/api/employee-image-processed-list", function (response) {
        _this.employees = response;
        notify.loading(false);
      }).always(function () {});
    },

    /**
     * show modal to update client time clock status
     * @param client
     */
    updateStatusModal: function updateStatusModal(employee) {
      this.activeEmployee = _.cloneDeep(employee);

      modals.showStrict("#status-modal");
    },

    // updateImageStatus(status) {
    //   notify.loading(true);
    //   this.$http
    //       .post(
    //           `/api/employee-image-update/`,
    //           {
    //             status: status,
    //             employee_id: this.activeEmployee.employee_id,
    //             image: this.activeEmployee.image,
    //             id: this.activeEmployee.id
    //           },
    //           response => {
    //             this.getImageList();
    //             modals.hide("#status-modal");
    //             notify.loading(false);
    //           }
    //       )
    //       .always(() => {
    //         notify.loading(false);
    //       });
    // },

    deactivateClient: function deactivateClient() {
      var _this2 = this;

      notify.loading(true);
      this.$http.get("/api/client-settings-deactivate/" + this.activeClient.id, function (response) {
        _this2.getClients();
        modals.hide("#status-modal");
        notify.loading(false);
      }).always(function () {
        notify.loading(false);
      });
    },

    activateClient: function activateClient() {
      var _this3 = this;

      notify.loading(true);
      this.$http.post("/api/client-settings-activate/" + this.activeClient.id, { password: this.password }, function (response) {
        _this3.getClients();
        _this3.password = '';
        modals.hide("#password-modal");
        notify.loading(false);
      }).always(function () {
        notify.loading(false);
      });
    },

    updatePassword: function updatePassword() {
      modals.showStrict("#password-modal");
    },

    sortBy: function sortBy(field, reverse, primer) {
      var key = primer ? function (x) {
        return primer(x[field]);
      } : function (x) {
        return x[field];
      };

      reverse = !reverse ? 1 : -1;

      return function (a, b) {
        return a = key(a), b = key(b), reverse * ((a > b) - (b > a));
      };
    },

    sortUsers: function sortUsers(field, reverse) {
      var primer = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];

      console.log(field);
      this.sortOrders = reverse;
      this.sortKey = field;
      this.employees.sort(this.sortBy(field, reverse, primer));
    },

    escapeRegExp: function escapeRegExp(str) {
      return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    },

    convertWildcardStringToRegExp: function convertWildcardStringToRegExp(expression) {
      var terms = expression.split('*');

      var trailingWildcard = false;

      var expr = '';
      for (var i = 0; i < terms.length; i++) {
        if (terms[i]) {
          if (i > 0 && terms[i - 1]) {
            expr += '.*';
          }
          trailingWildcard = false;
          expr += this.escapeRegExp(terms[i]);
        } else {
          trailingWildcard = true;
          expr += '.*';
        }
      }

      if (!trailingWildcard) {
        expr += '.*';
      }

      return new RegExp('^' + expr + '$', 'i');
    }
  }
};
module.exports = exports["default"];
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n  <div class=\"row\" _v-85888a94=\"\">\n    <div class=\"col-md-12 col-sm-12 no-padding-left no-padding-right\" _v-85888a94=\"\">\n      <div class=\"col-md-12 col-sm-12  no-padding-left no-padding-right\" _v-85888a94=\"\">\n        <table class=\"table table-xxs\" _v-85888a94=\"\">\n          <thead class=\"header custom-header\" _v-85888a94=\"\">\n          <tr class=\"bg-top-1\" _v-85888a94=\"\">\n            <th class=\"text-center text-black p-5 font-20 pl-10\" colspan=\"4\" _v-85888a94=\"\">\n              Employee Image Review Status\n            </th>\n          </tr>\n          <tr _v-85888a94=\"\">\n            <th class=\"text-left text-black\" _v-85888a94=\"\">Employee Name</th>\n            <th class=\"text-left text-black\" _v-85888a94=\"\">Status</th>\n            <th class=\"text-left text-black\" _v-85888a94=\"\">Reviewed By</th>\n            <th class=\"text-center text-black\" _v-85888a94=\"\"></th>\n          </tr>\n          </thead>\n          <tbody _v-85888a94=\"\">\n          <tr v-for=\"employee in employees\" _v-85888a94=\"\">\n            <td class=\"text-left cursor-pointer\" _v-85888a94=\"\">{{ employee.name }}</td>\n            <td class=\"text-left cursor-pointer\" _v-85888a94=\"\">\n              <span v-if=\"employee.status === 1\" class=\"text-black text-success\" _v-85888a94=\"\">Approved</span>\n              <span v-if=\"employee.status === 2\" class=\"text-black text-danger\" _v-85888a94=\"\">Rejected</span>\n            </td>\n            <td class=\"text-left cursor-pointer\" _v-85888a94=\"\">{{ employee.user_name }}</td>\n            <td class=\"text-center cursor-pointer text-black\" @click=\"updateStatusModal(employee)\" _v-85888a94=\"\"><span _v-85888a94=\"\">\n              View </span></td>\n          </tr>\n          </tbody>\n        </table>\n      </div>\n    </div>\n\n\n    <div id=\"status-modal\" aria-hidden=\"true\" aria-labelledby=\"exampleModalLabel\" class=\"modal fade\" role=\"dialog\" tabindex=\"-1\" _v-85888a94=\"\">\n      <div class=\"modal-dialog\" role=\"document\" _v-85888a94=\"\">\n        <div class=\"modal-content modal-grey\" _v-85888a94=\"\">\n          <div class=\"modal-header no-padding bg-slate-700\" _v-85888a94=\"\">\n            <div class=\"col-md-12 col-sm-12 col-xs-12 p-5 text-black text-left bg-top-1 font-16\" _v-85888a94=\"\">\n            </div>\n            <button aria-label=\"Close\" class=\"close close-modal\" data-dismiss=\"modal\" type=\"button\" _v-85888a94=\"\">\n              <span aria-hidden=\"true\" _v-85888a94=\"\">×</span>\n            </button>\n          </div>\n          <div class=\"modal-body\" _v-85888a94=\"\">\n\n            <img :src=\"activeEmployee.image_url\" class=\"img-responsive\" alt=\"\" width=\"500\" _v-85888a94=\"\">\n\n          </div>\n          <div class=\"modal-footer\" _v-85888a94=\"\">\n            <!--            <button class=\"btn btn-danger\" @click=\"updateImageStatus(0)\" type=\"button\">Reject</button>-->\n            <!--            <button class=\"btn btn-primary\" @click=\"updateImageStatus(1)\" type=\"button\">Approve</button>-->\n          </div>\n        </div>\n      </div>\n    </div>\n\n\n    <div id=\"password-modal\" aria-hidden=\"true\" aria-labelledby=\"exampleModalLabel\" class=\"modal fade\" role=\"dialog\" tabindex=\"-1\" _v-85888a94=\"\">\n      <div class=\"modal-dialog modal-sm-custom\" role=\"document\" _v-85888a94=\"\">\n        <div class=\"modal-content modal-grey\" _v-85888a94=\"\">\n          <div class=\"modal-header no-padding bg-slate-700\" _v-85888a94=\"\">\n            <div class=\"col-md-12 col-sm-12 col-xs-12 p-5 text-black text-left bg-top-1 font-16\" _v-85888a94=\"\"> Activate / Deactivate\n              Client\n            </div>\n            <button aria-label=\"Close\" class=\"close close-modal\" data-dismiss=\"modal\" type=\"button\" _v-85888a94=\"\">\n              <span aria-hidden=\"true\" _v-85888a94=\"\">×</span>\n            </button>\n          </div>\n          <div class=\"modal-body no-padding-left no-padding-right bg-top-4\" _v-85888a94=\"\">\n\n            <div class=\"col-md-12 p-5 font-16 text-center text-color-black bg-top-4 p-5\" _v-85888a94=\"\">\n              <div class=\"col-md-12 col-sm-12 text-right bg-top-4 text-color-black text-black text-center\" _v-85888a94=\"\">\n                {{ activeClient.name }}\n              </div>\n            </div>\n\n            <div class=\"col-md-12 p-5 font-16 text-center text-color-black bg-top-4 p-5\" _v-85888a94=\"\">\n              <div class=\"col-md-6 col-sm-6 text-center bg-top-4 text-color-black \" _v-85888a94=\"\">Status</div>\n              <div class=\"col-md-6 col-sm-6 text-center bg-top-4 text-color-black\" _v-85888a94=\"\"><span class=\"text-danger text-black\" _v-85888a94=\"\">No</span></div>\n            </div>\n\n            <div class=\"col-md-12 p-5 font-16 text-center text-color-black bg-top-4 p-5\" _v-85888a94=\"\">\n              <div class=\"col-md-6 col-sm-6 text-center bg-top-4 text-color-black \" _v-85888a94=\"\">Create Password</div>\n              <div class=\"col-md-6 col-sm-6 text-left bg-top-4 text-color-black\" _v-85888a94=\"\">\n                <input type=\"text\" class=\"form-control w-200\" v-model=\"password\" _v-85888a94=\"\">\n              </div>\n            </div>\n\n\n            <div class=\"col-md-12 p-5 font-16 text-center text-color-black bg-top-4 p-10\" _v-85888a94=\"\">\n              <div class=\"col-md-6 col-sm-6 text-center bg-top-4 text-color-black \" _v-85888a94=\"\"></div>\n              <div class=\"col-md-6 col-sm-6 text-left bg-top-4 text-color-black\" _v-85888a94=\"\">\n                <button class=\"btn btn-success border-2 border-white text-black w-200\" @click=\"activateClient()\" _v-85888a94=\"\">\n                  ACTIVATE\n                </button>\n              </div>\n            </div>\n\n          </div>\n          <div class=\"modal-footer no-padding-bottom\" _v-85888a94=\"\">\n            <!--            <button class=\"btn btn-secondary\" data-dismiss=\"modal\" type=\"button\">Close</button>-->\n            <!--            <button class=\"btn btn-primary\" type=\"button\">Save changes</button>-->\n          </div>\n        </div>\n      </div>\n    </div>\n\n\n  </div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  var id = "/home/shoieb/sites/elegant/resources/assets/js/vue/components/employee-image-review-processed.vue"
  module.hot.dispose(function () {
    require("vueify-insert-css").cache["\n.close-modal[_v-85888a94] {\n  font-size: 30px;\n  margin-top: -14.75px;\n  font-weight: 500;\n}\n\n.close-modal-29[_v-85888a94] {\n  font-size: 30px;\n  margin-top: -29.75px !important;\n  font-weight: 500;\n}\n\n.close-modal-0[_v-85888a94] {\n  font-size: 35px;\n  margin-top: 0 !important;\n  font-weight: 500;\n  z-index: 100;\n  color: #656565 !important;\n}\n\n.font-20[_v-85888a94] {\n  font-size: 20px;\n}\n\n.bg-slate-custom[_v-85888a94] {\n  background-color: #d6dce5;\n  border-color: #d6dce5;\n}\n\n.custom-header[_v-85888a94] {\n  position: -webkit-sticky;\n  position: sticky;\n  top: 48px;\n  z-index: 100;\n}\n\n.top-65[_v-85888a94] {\n  top: 65px;\n}\n\n.bg-top-1[_v-85888a94] {\n  background-color: #8497b0;\n  border-color: #8497b0;\n  color: #fff;\n}\n\n.bg-top-2[_v-85888a94] {\n  background-color: #adb9ca;\n  border-color: #adb9ca;\n  color: #fff;\n}\n\n.bg-top-3[_v-85888a94] {\n  background-color: #44546a;\n  border-color: #44546a;\n  color: #fff;\n}\n\n.bg-top-4[_v-85888a94] {\n  background-color: #d6dce5;\n  border-color: #d6dce5;\n  color: #fff;\n}\n\n[_v-85888a94]::-webkit-input-placeholder {\n  text-align: center;\n}\n\n[_v-85888a94]:-moz-placeholder { /* Firefox 18- */\n  text-align: center;\n}\n\n[_v-85888a94]::-moz-placeholder { /* Firefox 19+ */\n  text-align: center;\n}\n\n[_v-85888a94]:-ms-input-placeholder {\n  text-align: center;\n}\n\n.w-200[_v-85888a94] {\n  width: 200px !important;\n}\n\n@media (min-width: 769px) {\n  .modal-sm-custom[_v-85888a94] {\n    width: 500px;\n  }\n}\n\n\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, module.exports.template)
  }
})()}
},{"./../../mixed/modals":10,"./../../mixed/notify":11,"vue":5,"vue-hot-reload-api":4,"vueify-insert-css":6}],47:[function(require,module,exports){
var __vueify_style__ = require("vueify-insert-css").insert("\n.close-modal[_v-eb8c5496] {\n  font-size: 30px;\n  margin-top: -14.75px;\n  font-weight: 500;\n}\n\n.close-modal-29[_v-eb8c5496] {\n  font-size: 30px;\n  margin-top: -29.75px !important;\n  font-weight: 500;\n}\n\n.close-modal-0[_v-eb8c5496] {\n  font-size: 35px;\n  margin-top: 0 !important;\n  font-weight: 500;\n  z-index: 100;\n  color: #656565 !important;\n}\n\n.font-20[_v-eb8c5496] {\n  font-size: 20px;\n}\n\n.bg-slate-custom[_v-eb8c5496] {\n  background-color: #d6dce5;\n  border-color: #d6dce5;\n}\n\n.custom-header[_v-eb8c5496] {\n  position: -webkit-sticky;\n  position: sticky;\n  top: 48px;\n  z-index: 100;\n}\n\n.top-65[_v-eb8c5496] {\n  top: 65px;\n}\n\n.bg-top-1[_v-eb8c5496] {\n  background-color: #8497b0;\n  border-color: #8497b0;\n  color: #fff;\n}\n\n.bg-top-2[_v-eb8c5496] {\n  background-color: #adb9ca;\n  border-color: #adb9ca;\n  color: #fff;\n}\n\n.bg-top-3[_v-eb8c5496] {\n  background-color: #44546a;\n  border-color: #44546a;\n  color: #fff;\n}\n\n.bg-top-4[_v-eb8c5496] {\n  background-color: #d6dce5;\n  border-color: #d6dce5;\n  color: #fff;\n}\n\n[_v-eb8c5496]::-webkit-input-placeholder {\n  text-align: center;\n}\n\n[_v-eb8c5496]:-moz-placeholder { /* Firefox 18- */\n  text-align: center;\n}\n\n[_v-eb8c5496]::-moz-placeholder { /* Firefox 19+ */\n  text-align: center;\n}\n\n[_v-eb8c5496]:-ms-input-placeholder {\n  text-align: center;\n}\n\n.w-200[_v-eb8c5496] {\n  width: 200px !important;\n}\n\n@media (min-width: 769px) {\n  .modal-sm-custom[_v-eb8c5496] {\n    width: 500px;\n  }\n}\n\n\n")
"use strict";

exports.__esModule = true;
var modals = require("./../../mixed/modals");
var notify = require("./../../mixed/notify");

exports["default"] = {
  data: function data() {
    return {
      employees: {},
      searchedClients: {},
      activeEmployee: {},
      jobs: {},
      type: 0,
      availableJobs: {},
      selectedJObs: {},
      ids: [],
      query: '',
      password: ''
    };
  },
  props: ['user'],
  filters: {},
  watch: {
    'query': function query(val, oldVal) {
      var regex = this.convertWildcardStringToRegExp(val);
      this.searchedClients = this.clients.filter(function (item) {
        return regex.test(item.name);
      });
    }
  },
  ready: function ready() {
    this.getImageList();
  },

  events: {},

  methods: {

    getImageList: function getImageList() {
      var _this = this;

      notify.loading(true);
      this.$http.get("/api/employee-image-review-list", function (response) {
        _this.employees = response;
        notify.loading(false);
      }).always(function () {});
    },

    /**
     * show modal to update client time clock status
     * @param client
     */
    updateStatusModal: function updateStatusModal(employee) {
      this.activeEmployee = _.cloneDeep(employee);

      modals.showStrict("#status-modal");
    },

    updateImageStatus: function updateImageStatus(status) {
      var _this2 = this;

      notify.loading(true);
      this.$http.post("/api/employee-image-update/", {
        status: status,
        employee_id: this.activeEmployee.employee_id,
        image: this.activeEmployee.image,
        id: this.activeEmployee.id
      }, function (response) {
        _this2.getImageList();
        modals.hide("#status-modal");
        notify.loading(false);
      }).always(function () {
        notify.loading(false);
      });
    },

    deactivateClient: function deactivateClient() {
      var _this3 = this;

      notify.loading(true);
      this.$http.get("/api/client-settings-deactivate/" + this.activeClient.id, function (response) {
        _this3.getClients();
        modals.hide("#status-modal");
        notify.loading(false);
      }).always(function () {
        notify.loading(false);
      });
    },

    activateClient: function activateClient() {
      var _this4 = this;

      notify.loading(true);
      this.$http.post("/api/client-settings-activate/" + this.activeClient.id, { password: this.password }, function (response) {
        _this4.getClients();
        _this4.password = '';
        modals.hide("#password-modal");
        notify.loading(false);
      }).always(function () {
        notify.loading(false);
      });
    },

    updatePassword: function updatePassword() {
      modals.showStrict("#password-modal");
    },

    sortBy: function sortBy(field, reverse, primer) {
      var key = primer ? function (x) {
        return primer(x[field]);
      } : function (x) {
        return x[field];
      };

      reverse = !reverse ? 1 : -1;

      return function (a, b) {
        return a = key(a), b = key(b), reverse * ((a > b) - (b > a));
      };
    },

    sortUsers: function sortUsers(field, reverse) {
      var primer = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];

      console.log(field);
      this.sortOrders = reverse;
      this.sortKey = field;
      this.employees.sort(this.sortBy(field, reverse, primer));
    },

    escapeRegExp: function escapeRegExp(str) {
      return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    },

    convertWildcardStringToRegExp: function convertWildcardStringToRegExp(expression) {
      var terms = expression.split('*');

      var trailingWildcard = false;

      var expr = '';
      for (var i = 0; i < terms.length; i++) {
        if (terms[i]) {
          if (i > 0 && terms[i - 1]) {
            expr += '.*';
          }
          trailingWildcard = false;
          expr += this.escapeRegExp(terms[i]);
        } else {
          trailingWildcard = true;
          expr += '.*';
        }
      }

      if (!trailingWildcard) {
        expr += '.*';
      }

      return new RegExp('^' + expr + '$', 'i');
    }
  }
};
module.exports = exports["default"];
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n  <div class=\"row\" _v-eb8c5496=\"\">\n    <div class=\"col-md-12 col-sm-12 no-padding-left no-padding-right\" _v-eb8c5496=\"\">\n      <div class=\"col-md-12 col-sm-12  no-padding-left no-padding-right\" _v-eb8c5496=\"\">\n        <table class=\"table table-xxs\" _v-eb8c5496=\"\">\n          <thead class=\"header custom-header\" _v-eb8c5496=\"\">\n          <tr class=\"bg-top-1\" _v-eb8c5496=\"\">\n            <th class=\"text-center text-black p-5 font-20 pl-10\" colspan=\"2\" _v-eb8c5496=\"\">\n              Employee Image Review\n            </th>\n          </tr>\n          </thead>\n          <tbody _v-eb8c5496=\"\">\n          <tr v-for=\"employee in employees\" _v-eb8c5496=\"\">\n            <td class=\"text-left cursor-pointer\" @click=\"updateStatusModal(employee)\" _v-eb8c5496=\"\">{{ employee.name }}</td>\n            <td class=\"text-center cursor-pointer text-black\" @click=\"updateStatusModal(employee)\" _v-eb8c5496=\"\"><span _v-eb8c5496=\"\">\n              View </span></td>\n          </tr>\n          </tbody>\n        </table>\n      </div>\n    </div>\n\n\n    <div id=\"status-modal\" aria-hidden=\"true\" aria-labelledby=\"exampleModalLabel\" class=\"modal fade\" role=\"dialog\" tabindex=\"-1\" _v-eb8c5496=\"\">\n      <div class=\"modal-dialog\" role=\"document\" _v-eb8c5496=\"\">\n        <div class=\"modal-content modal-grey\" _v-eb8c5496=\"\">\n          <div class=\"modal-header no-padding bg-slate-700\" _v-eb8c5496=\"\">\n            <div class=\"col-md-12 col-sm-12 col-xs-12 p-5 text-black text-left bg-top-1 font-16\" _v-eb8c5496=\"\"> Review Image For\n              {{ activeEmployee.name }}\n            </div>\n            <button aria-label=\"Close\" class=\"close close-modal\" data-dismiss=\"modal\" type=\"button\" _v-eb8c5496=\"\">\n              <span aria-hidden=\"true\" _v-eb8c5496=\"\">×</span>\n            </button>\n          </div>\n          <div class=\"modal-body\" _v-eb8c5496=\"\">\n\n            <img :src=\"activeEmployee.image_url\" class=\"img-responsive\" alt=\"\" width=\"500\" _v-eb8c5496=\"\">\n\n          </div>\n          <div class=\"modal-footer\" _v-eb8c5496=\"\">\n            <button class=\"btn btn-danger\" @click=\"updateImageStatus(0)\" type=\"button\" _v-eb8c5496=\"\">Reject</button>\n            <button class=\"btn btn-primary\" @click=\"updateImageStatus(1)\" type=\"button\" _v-eb8c5496=\"\">Approve</button>\n          </div>\n        </div>\n      </div>\n    </div>\n\n\n    <div id=\"password-modal\" aria-hidden=\"true\" aria-labelledby=\"exampleModalLabel\" class=\"modal fade\" role=\"dialog\" tabindex=\"-1\" _v-eb8c5496=\"\">\n      <div class=\"modal-dialog modal-sm-custom\" role=\"document\" _v-eb8c5496=\"\">\n        <div class=\"modal-content modal-grey\" _v-eb8c5496=\"\">\n          <div class=\"modal-header no-padding bg-slate-700\" _v-eb8c5496=\"\">\n            <div class=\"col-md-12 col-sm-12 col-xs-12 p-5 text-black text-left bg-top-1 font-16\" _v-eb8c5496=\"\"> Activate / Deactivate\n              Client\n            </div>\n            <button aria-label=\"Close\" class=\"close close-modal\" data-dismiss=\"modal\" type=\"button\" _v-eb8c5496=\"\">\n              <span aria-hidden=\"true\" _v-eb8c5496=\"\">×</span>\n            </button>\n          </div>\n          <div class=\"modal-body no-padding-left no-padding-right bg-top-4\" _v-eb8c5496=\"\">\n\n            <div class=\"col-md-12 p-5 font-16 text-center text-color-black bg-top-4 p-5\" _v-eb8c5496=\"\">\n              <div class=\"col-md-12 col-sm-12 text-right bg-top-4 text-color-black text-black text-center\" _v-eb8c5496=\"\">\n                {{ activeClient.name }}\n              </div>\n            </div>\n\n            <div class=\"col-md-12 p-5 font-16 text-center text-color-black bg-top-4 p-5\" _v-eb8c5496=\"\">\n              <div class=\"col-md-6 col-sm-6 text-center bg-top-4 text-color-black \" _v-eb8c5496=\"\">Status</div>\n              <div class=\"col-md-6 col-sm-6 text-center bg-top-4 text-color-black\" _v-eb8c5496=\"\"><span class=\"text-danger text-black\" _v-eb8c5496=\"\">No</span></div>\n            </div>\n\n            <div class=\"col-md-12 p-5 font-16 text-center text-color-black bg-top-4 p-5\" _v-eb8c5496=\"\">\n              <div class=\"col-md-6 col-sm-6 text-center bg-top-4 text-color-black \" _v-eb8c5496=\"\">Create Password</div>\n              <div class=\"col-md-6 col-sm-6 text-left bg-top-4 text-color-black\" _v-eb8c5496=\"\">\n                <input type=\"text\" class=\"form-control w-200\" v-model=\"password\" _v-eb8c5496=\"\">\n              </div>\n            </div>\n\n\n            <div class=\"col-md-12 p-5 font-16 text-center text-color-black bg-top-4 p-10\" _v-eb8c5496=\"\">\n              <div class=\"col-md-6 col-sm-6 text-center bg-top-4 text-color-black \" _v-eb8c5496=\"\"></div>\n              <div class=\"col-md-6 col-sm-6 text-left bg-top-4 text-color-black\" _v-eb8c5496=\"\">\n                <button class=\"btn btn-success border-2 border-white text-black w-200\" @click=\"activateClient()\" _v-eb8c5496=\"\">\n                  ACTIVATE\n                </button>\n              </div>\n            </div>\n\n          </div>\n          <div class=\"modal-footer no-padding-bottom\" _v-eb8c5496=\"\">\n            <!--            <button class=\"btn btn-secondary\" data-dismiss=\"modal\" type=\"button\">Close</button>-->\n            <!--            <button class=\"btn btn-primary\" type=\"button\">Save changes</button>-->\n          </div>\n        </div>\n      </div>\n    </div>\n\n\n  </div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  var id = "/home/shoieb/sites/elegant/resources/assets/js/vue/components/employee-image-review.vue"
  module.hot.dispose(function () {
    require("vueify-insert-css").cache["\n.close-modal[_v-eb8c5496] {\n  font-size: 30px;\n  margin-top: -14.75px;\n  font-weight: 500;\n}\n\n.close-modal-29[_v-eb8c5496] {\n  font-size: 30px;\n  margin-top: -29.75px !important;\n  font-weight: 500;\n}\n\n.close-modal-0[_v-eb8c5496] {\n  font-size: 35px;\n  margin-top: 0 !important;\n  font-weight: 500;\n  z-index: 100;\n  color: #656565 !important;\n}\n\n.font-20[_v-eb8c5496] {\n  font-size: 20px;\n}\n\n.bg-slate-custom[_v-eb8c5496] {\n  background-color: #d6dce5;\n  border-color: #d6dce5;\n}\n\n.custom-header[_v-eb8c5496] {\n  position: -webkit-sticky;\n  position: sticky;\n  top: 48px;\n  z-index: 100;\n}\n\n.top-65[_v-eb8c5496] {\n  top: 65px;\n}\n\n.bg-top-1[_v-eb8c5496] {\n  background-color: #8497b0;\n  border-color: #8497b0;\n  color: #fff;\n}\n\n.bg-top-2[_v-eb8c5496] {\n  background-color: #adb9ca;\n  border-color: #adb9ca;\n  color: #fff;\n}\n\n.bg-top-3[_v-eb8c5496] {\n  background-color: #44546a;\n  border-color: #44546a;\n  color: #fff;\n}\n\n.bg-top-4[_v-eb8c5496] {\n  background-color: #d6dce5;\n  border-color: #d6dce5;\n  color: #fff;\n}\n\n[_v-eb8c5496]::-webkit-input-placeholder {\n  text-align: center;\n}\n\n[_v-eb8c5496]:-moz-placeholder { /* Firefox 18- */\n  text-align: center;\n}\n\n[_v-eb8c5496]::-moz-placeholder { /* Firefox 19+ */\n  text-align: center;\n}\n\n[_v-eb8c5496]:-ms-input-placeholder {\n  text-align: center;\n}\n\n.w-200[_v-eb8c5496] {\n  width: 200px !important;\n}\n\n@media (min-width: 769px) {\n  .modal-sm-custom[_v-eb8c5496] {\n    width: 500px;\n  }\n}\n\n\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, module.exports.template)
  }
})()}
},{"./../../mixed/modals":10,"./../../mixed/notify":11,"vue":5,"vue-hot-reload-api":4,"vueify-insert-css":6}],48:[function(require,module,exports){
"use strict";

exports.__esModule = true;
var modals = require("./../../mixed/modals");
var notify = require("./../../mixed/notify");

exports["default"] = {
    data: function data() {
        return {
            state: false,
            employee: {},
            statuses: {
                "Left VM": "LV",
                "Left Voice Mail": "LV",
                Answered: "ANSWERED",
                Called: "CALLED",
                Disc: "LD",
                "Hang Up": "HU",
                "Wrong No": "WN",
                "VM Full": "VF",
                "No VM": "NV",
                "delete": "DELETE",
                Call: "Call",
                Return: "Return",
                "Return-Apologetic": "RA",
                "Return-Bad Excuses": "RB",
                "Return-Don't Care": "RC",
                Apologetic: "A",
                "Bad Excuses": "B",
                "Don't Care": "C"
            },
            gradeStatus: ["Return", "Return-Apologetic", "Return-Bad Excuses", "Return-Don't Care", "Apologetic", "Bad Excuses", "Don't Care"]
        };
    },
    props: ["employeeId"],
    filters: {},
    watch: {},
    ready: function ready() {
        var _this = this;

        window.bus.$on("showEmployeePerformanceReport", function (id) {
            _this.getEmployeePerformanceData(id);
        });
    },
    events: {},
    methods: {
        /**
         * calculate call grading
         * @param log
         * @returns {*}
         */
        callLogGrading: function callLogGrading(log) {
            var onlyString = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];

            var responses = _.sortBy(_.cloneDeep(log), function (node) {
                return -new Date(node.created_at).getTime();
            });

            for (var i = 0; i < responses.length; i++) {
                if (this.gradeStatus.includes(responses[i].type)) {
                    if (onlyString) {
                        return this.statuses[responses[i].type];
                    } else {
                        return "<span class=\"text-danger-400\">" + this.statuses[responses[i].type] + "</span>";
                    }
                    break;
                }
            }
            return responses.length + "";
        },

        formatDate: function formatDate(date, from, format) {
            if (moment(date).isValid()) {
                return moment(date, from).format(format);
            } else {
                return "";
            }
        },

        monthName: function monthName() {
            var sub = arguments.length <= 0 || arguments[0] === undefined ? 0 : arguments[0];

            return moment().subtract(sub, "months").format("MMMM");
        },

        countOfferByDate: function countOfferByDate(month, d) {
            var _this2 = this;

            var orders = _.clone(this.employee.order_status_log);
            var day = (d + "").padStart(2, "0");

            var currentData = moment().format("YYYY") + "-" + moment().subtract(month, "months").format("MM") + "-" + day;

            var offersDate = orders.filter(function (order) {
                return order.order_date == currentData && order.status == "select";
            });

            var offersLength = offersDate.length > 0 ? offersDate.length : "";

            var ordersDate = orders.filter(function (order) {
                return order.order_date == currentData;
            });

            var noShow = ordersDate.filter(function (order) {
                return order.no_show == 1 && order.no_show_verified == 1;
            });

            if (noShow.length > 0) {
                var _ret = (function () {
                    var responseLogId = noShow[noShow.length - 1].id;
                    var dateOrderResponses = _this2.employee.no_show_verified.filter(function (val) {
                        return val.id == responseLogId;
                    })[0].order.responses;
                    var noShowString = _this2.callLogGrading(dateOrderResponses, true);
                    console.log(noShowString);
                    return {
                        v: "<div class='bg-danger text-center square-25 pt-3'>" + noShowString.substring(0, 1) + "</div>"
                    };
                })();

                if (typeof _ret === "object") return _ret.v;
            }

            var worked = ordersDate.filter(function (order) {
                return order.worked == 1;
            });

            if (worked.length > 0) {
                return "<div class='bg-green text-center square-25'></div>";
            }

            var offered = ordersDate.filter(function (order) {
                return order.status == "select";
            });

            if (offered.length > 0) {
                return "<div class='bg-slate-300-light text-center square-25 pt-2'>" + offersLength + "</div>";
            }
        },

        getEmployeePerformanceData: function getEmployeePerformanceData(id) {
            var _this3 = this;

            notify.loading(true);
            this.$http.get("/api/employee-performance-data/" + id, function (response) {
                _this3.employee = response;
                $(".performance-nav li").removeClass("active");
                $("#page-2").removeClass("active");
                $("#page-1-li").addClass("active");
                $("#page-1").addClass("active");
                _this3.$nextTick(function () {
                    $('[data-popup="popover"]').popover();
                });
                modals.showStrict("#employee-performance-chart");
            }).always(function () {
                notify.loading(false);
            });
        }
    }
};
module.exports = exports["default"];
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n    <div class=\"row\">\n        <div class=\"modal fade\" id=\"employee-performance-chart\">\n            <div class=\"modal-dialog modal-full\">\n                <div class=\"modal-content\">\n                    <div class=\"modal-header text-right\">\n                        <button class=\"text-black text-color-black close\" type=\"button\" data-dismiss=\"modal\" aria-hidden=\"true\">×\n                        </button>\n                    </div>\n                    <div class=\"modal-body\">\n                        <div class=\"col-md-12\">\n                            <div class=\"tabbable\">\n                                <ul class=\"nav nav-tabs nav-tabs-solid nav-justified performance-nav\">\n                                    <li class=\"active\" id=\"page-1-li\"><a href=\"#page-1\" data-toggle=\"tab\">Page 1</a></li>\n                                    <li><a href=\"#page-2\" data-toggle=\"tab\">Page 2</a></li>\n                                </ul>\n\n                                <div class=\"tab-content\">\n                                    <div class=\"tab-pane active\" id=\"page-1\">\n                                        <h4 class=\"no-margin text-semibold text-center bg-slate-300 text-color-black\">PERFORMANCE CHART</h4>\n                                        <table class=\"table table-xss table-chart\">\n                                            <tbody>\n                                            <tr class=\"bg-slate-800\">\n                                                <td class=\"bg-slate-800 no-padding-left no-padding-right\"></td>\n                                                <td v-for=\"(index,day) in 31\" class=\"bg-slate-800 no-padding-left no-padding-right text-center\" :key=\"index\">\n                                                    <div class=\"square-25 pt-2\">{{ day+1 }}</div>\n                                                </td>\n                                            </tr>\n                                            <tr>\n                                                <td class=\"bg-slate-800 text-center\">{{ monthName(3) }}</td>\n                                                <td v-for=\"(index,day) in 31\" :key=\"index\">\n                                                    {{{ countOfferByDate(3,day+1) }}}\n                                                </td>\n                                            </tr>\n                                            <tr>\n                                                <td class=\"bg-slate-800 text-center\">{{ monthName(2) }}</td>\n                                                <td v-for=\"(index,day) in 31\" :key=\"index\">\n                                                    {{{ countOfferByDate(2,day+1) }}}\n                                                </td>\n                                            </tr>\n                                            <tr>\n                                                <td class=\"bg-slate-800 text-center\">{{ monthName(1) }}</td>\n                                                <td v-for=\"(index,day) in 31\" :key=\"index\">\n                                                    {{{ countOfferByDate(1,day+1) }}}\n                                                </td>\n                                            </tr>\n                                            <tr>\n                                                <td class=\"bg-slate-800 text-center\">{{ monthName(0) }}</td>\n                                                <td v-for=\"(index,day) in 31\" :key=\"index\">\n                                                    {{{ countOfferByDate(0,day+1) }}}\n                                                </td>\n                                            </tr>\n                                            </tbody>\n                                        </table>\n                                        <h4 class=\"no-margin text-semibold text-center\">ATTANDANCE RECORDS</h4>\n                                        <table class=\"table table-xxs\">\n                                            <tbody>\n                                            <tr>\n                                                <td class=\"text-center bg-slate-300\">NAME</td>\n                                                <td class=\"text-center\">{{ employee.name }}</td>\n                                                <td class=\"text-center bg-slate-300\"></td>\n                                                <td class=\"text-center bg-slate-300\">Last 90 Days</td>\n                                                <td class=\"text-center bg-slate-300\">Last 365 Days</td>\n                                                <td class=\"text-center bg-slate-300\">Life Time</td>\n                                            </tr>\n                                            <tr>\n                                                <td class=\"text-center bg-slate-300\">G.A.R</td>\n                                                <td class=\"text-center\">{{ employee.gar }}</td>\n                                                <td class=\" text-center bg-slate-300\">JOB OFFERED(Total)</td>\n                                                <td class=\"text-center\">{{ employee.jo_ninety_count }}</td>\n                                                <td class=\"text-center\">{{ employee.jo_one_year_count }}</td>\n                                                <td class=\"text-center\">{{ employee.jo_full_count }}</td>\n                                            </tr>\n                                            <tr>\n                                                <td class=\"text-center bg-slate-300\">Phone 1</td>\n                                                <td class=\"text-center\"> {{ employee.primary_phone }}</td>\n                                                <td class=\"text-center bg-slate-300\">JOB OFFERED(Days)</td>\n                                                <td class=\"text-center\">{{ employee.jo_ninety_days }}</td>\n                                                <td class=\"text-center\">{{ employee.jo_one_year_days }}</td>\n                                                <td class=\"text-center\">{{ employee.jo_full_days }}</td>\n                                            </tr>\n                                            <tr>\n                                                <td class=\"text-center bg-slate-300\">Phone 2</td>\n                                                <td class=\"text-center\">{{ employee.secondary_phone }}</td>\n                                                <td class=\"text-center bg-slate-300\">RE CONFIRMED</td>\n                                                <td class=\"text-center\">{{ employee.re_confirmed_ninety_count }}</td>\n                                                <td class=\"text-center\">{{ employee.re_confirmed_one_year_count }}</td>\n                                                <td class=\"text-center\">{{ employee.re_confirmed_full_count }}</td>\n                                            </tr>\n                                            <tr>\n                                                <td class=\"text-center bg-slate-300\">Email</td>\n                                                <td class=\"text-center\">{{ employee.email }}</td>\n                                                <td class=\"text-center bg-slate-300\">SHIFT WORKED</td>\n                                                <td class=\"text-center\">{{ employee.worked_ninety_count }}</td>\n                                                <td class=\"text-center\">{{ employee.worked_one_year_count }}</td>\n                                                <td class=\"text-center\">{{ employee.worked_full_count }}</td>\n                                            </tr>\n                                            <tr>\n                                                <td class=\"text-center bg-slate-300\">Hire Date</td>\n                                                <td class=\"text-center\">{{ employee.hire_date | customDateFormat 'YYYY-MM-DD HH:mm:ss' 'MMM DD, YYYY'}}</td>\n                                                <td class=\"text-center bg-slate-300\">CALL OUT</td>\n                                                <td class=\"text-center\">{{ employee.call_out_ninety_count }}</td>\n                                                <td class=\"text-center\">{{ employee.call_out_one_year_count }}</td>\n                                                <td class=\"text-center\">{{ employee.call_out_full_count }}</td>\n                                            </tr>\n                                            <tr>\n                                                <td class=\"text-center\"></td>\n                                                <td class=\"text-center\"></td>\n                                                <td class=\"text-center bg-slate-300\">NO SHOW</td>\n                                                <td class=\"text-center\">{{ employee.no_show_ninety_count }}</td>\n                                                <td class=\"text-center\">{{ employee.no_show_one_year_count }}</td>\n                                                <td class=\"text-center\">{{ employee.no_show_full_count }}</td>\n                                            </tr>\n                                            </tbody>\n                                        </table>\n                                    </div>\n\n                                    <div class=\"tab-pane\" id=\"page-2\">\n                                        <h4 class=\"no-margin text-semibold text-center bg-slate-300 text-color-black\">COMMUNICATION SUMMARY</h4>\n                                        <table class=\"table table-xxs\">\n                                            <thead>\n                                            <tr>\n                                                <th class=\"bg-slate-800 text-left\">DATE</th>\n                                                <th class=\"bg-slate-800 text-center\">SOURCE</th>\n                                                <th class=\"bg-slate-800 text-center\">DETAILS</th>\n                                                <th class=\"bg-slate-800 text-center\">GRADE</th>\n                                                <th class=\"bg-slate-800 text-center\">1st</th>\n                                                <th class=\"bg-slate-800 text-center\">2nd</th>\n                                                <th class=\"bg-slate-800 text-center\">3rd</th>\n                                                <th class=\"bg-slate-800 text-center\">4th</th>\n                                                <th class=\"bg-slate-800 text-center\">Note</th>\n                                            </tr>\n                                            </thead>\n                                            <tbody>\n                                            <tr v-for=\"(index,noShow) in employee.no_show_verified\" :key=\"index\">\n                                                <td class=\"text-left\"> {{ formatDate(noShow.updated_at,'YYYY-MM-DD HH:mm:ss','D/M/YYYY') }}</td>\n                                                <td class=\"text-center\">NO SHOW</td>\n                                                <td class=\"text-center\">\n                                                    {{ noShow.order.client.company_code+' '+noShow.order.position.title+' '}}\n                                                    {{ formatDate(noShow.order.date,'YYYY-MM-DD','D/M/YYYY') }}\n                                                </td>\n                                                <td class=\"text-center\">\n                                                    {{{ callLogGrading(noShow.order.responses) }}}\n                                                </td>\n                                                <td class=\"text-center\">\n                                                    {{ formatDate(noShow.order.responses[0].created_at,'YYYY-MM-DD HH:mm:ss','D-M-YYYY') }} -\n                                                    <span class=\"text-danger-400\">{{ statuses[noShow.order.responses[0].type] }}</span>\n                                                </td>\n                                                <td class=\"text-center\">\n                                                    {{ formatDate(noShow.order.responses[1].created_at,'YYYY-MM-DD HH:mm:ss','D-M-YYYY') }} -\n                                                    <span class=\"text-danger-400\">{{ statuses[noShow.order.responses[1].type] }}</span>\n                                                </td>\n                                                <td class=\"text-center\">\n                                                    {{ formatDate(noShow.order.responses[2].created_at,'YYYY-MM-DD HH:mm:ss','D-M-YYYY') }} -\n                                                    <span class=\"text-danger-400\">{{ statuses[noShow.order.responses[2].type] }}</span>\n                                                </td>\n                                                <td class=\"text-center\">\n                                                    {{ formatDate(noShow.order.responses[3].created_at,'YYYY-MM-DD HH:mm:ss','D-M-YYYY') }} -\n                                                    <span class=\"text-danger-400\">{{ statuses[noShow.order.responses[3].type] }}</span>\n                                                </td>\n                                                <td class=\"text-center\">\n                                                    <button v-if=\"noShow.note\" type=\"button\" class=\"btn btn-default btn-sm\" data-html=\"true\" data-popup=\"popover\" data-title=\"\" data-trigger=\"hover\" :data-content=\"noShow.note | formatNote\"><i class=\"icon-notebook position-right\"></i></button>\n                                                </td>\n                                            </tr>\n                                            <tr>\n                                                <td class=\"text-left\">Profile Comments</td>\n                                                <td colspan=\"7\">{{ employee.comments }}</td>\n                                            </tr>\n                                            <tr>\n                                                <td class=\"text-left\">Dashboard Comments</td>\n                                                <td colspan=\"7\">\n                                                    <blockquote class=\"no-margin\" v-for=\"(index,comment) in employee.dashboard_comments\" :key=\"index\">\n                                                        {{ comment.note }}\n                                                        <footer><cite title=\"Source Title\">{{ comment.user.name }} -\n                                                            {{ formatDate(comment.created_at,'YYYY-MM-DD HH:mm:ss','D-M-YYYY') }}\n                                                        </cite></footer>\n                                                    </blockquote>\n                                                </td>\n                                            </tr>\n                                            </tbody>\n                                        </table>\n                                    </div>\n\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"modal-footer\">\n                        <!--<button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button>-->\n                    </div>\n                </div><!-- /.modal-content -->\n            </div><!-- /.modal-dialog -->\n        </div><!-- /.modal -->\n    </div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  var id = "/home/shoieb/sites/elegant/resources/assets/js/vue/components/employee-performance-data.vue"
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, module.exports.template)
  }
})()}
},{"./../../mixed/modals":10,"./../../mixed/notify":11,"vue":5,"vue-hot-reload-api":4}],49:[function(require,module,exports){
var __vueify_style__ = require("vueify-insert-css").insert("\nthead.report-header {\n  max-width: 99% !important;\n}\n\n.fixed_header_report tbody {\n  display: block;\n  max-height: 700px;\n  overflow-y: scroll;\n}\n\n.fixed_header_report thead,\ntbody.fixed_body_report tr {\n  display: table;\n  width: 100%;\n  table-layout: fixed;\n}\n\ntable.fixed_header_report thead {\n  background-color: #eaeaea;\n}\n\ntable.fixed_header_report tbody {\n  background-color: #fcfcfc;\n}\n")
"use strict";

exports.__esModule = true;
var modals = require("./../../mixed/modals");
var notify = require("./../../mixed/notify");
var shifts = {
  U: 3,
  "A+": 6,
  A: 5,
  B: 2,
  C: 1
};

var priority = {
  U: 0,
  "A+": 6,
  A: 5,
  B: 0,
  C: 0
};
exports["default"] = {
  data: function data() {
    return {
      state: false,
      employees: {},
      employee: {},
      activeEmployee: {},
      positions: {},
      types: ["A+", "A", "U", "B", "C"],
      actions: 0,
      sortOrders: true,
      sortKey: "action",
      perPage: 100,
      page: 1,
      sortOrder: false,
      sortField: 'actions',
      totalPages: '',
      pagination: {},
      filterGroup: '1-6',
      filter: ''
    };
  },
  filters: {},
  watch: {
    'filterGroup': function filterGroup() {
      this.getEmployeeReport();
    }
  },
  //   'filter':function(){
  //     this.getEmployeeReport();
  //   }
  ready: function ready() {
    var _this = this;

    //$(".table").fixedHeader();
    this.getEmployeeReport();
    $('#positions-modal').on('hidden.bs.modal', function () {
      // this.fetchPendingOrders();
      _this.positions = {};
    });
  },
  events: {},
  methods: {
    filterEmployee: function filterEmployee() {
      this.getEmployeeReport();
    },
    showPerformanceReport: function showPerformanceReport(employee) {
      window.bus.$emit("showEmployeePerformanceReport", employee.id);
    },

    showPositions: function showPositions(employee) {
      var _this2 = this;

      var showModal = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];

      notify.loading(true);
      this.$http.get("/api/employee-positions-report/" + employee.id, function (response) {
        _this2.activeEmployee = response.employee;
        _this2.positions = response.positions;
        if (showModal) {
          modals.showStrict("#positions-modal");
        }
      }).always(function () {
        notify.loading(false);
      });
    },

    saveEmployeePositions: function saveEmployeePositions() {
      notify.loading(true);
      this.$http.put("/api/employee-positions-report/" + this.activeEmployee.id, {
        data: this.positions
      }, function (response) {
        //modals.hide("#positions-modal");
        //this.showPositions(this.activeEmployee, false);
        notify.success("Position data updated");
      }).always(function () {
        notify.loading(false);
      });
    },
    /**
     * get employee report data
     */
    getEmployeeReport: function getEmployeeReport() {
      var _this3 = this;

      notify.loading(true);
      this.$http.get("/api/employee-report-data?filter=" + this.filter + "&group=" + this.filterGroup + "&actions=" + this.actions + "&per_page=" + this.perPage + "&page=" + this.page + "&sortOrder=" + (this.sortOrder ? 'asc' : 'desc') + "&sortField=" + this.sortField, function (response) {
        _this3.pagination = response;
        _this3.employees = response.data;
      }).always(function () {
        notify.loading(false);
      });
    },

    changePage: function changePage(currentPage) {
      this.page = currentPage;
      this.getEmployeeReport();
    },

    sortByAction: function sortByAction(action) {
      this.actions = action;
      this.getEmployeeReport();
    },

    /**
     * show modal to update employess data
     */
    editEmployeeModal: function editEmployeeModal(employee) {
      this.employee = _.cloneDeep(employee);
      modals.showStrict("#modal-edit-employee-info");
    },

    /**
     * send request to update employee data and refresh the list
     */
    editEmployee: function editEmployee() {
      var _this4 = this;

      this.state = true;
      this.$http.patch("/api/update-employee-report/" + this.employee.id, this.employee, function (response) {
        modals.hide("#modal-edit-employee-info");
        _this4.getEmployeeReport();
      }).always(function () {
        _this4.state = false;
      });
    },

    /**
     * calculate shift required with given chart
     */
    calculateShiftRequired: function calculateShiftRequired(employee) {
      if (employee.shift_required < shifts[employee.reliability]) {
        return "bg-success-new";
      } else if (employee.shift_required > shifts[employee.reliability]) {
        return "bg-magenta";
      } else {
        return "";
      }
    },

    /**
     * calculate priority with given chart
     */
    calculatePriority: function calculatePriority(employee) {
      var priorityLength = employee.employee_a_b_c.length;
      if (employee.reliability === "U" || employee.reliability === "C") {
        return priorityLength > 0 ? "bg-magenta" : "";
      } else if (employee.reliability === "B") {
        return priorityLength >= 0 && priorityLength <= 4 ? "" : "bg-magenta";
      } else if (employee.reliability === "A+") {
        if (priorityLength <= 5) {
          return "bg-success";
        } else if (priorityLength > 10) {
          return "bg-magenta";
        } else {
          return "normal";
        }
      } else {
        if (priorityLength <= 4) {
          return "bg-success-new";
        } else if (priorityLength > 8) {
          return "bg-magenta";
        } else {
          return "normal";
        }
      }
    },

    /**
     * calcualte job offered with given chart
     */
    calculateJobOffered: function calculateJobOffered(jo, confirmed, reConfirmed) {
      if (jo >= 10 && jo < 20 && confirmed === 0 && reConfirmed === 0) {
        return "bg-indigo";
      } else if (jo >= 20 && confirmed === 0 && reConfirmed === 0) {
        return "bg-danger";
      } else {
        return "normal";
      }
    },

    /**
     * calculation for an employee on for how many client that employee is in priority list
     */
    clientPriority: function clientPriority(employeePriority) {
      var priorities = _.groupBy(employeePriority, function (emp) {
        return emp.client_id;
      });
      if (this.isEmpty(priorities)) {
        return 0;
      } else {
        return this.countProperties(priorities);
      }
    },

    /**
     * calculate score of an employee
     * @argument confirmed
     * @argument reConfirmed
     * @argument worked
     * @argument callOut
     * @argument noShow
     */
    calculateEmployeeScore: function calculateEmployeeScore(confirmed, reConfirmed, worked, callOut, noShow) {
      var score = new Array();
      var rc = Number(reConfirmed);
      if (rc < 1) {
        return "U";
      } else {
        var c = Number(confirmed) * 100 / rc;
        var w = Number(worked) * 100 / rc;
        var co = Number(callOut) * 100 / rc;
        var ns = Number(noShow) * 100 / rc;
        if (w >= 90 && ns <= 5) {
          score.push("A+");
        }
        if (w >= 80 && ns <= 0) {
          score.push("A");
        }
        if (w >= 60 && ns <= 20) {
          score.push("B");
        }
        if (w >= 50 && ns <= 40) {
          score.push("C");
        }
        return score.length ? score[0] : "U";
      }
    },

    /**
     * check if an object is empty
     */
    isEmpty: function isEmpty(obj) {
      for (var key in obj) {
        if (obj.hasOwnProperty(key)) return false;
      }
      return true;
    },

    /**
     * count no. of properties an object has
     */
    countProperties: function countProperties(obj) {
      var count = 0;
      for (var property in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, property)) {
          count++;
        }
      }
      return count;
    },

    sortBy: function sortBy(field, reverse, primer) {
      var key = primer ? function (x) {
        return primer(x[field]);
      } : function (x) {
        return x[field];
      };

      reverse = !reverse ? 1 : -1;

      return function (a, b) {
        return a = key(a), b = key(b), reverse * ((a > b) - (b > a));
      };
    },

    sortEmployees: function sortEmployees(field, order) {
      var primer = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];

      this.sortField = field;
      this.sortOrder = order;
      this.getEmployeeReport();
    }

  }
};
module.exports = exports["default"];
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n  <div class=\"row\">\n\n    <div class=\"col-md-12 p-10\">\n      <div class=\"col-md-6\">\n        <h4 class=\"no-margin text-semibold text-left\">EMPLOYEE PERFORMANCE REPORT</h4>\n      </div>\n      <div class=\"col-md-3\">\n        <select class=\"form-control select\" name=\"role\" v-model=\"filterGroup\" v-select2=\"filterGroup\">\n          <option value=\"1-6\">1-6</option>\n          <option value=\"7-9\">7-9</option>\n          <option value=\"1-9\">All</option>\n        </select>\n      </div>\n      <div class=\"col-md-3\">\n        <input @keyup.enter=\"filterEmployee()\" class=\"form-control\" type=\"text\" v-model=\"filter\">\n      </div>\n    </div>\n    <div class=\"col-md-12 no-padding mb-20\">\n      <div class=\"table-responsive\">\n        <table class=\"table table-xxs table-bordered fixed_header_report \">\n          <thead class=\"header report-header\">\n          <tr>\n            <th class=\"bg-slate-700 text-center\" rowspan=\"2\">\n              P.Chart\n            </th>\n            <th @click=\"sortEmployees('employees.status',!sortOrder)\" class=\"bg-slate-700 text-center cursor-pointer\" rowspan=\"2\">\n              Status <i :class=\"sortOrder ? 'fa fa-arrow-down':'fa fa-arrow-up'\" v-if=\"sortField === 'employees.status'\"></i>\n            </th>\n            <th @click=\"sortEmployees('grooming',!sortOrder)\" class=\"bg-slate-700 text-center cursor-pointer\" rowspan=\"2\">\n              G.A.R <i :class=\"sortOrder ? 'fa fa-arrow-down':'fa fa-arrow-up'\" v-if=\"sortField === 'grooming'\"></i>\n            </th>\n            <th @click=\"sortEmployees('first_name',!sortOrder)\" class=\"bg-slate-700 text-center  cursor-pointer\" rowspan=\"2\" width=\"10%\">\n              Employee Name <i :class=\"sortOrder ? 'fa fa-arrow-down':'fa fa-arrow-up'\" v-if=\"sortField === 'first_name'\"></i>\n            </th>\n            <th class=\"bg-danger-600 text-center\" colspan=\"6\">Attendance</th>\n            <th @click=\"sortEmployees('score',!sortOrder)\" class=\"bg-indigo-400 text-center cursor-pointer\" rowspan=\"2\">\n              Score <i :class=\"sortOrder ? 'fa fa-arrow-down':'fa fa-arrow-up'\" v-if=\"sortField === 'score'\"></i>\n            </th>\n            <th class=\"bg-danger-600 text-center\" colspan=\"2\">Review</th>\n            <th @click=\"sortEmployees('shift_required',!sortOrder)\" class=\"bg-indigo-400 text-center  cursor-pointer\" rowspan=\"2\">Shift Required <i :class=\"sortOrder ? 'fa fa-arrow-down':'fa fa-arrow-up'\" v-if=\"sortField === 'shift_required'\"></i></th>\n            <th @click=\"sortEmployees('max_hours',!sortOrder)\" class=\"bg-indigo-400 text-center cursor-pointer\" rowspan=\"2\">Max Hours <i :class=\"sortOrder ? 'fa fa-arrow-down':'fa fa-arrow-up'\" v-if=\"sortField === 'max_hours'\"></i>\n            </th>\n            <th class=\"bg-indigo-400 text-center\" rowspan=\"2\">X Client</th>\n            <th class=\"bg-indigo-400 text-center\" rowspan=\"2\">Priority List</th>\n            <th @click=\"sortEmployees('actions',!sortOrder)\" class=\"bg-indigo-400 text-center cursor-pointer\" rowspan=\"2\">Positions <i :class=\"sortOrder ? 'fa fa-arrow-down':'fa fa-arrow-up'\" v-if=\"sortField === 'actions'\"></i></th>\n          </tr>\n          <tr>\n            <th class=\"bg-black-center text-center\">JO\n            </th>\n            <th class=\"bg-black-center text-center\">\n              RC\n            </th>\n            <th class=\"bg-black-center text-center\">W\n            </th>\n            <th class=\"bg-black-center text-center\">\n              DR\n            </th>\n            <th class=\"bg-black-center text-center\">CO</th>\n            <th class=\"bg-black-center text-center\">NS\n            </th>\n            <th class=\"bg-black-center text-center\">Good</th>\n            <th class=\"bg-black-center text-center\">Bad</th>\n          </tr>\n          </thead>\n          <tbody class=\"fixed_body_report\">\n          <tr :key=\"index\" v-for=\"(index,employee) in employees\">\n            <td class=\"text-center text-blue cursor-pointer\">\n              <button @click=\"showPerformanceReport(employee)\" class=\"btn btn-primary\">P.Chart\n              </button>\n            </td>\n            <td class=\"text-center\"> {{ employee.status }}</td>\n            <td class=\"text-center\">{{ employee.grooming + employee.attitude + employee.reliability }}</td>\n            <td @click=\"editEmployeeModal(employee)\" class=\"text-center text-blue cursor-pointer\" width=\"10%\">{{\n                employee.fullName\n              }}\n            </td>\n            <td :class=\"calculateJobOffered(employee.jo_half_year_count,employee.confirmed_half_year.length,employee.re_confirmed_half_year_count)\" class=\"text-center\">\n              <span class=\"text-bold display-block\">{{ employee.jo_half_year_count }}</span>\n              <!-- <span class=\"text-bold text-grey-300\">{{ employee.jo_one_year_count }}</span> -->\n            </td>\n            <td class=\"text-center\">\n              <span class=\"text-bold display-block\">{{ employee.re_confirmed_half_year_count }}</span>\n              <!-- <span class=\"text-bold text-grey-300\">{{ employee.re_confirmed_one_year_count }}</span> -->\n            </td>\n            <td class=\"text-center\">\n              <span class=\"text-bold display-block\">{{ employee.worked_half_year_count }}</span>\n              <!-- <span class=\"text-bold text-grey-300\">{{ employee.worked_one_year_count }}</span> -->\n            </td>\n            <td class=\"text-center\">\n              <span class=\"text-bold display-block\">{{ employee.did_not_re_confirm_half_year_count }}</span>\n              <!-- <span class=\"text-bold text-grey-300\">{{ employee.confirmed_one_year_count }}</span> -->\n            </td>\n            <td class=\"text-center\">\n              <span class=\"text-bold display-block\">{{ employee.call_out_half_year_count }}</span>\n              <!-- <span class=\"text-bold text-grey-300\">{{ employee.call_out_one_year_count }}</span> -->\n            </td>\n            <td class=\"text-center\">\n              <span class=\"text-bold display-block\">{{ employee.no_show_half_year_count }}</span>\n              <!-- <span class=\"text-bold text-grey-300\">{{ employee.no_show_one_year_count }}</span> -->\n            </td>\n            <td :class=\"[\n                                                            employee.preffered_reliability < types.indexOf(employee.reliability) ? 'bg-success-new':'',\n                                                            employee.preffered_reliability > types.indexOf(employee.reliability) ? 'bg-magenta':''\n                                                            ]\" class=\"text-center\">{{ employee.score }}\n            </td>\n            <td class=\"text-center\"></td>\n            <td class=\"text-center\"></td>\n            <td :class=\"employee.shift_required_class\" class=\"text-center\">{{ employee.shift_required }}\n            </td>\n            <td :class=\"employee.max_hours_class\" class=\"text-center\">{{ employee.max_hours }}</td>\n            <td class=\"text-center\">\n              <span class=\"text-bold display-block\">{{ employee.client_x_count }}</span>\n            </td>\n            <td class=\"text-center\">\n              <span class=\"text-bold text-danger-300 display-block\">{{ employee.abc }}</span>\n            </td>\n            <td class=\"text-center\">\n              <button :class=\"[ employee.action? 'btn-info':'']\" @click=\"showPositions(employee)\" class=\"btn\">Positions\n              </button>\n            </td>\n          </tr>\n          </tbody>\n        </table>\n\n        <ul class=\"pagination pt-20 pb-10 pull-right pr-10\">\n          <li v-if=\"pagination.current_page > 1\">\n            <a aria-label=\"Previous\" href=\"javascript:void(0)\" v-on:click.prevent=\"changePage(pagination.current_page - 1)\">\n              <span aria-hidden=\"true\">«</span>\n            </a>\n          </li>\n          <li :class=\"{'active': page == pagination.current_page}\" :key=\"key\" v-for=\"(key,page) in pagination.totalPages\">\n            <a href=\"javascript:void(0)\" v-on:click.prevent=\"changePage(page)\">{{ page }}</a>\n          </li>\n          <li v-if=\"pagination.current_page < pagination.last_page\">\n            <a aria-label=\"Next\" href=\"javascript:void(0)\" v-on:click.prevent=\"changePage(pagination.current_page + 1)\">\n              <span aria-hidden=\"true\">»</span>\n            </a>\n          </li>\n        </ul>\n      </div>\n    </div>\n\n    <div class=\"modal fade\" id=\"modal-edit-employee-info\">\n      <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n          <div class=\"modal-header\">\n            <button aria-hidden=\"true\" class=\"close\" data-dismiss=\"modal\" type=\"button\">Cancel</button>\n          </div>\n          <div class=\"modal-body\">\n            <form action=\"#\">\n              <div class=\"col-md-12\">\n                <div class=\"panel panel-flat\">\n                  <div class=\"panel-body\">\n                    <fieldset>\n                      <legend class=\"text-semibold\">{{ employee.fullName }} - Update Information\n                      </legend>\n                      <div class=\"row mb-20\">\n                        <div class=\"col-md-4\">\n                          <label>Grooming:</label>\n                          <select class=\"form-control\" name=\"grooming\" v-model=\"employee.grooming\">\n                            <option value=\"\">Select An Option</option>\n                            <option :key=\"index\" :value=\"type\" v-for=\"(index,type) in types\">{{ type }}\n                            </option>\n                          </select>\n                        </div>\n                        <div class=\"col-md-4\">\n                          <label>Attitude:</label>\n                          <select class=\"form-control\" name=\"grooming\" v-model=\"employee.attitude\">\n                            <option value=\"\">Select An Option</option>\n                            <option :key=\"index\" :value=\"type\" v-for=\"(index,type) in types\">{{ type }}\n                            </option>\n                          </select>\n                        </div>\n                        <div class=\"col-md-4\">\n                          <label>Reliabilty:</label>\n                          <select :class=\"[\n                                                            employee.preffered_reliability < types.indexOf(employee.reliability) ? 'bg-success-new':'',\n                                                            employee.preffered_reliability > types.indexOf(employee.reliability) ? 'bg-magenta':''\n                                                            ]\" class=\"form-control\" name=\"grooming\" v-model=\"employee.reliability\">\n                            <option value=\"\">Select An Option</option>\n                            <option :key=\"index\" :value=\"type\" v-for=\"(index,type) in types\">{{ type }}\n                            </option>\n                          </select>\n                        </div>\n                      </div>\n                      <div class=\"row\">\n                        <div class=\"col-md-4\">\n                          <div class=\"form-group\">\n                            <label>Status:</label>\n                            <select class=\"form-control\" name=\"status\" v-model=\"employee.status\">\n                              <option value=\"Watch List\">Watch List</option>\n                              <option value=\"Active\">Active</option>\n                              <option value=\"Inactive\">Inactive</option>\n                              <option value=\"Quit\">Quit</option>\n                              <option value=\"Terminated\">Terminated</option>\n                              <option value=\"Suspended\">Suspended</option>\n                            </select>\n                          </div>\n                        </div>\n                        <div class=\"col-md-4\">\n                          <label>Shift Required:</label>\n                          <input :class=\"[\n                                                           employee.shift_required > employee.preffered_shift_required[1] ? 'bg-magenta':'',\n                                                           employee.shift_required < employee.preffered_shift_required[0] ? 'bg-success-new':''\n                                                           ]\" class=\"form-control\" name=\"shift_required\" type=\"text\" v-model=\"employee.shift_required\">\n                        </div>\n                        <div class=\"col-md-4\">\n                          <label>Max Hours:</label>\n                          <input :class=\"[employee.max_hours > employee.preffered_max_hours ? 'bg-magenta':'',\n                                                           employee.max_hours < employee.preffered_max_hours ? 'bg-success-new':'',\n                                                           employee.max_hours == employee.preffered_max_hours ? '':'']\" class=\"form-control\" name=\"max_hours\" type=\"text\" v-model=\"employee.max_hours\">\n                        </div>\n                      </div>\n                      <!-- <div class=\"text-right\">\n                          <button type=\"submit\" class=\"btn btn-primary\" v-submit=\"state\"\n                                  v-on:click.prevent=\"editEmployee\">Save <i\n                                      class=\"icon-arrow-right14 position-right\"></i></button>\n                      </div> -->\n                    </fieldset>\n                  </div>\n                </div>\n              </div>\n            </form>\n          </div>\n\n          <div class=\"modal-footer\">\n            <button class=\"btn btn-primary mr-10\" type=\"submit\" v-on:click.prevent=\"editEmployee\" v-submit=\"state\">Save <i class=\"icon-arrow-right14 position-right\"></i></button>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"modal fade\" id=\"positions-modal\">\n      <div class=\"modal-dialog modal-full\">\n        <div class=\"modal-content\">\n          <div class=\"col-md-6 no-padding text-left\">\n            <button @click=\"saveEmployeePositions()\" class=\"btn btn-xs btn-primary pull-left ml-20 mt-5\" type=\"button\">Save changes\n            </button>\n          </div>\n          <div class=\"col-md-6 no-padding text-right\">\n            <i aria-hidden=\"true\" class=\"fa fa-times font-40  pull-right cursor-pointer\" data-dismiss=\"modal\"></i>\n          </div>\n          <div class=\"modal-header mt-20\">\n            <h4 class=\"modal-title text-center bg-slate-800\">Assign Clients</h4>\n          </div>\n          <div class=\"modal-body no-padding-top\">\n            <div class=\"col-md-12 no-padding\">\n              <div class=\"col-md-3 text-left float-left no-padding\">\n                <table class=\"table table-xxs table-borderless\">\n                  <tbody><tr>\n                    <td class=\"bg-slate-300\">Name</td>\n                    <td class=\"text-black text-primary\">{{ activeEmployee.fullName }}</td>\n                  </tr>\n                  <tr>\n                    <td class=\"bg-slate-300\">GAR - B</td>\n                    <td>{{\n                        activeEmployee.grooming + activeEmployee.attitude + activeEmployee.reliability\n                      }} - {{ activeEmployee.background }}\n                    </td>\n                  </tr>\n                  <tr>\n                    <td class=\"bg-slate-300\">Transport</td>\n                    <td>{{ activeEmployee.transportation }}</td>\n                  </tr>\n                </tbody></table>\n              </div>\n              <div class=\"col-md-7\"></div>\n              <div class=\"col-md-2 text-right no-padding\">\n                <table class=\"table table-xxs table-borderless\">\n                  <tbody><tr>\n                    <td class=\"bg-slate-300\">ABC - X - M</td>\n                  </tr>\n                  <tr>\n                    <td class=\"text-black text-primary\">\n                      {{ activeEmployee.count_a_b_c_position_count }} -\n                      {{ activeEmployee.count_x_count }} - {{ activeEmployee.count_m_count }}\n                    </td>\n                  </tr>\n                </tbody></table>\n              </div>\n            </div>\n            <table class=\"table table-xxs table-bordered table-fixed\">\n              <thead>\n              <tr>\n                <th class=\"text-left bg-slate-800\">Client Name</th>\n                <th class=\"text-center bg-slate-800\">Position - Zone</th>\n                <th class=\"text-center bg-slate-800\">Pay Rate</th>\n                <th class=\"text-center bg-slate-800\" width=\"140\">Manual Pay Rate</th>\n                <th class=\"text-center bg-slate-800\">Auto</th>\n                <th class=\"text-center bg-slate-800\">Manual</th>\n                <th class=\"text-center bg-slate-800\">C Days</th>\n                <th class=\"text-center bg-slate-800\">Clients Priority</th>\n                <th class=\"text-center bg-slate-800\">Worked 180</th>\n                <th class=\"text-center bg-slate-800\">Action</th>\n              </tr>\n              </thead>\n              <tbody>\n              <tr v-for=\"position in positions\">\n                <td class=\"text-left\">{{ position.company_code + ' ' + position.title }}</td>\n                <td class=\"text-center\">{{ position.type + ' - ' + position.zone }}</td>\n                <td class=\"text-center\">{{ position.rate }}</td>\n                <td class=\"text-center\" width=\"140\"><input class=\"form-control\" type=\"text\" v-model=\"position.manual_pay_rate\"></td>\n                <td class=\"text-center\">{{ position.auto_zone }}</td>\n                <td class=\"text-center\">\n                  <select class=\"form-control select input-xs\" id=\"band\" name=\"band\" v-model=\"position.band\" v-select2=\"position.band\">\n                    <option value=\"\">None</option>\n                    <option :selected=\" employee.band == 'A'\" value=\"A\">A\n                    </option>\n                    <option :selected=\" employee.band == 'B'\" value=\"B\">B\n                    </option>\n                    <option :selected=\" employee.band == 'C'\" v-if=\"position.action.c || position.band =='C'\" value=\"C\">C\n                    </option>\n                    <option :selected=\" employee.band == 'M'\" value=\"M\">M\n                    </option>\n                    <option :selected=\" employee.band == 'X'\" value=\"X\">X\n                    </option>\n                    <option :selected=\" employee.band == 'W'\" value=\"W\">W\n                    </option>\n                  </select>\n                </td>\n                <td class=\"text-center\">\n                  <span v-if=\"position.band =='C'\">{{ position.c_days }}</span>\n                </td>\n                <td :class=\"position.background_class\" class=\"text-center\">{{\n                    position.current_priority\n                  }}\n                  - {{\n                    position.required_priority\n                  }}\n                </td>\n                <td class=\"text-center\">\n                  {{ position.half_year }}\n                </td>\n                <td class=\"text-center\">\n                  <span :class=\"position.action.class\" class=\"label min-width-50\">{{ position.action.text }}</span>\n                </td>\n              </tr>\n              </tbody>\n            </table>\n          </div>\n          <div class=\"modal-footer\">\n            <button class=\"btn btn-default\" data-dismiss=\"modal\" type=\"button\">Close</button>\n            <button @click=\"saveEmployeePositions()\" class=\"btn btn-primary\" type=\"button\">Save changes\n            </button>\n          </div>\n        </div><!-- /.modal-content -->\n      </div><!-- /.modal-dialog -->\n    </div><!-- /.modal -->\n    <employee-performance-data></employee-performance-data>\n  </div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  var id = "/home/shoieb/sites/elegant/resources/assets/js/vue/components/employee-report.vue"
  module.hot.dispose(function () {
    require("vueify-insert-css").cache["\nthead.report-header {\n  max-width: 99% !important;\n}\n\n.fixed_header_report tbody {\n  display: block;\n  max-height: 700px;\n  overflow-y: scroll;\n}\n\n.fixed_header_report thead,\ntbody.fixed_body_report tr {\n  display: table;\n  width: 100%;\n  table-layout: fixed;\n}\n\ntable.fixed_header_report thead {\n  background-color: #eaeaea;\n}\n\ntable.fixed_header_report tbody {\n  background-color: #fcfcfc;\n}\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, module.exports.template)
  }
})()}
},{"./../../mixed/modals":10,"./../../mixed/notify":11,"vue":5,"vue-hot-reload-api":4,"vueify-insert-css":6}],50:[function(require,module,exports){
var __vueify_style__ = require("vueify-insert-css").insert("\n/* table.fixed_header_status tbody{\n  overflow:auto;\n  height:600px;\n} */\nthead.status-header{\n max-width: 99% !important;\n}\n\n.fixed_header_status tbody {\n  display: block;\n  max-height: 600px;\n  overflow-y: scroll;\n}\n\n.fixed_header_status thead,\ntbody.fixed_body_status tr {\n  display: table;\n  width: 100%;\n  table-layout: fixed;\n}\ntable.fixed_header_status thead {\n  background-color: #eaeaea;\n}\n\ntable.fixed_header_status tbody {\n  background-color: #fcfcfc;\n}\n")
"use strict";

exports.__esModule = true;
var modals = require("./../../mixed/modals");
var notify = require("./../../mixed/notify");
var shifts = {
  U: 3,
  "A+": 6,
  A: 5,
  B: 2,
  C: 1
};

var priority = {
  U: 0,
  "A+": 6,
  A: 5,
  B: 0,
  C: 0
};
exports["default"] = {
  data: function data() {
    return {
      employeeObject: {
        first_name: "",
        middle_name: "",
        last_name: "",
        employee_code: "",
        dob: "",
        ss: "",
        tax_id: "",
        marital_status: "",
        no_of_dependent: "",
        gender: "",
        street: "",
        apt: "",
        city: "",
        state: "",
        zip_code: "",
        primary_phone: "",
        secondary_phone: "",
        email: "",
        email_notification: 0,
        password: "",
        bank_name: "",
        routing_number: "",
        account_number: "",
        legal_status: "",
        shift_required: 3,
        max_hours: 25,
        status: "Watch List",
        hire_date: "",
        minimum_salary: 8,
        desired_position: "",
        increased_pay: "",
        max_pay_rate: "",
        payroll_group: "",
        transportation: "",
        comments: "",
        grooming: "",
        attitude: "",
        reliability: "",
        background: "",
        partners: [],
        shifts: [],
        jobs: [],
        early: "",
        late: "",
        uniforms: [],
        tools: [],
        skills: [],
        is_draft: 0
      },
      state: false,
      employees: {},
      employee: {},
      activeEmployee: {},
      positions: {},
      types: ["A+", "A", "U", "B", "C"],
      actions: 0,
      sortOrders: true,
      sortKey: "action",
      currentEmployee: {},
      types: ["A+", "A", "B", "C", "U"],
      backgroundTypes: ["A", "B", "C", "U"],
      options: [],
      commonData: {
        uniforms: []
      },
      activeUser: {},
      filterStatus: 'Watch List|Active',
      filterGroup: '1-6',
      perPage: 100,
      page: 1,
      sortOrder: false,
      sortField: 'hire_date',
      totalPages: '',
      pagination: {}
    };
  },
  filters: {
    moment: (function (_moment) {
      function moment(_x) {
        return _moment.apply(this, arguments);
      }

      moment.toString = function () {
        return _moment.toString();
      };

      return moment;
    })(function (time) {
      return moment(time, "HH:mm:ss").format("hA");
    }),

    parseDate: function parseDate(date) {
      return moment(date).format("DD,MMM YYYY");
    },

    minimumSalary: {
      read: function read(val) {
        return val;
      },
      write: function write(val, oldVal) {
        var number = +val.replace(/[^\d.]/g, "");
        if (isNaN(number)) {
          return null;
        } else {
          return number > 40 ? 8 : number;
        }
      }
    },

    payRateIncrease: {
      read: function read(val) {
        return val;
      },
      write: function write(val, oldVal) {
        var number = +val.replace(/[^\d.]/g, "");
        if (isNaN(number)) {
          return null;
        } else {
          return number >= 10 ? 1 : number;
        }
      }
    }
  },
  watch: {
    'filterStatus': function filterStatus() {
      this.getEmployeeStatusLogReport();
    },
    'filterGroup': function filterGroup() {
      this.getEmployeeStatusLogReport();
    }
  },
  ready: function ready() {
    this.getEmployeeStatusLogReport();
    this.getData();
    var that = this;
    $("#modal_edit_employee").on("hidden.bs.modal", function () {
      $(".stepy-basic-edit").stepy("step", 1);
      that.clearCurrentEmployee();
    });
  },
  created: function created() {
    this.currentEmployee = _.cloneDeep(this.employeeObject);
  },
  events: {},
  methods: {

    showPerformanceReport: function showPerformanceReport(employee) {
      window.bus.$emit("showEmployeePerformanceReport", employee.id);
    },

    setFilter: function setFilter() {
      this.getEmployeeStatusLogReport();
    },

    changePage: function changePage(currentPage) {
      this.page = currentPage;
      this.getEmployeeStatusLogReport();
    },

    sortEmployees: function sortEmployees(field, order) {
      this.sortField = field;
      this.sortOrder = order;
      this.getEmployeeStatusLogReport();
    },
    /**
     * get employee report data
     */
    getEmployeeStatusLogReport: function getEmployeeStatusLogReport() {
      var _this = this;

      notify.loading(true);
      this.$http.get("/api/employee-status-log-report-data?status=" + this.filterStatus + "&group=" + this.filterGroup + "&per_page=" + this.perPage + "&page=" + this.page + "&sortOrder=" + (this.sortOrder ? 'asc' : 'desc') + "&sortField=" + this.sortField, function (response) {
        _this.pagination = response;
        _this.employees = _this.pagination.data;
      }).always(function () {
        notify.loading(false);
      });
    },

    statusFormat: function statusFormat(value) {
      return '<span class="text-black text-' + value.replace(/\s+/g, "-") + '">' + value.charAt(0) + "</span>";
    },

    getData: function getData() {
      var _this2 = this;

      this.$http.get("/api/employee-data/", "", function (response) {
        _this2.commonData = response;
      }).always(function () {});
    },

    /**
     * prepare modal and show edit employee modal
     * @param data
     */
    editModal: function editModal(data) {
      var _this3 = this;

      notify.loading(true);
      this.$http.get("/api/employee/" + data.id, "", function (employee) {
        _this3.currentEmployee = _.cloneDeep(employee);
        _this3.currentEmployee.skills = _.pluck(employee.skills, "id").map(Number);
        _this3.currentEmployee.tools = _.pluck(employee.tools, "id").map(Number);
        _this3.currentEmployee.uniforms = _.pluck(employee.uniforms, "id").map(Number);
        _this3.currentEmployee.desired_position = employee.position_desired;
        _this3.currentEmployee.dob = moment(_this3.currentEmployee.dob).format("MM-DD-YYYY");
        _this3.currentEmployee.hire_date = moment(_this3.currentEmployee.hire_date).format("MM-DD-YYYY");
        modals.showStrict("#modal_edit_employee");
      }).always(function () {
        notify.loading(false);
      });
      //modals.hide('#draft_employees');
    },

    editEmployee: function editEmployee() {
      var _this4 = this;

      this.currentEmployee.is_draft = 0;
      this.currentEmployee.dob = moment(this.currentEmployee.dob).format("MM-DD-YYYY");
      this.currentEmployee.hire_date = moment(this.currentEmployee.hire_date).format("MM-DD-YYYY");
      this.$http.put("/api/employee/" + this.currentEmployee.id, this.currentEmployee, function () {
        //this.getData();
        modals.hide("#modal_edit_employee");
        notify.success("Employee Information Edited Successfully");
      }).always(function () {
        _this4.state = false;
      });
    },

    clearCurrentEmployee: function clearCurrentEmployee() {
      this.currentEmployee = {
        first_name: "",
        middle_name: "",
        last_name: "",
        employee_code: "",
        dob: "",
        ss: "",
        tax_id: "",
        marital_status: "",
        no_of_dependent: "",
        gender: "",
        street: "",
        apt: "",
        city: "",
        state: "",
        zip_code: "",
        primary_phone: "",
        secondary_phone: "",
        email: "",
        password: "",
        bank_name: "",
        routing_number: "",
        account_number: "",
        legal_status: "",
        shift_required: 3,
        max_hours: 25,
        status: "Watch List",
        hire_date: "",
        minimum_salary: 8,
        desired_position: "",
        increased_pay: "",
        max_pay_rate: "",
        payroll_group: "",
        transportation: "",
        comments: "",
        grooming: "",
        attitude: "",
        reliability: "",
        background: "",
        partners: [],
        shifts: [],
        jobs: [],
        early: "",
        late: "",
        uniforms: [],
        tools: [],
        skills: [],
        is_draft: 0
      };
    },

    /**
     * show modal to edit user information
     */
    showEditUserModal: function showEditUserModal(user) {
      this.activeUser = _.cloneDeep(user);
      if (this.activeUser.password) {
        this.activeUser.password = "**********";
      }
      modals.showStrict("#update-user-data");
    },

    updateUserAccessData: function updateUserAccessData() {
      var _this5 = this;

      var user = _.cloneDeep(this.activeUser);
      user.employee_id = user.id;
      if (user.password == '**********') {
        user.password = null;
      }
      this.$http.post("/api/update-user-access-data", user, function (response) {
        modals.hide("#update-user-data");
        _this5.getEmployeeStatusLogReport();
      }).always(function () {});
    }
  }
};
module.exports = exports["default"];
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n  <div class=\"row\">\n    <div class=\"col-md-12 bg-black h-100 pt-20 pb-20\">\n      <div class=\"col-md-6 text-center\">\n        <h4 class=\"no-margin text-semibold text-center\">EMPLOYEE STATUS LOG</h4>\n      </div>\n      <div class=\"col-md-3\">\n        <select class=\"form-control select\" name=\"role\" v-select2=\"filterStatus\" v-model=\"filterStatus\">\n                    <option value=\"Watch List|Active\">Watchlist and Active</option>\n                    <option value=\"Watch List|Active|Inactive|Quit|Terminated|Suspended\">All Status</option>\n                    <option value=\"Watch List\">Watch List</option>\n                    <option value=\"Active\">Active</option>\n                    <option value=\"Inactive\">Inactive</option>\n                    <option value=\"Quit\">Quit</option>\n                    <option value=\"Terminated\">Terminated</option>\n                    <option value=\"Suspended\">Suspended</option>\n                </select>\n      </div>\n      <div class=\"col-md-3\">\n        <select class=\"form-control select\" name=\"role\" v-select2=\"filterGroup\" v-model=\"filterGroup\">\n                    <option value=\"1-6\">1-6</option>\n                    <option value=\"7-9\">7-9</option>\n                    <option value=\"1-9\">All</option>\n                </select>\n      </div>\n    </div>\n    <div class=\"col-md-12 no-padding mb-20\">\n      <div class=\"table-responsive overflow-hidden\">\n        <table class=\"table table-xxs table-bordered fixed_header_status\">\n          <thead class=\"header status-header\">\n            <tr>\n              <th width=\"7%\" class=\"bg-black text-center cursor-pointer\" @click=\"sortEmployees('first_name',!sortOrder)\" rowspan=\"2\">Employee Name\n                <i v-if=\"sortField === 'first_name'\" :class=\"sortOrder ? 'fa fa-arrow-down':'fa fa-arrow-up'\"></i>\n              </th>\n              <th width=\"5%\" class=\"bg-black text-center cursor-pointer\" @click=\"sortEmployees('hire_date',!sortOrder)\" rowspan=\"2\">Hire Date\n                <i v-if=\"sortField === 'hire_date'\" :class=\"sortOrder ? 'fa fa-arrow-down':'fa fa-arrow-up'\"></i>\n              </th>\n              <th class=\"bg-black text-center cursor-pointer\" @click=\"sortEmployees('status',!sortOrder)\" rowspan=\"2\">\n                St\n                <i v-if=\"sortField === 'status'\" :class=\"sortOrder ? 'fa fa-arrow-down':'fa fa-arrow-up'\"></i>\n              </th>\n              <th class=\"bg-black text-center cursor-pointer\" rowspan=\"2\" @click=\"sortEmployees('grooming',!sortOrder)\">\n                G.A.R\n                <i v-if=\"sortField === 'grooming'\" :class=\"sortOrder ? 'fa fa-arrow-down':'fa fa-arrow-up'\"></i>\n              </th>\n              <th width=\"5%\" class=\"bg-black text-center cursor-pointer\" rowspan=\"2\" @click=\"sortEmployees('cities.title',!sortOrder)\">\n                City\n                <i v-if=\"sortField === 'city'\" :class=\"sortOrder ? 'fa fa-arrow-down':'fa fa-arrow-up'\"></i>\n              </th>\n              <th class=\"bg-danger-600 text-center\" colspan=\"3\">Client Zone</th>\n              <th class=\"bg-slate text-center\" colspan=\"7\">Jobs &amp; Position</th>\n              <th class=\"bg-orange-300 text-center\" colspan=\"2\">Shift</th>\n              <th class=\"bg-green-300 text-center\" colspan=\"5\">Pay Rate</th>\n              <th class=\"bg-warning-300 text-center\" colspan=\"2\">Apps</th>\n              <th class=\"bg-primary text-center\" colspan=\"2\">Job Offer</th>\n              <th class=\"bg-indigo text-center\" colspan=\"3\">Job Accept</th>\n              <th class=\"bg-slate text-center\" colspan=\"2\">Last</th>\n              <th class=\"bg-black text-center\" rowspan=\"2\">EF</th>\n              <th class=\"bg-black text-center\" rowspan=\"2\">UA</th>\n              <th class=\"bg-black text-center\" rowspan=\"2\">P.C</th>\n            </tr>\n            <tr>\n              <th class=\"bg-black text-center\" title=\"Number of client in zone A\">A</th>\n              <th class=\"bg-black text-center\" title=\"Number of client in zone B\">B</th>\n              <th class=\"bg-black text-center\" title=\"Number of client in zone C\">C</th>\n\n              <th class=\"bg-slate-800 text-center\" title=\"Qualified JOB\">QJ</th>\n              <th class=\"bg-slate-800 text-center\" title=\"Qualified POSITION\">QP</th>\n              <th class=\"bg-slate-800 text-center\" title=\"Total number this employee is in position A,B,C\">ABC</th>\n              <th class=\"bg-slate-800 text-center\" title=\"Total number this employee is in position D,G\">DG</th>\n              <th class=\"bg-slate-800 text-center\" title=\"Total number this employee is in position E,H\">EH</th>\n              <th class=\"bg-slate-800 text-center\">Rest</th>\n              <th class=\"bg-slate-800 text-center\" title=\"Total number of CLIENT this employee is in list X\">X</th>\n\n              <th class=\"bg-orange-800 text-center cursor-pointer\" title=\"SHIFT REQUIRED\" @click=\"sortEmployees('shift_required',!sortOrder)\">SR\n                <i v-if=\"sortField === 'shift_required'\" :class=\"sortOrder ? 'fa fa-arrow-down':'fa fa-arrow-up'\"></i>\n              </th>\n              <th class=\"bg-orange-800 text-center cursor-pointer\" title=\"MAX HOURS\" @click=\"sortEmployees('max_hours',!sortOrder)\">MH\n                <i v-if=\"sortField === 'max_hours'\" :class=\"sortOrder ? 'fa fa-arrow-down':'fa fa-arrow-up'\"></i>\n              </th>\n\n              <th class=\"bg-green-800 text-center cursor-pointer\" title=\"MINIMUM SALARY\" @click=\"sortEmployees('minimum_salary',!sortOrder)\">MS\n                <i v-if=\"sortField === 'minimum_salary'\" :class=\"sortOrder ? 'fa fa-arrow-down':'fa fa-arrow-up'\"></i>\n              </th>\n              <th class=\"bg-green-800 text-center cursor-pointer\" title=\"PAYRATE INCREASE\" @click=\"sortEmployees('increased_pay',!sortOrder)\">PI\n                <i v-if=\"sortField === 'increased_pay'\" :class=\"sortOrder ? 'fa fa-arrow-down':'fa fa-arrow-up'\"></i>\n              </th>\n              <th class=\"bg-green-800 text-center cursor-pointer\" title=\"MAX PAY\" @click=\"sortEmployees('max_pay_rate',!sortOrder)\">MP\n                <i v-if=\"sortField === 'max_pay_rate'\" :class=\"sortOrder ? 'fa fa-arrow-down':'fa fa-arrow-up'\"></i>\n              </th>\n              <th class=\"bg-green-800 text-center cursor-pointer\" title=\"PAYROLL GROUP\" @click=\"sortEmployees('ppayroll_group',!sortOrder)\">PG\n                <i v-if=\"sortField === 'payroll_group'\" :class=\"sortOrder ? 'fa fa-arrow-down':'fa fa-arrow-up'\"></i>\n              </th>\n              <th class=\"bg-green-800 text-center\" title=\"HIGHEST RATE\">HR</th>\n\n              <th class=\"bg-warning-800 text-center\" title=\"APP ACCESS\">AA</th>\n              <th class=\"bg-warning-800 text-center cursor-pointer\" title=\"LAST ACCESSED\" @click=\"sortEmployees('last_app_activity',!sortOrder)\">LA\n                <i v-if=\"sortField === 'last_app_activity'\" :class=\"sortOrder ? 'fa fa-arrow-down':'fa fa-arrow-up'\"></i>\n              </th>\n\n              <th class=\"bg-primary-800 text-center\" title=\"TOTAL JOB OFFERED IN LAST 90 DAYS\">T</th>\n              <th class=\"bg-primary-800 text-center\" title=\"TOTAL NUMBER OF DAYS JOB OFFERED IN LAST 90 DAYS\">D</th>\n\n              <th class=\"bg-indigo-800 text-center\" title=\"CONFIRMED AND RECONFIRMED IN LAST 90 DAYS\">A</th>\n              <th class=\"bg-indigo-800 text-center\" title=\"WORKED IN LAST 90 DAYS\">W</th>\n              <th class=\"bg-indigo-800 text-center\" title=\"NO SHOW IN LAST 90 DAYS\">NS</th>\n\n              <th class=\"bg-slate-800 text-center\" title=\"NUMBER OF DAYS AGO LAST JOB WAS OFFERED\">LO</th>\n              <th class=\"bg-slate-800 text-center\" title=\"NUMBER OF DAYS AGO LAST JOB WAS ACCEPTED\">LA</th>\n            </tr>\n          </thead>\n          <tbody class=\"fixed_body_status\">\n            <tr v-for=\"(index,employee) in employees\" :key=\"index\">\n              <td width=\"7%\" class=\"text-left pl-5 pr-5 pt-10 pb-10\">{{employee.name}}</td>\n              <td width=\"5%\" class=\"text-center pl-5 pr-5 pt-10 pb-10\">\n                {{ employee.hire_date | customDateFormat\n                'YYYY-MM-DD h:m:s'\n                'MM/DD/YYYY' }}\n              </td>\n              <td class=\"text-center pl-5 pr-5 pt-10 pb-10\">{{{ statusFormat(employee.status) }}}</td>\n              <td class=\"text-left pl-5 pr-5 pt-10 pb-10\">{{ employee.grooming+employee.attitude+employee.reliability}}</td>\n              <td width=\"5%\" class=\"text-left pl-5 pr-5 pt-10 pb-10\">{{ employee.city}}</td>\n              <td class=\"text-center pl-5 pr-5 pt-10 pb-10\">{{ employee.zone_a}}</td>\n              <td class=\"text-center pl-5 pr-5 pt-10 pb-10\">{{ employee.zone_b}}</td>\n              <td class=\"text-center pl-5 pr-5 pt-10 pb-10\">{{ employee.zone_c}}</td>\n              <td class=\"text-center pl-5 pr-5 pt-10 pb-10\">{{employee.qj}}</td>\n              <td class=\"text-center pl-5 pr-5 pt-10 pb-10\">{{employee.qp}}</td>\n              <td class=\"text-center pl-5 pr-5 pt-10 pb-10\">{{employee.employee_a_b_c_count}}</td>\n              <td class=\"text-center pl-5 pr-5 pt-10 pb-10\">{{ employee.dg }}</td>\n              <td class=\"text-center pl-5 pr-5 pt-10 pb-10\">{{ employee.eh }}</td>\n              <td class=\"text-center pl-5 pr-5 pt-10 pb-10\"> {{ employee.rest }}</td>\n              <td class=\"text-center pl-5 pr-5 pt-10 pb-10\">{{employee.employee_x_count}}</td>\n              <td class=\"text-center pl-5 pr-5 pt-10 pb-10\">{{employee.shift_required}}</td>\n              <td class=\"text-center pl-5 pr-5 pt-10 pb-10\">{{employee.max_hours}}</td>\n              <td class=\"text-center pl-5 pr-5 pt-10 pb-10\">{{employee.minimum_salary}}</td>\n              <td class=\"text-center pl-5 pr-5 pt-10 pb-10\">{{employee.increased_pay}}</td>\n              <td class=\"text-center pl-5 pr-5 pt-10 pb-10\">{{employee.max_pay_rate}}</td>\n              <td class=\"text-center pl-5 pr-5 pt-10 pb-10\">{{employee.payroll_group}}</td>\n              <td class=\"text-center pl-5 pr-5 pt-10 pb-10\">{{employee.hr}}</td>\n              <td class=\"text-center pl-5 pr-5 pt-10 pb-10\">{{employee.app_access}}</td>\n              <td class=\"text-center pl-5 pr-5 pt-10 pb-10\">\n                {{ employee.last_app_activity | customDateFormat\n                'YYYY-MM-DD h:m:s'\n                'MMM DD' }}\n              </td>\n              <td class=\"text-center pl-5 pr-5 pt-10 pb-10\">{{employee.jo}}</td>\n              <td class=\"text-center pl-5 pr-5 pt-10 pb-10\">{{employee.jo_days}}</td>\n              <td class=\"text-center pl-5 pr-5 pt-10 pb-10\">{{employee.re_confirmed_ninety_count}}</td>\n              <td class=\"text-center pl-5 pr-5 pt-10 pb-10\">{{employee.worked}}</td>\n              <td class=\"text-center pl-5 pr-5 pt-10 pb-10\">{{employee.ns}}</td>\n              <td class=\"text-center pl-5 pr-5 pt-10 pb-10\">{{employee.lo}}</td>\n              <td class=\"text-center pl-5 pr-5 pt-10 pb-10\">{{employee.la}}</td>\n              <td class=\"text-center pl-5 pr-5 pt-10 pb-10\">\n                <span class=\"text-black text-blue cursor-pointer\" @click=\"editModal(employee)\">EF</span>\n              </td>\n              <td class=\"text-center pl-5 pr-5 pt-10 pb-10\">\n                <span class=\"text-black text-orange cursor-pointer\" @click=\"showEditUserModal(employee)\">UA</span>\n              </td>\n              <td class=\"text-center pl-5 pr-5 pt-10 pb-10 cursor-pointer\">\n                <span class=\"text-black text-blue cursor-pointer\" @click=\"showPerformanceReport(employee)\">P.C</span>\n              </td>\n            </tr>\n          </tbody>\n        </table>\n\n        <ul class=\"pagination pt-20 pb-10 pull-right pr-10\">\n        <li v-if=\"pagination.current_page > 1\">\n            <a href=\"javascript:void(0)\" aria-label=\"Previous\" v-on:click.prevent=\"changePage(pagination.current_page - 1)\">\n                <span aria-hidden=\"true\">«</span>\n                </a>\n            </li>\n        <li v-for=\"(key,page) in pagination.totalPages\" :key=\"key\" :class=\"{'active': page == pagination.current_page}\">\n            <a href=\"javascript:void(0)\" v-on:click.prevent=\"changePage(page)\">{{ page }}</a>\n            </li>\n        <li v-if=\"pagination.current_page < pagination.last_page\">\n            <a href=\"javascript:void(0)\" aria-label=\"Next\" v-on:click.prevent=\"changePage(pagination.current_page + 1)\">\n                <span aria-hidden=\"true\">»</span>\n                </a>\n            </li>\n        </ul>\n      </div>\n    </div>\n\n    <div id=\"modal_edit_employee\" class=\"modal fade\">\n\t<div class=\"modal-dialog modal-medium\">\n\t\t<div class=\"modal-content grey-bg\">\n\t\t\t<div class=\"modal-header\">\n\t\t\t\t<button type=\"button\" class=\"close\" data-dismiss=\"modal\">Cancel</button>\n\t\t\t</div>\n\t\t\t<div class=\"modal-body\">\n\t\t\t\t<div class=\"row\">\n\t\t\t\t\t<form class=\"stepy-basic-edit employee-form-create\" action=\"#\" autocomplete=\"off\">\n\t\t\t\t\t\t<fieldset title=\"1\">\n\t\t\t\t\t\t\t<legend>Personal data</legend>\n\t\t\t\t\t\t\t<div class=\"row\">\n\t\t\t\t\t\t\t\t<div class=\"col-md-4\">\n\t\t\t\t\t\t\t\t\t<div class=\"form-group\">\n\t\t\t\t\t\t\t\t\t\t<label>First Name:</label>\n\t\t\t\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control focus-field\" v-model=\"currentEmployee.first_name\" v-bind:class=\"{ 'border-blue-600': !currentEmployee.first_name }\" autofocus=\"\">\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"col-md-4\">\n\t\t\t\t\t\t\t\t\t<div class=\"form-group\">\n\t\t\t\t\t\t\t\t\t\t<label>Last Name:</label>\n\t\t\t\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" v-model=\"currentEmployee.last_name\" v-bind:class=\"{ 'border-blue-600': !currentEmployee.last_name }\">\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"col-md-4\">\n\t\t\t\t\t\t\t\t\t<div class=\"form-group\">\n\t\t\t\t\t\t\t\t\t\t<label>Middle Name:</label>\n\t\t\t\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" v-model=\"currentEmployee.middle_name\" v-bind:class=\"{ 'border-blue-600': !currentEmployee.last_name }\">\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<div class=\"row\">\n\t\t\t\t\t\t\t\t<div class=\"col-md-4\">\n\t\t\t\t\t\t\t\t\t<div class=\"form-group\">\n\t\t\t\t\t\t\t\t\t\t<label>Date of Birth:</label>\n\t\t\t\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control pickadate-year\" v-model=\"currentEmployee.dob\" v-bind:class=\"{ 'border-blue-600': !currentEmployee.dob }\">\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"col-md-4\">\n\t\t\t\t\t\t\t\t\t<div class=\"form-group\">\n\t\t\t\t\t\t\t\t\t\t<label>SS:</label>\n\t\t\t\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control format-ss\" v-model=\"currentEmployee.ss\" v-bind:class=\"{ 'border-blue-600': !currentEmployee.ss }\">\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"col-md-4\">\n\t\t\t\t\t\t\t\t\t<div class=\"form-group\">\n\t\t\t\t\t\t\t\t\t\t<label>Tax ID:</label>\n\t\t\t\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control format-tax\" v-model=\"currentEmployee.tax_id\" v-bind:class=\"{ 'border-blue-600': !currentEmployee.tax_id }\">\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<div class=\"row\">\n\t\t\t\t\t\t\t\t<div class=\"col-md-4\">\n\t\t\t\t\t\t\t\t\t<div class=\"form-group\">\n\t\t\t\t\t\t\t\t\t\t<label>Marital Status:</label>\n\t\t\t\t\t\t\t\t\t\t<select name=\"marital_status\" class=\"form-control\" v-bind:class=\"{ 'border-blue-600': !currentEmployee.marital_status }\" v-model=\"currentEmployee.marital_status\">\n\t\t\t\t\t\t\t\t\t\t\t<option value=\"\">Select An Option</option>\n\t\t\t\t\t\t\t\t\t\t\t<option value=\"Married\">Married</option>\n\t\t\t\t\t\t\t\t\t\t\t<option value=\"Widowed\">Widowed</option>\n\t\t\t\t\t\t\t\t\t\t\t<option value=\"Separated\">Separated</option>\n\t\t\t\t\t\t\t\t\t\t\t<option value=\"Divorced\">Divorced</option>\n\t\t\t\t\t\t\t\t\t\t\t<option value=\"Single\">Single</option>\n\t\t\t\t\t\t\t\t\t\t</select>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<div class=\"col-md-4\">\n\t\t\t\t\t\t\t\t\t<div class=\"form-group\">\n\t\t\t\t\t\t\t\t\t\t<label>No. Of Dependant:</label>\n\t\t\t\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" v-model=\"currentEmployee.no_of_dependent\" v-bind:class=\"{ 'border-blue-600': !currentEmployee.no_of_dependent }\">\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"col-md-4\">\n\t\t\t\t\t\t\t\t\t<div class=\"form-group\">\n\t\t\t\t\t\t\t\t\t\t<label>Gender:</label>\n\t\t\t\t\t\t\t\t\t\t<select name=\"gender\" class=\"form-control\" v-model=\"currentEmployee.gender\" v-bind:class=\"{ 'border-blue-600': !currentEmployee.gender }\">\n\t\t\t\t\t\t\t\t\t\t\t<option value=\"\">Select An Option</option>\n\t\t\t\t\t\t\t\t\t\t\t<option value=\"Male\">Male</option>\n\t\t\t\t\t\t\t\t\t\t\t<option value=\"Female\">Female</option>\n\t\t\t\t\t\t\t\t\t\t</select>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<br>\n\t\t\t\t\t\t\t<!-- <legend class=\"text-semibold  pb-15\"><i class=\"icon-home position-left\"></i></legend> -->\n\t\t\t\t\t\t\t<div class=\"row\">\n\t\t\t\t\t\t\t\t<div class=\"col-md-6\">\n\t\t\t\t\t\t\t\t\t<div class=\"form-group\">\n\t\t\t\t\t\t\t\t\t\t<label>Street#:</label>\n\t\t\t\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" v-model=\"currentEmployee.street\" v-bind:class=\"{ 'border-blue-600': !currentEmployee.street }\">\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"col-md-6\">\n\t\t\t\t\t\t\t\t\t<div class=\"form-group\">\n\t\t\t\t\t\t\t\t\t\t<label>Apartment#:</label>\n\t\t\t\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" v-model=\"currentEmployee.apt\" v-bind:class=\"{ 'border-blue-600': !currentEmployee.apt }\">\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class=\"row\">\n\t\t\t\t\t\t\t\t<div class=\"col-md-4\">\n\t\t\t\t\t\t\t\t\t<div class=\"form-group\">\n\t\t\t\t\t\t\t\t\t\t<label>City:</label>\n\t\t\t\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" v-model=\"currentEmployee.city\" v-bind:class=\"{ 'border-blue-600': !currentEmployee.city }\">\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"col-md-4\">\n\t\t\t\t\t\t\t\t\t<div class=\"form-group\">\n\t\t\t\t\t\t\t\t\t\t<label>State:</label>\n\t\t\t\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control format-state to-upper\" v-model=\"currentEmployee.state\" v-bind:class=\"{ 'border-blue-600': !currentEmployee.state }\">\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"col-md-4\">\n\t\t\t\t\t\t\t\t\t<div class=\"form-group\">\n\t\t\t\t\t\t\t\t\t\t<label>Zip:</label>\n\t\t\t\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control format-zip\" v-model=\"currentEmployee.zip_code\" v-bind:class=\"{ 'border-blue-600': !currentEmployee.zip_code }\">\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<hr>\n\t\t\t\t\t\t\t<!-- <legend class=\"text-semibold\"><i class=\"icon-address-book position-left\"></i></legend> -->\n\t\t\t\t\t\t\t<div class=\"row\">\n\t\t\t\t\t\t\t\t<div class=\"col-md-6\">\n\t\t\t\t\t\t\t\t\t<div class=\"form-group\">\n\t\t\t\t\t\t\t\t\t\t<label>Primary Phone:</label>\n\t\t\t\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control format-phone-dash\" v-model=\"currentEmployee.primary_phone\" v-bind:class=\"{ 'border-blue-600': !currentEmployee.primary_phone }\">\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<div class=\"col-md-6\">\n\t\t\t\t\t\t\t\t\t<div class=\"form-group\">\n\t\t\t\t\t\t\t\t\t\t<label>Secondary Phone:</label>\n\t\t\t\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control format-phone-dash\" v-model=\"currentEmployee.secondary_phone\" v-bind:class=\"{ 'border-blue-600': !currentEmployee.secondary_phone }\">\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<div class=\"col-md-4\">\n\t\t\t\t\t\t\t\t\t<div class=\"form-group\">\n\t\t\t\t\t\t\t\t\t\t<label>Email:</label>\n\t\t\t\t\t\t\t\t\t\t<input type=\"email\" class=\"form-control\" v-model=\"currentEmployee.email\" v-bind:class=\"{ 'border-blue-600': !currentEmployee.email }\">\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<div class=\"col-md-4\">\n\t\t\t\t\t\t\t\t\t<br>\n\t\t\t\t\t\t\t\t\t<br>\n\t\t\t\t\t\t\t\t\t<span class=\"checkboxes\">\n\t\t\t\t\t\t\t\t\t\t<label>\n\t\t\t\t\t\t\t\t\t\t\t<input type=\"checkbox\" v-model=\"currentEmployee.email_notification\" value=\"1\"> Email Notification\n\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<div class=\"col-md-4\">\n\t\t\t\t\t\t\t\t\t<div class=\"form-group\">\n\t\t\t\t\t\t\t\t\t\t<label>Password:</label>\n\t\t\t\t\t\t\t\t\t\t<input type=\"password\" class=\"form-control\" v-model=\"currentEmployee.password\" v-bind:class=\"{ 'border-blue-600': !currentEmployee.password }\">\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<hr>\n\t\t\t\t\t\t\t\t<div class=\"col-md-6\">\n\t\t\t\t\t\t\t\t\t<div class=\"form-group\">\n\t\t\t\t\t\t\t\t\t\t<label>Bank Name:</label>\n\t\t\t\t\t\t\t\t\t\t<input type=\"email\" class=\"form-control\" v-model=\"currentEmployee.bank_name\" v-bind:class=\"{ 'border-blue-600': !currentEmployee.bank_name }\">\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"col-md-6\">\n\t\t\t\t\t\t\t\t\t<div class=\"form-group\">\n\t\t\t\t\t\t\t\t\t\t<label>Routing Number:</label>\n\t\t\t\t\t\t\t\t\t\t<input type=\"email\" class=\"form-control\" v-bind:class=\"{ 'border-blue-600': !currentEmployee.routing_number }\" v-model=\"currentEmployee.routing_number\">\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"col-md-6\">\n\t\t\t\t\t\t\t\t\t<div class=\"form-group\">\n\t\t\t\t\t\t\t\t\t\t<label>Account Number:</label>\n\t\t\t\t\t\t\t\t\t\t<input type=\"email\" class=\"form-control\" v-bind:class=\"{ 'border-blue-600': !currentEmployee.accounting_number }\" v-model=\"currentEmployee.account_number\">\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"col-md-6\">\n\t\t\t\t\t\t\t\t\t<div class=\"form-group\">\n\t\t\t\t\t\t\t\t\t\t<label>Legal Status:</label>\n\t\t\t\t\t\t\t\t\t\t<select name=\"legal_status\" class=\"form-control\" v-bind:class=\"{ 'border-blue-600': !currentEmployee.legal_status }\" v-model=\"currentEmployee.legal_status\">\n\t\t\t\t\t\t\t\t\t\t\t<option value=\"\">Select An Option</option>\n\t\t\t\t\t\t\t\t\t\t\t<option value=\"US Citizen\">US Citizen</option>\n\t\t\t\t\t\t\t\t\t\t\t<option value=\"Permanent Resident\">Permanent Resident</option>\n\t\t\t\t\t\t\t\t\t\t\t<option value=\"Work Permit\">Work Permit</option>\n\t\t\t\t\t\t\t\t\t\t</select>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<!-- <div class=\"col-md-6\">\n                                    <div class=\"form-group\">\n                                    <label>Password:</label>\n                                    <input type=\"password\" class=\"form-control\" v-model=\"currentEmployee.password\" placeholder=\"******\">\n                                    </div>\n                                </div> -->\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</fieldset>\n\n\t\t\t\t\t\t<fieldset title=\"2\">\n\t\t\t\t\t\t\t<legend>Ranking</legend>\n\t\t\t\t\t\t\t<div class=\"row\">\n\t\t\t\t\t\t\t\t<div class=\"col-md-4\">\n\t\t\t\t\t\t\t\t\t<div class=\"form-group\">\n\t\t\t\t\t\t\t\t\t\t<label>Shift Required:</label>\n\t\t\t\t\t\t\t\t\t\t<input type=\"text\" v-model=\"currentEmployee.shift_required\" v-bind:class=\"{ 'border-blue-600': !currentEmployee.shift_required }\" class=\"form-control\">\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<div class=\"col-md-4\">\n\t\t\t\t\t\t\t\t\t<div class=\"form-group\">\n\t\t\t\t\t\t\t\t\t\t<label>Max Hours:</label>\n\t\t\t\t\t\t\t\t\t\t<input type=\"text\" v-model=\"currentEmployee.max_hours\" v-bind:class=\"{ 'border-blue-600': !currentEmployee.max_hours }\" class=\"form-control\">\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<div class=\"col-md-4\">\n\t\t\t\t\t\t\t\t\t<div class=\"form-group\">\n\t\t\t\t\t\t\t\t\t\t<label>Status:</label>\n\t\t\t\t\t\t\t\t\t\t<select name=\"desired_position\" class=\"form-control\" v-bind:class=\"{ 'border-blue-600': !currentEmployee.status }\" v-model=\"currentEmployee.status\">\n\t\t\t\t\t\t\t\t\t\t\t<option value=\"\">Select An Option</option>\n\t\t\t\t\t\t\t\t\t\t\t<option value=\"Watch List\">Watch List</option>\n\t\t\t\t\t\t\t\t\t\t\t<option value=\"Active\">Active</option>\n\t\t\t\t\t\t\t\t\t\t\t<option value=\"Inactive\">Inactive</option>\n\t\t\t\t\t\t\t\t\t\t\t<option value=\"Quit\">Quit</option>\n\t\t\t\t\t\t\t\t\t\t\t<option value=\"Terminated\">Terminated</option>\n\t\t\t\t\t\t\t\t\t\t\t<option value=\"Suspended\">Suspended</option>\n\t\t\t\t\t\t\t\t\t\t</select>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<hr>\n\t\t\t\t\t\t\t<!-- <legend class=\"text-semibold\"><i class=\"icon-user-tie position-left\"></i></legend> -->\n\t\t\t\t\t\t\t<div class=\"row\">\n\t\t\t\t\t\t\t\t<div class=\"col-md-4\">\n\t\t\t\t\t\t\t\t\t<div class=\"form-group\">\n\t\t\t\t\t\t\t\t\t\t<label>Hire Date:</label>\n\t\t\t\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control pickadate-year\" v-model=\"currentEmployee.hire_date\" v-bind:class=\"{ 'border-blue-600': !currentEmployee.hire_date }\">\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"col-md-4\">\n\t\t\t\t\t\t\t\t\t<div class=\"form-group\">\n\t\t\t\t\t\t\t\t\t\t<label>Minimum Salary:</label>\n\t\t\t\t\t\t\t\t\t\t<input type=\"text\" v-model=\"currentEmployee.minimum_salary\" v-bind:class=\"{ 'border-blue-600': !currentEmployee.minimum_salary }\" class=\"form-control format-2digit\">\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<div class=\"col-md-4\">\n\t\t\t\t\t\t\t\t\t<div class=\"form-group\">\n\t\t\t\t\t\t\t\t\t\t<label>Desired Position:</label>\n\t\t\t\t\t\t\t\t\t\t<select name=\"desired_position\" class=\"form-control\" v-bind:class=\"{ 'border-blue-600': !currentEmployee.desired_position }\" v-model=\"currentEmployee.desired_position\">\n\t\t\t\t\t\t\t\t\t\t\t<option value=\"\">Select An Option</option>\n\t\t\t\t\t\t\t\t\t\t\t<option value=\"Full Time\">Full Time</option>\n\t\t\t\t\t\t\t\t\t\t\t<option value=\"Part Time\">Part Time</option>\n\t\t\t\t\t\t\t\t\t\t</select>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"col-md-4\">\n\t\t\t\t\t\t\t\t\t<div class=\"form-group\">\n\t\t\t\t\t\t\t\t\t\t<label>Pay Rate increase:</label>\n\t\t\t\t\t\t\t\t\t\t<input type=\"text\" v-model=\"currentEmployee.increased_pay\" class=\"form-control format-2digit\">\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"col-md-4\">\n\t\t\t\t\t\t\t\t\t<div class=\"form-group\">\n\t\t\t\t\t\t\t\t\t\t<label>Max Pay Rate:</label>\n\t\t\t\t\t\t\t\t\t\t<input type=\"text\" v-model=\"currentEmployee.max_pay_rate\" :disabled=\"!currentEmployee.increased_pay > 0 &amp;&amp; !currentEmployee.max_pay_rate > 0\" class=\"form-control format-2digit\">\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"col-md-4\">\n\t\t\t\t\t\t\t\t\t<div class=\"form-group\">\n\t\t\t\t\t\t\t\t\t\t<label>Payroll Group:</label>\n\t\t\t\t\t\t\t\t\t\t<select name=\"payroll_group\" class=\"form-control\" v-bind:class=\"{ 'border-blue-600': !currentEmployee.payroll_group }\" v-model=\"currentEmployee.payroll_group\">\n\t\t\t\t\t\t\t\t\t\t\t<option value=\"\">Select An Option</option>\n\t\t\t\t\t\t\t\t\t\t\t <option v-for=\"(key,i) in 10\" :key=\"key\" :value=\"i\">{{ i }}</option>\n\t\t\t\t\t\t\t\t\t\t</select>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"col-md-4\">\n\t\t\t\t\t\t\t\t\t<div class=\"form-group\">\n\t\t\t\t\t\t\t\t\t\t<label>Transportation:</label>\n\t\t\t\t\t\t\t\t\t\t<select name=\"transportation\" class=\"form-control\" v-model=\"currentEmployee.transportation\" v-bind:class=\"{ 'border-blue-600': !currentEmployee.transportation }\">\n\t\t\t\t\t\t\t\t\t\t\t<option value=\"\">Select An Option</option>\n\t\t\t\t\t\t\t\t\t\t\t<option value=\"Car\">Car</option>\n\t\t\t\t\t\t\t\t\t\t\t<option value=\"Public Transport\">Public Transport</option>\n\t\t\t\t\t\t\t\t\t\t\t<option value=\"Share Ride\">Share Ride</option>\n\t\t\t\t\t\t\t\t\t\t\t<option value=\"Driver\">Driver</option>\n\t\t\t\t\t\t\t\t\t\t</select>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"col-md-4\">\n\t\t\t\t\t\t\t\t\t<div class=\"form-group\">\n\t\t\t\t\t\t\t\t\t\t<label>Employee ID:</label>\n\t\t\t\t\t\t\t\t\t\t<input type=\"text\" v-model=\"currentEmployee.employee_code\" v-bind:class=\"{ 'border-blue-600': !currentEmployee.employee_code }\" class=\"form-control format-zip\">\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"col-md-4\">\n\t\t\t\t\t\t\t\t\t<div class=\"form-group\">\n\t\t\t\t\t\t\t\t\t\t<label>Comments:</label>\n\t\t\t\t\t\t\t\t\t\t<textarea rows=\"5\" cols=\"5\" class=\"form-control\" v-bind:class=\"{ 'border-blue-600': !currentEmployee.comments }\" v-model=\"currentEmployee.comments\"></textarea>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\n\n\t\t\t\t\t\t</fieldset>\n\n\n\t\t\t\t\t\t<fieldset title=\"3\">\n\t\t\t\t\t\t\t<legend>Work Metrics</legend>\n\t\t\t\t\t\t\t<legend class=\"text-semibold\">\n\t\t\t\t\t\t\t\t<i class=\"icon-truck position-left\"></i>\n\t\t\t\t\t\t\t</legend>\n\t\t\t\t\t\t\t<div class=\"row\">\n\t\t\t\t\t\t\t\t<div class=\"col-md-3\">\n\t\t\t\t\t\t\t\t\t<label>Grooming:</label>\n\t\t\t\t\t\t\t\t\t<select class=\"form-control\" name=\"grooming\" v-model=\"currentEmployee.grooming\" v-bind:class=\"{ 'border-blue-600': !currentEmployee.grooming }\">\n\t\t\t\t\t\t\t\t\t\t<option value=\"\">Select An Option</option>\n\t\t\t\t\t\t\t\t\t\t<option v-for=\"type in types\" value=\"{{ type }}\">{{ type }}</option>\n\t\t\t\t\t\t\t\t\t</select>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<div class=\"col-md-3\">\n\t\t\t\t\t\t\t\t\t<div class=\"form-group\">\n\t\t\t\t\t\t\t\t\t\t<label>Attitude:</label>\n\t\t\t\t\t\t\t\t\t\t<select class=\"form-control\" name=\"attitude\" v-model=\"currentEmployee.attitude\" v-bind:class=\"{ 'border-blue-600': !currentEmployee.attitude }\">\n\t\t\t\t\t\t\t\t\t\t\t<option value=\"\">Select An Option</option>\n\t\t\t\t\t\t\t\t\t\t\t<option v-for=\"type in types\" value=\"{{ type }}\">{{ type }}</option>\n\t\t\t\t\t\t\t\t\t\t</select>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<div class=\"col-md-3\">\n\t\t\t\t\t\t\t\t\t<div class=\"form-group\">\n\t\t\t\t\t\t\t\t\t\t<label>Reliability:</label>\n\t\t\t\t\t\t\t\t\t\t<select class=\"form-control\" name=\"reliability\" v-bind:class=\"{ 'border-blue-600': !currentEmployee.reliability }\" v-model=\"currentEmployee.reliability\">\n\t\t\t\t\t\t\t\t\t\t\t<option value=\"\">Select An Option</option>\n\t\t\t\t\t\t\t\t\t\t\t<option v-for=\"type in types\" value=\"{{ type }}\">{{ type }}</option>\n\t\t\t\t\t\t\t\t\t\t</select>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<div class=\"col-md-3\">\n\t\t\t\t\t\t\t\t\t<div class=\"form-group\">\n\t\t\t\t\t\t\t\t\t\t<label>Background:</label>\n\t\t\t\t\t\t\t\t\t\t<select class=\"form-control\" name=\"background\" v-model=\"currentEmployee.background\" v-bind:class=\"{ 'border-blue-600': !currentEmployee.background }\">\n\t\t\t\t\t\t\t\t\t\t\t<option value=\"\">Select An Option</option>\n\t\t\t\t\t\t\t\t\t\t\t<option v-for=\"type in backgroundTypes\" value=\"{{ type }}\">{{ type }}\n\t\t\t\t\t\t\t\t\t\t\t</option>\n\t\t\t\t\t\t\t\t\t\t</select>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<hr>\n\t\t\t\t\t\t</fieldset>\n\n\n\t\t\t\t\t\t<fieldset title=\"4\">\n\t\t\t\t\t\t\t<legend>UTS</legend>\n\n\t\t\t\t\t\t\t<div class=\"col-md-4-5\">\n\t\t\t\t\t\t\t\t<span class=\"label label-primary mb-10\">Uniforms</span>\n\t\t\t\t\t\t\t\t<br>\n\t\t\t\t\t\t\t\t<div class=\"row pr-10 pl-10 pre-scrollable-740\">\n\t\t\t\t\t\t\t\t\t<div class=\"col-md-6 p-5\" v-for=\"uniformGroup in commonData.uniforms\" track-by=\"$index\">\n\t\t\t\t\t\t\t\t\t\t<strong>{{ uniformGroup.title }}</strong>\n\t\t\t\t\t\t\t\t\t\t<div class=\"checkboxes\" v-for=\"uniform in uniformGroup.uniforms\" track-by=\"$index\">\n\t\t\t\t\t\t\t\t\t\t\t<label>\n\t\t\t\t\t\t\t\t\t\t\t\t<input type=\"checkbox\" v-model=\"currentEmployee.uniforms\" :value=\"uniform.id\"> {{ uniform.title }}\n\t\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<div class=\"col-md-4-5\">\n\t\t\t\t\t\t\t\t<span class=\"label label-primary mb-10 ml-20\">Skills</span>\n\t\t\t\t\t\t\t\t<br>\n\t\t\t\t\t\t\t\t<div class=\"row pr-10 pl-10 ml-10 pre-scrollable-740\">\n\t\t\t\t\t\t\t\t\t<div class=\"col-md-6 p-5\" v-for=\"skillGroup in commonData.skills\">\n\t\t\t\t\t\t\t\t\t\t<strong>{{ skillGroup.title }}</strong>\n\t\t\t\t\t\t\t\t\t\t<div class=\"checkboxes\" v-for=\"skill in skillGroup.skills\">\n\t\t\t\t\t\t\t\t\t\t\t<label>\n\t\t\t\t\t\t\t\t\t\t\t\t<input type=\"checkbox\" v-model=\"currentEmployee.skills\" :value=\"skill.id\"> {{ skill.title }}\n\t\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<div class=\"col-md-3\">\n\t\t\t\t\t\t\t\t<span class=\"label label-primary mb-10 ml-20\">Tools</span>\n\t\t\t\t\t\t\t\t<br>\n\t\t\t\t\t\t\t\t<div class=\"row pr-10 pl-10 ml-10 pre-scrollable-740\">\n\t\t\t\t\t\t\t\t\t<div class=\"\" v-for=\"toolGroup in commonData.tools\">\n\t\t\t\t\t\t\t\t\t\t<strong>{{ toolGroup.title }}</strong>\n\t\t\t\t\t\t\t\t\t\t<div class=\"checkboxes\" v-for=\"tool in toolGroup.tools\">\n\t\t\t\t\t\t\t\t\t\t\t<label>\n\t\t\t\t\t\t\t\t\t\t\t\t<input type=\"checkbox\" v-model=\"currentEmployee.tools\" :value=\"tool.id\"> {{ tool.title }}\n\t\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</fieldset>\n\n\t\t\t\t\t\t<button type=\"submit\" v-submit=\"state\" v-on:click.prevent=\"editEmployee\" class=\"btn btn-primary stepy-finish\">Edit Employee\n\t\t\t\t\t\t\t<i class=\"icon-arrow-right14 position-right\"></i>\n\t\t\t\t\t\t</button>\n\n\t\t\t\t\t</form>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class=\"modal-footer\">\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n\n\n<div class=\"modal fade\" id=\"update-user-data\">\n      <div class=\"modal-dialog modal-lg\">\n        <div class=\"modal-content\">\n          <div class=\"modal-header bg-slate-600\">\n            <button type=\"button\" class=\"close text-black text-color-black\" data-dismiss=\"modal\" aria-hidden=\"true\">×</button>\n            <h4 class=\"modal-title text-center\">{{ activeUser.name }}</h4>\n          </div>\n          <div class=\"modal-body no-padding\">\n            <div class=\"row\">\n              <div class=\"table-responsive\">\n                <div class=\"col-md-12\">\n                  <div class=\"col-md-6 p-5 bg-slate-300 text-center\">STATUS</div>\n                  <div class=\"col-md-6 p-5\">{{ activeUser.status }}</div>\n                </div>\n\n                <div class=\"col-md-12\">\n                  <div class=\"col-md-6 p-5 bg-slate-300 text-center\">HIRE DATE</div>\n                  <div class=\"col-md-6 p-5\">\n                    {{ activeUser.hire_date | customDateFormat\n                    'YYYY-MM-DD h:m:s'\n                    'MM/DD/YYYY' }}\n                  </div>\n                </div>\n\n                <div class=\"col-md-12\">\n                  <div class=\"col-md-6 p-5 bg-slate-300 text-center\">END DATE</div>\n                  <div class=\"col-md-6 p-5\">{{ activeUser.end_date }}</div>\n                </div>\n\n                <div class=\"col-md-12\">\n                  <div class=\"col-md-6 p-5 bg-slate-300 text-center\">PHONE 1</div>\n                  <div class=\"col-md-6 p-5\">{{ activeUser.primary_phone }}</div>\n                </div>\n\n                <div class=\"col-md-12\">\n                  <div class=\"col-md-6 p-5 bg-slate-300 text-center\">PHONE 2</div>\n                  <div class=\"col-md-6 p-5\">{{ activeUser.secondary_phone }}</div>\n                </div>\n              </div>\n            </div>\n            <div class=\"row no-padding-right\">\n              <div class=\"col-md-2 no-padding-right\">\n                <div class=\"col-md-12 text-center text-black bg-black-center pt-20 pb-20 text-uppercase\">User Access</div>\n                <div class=\"col-md-12 text-center text-black mt-20\">\n                  <span class=\"text-center font-30\" :class=\"'text-app-access-'+activeUser.app_access.toLowerCase()\">{{ activeUser.app_access }}</span>\n                </div>\n              </div>\n              <div class=\"col-md-10 col-md-10-custom bg-black\">\n                <div class=\"col-md-3 mb-10 mt-5 text-right pt-20\">\n                  <label class=\"text-black\" for=\"email\">Email</label>\n                </div>\n                <div class=\"col-md-8 mb-5 mt-5 pt-20\">\n                  <input type=\"text\" class=\"form-control input-sm\" v-model=\"activeUser.email\">\n                </div>\n                <div class=\"col-md-3 mb-5 mt-5 pt-20 text-right\">\n                  <label class=\"text-black\" for=\"password\">Password</label>\n                </div>\n                <div class=\"col-md-8 mb-5 mt-5 pt-20\">\n                  <input type=\"text\" class=\"form-control input-sm\" v-model=\"activeUser.password\">\n                </div>\n                <div class=\"col-md-3 mb-5 mt-5 pt-20 text-right\">\n                  <label class=\"text-black\" for=\"pin\">Pin</label>\n                </div>\n                <div class=\"col-md-8 mb-5 mt-5 pt-20\">\n                  <input type=\"text\" class=\"form-control input-sm\" v-model=\"activeUser.pin\">\n                </div>\n                <div class=\"col-md-3 mb-5 mt-5 pt-20 text-right\">\n                  <label class=\"text-black\" for=\"pin\">App Access</label>\n                </div>\n                <div class=\"col-md-8 mb-5 mt-5 pt-20\">\n                  <select name=\"app_access\" class=\"form-control\" v-model=\"activeUser.app_access\">\n                    <option value=\"Yes\">Yes</option>\n                    <option value=\"No\">No</option>\n                  </select>\n                </div>\n              </div>\n            </div>\n            <div class=\"p-20 bg-black text-right\">\n              <button type=\"button\" class=\"btn bg-blue-300 text-black mr-80\" @click=\"updateUserAccessData\">Update</button>\n            </div>\n          </div>\n        </div>\n      </div>\n      <!--<div class=\"modal-footer\">-->\n      <!--<button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button>-->\n      <!--<button type=\"button\" class=\"btn btn-primary\">Save changes</button>-->\n      <!--</div>-->\n    </div>\n\n\n<employee-performance-data></employee-performance-data>\n</div>\n\n\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  var id = "/home/shoieb/sites/elegant/resources/assets/js/vue/components/employee-status-log-report.vue"
  module.hot.dispose(function () {
    require("vueify-insert-css").cache["\n/* table.fixed_header_status tbody{\n  overflow:auto;\n  height:600px;\n} */\nthead.status-header{\n max-width: 99% !important;\n}\n\n.fixed_header_status tbody {\n  display: block;\n  max-height: 600px;\n  overflow-y: scroll;\n}\n\n.fixed_header_status thead,\ntbody.fixed_body_status tr {\n  display: table;\n  width: 100%;\n  table-layout: fixed;\n}\ntable.fixed_header_status thead {\n  background-color: #eaeaea;\n}\n\ntable.fixed_header_status tbody {\n  background-color: #fcfcfc;\n}\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, module.exports.template)
  }
})()}
},{"./../../mixed/modals":10,"./../../mixed/notify":11,"vue":5,"vue-hot-reload-api":4,"vueify-insert-css":6}],51:[function(require,module,exports){
'use strict';

exports.__esModule = true;
var notify = require('./../../mixed/notify');
var modals = require('./../../mixed/modals');
exports['default'] = {
    filters: {
        momentTime: function momentTime(time) {
            return moment(time, "YYYY-MM-DD HH:mm:ss").format('h:m a');
        },
        formatHeader: function formatHeader(val) {
            return val.replace(/_/g, ' ').toUpperCase();
        }
    },
    data: function data() {
        return {
            orders: {},
            week1Ids: [],
            week2Ids: [],
            week3Ids: [],
            employee: {},
            shiftRemaining: 0,
            shiftRemainingSet: false
        };
    },
    ready: function ready() {
        var that = this;
        $(document).ready(function () {
            $('#employee-job-search').on('hidden.bs.modal', function () {
                that.week1Ids = [];
                that.week2Ids = [];
                that.week3Ids = [];
                that.shiftRemaining = 0;
                that.shiftRemainingSet = false;
            });
        });
    },
    props: ['activeEmployee'],
    events: {
        'employeeJobSearchEvent': function employeeJobSearchEvent() {
            this.fetchOrders();
        },
        'clearOrders': function clearOrders() {
            this.orders = {};
        }
    },
    methods: {
        checkItem: function checkItem(arr, item) {
            var limit = arguments.length <= 2 || arguments[2] === undefined ? 0 : arguments[2];

            var status = false;
            if (this[arr].length > limit) {
                status = !this[arr].includes(item.toString());
            }

            return status;
        },

        fetchOrders: function fetchOrders() {
            var _this = this;

            var modal = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];

            notify.loading(true);
            this.$http.get('/api/employee-job-search/' + this.activeEmployee.id, '', function (response) {
                if (!_this.shiftRemainingSet) {
                    _this.shiftRemaining = response.remainingShift;
                    _this.shiftRemainingSet = true;
                }
                _this.orders = response;
            }).always(function () {
                notify.loading(false);
            });
        },

        addEmployeeToOrders: function addEmployeeToOrders(week, ids) {
            var _this2 = this;

            var that = this;
            var selectedOrders = _.filter(this.orders[week], function (o) {
                return that[ids].includes(o.order_id.toString());
            });
            notify.loading(true);
            this.$http.post('/api/employee-add-to-requested-order', { employees: selectedOrders }, function (response) {
                _this2.$parent.getOrders();
                _this2.$parent.employeeOrderRecords(_this2.activeEmployee, '', '', false);
            }).always(function () {
                _this2.fetchOrders();
                notify.loading(false);
            });
        }
    }
};
module.exports = exports['default'];
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n    <div class=\"row\" v-if=\"!orders.message\">\n        <div class=\"col-md-4\">\n            <h1 class=\"text-center\">Jobs - Week 1 ({{shiftRemaining}})</h1>\n            <div class=\"table-responsive\">\n                <table class=\"table table-xxs\">\n                    <thead>\n                    <tr>\n                        <th>#</th>\n                        <th>Company Code</th>\n                        <th>Job Title</th>\n                        <th>Date</th>\n                        <th>In Time</th>\n                        <th>Rate</th>\n                    </tr>\n                    </thead>\n                    <tbody>\n                    <tr v-for=\"order in orders.week_1\">\n                        <td><input type=\"checkbox\" name=\"\" v-model=\"week1Ids\" value=\"{{order.order_id}}\" :disabled=\"checkItem('week1Ids',order.order_id,(shiftRemaining - 1))\"></td>\n                        <td>{{ order.company_code}}</td>\n                        <td>{{ order.title }}</td>\n                        <td>{{ order.date }}</td>\n                        <td>{{ order.in_time | momentTime }}</td>\n                        <td>{{order.rate}}</td>\n                    </tr>\n                    </tbody>\n                </table>\n                <button v-if=\"orders.week_1\" v-on:click=\"addEmployeeToOrders('week_1','week1Ids')\" type=\"button\" class=\"btn btn-primary pull-right mt-10\">Add\n                </button>\n            </div>\n        </div>\n\n        <div class=\"col-md-4\">\n            <h1 class=\"text-center\">Jobs - Week 2 (1)</h1>\n            <div class=\"table-responsive\">\n                <table class=\"table table-xxs\">\n                    <thead>\n                    <tr>\n                        <th>#</th>\n                        <th>Company Code</th>\n                        <th>Job Title</th>\n                        <th>Date</th>\n                        <th>In Time</th>\n                        <th>Rate</th>\n                    </tr>\n                    </thead>\n                    <tbody>\n                    <tr v-for=\"order in orders.week_2\">\n                        <td><input type=\"checkbox\" name=\"\" v-model=\"week2Ids\" value=\"{{order.order_id}}\" :disabled=\"checkItem('week2Ids',order.order_id)\"></td>\n                        <td>{{ order.company_code}}</td>\n                        <td>{{ order.title }}</td>\n                        <td>{{ order.date }}</td>\n                        <td>{{ order.in_time | momentTime }}</td>\n                        <td>{{order.rate}}</td>\n                    </tr>\n                    </tbody>\n                </table>\n                <button v-if=\"orders.week_2\" type=\"button\" v-on:click=\"addEmployeeToOrders('week_2','week2Ids')\" class=\"btn btn-primary pull-right mt-10\">Add\n                </button>\n            </div>\n        </div>\n\n        <div class=\"col-md-4\">\n            <h1 class=\"text-center\">Jobs - Week 3 (1)</h1>\n            <div class=\"table-responsive\">\n                <table class=\"table table-xxs\">\n                    <thead>\n                    <tr>\n                        <th>#</th>\n                        <th>Company Code</th>\n                        <th>Job Title</th>\n                        <th>Date</th>\n                        <th>In Time</th>\n                        <th>Rate</th>\n                    </tr>\n                    </thead>\n                    <tbody>\n                    <tr v-for=\"order in orders.week_3\">\n                        <td><input type=\"checkbox\" name=\"\" v-model=\"week3Ids\" value=\"{{order.order_id}}\" :disabled=\"checkItem('week3Ids',order.order_id)\"></td>\n                        <td>{{ order.company_code}}</td>\n                        <td>{{ order.title }}</td>\n                        <td>{{ order.date }}</td>\n                        <td>{{ order.in_time | momentTime }}</td>\n                        <td>{{order.rate}}</td>\n                    </tr>\n                    </tbody>\n                </table>\n                <button v-if=\"orders.week_3\" type=\"button\" v-on:click=\"addEmployeeToOrders('week_3','week3Ids')\" class=\"btn btn-primary pull-right mt-10\">Add\n                </button>\n            </div>\n        </div>\n    </div>\n    <div class=\"row\" v-else=\"\">\n        <h2 class=\"text-center\">{{orders.message}}</h2>\n    </div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  var id = "/home/shoieb/sites/elegant/resources/assets/js/vue/components/employeeSearchJob.vue"
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, module.exports.template)
  }
})()}
},{"./../../mixed/modals":10,"./../../mixed/notify":11,"vue":5,"vue-hot-reload-api":4}],52:[function(require,module,exports){
var __vueify_style__ = require("vueify-insert-css").insert("\na[_v-b99fe366]:hover, a[_v-b99fe366]:focus {\n  color: #fff;\n  text-decoration: none;\n}\n\n")
"use strict";

exports.__esModule = true;
var modals = require("./../../mixed/modals");
var notify = require("./../../mixed/notify");

exports["default"] = {
  data: function data() {
    return {
      employees: {}
    };
  },
  props: ['full', 'empty'],
  filters: {},
  watch: {},
  ready: function ready() {},

  events: {},

  methods: {
    orderModal: function orderModal() {
      window.bus.$emit("showAddOrderModal");
    },

    parse: function parse(data) {
      return JSON.parse(data);
    }
  }
};
module.exports = exports["default"];
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n  <div _v-b99fe366=\"\">\n    <!-- Content area -->\n    <div class=\"content p-5\" _v-b99fe366=\"\">\n      <div class=\"row\" _v-b99fe366=\"\">\n\n        <div class=\"col-md-4 col-sm-4 min-height-70 mt-10 \" v-for=\"order in parse(full)\" _v-b99fe366=\"\">\n          <div class=\"col-md-12 col-sm-12 no-padding-left no-padding-right manager-client-bg radius-left radius-right\" _v-b99fe366=\"\">\n            <div class=\"col-md-9 col-sm-9 font-white v-middle font-16 text-black min-height-70\" _v-b99fe366=\"\">\n              <a class=\"font-white text-decoration-none\" :href=\"'/field-manager/client-board/'+order.client_id\" _v-b99fe366=\"\">{{\n                  order.name\n                }}</a>\n            </div>\n            <div class=\"col-md-3 col-sm-3 min-height-70\" _v-b99fe366=\"\">\n              <div class=\"col-md-6-col-sm-6 text-primary-400 text-black pt-10 font-15 text-right\" _v-b99fe366=\"\">\n                {{ order.confirmed }}\n              </div>\n              <div class=\"col-md-6-col-sm-6 text-orange-400 text-black pt-5 font-15 text-right\" _v-b99fe366=\"\">{{ order.required }}\n              </div>\n            </div>\n          </div>\n        </div>\n\n      </div>\n\n\n      <div class=\"row mt-10 pt-20\" _v-b99fe366=\"\">\n        <div class=\"col-md-4 col-sm-4 min-height-70 mt-10 cursor-pointer\" v-for=\"order in parse(empty)\" _v-b99fe366=\"\">\n          <div class=\"col-md-12 col-sm-12 font-white v-middle font-16 text-black manager-empty-client-bg min-height-70 radius-left radius-right\" _v-b99fe366=\"\">\n            {{ order.name }}\n          </div>\n        </div>\n      </div>\n\n\n    </div>\n  </div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  var id = "/home/shoieb/sites/elegant/resources/assets/js/vue/components/field-manager-dashboard.vue"
  module.hot.dispose(function () {
    require("vueify-insert-css").cache["\na[_v-b99fe366]:hover, a[_v-b99fe366]:focus {\n  color: #fff;\n  text-decoration: none;\n}\n\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, module.exports.template)
  }
})()}
},{"./../../mixed/modals":10,"./../../mixed/notify":11,"vue":5,"vue-hot-reload-api":4,"vueify-insert-css":6}],53:[function(require,module,exports){
var __vueify_style__ = require("vueify-insert-css").insert("\n\n.h-60[_v-05be1a1c] {\n  height: 60px;\n}\n\n.w-180[_v-05be1a1c] {\n  width: 180px;\n}\n\n.w-70[_v-05be1a1c] {\n  width: 70px;\n}\n\n.blue-nav[_v-05be1a1c] {\n  background-color: #0075b6;\n}\n\n.blue-nav > a[_v-05be1a1c] {\n  color: #fff;\n  font-weight: bolder;\n  text-align: center;\n}\n\n.blue-nav > a[_v-05be1a1c]:hover, .blue-nav > a[_v-05be1a1c]:focus {\n  text-decoration: none;\n  background-color: #0075b6 !important;\n}\n\n\n.orange-nav[_v-05be1a1c] {\n  background-color: #d96029;\n  text-align: center;\n}\n\n.orange-nav > a[_v-05be1a1c] {\n  color: #fff;\n  font-weight: bolder;\n}\n\n.orange-nav > a[_v-05be1a1c]:hover, .orange-nav > a[_v-05be1a1c]:focus {\n  text-decoration: none;\n  background-color: #d96029 !important;\n}\n\n\n.green-nav[_v-05be1a1c] {\n  background-color: #00a792;\n  text-align: center;\n}\n\n.green-nav > a[_v-05be1a1c] {\n  color: #fff;\n  font-weight: bolder;\n}\n\n.green-nav > a[_v-05be1a1c]:hover, .green-nav > a[_v-05be1a1c]:focus {\n  text-decoration: none;\n  background-color: #00a792 !important;\n}\n\n\n.black-nav[_v-05be1a1c] {\n  background-color: #1b1b25;\n  text-align: center;\n}\n\n.black-nav > a[_v-05be1a1c] {\n  color: #fff;\n  font-weight: bolder;\n}\n\n.black-nav > a[_v-05be1a1c]:hover, .black-nav > a[_v-05be1a1c]:focus {\n  text-decoration: none;\n  background-color: #1b1b25 !important;\n}\n")
"use strict";

exports.__esModule = true;
var modals = require("./../../mixed/modals");
var notify = require("./../../mixed/notify");

exports["default"] = {
  data: function data() {
    return {
      employees: {}
    };
  },
  props: ['user'],
  filters: {},
  watch: {},
  ready: function ready() {},

  events: {},

  methods: {
    orderModal: function orderModal() {
      window.bus.$emit("showAddOrderModal");
    }
  }
};
module.exports = exports["default"];
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n  <div _v-05be1a1c=\"\">\n    <ul class=\"nav navbar-nav no-margin-left\" _v-05be1a1c=\"\">\n\n      <li class=\"black-nav border-right border-white border-2 w-70 h-60 p-5\" _v-05be1a1c=\"\">\n        <a href=\"/field-manager/dashboard\" class=\"\" _v-05be1a1c=\"\">\n          <i class=\"fa fa-home font-20\" _v-05be1a1c=\"\"></i>\n        </a>\n      </li>\n\n      <li class=\"blue-nav border-right border-white border-2 w-180 h-60 p-5\" _v-05be1a1c=\"\">\n        <a @click=\"orderModal()\" class=\"font-15\" _v-05be1a1c=\"\">\n          <img src=\"/images/icons/icon_placeorder.png\" class=\"mb-5 pr-10\" height=\"15\" alt=\"\" _v-05be1a1c=\"\"> Place\n          Order\n        </a>\n      </li>\n\n      <li class=\"orange-nav border-right border-white border-2 w-180 h-60 p-5\" _v-05be1a1c=\"\">\n        <a href=\"#\" class=\"font-15\" _v-05be1a1c=\"\">\n          <img src=\"/images/icons/icon_emp_noshow.png\" class=\"mb-5 pr-10\" height=\"15\" alt=\"\" _v-05be1a1c=\"\"> No Show\n        </a>\n      </li>\n\n      <li class=\"green-nav border-right border-white border-2 w-180 h-60 p-5\" _v-05be1a1c=\"\">\n        <a href=\"#\" class=\"font-15\" _v-05be1a1c=\"\">\n          <img src=\"/images/icons/icon_emp.png\" class=\"mb-5 pr-10\" height=\"15\" alt=\"\" _v-05be1a1c=\"\"> Employees\n        </a>\n      </li>\n\n      <li class=\"black-nav border-right border-white border-2 w-180 h-60 p-5\" _v-05be1a1c=\"\">\n        <a href=\"#\" class=\"font-15\" _v-05be1a1c=\"\">\n          <img src=\"/images/icons/icon_history.png\" class=\"mb-5 pr-10\" height=\"15\" alt=\"\" _v-05be1a1c=\"\"> Menu\n        </a>\n      </li>\n\n    </ul>\n\n    <ul class=\"nav navbar-nav navbar-right\" _v-05be1a1c=\"\">\n      <li class=\"black-nav w-180 p-5\" _v-05be1a1c=\"\">\n        <a href=\"#\" class=\"font-15\" _v-05be1a1c=\"\">\n          Manager Name\n        </a>\n      </li>\n    </ul>\n\n  </div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  var id = "/home/shoieb/sites/elegant/resources/assets/js/vue/components/field-manager-nav.vue"
  module.hot.dispose(function () {
    require("vueify-insert-css").cache["\n\n.h-60[_v-05be1a1c] {\n  height: 60px;\n}\n\n.w-180[_v-05be1a1c] {\n  width: 180px;\n}\n\n.w-70[_v-05be1a1c] {\n  width: 70px;\n}\n\n.blue-nav[_v-05be1a1c] {\n  background-color: #0075b6;\n}\n\n.blue-nav > a[_v-05be1a1c] {\n  color: #fff;\n  font-weight: bolder;\n  text-align: center;\n}\n\n.blue-nav > a[_v-05be1a1c]:hover, .blue-nav > a[_v-05be1a1c]:focus {\n  text-decoration: none;\n  background-color: #0075b6 !important;\n}\n\n\n.orange-nav[_v-05be1a1c] {\n  background-color: #d96029;\n  text-align: center;\n}\n\n.orange-nav > a[_v-05be1a1c] {\n  color: #fff;\n  font-weight: bolder;\n}\n\n.orange-nav > a[_v-05be1a1c]:hover, .orange-nav > a[_v-05be1a1c]:focus {\n  text-decoration: none;\n  background-color: #d96029 !important;\n}\n\n\n.green-nav[_v-05be1a1c] {\n  background-color: #00a792;\n  text-align: center;\n}\n\n.green-nav > a[_v-05be1a1c] {\n  color: #fff;\n  font-weight: bolder;\n}\n\n.green-nav > a[_v-05be1a1c]:hover, .green-nav > a[_v-05be1a1c]:focus {\n  text-decoration: none;\n  background-color: #00a792 !important;\n}\n\n\n.black-nav[_v-05be1a1c] {\n  background-color: #1b1b25;\n  text-align: center;\n}\n\n.black-nav > a[_v-05be1a1c] {\n  color: #fff;\n  font-weight: bolder;\n}\n\n.black-nav > a[_v-05be1a1c]:hover, .black-nav > a[_v-05be1a1c]:focus {\n  text-decoration: none;\n  background-color: #1b1b25 !important;\n}\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, module.exports.template)
  }
})()}
},{"./../../mixed/modals":10,"./../../mixed/notify":11,"vue":5,"vue-hot-reload-api":4,"vueify-insert-css":6}],54:[function(require,module,exports){
var __vueify_style__ = require("vueify-insert-css").insert("\n.re-confirm > div.col-md-12[_v-6ea7e0fb],\n.re-confirm > div.col-md-6[_v-6ea7e0fb],\n.re-confirm > div.col-md-12[_v-6ea7e0fb] {\n  padding: 0 !important;\n}\n\n.bordered-div[_v-6ea7e0fb] {\n  border-left: 1px solid #ddd;\n  border-right: 1px solid #ddd;\n}\n\n.bordered-left[_v-6ea7e0fb] {\n  border-left: 1px solid #ddd;\n}\n\n.bordered-right[_v-6ea7e0fb] {\n  border-right: 1px solid #ddd;\n}\n\n.bordered-bottom[_v-6ea7e0fb] {\n  border-bottom: 1px solid #ddd;\n}\n\n.fixed-header[_v-6ea7e0fb] {\n  position: fixed;\n  top: 48px;\n  right: 0px;\n  z-index: 1000 !important;\n}\n\n.middle-div[_v-6ea7e0fb] {\n  width: 60% !important;\n  right: 20% !important;\n}\n\n.div-20[_v-6ea7e0fb] {\n  width: 20% !important;\n}\n\n.div-60[_v-6ea7e0fb] {\n  width: 60% !important;\n}\n\n.top-120[_v-6ea7e0fb] {\n  top: 120px;\n}\n\n.list-div[_v-6ea7e0fb] {\n  margin-bottom: 40px;\n  min-height: 900px !important;\n}\n\n.bottom-div[_v-6ea7e0fb] {\n  position: fixed;\n  bottom: 0px;\n  right: 0px;\n  z-index: 1000 !important;\n  height: 40px !important;\n  width: 100%;\n}\n\n.mb-40[_v-6ea7e0fb] {\n  margin-bottom: 40px !important;\n}\n\n.border-custom-grey[_v-6ea7e0fb] {\n  border-color: #ddd !important;\n}\n\n.h-30[_v-6ea7e0fb] {\n  min-height: 35px !important;\n}\n")
"use strict";

exports.__esModule = true;
var modals = require("./../../mixed/modals");
var notify = require("./../../mixed/notify");

exports["default"] = {
  data: function data() {
    return {
      dates: [],
      tab: 'due',
      startDate: '',
      endDate: '',
      state: false,
      employees: {},
      collectedEmployees: {},
      submittedEmployees: {},
      filteredEmployees: {},
      clients: {},
      order: {
        client_id: "",
        position_code: ""
      },
      week: '',
      date: '',
      activeClient: {},
      issues: {
        in_hour: '1',
        in_minute: '00',
        in_format: 'PM',
        out_hour: '1',
        out_minute: '00',
        out_format: 'PM',
        "break": '',
        note: ''
      },
      hours: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
      minutes: ['00', '05', '10', '15', '20', '25', '30', '35', '40', '45', '50', '55', '60'],
      breaks: ['00', '05', '10', '15', '20', '25', '30', '35', '40', '45', '50', '55', '60', '65', '70', '75', '80', '85', '90']
    };
  },

  props: ['tablet', 'desktop'],

  computed: {

    updatedEmployees: function updatedEmployees() {
      return _.filter(this.employees, function (o) {
        return o.worked || o.no_show;
      });
    },

    updatedCollectedEmployees: function updatedCollectedEmployees() {
      return _.filter(this.collectedEmployees, function (o) {
        return o.checked;
      });
    },

    employeeGroups: function employeeGroups() {
      return _.groupBy(this.employees, "department_id");
    },

    collectedEmployeeGroups: function collectedEmployeeGroups() {
      return _.groupBy(this.collectedEmployees, "department_id");
    },

    selected: function selected() {
      var selected = 0;
      _.forEach(this.employees, function (employeeGroup) {
        selected += _.size(_.filter(employeeGroup, function (o) {
          return o.approved || o.rejected;
        }));
      });

      return selected;
    }
  },
  filters: {},
  watch: {
    "date": function date(val) {
      this.getReConfirmedEmployees(val);
    },

    "tab": function tab(val) {
      this.setFilteredEmployees(val);
    },

    clients: function clients() {
      $("#position-client").selectric("refresh");
    },

    activeClient: function activeClient() {
      //   $("#position-code").selectric("refresh");
    },
    "order.position_code": function orderPosition_code(val) {
      this.getReConfirmedEmployees(val);
    }
  },
  ready: function ready() {
    //$(".table").fixedHeader();
    this.getMissingTimecards();
    this.getSubmittedTimecards();
  },
  events: {},
  methods: {

    /**
     * get employee report data
     */
    getSubmittedTimecards: function getSubmittedTimecards() {
      var _this = this;

      notify.loading(true);
      this.$http.get("/api/submitted-time-cards", function (response) {
        _this.submittedEmployees = response;
        _this.setFilteredEmployees('pending');
      }).always(function () {
        notify.loading(false);
      });
    },

    setFilteredEmployees: function setFilteredEmployees(tab) {

      var employees = '';
      if (tab === 'pending') {
        employees = _.filter(this.submittedEmployees, function (o) {
          return !o.paid && o.approved && !o.rejected;
        });
      }

      if (tab === 'approved') {
        employees = _.filter(this.submittedEmployees, function (o) {
          return o.paid && o.approved;
        });
      }

      if (tab === 'rejected') {
        employees = _.filter(this.submittedEmployees, function (o) {
          return !o.paid && !o.approved && o.rejected;
        });
      }

      this.filteredEmployees = employees;
    },

    /**
     * confirmation before verifying an order
     * @param emp
     */
    confirmVerifyPayment: function confirmVerifyPayment(emp) {
      this.activeEmployee = _.cloneDeep(emp);
      notify.prompt('Are you sure?', '', this.makePaid);
    },

    /**
     * update list based on user entry
     */
    makePaid: function makePaid() {
      var _this2 = this;

      notify.loading(true);
      this.$http.get("/api/time-cards-make-paid/" + this.activeEmployee.employee_order_issue_id, function (response) {
        notify.loading(false);
        _this2.getSubmittedTimecards();
      }).always(function () {
        //notify.loading(false);
      });
    },

    countCollections: function countCollections(departmentId, date) {
      var due = 0;
      _.forEach(this.employees, function (employeeGroup) {
        due += _.size(_.filter(employeeGroup, {
          'department_id': departmentId, 'date': date, 'worked': 0, 'no_show': 0
        }));
      });

      var collected = 0;

      _.forEach(this.collectedEmployees, function (employeeGroup) {
        collected += _.size(_.filter(employeeGroup, function (o) {
          return o.department_id === departmentId && o.date === date && (o.worked || o.no_show);
        }));
      });

      return collected + ' / ' + (collected + due);
    },

    setTab: function setTab(val) {
      this.tab = val;
    },

    groupByDate: function groupByDate(data) {
      return _.groupBy(data, "date");
    },

    groupByCustom: function groupByCustom(data, column) {
      return _.groupBy(data, column);
    },

    /**
     * get employee report data
     */
    getMissingTimecards: function getMissingTimecards() {
      var _this3 = this;

      notify.loading(true);
      this.$http.get("/api/missing-time-cards", function (response) {
        _this3.employees = response;
      }).always(function () {
        notify.loading(false);
      });
    },

    showIssuesModal: function showIssuesModal(data) {
      this.issues = _.cloneDeep(data);
      modals.showStrict("#issues-modal");
    },

    updateOrderIssue: function updateOrderIssue() {
      var _this4 = this;

      this.$http.post("/api/create-employee_order-issue", {
        in_hour: this.issues.in_hour,
        in_minute: this.issues.in_minute,
        in_format: this.issues.in_format,
        out_hour: this.issues.out_hour,
        out_minute: this.issues.out_minute,
        out_format: this.issues.out_format,
        "break": this.issues["break"],
        note: this.issues.note,
        employee_order_status_log_id: this.issues.id
      }, function (response) {
        modals.hide("#issues-modal");
        _this4.getMissingTimecards();
      }).always(function () {});
    },

    /**
     * confirmation before verifying an order
     * @param emp
     */
    verifyUpdate: function verifyUpdate() {
      notify.prompt('Are you sure?', '', this.updateList);
    },

    /**
     * update list based on user entry
     */
    updateList: function updateList() {
      var _this5 = this;

      notify.loading(true);
      this.$http.post("/api/update-missing-time-cards", this.employees, function (response) {
        notify.loading(false);
        _this5.getMissingTimecards();
        _this5.getSubmittedTimecards();
      }).always(function () {
        //notify.loading(false);
      });
    }
  }
};
module.exports = exports["default"];
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n  <div class=\"row re-confirm no-margin\" _v-6ea7e0fb=\"\">\n    <div v-if=\"tab === 'due'\" class=\"col-md-12 col-xs-12 no-padding-left no-padding-right\" _v-6ea7e0fb=\"\">\n      <div :class=\"{'middle-div' : desktop == '1'}\" class=\"col-md-12 no-padding-left no-padding-right fixed-header \" _v-6ea7e0fb=\"\">\n        <table class=\"table table-xxs\" _v-6ea7e0fb=\"\">\n          <thead class=\"header\" _v-6ea7e0fb=\"\">\n          <tr _v-6ea7e0fb=\"\">\n            <th class=\"bg-white text-center\" colspan=\"8\" _v-6ea7e0fb=\"\">\n              <span class=\"text-uppercase text-color-black text-center font-20\" _v-6ea7e0fb=\"\">Missing Timecards</span>\n            </th>\n          </tr>\n          <tr _v-6ea7e0fb=\"\">\n            <th class=\"mt-20 mb-10 bg-white no-padding-right text-right\" colspan=\"8\" _v-6ea7e0fb=\"\">\n              <button :class=\"{'btn-primary':tab === 'due', 'btn-danger':tab === 'collected'}\" class=\"btn  pull-right text-black\" @click=\"verifyUpdate\" _v-6ea7e0fb=\"\">\n\n                {{ tab === 'due' ? 'SAVE' : 'UNDO' }}\n              </button>\n            </th>\n          </tr>\n          <tr _v-6ea7e0fb=\"\">\n            <th class=\"col-md-2 bg-slate-800 text-black text-uppercase text-left\" _v-6ea7e0fb=\"\"></th>\n            <th class=\"col-md-2 bg-slate-800 text-black text-uppercase text-left\" _v-6ea7e0fb=\"\"></th>\n            <th class=\"col-md-2 bg-slate-800 text-black text-uppercase text-center border-left\" _v-6ea7e0fb=\"\">In</th>\n            <th class=\"col-md-2 bg-slate-800 text-black text-uppercase text-left\" _v-6ea7e0fb=\"\">Out</th>\n            <th class=\"col-md-1 bg-slate-800 text-black text-uppercase text-left border-right\" _v-6ea7e0fb=\"\">Break</th>\n            <th class=\"col-md-1 bg-slate-800 text-black text-uppercase text-left\" _v-6ea7e0fb=\"\">Note</th>\n            <th class=\"col-md-1 bg-green-700 text-black text-center no-padding-left no-padding-right text-black\" _v-6ea7e0fb=\"\">Approved\n            </th>\n            <th class=\"col-md-1 bg-danger-700 text-black text-uppercase text-center no-padding-left no-padding-right text-black\" _v-6ea7e0fb=\"\">Rejected\n            </th>\n          </tr>\n          </thead>\n          <tbody _v-6ea7e0fb=\"\"></tbody>\n        </table>\n      </div>\n\n      <div v-if=\" desktop == '1'\" class=\"col-md-3 div-20\" _v-6ea7e0fb=\"\"></div>\n\n      <div v-show=\"tab === 'due'\" :class=\"{'col-md-7 div-60' : desktop == '1', 'col-md-12 ' : tablet =='1',}\" class=\"bordered-div  no-padding-left no-padding-right top-120 list-div \" _v-6ea7e0fb=\"\">\n        <div v-for=\"(index,employeeByClient) in employees\" :key=\"index\" class=\"col-md-12 bordered-div no-padding-left no-padding-right\" _v-6ea7e0fb=\"\">\n          <div v-for=\"(index,groupedEmployees) in groupByCustom(employeeByClient,'department_name')\" :key=\"index\" class=\"col-md-12 bordered-div no-padding-left no-padding-right\" _v-6ea7e0fb=\"\">\n            <div class=\"col-md-12\" _v-6ea7e0fb=\"\">\n          <span class=\"\" _v-6ea7e0fb=\"\">\n               <span class=\"text-danger text-black font-12\" _v-6ea7e0fb=\"\">{{ groupedEmployees[0].client_name }}</span> <br _v-6ea7e0fb=\"\">\n              <span class=\"text-primary text-black text-italic font-12\" _v-6ea7e0fb=\"\">{{ groupedEmployees[0].department_name }}</span>\n            </span>\n            </div>\n            <div v-for=\"(index,employee) in groupByDate(groupedEmployees)\" :key=\"index\" class=\"col-md-12 no-padding-left no-padding-right bg-white\" _v-6ea7e0fb=\"\">\n              <div class=\"col-md-12 text-left text-color-black  no-padding-left no-padding-right mt-5 mb-10\" _v-6ea7e0fb=\"\">\n            <span class=\"pl-10\" _v-6ea7e0fb=\"\">\n               <span class=\"text-black font-12 pr-5\" _v-6ea7e0fb=\"\">{{ employee[0].day }} {{ employee[0].custom_date }}</span> <span class=\"font-12\" _v-6ea7e0fb=\"\">({{ countCollections(employee[0].department_id, employee[0].date) }})</span> <br _v-6ea7e0fb=\"\">\n            </span>\n              </div>\n              <div v-for=\"(ind,emp) in employee\" :key=\"ind\" class=\"col-md-12 no-padding border-top border-custom-grey\" _v-6ea7e0fb=\"\">\n                <div class=\"col-md-2 text-center table-padding text-italic font-12 h-30\" _v-6ea7e0fb=\"\">{{ emp.title }}\n                </div>\n\n                <div class=\"col-md-2  text-left table-padding font-14 h-30 cursor-pointer\" @click=\"showIssuesModal(emp)\" _v-6ea7e0fb=\"\"><span class=\"pr-3 font-12 text-italic\" _v-6ea7e0fb=\"\">{{ emp.pay_rate }}</span><span class=\"pl-5\" _v-6ea7e0fb=\"\">{{ emp.name }}</span>\n                </div>\n\n                <div class=\"col-md-2 text-center table-padding border-left border-custom-grey h-30\" _v-6ea7e0fb=\"\">{{ emp.in_hour + ':' + emp.in_minute + ' ' + emp.in_format }}\n                </div>\n\n                <div class=\"col-md-2  text-left table-padding h-30\" _v-6ea7e0fb=\"\">{{ emp.out_hour + ':' + emp.out_minute + ' ' + emp.out_format }}\n                </div>\n\n                <div class=\"col-md-1  text-left table-padding border-right border-custom-grey h-30\" _v-6ea7e0fb=\"\">{{ emp.break }}\n                </div>\n\n                <div :title=\"emp.note\" class=\"col-md-1  text-left table-padding h-30\" _v-6ea7e0fb=\"\">View\n                </div>\n\n                <div class=\"col-md-1 text-center no-padding-left no-padding-right table-padding h-30\" _v-6ea7e0fb=\"\">\n                  <input v-if=\"!emp.rejected\" v-model=\"emp.approved\" :disabled=\"(selected > 0) &amp;&amp; (!emp.approved &amp;&amp; !emp.rejected)\" :value=\"emp.approved\" type=\"checkbox\" _v-6ea7e0fb=\"\">\n                </div>\n                <div class=\"col-md-1 text-center table-padding h-30\" _v-6ea7e0fb=\"\">\n                  <input v-if=\"!emp.approved\" v-model=\"emp.rejected\" :disabled=\"(selected > 0) &amp;&amp; (!emp.approved &amp;&amp; !emp.rejected)\" :value=\"emp.rejected\" type=\"checkbox\" _v-6ea7e0fb=\"\">\n                </div>\n              </div>\n              <div class=\"col-md-12 border-bottom border-custom-grey mb-40\" _v-6ea7e0fb=\"\"></div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n\n\n    <div v-if=\"tab !== 'due'\" class=\"col-md-12 col-sm-12 col-xs-12 no-padding-left no-padding-right\" _v-6ea7e0fb=\"\">\n      <div class=\"col-md-12 col-sm-12 col-xs-12 no-padding-left no-padding-right fixed-header \" _v-6ea7e0fb=\"\">\n        <table class=\"table table-xxs\" _v-6ea7e0fb=\"\">\n          <thead class=\"header\" _v-6ea7e0fb=\"\">\n          <tr _v-6ea7e0fb=\"\">\n            <th class=\"bg-white text-center\" colspan=\"12\" _v-6ea7e0fb=\"\">\n              <span class=\"text-uppercase text-color-black text-center font-20\" _v-6ea7e0fb=\"\">Submitted Timecards</span>\n            </th>\n          </tr>\n          <tr _v-6ea7e0fb=\"\">\n            <th class=\"col-md-3 bg-slate-800 text-black text-uppercase text-left\" _v-6ea7e0fb=\"\">Client</th>\n            <th class=\"col-md-1 bg-slate-800 text-black text-uppercase text-left border-left\" _v-6ea7e0fb=\"\">Date</th>\n            <th class=\"col-md-1 bg-slate-800 text-black text-uppercase text-left border-left\" _v-6ea7e0fb=\"\">Job</th>\n            <th class=\"col-md-2 bg-slate-800 text-black text-uppercase text-left border-left\" _v-6ea7e0fb=\"\">Employee</th>\n            <th class=\"col-md-1 bg-slate-800 text-black text-uppercase text-left border-left\" _v-6ea7e0fb=\"\">In</th>\n            <th class=\"col-md-1 bg-slate-800 text-black text-uppercase text-left border-left\" _v-6ea7e0fb=\"\">Out</th>\n            <th class=\"col-md-0-5 bg-slate-800 text-black text-uppercase text-left border-left\" _v-6ea7e0fb=\"\">Break</th>\n            <th class=\"col-md-0-5 bg-slate-800 text-black text-uppercase text-left border-left\" _v-6ea7e0fb=\"\">Total</th>\n            <th class=\"col-md-0-5 bg-slate-800 text-black text-uppercase text-left border-left\" _v-6ea7e0fb=\"\">Rate</th>\n            <th class=\"col-md-0-5 bg-slate-800 text-black text-uppercase text-left border-left\" _v-6ea7e0fb=\"\">Amount</th>\n            <th class=\"col-md-0-5 bg-slate-800 text-black text-uppercase text-left border-left\" _v-6ea7e0fb=\"\">Note\n            </th>\n            <th class=\"col-md-0-5 bg-primary text-black text-uppercase text-left border-left\" _v-6ea7e0fb=\"\">Done\n            </th>\n          </tr>\n          </thead>\n          <tbody _v-6ea7e0fb=\"\"></tbody>\n        </table>\n      </div>\n\n      <div class=\"col-md-12 col-sm-12 col-xs-12 bordered-div  no-padding-left no-padding-right top-90 list-div div-100\" _v-6ea7e0fb=\"\">\n        <div v-for=\"(ind,emp) in filteredEmployees\" :key=\"ind\" class=\"col-md-12 col-sm-12 col-xs-12 no-padding border-top border-custom-grey\" _v-6ea7e0fb=\"\">\n          <div class=\"col-md-3 col-sm-3 col-xs-3 text-left table-padding font-12 h-30\" _v-6ea7e0fb=\"\">{{ emp.client_name }}\n          </div>\n          <div class=\"col-md-1 col-sm-1 col-xs-1 text-left table-padding font-12 h-30\" _v-6ea7e0fb=\"\">{{ emp.custom_date }}\n          </div>\n          <div class=\"col-md-1 col-sm-1 col-xs-1 text-left table-padding font-12 h-30\" _v-6ea7e0fb=\"\">{{ emp.title }}\n          </div>\n          <div class=\"col-md-2 col-sm-2 col-xs-2 text-left table-padding font-12 h-30\" _v-6ea7e0fb=\"\">{{ emp.name }}\n          </div>\n          <div class=\"col-md-1 col-sm-1 col-xs-1 text-left table-padding font-12 h-30\" _v-6ea7e0fb=\"\">{{ emp.in_hour + ':' + emp.in_minute + ' ' + emp.in_format }}\n          </div>\n          <div class=\"col-md-1 col-sm-1 col-xs-1 text-left table-padding font-12 h-30\" _v-6ea7e0fb=\"\">{{ emp.out_hour + ':' + emp.out_minute + ' ' + emp.out_format }}\n          </div>\n          <div class=\"col-md-0-5 text-left table-padding font-12 h-30\" _v-6ea7e0fb=\"\">{{ emp.break ? emp.break : 0 }}\n          </div>\n          <div class=\"col-md-0-5 text-left table-padding font-12 h-30\" _v-6ea7e0fb=\"\">{{ emp.total }}\n          </div>\n          <div class=\"col-md-0-5 text-left table-padding font-12 h-30\" _v-6ea7e0fb=\"\">{{ emp.pay_rate }}\n          </div>\n          <div class=\"col-md-0-5 text-left table-padding font-12 h-30\" _v-6ea7e0fb=\"\">{{ emp.amount }}\n          </div>\n          <div class=\"col-md-0-5 text-left table-padding font-12 h-30\" _v-6ea7e0fb=\"\"><span :title=\"emp.note\" _v-6ea7e0fb=\"\">Note</span>\n          </div>\n          <div class=\"col-md-0-5 col-sm-1 col-xs-1 text-left table-padding font-12 h-30\" _v-6ea7e0fb=\"\">\n            <span v-if=\"emp.paid &amp;&amp; emp.approved\" class=\"text-black text-success \" _v-6ea7e0fb=\"\">Paid</span>\n            <span v-if=\"!emp.paid &amp;&amp; !emp.approved &amp;&amp; emp.rejected\" class=\"text-black text-danger \" _v-6ea7e0fb=\"\">Rejected</span>\n            <button v-if=\"!emp.paid &amp;&amp; emp.approved\" class=\"btn btn-primary\" @click=\"confirmVerifyPayment(emp)\" _v-6ea7e0fb=\"\">Pay\n            </button>\n          </div>\n\n        </div>\n        <div class=\"col-md-12 col-sm-12 col-xs-12 border-bottom border-custom-grey mb-40\" _v-6ea7e0fb=\"\"></div>\n\n      </div>\n    </div>\n\n\n    <div class=\"col-md-12 col-sm-12 col-xs-12 text-center no-padding-left no-padding-right bottom-div pt-2 bg-slate\" _v-6ea7e0fb=\"\">\n      <span :class=\"{'bg-slate-400 ' : tab === 'due'}\" class=\"font-20 pl-10 pr-10 pb-15 mt-5 cursor-pointer text-black text-color-black\" @click=\"setTab('due')\" _v-6ea7e0fb=\"\">Due</span>\n      <span :class=\"{'bg-slate-400 ' : tab === 'pending'}\" class=\"font-20 pl-10 pr-10 pb-15 mt-5 cursor-pointer text-black text-color-black\" @click=\"setTab('pending')\" _v-6ea7e0fb=\"\">Submitted</span>\n      <span :class=\"{'bg-slate-400 ' : tab === 'approved'}\" class=\"font-20 pl-10 pr-10 pb-15 mt-5 cursor-pointer text-black text-color-black\" @click=\"setTab('approved')\" _v-6ea7e0fb=\"\">Approved</span>\n      <span :class=\"{'bg-slate-400 ' : tab === 'rejected'}\" class=\"font-20 pl-10 pr-10 pb-15 mt-5 cursor-pointer text-black text-color-black\" @click=\"setTab('rejected')\" _v-6ea7e0fb=\"\">Rejected</span>\n    </div>\n\n\n    <div id=\"issues-modal\" aria-hidden=\"true\" aria-labelledby=\"exampleModalLabel\" class=\"modal fade\" role=\"dialog\" tabindex=\"-1\" _v-6ea7e0fb=\"\">\n      <div class=\"modal-dialog modal-lg\" role=\"document\" _v-6ea7e0fb=\"\">\n        <div class=\"modal-content modal-grey\" _v-6ea7e0fb=\"\">\n          <div class=\"modal-header no-padding bg-slate-700\" _v-6ea7e0fb=\"\">\n            <div class=\"col-md-6 col-sm-6 col-xs-6 p-5 text-black text-left font-14\" _v-6ea7e0fb=\"\">\n              <span _v-6ea7e0fb=\"\">{{ issues.client_name }}\n              <span class=\"text-orange-700\" _v-6ea7e0fb=\"\">( {{ issues.title }} )</span>\n              </span></div>\n            <div class=\"col-md-4 col-sm-4 col-xs-4 p-5 text-black text-right font-14\" _v-6ea7e0fb=\"\">\n              {{ issues.day }}, {{ issues.custom_date }}\n            </div>\n            <div class=\"col-md-2 col-sm-2 col-xs-2\" _v-6ea7e0fb=\"\"></div>\n            <button aria-label=\"Close\" class=\"close\" data-dismiss=\"modal\" type=\"button\" _v-6ea7e0fb=\"\">\n              <span aria-hidden=\"true\" _v-6ea7e0fb=\"\">×</span>\n            </button>\n          </div>\n          <div class=\"modal-body no-padding-left no-padding-right\" _v-6ea7e0fb=\"\">\n            <div class=\"col-md-4 col-sm-4 col-xs-4 text-black font-16 text-center no-padding-left pt-20 pb-20\" _v-6ea7e0fb=\"\">\n              Start Time\n            </div>\n            <div class=\"col-md-2 col-sm-2 col-xs-2 text-black font-16 text-center pt-20 pb-20\" _v-6ea7e0fb=\"\">\n              <select v-model=\"issues.in_hour\" class=\"form-control \" _v-6ea7e0fb=\"\">\n                <option v-for=\"item in hours\" :value=\"item\" _v-6ea7e0fb=\"\">{{ item }}</option>\n              </select>\n            </div>\n            <div class=\"col-md-2 col-sm-2 col-xs-2 text-black font-16 text-center no-padding-right pt-20 pb-20\" _v-6ea7e0fb=\"\">\n              <select v-model=\"issues.in_minute\" class=\"form-control\" _v-6ea7e0fb=\"\">\n                <option v-for=\"item in minutes\" :value=\"item\" _v-6ea7e0fb=\"\">{{ item }}</option>\n              </select>\n            </div>\n            <div class=\"col-md-2 col-sm-2 col-xs-2 text-black font-16 text-center pt-20 pb-20\" _v-6ea7e0fb=\"\">\n              <select v-model=\"issues.in_format\" class=\"form-control\" _v-6ea7e0fb=\"\">\n                <option value=\"AM\" _v-6ea7e0fb=\"\">AM</option>\n                <option value=\"PM\" _v-6ea7e0fb=\"\">PM</option>\n              </select>\n            </div>\n            <div class=\"col-md-2 col-sm-2 col-xs-2 text-black font-16 text-center no-padding-right pt-20 pb-20\" _v-6ea7e0fb=\"\">\n\n            </div>\n\n\n            <div class=\"col-md-4 col-sm-4 col-xs-4 text-black font-16 text-center no-padding-left pt-20 pb-20\" _v-6ea7e0fb=\"\">\n              End Time\n            </div>\n            <div class=\"col-md-2 col-sm-2 col-xs-2 text-black font-16 text-center pt-20 pb-20\" _v-6ea7e0fb=\"\">\n              <select v-model=\"issues.out_hour\" class=\"form-control\" _v-6ea7e0fb=\"\">\n                <option v-for=\"item in hours\" :value=\"item\" _v-6ea7e0fb=\"\">{{ item }}</option>\n              </select>\n            </div>\n            <div class=\"col-md-2 col-sm-2 col-xs-2 text-black font-16 text-center no-padding-right pt-20 pb-20\" _v-6ea7e0fb=\"\">\n              <select v-model=\"issues.out_minute\" class=\"form-control \" _v-6ea7e0fb=\"\">\n                <option v-for=\"item in minutes\" :value=\"item\" _v-6ea7e0fb=\"\">{{ item }}</option>\n              </select>\n            </div>\n            <div class=\"col-md-2 col-sm-2 col-xs-2 text-black font-16 text-center pt-20 pb-20\" _v-6ea7e0fb=\"\">\n              <select v-model=\"issues.out_format\" class=\"form-control \" _v-6ea7e0fb=\"\">\n                <option value=\"AM\" _v-6ea7e0fb=\"\">AM</option>\n                <option value=\"PM\" _v-6ea7e0fb=\"\">PM</option>\n              </select>\n            </div>\n            <div class=\"col-md-2 col-sm-2 col-xs-2 text-black font-16 text-center no-padding-right pt-20 pb-20\" _v-6ea7e0fb=\"\">\n\n            </div>\n\n            <div class=\"col-md-12 col-sm-12 col-xs-12 text-black\" _v-6ea7e0fb=\"\">\n              <div class=\"col-md-4 col-sm-4 col-xs-4 text-black font-16 text-center no-padding-left pt-20 pb-20\" _v-6ea7e0fb=\"\">\n                Break\n              </div>\n              <div class=\"col-md-3 col-sm-3 col-xs-3  no-padding-right pl-5 pt-20 pb-20\" _v-6ea7e0fb=\"\">\n                <select v-model=\"issues.break\" class=\"form-control \" _v-6ea7e0fb=\"\">\n                  <option v-for=\"item in breaks\" :value=\"item\" _v-6ea7e0fb=\"\">{{ item }}</option>\n                </select>\n              </div>\n              <div class=\"col-md-5 col-sm-5 col-xs-5  no-padding-right\" _v-6ea7e0fb=\"\">\n              </div>\n\n            </div>\n\n\n            <div class=\"col-md-12 col-sm-12 col-xs-12\" _v-6ea7e0fb=\"\">\n              <div class=\"col-md-2 col-sm-2 col-xs-2 text-black font-16 text-center no-padding-right pt-20 pb-20\" _v-6ea7e0fb=\"\">\n\n              </div>\n              <div class=\"col-md-8 col-sm-8 col-xs-8 p-40 no-padding-right\" _v-6ea7e0fb=\"\">\n                <textarea v-model=\"issues.note\" class=\"form-control\" cols=\"30\" name=\"\" rows=\"6\" _v-6ea7e0fb=\"\"></textarea>\n              </div>\n            </div>\n\n            <div class=\"col-md-12 col-sm-12 col-xs-12\" _v-6ea7e0fb=\"\">\n              <div class=\"col-md-2 col-sm-2 col-xs-2 text-black font-16 text-center no-padding-right pt-20 pb-20\" _v-6ea7e0fb=\"\">\n\n              </div>\n              <div class=\"col-md-8 col-sm-8 col-xs-8 p-40 no-padding-right text-right pt-10 mt-10\" _v-6ea7e0fb=\"\">\n                <button class=\"btn btn-primary text-black p-5 no-padding-left border-white pl-10 pr-10\" @click=\"updateOrderIssue\" _v-6ea7e0fb=\"\">Save\n                </button>\n              </div>\n            </div>\n          </div>\n          <div class=\"modal-footer\" _v-6ea7e0fb=\"\">\n            <!--            <button class=\"btn btn-secondary\" data-dismiss=\"modal\" type=\"button\">Close</button>-->\n            <!--            <button class=\"btn btn-primary\" type=\"button\">Save changes</button>-->\n          </div>\n        </div>\n      </div>\n    </div>\n\n  </div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  var id = "/home/shoieb/sites/elegant/resources/assets/js/vue/components/missing-timecards.vue"
  module.hot.dispose(function () {
    require("vueify-insert-css").cache["\n.re-confirm > div.col-md-12[_v-6ea7e0fb],\n.re-confirm > div.col-md-6[_v-6ea7e0fb],\n.re-confirm > div.col-md-12[_v-6ea7e0fb] {\n  padding: 0 !important;\n}\n\n.bordered-div[_v-6ea7e0fb] {\n  border-left: 1px solid #ddd;\n  border-right: 1px solid #ddd;\n}\n\n.bordered-left[_v-6ea7e0fb] {\n  border-left: 1px solid #ddd;\n}\n\n.bordered-right[_v-6ea7e0fb] {\n  border-right: 1px solid #ddd;\n}\n\n.bordered-bottom[_v-6ea7e0fb] {\n  border-bottom: 1px solid #ddd;\n}\n\n.fixed-header[_v-6ea7e0fb] {\n  position: fixed;\n  top: 48px;\n  right: 0px;\n  z-index: 1000 !important;\n}\n\n.middle-div[_v-6ea7e0fb] {\n  width: 60% !important;\n  right: 20% !important;\n}\n\n.div-20[_v-6ea7e0fb] {\n  width: 20% !important;\n}\n\n.div-60[_v-6ea7e0fb] {\n  width: 60% !important;\n}\n\n.top-120[_v-6ea7e0fb] {\n  top: 120px;\n}\n\n.list-div[_v-6ea7e0fb] {\n  margin-bottom: 40px;\n  min-height: 900px !important;\n}\n\n.bottom-div[_v-6ea7e0fb] {\n  position: fixed;\n  bottom: 0px;\n  right: 0px;\n  z-index: 1000 !important;\n  height: 40px !important;\n  width: 100%;\n}\n\n.mb-40[_v-6ea7e0fb] {\n  margin-bottom: 40px !important;\n}\n\n.border-custom-grey[_v-6ea7e0fb] {\n  border-color: #ddd !important;\n}\n\n.h-30[_v-6ea7e0fb] {\n  min-height: 35px !important;\n}\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, module.exports.template)
  }
})()}
},{"./../../mixed/modals":10,"./../../mixed/notify":11,"vue":5,"vue-hot-reload-api":4,"vueify-insert-css":6}],55:[function(require,module,exports){
var __vueify_style__ = require("vueify-insert-css").insert("\n")
"use strict";

exports.__esModule = true;
var modals = require("./../../mixed/modals");
var notify = require("./../../mixed/notify");
exports["default"] = {
    data: function data() {
        return {
            state: false,
            types: ['A+', 'A', 'B', 'C', 'U'],
            backgroundTypes: ['A', 'B', 'C', 'U'],
            employees: {},
            employee: {},
            activeEmployee: {},
            positions: {},
            jobs: {},
            commonData: {
                uniforms: []
            },
            currentEmployee: {
                first_name: '',
                middle_name: '',
                last_name: '',
                employee_code: '',
                dob: '',
                ss: '',
                tax_id: '',
                marital_status: '',
                no_of_dependent: '',
                gender: '',
                street: '',
                apt: '',
                city: '',
                state: '',
                zip_code: '',
                primary_phone: '',
                secondary_phone: '',
                email: '',
                email_notification: 0,
                password: '',
                bank_name: '',
                routing_number: '',
                account_number: '',
                legal_status: '',
                shift_required: 3,
                max_hours: 25,
                status: 'Watch List',
                hire_date: '',
                minimum_salary: 8,
                desired_position: '',
                increased_pay: '',
                max_pay_rate: '',
                payroll_group: '',
                transportation: '',
                comments: '',
                grooming: '',
                attitude: '',
                reliability: '',
                background: '',
                partners: [],
                shifts: [],
                jobs: [],
                early: '',
                late: '',
                uniforms: [],
                tools: [],
                skills: [],
                is_draft: 0
            }
        };
    },
    filters: {
        moment: (function (_moment) {
            function moment(_x) {
                return _moment.apply(this, arguments);
            }

            moment.toString = function () {
                return _moment.toString();
            };

            return moment;
        })(function (time) {
            return moment(time, "HH:mm:ss").format('hA');
        }),

        parseDate: function parseDate(date) {
            return moment(date).format('DD,MMM YYYY');
        },

        minimumSalary: {
            read: function read(val) {
                return val;
            },
            write: function write(val, oldVal) {
                var number = +val.replace(/[^\d.]/g, '');
                if (isNaN(number)) {
                    return null;
                } else {
                    return number > 40 ? 8 : number;
                }
            }
        },

        payRateIncrease: {
            read: function read(val) {
                return val;
            },
            write: function write(val, oldVal) {
                var number = +val.replace(/[^\d.]/g, '');
                if (isNaN(number)) {
                    return null;
                } else {
                    return number >= 10 ? 1 : number;
                }
            }
        }
    },
    watch: {},
    ready: function ready() {
        $(".table-fixed").fixedHeader();
        this.getNoJobOfferLog();
        this.getData();
        var that = this;
        $('#modal_edit_employee').on('hidden.bs.modal', function () {
            $('.stepy-basic-edit').stepy('step', 1);
            that.clearCurrentEmployee();
        });
    },
    events: {},
    methods: {
        getData: function getData() {
            var _this = this;

            this.$http.get('/api/employee-data/', '', function (response) {
                _this.commonData = response;
                // this.startTimes = _.uniq(_.pluck(response.shifts, 'start_time'));
                // this.endTimes = _.uniq(_.pluck(response.shifts, 'end_time'));
            }).always(function () {});
        },

        /**
         * prepare modal and show edit employee modal
         * @param data
         */
        editModal: function editModal(data) {
            var _this2 = this;

            notify.loading(true);
            this.$http.get('/api/employee/' + data.employee_id, '', function (employee) {
                _this2.currentEmployee = _.cloneDeep(employee);
                _this2.currentEmployee.skills = _.pluck(employee.skills, 'id').map(Number);
                _this2.currentEmployee.tools = _.pluck(employee.tools, 'id').map(Number);
                _this2.currentEmployee.uniforms = _.pluck(employee.uniforms, 'id').map(Number);
                _this2.currentEmployee.desired_position = employee.position_desired;
                _this2.currentEmployee.dob = moment(_this2.currentEmployee.dob).format('MM-DD-YYYY');
                _this2.currentEmployee.hire_date = moment(_this2.currentEmployee.hire_date).format('MM-DD-YYYY');
                modals.showStrict('#modal_edit_employee');
            }).always(function () {
                notify.loading(false);
            });
            //modals.hide('#draft_employees');
        },

        editEmployee: function editEmployee() {
            var _this3 = this;

            this.currentEmployee.is_draft = 0;
            this.currentEmployee.dob = moment(this.currentEmployee.dob).format('MM-DD-YYYY');
            this.currentEmployee.hire_date = moment(this.currentEmployee.hire_date).format('MM-DD-YYYY');
            this.$http.put('/api/employee/' + this.currentEmployee.id, this.currentEmployee, function () {
                //this.getData();
                modals.hide('#modal_edit_employee');
                notify.success('Employee Information Edited Successfully');
            }).always(function () {
                _this3.state = false;
            });
        },

        hireClass: function hireClass(days) {
            return !days ? "bg-danger" : days < 90 ? "bg-green text-center" : "text-center";
        },

        ShowupdateLogStatusModal: function ShowupdateLogStatusModal(employee) {
            this.employee = _.cloneDeep(employee);
            modals.showStrict("#employee-log-status");
        },

        updateLogData: function updateLogData() {
            var _this4 = this;

            this.$http.post("/api/update-no-job-offer-data", this.employee, function (response) {
                _this4.getNoJobOfferLog();
            }).always(function () {
                modals.hide("#employee-log-status");
            });
        },

        showPerformanceReport: function showPerformanceReport(employee) {
            window.bus.$emit("showEmployeePerformanceReport", employee.employee_id);
        },

        /**
         * get employee report data
         */
        getNoJobOfferLog: function getNoJobOfferLog() {
            var _this5 = this;

            notify.loading(true);
            this.$http.get("/api/employee-no-job-offer-log", function (response) {
                _this5.employees = response;
            }).always(function () {
                notify.loading(false);
            });
        },

        /**
         * jobs for an employee
         */
        showJobs: function showJobs(employee) {
            var _this6 = this;

            var showModal = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];

            notify.loading(true);
            this.$http.get("/api/employee-job-data/" + employee.employee_id, function (response) {
                _this6.jobs = response.jobs;
                _this6.positions = response.positions;
                if (showModal) {
                    modals.showStrict("#employee-jobs");
                }
            }).always(function () {
                notify.loading(false);
            });
        },

        /**
         * count type of positions for each job-list pair
         */
        countList: function countList(list, jobId) {
            var positions = _.cloneDeep(this.positions);
            var listPositions = positions.filter(function (position) {
                if (Array.isArray(list)) {
                    return list.includes(position.list) && position.job_id == jobId;
                } else {
                    return position.list == list && position.job_id == jobId;
                }
            });

            return listPositions.length;
        }
    }
};
module.exports = exports["default"];
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n    <div class=\"row\">\n        <h4 class=\"no-margin text-semibold text-center\">EMPLOYEE NO JOB OFFER LOG</h4>\n        <div class=\"col-md-12 no-padding mb-20\">\n            <div class=\"table-responsive\">\n                <table class=\"table table-xxs table-bordered table-fixed\">\n                    <thead class=\"header\">\n                    <tr>\n                        <th class=\"bg-slate-800 text-center text-uppercase\">hire date</th>\n                        <th class=\"bg-slate-800 text-center text-uppercase\">zip</th>\n                        <th class=\"bg-slate-800 text-center text-uppercase\">employee name</th>\n                        <th class=\"bg-slate-800 text-center text-uppercase\">g.a.r</th>\n                        <th class=\"bg-slate-800 text-center text-uppercase\">last offer</th>\n                        <th class=\"bg-slate-800 text-center text-uppercase\">job list</th>\n                        <th class=\"bg-slate-800 text-center text-uppercase\">p.chart</th>\n                        <th class=\"bg-slate-800 text-left text-uppercase\">action</th>\n                        <th class=\"bg-slate-800 text-center text-uppercase\">days</th>\n                        <th class=\"bg-slate-800 text-center text-uppercase\">Edit</th>\n                    </tr>\n                    </thead>\n                    <tbody>\n                    <tr v-for=\"(index,employee) in employees\" :key=\"index\">\n                        <td :class=\"hireClass(employee.hire_days)\">\n                            {{ employee.hire }}\n                        </td>\n                        <td class=\"text-center\">{{ employee.zip_code }}</td>\n                        <td class=\"text-center\">{{ employee.name }}</td>\n                        <td class=\"text-center\">{{ employee.gar}}</td>\n                        <td class=\"text-center\">{{ employee.last_offer}}</td>\n                        <td class=\"text-center\">\n                            <button class=\"btn btn-primary\" @click=\"showJobs(employee)\">\n                                Job List\n                            </button>\n                        </td>\n                        <td class=\"text-center\">\n                            <button class=\"btn btn-primary\" @click=\"showPerformanceReport(employee)\">\n                                P.Chart\n                            </button>\n                        </td>\n                        <td class=\"text-left cursor-pointer\" @click=\"ShowupdateLogStatusModal(employee)\">\n                            {{ employee.offer_log_status }}\n                            <span class=\"text-bold ml-5 no-margin-top font-11\" data-popup=\"tooltip-custom\" :title=\"employee.offer_log_note\">\n                            <span class=\"fa-stack fa-1x line-1-5-em\" v-if=\"employee.offer_log_note\">\n                              <i class=\"fa fa-circle fa-stack-1x icon-background font-10\"></i>\n                              <i class=\"fa fa-circle fa-stack-1x text-danger-600 font-10\"></i>\n                            </span>\n                        </span>\n                        </td>\n                        <td class=\"text-center\">{{ employee.days }}</td>\n                        <td class=\"text-center\">\n                            <button class=\"btn btn-primary\" @click=\"editModal(employee)\">\n                                Edit\n                            </button>\n                        </td>\n                    </tr>\n                    </tbody>\n                </table>\n            </div>\n        </div>\n        <employee-performance-data></employee-performance-data>\n\n        <div class=\"modal fade\" id=\"employee-jobs\" tabindex=\"-1\" role=\"dialog\">\n            <div class=\"modal-dialog modal-full\" role=\"document\">\n                <div class=\"modal-content\">\n                    <div class=\"modal-header\">\n                        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">×</span></button>\n                        <h4 class=\"modal-title text-center text-uppercase bg-slate-300\">Job List</h4>\n                    </div>\n                    <div class=\"modal-body no-padding-top no-padding-bottom\">\n                        <div class=\"table-responsive\">\n                            <table class=\"table table-xxs table-bordered table-fixed\">\n                                <thead class=\"\">\n                                <tr>\n                                    <th class=\"bg-slate-800 text-center\">JOBS</th>\n                                    <th class=\"bg-slate-800 text-center\">Total Positions</th>\n                                    <th class=\"bg-slate-800 text-center\">ABC</th>\n                                    <th class=\"bg-slate-800 text-center\">D</th>\n                                    <th class=\"bg-slate-800 text-center\">E</th>\n                                    <th class=\"bg-slate-800 text-center\">F</th>\n                                    <th class=\"bg-slate-800 text-center\">G-M</th>\n                                </tr>\n                                </thead>\n                                <tbody>\n                                <tr v-for=\"(index,job) in jobs\" :key=\"index\">\n                                    <td class=\"text-center\">{{ job.title }}</td>\n                                    <td class=\"text-center\">{{ job.total_positions }}</td>\n                                    <td class=\"text-center\"> {{ countList(['A','B','C'], job.id) }}</td>\n                                    <td class=\"text-center\">{{ countList('D', job.id) }}</td>\n                                    <td class=\"text-center\">{{ countList('E', job.id) }}</td>\n                                    <td class=\"text-center\">{{ countList('F', job.id) }}</td>\n                                    <td class=\"text-center\">{{ countList(['G','H','I','J','K','L','M'], job.id) }}</td>\n                                </tr>\n                                </tbody>\n                            </table>\n                        </div>\n                    </div>\n                    <div class=\"modal-footer\">\n                        <!-- <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button>\n                        <button type=\"button\" class=\"btn btn-primary\">Save changes</button> -->\n                    </div>\n                </div><!-- /.modal-content -->\n            </div><!-- /.modal-dialog -->\n        </div><!-- /.modal -->\n\n\n        <div class=\"modal fade\" id=\"employee-log-status\" tabindex=\"-1\" role=\"dialog\">\n            <div class=\"modal-dialog modal-xs\" role=\"document\">\n                <div class=\"modal-content\">\n                    <div class=\"modal-header\">\n                        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">×</span></button>\n                        <h4 class=\"modal-title text-center text-uppercase bg-slate-300\">ACTION</h4>\n                    </div>\n                    <div class=\"modal-body no-padding-top no-padding-bottom mt-20\">\n                        <div class=\"col-md-12  text-left\">\n                            <div class=\"col-md-3  text-left\">\n                                <div class=\"text-left\">\n                                    <input type=\"radio\" value=\"Consult\" v-model=\"employee.offer_log_status\" name=\"status\">\n                                </div>\n                            </div>\n                            <div class=\"col-md-9 text-left\">\n                                <label class=\"text-color-black text-black no-padding-left\">CONSULT</label>\n                            </div>\n                        </div>\n                        <div class=\"col-md-12 text-left\">\n                            <div class=\"col-md-3  text-left\">\n                                <div class=\"text-left\">\n                                    <input type=\"radio\" value=\"Fixed\" v-model=\"employee.offer_log_status\" name=\"status\">\n                                </div>\n                            </div>\n                            <div class=\"col-md-9 text-left\">\n                                <label class=\"text-color-black text-black no-padding-left\">FIXED</label>\n                            </div>\n                        </div>\n                        <div class=\"col-md-12 text-right mb-15\">\n                            <button type=\"button\" class=\"btn btn-primary\" @click=\"updateLogData()\">Save</button>\n                        </div>\n                        <div class=\"col-md-12 text-right\">\n                            <div class=\"form-group\">\n                                <textarea class=\"form-control\" v-model=\"employee.offer_log_note\" name=\"\" id=\"\" cols=\"30\" rows=\"5\"></textarea>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"modal-footer\">\n                        <!-- <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button>\n                        <button type=\"button\" class=\"btn btn-primary\">Save changes</button> -->\n                    </div>\n                </div><!-- /.modal-content -->\n            </div><!-- /.modal-dialog -->\n        </div><!-- /.modal -->\n\n\n        <div class=\"modal fade\" id=\"modal_edit_employee\" tabindex=\"-1\" role=\"dialog\">\n            <div class=\"modal-dialog modal-full\" role=\"document\">\n                <div class=\"modal-content grey-bg modal-medium\">\n                    <div class=\"modal-header text-right\">\n                        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">×</span></button>\n                    </div>\n                    <div class=\"modal-body\">\n                        <div class=\"row\">\n                            <form class=\"stepy-basic-edit employee-form-create\" action=\"#\">\n                                <fieldset title=\"1\">\n                                    <legend>Personal data</legend>\n                                    <div class=\"row\">\n                                        <div class=\"col-md-4\">\n                                            <div class=\"form-group\">\n                                                <label>First Name:</label>\n                                                <input type=\"text\" class=\"form-control focus-field\" v-model=\"currentEmployee.first_name\" v-bind:class=\"{ 'border-blue-600': !currentEmployee.first_name }\" autofocus=\"\">\n                                            </div>\n                                        </div>\n                                        <div class=\"col-md-4\">\n                                            <div class=\"form-group\">\n                                                <label>Last Name:</label>\n                                                <input type=\"text\" class=\"form-control\" v-model=\"currentEmployee.last_name\" v-bind:class=\"{ 'border-blue-600': !currentEmployee.last_name }\">\n                                            </div>\n                                        </div>\n                                        <div class=\"col-md-4\">\n                                            <div class=\"form-group\">\n                                                <label>Middle Name:</label>\n                                                <input type=\"text\" class=\"form-control\" v-model=\"currentEmployee.middle_name\" v-bind:class=\"{ 'border-blue-600': !currentEmployee.last_name }\">\n                                            </div>\n                                        </div>\n                                    </div>\n\n                                    <div class=\"row\">\n                                        <div class=\"col-md-4\">\n                                            <div class=\"form-group\">\n                                                <label>Date of Birth:</label>\n                                                <input type=\"text\" class=\"form-control pickadate-year\" v-model=\"currentEmployee.dob\" v-bind:class=\"{ 'border-blue-600': !currentEmployee.dob }\">\n                                            </div>\n                                        </div>\n                                        <div class=\"col-md-4\">\n                                            <div class=\"form-group\">\n                                                <label>SS:</label>\n                                                <input type=\"text\" class=\"form-control format-ss\" v-model=\"currentEmployee.ss\" v-bind:class=\"{ 'border-blue-600': !currentEmployee.ss }\">\n                                            </div>\n                                        </div>\n                                        <div class=\"col-md-4\">\n                                            <div class=\"form-group\">\n                                                <label>Tax ID:</label>\n                                                <input type=\"text\" class=\"form-control format-tax\" v-model=\"currentEmployee.tax_id\" v-bind:class=\"{ 'border-blue-600': !currentEmployee.tax_id }\">\n                                            </div>\n                                        </div>\n                                    </div>\n\n                                    <div class=\"row\">\n                                        <div class=\"col-md-4\">\n                                            <div class=\"form-group\">\n                                                <label>Marital Status:</label>\n                                                <select name=\"marital_status\" class=\"form-control\" v-bind:class=\"{ 'border-blue-600': !currentEmployee.marital_status }\" v-model=\"currentEmployee.marital_status\">\n                                                    <option value=\"\">Select An Option</option>\n                                                    <option value=\"Married\">Married</option>\n                                                    <option value=\"Widowed\">Widowed</option>\n                                                    <option value=\"Separated\">Separated</option>\n                                                    <option value=\"Divorced\">Divorced</option>\n                                                    <option value=\"Single\">Single</option>\n                                                </select>\n                                            </div>\n                                        </div>\n\n                                        <div class=\"col-md-4\">\n                                            <div class=\"form-group\">\n                                                <label>No. Of Dependant:</label>\n                                                <input type=\"text\" class=\"form-control\" v-model=\"currentEmployee.no_of_dependent\" v-bind:class=\"{ 'border-blue-600': !currentEmployee.no_of_dependent }\">\n                                            </div>\n                                        </div>\n                                        <div class=\"col-md-4\">\n                                            <div class=\"form-group\">\n                                                <label>Gender:</label>\n                                                <select name=\"gender\" class=\"form-control\" v-model=\"currentEmployee.gender\" v-bind:class=\"{ 'border-blue-600': !currentEmployee.gender }\">\n                                                    <option value=\"\">Select An Option</option>\n                                                    <option value=\"Male\">Male</option>\n                                                    <option value=\"Female\">Female</option>\n                                                </select>\n                                            </div>\n                                        </div>\n\n                                    </div>\n\n                                    <br>\n                                    <!-- <legend class=\"text-semibold  pb-15\"><i class=\"icon-home position-left\"></i></legend> -->\n                                    <div class=\"row\">\n                                        <div class=\"col-md-6\">\n                                            <div class=\"form-group\">\n                                                <label>Street#:</label>\n                                                <input type=\"text\" class=\"form-control\" v-model=\"currentEmployee.street\" v-bind:class=\"{ 'border-blue-600': !currentEmployee.street }\">\n                                            </div>\n                                        </div>\n                                        <div class=\"col-md-6\">\n                                            <div class=\"form-group\">\n                                                <label>Apartment#:</label>\n                                                <input type=\"text\" class=\"form-control\" v-model=\"currentEmployee.apt\" v-bind:class=\"{ 'border-blue-600': !currentEmployee.apt }\">\n                                            </div>\n                                        </div>\n                                    </div>\n                                    <div class=\"row\">\n                                        <div class=\"col-md-4\">\n                                            <div class=\"form-group\">\n                                                <label>City:</label>\n                                                <input type=\"text\" class=\"form-control\" v-model=\"currentEmployee.city\" v-bind:class=\"{ 'border-blue-600': !currentEmployee.city }\">\n                                            </div>\n                                        </div>\n                                        <div class=\"col-md-4\">\n                                            <div class=\"form-group\">\n                                                <label>State:</label>\n                                                <input type=\"text\" class=\"form-control format-state to-upper\" v-model=\"currentEmployee.state\" v-bind:class=\"{ 'border-blue-600': !currentEmployee.state }\">\n                                            </div>\n                                        </div>\n                                        <div class=\"col-md-4\">\n                                            <div class=\"form-group\">\n                                                <label>Zip:</label>\n                                                <input type=\"text\" class=\"form-control format-zip\" v-model=\"currentEmployee.zip_code\" v-bind:class=\"{ 'border-blue-600': !currentEmployee.zip_code }\">\n                                            </div>\n                                        </div>\n                                    </div>\n                                    <hr>\n                                    <!-- <legend class=\"text-semibold\"><i class=\"icon-address-book position-left\"></i></legend> -->\n                                    <div class=\"row\">\n                                        <div class=\"col-md-6\">\n                                            <div class=\"form-group\">\n                                                <label>Primary Phone:</label>\n                                                <input type=\"text\" class=\"form-control format-phone-dash\" v-model=\"currentEmployee.primary_phone\" v-bind:class=\"{ 'border-blue-600': !currentEmployee.primary_phone }\">\n                                            </div>\n                                        </div>\n\n                                        <div class=\"col-md-6\">\n                                            <div class=\"form-group\">\n                                                <label>Secondary Phone:</label>\n                                                <input type=\"text\" class=\"form-control format-phone-dash\" v-model=\"currentEmployee.secondary_phone\" v-bind:class=\"{ 'border-blue-600': !currentEmployee.secondary_phone }\">\n                                            </div>\n                                        </div>\n\n                                        <div class=\"col-md-4\">\n                                            <div class=\"form-group\">\n                                                <label>Email:</label>\n                                                <input type=\"email\" class=\"form-control\" v-model=\"currentEmployee.email\" v-bind:class=\"{ 'border-blue-600': !currentEmployee.email }\">\n                                            </div>\n                                        </div>\n\n                                        <div class=\"col-md-4\">\n                                            <br>\n                                            <br>\n                                            <span class=\"checkboxes\">\n\t\t\t\t\t\t\t\t\t\t<label>\n\t\t\t\t\t\t\t\t\t\t\t<input type=\"checkbox\" v-model=\"currentEmployee.email_notification\" value=\"1\"> Email Notification\n\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t</span>\n                                        </div>\n\n                                        <div class=\"col-md-4\">\n                                            <div class=\"form-group\">\n                                                <label>Password:</label>\n                                                <input type=\"password\" class=\"form-control\" v-model=\"currentEmployee.password\" v-bind:class=\"{ 'border-blue-600': !currentEmployee.password }\">\n                                            </div>\n                                        </div>\n\n                                        <hr>\n                                        <div class=\"col-md-6\">\n                                            <div class=\"form-group\">\n                                                <label>Bank Name:</label>\n                                                <input type=\"email\" class=\"form-control\" v-model=\"currentEmployee.bank_name\" v-bind:class=\"{ 'border-blue-600': !currentEmployee.bank_name }\">\n                                            </div>\n                                        </div>\n                                        <div class=\"col-md-6\">\n                                            <div class=\"form-group\">\n                                                <label>Routing Number:</label>\n                                                <input type=\"email\" class=\"form-control\" v-bind:class=\"{ 'border-blue-600': !currentEmployee.routing_number }\" v-model=\"currentEmployee.routing_number\">\n                                            </div>\n                                        </div>\n                                        <div class=\"col-md-6\">\n                                            <div class=\"form-group\">\n                                                <label>Account Number:</label>\n                                                <input type=\"email\" class=\"form-control\" v-bind:class=\"{ 'border-blue-600': !currentEmployee.accounting_number }\" v-model=\"currentEmployee.account_number\">\n                                            </div>\n                                        </div>\n                                        <div class=\"col-md-6\">\n                                            <div class=\"form-group\">\n                                                <label>Legal Status:</label>\n                                                <select name=\"legal_status\" class=\"form-control\" v-bind:class=\"{ 'border-blue-600': !currentEmployee.legal_status }\" v-model=\"currentEmployee.legal_status\">\n                                                    <option value=\"\">Select An Option</option>\n                                                    <option value=\"US Citizen\">US Citizen</option>\n                                                    <option value=\"Permanent Resident\">Permanent Resident</option>\n                                                    <option value=\"Work Permit\">Work Permit</option>\n                                                </select>\n                                            </div>\n                                        </div>\n\n                                        <!-- <div class=\"col-md-6\">\n                                            <div class=\"form-group\">\n                                            <label>Password:</label>\n                                            <input type=\"password\" class=\"form-control\" v-model=\"currentEmployee.password\" placeholder=\"******\">\n                                            </div>\n                                        </div> -->\n                                    </div>\n                                </fieldset>\n\n                                <fieldset title=\"2\">\n                                    <legend>Ranking</legend>\n                                    <div class=\"row\">\n                                        <div class=\"col-md-4\">\n                                            <div class=\"form-group\">\n                                                <label>Shift Required:</label>\n                                                <input type=\"text\" v-model=\"currentEmployee.shift_required\" v-bind:class=\"{ 'border-blue-600': !currentEmployee.shift_required }\" class=\"form-control\">\n                                            </div>\n                                        </div>\n\n                                        <div class=\"col-md-4\">\n                                            <div class=\"form-group\">\n                                                <label>Max Hours:</label>\n                                                <input type=\"text\" v-model=\"currentEmployee.max_hours\" v-bind:class=\"{ 'border-blue-600': !currentEmployee.max_hours }\" class=\"form-control\">\n                                            </div>\n                                        </div>\n\n                                        <div class=\"col-md-4\">\n                                            <div class=\"form-group\">\n                                                <label>Status:</label>\n                                                <select name=\"desired_position\" class=\"form-control\" v-bind:class=\"{ 'border-blue-600': !currentEmployee.status }\" v-model=\"currentEmployee.status\">\n                                                    <option value=\"\">Select An Option</option>\n                                                    <option value=\"Watch List\">Watch List</option>\n                                                    <option value=\"Active\">Active</option>\n                                                    <option value=\"Inactive\">Inactive</option>\n                                                    <option value=\"Quit\">Quit</option>\n                                                    <option value=\"Terminated\">Terminated</option>\n                                                    <option value=\"Suspended\">Suspended</option>\n                                                </select>\n                                            </div>\n                                        </div>\n                                    </div>\n                                    <hr>\n                                    <!-- <legend class=\"text-semibold\"><i class=\"icon-user-tie position-left\"></i></legend> -->\n                                    <div class=\"row\">\n                                        <div class=\"col-md-4\">\n                                            <div class=\"form-group\">\n                                                <label>Hire Date:</label>\n                                                <input type=\"text\" class=\"form-control pickadate-year\" v-model=\"currentEmployee.hire_date\" v-bind:class=\"{ 'border-blue-600': !currentEmployee.hire_date }\">\n                                            </div>\n                                        </div>\n                                        <div class=\"col-md-4\">\n                                            <div class=\"form-group\">\n                                                <label>Minimum Salary:</label>\n                                                <input type=\"text\" v-model=\"currentEmployee.minimum_salary | minimumSalary\" v-bind:class=\"{ 'border-blue-600': !currentEmployee.minimum_salary }\" class=\"form-control format-2digit\">\n                                            </div>\n                                        </div>\n\n                                        <div class=\"col-md-4\">\n                                            <div class=\"form-group\">\n                                                <label>Desired Position:</label>\n                                                <select name=\"desired_position\" class=\"form-control\" v-bind:class=\"{ 'border-blue-600': !currentEmployee.desired_position }\" v-model=\"currentEmployee.desired_position\">\n                                                    <option value=\"\">Select An Option</option>\n                                                    <option value=\"Full Time\">Full Time</option>\n                                                    <option value=\"Part Time\">Part Time</option>\n                                                </select>\n                                            </div>\n                                        </div>\n                                        <div class=\"col-md-4\">\n                                            <div class=\"form-group\">\n                                                <label>Pay Rate increase:</label>\n                                                <input type=\"text\" v-model=\"currentEmployee.increased_pay | payRateIncrease\" class=\"form-control format-2digit\">\n                                            </div>\n                                        </div>\n                                        <div class=\"col-md-4\">\n                                            <div class=\"form-group\">\n                                                <label>Max Pay Rate:</label>\n                                                <input type=\"text\" v-model=\"currentEmployee.max_pay_rate | minimumSalary\" :disabled=\"!currentEmployee.increased_pay > 0 &amp;&amp; !currentEmployee.max_pay_rate > 0\" class=\"form-control format-2digit\">\n                                            </div>\n                                        </div>\n                                        <div class=\"col-md-4\">\n                                            <div class=\"form-group\">\n                                                <label>Payroll Group:</label>\n                                                <select name=\"payroll_group\" class=\"form-control\" v-bind:class=\"{ 'border-blue-600': !currentEmployee.payroll_group }\" v-model=\"currentEmployee.payroll_group\">\n                                                    <option value=\"\">Select An Option</option>\n                                                    <option v-for=\"i in 10\" value=\"{{ i }}\">{{ i }}</option>\n                                                </select>\n                                            </div>\n                                        </div>\n                                        <div class=\"col-md-4\">\n                                            <div class=\"form-group\">\n                                                <label>Transportation:</label>\n                                                <select name=\"transportation\" class=\"form-control\" v-model=\"currentEmployee.transportation\" v-bind:class=\"{ 'border-blue-600': !currentEmployee.transportation }\">\n                                                    <option value=\"\">Select An Option</option>\n                                                    <option value=\"Car\">Car</option>\n                                                    <option value=\"Public Transport\">Public Transport</option>\n                                                    <option value=\"Share Ride\">Share Ride</option>\n                                                    <option value=\"Driver\">Driver</option>\n                                                </select>\n                                            </div>\n                                        </div>\n                                        <div class=\"col-md-4\">\n                                            <div class=\"form-group\">\n                                                <label>Employee ID:</label>\n                                                <input type=\"text\" v-model=\"currentEmployee.employee_code\" v-bind:class=\"{ 'border-blue-600': !currentEmployee.employee_code }\" class=\"form-control format-zip\">\n                                            </div>\n                                        </div>\n                                        <div class=\"col-md-4\">\n                                            <div class=\"form-group\">\n                                                <label>Comments:</label>\n                                                <textarea rows=\"5\" cols=\"5\" class=\"form-control\" v-bind:class=\"{ 'border-blue-600': !currentEmployee.comments }\" v-model=\"currentEmployee.comments\"></textarea>\n                                            </div>\n                                        </div>\n                                    </div>\n\n\n                                </fieldset>\n\n\n                                <fieldset title=\"3\">\n                                    <legend>Work Metrics</legend>\n                                    <legend class=\"text-semibold\">\n                                        <i class=\"icon-truck position-left\"></i>\n                                    </legend>\n                                    <div class=\"row\">\n                                        <div class=\"col-md-3\">\n                                            <label>Grooming:</label>\n                                            <select class=\"form-control\" name=\"grooming\" v-model=\"currentEmployee.grooming\" v-bind:class=\"{ 'border-blue-600': !currentEmployee.grooming }\">\n                                                <option value=\"\">Select An Option</option>\n                                                <option v-for=\"type in types\" :value=\"type\">{{ type }}</option>\n                                            </select>\n                                        </div>\n\n                                        <div class=\"col-md-3\">\n                                            <div class=\"form-group\">\n                                                <label>Attitude:</label>\n                                                <select class=\"form-control\" name=\"attitude\" v-model=\"currentEmployee.attitude\" v-bind:class=\"{ 'border-blue-600': !currentEmployee.attitude }\">\n                                                    <option value=\"\">Select An Option</option>\n                                                    <option v-for=\"type in types\" :value=\"type\">{{ type }}</option>\n                                                </select>\n                                            </div>\n                                        </div>\n\n                                        <div class=\"col-md-3\">\n                                            <div class=\"form-group\">\n                                                <label>Reliability:</label>\n                                                <select class=\"form-control\" name=\"reliability\" v-bind:class=\"{ 'border-blue-600': !currentEmployee.reliability }\" v-model=\"currentEmployee.reliability\">\n                                                    <option value=\"\">Select An Option</option>\n                                                    <option v-for=\"type in types\" :value=\"type\">{{ type }}</option>\n                                                </select>\n                                            </div>\n                                        </div>\n\n                                        <div class=\"col-md-3\">\n                                            <div class=\"form-group\">\n                                                <label>Background:</label>\n                                                <select class=\"form-control\" name=\"background\" v-model=\"currentEmployee.background\" v-bind:class=\"{ 'border-blue-600': !currentEmployee.background }\">\n                                                    <option value=\"\">Select An Option</option>\n                                                    <option v-for=\"type in backgroundTypes\" :value=\"type\">{{ type }}\n                                                    </option>\n                                                </select>\n                                            </div>\n                                        </div>\n                                    </div>\n                                    <hr>\n                                </fieldset>\n\n\n                                <fieldset title=\"4\">\n                                    <legend>UTS</legend>\n\n                                    <div class=\"col-md-4-5\">\n                                        <span class=\"label label-primary mb-10\">Uniforms</span>\n                                        <br>\n                                        <div class=\"row pr-10 pl-10 pre-scrollable-740\">\n                                            <div class=\"col-md-6 p-5\" v-for=\"uniformGroup in commonData.uniforms\" track-by=\"$index\">\n                                                <strong>{{ uniformGroup.title }}</strong>\n                                                <div class=\"checkboxes\" v-for=\"uniform in uniformGroup.uniforms\" track-by=\"$index\">\n                                                    <label>\n                                                        <input type=\"checkbox\" v-model=\"currentEmployee.uniforms\" :value=\"uniform.id\"> {{ uniform.title }}\n                                                    </label>\n                                                </div>\n                                            </div>\n                                        </div>\n\n                                    </div>\n\n                                    <div class=\"col-md-4-5\">\n                                        <span class=\"label label-primary mb-10 ml-20\">Skills</span>\n                                        <br>\n                                        <div class=\"row pr-10 pl-10 ml-10 pre-scrollable-740\">\n                                            <div class=\"col-md-6 p-5\" v-for=\"skillGroup in commonData.skills\">\n                                                <strong>{{ skillGroup.title }}</strong>\n                                                <div class=\"checkboxes\" v-for=\"skill in skillGroup.skills\">\n                                                    <label>\n                                                        <input type=\"checkbox\" v-model=\"currentEmployee.skills\" :value=\"skill.id\"> {{ skill.title }}\n                                                    </label>\n                                                </div>\n                                            </div>\n                                        </div>\n                                    </div>\n\n                                    <div class=\"col-md-3\">\n                                        <span class=\"label label-primary mb-10 ml-20\">Tools</span>\n                                        <br>\n                                        <div class=\"row pr-10 pl-10 ml-10 pre-scrollable-740\">\n                                            <div class=\"\" v-for=\"toolGroup in commonData.tools\">\n                                                <strong>{{ toolGroup.title }}</strong>\n                                                <div class=\"checkboxes\" v-for=\"tool in toolGroup.tools\">\n                                                    <label>\n                                                        <input type=\"checkbox\" v-model=\"currentEmployee.tools\" :value=\"tool.id\"> {{ tool.title }}\n                                                    </label>\n                                                </div>\n                                            </div>\n                                        </div>\n                                    </div>\n                                </fieldset>\n\n                                <button type=\"submit\" v-submit=\"state\" v-on:click.prevent=\"editEmployee\" class=\"btn btn-primary stepy-finish\">Edit Employee\n                                    <i class=\"icon-arrow-right14 position-right\"></i>\n                                </button>\n\n                            </form>\n                        </div>\n                    </div>\n                    <div class=\"modal-footer\">\n                        <!-- <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button>\n                        <button type=\"button\" class=\"btn btn-primary\">Save changes</button> -->\n                    </div>\n                </div><!-- /.modal-content -->\n            </div><!-- /.modal-dialog -->\n        </div><!-- /.modal -->\n\n\n    </div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  var id = "/home/shoieb/sites/elegant/resources/assets/js/vue/components/no-job-offer-log.vue"
  module.hot.dispose(function () {
    require("vueify-insert-css").cache["\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, module.exports.template)
  }
})()}
},{"./../../mixed/modals":10,"./../../mixed/notify":11,"vue":5,"vue-hot-reload-api":4,"vueify-insert-css":6}],56:[function(require,module,exports){
var __vueify_style__ = require("vueify-insert-css").insert("\n")
"use strict";

exports.__esModule = true;
var modals = require("./../../mixed/modals");
var notify = require("./../../mixed/notify");

exports["default"] = {
  data: function data() {
    return {
      employees: {},
      employee: null,
      statuses: {
        "Left VM": "LV",
        "Left Voice Mail": "LV",
        Answered: "ANSWERED",
        Called: "CALLED",
        Disc: "LD",
        "Hang Up": "HU",
        "Wrong No": "WN",
        "VM Full": "VF",
        "No VM": "NV",
        "delete": "DELETE"
      },
      response: null
    };
  },
  filters: {},
  watch: {},
  ready: function ready() {
    this.getEmployees();
  },
  events: {},
  methods: {
    showPerformanceReport: function showPerformanceReport(employee) {
      window.bus.$emit("showEmployeePerformanceReport", employee.id);
    },

    getEmployees: function getEmployees() {
      var _this = this;

      var assignEmployee = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];

      notify.loading(true);
      this.$http.get("/api/no-response-log", function (response) {
        _this.employees = response;
        if (assignEmployee) {
          (function () {
            var id = _this.employee.id;
            var employee = _this.employees.filter(function (employee) {
              return employee.id == id;
            });
            _this.employee = employee[0];
          })();
        }
      }).always(function () {
        notify.loading(false);
      });
    },

    formatDate: function formatDate(date, from, format) {
      if (moment(date).isValid()) {
        return moment(date, from).format(format);
      } else {
        return "";
      }
    },

    setEmployee: function setEmployee(employee) {
      this.employee = _.cloneDeep(employee);
    },

    showStatusUpdateModal: function showStatusUpdateModal() {
      modals.showStrict("#status-update-modal");
    },

    closeModal: function closeModal() {
      modals.hide("#status-update-modal");
    },

    updateEmployeeStatus: function updateEmployeeStatus() {
      var _this2 = this;

      notify.loading(true);
      this.$http.post("/api/update-employee-status", this.employee, function (response) {
        modals.hide("#status-update-modal");
        _this2.employee = null;
        _this2.getEmployees();
      }).always(function () {
        notify.loading(false);
      });
    },

    showResponseModal: function showResponseModal() {
      modals.showStrict("#response-modal");
    },

    showNotesModal: function showNotesModal() {
      window.bus.$emit("showNotesModal");
    },

    saveResponse: function saveResponse() {
      var _this3 = this;

      notify.loading(true);
      this.$http.post("/api/save-employee-call-response", {
        employee_id: this.employee.id,
        type: this.response,
        entry_point: "No Response Log"
      }, function (response) {
        modals.hide("#response-modal");
        _this3.getEmployees(true);
        _this3.response = null;
      }).always(function () {
        notify.loading(false);
      });
    }
  }
};
module.exports = exports["default"];
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n    <div class=\"row\">\n        <div v-if=\"employee\" class=\"col-md-12 display-flex\">\n            <div class=\"col-md-8 mb-5 no-padding\">\n                <div class=\"col-md-12 bg-brown-700 no-padding\">\n                    <div class=\"col-md-12 pl-5 pt-10 pb-10 text-black text-color-black bg-primary text-left\">{{\n                        employee.fullName }}\n                    </div>\n                </div>\n                <div class=\"col-md-4 no-padding\">\n                    <div class=\"col-md-12 pl-5 pt-10 pb-10 text-black text-color-black bg-primary-300 text-left\">{{\n                        employee.primary_phone }}\n                    </div>\n                    <div class=\"col-md-12 pl-5 pt-10 pb-10 text-black text-color-black bg-primary-300 text-left\">{{\n                        employee.secondary_phone }}\n                    </div>\n                    <div class=\"col-md-12 pl-5 pt-10 pb-10 text-black text-color-black bg-primary-300 text-left\">{{\n                        employee.email }}\n                    </div>\n                </div>\n                <div class=\"col-md-8 no-padding\">\n                    <div class=\"col-md-4 text-center\">\n                        <button class=\"btn btn-danger bg-danger-700 text-black mt-30\" @click=\"showStatusUpdateModal\">\n                            Action\n                        </button>\n                    </div>\n                    <div class=\"col-md-4 text-center\">\n                        <button class=\"btn btn-primary bg-primary-700 text-black mt-30\" @click=\"showResponseModal\">\n                            Called\n                        </button>\n                    </div>\n\n                    <div class=\"col-md-4 text-center\">\n                        <button class=\"btn btn-primary bg-primary-700 text-black mt-30\" @click=\"showNotesModal\">\n                            Note\n                        </button>\n                    </div>\n                </div>\n            </div>\n            <div class=\"col-md-4 mb-10 no-padding\">\n                <div class=\"col-md-12 no-padding\">\n                    <div class=\"col-md-3 no-padding text-black bg-slate-700 text-center\">Date</div>\n                    <div class=\"col-md-3 no-padding text-black bg-slate-700 text-center\">Time</div>\n                    <div class=\"col-md-3 no-padding text-black bg-slate-700 text-center\">Called By</div>\n                    <div class=\"col-md-3 no-padding text-black bg-slate-700 text-center\">Remarks</div>\n                </div>\n                <div class=\"col-md-12 no-padding\" v-for=\"(index,log) in employee.logs\" :key=\"index\">\n                    <div class=\"col-md-3 no-padding text-center border-bottom border-bottom border-left\">\n                        {{ formatDate(log.created_at,'YYYY-MM-DD HH:mm:ss','D-MMM') }}\n                    </div>\n                    <div class=\"col-md-3 no-padding text-center  border-bottom border-bottom border-left\">\n                        {{ formatDate(log.created_at,'YYYY-MM-DD HH:mm:ss','HH:mm A') }}\n                    </div>\n                    <div class=\"col-md-3 no-padding text-center  border-bottom border-bottom border-left\">\n                        {{ log.user.name }}\n                    </div>\n                    <div class=\"col-md-3 no-padding text-center  border-bottom border-right border-bottom border-left\">\n                        {{ statuses[log.type] }}\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class=\"col-md-12\">\n            <div class=\"table-responsive\">\n                <table class=\"table table-bordered table-xxs\">\n                    <thead class=\"header\">\n                    <tr>\n                        <th class=\"bg-slate-700 text-center\" rowspan=\"2\">\n                            P.Chart\n                        </th>\n                        <th class=\"bg-slate-700 text-center\" rowspan=\"2\">\n                            EMPLOYEE NAME\n                        </th>\n                        <th class=\"bg-slate-700 text-center\" rowspan=\"2\">\n                            # of Text\n                        </th>\n                        <th class=\"bg-slate-700 text-center\" rowspan=\"2\">\n                            # of Calls\n                        </th>\n                        <th class=\"bg-slate-700 text-center\" rowspan=\"2\"># of Days</th>\n                        <th class=\"bg-slate-700 text-center\" rowspan=\"2\">Worked\n                        </th>\n                        <th class=\"bg-slate-700 text-center\" rowspan=\"2\">\n                            C+RC\n                        </th>\n                        <th class=\"bg-slate-700 text-center\" rowspan=\"2\">Status</th>\n                        <th class=\"bg-slate-700 text-center\" colspan=\"4\">CALL LOG</th>\n                    </tr>\n                    <tr>\n                        <th class=\"bg-slate-300 text-center\">1st</th>\n                        <th class=\"bg-slate-300 text-center\">2nd</th>\n                        <th class=\"bg-slate-300 text-center\">3rd</th>\n                        <th class=\"bg-slate-300 text-center\">4th</th>\n                    </tr>\n                    </thead>\n                    <tbody>\n                    <tr v-for=\"(index,emp) in employees\" :key=\"index\" v-bind:class=\"[ (emp.id == employee.id) ? 'bg-orange-custom':'']\">\n                        <td class=\"text-center\">\n                            <button class=\"btn btn-primary\" @click=\"showPerformanceReport(emp)\">P.Chart\n                            </button>\n                        </td>\n                        <td class=\"text-center cursor-pointer\" @click=\"setEmployee(emp)\">{{ emp.fullName }}\n                        </td>\n                        <td class=\"text-center\">{{ emp.texts }}</td>\n                        <td class=\"text-center\">{{ emp.calls }}</td>\n                        <td class=\"text-center\">{{ emp.days }}</td>\n                        <td class=\"text-center\">{{ emp.worked_system_settings_count }}</td>\n                        <td class=\"text-center\">{{ emp.confirmed_fifty_count }}</td>\n                        <td class=\"text-center\">{{ emp.status }}</td>\n                        <td class=\"text-center\">\n                            {{ formatDate(emp.logs[0].created_at,'YYYY-MM-DD HH:mm:ss','D MMM') }} -\n                            <span class=\"text-danger-400\">{{ statuses[emp.logs[0].type] }}</span>\n                        </td>\n                        <td class=\"text-center\">\n                            {{ formatDate(emp.logs[1].created_at,'YYYY-MM-DD HH:mm:ss','D MMM') }} -\n                            <span class=\"text-danger-400\">{{ statuses[emp.logs[1].type] }}</span>\n                        </td>\n                        <td class=\"text-center\">\n                            {{ formatDate(emp.logs[2].created_at,'YYYY-MM-DD HH:mm:ss','D MMM') }} -\n                            <span class=\"text-danger-400\">{{ statuses[emp.logs[2].type] }}</span>\n                        </td>\n                        <td class=\"text-center\">\n                            {{ formatDate(emp.logs[3].created_at,'YYYY-MM-DD HH:mm:ss','D MMM') }} -\n                            <span class=\"text-danger-400\">{{ statuses[emp.logs[3].type] }}</span>\n                        </td>\n                    </tr>\n                    </tbody>\n                </table>\n            </div>\n        </div>\n\n\n        <div class=\"modal fade\" id=\"status-update-modal\">\n            <div class=\"modal-dialog modal-xs\">\n                <div class=\"modal-content\">\n                    <h5 class=\" cursor-pointer text-right pr-5\" @click=\"closeModal\">Cancel</h5>\n                    <div class=\"modal-header\">\n                        <h4 class=\"modal-title text-center bg-slate-800\">CHANGE STATUS</h4>\n                        <h4 class=\"modal-title text-center bg-slate-300\">{{ employee.status }}</h4>\n                    </div>\n                    <div class=\"modal-body no-padding-top\">\n                        <div class=\"table-responsive\">\n                            <table class=\"table table-bordered\">\n                                <tbody>\n                                <tr>\n                                    <td class=\"text-center text-black\">Inactive</td>\n                                    <td class=\"text-center\">\n                                        <input type=\"radio\" name=\"status\" value=\"Inactive\" v-model=\"employee.status\">\n                                    </td>\n                                </tr>\n                                <tr>\n                                    <td class=\"text-center text-black\">Quit</td>\n                                    <td class=\"text-center\">\n                                        <input type=\"radio\" name=\"status\" value=\"Quit\" v-model=\"employee.status\">\n                                    </td>\n                                </tr>\n                                <tr>\n                                    <td class=\"text-center text-black\">Active</td>\n                                    <td class=\"text-center\">\n                                        <input type=\"radio\" name=\"status\" value=\"Active\" v-model=\"employee.status\">\n                                    </td>\n                                </tr>\n                                </tbody>\n                            </table>\n                        </div>\n                    </div>\n                    <div class=\"modal-footer\">\n                        <!--<button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button>-->\n                        <button type=\"button\" class=\"btn btn-primary pull-right\" @click=\"updateEmployeeStatus\">Submit\n                        </button>\n                    </div>\n                </div><!-- /.modal-content -->\n            </div><!-- /.modal-dialog -->\n        </div><!-- /.modal -->\n\n\n        <div class=\"modal fade\" id=\"response-modal\">\n            <div class=\"modal-dialog modal-xs\">\n                <div class=\"modal-content\">\n                    <div class=\"modal-header\">\n                        <button class=\"text-black text-color-black\" type=\"button\" data-dismiss=\"modal\" aria-hidden=\"true\">×\n                        </button>\n                        <!--<h4 class=\"modal-title\">Modal title</h4>-->\n                    </div>\n                    <div class=\"modal-body\">\n                        <div class=\"col-md-12\">\n                            <div class=\"form-group\">\n                                <div class=\"radio\">\n                                    <label><input type=\"radio\" value=\"Left VM\" name=\"callledStatus\" v-model=\"response\">Left\n                                        Voicemail</label>\n                                </div>\n                                <div class=\"radio\">\n                                    <label><input type=\"radio\" value=\"No VM\" name=\"callledStatus\" v-model=\"response\">Did'nt\n                                        Leave Voicemail</label>\n                                </div>\n                                <div class=\"radio\">\n                                    <label><input type=\"radio\" value=\"VM Full\" name=\"callledStatus\" v-model=\"response\">Voicemail\n                                        Full</label>\n                                </div>\n                                <div class=\"radio\">\n                                    <label><input type=\"radio\" value=\"Hang Up\" name=\"callledStatus\" v-model=\"response\">Hang\n                                        Up</label>\n                                </div>\n                                <div class=\"radio\">\n                                    <label><input type=\"radio\" value=\"Disc\" name=\"callledStatus\" v-model=\"response\">Line\n                                        Disconnected</label>\n                                </div>\n                                <div class=\"radio\">\n                                    <label><input type=\"radio\" value=\"Wrong No\" name=\"callledStatus\" v-model=\"response\">Wrong\n                                        Number</label>\n                                </div>\n                            </div>\n                            <div class=\"text-right\">\n                                <button type=\"button\" class=\"btn btn-primary\" @click=\"saveResponse\">Save\n                                </button>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"modal-footer\">\n                        <!--<button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button>-->\n                    </div>\n                </div><!-- /.modal-content -->\n            </div><!-- /.modal-dialog -->\n        </div><!-- /.modal -->\n        <employee-performance-data></employee-performance-data>\n        <notes :employee=\"employee\" entry-point=\"no-response-log\"></notes>\n    </div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  var id = "/home/shoieb/sites/elegant/resources/assets/js/vue/components/no-response-log.vue"
  module.hot.dispose(function () {
    require("vueify-insert-css").cache["\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, module.exports.template)
  }
})()}
},{"./../../mixed/modals":10,"./../../mixed/notify":11,"vue":5,"vue-hot-reload-api":4,"vueify-insert-css":6}],57:[function(require,module,exports){
var __vueify_style__ = require("vueify-insert-css").insert("\n")
"use strict";

exports.__esModule = true;
var modals = require("./../../mixed/modals");
var notify = require("./../../mixed/notify");
exports["default"] = {
  data: function data() {
    return {
      state: false,
      employees: {},
      employee: {},
      clearRecord: false
    };
  },
  filters: {},
  watch: {},
  ready: function ready() {
    $(".table-fixed").fixedHeader();
    this.getNoShowConflictsLog();
  },
  events: {},
  methods: {
    findNoShow: function findNoShow(order) {
      var checkVerification = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];

      var orders = _.cloneDeep(order);

      var noShow = orders.filter(function (order) {
        return order.no_show == 1;
      });
      if (checkVerification) {
        return noShow[0].no_show && noShow[0].no_show_verified ? "Verified NS" : "Pending Verification";
      }
      var data = "";
      noShow.map(function (val) {
        data += val["company_code"] + " " + val["title"] + "<br>";
      });
      return data;
    },

    findDidNoTReConfirm: function findDidNoTReConfirm(order) {
      var orders = _.cloneDeep(order);

      var didNotReConfirm = orders.filter(function (order) {
        return order.status == "did-not-re-confirm";
      });
      var data = "";
      didNotReConfirm.map(function (val) {
        data += val["company_code"] + " " + val["title"] + "<br>";
      });
      return data;
    },

    findCallOut: function findCallOut(order) {
      var orders = _.cloneDeep(order);

      var CallOut = orders.filter(function (order) {
        return order.status == "call-out";
      });
      var data = "";
      CallOut.map(function (val) {
        data += val["company_code"] + " " + val["title"] + "<br>";
      });
      return data;
    },

    findWorked: function findWorked(order) {
      var orders = _.cloneDeep(order);

      var worked = orders.filter(function (order) {
        return order.worked == 1;
      });
      var data = "";
      worked.map(function (val) {
        data += val["company_code"] + " " + val["title"] + "<br>";
      });
      return data;
    },
    /**
     * get employee no show conflicts data
     */
    getNoShowConflictsLog: function getNoShowConflictsLog() {
      var _this = this;

      notify.loading(true);
      this.$http.get("/api/no-show-conflicts", function (response) {
        _this.employees = response;
      }).always(function () {
        notify.loading(false);
      });
    },

    /**
     * show modal to clear records
     */
    showClearNoShowModal: function showClearNoShowModal(employee) {
      this.employee = _.cloneDeep(employee);
      this.clearRecord = false;
      modals.showStrict("#clear-no-show");
    },

    /**
     * clear no show records
     */
    clearNoShowRecord: function clearNoShowRecord() {
      var _this2 = this;

      var worked = this.employee.filter(function (order) {
        return order.worked == 1;
      });
      if (this.clearRecord) {
        this.$http.patch("/api/clear-no-show/", worked[0], function (response) {
          modals.hide("#clear-no-show");
          _this2.getNoShowConflictsLog();
        }).always(function () {});
      } else {
        notify.info("Plase check the box before submitting");
      }
    }
  }
};
module.exports = exports["default"];
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n    <div class=\"row\">\n        <h4 class=\"no-margin text-semibold text-center\">EMPLOYEE NO SHOW CONFLICTS</h4>\n        <div class=\"col-md-12 no-padding mb-20\">\n            <div class=\"table-responsive\">\n                <table class=\"table table-xxs table-bordered table-fixed\">\n                  <thead class=\"header\">\n                      <tr>\n                        <th class=\"bg-slate-800 text-center text-uppercase\">employee name</th>\n                        <th class=\"bg-slate-800 text-center text-uppercase\">no show</th>\n                        <th class=\"bg-slate-800 text-center text-uppercase\">call out</th>\n                        <th class=\"bg-slate-800 text-center text-uppercase\">did not re-confirm</th>\n                        <th class=\"bg-slate-800 text-center text-uppercase\">date</th>\n                        <th class=\"bg-slate-800 text-center text-uppercase\">action</th>\n                        <th class=\"bg-slate-800 text-center text-uppercase\">status</th>\n                        <th class=\"bg-slate-800 text-center text-uppercase\">worked at</th>\n                      </tr>\n                  </thead>\n                  <tbody>\n                    <tr v-for=\"(index,employee) in employees\" :key=\"index\">\n                      <td class=\"text-center\">{{ employee[0].name }}</td>\n                      <td class=\"text-center\">{{{ findNoShow(employee) }}}</td>\n                      <td class=\"text-center\">{{{ findCallOut(employee) }}}</td>\n                      <td class=\"text-center\">{{{ findDidNoTReConfirm(employee) }}}</td>\n                      <td class=\"text-center\">{{ employee[0].date | customDateFormat 'YYYY-MM-DD' 'DD-MMM '}} </td>\n                      <td class=\"text-center\">\n                        <button class=\"btn btn-danger\" @click=\"showClearNoShowModal(employee)\">\n                            Action\n                        </button>\n                      </td>\n                      <td class=\"text-center\"> {{ findNoShow(employee,true) }}</td>\n                      <td class=\"text-center\">{{{ findWorked(employee) }}}</td>\n                    </tr>\n                  </tbody>\n                </table>\n            </div>\n        </div>\n        <div class=\"modal fade\" id=\"clear-no-show\" tabindex=\"-1\" role=\"dialog\">\n          <div class=\"modal-dialog modal-xs\" role=\"document\">\n            <div class=\"modal-content\">\n              <div class=\"modal-header\">\n                <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">×</span></button>\n                <h4 class=\"modal-title text-center text-uppercase bg-slate-300\">ACTION</h4>\n              </div>\n              <div class=\"modal-body no-padding-top no-padding-bottom\">\n                            <div class=\"col-md-12  text-left mt-20 mb-20\">\n                                <div class=\"col-md-3  text-left\">\n                                    <div class=\"text-left\">\n                                        <input type=\"checkbox\" value=\"1\" v-model=\"clearRecord\" name=\"status\">\n                                    </div>\n                                </div>\n                                <div class=\"col-md-9 text-left\">\n                                    <label class=\"text-color-black text-black no-padding-left\">CLEAR RECORDS</label>\n                                </div>\n                            </div>\n                            <div class=\"col-md-12 text-right mb-15\">\n                                <button type=\"button\" class=\"btn btn-primary\" @click=\"clearNoShowRecord()\">Submit</button>\n                            </div>\n              </div>\n              <div class=\"modal-footer\">\n                <!-- <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button>\n                <button type=\"button\" class=\"btn btn-primary\">Save changes</button> -->\n              </div>\n            </div><!-- /.modal-content -->\n          </div><!-- /.modal-dialog -->\n        </div><!-- /.modal -->\n    </div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  var id = "/home/shoieb/sites/elegant/resources/assets/js/vue/components/no-show-conflicts.vue"
  module.hot.dispose(function () {
    require("vueify-insert-css").cache["\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, module.exports.template)
  }
})()}
},{"./../../mixed/modals":10,"./../../mixed/notify":11,"vue":5,"vue-hot-reload-api":4,"vueify-insert-css":6}],58:[function(require,module,exports){
var __vueify_style__ = require("vueify-insert-css").insert("\n")
"use strict";

exports.__esModule = true;
var modals = require("./../../mixed/modals");
var notify = require("./../../mixed/notify");

exports["default"] = {
  data: function data() {
    return {
      employees: {},
      employee: null,
      list: {},
      suspend: 0,
      action: 10,
      statuses: {
        "Left VM": "LV",
        "Left Voice Mail": "LV",
        Answered: "ANSWERED",
        Called: "CALLED",
        Disc: "LD",
        "Hang Up": "HU",
        "Wrong No": "WN",
        "VM Full": "VF",
        "No VM": "NV",
        "delete": "DELETE",
        Call: "Call",
        Return: "Return",
        "Return-Apologetic": "RA",
        "Return-Bad Excuses": "RB",
        "Return-Don't Care": "RC",
        Apologetic: "A",
        "Bad Excuses": "B",
        "Don't Care": "C"
      },
      gradeStatus: ["Return-Apologetic", "Return-Bad Excuses", "Return-Don't Care", "Apologetic", "Bad Excuses", "Don't Care", "Return"],
      response: "",
      employeeResponse: "",
      returnedCallStatus: false,
      returnedCallDate: "",
      note: "",
      dispute: 0
    };
  },
  filters: {},
  watch: {},
  ready: function ready() {
    $(".table-fixed-header").fixedHeader();
    $(".header-copy").hide();
    $(".pickadate-year-invoice").pickadate({
      format: "yyyy-mm-dd",
      selectYears: 70,
      max: true,
      firstDay: 1
    });
    this.getEmployees();
  },
  events: {},
  methods: {
    /**
     * calculate call grading
     * @param log
     * @returns {*}
     */
    callLogGrading: function callLogGrading(log) {
      var responses = _.sortBy(_.cloneDeep(log), function (node) {
        return -new Date(node.created_at).getTime();
      });

      for (var i = 0; i < responses.length; i++) {
        if (this.gradeStatus.includes(responses[i].type)) {
          return "<span class=\"text-danger-400\">" + this.statuses[responses[i].type] + "</span>";
          break;
        }
      }
      return responses.length;
    },

    showPerformanceReport: function showPerformanceReport(employee) {
      window.bus.$emit("showEmployeePerformanceReport", employee.id);
    },

    getEmployees: function getEmployees() {
      var _this = this;

      notify.loading(true);
      this.$http.get("/api/no-show-verification-log-disputed", function (response) {
        _this.employees = response;
        //this.getEmployeeData(this.employees[0].id);
      }).always(function () {
        notify.loading(false);
      });
    },

    getEmployeeData: function getEmployeeData(id) {
      var _this2 = this;

      notify.loading(true);
      var that = this;
      this.$http.get("/api/no-show-verification-log-disputed/" + id, function (response) {
        _this2.employee = response;
        $(".header-copy").remove();
        _this2.$nextTick(function () {
          $(".table-fixed-header").fixedHeader();
          $(".header-copy").hide();
          $(".header-copy").css("display", "block");
          $(".actionButton").click(function () {
            that.showEmployeeListModal();
          });
          $(".callButton").click(function () {
            that.showResponseModal();
          });
          this.$nextTick(function () {
            $('[data-popup="popover"]').popover();
          });
        });
      }).always(function () {
        notify.loading(false);
      });
    },

    showEmployeeListModal: function showEmployeeListModal() {
      modals.showStrict("#employee-no-show-list");
    },

    showVerificationModal: function showVerificationModal(list) {
      this.action = 10;
      this.suspend = 0;
      this.employeeResponse = "";
      this.returnedCallStatus = false;
      this.returnedCallDate = "";
      this.note = "";
      this.dispute = 0;
      this.list = _.cloneDeep(list);
      modals.showStrict("#verification-modal");
    },

    formatDate: function formatDate(date, from, format) {
      if (moment(date).isValid()) {
        return moment(date, from).format(format);
      } else {
        return "";
      }
    },

    setEmployee: function setEmployee(employee) {
      this.getEmployeeData(employee.id);
    },

    countNote: function countNote(note) {
      return note.length > 19 ? false : true;
    },

    verifyNoShow: function verifyNoShow() {
      var _this3 = this;

      notify.loading(true);
      this.$http.post("/api/verify-no-show-entry/" + this.list.id, {
        note: this.note
      }, function (response) {
        modals.hide("#verification-modal");
        //modals.hide("#employee-no-show-list");
        //this.employee = null;
        _this3.note = "";
        _this3.getEmployees();
      }).always(function () {
        notify.loading(false);
      });
    },

    refreshEntry: function refreshEntry() {
      var _this4 = this;

      if (this.returnedCallStatus && !this.returnedCallDate) {
        notify.info("Please Set Returned Call Date");
        return false;
      }

      if (this.employeeResponse && this.action === 10) {
        notify.info("Please Select Final Action");
        return false;
      }

      if (this.note && this.action === 10 && !this.returnedCallStatus && !this.dispute) {
        notify.info("Please Select Final Action");
        return false;
      }

      if ((this.action !== 10 || this.returnedCallStatus || this.dispute) && this.note.length < 1) {
        notify.info("Please Add Note");
        return false;
      }

      var orderIds = _.pluck(this.employee.no_show_un_verified, "order_id");

      notify.loading(true);
      this.$http.post("/api/no-show-verification-process/" + this.list.id + "/" + this.action + "?suspend=" + this.suspend, {
        note: this.note,
        response: this.employeeResponse,
        returnedCall: this.returnedCallStatus ? "Return" : "",
        returnDate: this.returnedCallDate,
        orderIds: orderIds,
        dispute: this.dispute
      }, function (response) {
        modals.hide("#verification-modal");
        //modals.hide("#employee-no-show-list");
        //this.employee = null;
        _this4.getEmployeeData(_this4.list.employee_id);
        _this4.getEmployees();
      }).always(function () {
        notify.loading(false);
      });
    },

    showResponseModal: function showResponseModal() {
      modals.showStrict("#response-modal");
    },

    saveResponse: function saveResponse() {
      var _this5 = this;

      var orderIds = _.pluck(this.employee.no_show_un_verified, "order_id");
      notify.loading(true);
      this.$http.post("/api/save-employee-call-response", {
        employee_id: this.employee.id,
        type: this.response,
        entry_point: "No Show Verification",
        orderIds: orderIds
      }, function (response) {
        modals.hide("#response-modal");
        _this5.response = null;
        _this5.employee = null;
        _this5.getEmployees();
      }).always(function () {
        notify.loading(false);
      });
    }
  }
};
module.exports = exports["default"];
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n    <div class=\"row\">\n        <!-- <h4 class=\"text-center\">\n            No Show Employees Verification\n        </h4> -->\n        <div class=\"col-md-12\">\n            <div class=\"table-responsive\">\n                <table class=\"table table-bordered table-xxs table-fixed-header\">\n                    <thead class=\"header\">\n                    <tr>\n                        <th colspan=\"13\" class=\"no-padding-left no-padding-right\">\n                            <div v-if=\"employee\" class=\"col-md-12 no-padding\">\n                                <div class=\"col-md-8 mb-5 no-padding\">\n                                    <div class=\"col-md-12 bg-brown-700 no-padding\">\n                                        <div class=\"col-md-3 no-padding text-black bg-brown-700 text-center\">{{ employee.fullName }}</div>\n                                        <div class=\"col-md-3 no-padding text-black bg-brown-700 text-center\">{{ employee.primary_phone }}\n                                        </div>\n                                        <div class=\"col-md-3 no-padding text-black bg-brown-700 text-center\">{{ employee.secondary_phone\n                                            }}\n                                        </div>\n                                        <div class=\"col-md-3 no-padding text-black bg-brown-700 text-center\">{{ employee.email }}</div>\n                                    </div>\n                                    <div class=\"col-md-7 no-padding\">\n                                        <div class=\"col-md-12 no-padding\" v-for=\"(index,list) in employee.no_show_disputed\" :key=\"index\">\n                                            <div class=\"col-md-6 no-padding text-black bg-orange-custom text-center text-color-black\">\n                                                {{ list.order.client.company_code+' '+list.order.position.title}}\n                                            </div>\n                                            <div class=\"col-md-3 no-padding text-black bg-orange-custom text-center text-color-black\">\n                                                {{ formatDate(list.order.date,'YYYY-MM-DD','ddd') }}\n                                            </div>\n                                            <div class=\"col-md-3 no-padding text-black bg-orange-custom text-center text-color-black\">{{\n                                                formatDate(list.order.date,'YYYY-MM-DD','DD/MM/YYYY') }}\n                                            </div>\n                                        </div>\n                                    </div>\n                                    <div class=\"col-md-5 no-padding\">\n                                        <div class=\"col-md-6 text-center\">\n                                            <button class=\"btn btn-danger bg-danger-700 text-black mt-30 actionButton\" @click=\"showEmployeeListModal\">\n                                                Action\n                                            </button>\n                                        </div>\n                                        <div class=\"col-md-6 text-center\">\n                                            <button class=\"btn btn-primary bg-primary-700 text-black mt-30 callButton\" @click=\"showResponseModal\">\n                                                Called\n                                            </button>\n                                        </div>\n                                    </div>\n                                </div>\n                                <div class=\"col-md-4 mb-10 no-padding\">\n                                    <div class=\"col-md-12 no-padding\">\n                                        <div class=\"col-md-3 no-padding text-black bg-slate-700 text-center\">Date</div>\n                                        <div class=\"col-md-3 no-padding text-black bg-slate-700 text-center\">Time</div>\n                                        <div class=\"col-md-3 no-padding text-black bg-slate-700 text-center\">Called By</div>\n                                        <div class=\"col-md-3 no-padding text-black bg-slate-700 text-center\">Remarks</div>\n                                    </div>\n                                    <div class=\"col-md-12 no-padding\" v-for=\"(index,log) in employee.latest_responses\" :key=\"index\">\n                                        <div class=\"col-md-3 no-padding text-center border-bottom border-bottom border-left\">\n                                            {{ formatDate(log.created_at,'YYYY-MM-DD HH:mm:ss','D-MMM') }}\n                                        </div>\n                                        <div class=\"col-md-3 no-padding text-center  border-bottom border-bottom border-left\">\n                                            {{ formatDate(log.created_at,'YYYY-MM-DD HH:mm:ss','HH:mm A') }}\n                                        </div>\n                                        <div class=\"col-md-3 no-padding text-center  border-bottom border-bottom border-left\">\n                                            {{ log.user.name }}\n                                        </div>\n                                        <div class=\"col-md-3 no-padding text-center  border-bottom border-right border-bottom border-left\">\n                                            {{ statuses[log.type] }}\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                        </th>\n                    </tr>\n                    <tr>\n                        <th></th>\n                        <th></th>\n                        <th></th>\n                        <th></th>\n                        <th></th>\n                        <th></th>\n                        <th></th>\n                        <th></th>\n                        <th></th>\n                        <th></th>\n                        <th></th>\n                        <th></th>\n                        <th></th>\n                    </tr>\n                    <tr>\n                        <th class=\"bg-slate-700 text-black text-center\" rowspan=\"2\">P.Chart</th>\n                        <th class=\"bg-slate-700 text-black text-center\" rowspan=\"2\">EMPLOYEE NAME</th>\n                        <th class=\"bg-brown-700 text-black text-center\" colspan=\"5\">PENDING NO SHOW VERIFICATION</th>\n                        <th class=\"bg-brown text-black text-center\" rowspan=\"2\">90</th>\n                        <th class=\"bg-brown text-black text-center\" rowspan=\"2\">365</th>\n                        <th class=\"bg-slate-700 text-black text-center\" colspan=\"4\">CALL LOG</th>\n                    </tr>\n                    <tr>\n                        <th class=\"bg-brown-700 text-black text-center\">1</th>\n                        <th class=\"bg-brown-700 text-black text-center\">2</th>\n                        <th class=\"bg-brown-700 text-black text-center\">3</th>\n                        <th class=\"bg-brown-700 text-black text-center\">4</th>\n                        <th class=\"bg-brown-700 text-black text-center\">5</th>\n\n                        <th class=\"bg-slate-700 text-black text-center\">1st</th>\n                        <th class=\"bg-slate-700 text-black text-center\">2nd</th>\n                        <th class=\"bg-slate-700 text-black text-center\">3rd</th>\n                        <th class=\"bg-slate-700 text-black text-center\">4th</th>\n                    </tr>\n                    </thead>\n                    <tbody>\n                    <tr v-for=\"(index,employee) in employees\" :key=\"index\">\n                        <td class=\"text-center\">\n                            <button class=\"btn btn-primary\" @click=\"showPerformanceReport(employee)\">P.Chart\n                            </button>\n                        </td>\n                        <td class=\"text-center\" @click=\"setEmployee(employee)\">{{ employee.fullName }}</td>\n                        <td class=\"text-center\">{{ formatDate(employee.lists[0].order.date,'YYYY-MM-DD','D-MMM') }}</td>\n                        <td class=\"text-center\">{{ formatDate(employee.lists[1].order.date,'YYYY-MM-DD','D-MMM') }}</td>\n                        <td class=\"text-center\">{{ formatDate(employee.lists[2].order.date,'YYYY-MM-DD','D-MMM') }}</td>\n                        <td class=\"text-center\">{{ formatDate(employee.lists[3].order.date,'YYYY-MM-DD','D-MMM') }}</td>\n                        <td class=\"text-center\">{{ formatDate(employee.lists[4].order.date,'YYYY-MM-DD','D-MMM') }}</td>\n                        <td class=\"text-center bg-orange-light-custom\">{{ employee.no_show_verified_thirty_count }}</td>\n                        <td class=\"text-center bg-orange-light-custom\">{{ employee.no_show_verified_ninety_count }}</td>\n                        <td class=\"text-center\">{{ formatDate(employee.logs[0].created_at,'YYYY-MM-DD HH:mm:ss','D MMM')\n                            }} -\n                            <span class=\"text-danger-400\">{{ statuses[employee.logs[0].type] }}</span>\n                        </td>\n                        <td class=\"text-center\">{{ formatDate(employee.logs[1].created_at,'YYYY-MM-DD HH:mm:ss','D MMM')\n                            }} -\n                            <span class=\"text-danger-400\">{{ statuses[employee.logs[1].type] }}</span>\n                        </td>\n                        <td class=\"text-center\">{{ formatDate(employee.logs[2].created_at,'YYYY-MM-DD HH:mm:ss','D MMM')\n                            }} -\n                            <span class=\"text-danger-400\">{{ statuses[employee.logs[2].type] }}</span>\n                        </td>\n                        <td class=\"text-center\">{{ formatDate(employee.logs[3].created_at,'YYYY-MM-DD HH:mm:ss','D MMM')\n                            }} -\n                            <span class=\"text-danger-400\">{{ statuses[employee.logs[3].type] }}</span>\n                        </td>\n                    </tr>\n                    </tbody>\n                </table>\n            </div>\n        </div>\n\n        <div class=\"modal fade\" id=\"employee-no-show-list\">\n            <div class=\"modal-dialog modal-full\">\n                <div class=\"modal-content\">\n                    <div class=\"modal-header no-padding\">\n                        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\">×</button>\n                        <h4 class=\"modal-title bg-orange-custom text-black text-color-black p-20\">{{ employee.fullName\n                            }}</h4>\n                    </div>\n                    <div class=\"modal-body p-10 no-padding-top\">\n                        <div class=\"row\">\n                            <div class=\"col-md-12\">\n                                <h4 class=\"text-center text-black bg-brown-700 no-padding no-margin\">PENDING NO\n                                    SHOW</h4>\n                                <div class=\"table-responsive\">\n                                    <table class=\"table table-bordered table-xxs\">\n                                        <thead>\n                                        <tr class=\"bg-brown\">\n                                            <th class=\"text-center text-black text-color-black\">DATE</th>\n                                            <th class=\"text-center text-black text-color-black\">POSITION</th>\n                                            <th class=\"text-center text-black text-color-black\">1st Call</th>\n                                            <th class=\"text-center text-black text-color-black\">2nd Call</th>\n                                            <th class=\"text-center text-black text-color-black\">3rd Call</th>\n                                            <th class=\"text-center text-black text-color-black\">4th Call</th>\n                                            <th class=\"text-center text-black text-color-black\">NOTE</th>\n                                            <th class=\"text-center text-black text-color-black\">VERIFY</th>\n                                        </tr>\n                                        </thead>\n                                        <tbody>\n                                        <tr v-for=\"(index,list) in employee.no_show_disputed\" :key=\"index\">\n                                            <td class=\"text-center\">\n                                                {{ formatDate(list.order.date,'YYYY-MM-DD','M/D/YYYY') }}\n                                            </td>\n                                            <td>\n                                                {{ list.order.client.company_code+' '+list.order.position.title}}\n                                            </td>\n                                            <td class=\"text-center\">\n                                                {{\n                                                formatDate(list.order.responses[0].created_at,'YYYY-MM-DD\n                                                HH:mm:ss','D-MMM') }} -\n                                                <span class=\"text-danger-400\">{{ statuses[list.order.responses[0].type] }}</span>\n                                            </td>\n                                            <td class=\"text-center\">\n                                                {{\n                                                formatDate(list.order.responses[1].created_at,'YYYY-MM-DD\n                                                HH:mm:ss','D-MMM') }} -\n                                                <span class=\"text-danger-400\">{{ statuses[list.order.responses[1].type] }}</span>\n                                            </td>\n                                            <td class=\"text-center\">\n                                                {{\n                                                formatDate(list.order.responses[2].created_at,'YYYY-MM-DD\n                                                HH:mm:ss','D-MMM') }} -\n                                                <span class=\"text-danger-400\">{{ statuses[list.order.responses[2].type] }}</span>\n                                            </td>\n                                            <td class=\"text-center\">\n                                                {{\n                                                formatDate(list.order.responses[3].created_at,'YYYY-MM-DD\n                                                HH:mm:ss','D-MMM') }} -\n                                                <span class=\"text-danger-400\">{{ statuses[list.order.responses[3].type] }}</span>\n                                            </td>\n                                            <td class=\"text-center text-black text-color-black\">\n                                                <button v-if=\"list.note\" type=\"button\" class=\"btn btn-default btn-sm\" data-html=\"true\" data-popup=\"popover\" data-title=\"\" data-trigger=\"hover\" :data-content=\"list.note | formatNote\"><i class=\"icon-notebook position-right\"></i></button>\n                                            </td>\n                                            <td class=\"text-center\">\n                                                <button class=\"btn btn-primary text-center\" @click=\"showVerificationModal(list)\"> Verify\n                                                </button>\n                                            </td>\n                                        </tr>\n                                        </tbody>\n                                    </table>\n                                </div>\n                            </div>\n                            <div class=\"col-md-12 mt-150\">\n                                <h4 class=\"text-center text-black bg-slate-700 no-padding no-margin\">VERIFIED NO\n                                    SHOW</h4>\n                                <div class=\"table-responsive\">\n                                    <table class=\"table table-bordered table-xxs\">\n                                        <thead>\n                                        <tr class=\"bg-slate\">\n                                            <th class=\"text-center text-black text-color-black\">DATE</th>\n                                            <th class=\"text-center text-black text-color-black\">POSITION</th>\n                                            <th class=\"text-center text-black text-color-black\">Grade</th>\n                                            <th class=\"text-center text-black text-color-black\">1st Call</th>\n                                            <th class=\"text-center text-black text-color-black\">2nd Call</th>\n                                            <th class=\"text-center text-black text-color-black\">3rd Call</th>\n                                            <th class=\"text-center text-black text-color-black\">4th Call</th>\n                                            <th class=\"text-center text-black text-color-black\">NOTE</th>\n                                        </tr>\n                                        </thead>\n                                        <tbody>\n                                        <tr v-for=\"(index,list) in employee.no_show_verified\" :key=\"index\">\n                                            <td class=\"text-center\">\n                                                {{ formatDate(list.order.date,'YYYY-MM-DD','M/D/YYYY') }}\n                                            </td>\n                                            <td class=\"text-center\">\n                                                {{ list.order.client.company_code+' '+list.order.position.title}}\n                                            </td>\n                                            <td class=\"text-center\">\n                                                {{{ callLogGrading(list.order.responses) }}}\n                                            </td>\n                                            <td class=\"text-center\">\n                                                {{\n                                                formatDate(list.order.responses[0].created_at,'YYYY-MM-DD\n                                                HH:mm:ss','MM-DD-YYYY') }} -\n                                                <span class=\"text-danger-400\">{{ statuses[list.order.responses[0].type] }}</span>\n                                            </td>\n                                            <td class=\"text-center\">\n                                                {{\n                                                formatDate(list.order.responses[1].created_at,'YYYY-MM-DD\n                                                HH:mm:ss','MM-DD-YYYY') }} -\n                                                <span class=\"text-danger-400\">{{ statuses[list.order.responses[1].type] }}</span>\n                                            </td>\n                                            <td class=\"text-center\">\n                                                {{\n                                                formatDate(list.order.responses[2].created_at,'YYYY-MM-DD\n                                                HH:mm:ss','MM-DD-YYYY') }} -\n                                                <span class=\"text-danger-400\">{{ statuses[list.order.responses[2].type] }}</span>\n                                            </td>\n                                            <td class=\"text-center\">\n                                                {{\n                                                formatDate(list.order.responses[3].created_at,'YYYY-MM-DD\n                                                HH:mm:ss','MM-DD-YYYY') }} -\n                                                <span class=\"text-danger-400\">{{ statuses[list.order.responses[3].type] }}</span>\n                                            </td>\n                                            <td class=\"text-center\">\n                                                <button v-if=\"list.note\" type=\"button\" class=\"btn btn-default btn-sm\" data-html=\"true\" data-popup=\"popover\" data-title=\"\" data-trigger=\"hover\" :data-content=\"list.note | formatNote\"><i class=\"icon-notebook position-right\"></i></button>\n                                            </td>\n                                        </tr>\n                                        </tbody>\n                                    </table>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"modal-footer\">\n                        <!--<button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button>-->\n                        <!--<button type=\"button\" class=\"btn btn-primary\">Save changes</button>-->\n                    </div>\n                </div><!-- /.modal-content -->\n            </div><!-- /.modal-dialog -->\n        </div><!-- /.modal -->\n\n\n        <div class=\"modal fade\" id=\"verification-modal\">\n            <div class=\"modal-dialog modal-lg bg-slate-300\">\n                <div class=\"modal-content\">\n                    <div class=\"modal-header bg-slate-300 text-right\">\n                        <button class=\"text-black text-color-black\" type=\"button\" data-dismiss=\"modal\" aria-hidden=\"true\">×\n                        </button>\n                        <!--<h4 class=\"modal-title\">Modal title</h4>-->\n                    </div>\n                    <div class=\"modal-body bg-slate-300 no-padding pt-20\">\n                        <!--<div class=\"radio\">-->\n                        <!--<label class=\"text-color-black text-black no-padding-left\"><input type=\"checkbox\" value=\"1\"-->\n                        <!--v-model=\"suspend\"-->\n                        <!--name=\"undo\">Suspend</label>-->\n                        <!--</div>-->\n                        <!--<br>-->\n                        <!--<button type=\"button\" class=\"btn bg-brown\" @click=\"verifyNoShow\">VERIFIED</button>-->\n                        <!--<br>-->\n\n                        <div class=\"col-md-4 bg-slate-300 no-padding min-height-150\">\n                            <h4 class=\"bg-blue-300 text-black text-center\">MISSED</h4>\n                            <div class=\"col-md-12\">\n                                <div class=\"col-md-12 text-center\">\n                                    <div class=\"form-group\">\n                                        <input type=\"checkbox\" value=\"1\" v-model=\"returnedCallStatus\" name=\"reruened-call\">\n                                        Returned Call\n                                    </div>\n                                </div>\n                                <div class=\"col-md-12 text-center\">\n                                    <div class=\"form-group pr-10\">\n                                        <input type=\"text\" name=\"\" class=\"form-control text-black pickadate-year-invoice\" v-model=\"returnedCallDate\">\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n\n                        <div class=\"col-md-4 bg-slate-300 no-padding min-height-150\">\n                            <h4 class=\"bg-black-center text-black\">TALKED</h4>\n                            <div class=\"col-md-12\">\n                                <div class=\"col-md-3\">\n                                    <div class=\"text-right\">\n                                        <input type=\"radio\" value=\"Apologetic\" v-model=\"employeeResponse\" name=\"employee-response\">\n                                    </div>\n                                </div>\n                                <div class=\"col-md-9 text-left\">\n                                    <label class=\"text-color-black text-black no-padding-left\">Apologetic</label>\n                                </div>\n                            </div>\n                            <div class=\"col-md-12\">\n                                <div class=\"col-md-3\">\n                                    <div class=\"text-right\">\n                                        <input type=\"radio\" value=\"Bad Excuses\" v-model=\"employeeResponse\" name=\"employee-response\">\n                                    </div>\n                                </div>\n                                <div class=\"col-md-9 text-left\">\n                                    <label class=\"text-color-black text-black no-padding-left\">Bad Excuses</label>\n                                </div>\n                            </div>\n                            <div class=\"col-md-12\">\n                                <div class=\"col-md-3\">\n                                    <div class=\"text-right\">\n                                        <input type=\"radio\" value=\"Don't Care\" v-model=\"employeeResponse\" name=\"employee-response\">\n                                    </div>\n                                </div>\n                                <div class=\"col-md-9 text-left\">\n                                    <label class=\"text-color-black text-black no-padding-left\">Don't Care</label>\n                                </div>\n                            </div>\n                        </div>\n\n                        <div class=\"col-md-4 bg-slate-300 no-padding min-height-150\">\n                            <h4 class=\"bg-danger text-black text-center\">FINAL ACTION</h4>\n                            <div class=\"col-md-12\">\n                                <div class=\"col-md-3\">\n                                    <div class=\"text-right\">\n                                        <input type=\"radio\" value=\"1\" v-model=\"action\" name=\"undo\">\n                                    </div>\n                                </div>\n                                <div class=\"col-md-9 text-left\">\n                                    <label class=\"text-color-black text-black no-padding-left\">NO SHOW</label>\n                                </div>\n                            </div>\n                            <div class=\"col-md-12\">\n                                <div class=\"col-md-3\">\n                                    <div class=\"text-right\">\n                                        <input type=\"radio\" value=\"2\" v-model=\"action\" name=\"undo\">\n                                    </div>\n                                </div>\n                                <div class=\"col-md-9 text-left\">\n                                    <label class=\"text-color-black text-black no-padding-left\">Worked</label>\n                                </div>\n                            </div>\n                            <div class=\"col-md-12\">\n                                <div class=\"col-md-3\">\n                                    <div class=\"text-right\">\n                                        <input type=\"radio\" value=\"4\" v-model=\"action\" name=\"undo\">\n                                    </div>\n                                </div>\n                                <div class=\"col-md-9 text-left\">\n                                    <label class=\"text-color-black text-black no-padding-left\">Clear Record</label>\n                                </div>\n                            </div>\n                        </div>\n\n                        <div class=\"col-md-12 pl-20\">\n                            <div class=\"form-group\">\n                                <textarea name=\"\" id=\"\" cols=\"100\" rows=\"5\" v-model=\"note\"></textarea>\n                            </div>\n                        </div>\n\n                    </div>\n                    <div class=\"modal-footer bg-slate-300\">\n                        <div class=\"col-md-6 text-left\">\n\n                        </div>\n                        <!--<button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button>-->\n                        <div class=\"col-md-6 text-right\">\n                            <button type=\"button\" class=\"btn btn-success pull-right\" @click=\"refreshEntry\">Submit</button>\n                        </div>\n                    </div>\n                </div><!-- /.modal-content -->\n            </div><!-- /.modal-dialog -->\n        </div><!-- /.modal -->\n\n        <div class=\"modal fade\" id=\"response-modal\">\n            <div class=\"modal-dialog modal-xs\">\n                <div class=\"modal-content bg-orange-custom\">\n                    <div class=\"modal-header\">\n                        <button class=\"text-black text-color-black\" type=\"button\" data-dismiss=\"modal\" aria-hidden=\"true\">×\n                        </button>\n                        <!--<h4 class=\"modal-title\">Modal title</h4>-->\n                    </div>\n                    <div class=\"modal-body\">\n                        <div class=\"col-md-12\">\n                            <div class=\"form-group\">\n                                <div class=\"radio\">\n                                    <label><input type=\"radio\" value=\"Left VM\" name=\"callledStatus\" v-model=\"response\">Left\n                                        Voicemail</label>\n                                </div>\n                                <div class=\"radio\">\n                                    <label><input type=\"radio\" value=\"No VM\" name=\"callledStatus\" v-model=\"response\">Did'nt\n                                        Leave Voicemail</label>\n                                </div>\n                                <div class=\"radio\">\n                                    <label><input type=\"radio\" value=\"VM Full\" name=\"callledStatus\" v-model=\"response\">Voicemail\n                                        Full</label>\n                                </div>\n                                <div class=\"radio\">\n                                    <label><input type=\"radio\" value=\"Hang Up\" name=\"callledStatus\" v-model=\"response\">Hang\n                                        Up</label>\n                                </div>\n                                <div class=\"radio\">\n                                    <label><input type=\"radio\" value=\"Disc\" name=\"callledStatus\" v-model=\"response\">Line\n                                        Disconnected</label>\n                                </div>\n                                <div class=\"radio\">\n                                    <label><input type=\"radio\" value=\"Wrong No\" name=\"callledStatus\" v-model=\"response\">Wrong\n                                        Number</label>\n                                </div>\n                            </div>\n                            <div class=\"text-right\">\n                                <button type=\"button\" class=\"btn btn-primary\" @click=\"saveResponse\">Save\n                                </button>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"modal-footer\">\n                        <!--<button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button>-->\n                    </div>\n                </div><!-- /.modal-content -->\n            </div><!-- /.modal-dialog -->\n        </div><!-- /.modal -->\n        <employee-performance-data></employee-performance-data>\n    </div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  var id = "/home/shoieb/sites/elegant/resources/assets/js/vue/components/no-show-dispute.vue"
  module.hot.dispose(function () {
    require("vueify-insert-css").cache["\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, module.exports.template)
  }
})()}
},{"./../../mixed/modals":10,"./../../mixed/notify":11,"vue":5,"vue-hot-reload-api":4,"vueify-insert-css":6}],59:[function(require,module,exports){
var __vueify_style__ = require("vueify-insert-css").insert("\n")
"use strict";

exports.__esModule = true;
var modals = require("./../../mixed/modals");
var notify = require("./../../mixed/notify");

exports["default"] = {
  data: function data() {
    return {
      state: false,
      employees: {},
      allEmployees: {},
      clients: {},
      client_id: "",
      employee_id: "",
      start_date: "",
      end_date: "",
      activeEmployee: {},
      action: 0
    };
  },
  filters: {},
  watch: {
    clients: function clients() {
      // $("#position-client").selectric("refresh");
    },
    client_id: function client_id() {
      this.getNoShowEmployees();
    },
    employee_id: function employee_id() {
      this.getNoShowEmployees();
    },
    start_date: function start_date() {
      this.getNoShowEmployees();
    },
    end_date: function end_date() {
      this.getNoShowEmployees();
    }
  },
  ready: function ready() {
    this.getNoShowEmployees();
    this.getClientList();
    this.getEmployeeList();
  },
  events: {},
  methods: {
    getClientList: function getClientList() {
      var _this = this;

      this.$http.get("/api/order-data", "", function (response) {
        _this.clients = response;
      }).always(function () {});
    },

    getEmployeeList: function getEmployeeList() {
      var _this2 = this;

      this.$http.get("/api/employee-list-data", "", function (response) {
        _this2.allEmployees = response;
      }).always(function () {});
    },
    /**
     * get employee report data
     */
    getNoShowEmployees: function getNoShowEmployees() {
      var _this3 = this;

      notify.loading(true);
      this.$http.get("/api/no-show-employees?start_date=" + this.start_date + "&end_date=" + this.end_date + "&client_id=" + this.client_id + "&employee_id=" + this.employee_id, function (response) {
        _this3.employees = response;
      }).always(function () {
        notify.loading(false);
      });
    },

    /**
     * move worked employees back to no-show status
     */
    moveToNoWork: function moveToNoWork() {
      var _this4 = this;

      notify.loading(true);
      this.$http.get("/api/move-to-worked/" + this.activeEmployee.id + "/" + this.action, function (response) {
        _this4.getNoShowEmployees();
        modals.hide("#undo-modal");
      }).always(function () {
        notify.loading(false);
      });
    },

    showUndoModal: function showUndoModal(employee) {
      this.action = 0;
      this.activeEmployee = employee;
      modals.showStrict("#undo-modal");
    }
  }
};
module.exports = exports["default"];
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n    <div class=\"row \">\n        <div class=\"col-md-7 no-padding\">\n            <h4 class=\"bg-brown text-black text-center no-padding no-margin\">\n                NO SHOW\n            </h4>\n        </div>\n        <div class=\"col-md-7 no-padding-top no-padding-bottom bg-brown-300\">\n            <div class=\"col-md-6\">\n                <div class=\"form-group\">\n                    <label>Select Client</label>\n                    <select class=\"form-control \" name=\"\" id=\"position-client\" v-select2=\"client_id\" v-model=\"client_id\">\n                        <option value=\"\">Show All</option>\n                        <option v-for=\"(index,client) in clients\" :key=\"index\" :value=\"client.id\">{{ client.name }}\n                        </option>\n                    </select>\n                </div>\n            </div>\n            <div class=\"col-md-6\">\n                <div class=\"form-group pl-10\">\n                    <label for=\"start_date\">Start Date</label>\n                    <input type=\"text\" class=\"form-control pickadate-year text-black\" v-model=\"start_date\" id=\"start_date\">\n                </div>\n            </div>\n        </div>\n        <div class=\"col-md-7 no-padding-top no-padding-bottom bg-brown-300\">\n            <div class=\"col-md-6\">\n                <div class=\"form-group\">\n                    <label>Select Employee</label>\n                    <select class=\"form-control \" name=\"\" id=\"employee-list\" v-select2=\"employee_id\" v-model=\"employee_id\">\n                        <option value=\"\">Show All</option>\n                        <option v-for=\"(index,employee) in allEmployees\" :key=\"index\" :value=\"employee.id\">{{ employee.fullName }}\n                        </option>\n                    </select>\n                </div>\n            </div>\n            <div class=\"col-md-6\">\n                <div class=\"form-group pl-10\">\n                    <label for=\"end_date\">End Date</label>\n                    <input type=\"text\" class=\"form-control pickadate-year text-black\" v-model=\"end_date\" id=\"end_date\">\n                </div>\n            </div>\n        </div>\n        <div class=\"col-md-7 no-padding\">\n            <table class=\"table table-xxs table-bordered\">\n                <thead>\n                <tr>\n                    <!--<th class=\"bg-indigo-400 text-black text-center\" colspan=\"2\">Employees</th>-->\n                    <th class=\"bg-black-center text-black text-center text-uppercase\">Employee</th>\n                    <th class=\"bg-black-center text-black text-center text-uppercase\">Date</th>\n                    <th class=\"bg-black-center text-black text-center text-uppercase\">Job</th>\n                    <th class=\"bg-black-center text-black text-center text-uppercase\">Undo</th>\n                </tr>\n                </thead>\n                <tbody v-for=\"(index,employee) in employees\" :key=\"index\">\n                <!--<tr class=\"bg-slate-300\">-->\n                <!--<td class=\"text-center\" colspan=\"4\">-->\n                <!--{{ employee[0].date| customDateFormat 'YYYY-MM-DD' 'dddd DD/MM/YY'}} {{-->\n                <!--employee[0].company_code+' '+employee[0].title }}-->\n                <!--</td>-->\n                <!--</tr>-->\n                <tr v-for=\"(ind,emp) in employee\" :key=\"ind\">\n                    <td class=\"text-center\">{{ emp.first_name+' '+emp.last_name }}</td>\n                    <td class=\"text-center\">{{ emp.date }}</td>\n                    <td class=\"text-center\">{{ emp.company_code+' '+emp.title}}</td>\n                    <td class=\"text-center\">\n                        <button class=\"btn btn-info btn-xs p-2\" @click=\"showUndoModal(emp)\">Undo</button>\n                    </td>\n                </tr>\n                </tbody>\n            </table>\n        </div>\n\n        <div class=\"modal fade\" id=\"undo-modal\">\n            <div class=\"modal-dialog modal-xs\">\n                <div class=\"modal-content bg-brown-300\">\n                    <div class=\"modal-header\">\n                        <button type=\"button\" class=\"close text-black text-color-black\" data-dismiss=\"modal\" aria-hidden=\"true\">×</button>\n                        <h4 class=\"modal-title\">Select An Action</h4>\n                    </div>\n                    <div class=\"modal-body bg-brown-300\">\n                        <div class=\"form-group\">\n                            <div class=\"radio\">\n                                <label class=\"text-color-black text-black\"><input type=\"radio\" value=\"3\" v-model=\"action\" name=\"undo\">Undo</label>\n                            </div>\n                            <div class=\"radio\">\n                                <label class=\"text-color-black text-black\"><input type=\"radio\" value=\"2\" v-model=\"action\" name=\"no-show\">Worked</label>\n                            </div>\n                            <div class=\"radio\">\n                                <label class=\"text-color-black text-black\"><input type=\"radio\" value=\"4\" v-model=\"action\" name=\"clear-record\">Clear\n                                    Record</label>\n                            </div>\n                        </div>\n                        <div class=\"form-group text-right\">\n                            <button type=\"button\" class=\"btn bg-green-300 text-black\" @click=\"moveToNoWork\">Submit</button>\n                        </div>\n                    </div>\n                </div>\n                <!--<div class=\"modal-footer\">-->\n                <!--<button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button>-->\n                <!--<button type=\"button\" class=\"btn btn-primary\">Save changes</button>-->\n                <!--</div>-->\n            </div><!-- /.modal-content -->\n        </div><!-- /.modal-dialog -->\n    </div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  var id = "/home/shoieb/sites/elegant/resources/assets/js/vue/components/no-show-employees.vue"
  module.hot.dispose(function () {
    require("vueify-insert-css").cache["\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, module.exports.template)
  }
})()}
},{"./../../mixed/modals":10,"./../../mixed/notify":11,"vue":5,"vue-hot-reload-api":4,"vueify-insert-css":6}],60:[function(require,module,exports){
var __vueify_style__ = require("vueify-insert-css").insert("\n.re-confirm > div.col-md-12[_v-8cc66946],\n.re-confirm > div.col-md-6[_v-8cc66946],\n.re-confirm > div.col-md-12[_v-8cc66946] {\n  padding: 0 !important;\n}\n\n.bordered-div[_v-8cc66946] {\n  border-left: 1px solid #ddd;\n  border-right: 1px solid #ddd;\n}\n\n.bordered-left[_v-8cc66946] {\n  border-left: 1px solid #ddd;\n}\n\n.bordered-right[_v-8cc66946] {\n  border-right: 1px solid #ddd;\n}\n\n.bordered-bottom[_v-8cc66946] {\n  border-bottom: 1px solid #ddd;\n}\n\n.fixed-header[_v-8cc66946] {\n  position: fixed;\n  top: 48px;\n  right: 0px;\n  z-index: 1000 !important;\n}\n\n.middle-div[_v-8cc66946] {\n  width: 60% !important;\n  right: 20% !important;\n}\n\n.div-20[_v-8cc66946] {\n  width: 20% !important;\n}\n\n.div-60[_v-8cc66946] {\n  width: 60% !important;\n}\n\n.top-65[_v-8cc66946] {\n  top: 65px;\n}\n\n\n.pt-65[_v-8cc66946] {\n  padding-top: 65px;\n}\n\n\n.list-div[_v-8cc66946] {\n  margin-bottom: 40px;\n  min-height: 900px !important;\n}\n\n.bottom-div[_v-8cc66946] {\n  position: fixed;\n  bottom: 0px;\n  right: 0px;\n  z-index: 1000 !important;\n  height: 40px !important;\n  width: 100%;\n}\n\n.mb-40[_v-8cc66946] {\n  margin-bottom: 40px !important;\n}\n\n.p-40[_v-8cc66946] {\n  padding-top: 40px;\n  padding-bottom: 40px;\n}\n\n.m-30[_v-8cc66946] {\n  margin-left: 30px;\n  margin-right: 30px;\n}\n\n.h-30[_v-8cc66946] {\n  min-height: 50px !important;\n}\n\n.h-25[_v-8cc66946] {\n  min-height: 25px !important;\n}\n\n\n.border-custom-grey[_v-8cc66946] {\n  border-color: #ddd !important;\n}\n\n.w-120[_v-8cc66946] {\n  min-width: 120px !important;\n}\n\n.w-100[_v-8cc66946] {\n  min-width: 100px !important;\n}\n\n.col-md-15[_v-8cc66946] {\n  width: 10.99999995%;\n  float: left;\n}\n\n.text-grey-custom[_v-8cc66946] {\n  color: #696666 !important;\n}\n\n.btn-brown[_v-8cc66946] {\n  color: #fff;\n  background-color: #6f4c42;\n  border: 2px solid #ffffff;\n}\n\n.btn-brown[_v-8cc66946]:active, .btn-brown.active[_v-8cc66946]:hover, .btn-brown[_v-8cc66946]:focus, .btn-brown[_v-8cc66946]:target, .btn-brown.active[_v-8cc66946]:focus, .btn-brown:active.focus[_v-8cc66946], .btn-brown.active.focus[_v-8cc66946] {\n  border: 2px solid #6f4c42 !important;\n}\n\n@media (max-width: 1024px) {\n  .h-30[_v-8cc66946] {\n    min-height: 55px !important;\n  }\n}\n\n\n.close-modal[_v-8cc66946] {\n  font-size: 30px;\n  margin-top: -14.75px;\n  font-weight: 500;\n}\n\n.font-20[_v-8cc66946] {\n  font-size: 20px;\n}\n\n")
"use strict";

exports.__esModule = true;
var modals = require("./../../mixed/modals");
var notify = require("./../../mixed/notify");

exports["default"] = {
  data: function data() {
    return {
      issues: {
        in_hour: '',
        in_minute: '',
        in_format: '',
        out_hour: '',
        out_minute: '',
        out_format: '',
        "break": '',
        note: ''
      },
      shiftClaim: {
        client_id: '',
        date: '',
        employee_id: '',
        position_code: '',
        in_hour: '',
        in_minute: '',
        in_format: '',
        out_hour: '',
        out_minute: '',
        out_format: '',
        "break": '',
        note: ''
      },
      allClients: {},
      allEmployees: {},
      selectedClient: {},
      hours: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
      minutes: ['00', '05', '10', '15', '20', '25', '30', '35', '40', '45', '50', '55', '60'],
      breaks: ['00', '05', '10', '15', '20', '25', '30', '35', '40', '45', '50', '55', '60', '65', '70', '75', '80', '85', '90'],
      dates: [],
      tab: 'due',
      startDate: '',
      endDate: '',
      state: false,
      employees: {},
      singleEmployeeList: {},
      clients: {},
      order: {
        client_id: "",
        position_code: ""
      },
      week: '',
      date: '',
      activeEmployee: {},
      activeAction: '',
      status: 0,
      note: '',
      statuses: {
        "Left VM": "LV",
        "Left Voice Mail": "LV",
        "Left Voicemail": "LV",
        "Mailbox Full": "MF",
        "Out of Service": "OS",
        "Answered": "ANSWERED",
        "Called": "Called",
        "Disc": "LD",
        "Hang Up": "HU",
        "Wrong No": "WN",
        "VM Full": "VF",
        "No VM": "NV",
        "delete": "DELETE",
        "Call": "Call",
        "Return": "Return",
        "Returned": "Returned",
        "Return-Apologetic": "RA",
        "Return-Bad-Excuses": "RB",
        "Return-Don't Care": "RC",
        "Apologetic": "A",
        "Bad Excuses": "B",
        "Don't Care": "C",
        "": ""
      }
    };
  },

  props: ['tablet', 'desktop'],

  computed: {

    updatedEmployees: function updatedEmployees() {
      return _.filter(this.employees, function (o) {
        return o.worked || o.no_show;
      });
    },

    updatedCollectedEmployees: function updatedCollectedEmployees() {
      return _.filter(this.collectedEmployees, function (o) {
        return o.checked;
      });
    },

    employeeGroups: function employeeGroups() {
      return _.groupBy(this.employees, "date");
    },

    collectedEmployeeGroups: function collectedEmployeeGroups() {
      return _.groupBy(this.collectedEmployees, "department_id");
    }
  },
  filters: {},
  watch: {
    "date": function date(val) {
      this.getNoShowEmployees(val);
    },

    clients: function clients() {
      $("#position-client").selectric("refresh");
    },

    activeClient: function activeClient() {
      //   $("#position-code").selectric("refresh");
    },
    "order.position_code": function orderPosition_code(val) {
      this.getNoShowEmployees(val);
    },
    'selectedClient': function selectedClient() {
      $('#position-code').selectric('refresh');
    },

    'shiftClaim.client_id': function shiftClaimClient_id(val) {
      this.selectedClient = _.clone(_.find(this.allClients, function (o) {
        return o.id == val;
      }));
    }
  },
  ready: function ready() {
    //$(".table").fixedHeader();
    this.getNoShowEmployees();
    this.getEmployees();
    this.getClientList();
  },
  events: {},
  methods: {

    formatNote: function formatNote(emp) {
      var notes = '';
      notes += '<b>Action Note:</b> ' + emp.note + '<br><br>';

      if (emp.logs.length) {
        notes += '<b>Communication:</b> <br>';
      }

      _.forEach(emp.logs, function (log) {
        notes += '<li>' + log.type + ' ' + log.date + ' ' + log.user.name + ' - ' + log.note + ' </li>';
      });

      this.$nextTick(function () {
        $('[data-popup="popover"]').popover();
      });

      return notes;
    },

    /**
     * update list based on user entry
     */
    saveShiftClaim: function saveShiftClaim() {
      this.$http.post("/api/save-missing-shift-claim", this.shiftClaim, function (response) {
        notify.info('Missing shift added successfully.');
        modals.hide("#missing-shift-claim-modal");
      }).always(function () {
        //notify.loading(false);
      });
    },

    showShiftClaimModal: function showShiftClaimModal() {
      this.shiftClaim = {
        client_id: '',
        date: '',
        employee_id: '',
        position_code: '',
        in_hour: '',
        in_minute: '',
        in_format: '',
        out_hour: '',
        out_minute: '',
        out_format: '',
        "break": '',
        note: ''
      };
      modals.showStrict("#missing-shift-claim-modal");
    },

    /**
     * get list of clients
     */
    getEmployees: function getEmployees() {
      var _this = this;

      this.$http.get('/api/employee-list-data', '', function (response) {
        _this.allEmployees = response;
      }).always(function () {});
    },

    getClientList: function getClientList() {
      var _this2 = this;

      this.$http.get("/api/order-data", "", function (response) {
        _this2.allClients = response;
      }).always(function () {});
    },

    groupByDate: function groupByDate(data) {
      return _.groupBy(data, "client_id");
    },

    /**
     * get employee list
     */
    getNoShowEmployees: function getNoShowEmployees() {
      var _this3 = this;

      notify.loading(true);
      this.$http.get("/api/no-show-verification-log-approval", function (response) {
        _this3.employees = response;
      }).always(function () {
        notify.loading(false);
      });
    },

    /**
     * get employee list
     */
    getNoShowSingleEmployee: function getNoShowSingleEmployee(id) {
      var _this4 = this;

      notify.loading(true);
      this.$http.get("/api/no-show-verification-log-single/" + id, function (response) {
        _this4.singleEmployeeList = response;
        modals.showStrict("#single-list-modal");
      }).always(function () {
        notify.loading(false);
      });
    },

    showInputModal: function showInputModal(employee) {
      this.activeEmployee = _.cloneDeep(employee);
      modals.showStrict("#input-modal");
    },

    setAction: function setAction(action) {
      this.activeAction = action;
    },

    updateAction: function updateAction() {
      var _this5 = this;

      if (this.activeAction) {
        notify.loading(true);
        this.$http.post("/api/no-show-verification-log-update-action/" + this.activeEmployee.employee_order_status_log_id, {
          action: this.activeAction
        }, function (response) {
          _this5.getNoShowEmployees();
          modals.hide("#input-modal");
        }).always(function () {
          notify.loading(false);
        });
      } else {
        notify.info('Please set an action first.');
      }
    },

    updateApprovalStatus: function updateApprovalStatus() {
      var _this6 = this;

      notify.loading(true);
      this.$http.post("/api/no-show-verification-log-update-status/" + this.activeEmployee.employee_order_status_log_id, {
        action: this.activeEmployee.action
      }, function (response) {
        _this6.getNoShowEmployees();
      }).always(function () {
        notify.loading(false);
      });
    },

    showIssuesModal: function showIssuesModal() {
      this.issues = {
        in_hour: '',
        in_minute: '',
        in_format: '',
        out_hour: '',
        out_minute: '',
        out_format: '',
        "break": '',
        note: ''
      };
      modals.showStrict("#issues-modal");
    },

    saveResponse: function saveResponse(response) {
      var _this7 = this;

      var orderIds = this.activeEmployee.order_id;
      notify.loading(true);
      this.$http.post("/api/save-employee-call-response", {
        employee_id: this.activeEmployee.id,
        type: response,
        entry_point: "No Show Verification",
        orderIds: orderIds
      }, function (response) {
        modals.hide("#input-modal");
        _this7.getNoShowEmployees();
      }).always(function () {
        notify.loading(false);
      });
    },

    commentModal: function commentModal(status) {
      this.status = _.cloneDeep(status);
      modals.showStrict("#comment-modal");
    },

    saveOrderIssue: function saveOrderIssue() {
      var _this8 = this;

      this.$http.post("/api/create-employee_order-issue", {
        in_hour: this.issues.in_hour,
        in_minute: this.issues.in_minute,
        in_format: this.issues.in_format,
        out_hour: this.issues.out_hour,
        out_minute: this.issues.out_minute,
        out_format: this.issues.out_format,
        "break": this.issues["break"],
        note: this.issues.note,
        employee_order_status_log_id: this.activeEmployee.employee_order_status_log_id
      }, function (response) {
        modals.hide("#issues-modal");
        modals.hide("#input-modal");
        _this8.getNoShowEmployees();
      }).always(function () {});
    },

    /**
     * confirmation before verifying an order
     * @param emp
     */
    verifyUpdate: function verifyUpdate(emp) {
      this.activeEmployee = _.cloneDeep(emp);
      notify.prompt('Are you sure?', '', this.updateApprovalStatus);
    }
  }
};
module.exports = exports["default"];
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n  <div class=\"row re-confirm no-margin\" _v-8cc66946=\"\">\n    <div class=\"col-md-12 col-sm-12 col-xs-12 no-padding-left no-padding-right\" _v-8cc66946=\"\">\n      <div class=\"col-md-12 col-sm-12 col-xs-12 no-padding-left no-padding-right fixed-header bg-white text-center\" _v-8cc66946=\"\">\n        <div class=\"col-md-4\" _v-8cc66946=\"\"></div>\n        <div class=\"col-md-4 text-center\" _v-8cc66946=\"\">\n          <span class=\"text-uppercase text-20 text-color-black text-center text-black font-20\" _v-8cc66946=\"\">NO SHOW APPROVAL</span>\n        </div>\n        <div class=\"col-md-4 text-center p-10\" _v-8cc66946=\"\">\n\n        </div>\n\n        <div class=\"col-md-12 no-padding-left no-padding-right bg-slate-800\" _v-8cc66946=\"\">\n          <div class=\"col-md-1 col-sm-1 col-xs-1 text-black text-center h-25 p-10\" _v-8cc66946=\"\">CHANGE</div>\n          <div class=\"col-md-3 col-sm-3 col-xs-3 text-black text-center h-25 p-10\" _v-8cc66946=\"\">NAME</div>\n          <div class=\"col-md-3 col-sm-3 col-xs-3 text-black text-center h-25 p-10\" _v-8cc66946=\"\">NO SHOW AT</div>\n          <div class=\"col-md-1 col-sm-1 col-xs-1 text-black text-center h-25 p-10\" _v-8cc66946=\"\">NOTE</div>\n          <div class=\"col-md-1 col-sm-1 col-xs-1 text-black text-center h-25 p-10\" _v-8cc66946=\"\">ACTION</div>\n          <div class=\"col-md-1 col-sm-1 col-xs-1 text-black text-center h-25 p-10\" _v-8cc66946=\"\">GAR</div>\n          <div class=\"col-md-1 col-sm-1 col-xs-1 text-black text-center h-25 p-10\" _v-8cc66946=\"\">W-NS-CO</div>\n          <div class=\"col-md-1 col-sm-1 col-xs-1 text-black text-center h-25 p-10\" _v-8cc66946=\"\">ACCEPT</div>\n        </div>\n      </div>\n\n      <!--      <div class=\"col-md-3 div-20\"></div>-->\n\n      <div :class=\"{'col-md-12' : desktop == '1', 'col-md-12 col-sm-12 col-xs-12  pt-5 pl-5 pr-5' : tablet =='1',}\" class=\" bordered-div no-padding-left no-padding-right top-65 list-div\" _v-8cc66946=\"\">\n\n        <div v-for=\"(ind,emp) in employees\" :key=\"ind\" class=\"col-md-12 col-sm-12 col-xs-12 no-padding border-top d-sm-border-bottom border-custom-grey\" _v-8cc66946=\"\">\n          <div class=\"col-md-1 col-sm-1 col-xs-1 border-right border-custom-grey text-center text-color-black table-padding font-13 h-30 text-center\" _v-8cc66946=\"\">\n            <button class=\"btn btn-primary\" @click=\"showInputModal(emp)\" _v-8cc66946=\"\">Change</button>\n          </div>\n\n          <div class=\"col-md-3 col-sm-3 col-xs-3 border-right text-black border-custom-grey text-center text-color-black table-padding font-13 h-30 \" _v-8cc66946=\"\"><span class=\"pt-15\" _v-8cc66946=\"\">{{ emp.name }}</span>\n          </div>\n\n          <div class=\"col-md-3 col-sm-3 col-xs-3 text-center table-padding text-color-black border-right border-custom-grey font-12 h-30\" _v-8cc66946=\"\"><span class=\"pt-15\" _v-8cc66946=\"\">{{ emp.custom_date }}, {{ emp.client_name }}, {{ emp.title }}</span>\n          </div>\n\n          <!--          <div-->\n          <!--              class=\"col-md-2 col-sm-2 col-xs-2 text-center table-padding text-color-black border-right border-custom-grey font-12 h-30\"-->\n          <!--          >-->\n          <!--            <span-->\n          <!--                v-if=\"emp.logs[0].type\">{{ statuses[emp.logs[0].type] }} {{ emp.logs[0].date }} {{ emp.logs[0].user.name ? \"(\" + emp.logs[0].user.name + \")\" : \"\" }}, </span>-->\n          <!--            <span-->\n          <!--                v-if=\"emp.logs[1].type\">{{ statuses[emp.logs[1].type] }} {{ emp.logs[1].date }} {{ emp.logs[1].user.name ? \"(\" + emp.logs[1].user.name + \")\" : \"\" }}, </span>-->\n          <!--            {{ statuses[emp.logs[2].type] }} {{ emp.logs[2].date }} {{ emp.logs[2].user.name ? \"(\" + emp.logs[2].user.name + \")\" : \"\" }}-->\n          <!--          </div>-->\n\n          <div class=\"col-md-1 col-sm-1 col-xs-1 border-right border-custom-grey table-padding h-30 cursor-pointer text-primary text-black text-center\" _v-8cc66946=\"\"><span :data-content=\"formatNote(emp)\" data-html=\"true\" data-placement=\"bottom\" data-popup=\"popover\" data-title=\"\" data-trigger=\"hover\" _v-8cc66946=\"\">Notes</span>\n          </div>\n\n          <div class=\"col-md-1 col-sm-1 col-xs-1 border-right border-custom-grey table-padding h-30 text-center\" _v-8cc66946=\"\">\n            <span v-if=\"emp.action === 'Unacceptable'\" class=\"text-black text-uppercase text-danger\" _v-8cc66946=\"\">Unacceptable</span>\n            <span v-if=\"emp.action === 'Apologetic'\" class=\"text-black text-uppercase text-brown-600\" _v-8cc66946=\"\">Apologetic</span>\n            <span v-if=\"emp.action === 'Forgiven'\" class=\"text-black text-uppercase text-success\" _v-8cc66946=\"\">Forgiven</span>\n          </div>\n          <div class=\"col-md-1 col-sm-1 col-xs-1 border-right border-custom-grey text-center table-padding h-30\" _v-8cc66946=\"\">{{ emp.gar }}\n          </div>\n          <div class=\"col-md-1 col-sm-1 col-xs-1 border-right border-custom-grey text-center table-padding h-30 \" _v-8cc66946=\"\">{{ emp.worked_one_year_count }} - {{ emp.no_show_one_year_count }} - {{ emp.call_out_oneyear_count }}\n          </div>\n          <div class=\"col-md-1 col-sm-1 col-xs-1 border-right border-custom-grey text-center table-padding h-30 text-primary \" _v-8cc66946=\"\">\n            <button class=\"btn btn-primary\" @click=\"verifyUpdate(emp)\" _v-8cc66946=\"\">Accept</button>\n          </div>\n\n        </div>\n        <div class=\"col-md-12 col-sm-12 col-xs-12 border-bottom border-custom-grey mb-40\" _v-8cc66946=\"\"></div>\n\n      </div>\n\n    </div>\n\n\n    <div id=\"input-modal\" aria-hidden=\"true\" aria-labelledby=\"exampleModalLabel\" class=\"modal fade\" role=\"dialog\" tabindex=\"-1\" _v-8cc66946=\"\">\n      <div class=\"modal-dialog\" role=\"document\" _v-8cc66946=\"\">\n        <div class=\"modal-content modal-grey\" _v-8cc66946=\"\">\n          <div class=\"modal-header no-padding bg-slate-700\" _v-8cc66946=\"\">\n            <div class=\"col-md-4 col-sm-4 col-xs-4 p-5 text-black font-16\" _v-8cc66946=\"\">{{ activeEmployee.name }}</div>\n            <div class=\"col-md-4 col-sm-4 col-xs-4 p-5 text-black font-16\" _v-8cc66946=\"\"></div>\n            <div class=\"col-md-4 col-sm-4 col-xs-4 p-5 text-black font-16\" _v-8cc66946=\"\"></div>\n            <button aria-label=\"Close\" class=\"close close-modal\" data-dismiss=\"modal\" type=\"button\" _v-8cc66946=\"\">\n              <span aria-hidden=\"true\" _v-8cc66946=\"\">×</span>\n            </button>\n          </div>\n          <div class=\"modal-body no-padding-left no-padding-right\" _v-8cc66946=\"\">\n            <div class=\"col-md-12 col-sm-12 col-xs-12 text-black font-16 text-center no-padding-left pt-20 pb-20\" _v-8cc66946=\"\">\n              {{ activeEmployee.custom_date }}, {{ activeEmployee.client_name }}, {{ activeEmployee.title }}\n            </div>\n            <div class=\"col-md-12 col-sm-12 col-xs-12 text-center pt-20 pb-20\" _v-8cc66946=\"\">\n              <span v-if=\"activeEmployee.logs[0].type\" _v-8cc66946=\"\">{{ statuses[activeEmployee.logs[0].type] }} {{ activeEmployee.logs[0].date }} {{ activeEmployee.logs[0].user.name ? \"(\" + activeEmployee.logs[0].user.name + \")\" : \"\" }}, </span>\n              <span v-if=\"activeEmployee.logs[1].type\" _v-8cc66946=\"\">{{ statuses[activeEmployee.logs[1].type] }} {{ activeEmployee.logs[1].date }} {{ activeEmployee.logs[1].user.name ? \"(\" + activeEmployee.logs[1].user.name + \")\" : \"\" }}, </span>\n              {{ statuses[activeEmployee.logs[2].type] }} {{ activeEmployee.logs[2].date }} {{ activeEmployee.logs[2].user.name ? \"(\" + activeEmployee.logs[2].user.name + \")\" : \"\" }}\n            </div>\n            <div class=\"col-md-12 col-sm-12 col-xs-12  font-16 text-left no-padding-right pt-20 pb-20 pl-20\" _v-8cc66946=\"\">\n              <span class=\"text-black\" _v-8cc66946=\"\"> Note: </span>{{ activeEmployee.note }}\n            </div>\n\n            <div class=\"col-md-12 col-sm-12 col-xs-12 p-10 border-top border-2 border-white\" _v-8cc66946=\"\"></div>\n\n            <div class=\"col-md-6 col-sm-6 col-xs-6 font-16 text-center no-padding-left pt-20 pb-20\" _v-8cc66946=\"\">\n              Selected:\n            </div>\n            <div class=\"col-md-6 col-sm-6 col-xs-6 text-black font-16 text-left pt-20 pb-20\" _v-8cc66946=\"\">\n              <span v-if=\"activeEmployee.action === 'Unacceptable'\" class=\"text-bold text-uppercase text-danger\" _v-8cc66946=\"\">Unacceptable</span>\n              <span v-if=\"activeEmployee.action === 'Apologetic'\" class=\"text-uppercase text-brown-600\" _v-8cc66946=\"\">Apologetic</span>\n              <span v-if=\"activeEmployee.action === 'Forgiven'\" class=\"text-uppercase text-success\" _v-8cc66946=\"\">Forgiven</span>\n            </div>\n\n            <div class=\"col-md-6 col-sm-6 col-xs-6 text-black font-16 text-center no-padding-right pt-20 pb-20\" _v-8cc66946=\"\">\n              Change to:\n            </div>\n            <div class=\"col-md-6 col-sm-6 col-xs-6 text-black font-16 text-center no-padding-right pt-20 pb-20\" _v-8cc66946=\"\">\n\n            </div>\n\n            <div class=\"col-md-12 col-sm-12 col-xs-12\" _v-8cc66946=\"\">\n\n              <div v-if=\"activeEmployee.action === 'Unacceptable'\" class=\"col-md-12 col-sm-12 col-xs-12\" _v-8cc66946=\"\">\n                <div class=\"col-md-6 col-sm-6 col-xs-6 text-black font-16 text-center no-padding-right pt-20 pb-20\" _v-8cc66946=\"\">\n                  <button class=\"btn btn-brown text-black border-2 w-120\" @click=\"setAction('Apologetic')\" _v-8cc66946=\"\"> APOLOGETIC\n                  </button>\n                </div>\n\n                <div class=\"col-md-6 col-sm-6 col-xs-6 text-black font-16 text-right no-padding-right pt-20 pb-20\" _v-8cc66946=\"\">\n                  <button class=\"btn btn-success text-black border-white border-2 w-120\" @click=\"setAction('Forgiven')\" _v-8cc66946=\"\"> FORGIVEN\n                  </button>\n                </div>\n              </div>\n\n              <div v-if=\"activeEmployee.action === 'Apologetic'\" class=\"col-md-12 col-sm-12 col-xs-12\" _v-8cc66946=\"\">\n                <div class=\"col-md-6 col-sm-6 col-xs-6 text-black font-16 text-center no-padding-right pt-20 pb-20\" _v-8cc66946=\"\">\n                  <button class=\"btn btn-danger text-black border-white border-2 w-120\" @click=\"setAction('Unacceptable')\" _v-8cc66946=\"\"> BAD EXCUSE\n                  </button>\n                </div>\n\n                <div class=\"col-md-6 col-sm-6 col-xs-6 text-black font-16 text-right no-padding-right pt-20 pb-20\" _v-8cc66946=\"\">\n                  <button class=\"btn btn-success text-black border-white border-2 w-120\" @click=\"setAction('Forgiven')\" _v-8cc66946=\"\"> FORGIVEN\n                  </button>\n                </div>\n              </div>\n\n              <div v-if=\"activeEmployee.action === 'Forgiven'\" class=\"col-md-12 col-sm-12 col-xs-12\" _v-8cc66946=\"\">\n                <div class=\"col-md-6 col-sm-6 col-xs-6 text-black font-16 text-center no-padding-right pt-20 pb-20\" _v-8cc66946=\"\">\n                  <button class=\"btn btn-danger text-black border-white border-2 w-120\" @click=\"setAction('Unacceptable')\" _v-8cc66946=\"\"> BAD EXCUSE\n                  </button>\n                </div>\n\n                <div class=\"col-md-6 col-sm-6 col-xs-6 text-black font-16 text-right no-padding-right pt-20 pb-20\" _v-8cc66946=\"\">\n                  <button class=\"btn btn-brown text-black border-2 w-120\" @click=\"setAction('Apologetic')\" _v-8cc66946=\"\"> APOLOGETIC\n                  </button>\n                </div>\n              </div>\n\n              <div class=\"col-md-12 col-sm-12 col-xs-12\" _v-8cc66946=\"\">\n                <div class=\"col-md-6 col-sm-6 col-xs-6 text-black font-16 text-center no-padding-right pt-20 pb-20\" _v-8cc66946=\"\">\n\n                </div>\n\n                <div class=\"col-md-6 col-sm-6 col-xs-6 text-black font-16 text-right no-padding-right pt-20 pb-20\" _v-8cc66946=\"\">\n                  <button class=\"btn btn-primary text-black border-white border-2 w-120\" @click=\"updateAction()\" _v-8cc66946=\"\"> SAVE\n                  </button>\n                </div>\n              </div>\n\n            </div>\n\n            <div class=\"col-md-12 col-sm-12 col-xs-12 p-10\" _v-8cc66946=\"\"></div>\n\n          </div>\n          <div class=\"modal-footer\" _v-8cc66946=\"\">\n            <!--            <button class=\"btn btn-secondary\" data-dismiss=\"modal\" type=\"button\">Close</button>-->\n            <!--            <button class=\"btn btn-primary\" type=\"button\">Save changes</button>-->\n          </div>\n        </div>\n      </div>\n    </div>\n\n\n  </div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  var id = "/home/shoieb/sites/elegant/resources/assets/js/vue/components/no-show-verification-approval.vue"
  module.hot.dispose(function () {
    require("vueify-insert-css").cache["\n.re-confirm > div.col-md-12[_v-8cc66946],\n.re-confirm > div.col-md-6[_v-8cc66946],\n.re-confirm > div.col-md-12[_v-8cc66946] {\n  padding: 0 !important;\n}\n\n.bordered-div[_v-8cc66946] {\n  border-left: 1px solid #ddd;\n  border-right: 1px solid #ddd;\n}\n\n.bordered-left[_v-8cc66946] {\n  border-left: 1px solid #ddd;\n}\n\n.bordered-right[_v-8cc66946] {\n  border-right: 1px solid #ddd;\n}\n\n.bordered-bottom[_v-8cc66946] {\n  border-bottom: 1px solid #ddd;\n}\n\n.fixed-header[_v-8cc66946] {\n  position: fixed;\n  top: 48px;\n  right: 0px;\n  z-index: 1000 !important;\n}\n\n.middle-div[_v-8cc66946] {\n  width: 60% !important;\n  right: 20% !important;\n}\n\n.div-20[_v-8cc66946] {\n  width: 20% !important;\n}\n\n.div-60[_v-8cc66946] {\n  width: 60% !important;\n}\n\n.top-65[_v-8cc66946] {\n  top: 65px;\n}\n\n\n.pt-65[_v-8cc66946] {\n  padding-top: 65px;\n}\n\n\n.list-div[_v-8cc66946] {\n  margin-bottom: 40px;\n  min-height: 900px !important;\n}\n\n.bottom-div[_v-8cc66946] {\n  position: fixed;\n  bottom: 0px;\n  right: 0px;\n  z-index: 1000 !important;\n  height: 40px !important;\n  width: 100%;\n}\n\n.mb-40[_v-8cc66946] {\n  margin-bottom: 40px !important;\n}\n\n.p-40[_v-8cc66946] {\n  padding-top: 40px;\n  padding-bottom: 40px;\n}\n\n.m-30[_v-8cc66946] {\n  margin-left: 30px;\n  margin-right: 30px;\n}\n\n.h-30[_v-8cc66946] {\n  min-height: 50px !important;\n}\n\n.h-25[_v-8cc66946] {\n  min-height: 25px !important;\n}\n\n\n.border-custom-grey[_v-8cc66946] {\n  border-color: #ddd !important;\n}\n\n.w-120[_v-8cc66946] {\n  min-width: 120px !important;\n}\n\n.w-100[_v-8cc66946] {\n  min-width: 100px !important;\n}\n\n.col-md-15[_v-8cc66946] {\n  width: 10.99999995%;\n  float: left;\n}\n\n.text-grey-custom[_v-8cc66946] {\n  color: #696666 !important;\n}\n\n.btn-brown[_v-8cc66946] {\n  color: #fff;\n  background-color: #6f4c42;\n  border: 2px solid #ffffff;\n}\n\n.btn-brown[_v-8cc66946]:active, .btn-brown.active[_v-8cc66946]:hover, .btn-brown[_v-8cc66946]:focus, .btn-brown[_v-8cc66946]:target, .btn-brown.active[_v-8cc66946]:focus, .btn-brown:active.focus[_v-8cc66946], .btn-brown.active.focus[_v-8cc66946] {\n  border: 2px solid #6f4c42 !important;\n}\n\n@media (max-width: 1024px) {\n  .h-30[_v-8cc66946] {\n    min-height: 55px !important;\n  }\n}\n\n\n.close-modal[_v-8cc66946] {\n  font-size: 30px;\n  margin-top: -14.75px;\n  font-weight: 500;\n}\n\n.font-20[_v-8cc66946] {\n  font-size: 20px;\n}\n\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, module.exports.template)
  }
})()}
},{"./../../mixed/modals":10,"./../../mixed/notify":11,"vue":5,"vue-hot-reload-api":4,"vueify-insert-css":6}],61:[function(require,module,exports){
var __vueify_style__ = require("vueify-insert-css").insert("\n.re-confirm > div.col-md-12[_v-4ee2a991],\n.re-confirm > div.col-md-6[_v-4ee2a991],\n.re-confirm > div.col-md-12[_v-4ee2a991] {\n  padding: 0 !important;\n}\n\n.bordered-div[_v-4ee2a991] {\n  border-left: 1px solid #ddd;\n  border-right: 1px solid #ddd;\n}\n\n.bordered-left[_v-4ee2a991] {\n  border-left: 1px solid #ddd;\n}\n\n.bordered-right[_v-4ee2a991] {\n  border-right: 1px solid #ddd;\n}\n\n.bordered-bottom[_v-4ee2a991] {\n  border-bottom: 1px solid #ddd;\n}\n\n.fixed-header[_v-4ee2a991] {\n  position: fixed;\n  top: 48px;\n  right: 0px;\n  z-index: 1000 !important;\n}\n\n.middle-div[_v-4ee2a991] {\n  width: 60% !important;\n  right: 20% !important;\n}\n\n.div-20[_v-4ee2a991] {\n  width: 20% !important;\n}\n\n.div-60[_v-4ee2a991] {\n  width: 60% !important;\n}\n\n.top-65[_v-4ee2a991] {\n  top: 65px;\n}\n\n\n.pt-65[_v-4ee2a991] {\n  padding-top: 65px;\n}\n\n\n.list-div[_v-4ee2a991] {\n  margin-bottom: 40px;\n  min-height: 900px !important;\n}\n\n.bottom-div[_v-4ee2a991] {\n  position: fixed;\n  bottom: 0px;\n  right: 0px;\n  z-index: 1000 !important;\n  height: 40px !important;\n  width: 100%;\n}\n\n.mb-40[_v-4ee2a991] {\n  margin-bottom: 40px !important;\n}\n\n.p-40[_v-4ee2a991] {\n  padding-top: 40px;\n  padding-bottom: 40px;\n}\n\n.m-30[_v-4ee2a991] {\n  margin-left: 30px;\n  margin-right: 30px;\n}\n\n.h-30[_v-4ee2a991] {\n  min-height: 35px !important;\n}\n\n\n.border-custom-grey[_v-4ee2a991] {\n  border-color: #ddd !important;\n}\n\n.bg-shift[_v-4ee2a991] {\n  background-color: #d5dce3;\n}\n\n.bg-shift-darker[_v-4ee2a991] {\n  background-color: #aeb7bf;\n}\n\n.w-120[_v-4ee2a991] {\n  min-width: 120px !important;\n}\n\n.w-100[_v-4ee2a991] {\n  min-width: 100px !important;\n}\n\n.col-md-15[_v-4ee2a991] {\n  width: 10.99999995%;\n  float: left;\n}\n\n.text-grey-custom[_v-4ee2a991] {\n  color: #696666 !important;\n}\n\n@media (max-width: 1024px) {\n  .h-30[_v-4ee2a991] {\n    min-height: 55px !important;\n  }\n}\n\n.close-modal[_v-4ee2a991] {\n  font-size: 30px;\n  margin-top: -14.75px;\n  font-weight: 500;\n}\n\n.font-20[_v-4ee2a991] {\n  font-size: 20px;\n}\n\n\n")
"use strict";

exports.__esModule = true;
var modals = require("./../../mixed/modals");
var notify = require("./../../mixed/notify");

exports["default"] = {
  data: function data() {
    return {
      issues: {
        in_hour: '',
        in_minute: '',
        in_format: '',
        out_hour: '',
        out_minute: '',
        out_format: '',
        "break": '',
        note: ''
      },
      shiftClaim: {
        client_id: '',
        date: '',
        employee_id: '',
        position_code: '',
        in_hour: '',
        in_minute: '',
        in_format: '',
        out_hour: '',
        out_minute: '',
        out_format: '',
        "break": '',
        note: ''
      },
      allClients: {},
      allEmployees: {},
      selectedClient: {},
      hours: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
      minutes: ['00', '05', '10', '15', '20', '25', '30', '35', '40', '45', '50', '55', '60'],
      breaks: ['00', '05', '10', '15', '20', '25', '30', '35', '40', '45', '50', '55', '60', '65', '70', '75', '80', '85', '90'],
      dates: [],
      tab: 'due',
      startDate: '',
      endDate: '',
      state: false,
      employees: {},
      allNoShowEmployees: {},
      groupedNoShowEmployees: {},
      allShifts: {},
      singleEmployeeList: {},
      clients: {},
      order: {
        client_id: "",
        position_code: ""
      },
      week: '',
      date: '',
      activeEmployee: {},
      originalEmployeeData: {},
      status: 0,
      note: '',
      allNotes: '',
      statuses: {
        "Left VM": "LV",
        "Left Voice Mail": "LV",
        "Left Voicemail": "LV",
        "Mailbox Full": "MF",
        "Out of Service": "OS",
        "Answered": "ANSWERED",
        "Called": "Called",
        "Disc": "LD",
        "Hang Up": "HU",
        "Wrong No": "WN",
        "VM Full": "VF",
        "No VM": "NV",
        "delete": "DELETE",
        "Call": "Call",
        "Return": "Return",
        "Returned": "Returned",
        "Return-Apologetic": "RA",
        "Return-Bad Excuses": "RB",
        "Return-Don't Care": "RC",
        "Apologetic": "A",
        "Bad Excuses": "B",
        "Don't Care": "C",
        "": ""
      }
    };
  },

  props: ['tablet', 'desktop'],

  computed: {

    updatedEmployees: function updatedEmployees() {
      return _.filter(this.employees, function (o) {
        return o.worked || o.no_show;
      });
    },

    updatedCollectedEmployees: function updatedCollectedEmployees() {
      return _.filter(this.collectedEmployees, function (o) {
        return o.checked;
      });
    },

    collectedEmployeeGroups: function collectedEmployeeGroups() {
      return _.groupBy(this.collectedEmployees, "department_id");
    }
  },
  filters: {},
  watch: {
    "date": function date(val) {
      this.getNoShowEmployees(val);
    },

    clients: function clients() {
      $("#position-client").selectric("refresh");
    },

    activeClient: function activeClient() {
      //   $("#position-code").selectric("refresh");
    },

    "order.position_code": function orderPosition_code(val) {
      this.getNoShowEmployees(val);
    },
    'selectedClient': function selectedClient() {
      $('#position-code').selectric('refresh');
    },

    'shiftClaim.client_id': function shiftClaimClient_id(val) {
      this.selectedClient = _.clone(_.find(this.allClients, function (o) {
        return o.id == val;
      }));
    }
  },
  ready: function ready() {
    //$(".table").fixedHeader();
    this.getNoShowEmployees();
    this.getEmployees();
    this.getClientList();
  },
  events: {},
  methods: {
    employeeGroups: function employeeGroups() {
      this.groupedNoShowEmployees = _.groupBy(this.allNoShowEmployees, "date");
    },
    /**
     * update list based on user entry
     */
    saveShiftClaim: function saveShiftClaim() {
      this.$http.post("/api/save-missing-shift-claim", this.shiftClaim, function (response) {
        notify.info('Missing shift added successfully.');
        modals.hide("#missing-shift-claim-modal");
      }).always(function () {
        //notify.loading(false);
      });
    },

    showShiftClaimModal: function showShiftClaimModal() {
      this.shiftClaim = {
        client_id: '',
        date: '',
        employee_id: '',
        position_code: '',
        in_hour: '',
        in_minute: '',
        in_format: '',
        out_hour: '',
        out_minute: '',
        out_format: '',
        "break": '',
        note: ''
      };
      modals.showStrict("#missing-shift-claim-modal");
    },

    /**
     * get list of clients
     */
    getEmployees: function getEmployees() {
      var _this = this;

      this.$http.get('/api/employee-list-data', '', function (response) {
        _this.allEmployees = response;
      }).always(function () {});
    },

    getClientList: function getClientList() {
      var _this2 = this;

      this.$http.get("/api/order-data", "", function (response) {
        _this2.allClients = response;
      }).always(function () {});
    },

    groupByDate: function groupByDate(data) {
      return _.groupBy(data, "client_id");
    },

    /**
     * get employee list
     */
    getNoShowEmployees: function getNoShowEmployees(clientId) {
      var _this3 = this;

      notify.loading(true);
      this.$http.get("/api/no-show-verification-log", function (response) {
        _this3.employees = response;
        _this3.allNoShowEmployees = response;
        _this3.employeeGroups();
      }).always(function () {
        notify.loading(false);
      });
    },

    /**
     * get employee list
     */
    getNoShowSingleEmployee: function getNoShowSingleEmployee(id) {
      var _this4 = this;

      notify.loading(true);
      this.$http.get("/api/no-show-verification-log-single/" + id, function (response) {
        _this4.singleEmployeeList = response;
        modals.showStrict("#single-list-modal");
      }).always(function () {
        notify.loading(false);
      });
    },

    showInputModal: function showInputModal(employee) {
      var _this5 = this;

      notify.loading(true);
      this.$http.get("/api/no-show-verification-log-single-data/" + employee.employee_order_status_log_id, function (response) {
        _this5.activeEmployee = response;
        _this5.allShifts = _.filter(_this5.employees, { 'id': response.id });
        var notes = '';
        _.forEach(_this5.activeEmployee.logs, function (log) {
          notes += '<li>' + log.type + ' ' + log.date + ' ' + log.user.name + ' - ' + log.note + ' </li>';
        });
        _this5.allNotes = notes;
        _this5.$nextTick(function () {
          $('[data-popup="popover"]').popover();
        });
        modals.showStrict("#input-modal");
      }).always(function () {
        notify.loading(false);
      });
    },

    showIssuesModal: function showIssuesModal() {
      this.issues = {
        in_hour: '',
        in_minute: '',
        in_format: '',
        out_hour: '',
        out_minute: '',
        out_format: '',
        "break": '',
        note: ''
      };
      modals.showStrict("#issues-modal");
    },

    saveResponse: function saveResponse(response) {
      var _this6 = this;

      var orderIds = this.activeEmployee.order_id;
      notify.loading(true);
      this.$http.post("/api/save-employee-call-response", {
        employee_id: this.activeEmployee.id,
        type: response,
        entry_point: "No Show Verification",
        orderIds: orderIds,
        note: this.note
      }, function (response) {
        //modals.hide("#input-modal");
        modals.hide("#comment-modal");
        _this6.note = '';
        //this.getNoShowEmployees();
        var index = _.findIndex(_this6.employees, { 'id': response.id, 'order_id': response.order_id });
        _this6.employees[index] = response;
        _this6.allNoShowEmployees = _this6.employees;
        _this6.employeeGroups();
        _this6.showInputModal(response);
      }).always(function () {
        notify.loading(false);
      });
    },

    commentModal: function commentModal(status) {
      this.status = _.cloneDeep(status);
      this.note = '';
      modals.showStrict("#comment-modal");
    },

    saveOrderIssue: function saveOrderIssue() {
      var _this7 = this;

      this.$http.post("/api/create-employee_order-issue", {
        in_hour: this.issues.in_hour,
        in_minute: this.issues.in_minute,
        in_format: this.issues.in_format,
        out_hour: this.issues.out_hour,
        out_minute: this.issues.out_minute,
        out_format: this.issues.out_format,
        "break": this.issues["break"],
        note: this.issues.note,
        employee_order_status_log_id: this.activeEmployee.employee_order_status_log_id
      }, function (response) {
        modals.hide("#issues-modal");
        modals.hide("#input-modal");
        _this7.getNoShowEmployees();
      }).always(function () {});
    },

    updateStatus: function updateStatus() {
      var _this8 = this;

      if (this.note.length) {
        notify.loading(true);
        if (this.status === 'Called' || this.status === 'Returned') {
          this.saveResponse(this.status);
        } else {
          this.$http.post("/api/update-no-show-entry/" + this.activeEmployee.employee_order_status_log_id, {
            note: this.note,
            status: this.status
          }, function (response) {
            modals.hide("#input-modal");
            modals.hide("#comment-modal");
            _this8.note = '';
            _this8.getNoShowEmployees();
            _this8.employeeGroups();
            //this.getNoShowEmployees();
          }).always(function () {
            notify.loading(false);
          });
        }
      } else {
        notify.info('Please provide comment.');
      }
    },

    /**
     * update list based on user entry
     */
    updateList: function updateList() {
      var _this9 = this;

      notify.loading(true);
      if (this.tab === 'due') {
        var selectedEmployees = _.groupBy(this.updatedEmployees, "order_created_at");

        this.$http.post("/api/re-confirmed-employees", selectedEmployees, function (response) {
          notify.loading(false);
          _this9.getNoShowEmployees(_this9.order.client_id);
        }).always(function () {
          //notify.loading(false);
        });
      } else {
          var selectedEmployees = _.groupBy(this.updatedCollectedEmployees, "order_created_at");

          this.$http.post("/api/re-confirmed-employees-undo", selectedEmployees, function (response) {
            notify.loading(false);
            _this9.getNoShowEmployees(_this9.order.client_id);
          }).always(function () {
            //notify.loading(false);
          });
        }
    }
  }
};
module.exports = exports["default"];
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n  <div class=\"row re-confirm no-margin\" _v-4ee2a991=\"\">\n    <div class=\"col-md-12 col-sm-12 col-xs-12 no-padding-left no-padding-right\" _v-4ee2a991=\"\">\n      <div class=\"col-md-12 col-sm-12 col-xs-12 no-padding-left no-padding-right fixed-header bg-white text-center\" _v-4ee2a991=\"\">\n        <div class=\"col-md-4\" _v-4ee2a991=\"\"></div>\n        <div class=\"col-md-4 text-center\" _v-4ee2a991=\"\">\n          <span class=\"text-uppercase text-20 text-color-black text-center text-black font-20\" _v-4ee2a991=\"\">NO SHOW</span>\n        </div>\n        <div class=\"col-md-4 text-center p-10\" _v-4ee2a991=\"\">\n          <span class=\"text-uppercase text-20 text-color-black text-center text-black font-20 pull-right cursor-pointer \" @click=\"showShiftClaimModal\" _v-4ee2a991=\"\">CLAIM</span>\n        </div>\n      </div>\n\n      <!--      <div class=\"col-md-3 div-20\"></div>-->\n      <div v-if=\"desktop =='1'\" class=\"col-md-1\" _v-4ee2a991=\"\"></div>\n\n      <div :class=\"{'col-md-10' : desktop == '1', 'col-md-12 col-sm-12 col-xs-12  pt-5 pl-5 pr-5' : tablet =='1',}\" class=\" bordered-div no-padding-left no-padding-right top-65 list-div\" _v-4ee2a991=\"\">\n        <div class=\"col-md-12 col-sm-12 col-xs-12  border-bottom border-custom-grey p-0\" _v-4ee2a991=\"\"></div>\n        <div v-for=\"(index,groupedEmployees) in groupedNoShowEmployees\" :key=\"index\" class=\"col-md-12 col-sm-12 col-xs-12 bordered-div no-padding-left no-padding-right\" _v-4ee2a991=\"\">\n          <div class=\"col-md-12 col-sm-12 col-xs-12 no-padding-left no-padding-right\" _v-4ee2a991=\"\">\n                    <span class=\"pl-10\" _v-4ee2a991=\"\">\n               <span class=\"text-black text-danger font-13 pr-5\" _v-4ee2a991=\"\">{{\n                   groupedEmployees[0].day\n                 }} {{ groupedEmployees[0].custom_date }}</span> <br _v-4ee2a991=\"\">\n            </span>\n          </div>\n          <div v-for=\"(index,employee) in groupByDate(groupedEmployees)\" :key=\"index\" class=\"col-md-12 col-sm-12 col-xs-12 no-padding-left no-padding-right bg-white\" _v-4ee2a991=\"\">\n            <div class=\"col-md-12 col-sm-12 col-xs-12 text-left text-color-black  no-padding-left no-padding-right mt-5 mb-10\" _v-4ee2a991=\"\">\n              <!--            <span class=\"pl-10\">-->\n              <!--               <span-->\n              <!--                   class=\"text-black text-danger font-11 pr-5\">{{ employee[0].day }} {{ employee[0].custom_date }}</span> <br>-->\n              <!--            </span>-->\n            </div>\n            <div v-for=\"(ind,emp) in employee\" :key=\"ind\" class=\"col-md-12 col-sm-12 col-xs-12 no-padding border-top d-sm-border-bottom border-custom-grey\" _v-4ee2a991=\"\">\n              <div class=\"col-md-3 col-sm-3 col-xs-3 border-right border-custom-grey text-center text-color-black table-padding font-13 h-30\" _v-4ee2a991=\"\"><span class=\"\" _v-4ee2a991=\"\">{{ emp.client_name }}</span>\n              </div>\n\n              <div class=\"col-md-2 col-sm-1 col-xs-1 text-center table-padding text-italic text-color-black border-right border-custom-grey font-12 h-30\" _v-4ee2a991=\"\">{{ emp.title }}\n              </div>\n\n              <div class=\"col-md-2 col-sm-2 col-xs-2 border-right border-custom-grey text-left table-padding font-14 h-30 cursor-pointer text-primary text-black\" @click=\"showInputModal(emp)\" _v-4ee2a991=\"\">{{ emp.name }}\n              </div>\n\n              <div class=\"col-md-1-6 col-sm-2 col-xs-2  border-right border-custom-grey text-left table-padding font-12 h-30\" _v-4ee2a991=\"\">\n                <span class=\"text-grey-custom\" _v-4ee2a991=\"\">\n                  {{ statuses[emp.logs[0].type] }} {{\n                    emp.logs[0].date\n                  }} {{ emp.logs[0].user.name ? \"(\" + emp.logs[0].user.name + \")\" : \"\" }}\n                </span>\n              </div>\n              <div class=\"col-md-1-6 col-sm-2 col-xs-2   border-right border-custom-grey text-left table-padding font-12 h-30\" _v-4ee2a991=\"\"><span class=\"text-grey-custom\" _v-4ee2a991=\"\">\n                {{ statuses[emp.logs[1].type] }} {{\n                  emp.logs[1].date\n                }} {{ emp.logs[1].user.name ? \"(\" + emp.logs[1].user.name + \")\" : \"\" }}\n              </span>\n              </div>\n              <div class=\"col-md-1-6 col-sm-2 col-xs-2   text-left table-padding font-12 h-30\" _v-4ee2a991=\"\"><span class=\"text-grey-custom\" _v-4ee2a991=\"\">\n                {{ statuses[emp.logs[2].type] }} {{\n                  emp.logs[2].date\n                }} {{ emp.logs[2].user.name ? \"(\" + emp.logs[2].user.name + \")\" : \"\" }}\n              </span>\n              </div>\n            </div>\n            <div class=\"col-md-12 col-sm-12 col-xs-12 border-bottom border-custom-grey mb-40\" _v-4ee2a991=\"\"></div>\n          </div>\n        </div>\n      </div>\n\n    </div>\n\n\n    <div id=\"input-modal\" aria-hidden=\"true\" aria-labelledby=\"exampleModalLabel\" class=\"modal fade\" role=\"dialog\" tabindex=\"-1\" _v-4ee2a991=\"\">\n      <div class=\"modal-dialog\" role=\"document\" _v-4ee2a991=\"\">\n        <div class=\"modal-content modal-grey\" _v-4ee2a991=\"\">\n          <div class=\"modal-header no-padding bg-slate-700\" _v-4ee2a991=\"\">\n            <div class=\"col-md-4 col-sm-4 col-xs-4 p-5 text-black font-16\" _v-4ee2a991=\"\">{{ activeEmployee.name }}</div>\n            <div class=\"col-md-4 col-sm-4 col-xs-4 p-5 text-black font-16\" _v-4ee2a991=\"\">{{ activeEmployee.primary_phone }}</div>\n            <div class=\"col-md-4 col-sm-4 col-xs-4 p-5 text-black font-16\" _v-4ee2a991=\"\">{{ activeEmployee.secondary_phone }}</div>\n            <button aria-label=\"Close\" class=\"close close-modal\" data-dismiss=\"modal\" type=\"button\" _v-4ee2a991=\"\">\n              <span aria-hidden=\"true\" _v-4ee2a991=\"\">×</span>\n            </button>\n          </div>\n          <div class=\"modal-body no-padding-left no-padding-right\" _v-4ee2a991=\"\">\n\n            <div class=\"col-md-12 pb-10 ml-10 font-14 text-center text-color-black\" _v-4ee2a991=\"\">\n\n              <span class=\"p-10\" _v-4ee2a991=\"\">{{ activeEmployee.day }} {{ activeEmployee.custom_date }} - </span>\n\n              <span class=\"p-10\" _v-4ee2a991=\"\">{{ activeEmployee.client_name }} - </span>\n\n              <span class=\"p-10\" _v-4ee2a991=\"\">{{ activeEmployee.title }} </span>\n\n            </div>\n\n            <div class=\"col-md-12 col-sm-12 col-xs-12 p-20\" _v-4ee2a991=\"\"></div>\n\n            <div class=\"col-md-6 col-sm-6 col-xs-6 text-black font-16 text-center no-padding-left pt-20 pb-20\" _v-4ee2a991=\"\">\n              <button class=\"btn btn-primary text-black p-5 no-padding-left border-white w-120 text-center\" @click=\"commentModal('Called')\" _v-4ee2a991=\"\">Called\n              </button>\n            </div>\n\n            <div class=\"col-md-6 col-sm-6 col-xs-6 text-black font-16 text-center no-padding-right pt-20 pb-20\" _v-4ee2a991=\"\">\n              <button class=\"btn btn-primary text-black p-5 no-padding-right border-white  w-120 text-center\" @click=\"commentModal('Returned')\" _v-4ee2a991=\"\">\n                Returned\n              </button>\n            </div>\n\n            <div class=\"col-md-12 col-sm-12 col-xs-12 p-20 text-center\" _v-4ee2a991=\"\">\n              <span :data-content=\"allNotes\" data-html=\"true\" data-placement=\"bottom\" data-popup=\"popover\" data-title=\"\" data-trigger=\"hover\" _v-4ee2a991=\"\"><i class=\"fa fa-clipboard font-20\" _v-4ee2a991=\"\"></i></span>\n            </div>\n\n            <div class=\"col-md-4 col-sm-4 col-xs-4 text-black font-16 text-center no-padding-left pt-20 pb-20\" _v-4ee2a991=\"\">\n              <button class=\"btn btn-danger text-black p-5 no-padding-left border-white w-120 text-center\" @click=\"commentModal(0)\" _v-4ee2a991=\"\">Unacceptable\n              </button>\n            </div>\n            <div class=\"col-md-4 col-sm-4 col-xs-4 text-black font-16 text-center pt-20 pb-20\" _v-4ee2a991=\"\">\n              <button class=\"btn btn-warning text-black p-5  border-white w-120 text-center\" @click=\"commentModal(1)\" _v-4ee2a991=\"\">Apologetic\n              </button>\n            </div>\n            <div class=\"col-md-4 col-sm-4 col-xs-4 text-black font-16 text-center no-padding-right pt-20 pb-20\" _v-4ee2a991=\"\">\n              <button class=\"btn btn-success text-black p-5 no-padding-right border-white w-120 text-center\" @click=\"commentModal(2)\" _v-4ee2a991=\"\">Forgiven\n              </button>\n            </div>\n\n            <div class=\"col-md-12 col-sm-12 col-xs-12 p-10\" _v-4ee2a991=\"\"></div>\n\n            <div class=\"col-md-4 col-sm-4 col-xs-4 font-11 text-right text-italic text-grey-400 no-padding-left pt-20 pb-20\" _v-4ee2a991=\"\">\n              <span _v-4ee2a991=\"\">Worked</span><br _v-4ee2a991=\"\">\n              <span class=\"mr-10 pr-10\" _v-4ee2a991=\"\">{{ activeEmployee.worked_one_year_count }}</span>\n            </div>\n            <div class=\"col-md-4 col-sm-4 col-xs-4 font-11 text-center text-italic text-grey-400 no-padding-left pt-20 pb-20\" _v-4ee2a991=\"\">\n              <span _v-4ee2a991=\"\">No Show</span><br _v-4ee2a991=\"\">\n              <span class=\"cursor-pointer\" @click=\"getNoShowSingleEmployee(activeEmployee.id)\" _v-4ee2a991=\"\">{{\n                  activeEmployee.no_show_one_year_count\n                }}</span>\n            </div>\n            <div class=\"col-md-4 col-sm-4 col-xs-4 font-11 text-grey-400 no-padding-left pt-20 pb-20\" _v-4ee2a991=\"\">\n              <div class=\"col-md-6 col-sm-6 text-left no-padding\" _v-4ee2a991=\"\">\n                <span _v-4ee2a991=\"\">Call Out</span><br _v-4ee2a991=\"\">\n                <span class=\"ml-10 pl-10\" _v-4ee2a991=\"\">{{ activeEmployee.call_out_oneyear_count }}</span>\n              </div>\n              <div class=\"col-md-6 col-sm-6 text-right no-padding\" _v-4ee2a991=\"\">\n                <button class=\"btn bg-grey-300 text-black pt-5 pb-5 pl-10 pr-10 mt-10\" @click=\"showIssuesModal()\" _v-4ee2a991=\"\">W\n                </button>\n              </div>\n            </div>\n\n            <div v-if=\"allShifts.length > 1\" class=\"col-md-12 col-sm-12 col-xs-12 font-11 bg-shift no-padding-left border-top border-2 border-white \" _v-4ee2a991=\"\">\n              <div v-for=\"shift in allShifts\" :class=\"activeEmployee.order_id === shift.order_id ? 'bg-shift-darker':''\" class=\"p-10 text-center col-md-2 col-sm-2 col-xs-2 text-color-black font-12 border-right border-2 border-white cursor-pointer\" @click=\"showInputModal(shift)\" _v-4ee2a991=\"\">\n                <span class=\"\" _v-4ee2a991=\"\">{{ shift.day + ' ' + shift.custom_date }}</span><br _v-4ee2a991=\"\">\n                <span class=\"\" _v-4ee2a991=\"\">{{ shift.company_code }}</span><br _v-4ee2a991=\"\">\n                <span class=\"\" _v-4ee2a991=\"\">{{ shift.title }}</span>\n              </div>\n            </div>\n\n          </div>\n          <div class=\"modal-footer no-padding-bottom\" _v-4ee2a991=\"\">\n            <!--            <button class=\"btn btn-secondary\" data-dismiss=\"modal\" type=\"button\">Close</button>-->\n            <!--            <button class=\"btn btn-primary\" type=\"button\">Save changes</button>-->\n          </div>\n        </div>\n      </div>\n    </div>\n\n\n    <div id=\"issues-modal\" aria-hidden=\"true\" aria-labelledby=\"exampleModalLabel\" class=\"modal fade\" role=\"dialog\" tabindex=\"-1\" _v-4ee2a991=\"\">\n      <div class=\"modal-dialog modal-lg\" role=\"document\" _v-4ee2a991=\"\">\n        <div class=\"modal-content modal-grey\" _v-4ee2a991=\"\">\n          <div class=\"modal-header no-padding bg-slate-700\" _v-4ee2a991=\"\">\n            <div class=\"col-md-6 col-sm-6 col-xs-6 p-5 text-black text-left font-14\" _v-4ee2a991=\"\">\n              <span _v-4ee2a991=\"\">{{ activeEmployee.client_name }}\n              <span class=\"text-orange-700\" _v-4ee2a991=\"\">( {{ activeEmployee.title }} )</span>\n              </span></div>\n            <div class=\"col-md-4 col-sm-4 col-xs-4 p-5 text-black text-right font-14\" _v-4ee2a991=\"\">\n              {{ activeEmployee.day }}, {{ activeEmployee.custom_date }}\n            </div>\n            <div class=\"col-md-2 col-sm-2 col-xs-2\" _v-4ee2a991=\"\"></div>\n            <button aria-label=\"Close\" class=\"close close-modal\" data-dismiss=\"modal\" type=\"button\" _v-4ee2a991=\"\">\n              <span aria-hidden=\"true\" _v-4ee2a991=\"\">×</span>\n            </button>\n          </div>\n          <div class=\"modal-body no-padding-left no-padding-right\" _v-4ee2a991=\"\">\n            <div class=\"col-md-4 col-sm-4 col-xs-4 text-black font-16 text-center no-padding-left pt-20 pb-20\" _v-4ee2a991=\"\">\n              Start Time\n            </div>\n            <div class=\"col-md-2 col-sm-2 col-xs-2 text-black font-16 text-center pt-20 pb-20\" _v-4ee2a991=\"\">\n              <select v-model=\"issues.in_hour\" class=\"form-control \" _v-4ee2a991=\"\">\n                <option v-for=\"item in hours\" :value=\"item\" _v-4ee2a991=\"\">{{ item }}</option>\n              </select>\n            </div>\n            <div class=\"col-md-2 col-sm-2 col-xs-2 text-black font-16 text-center no-padding-right pt-20 pb-20\" _v-4ee2a991=\"\">\n              <select v-model=\"issues.in_minute\" class=\"form-control\" _v-4ee2a991=\"\">\n                <option v-for=\"item in minutes\" :value=\"item\" _v-4ee2a991=\"\">{{ item }}</option>\n              </select>\n            </div>\n            <div class=\"col-md-2 col-sm-2 col-xs-2 text-black font-16 text-center pt-20 pb-20\" _v-4ee2a991=\"\">\n              <select v-model=\"issues.in_format\" class=\"form-control \" _v-4ee2a991=\"\">\n                <option value=\"AM\" _v-4ee2a991=\"\">AM</option>\n                <option value=\"PM\" _v-4ee2a991=\"\">PM</option>\n              </select>\n            </div>\n            <div class=\"col-md-2 col-sm-2 col-xs-2 text-black font-16 text-center no-padding-right pt-20 pb-20\" _v-4ee2a991=\"\">\n\n            </div>\n\n\n            <div class=\"col-md-4 col-sm-4 col-xs-4 text-black font-16 text-center no-padding-left pt-20 pb-20\" _v-4ee2a991=\"\">\n              End Time\n            </div>\n            <div class=\"col-md-2 col-sm-2 col-xs-2 text-black font-16 text-center pt-20 pb-20\" _v-4ee2a991=\"\">\n              <select v-model=\"issues.out_hour\" class=\"form-control\" _v-4ee2a991=\"\">\n                <option v-for=\"item in hours\" :value=\"item\" _v-4ee2a991=\"\">{{ item }}</option>\n              </select>\n            </div>\n            <div class=\"col-md-2 col-sm-2 col-xs-2 text-black font-16 text-center no-padding-right pt-20 pb-20\" _v-4ee2a991=\"\">\n              <select v-model=\"issues.out_minute\" class=\"form-control\" _v-4ee2a991=\"\">\n                <option v-for=\"item in minutes\" :value=\"item\" _v-4ee2a991=\"\">{{ item }}</option>\n              </select>\n            </div>\n            <div class=\"col-md-2 col-sm-2 col-xs-2 text-black font-16 text-center pt-20 pb-20\" _v-4ee2a991=\"\">\n              <select v-model=\"issues.out_format\" class=\"form-control \" _v-4ee2a991=\"\">\n                <option value=\"AM\" _v-4ee2a991=\"\">AM</option>\n                <option value=\"PM\" _v-4ee2a991=\"\">PM</option>\n              </select>\n            </div>\n            <div class=\"col-md-2 col-sm-2 col-xs-2 text-black font-16 text-center no-padding-right pt-20 pb-20\" _v-4ee2a991=\"\">\n\n            </div>\n\n            <div class=\"col-md-12 col-sm-12 col-xs-12 text-black\" _v-4ee2a991=\"\">\n              <div class=\"col-md-4 col-sm-4 col-xs-4 text-black font-16 text-center no-padding-left pt-20 pb-20\" _v-4ee2a991=\"\">\n                Break\n              </div>\n              <div class=\"col-md-3 col-sm-3 col-xs-3  no-padding-right pl-5 pt-20 pb-20\" _v-4ee2a991=\"\">\n                <select v-model=\"issues.break\" class=\"form-control\" _v-4ee2a991=\"\">\n                  <option v-for=\"item in breaks\" :value=\"item\" _v-4ee2a991=\"\">{{ item }}</option>\n                </select>\n              </div>\n              <div class=\"col-md-5 col-sm-5 col-xs-5  no-padding-right\" _v-4ee2a991=\"\">\n              </div>\n\n            </div>\n\n\n            <div class=\"col-md-12 col-sm-12 col-xs-12\" _v-4ee2a991=\"\">\n              <div class=\"col-md-2 col-sm-2 col-xs-2 text-black font-16 text-center no-padding-right pt-20 pb-20\" _v-4ee2a991=\"\">\n\n              </div>\n              <div class=\"col-md-8 col-sm-8 col-xs-8 p-40 no-padding-right\" _v-4ee2a991=\"\">\n                <textarea v-model=\"issues.note\" class=\"form-control\" cols=\"30\" name=\"\" rows=\"6\" _v-4ee2a991=\"\"></textarea>\n              </div>\n            </div>\n\n            <div class=\"col-md-12 col-sm-12 col-xs-12\" _v-4ee2a991=\"\">\n              <div class=\"col-md-2 col-sm-2 col-xs-2 text-black font-16 text-center no-padding-right pt-20 pb-20\" _v-4ee2a991=\"\">\n\n              </div>\n              <div class=\"col-md-8 col-sm-8 col-xs-8 p-40 no-padding-right text-right\" _v-4ee2a991=\"\">\n                <button class=\"btn btn-primary text-black p-5 no-padding-left border-white pl-10 pr-10\" @click=\"saveOrderIssue\" _v-4ee2a991=\"\">Save\n                </button>\n              </div>\n            </div>\n          </div>\n          <div class=\"modal-footer\" _v-4ee2a991=\"\">\n            <!--            <button class=\"btn btn-secondary\" data-dismiss=\"modal\" type=\"button\">Close</button>-->\n            <!--            <button class=\"btn btn-primary\" type=\"button\">Save changes</button>-->\n          </div>\n        </div>\n      </div>\n    </div>\n\n\n    <div id=\"missing-shift-claim-modal\" aria-hidden=\"true\" aria-labelledby=\"exampleModalLabel\" class=\"modal fade\" role=\"dialog\" _v-4ee2a991=\"\">\n      <div class=\"modal-dialog modal-lg\" role=\"document\" _v-4ee2a991=\"\">\n        <div class=\"modal-content modal-grey\" _v-4ee2a991=\"\">\n          <div class=\"modal-header no-padding bg-slate-700\" _v-4ee2a991=\"\">\n            <div class=\"col-md-12 col-sm-12 col-xs-12 p-5 text-black text-center font-14\" _v-4ee2a991=\"\">\n              Missing Shift Claim\n            </div>\n            <button aria-label=\"Close\" class=\"close close-modal\" data-dismiss=\"modal\" type=\"button\" _v-4ee2a991=\"\">\n              <span aria-hidden=\"true\" _v-4ee2a991=\"\">×</span>\n            </button>\n          </div>\n          <div class=\"modal-body no-padding-left no-padding-right\" _v-4ee2a991=\"\">\n\n            <div class=\"col-md-12 no-padding text-black\" _v-4ee2a991=\"\">\n              <div class=\"col-md-6\" _v-4ee2a991=\"\">\n                <div class=\"form-group\" _v-4ee2a991=\"\">\n                  <select v-model=\"shiftClaim.client_id\" v-select2=\"shiftClaim.client_id\" class=\"form-control\" name=\"shiftClaim.client_id\" _v-4ee2a991=\"\">\n                    <option value=\"\" _v-4ee2a991=\"\">Search Client</option>\n                    <option v-for=\"client in allClients\" value=\"{{ client.id }}\" _v-4ee2a991=\"\">{{ client.name }}\n                    </option>\n                  </select>\n                </div>\n              </div>\n              <div class=\"col-md-6\" _v-4ee2a991=\"\">\n                <div class=\"form-group\" _v-4ee2a991=\"\">\n                  <input v-model=\"shiftClaim.date\" class=\"form-control pickadate-post-order text-black\" name=\"date\" placeholder=\"Select Date\" required=\"required\" type=\"text\" _v-4ee2a991=\"\">\n                </div>\n              </div>\n            </div>\n\n\n            <div class=\"col-md-12 no-padding text-black\" _v-4ee2a991=\"\">\n              <div class=\"col-md-6\" _v-4ee2a991=\"\">\n                <div class=\"form-group\" _v-4ee2a991=\"\">\n                  <select v-model=\"shiftClaim.employee_id\" v-select2=\"shiftClaim.employee_id\" class=\"form-control\" name=\"shiftClaim.employee_id\" _v-4ee2a991=\"\">\n                    <option value=\"\" _v-4ee2a991=\"\">Search Employee</option>\n                    <option v-for=\"employee in allEmployees\" value=\"{{ employee.id }}\" _v-4ee2a991=\"\">{{ employee.fullName }}\n                    </option>\n                  </select>\n                </div>\n              </div>\n              <div class=\"col-md-6\" _v-4ee2a991=\"\">\n                <div class=\"form-group\" _v-4ee2a991=\"\">\n                  <select id=\"position-code\" v-model=\"shiftClaim.position_code\" v-vue-selectric=\"shiftClaim.position_code\" class=\"form-control wide\" name=\"position_code\" _v-4ee2a991=\"\">\n                    <option value=\"\" _v-4ee2a991=\"\">Select Job</option>\n                    <option v-for=\"position in selectedClient.positions\" :value=\"position.position_code\" _v-4ee2a991=\"\">{{ position.title }}\n                    </option>\n                  </select>\n                </div>\n              </div>\n            </div>\n\n            <div class=\"col-md-12 border-bottom border-2 border-white pt-10 mt-10 pb-10 mb-10 no-padding-left no-padding-right\" _v-4ee2a991=\"\"></div>\n\n\n            <div class=\"col-md-4 col-sm-4 col-xs-4 text-black font-16 text-center no-padding-left pt-20 pb-20\" _v-4ee2a991=\"\">\n              Start Time\n            </div>\n            <div class=\"col-md-2 col-sm-2 col-xs-2 text-black font-16 text-center pt-20 pb-20\" _v-4ee2a991=\"\">\n              <select v-model=\"shiftClaim.in_hour\" class=\"form-control \" _v-4ee2a991=\"\">\n                <option v-for=\"item in hours\" :value=\"item\" _v-4ee2a991=\"\">{{ item }}</option>\n              </select>\n            </div>\n            <div class=\"col-md-2 col-sm-2 col-xs-2 text-black font-16 text-center no-padding-right pt-20 pb-20\" _v-4ee2a991=\"\">\n              <select v-model=\"shiftClaim.in_minute\" class=\"form-control\" _v-4ee2a991=\"\">\n                <option v-for=\"item in minutes\" :value=\"item\" _v-4ee2a991=\"\">{{ item }}</option>\n              </select>\n            </div>\n            <div class=\"col-md-2 col-sm-2 col-xs-2 text-black font-16 text-center pt-20 pb-20\" _v-4ee2a991=\"\">\n              <select v-model=\"shiftClaim.in_format\" class=\"form-control \" _v-4ee2a991=\"\">\n                <option value=\"AM\" _v-4ee2a991=\"\">AM</option>\n                <option value=\"PM\" _v-4ee2a991=\"\">PM</option>\n              </select>\n            </div>\n            <div class=\"col-md-2 col-sm-2 col-xs-2 text-black font-16 text-center no-padding-right pt-20 pb-20\" _v-4ee2a991=\"\">\n\n            </div>\n\n\n            <div class=\"col-md-4 col-sm-4 col-xs-4 text-black font-16 text-center no-padding-left pt-20 pb-20\" _v-4ee2a991=\"\">\n              End Time\n            </div>\n            <div class=\"col-md-2 col-sm-2 col-xs-2 text-black font-16 text-center pt-20 pb-20\" _v-4ee2a991=\"\">\n              <select v-model=\"shiftClaim.out_hour\" class=\"form-control\" _v-4ee2a991=\"\">\n                <option v-for=\"item in hours\" :value=\"item\" _v-4ee2a991=\"\">{{ item }}</option>\n              </select>\n            </div>\n            <div class=\"col-md-2 col-sm-2 col-xs-2 text-black font-16 text-center no-padding-right pt-20 pb-20\" _v-4ee2a991=\"\">\n              <select v-model=\"shiftClaim.out_minute\" class=\"form-control\" _v-4ee2a991=\"\">\n                <option v-for=\"item in minutes\" :value=\"item\" _v-4ee2a991=\"\">{{ item }}</option>\n              </select>\n            </div>\n            <div class=\"col-md-2 col-sm-2 col-xs-2 text-black font-16 text-center pt-20 pb-20\" _v-4ee2a991=\"\">\n              <select v-model=\"shiftClaim.out_format\" class=\"form-control \" _v-4ee2a991=\"\">\n                <option value=\"AM\" _v-4ee2a991=\"\">AM</option>\n                <option value=\"PM\" _v-4ee2a991=\"\">PM</option>\n              </select>\n            </div>\n            <div class=\"col-md-2 col-sm-2 col-xs-2 text-black font-16 text-center no-padding-right pt-20 pb-20\" _v-4ee2a991=\"\">\n\n            </div>\n\n            <div class=\"col-md-12 col-sm-12 col-xs-12 text-black\" _v-4ee2a991=\"\">\n              <div class=\"col-md-4 col-sm-4 col-xs-4 text-black font-16 text-center no-padding-left pt-20 pb-20\" _v-4ee2a991=\"\">\n                Break\n              </div>\n              <div class=\"col-md-3 col-sm-3 col-xs-3  no-padding-right pl-5 pt-20 pb-20\" _v-4ee2a991=\"\">\n                <select v-model=\"shiftClaim.break\" class=\"form-control\" _v-4ee2a991=\"\">\n                  <option v-for=\"item in breaks\" :value=\"item\" _v-4ee2a991=\"\">{{ item }}</option>\n                </select>\n              </div>\n              <div class=\"col-md-5 col-sm-5 col-xs-5  no-padding-right\" _v-4ee2a991=\"\">\n              </div>\n\n            </div>\n\n\n            <div class=\"col-md-12 col-sm-12 col-xs-12\" _v-4ee2a991=\"\">\n              <div class=\"col-md-2 col-sm-2 col-xs-2 text-black font-16 text-center no-padding-right pt-20 pb-20\" _v-4ee2a991=\"\">\n\n              </div>\n              <div class=\"col-md-8 col-sm-8 col-xs-8 p-40 no-padding-right\" _v-4ee2a991=\"\">\n                <textarea v-model=\"shiftClaim.note\" class=\"form-control\" cols=\"30\" name=\"\" rows=\"6\" _v-4ee2a991=\"\"></textarea>\n              </div>\n            </div>\n\n            <div class=\"col-md-12 col-sm-12 col-xs-12\" _v-4ee2a991=\"\">\n              <div class=\"col-md-2 col-sm-2 col-xs-2 text-black font-16 text-center no-padding-right pt-20 pb-20\" _v-4ee2a991=\"\">\n\n              </div>\n              <div class=\"col-md-8 col-sm-8 col-xs-8 p-40 no-padding-right text-right\" _v-4ee2a991=\"\">\n                <button class=\"btn btn-primary text-black p-5 no-padding-left border-white pl-10 pr-10\" @click=\"saveShiftClaim\" _v-4ee2a991=\"\">Save\n                </button>\n              </div>\n            </div>\n          </div>\n          <div class=\"modal-footer\" _v-4ee2a991=\"\">\n            <!--            <button class=\"btn btn-secondary\" data-dismiss=\"modal\" type=\"button\">Close</button>-->\n            <!--            <button class=\"btn btn-primary\" type=\"button\">Save changes</button>-->\n          </div>\n        </div>\n      </div>\n    </div>\n\n\n    <div id=\"comment-modal\" aria-hidden=\"true\" aria-labelledby=\"exampleModalLabel\" class=\"modal fade\" role=\"dialog\" tabindex=\"-1\" _v-4ee2a991=\"\">\n      <div class=\"modal-dialog\" role=\"document\" _v-4ee2a991=\"\">\n        <div class=\"modal-content modal-grey\" _v-4ee2a991=\"\">\n          <div class=\"modal-header pl-10\" _v-4ee2a991=\"\">\n            <h3 v-if=\"status === 0\" class=\"text-danger\" _v-4ee2a991=\"\"> Bad Excuse </h3>\n            <h3 v-if=\"status === 1\" class=\"text-warning\" _v-4ee2a991=\"\"> Apologetic </h3>\n            <h3 v-if=\"status === 2\" class=\"text-success\" _v-4ee2a991=\"\"> Forgiven </h3>\n            <h3 v-if=\"status === 'Called'\" class=\"text-primary\" _v-4ee2a991=\"\"> Called </h3>\n            <h3 v-if=\"status === 'Returned'\" class=\"text-primary\" _v-4ee2a991=\"\"> Returned </h3>\n            <button aria-label=\"Close\" class=\"close close-modal\" data-dismiss=\"modal\" type=\"button\" _v-4ee2a991=\"\">\n              <span aria-hidden=\"true\" _v-4ee2a991=\"\">×</span>\n            </button>\n          </div>\n          <div class=\"modal-body no-padding-left no-padding-right\" _v-4ee2a991=\"\">\n\n            <div class=\"col-md-12 col-sm-12 col-xs-12\" _v-4ee2a991=\"\">\n              <div v-for=\"log in activeEmployee.logs\" _v-4ee2a991=\"\">\n                <li _v-4ee2a991=\"\">\n                  {{ statuses[log.type] }} {{ log.date }} {{ log.user.name }} <span v-if=\"log.note\" _v-4ee2a991=\"\"> - {{ log.note }}</span>\n                </li>\n              </div>\n            </div>\n\n            <div class=\"col-md-12 col-sm-12 col-xs-12 p-40\" _v-4ee2a991=\"\">\n              <textarea id=\"\" v-model=\"note\" class=\"form-control\" cols=\"30\" name=\"\" rows=\"6\" _v-4ee2a991=\"\"></textarea>\n            </div>\n\n            <div class=\"col-md-12 col-sm-12 col-xs-12 pt-10 text-right\" _v-4ee2a991=\"\">\n              <button class=\"btn btn-primary text-black p-5 no-padding-left border-white pl-10 pr-10\" @click=\"updateStatus\" _v-4ee2a991=\"\">Save\n              </button>\n            </div>\n\n          </div>\n          <div class=\"modal-footer\" _v-4ee2a991=\"\">\n            <!--            <button class=\"btn btn-secondary\" data-dismiss=\"modal\" type=\"button\">Close</button>-->\n            <!--            <button class=\"btn btn-primary\" type=\"button\">Save changes</button>-->\n          </div>\n        </div>\n      </div>\n    </div>\n\n\n    <div id=\"single-list-modal\" aria-hidden=\"true\" aria-labelledby=\"exampleModalLabel\" class=\"modal fade\" role=\"dialog\" tabindex=\"-1\" _v-4ee2a991=\"\">\n      <div class=\"modal-dialog modal-full\" role=\"document\" _v-4ee2a991=\"\">\n        <div class=\"modal-content \" _v-4ee2a991=\"\">\n          <div class=\"modal-header no-padding bg-slate-700\" _v-4ee2a991=\"\">\n            <div class=\"col-md-6 col-sm-6 p-5 text-black font-16\" _v-4ee2a991=\"\">{{ activeEmployee.name }}</div>\n            <div class=\"col-md-6  col-sm-6 p-5 text-black font-16\" _v-4ee2a991=\"\">Previous No Show</div>\n            <button aria-label=\"Close\" class=\"close close-modal\" data-dismiss=\"modal\" type=\"button\" _v-4ee2a991=\"\">\n              <span aria-hidden=\"true\" _v-4ee2a991=\"\">×</span>\n            </button>\n          </div>\n\n          <div class=\"modal-body no-padding-left no-padding-right\" _v-4ee2a991=\"\">\n\n            <table class=\"table table-xxs\" _v-4ee2a991=\"\">\n              <thead _v-4ee2a991=\"\">\n              <tr _v-4ee2a991=\"\">\n                <th class=\"bg-slate-300 text-white text-uppercase text-left w-100\" _v-4ee2a991=\"\">Date</th>\n                <th class=\"bg-slate-300 text-white text-uppercase text-left\" _v-4ee2a991=\"\">Client</th>\n                <th class=\"bg-slate-300 text-white text-uppercase text-left\" _v-4ee2a991=\"\">Job</th>\n                <th class=\"bg-slate-300 text-white text-uppercase text-left\" _v-4ee2a991=\"\">Note</th>\n                <th class=\"bg-slate-300 text-white text-uppercase text-left\" _v-4ee2a991=\"\">Undo</th>\n              </tr>\n              </thead>\n              <tbody _v-4ee2a991=\"\">\n              <tr v-for=\"(index,list) in singleEmployeeList\" :key=\"index\" _v-4ee2a991=\"\">\n                <td class=\" text-left w-100\" _v-4ee2a991=\"\">{{ list.custom_date }}</td>\n                <td class=\" text-left\" _v-4ee2a991=\"\">{{ list.client_name }}</td>\n                <td class=\" text-left\" _v-4ee2a991=\"\">{{ list.title }}</td>\n                <td class=\" text-left\" _v-4ee2a991=\"\">{{ list.note }}</td>\n                <td _v-4ee2a991=\"\"></td>\n              </tr>\n              </tbody>\n            </table>\n\n          </div>\n          <div class=\"modal-footer\" _v-4ee2a991=\"\">\n            <!--            <button class=\"btn btn-secondary\" data-dismiss=\"modal\" type=\"button\">Close</button>-->\n            <!--            <button class=\"btn btn-primary\" type=\"button\">Save changes</button>-->\n          </div>\n        </div>\n      </div>\n    </div>\n\n\n  </div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  var id = "/home/shoieb/sites/elegant/resources/assets/js/vue/components/no-show-verification-updated.vue"
  module.hot.dispose(function () {
    require("vueify-insert-css").cache["\n.re-confirm > div.col-md-12[_v-4ee2a991],\n.re-confirm > div.col-md-6[_v-4ee2a991],\n.re-confirm > div.col-md-12[_v-4ee2a991] {\n  padding: 0 !important;\n}\n\n.bordered-div[_v-4ee2a991] {\n  border-left: 1px solid #ddd;\n  border-right: 1px solid #ddd;\n}\n\n.bordered-left[_v-4ee2a991] {\n  border-left: 1px solid #ddd;\n}\n\n.bordered-right[_v-4ee2a991] {\n  border-right: 1px solid #ddd;\n}\n\n.bordered-bottom[_v-4ee2a991] {\n  border-bottom: 1px solid #ddd;\n}\n\n.fixed-header[_v-4ee2a991] {\n  position: fixed;\n  top: 48px;\n  right: 0px;\n  z-index: 1000 !important;\n}\n\n.middle-div[_v-4ee2a991] {\n  width: 60% !important;\n  right: 20% !important;\n}\n\n.div-20[_v-4ee2a991] {\n  width: 20% !important;\n}\n\n.div-60[_v-4ee2a991] {\n  width: 60% !important;\n}\n\n.top-65[_v-4ee2a991] {\n  top: 65px;\n}\n\n\n.pt-65[_v-4ee2a991] {\n  padding-top: 65px;\n}\n\n\n.list-div[_v-4ee2a991] {\n  margin-bottom: 40px;\n  min-height: 900px !important;\n}\n\n.bottom-div[_v-4ee2a991] {\n  position: fixed;\n  bottom: 0px;\n  right: 0px;\n  z-index: 1000 !important;\n  height: 40px !important;\n  width: 100%;\n}\n\n.mb-40[_v-4ee2a991] {\n  margin-bottom: 40px !important;\n}\n\n.p-40[_v-4ee2a991] {\n  padding-top: 40px;\n  padding-bottom: 40px;\n}\n\n.m-30[_v-4ee2a991] {\n  margin-left: 30px;\n  margin-right: 30px;\n}\n\n.h-30[_v-4ee2a991] {\n  min-height: 35px !important;\n}\n\n\n.border-custom-grey[_v-4ee2a991] {\n  border-color: #ddd !important;\n}\n\n.bg-shift[_v-4ee2a991] {\n  background-color: #d5dce3;\n}\n\n.bg-shift-darker[_v-4ee2a991] {\n  background-color: #aeb7bf;\n}\n\n.w-120[_v-4ee2a991] {\n  min-width: 120px !important;\n}\n\n.w-100[_v-4ee2a991] {\n  min-width: 100px !important;\n}\n\n.col-md-15[_v-4ee2a991] {\n  width: 10.99999995%;\n  float: left;\n}\n\n.text-grey-custom[_v-4ee2a991] {\n  color: #696666 !important;\n}\n\n@media (max-width: 1024px) {\n  .h-30[_v-4ee2a991] {\n    min-height: 55px !important;\n  }\n}\n\n.close-modal[_v-4ee2a991] {\n  font-size: 30px;\n  margin-top: -14.75px;\n  font-weight: 500;\n}\n\n.font-20[_v-4ee2a991] {\n  font-size: 20px;\n}\n\n\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, module.exports.template)
  }
})()}
},{"./../../mixed/modals":10,"./../../mixed/notify":11,"vue":5,"vue-hot-reload-api":4,"vueify-insert-css":6}],62:[function(require,module,exports){
var __vueify_style__ = require("vueify-insert-css").insert("\n")
"use strict";

exports.__esModule = true;
var modals = require("./../../mixed/modals");
var notify = require("./../../mixed/notify");

exports["default"] = {
  data: function data() {
    return {
      employees: {},
      employee: null,
      list: {},
      activeList: {},
      suspend: 0,
      action: 10,
      statuses: {
        "Left VM": "LV",
        "Left Voice Mail": "LV",
        Answered: "ANSWERED",
        Called: "CALLED",
        Disc: "LD",
        "Hang Up": "HU",
        "Wrong No": "WN",
        "VM Full": "VF",
        "No VM": "NV",
        "delete": "DELETE",
        Call: "Call",
        Return: "Return",
        "Return-Apologetic": "RA",
        "Return-Bad Excuses": "RB",
        "Return-Don't Care": "RC",
        Apologetic: "A",
        "Bad Excuses": "B",
        "Don't Care": "C"
      },
      gradeStatus: ["Return-Apologetic", "Return-Bad Excuses", "Return-Don't Care", "Apologetic", "Bad Excuses", "Don't Care", "Return"],
      response: "",
      employeeResponse: "",
      returnedCallStatus: false,
      returnedCallDate: "",
      note: "",
      dispute: 0
    };
  },
  filters: {},
  watch: {},
  ready: function ready() {
    this.$nextTick(function () {
      $('[data-popup="popover"]').popover();
    });
    $(".table-fixed-header").fixedHeader();
    $(".header-copy").hide();
    $(".pickadate-year-invoice").pickadate({
      format: "yyyy-mm-dd",
      selectYears: 70,
      max: true,
      firstDay: 1
    });
    this.getEmployees();
  },
  events: {},
  methods: {
    /**
     * calculate call grading
     * @param log
     * @returns {*}
     */
    callLogGrading: function callLogGrading(log) {
      var responses = _.sortBy(_.cloneDeep(log), function (node) {
        return -new Date(node.created_at).getTime();
      });

      for (var i = 0; i < responses.length; i++) {
        if (this.gradeStatus.includes(responses[i].type)) {
          return "<span class=\"text-danger-400\">" + this.statuses[responses[i].type] + "</span>";
          break;
        }
      }
      return responses.length;
    },

    showPerformanceReport: function showPerformanceReport(employee) {
      window.bus.$emit("showEmployeePerformanceReport", employee.id);
    },

    getEmployees: function getEmployees() {
      var _this = this;

      notify.loading(true);
      this.$http.get("/api/no-show-verification-log", function (response) {
        _this.employees = response;
        //this.getEmployeeData(this.employees[0].id);
      }).always(function () {
        notify.loading(false);
      });
    },

    getEmployeeData: function getEmployeeData(id) {
      var _this2 = this;

      notify.loading(true);
      var that = this;
      this.$http.get("/api/no-show-verification-log/" + id, function (response) {
        _this2.employee = response;
        $(".header-copy").remove();
        _this2.$nextTick(function () {
          $(".table-fixed-header").fixedHeader();
          $(".header-copy").hide();
          $(".header-copy").css("display", "block");
          $(".actionButton").click(function () {
            that.showEmployeeListModal();
          });
          $(".callButton").click(function () {
            that.showResponseModal();
          });
          this.$nextTick(function () {
            $('[data-popup="popover"]').popover();
          });
        });
      }).always(function () {
        notify.loading(false);
      });
    },

    showEmployeeListModal: function showEmployeeListModal() {
      modals.showStrict("#employee-no-show-list");
    },

    showVerificationModal: function showVerificationModal(list) {
      this.action = 10;
      this.suspend = 0;
      this.employeeResponse = "";
      this.returnedCallStatus = false;
      this.returnedCallDate = "";
      this.note = "";
      this.dispute = 0;
      this.activeList = _.cloneDeep(list);
      modals.showStrict("#verification-modal");
    },

    formatDate: function formatDate(date, from, format) {
      if (moment(date).isValid()) {
        return moment(date, from).format(format);
      } else {
        return "";
      }
    },

    setEmployee: function setEmployee(employee) {
      this.getEmployeeData(employee.id);
    },

    countNote: function countNote(note) {
      return note.length > 19 ? false : true;
    },

    verifyNoShow: function verifyNoShow() {
      var _this3 = this;

      notify.loading(true);
      this.$http.post("/api/verify-no-show-entry/" + this.activeList.id, {
        note: this.note
      }, function (response) {
        modals.hide("#verification-modal");
        //modals.hide("#employee-no-show-list");
        //this.employee = null;
        _this3.note = "";
        _this3.getEmployees();
      }).always(function () {
        notify.loading(false);
      });
    },

    refreshEntry: function refreshEntry() {
      var _this4 = this;

      if (this.returnedCallStatus && !this.returnedCallDate) {
        notify.info("Please Set Returned Call Date");
        return false;
      }

      if (this.employeeResponse && this.action === 10) {
        notify.info("Please Select Final Action");
        return false;
      }

      if (this.note && this.action === 10 && !this.returnedCallStatus && !this.dispute) {
        notify.info("Please Select Final Action");
        return false;
      }

      if ((this.action !== 10 || this.returnedCallStatus || this.dispute) && this.note.length < 1) {
        notify.info("Please Add Note");
        return false;
      }

      var orderIds = _.pluck(this.employee.no_show_un_verified, "order_id");

      notify.loading(true);
      this.$http.post("/api/no-show-verification-process/" + this.activeList.id + "/" + this.action + "?suspend=" + this.suspend, {
        note: this.note,
        response: this.employeeResponse,
        returnedCall: this.returnedCallStatus ? "Return" : "",
        returnDate: this.returnedCallDate,
        orderIds: orderIds,
        dispute: this.dispute
      }, function (response) {
        modals.hide("#verification-modal");
        //modals.hide("#employee-no-show-list");
        //this.employee = null;
        _this4.getEmployeeData(_this4.activeList.employee_id);
        _this4.getEmployees();
      }).always(function () {
        notify.loading(false);
      });
    },

    showResponseModal: function showResponseModal() {
      modals.showStrict("#response-modal");
    },

    saveResponse: function saveResponse() {
      var _this5 = this;

      var orderIds = _.pluck(this.employee.no_show_un_verified, "order_id");
      notify.loading(true);
      this.$http.post("/api/save-employee-call-response", {
        employee_id: this.employee.id,
        type: this.response,
        entry_point: "No Show Verification",
        orderIds: orderIds
      }, function (response) {
        modals.hide("#response-modal");
        _this5.response = null;
        _this5.employee = null;
        _this5.getEmployees();
      }).always(function () {
        notify.loading(false);
      });
    }
  }
};
module.exports = exports["default"];
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n    <div class=\"row\">\n        <!-- <h4 class=\"text-center\">\n            No Show Employees Verification\n        </h4> -->\n        <div class=\"col-md-12\">\n            <div class=\"table-responsive\">\n                <table class=\"table table-bordered table-xxs table-fixed-header\">\n                    <thead class=\"header\">\n                    <tr>\n                        <th colspan=\"13\" class=\"no-padding-left no-padding-right\">\n                            <div v-if=\"employee\" class=\"col-md-12 no-padding\">\n                                <div class=\"col-md-8 mb-5 no-padding\">\n                                    <div class=\"col-md-12 bg-brown-700 no-padding\">\n                                        <div class=\"col-md-3 no-padding text-black bg-brown-700 text-center\">{{ employee.fullName }}</div>\n                                        <div class=\"col-md-3 no-padding text-black bg-brown-700 text-center\">{{ employee.primary_phone }}\n                                        </div>\n                                        <div class=\"col-md-3 no-padding text-black bg-brown-700 text-center\">{{ employee.secondary_phone\n                                            }}\n                                        </div>\n                                        <div class=\"col-md-3 no-padding text-black bg-brown-700 text-center\">{{ employee.email }}</div>\n                                    </div>\n                                    <div class=\"col-md-7 no-padding\">\n                                        <div class=\"col-md-12 no-padding\" v-for=\"(index,list) in employee.no_show_un_verified\" :key=\"index\">\n                                            <div class=\"col-md-6 no-padding text-black bg-orange-custom text-center text-color-black\">\n                                                {{ list.order.client.company_code+' '+list.order.position.title}}\n                                            </div>\n                                            <div class=\"col-md-3 no-padding text-black bg-orange-custom text-center text-color-black\">\n                                                {{ formatDate(list.order.date,'YYYY-MM-DD','ddd') }}\n                                            </div>\n                                            <div class=\"col-md-3 no-padding text-black bg-orange-custom text-center text-color-black\">{{\n                                                formatDate(list.order.date,'YYYY-MM-DD','DD/MM/YYYY') }}\n                                            </div>\n                                        </div>\n                                    </div>\n                                    <div class=\"col-md-5 no-padding\">\n                                        <div class=\"col-md-6 text-center\">\n                                            <button class=\"btn btn-danger bg-danger-700 text-black mt-30 actionButton\" @click=\"showEmployeeListModal\">\n                                                Action\n                                            </button>\n                                        </div>\n                                        <div class=\"col-md-6 text-center\">\n                                            <button class=\"btn btn-primary bg-primary-700 text-black mt-30 callButton\" @click=\"showResponseModal\">\n                                                Called\n                                            </button>\n                                        </div>\n                                    </div>\n                                </div>\n                                <div class=\"col-md-4 mb-10 no-padding\">\n                                    <div class=\"col-md-12 no-padding\">\n                                        <div class=\"col-md-3 no-padding text-black bg-slate-700 text-center\">Date</div>\n                                        <div class=\"col-md-3 no-padding text-black bg-slate-700 text-center\">Time</div>\n                                        <div class=\"col-md-3 no-padding text-black bg-slate-700 text-center\">Called By</div>\n                                        <div class=\"col-md-3 no-padding text-black bg-slate-700 text-center\">Remarks</div>\n                                    </div>\n                                    <div class=\"col-md-12 no-padding\" v-for=\"(index,log) in employee.latest_responses\" :key=\"index\">\n                                        <div class=\"col-md-3 no-padding text-center border-bottom border-bottom border-left\">\n                                            {{ formatDate(log.created_at,'YYYY-MM-DD HH:mm:ss','D-MMM') }}\n                                        </div>\n                                        <div class=\"col-md-3 no-padding text-center  border-bottom border-bottom border-left\">\n                                            {{ formatDate(log.created_at,'YYYY-MM-DD HH:mm:ss','HH:mm A') }}\n                                        </div>\n                                        <div class=\"col-md-3 no-padding text-center  border-bottom border-bottom border-left\">\n                                            {{ log.user.name }}\n                                        </div>\n                                        <div class=\"col-md-3 no-padding text-center  border-bottom border-right border-bottom border-left\">\n                                            {{ statuses[log.type] }}\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                        </th>\n                    </tr>\n                    <tr>\n                        <th></th>\n                        <th></th>\n                        <th></th>\n                        <th></th>\n                        <th></th>\n                        <th></th>\n                        <th></th>\n                        <th></th>\n                        <th></th>\n                        <th></th>\n                        <th></th>\n                        <th></th>\n                        <th></th>\n                    </tr>\n                    <tr>\n                        <th class=\"bg-slate-700 text-black text-center\" rowspan=\"2\">P.Chart</th>\n                        <th class=\"bg-slate-700 text-black text-center\" rowspan=\"2\">EMPLOYEE NAME</th>\n                        <th class=\"bg-brown-700 text-black text-center\" colspan=\"5\">PENDING NO SHOW VERIFICATION</th>\n                        <th class=\"bg-brown text-black text-center\" rowspan=\"2\">90</th>\n                        <th class=\"bg-brown text-black text-center\" rowspan=\"2\">365</th>\n                        <th class=\"bg-slate-700 text-black text-center\" colspan=\"4\">CALL LOG</th>\n                    </tr>\n                    <tr>\n                        <th class=\"bg-brown-700 text-black text-center\">1</th>\n                        <th class=\"bg-brown-700 text-black text-center\">2</th>\n                        <th class=\"bg-brown-700 text-black text-center\">3</th>\n                        <th class=\"bg-brown-700 text-black text-center\">4</th>\n                        <th class=\"bg-brown-700 text-black text-center\">5</th>\n\n                        <th class=\"bg-slate-700 text-black text-center\">1st</th>\n                        <th class=\"bg-slate-700 text-black text-center\">2nd</th>\n                        <th class=\"bg-slate-700 text-black text-center\">3rd</th>\n                        <th class=\"bg-slate-700 text-black text-center\">4th</th>\n                    </tr>\n                    </thead>\n                    <tbody>\n                    <tr v-for=\"(index,employee) in employees\" :key=\"index\">\n                        <td class=\"text-center\">\n                            <button class=\"btn btn-primary\" @click=\"showPerformanceReport(employee)\">P.Chart\n                            </button>\n                        </td>\n                        <td class=\"text-center\" @click=\"setEmployee(employee)\">{{ employee.fullName }}</td>\n                        <td class=\"text-center\">{{ formatDate(employee.lists[0].order.date,'YYYY-MM-DD','D-MMM') }}</td>\n                        <td class=\"text-center\">{{ formatDate(employee.lists[1].order.date,'YYYY-MM-DD','D-MMM') }}</td>\n                        <td class=\"text-center\">{{ formatDate(employee.lists[2].order.date,'YYYY-MM-DD','D-MMM') }}</td>\n                        <td class=\"text-center\">{{ formatDate(employee.lists[3].order.date,'YYYY-MM-DD','D-MMM') }}</td>\n                        <td class=\"text-center\">{{ formatDate(employee.lists[4].order.date,'YYYY-MM-DD','D-MMM') }}</td>\n                        <td class=\"text-center bg-orange-light-custom\">{{ employee.no_show_verified_thirty_count }}</td>\n                        <td class=\"text-center bg-orange-light-custom\">{{ employee.no_show_verified_ninety_count }}</td>\n                        <td class=\"text-center\">{{ formatDate(employee.logs[0].created_at,'YYYY-MM-DD HH:mm:ss','D MMM')\n                            }} -\n                            <span class=\"text-danger-400\">{{ statuses[employee.logs[0].type] }}</span>\n                        </td>\n                        <td class=\"text-center\">{{ formatDate(employee.logs[1].created_at,'YYYY-MM-DD HH:mm:ss','D MMM')\n                            }} -\n                            <span class=\"text-danger-400\">{{ statuses[employee.logs[1].type] }}</span>\n                        </td>\n                        <td class=\"text-center\">{{ formatDate(employee.logs[2].created_at,'YYYY-MM-DD HH:mm:ss','D MMM')\n                            }} -\n                            <span class=\"text-danger-400\">{{ statuses[employee.logs[2].type] }}</span>\n                        </td>\n                        <td class=\"text-center\">{{ formatDate(employee.logs[3].created_at,'YYYY-MM-DD HH:mm:ss','D MMM')\n                            }} -\n                            <span class=\"text-danger-400\">{{ statuses[employee.logs[3].type] }}</span>\n                        </td>\n                    </tr>\n                    </tbody>\n                </table>\n            </div>\n        </div>\n\n        <div class=\"modal fade\" id=\"employee-no-show-list\">\n            <div class=\"modal-dialog modal-full\">\n                <div class=\"modal-content\">\n                    <div class=\"modal-header no-padding\">\n                        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\">×</button>\n                        <h4 class=\"modal-title bg-orange-custom text-black text-color-black p-20\">{{ employee.fullName\n                            }}</h4>\n                    </div>\n                    <div class=\"modal-body p-10 no-padding-top\">\n                        <div class=\"row\">\n                            <div class=\"col-md-12\">\n                                <h4 class=\"text-center text-black bg-brown-700 no-padding no-margin\">PENDING NO\n                                    SHOW</h4>\n                                <div class=\"table-responsive\">\n                                    <table class=\"table table-bordered table-xxs\">\n                                        <thead>\n                                        <tr class=\"bg-brown\">\n                                            <th class=\"text-center text-black text-color-black\">DATE</th>\n                                            <th class=\"text-center text-black text-color-black\">POSITION</th>\n                                            <th class=\"text-center text-black text-color-black\">1st Call</th>\n                                            <th class=\"text-center text-black text-color-black\">2nd Call</th>\n                                            <th class=\"text-center text-black text-color-black\">3rd Call</th>\n                                            <th class=\"text-center text-black text-color-black\">4th Call</th>\n                                            <th class=\"text-center text-black text-color-black\">NOTE</th>\n                                            <th class=\"text-center text-black text-color-black\">VERIFY</th>\n                                        </tr>\n                                        </thead>\n                                        <tbody>\n                                        <tr v-for=\"(index,list) in employee.no_show_un_verified\" :key=\"index\">\n                                            <td class=\"text-center\">\n                                                {{ formatDate(list.order.date,'YYYY-MM-DD','M/D/YYYY') }}\n                                            </td>\n                                            <td>\n                                                {{ list.order.client.company_code+' '+list.order.position.title}}\n                                            </td>\n                                            <td class=\"text-center\">\n                                                {{\n                                                formatDate(list.order.responses[0].created_at,'YYYY-MM-DD\n                                                HH:mm:ss','D-MMM') }} -\n                                                <span class=\"text-danger-400\">{{ statuses[list.order.responses[0].type] }}</span>\n                                            </td>\n                                            <td class=\"text-center\">\n                                                {{\n                                                formatDate(list.order.responses[1].created_at,'YYYY-MM-DD\n                                                HH:mm:ss','D-MMM') }} -\n                                                <span class=\"text-danger-400\">{{ statuses[list.order.responses[1].type] }}</span>\n                                            </td>\n                                            <td class=\"text-center\">\n                                                {{\n                                                formatDate(list.order.responses[2].created_at,'YYYY-MM-DD\n                                                HH:mm:ss','D-MMM') }} -\n                                                <span class=\"text-danger-400\">{{ statuses[list.order.responses[2].type] }}</span>\n                                            </td>\n                                            <td class=\"text-center\">\n                                                {{\n                                                formatDate(list.order.responses[3].created_at,'YYYY-MM-DD\n                                                HH:mm:ss','D-MMM') }} -\n                                                <span class=\"text-danger-400\">{{ statuses[list.order.responses[3].type] }}</span>\n                                            </td>\n                                            <td class=\"text-center text-black text-color-black\">\n                                                <button v-if=\"list.note\" type=\"button\" class=\"btn btn-default btn-sm\" data-html=\"true\" data-popup=\"popover\" data-title=\"\" data-trigger=\"hover\" :data-content=\"list.note | formatNote\"><i class=\"icon-notebook position-right\"></i></button>\n                                            </td>\n                                            <td class=\"text-center\">\n                                                <button class=\"btn btn-primary text-center\" @click=\"showVerificationModal(list)\"> Verify\n                                                </button>\n                                            </td>\n                                        </tr>\n                                        </tbody>\n                                    </table>\n                                </div>\n                            </div>\n                            <div class=\"col-md-12 mt-150\">\n                                <h4 class=\"text-center text-black bg-slate-700 no-padding no-margin\">VERIFIED NO\n                                    SHOW</h4>\n                                <div class=\"table-responsive\">\n                                    <table class=\"table table-bordered table-xxs\">\n                                        <thead>\n                                        <tr class=\"bg-slate\">\n                                            <th class=\"text-center text-black text-color-black\">DATE</th>\n                                            <th class=\"text-center text-black text-color-black\">POSITION</th>\n                                            <th class=\"text-center text-black text-color-black\">Grade</th>\n                                            <th class=\"text-center text-black text-color-black\">1st Call</th>\n                                            <th class=\"text-center text-black text-color-black\">2nd Call</th>\n                                            <th class=\"text-center text-black text-color-black\">3rd Call</th>\n                                            <th class=\"text-center text-black text-color-black\">4th Call</th>\n                                            <th class=\"text-center text-black text-color-black\">NOTE</th>\n                                        </tr>\n                                        </thead>\n                                        <tbody>\n                                        <tr v-for=\"(index,list) in employee.no_show_verified\" :key=\"index\">\n                                            <td class=\"text-center\">\n                                                {{ formatDate(list.order.date,'YYYY-MM-DD','M/D/YYYY') }}\n                                            </td>\n                                            <td class=\"text-center\">\n                                                {{ list.order.client.company_code+' '+list.order.position.title}}\n                                            </td>\n                                            <td class=\"text-center\">\n                                                {{{ callLogGrading(list.order.responses) }}}\n                                            </td>\n                                            <td class=\"text-center\">\n                                                {{\n                                                formatDate(list.order.responses[0].created_at,'YYYY-MM-DD\n                                                HH:mm:ss','MM-DD-YYYY') }} -\n                                                <span class=\"text-danger-400\">{{ statuses[list.order.responses[0].type] }}</span>\n                                            </td>\n                                            <td class=\"text-center\">\n                                                {{\n                                                formatDate(list.order.responses[1].created_at,'YYYY-MM-DD\n                                                HH:mm:ss','MM-DD-YYYY') }} -\n                                                <span class=\"text-danger-400\">{{ statuses[list.order.responses[1].type] }}</span>\n                                            </td>\n                                            <td class=\"text-center\">\n                                                {{\n                                                formatDate(list.order.responses[2].created_at,'YYYY-MM-DD\n                                                HH:mm:ss','MM-DD-YYYY') }} -\n                                                <span class=\"text-danger-400\">{{ statuses[list.order.responses[2].type] }}</span>\n                                            </td>\n                                            <td class=\"text-center\">\n                                                {{\n                                                formatDate(list.order.responses[3].created_at,'YYYY-MM-DD\n                                                HH:mm:ss','MM-DD-YYYY') }} -\n                                                <span class=\"text-danger-400\">{{ statuses[list.order.responses[3].type] }}</span>\n                                            </td>\n                                            <td class=\"text-center\">\n                                                <button v-if=\"list.note\" type=\"button\" class=\"btn btn-default btn-sm\" data-html=\"true\" data-popup=\"popover\" data-title=\"\" data-trigger=\"hover\" :data-content=\"list.note | formatNote\"><i class=\"icon-notebook position-right\"></i></button>\n                                            </td>\n                                        </tr>\n                                        </tbody>\n                                    </table>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"modal-footer\">\n                        <!--<button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button>-->\n                        <!--<button type=\"button\" class=\"btn btn-primary\">Save changes</button>-->\n                    </div>\n                </div><!-- /.modal-content -->\n            </div><!-- /.modal-dialog -->\n        </div><!-- /.modal -->\n\n\n        <div class=\"modal fade\" id=\"verification-modal\">\n            <div class=\"modal-dialog modal-lg bg-slate-300\">\n                <div class=\"modal-content\">\n                    <div class=\"modal-header bg-slate-300 text-right\">\n                        <button class=\"text-black text-color-black\" type=\"button\" data-dismiss=\"modal\" aria-hidden=\"true\">×\n                        </button>\n                        <h4 class=\"modal-title text-left\">\n                            {{ formatDate(activeList.order.date,'YYYY-MM-DD','M/D/YYYY') }} -\n                            {{ activeList.order.client.company_code+' '+activeList.order.position.title}}\n                        </h4>\n                    </div>\n                    <div class=\"modal-body bg-slate-300 no-padding pt-20\">\n                        <!--<div class=\"radio\">-->\n                        <!--<label class=\"text-color-black text-black no-padding-left\"><input type=\"checkbox\" value=\"1\"-->\n                        <!--v-model=\"suspend\"-->\n                        <!--name=\"undo\">Suspend</label>-->\n                        <!--</div>-->\n                        <!--<br>-->\n                        <!--<button type=\"button\" class=\"btn bg-brown\" @click=\"verifyNoShow\">VERIFIED</button>-->\n                        <!--<br>-->\n\n                        <div class=\"col-md-4 bg-slate-300 no-padding min-height-150\">\n                            <h4 class=\"bg-blue-300 text-black text-center\">MISSED</h4>\n                            <div class=\"col-md-12\">\n                                <div class=\"col-md-12 text-center\">\n                                    <div class=\"form-group\">\n                                        <input type=\"checkbox\" value=\"1\" v-model=\"returnedCallStatus\" name=\"reruened-call\">\n                                        Returned Call\n                                    </div>\n                                </div>\n                                <div class=\"col-md-12 text-center\">\n                                    <div class=\"form-group pr-10\">\n                                        <input type=\"text\" name=\"\" class=\"form-control text-black pickadate-year-invoice\" v-model=\"returnedCallDate\">\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n\n                        <div class=\"col-md-4 bg-slate-300 no-padding min-height-150\">\n                            <h4 class=\"bg-black-center text-black\">TALKED</h4>\n                            <div class=\"col-md-12\">\n                                <div class=\"col-md-3\">\n                                    <div class=\"text-right\">\n                                        <input type=\"radio\" value=\"Apologetic\" v-model=\"employeeResponse\" name=\"employee-response\">\n                                    </div>\n                                </div>\n                                <div class=\"col-md-9 text-left\">\n                                    <label class=\"text-color-black text-black no-padding-left\">Apologetic</label>\n                                </div>\n                            </div>\n                            <div class=\"col-md-12\">\n                                <div class=\"col-md-3\">\n                                    <div class=\"text-right\">\n                                        <input type=\"radio\" value=\"Bad Excuses\" v-model=\"employeeResponse\" name=\"employee-response\">\n                                    </div>\n                                </div>\n                                <div class=\"col-md-9 text-left\">\n                                    <label class=\"text-color-black text-black no-padding-left\">Bad Excuses</label>\n                                </div>\n                            </div>\n                            <div class=\"col-md-12\">\n                                <div class=\"col-md-3\">\n                                    <div class=\"text-right\">\n                                        <input type=\"radio\" value=\"Don't Care\" v-model=\"employeeResponse\" name=\"employee-response\">\n                                    </div>\n                                </div>\n                                <div class=\"col-md-9 text-left\">\n                                    <label class=\"text-color-black text-black no-padding-left\">Don't Care</label>\n                                </div>\n                            </div>\n                        </div>\n\n                        <div class=\"col-md-4 bg-slate-300 no-padding min-height-150\">\n                            <h4 class=\"bg-danger text-black text-center\">FINAL ACTION</h4>\n                            <div class=\"col-md-12\">\n                                <div class=\"col-md-3\">\n                                    <div class=\"text-right\">\n                                        <input type=\"radio\" value=\"1\" v-model=\"action\" name=\"undo\">\n                                    </div>\n                                </div>\n                                <div class=\"col-md-9 text-left\">\n                                    <label class=\"text-color-black text-black no-padding-left\">NO SHOW</label>\n                                </div>\n                            </div>\n                            <!-- <div class=\"col-md-12\">\n                                <div class=\"col-md-3\">\n                                    <div class=\"text-right\">\n                                        <input type=\"radio\" value=\"2\" v-model=\"action\" name=\"undo\">\n                                    </div>\n                                </div>\n                                <div class=\"col-md-9 text-left\">\n                                    <label class=\"text-color-black text-black no-padding-left\">Worked</label>\n                                </div>\n                            </div>\n                            <div class=\"col-md-12\">\n                                <div class=\"col-md-3\">\n                                    <div class=\"text-right\">\n                                        <input type=\"radio\" value=\"4\" v-model=\"action\" name=\"undo\">\n                                    </div>\n                                </div>\n                                <div class=\"col-md-9 text-left\">\n                                    <label class=\"text-color-black text-black no-padding-left\">Clear Record</label>\n                                </div>\n                            </div> -->\n                        </div>\n\n                        <div class=\"col-md-12 pl-20\">\n                            <div class=\"form-group\">\n                                <textarea name=\"\" id=\"\" cols=\"100\" rows=\"5\" v-model=\"note\"></textarea>\n                            </div>\n                        </div>\n\n                    </div>\n                    <div class=\"modal-footer bg-slate-300\">\n                        <div class=\"col-md-6 text-left\">\n                            <div class=\"form-group\">\n                                <input type=\"checkbox\" value=\"1\" v-model=\"dispute\" name=\"dispute\">\n                                Dispute\n                            </div>\n                        </div>\n                        <!--<button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button>-->\n                        <div class=\"col-md-6 text-right\">\n                            <button type=\"button\" class=\"btn btn-success pull-right\" @click=\"refreshEntry\">Submit</button>\n                        </div>\n                    </div>\n                </div><!-- /.modal-content -->\n            </div><!-- /.modal-dialog -->\n        </div><!-- /.modal -->\n\n        <div class=\"modal fade\" id=\"response-modal\">\n            <div class=\"modal-dialog modal-xs\">\n                <div class=\"modal-content bg-orange-custom\">\n                    <div class=\"modal-header\">\n                        <button class=\"text-black text-color-black\" type=\"button\" data-dismiss=\"modal\" aria-hidden=\"true\">×\n                        </button>\n                        <!--<h4 class=\"modal-title\">Modal title</h4>-->\n                    </div>\n                    <div class=\"modal-body\">\n                        <div class=\"col-md-12\">\n                            <div class=\"form-group\">\n                                <div class=\"radio\">\n                                    <label><input type=\"radio\" value=\"Left VM\" name=\"callledStatus\" v-model=\"response\">Left\n                                        Voicemail</label>\n                                </div>\n                                <div class=\"radio\">\n                                    <label><input type=\"radio\" value=\"No VM\" name=\"callledStatus\" v-model=\"response\">Did'nt\n                                        Leave Voicemail</label>\n                                </div>\n                                <div class=\"radio\">\n                                    <label><input type=\"radio\" value=\"VM Full\" name=\"callledStatus\" v-model=\"response\">Voicemail\n                                        Full</label>\n                                </div>\n                                <div class=\"radio\">\n                                    <label><input type=\"radio\" value=\"Hang Up\" name=\"callledStatus\" v-model=\"response\">Hang\n                                        Up</label>\n                                </div>\n                                <div class=\"radio\">\n                                    <label><input type=\"radio\" value=\"Disc\" name=\"callledStatus\" v-model=\"response\">Line\n                                        Disconnected</label>\n                                </div>\n                                <div class=\"radio\">\n                                    <label><input type=\"radio\" value=\"Wrong No\" name=\"callledStatus\" v-model=\"response\">Wrong\n                                        Number</label>\n                                </div>\n                            </div>\n                            <div class=\"text-right\">\n                                <button type=\"button\" class=\"btn btn-primary\" @click=\"saveResponse\">Save\n                                </button>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"modal-footer\">\n                        <!--<button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button>-->\n                    </div>\n                </div><!-- /.modal-content -->\n            </div><!-- /.modal-dialog -->\n        </div><!-- /.modal -->\n        <employee-performance-data></employee-performance-data>\n    </div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  var id = "/home/shoieb/sites/elegant/resources/assets/js/vue/components/no-show-verification.vue"
  module.hot.dispose(function () {
    require("vueify-insert-css").cache["\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, module.exports.template)
  }
})()}
},{"./../../mixed/modals":10,"./../../mixed/notify":11,"vue":5,"vue-hot-reload-api":4,"vueify-insert-css":6}],63:[function(require,module,exports){
"use strict";

exports.__esModule = true;
var modals = require("./../../mixed/modals");
var notify = require("./../../mixed/notify");
exports["default"] = {
  data: function data() {
    return {
      notes: {},
      newNote: ""
    };
  },
  filters: {},
  watch: {
    /**
     * update component value
     * @param val
     */
    employee: function employee(val) {
      this.fetchNotes();
    }
  },
  ready: function ready() {
    window.bus.$on("showNotesModal", function () {
      modals.showStrict("#note-modal");
    });
  },
  events: {},
  methods: {
    /**
     * fetch notes data
     */
    fetchNotes: function fetchNotes() {
      var _this = this;

      this.$http.get("/api/note-by-entry/" + this.entryPoint + "/" + this.employee.id, "", function (response) {
        _this.notes = response;
      }).always(function () {});
    },

    /**
     * store a new note
     */
    storeNote: function storeNote() {
      var _this2 = this;

      this.$http.post("/api/note", {
        entry_point: this.entryPoint,
        note: this.newNote,
        employee_id: this.employee.id
      }, function (response) {
        _this2.newNote = "";
        _this2.fetchNotes();
      }).always(function () {});
    },

    formatDate: function formatDate(date, from, format) {
      if (moment(date).isValid()) {
        return moment(date, from).format(format);
      } else {
        return "";
      }
    }
  },
  props: ["entryPoint", "employee"]
};
module.exports = exports["default"];
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n    <div class=\"row\">\n        <div class=\"modal fade\" id=\"note-modal\">\n            <div class=\"modal-dialog modal-lg\">\n                <div class=\"modal-content\">\n                    <div class=\"modal-header\">\n                        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\">×</button>\n                        <h4 class=\"modal-title\">Notes</h4>\n                    </div>\n                    <div class=\"modal-body\">\n                        <div class=\"table-responsive\">\n                            <table class=\"table table-xxs table-bordered\">\n                                <thead>\n                                <tr>\n                                    <th class=\"bg-black col-md-8\">Note</th>\n                                    <th class=\"bg-black col-md-2\">Date</th>\n                                    <th class=\"bg-black col-md-2\">Added By</th>\n                                </tr>\n                                </thead>\n                                <tbody>\n                                <tr v-for=\"(index,note) in notes\" :key=\"index\">\n                                    <td class=\"col-md-8\">{{ note.note }}</td>\n                                    <td class=\"col-md-2\">{{ formatDate(note.created_at,'YYYY-MM-DD HH:mm:ss','D MMM') }}</td>\n                                    <td class=\"col-md-2\"> {{ note.user.name }}</td>\n                                </tr>\n                                </tbody>\n                            </table>\n                        </div>\n                        <div class=\"col-md-12 no-padding-left no-padding-right pt-10\">\n                                            <div class=\"form-group\">\n                                                <label>New Note:</label>\n                                                <textarea rows=\"5\" cols=\"5\" class=\"form-control\" v-model=\"newNote\"></textarea>\n                                            </div>\n                                        </div>\n                    </div>\n                    <div class=\"modal-footer\">\n                        <button type=\"button\" class=\"btn btn-primary\" v-on:click=\"storeNote\">Create New Note</button>\n                    </div>\n                </div><!-- /.modal-content -->\n            </div><!-- /.modal-dialog -->\n        </div><!-- /.modal -->\n    </div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  var id = "/home/shoieb/sites/elegant/resources/assets/js/vue/components/notes.vue"
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, module.exports.template)
  }
})()}
},{"./../../mixed/modals":10,"./../../mixed/notify":11,"vue":5,"vue-hot-reload-api":4}],64:[function(require,module,exports){
var __vueify_style__ = require("vueify-insert-css").insert("\n.header-bg[_v-4e6b25ba] {\n  background-color: #0097c7;\n  border-color: #0097c7;\n}\n\n.font-30[_v-4e6b25ba] {\n  font-size: 30px;\n}\n\n.font-50[_v-4e6b25ba] {\n  font-size: 50px;\n}\n\n.form-control[_v-4e6b25ba] {\n  height: 46px;\n  background-color: #e9eef1;\n  border-radius: 5px;\n  font-size: 14px;\n  color: #1a1b1b;\n}\n\n.custom-border[_v-4e6b25ba] {\n  border-color: #e9eef1;\n}\n\n.btn-submit[_v-4e6b25ba], .btn-submit[_v-4e6b25ba]:active:hover, .btn-submit[_v-4e6b25ba]:active:focus {\n  background-color: #0097c7;\n  border-color: #0097c7;\n  width: 180px;\n  text-align: center;\n  font-size: 18px;\n  font-weight: 500;\n}\n\n")
"use strict";

exports.__esModule = true;
var modals = require("./../../mixed/modals");
var notify = require("./../../mixed/notify");

exports["default"] = {
  data: function data() {
    return {
      employees: {},
      clients: {},
      activeClient: {},
      order: {
        client_id: '',
        position_code: '',
        no_of_employee: 0,
        in_time: '',
        out_time: '',
        date: '',
        note: ''
      }
    };
  },
  props: ['user'],
  filters: {},
  watch: {
    'order.client_id': function orderClient_id(val) {
      this.activeClient = _.clone(_.find(this.clients, function (o) {
        return o.id == val;
      }));
    }
  },
  ready: function ready() {
    var _this = this;

    $('.timepicker').pickatime({
      clear: ''
    });

    window.bus.$on("showAddOrderModal", function () {
      _this.orderModal();
    });

    setTimeout(function () {
      _this.getClients();
      _this.getEmployees();
    }, 1000);
  },

  events: {},

  methods: {
    orderModal: function orderModal() {
      modals.showStrict("#modal-add-order");
    },

    timeModal: function timeModal() {
      modals.showStrict("#modal-time");
    },

    getClients: function getClients() {
      var _this2 = this;

      this.$http.get('/api/order-data', '', function (response) {
        _this2.clients = response;
      }).always(function () {});
    },

    /**
     * get list of clients
     */
    getEmployees: function getEmployees() {
      var _this3 = this;

      this.$http.get('/api/all-employee-list-data', '', function (response) {
        _this3.employees = response.employees;
      }).always(function () {});
    }

  }
};
module.exports = exports["default"];
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n  <div _v-4e6b25ba=\"\">\n    <div class=\"modal fade\" id=\"modal-add-order\" _v-4e6b25ba=\"\">\n      <div class=\"modal-dialog modal-medium\" _v-4e6b25ba=\"\">\n        <div class=\"modal-content\" _v-4e6b25ba=\"\">\n          <div class=\"modal-header header-bg no-padding-left no-padding-right no-padding-top\" _v-4e6b25ba=\"\">\n            <i class=\"icon-cross mr-5 font-50  pull-right cursor-pointer font-white pt-10\" data-dismiss=\"modal\" aria-hidden=\"true\" _v-4e6b25ba=\"\"></i>\n            <h4 class=\"modal-title text-center p-10 font-weight-500 font-white font-30\" _v-4e6b25ba=\"\">Place New Order</h4>\n          </div>\n          <div class=\"modal-body no-padding-left no-padding-right\" _v-4e6b25ba=\"\">\n            <div class=\"row pl-20 pr-20 ml-5 mr-5\" _v-4e6b25ba=\"\">\n              <div class=\"col-md-12 no-padding-left no-padding-right\" _v-4e6b25ba=\"\">\n                <div class=\"col-md-6 col-sm-6\" _v-4e6b25ba=\"\">\n                  <div class=\"form-group\" _v-4e6b25ba=\"\">\n                    <label class=\"text-primary-400 font-weight-500\" _v-4e6b25ba=\"\">Select Client</label>\n                    <select class=\"form-control \" name=\"\" v-model=\"order.client_id\" _v-4e6b25ba=\"\">\n                      <option value=\"\" _v-4e6b25ba=\"\"></option>\n                      <option v-for=\"client in clients\" value=\"{{ client.id }}\" _v-4e6b25ba=\"\">{{ client.name }}\n                      </option>\n                    </select>\n                  </div>\n                </div>\n                <div class=\"col-md-6 col-sm-6\" _v-4e6b25ba=\"\">\n                  <div class=\"form-group\" _v-4e6b25ba=\"\">\n                    <label class=\"text-primary-400 font-weight-500\" _v-4e6b25ba=\"\">Select Date</label>\n                    <input type=\"text\" name=\"username\" v-model=\"order.date\" class=\"form-control pickadate-post-order text-black\" required=\"required\" _v-4e6b25ba=\"\">\n                  </div>\n                </div>\n              </div>\n\n              <div class=\"col-md-6 col-sm-6\" _v-4e6b25ba=\"\">\n                <div class=\"form-group\" _v-4e6b25ba=\"\">\n                  <label class=\"text-primary-400 font-weight-500\" _v-4e6b25ba=\"\">Select Job</label>\n                  <select class=\"form-control wide\" id=\"position-code\" name=\"position_code\" v-model=\"order.position_code\" _v-4e6b25ba=\"\">\n                    <option value=\"\" _v-4e6b25ba=\"\"></option>\n                    <option v-for=\"position in activeClient.positions\" :value=\"position.position_code\" _v-4e6b25ba=\"\">{{ position.title }}\n                    </option>\n                  </select>\n                </div>\n              </div>\n\n              <div class=\"col-md-6 col-sm-6\" _v-4e6b25ba=\"\">\n                <div class=\"form-group no_of_employee\" _v-4e6b25ba=\"\">\n                  <label class=\"text-primary-400 font-weight-500\" _v-4e6b25ba=\"\">Number Of Staff</label>\n                  <select class=\"form-control \" name=\"position_code\" id=\"no-of-employee\" v-model=\"order.no_of_employee\" _v-4e6b25ba=\"\">\n                    <option value=\"\" _v-4e6b25ba=\"\"></option>\n                    <option v-for=\"(index, number) in 150\" class=\"\" value=\"{{ number }}\" _v-4e6b25ba=\"\">{{ number }}\n                    </option>\n                  </select>\n                </div>\n              </div>\n\n\n              <div class=\"col-md-12 no-padding\" _v-4e6b25ba=\"\">\n                <div class=\"col-md-6 col-sm-6\" _v-4e6b25ba=\"\">\n                  <div class=\"form-group\" _v-4e6b25ba=\"\">\n                    <label class=\"display-block text-primary-400 font-weight-500\" _v-4e6b25ba=\"\">Start Time</label>\n                    <select name=\"in_time\" class=\"form-control\" id=\"\" v-model=\"order.in_time\" _v-4e6b25ba=\"\">\n                      <option value=\"12:00 AM\" _v-4e6b25ba=\"\">12:00 AM</option>\n                      <option value=\"12:30 AM\" _v-4e6b25ba=\"\">12:30 AM</option>\n                      <option value=\"1:00 AM\" _v-4e6b25ba=\"\">1:00 AM</option>\n                      <option value=\"1:30 AM\" _v-4e6b25ba=\"\">1:30 AM</option>\n                      <option value=\"2:00 AM\" _v-4e6b25ba=\"\">2:00 AM</option>\n                      <option value=\"2:30 AM\" _v-4e6b25ba=\"\">2:30 AM</option>\n                      <option value=\"3:00 AM\" _v-4e6b25ba=\"\">3:00 AM</option>\n                      <option value=\"3:30 AM\" _v-4e6b25ba=\"\">3:30 AM</option>\n                      <option value=\"4:00 AM\" _v-4e6b25ba=\"\">4:00 AM</option>\n                      <option value=\"4:30 AM\" _v-4e6b25ba=\"\">4:30 AM</option>\n                      <option value=\"5:00 AM\" _v-4e6b25ba=\"\">5:00 AM</option>\n                      <option value=\"5:30 AM\" _v-4e6b25ba=\"\">5:30 AM</option>\n                      <option value=\"6:30 AM\" _v-4e6b25ba=\"\">6:00 AM</option>\n                      <option value=\"7:00 AM\" _v-4e6b25ba=\"\">6:30 AM</option>\n                      <option value=\"7:30 AM\" _v-4e6b25ba=\"\">7:00 AM</option>\n                      <option value=\"8:00 AM\" _v-4e6b25ba=\"\">7:30 AM</option>\n                      <option value=\"8:30 AM\" _v-4e6b25ba=\"\">8:00 AM</option>\n                      <option value=\"9:00 AM\" _v-4e6b25ba=\"\">8:30 AM</option>\n                      <option value=\"9:30 AM\" _v-4e6b25ba=\"\">9:00 AM</option>\n                      <option value=\"10:00 AM\" _v-4e6b25ba=\"\">9:30 AM</option>\n                      <option value=\"10:30 AM\" _v-4e6b25ba=\"\">10:00 AM</option>\n                      <option value=\"11:00 AM\" _v-4e6b25ba=\"\">10:30 AM</option>\n                      <option value=\"11:30 AM\" _v-4e6b25ba=\"\">11:00 AM</option>\n\n                      <option value=\"12:00 PM\" _v-4e6b25ba=\"\">12:00 PM</option>\n                      <option value=\"12:30 PM\" _v-4e6b25ba=\"\">12:30 PM</option>\n                      <option value=\"1:00 PM\" _v-4e6b25ba=\"\">1:00 PM</option>\n                      <option value=\"1:30 PM\" _v-4e6b25ba=\"\">1:30 PM</option>\n                      <option value=\"2:00 PM\" _v-4e6b25ba=\"\">2:00 PM</option>\n                      <option value=\"2:30 PM\" _v-4e6b25ba=\"\">2:30 PM</option>\n                      <option value=\"3:00 PM\" _v-4e6b25ba=\"\">3:00 PM</option>\n                      <option value=\"3:30 PM\" _v-4e6b25ba=\"\">3:30 PM</option>\n                      <option value=\"4:00 PM\" _v-4e6b25ba=\"\">4:00 PM</option>\n                      <option value=\"4:30 PM\" _v-4e6b25ba=\"\">4:30 PM</option>\n                      <option value=\"5:00 PM\" _v-4e6b25ba=\"\">5:00 PM</option>\n                      <option value=\"5:30 PM\" _v-4e6b25ba=\"\">5:30 PM</option>\n                      <option value=\"6:30 PM\" _v-4e6b25ba=\"\">6:00 PM</option>\n                      <option value=\"7:00 PM\" _v-4e6b25ba=\"\">6:30 PM</option>\n                      <option value=\"7:30 PM\" _v-4e6b25ba=\"\">7:00 PM</option>\n                      <option value=\"8:00 PM\" _v-4e6b25ba=\"\">7:30 PM</option>\n                      <option value=\"8:30 PM\" _v-4e6b25ba=\"\">8:00 PM</option>\n                      <option value=\"9:00 PM\" _v-4e6b25ba=\"\">8:30 PM</option>\n                      <option value=\"9:30 PM\" _v-4e6b25ba=\"\">9:00 PM</option>\n                      <option value=\"10:00 PM\" _v-4e6b25ba=\"\">9:30 PM</option>\n                      <option value=\"10:30 PM\" _v-4e6b25ba=\"\">10:00 PM</option>\n                      <option value=\"11:00 PM\" _v-4e6b25ba=\"\">10:30 PM</option>\n                      <option value=\"11:30 PM\" _v-4e6b25ba=\"\">11:00 PM</option>\n\n                    </select>\n                  </div>\n                </div>\n                <div class=\"col-md-6 col-sm-6\" _v-4e6b25ba=\"\">\n                  <div class=\"form-group\" _v-4e6b25ba=\"\">\n                    <label class=\"display-block text-primary-400 font-weight-500\" _v-4e6b25ba=\"\">End Time</label>\n                    <select name=\"out_time\" class=\"form-control\" id=\"\" v-model=\"order.out_time\" _v-4e6b25ba=\"\">\n                      <option value=\"12:00 AM\" _v-4e6b25ba=\"\">12:00 AM</option>\n                      <option value=\"12:30 AM\" _v-4e6b25ba=\"\">12:30 AM</option>\n                      <option value=\"1:00 AM\" _v-4e6b25ba=\"\">1:00 AM</option>\n                      <option value=\"1:30 AM\" _v-4e6b25ba=\"\">1:30 AM</option>\n                      <option value=\"2:00 AM\" _v-4e6b25ba=\"\">2:00 AM</option>\n                      <option value=\"2:30 AM\" _v-4e6b25ba=\"\">2:30 AM</option>\n                      <option value=\"3:00 AM\" _v-4e6b25ba=\"\">3:00 AM</option>\n                      <option value=\"3:30 AM\" _v-4e6b25ba=\"\">3:30 AM</option>\n                      <option value=\"4:00 AM\" _v-4e6b25ba=\"\">4:00 AM</option>\n                      <option value=\"4:30 AM\" _v-4e6b25ba=\"\">4:30 AM</option>\n                      <option value=\"5:00 AM\" _v-4e6b25ba=\"\">5:00 AM</option>\n                      <option value=\"5:30 AM\" _v-4e6b25ba=\"\">5:30 AM</option>\n                      <option value=\"6:30 AM\" _v-4e6b25ba=\"\">6:00 AM</option>\n                      <option value=\"7:00 AM\" _v-4e6b25ba=\"\">6:30 AM</option>\n                      <option value=\"7:30 AM\" _v-4e6b25ba=\"\">7:00 AM</option>\n                      <option value=\"8:00 AM\" _v-4e6b25ba=\"\">7:30 AM</option>\n                      <option value=\"8:30 AM\" _v-4e6b25ba=\"\">8:00 AM</option>\n                      <option value=\"9:00 AM\" _v-4e6b25ba=\"\">8:30 AM</option>\n                      <option value=\"9:30 AM\" _v-4e6b25ba=\"\">9:00 AM</option>\n                      <option value=\"10:00 AM\" _v-4e6b25ba=\"\">9:30 AM</option>\n                      <option value=\"10:30 AM\" _v-4e6b25ba=\"\">10:00 AM</option>\n                      <option value=\"11:00 AM\" _v-4e6b25ba=\"\">10:30 AM</option>\n                      <option value=\"11:30 AM\" _v-4e6b25ba=\"\">11:00 AM</option>\n\n                      <option value=\"12:00 PM\" _v-4e6b25ba=\"\">12:00 PM</option>\n                      <option value=\"12:30 PM\" _v-4e6b25ba=\"\">12:30 PM</option>\n                      <option value=\"1:00 PM\" _v-4e6b25ba=\"\">1:00 PM</option>\n                      <option value=\"1:30 PM\" _v-4e6b25ba=\"\">1:30 PM</option>\n                      <option value=\"2:00 PM\" _v-4e6b25ba=\"\">2:00 PM</option>\n                      <option value=\"2:30 PM\" _v-4e6b25ba=\"\">2:30 PM</option>\n                      <option value=\"3:00 PM\" _v-4e6b25ba=\"\">3:00 PM</option>\n                      <option value=\"3:30 PM\" _v-4e6b25ba=\"\">3:30 PM</option>\n                      <option value=\"4:00 PM\" _v-4e6b25ba=\"\">4:00 PM</option>\n                      <option value=\"4:30 PM\" _v-4e6b25ba=\"\">4:30 PM</option>\n                      <option value=\"5:00 PM\" _v-4e6b25ba=\"\">5:00 PM</option>\n                      <option value=\"5:30 PM\" _v-4e6b25ba=\"\">5:30 PM</option>\n                      <option value=\"6:30 PM\" _v-4e6b25ba=\"\">6:00 PM</option>\n                      <option value=\"7:00 PM\" _v-4e6b25ba=\"\">6:30 PM</option>\n                      <option value=\"7:30 PM\" _v-4e6b25ba=\"\">7:00 PM</option>\n                      <option value=\"8:00 PM\" _v-4e6b25ba=\"\">7:30 PM</option>\n                      <option value=\"8:30 PM\" _v-4e6b25ba=\"\">8:00 PM</option>\n                      <option value=\"9:00 PM\" _v-4e6b25ba=\"\">8:30 PM</option>\n                      <option value=\"9:30 PM\" _v-4e6b25ba=\"\">9:00 PM</option>\n                      <option value=\"10:00 PM\" _v-4e6b25ba=\"\">9:30 PM</option>\n                      <option value=\"10:30 PM\" _v-4e6b25ba=\"\">10:00 PM</option>\n                      <option value=\"11:00 PM\" _v-4e6b25ba=\"\">10:30 PM</option>\n                      <option value=\"11:30 PM\" _v-4e6b25ba=\"\">11:00 PM</option>\n\n                    </select>\n                  </div>\n                </div>\n              </div>\n\n              <div class=\"col-md-12 col-sm-12\" _v-4e6b25ba=\"\">\n                <div class=\"form-group\" _v-4e6b25ba=\"\">\n                  <label class=\"text-primary-400 font-weight-500\" _v-4e6b25ba=\"\">Note</label>\n                  <textarea rows=\"5\" cols=\"5\" class=\"form-control order\" v-model=\"order.note\" _v-4e6b25ba=\"\"></textarea>\n                </div>\n              </div>\n            </div>\n            <div class=\"col-md-12 col-sm-12 no-padding-left no-padding-right custom-border border-top border-2\" _v-4e6b25ba=\"\"></div>\n            <div class=\"modal-footer  mr-10 mt-15 pb-5\" _v-4e6b25ba=\"\">\n              <button type=\"button\" class=\"btn btn-primary radius-right radius-left btn-submit mt-5\" _v-4e6b25ba=\"\">SUBMIT</button>\n            </div>\n          </div><!-- /.modal-content -->\n        </div><!-- /.modal-dialog -->\n      </div><!-- /.modal -->\n    </div>\n\n  </div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  var id = "/home/shoieb/sites/elegant/resources/assets/js/vue/components/order.vue"
  module.hot.dispose(function () {
    require("vueify-insert-css").cache["\n.header-bg[_v-4e6b25ba] {\n  background-color: #0097c7;\n  border-color: #0097c7;\n}\n\n.font-30[_v-4e6b25ba] {\n  font-size: 30px;\n}\n\n.font-50[_v-4e6b25ba] {\n  font-size: 50px;\n}\n\n.form-control[_v-4e6b25ba] {\n  height: 46px;\n  background-color: #e9eef1;\n  border-radius: 5px;\n  font-size: 14px;\n  color: #1a1b1b;\n}\n\n.custom-border[_v-4e6b25ba] {\n  border-color: #e9eef1;\n}\n\n.btn-submit[_v-4e6b25ba], .btn-submit[_v-4e6b25ba]:active:hover, .btn-submit[_v-4e6b25ba]:active:focus {\n  background-color: #0097c7;\n  border-color: #0097c7;\n  width: 180px;\n  text-align: center;\n  font-size: 18px;\n  font-weight: 500;\n}\n\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, module.exports.template)
  }
})()}
},{"./../../mixed/modals":10,"./../../mixed/notify":11,"vue":5,"vue-hot-reload-api":4,"vueify-insert-css":6}],65:[function(require,module,exports){
var __vueify_style__ = require("vueify-insert-css").insert("\n.re-confirm > div.col-md-12[_v-e0be087e],\n.re-confirm > div.col-md-6[_v-e0be087e],\n.re-confirm > div.col-md-12[_v-e0be087e] {\n  padding: 0 !important;\n}\n\n.bordered-div[_v-e0be087e] {\n  border-left: 1px solid #ddd;\n  border-right: 1px solid #ddd;\n}\n\n.bordered-left[_v-e0be087e] {\n  border-left: 1px solid #ddd;\n}\n\n.bordered-right[_v-e0be087e] {\n  border-right: 1px solid #ddd;\n}\n\n.bordered-bottom[_v-e0be087e] {\n  border-bottom: 1px solid #ddd;\n}\n\n.fixed-header[_v-e0be087e] {\n  position: fixed;\n  top: 48px;\n  right: 0px;\n  z-index: 1000 !important;\n}\n\n.middle-div[_v-e0be087e] {\n  width: 60% !important;\n  right: 20% !important;\n}\n\n.div-20[_v-e0be087e] {\n  width: 20% !important;\n}\n\n.div-60[_v-e0be087e] {\n  width: 60% !important;\n}\n\n.top-155[_v-e0be087e] {\n  top: 155px;\n}\n\n.list-div[_v-e0be087e] {\n  margin-bottom: 40px;\n  min-height: 900px !important;\n}\n\n.bottom-div[_v-e0be087e] {\n  position: fixed;\n  bottom: 0px;\n  right: 0px;\n  z-index: 1000 !important;\n  height: 40px !important;\n  width: 100%;\n}\n\n.mb-40[_v-e0be087e] {\n  margin-bottom: 40px !important;\n}\n\n.border-custom-grey[_v-e0be087e] {\n  border-color: #ddd !important;\n}\n")
"use strict";

exports.__esModule = true;
var modals = require("./../../mixed/modals");
var notify = require("./../../mixed/notify");

exports["default"] = {
  data: function data() {
    return {
      dates: [],
      tab: 'due',
      startDate: '',
      endDate: '',
      state: false,
      employees: {},
      collectedEmployees: {},
      clients: {},
      order: {
        client_id: "",
        position_code: ""
      },
      week: '',
      date: '',
      activeClient: {},
      allClients: {},
      allEmployees: {},
      newOrder: {},
      selectedClient: {}
    };
  },

  props: ['tablet', 'desktop'],

  computed: {

    updatedEmployees: function updatedEmployees() {
      return _.filter(this.employees, function (o) {
        return o.worked || o.no_show;
      });
    },

    updatedCollectedEmployees: function updatedCollectedEmployees() {
      return _.filter(this.collectedEmployees, function (o) {
        return o.checked;
      });
    },

    employeeGroups: function employeeGroups() {
      return _.groupBy(this.employees, "department_id");
    },

    collectedEmployeeGroups: function collectedEmployeeGroups() {
      return _.groupBy(this.collectedEmployees, "department_id");
    }
  },
  filters: {},
  watch: {
    "date": function date(val) {
      this.getReConfirmedEmployees(val);
    },

    clients: function clients() {
      $("#position-client").selectric("refresh");
    },

    activeClient: function activeClient() {
      //   $("#position-code").selectric("refresh");
    },
    "order.position_code": function orderPosition_code(val) {
      this.getReConfirmedEmployees(val);
    },
    'selectedClient': function selectedClient() {
      $('#position-code').selectric('refresh');
    },

    'newOrder.client_id': function newOrderClient_id(val) {
      this.selectedClient = _.clone(_.find(this.clients, function (o) {
        return o.id == val;
      }));
    }
  },
  ready: function ready() {
    //$(".table").fixedHeader();
    this.getClientList();
    this.getEmployees();
  },
  events: {},
  methods: {

    /**
     * update list based on user entry
     */
    addToWorked: function addToWorked() {
      this.$http.post("/api/add-to-worked", this.newOrder, function (response) {
        modals.hide("#add-to-worked-modal");
      }).always(function () {
        //notify.loading(false);
      });
    },

    showWorkedModal: function showWorkedModal() {
      var client = arguments.length <= 0 || arguments[0] === undefined ? null : arguments[0];
      var date = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1];

      this.newOrder = {};
      if (client) {
        this.newOrder.client_id = client;
      }

      if (date) {
        this.newOrder.date = date;
        // var picker = $('.pickadate-post-order').pickadate('picker');
        // picker.set('select', date, {format: 'mm-dd-yyyy'})
      }
      modals.showStrict("#add-to-worked-modal");
    },

    /**
     * get list of clients
     */
    getEmployees: function getEmployees() {
      var _this = this;

      this.$http.get('/api/employee-list-data', '', function (response) {
        _this.allEmployees = response;
      }).always(function () {});
    },

    countCollections: function countCollections(departmentId, date) {
      var due = 0;
      _.forEach(this.employees, function (employeeGroup) {
        due += _.size(_.filter(employeeGroup, {
          'department_id': departmentId, 'date': date, 'worked': 0, 'no_show': 0
        }));
      });

      var collected = 0;

      _.forEach(this.collectedEmployees, function (employeeGroup) {
        collected += _.size(_.filter(employeeGroup, function (o) {
          return o.department_id === departmentId && o.date === date && (o.worked || o.no_show);
        }));
      });

      return collected + ' / ' + (collected + due);
    },

    setTab: function setTab(val) {
      this.tab = val;
    },

    groupByDate: function groupByDate(data) {
      return _.groupBy(data, "date");
    },

    groupByCustom: function groupByCustom(data, column) {
      return _.groupBy(data, column);
    },

    getClientList: function getClientList() {
      var _this2 = this;

      this.$http.get("/api/order-data", "", function (response) {
        _this2.clients = response;
        _this2.getReConfirmedEmployees("");
      }).always(function () {});
    },
    /**
     * get employee report data
     */
    getReConfirmedEmployees: function getReConfirmedEmployees(clientId) {
      var _this3 = this;

      notify.loading(true);
      this.$http.get("/api/re-confirmed-employees?date=" + this.date, function (response) {
        _this3.employees = response.due;
        _this3.collectedEmployees = response.collected;
        _this3.startDate = response.startDate;
        _this3.endDate = response.endDate;
        _this3.date = response.date;
      }).always(function () {
        notify.loading(false);
      });
    },

    /**
     * update list based on user entry
     */
    updateList: function updateList() {
      var _this4 = this;

      notify.loading(true);
      if (this.tab === 'due') {
        var selectedEmployees = _.groupBy(this.updatedEmployees, "order_created_at");

        this.$http.post("/api/re-confirmed-employees", this.employees, function (response) {
          notify.loading(false);
          _this4.getReConfirmedEmployees(_this4.order.client_id);
        }).always(function () {
          //notify.loading(false);
        });
      } else {
          var selectedEmployees = _.groupBy(this.updatedCollectedEmployees, "order_created_at");

          this.$http.post("/api/re-confirmed-employees-undo", this.collectedEmployees, function (response) {
            notify.loading(false);
            _this4.getReConfirmedEmployees(_this4.order.client_id);
          }).always(function () {
            //notify.loading(false);
          });
        }
    }
  }
};
module.exports = exports["default"];
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n  <div class=\"row re-confirm no-margin\" _v-e0be087e=\"\">\n    <div class=\"col-md-12 col-xs-12 no-padding-left no-padding-right\" _v-e0be087e=\"\">\n      <div :class=\"{'middle-div' : desktop == '1'}\" class=\"col-md-12 no-padding-left no-padding-right fixed-header \" _v-e0be087e=\"\">\n        <table class=\"table table-xxs\" _v-e0be087e=\"\">\n          <thead class=\"header\" _v-e0be087e=\"\">\n          <tr _v-e0be087e=\"\">\n            <th class=\"bg-white\" colspan=\"4\" _v-e0be087e=\"\">\n              <span class=\"text-uppercase text-color-black text-center font-20\" _v-e0be087e=\"\">Timesheet Collection Log</span>\n            </th>\n          </tr>\n          <tr _v-e0be087e=\"\">\n            <th class=\"mt-20 mb-10 bg-white no-padding-left\" _v-e0be087e=\"\">\n              <div class=\"form-group mt-20 mb-10 \" _v-e0be087e=\"\">\n                <input id=\"start_date\" v-model=\"date\" class=\"form-control pickadate-year-sunday text-black\" type=\"text\" _v-e0be087e=\"\">\n              </div>\n            </th>\n            <th class=\"mt-20 mb-10 bg-white\" colspan=\"2\" _v-e0be087e=\"\">\n              <h1 class=\"text-uppercase text-black text-danger text-center\" _v-e0be087e=\"\">\n                {{ startDate }} - {{ endDate }}\n              </h1>\n            </th>\n            <th class=\"mt-20 mb-10 bg-white no-padding-right\" _v-e0be087e=\"\">\n              <button :class=\"{'btn-primary':tab === 'due', 'btn-danger':tab === 'collected'}\" class=\"btn  pull-right text-black\" @click=\"updateList\" _v-e0be087e=\"\">\n\n                {{ tab === 'due' ? 'SAVE' : 'UNDO' }}\n              </button>\n            </th>\n          </tr>\n          <tr _v-e0be087e=\"\">\n            <th class=\"col-md-4 bg-slate-800 text-black text-uppercase text-center\" _v-e0be087e=\"\"></th>\n            <th class=\"col-md-4 bg-slate-800 text-black text-uppercase text-center\" _v-e0be087e=\"\"></th>\n            <th class=\"col-md-2 bg-slate-800 text-black text-center no-padding-left no-padding-right text-black\" _v-e0be087e=\"\">{{ tab === 'due' ? 'WORKED' : 'STATUS' }}\n            </th>\n            <th class=\"col-md-2 bg-slate-800 text-black text-uppercase text-center no-padding-left no-padding-right text-black\" _v-e0be087e=\"\">{{ tab === 'due' ? 'NO SHOW' : '' }}\n            </th>\n          </tr>\n          </thead>\n          <tbody _v-e0be087e=\"\"></tbody>\n        </table>\n      </div>\n\n      <div v-if=\" desktop == '1'\" class=\"col-md-3 div-20\" _v-e0be087e=\"\"></div>\n\n      <div v-show=\"tab === 'due'\" :class=\"{'col-md-7 div-60' : desktop == '1', 'col-md-12 ' : tablet =='1',}\" class=\"bordered-div  no-padding-left no-padding-right top-155 list-div \" _v-e0be087e=\"\">\n        <div v-for=\"(index,employeeByClient) in employees\" :key=\"index\" class=\"col-md-12 bordered-div no-padding-left no-padding-right\" _v-e0be087e=\"\">\n          <div v-for=\"(index,groupedEmployees) in groupByCustom(employeeByClient,'department_name')\" :key=\"index\" class=\"col-md-12 bordered-div no-padding-left no-padding-right\" _v-e0be087e=\"\">\n            <div class=\"col-md-12\" _v-e0be087e=\"\">\n          <span class=\"\" _v-e0be087e=\"\">\n               <span class=\"text-danger text-black font-12\" _v-e0be087e=\"\">{{ groupedEmployees[0].client_name }}</span> <br _v-e0be087e=\"\">\n              <span class=\"text-primary text-black text-italic font-12\" _v-e0be087e=\"\">{{ groupedEmployees[0].department_name }}</span>\n            </span>\n            </div>\n            <div v-for=\"(index,employee) in groupByDate(groupedEmployees)\" :key=\"index\" class=\"col-md-12 no-padding-left no-padding-right bg-white\" _v-e0be087e=\"\">\n              <div class=\"col-md-12 text-left text-color-black  no-padding-left no-padding-right mt-5 mb-10\" _v-e0be087e=\"\">\n            <span class=\"pl-10 cursor-pointer\" @click=\"showWorkedModal(employee[0].client_id,employee[0].picker_date)\" _v-e0be087e=\"\">\n               <span class=\"text-black font-12 pr-5\" _v-e0be087e=\"\">{{ employee[0].day }} {{ employee[0].custom_date }}</span> <span class=\"font-12\" _v-e0be087e=\"\">({{ countCollections(employee[0].department_id, employee[0].date) }})</span> <br _v-e0be087e=\"\">\n            </span>\n              </div>\n              <div v-for=\"(ind,emp) in employee\" :key=\"ind\" class=\"col-md-12 no-padding border-top border-custom-grey\" _v-e0be087e=\"\">\n                <div class=\"col-md-4 text-center table-padding text-italic\" _v-e0be087e=\"\">{{ emp.title }}\n                </div>\n\n                <div class=\"col-md-4  text-left table-padding\" _v-e0be087e=\"\">{{ emp.name }}\n                </div>\n\n                <div class=\"col-md-2 text-center no-padding-left no-padding-right table-padding\" _v-e0be087e=\"\">\n                  <input v-if=\"!emp.no_show\" v-model=\"emp.worked\" :value=\"emp.worked\" type=\"checkbox\" _v-e0be087e=\"\">\n                </div>\n                <div class=\"col-md-2 text-center table-padding\" _v-e0be087e=\"\">\n                  <input v-if=\"!emp.worked\" v-model=\"emp.no_show\" :value=\"emp.no_show\" type=\"checkbox\" _v-e0be087e=\"\">\n                </div>\n              </div>\n              <div class=\"col-md-12 border-bottom border-custom-grey mb-40\" _v-e0be087e=\"\"></div>\n            </div>\n          </div>\n        </div>\n      </div>\n\n\n      <div v-show=\"tab === 'collected'\" :class=\"{'div-60' : desktop == '1',}\" class=\"col-md-12 bordered-div no-padding-left no-padding-right top-155 list-div\" _v-e0be087e=\"\">\n        <div class=\"col-md-12 col-sm-12 col-xs-12 text-right\" _v-e0be087e=\"\">\n          <a :href=\"'/api/export-collected-employees?date='+date\" _v-e0be087e=\"\">\n            <button class=\"btn btn-primary\" _v-e0be087e=\"\">EXPORT</button>\n          </a>\n        </div>\n        <div v-for=\"(index,collectedEmployeesByClient) in collectedEmployees\" :key=\"index\" class=\"col-md-12 bordered-div no-padding-left no-padding-right\" _v-e0be087e=\"\">\n          <div v-for=\"(index,groupedEmployees) in groupByCustom(collectedEmployeesByClient,'department_name')\" :key=\"index\" class=\"col-md-12 bordered-div no-padding-left no-padding-right\" _v-e0be087e=\"\">\n            <div class=\"col-md-12\" _v-e0be087e=\"\">\n          <span class=\"\" _v-e0be087e=\"\">\n               <span class=\"text-black text-danger font-112\" _v-e0be087e=\"\">{{ groupedEmployees[0].client_name }}</span> <br _v-e0be087e=\"\">\n              <span class=\"text-primary text-black text-italic font-12\" _v-e0be087e=\"\">{{ groupedEmployees[0].department_name }}</span>\n            </span>\n            </div>\n            <div v-for=\"(index,employee) in groupByDate(groupedEmployees)\" :key=\"index\" class=\"col-md-12 no-padding-left no-padding-right bg-white\" _v-e0be087e=\"\">\n              <div class=\"col-md-12 text-left text-color-black  no-padding-left no-padding-right mt-5 mb-10\" _v-e0be087e=\"\">\n            <span class=\"pl-10 cursor-pointer\" @click=\"showWorkedModal(employee[0].client_id,employee[0].picker_date)\" _v-e0be087e=\"\">\n               <span class=\" font-12 text-black pr-5\" _v-e0be087e=\"\">{{ employee[0].day }} {{ employee[0].custom_date }}</span> <span class=\"font-12\" _v-e0be087e=\"\">({{ countCollections(employee[0].department_id, employee[0].date) }})</span> <br _v-e0be087e=\"\">\n            </span>\n              </div>\n              <div v-for=\"(ind,emp) in employee\" :key=\"ind\" class=\"col-md-12 no-padding border-top border-custom-grey\" _v-e0be087e=\"\">\n                <div class=\"col-md-4 text-center table-padding text-italic\" _v-e0be087e=\"\">{{ emp.title }}\n                </div>\n\n                <div class=\"col-md-4  text-left table-padding\" _v-e0be087e=\"\">{{ emp.name }}\n                </div>\n\n                <div class=\"col-md-2 text-center no-padding-left no-padding-right table-padding\" _v-e0be087e=\"\">\n                  <span v-if=\"emp.worked\" class=\"text-green text-italic\" _v-e0be087e=\"\">Worked</span>\n                  <span v-if=\"emp.no_show\" class=\"text-danger text-italic\" _v-e0be087e=\"\">No Show</span>\n                </div>\n                <div class=\"col-md-2 text-center table-padding\" _v-e0be087e=\"\">\n                  <input v-model=\"emp.checked\" type=\"checkbox\" _v-e0be087e=\"\">\n                </div>\n              </div>\n              <div class=\"col-md-12 border-bottom border-custom-grey mb-40\" _v-e0be087e=\"\"></div>\n            </div>\n          </div>\n        </div>\n      </div>\n      <!--      <button class=\"btn btn-primary pull-right mt-20\" @click=\"updateList\">-->\n      <!--        Save-->\n      <!--        <i class=\"icon-arrow-right14 position-right\"></i>-->\n      <!--      </button>-->\n    </div>\n    <div :class=\"{'middle-div' : desktop == '1'}\" class=\" no-padding-left no-padding-right bg-slate-400 bottom-div pt-2 \" _v-e0be087e=\"\">\n      <span :class=\"{'bg-slate-800' : tab === 'due'}\" class=\"font-20 pl-10 pr-10 p-5 pb-15 mt-5 cursor-pointer\" @click=\"setTab('due')\" _v-e0be087e=\"\">Due</span>\n      <span :class=\"{'bg-slate-800' : tab === 'collected'}\" class=\"font-20 pl-10 pr-10 p-5 pb-15 mt-5 cursor-pointer\" @click=\"setTab('collected')\" _v-e0be087e=\"\">Collected</span>\n\n      <span class=\"font-20 pl-10 pr-10 p-5 pb-15 cursor-pointer bg-slate-800 pull-right\" @click=\"showWorkedModal()\" _v-e0be087e=\"\">ADD</span>\n    </div>\n\n\n    <div id=\"add-to-worked-modal\" aria-hidden=\"true\" aria-labelledby=\"exampleModalLabel\" class=\"modal fade\" role=\"dialog\" _v-e0be087e=\"\">\n      <div class=\"modal-dialog modal-lg\" role=\"document\" _v-e0be087e=\"\">\n        <div class=\"modal-content modal-grey\" _v-e0be087e=\"\">\n          <div class=\"modal-header no-padding bg-slate-700\" _v-e0be087e=\"\">\n            <div class=\"col-md-12 col-sm-12 col-xs-12 p-5 text-black text-center font-14\" _v-e0be087e=\"\">\n              Add To Worked\n            </div>\n            <button aria-label=\"Close\" class=\"close\" data-dismiss=\"modal\" type=\"button\" _v-e0be087e=\"\">\n              <span aria-hidden=\"true\" _v-e0be087e=\"\">×</span>\n            </button>\n          </div>\n          <div class=\"modal-body no-padding-left no-padding-right text-black\" _v-e0be087e=\"\">\n\n            <div class=\"col-md-12 no-padding\" _v-e0be087e=\"\">\n              <div class=\"col-md-6\" _v-e0be087e=\"\">\n                <div class=\"form-group\" _v-e0be087e=\"\">\n                  <select v-model=\"newOrder.client_id\" v-select2=\"newOrder.client_id\" class=\"form-control\" name=\"newOrder.client_id\" _v-e0be087e=\"\">\n                    <option value=\"\" _v-e0be087e=\"\">Search Client</option>\n                    <option v-for=\"client in clients\" value=\"{{ client.id }}\" _v-e0be087e=\"\">{{ client.name }}\n                    </option>\n                  </select>\n                </div>\n              </div>\n              <div class=\"col-md-6\" _v-e0be087e=\"\">\n                <div class=\"form-group\" _v-e0be087e=\"\">\n                  <input v-model=\"newOrder.date\" class=\"form-control pickadate-post-order text-black\" name=\"date\" placeholder=\"Select Date\" required=\"required\" type=\"text\" _v-e0be087e=\"\">\n                </div>\n              </div>\n            </div>\n\n\n            <div class=\"col-md-12 no-padding\" _v-e0be087e=\"\">\n              <div class=\"col-md-6\" _v-e0be087e=\"\">\n                <div class=\"form-group\" _v-e0be087e=\"\">\n                  <select v-model=\"newOrder.employee_id\" v-select2=\"newOrder.employee_id\" class=\"form-control\" name=\"newOrder.employee_id\" _v-e0be087e=\"\">\n                    <option value=\"\" _v-e0be087e=\"\">Search Employee</option>\n                    <option v-for=\"employee in allEmployees\" value=\"{{ employee.id }}\" _v-e0be087e=\"\">{{ employee.fullName }}\n                    </option>\n                  </select>\n                </div>\n              </div>\n              <div class=\"col-md-6\" _v-e0be087e=\"\">\n                <div class=\"form-group\" _v-e0be087e=\"\">\n                  <select id=\"position-code\" v-model=\"newOrder.position_code\" v-vue-selectric=\"newOrder.position_code\" class=\"form-control wide\" name=\"position_code\" _v-e0be087e=\"\">\n                    <option value=\"\" _v-e0be087e=\"\">Select Job</option>\n                    <option v-for=\"position in selectedClient.positions\" :value=\"position.position_code\" _v-e0be087e=\"\">{{ position.title }}\n                    </option>\n                  </select>\n                </div>\n              </div>\n            </div>\n\n\n            <div class=\"col-md-12 col-sm-12 col-xs-12\" _v-e0be087e=\"\">\n              <div class=\"col-md-2 col-sm-2 col-xs-2 text-black font-16 text-center no-padding-right pt-20 pb-20\" _v-e0be087e=\"\">\n\n              </div>\n              <div class=\"col-md-10 col-sm-10 col-xs-10 p-40 no-padding-right text-right\" _v-e0be087e=\"\">\n                <button class=\"btn btn-primary text-black p-5 no-padding-left border-white pl-10 pr-10\" @click=\"addToWorked\" _v-e0be087e=\"\">Save\n                </button>\n              </div>\n            </div>\n          </div>\n          <div class=\"modal-footer\" _v-e0be087e=\"\">\n          </div>\n        </div>\n      </div>\n    </div>\n\n\n  </div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  var id = "/home/shoieb/sites/elegant/resources/assets/js/vue/components/re-confirmed-employees.vue"
  module.hot.dispose(function () {
    require("vueify-insert-css").cache["\n.re-confirm > div.col-md-12[_v-e0be087e],\n.re-confirm > div.col-md-6[_v-e0be087e],\n.re-confirm > div.col-md-12[_v-e0be087e] {\n  padding: 0 !important;\n}\n\n.bordered-div[_v-e0be087e] {\n  border-left: 1px solid #ddd;\n  border-right: 1px solid #ddd;\n}\n\n.bordered-left[_v-e0be087e] {\n  border-left: 1px solid #ddd;\n}\n\n.bordered-right[_v-e0be087e] {\n  border-right: 1px solid #ddd;\n}\n\n.bordered-bottom[_v-e0be087e] {\n  border-bottom: 1px solid #ddd;\n}\n\n.fixed-header[_v-e0be087e] {\n  position: fixed;\n  top: 48px;\n  right: 0px;\n  z-index: 1000 !important;\n}\n\n.middle-div[_v-e0be087e] {\n  width: 60% !important;\n  right: 20% !important;\n}\n\n.div-20[_v-e0be087e] {\n  width: 20% !important;\n}\n\n.div-60[_v-e0be087e] {\n  width: 60% !important;\n}\n\n.top-155[_v-e0be087e] {\n  top: 155px;\n}\n\n.list-div[_v-e0be087e] {\n  margin-bottom: 40px;\n  min-height: 900px !important;\n}\n\n.bottom-div[_v-e0be087e] {\n  position: fixed;\n  bottom: 0px;\n  right: 0px;\n  z-index: 1000 !important;\n  height: 40px !important;\n  width: 100%;\n}\n\n.mb-40[_v-e0be087e] {\n  margin-bottom: 40px !important;\n}\n\n.border-custom-grey[_v-e0be087e] {\n  border-color: #ddd !important;\n}\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, module.exports.template)
  }
})()}
},{"./../../mixed/modals":10,"./../../mixed/notify":11,"vue":5,"vue-hot-reload-api":4,"vueify-insert-css":6}],66:[function(require,module,exports){
"use strict";

exports.__esModule = true;
var modals = require("./../../mixed/modals");
var notify = require("./../../mixed/notify");
exports["default"] = {
    data: function data() {
        return {
            invoices: {},
            printData: {},
            cssPath: window.cssPath
        };
    },
    filters: {},
    watch: {},
    ready: function ready() {
        this.fetchRecentInvoices();
    },
    events: {
        refreshData: function refreshData() {}
    },
    methods: {
        /**
         * fetch invoice data
         */
        fetchRecentInvoices: function fetchRecentInvoices() {
            var _this = this;

            this.$http.get("/api/recent-invoices", "", function (response) {
                _this.invoices = response;
            }).always(function () {});
        },

        /**
         * calculate total amount
         */
        totalAmount: function totalAmount() {
            var amount = 0;
            this.invoices.map(function (invoice) {
                amount += invoice.amount;
            });

            return amount;
        },

        /**
         * send request to get data to prepare print sheet
         * @param invoiceCode
         */
        printInvoice: function printInvoice(invoiceCode) {
            var _this2 = this;

            this.$http.get("/api/print-invoice/" + invoiceCode, "", function (response) {
                _this2.printData = response;
            }).always(function () {});
            modals.showStrict("#print-invoice-modal");
        },

        printContent: function printContent() {
            // let content = $('#print-content').clone();
            var mywindow = window.open('', 'PRINT INVOICE', 'height=700,width=1200');

            mywindow.document.write('<html><head><title>' + document.title + '</title>');
            mywindow.document.write('<link rel="stylesheet" href="/print-layout.css" type="text/css" />');
            mywindow.document.write('<link rel="stylesheet" href="/regular.css" type="text/css" />');
            mywindow.document.write('</head><body >');
            mywindow.document.write(document.getElementById("print-content").innerHTML);
            mywindow.document.write('</body></html>');
            mywindow.print();
            mywindow.close();

            return true;
        }
    },
    props: ["bg"]
};
module.exports = exports["default"];
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n    <div class=\"row\">\n        <h4 class=\"bg-green-800 text-black text-color-black text-center no-margin-top no-margin-bottom text-uppercase\">RECENT</h4>\n        <div class=\"col-md-12 no-padding table-body\">\n            <div class=\"col-md-12 no-padding\">\n                <table class=\"table table-xxs table-bordered\">\n                    <thead>\n                    <tr>\n                        <th class=\"bg-green-700 text-black text-color-black text-center\">EDIT</th>\n                        <th class=\"bg-black-center text-black text-center\">#INVOICE</th>\n                        <th class=\"bg-black-center text-black text-center\">DATE</th>\n                        <th class=\"bg-black-center text-black text-center\">CODE</th>\n                        <th class=\"bg-black-center text-black text-center\">CLIENT NAME</th>\n                        <th class=\"bg-black-center text-black text-center\">DEPARTMENT</th>\n                        <th class=\"bg-black-center text-black text-center\">CONTACT</th>\n                        <th class=\"bg-black-center text-black text-center\">GROUP</th>\n                        <th class=\"bg-black-center text-black text-center\">#PO</th>\n                        <th class=\"bg-black-center text-black text-center\">AMOUNT</th>\n                        <th class=\"bg-danger text-black text-center\">PRINT</th>\n                        <th class=\"bg-indigo text-black text-center\">COMPLETE</th>\n                    </tr>\n                    </thead>\n                    <tbody>\n                    <tr v-for=\"(index,invoice) in invoices\" :key=\"index\">\n                        <td class=\" text-center text-black text-green-300 text-italic\">edit</td>\n                        <td class=\" text-center\">{{ invoice.invoice_code}}</td>\n                        <td class=\" text-center\">{{ invoice.created_at | customDateFormat 'YYYY-MM-DD h:m:s' 'D/M/YYYY'}}</td>\n                        <td class=\" text-center\">{{ invoice.company_code}}</td>\n                        <td class=\" text-center\">{{ invoice.client_name }}</td>\n                        <td class=\" text-center\">{{ invoice.department_name }}</td>\n                        <td class=\" text-center\">{{ invoice.first_name + ' ' + invoice.last_name}}</td>\n                        <td class=\" text-center\">{{ invoice.client_group }}</td>\n                        <td class=\" text-center\">{{ invoice.zip }}</td>\n                        <td class=\" text-center\">{{ invoice.amount }}</td>\n                        <td class=\" text-center text-danger text-black text-italic cursor-pointer\"><a target=\"_blank\" :href=\"'/api/print-invoice/'+invoice.invoice_code\">Print</a></td>\n                        <td class=\" text-center text-primary  text-black text-italic cursor-pointer\">Complete</td>\n                    </tr>\n                    <tr>\n                        <td colspan=\"9\" class=\"text-right bg-green-300 no-border\"></td>\n                        <td class=\"text-center bg-green-300 no-border text-black text-color-black\"> {{ totalAmount() }}</td>\n                        <td colspan=\"2\" class=\"text-right bg-green-300 no-border\"></td>\n                    </tr>\n                    </tbody>\n                </table>\n            </div>\n        </div>\n\n        <div class=\"modal fade\" id=\"print-invoice-modal\">\n            <div class=\"modal-dialog modal-lg\">\n                <div class=\"modal-content\">\n                    <div class=\"modal-header\">\n                        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\">×</button>\n                        <!--<h4 class=\"modal-title\">Modal title</h4>-->\n                    </div>\n                    <div class=\"modal-body\" id=\"print-content\">\n                        <div class=\"row\">\n                            <div class=\"col-md-9\">\n                                <img src=\"/images/logo_white.png\" width=\"500\" height=\"70\" alt=\"\">\n                            </div>\n                            <div class=\"col-md-3 \">\n                                <div class=\"col-md-12 bg-slate-800 text-black text-center calibri-14-bold\">INVOICE</div>\n                                <div class=\"col-md-12 bg-slate-300 text-black text-center calibri-14-bold\">NET 30</div>\n                            </div>\n                        </div>\n\n                        <div class=\"row\">\n                            <div class=\"col-xs-12\">\n                                <div class=\"col-xs-2 bg-slate-300 text-right text-black text-color-black\">Bill To:</div>\n                                <div class=\"col-xs-5 text-left  text-black text-color-black\"> {{ printData.invoice.client_name}}</div>\n                                <div class=\"col-xs-2 bg-slate-300 text-right  text-black text-color-black\">Contact:</div>\n                                <div class=\"col-xs-3 text-left  text-black text-color-black\"> {{ printData.invoice.contact_name}}</div>\n                            </div>\n                            <div class=\"col-xs-12\">\n                                <div class=\"col-xs-2 bg-slate-300 text-right text-black text-color-black\">Address:</div>\n                                <div class=\"col-xs-5 text-left  text-black text-color-black\"> {{ printData.invoice.address_line_1}}</div>\n                                <div class=\"col-xs-2 bg-slate-300 text-right  text-black text-color-black\">Phone:</div>\n                                <div class=\"col-xs-3 text-left  text-black text-color-black\"> {{ printData.invoice.contact_phone}}</div>\n                            </div>\n                            <div class=\"col-xs-12 min-height-20\">\n                                <div class=\"col-xs-2  text-right text-black text-color-black\"></div>\n                                <div class=\"col-xs-5 text-left  text-black text-color-black\">{{ printData.invoice.address_line_2}}</div>\n                                <div class=\"col-xs-2  text-right  text-black text-color-black\"></div>\n                                <div class=\"col-xs-3 text-left  text-black text-color-black\"></div>\n                            </div>\n                            <div class=\"col-xs-12 \">\n                                <div class=\"col-xs-2 bg-slate-300 text-right text-black text-color-black\">Department:</div>\n                                <div class=\"col-xs-5 text-left  text-black text-color-black\"> {{ printData.invoice.department_name}}</div>\n                                <div class=\"col-xs-2 bg-slate-300 text-right  text-black text-color-black\">PO#:</div>\n                                <div class=\"col-xs-3 text-left  text-black text-color-black\"> {{ printData.invoice.client_zip}}</div>\n                            </div>\n                            <div class=\"col-xs-12 min-height-20\"></div>\n                            <div class=\"col-xs-12\">\n                                <div class=\"col-xs-2 bg-slate-300 text-right text-black text-color-black\">Invoice No:</div>\n                                <div class=\"col-xs-5 text-left  text-black text-color-black\"> {{ printData.invoice.invoice_code}}</div>\n                                <div class=\"col-xs-2 bg-slate-300 text-right  text-black text-color-black\">Contact:</div>\n                                <div class=\"col-xs-3 text-left  text-black text-color-black\"> {{ printData.system.contact}}</div>\n                            </div>\n                            <div class=\"col-xs-12\">\n                                <div class=\"col-xs-2 bg-slate-300 text-right text-black text-color-black\">Invoice Date:</div>\n                                <div class=\"col-xs-5 text-left  text-black text-color-black\"> {{ printData.invoice.created_at | customDateFormat 'YYYY-MM-DD h:m:s' 'M/D/YYYY'}}</div>\n                                <div class=\"col-xs-2 bg-slate-300 text-right  text-black text-color-black\">Tel:</div>\n                                <div class=\"col-xs-3 text-left  text-black text-color-black\"> {{ printData.system.telephone}}</div>\n                            </div>\n                            <div class=\"col-xs-12\">\n                                <div class=\"col-xs-2 bg-slate-300 text-right text-black text-color-black\">Payable To:</div>\n                                <div class=\"col-xs-5 text-left  text-black text-color-black\"> {{ printData.system.payable_to}}</div>\n                                <div class=\"col-xs-2 bg-slate-300 text-right  text-black text-color-black\">Fax:</div>\n                                <div class=\"col-xs-3 text-left  text-black text-color-black\"> {{ printData.system.fax}}</div>\n                            </div>\n                            <div class=\"col-xs-12\">\n                                <div class=\"col-xs-2 text-right text-black text-color-black\"></div>\n                                <div class=\"col-xs-5 text-left  text-black text-color-black\"> {{ printData.system.payable_to_address}}</div>\n                                <div class=\"col-xs-2 text-right  text-black text-color-black\"></div>\n                                <div class=\"col-xs-3 text-left  text-black text-color-black\"></div>\n                            </div>\n                            <div class=\"col-xs-12\">\n                                <div class=\"col-xs-6\"></div>\n                                <div class=\"col-xs-6\">\n                                    <div class=\"col-xs-12\">\n                                        <div class=\"col-xs-6 bg-slate-300 text-right text-color-black calibri-12-bold\">INVOICE TOTAL:</div>\n                                        <div class=\"col-xs-6 calibri-12-bold\">\n                                            <div class=\"col-xs-6 text-left\">$</div>\n                                            <div class=\"col-xs-6 text-right\">{{ printData.amount }}</div>\n                                        </div>\n                                    </div>\n                                    <div class=\"col-xs-12\">\n                                        <div class=\"col-xs-6 bg-slate-300 text-right text-color-black calibri-12-bold\">AMOUNT DUE:</div>\n                                        <div class=\"col-xs-6 text-right calibri-12-bold\">\n                                            <div class=\"col-xs-6 text-left\">$</div>\n                                            <div class=\"col-xs-6 text-right\">{{ printData.amount }}</div>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                            <div class=\"col-xs-12 no-padding table-body overflow-visible\">\n                                <div class=\"col-xs-12 no-padding overflow-visible\">\n                                    <table class=\"table table-xxs overflow-visible\">\n                                        <thead>\n                                        <tr class=\"no-border\">\n                                            <th class=\"bg-slate text-black text-center\">JOB</th>\n                                            <th class=\"bg-slate text-black text-center\">EMPLOYEE NAME</th>\n                                            <th class=\"bg-slate text-black text-center\">DATE</th>\n                                            <th class=\"bg-slate text-black text-center\">HOURS</th>\n                                            <th class=\"bg-slate text-black text-center\">RATE</th>\n                                            <th class=\"bg-slate text-black text-right\">AMOUNT</th>\n                                        </tr>\n                                        </thead>\n                                        <tbody v-for=\"(index,weekEmployees) in printData.employees\" :key=\"index\" class=\"no-border\">\n                                        <tr v-for=\"(index,employee) in weekEmployees\" :key=\"index\" class=\"no-border\">\n                                            <td class=\" text-center no-border\">{{ employee.position_title }}</td>\n                                            <td class=\" text-center no-border\">{{ employee.employee_name }}</td>\n                                            <td class=\" text-center no-border\">{{ employee.date | customDateFormat 'YYYY-MM-DD' 'D-MMM'}}</td>\n                                            <td class=\" text-center no-border\">{{ employee.duration/60 }}</td>\n                                            <td class=\" text-center no-border\">{{ employee.rate }}</td>\n                                            <td class=\" text-right no-border\">\n                                                <div class=\"col-xs-6\">$</div>\n                                                <div class=\"col-xs-6\">{{ employee.amount }}</div>\n                                            </td>\n                                        </tr>\n                                        <tr class=\"no-border\">\n                                            <td colspan=\"6\" class=\" no-border col-xs-12 min-height-20\"></td>\n                                        </tr>\n                                        </tbody>\n                                    </table>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"modal-footer\">\n                        <!--<button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button>-->\n                        <button type=\"button\" @click=\"printContent\" class=\"btn btn-primary\">Print</button>\n                    </div>\n                </div><!-- /.modal-content -->\n            </div><!-- /.modal-dialog -->\n        </div><!-- /.modal -->\n    </div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  var id = "/home/shoieb/sites/elegant/resources/assets/js/vue/components/recent-invoices.vue"
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, module.exports.template)
  }
})()}
},{"./../../mixed/modals":10,"./../../mixed/notify":11,"vue":5,"vue-hot-reload-api":4}],67:[function(require,module,exports){
var __vueify_style__ = require("vueify-insert-css").insert("\n.close-modal[_v-0b66708e] {\n  font-size: 30px;\n  margin-top: -14.75px;\n  font-weight: 500;\n}\n\n.close-modal-29[_v-0b66708e] {\n  font-size: 30px;\n  margin-top: -29.75px !important;\n  font-weight: 500;\n}\n\n.close-modal-0[_v-0b66708e] {\n  font-size: 35px;\n  margin-top: 0 !important;\n  font-weight: 500;\n  z-index: 100;\n  color: #656565 !important;\n}\n\n.font-20[_v-0b66708e] {\n  font-size: 20px;\n}\n\n.bg-slate-custom[_v-0b66708e] {\n  background-color: #d6dce5;\n  border-color: #d6dce5;\n}\n\n.custom-header[_v-0b66708e] {\n  position: -webkit-sticky;\n  position: sticky;\n  top: 48px;\n  z-index: 100;\n}\n\n.top-65[_v-0b66708e] {\n  top: 65px;\n}\n")
"use strict";

exports.__esModule = true;
var modals = require("./../../mixed/modals");
var notify = require("./../../mixed/notify");

exports["default"] = {
  data: function data() {
    return {
      employees: {},
      activeEmployee: {},
      jobs: {},
      clients: {},
      type: 0,
      availableJobs: {},
      selectedJObs: {},
      ids: [],
      all: false,
      primary_phone: ''
    };
  },
  props: ['user'],
  filters: {},
  watch: {
    'all': function all(val, oldVal) {
      this.getEmployees(val ? 1 : 0);
    }
  },
  ready: function ready() {
    this.getEmployees();
  },

  events: {},

  methods: {

    getEmployees: function getEmployees() {
      var _this = this;

      var all = arguments.length <= 0 || arguments[0] === undefined ? 0 : arguments[0];

      notify.loading(true);
      this.$http.post("/api/recruiter-verification-board-data?all=" + all, {
        type: this.type
      }, function (response) {
        _this.employees = response;
        notify.loading(false);
      }).always(function () {});
    },

    verifyEmployees: function verifyEmployees() {
      var _this2 = this;

      if (this.ids.length) {
        notify.loading(true);
        this.$http.post("/api/recruiter-verify-employee", {
          ids: this.ids
        }, function (response) {
          notify.success(_this2.ids.length + ' employee verified.');
          _this2.ids = [];
          _this2.getEmployees(0);
        }).always(function () {});
      } else {
        notify.info('Select employees to verify.');
      }
    },

    sortBy: function sortBy(field, reverse, primer) {
      var key = primer ? function (x) {
        return primer(x[field]);
      } : function (x) {
        return x[field];
      };

      reverse = !reverse ? 1 : -1;

      return function (a, b) {
        return a = key(a), b = key(b), reverse * ((a > b) - (b > a));
      };
    },

    sortUsers: function sortUsers(field, reverse) {
      var primer = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];

      console.log(field);
      this.sortOrders = reverse;
      this.sortKey = field;
      this.employees.sort(this.sortBy(field, reverse, primer));
    }
  }
};
module.exports = exports["default"];
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n  <div class=\"row\" _v-0b66708e=\"\">\n    <div class=\"col-md-12 col-sm-12 no-padding-left no-padding-right\" _v-0b66708e=\"\">\n      <div class=\"col-md-12 col-sm-12  no-padding-left no-padding-right\" _v-0b66708e=\"\">\n        <table class=\"table table-xxs\" _v-0b66708e=\"\">\n          <thead class=\"header custom-header\" _v-0b66708e=\"\">\n          <tr class=\"bg-slate-700\" _v-0b66708e=\"\">\n            <th class=\"text-center text-black p-5 font-20 pl-10\" colspan=\"5\" _v-0b66708e=\"\">RECRUITMENT VERIFICATION\n            </th>\n          </tr>\n          <tr _v-0b66708e=\"\">\n            <th class=\"bg-slate-700 text-left text-black text-uppercase \" _v-0b66708e=\"\">\n              Recruiter\n            </th>\n            <th class=\"bg-slate-700 text-left text-black cursor-pointer text-uppercase\" @click=\"sortUsers('name',!sortOrders)\" _v-0b66708e=\"\">\n              Hired Employee\n              <i v-if=\"sortKey === 'name'\" :class=\"sortOrders ? 'fa fa-arrow-down':'fa fa-arrow-up'\" _v-0b66708e=\"\"></i>\n            </th>\n            <th class=\"bg-slate-700 text-center text-black  text-center cursor-pointer text-uppercase\" @click=\"sortUsers('custom_hire_date',!sortOrders)\" _v-0b66708e=\"\">\n              Hire Date\n              <i v-if=\"sortKey === 'custom_hire_date'\" :class=\"sortOrders ? 'fa fa-arrow-down':'fa fa-arrow-up'\" _v-0b66708e=\"\"></i>\n            </th>\n            <th class=\"bg-slate-700 text-black text-center text-uppercase\" _v-0b66708e=\"\">Shift Worked</th>\n            <th class=\"bg-slate-700 text-black text-center text-uppercase\" _v-0b66708e=\"\">Completed</th>\n          </tr>\n          </thead>\n          <tbody _v-0b66708e=\"\">\n          <tr v-for=\"(index,employee) in employees\" :key=\"index\" _v-0b66708e=\"\">\n            <td class=\"text-left cursor-pointer\" _v-0b66708e=\"\">{{ employee.recruiter.name }}</td>\n            <td class=\"text-left cursor-pointer\" _v-0b66708e=\"\">{{ employee.name }}</td>\n            <td class=\"text-center\" _v-0b66708e=\"\">{{ employee.custom_hire_date }}</td>\n            <td class=\"text-center\" _v-0b66708e=\"\">{{ employee.worked_one_year_count }}</td>\n            <td class=\"text-center cursor-pointer\" _v-0b66708e=\"\">\n              <input id=\"\" v-model=\"ids\" :value=\"employee.id\" class=\"\" name=\"employees\" type=\"checkbox\" _v-0b66708e=\"\">\n            </td>\n          </tr>\n          <tr _v-0b66708e=\"\">\n            <td class=\"text-right\" colspan=\"5\" _v-0b66708e=\"\">\n              <button class=\"btn btn-primary border-2 border-white text-black\" @click=\"verifyEmployees()\" _v-0b66708e=\"\">SUBMIT\n              </button>\n            </td>\n          </tr>\n          </tbody>\n        </table>\n      </div>\n    </div>\n\n\n  </div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  var id = "/home/shoieb/sites/elegant/resources/assets/js/vue/components/recruiment-verification-board.vue"
  module.hot.dispose(function () {
    require("vueify-insert-css").cache["\n.close-modal[_v-0b66708e] {\n  font-size: 30px;\n  margin-top: -14.75px;\n  font-weight: 500;\n}\n\n.close-modal-29[_v-0b66708e] {\n  font-size: 30px;\n  margin-top: -29.75px !important;\n  font-weight: 500;\n}\n\n.close-modal-0[_v-0b66708e] {\n  font-size: 35px;\n  margin-top: 0 !important;\n  font-weight: 500;\n  z-index: 100;\n  color: #656565 !important;\n}\n\n.font-20[_v-0b66708e] {\n  font-size: 20px;\n}\n\n.bg-slate-custom[_v-0b66708e] {\n  background-color: #d6dce5;\n  border-color: #d6dce5;\n}\n\n.custom-header[_v-0b66708e] {\n  position: -webkit-sticky;\n  position: sticky;\n  top: 48px;\n  z-index: 100;\n}\n\n.top-65[_v-0b66708e] {\n  top: 65px;\n}\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, module.exports.template)
  }
})()}
},{"./../../mixed/modals":10,"./../../mixed/notify":11,"vue":5,"vue-hot-reload-api":4,"vueify-insert-css":6}],68:[function(require,module,exports){
var __vueify_style__ = require("vueify-insert-css").insert("\n.close-modal[_v-3646dd70] {\n  font-size: 30px;\n  margin-top: -14.75px;\n  font-weight: 500;\n}\n\n.close-modal-29[_v-3646dd70] {\n  font-size: 30px;\n  margin-top: -29.75px !important;\n  font-weight: 500;\n}\n\n.close-modal-0[_v-3646dd70] {\n  font-size: 35px;\n  margin-top: 0 !important;\n  font-weight: 500;\n  z-index: 100;\n  color: #656565 !important;\n}\n\n.font-20[_v-3646dd70] {\n  font-size: 20px;\n}\n\n.bg-slate-custom[_v-3646dd70] {\n  background-color: #d6dce5;\n  border-color: #d6dce5;\n}\n\n.custom-header[_v-3646dd70] {\n  position: -webkit-sticky;\n  position: sticky;\n  top: 48px;\n  z-index: 100;\n}\n\n.top-65[_v-3646dd70] {\n  top: 65px;\n}\n\n.border-color-custom[_v-3646dd70] {\n  border-color: #ddd;\n}\n\n.border-3[_v-3646dd70] {\n  border-width: 3px;\n}\n")
"use strict";

exports.__esModule = true;
var modals = require("./../../mixed/modals");
var notify = require("./../../mixed/notify");

exports["default"] = {
  data: function data() {
    return {
      employees: {},
      activeEmployee: {},
      jobs: {},
      clients: {},
      type: 0,
      availableJobs: {},
      selectedJObs: {},
      orders: [],
      all: false,
      primary_phone: ""
    };
  },
  props: ["user"],
  filters: {},
  watch: {
    all: function all(val, oldVal) {
      this.getEmployees(val ? 1 : 0);
    }
  },
  ready: function ready() {
    this.getEmployees();
  },
  events: {},
  methods: {
    getEmployees: function getEmployees() {
      var _this = this;

      var all = arguments.length <= 0 || arguments[0] === undefined ? 0 : arguments[0];

      notify.loading(true);
      this.$http.post("/api/recruiter-board-data?all=" + all, {
        type: this.type
      }, function (response) {
        _this.employees = response;
        notify.loading(false);
      }).always(function () {});
    },

    listJobs: function listJobs(employee) {
      var _this2 = this;

      this.activeEmployee = _.cloneDeep(employee);
      notify.loading(true);
      this.$http.post("/api/available-jobs/" + this.activeEmployee.id, {}, function (response) {
        _this2.jobs = _.groupBy(response, "title");
        modals.showStrict("#job-list-modal");
        notify.loading(false);
      }).always(function () {});
    },

    listClients: function listClients(employee) {
      var _this3 = this;

      this.activeEmployee = _.cloneDeep(employee);
      notify.loading(true);
      this.$http.post("/api/available-jobs/" + this.activeEmployee.id, {}, function (response) {
        _this3.clients = _.groupBy(response, "name");
        modals.showStrict("#client-list-modal");
        notify.loading(false);
      }).always(function () {});
    },

    listAvailableJobs: function listAvailableJobs(employee) {
      var _this4 = this;

      this.activeEmployee = _.cloneDeep(employee);
      notify.loading(true);
      this.$http.get("/api/employee-job-search/" + this.activeEmployee.id + "?group=0", {}, function (response) {
        _this4.orders = [];
        _this4.availableJobs = response;
        modals.showStrict("#available-jobs-list-modal");
        notify.loading(false);
      }).always(function () {});
    },

    listSelectedJobs: function listSelectedJobs(employee) {
      var _this5 = this;

      this.activeEmployee = _.cloneDeep(employee);
      notify.loading(true);
      this.$http.get("/api/employee-selected-jobs/" + this.activeEmployee.id, {}, function (response) {
        _this5.selectedJObs = response;
        modals.showStrict("#selected-jobs-list-modal");
        notify.loading(false);
      }).always(function () {});
    },

    addEmployeeToOrders: function addEmployeeToOrders() {
      var _this6 = this;

      notify.loading(true);
      this.$http.post("/api/add-employee-to-orders/", {
        employees: [this.activeEmployee],
        orders: this.orders
      }, function (response) {
        _this6.getEmployees();
        modals.hide("#available-jobs-list-modal");
        notify.loading(false);
        notify.info(_this6.activeEmployee.name + " added to " + _this6.orders.length + " orders.");
      }).always(function () {});
    },

    editPhoneModal: function editPhoneModal(employee) {
      this.activeEmployee = _.cloneDeep(employee);
      this.primary_phone = "";
      modals.showStrict("#edit-phone");
    },

    editPhone: function editPhone() {
      var _this7 = this;

      notify.loading(true);
      this.$http.post("/api/update-primary-phone/" + this.activeEmployee.id, {
        primary_phone: this.primary_phone
      }, function (response) {
        _this7.getEmployees();
        modals.hide("#edit-phone");
      }).always(function () {});
    },

    editEmployeeModal: function editEmployeeModal(employee) {
      this.activeEmployee = _.cloneDeep(employee);
      modals.showStrict("#edit-employee-info");
    },

    editEmployee: function editEmployee() {},

    sendInvitation: function sendInvitation() {
      if (this.activeEmployee.user_id) {
        notify.loading(true);
        this.$http.get("/api/send-employee-invitation/" + this.activeEmployee.user_id, function (response) {
          //modals.hide("#modal-edit-employee-info");
        }).always(function () {
          notify.loading(false);
        });
      } else {
        notify.info("Set email address before sending invitation.");
      }
    },

    sortBy: function sortBy(field, reverse, primer) {
      var key = primer ? function (x) {
        return primer(x[field]);
      } : function (x) {
        return x[field];
      };

      reverse = !reverse ? 1 : -1;

      return function (a, b) {
        return a = key(a), b = key(b), reverse * ((a > b) - (b > a));
      };
    },
    sortUsers: function sortUsers(field, reverse) {
      var primer = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];

      console.log(field);
      this.sortOrders = reverse;
      this.sortKey = field;
      this.employees.sort(this.sortBy(field, reverse, primer));
    }
  }
};
module.exports = exports["default"];
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n  <div class=\"row\" _v-3646dd70=\"\">\n    <div class=\"col-md-12 col-sm-12 no-padding-left no-padding-right\" _v-3646dd70=\"\">\n      <div class=\"col-md-12 col-sm-12 no-padding-left no-padding-right\" _v-3646dd70=\"\">\n        <table class=\"table table-xxs\" _v-3646dd70=\"\">\n          <thead class=\"header custom-header\" _v-3646dd70=\"\">\n            <tr class=\"bg-slate-700\" _v-3646dd70=\"\">\n              <th class=\"text-left text-black p-5 font-20 pl-10\" colspan=\"7\" _v-3646dd70=\"\">\n                Recruiter's Board\n                <!--              <span class=\"pl-20\"><input-->\n                <!--                id=\"all\"-->\n                <!--                v-model=\"all\"-->\n                <!--                name=\"all\"-->\n                <!--                type=\"checkbox\"-->\n                <!--                value=\"1\"></span>-->\n              </th>\n              <th class=\"text-right text-black p-5 font-20 pr-10\" colspan=\"7\" _v-3646dd70=\"\">\n                {{ user }}\n              </th>\n            </tr>\n            <tr _v-3646dd70=\"\">\n              <th class=\"bg-slate-700 text-left text-black cursor-pointer\" @click=\"sortUsers('name', !sortOrders)\" _v-3646dd70=\"\">\n                Name\n                <i v-if=\"sortKey === 'name'\" :class=\"sortOrders ? 'fa fa-arrow-down' : 'fa fa-arrow-up'\" _v-3646dd70=\"\"></i>\n              </th>\n              <th class=\"\n                  bg-slate-700\n                  text-center text-black text-center\n                  cursor-pointer\n                \" @click=\"sortUsers('primary_phone', !sortOrders)\" _v-3646dd70=\"\">\n                Phone\n                <i v-if=\"sortKey === 'primary_phone'\" :class=\"sortOrders ? 'fa fa-arrow-down' : 'fa fa-arrow-up'\" _v-3646dd70=\"\"></i>\n              </th>\n              <th class=\"\n                  bg-slate-700\n                  text-center text-black text-center\n                  cursor-pointer\n                \" @click=\"sortUsers('custom_hire_date', !sortOrders)\" _v-3646dd70=\"\">\n                Hire Date\n                <i v-if=\"sortKey === 'custom_hire_date'\" :class=\"sortOrders ? 'fa fa-arrow-down' : 'fa fa-arrow-up'\" _v-3646dd70=\"\"></i>\n              </th>\n\n              <th class=\"\n                  bg-slate-700\n                  text-black text-center\n                  cursor-pointer cursor-pointer\n                \" @click=\"sortUsers('gar', !sortOrders)\" _v-3646dd70=\"\">\n                G.A.R\n                <i v-if=\"sortKey === 'gar'\" :class=\"sortOrders ? 'fa fa-arrow-down' : 'fa fa-arrow-up'\" _v-3646dd70=\"\"></i>\n              </th>\n              <th class=\"bg-slate-700 text-center text-black text-center\" _v-3646dd70=\"\">\n                Job List\n              </th>\n              <th class=\"bg-slate-700 text-center text-black text-center\" _v-3646dd70=\"\">\n                Client List\n              </th>\n              <th class=\"bg-slate-700 text-black text-center cursor-pointer\" @click=\"sortUsers('app_access', !sortOrders)\" _v-3646dd70=\"\">\n                App Access\n                <i v-if=\"sortKey === 'app_access'\" :class=\"sortOrders ? 'fa fa-arrow-down' : 'fa fa-arrow-up'\" _v-3646dd70=\"\"></i>\n              </th>\n              <th class=\"bg-black-center text-black text-center\" _v-3646dd70=\"\">\n                Job Offered\n              </th>\n              <th class=\"bg-black-center text-black text-center\" _v-3646dd70=\"\">\n                Job Accepted\n              </th>\n              <th class=\"bg-primary text-black text-center\" _v-3646dd70=\"\">Worked</th>\n              <th class=\"bg-danger text-black text-center\" _v-3646dd70=\"\">No Show</th>\n              <th class=\"bg-slate-700 text-black text-center cursor-pointer\" @click=\"sortUsers('last_login', !sortOrders)\" _v-3646dd70=\"\">\n                Last Login\n                <i v-if=\"sortKey === 'last_login'\" :class=\"sortOrders ? 'fa fa-arrow-down' : 'fa fa-arrow-up'\" _v-3646dd70=\"\"></i>\n              </th>\n              <th class=\"bg-black-center text-black text-center\" _v-3646dd70=\"\">\n                Open Offers\n              </th>\n              <th class=\"bg-black-center text-black text-center\" _v-3646dd70=\"\">Offer More</th>\n            </tr>\n          </thead>\n          <tbody _v-3646dd70=\"\">\n            <tr v-for=\"(index, employee) in employees\" :key=\"index\" _v-3646dd70=\"\">\n              <td class=\"\n                  text-left\n                  cursor-pointer\n                  border-right border-color-custom\n                \" @click=\"editEmployeeModal(employee)\" _v-3646dd70=\"\">\n                {{ employee.name }}\n              </td>\n              <td class=\"\n                  text-center\n                  cursor-pointer\n                  border-right border-color-custom\n                \" @click=\"editPhoneModal(employee)\" _v-3646dd70=\"\">\n                {{ employee.primary_phone }}\n              </td>\n              <td class=\"text-center border-right border-color-custom\" _v-3646dd70=\"\">\n                {{ employee.custom_hire_date }}\n              </td>\n              <td class=\"text-center border-right border-color-custom\" _v-3646dd70=\"\">\n                {{ employee.gar }}\n              </td>\n              <td class=\"\n                  text-center\n                  cursor-pointer\n                  border-right border-color-custom\n                \" _v-3646dd70=\"\">\n                <span @click=\"listJobs(employee)\" _v-3646dd70=\"\"><i class=\"\n                      fa fa-briefcase\n                      font-16\n                      border-right border-color-custom\n                    \" _v-3646dd70=\"\"></i></span>\n              </td>\n              <td class=\"\n                  text-center\n                  cursor-pointer\n                  border-right border-color-custom\n                \" _v-3646dd70=\"\">\n                <span @click=\"listClients(employee)\" _v-3646dd70=\"\"><i class=\"fa fa-users font-16\" _v-3646dd70=\"\"></i></span>\n              </td>\n              <td class=\"text-center border-right border-color-custom\" _v-3646dd70=\"\">\n                <span class=\"{{ employee.app_access === 1 ? 'text-success' : 'text-danger' }}\" _v-3646dd70=\"\">{{ employee.app_access === 1 ? \"Yes\" : \"No\" }}</span>\n              </td>\n              <td class=\"text-center border-right border-color-custom\" _v-3646dd70=\"\">\n                {{\n                  employee.jo_ninety_count &gt; 0 ? employee.jo_ninety_count : \"\"\n                }}\n              </td>\n              <td class=\"text-center border-right border-color-custom\" _v-3646dd70=\"\">\n                {{\n                  employee.confirmed_one_year_count\n                    ? employee.confirmed_one_year_count\n                    : \"\"\n                }}\n              </td>\n              <td class=\"text-center border-right border-color-custom {{employee.worked_one_year_count >= 5 ?'bg-primary text-black':''}}\" _v-3646dd70=\"\">\n                {{\n                  employee.worked_one_year_count &gt; 0\n                    ? employee.worked_one_year_count\n                    : \"\"\n                }}\n              </td>\n              <td class=\"text-center border-right border-color-custom {{employee.no_show_one_year_count > 0 ?'bg-danger text-black':''}}\" _v-3646dd70=\"\">\n                {{\n                  employee.no_show_one_year_count &gt; 0\n                    ? employee.no_show_one_year_count\n                    : \"\"\n                }}\n              </td>\n              <td class=\"text-center border-right border-color-custom\" _v-3646dd70=\"\">\n                {{ employee.last_login }}\n              </td>\n              <td class=\"\n                  text-center\n                  cursor-pointer\n                  border-right border-color-custom\n                \" @click=\"listSelectedJobs(employee)\" _v-3646dd70=\"\">\n                {{ employee.oo_count }}\n              </td>\n              <td class=\"text-center cursor-pointer\" @click=\"listAvailableJobs(employee)\" _v-3646dd70=\"\">\n                Offer More\n              </td>\n            </tr>\n          </tbody>\n        </table>\n      </div>\n    </div>\n\n    <div id=\"job-list-modal\" aria-hidden=\"true\" aria-labelledby=\"exampleModalLabel\" class=\"modal fade\" role=\"dialog\" tabindex=\"-1\" _v-3646dd70=\"\">\n      <div class=\"modal-dialog modal-sm\" role=\"document\" _v-3646dd70=\"\">\n        <div class=\"modal-content modal-grey\" _v-3646dd70=\"\">\n          <div class=\"modal-header no-padding bg-slate-700\" _v-3646dd70=\"\">\n            <div class=\"\n                col-md-12 col-sm-12 col-xs-12\n                p-5\n                text-black text-center\n                font-16\n                bg-slate-700\n              \" _v-3646dd70=\"\">\n              JOB LIST\n            </div>\n            <div class=\"\n                col-md-12 col-sm-12 col-xs-12\n                p-5\n                text-black\n                bg-slate-400\n                text-color-black text-center\n                font-16\n              \" _v-3646dd70=\"\">\n              {{ activeEmployee.name }}\n            </div>\n            <button aria-label=\"Close\" class=\"close close-modal-29\" data-dismiss=\"modal\" type=\"button\" _v-3646dd70=\"\">\n              <span aria-hidden=\"true\" _v-3646dd70=\"\">×</span>\n            </button>\n          </div>\n          <div class=\"modal-body no-padding-left no-padding-right bg-slate-200\" _v-3646dd70=\"\">\n            <div v-for=\"(index, job) in jobs\" :key=\"index\" class=\"\n                col-md-12\n                p-5\n                font-16\n                text-center text-color-black\n                bg-slate-200\n              \" _v-3646dd70=\"\">\n              <div class=\"\n                  col-md-6 col-sm-6\n                  text-left\n                  bg-slate-200\n                  text-color-black\n                \" _v-3646dd70=\"\">\n                {{ index }}\n              </div>\n              <div class=\"\n                  col-md-6 col-sm-6\n                  text-right\n                  bg-slate-200\n                  text-color-black\n                \" _v-3646dd70=\"\">\n                {{ job.length }}\n              </div>\n            </div>\n          </div>\n          <div class=\"modal-footer no-padding-bottom\" _v-3646dd70=\"\">\n            <!--            <button class=\"btn btn-secondary\" data-dismiss=\"modal\" type=\"button\">Close</button>-->\n            <!--            <button class=\"btn btn-primary\" type=\"button\">Save changes</button>-->\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div id=\"client-list-modal\" aria-hidden=\"true\" aria-labelledby=\"exampleModalLabel\" class=\"modal fade\" role=\"dialog\" tabindex=\"-1\" _v-3646dd70=\"\">\n      <div class=\"modal-dialog modal-full\" role=\"document\" _v-3646dd70=\"\">\n        <div class=\"modal-content modal-grey\" _v-3646dd70=\"\">\n          <div class=\"\n              modal-header\n              no-padding\n              bg-slate-700\n              border-bottom border-2 border-white\n            \" _v-3646dd70=\"\">\n            <div class=\"\n                col-md-12 col-sm-12 col-xs-12\n                no-padding-left no-padding-right\n              \" _v-3646dd70=\"\">\n              <div class=\"\n                  col-md-3 col-sm-3 col-xs-3\n                  p-5\n                  text-black\n                  bg-slate-400\n                  text-color-black text-center\n                  font-16\n                  border-right border-2 border-white\n                \" _v-3646dd70=\"\">\n                Client List\n              </div>\n              <div class=\"\n                  col-md-9 col-sm-9 col-xs-9\n                  p-5\n                  text-black\n                  bg-slate-400\n                  text-color-black text-center\n                  font-16\n                \" _v-3646dd70=\"\">\n                {{ activeEmployee.name }}\n              </div>\n              <button aria-label=\"Close\" class=\"close close-modal\" data-dismiss=\"modal\" type=\"button\" _v-3646dd70=\"\">\n                <span aria-hidden=\"true\" _v-3646dd70=\"\">×</span>\n              </button>\n            </div>\n          </div>\n          <div class=\"\n              modal-body\n              no-padding-left no-padding-top no-padding-right\n              bg-slate-200\n            \" _v-3646dd70=\"\">\n            <div class=\"\n                col-md-12 col-sm-12 col-xs-12\n                no-padding-left no-padding-right\n              \" _v-3646dd70=\"\">\n              <div class=\"\n                  col-md-1 col-sm-1 col-xs-1\n                  p-5\n                  text-black\n                  bg-slate-400\n                  text-left\n                  font-16\n                  border-bottom border-right border-2 border-white\n                \" _v-3646dd70=\"\">\n                Zone\n              </div>\n              <div class=\"\n                  col-md-2 col-sm-2 col-xs-2\n                  p-5\n                  text-black\n                  bg-slate-400\n                  text-left\n                  font-16\n                  border-bottom border-right border-2 border-white\n                \" _v-3646dd70=\"\">\n                Client\n              </div>\n              <div class=\"\n                  col-md-9 col-sm-9 col-xs-9\n                  p-5\n                  text-black\n                  bg-slate-400\n                  text-center\n                  font-16\n                  border-bottom border-right border-2 border-white\n                \" _v-3646dd70=\"\">\n                Position\n              </div>\n            </div>\n            <div v-for=\"(index, client) in clients\" :key=\"index\" class=\"\n                col-md-12\n                no-padding-left no-padding-right\n                font-16\n                text-left text-color-black\n                bg-slate-200\n                border-bottom border-white\n              \" _v-3646dd70=\"\">\n              <div class=\"\n                  col-md-1 col-sm-1\n                  p-10\n                  text-left\n                  col-xs-1\n                  text-left\n                  bg-slate-200\n                  text-color-black\n                  border-right border-white\n                  font-12\n                \" _v-3646dd70=\"\">\n                {{ client[0].zone }}\n              </div>\n              <div class=\"\n                  col-md-2 col-sm-2 col-xs-2\n                  p-10\n                  text-left text-left\n                  bg-slate-200\n                  text-color-black\n                  border-right border-white\n                  font-12\n                \" _v-3646dd70=\"\">\n                {{ index }}\n              </div>\n              <div v-for=\"(index, jobs) in client\" class=\"\n                  col-md-1 col-sm-1 col-xs-1\n                  p-10\n                  text-left\n                  bg-slate-200\n                  text-color-black\n                  border-right border-white\n                  font-12\n                \" _v-3646dd70=\"\">\n                {{ jobs.title }}\n              </div>\n            </div>\n          </div>\n          <div class=\"modal-footer no-padding-bottom\" _v-3646dd70=\"\">\n            <!--            <button class=\"btn btn-secondary\" data-dismiss=\"modal\" type=\"button\">Close</button>-->\n            <!--            <button class=\"btn btn-primary\" type=\"button\">Save changes</button>-->\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div id=\"available-jobs-list-modal\" aria-hidden=\"true\" aria-labelledby=\"exampleModalLabel\" class=\"modal fade\" role=\"dialog\" tabindex=\"-1\" _v-3646dd70=\"\">\n      <div class=\"modal-dialog modal-full\" role=\"document\" _v-3646dd70=\"\">\n        <div class=\"modal-content modal-grey\" _v-3646dd70=\"\">\n          <div class=\"\n              modal-header\n              no-padding\n              bg-slate-700\n              border-bottom border-2 border-white\n            \" _v-3646dd70=\"\">\n            <div class=\"\n                col-md-12 col-sm-12 col-xs-12\n                no-padding-left no-padding-right\n              \" _v-3646dd70=\"\">\n              <div class=\"\n                  col-md-8 col-sm-8 col-xs-8\n                  p-5\n                  text-black\n                  bg-green-800\n                  text-left\n                  pl-20\n                  font-16\n                \" _v-3646dd70=\"\">\n                OFFER ADDITIONAL JOBS\n              </div>\n\n              <div class=\"\n                  col-md-4 col-sm-4 col-xs-4\n                  p-5\n                  text-black\n                  bg-green-800\n                  text-center\n                  font-16\n                \" _v-3646dd70=\"\">\n                {{ activeEmployee.name }}\n              </div>\n              <button aria-label=\"Close\" class=\"close close-modal\" data-dismiss=\"modal\" type=\"button\" _v-3646dd70=\"\">\n                <span aria-hidden=\"true\" _v-3646dd70=\"\">×</span>\n              </button>\n            </div>\n          </div>\n          <div class=\"\n              modal-body\n              no-padding-left no-padding-top no-padding-right\n              bg-slate-200\n            \" _v-3646dd70=\"\">\n            <div v-for=\"(index, job) in availableJobs\" v-if=\"job.no_of_employee !== 'Full'\" :key=\"index\" class=\"col-md-12 col-sm-12 no-padding-left no-padding-right font-16 text-left text-color-black bg-slate-200 border-bottom border-2 {{ index !== availableJobs.length-1 &amp;&amp; availableJobs[index].date !== availableJobs[index+1].date ? 'border-3 border-slate-600':'border-white'}}\n\" _v-3646dd70=\"\">\n              <div class=\"\n                  col-md-2 col-sm-2\n                  p-10\n                  text-left\n                  col-xs-2\n                  text-left\n                  bg-slate-200\n                  text-color-black\n                  border-white\n                  font-12\n                \" _v-3646dd70=\"\">\n                {{ job.day }}\n              </div>\n              <div class=\"\n                  col-md-2 col-sm-2 col-xs-2\n                  p-10\n                  text-left text-left\n                  bg-slate-200\n                  text-color-black\n                  border-white\n                  font-12\n                \" _v-3646dd70=\"\">\n                {{ job.date }}\n              </div>\n              <div class=\"\n                  col-md-2 col-sm-2 col-xs-2\n                  p-10\n                  text-left text-left\n                  bg-slate-200\n                  text-color-black\n                  border-white\n                  font-12\n                \" _v-3646dd70=\"\">\n                {{ job.time }}\n              </div>\n              <div class=\"\n                  col-md-2 col-sm-2 col-xs-2\n                  p-10\n                  text-left text-left\n                  bg-slate-200\n                  text-color-black\n                  border-white\n                  font-12\n                \" _v-3646dd70=\"\">\n                {{ job.name }}\n              </div>\n              <div class=\"\n                  col-md-2 col-sm-2 col-xs-2\n                  p-10\n                  text-left text-left\n                  bg-slate-200\n                  text-color-black\n                  border-right border-white\n                  font-12\n                \" _v-3646dd70=\"\">\n                {{ job.title }}\n              </div>\n              <div class=\"\n                  col-md-2 col-sm-2 col-xs-2\n                  p-10\n                  text-center text-left\n                  bg-slate-200\n                  text-color-black\n                  border-right border-white\n                  font-12\n                \" _v-3646dd70=\"\">\n                <input id=\"\" v-model=\"orders\" :value=\"job\" name=\"jobs\" type=\"checkbox\" _v-3646dd70=\"\">\n              </div>\n            </div>\n\n            <div class=\"\n                col-md-12 col-sm-12\n                no-padding-left no-padding-right\n                font-16\n                text-right\n                pr-20\n                text-color-black\n                bg-slate-200\n                pt-20\n                pb-20\n              \" _v-3646dd70=\"\">\n              <button class=\"btn btn-primary border-2 border-white text-black\" @click=\"addEmployeeToOrders()\" _v-3646dd70=\"\">\n                SUBMIT\n              </button>\n            </div>\n          </div>\n          <div class=\"modal-footer no-padding-bottom\" _v-3646dd70=\"\">\n            <!--            <button class=\"btn btn-secondary\" data-dismiss=\"modal\" type=\"button\">Close</button>-->\n            <!--            <button class=\"btn btn-primary\" type=\"button\">Save changes</button>-->\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div id=\"selected-jobs-list-modal\" aria-hidden=\"true\" aria-labelledby=\"exampleModalLabel\" class=\"modal fade\" role=\"dialog\" tabindex=\"-1\" _v-3646dd70=\"\">\n      <div class=\"modal-dialog modal-full\" role=\"document\" _v-3646dd70=\"\">\n        <div class=\"modal-content modal-grey\" _v-3646dd70=\"\">\n          <div class=\"\n              modal-header\n              no-padding\n              bg-slate-700\n              border-bottom border-2 border-white\n            \" _v-3646dd70=\"\">\n            <div class=\"\n                col-md-12 col-sm-12 col-xs-12\n                no-padding-left no-padding-right\n              \" _v-3646dd70=\"\">\n              <div class=\"\n                  col-md-8 col-sm-8 col-xs-8\n                  p-5\n                  text-black\n                  bg-slate-800\n                  text-left\n                  pl-20\n                  font-16\n                \" _v-3646dd70=\"\">\n                OPEN JOB OFFERS\n              </div>\n\n              <div class=\"\n                  col-md-4 col-sm-4 col-xs-4\n                  p-5\n                  text-black\n                  bg-slate-800\n                  text-center\n                  font-16\n                \" _v-3646dd70=\"\">\n                {{ activeEmployee.name }}\n              </div>\n              <button aria-label=\"Close\" class=\"close close-modal\" data-dismiss=\"modal\" type=\"button\" _v-3646dd70=\"\">\n                <span aria-hidden=\"true\" _v-3646dd70=\"\">×</span>\n              </button>\n            </div>\n          </div>\n          <div class=\"\n              modal-body\n              no-padding-left no-padding-top no-padding-right\n              bg-slate-200\n            \" _v-3646dd70=\"\">\n            <div v-for=\"(index, job) in selectedJObs\" v-if=\"job.no_of_employee !== 'Full'\" :key=\"index\" class=\"col-md-12 col-sm-12 no-padding-left no-padding-right font-16 text-left text-color-black bg-slate-200 border-bottom border-2\n {{ index !== selectedJObs.length-1 &amp;&amp; selectedJObs[index].date !== selectedJObs[index+1].date ? 'border-3 border-slate-600':'border-white'}}\" _v-3646dd70=\"\">\n              <div class=\"\n                  col-md-2 col-sm-2\n                  p-10\n                  text-left\n                  col-xs-2\n                  text-left\n                  bg-slate-200\n                  text-color-black\n                  border-white\n                  font-12\n                \" _v-3646dd70=\"\">\n                {{ job.day }}\n              </div>\n              <div class=\"\n                  col-md-2 col-sm-2 col-xs-2\n                  p-10\n                  text-left text-left\n                  bg-slate-200\n                  text-color-black\n                  border-white\n                  font-12\n                \" _v-3646dd70=\"\">\n                {{ job.date }}\n              </div>\n              <div class=\"\n                  col-md-2 col-sm-2 col-xs-2\n                  p-10\n                  text-left text-left\n                  bg-slate-200\n                  text-color-black\n                  border-white\n                  font-12\n                \" _v-3646dd70=\"\">\n                {{ job.time }}\n              </div>\n              <div class=\"\n                  col-md-3 col-sm-3 col-xs-3\n                  p-10\n                  text-left text-left\n                  bg-slate-200\n                  text-color-black\n                  border-white\n                  font-12\n                \" _v-3646dd70=\"\">\n                {{ job.client_name }}\n              </div>\n              <div class=\"\n                  col-md-3 col-sm-3 col-xs-3\n                  p-10\n                  text-left text-left\n                  bg-slate-200\n                  text-color-black\n                  border-right border-white\n                  font-12\n                \" _v-3646dd70=\"\">\n                {{ job.title }}\n              </div>\n            </div>\n          </div>\n          <div class=\"modal-footer no-padding-bottom\" _v-3646dd70=\"\">\n            <!--            <button class=\"btn btn-secondary\" data-dismiss=\"modal\" type=\"button\">Close</button>-->\n            <!--            <button class=\"btn btn-primary\" type=\"button\">Save changes</button>-->\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div id=\"edit-phone\" aria-hidden=\"true\" aria-labelledby=\"exampleModalLabel\" class=\"modal fade\" role=\"dialog\" tabindex=\"-1\" _v-3646dd70=\"\">\n      <div class=\"modal-dialog\" role=\"document\" _v-3646dd70=\"\">\n        <div class=\"modal-content modal-grey\" _v-3646dd70=\"\">\n          <div class=\"modal-header no-padding bg-slate-700\" _v-3646dd70=\"\">\n            <div class=\"\n                col-md-12 col-sm-12 col-xs-12\n                p-5\n                text-black text-center\n                font-16\n                bg-slate-700\n              \" _v-3646dd70=\"\">\n              Edit Primary Number\n            </div>\n            <div class=\"\n                col-md-12 col-sm-12 col-xs-12\n                p-5\n                text-black\n                bg-slate-400\n                text-color-black text-center\n                font-16\n              \" _v-3646dd70=\"\">\n              {{ activeEmployee.name }}\n            </div>\n            <button aria-label=\"Close\" class=\"close close-modal-29\" data-dismiss=\"modal\" type=\"button\" _v-3646dd70=\"\">\n              <span aria-hidden=\"true\" _v-3646dd70=\"\">×</span>\n            </button>\n          </div>\n          <div class=\"modal-body no-padding-left no-padding-right bg-slate-300\" _v-3646dd70=\"\">\n            <div class=\"\n                col-md-12\n                p-5\n                font-16\n                text-center text-color-black\n                bg-slate-300\n              \" _v-3646dd70=\"\">\n              <div class=\"col-md-12 col-sm-12 col-xs-12 bg-slate-300 p-20\" _v-3646dd70=\"\">\n                <div class=\"\n                    col-md-4 col-sm-4\n                    text-left\n                    bg-slate-300\n                    text-color-black text-left\n                  \" _v-3646dd70=\"\">\n                  Current\n                </div>\n                <div class=\"\n                    col-md-8 col-sm-8\n                    text-right\n                    bg-slate-300\n                    text-color-black\n                    no-padding-right\n                  \" _v-3646dd70=\"\">\n                  {{ activeEmployee.primary_phone }}\n                </div>\n              </div>\n\n              <div class=\"col-md-12 col-sm-12 col-xs-12 bg-slate-300 p-20\" _v-3646dd70=\"\">\n                <div class=\"\n                    col-md-4 col-sm-4\n                    text-left\n                    bg-slate-300\n                    text-color-black text-left\n                  \" _v-3646dd70=\"\">\n                  New\n                </div>\n                <div class=\"\n                    col-md-8 col-sm-8\n                    text-right\n                    bg-slate-300\n                    text-color-black\n                    no-padding-right\n                  \" _v-3646dd70=\"\">\n                  <input v-model=\"primary_phone\" class=\"form-control format-phone-dash\" placeholder=\"\" type=\"text\" _v-3646dd70=\"\">\n                </div>\n              </div>\n\n              <div class=\"\n                  col-md-12 col-sm-12\n                  no-padding-left no-padding-right\n                  font-16\n                  text-right\n                  pr-20\n                  text-color-black\n                  bg-slate-200\n                  pt-20\n                  pb-20\n                \" _v-3646dd70=\"\">\n                <button class=\"btn btn-primary border-2 border-white text-black\" @click=\"editPhone()\" _v-3646dd70=\"\">\n                  SUBMIT\n                </button>\n              </div>\n            </div>\n          </div>\n          <div class=\"modal-footer no-padding-bottom\" _v-3646dd70=\"\">\n            <!--            <button class=\"btn btn-secondary\" data-dismiss=\"modal\" type=\"button\">Close</button>-->\n            <!--            <button class=\"btn btn-primary\" type=\"button\">Save changes</button>-->\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div id=\"edit-employee-info\" aria-hidden=\"true\" aria-labelledby=\"exampleModalLabel\" class=\"modal fade\" role=\"dialog\" tabindex=\"-1\" _v-3646dd70=\"\">\n      <div class=\"modal-dialog\" role=\"document\" _v-3646dd70=\"\">\n        <div class=\"modal-content modal-grey\" _v-3646dd70=\"\">\n          <div class=\"modal-header no-padding bg-slate-700\" _v-3646dd70=\"\">\n            <!--            <div-->\n            <!--                class=\"col-md-12 col-sm-12 col-xs-12 p-5 text-black text-center font-16 bg-slate-700\">Edit Primary Number-->\n            <!--            </div>-->\n            <!--            <div-->\n            <!--                class=\"col-md-12 col-sm-12 col-xs-12 p-5 text-black bg-slate-400 text-color-black text-center font-16\">{{ activeEmployee.name }}-->\n            <!--            </div>-->\n            <button aria-label=\"Close\" class=\"close close-modal-0\" data-dismiss=\"modal\" type=\"button\" _v-3646dd70=\"\">\n              <span aria-hidden=\"true\" _v-3646dd70=\"\">×</span>\n            </button>\n          </div>\n          <div class=\"\n              modal-body\n              no-padding-left no-padding-right\n              bg-slate-custom\n              font-12\n            \" _v-3646dd70=\"\">\n            <div class=\"\n                col-md-12\n                p-5\n                font-16\n                text-center text-color-black\n                bg-slate-custom\n              \" _v-3646dd70=\"\">\n              <div class=\"col-md-12 col-sm-12 col-xs-12 p-20\" _v-3646dd70=\"\">\n                <div class=\"\n                    col-md-4 col-sm-4\n                    text-left text-color-black text-left\n                    font-12\n                  \" _v-3646dd70=\"\">\n                  {{ activeEmployee.name }}\n                </div>\n                <div class=\"\n                    col-md-2 col-sm-2\n                    text-left text-color-black text-left\n                    font-12\n                  \" _v-3646dd70=\"\">\n                  {{ activeEmployee.gar }}\n                </div>\n                <div class=\"\n                    col-md-3 col-sm-3\n                    text-left text-color-black text-left\n                    font-12\n                  \" _v-3646dd70=\"\">\n                  {{ activeEmployee.primary_phone }}\n                </div>\n                <div class=\"\n                    col-md-3 col-sm-3\n                    text-left text-right text-italic text-primary\n                    font-12\n                    cursor-pointer\n                  \" _v-3646dd70=\"\">\n                  Edit\n                </div>\n              </div>\n\n              <div class=\"col-md-12 col-sm-12 col-xs-12 p-20\" _v-3646dd70=\"\">\n                <div class=\"\n                    col-md-3 col-sm-3\n                    text-left text-color-black text-left\n                    font-12\n                  \" _v-3646dd70=\"\">\n                  {{ activeEmployee.street }}\n                </div>\n                <div class=\"\n                    col-md-3 col-sm-3\n                    text-left text-color-black text-left\n                    font-12\n                  \" _v-3646dd70=\"\"></div>\n                <div class=\"\n                    col-md-3 col-sm-3\n                    text-left text-color-black text-left\n                    font-12\n                  \" _v-3646dd70=\"\">\n                  {{ activeEmployee.secondary_phone }}\n                </div>\n                <div class=\"\n                    col-md-3 col-sm-3\n                    text-left text-right text-italic text-primary\n                    font-12\n                    cursor-pointer\n                  \" _v-3646dd70=\"\">\n                  Edit\n                </div>\n              </div>\n\n              <div class=\"col-md-12 col-sm-12 col-xs-12 p-20\" _v-3646dd70=\"\">\n                <div class=\"\n                    col-md-3 col-sm-3\n                    text-left text-color-black text-left\n                    font-12\n                  \" _v-3646dd70=\"\">\n                  {{ activeEmployee.apt }}\n                </div>\n                <div class=\"\n                    col-md-3 col-sm-3\n                    text-left text-color-black text-left\n                    font-12\n                  \" _v-3646dd70=\"\"></div>\n                <div class=\"\n                    col-md-3 col-sm-3\n                    text-left text-color-black text-left\n                    font-12\n                  \" _v-3646dd70=\"\"></div>\n                <div class=\"\n                    col-md-3 col-sm-3\n                    text-left text-right text-italic text-primary\n                    font-12\n                  \" _v-3646dd70=\"\"></div>\n              </div>\n\n              <div class=\"col-md-12 col-sm-12 col-xs-12 p-20 font-12\" _v-3646dd70=\"\">\n                <div class=\"\n                    col-md-3 col-sm-3\n                    text-left text-color-black text-left\n                    font-12\n                  \" _v-3646dd70=\"\">\n                  {{\n                    activeEmployee.city + activeEmployee.city\n                      ? \" , \"\n                      : \"\" + activeEmployee.state + activeEmployee.state\n                      ? \" , \"\n                      : \"\" + activeEmployee.zip_code\n                  }}\n                </div>\n                <div class=\"\n                    col-md-3 col-sm-3\n                    text-left text-color-black text-left\n                    font-12\n                  \" _v-3646dd70=\"\"></div>\n                <div class=\"\n                    col-md-3 col-sm-3\n                    text-left text-color-black text-left\n                    font-12\n                  \" _v-3646dd70=\"\">\n                  {{ activeEmployee.email }}\n                </div>\n                <div class=\"\n                    col-md-3 col-sm-3\n                    text-left text-right text-italic text-primary\n                    font-12\n                    cursor-pointer\n                  \" _v-3646dd70=\"\">\n                  Edit\n                </div>\n              </div>\n\n              <div v-if=\"activeEmployee.comments\" class=\"col-md-12 col-sm-12 col-xs-12 p-20 font-12 p-20 bg-grey\" _v-3646dd70=\"\">\n                {{ activeEmployee.comments }}\n              </div>\n\n              <div class=\"\n                  col-md-12 col-sm-12\n                  no-padding-left no-padding-right\n                  font-16\n                  text-right\n                  pr-20\n                  text-color-black\n                  bg-slate-200\n                  pt-20\n                  pb-20\n                \" _v-3646dd70=\"\">\n                <button class=\"btn btn-primary border-2 border-white text-black\" @click=\"sendInvitation()\" _v-3646dd70=\"\">\n                  Send Invite\n                </button>\n              </div>\n            </div>\n          </div>\n          <div class=\"modal-footer no-padding-bottom\" _v-3646dd70=\"\">\n            <!--            <button class=\"btn btn-secondary\" data-dismiss=\"modal\" type=\"button\">Close</button>-->\n            <!--            <button class=\"btn btn-primary\" type=\"button\">Save changes</button>-->\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  var id = "/home/shoieb/sites/elegant/resources/assets/js/vue/components/recruiter-board.vue"
  module.hot.dispose(function () {
    require("vueify-insert-css").cache["\n.close-modal[_v-3646dd70] {\n  font-size: 30px;\n  margin-top: -14.75px;\n  font-weight: 500;\n}\n\n.close-modal-29[_v-3646dd70] {\n  font-size: 30px;\n  margin-top: -29.75px !important;\n  font-weight: 500;\n}\n\n.close-modal-0[_v-3646dd70] {\n  font-size: 35px;\n  margin-top: 0 !important;\n  font-weight: 500;\n  z-index: 100;\n  color: #656565 !important;\n}\n\n.font-20[_v-3646dd70] {\n  font-size: 20px;\n}\n\n.bg-slate-custom[_v-3646dd70] {\n  background-color: #d6dce5;\n  border-color: #d6dce5;\n}\n\n.custom-header[_v-3646dd70] {\n  position: -webkit-sticky;\n  position: sticky;\n  top: 48px;\n  z-index: 100;\n}\n\n.top-65[_v-3646dd70] {\n  top: 65px;\n}\n\n.border-color-custom[_v-3646dd70] {\n  border-color: #ddd;\n}\n\n.border-3[_v-3646dd70] {\n  border-width: 3px;\n}\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, module.exports.template)
  }
})()}
},{"./../../mixed/modals":10,"./../../mixed/notify":11,"vue":5,"vue-hot-reload-api":4,"vueify-insert-css":6}],69:[function(require,module,exports){
var __vueify_style__ = require("vueify-insert-css").insert("\n")
"use strict";

exports.__esModule = true;
var modals = require("./../../mixed/modals");
var notify = require("./../../mixed/notify");

exports["default"] = {
  data: function data() {
    return {
      positions: {},
      clients: [],
      ids: [],
      first: 0,
      second: 0,
      third: 0,
      mini: parseInt(mini)
    };
  },
  filters: {},
  watch: {},
  ready: function ready() {
    var _this = this;

    this.getClients();
    this.getPositions();
    window.bus.$on("getScheduleRuleReport", function () {
      _this.getPositions();
    });
  },
  events: {},
  methods: {
    showClientModal: function showClientModal() {
      modals.showStrict("#edit_client_list");
    },

    getPositions: function getPositions() {
      var _this2 = this;

      if (this.ids.length) {
        notify.loading(true);
        this.$http.post("/api/schedule-rule-report", { ids: this.ids, mini: this.mini }, function (response) {
          _this2.positions = response;
          modals.hide("#edit_client_list");
        }).always(function () {
          notify.loading(false);
        });
      }
    },

    /**
     * get list of all clients
     */
    getClients: function getClients() {
      var _this3 = this;

      this.$http.get("/api/clients", "", function (response) {
        _this3.clients = response;
        _this3.first = Math.round(_this3.clients.length / 3);
        _this3.second = _this3.first * 2;
        _this3.third = _this3.first * 3;
      }).always(function () {
        notify.loading(false);
      });
    },

    showScheduleRules: function showScheduleRules(position) {
      window.bus.$emit("showSchedulingRule", position);
    }
  }
};
module.exports = exports["default"];
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n  <div class=\"row\">\n    <button class=\"btn btn-primary pull-right mb-10\" @click=\"showClientModal\">Show Clients</button>\n    <div class=\"col-md-12 no-padding mb-20\">\n      <div class=\"table-responsive\">\n        <table class=\"table table-xxs table-bordered table-fixed\">\n          <thead class=\"header\">\n            <tr>\n              <th class=\"bg-slate-800 text-center text-black\">Position Name</th>\n              <th class=\"bg-slate-800 text-center text-black\">Priority</th>\n              <th class=\"bg-slate-800 text-center text-black\">Required</th>\n              <th v-if=\"!mini\" class=\"bg-slate-800 text-center text-black\">A</th>\n              <th v-if=\"!mini\" class=\"bg-slate-800 text-center text-black\">B</th>\n              <th v-if=\"!mini\" class=\"bg-slate-800 text-center text-black\">C</th>\n              <th v-if=\"!mini\" class=\"bg-slate-800 text-center text-black\">D</th>\n              <th v-if=\"!mini\" class=\"bg-slate-800 text-center text-black\">E</th>\n              <th v-if=\"!mini\" class=\"bg-slate-800 text-center text-black\">F</th>\n              <th v-if=\"!mini\" class=\"bg-slate-800 text-center text-black\">G</th>\n              <th v-if=\"!mini\" class=\"bg-slate-800 text-center text-black\">H</th>\n              <th v-if=\"!mini\" class=\"bg-slate-800 text-center text-black\">I</th>\n              <th v-if=\"!mini\" class=\"bg-slate-800 text-center text-black\">J</th>\n              <th v-if=\"!mini\" class=\"bg-slate-800 text-center text-black\">K</th>\n              <th v-if=\"!mini\" class=\"bg-slate-800 text-center text-black\">L</th>\n              <th v-if=\"!mini\" class=\"bg-danger-600 text-center text-black\">X</th>\n              <th v-if=\"!mini\" class=\"bg-slate-800 text-center text-black\">M</th>\n              <th class=\"bg-slate-800 text-center text-black\">Scheduling Rule</th>\n              <th class=\"bg-slate-800 text-center text-black\"></th>\n            </tr>\n          </thead>\n          <tbody>\n            <tr v-for=\"position in positions\">\n              <td class=\"text-center text-black\">{{position.company_code + ' '+position.title}}</td>\n              <td class=\"text-center text-black\">{{ position.current_priority }}</td>\n              <td class=\"text-center text-black\">{{ position.required_priority }}</td>\n              <td v-if=\"!mini\" class=\"bg-success-300 text-center text-color-black text-black\">{{position.A}}</td>\n              <td v-if=\"!mini\" class=\"bg-success-300 text-center text-color-black text-black\">{{position.B}}</td>\n              <td v-if=\"!mini\" class=\"bg-success-300 text-center text-color-black text-black\">{{position.C}}</td>\n              <td v-if=\"!mini\" class=\"bg-slate text-center text-black\">{{position.D}}</td>\n              <td v-if=\"!mini\" class=\"bg-slate text-center text-black\">{{position.E}}</td>\n              <td v-if=\"!mini\" class=\"bg-slate text-center text-black\">{{position.F}}</td>\n              <td v-if=\"!mini\" class=\"bg-slate-400 text-center text-black\">{{position.G}}</td>\n              <td v-if=\"!mini\" class=\"bg-slate-400 text-center text-black\">{{position.H}}</td>\n              <td v-if=\"!mini\" class=\"bg-slate-400 text-center text-black\">{{position.I}}</td>\n              <td v-if=\"!mini\" class=\"bg-slate-300 text-center text-black\">{{position.J}}</td>\n              <td v-if=\"!mini\" class=\"bg-slate-300 text-center text-black\">{{position.K}}</td>\n              <td v-if=\"!mini\" class=\"bg-slate-300 text-center text-black\">{{position.L}}</td>\n              <td v-if=\"!mini\" class=\"text-center text-black text-danger-600\">{{position.X}}</td>\n              <td v-if=\"!mini\" class=\"text-center text-black\">{{position.M}}</td>\n              <td class=\"text-center text-black text-info-700\">{{position.code}}</td>\n              <td class=\"text-center text-black\">\n                <button class=\"btn btn-xs bg-info\" @click=\"showScheduleRules(position)\">Change Rule</button>\n              </td>\n            </tr>\n          </tbody>\n        </table>\n      </div>\n    </div>\n\n    <div class=\"modal fade\" id=\"edit_client_list\">\n      <div class=\"modal-dialog modal-lg\">\n        <div class=\"modal-content\">\n          <div class=\"modal-header\">\n            <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\">×</button>\n            <h4 class=\"modal-title pl-10\">Edit Client List</h4>\n          </div>\n          <div class=\"modal-body\">\n            <div class=\"row\">\n              <div class=\"col-md-12\">\n                <div class=\"col-md-12 mb-10\">\n                  <span class=\"label label-primary label-block text-center text-bold\">Clients</span>\n                </div>\n                <div class=\"col-md-4\">\n                  <div class=\"col-md-12\" v-for=\"(index,client) in clients\" :key=\"index\">\n                    <div v-if=\"index <= first\" class=\"\">\n                      <input type=\"checkbox\" name=\"\" :id=\"'current-client'+client.id\" v-model=\"ids\" :value=\"client.id\">\n                      {{ client.name }}\n                    </div>\n                  </div>\n                </div>\n                <div class=\"col-md-4\">\n                  <div class=\"col-md-12\" v-for=\"(index,client) in clients\" :key=\"index\" v-if=\"index > first &amp;&amp; index <= second\">\n                    <div class=\"\">\n                      <input type=\"checkbox\" name=\"\" :id=\"'current-client'+client.id\" v-model=\"ids\" :value=\"client.id\">\n                      {{ client.name }}\n                    </div>\n                  </div>\n                </div>\n                <div class=\"col-md-4\">\n                  <div class=\"col-md-12\" v-for=\"(index,client) in clients\" :key=\"index\" v-if=\"index > second\">\n                    <div class=\"\">\n                      <input type=\"checkbox\" name=\"\" :id=\"'current-client'+client.id\" v-model=\"ids\" :value=\"client.id\">\n                      {{ client.name }}\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </div>\n            <br>\n            <br>\n            <div class=\"text-right\">\n              <button type=\"submit\" class=\"btn btn-primary\" v-submit=\"state\" v-on:click.prevent=\"getPositions\">\n                Get Schedule Report Rule\n                <i class=\"icon-arrow-right14 position-right\"></i>\n              </button>\n            </div>\n          </div>\n          <div class=\"modal-footer\"></div>\n        </div>\n        <!-- /.modal-content -->\n      </div>\n      <!-- /.modal-dialog -->\n    </div>\n  </div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  var id = "/home/shoieb/sites/elegant/resources/assets/js/vue/components/schedule-rule-report.vue"
  module.hot.dispose(function () {
    require("vueify-insert-css").cache["\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, module.exports.template)
  }
})()}
},{"./../../mixed/modals":10,"./../../mixed/notify":11,"vue":5,"vue-hot-reload-api":4,"vueify-insert-css":6}],70:[function(require,module,exports){
var __vueify_style__ = require("vueify-insert-css").insert("\n    .table-body {\n        height: 650px;\n        overflow-y: scroll;\n    }\n")
"use strict";

exports.__esModule = true;
exports["default"] = {
    data: function data() {
        return {
            employees: {},
            activeEmployee: {},
            error: {
                in_time: "",
                out_time: "",
                am_pm: "",
                no_job: ""
            }
        };
    },
    filters: {},
    ready: function ready() {
        this.fetchScheduledEmployees();
        var that = this;
        window.bus.$on("refreshScheduledEmployeeError", function () {
            that.fetchScheduledEmployees();
        });
    },
    events: {},
    methods: {
        /**
         * fetch scheduled employees for the current week
         */
        fetchScheduledEmployees: function fetchScheduledEmployees() {
            var _this = this;

            this.$http.get("/api/accounting-scheduled-employee-all", "", function (response) {
                _this.employees = _.groupBy(response, function (value) {
                    return value.name + " --- " + value.department_name;
                });
            }).always(function () {});
        }
    }
};
module.exports = exports["default"];
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n    <div class=\"row\">\n        <div class=\"col-md-12\">\n            <div class=\"col-md-8 no-padding\">\n                <h5 class=\"bg-danger text-center no-margin-top no-margin-bottom\">Scheduled Employee</h5>\n            </div>\n            <div class=\"col-md-3 no-padding\">\n                <h5 class=\"text-center no-margin-top no-margin-bottom bg-blue\">Team 1</h5>\n            </div>\n            <div class=\"col-md-1 no-padding\">\n                <h5 class=\"text-center no-margin-top no-margin-bottom bg-green\">Team 2</h5>\n            </div>\n            <div class=\"col-md-12 no-padding\">\n                <div class=\"bg-black col-md-1 p-5\">Client</div>\n                <div class=\"bg-black col-md-1 p-5\">Date</div>\n                <div class=\"bg-black col-md-1 p-5\">Job</div>\n                <div class=\"bg-black col-md-2 p-5\">Employee</div>\n                <div class=\"bg-black col-md-1 p-5\">In</div>\n                <div class=\"bg-black col-md-1 p-5\">Out</div>\n                <div class=\"bg-black col-md-1 p-5\">A/P</div>\n                <div class=\"bg-black col-md-1 p-5\">In Time</div>\n                <div class=\"bg-black col-md-1 p-5\">Out Time</div>\n                <div class=\"bg-black col-md-1 p-5\">Break</div>\n                <div class=\"bg-black col-md-1 p-5\">Duration</div>\n            </div>\n            <div class=\"col-md-12 no-padding\">\n                <div class=\"table-responsive\">\n                    <table class=\"table table-xxs table-fixed table-bordered\">\n                        <tbody v-for=\"(index, groups) in employees\">\n                        <tr class=\"\">\n                            <td colspan=\"7\" class=\" col-md-12\"></td>\n                        </tr>\n                        <tr v-for=\"employee in groups\">\n                            <td class=\"col-md-1\">{{ employee.company_code }}</td>\n                            <td class=\"col-md-1\">\n                                {{ employee.date | customDateFormat\n                                'YYYY-MM-DD'\n                                'DD - MMM' }}\n                            </td>\n                            <td class=\"col-md-1\">{{ employee.title }}</td>\n                            <td class=\"col-md-2\">{{ employee.first_name + ' ' + employee.last_name }}</td>\n                            <td class=\"col-md-1\" v-bind:class=\"[employee.error.in_time == 1 ? 'error' : '']\"><span v-if=\"employee.error.in_time == 1\" class=\"text-center\">In</span></td>\n                            <td class=\"col-md-1\" v-bind:class=\"[employee.error.out_time == 1 ? 'error' : '']\"><span v-if=\"employee.error.out_time == 1\" class=\"text-center\">Out</span></td>\n                            <td class=\"col-md-1\" v-bind:class=\"[employee.error.am_pm == 1 ? 'error' : '']\"><span v-if=\"employee.error.am_pm == 1\" class=\"text-center\">A/P</span></td>\n                            <td class=\"col-md-1\">{{ employee.in_time}}</td>\n                            <td class=\"col-md-1\">{{ employee.out_time}}</td>\n                            <td class=\"col-md-1\">{{ employee.break_time}}</td>\n                            <td class=\"col-md-1\">{{ employee.duration_team_2/60}}</td>\n                        </tr>\n                        </tbody>\n                    </table>\n                </div>\n            </div>\n        </div>\n    </div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  var id = "/home/shoieb/sites/elegant/resources/assets/js/vue/components/scheduled-employees-errors.vue"
  module.hot.dispose(function () {
    require("vueify-insert-css").cache["\n    .table-body {\n        height: 650px;\n        overflow-y: scroll;\n    }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, module.exports.template)
  }
})()}
},{"vue":5,"vue-hot-reload-api":4,"vueify-insert-css":6}],71:[function(require,module,exports){
var __vueify_style__ = require("vueify-insert-css").insert("\n.close-modal[_v-335e5ea1] {\n  font-size: 30px;\n  margin-top: -14.75px;\n  font-weight: 500;\n}\n\n.close-modal-29[_v-335e5ea1] {\n  font-size: 30px;\n  margin-top: -29.75px !important;\n  font-weight: 500;\n}\n\n.close-modal-0[_v-335e5ea1] {\n  font-size: 35px;\n  margin-top: 0 !important;\n  font-weight: 500;\n  z-index: 100;\n  color: #656565 !important;\n}\n\n.font-20[_v-335e5ea1] {\n  font-size: 20px;\n}\n\n.bg-slate-custom[_v-335e5ea1] {\n  background-color: #d6dce5;\n  border-color: #d6dce5;\n}\n\n.custom-header[_v-335e5ea1] {\n  position: -webkit-sticky;\n  position: sticky;\n  top: 48px;\n  z-index: 100;\n}\n\n.top-65[_v-335e5ea1] {\n  top: 65px;\n}\n\n.bg-top-1[_v-335e5ea1] {\n  background-color: #8497b0;\n  border-color: #8497b0;\n  color: #fff;\n}\n\n.bg-top-2[_v-335e5ea1] {\n  background-color: #adb9ca;\n  border-color: #adb9ca;\n  color: #fff;\n}\n\n.bg-top-3[_v-335e5ea1] {\n  background-color: #44546a;\n  border-color: #44546a;\n  color: #fff;\n}\n\n.bg-top-4[_v-335e5ea1] {\n  background-color: #d6dce5;\n  border-color: #d6dce5;\n  color: #fff;\n}\n\n[_v-335e5ea1]::-webkit-input-placeholder {\n  text-align: center;\n}\n\n[_v-335e5ea1]:-moz-placeholder { /* Firefox 18- */\n  text-align: center;\n}\n\n[_v-335e5ea1]::-moz-placeholder { /* Firefox 19+ */\n  text-align: center;\n}\n\n[_v-335e5ea1]:-ms-input-placeholder {\n  text-align: center;\n}\n\n.w-200[_v-335e5ea1] {\n  width: 200px !important;\n}\n\n@media (min-width: 769px) {\n  .modal-sm-custom[_v-335e5ea1] {\n    width: 500px;\n  }\n}\n\n\n")
"use strict";

exports.__esModule = true;
var modals = require("./../../mixed/modals");
var notify = require("./../../mixed/notify");

exports["default"] = {
  data: function data() {
    return {
      clients: {},
      searchedClients: {},
      activeClient: {},
      jobs: {},
      type: 0,
      availableJobs: {},
      selectedJObs: {},
      ids: [],
      query: '',
      password: ''
    };
  },
  props: ['user'],
  filters: {},
  watch: {
    'query': function query(val, oldVal) {
      var regex = this.convertWildcardStringToRegExp(val);
      this.searchedClients = this.clients.filter(function (item) {
        return regex.test(item.name);
      });
    }
  },
  ready: function ready() {
    this.getClients();
  },

  events: {},

  methods: {

    getClients: function getClients() {
      var _this = this;

      notify.loading(true);
      this.$http.get("/api/client-settings-list", function (response) {
        _this.clients = response;
        _this.searchedClients = response;
        notify.loading(false);
      }).always(function () {});
    },

    /**
     * show modal to update client time clock status
     * @param client
     */
    updateStatusModal: function updateStatusModal(client) {
      this.activeClient = _.cloneDeep(client);

      if (!client.time_clock_status) {
        modals.showStrict("#password-modal");
      } else {
        modals.showStrict("#status-modal");
      }
    },

    deactivateClient: function deactivateClient() {
      var _this2 = this;

      notify.loading(true);
      this.$http.get("/api/client-settings-deactivate/" + this.activeClient.id, function (response) {
        _this2.getClients();
        modals.hide("#status-modal");
        notify.loading(false);
      }).always(function () {
        notify.loading(false);
      });
    },

    activateClient: function activateClient() {
      var _this3 = this;

      notify.loading(true);
      this.$http.post("/api/client-settings-activate/" + this.activeClient.id, { password: this.password }, function (response) {
        _this3.getClients();
        _this3.password = '';
        modals.hide("#password-modal");
        notify.loading(false);
      }).always(function () {
        notify.loading(false);
      });
    },

    updatePassword: function updatePassword() {
      modals.showStrict("#password-modal");
    },

    sortBy: function sortBy(field, reverse, primer) {
      var key = primer ? function (x) {
        return primer(x[field]);
      } : function (x) {
        return x[field];
      };

      reverse = !reverse ? 1 : -1;

      return function (a, b) {
        return a = key(a), b = key(b), reverse * ((a > b) - (b > a));
      };
    },

    sortUsers: function sortUsers(field, reverse) {
      var primer = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];

      console.log(field);
      this.sortOrders = reverse;
      this.sortKey = field;
      this.employees.sort(this.sortBy(field, reverse, primer));
    },

    escapeRegExp: function escapeRegExp(str) {
      return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    },

    convertWildcardStringToRegExp: function convertWildcardStringToRegExp(expression) {
      var terms = expression.split('*');

      var trailingWildcard = false;

      var expr = '';
      for (var i = 0; i < terms.length; i++) {
        if (terms[i]) {
          if (i > 0 && terms[i - 1]) {
            expr += '.*';
          }
          trailingWildcard = false;
          expr += this.escapeRegExp(terms[i]);
        } else {
          trailingWildcard = true;
          expr += '.*';
        }
      }

      if (!trailingWildcard) {
        expr += '.*';
      }

      return new RegExp('^' + expr + '$', 'i');
    }
  }
};
module.exports = exports["default"];
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n  <div class=\"row\" _v-335e5ea1=\"\">\n    <div class=\"col-md-12 col-sm-12 no-padding-left no-padding-right\" _v-335e5ea1=\"\">\n      <div class=\"col-md-12 col-sm-12  no-padding-left no-padding-right\" _v-335e5ea1=\"\">\n        <table class=\"table table-xxs\" _v-335e5ea1=\"\">\n          <thead class=\"header custom-header\" _v-335e5ea1=\"\">\n          <tr class=\"bg-top-1\" _v-335e5ea1=\"\">\n            <th class=\"text-center text-black p-5 font-20 pl-10\" colspan=\"4\" _v-335e5ea1=\"\">\n              ACTIVATE CLIENT FOR TIME CLOCK\n            </th>\n          </tr>\n          <tr class=\"bg-top-2\" _v-335e5ea1=\"\">\n            <th class=\"text-center text-black p-5 font-20 pl-10\" colspan=\"4\" _v-335e5ea1=\"\">\n              <div class=\"row\" _v-335e5ea1=\"\">\n                <div class=\"col-md-4 col-sm-4\" _v-335e5ea1=\"\"></div>\n                <div class=\"col-md-4 col-sm-4  p-5\" _v-335e5ea1=\"\">\n                  <input type=\"text\" name=\"search\" v-model=\"query\" class=\"form-control\" placeholder=\"search client\" _v-335e5ea1=\"\"></div>\n                <div class=\"col-md-4 col-sm-4\" _v-335e5ea1=\"\"></div>\n              </div>\n            </th>\n          </tr>\n          <tr _v-335e5ea1=\"\">\n            <th class=\"bg-top-3 text-left text-black text-uppercase \" _v-335e5ea1=\"\">\n              CLIENT NAME\n            </th>\n            <th class=\"bg-top-3 text-center text-black cursor-pointer text-uppercase\" @click=\"sortUsers('name',!sortOrders)\" _v-335e5ea1=\"\">\n              STATUS\n              <i v-if=\"sortKey === 'name'\" :class=\"sortOrders ? 'fa fa-arrow-down':'fa fa-arrow-up'\" _v-335e5ea1=\"\"></i>\n            </th>\n            <th class=\"bg-top-3 text-black text-center text-uppercase\" _v-335e5ea1=\"\">PASSWORD</th>\n\n            <th class=\"bg-top-3 text-black text-center text-uppercase\" _v-335e5ea1=\"\">Tab</th>\n\n          </tr>\n          </thead>\n          <tbody _v-335e5ea1=\"\">\n          <tr v-for=\"client in clients\" _v-335e5ea1=\"\">\n            <td class=\"text-left cursor-pointer\" @click=\"updateStatusModal(client)\" _v-335e5ea1=\"\">{{ client.name }}</td>\n            <td class=\"text-center cursor-pointer text-black\" @click=\"updateStatusModal(client)\" _v-335e5ea1=\"\"><span class=\"{{ client.time_clock_status ? 'text-success' : 'text-danger' }} text-black\" _v-335e5ea1=\"\">{{\n                client.time_clock_status ? 'Active' : 'No'\n              }}</span></td>\n            <td class=\"text-center cursor-pointer\" _v-335e5ea1=\"\">{{ client.password }}</td>\n            <td class=\"text-center cursor-pointer\" v-html=\"client.last_active\" _v-335e5ea1=\"\"></td>\n          </tr>\n          </tbody>\n        </table>\n      </div>\n    </div>\n\n\n    <div id=\"status-modal\" aria-hidden=\"true\" aria-labelledby=\"exampleModalLabel\" class=\"modal fade\" role=\"dialog\" tabindex=\"-1\" _v-335e5ea1=\"\">\n      <div class=\"modal-dialog modal-sm\" role=\"document\" _v-335e5ea1=\"\">\n        <div class=\"modal-content modal-grey\" _v-335e5ea1=\"\">\n          <div class=\"modal-header no-padding bg-slate-700\" _v-335e5ea1=\"\">\n            <div class=\"col-md-12 col-sm-12 col-xs-12 p-5 text-black text-left bg-top-1 font-16\" _v-335e5ea1=\"\"> Activate / Deactivate\n              Client\n            </div>\n            <button aria-label=\"Close\" class=\"close close-modal\" data-dismiss=\"modal\" type=\"button\" _v-335e5ea1=\"\">\n              <span aria-hidden=\"true\" _v-335e5ea1=\"\">×</span>\n            </button>\n          </div>\n          <div class=\"modal-body no-padding-left no-padding-right bg-top-4\" _v-335e5ea1=\"\">\n\n            <div class=\"col-md-12 p-5 font-16 text-center text-color-black bg-top-4 p-5\" _v-335e5ea1=\"\">\n              <div class=\"col-md-12 col-sm-12 text-right bg-top-4 text-color-black text-black text-center\" _v-335e5ea1=\"\">\n                {{ activeClient.name }}\n              </div>\n\n            </div>\n\n            <div class=\"col-md-12 p-5 font-16 text-center text-color-black bg-top-4 p-5\" _v-335e5ea1=\"\">\n              <div class=\"col-md-6 col-sm-6 text-center bg-top-4 text-color-black \" _v-335e5ea1=\"\">Status</div>\n              <div class=\"col-md-6 col-sm-6 text-center bg-top-4 text-color-black\" _v-335e5ea1=\"\"><span class=\"text-success text-black\" _v-335e5ea1=\"\">Active</span></div>\n            </div>\n\n\n            <div class=\"col-md-12 p-5 font-16 text-center text-color-black bg-top-4 p-10\" _v-335e5ea1=\"\">\n              <div class=\"col-md-6 col-sm-6 text-center bg-top-4 text-color-black \" _v-335e5ea1=\"\"></div>\n              <div class=\"col-md-6 col-sm-6 text-center bg-top-4 text-color-black\" _v-335e5ea1=\"\">\n                <button class=\"btn btn-danger border-2 border-white text-black\" @click=\"deactivateClient()\" _v-335e5ea1=\"\">DEACTIVATE\n                </button>\n              </div>\n            </div>\n\n          </div>\n          <div class=\"modal-footer no-padding-bottom\" _v-335e5ea1=\"\">\n            <!--            <button class=\"btn btn-secondary\" data-dismiss=\"modal\" type=\"button\">Close</button>-->\n            <!--            <button class=\"btn btn-primary\" type=\"button\">Save changes</button>-->\n          </div>\n        </div>\n      </div>\n    </div>\n\n\n    <div id=\"password-modal\" aria-hidden=\"true\" aria-labelledby=\"exampleModalLabel\" class=\"modal fade\" role=\"dialog\" tabindex=\"-1\" _v-335e5ea1=\"\">\n      <div class=\"modal-dialog modal-sm-custom\" role=\"document\" _v-335e5ea1=\"\">\n        <div class=\"modal-content modal-grey\" _v-335e5ea1=\"\">\n          <div class=\"modal-header no-padding bg-slate-700\" _v-335e5ea1=\"\">\n            <div class=\"col-md-12 col-sm-12 col-xs-12 p-5 text-black text-left bg-top-1 font-16\" _v-335e5ea1=\"\"> Activate / Deactivate\n              Client\n            </div>\n            <button aria-label=\"Close\" class=\"close close-modal\" data-dismiss=\"modal\" type=\"button\" _v-335e5ea1=\"\">\n              <span aria-hidden=\"true\" _v-335e5ea1=\"\">×</span>\n            </button>\n          </div>\n          <div class=\"modal-body no-padding-left no-padding-right bg-top-4\" _v-335e5ea1=\"\">\n\n            <div class=\"col-md-12 p-5 font-16 text-center text-color-black bg-top-4 p-5\" _v-335e5ea1=\"\">\n              <div class=\"col-md-12 col-sm-12 text-right bg-top-4 text-color-black text-black text-center\" _v-335e5ea1=\"\">\n                {{ activeClient.name }}\n              </div>\n            </div>\n\n            <div class=\"col-md-12 p-5 font-16 text-center text-color-black bg-top-4 p-5\" _v-335e5ea1=\"\">\n              <div class=\"col-md-6 col-sm-6 text-center bg-top-4 text-color-black \" _v-335e5ea1=\"\">Status</div>\n              <div class=\"col-md-6 col-sm-6 text-center bg-top-4 text-color-black\" _v-335e5ea1=\"\"><span class=\"text-danger text-black\" _v-335e5ea1=\"\">No</span></div>\n            </div>\n\n            <div class=\"col-md-12 p-5 font-16 text-center text-color-black bg-top-4 p-5\" _v-335e5ea1=\"\">\n              <div class=\"col-md-6 col-sm-6 text-center bg-top-4 text-color-black \" _v-335e5ea1=\"\">Create Password</div>\n              <div class=\"col-md-6 col-sm-6 text-left bg-top-4 text-color-black\" _v-335e5ea1=\"\">\n                <input type=\"text\" class=\"form-control w-200\" v-model=\"password\" _v-335e5ea1=\"\">\n              </div>\n            </div>\n\n\n            <div class=\"col-md-12 p-5 font-16 text-center text-color-black bg-top-4 p-10\" _v-335e5ea1=\"\">\n              <div class=\"col-md-6 col-sm-6 text-center bg-top-4 text-color-black \" _v-335e5ea1=\"\"></div>\n              <div class=\"col-md-6 col-sm-6 text-left bg-top-4 text-color-black\" _v-335e5ea1=\"\">\n                <button class=\"btn btn-success border-2 border-white text-black w-200\" @click=\"activateClient()\" _v-335e5ea1=\"\">\n                  ACTIVATE\n                </button>\n              </div>\n            </div>\n\n          </div>\n          <div class=\"modal-footer no-padding-bottom\" _v-335e5ea1=\"\">\n            <!--            <button class=\"btn btn-secondary\" data-dismiss=\"modal\" type=\"button\">Close</button>-->\n            <!--            <button class=\"btn btn-primary\" type=\"button\">Save changes</button>-->\n          </div>\n        </div>\n      </div>\n    </div>\n\n\n  </div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  var id = "/home/shoieb/sites/elegant/resources/assets/js/vue/components/settings-client.vue"
  module.hot.dispose(function () {
    require("vueify-insert-css").cache["\n.close-modal[_v-335e5ea1] {\n  font-size: 30px;\n  margin-top: -14.75px;\n  font-weight: 500;\n}\n\n.close-modal-29[_v-335e5ea1] {\n  font-size: 30px;\n  margin-top: -29.75px !important;\n  font-weight: 500;\n}\n\n.close-modal-0[_v-335e5ea1] {\n  font-size: 35px;\n  margin-top: 0 !important;\n  font-weight: 500;\n  z-index: 100;\n  color: #656565 !important;\n}\n\n.font-20[_v-335e5ea1] {\n  font-size: 20px;\n}\n\n.bg-slate-custom[_v-335e5ea1] {\n  background-color: #d6dce5;\n  border-color: #d6dce5;\n}\n\n.custom-header[_v-335e5ea1] {\n  position: -webkit-sticky;\n  position: sticky;\n  top: 48px;\n  z-index: 100;\n}\n\n.top-65[_v-335e5ea1] {\n  top: 65px;\n}\n\n.bg-top-1[_v-335e5ea1] {\n  background-color: #8497b0;\n  border-color: #8497b0;\n  color: #fff;\n}\n\n.bg-top-2[_v-335e5ea1] {\n  background-color: #adb9ca;\n  border-color: #adb9ca;\n  color: #fff;\n}\n\n.bg-top-3[_v-335e5ea1] {\n  background-color: #44546a;\n  border-color: #44546a;\n  color: #fff;\n}\n\n.bg-top-4[_v-335e5ea1] {\n  background-color: #d6dce5;\n  border-color: #d6dce5;\n  color: #fff;\n}\n\n[_v-335e5ea1]::-webkit-input-placeholder {\n  text-align: center;\n}\n\n[_v-335e5ea1]:-moz-placeholder { /* Firefox 18- */\n  text-align: center;\n}\n\n[_v-335e5ea1]::-moz-placeholder { /* Firefox 19+ */\n  text-align: center;\n}\n\n[_v-335e5ea1]:-ms-input-placeholder {\n  text-align: center;\n}\n\n.w-200[_v-335e5ea1] {\n  width: 200px !important;\n}\n\n@media (min-width: 769px) {\n  .modal-sm-custom[_v-335e5ea1] {\n    width: 500px;\n  }\n}\n\n\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, module.exports.template)
  }
})()}
},{"./../../mixed/modals":10,"./../../mixed/notify":11,"vue":5,"vue-hot-reload-api":4,"vueify-insert-css":6}],72:[function(require,module,exports){
var __vueify_style__ = require("vueify-insert-css").insert("\n.close-modal[_v-0295b084] {\n  font-size: 30px;\n  margin-top: -14.75px;\n  font-weight: 500;\n}\n\n.close-modal-29[_v-0295b084] {\n  font-size: 30px;\n  margin-top: -29.75px !important;\n  font-weight: 500;\n}\n\n.close-modal-0[_v-0295b084] {\n  font-size: 35px;\n  margin-top: 0 !important;\n  font-weight: 500;\n  z-index: 100;\n  color: #656565 !important;\n}\n\n.font-20[_v-0295b084] {\n  font-size: 20px;\n}\n\n.bg-slate-custom[_v-0295b084] {\n  background-color: #d6dce5;\n  border-color: #d6dce5;\n}\n\n.custom-header[_v-0295b084] {\n  position: -webkit-sticky;\n  position: sticky;\n  top: 48px;\n  z-index: 100;\n}\n\n.top-65[_v-0295b084] {\n  top: 65px;\n}\n\n.bg-top-1[_v-0295b084] {\n  background-color: #8497b0;\n  border-color: #8497b0;\n  color: #fff;\n}\n\n.bg-top-2[_v-0295b084] {\n  background-color: #adb9ca;\n  border-color: #adb9ca;\n  color: #fff;\n}\n\n.bg-top-3[_v-0295b084] {\n  background-color: #44546a;\n  border-color: #44546a;\n  color: #fff;\n}\n\n[_v-0295b084]::-webkit-input-placeholder {\n  text-align: center;\n}\n\n[_v-0295b084]:-moz-placeholder { /* Firefox 18- */\n  text-align: center;\n}\n\n[_v-0295b084]::-moz-placeholder { /* Firefox 19+ */\n  text-align: center;\n}\n\n[_v-0295b084]:-ms-input-placeholder {\n  text-align: center;\n}\n\n")
"use strict";

exports.__esModule = true;
var modals = require("./../../mixed/modals");
var notify = require("./../../mixed/notify");

exports["default"] = {
  data: function data() {
    return {
      employees: {},
      searchedEmployees: {},
      activeEmployee: {},
      jobs: {},
      clients: {},
      type: 0,
      availableJobs: {},
      selectedJObs: {},
      ids: [],
      all: false,
      primary_phone: '',
      new_pin: ''
    };
  },
  props: ['user'],
  filters: {},
  watch: {
    'query': function query(val, oldVal) {
      var regex = this.convertWildcardStringToRegExp(val);
      this.searchedEmployees = this.employees.filter(function (item) {
        return regex.test(item.first_name) || regex.test(item.middle_name) || regex.test(item.last_name) || regex.test(item.primary_phone) || regex.test(item.secondary_phone) || regex.test(item.pin);
      });
    }
  },
  ready: function ready() {
    this.getEmployees();
  },

  events: {},

  methods: {

    getEmployees: function getEmployees() {
      var _this = this;

      notify.loading(true);
      this.$http.get("/api/employee-settings-list", function (response) {
        _this.employees = response;
        _this.searchedEmployees = response;
        notify.loading(false);
      }).always(function () {});
    },

    updateCodeModal: function updateCodeModal(employee) {
      this.activeEmployee = _.cloneDeep(employee);
      modals.showStrict("#code-modal");
    },

    updateCode: function updateCode() {
      var _this2 = this;

      notify.loading(true);
      this.$http.post("/api/employee-settings-update-code", {
        user_id: this.activeEmployee.user_id,
        pin: this.new_pin
      }, function (response) {
        _this2.getEmployees();
        _this2.new_pin = '';
        modals.hide("#code-modal");
        notify.loading(false);
      }).always(function () {
        notify.loading(false);
      });
    },

    sortBy: function sortBy(field, reverse, primer) {
      var key = primer ? function (x) {
        return primer(x[field]);
      } : function (x) {
        return x[field];
      };

      reverse = !reverse ? 1 : -1;

      return function (a, b) {
        return a = key(a), b = key(b), reverse * ((a > b) - (b > a));
      };
    },

    sortUsers: function sortUsers(field, reverse) {
      var primer = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];

      console.log(field);
      this.sortOrders = reverse;
      this.sortKey = field;
      this.employees.sort(this.sortBy(field, reverse, primer));
    },

    escapeRegExp: function escapeRegExp(str) {
      return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    },

    convertWildcardStringToRegExp: function convertWildcardStringToRegExp(expression) {
      var terms = expression.split('*');

      var trailingWildcard = false;

      var expr = '';
      for (var i = 0; i < terms.length; i++) {
        if (terms[i]) {
          if (i > 0 && terms[i - 1]) {
            expr += '.*';
          }
          trailingWildcard = false;
          expr += this.escapeRegExp(terms[i]);
        } else {
          trailingWildcard = true;
          expr += '.*';
        }
      }

      if (!trailingWildcard) {
        expr += '.*';
      }

      return new RegExp('^' + expr + '$', 'i');
    }
  }
};
module.exports = exports["default"];
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n  <div class=\"row\" _v-0295b084=\"\">\n    <div class=\"col-md-12 col-sm-12 no-padding-left no-padding-right\" _v-0295b084=\"\">\n      <div class=\"col-md-12 col-sm-12  no-padding-left no-padding-right\" _v-0295b084=\"\">\n        <table class=\"table table-xxs\" _v-0295b084=\"\">\n          <thead class=\"header custom-header\" _v-0295b084=\"\">\n          <tr class=\"bg-top-1\" _v-0295b084=\"\">\n            <th class=\"text-center text-black p-5 font-20 pl-10\" colspan=\"4\" _v-0295b084=\"\">\n              EMPLOYEE TIME CLOCK CODE SEARCH\n            </th>\n          </tr>\n          <tr class=\"bg-top-2\" _v-0295b084=\"\">\n            <th class=\"text-center text-black p-5 font-20 pl-10\" colspan=\"4\" _v-0295b084=\"\">\n              <div class=\"row\" _v-0295b084=\"\">\n                <div class=\"col-md-4 col-sm-4\" _v-0295b084=\"\"></div>\n                <div class=\"col-md-4 col-sm-4  p-5\" _v-0295b084=\"\">\n                  <input type=\"text\" name=\"search\" v-model=\"query\" class=\"form-control\" placeholder=\"search employee\" _v-0295b084=\"\"></div>\n                <div class=\"col-md-4 col-sm-4\" _v-0295b084=\"\"></div>\n              </div>\n            </th>\n          </tr>\n          <tr _v-0295b084=\"\">\n            <th class=\"bg-top-3 text-center text-black text-uppercase \" _v-0295b084=\"\">\n              PHONE 1\n            </th>\n            <th class=\"bg-top-3 text-centertext-black cursor-pointer text-uppercase\" @click=\"sortUsers('name',!sortOrders)\" _v-0295b084=\"\">\n              PHONE 2\n              <i v-if=\"sortKey === 'name'\" :class=\"sortOrders ? 'fa fa-arrow-down':'fa fa-arrow-up'\" _v-0295b084=\"\"></i>\n            </th>\n            <th class=\"bg-top-3 text-left text-black cursor-pointer text-uppercase\" @click=\"sortUsers('custom_hire_date',!sortOrders)\" _v-0295b084=\"\">\n              NAME\n              <i v-if=\"sortKey === 'custom_hire_date'\" :class=\"sortOrders ? 'fa fa-arrow-down':'fa fa-arrow-up'\" _v-0295b084=\"\"></i>\n            </th>\n            <th class=\"bg-top-3 text-black text-center text-uppercase\" _v-0295b084=\"\">CODE</th>\n\n          </tr>\n          </thead>\n          <tbody _v-0295b084=\"\">\n          <tr v-for=\"employee in searchedEmployees\" _v-0295b084=\"\">\n            <td class=\"text-center\" _v-0295b084=\"\">{{ employee.primary_phone }}</td>\n            <td class=\"text-center\" _v-0295b084=\"\">{{ employee.secondary_phone }}</td>\n            <td class=\"text-left cursor-pointer\" @click=\"updateCodeModal(employee)\" _v-0295b084=\"\">{{ employee.name }}</td>\n            <td class=\"text-center cursor-pointer\" @click=\"updateCodeModal(employee)\" _v-0295b084=\"\">\n              {{ employee.pin }}\n            </td>\n          </tr>\n          </tbody>\n        </table>\n      </div>\n    </div>\n\n\n    <div id=\"code-modal\" aria-hidden=\"true\" aria-labelledby=\"exampleModalLabel\" class=\"modal fade\" role=\"dialog\" tabindex=\"-1\" _v-0295b084=\"\">\n      <div class=\"modal-dialog modal-sm\" role=\"document\" _v-0295b084=\"\">\n        <div class=\"modal-content modal-grey\" _v-0295b084=\"\">\n          <div class=\"modal-header no-padding bg-slate-700\" _v-0295b084=\"\">\n            <div class=\"col-md-12 col-sm-12 col-xs-12 p-5 text-black text-left bg-top-1 font-16\" _v-0295b084=\"\">Update Code\n            </div>\n            <button aria-label=\"Close\" class=\"close close-modal\" data-dismiss=\"modal\" type=\"button\" _v-0295b084=\"\">\n              <span aria-hidden=\"true\" _v-0295b084=\"\">×</span>\n            </button>\n          </div>\n          <div class=\"modal-body no-padding-left no-padding-right bg-top-2\" _v-0295b084=\"\">\n\n            <div class=\"col-md-12 p-5 font-16 text-center text-color-black bg-top-2\" _v-0295b084=\"\">\n              <div class=\"col-md-6 col-sm-6 text-right bg-top-2 text-color-black text-black\" _v-0295b084=\"\">\n                {{ activeEmployee.name }}\n              </div>\n              <div class=\"col-md-6 col-sm-6 text-right bg-top-2 text-color-black\" _v-0295b084=\"\"></div>\n            </div>\n\n            <div class=\"col-md-12 p-5 font-16 text-center text-color-black bg-top-2\" _v-0295b084=\"\">\n              <div class=\"col-md-6 col-sm-6 text-center bg-top-2 text-color-black \" _v-0295b084=\"\">Current Code</div>\n              <div class=\"col-md-6 col-sm-6 text-center bg-top-2 text-color-black\" _v-0295b084=\"\">{{ activeEmployee.pin }}</div>\n            </div>\n\n            <div class=\"col-md-12 p-5 font-16 text-center text-color-black bg-top-2\" _v-0295b084=\"\">\n              <div class=\"col-md-6 col-sm-6 text-center bg-top-2 text-color-black \" _v-0295b084=\"\">New Code</div>\n              <div class=\"col-md-6 col-sm-6 text-right bg-top-2 text-color-black\" _v-0295b084=\"\">\n                <input type=\"text\" class=\"form-control\" v-model=\"new_pin\" _v-0295b084=\"\">\n              </div>\n            </div>\n\n\n            <div class=\"col-md-12 p-5 font-16 text-center text-color-black bg-top-2\" _v-0295b084=\"\">\n              <div class=\"col-md-6 col-sm-6 text-center bg-top-2 text-color-black \" _v-0295b084=\"\"></div>\n              <div class=\"col-md-6 col-sm-6 text-right bg-top-2 text-color-black\" _v-0295b084=\"\">\n                <button class=\"btn btn-primary border-2 border-white text-black\" @click=\"updateCode\" _v-0295b084=\"\">SUBMIT\n                </button>\n              </div>\n            </div>\n\n          </div>\n          <div class=\"modal-footer no-padding-bottom\" _v-0295b084=\"\">\n            <!--            <button class=\"btn btn-secondary\" data-dismiss=\"modal\" type=\"button\">Close</button>-->\n            <!--            <button class=\"btn btn-primary\" type=\"button\">Save changes</button>-->\n          </div>\n        </div>\n      </div>\n    </div>\n\n  </div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  var id = "/home/shoieb/sites/elegant/resources/assets/js/vue/components/settings-employee.vue"
  module.hot.dispose(function () {
    require("vueify-insert-css").cache["\n.close-modal[_v-0295b084] {\n  font-size: 30px;\n  margin-top: -14.75px;\n  font-weight: 500;\n}\n\n.close-modal-29[_v-0295b084] {\n  font-size: 30px;\n  margin-top: -29.75px !important;\n  font-weight: 500;\n}\n\n.close-modal-0[_v-0295b084] {\n  font-size: 35px;\n  margin-top: 0 !important;\n  font-weight: 500;\n  z-index: 100;\n  color: #656565 !important;\n}\n\n.font-20[_v-0295b084] {\n  font-size: 20px;\n}\n\n.bg-slate-custom[_v-0295b084] {\n  background-color: #d6dce5;\n  border-color: #d6dce5;\n}\n\n.custom-header[_v-0295b084] {\n  position: -webkit-sticky;\n  position: sticky;\n  top: 48px;\n  z-index: 100;\n}\n\n.top-65[_v-0295b084] {\n  top: 65px;\n}\n\n.bg-top-1[_v-0295b084] {\n  background-color: #8497b0;\n  border-color: #8497b0;\n  color: #fff;\n}\n\n.bg-top-2[_v-0295b084] {\n  background-color: #adb9ca;\n  border-color: #adb9ca;\n  color: #fff;\n}\n\n.bg-top-3[_v-0295b084] {\n  background-color: #44546a;\n  border-color: #44546a;\n  color: #fff;\n}\n\n[_v-0295b084]::-webkit-input-placeholder {\n  text-align: center;\n}\n\n[_v-0295b084]:-moz-placeholder { /* Firefox 18- */\n  text-align: center;\n}\n\n[_v-0295b084]::-moz-placeholder { /* Firefox 19+ */\n  text-align: center;\n}\n\n[_v-0295b084]:-ms-input-placeholder {\n  text-align: center;\n}\n\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, module.exports.template)
  }
})()}
},{"./../../mixed/modals":10,"./../../mixed/notify":11,"vue":5,"vue-hot-reload-api":4,"vueify-insert-css":6}],73:[function(require,module,exports){
var __vueify_style__ = require("vueify-insert-css").insert("\n.close-modal[_v-7ab94964] {\n  font-size: 30px;\n  margin-top: -14.75px;\n  font-weight: 500;\n}\n\n.close-modal-29[_v-7ab94964] {\n  font-size: 30px;\n  margin-top: -29.75px !important;\n  font-weight: 500;\n}\n\n.close-modal-0[_v-7ab94964] {\n  font-size: 35px;\n  margin-top: 0 !important;\n  font-weight: 500;\n  z-index: 100;\n  color: #656565 !important;\n}\n\n.font-20[_v-7ab94964] {\n  font-size: 20px;\n}\n\n.bg-slate-custom[_v-7ab94964] {\n  background-color: #d6dce5;\n  border-color: #d6dce5;\n}\n\n.custom-header[_v-7ab94964] {\n  position: -webkit-sticky;\n  position: sticky;\n  top: 48px;\n  z-index: 100;\n}\n\n.top-65[_v-7ab94964] {\n  top: 65px;\n}\n\n.bg-top-1[_v-7ab94964] {\n  background-color: #8497b0;\n  border-color: #8497b0;\n  color: #fff;\n}\n\n.bg-top-2[_v-7ab94964] {\n  background-color: #adb9ca;\n  border-color: #adb9ca;\n  color: #fff;\n}\n\n.bg-top-3[_v-7ab94964] {\n  background-color: #44546a;\n  border-color: #44546a;\n  color: #fff;\n}\n\n[_v-7ab94964]::-webkit-input-placeholder {\n  text-align: center;\n}\n\n[_v-7ab94964]:-moz-placeholder { /* Firefox 18- */\n  text-align: center;\n}\n\n[_v-7ab94964]::-moz-placeholder { /* Firefox 19+ */\n  text-align: center;\n}\n\n[_v-7ab94964]:-ms-input-placeholder {\n  text-align: center;\n}\n\n")
"use strict";

exports.__esModule = true;
var modals = require("./../../mixed/modals");
var notify = require("./../../mixed/notify");

exports["default"] = {
  data: function data() {
    return {
      entries: {},
      searchedEntries: {},
      query: '',
      activeEntry: {}
    };
  },
  props: ['user'],
  filters: {},
  watch: {
    'query': function query(val, oldVal) {
      var regex = this.convertWildcardStringToRegExp(val);
      this.searchedEntries = this.entries.filter(function (item) {
        return regex.test(item.client);
      });
    }
  },
  ready: function ready() {
    this.getReportData();
  },

  events: {},

  methods: {

    getReportData: function getReportData() {
      var _this = this;

      notify.loading(true);
      this.$http.get("/api/time-sheet-report-log-data", function (response) {
        _this.entries = response;
        _this.searchedEntries = response;
        notify.loading(false);
      }).always(function () {});
    },

    showPendingList: function showPendingList(entry) {
      this.activeEntry = entry;
      modals.showStrict("#pending-list-modal");
    },

    sortBy: function sortBy(field, reverse, primer) {
      var key = primer ? function (x) {
        return primer(x[field]);
      } : function (x) {
        return x[field];
      };

      reverse = !reverse ? 1 : -1;

      return function (a, b) {
        return a = key(a), b = key(b), reverse * ((a > b) - (b > a));
      };
    },

    sortUsers: function sortUsers(field, reverse) {
      var primer = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];

      this.sortOrders = reverse;
      this.sortKey = field;
      this.entries.sort(this.sortBy(field, reverse, primer));
    },

    escapeRegExp: function escapeRegExp(str) {
      return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    },

    convertWildcardStringToRegExp: function convertWildcardStringToRegExp(expression) {
      var terms = expression.split('*');

      var trailingWildcard = false;

      var expr = '';
      for (var i = 0; i < terms.length; i++) {
        if (terms[i]) {
          if (i > 0 && terms[i - 1]) {
            expr += '.*';
          }
          trailingWildcard = false;
          expr += this.escapeRegExp(terms[i]);
        } else {
          trailingWildcard = true;
          expr += '.*';
        }
      }

      if (!trailingWildcard) {
        expr += '.*';
      }

      return new RegExp('^' + expr + '$', 'i');
    }
  }
};
module.exports = exports["default"];
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n  <div class=\"row\" _v-7ab94964=\"\">\n    <div class=\"col-md-12 col-sm-12 no-padding-left no-padding-right\" _v-7ab94964=\"\">\n      <div class=\"col-md-12 col-sm-12  no-padding-left no-padding-right\" _v-7ab94964=\"\">\n        <table class=\"table table-xxs\" _v-7ab94964=\"\">\n          <thead class=\"header custom-header\" _v-7ab94964=\"\">\n          <tr class=\"bg-top-1\" _v-7ab94964=\"\">\n            <th class=\"text-center text-black p-5 font-20 pl-10\" colspan=\"5\" _v-7ab94964=\"\">\n              TIME CLOCK REPORT LOG\n            </th>\n          </tr>\n          <tr class=\"bg-top-2\" _v-7ab94964=\"\">\n            <th class=\"text-center text-black p-5 font-20 pl-10\" colspan=\"5\" _v-7ab94964=\"\">\n              <div class=\"row\" _v-7ab94964=\"\">\n                <div class=\"col-md-4 col-sm-4\" _v-7ab94964=\"\"></div>\n                <div class=\"col-md-4 col-sm-4  p-5\" _v-7ab94964=\"\">\n                  <input type=\"text\" name=\"search\" class=\"form-control\" placeholder=\"search client\" v-model=\"query\" _v-7ab94964=\"\"></div>\n                <div class=\"col-md-4 col-sm-4\" _v-7ab94964=\"\"></div>\n              </div>\n            </th>\n          </tr>\n          <tr _v-7ab94964=\"\">\n            <th class=\"bg-top-3 text-left text-black text-uppercase \" _v-7ab94964=\"\">\n              REPORT DATE\n            </th>\n            <th class=\"bg-top-3 text-left text-black cursor-pointer text-uppercase\" @click=\"sortUsers('date',!sortOrders)\" _v-7ab94964=\"\">\n              CLIENT NAME\n              <i v-if=\"sortKey === 'client'\" :class=\"sortOrders ? 'fa fa-arrow-down':'fa fa-arrow-up'\" _v-7ab94964=\"\"></i>\n            </th>\n            <th class=\"bg-top-3 text-black text-center text-uppercase\" _v-7ab94964=\"\">APPROVED</th>\n            <th class=\"bg-top-3 text-black text-center text-uppercase\" _v-7ab94964=\"\">PENDING</th>\n            <th class=\"bg-top-3 text-black text-center text-uppercase\" _v-7ab94964=\"\">ERROR</th>\n\n          </tr>\n          </thead>\n          <tbody _v-7ab94964=\"\">\n          <tr v-for=\"(index,entry) in searchedEntries\" :key=\"index\" _v-7ab94964=\"\">\n            <td class=\"text-left cursor-pointer\" _v-7ab94964=\"\">{{ entry.date }}</td>\n            <td class=\"text-left cursor-pointer\" @click=\"showPendingList(entry)\" _v-7ab94964=\"\">{{ entry.client }}</td>\n            <td class=\"text-center\" _v-7ab94964=\"\">{{ entry.approved }}</td>\n            <td class=\"text-center cursor-pointer\" @click=\"showPendingList(entry)\" _v-7ab94964=\"\">\n              {{ entry.pending }}\n            </td>\n            <td class=\"text-center\" _v-7ab94964=\"\"></td>\n          </tr>\n          </tbody>\n        </table>\n      </div>\n    </div>\n\n\n    <div id=\"pending-list-modal\" aria-hidden=\"true\" aria-labelledby=\"exampleModalLabel\" class=\"modal fade\" role=\"dialog\" tabindex=\"-1\" _v-7ab94964=\"\">\n      <div class=\"modal-dialog modal-lg\" role=\"document\" _v-7ab94964=\"\">\n        <div class=\"modal-content\" _v-7ab94964=\"\">\n          <div class=\"modal-header no-padding\" _v-7ab94964=\"\">\n            <div class=\"\n                col-md-12 col-sm-12 col-xs-12\n                p-10\n                text-black text-center\n                font-16\n                bg-slate-700\n              \" _v-7ab94964=\"\">\n              Pending Approval List For {{ activeEntry.client }}\n            </div>\n            <!--            <div-->\n            <!--                class=\"-->\n            <!--                col-md-12 col-sm-12 col-xs-12-->\n            <!--                p-5-->\n            <!--                text-black-->\n            <!--                bg-slate-400-->\n            <!--                text-color-black text-center-->\n            <!--                font-16-->\n            <!--              \"-->\n            <!--            >-->\n            <!--              {{ activeEntry.client }}-->\n            <!--            </div>-->\n            <button aria-label=\"Close\" class=\"close close-modal-29 pt-10\" data-dismiss=\"modal\" type=\"button\" _v-7ab94964=\"\">\n              <span aria-hidden=\"true\" _v-7ab94964=\"\">×</span>\n            </button>\n          </div>\n          <div class=\"modal-body no-padding-left no-padding-right\" _v-7ab94964=\"\">\n            <table class=\"table table-bordered\" _v-7ab94964=\"\">\n              <thead _v-7ab94964=\"\">\n              <tr _v-7ab94964=\"\">\n                <td class=\"text-black text-left\" _v-7ab94964=\"\">Name</td>\n                <td class=\"text-black text-center\" _v-7ab94964=\"\">Date</td>\n                <td class=\"text-black text-center\" _v-7ab94964=\"\">In Time</td>\n                <td class=\"text-black text-center\" _v-7ab94964=\"\">Out Time</td>\n                <td class=\"text-black text-center\" _v-7ab94964=\"\">Break</td>\n              </tr>\n              </thead>\n              <tbody _v-7ab94964=\"\">\n              <tr v-for=\"(index,entry) in activeEntry.pendingList\" :key=\"index\" _v-7ab94964=\"\">\n                <td class=\"text-left\" _v-7ab94964=\"\">{{ entry.employee_name }}</td>\n                <td class=\"text-center\" _v-7ab94964=\"\">{{ entry.date }}</td>\n                <td class=\"text-center\" _v-7ab94964=\"\">{{ entry.in_time }}</td>\n                <td class=\"text-center\" _v-7ab94964=\"\">{{ entry.out_time }}</td>\n                <td class=\"text-center\" _v-7ab94964=\"\">{{ entry.break_duration }}</td>\n              </tr>\n              </tbody>\n            </table>\n          </div>\n          <div class=\"modal-footer no-padding-bottom\" _v-7ab94964=\"\">\n            <!--            <button class=\"btn btn-secondary\" data-dismiss=\"modal\" type=\"button\">Close</button>-->\n            <!--            <button class=\"btn btn-primary\" type=\"button\">Save changes</button>-->\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  var id = "/home/shoieb/sites/elegant/resources/assets/js/vue/components/settings-time-clock-report-log.vue"
  module.hot.dispose(function () {
    require("vueify-insert-css").cache["\n.close-modal[_v-7ab94964] {\n  font-size: 30px;\n  margin-top: -14.75px;\n  font-weight: 500;\n}\n\n.close-modal-29[_v-7ab94964] {\n  font-size: 30px;\n  margin-top: -29.75px !important;\n  font-weight: 500;\n}\n\n.close-modal-0[_v-7ab94964] {\n  font-size: 35px;\n  margin-top: 0 !important;\n  font-weight: 500;\n  z-index: 100;\n  color: #656565 !important;\n}\n\n.font-20[_v-7ab94964] {\n  font-size: 20px;\n}\n\n.bg-slate-custom[_v-7ab94964] {\n  background-color: #d6dce5;\n  border-color: #d6dce5;\n}\n\n.custom-header[_v-7ab94964] {\n  position: -webkit-sticky;\n  position: sticky;\n  top: 48px;\n  z-index: 100;\n}\n\n.top-65[_v-7ab94964] {\n  top: 65px;\n}\n\n.bg-top-1[_v-7ab94964] {\n  background-color: #8497b0;\n  border-color: #8497b0;\n  color: #fff;\n}\n\n.bg-top-2[_v-7ab94964] {\n  background-color: #adb9ca;\n  border-color: #adb9ca;\n  color: #fff;\n}\n\n.bg-top-3[_v-7ab94964] {\n  background-color: #44546a;\n  border-color: #44546a;\n  color: #fff;\n}\n\n[_v-7ab94964]::-webkit-input-placeholder {\n  text-align: center;\n}\n\n[_v-7ab94964]:-moz-placeholder { /* Firefox 18- */\n  text-align: center;\n}\n\n[_v-7ab94964]::-moz-placeholder { /* Firefox 19+ */\n  text-align: center;\n}\n\n[_v-7ab94964]:-ms-input-placeholder {\n  text-align: center;\n}\n\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, module.exports.template)
  }
})()}
},{"./../../mixed/modals":10,"./../../mixed/notify":11,"vue":5,"vue-hot-reload-api":4,"vueify-insert-css":6}],74:[function(require,module,exports){
var __vueify_style__ = require("vueify-insert-css").insert("\n.close-modal[_v-d4d79138] {\n  font-size: 30px;\n  margin-top: -14.75px;\n  font-weight: 500;\n}\n\n.close-modal-29[_v-d4d79138] {\n  font-size: 30px;\n  margin-top: -29.75px !important;\n  font-weight: 500;\n}\n\n.close-modal-15[_v-d4d79138] {\n  font-size: 30px;\n  margin-top: -15.75px !important;\n  font-weight: 500;\n}\n\n.close-modal-0[_v-d4d79138] {\n  font-size: 35px;\n  margin-top: 0 !important;\n  font-weight: 500;\n  z-index: 100;\n  color: #656565 !important;\n}\n\n.font-20[_v-d4d79138] {\n  font-size: 20px;\n}\n\n.bg-slate-custom[_v-d4d79138] {\n  background-color: #d6dce5;\n  border-color: #d6dce5;\n}\n\n.custom-header[_v-d4d79138] {\n  position: -webkit-sticky;\n  position: sticky;\n  top: 48px;\n  z-index: 100;\n}\n\n.top-65[_v-d4d79138] {\n  top: 65px;\n}\n\n.bg-top-1[_v-d4d79138] {\n  background-color: #8497b0;\n  border-color: #8497b0;\n  color: #fff;\n}\n\n.bg-top-2[_v-d4d79138] {\n  background-color: #adb9ca;\n  border-color: #adb9ca;\n  color: #fff;\n}\n\n.bg-top-3[_v-d4d79138] {\n  background-color: #44546a;\n  border-color: #44546a;\n  color: #fff;\n}\n\n.bg-top-4[_v-d4d79138] {\n  background-color: #d6dce5;\n  border-color: #d6dce5;\n  color: #fff;\n}\n\n[_v-d4d79138]::-webkit-input-placeholder {\n  text-align: center;\n}\n\n[_v-d4d79138]:-moz-placeholder { /* Firefox 18- */\n  text-align: center;\n}\n\n[_v-d4d79138]::-moz-placeholder { /* Firefox 19+ */\n  text-align: center;\n}\n\n[_v-d4d79138]:-ms-input-placeholder {\n  text-align: center;\n}\n\n.w-200[_v-d4d79138] {\n  width: 200px !important;\n}\n\n@media (min-width: 769px) {\n  .modal-sm-custom[_v-d4d79138] {\n    width: 500px;\n  }\n}\n\n.pr-80[_v-d4d79138] {\n  padding-right: 80px\n}\n")
"use strict";

exports.__esModule = true;
var modals = require("./../../mixed/modals");
var notify = require("./../../mixed/notify");

exports["default"] = {
  data: function data() {
    return {
      clients: {},
      searchedClients: {},
      activeClient: {},
      positions: {},
      contacts: {},
      jobs: {},
      type: 0,
      availableJobs: {},
      selectedJObs: {},
      ids: [],
      all: false,
      primary_phone: ''
    };
  },
  props: ['user'],
  filters: {},
  watch: {
    'all': function all(val, oldVal) {
      this.getClients(val ? 1 : 0);
    }
  },
  ready: function ready() {
    this.getClients();
  },

  events: {},

  methods: {

    getClients: function getClients() {
      var _this = this;

      notify.loading(true);
      this.$http.get("/api/permission-settings-list", function (response) {
        _this.clients = response;
        _this.searchedClients = response;
        notify.loading(false);
      }).always(function () {});
    },

    getPositions: function getPositions() {},

    jobsModal: function jobsModal(client) {
      var _this2 = this;

      this.positions = {};
      this.activeClient = _.cloneDeep(client);
      notify.loading(true);
      this.$http.get("/api/permission-settings-positions-list/" + this.activeClient.id, function (response) {
        _this2.positions = response;
        notify.loading(false);
        modals.showStrict("#jobs-modal");
      }).always(function () {});
    },

    updatePositionsTimeClockStatus: function updatePositionsTimeClockStatus() {
      var _this3 = this;

      notify.loading(true);
      this.$http.post("/api/permission-settings-update-positions-status", {
        positions: this.positions
      }, function (response) {
        notify.loading(false);
        modals.hide("#jobs-modal");
        _this3.positions = {};
        _this3.getClients();
      }).always(function () {});
    },

    managerModal: function managerModal(client) {
      var _this4 = this;

      this.positions = {};
      this.activeClient = _.cloneDeep(client);
      notify.loading(true);
      this.$http.get("/api/permission-settings-contacts-list/" + this.activeClient.id, function (response) {
        _this4.contacts = response;
        notify.loading(false);
        modals.showStrict("#manager-modal");
      }).always(function () {});
    },

    updateContactsTimeClockStatus: function updateContactsTimeClockStatus() {
      var _this5 = this;

      notify.loading(true);
      this.$http.post("/api/permission-settings-update-contacts-status", {
        contacts: this.contacts
      }, function (response) {
        notify.loading(false);
        modals.hide("#manager-modal");
        _this5.contacts = {};
        _this5.getClients();
      }).always(function () {});
    },

    sortBy: function sortBy(field, reverse, primer) {
      var key = primer ? function (x) {
        return primer(x[field]);
      } : function (x) {
        return x[field];
      };

      reverse = !reverse ? 1 : -1;

      return function (a, b) {
        return a = key(a), b = key(b), reverse * ((a > b) - (b > a));
      };
    },

    sortUsers: function sortUsers(field, reverse) {
      var primer = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];

      console.log(field);
      this.sortOrders = reverse;
      this.sortKey = field;
      this.employees.sort(this.sortBy(field, reverse, primer));
    },

    sendInvitation: function sendInvitation(id) {
      if (!id) {
        notify.info("Please set user account before sending invitation.");

        return false;
      }
      notify.loading(true);
      this.$http.get('/api/send-manager-invitation/' + id, function (response) {
        //modals.hide("#modal-edit-employee-info");
      }).always(function () {
        notify.loading(false);
      });
    }
  }
};
module.exports = exports["default"];
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n  <div class=\"row\" _v-d4d79138=\"\">\n    <div class=\"col-md-12 col-sm-12 no-padding-left no-padding-right\" _v-d4d79138=\"\">\n      <div class=\"col-md-12 col-sm-12  no-padding-left no-padding-right\" _v-d4d79138=\"\">\n        <table class=\"table table-xxs\" _v-d4d79138=\"\">\n          <thead class=\"header custom-header\" _v-d4d79138=\"\">\n          <tr class=\"bg-top-1\" _v-d4d79138=\"\">\n            <th class=\"text-center text-black p-5 font-20 pl-10\" colspan=\"3\" _v-d4d79138=\"\">\n              MANAGE TIME CLOCK PERMISSIONS\n            </th>\n          </tr>\n          <tr _v-d4d79138=\"\">\n            <th class=\"bg-top-3 text-left text-black text-uppercase\" _v-d4d79138=\"\">\n              ACTIVE CLIENT LIST\n            </th>\n            <th class=\"bg-top-3 text-center text-black cursor-pointer text-uppercase\" _v-d4d79138=\"\">\n              ENABLED JOBS\n            </th>\n            <th class=\"bg-top-3 text-black text-center text-uppercase\" _v-d4d79138=\"\">PERMITTED MANAGERS</th>\n\n          </tr>\n          </thead>\n          <tbody _v-d4d79138=\"\">\n          <tr v-for=\"client in clients\" _v-d4d79138=\"\">\n            <td class=\"text-leftcursor-pointer\" _v-d4d79138=\"\"> {{ client.name }}</td>\n            <td class=\"text-center cursor-pointer\" @click=\"jobsModal(client)\" _v-d4d79138=\"\">{{ client.active_position_count }} /\n              {{ client.position_count }}\n            </td>\n            <td class=\"text-center cursor-pointer\" @click=\"managerModal(client)\" _v-d4d79138=\"\">{{ client.active_contacts_count }} /\n              {{ client.contacts_count }}\n            </td>\n          </tr>\n          </tbody>\n        </table>\n      </div>\n    </div>\n\n\n    <div id=\"jobs-modal\" aria-hidden=\"true\" aria-labelledby=\"exampleModalLabel\" class=\"modal fade\" role=\"dialog\" tabindex=\"-1\" _v-d4d79138=\"\">\n      <div class=\"modal-dialog modal-sm-custom\" role=\"document\" _v-d4d79138=\"\">\n        <div class=\"modal-content modal-grey\" _v-d4d79138=\"\">\n          <div class=\"modal-header no-padding bg-slate-700\" _v-d4d79138=\"\">\n            <div class=\"col-md-12 col-sm-12 col-xs-12 p-5 text-center bg-top-2 font-16\" _v-d4d79138=\"\"> {{ activeClient.name }}\n            </div>\n            <button aria-label=\"Close\" class=\"close close-modal\" data-dismiss=\"modal\" type=\"button\" _v-d4d79138=\"\">\n              <span aria-hidden=\"true\" _v-d4d79138=\"\">×</span>\n            </button>\n          </div>\n          <div class=\"modal-body no-padding-left no-padding-right no-padding-top\" _v-d4d79138=\"\">\n            <div class=\"col-md-12  font-12 text-center text-color-black no-padding-left no-padding-right\" _v-d4d79138=\"\">\n              <table class=\"table table-xxs\" _v-d4d79138=\"\">\n                <thead class=\"header custom-header\" _v-d4d79138=\"\">\n                <tr _v-d4d79138=\"\">\n                  <th class=\"bg-top-3 text-left text-black text-uppercase\" _v-d4d79138=\"\">\n                    JOB POSITION\n                  </th>\n                  <th class=\"bg-top-3 text-black text-center text-uppercase\" _v-d4d79138=\"\">ENABLED</th>\n\n                </tr>\n                </thead>\n                <tbody _v-d4d79138=\"\">\n                <tr v-for=\"position in positions\" _v-d4d79138=\"\">\n                  <td class=\"text-left cursor-pointer\" _v-d4d79138=\"\">{{ position.title }}</td>\n                  <td class=\"text-center\" _v-d4d79138=\"\"><input type=\"checkbox\" name=\"job\" v-model=\"position.time_clock_status\" _v-d4d79138=\"\"></td>\n                </tr>\n                </tbody>\n              </table>\n            </div>\n\n            <div class=\"col-md-12 p-5 font-16 text-right text-color-black p-5 bg-top-2 p-20\" _v-d4d79138=\"\">\n              <div class=\"col-md-6\" _v-d4d79138=\"\"></div>\n              <div class=\"col-md-6 text-center\" _v-d4d79138=\"\">\n                <button class=\"btn btn-primary  border-2 border-white text-black pr-10 mr-10\" @click=\"updatePositionsTimeClockStatus()\" _v-d4d79138=\"\">SAVE\n                </button>\n              </div>\n            </div>\n\n          </div>\n          <div class=\"modal-footer no-padding-bottom\" _v-d4d79138=\"\">\n            <!--            <button class=\"btn btn-secondary\" data-dismiss=\"modal\" type=\"button\">Close</button>-->\n            <!--            <button class=\"btn btn-primary\" type=\"button\">Save changes</button>-->\n          </div>\n        </div>\n      </div>\n    </div>\n\n\n    <div id=\"manager-modal\" aria-hidden=\"true\" aria-labelledby=\"exampleModalLabel\" class=\"modal fade\" role=\"dialog\" tabindex=\"-1\" _v-d4d79138=\"\">\n      <div class=\"modal-dialog modal-medium\" role=\"document\" _v-d4d79138=\"\">\n        <div class=\"modal-content modal-grey\" _v-d4d79138=\"\">\n          <div class=\"modal-header no-padding bg-slate-700\" _v-d4d79138=\"\">\n            <div class=\"col-md-12 col-sm-12 col-xs-12 p-5 text-center bg-top-2 font-16\" _v-d4d79138=\"\">\n              <span class=\"pull-left pl-20\" _v-d4d79138=\"\">{{ activeClient.name }}</span>\n              <span class=\"pull-right pr-80 mr-20\" _v-d4d79138=\"\">Manager's Permit Control</span>\n            </div>\n            <button aria-label=\"Close\" class=\"close close-modal-15\" data-dismiss=\"modal\" type=\"button\" _v-d4d79138=\"\">\n              <span aria-hidden=\"true\" _v-d4d79138=\"\">×</span>\n            </button>\n          </div>\n          <div class=\"modal-body no-padding-left no-padding-right no-padding-top border-2 border-top border-white\" _v-d4d79138=\"\">\n            <div class=\"col-md-12  font-12 text-center text-color-black no-padding-left no-padding-right\" _v-d4d79138=\"\">\n              <table class=\"table table-xxs\" _v-d4d79138=\"\">\n                <thead class=\"header custom-header\" _v-d4d79138=\"\">\n                <tr _v-d4d79138=\"\">\n                  <th class=\"bg-top-3 text-left text-black text-uppercase\" _v-d4d79138=\"\">MANAGER'S NAME</th>\n                  <th class=\"bg-top-3 text-black text-left text-uppercase\" _v-d4d79138=\"\">TITLE</th>\n                  <th class=\"bg-top-3 text-left text-black text-uppercase\" _v-d4d79138=\"\">EMAIL</th>\n                  <th class=\"bg-top-3 text-black text-center text-uppercase\" _v-d4d79138=\"\">NOTIFICATION</th>\n                  <th class=\"bg-top-3 text-center text-black text-uppercase\" _v-d4d79138=\"\">TAB CONTROL</th>\n                  <th class=\"bg-top-3 text-black text-center text-uppercase\" _v-d4d79138=\"\">PASS/PIN</th>\n                  <th class=\"bg-top-3 text-center text-black text-uppercase\" _v-d4d79138=\"\">SEND LINK</th>\n\n                </tr>\n                </thead>\n                <tbody _v-d4d79138=\"\">\n                <tr v-for=\"contact in contacts\" _v-d4d79138=\"\">\n                  <td class=\"text-left cursor-pointer\" _v-d4d79138=\"\">{{ contact.name }}</td>\n                  <td class=\"text-left cursor-pointer\" _v-d4d79138=\"\">{{ contact.job_title }}</td>\n                  <td class=\"text-left cursor-pointer\" _v-d4d79138=\"\">{{ contact.email }}</td>\n                  <td class=\"text-center cursor-pointer\" _v-d4d79138=\"\"><input type=\"checkbox\" :disabled=\"!contact.email\" v-model=\"contact.email_status\" _v-d4d79138=\"\"></td>\n                  <td class=\"text-center cursor-pointer\" _v-d4d79138=\"\"><input type=\"checkbox\" :disabled=\"!contact.email\" v-model=\"contact.time_clock_status\" _v-d4d79138=\"\">\n                  </td>\n                  <td class=\"text-center cursor-pointer\" _v-d4d79138=\"\">\n                    <span v-if=\"contact.email\" class=\"text-success text-black\" _v-d4d79138=\"\">Set</span>\n                    <span v-if=\"!contact.email\" class=\"text-danger text-black\" _v-d4d79138=\"\"><i class=\"fa fa-close\" _v-d4d79138=\"\"></i></span>\n                  </td>\n                  <td class=\"text-center cursor-pointer\" _v-d4d79138=\"\"><span @click=\"sendInvitation(contact.user_id)\" class=\"text-primary text-black\" _v-d4d79138=\"\"><i class=\"fa fa-inbox\" _v-d4d79138=\"\"></i></span></td>\n                </tr>\n                </tbody>\n              </table>\n            </div>\n\n            <div class=\"col-md-12 p-5 font-16 text-right text-color-black p-5 bg-top-2 p-10\" _v-d4d79138=\"\">\n              <div class=\"col-md-6\" _v-d4d79138=\"\"></div>\n              <div class=\"col-md-6 text-right\" _v-d4d79138=\"\">\n                <button class=\"btn btn-primary  border-2 border-white text-black pr-10 mr-10\" @click=\"updateContactsTimeClockStatus()\" _v-d4d79138=\"\">SAVE\n                </button>\n              </div>\n            </div>\n\n          </div>\n          <div class=\"modal-footer no-padding-bottom\" _v-d4d79138=\"\">\n            <!--            <button class=\"btn btn-secondary\" data-dismiss=\"modal\" type=\"button\">Close</button>-->\n            <!--            <button class=\"btn btn-primary\" type=\"button\">Save changes</button>-->\n          </div>\n        </div>\n      </div>\n    </div>\n\n\n  </div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  var id = "/home/shoieb/sites/elegant/resources/assets/js/vue/components/settings-time-clock.vue"
  module.hot.dispose(function () {
    require("vueify-insert-css").cache["\n.close-modal[_v-d4d79138] {\n  font-size: 30px;\n  margin-top: -14.75px;\n  font-weight: 500;\n}\n\n.close-modal-29[_v-d4d79138] {\n  font-size: 30px;\n  margin-top: -29.75px !important;\n  font-weight: 500;\n}\n\n.close-modal-15[_v-d4d79138] {\n  font-size: 30px;\n  margin-top: -15.75px !important;\n  font-weight: 500;\n}\n\n.close-modal-0[_v-d4d79138] {\n  font-size: 35px;\n  margin-top: 0 !important;\n  font-weight: 500;\n  z-index: 100;\n  color: #656565 !important;\n}\n\n.font-20[_v-d4d79138] {\n  font-size: 20px;\n}\n\n.bg-slate-custom[_v-d4d79138] {\n  background-color: #d6dce5;\n  border-color: #d6dce5;\n}\n\n.custom-header[_v-d4d79138] {\n  position: -webkit-sticky;\n  position: sticky;\n  top: 48px;\n  z-index: 100;\n}\n\n.top-65[_v-d4d79138] {\n  top: 65px;\n}\n\n.bg-top-1[_v-d4d79138] {\n  background-color: #8497b0;\n  border-color: #8497b0;\n  color: #fff;\n}\n\n.bg-top-2[_v-d4d79138] {\n  background-color: #adb9ca;\n  border-color: #adb9ca;\n  color: #fff;\n}\n\n.bg-top-3[_v-d4d79138] {\n  background-color: #44546a;\n  border-color: #44546a;\n  color: #fff;\n}\n\n.bg-top-4[_v-d4d79138] {\n  background-color: #d6dce5;\n  border-color: #d6dce5;\n  color: #fff;\n}\n\n[_v-d4d79138]::-webkit-input-placeholder {\n  text-align: center;\n}\n\n[_v-d4d79138]:-moz-placeholder { /* Firefox 18- */\n  text-align: center;\n}\n\n[_v-d4d79138]::-moz-placeholder { /* Firefox 19+ */\n  text-align: center;\n}\n\n[_v-d4d79138]:-ms-input-placeholder {\n  text-align: center;\n}\n\n.w-200[_v-d4d79138] {\n  width: 200px !important;\n}\n\n@media (min-width: 769px) {\n  .modal-sm-custom[_v-d4d79138] {\n    width: 500px;\n  }\n}\n\n.pr-80[_v-d4d79138] {\n  padding-right: 80px\n}\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, module.exports.template)
  }
})()}
},{"./../../mixed/modals":10,"./../../mixed/notify":11,"vue":5,"vue-hot-reload-api":4,"vueify-insert-css":6}],75:[function(require,module,exports){
var __vueify_style__ = require("vueify-insert-css").insert("\n.re-confirm > div.col-md-12,\n.re-confirm > div.col-md-6,\n.re-confirm > div.col-md-12 {\n  padding: 0 !important;\n}\n\n.bordered-div {\n  border-left: 1px solid #ddd;\n  border-right: 1px solid #ddd;\n}\n\n.bordered-left {\n  border-left: 1px solid #ddd;\n}\n\n.bordered-right {\n  border-right: 1px solid #ddd;\n}\n\n.bordered-bottom {\n  border-bottom: 1px solid #ddd;\n}\n\n.fixed-header {\n  position: fixed;\n  top: 48px;\n  right: 0px;\n  z-index: 1000 !important;\n}\n\n.tab-div {\n  width: 100% !important;\n  text-align: center;\n}\n\n.div-20 {\n  width: 20% !important;\n}\n\n.div-100 {\n  width: 100% !important;\n}\n\n.top-90 {\n  top: 90px;\n}\n\n.list-div {\n  margin-bottom: 40px;\n  min-height: 900px !important;\n}\n\n.bottom-div {\n  position: fixed;\n  bottom: 0px;\n  right: 0px;\n  z-index: 1000 !important;\n  height: 40px !important;\n  width: 100%;\n}\n\n.mb-40 {\n  margin-bottom: 40px !important;\n}\n\n.border-custom-grey {\n  border-color: #ddd !important;\n}\n\n.h-30 {\n  min-height: 35px !important;\n}\n\n.col-md-0-5 {\n  width: 4.13333333%;\n  position: relative;\n  float: left;\n}\n")
"use strict";

exports.__esModule = true;
var modals = require("./../../mixed/modals");
var notify = require("./../../mixed/notify");

exports["default"] = {
  data: function data() {
    return {
      dates: [],
      tab: 'pending',
      startDate: '',
      endDate: '',
      state: false,
      employees: {},
      activeEmployee: {},
      filteredEmployees: {},
      collectedEmployees: {},
      clients: {},
      order: {
        client_id: "",
        position_code: ""
      },
      week: '',
      date: '',
      activeClient: {},
      issues: {
        in_hour: '1',
        in_minute: '00',
        in_format: 'PM',
        out_hour: '1',
        out_minute: '00',
        out_format: 'PM',
        "break": '',
        note: ''
      },
      hours: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
      minutes: ['00', '05', '10', '15', '20', '25', '30', '35', '40', '45', '50', '55', '60'],
      breaks: ['00', '05', '10', '15', '20', '25', '30', '35', '40', '45', '50', '55', '60', '65', '70', '75', '80', '85', '90']
    };
  },

  props: ['tablet', 'desktop'],

  computed: {

    updatedEmployees: function updatedEmployees() {
      return _.filter(this.employees, function (o) {
        return o.worked || o.no_show;
      });
    }

  },
  filters: {},
  watch: {
    "tab": function tab(val) {
      this.setFilteredEmployees(val);
    },

    clients: function clients() {
      $("#position-client").selectric("refresh");
    },

    activeClient: function activeClient() {
      //   $("#position-code").selectric("refresh");
    },
    "order.position_code": function orderPosition_code(val) {
      this.getReConfirmedEmployees(val);
    }
  },
  ready: function ready() {
    //$(".table").fixedHeader();
    this.getSubmittedTimecards();
  },
  events: {},
  methods: {

    countCollections: function countCollections(departmentId, date) {
      var due = 0;
      _.forEach(this.employees, function (employeeGroup) {
        due += _.size(_.filter(employeeGroup, {
          'department_id': departmentId, 'date': date, 'worked': 0, 'no_show': 0
        }));
      });

      var collected = 0;

      _.forEach(this.collectedEmployees, function (employeeGroup) {
        collected += _.size(_.filter(employeeGroup, function (o) {
          return o.department_id === departmentId && o.date === date && (o.worked || o.no_show);
        }));
      });

      return collected + ' / ' + (collected + due);
    },

    setTab: function setTab(val) {
      this.tab = val;
    },

    groupByDate: function groupByDate(data) {
      return _.groupBy(data, "date");
    },

    groupByCustom: function groupByCustom(data, column) {
      return _.groupBy(data, column);
    },

    /**
     * get employee report data
     */
    getSubmittedTimecards: function getSubmittedTimecards() {
      var _this = this;

      notify.loading(true);
      this.$http.get("/api/submitted-time-cards", function (response) {
        _this.employees = response;
        _this.setFilteredEmployees('pending');
      }).always(function () {
        notify.loading(false);
      });
    },

    setFilteredEmployees: function setFilteredEmployees(tab) {

      var employees = '';
      if (tab === 'pending') {
        employees = _.filter(this.employees, function (o) {
          return !o.paid && o.approved && !o.rejected;
        });
      }

      if (tab === 'approved') {
        employees = _.filter(this.employees, function (o) {
          return o.paid && o.approved;
        });
      }

      if (tab === 'rejected') {
        employees = _.filter(this.employees, function (o) {
          return !o.paid && !o.approved && o.rejected;
        });
      }

      this.filteredEmployees = employees;
    },

    showIssuesModal: function showIssuesModal(data) {
      this.issues = _.cloneDeep(data);
      modals.showStrict("#issues-modal");
    },

    updateOrderIssue: function updateOrderIssue() {
      var _this2 = this;

      this.$http.post("/api/create-employee_order-issue", {
        in_hour: this.issues.in_hour,
        in_minute: this.issues.in_minute,
        in_format: this.issues.in_format,
        out_hour: this.issues.out_hour,
        out_minute: this.issues.out_minute,
        out_format: this.issues.out_format,
        "break": this.issues["break"],
        note: this.issues.note,
        employee_order_status_log_id: this.issues.id
      }, function (response) {
        modals.hide("#issues-modal");
        _this2.getSubmittedTimecards();
      }).always(function () {});
    },

    /**
     * confirmation before verifying an order
     * @param emp
     */
    confirmVerifyPayment: function confirmVerifyPayment(emp) {
      this.activeEmployee = _.cloneDeep(emp);
      notify.prompt('Are you sure?', '', this.makePaid);
    },

    /**
     * update list based on user entry
     */
    makePaid: function makePaid() {
      var _this3 = this;

      notify.loading(true);
      this.$http.get("/api/time-cards-make-paid/" + this.activeEmployee.employee_order_issue_id, function (response) {
        notify.loading(false);
        _this3.getSubmittedTimecards();
      }).always(function () {
        //notify.loading(false);
      });
    }
  }
};
module.exports = exports["default"];
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n  <div class=\"row re-confirm no-margin\">\n    <div class=\"col-md-12 col-sm-12 col-xs-12 no-padding-left no-padding-right\">\n      <div class=\"col-md-12 col-sm-12 col-xs-12 no-padding-left no-padding-right fixed-header \">\n        <table class=\"table table-xxs\">\n          <thead class=\"header\">\n          <tr>\n            <th class=\"bg-white text-center\" colspan=\"12\">\n              <span class=\"text-uppercase text-color-black text-center font-20\">Submitted Timecards</span>\n            </th>\n          </tr>\n          <tr>\n            <th class=\"col-md-3 bg-slate-800 text-black text-uppercase text-left\">Client</th>\n            <th class=\"col-md-1 bg-slate-800 text-black text-uppercase text-left border-left\">Date</th>\n            <th class=\"col-md-1 bg-slate-800 text-black text-uppercase text-left border-left\">Job</th>\n            <th class=\"col-md-2 bg-slate-800 text-black text-uppercase text-left border-left\">Employee</th>\n            <th class=\"col-md-1 bg-slate-800 text-black text-uppercase text-left border-left\">In</th>\n            <th class=\"col-md-1 bg-slate-800 text-black text-uppercase text-left border-left\">Out</th>\n            <th class=\"col-md-0-5 bg-slate-800 text-black text-uppercase text-left border-left\">Break</th>\n            <th class=\"col-md-0-5 bg-slate-800 text-black text-uppercase text-left border-left\">Total</th>\n            <th class=\"col-md-0-5 bg-slate-800 text-black text-uppercase text-left border-left\">Rate</th>\n            <th class=\"col-md-0-5 bg-slate-800 text-black text-uppercase text-left border-left\">Amount</th>\n            <th class=\"col-md-0-5 bg-slate-800 text-black text-uppercase text-left border-left\">Note\n            </th>\n            <th class=\"col-md-0-5 bg-primary text-black text-uppercase text-left border-left\">Done\n            </th>\n          </tr>\n          </thead>\n          <tbody></tbody>\n        </table>\n      </div>\n\n      <div class=\"col-md-12 col-sm-12 col-xs-12 bordered-div  no-padding-left no-padding-right top-90 list-div div-100\">\n        <div v-for=\"(ind,emp) in filteredEmployees\" :key=\"ind\" class=\"col-md-12 col-sm-12 col-xs-12 no-padding border-top border-custom-grey\">\n          <div class=\"col-md-3 col-sm-3 col-xs-3 text-left table-padding font-12 h-30\">{{ emp.client_name }}\n          </div>\n          <div class=\"col-md-1 col-sm-1 col-xs-1 text-left table-padding font-12 h-30\">{{ emp.custom_date }}\n          </div>\n          <div class=\"col-md-1 col-sm-1 col-xs-1 text-left table-padding font-12 h-30\">{{ emp.title }}\n          </div>\n          <div class=\"col-md-2 col-sm-2 col-xs-2 text-left table-padding font-12 h-30\">{{ emp.name }}\n          </div>\n          <div class=\"col-md-1 col-sm-1 col-xs-1 text-left table-padding font-12 h-30\">{{ emp.in_hour + ':' + emp.in_minute + ' ' + emp.in_format }}\n          </div>\n          <div class=\"col-md-1 col-sm-1 col-xs-1 text-left table-padding font-12 h-30\">{{ emp.out_hour + ':' + emp.out_minute + ' ' + emp.out_format }}\n          </div>\n          <div class=\"col-md-0-5 text-left table-padding font-12 h-30\">{{ emp.break ? emp.break : 0 }}\n          </div>\n          <div class=\"col-md-0-5 text-left table-padding font-12 h-30\">{{ emp.total }}\n          </div>\n          <div class=\"col-md-0-5 text-left table-padding font-12 h-30\">{{ emp.pay_rate }}\n          </div>\n          <div class=\"col-md-0-5 text-left table-padding font-12 h-30\">{{ emp.amount }}\n          </div>\n          <div class=\"col-md-0-5 text-left table-padding font-12 h-30\"><span :title=\"emp.note\">Note</span>\n          </div>\n          <div class=\"col-md-0-5 col-sm-1 col-xs-1 text-left table-padding font-12 h-30\">\n            <span v-if=\"emp.paid &amp;&amp; emp.approved\" class=\"text-black text-success \">Paid</span>\n            <span v-if=\"!emp.paid &amp;&amp; !emp.approved &amp;&amp; emp.rejected\" class=\"text-black text-danger \">Rejected</span>\n            <button v-if=\"!emp.paid &amp;&amp; emp.approved\" class=\"btn btn-primary\" @click=\"confirmVerifyPayment(emp)\">Pay\n            </button>\n          </div>\n\n        </div>\n        <div class=\"col-md-12 col-sm-12 col-xs-12 border-bottom border-custom-grey mb-40\"></div>\n\n      </div>\n    </div>\n\n\n    <div class=\"col-md-12 col-sm-12 col-xs-12 text-center no-padding-left no-padding-right bottom-div pt-2 bg-slate\">\n      <span :class=\"{'bg-slate-400 ' : tab === 'pending'}\" class=\"font-20 pl-10 pr-10 pb-15 mt-5 cursor-pointer text-black text-color-black\" @click=\"setTab('pending')\">Due</span>\n      <span :class=\"{'bg-slate-400 ' : tab === 'approved'}\" class=\"font-20 pl-10 pr-10 pb-15 mt-5 cursor-pointer text-black text-color-black\" @click=\"setTab('approved')\">Approved</span>\n      <span :class=\"{'bg-slate-400 ' : tab === 'rejected'}\" class=\"font-20 pl-10 pr-10 pb-15 mt-5 cursor-pointer text-black text-color-black\" @click=\"setTab('rejected')\">Rejected</span>\n    </div>\n  </div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  var id = "/home/shoieb/sites/elegant/resources/assets/js/vue/components/submitted-timecards.vue"
  module.hot.dispose(function () {
    require("vueify-insert-css").cache["\n.re-confirm > div.col-md-12,\n.re-confirm > div.col-md-6,\n.re-confirm > div.col-md-12 {\n  padding: 0 !important;\n}\n\n.bordered-div {\n  border-left: 1px solid #ddd;\n  border-right: 1px solid #ddd;\n}\n\n.bordered-left {\n  border-left: 1px solid #ddd;\n}\n\n.bordered-right {\n  border-right: 1px solid #ddd;\n}\n\n.bordered-bottom {\n  border-bottom: 1px solid #ddd;\n}\n\n.fixed-header {\n  position: fixed;\n  top: 48px;\n  right: 0px;\n  z-index: 1000 !important;\n}\n\n.tab-div {\n  width: 100% !important;\n  text-align: center;\n}\n\n.div-20 {\n  width: 20% !important;\n}\n\n.div-100 {\n  width: 100% !important;\n}\n\n.top-90 {\n  top: 90px;\n}\n\n.list-div {\n  margin-bottom: 40px;\n  min-height: 900px !important;\n}\n\n.bottom-div {\n  position: fixed;\n  bottom: 0px;\n  right: 0px;\n  z-index: 1000 !important;\n  height: 40px !important;\n  width: 100%;\n}\n\n.mb-40 {\n  margin-bottom: 40px !important;\n}\n\n.border-custom-grey {\n  border-color: #ddd !important;\n}\n\n.h-30 {\n  min-height: 35px !important;\n}\n\n.col-md-0-5 {\n  width: 4.13333333%;\n  position: relative;\n  float: left;\n}\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, module.exports.template)
  }
})()}
},{"./../../mixed/modals":10,"./../../mixed/notify":11,"vue":5,"vue-hot-reload-api":4,"vueify-insert-css":6}],76:[function(require,module,exports){
var __vueify_style__ = require("vueify-insert-css").insert("\n    .task-list span {\n        display: inline-block;\n        width: 33%;\n    }\n\n    .task-list {\n        text-align: center;\n    }\n")
"use strict";

exports.__esModule = true;
var notify = require("./../../mixed/notify");

exports["default"] = {
    data: function data() {
        return {
            employees: [],
            jobSummaryMessage: "",
            jobTitle: null,
            jobDate: null,
            jobTime: null,
            salary: null,
            currentOrder: null
        };
    },
    props: ["joblist"],
    ready: function ready() {},
    methods: {
        updateActiveList: function updateActiveList() {
            var _this = this;

            var self = this;
            self.$http.post("/api/completeTask", { employees: this.employees }, function (response) {
                var rem = 0;
                var i = 0;

                self.employees = self.employees.filter(function (item) {
                    i++;
                    if (item.status == 1 || item.status == true) rem++;
                    return item.status == 0 || item.status == false;
                });

                for (job in _this.joblist) {
                    if (_this.joblist[job].orderId == self.currentOrder.orderId && _this.joblist[job].rate == self.salary && _this.joblist[job].grp == self.currentOrder.grp && _this.joblist[job].user != null) {
                        if (_this.joblist[job].recipent != rem) _this.joblist[job].recipent -= rem;else {
                            self.joblist = self.joblist.filter(function (item) {
                                if (item.separator == self.currentOrder.separator) {
                                    return false;
                                } else return true;
                            });

                            _this.$dispatch("counterRecount", 4);
                            _this.jobSummaryMessage = "";
                            _this.jobTitle = null;
                            _this.jobDate = null;
                            _this.jobTime = null;
                            _this.salary = null;
                            _this.employees = null;
                        }
                        break;
                    }
                }
            }).always(function () {});
        }
    },
    events: {
        loadNew: function loadNew(task) {
            notify.loading(true);
            var self = this;
            self.jobTitle = task.employee + " " + task.needed + " " + task.post;

            self.jobTime = task.inTime + "-" + task.outTime;
            self.currentOrder = task;

            self.jobDate = moment(task.date).format("ddd MM-DD");

            //self.$http.get('/api/get-employee-list-details/'+task.orderId+'/assignment-details/text/'+task.rate, '', (response) => {

            self.$http.put("/api/get-employee-list-details/", {
                list: task.empList,
                orderId: task.orderId,
                type: "assignment-details",
                service: "text",
                rate: task.rate,
                limit: task.recipent
            }, function (response) {
                self.employees = response.employees;
                for (var pos in self.employees) {
                    self.employees[pos].status = Boolean(parseInt(self.employees[pos].status));
                }
                self.salary = response.employees[0].pay_rate;
                self.jobSummaryMessage = "YOUR JOB DETAILS:\n\n" + self.jobDate + "\n" + task.inTime + "-" + task.outTime + "\n" + task.employeeName + "\n" + task.post + "\n" + self.salary + "/ hour\n\n" + "UNIFORM:\n";
                if (response.order.uniforms.length) {
                    for (var i = 0; i < response.order.uniforms.length; i++) self.jobSummaryMessage += response.order.uniforms[i].uniform + "\n";
                } else {
                    for (var i = 0; i < response.order.positions.uniforms.length; i++) self.jobSummaryMessage += response.order.positions.uniforms[i].title + "\n";
                }

                self.jobSummaryMessage += "\nADDRESS:\n" + response.order.client.address_line_1 + "\n";
                if (response.order.client.address_line_2) self.jobSummaryMessage += response.order.client.address_line_2 + "\n";
                self.jobSummaryMessage += response.order.client.city + ", " + response.order.client.state + " " + response.order.client.zip + "\n";

                self.jobSummaryMessage += "\nNOTE:\n" + response.order.positions.employee_note + "\n";

                self.jobSummaryMessage += "\nSPECIAL INSTRUCTION:\n" + response.order.text_instruction;
            }).always(function () {
                notify.loading(false);
            });
        },
        clearMessage: function clearMessage(task) {
            var flag = false;
            for (var pos in this.joblist) {
                if (this.joblist[pos].user == current_user) flag = true;
            }
            if (flag == false) {
                this.employees = null;
                this.jobSummaryMessage = "";
                this.jobTitle = null;
                this.jobDate = null;
                this.jobTime = null;
                this.salary = null;
            }
        }
    }
};
module.exports = exports["default"];
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n    <div class=\"row mb-15\">\n        <div class=\"col-md-4\">\n            <div class=\"col-md-12 bg-slate no-padding\">\n                <div class=\"col-md-5 small\">{{jobTitle}}</div>\n                <div class=\"col-md-2 no-padding small\">{{jobDate}}</div>\n                <div class=\"col-md-5 small\" align=\"center\">{{jobTime}}</div>\n            </div>\n            <textarea name=\"jobSummaryMessage\" id=\"jobSummaryMessage\" cols=\"30\" rows=\"18\" class=\"form-control\" v-model=\"jobSummaryMessage\"></textarea>\n        </div>\n        <div class=\"col-md-8\">\n            <div class=\"col-md-12\">\n                <button type=\"button\" class=\"btn btn-primary btn-xs pull-right\" v-on:click=\"updateActiveList\">Complete</button>\n            </div>\n            <div class=\"col-md-12\">\n                <div class=\"table-responsive\">\n                    <table class=\"table table-xxs\">\n                        <thead>\n                        <tr>\n\n                            <th>Name</th>\n                            <th>Phone 1</th>\n                            <th>Phone 2</th>\n                            <th>Email</th>\n                            <th></th>\n                        </tr>\n                        </thead>\n                        <tbody>\n                        <tr v-for=\"employee in employees\">\n                            <td>{{employee.first_name}} {{employee.last_name}}</td>\n                            <td>{{employee.primary_phone}}</td>\n                            <td>{{employee.secondary_phone}}</td>\n                            <td>{{employee.email}}</td>\n                            <td><input type=\"checkbox\" v-model=\"employee.status\" value=\"1\"></td>\n                        </tr>\n\n                        </tbody>\n                    </table>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"col-md-12\">\n            <div class=\"row task-list\">\n                <div class=\"col-md-2\" v-for=\"item of joblist\">\n                    <new-job-task :task=\"item\"></new-job-task>\n                </div>\n            </div>\n        </div>\n    </div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  var id = "/home/shoieb/sites/elegant/resources/assets/js/vue/components/text-assignment-detail.vue"
  module.hot.dispose(function () {
    require("vueify-insert-css").cache["\n    .task-list span {\n        display: inline-block;\n        width: 33%;\n    }\n\n    .task-list {\n        text-align: center;\n    }\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, module.exports.template)
  }
})()}
},{"./../../mixed/notify":11,"vue":5,"vue-hot-reload-api":4,"vueify-insert-css":6}],77:[function(require,module,exports){
var __vueify_style__ = require("vueify-insert-css").insert("\n\n\t.task-list span{\n\t\tdisplay: inline-block;\n\t\twidth: 33%;\n\t}\n\t.task-list{\n\t\ttext-align: center;\n\t}\n")
'use strict';

exports.__esModule = true;
var notify = require('./../../mixed/notify');

exports['default'] = {
    data: function data() {
        return {
            employees: [],
            jobSummaryMessage: '',
            jobTitle: null,
            jobDate: null,
            jobTime: null,
            salary: null,
            currentOrder: null
        };
    },
    props: ['joblist'],
    ready: function ready() {},
    methods: {
        updateActiveList: function updateActiveList() {
            var _this = this;

            var self = this;
            self.$http.post('/api/completeTask', { 'employees': this.employees }, function (response) {
                var rem = 0;
                var i = 0;

                self.employees = self.employees.filter(function (item) {
                    i++;
                    if (item.status == 1 || item.status == true) rem++;
                    return item.status == 0 || item.status == false;
                });

                for (job in _this.joblist) {
                    if (_this.joblist[job].orderId == self.currentOrder.orderId && _this.joblist[job].rate == self.salary && _this.joblist[job].grp == self.currentOrder.grp && _this.joblist[job].user != null) {
                        if (_this.joblist[job].recipent != rem) _this.joblist[job].recipent -= rem;else {
                            self.joblist = self.joblist.filter(function (item) {
                                if (item.separator == self.currentOrder.separator) {
                                    return false;
                                } else return true;
                            });

                            _this.$dispatch('counterRecount', 5);
                            _this.jobSummaryMessage = '';
                            _this.jobTitle = null;
                            _this.jobDate = null;
                            _this.jobTime = null;
                            _this.salary = null;
                            _this.employees = null;
                        }
                        break;
                    }
                }
            }).always(function () {});
        }
    },
    events: {
        'loadNew': function loadNew(task) {
            notify.loading(true);
            var self = this;
            self.jobTitle = task.employee + ' ' + task.needed + ' ' + task.post;

            self.jobTime = task.inTime + "-" + task.outTime;
            self.currentOrder = task;

            if (moment.duration(moment(task.date).diff(moment().startOf('day'))).asDays() < 1) self.jobDate = "Today";else if (moment.duration(moment(task.date).diff(moment().startOf('day'))).asDays() < 2) self.jobDate = "Tomorrow";else self.jobDate = moment(task.date).format("ddd, MM-DD");

            self.$http.put('/api/get-employee-list/', { list: task.empList, orderId: task.orderId, type: 'client-request', service: 'text', rate: task.rate, limit: task.recipent }, function (response) {
                self.employees = response;
                for (var pos in self.employees) {
                    self.employees[pos].status = Boolean(parseInt(self.employees[pos].status));
                }
                self.salary = response[0].pay_rate;
                self.jobSummaryMessage = "NEW JOB\n" + self.jobDate + "\n" + task.inTime + "-" + task.outTime + "\n" + task.post + "\n" + self.salary + "/ hour\n" + task.employeeName + "\n" + task.employeeAddr1 + "\n";
                if (task.employeeAddr2) self.jobSummaryMessage += task.employeeAddr2 + "\n";

                self.jobSummaryMessage += "To accept this job, Call\n" + "ELEGANT STAFFING\n" + "800-807-8503 ext.2";
            }).always(function () {
                notify.loading(false);
            });
        },
        'clearMessage': function clearMessage(task) {
            var flag = false;
            for (var pos in this.joblist) {
                if (this.joblist[pos].user == current_user) flag = true;
            }
            if (flag == false) {
                this.employees = null;
                this.jobSummaryMessage = '';
                this.jobTitle = null;
                this.jobDate = null;
                this.jobTime = null;
                this.salary = null;
            }
        }
    }
};
module.exports = exports['default'];
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"row mb-15\">\n    <div class=\"col-md-4\">\n        <div class=\"col-md-12 bg-slate no-padding\">\n            <div class=\"col-md-5 small\">{{jobTitle}}</div>\n            <div class=\"col-md-2 no-padding small\">{{jobDate}}</div>\n            <div class=\"col-md-5 small\" align=\"center\">{{jobTime}}</div>\n        </div>\n        <textarea name=\"jobSummaryMessage\" id=\"jobSummaryMessage\" cols=\"30\" rows=\"18\" class=\"form-control\" v-model=\"jobSummaryMessage\"></textarea>\n    </div>\n    <div class=\"col-md-8\">\n        <div class=\"col-md-12\">\n            <button type=\"button\" class=\"btn btn-primary btn-xs pull-right\" v-on:click=\"updateActiveList\">Complete</button>\n        </div>\n        <div class=\"col-md-12\">\n            <div class=\"table-responsive\">\n                <table class=\"table table-xxs\">\n                    <thead>\n                    <tr>\n\n                        <th>Name</th>\n                        <th>Phone 1</th>\n                        <th>Phone 2</th>\n                        <th>Email</th>\n                        <th></th>\n                    </tr>\n                    </thead>\n                    <tbody>\n                    <tr v-for=\"employee in employees\">\n                        <td>{{employee.first_name}} {{employee.last_name}}</td>\n                        <td>{{employee.primary_phone}}</td>\n                        <td>{{employee.secondary_phone}}</td>\n                        <td>{{employee.email}}</td>\n                        <td><input type=\"checkbox\" v-model=\"employee.status\" value=\"1\"></td>\n                    </tr>\n\n                    </tbody>\n                </table>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"col-md-12\">\n        <div class=\"row task-list\">\n        \t<div class=\"col-md-2\" v-for=\"item of joblist\">\n        \t\t<new-job-task :task=\"item\"></new-job-task>\n        \t</div>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  var id = "/home/shoieb/sites/elegant/resources/assets/js/vue/components/text-client-request.vue"
  module.hot.dispose(function () {
    require("vueify-insert-css").cache["\n\n\t.task-list span{\n\t\tdisplay: inline-block;\n\t\twidth: 33%;\n\t}\n\t.task-list{\n\t\ttext-align: center;\n\t}\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, module.exports.template)
  }
})()}
},{"./../../mixed/notify":11,"vue":5,"vue-hot-reload-api":4,"vueify-insert-css":6}],78:[function(require,module,exports){
var __vueify_style__ = require("vueify-insert-css").insert("\n\n\t.task-list span{\n\t\tdisplay: inline-block;\n\t\twidth: 33%;\n\t}\n\t.task-list{\n\t\ttext-align: center;\n\t}\n")
'use strict';

exports.__esModule = true;
var notify = require('./../../mixed/notify');

exports['default'] = {
    data: function data() {
        return {
            employees: [],
            jobSummaryMessage: '',
            jobTitle: null,
            jobDate: null,
            jobTime: null,
            salary: null,
            currentOrder: null
        };
    },
    props: ['joblist'],
    ready: function ready() {},
    methods: {
        updateActiveList: function updateActiveList() {
            var _this = this;

            var self = this;
            self.$http.post('/api/completeTask', { 'employees': this.employees }, function (response) {
                var rem = 0;
                var i = 0;

                self.employees = self.employees.filter(function (item) {
                    i++;
                    if (item.status == 1 || item.status == true) rem++;
                    return item.status == 0 || item.status == false;
                });

                for (job in _this.joblist) {
                    if (_this.joblist[job].orderId == self.currentOrder.orderId && _this.joblist[job].rate == self.salary && _this.joblist[job].grp == self.currentOrder.grp && _this.joblist[job].user != null) {
                        if (_this.joblist[job].recipent != rem) _this.joblist[job].recipent -= rem;else {
                            self.joblist = self.joblist.filter(function (item) {
                                if (item.separator == self.currentOrder.separator) {
                                    return false;
                                } else return true;
                            });

                            _this.$dispatch('counterRecount', 10);
                            _this.jobSummaryMessage = '';
                            _this.jobTitle = null;
                            _this.jobDate = null;
                            _this.jobTime = null;
                            _this.salary = null;
                            _this.employees = null;
                        }
                        break;
                    }
                }
            }).always(function () {});
        }
    },
    events: {
        'loadNew': function loadNew(task) {
            notify.loading(true);
            var self = this;
            self.jobTitle = task.employee + ' ' + task.needed + ' ' + task.post;

            self.jobTime = task.inTime + "-" + task.outTime;
            self.currentOrder = task;

            if (moment.duration(moment(task.date).diff(moment().startOf('day'))).asDays() < 1) self.jobDate = "Today";else if (moment.duration(moment(task.date).diff(moment().startOf('day'))).asDays() < 2) self.jobDate = "Tomorrow";else self.jobDate = moment(task.date).format("ddd, MM-DD");

            self.$http.put('/api/get-employee-list/', { list: task.empList, orderId: task.orderId, type: 'job-cancel', service: 'text', rate: task.rate, limit: task.recipent }, function (response) {
                self.employees = response;

                for (var pos in self.employees) {
                    self.employees[pos].status = Boolean(parseInt(self.employees[pos].status));
                }
                self.salary = response[0].pay_rate;
                self.jobSummaryMessage = "SHIFT CANCEL\n" + "The following shift has been cancelled\n" + "by the client.\n" + self.jobDate + "\n" + task.inTime + "-" + task.outTime + "\n" + task.employeeName + "\n" + task.post + "\n" + "For the details, please call\n" + "ELEGANT STAFFING\n" + "800-807-8503 ext.2";
            }).always(function () {
                notify.loading(false);
            });
        },
        'clearMessage': function clearMessage(task) {
            var flag = false;
            for (var pos in this.joblist) {
                if (this.joblist[pos].user == current_user) flag = true;
            }
            if (flag == false) {
                this.employees = null;
                this.jobSummaryMessage = '';
                this.jobTitle = null;
                this.jobDate = null;
                this.jobTime = null;
                this.salary = null;
            }
        }
    }
};
module.exports = exports['default'];
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"row mb-15\">\n    <div class=\"col-md-4\">\n        <div class=\"col-md-12 bg-slate no-padding\">\n            <div class=\"col-md-5 small\">{{jobTitle}}</div>\n            <div class=\"col-md-2 no-padding small\">{{jobDate}}</div>\n            <div class=\"col-md-5 small\" align=\"center\">{{jobTime}}</div>\n        </div>\n        <textarea name=\"jobSummaryMessage\" id=\"jobSummaryMessage\" cols=\"30\" rows=\"18\" class=\"form-control\" v-model=\"jobSummaryMessage\"></textarea>\n    </div>\n    <div class=\"col-md-8\">\n        <div class=\"col-md-12\">\n            <button type=\"button\" class=\"btn btn-primary btn-xs pull-right\" v-on:click=\"updateActiveList\">Complete</button>\n        </div>\n        <div class=\"col-md-12\">\n            <div class=\"table-responsive\">\n                <table class=\"table table-xxs\">\n                    <thead>\n                    <tr>\n\n                        <th>Name</th>\n                        <th>Phone 1</th>\n                        <th>Phone 2</th>\n                        <th>Email</th>\n                        <th></th>\n                    </tr>\n                    </thead>\n                    <tbody>\n                    <tr v-for=\"employee in employees\">\n                        <td>{{employee.first_name}} {{employee.last_name}}</td>\n                        <td>{{employee.primary_phone}}</td>\n                        <td>{{employee.secondary_phone}}</td>\n                        <td>{{employee.email}}</td>\n                        <td><input type=\"checkbox\" v-model=\"employee.status\" value=\"1\"></td>\n                    </tr>\n\n                    </tbody>\n                </table>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"col-md-12\">\n        <div class=\"row task-list\">\n        \t<div class=\"col-md-2\" v-for=\"item of joblist\">\n        \t\t<new-job-task :task=\"item\"></new-job-task>\n        \t</div>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  var id = "/home/shoieb/sites/elegant/resources/assets/js/vue/components/text-job-cancel.vue"
  module.hot.dispose(function () {
    require("vueify-insert-css").cache["\n\n\t.task-list span{\n\t\tdisplay: inline-block;\n\t\twidth: 33%;\n\t}\n\t.task-list{\n\t\ttext-align: center;\n\t}\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, module.exports.template)
  }
})()}
},{"./../../mixed/notify":11,"vue":5,"vue-hot-reload-api":4,"vueify-insert-css":6}],79:[function(require,module,exports){
var __vueify_style__ = require("vueify-insert-css").insert("\n\n\t .task-list .job-summary span{\n\t\tdisplay: inline-block;\n\t\twidth: 100%;\n\n\t}\n\t.task-list{\n\t\ttext-align: center;\n\t}\n")
'use strict';

exports.__esModule = true;
var notify = require('./../../mixed/notify');

exports['default'] = {
    data: function data() {
        return {
            employees: [],
            order: [],
            jobSummaryMessage: '',
            currentOrderId: null
        };
    },
    props: ['joblist'],
    ready: function ready() {},
    methods: {
        updateActiveList: function updateActiveList() {
            var _this = this;

            var self = this;
            self.$http.post('/api/completeTask', { 'employees': this.employees }, function (response) {
                var rem = 0;
                var i = 0;

                self.employees = self.employees.filter(function (item) {
                    i++;
                    if (item.status == 1 || item.status == true) rem++;
                    return item.status == 0 || item.status == false;
                });

                for (job in _this.joblist) {
                    if (_this.joblist[job].code == self.currentOrderId) {
                        if (_this.joblist[job].recipent != rem) _this.joblist[job].recipent -= rem;else {
                            self.joblist = self.joblist.filter(function (item) {
                                if (item.code == self.currentOrderId) {
                                    return false;
                                } else return true;
                            });

                            _this.$dispatch('counterRecount', 2);
                            _this.jobSummaryMessage = '';
                            _this.employees = null;
                        }
                        break;
                    }
                }
            }).always(function () {});
        },
        formateDate: function formateDate(datetime) {
            var dated = moment(datetime).format("ddd MM/DD");
            return dated;
        },
        formateTime: function formateTime(datetime) {
            var dated = moment(datetime).format("h:mm a");
            return dated;
        }
    },
    events: {
        'loadNew': function loadNew(task) {
            notify.loading(true);
            var self = this;
            self.jobTitle = task.employee + ' ' + task.needed + ' ' + task.post;

            self.jobTime = task.inTime + "-" + task.outTime;
            self.currentOrderId = task.code;

            self.$http.get('/api/get-summary-data/' + task.code, '', function (response) {
                self.employees = response.employees;
                self.order = response.order;

                for (var pos in self.employees) {
                    self.employees[pos].status = Boolean(parseInt(self.employees[pos].status));
                }

                self.jobSummaryMessage = "YOUR JOB SUMMARY\n\n";
                for (i = 0; i < self.order.length; i++) {
                    self.jobSummaryMessage += self.formateDate(self.order[i].date) + "\n" + self.formateTime(self.order[i].in_time) + " - " + self.formateTime(self.order[i].in_time) + "\n" + self.order[i].client.name + "\n" + self.order[i].positions.title + "\n\n";
                }
                self.jobSummaryMessage += "Thank you….";
            }).always(function () {
                notify.loading(false);
            });
        },
        'clearMessage': function clearMessage(task) {
            var flag = false;
            for (var pos in this.joblist) {
                if (this.joblist[pos].user == current_user) flag = true;
            }
            if (flag == false) {
                this.employees = null;
                this.jobSummaryMessage = '';
                this.jobTitle = null;
                this.jobDate = null;
                this.jobTime = null;
                this.salary = null;
            }
        }
    }
};
module.exports = exports['default'];
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"row mb-15\">\n    <div class=\"col-md-4\">\n        <div class=\"col-md-12 bg-slate no-padding\">\n            <div class=\"col-md-5 small\"></div>\n            <div class=\"col-md-2 no-padding small\">Summary</div>\n            <div class=\"col-md-5 small\" align=\"center\"></div>\n        </div>\n        <textarea name=\"jobSummaryMessage\" id=\"jobSummaryMessage\" cols=\"30\" rows=\"18\" class=\"form-control\" v-model=\"jobSummaryMessage\"></textarea>\n    </div>\n    <div class=\"col-md-8\">\n        <div class=\"col-md-12\">\n            <button type=\"button\" class=\"btn btn-primary btn-xs pull-right\" v-on:click=\"updateActiveList\">Complete</button>\n        </div>\n        <div class=\"col-md-12\">\n            <div class=\"table-responsive\">\n                <table class=\"table table-xxs\">\n                    <thead>\n                    <tr>\n\n                        <th>Name</th>\n                        <th>Phone 1</th>\n                        <th>Phone 2</th>\n                        <th>Email</th>\n                        <th></th>\n                    </tr>\n                    </thead>\n                    <tbody>\n                    <tr v-for=\"employee in employees\">\n                        <td>{{employee.first_name}} {{employee.last_name}}</td>\n                        <td>{{employee.primary_phone}}</td>\n                        <td>{{employee.secondary_phone}}</td>\n                        <td>{{employee.email}}</td>\n                        <td><input type=\"checkbox\" v-model=\"employee.status\" value=\"1\"></td>\n                    </tr>\n\n                    </tbody>\n                </table>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"col-md-12\">\n        <div class=\"row task-list\">\n        \t<div class=\"col-md-1\" v-for=\"item of joblist\">\n        \t\t<job-summary :task=\"item\"></job-summary>\n        \t</div>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  var id = "/home/shoieb/sites/elegant/resources/assets/js/vue/components/text-job-summary.vue"
  module.hot.dispose(function () {
    require("vueify-insert-css").cache["\n\n\t .task-list .job-summary span{\n\t\tdisplay: inline-block;\n\t\twidth: 100%;\n\n\t}\n\t.task-list{\n\t\ttext-align: center;\n\t}\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, module.exports.template)
  }
})()}
},{"./../../mixed/notify":11,"vue":5,"vue-hot-reload-api":4,"vueify-insert-css":6}],80:[function(require,module,exports){
var __vueify_style__ = require("vueify-insert-css").insert("\n\n\t.task-list span{\n\t\tdisplay: inline-block;\n\t\twidth: 33%;\n\t}\n\t.task-list{\n\t\ttext-align: center;\n\t}\n")
'use strict';

exports.__esModule = true;
var notify = require('./../../mixed/notify');

exports['default'] = {
    data: function data() {
        return {
            employees: [],
            jobSummaryMessage: '',
            jobTitle: null,
            jobDate: null,
            jobTime: null,
            salary: null,
            currentOrder: null
        };
    },
    props: ['joblist'],
    ready: function ready() {},
    methods: {
        updateActiveList: function updateActiveList() {
            var _this = this;

            var self = this;
            self.$http.post('/api/completeTask', { 'employees': this.employees }, function (response) {
                var rem = 0;
                var i = 0;

                self.employees = self.employees.filter(function (item) {
                    i++;
                    if (item.status == 1 || item.status == true) rem++;
                    return item.status == 0 || item.status == false;
                });

                for (job in _this.joblist) {
                    if (_this.joblist[job].orderId == self.currentOrder.orderId && _this.joblist[job].rate == self.salary && _this.joblist[job].grp == self.currentOrder.grp && _this.joblist[job].user != null) {
                        if (_this.joblist[job].recipent != rem) _this.joblist[job].recipent -= rem;else {
                            self.joblist = self.joblist.filter(function (item) {
                                if (item.separator == self.currentOrder.separator) {
                                    return false;
                                } else return true;
                            });

                            _this.$dispatch('counterRecount', 6);
                            _this.jobSummaryMessage = '';
                            _this.jobTitle = null;
                            _this.jobDate = null;
                            _this.jobTime = null;
                            _this.salary = null;
                            _this.employees = null;
                        }
                        break;
                    }
                }
            }).always(function () {});
        }
    },
    events: {

        'loadNew': function loadNew(task) {
            notify.loading(true);
            var self = this;
            self.jobTitle = task.employee + ' ' + task.needed + ' ' + task.post;

            self.jobTime = task.inTime + "-" + task.outTime;
            self.currentOrder = task;

            if (moment.duration(moment(task.date).diff(moment().startOf('day'))).asDays() < 1) self.jobDate = "Today";else if (moment.duration(moment(task.date).diff(moment().startOf('day'))).asDays() < 2) self.jobDate = "Tomorrow";else self.jobDate = moment(task.date).format("ddd, MM-DD");

            self.$http.put('/api/get-employee-list/', { list: task.empList, orderId: task.orderId, type: 'move', service: 'text', rate: task.rate, limit: task.recipent }, function (response) {
                self.employees = response;
                for (var pos in self.employees) {
                    self.employees[pos].status = Boolean(parseInt(self.employees[pos].status));
                }
                self.salary = response[0].pay_rate;
                self.jobSummaryMessage = "We have a new opening at\n" + task.employeeName + "\n" + self.jobDate + "\n" + task.post + "\n" + self.salary + "/ hour\n" + "If you are interested to switch your shift. Call\n" + "ELEGANT STAFFING\n" + "800-807-8503 ext.2";
            }).always(function () {
                notify.loading(false);
            });
        },
        'clearMessage': function clearMessage(task) {
            var flag = false;
            for (var pos in this.joblist) {
                if (this.joblist[pos].user == current_user) flag = true;
            }
            if (flag == false) {
                this.employees = null;
                this.jobSummaryMessage = '';
                this.jobTitle = null;
                this.jobDate = null;
                this.jobTime = null;
                this.salary = null;
            }
        }
    }
};
module.exports = exports['default'];
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"row mb-15\">\n    <div class=\"col-md-4\">\n        <div class=\"col-md-12 bg-slate no-padding\">\n            <div class=\"col-md-5 small\">{{jobTitle}}</div>\n            <div class=\"col-md-2 no-padding small\">{{jobDate}}</div>\n            <div class=\"col-md-5 small\" align=\"center\">{{jobTime}}</div>\n        </div>\n        <textarea name=\"jobSummaryMessage\" id=\"jobSummaryMessage\" cols=\"30\" rows=\"18\" class=\"form-control\" v-model=\"jobSummaryMessage\"></textarea>\n    </div>\n    <div class=\"col-md-8\">\n        <div class=\"col-md-12\">\n            <button type=\"button\" class=\"btn btn-primary btn-xs pull-right\" v-on:click=\"updateActiveList\">Complete</button>\n        </div>\n        <div class=\"col-md-12\">\n            <div class=\"table-responsive\">\n                <table class=\"table table-xxs\">\n                    <thead>\n                    <tr>\n\n                        <th>Name</th>\n                        <th>Phone 1</th>\n                        <th>Phone 2</th>\n                        <th>Email</th>\n                        <th></th>\n                    </tr>\n                    </thead>\n                    <tbody>\n                    <tr v-for=\"employee in employees\">\n                        <td>{{employee.first_name}} {{employee.last_name}}</td>\n                        <td>{{employee.primary_phone}}</td>\n                        <td>{{employee.secondary_phone}}</td>\n                        <td>{{employee.email}}</td>\n                        <td><input type=\"checkbox\" v-model=\"employee.status\" value=\"1\"></td>\n                    </tr>\n\n                    </tbody>\n                </table>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"col-md-12\">\n        <div class=\"row task-list\">\n        \t<div class=\"col-md-2\" v-for=\"item of joblist\">\n        \t\t<new-job-task :task=\"item\"></new-job-task>\n        \t</div>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  var id = "/home/shoieb/sites/elegant/resources/assets/js/vue/components/text-move.vue"
  module.hot.dispose(function () {
    require("vueify-insert-css").cache["\n\n\t.task-list span{\n\t\tdisplay: inline-block;\n\t\twidth: 33%;\n\t}\n\t.task-list{\n\t\ttext-align: center;\n\t}\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, module.exports.template)
  }
})()}
},{"./../../mixed/notify":11,"vue":5,"vue-hot-reload-api":4,"vueify-insert-css":6}],81:[function(require,module,exports){
var __vueify_style__ = require("vueify-insert-css").insert("\n\n\t.task-list span{\n\t\tdisplay: inline-block;\n\t\twidth: 33%;\n\t}\n\t.task-list{\n\t\ttext-align: center;\n\t}\n")
'use strict';

exports.__esModule = true;
var notify = require('./../../mixed/notify');

exports['default'] = {
    data: function data() {
        return {
            employees: [],
            jobSummaryMessage: '',
            jobTitle: null,
            jobDate: null,
            jobTime: null,
            address: null,
            salary: null,
            currentOrder: null
        };
    },
    props: ['joblist'],
    ready: function ready() {},

    methods: {
        updateActiveList: function updateActiveList() {
            var _this = this;

            var self = this;
            self.$http.post('/api/completeTask', { 'employees': this.employees }, function (response) {
                //self.employees =null;

                var rem = 0;
                var i = 0;

                self.employees = self.employees.filter(function (item) {
                    i++;
                    if (item.status == 1 || item.status == true) rem++;
                    return item.status == 0 || item.status == false;
                });

                for (job in _this.joblist) {
                    if (_this.joblist[job].orderId == self.currentOrder.orderId && _this.joblist[job].rate == self.salary && _this.joblist[job].grp == self.currentOrder.grp && _this.joblist[job].user != null) {
                        if (_this.joblist[job].recipent != rem) _this.joblist[job].recipent -= rem;else {
                            self.joblist = self.joblist.filter(function (item) {
                                if (item.separator == self.currentOrder.separator) {
                                    return false;
                                } else return true;
                            });

                            _this.$dispatch('counterRecount', 1);
                            _this.jobSummaryMessage = '';
                            _this.jobTitle = null;
                            _this.jobDate = null;
                            _this.jobTime = null;
                            _this.salary = null;
                            _this.employees = null;
                        }
                        break;
                    }
                }
            }).always(function () {});
        }
    },
    events: {
        'loadNew': function loadNew(task) {

            notify.loading(true);
            var self = this;
            self.jobTitle = task.employee + ' ' + task.needed + ' ' + task.post;

            self.jobTime = task.inTime + "-" + task.outTime;
            self.currentOrder = task;

            if (moment.duration(moment(task.date).diff(moment().startOf('day'))).asDays() < 1) self.jobDate = "Today";else if (moment.duration(moment(task.date).diff(moment().startOf('day'))).asDays() < 2) self.jobDate = "Tomorrow";else self.jobDate = moment(task.date).format("ddd, MM-DD");

            self.$http.put('/api/get-employee-list/', { list: task.empList, orderId: task.orderId, type: 'new-job-offer', service: 'text', rate: task.rate, limit: task.recipent }, function (response) {
                self.employees = response;
                for (var pos in self.employees) {
                    self.employees[pos].status = Boolean(parseInt(self.employees[pos].status));
                }
                self.salary = response[0].pay_rate;
                self.jobSummaryMessage = "NEW JOB\n" + self.jobDate + "\n" + task.inTime + "-" + task.outTime + "\n" + task.post + "\n" + self.salary + "/ hour\n" + task.employeeName + "\n" + task.employeeAddr1 + "\n";
                if (task.employeeAddr2) self.jobSummaryMessage += task.employeeAddr2 + "\n";

                self.jobSummaryMessage += "To accept this job, Call\n" + "ELEGANT STAFFING\n" + "800-807-8503 ext.2";
            }).always(function () {
                notify.loading(false);
            });
        },
        'clearMessage': function clearMessage(task) {
            var flag = false;
            for (var pos in this.joblist) {
                if (this.joblist[pos].user == current_user) flag = true;
            }
            if (flag == false) {
                this.employees = null;
                this.jobSummaryMessage = '';
                this.jobTitle = null;
                this.jobDate = null;
                this.jobTime = null;
                this.salary = null;
            }
        }
    }
};
module.exports = exports['default'];
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"row mb-15\">\n    <div class=\"col-md-4\">\n        <div class=\"col-md-12 bg-slate no-padding\">\n            <div class=\"col-md-5 small\">{{jobTitle}}</div>\n            <div class=\"col-md-2 no-padding small\">{{jobDate}}</div>\n            <div class=\"col-md-5 small\" align=\"center\">{{jobTime}}</div>\n        </div>\n        <textarea name=\"jobSummaryMessage\" id=\"jobSummaryMessage\" cols=\"30\" rows=\"18\" class=\"form-control\" v-model=\"jobSummaryMessage\"></textarea>\n    </div>\n    <div class=\"col-md-8\">\n        <div class=\"col-md-12\">\n            <button type=\"button\" class=\"btn btn-primary btn-xs pull-right\" v-on:click=\"updateActiveList\">Complete</button>\n        </div>\n        <div class=\"col-md-12\">\n            <div class=\"table-responsive\">\n                <table class=\"table table-xxs\">\n                    <thead>\n                    <tr>\n\n                        <th>Name</th>\n                        <th>Phone 1</th>\n                        <th>Phone 2</th>\n                        <th>Email</th>\n                        <th></th>\n                    </tr>\n                    </thead>\n                    <tbody>\n                    <tr v-for=\"employee in employees\">\n                        <td>{{employee.first_name}} {{employee.last_name}}</td>\n                        <td>{{employee.primary_phone}}</td>\n                        <td>{{employee.secondary_phone}}</td>\n                        <td>{{employee.email}}</td>\n                        <td><input type=\"checkbox\" v-model=\"employee.status\" value=\"1\"></td>\n                    </tr>\n\n                    </tbody>\n                </table>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"col-md-12\">\n        <div class=\"row task-list\">\n        \t<div class=\"col-md-2\" v-for=\"item of joblist\">\n        \t\t<new-job-task :task=\"item\"></new-job-task>\n        \t</div>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  var id = "/home/shoieb/sites/elegant/resources/assets/js/vue/components/text-new-job.vue"
  module.hot.dispose(function () {
    require("vueify-insert-css").cache["\n\n\t.task-list span{\n\t\tdisplay: inline-block;\n\t\twidth: 33%;\n\t}\n\t.task-list{\n\t\ttext-align: center;\n\t}\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, module.exports.template)
  }
})()}
},{"./../../mixed/notify":11,"vue":5,"vue-hot-reload-api":4,"vueify-insert-css":6}],82:[function(require,module,exports){
var __vueify_style__ = require("vueify-insert-css").insert("\n\n\t.task-list span{\n\t\tdisplay: inline-block;\n\t\twidth: 33%;\n\t}\n\t.task-list{\n\t\ttext-align: center;\n\t}\n")
'use strict';

exports.__esModule = true;
var notify = require('./../../mixed/notify');

exports['default'] = {
    data: function data() {
        return {
            employees: [],
            jobSummaryMessage: '',
            jobTitle: null,
            jobDate: null,
            jobTime: null,
            salary: null,
            currentOrder: null
        };
    },
    props: ['joblist'],
    ready: function ready() {},
    methods: {
        updateActiveList: function updateActiveList() {
            var _this = this;

            var self = this;
            self.$http.post('/api/completeTask', { 'employees': this.employees }, function (response) {
                var rem = 0;
                var i = 0;

                self.employees = self.employees.filter(function (item) {
                    i++;
                    if (item.status == 1 || item.status == true) rem++;
                    return item.status == 0 || item.status == false;
                });

                for (job in _this.joblist) {
                    if (_this.joblist[job].orderId == self.currentOrder.orderId && _this.joblist[job].rate == self.salary && _this.joblist[job].grp == self.currentOrder.grp && _this.joblist[job].user != null) {
                        if (_this.joblist[job].recipent != rem) _this.joblist[job].recipent -= rem;else {
                            self.joblist = self.joblist.filter(function (item) {
                                if (item.separator == self.currentOrder.separator) {
                                    return false;
                                } else return true;
                            });

                            _this.$dispatch('counterRecount', 9);
                            _this.jobSummaryMessage = '';
                            _this.jobTitle = null;
                            _this.jobDate = null;
                            _this.jobTime = null;
                            _this.salary = null;
                            _this.employees = null;
                        }
                        break;
                    }
                }
            }).always(function () {});
        }
    },
    events: {
        'loadNew': function loadNew(task) {
            notify.loading(true);
            var self = this;
            self.jobTitle = task.employee + ' ' + task.needed + ' ' + task.post;

            self.jobTime = task.inTime + "-" + task.outTime;
            self.currentOrder = task;

            if (moment.duration(moment(task.date).diff(moment().startOf('day'))).asDays() < 1) self.jobDate = "Today";else if (moment.duration(moment(task.date).diff(moment().startOf('day'))).asDays() < 2) self.jobDate = "Tomorrow";else self.jobDate = moment(task.date).format("ddd, MM-DD");

            self.$http.put('/api/get-employee-list/', { list: task.empList, orderId: task.orderId, type: 'other-changes', service: 'text', rate: task.rate, limit: task.recipent }, function (response) {
                self.employees = response;
                for (var pos in self.employees) {
                    self.employees[pos].status = Boolean(parseInt(self.employees[pos].status));
                }
                self.salary = response[0].pay_rate;
                self.jobSummaryMessage = "CHANGE\n" + "There are some minor changes\n" + "for the following shift.\n" + self.jobDate + "\n" + task.employeeName + "\n" + task.post + "\n" + "For the details, please call\n" + "ELEGANT STAFFING\n" + "800-807-8503 ext.2";
            }).always(function () {
                notify.loading(false);
            });
        },
        'clearMessage': function clearMessage(task) {
            var flag = false;
            for (var pos in this.joblist) {
                if (this.joblist[pos].user == current_user) flag = true;
            }
            if (flag == false) {
                this.employees = null;
                this.jobSummaryMessage = '';
                this.jobTitle = null;
                this.jobDate = null;
                this.jobTime = null;
                this.salary = null;
            }
        }
    }
};
module.exports = exports['default'];
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"row mb-15\">\n    <div class=\"col-md-4\">\n        <div class=\"col-md-12 bg-slate no-padding\">\n            <div class=\"col-md-5 small\">{{jobTitle}}</div>\n            <div class=\"col-md-2 no-padding small\">{{jobDate}}</div>\n            <div class=\"col-md-5 small\" align=\"center\">{{jobTime}}</div>\n        </div>\n        <textarea name=\"jobSummaryMessage\" id=\"jobSummaryMessage\" cols=\"30\" rows=\"18\" class=\"form-control\" v-model=\"jobSummaryMessage\"></textarea>\n    </div>\n    <div class=\"col-md-8\">\n        <div class=\"col-md-12\">\n            <button type=\"button\" class=\"btn btn-primary btn-xs pull-right\" v-on:click=\"updateActiveList\">Complete</button>\n        </div>\n        <div class=\"col-md-12\">\n            <div class=\"table-responsive\">\n                <table class=\"table table-xxs\">\n                    <thead>\n                    <tr>\n\n                        <th>Name</th>\n                        <th>Phone 1</th>\n                        <th>Phone 2</th>\n                        <th>Email</th>\n                        <th></th>\n                    </tr>\n                    </thead>\n                    <tbody>\n                    <tr v-for=\"employee in employees\">\n                        <td>{{employee.first_name}} {{employee.last_name}}</td>\n                        <td>{{employee.primary_phone}}</td>\n                        <td>{{employee.secondary_phone}}</td>\n                        <td>{{employee.email}}</td>\n                        <td><input type=\"checkbox\" v-model=\"employee.status\" value=\"1\"></td>\n                    </tr>\n\n                    </tbody>\n                </table>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"col-md-12\">\n        <div class=\"row task-list\">\n        \t<div class=\"col-md-2\" v-for=\"item of joblist\">\n        \t\t<new-job-task :task=\"item\"></new-job-task>\n        \t</div>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  var id = "/home/shoieb/sites/elegant/resources/assets/js/vue/components/text-other-changes.vue"
  module.hot.dispose(function () {
    require("vueify-insert-css").cache["\n\n\t.task-list span{\n\t\tdisplay: inline-block;\n\t\twidth: 33%;\n\t}\n\t.task-list{\n\t\ttext-align: center;\n\t}\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, module.exports.template)
  }
})()}
},{"./../../mixed/notify":11,"vue":5,"vue-hot-reload-api":4,"vueify-insert-css":6}],83:[function(require,module,exports){
var __vueify_style__ = require("vueify-insert-css").insert("\n.task-list span {\n  display: inline-block;\n  width: 33%;\n}\n.task-list {\n  text-align: center;\n}\n")
"use strict";

exports.__esModule = true;
var notify = require("./../../mixed/notify");

exports["default"] = {
  data: function data() {
    return {
      employees: [],
      jobSummaryMessage: "",
      jobTitle: null,
      jobDate: null,
      jobTime: null,
      salary: null,
      currentOrder: null
    };
  },
  props: ["joblist"],
  ready: function ready() {},
  methods: {
    updateActiveList: function updateActiveList() {
      var _this = this;

      var self = this;
      self.$http.post("/api/completeTask", { employees: this.employees }, function (response) {
        var rem = 0;
        var i = 0;

        self.employees = self.employees.filter(function (item) {
          i++;
          if (item.status == 1 || item.status == true) rem++;
          return item.status == 0 || item.status == false;
        });

        for (job in _this.joblist) {
          if (_this.joblist[job].orderId == self.currentOrder.orderId && _this.joblist[job].rate == self.salary && _this.joblist[job].grp == self.currentOrder.grp && _this.joblist[job].user != null) {
            if (_this.joblist[job].recipent != rem) _this.joblist[job].recipent -= rem;else {
              self.joblist = self.joblist.filter(function (item) {
                if (item.separator == self.currentOrder.separator) {
                  return false;
                } else return true;
              });

              _this.$dispatch("counterRecount", 3);
              _this.jobSummaryMessage = "";
              _this.jobTitle = null;
              _this.jobDate = null;
              _this.jobTime = null;
              _this.salary = null;
              _this.employees = null;
            }
            break;
          }
        }
      }).always(function () {});
    }
  },
  events: {
    loadNew: function loadNew(task) {
      notify.loading(true);
      var self = this;
      self.jobTitle = task.employee + " " + task.needed + " " + task.post;

      self.jobTime = task.inTime + "-" + task.outTime;
      self.currentOrder = task;

      if (moment.duration(moment(task.date).diff(moment().startOf("day"))).asDays() < 1) self.jobDate = "Today";else if (moment.duration(moment(task.date).diff(moment().startOf("day"))).asDays() < 2) self.jobDate = "Tomorrow";else self.jobDate = moment(task.date).format("ddd, MM-DD");

      self.$http.put("/api/get-employee-list/", {
        list: task.empList,
        orderId: task.orderId,
        type: "reconfirmation-job",
        service: "text",
        rate: task.rate,
        limit: task.recipent
      }, function (response) {
        self.employees = response;
        for (var pos in self.employees) {
          self.employees[pos].status = Boolean(parseInt(self.employees[pos].status));
        }
        self.salary = response[0].pay_rate;
        self.jobSummaryMessage = "REMINDER\n\n" + "You have a shift\n" + self.jobDate + " at \n" + task.employeeName + "\n" + task.inTime + "-" + task.outTime + "\n" + " as a " + task.post + "\n" + "Please give us a call @678-805-1280  Ext. 2 to reconfirm your shift.\n" + "Thank you - ElegantStaffing\n";
      }).always(function () {
        notify.loading(false);
      });
    },
    clearMessage: function clearMessage(task) {
      var flag = false;
      for (var pos in this.joblist) {
        if (this.joblist[pos].user == current_user) flag = true;
      }
      if (flag == false) {
        this.employees = null;
        this.jobSummaryMessage = "";
        this.jobTitle = null;
        this.jobDate = null;
        this.jobTime = null;
        this.salary = null;
      }
    }
  }
};
module.exports = exports["default"];
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"row mb-15\">\n    <div class=\"col-md-4\">\n        <div class=\"col-md-12 bg-slate no-padding\">\n            <div class=\"col-md-5 small\">{{jobTitle}}</div>\n            <div class=\"col-md-2 no-padding small\">{{jobDate}}</div>\n            <div class=\"col-md-5 small\" align=\"center\">{{jobTime}}</div>\n        </div>\n        <textarea name=\"jobSummaryMessage\" id=\"jobSummaryMessage\" cols=\"30\" rows=\"18\" class=\"form-control\" v-model=\"jobSummaryMessage\"></textarea>\n    </div>\n    <div class=\"col-md-8\">\n        <div class=\"col-md-12\">\n            <button type=\"button\" class=\"btn btn-primary btn-xs pull-right\" v-on:click=\"updateActiveList\">Complete</button>\n        </div>\n        <div class=\"col-md-12\">\n            <div class=\"table-responsive\">\n                <table class=\"table table-xxs\">\n                    <thead>\n                    <tr>\n\n                        <th>Name</th>\n                        <th>Phone 1</th>\n                        <th>Phone 2</th>\n                        <th>Email</th>\n                        <th></th>\n                    </tr>\n                    </thead>\n                    <tbody>\n                    <tr v-for=\"employee in employees\">\n                        <td>{{employee.first_name}} {{employee.last_name}}</td>\n                        <td>{{employee.primary_phone}}</td>\n                        <td>{{employee.secondary_phone}}</td>\n                        <td>{{employee.email}}</td>\n                        <td><input type=\"checkbox\" v-model=\"employee.status\" value=\"1\"></td>\n                    </tr>\n\n                    </tbody>\n                </table>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"col-md-12\">\n        <div class=\"row task-list\">\n        \t<div class=\"col-md-2\" v-for=\"item of joblist\">\n        \t\t<new-job-task :task=\"item\"></new-job-task>\n        \t</div>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  var id = "/home/shoieb/sites/elegant/resources/assets/js/vue/components/text-reconfirmation-job.vue"
  module.hot.dispose(function () {
    require("vueify-insert-css").cache["\n.task-list span {\n  display: inline-block;\n  width: 33%;\n}\n.task-list {\n  text-align: center;\n}\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, module.exports.template)
  }
})()}
},{"./../../mixed/notify":11,"vue":5,"vue-hot-reload-api":4,"vueify-insert-css":6}],84:[function(require,module,exports){
var __vueify_style__ = require("vueify-insert-css").insert("\n\n\t.task-list span{\n\t\tdisplay: inline-block;\n\t\twidth: 33%;\n\t}\n\t.task-list{\n\t\ttext-align: center;\n\t}\n")
'use strict';

exports.__esModule = true;
var notify = require('./../../mixed/notify');

exports['default'] = {
    data: function data() {
        return {
            employees: [],
            jobSummaryMessage: '',
            jobTitle: null,
            jobDate: null,
            jobTime: null,
            salary: null,
            currentOrder: null
        };
    },
    props: ['joblist'],
    ready: function ready() {},
    methods: {
        updateActiveList: function updateActiveList() {
            var _this = this;

            var self = this;
            self.$http.post('/api/completeTask', { 'employees': this.employees }, function (response) {
                var rem = 0;
                var i = 0;

                self.employees = self.employees.filter(function (item) {
                    i++;
                    if (item.status == 1 || item.status == true) rem++;
                    return item.status == 0 || item.status == false;
                });

                for (job in _this.joblist) {
                    if (_this.joblist[job].orderId == self.currentOrder.orderId && _this.joblist[job].rate == self.salary && _this.joblist[job].grp == self.currentOrder.grp && _this.joblist[job].user != null) {
                        if (_this.joblist[job].recipent != rem) _this.joblist[job].recipent -= rem;else {
                            self.joblist = self.joblist.filter(function (item) {
                                if (item.separator == self.currentOrder.separator) {
                                    return false;
                                } else return true;
                            });

                            _this.$dispatch('counterRecount', 7);
                            _this.jobSummaryMessage = '';
                            _this.jobTitle = null;
                            _this.jobDate = null;
                            _this.jobTime = null;
                            _this.salary = null;
                            _this.employees = null;
                        }
                        break;
                    }
                }
            }).always(function () {});
        }
    },
    events: {
        'loadNew': function loadNew(task) {
            notify.loading(true);
            var self = this;
            self.jobTitle = task.employee + ' ' + task.needed + ' ' + task.post;

            self.jobTime = task.inTime + "-" + task.outTime;
            self.currentOrder = task;

            if (moment.duration(moment(task.date).diff(moment().startOf('day'))).asDays() < 1) self.jobDate = "Today";else if (moment.duration(moment(task.date).diff(moment().startOf('day'))).asDays() < 2) self.jobDate = "Tomorrow";else self.jobDate = moment(task.date).format("ddd, MM-DD");

            self.$http.put('/api/get-employee-list/', { list: task.empList, orderId: task.orderId, type: 'time-change', service: 'text', rate: task.rate, limit: task.recipent }, function (response) {
                self.employees = response;
                for (var pos in self.employees) {
                    self.employees[pos].status = Boolean(parseInt(self.employees[pos].status));
                }
                self.salary = response[0].pay_rate;
                self.jobSummaryMessage = "TIME CHANGED\n" + "For the following shift\n" + task.employeeName + "\n" + self.jobDate + "\n" + "\n" + "OLD TIME\n" + moment(response[0].base_in_time).format("h:mm a") + "-" + moment(response[0].base_out_time).format("h:mm a") + "\n" + "\n" + "NEW TIME\n" + task.inTime + "-" + task.outTime + "\n" + "\n" + "Please call Elegant Staffing\n" + "to confirm that you have received this msg.";
            }).always(function () {
                notify.loading(false);
            });
        },
        'clearMessage': function clearMessage(task) {
            var flag = false;
            for (var pos in this.joblist) {
                if (this.joblist[pos].user == current_user) flag = true;
            }
            if (flag == false) {
                this.employees = null;
                this.jobSummaryMessage = '';
                this.jobTitle = null;
                this.jobDate = null;
                this.jobTime = null;
                this.salary = null;
            }
        }
    }
};
module.exports = exports['default'];
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"row mb-15\">\n    <div class=\"col-md-4\">\n        <div class=\"col-md-12 bg-slate no-padding\">\n            <div class=\"col-md-5 small\">{{jobTitle}}</div>\n            <div class=\"col-md-2 no-padding small\">{{jobDate}}</div>\n            <div class=\"col-md-5 small\" align=\"center\">{{jobTime}}</div>\n        </div>\n        <textarea name=\"jobSummaryMessage\" id=\"jobSummaryMessage\" cols=\"30\" rows=\"18\" class=\"form-control\" v-model=\"jobSummaryMessage\"></textarea>\n    </div>\n    <div class=\"col-md-8\">\n        <div class=\"col-md-12\">\n            <button type=\"button\" class=\"btn btn-primary btn-xs pull-right\" v-on:click=\"updateActiveList\">Complete</button>\n        </div>\n        <div class=\"col-md-12\">\n            <div class=\"table-responsive\">\n                <table class=\"table table-xxs\">\n                    <thead>\n                    <tr>\n\n                        <th>Name</th>\n                        <th>Phone 1</th>\n                        <th>Phone 2</th>\n                        <th>Email</th>\n                        <th></th>\n                    </tr>\n                    </thead>\n                    <tbody>\n                    <tr v-for=\"employee in employees\">\n                        <td>{{employee.first_name}} {{employee.last_name}}</td>\n                        <td>{{employee.primary_phone}}</td>\n                        <td>{{employee.secondary_phone}}</td>\n                        <td>{{employee.email}}</td>\n                        <td><input type=\"checkbox\" v-model=\"employee.status\" value=\"1\"></td>\n                    </tr>\n\n                    </tbody>\n                </table>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"col-md-12\">\n        <div class=\"row task-list\">\n        \t<div class=\"col-md-2\" v-for=\"item of joblist\">\n        \t\t<new-job-task :task=\"item\"></new-job-task>\n        \t</div>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  var id = "/home/shoieb/sites/elegant/resources/assets/js/vue/components/text-time-change.vue"
  module.hot.dispose(function () {
    require("vueify-insert-css").cache["\n\n\t.task-list span{\n\t\tdisplay: inline-block;\n\t\twidth: 33%;\n\t}\n\t.task-list{\n\t\ttext-align: center;\n\t}\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, module.exports.template)
  }
})()}
},{"./../../mixed/notify":11,"vue":5,"vue-hot-reload-api":4,"vueify-insert-css":6}],85:[function(require,module,exports){
var __vueify_style__ = require("vueify-insert-css").insert("\n\n\t.task-list span{\n\t\tdisplay: inline-block;\n\t\twidth: 33%;\n\t}\n\t.task-list{\n\t\ttext-align: center;\n\t}\n")
'use strict';

exports.__esModule = true;
var notify = require('./../../mixed/notify');

exports['default'] = {
    data: function data() {
        return {
            employees: [],
            jobSummaryMessage: '',
            jobTitle: null,
            jobDate: null,
            jobTime: null,
            salary: null,
            currentOrder: null
        };
    },
    props: ['joblist'],
    ready: function ready() {},
    methods: {
        updateActiveList: function updateActiveList() {
            var _this = this;

            var self = this;
            self.$http.post('/api/completeTask', { 'employees': this.employees }, function (response) {
                var rem = 0;
                var i = 0;

                self.employees = self.employees.filter(function (item) {
                    i++;
                    if (item.status == 1 || item.status == true) rem++;
                    return item.status == 0 || item.status == false;
                });

                for (job in _this.joblist) {
                    if (_this.joblist[job].orderId == self.currentOrder.orderId && _this.joblist[job].rate == self.salary && _this.joblist[job].grp == self.currentOrder.grp && _this.joblist[job].user != null) {
                        if (_this.joblist[job].recipent != rem) _this.joblist[job].recipent -= rem;else {
                            self.joblist = self.joblist.filter(function (item) {
                                if (item.separator == self.currentOrder.separator) {
                                    return false;
                                } else return true;
                            });

                            _this.$dispatch('counterRecount', 8);
                            _this.jobSummaryMessage = '';
                            _this.jobTitle = null;
                            _this.jobDate = null;
                            _this.jobTime = null;
                            _this.salary = null;
                            _this.employees = null;
                        }
                        break;
                    }
                }
            }).always(function () {});
        }
    },
    events: {
        'loadNew': function loadNew(task) {
            notify.loading(true);
            var self = this;
            self.jobTitle = task.employee + ' ' + task.needed + ' ' + task.post;

            self.jobTime = task.inTime + "-" + task.outTime;
            self.currentOrder = task;

            if (moment.duration(moment(task.date).diff(moment().startOf('day'))).asDays() < 1) self.jobDate = "Today";else if (moment.duration(moment(task.date).diff(moment().startOf('day'))).asDays() < 2) self.jobDate = "Tomorrow " + moment(task.date).format("MM-DD");else self.jobDate = moment(task.date).format("ddd, MM-DD");

            self.$http.put('/api/get-employee-list/', { list: task.empList, orderId: task.orderId, type: 'time-conflict', service: 'text', rate: task.rate, limit: task.recipent }, function (response) {
                self.employees = response;
                for (var pos in self.employees) {
                    self.employees[pos].status = Boolean(parseInt(self.employees[pos].status));
                }
                self.salary = response[0].pay_rate;
                self.jobSummaryMessage = "TIME CONFLICT\n" + "Due to changes made by client\n" + "two of your shifts have overlaping time for\n" + self.jobDate + "\n" + "to resolve this issue, please call\n" + "ELEGANT STAFFING\n" + "800-807-8503 ext.2";
            }).always(function () {
                notify.loading(false);
            });
        },
        'clearMessage': function clearMessage(task) {
            var flag = false;
            for (var pos in this.joblist) {
                if (this.joblist[pos].user == current_user) flag = true;
            }
            if (flag == false) {
                this.employees = null;
                this.jobSummaryMessage = '';
                this.jobTitle = null;
                this.jobDate = null;
                this.jobTime = null;
                this.salary = null;
            }
        }
    }
};
module.exports = exports['default'];
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"row mb-15\">\n    <div class=\"col-md-4\">\n        <div class=\"col-md-12 bg-slate no-padding\">\n            <div class=\"col-md-5 small\">{{jobTitle}}</div>\n            <div class=\"col-md-2 no-padding small\">{{jobDate}}</div>\n            <div class=\"col-md-5 small\" align=\"center\">{{jobTime}}</div>\n        </div>\n        <textarea name=\"jobSummaryMessage\" id=\"jobSummaryMessage\" cols=\"30\" rows=\"18\" class=\"form-control\" v-model=\"jobSummaryMessage\"></textarea>\n    </div>\n    <div class=\"col-md-8\">\n        <div class=\"col-md-12\">\n            <button type=\"button\" class=\"btn btn-primary btn-xs pull-right\" v-on:click=\"updateActiveList\">Complete</button>\n        </div>\n        <div class=\"col-md-12\">\n            <div class=\"table-responsive\">\n                <table class=\"table table-xxs\">\n                    <thead>\n                    <tr>\n\n                        <th>Name</th>\n                        <th>Phone 1</th>\n                        <th>Phone 2</th>\n                        <th>Email</th>\n                        <th></th>\n                    </tr>\n                    </thead>\n                    <tbody>\n                    <tr v-for=\"employee in employees\">\n                        <td>{{employee.first_name}} {{employee.last_name}}</td>\n                        <td>{{employee.primary_phone}}</td>\n                        <td>{{employee.secondary_phone}}</td>\n                        <td>{{employee.email}}</td>\n                        <td><input type=\"checkbox\" v-model=\"employee.status\" value=\"1\"></td>\n                    </tr>\n\n                    </tbody>\n                </table>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"col-md-12\">\n        <div class=\"row task-list\">\n        \t<div class=\"col-md-2\" v-for=\"item of joblist\">\n        \t\t<new-job-task :task=\"item\"></new-job-task>\n        \t</div>\n        </div>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  var id = "/home/shoieb/sites/elegant/resources/assets/js/vue/components/text-time-conflict.vue"
  module.hot.dispose(function () {
    require("vueify-insert-css").cache["\n\n\t.task-list span{\n\t\tdisplay: inline-block;\n\t\twidth: 33%;\n\t}\n\t.task-list{\n\t\ttext-align: center;\n\t}\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, module.exports.template)
  }
})()}
},{"./../../mixed/notify":11,"vue":5,"vue-hot-reload-api":4,"vueify-insert-css":6}],86:[function(require,module,exports){
var __vueify_style__ = require("vueify-insert-css").insert("\n\n\n.search-box[_v-3208c0cc] {\n  width: 100%;\n  height: 50px;\n  border: 1px solid #098AD6;\n  border-radius: 5px;\n  padding: 5px;\n  font-size: 14px;\n  color: #000;\n  background-color: #FFFFFF;\n}\n\n.custom-checkbox[_v-3208c0cc] {\n  height: 24px;\n  padding: 5px 10px;\n  font-size: 12px;\n  line-height: 1.6666667;\n  border-radius: 5px;\n}\n\ninput[type=\"checkbox\"][_v-3208c0cc] {\n  accent-color: #009ACC;\n}\n\ninput[type=\"checkbox\"]#checkbox1:checked + span[_v-3208c0cc] {\n  border-color: red;\n  background-color: red;\n}\n\n.table-data[_v-3208c0cc] {\n  padding: 10px;\n  font-size: 17px;\n  color: #44505E;\n  font-weight: 400;\n  border-right: 2px solid #EDEEF3;\n  border-bottom: 2px solid #EDEEF3;\n}\n\n.close-modal[_v-3208c0cc] {\n  font-size: 30px;\n  margin-top: -14.75px;\n  font-weight: 500;\n}\n\n.close-modal-29[_v-3208c0cc] {\n  font-size: 30px;\n  margin-top: -29.75px !important;\n  font-weight: 500;\n}\n\n.close-modal-0[_v-3208c0cc] {\n  font-size: 35px;\n  margin-top: 0 !important;\n  font-weight: 500;\n  z-index: 100;\n  color: #656565 !important;\n}\n\n.font-20[_v-3208c0cc] {\n  font-size: 20px;\n}\n\n\n.font-40[_v-3208c0cc] {\n  font-size: 40px;\n}\n\n\n.bg-slate-custom[_v-3208c0cc] {\n  background-color: #d6dce5;\n  border-color: #d6dce5;\n}\n\n.custom-header[_v-3208c0cc] {\n  position: -webkit-sticky;\n  position: sticky;\n  top: 48px;\n  z-index: 100;\n}\n\n.top-65[_v-3208c0cc] {\n  top: 65px;\n}\n\n.bg-top-1[_v-3208c0cc] {\n  background-color: #202935;\n  border-color: #202935;\n  color: #fff;\n}\n\n.bg-top-2[_v-3208c0cc] {\n  background-color: #fff;\n  border-color: #fff;\n  color: #fff;\n}\n\n.column-header[_v-3208c0cc] {\n  padding: 12px !important;\n  font-size: 18px !important;\n  font-weight: 700 !important;\n  border-right: 2px solid #d6dce5;\n}\n\n.bg-top-3[_v-3208c0cc] {\n  background-color: #202933;\n  border-color: #202933;\n  color: #fff;\n}\n\n[_v-3208c0cc]::-webkit-input-placeholder {\n  text-align: left;\n  font-size: 20px\n}\n\n[_v-3208c0cc]:-moz-placeholder { /* Firefox 18- */\n  text-align: left;\n  font-size: 20px\n}\n\n[_v-3208c0cc]::-moz-placeholder { /* Firefox 19+ */\n  text-align: left;\n  font-size: 20px\n}\n\n[_v-3208c0cc]:-ms-input-placeholder {\n  text-align: left;\n  font-size: 20px\n}\n\n.btn-submit[_v-3208c0cc] {\n  padding: 5px 20px !important;\n  font-size: 25px !important;\n  font-weight: 600 !important;\n  border-radius: 5px;\n  background-color: #FFFFFF;\n  border-color: #098AD6;\n  color: #098AD6;\n}\n\n.radius-10[_v-3208c0cc] {\n  border-radius: 10px;\n}\n\n.bg-ticket[_v-3208c0cc] {\n  background-color: #029ACB;\n  border-color: #029ACB;\n  color: #FFFFFF;\n}\n\n.border-bottom-task[_v-3208c0cc] {\n  border-bottom-color: #EEEEEE;\n}\n\n.border-right-task[_v-3208c0cc] {\n  border-right-color: #EEEEEE;\n}\n\n.border-left-task[_v-3208c0cc] {\n  border-left-color: #EEEEEE;\n}\n\n.bg-modal-header[_v-3208c0cc] {\n  background-color: #3C4C60;\n  border-color: #3C4C60;\n  color: #FFFFFF;\n}\n\n.custom-blue[_v-3208c0cc] {\n  color: #029ACB;\n}\n\n.input-bg[_v-3208c0cc] {\n  background-color: #ddd !important;\n}\n\n\n.input-radius[_v-3208c0cc] {\n  background-color: #E9EFF1 !important;\n  border: 1px solid #E9EFF1 !important;\n  -moz-border-radius: 7px;\n  -webkit-border-radius: 7px;\n  border-radius: 7px;\n  font-size: 15px;\n  padding: 4px 7px;\n  outline: 0;\n  -webkit-appearance: none;\n}\n\n.custom-submit[_v-3208c0cc] {\n  background-color: #029ACB;\n  border-color: #029ACB;\n  padding-right: 50px;\n  padding-left: 50px;\n}\n\n.circle-div[_v-3208c0cc] {\n  background-color: #20C6A5;\n  height: 50px;\n  width: 50px;\n  border-radius: 100%;\n  position: fixed;\n  bottom: 21px;\n  right: 25px;\n}\n\n.font-add-icon[_v-3208c0cc] {\n  font-size: 40px;\n  padding-top: 5px;\n}\n\n\n.bubble[_v-3208c0cc] {\n  background-color: #F2F2F2;\n  border-radius: 5px;\n  box-shadow: 0 0 6px #B2B2B2;\n  display: inline-block;\n  padding: 10px 18px;\n  position: relative;\n  vertical-align: top;\n}\n\n.bubble[_v-3208c0cc]::before {\n  background-color: #F2F2F2;\n  content: \"\\00a0\";\n  display: block;\n  height: 16px;\n  position: absolute;\n  top: 11px;\n  transform: rotate(29deg) skew(-35deg);\n  -moz-transform: rotate(29deg) skew(-35deg);\n  -ms-transform: rotate(29deg) skew(-35deg);\n  -o-transform: rotate(29deg) skew(-35deg);\n  -webkit-transform: rotate(29deg) skew(-35deg);\n  width: 20px;\n}\n\n.me[_v-3208c0cc] {\n  float: left;\n  margin: 5px 45px 5px 20px;\n}\n\n.me[_v-3208c0cc]::before {\n  box-shadow: -2px 2px 2px 0 rgba(178, 178, 178, .4);\n  left: -9px;\n}\n\n.font-weight-500[_v-3208c0cc] {\n  font-weight: 500;\n}\n\n")
"use strict";

exports.__esModule = true;
var modals = require("./../../mixed/modals");
var notify = require("./../../mixed/notify");

exports["default"] = {
  data: function data() {
    return {
      status: "All",
      ticket: {
        application: '',
        priority: '',
        title: '',
        time_occurred: '',
        description: '',
        type: ''
      },
      tickets: {},
      searchedEmployees: {},
      activeEmployee: {},
      jobs: {},
      clients: {},
      type: 0,
      availableJobs: {},
      selectedJObs: {},
      ids: [],
      all: false,
      primary_phone: '',
      new_pin: '',
      comment: "",
      assign: {
        1: "Muntasir Rahman",
        2: "Hasibul Hasan",
        3: "Reza Shahreare"
      },
      priority: {
        1: "High",
        2: "Medium",
        3: "Low"
      },
      images: null,
      filter: {
        field: "",
        value: "",
        type: ""
      },
      query: "",
      totalPages: '',
      pagination: {},
      perPage: 200,
      page: 1,
      counts: {},
      sortOrders: true,
      sortKey: "action",
      sortOrder: false,
      sortField: 'time_occurred'
    };
  },
  props: ['user'],

  watch: {},
  ready: function ready() {
    this.getTickets();
    this.getTicketsStatusCount();
  },

  events: {},

  methods: {
    sortTickets: function sortTickets(field, order) {
      var primer = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];

      this.sortField = field;
      this.sortOrder = order;
      this.getTickets();
    },
    changePage: function changePage(currentPage) {
      this.page = currentPage;
      this.getTickets();
    },

    setTicketFilter: function setTicketFilter(field, value, type, status) {
      this.filter.field = field;
      this.filter.value = value;
      this.filter.type = type;
      this.status = status;
      this.getTickets();
    },

    getTicketsStatusCount: function getTicketsStatusCount() {
      var _this = this;

      notify.loading(true);
      this.$http.get("/api/tickets-status-count", function (response) {
        _this.counts = response;
        notify.loading(false);
      }).always(function () {});
    },

    getTickets: function getTickets() {
      var _this2 = this;

      notify.loading(true);
      this.$http.get("/api/tickets", {
        field: this.filter.field,
        value: this.filter.value,
        type: this.filter.type,
        query: this.query,
        page: this.page,
        sortOrder: this.sortOrder ? 'asc' : 'desc',
        sortField: this.sortField
      }, function (response) {
        _this2.pagination = response;
        _this2.tickets = response.data;
        notify.loading(false);
      }).always(function () {});
    },

    /**
     * update entries marked as completed
     */
    updateEntries: function updateEntries() {
      var _this3 = this;

      notify.loading(true);
      this.$http.post("/api/update-timesheet-accounting-team-1-pending", {
        ids: this.ids
      }, function (response) {
        notify.loading(false);
        _this3.getEntries();
      }).always(function () {});
    },

    sortBy: function sortBy(field, reverse, primer) {
      var key = primer ? function (x) {
        return primer(x[field]);
      } : function (x) {
        return x[field];
      };

      reverse = !reverse ? 1 : -1;

      return function (a, b) {
        return a = key(a), b = key(b), reverse * ((a > b) - (b > a));
      };
    },

    sortUsers: function sortUsers(field, reverse) {
      var primer = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];

      console.log(field);
      this.sortOrders = reverse;
      this.sortKey = field;
      this.employees.sort(this.sortBy(field, reverse, primer));
    },

    showCreateTicketModal: function showCreateTicketModal() {
      this.resetTicket();
      modals.showStrict("#create-ticket-modal");
    },

    createNewTicket: function createNewTicket() {
      var _this4 = this;

      notify.loading(true);
      var imagefile = document.querySelector('#file');
      // let data = {
      //   application: this.ticket.application,
      //   priority: this.ticket.priority,
      //   title: this.ticket.title,
      //   time_occurred: this.ticket.time_occurred,
      //   description: this.ticket.description,
      //   file: imagefile.files[0]
      // };
      var formData = new FormData();
      formData.append('file', imagefile.files[0]);
      formData.append('application', this.ticket.application);
      formData.append('priority', this.ticket.priority);
      formData.append('title', this.ticket.title);
      formData.append('time_occurred', this.ticket.time_occurred);
      formData.append('description', this.ticket.description);
      formData.append('type', this.ticket.type);

      this.$http({
        method: "post",
        url: "/api/create-new-ticket",
        data: formData,
        headers: { "Content-Type": "multipart/form-data" }
      }).then(function (response) {
        notify.loading(false);
        modals.hide("#create-ticket-modal");
        _this4.resetTicket();
        notify.success("Ticket created successfully");
        _this4.getTickets();
        _this4.getTicketsStatusCount();
      })["catch"](function (response) {
        notify.loading(false);
      });
      // this.$http
      //     .post(
      //         `/api/create-new-ticket`, formData, {
      //           headers: {
      //             'Content-Type': 'multipart/form-data'
      //           }
      //         },
      //         response => {
      //           notify.loading(false);
      //           modals.hide("#create-ticket-modal");
      //           this.resetTicket();
      //           notify.success("Ticket created successfully");
      //           this.getTickets();
      //           this.getTicketsStatusCount();
      //
      //         }
      //     )
      //     .always(() => {
      //       notify.loading(false);
      //     });
    },

    resetTicket: function resetTicket() {
      this.ticket = {
        application: '',
        priority: '',
        title: '',
        time_occurred: '',
        description: '',
        type: ''
      };
    },

    showEditTicketModal: function showEditTicketModal(ticket) {
      this.ticket = _.cloneDeep(ticket);
      modals.showStrict("#edit-ticket-modal");
    },

    addNewComment: function addNewComment() {
      var _this5 = this;

      notify.loading(true);
      this.$http.post("/api/create-new-comment", {
        ticket_id: this.ticket.id,
        comment: this.comment
      }, function (response) {
        notify.loading(false);
        _this5.comment = "";
        _this5.ticket.comments = response;
        notify.success("Comment posted successfully");
      }).always(function () {});
    },

    editTicket: function editTicket() {
      var _this6 = this;

      notify.loading(true);
      this.$http.post("/api/edit-ticket/" + this.ticket.id, {
        application: this.ticket.application,
        priority: this.ticket.priority,
        title: this.ticket.title,
        time_occurred: this.ticket.time_occurred,
        description: this.ticket.description,
        status: this.ticket.status,
        assigned_to: this.ticket.assigned_to,
        type: this.ticket.type
      }, function (response) {
        notify.loading(false);
        modals.hide("#edit-ticket-modal");
        _this6.resetTicket();
        _this6.getTickets();
        _this6.getTicketsStatusCount();
      }).always(function () {});
    },

    viewTicket: function viewTicket(ticket) {
      this.ticket = _.cloneDeep(ticket);
      modals.showStrict("#view-ticket-modal");
    },

    uploadFile: function uploadFile() {
      var _this7 = this;

      notify.loading(true);
      this.$http.post("/api/upload-ticket-file/" + this.ticket.id, {
        file: this.$els.file.files[0]
      }, function (response) {
        notify.loading(false);
        _this7.ticket.files = response;
        notify.success("File uploaded successfully");
      }).always(function () {});
    }

  }
};
module.exports = exports["default"];
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n  <div class=\"row\" _v-3208c0cc=\"\">\n    <div class=\"col-md-12 col-sm-12 no-padding-left\" _v-3208c0cc=\"\">\n      <div class=\"row p-20\" _v-3208c0cc=\"\">\n        <div class=\"col-md-4 col-sm-4 text-left pull-left\" _v-3208c0cc=\"\">\n          <div class=\"input-group content-group  col-md-12 pull-left\" _v-3208c0cc=\"\">\n            <div class=\"has-feedback has-feedback-right\" _v-3208c0cc=\"\">\n              <input type=\"text\" class=\"form-control input-xlg search-box\" value=\"\" v-model=\"query\" @keyup.enter=\"getTickets\" autocomplete=\"off\" _v-3208c0cc=\"\">\n              <div class=\"form-control-feedback\" _v-3208c0cc=\"\">\n                <i class=\"icon-search4 text-muted font-20\" _v-3208c0cc=\"\"></i>\n              </div>\n            </div>\n          </div>\n          <!--          <input type=\"text\" name=\"search tool\" v-model=\"query\" class=\"form-control input-lg search-box\"-->\n          <!--                 placeholder=\"Search Tools\">-->\n        </div>\n        <div class=\"col-md-4 col-sm-4  p-5\" _v-3208c0cc=\"\">\n\n        </div>\n        <div class=\"col-md-4 col-sm-4 text-right pull-right\" _v-3208c0cc=\"\">\n          <!--          <button class=\"btn  font-20 btn-submit\" @click=\"getTickets\">-->\n          <!--            <i class=\"icon-filter4 position-right font-20 badge-pill pr-15\"></i>-->\n          <!--            Filter-->\n          <!--          </button>-->\n        </div>\n\n      </div>\n      <div class=\"row\" _v-3208c0cc=\"\">\n        <div class=\"col-md-2 no-padding-right \" _v-3208c0cc=\"\">\n          <div class=\"row  font-18 pl-20 pt-15\" _v-3208c0cc=\"\">\n            <div class=\"col-md-12 col-sm-12 border-bottom border-bottom-task m-10 p-5 pb-10 pr-20 cursor-pointer\" @click=\"setTicketFilter('','','','All')\" _v-3208c0cc=\"\">\n              <div class=\"col-md-8 text-left\" _v-3208c0cc=\"\">All</div>\n              <div class=\"col-md-4 text-right\" _v-3208c0cc=\"\"><span class=\"badge bg-success ms-2 font-16 pl-10 pr-10 radius-10\" _v-3208c0cc=\"\">{{ counts.all }}</span>\n              </div>\n            </div>\n            <div class=\"col-md-12 col-sm-12 border-bottom border-bottom-task m-10 p-5 pb-10 pr-20 cursor-pointer\" @click=\"setTicketFilter('assigned_to','0','!=','Assigned')\" _v-3208c0cc=\"\">\n              <div class=\"col-md-8 text-left\" _v-3208c0cc=\"\">Assigned</div>\n              <div class=\"col-md-4 text-right\" _v-3208c0cc=\"\"><span class=\"badge bg-ticket ms-2 font-16 pl-10 pr-10 radius-10\" _v-3208c0cc=\"\">{{ counts.assignedTickets }}</span>\n              </div>\n            </div>\n            <div class=\"col-md-12 col-sm-12 border-bottom border-bottom-task m-10 p-5 pb-10 pr-20 cursor-pointer\" @click=\"setTicketFilter('assigned_to','null','=','Unassigned')\" _v-3208c0cc=\"\">\n              <div class=\"col-md-8 text-left\" _v-3208c0cc=\"\">Unassigned</div>\n              <div class=\"col-md-4 text-right\" _v-3208c0cc=\"\"><span class=\"badge bg-ticket ms-2 font-16 pl-10 pr-10 radius-10\" _v-3208c0cc=\"\">{{ counts.unAssignedTickets }}</span>\n              </div>\n            </div>\n          </div>\n\n          <!--          <div class=\"row pt-15 border-2 border-bottom border-bottom-task\">-->\n\n          <!--          </div>-->\n\n          <div class=\"row  font-18 pl-20\" _v-3208c0cc=\"\">\n            <div class=\"col-md-12 col-sm-12 border-bottom border-bottom-task m-10 p-5 pb-10 pr-20 cursor-pointer\" @click=\"setTicketFilter('status','1','=','Open')\" _v-3208c0cc=\"\">\n              <div class=\"col-md-8 text-left\" _v-3208c0cc=\"\">Open</div>\n              <div class=\"col-md-4 text-right\" _v-3208c0cc=\"\"><span class=\"badge bg-orange ms-2 font-16 pl-10 pr-10 radius-10\" _v-3208c0cc=\"\">{{ counts.open }}</span>\n              </div>\n            </div>\n            <!--            <div class=\"col-md-12 col-sm-12 border-bottom border-bottom-task m-10 p-5 pb-10 pr-20\">-->\n            <!--              <div class=\"col-md-8 text-left\">Pending</div>-->\n            <!--              <div class=\"col-md-4 text-right\"><span-->\n            <!--                  class=\"badge bg-danger ms-2 font-16 pl-10 pr-10 radius-10\">26</span>-->\n            <!--              </div>-->\n            <!--            </div>-->\n            <!--            <div class=\"col-md-12 col-sm-12 border-bottom border-bottom-task m-10 p-5 pb-10 pr-20\">-->\n            <!--              <div class=\"col-md-8 text-left\">Solved</div>-->\n            <!--              <div class=\"col-md-4 text-right\"><span-->\n            <!--                  class=\"badge bg-green ms-2 font-16 pl-10 pr-10 radius-10\">26</span>-->\n            <!--              </div>-->\n            <!--            </div>-->\n            <div class=\"col-md-12 col-sm-12 m-10 p-5 pb-10 pr-20 cursor-pointer\" @click=\"setTicketFilter('status','0','=','Closed')\" _v-3208c0cc=\"\">\n              <div class=\"col-md-8 text-left\" _v-3208c0cc=\"\">Closed</div>\n              <div class=\"col-md-4 text-right\" _v-3208c0cc=\"\"><span class=\"badge bg-primary ms-2 font-16 pl-10 pr-10 radius-10\" _v-3208c0cc=\"\">{{ counts.closed }}</span>\n              </div>\n            </div>\n          </div>\n\n        </div>\n\n        <div class=\"col-md-10 no-padding-left border-2 border-left border-left-task\" _v-3208c0cc=\"\">\n          <div class=\"col-md-12 col-sm-12  no-padding-left no-padding-right\" _v-3208c0cc=\"\">\n            <table class=\"table table-xxs\" _v-3208c0cc=\"\">\n              <thead class=\"header custom-header\" _v-3208c0cc=\"\">\n\n              <tr class=\"bg-top-1\" _v-3208c0cc=\"\">\n                <th class=\"text-center p-5 font-40 pl-10\" colspan=\"7\" _v-3208c0cc=\"\">\n                  {{ status }} Tickets\n                </th>\n              </tr>\n\n              <tr _v-3208c0cc=\"\">\n                <th class=\"bg-top-1 text-center text-black text-uppercase column-header\" _v-3208c0cc=\"\">\n                  ID\n                </th>\n                <th @click=\"sortTickets('user_name',!sortOrder)\" class=\"bg-top-1 text-center text-black cursor-pointer text-uppercase column-header\" _v-3208c0cc=\"\">\n                  Requester\n                  <i :class=\"sortOrder ? 'fa fa-arrow-down font-20':'fa fa-arrow-up font-20'\" v-if=\"sortField === 'user_name'\" _v-3208c0cc=\"\"></i>\n\n                </th>\n                <th @click=\"sortTickets('time_occurred',!sortOrder)\" class=\"bg-top-1 text-center text-black cursor-pointer text-uppercase column-header\" _v-3208c0cc=\"\">\n                  Created\n                  <i :class=\"sortOrder ? 'fa fa-arrow-down font-20':'fa fa-arrow-up font-20'\" v-if=\"sortField === 'time_occurred'\" _v-3208c0cc=\"\"></i>\n                </th>\n                <th class=\"bg-top-1 text-black text-center text-uppercase column-header\" _v-3208c0cc=\"\">Subject</th>\n                <th class=\"bg-top-1 text-black text-center text-uppercase column-header\" _v-3208c0cc=\"\">Assigned To</th>\n                <th class=\"bg-top-1 text-black text-center text-uppercase column-header\" @click=\"sortTickets('priority',!sortOrder)\" _v-3208c0cc=\"\">\n                  Priority\n                  <i :class=\"sortOrder ? 'fa fa-arrow-down font-20':'fa fa-arrow-up font-20'\" v-if=\"sortField === 'priority'\" _v-3208c0cc=\"\"></i>\n                </th>\n                <th class=\"bg-top-1 text-black text-center text-uppercase column-header\" _v-3208c0cc=\"\">Status</th>\n\n              </tr>\n              </thead>\n              <tbody _v-3208c0cc=\"\">\n              <tr v-for=\"ticket in tickets\" class=\"\" _v-3208c0cc=\"\">\n                <td class=\"text-center table-data\" _v-3208c0cc=\"\">\n                  <a href=\"#\" @click=\"showEditTicketModal(ticket)\" class=\"link-primary\" _v-3208c0cc=\"\">{{ ticket.id }}</a>\n                </td>\n                <td class=\"text-center table-data\" _v-3208c0cc=\"\">\n                  {{ ticket.user_name }}\n                </td>\n                <td class=\"text-center table-data\" _v-3208c0cc=\"\">\n                  {{ ticket.occurred }}\n                </td>\n                <td class=\"text-center table-data cursor-pointer\" @click=\"viewTicket(ticket)\" _v-3208c0cc=\"\">\n                  {{ ticket.title }}\n                </td>\n                <td class=\"text-center table-data\" _v-3208c0cc=\"\">\n                  {{ assign[ticket.assigned_to] }}\n                </td>\n                <td class=\"text-center table-data cursor-pointer\" @click=\"viewTicket(ticket)\" _v-3208c0cc=\"\">\n                <span v-if=\"ticket.priority == 1\" class=\"badge bg-danger ms-2 font-12 pl-15 pr-15 radius-10\" _v-3208c0cc=\"\">High</span>\n                  <span v-if=\"ticket.priority == 2\" class=\"badge bg-orange ms-2 font-12 pl-15 pr-15 radius-10\" _v-3208c0cc=\"\">Medium</span>\n                  <span v-if=\"ticket.priority == 3\" class=\"badge bg-success ms-2 font-12 pl-15 pr-15 radius-10\" _v-3208c0cc=\"\">Low</span>\n                </td>\n                <td class=\"text-center table-data\" _v-3208c0cc=\"\">\n                  <span v-if=\"ticket.status == 1\" class=\"badge bg-orange ms-2 font-12 pl-15 pr-15 radius-10\" _v-3208c0cc=\"\">Open</span>\n                  <span v-if=\"ticket.status == 0\" class=\"badge bg-success ms-2 font-12 pl-15 pr-15 radius-10\" _v-3208c0cc=\"\">Closed</span>\n                </td>\n              </tr>\n              </tbody>\n            </table>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div id=\"create-ticket-modal\" aria-hidden=\"true\" aria-labelledby=\"exampleModalLabel\" class=\"modal fade\" role=\"dialog\" tabindex=\"-1\" _v-3208c0cc=\"\">\n      <div class=\"modal-dialog modal-lg\" role=\"document\" _v-3208c0cc=\"\">\n        <div class=\"modal-content\" _v-3208c0cc=\"\">\n          <div class=\"modal-header no-padding bg-slate-700\" _v-3208c0cc=\"\">\n            <div class=\"col-md-12 col-sm-12 col-xs-12 p-5 text-black text-center bg-modal-header font-30\" _v-3208c0cc=\"\"> Create a New\n              Ticket\n            </div>\n            <button aria-label=\"Close\" class=\"close close-modal\" data-dismiss=\"modal\" type=\"button\" _v-3208c0cc=\"\">\n              <span aria-hidden=\"true\" _v-3208c0cc=\"\">×</span>\n            </button>\n          </div>\n          <div class=\"modal-body no-padding-left no-padding-right\" _v-3208c0cc=\"\">\n            <div class=\"col-md-6 text-left\" _v-3208c0cc=\"\">\n              <span class=\"custom-blue font-20 text-black\" _v-3208c0cc=\"\">\n                Application Name\n              </span>\n              <div class=\"form-group \" _v-3208c0cc=\"\">\n                <select class=\"form-control input-radius\" name=\"role\" v-model=\"ticket.application\" _v-3208c0cc=\"\">\n                  <option value=\"Time clock app\" _v-3208c0cc=\"\">Time clock app</option>\n                  <option value=\"Field Manager App\" _v-3208c0cc=\"\">Field Manager App</option>\n                  <option value=\"Employee App\" _v-3208c0cc=\"\">Employee App</option>\n                  <option value=\"Elegant Staffing Web App\" _v-3208c0cc=\"\">Elegant Staffing Web App</option>\n                  <option value=\"Accounting App\" _v-3208c0cc=\"\">Accounting App</option>\n                </select>\n              </div>\n            </div>\n            <div class=\"col-md-6 text-left\" _v-3208c0cc=\"\">\n              <span class=\"custom-blue font-20 text-black\" _v-3208c0cc=\"\">\n                 Priority\n              </span>\n              <div class=\"form-group \" _v-3208c0cc=\"\">\n                <select class=\"form-control input-radius\" name=\"role\" placeholder=\"Select Ticket Type\" v-model=\"ticket.priority\" _v-3208c0cc=\"\">\n                  <option value=\"1\" _v-3208c0cc=\"\">High</option>\n                  <option value=\"2\" _v-3208c0cc=\"\">Medium</option>\n                  <option value=\"3\" _v-3208c0cc=\"\">Low</option>\n                </select>\n              </div>\n            </div>\n            <div class=\"col-md-6 text-left\" _v-3208c0cc=\"\">\n              <span class=\"custom-blue font-20 text-black\" _v-3208c0cc=\"\">\n                Subject\n              </span>\n              <div class=\"form-group\" _v-3208c0cc=\"\">\n                <input type=\"text\" class=\"form-control input-radius\" placeholder=\"Enter title/subject of an issue\" v-model=\"ticket.title\" _v-3208c0cc=\"\">\n              </div>\n            </div>\n            <div class=\"col-md-6 text-left\" _v-3208c0cc=\"\">\n              <span class=\"custom-blue font-20 text-black\" _v-3208c0cc=\"\">\n                Time Occurred\n              </span>\n              <div class=\"form-group\" _v-3208c0cc=\"\">\n                <input type=\"text\" id=\"anytime-both\" class=\"form-control input-radius\" placeholder=\"select time of the issue\" v-model=\"ticket.time_occurred\" _v-3208c0cc=\"\">\n              </div>\n            </div>\n            <div class=\"col-md-6 text-left\" _v-3208c0cc=\"\">\n              <span class=\"custom-blue font-20 text-black\" _v-3208c0cc=\"\">\n                Ticket Type\n              </span>\n              <div class=\"form-group \" _v-3208c0cc=\"\">\n                <select class=\"form-control input-radius\" name=\"role\" placeholder=\"Select Ticket Type\" v-model=\"ticket.type\" _v-3208c0cc=\"\">\n                  <option value=\"Defect\" _v-3208c0cc=\"\">Defect</option>\n                  <option value=\"New Functionality\" _v-3208c0cc=\"\">New Functionality</option>\n                  <option value=\"Knowledge Gap\" _v-3208c0cc=\"\">Knowledge Gap</option>\n                  <option value=\"UI Issue\" _v-3208c0cc=\"\">UI Issue</option>\n                </select>\n              </div>\n            </div>\n            <div class=\"col-md-6 text-left no-padding-left\" _v-3208c0cc=\"\">\n                <span class=\"custom-blue font-20 text-black\" _v-3208c0cc=\"\">\n                Attachment\n              </span>\n              <input type=\"file\" name=\"file\" id=\"file\" class=\"form-control\" _v-3208c0cc=\"\">\n            </div>\n\n            <div class=\"col-md-12 text-left\" _v-3208c0cc=\"\">\n              <span class=\"custom-blue font-20 text-black\" _v-3208c0cc=\"\">\n                Description\n              </span>\n              <div class=\"form-group\" _v-3208c0cc=\"\">\n                <textarea rows=\"5\" cols=\"5\" class=\"form-control input-radius\" autocomplete=\"off\" v-model=\"ticket.description\" _v-3208c0cc=\"\"></textarea>\n              </div>\n            </div>\n\n          </div>\n          <div class=\"modal-footer no-padding-bottom pt-10 pb-10\" _v-3208c0cc=\"\">\n            <div class=\"row\" _v-3208c0cc=\"\">\n\n              <div class=\"col-md-12 no-padding-right\" _v-3208c0cc=\"\">\n                <button class=\"btn btn-primary custom-submit font-16 text-bold\" type=\"button\" @click.prevent=\"createNewTicket\" _v-3208c0cc=\"\">Submit\n                </button>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <!--    modal to view an existing ticket-->\n    <div id=\"view-ticket-modal\" aria-hidden=\"true\" aria-labelledby=\"exampleModalLabel\" class=\"modal fade\" role=\"dialog\" tabindex=\"-1\" _v-3208c0cc=\"\">\n      <div class=\"modal-dialog modal-md\" role=\"document\" _v-3208c0cc=\"\">\n        <div class=\"modal-content\" _v-3208c0cc=\"\">\n          <div class=\"modal-header no-padding bg-slate-700\" _v-3208c0cc=\"\">\n            <div class=\"col-md-12 col-sm-12 col-xs-12 p-5 text-black text-center bg-modal-header font-30\" _v-3208c0cc=\"\"> Ticket. {{\n                ticket.id\n              }}\n            </div>\n            <button aria-label=\"Close\" class=\"close close-modal\" data-dismiss=\"modal\" type=\"button\" _v-3208c0cc=\"\">\n              <span aria-hidden=\"true\" _v-3208c0cc=\"\">×</span>\n            </button>\n          </div>\n          <div class=\"modal-body no-padding-left no-padding-right\" _v-3208c0cc=\"\">\n            <div class=\"col-md-6 text-left pl-15 pr-15 pt-5 pb-5\" _v-3208c0cc=\"\">\n              <span class=\"custom-blue font-18 font-weight-500\" _v-3208c0cc=\"\">\n                Requested By\n              </span>\n            </div>\n            <div class=\"col-md-6 text-right pl-15 pr-15 pt-5 pb-5\" _v-3208c0cc=\"\">\n              <span class=\" font-18 \" _v-3208c0cc=\"\">\n                {{ ticket.user_name }}\n              </span>\n            </div>\n\n            <div class=\"col-md-6 text-left pl-15 pr-15 pt-5 pb-5\" _v-3208c0cc=\"\">\n              <span class=\"custom-blue font-18  font-weight-500\" _v-3208c0cc=\"\">\n                Requested On\n              </span>\n            </div>\n            <div class=\"col-md-6 text-right pl-15 pr-15 pt-5 pb-5\" _v-3208c0cc=\"\">\n              <span class=\" font-18 \" _v-3208c0cc=\"\">\n                {{ ticket.created }}\n              </span>\n            </div>\n            <div class=\"col-md-6 text-left pl-15 pr-15 pt-5 pb-5\" _v-3208c0cc=\"\">\n              <span class=\"custom-blue font-18  font-weight-500\" _v-3208c0cc=\"\">\n                Assigned To\n              </span>\n            </div>\n            <div class=\"col-md-6 text-right pl-15 pr-15 pt-5 pb-5\" _v-3208c0cc=\"\">\n              <span class=\" font-18 \" _v-3208c0cc=\"\">\n                 {{ assign[ticket.assigned_to] }}\n              </span>\n            </div>\n\n            <div class=\"col-md-6 text-left pl-15 pr-15 pt-5 pb-5\" _v-3208c0cc=\"\">\n              <span class=\"custom-blue font-18  font-weight-500\" _v-3208c0cc=\"\">\n                Priority\n              </span>\n            </div>\n            <div class=\"col-md-6 text-right pl-15 pr-15 pt-5 pb-5\" _v-3208c0cc=\"\">\n              <span class=\" font-18 \" _v-3208c0cc=\"\">\n                <span v-if=\"ticket.priority == 1\" class=\"badge bg-danger ms-2 font-12 pl-15 pr-15 radius-10\" _v-3208c0cc=\"\">High</span>\n                  <span v-if=\"ticket.priority == 2\" class=\"badge bg-orange ms-2 font-12 pl-15 pr-15 radius-10\" _v-3208c0cc=\"\">Medium</span>\n                <span v-if=\"ticket.priority == 3\" class=\"badge bg-success ms-2 font-12 pl-15 pr-15 radius-10\" _v-3208c0cc=\"\">Low</span>\n              </span>\n            </div>\n\n            <div class=\"col-md-6 text-left pl-15 pr-15 pt-5 pb-5\" _v-3208c0cc=\"\">\n              <span class=\"custom-blue font-18  font-weight-500\" _v-3208c0cc=\"\">\n                Status\n              </span>\n            </div>\n            <div class=\"col-md-6 text-right pl-15 pr-15 pt-5 pb-5\" _v-3208c0cc=\"\">\n              <span class=\" font-18 \" _v-3208c0cc=\"\">\n                 <span v-if=\"ticket.status == 1\" class=\"badge bg-orange ms-2 font-12 pl-15 pr-15 radius-10\" _v-3208c0cc=\"\">Open</span>\n                  <span v-if=\"ticket.status == 0\" class=\"badge bg-success ms-2 font-12 pl-15 pr-15 radius-10\" _v-3208c0cc=\"\">Closed</span>\n              </span>\n            </div>\n\n            <div class=\"col-md-12 text-left pl-15 pr-15 pt-5 pb-5\" _v-3208c0cc=\"\">\n              <span class=\"custom-blue font-18  font-weight-500\" _v-3208c0cc=\"\">\n                Description\n              </span>\n              <div class=\"form-group\" _v-3208c0cc=\"\">\n                <textarea rows=\"5\" cols=\"5\" class=\"form-control input-radius\" autocomplete=\"off\" readonly=\"\" v-model=\"ticket.description\" _v-3208c0cc=\"\"></textarea>\n              </div>\n            </div>\n\n\n          </div>\n          <div class=\"modal-footer no-padding-bottom pt-10 pb-10\" _v-3208c0cc=\"\">\n            <!--            <button class=\"btn btn-primary custom-submit font-16 text-bold\" type=\"button\"-->\n            <!--                    @click.prevent=\"createNewTicket\">Submit-->\n            <!--            </button>-->\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <!--modal to edit an existing ticket-->\n    <div id=\"edit-ticket-modal\" aria-hidden=\"true\" aria-labelledby=\"exampleModalLabel\" class=\"modal fade\" role=\"dialog\" tabindex=\"-1\" _v-3208c0cc=\"\">\n      <div class=\"modal-dialog modal-full\" role=\"document\" _v-3208c0cc=\"\">\n        <div class=\"modal-content\" _v-3208c0cc=\"\">\n          <div class=\"modal-header no-padding bg-slate-700\" _v-3208c0cc=\"\">\n            <div class=\"col-md-12 col-sm-12 col-xs-12 p-5 text-black text-center bg-modal-header font-30\" _v-3208c0cc=\"\"> Ticket:\n              {{ ticket.id }}\n            </div>\n            <button aria-label=\"Close\" class=\"close close-modal\" data-dismiss=\"modal\" type=\"button\" _v-3208c0cc=\"\">\n              <span aria-hidden=\"true\" _v-3208c0cc=\"\">×</span>\n            </button>\n          </div>\n          <div class=\"modal-body no-padding-left no-padding-right\" _v-3208c0cc=\"\">\n\n            <div class=\"col-md-4\" _v-3208c0cc=\"\">\n              <div class=\"col-md-12 text-left\" _v-3208c0cc=\"\">\n              <span class=\"custom-blue font-20 text-black\" _v-3208c0cc=\"\">\n                Application Name\n              </span>\n                <div class=\"form-group \" _v-3208c0cc=\"\">\n                  <select class=\"form-control input-radius\" name=\"role\" v-model=\"ticket.application\" _v-3208c0cc=\"\">\n                    <option value=\"Time clock app\" _v-3208c0cc=\"\">Time clock app</option>\n                    <option value=\"Field Manager App\" _v-3208c0cc=\"\">Field Manager App</option>\n                    <option value=\"Employee App\" _v-3208c0cc=\"\">Employee App</option>\n                    <option value=\"Elegant Staffing Web App\" _v-3208c0cc=\"\">Elegant Staffing Web App</option>\n                    <option value=\"Accounting App\" _v-3208c0cc=\"\">Accounting App</option>\n                  </select>\n                </div>\n              </div>\n\n              <div class=\"col-md-12 text-left\" _v-3208c0cc=\"\">\n              <span class=\"custom-blue font-20 text-black\" _v-3208c0cc=\"\">\n                Subject\n              </span>\n                <div class=\"form-group\" _v-3208c0cc=\"\">\n                  <input type=\"text\" class=\"form-control input-radius\" placeholder=\"Enter title/subject of an issue\" v-model=\"ticket.title\" _v-3208c0cc=\"\">\n                </div>\n              </div>\n\n              <div class=\"col-md-12 text-left\" _v-3208c0cc=\"\">\n              <span class=\"custom-blue font-20 text-black\" _v-3208c0cc=\"\">\n                Ticket Type\n              </span>\n                <div class=\"form-group \" _v-3208c0cc=\"\">\n                  <select class=\"form-control input-radius\" name=\"role\" placeholder=\"Select Ticket Type\" v-model=\"ticket.type\" _v-3208c0cc=\"\">\n                    <option value=\"Defect\" _v-3208c0cc=\"\">Defect</option>\n                    <option value=\"New Functionality\" _v-3208c0cc=\"\">New Functionality</option>\n                    <option value=\"Knowledge Gap\" _v-3208c0cc=\"\">Knowledge Gap</option>\n                    <option value=\"UI Issue\" _v-3208c0cc=\"\">UI Issue</option>\n                  </select>\n                </div>\n              </div>\n\n              <div class=\"col-md-12 text-left\" _v-3208c0cc=\"\">\n              <span class=\"custom-blue font-20 text-black\" _v-3208c0cc=\"\">\n                Description\n              </span>\n                <div class=\"form-group\" _v-3208c0cc=\"\">\n                <textarea rows=\"5\" cols=\"5\" class=\"form-control input-radius\" autocomplete=\"off\" v-model=\"ticket.description\" _v-3208c0cc=\"\"></textarea>\n                </div>\n              </div>\n              <div class=\"col-md-12 text-left\" v-if=\"ticket.file\" _v-3208c0cc=\"\">\n              <span class=\"custom-blue font-20 text-black\" _v-3208c0cc=\"\">\n                Attachement\n              </span>\n                <div class=\"col-md-12 text-left no-padding-left\" _v-3208c0cc=\"\">\n                  <a :href=\"ticket.file\" target=\"_blank\" _v-3208c0cc=\"\">\n                    <button class=\"btn btn-primary custom-submit font-16 text-bold pull-left mr-10\" type=\"button\" _v-3208c0cc=\"\">View File\n                    </button>\n                  </a>\n                </div>\n              </div>\n            </div>\n            <div class=\"col-md-4 border-2 border-right border-gray border-right-task\" _v-3208c0cc=\"\">\n              <div class=\"col-md-12 text-left\" _v-3208c0cc=\"\">\n              <span class=\"custom-blue font-20 text-black\" _v-3208c0cc=\"\">\n                Time Occurred\n              </span>\n                <div class=\"form-group\" _v-3208c0cc=\"\">\n                  <span class=\"font-20 \" _v-3208c0cc=\"\">{{ ticket.occurred }}</span>\n                </div>\n              </div>\n\n              <div class=\"col-md-12 text-left\" _v-3208c0cc=\"\">\n              <span class=\"custom-blue font-20 text-black\" _v-3208c0cc=\"\">\n                Status\n              </span>\n                <div class=\"form-group \" _v-3208c0cc=\"\">\n                  <select class=\"form-control input-radius\" name=\"role\" v-model=\"ticket.status\" _v-3208c0cc=\"\">\n                    <option value=\"1\" _v-3208c0cc=\"\">Open</option>\n                    <option value=\"0\" _v-3208c0cc=\"\">Closed</option>\n                  </select>\n                </div>\n              </div>\n\n              <div class=\"col-md-12 text-left\" _v-3208c0cc=\"\">\n              <span class=\"custom-blue font-20 text-black\" _v-3208c0cc=\"\">\n                 Priority\n              </span>\n                <div class=\"form-group \" _v-3208c0cc=\"\">\n                  <select class=\"form-control input-radius\" name=\"role\" placeholder=\"Select Ticket Type\" v-model=\"ticket.priority\" _v-3208c0cc=\"\">\n                    <option value=\"1\" _v-3208c0cc=\"\">High</option>\n                    <option value=\"2\" _v-3208c0cc=\"\">Medium</option>\n                    <option value=\"3\" _v-3208c0cc=\"\">Low</option>\n                  </select>\n                </div>\n              </div>\n\n              <div class=\"col-md-12 text-left\" _v-3208c0cc=\"\">\n              <span class=\"custom-blue font-20 text-black\" _v-3208c0cc=\"\">\n                Created By\n              </span>\n                <div class=\"form-group\" _v-3208c0cc=\"\">\n                  <span class=\"font-20 \" _v-3208c0cc=\"\">{{ ticket.user_name }}</span>\n                </div>\n              </div>\n\n              <div class=\"col-md-12 text-left\" _v-3208c0cc=\"\">\n              <span class=\"custom-blue font-20 text-black\" _v-3208c0cc=\"\">\n                Created On\n              </span>\n                <div class=\"form-group\" _v-3208c0cc=\"\">\n                  <span class=\"font-20 \" _v-3208c0cc=\"\">{{ ticket.created }}</span>\n                </div>\n              </div>\n\n              <div class=\"col-md-12 text-left\" _v-3208c0cc=\"\">\n              <span class=\"custom-blue font-20 text-black\" _v-3208c0cc=\"\">\n                Assigned To\n              </span>\n                <div class=\"form-group \" _v-3208c0cc=\"\">\n                  <select class=\"form-control input-radius\" name=\"role\" placeholder=\"Select Ticket Type\" v-model=\"ticket.assigned_to\" _v-3208c0cc=\"\">\n                    <option value=\"1\" _v-3208c0cc=\"\">Muntasir Rahman</option>\n                    <option value=\"2\" _v-3208c0cc=\"\">Hasibul Hasan</option>\n                    <option value=\"3\" _v-3208c0cc=\"\">Reza Shahreare</option>\n                  </select>\n                </div>\n              </div>\n\n              <button class=\"btn btn-primary custom-submit font-16 text-bold pull-right mr-10\" type=\"button\" @click.prevent=\"editTicket\" _v-3208c0cc=\"\">Update\n              </button>\n\n            </div>\n            <div class=\"col-md-4\" _v-3208c0cc=\"\">\n              <div class=\"col-md-12 text-left\" _v-3208c0cc=\"\">\n              <span class=\"custom-blue font-20 text-black\" _v-3208c0cc=\"\">\n                Comments\n              </span>\n              </div>\n              <div class=\"col-md-12\" v-for=\"comment in ticket.comments\" _v-3208c0cc=\"\">\n                <div class=\"col-md-2 pt-15\" _v-3208c0cc=\"\">\n                  <!--                  <i class=\"fa fa-user font-40\"></i>-->\n                  <span class=\"text-bold text-left text-20\" _v-3208c0cc=\"\">{{ comment.user.name }}</span>\n                </div>\n                <div class=\"col-md-10\" _v-3208c0cc=\"\">\n                  <div class=\"bubble me text-20\" _v-3208c0cc=\"\">\n                    {{ comment.comment }}<br _v-3208c0cc=\"\">\n                    <div class=\"text-right font-10 text-black\" _v-3208c0cc=\"\">{{ comment.created_at }}</div>\n                  </div>\n\n                </div>\n              </div>\n              <div class=\"col-md-12 pt-20 mt-20\" _v-3208c0cc=\"\">\n                <div class=\"col-md-12 text-left\" _v-3208c0cc=\"\">\n              <span class=\"custom-blue font-16 text-black\" _v-3208c0cc=\"\">\n                Add Comment\n              </span>\n                  <div class=\"form-group\" _v-3208c0cc=\"\">\n                <textarea rows=\"5\" cols=\"5\" class=\"form-control input-radius\" autocomplete=\"off\" v-model=\"comment\" _v-3208c0cc=\"\"></textarea>\n                  </div>\n                </div>\n                <button class=\"btn btn-primary custom-submit font-16 text-bold pull-right mr-10\" type=\"button\" @click.prevent=\"addNewComment\" _v-3208c0cc=\"\">Save\n                </button>\n              </div>\n\n            </div>\n\n          </div>\n          <div class=\"modal-footer no-padding-bottom pt-10 pb-10\" _v-3208c0cc=\"\">\n            <!--            <button class=\"btn btn-primary custom-submit font-16 text-bold\" type=\"button\"-->\n            <!--                    @click.prevent=\"createNewTicket\">Submit-->\n            <!--            </button>-->\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"col-md-12\" _v-3208c0cc=\"\">\n      <ul class=\"pagination pt-20 pb-10 pull-right pr-10\" _v-3208c0cc=\"\">\n        <li v-if=\"pagination.current_page > 1\" _v-3208c0cc=\"\">\n          <a aria-label=\"Previous\" href=\"javascript:void(0)\" v-on:click.prevent=\"changePage(pagination.current_page - 1)\" _v-3208c0cc=\"\">\n            <span aria-hidden=\"true\" _v-3208c0cc=\"\">«</span>\n          </a>\n        </li>\n        <li :class=\"{'active': page == pagination.current_page}\" :key=\"key\" v-for=\"(key,page) in pagination.totalPages\" _v-3208c0cc=\"\">\n          <a href=\"javascript:void(0)\" v-on:click.prevent=\"changePage(page)\" _v-3208c0cc=\"\">{{ page + 1 }}</a>\n        </li>\n        <li v-if=\"pagination.current_page < pagination.last_page\" _v-3208c0cc=\"\">\n          <a aria-label=\"Next\" href=\"javascript:void(0)\" v-on:click.prevent=\"changePage(pagination.current_page + 1)\" _v-3208c0cc=\"\">\n            <span aria-hidden=\"true\" _v-3208c0cc=\"\">»</span>\n          </a>\n        </li>\n      </ul>\n    </div>\n\n    <div class=\"circle-div text-center\" _v-3208c0cc=\"\">\n      <i class=\"fa fa-plus text-white font-add-icon cursor-pointer\" @click.prevent=\"showCreateTicketModal\" _v-3208c0cc=\"\"></i>\n    </div>\n  </div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  var id = "/home/shoieb/sites/elegant/resources/assets/js/vue/components/tickets-dashboard.vue"
  module.hot.dispose(function () {
    require("vueify-insert-css").cache["\n\n\n.search-box[_v-3208c0cc] {\n  width: 100%;\n  height: 50px;\n  border: 1px solid #098AD6;\n  border-radius: 5px;\n  padding: 5px;\n  font-size: 14px;\n  color: #000;\n  background-color: #FFFFFF;\n}\n\n.custom-checkbox[_v-3208c0cc] {\n  height: 24px;\n  padding: 5px 10px;\n  font-size: 12px;\n  line-height: 1.6666667;\n  border-radius: 5px;\n}\n\ninput[type=\"checkbox\"][_v-3208c0cc] {\n  accent-color: #009ACC;\n}\n\ninput[type=\"checkbox\"]#checkbox1:checked + span[_v-3208c0cc] {\n  border-color: red;\n  background-color: red;\n}\n\n.table-data[_v-3208c0cc] {\n  padding: 10px;\n  font-size: 17px;\n  color: #44505E;\n  font-weight: 400;\n  border-right: 2px solid #EDEEF3;\n  border-bottom: 2px solid #EDEEF3;\n}\n\n.close-modal[_v-3208c0cc] {\n  font-size: 30px;\n  margin-top: -14.75px;\n  font-weight: 500;\n}\n\n.close-modal-29[_v-3208c0cc] {\n  font-size: 30px;\n  margin-top: -29.75px !important;\n  font-weight: 500;\n}\n\n.close-modal-0[_v-3208c0cc] {\n  font-size: 35px;\n  margin-top: 0 !important;\n  font-weight: 500;\n  z-index: 100;\n  color: #656565 !important;\n}\n\n.font-20[_v-3208c0cc] {\n  font-size: 20px;\n}\n\n\n.font-40[_v-3208c0cc] {\n  font-size: 40px;\n}\n\n\n.bg-slate-custom[_v-3208c0cc] {\n  background-color: #d6dce5;\n  border-color: #d6dce5;\n}\n\n.custom-header[_v-3208c0cc] {\n  position: -webkit-sticky;\n  position: sticky;\n  top: 48px;\n  z-index: 100;\n}\n\n.top-65[_v-3208c0cc] {\n  top: 65px;\n}\n\n.bg-top-1[_v-3208c0cc] {\n  background-color: #202935;\n  border-color: #202935;\n  color: #fff;\n}\n\n.bg-top-2[_v-3208c0cc] {\n  background-color: #fff;\n  border-color: #fff;\n  color: #fff;\n}\n\n.column-header[_v-3208c0cc] {\n  padding: 12px !important;\n  font-size: 18px !important;\n  font-weight: 700 !important;\n  border-right: 2px solid #d6dce5;\n}\n\n.bg-top-3[_v-3208c0cc] {\n  background-color: #202933;\n  border-color: #202933;\n  color: #fff;\n}\n\n[_v-3208c0cc]::-webkit-input-placeholder {\n  text-align: left;\n  font-size: 20px\n}\n\n[_v-3208c0cc]:-moz-placeholder { /* Firefox 18- */\n  text-align: left;\n  font-size: 20px\n}\n\n[_v-3208c0cc]::-moz-placeholder { /* Firefox 19+ */\n  text-align: left;\n  font-size: 20px\n}\n\n[_v-3208c0cc]:-ms-input-placeholder {\n  text-align: left;\n  font-size: 20px\n}\n\n.btn-submit[_v-3208c0cc] {\n  padding: 5px 20px !important;\n  font-size: 25px !important;\n  font-weight: 600 !important;\n  border-radius: 5px;\n  background-color: #FFFFFF;\n  border-color: #098AD6;\n  color: #098AD6;\n}\n\n.radius-10[_v-3208c0cc] {\n  border-radius: 10px;\n}\n\n.bg-ticket[_v-3208c0cc] {\n  background-color: #029ACB;\n  border-color: #029ACB;\n  color: #FFFFFF;\n}\n\n.border-bottom-task[_v-3208c0cc] {\n  border-bottom-color: #EEEEEE;\n}\n\n.border-right-task[_v-3208c0cc] {\n  border-right-color: #EEEEEE;\n}\n\n.border-left-task[_v-3208c0cc] {\n  border-left-color: #EEEEEE;\n}\n\n.bg-modal-header[_v-3208c0cc] {\n  background-color: #3C4C60;\n  border-color: #3C4C60;\n  color: #FFFFFF;\n}\n\n.custom-blue[_v-3208c0cc] {\n  color: #029ACB;\n}\n\n.input-bg[_v-3208c0cc] {\n  background-color: #ddd !important;\n}\n\n\n.input-radius[_v-3208c0cc] {\n  background-color: #E9EFF1 !important;\n  border: 1px solid #E9EFF1 !important;\n  -moz-border-radius: 7px;\n  -webkit-border-radius: 7px;\n  border-radius: 7px;\n  font-size: 15px;\n  padding: 4px 7px;\n  outline: 0;\n  -webkit-appearance: none;\n}\n\n.custom-submit[_v-3208c0cc] {\n  background-color: #029ACB;\n  border-color: #029ACB;\n  padding-right: 50px;\n  padding-left: 50px;\n}\n\n.circle-div[_v-3208c0cc] {\n  background-color: #20C6A5;\n  height: 50px;\n  width: 50px;\n  border-radius: 100%;\n  position: fixed;\n  bottom: 21px;\n  right: 25px;\n}\n\n.font-add-icon[_v-3208c0cc] {\n  font-size: 40px;\n  padding-top: 5px;\n}\n\n\n.bubble[_v-3208c0cc] {\n  background-color: #F2F2F2;\n  border-radius: 5px;\n  box-shadow: 0 0 6px #B2B2B2;\n  display: inline-block;\n  padding: 10px 18px;\n  position: relative;\n  vertical-align: top;\n}\n\n.bubble[_v-3208c0cc]::before {\n  background-color: #F2F2F2;\n  content: \"\\00a0\";\n  display: block;\n  height: 16px;\n  position: absolute;\n  top: 11px;\n  transform: rotate(29deg) skew(-35deg);\n  -moz-transform: rotate(29deg) skew(-35deg);\n  -ms-transform: rotate(29deg) skew(-35deg);\n  -o-transform: rotate(29deg) skew(-35deg);\n  -webkit-transform: rotate(29deg) skew(-35deg);\n  width: 20px;\n}\n\n.me[_v-3208c0cc] {\n  float: left;\n  margin: 5px 45px 5px 20px;\n}\n\n.me[_v-3208c0cc]::before {\n  box-shadow: -2px 2px 2px 0 rgba(178, 178, 178, .4);\n  left: -9px;\n}\n\n.font-weight-500[_v-3208c0cc] {\n  font-weight: 500;\n}\n\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, module.exports.template)
  }
})()}
},{"./../../mixed/modals":10,"./../../mixed/notify":11,"vue":5,"vue-hot-reload-api":4,"vueify-insert-css":6}],87:[function(require,module,exports){
var __vueify_style__ = require("vueify-insert-css").insert("\n\n\n.search-box[_v-1c4e4af6] {\n  width: 100%;\n  height: 50px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  padding: 5px;\n  font-size: 14px;\n  color: #000;\n}\n\n.custom-checkbox[_v-1c4e4af6] {\n  height: 24px;\n  padding: 5px 10px;\n  font-size: 12px;\n  line-height: 1.6666667;\n  border-radius: 5px;\n}\n\ninput[type=\"checkbox\"][_v-1c4e4af6] {\n  accent-color: #009ACC;\n}\n\ninput[type=\"checkbox\"]#checkbox1:checked + span[_v-1c4e4af6] {\n  border-color: red;\n  background-color: red;\n}\n\n.table-data[_v-1c4e4af6] {\n  padding: 5px;\n  font-size: 16px;\n  color: #44505E;\n  font-weight: 400;\n  border-right: 2px solid #EDEEF3;\n  border-left: 2px solid #EDEEF3;\n  border-bottom: 2px solid #EDEEF3;\n}\n\n.close-modal[_v-1c4e4af6] {\n  font-size: 30px;\n  margin-top: -14.75px;\n  font-weight: 500;\n}\n\n.close-modal-29[_v-1c4e4af6] {\n  font-size: 30px;\n  margin-top: -29.75px !important;\n  font-weight: 500;\n}\n\n.close-modal-0[_v-1c4e4af6] {\n  font-size: 35px;\n  margin-top: 0 !important;\n  font-weight: 500;\n  z-index: 100;\n  color: #656565 !important;\n}\n\n.font-20[_v-1c4e4af6] {\n  font-size: 20px;\n}\n\n\n.btn-submit[_v-1c4e4af6] {\n  padding: 10px 50px !important;\n  font-size: 25px !important;\n  font-weight: 600 !important;\n  border-radius: 5px;\n}\n\n.bg-slate-custom[_v-1c4e4af6] {\n  background-color: #d6dce5;\n  border-color: #d6dce5;\n}\n\n.custom-header[_v-1c4e4af6] {\n  position: -webkit-sticky;\n  position: sticky;\n  top: 48px;\n  z-index: 100;\n}\n\n.top-65[_v-1c4e4af6] {\n  top: 65px;\n}\n\n.bg-top-1[_v-1c4e4af6] {\n  background-color: #009ACC;\n  border-color: #009ACC;\n  color: #fff;\n}\n\n.bg-top-2[_v-1c4e4af6] {\n  background-color: #fff;\n  border-color: #fff;\n  color: #fff;\n}\n\n.column-header[_v-1c4e4af6] {\n  padding: 12px !important;\n  font-size: 18px !important;\n  font-weight: 700 !important;\n  border-right: 2px solid #d6dce5;\n}\n\n.bg-top-3[_v-1c4e4af6] {\n  background-color: #202933;\n  border-color: #202933;\n  color: #fff;\n}\n\n\n.fixed-height-table[_v-1c4e4af6] {\n  max-height: 500px !important;\n  overflow-y: auto;\n}\n\n[_v-1c4e4af6]::-webkit-input-placeholder {\n  text-align: left;\n  font-size: 20px\n}\n\n[_v-1c4e4af6]:-moz-placeholder { /* Firefox 18- */\n  text-align: left;\n  font-size: 20px\n}\n\n[_v-1c4e4af6]::-moz-placeholder { /* Firefox 19+ */\n  text-align: left;\n  font-size: 20px\n}\n\n[_v-1c4e4af6]:-ms-input-placeholder {\n  text-align: left;\n  font-size: 20px\n}\n\n.client-list[_v-1c4e4af6] {\n  list-style-type: none;\n}\n\n.filter-div[_v-1c4e4af6] {\n  position: fixed;\n  top: 100px;\n}\n")
"use strict";

exports.__esModule = true;
var modals = require("./../../mixed/modals");
var notify = require("./../../mixed/notify");

exports["default"] = {
  data: function data() {
    return {
      entries: {},
      filteredEntries: {},
      searchedEmployees: {},
      activeEmployee: {},
      jobs: {},
      clients: {},
      type: 0,
      availableJobs: {},
      selectedJObs: {},
      ids: [],
      all: false,
      primary_phone: '',
      new_pin: ''
    };
  },
  props: ['user'],

  watch: {},
  ready: function ready() {
    this.getEntries();
  },

  events: {},

  methods: {

    filterEntries: function filterEntries(index) {
      if (index === '') {
        this.filteredEntries = this.entries;
      } else {
        this.filteredEntries = {};
        this.filteredEntries[index] = this.entries[index];
      }
    },

    getEntries: function getEntries() {
      var _this = this;

      notify.loading(true);
      this.$http.get("/api/timesheet-accounting-team-1-pending-approval", function (response) {
        _this.entries = response;
        _this.filteredEntries = response;
        notify.loading(false);
      }).always(function () {});
    },

    /**
     * update entries marked as completed
     */
    updateEntries: function updateEntries() {
      var _this2 = this;

      notify.loading(true);
      this.$http.post("/api/update-timesheet-accounting-team-1-pending-approval", {
        ids: this.ids
      }, function (response) {
        notify.loading(false);
        _this2.getEntries();
      }).always(function () {});
    },

    sortBy: function sortBy(field, reverse, primer) {
      var key = primer ? function (x) {
        return primer(x[field]);
      } : function (x) {
        return x[field];
      };

      reverse = !reverse ? 1 : -1;

      return function (a, b) {
        return a = key(a), b = key(b), reverse * ((a > b) - (b > a));
      };
    },

    sortUsers: function sortUsers(field, reverse) {
      var primer = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];

      console.log(field);
      this.sortOrders = reverse;
      this.sortKey = field;
      this.employees.sort(this.sortBy(field, reverse, primer));
    }

  }
};
module.exports = exports["default"];
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n  <div class=\"row\" _v-1c4e4af6=\"\">\n    <div class=\"col-md-3 col-xl-3 pt-50 pl-10\" _v-1c4e4af6=\"\">\n      <div class=\"filter-div\" _v-1c4e4af6=\"\">\n        <ul _v-1c4e4af6=\"\">\n          <li class=\"client-list cursor-pointer\" _v-1c4e4af6=\"\">\n            <span class=\"font-16 text-black p-10 pb-20\" v-on:click=\"filterEntries('')\" _v-1c4e4af6=\"\">Show All</span>\n          </li>\n          <li v-for=\"(index,clients) in entries\" class=\"client-list cursor-pointer font-16\" _v-1c4e4af6=\"\">\n          <span class=\"font-16 text-black p-10 pb-20 pr-5\" v-on:click=\"filterEntries(index)\" _v-1c4e4af6=\"\">{{\n              index\n            }}</span>\n            (<span class=\"text-blue-600\" _v-1c4e4af6=\"\">{{ entries[index].length }}</span>)\n          </li>\n        </ul>\n      </div>\n    </div>\n    <div class=\"col-md-8 col-xl-8 col-sm-12 no-padding-left no-padding-right\" _v-1c4e4af6=\"\">\n      <div class=\"col-md-12 col-sm-12  no-padding-left no-padding-right\" _v-1c4e4af6=\"\">\n        <table class=\"table table-xxs fixed-height-table\" _v-1c4e4af6=\"\">\n          <thead class=\"header custom-header\" _v-1c4e4af6=\"\">\n          <!--          <tr class=\"bg-top-1\">-->\n          <!--            <th class=\"text-center p-5 font-20 pl-10\" colspan=\"6\">-->\n          <!--              PENDING APPROVAL-->\n          <!--            </th>-->\n          <!--          </tr>-->\n\n          <tr _v-1c4e4af6=\"\">\n            <th class=\"bg-top-3 text-left text-black cursor-pointer text-uppercase column-header\" _v-1c4e4af6=\"\">\n              JOB\n\n            </th>\n            <th class=\"bg-top-3 text-left text-black cursor-pointer text-uppercase column-header\" _v-1c4e4af6=\"\">\n              DATE\n            </th>\n            <th class=\"bg-top-3 text-black text-left text-uppercase column-header\" _v-1c4e4af6=\"\">EMPLOYEE</th>\n            <th class=\"bg-top-3 text-black text-left text-uppercase column-header\" _v-1c4e4af6=\"\">IN</th>\n            <th class=\"bg-top-3 text-black text-left text-uppercase column-header\" _v-1c4e4af6=\"\">OUT</th>\n            <th class=\"bg-top-3 text-black text-left text-uppercase column-header\" _v-1c4e4af6=\"\">BREAK</th>\n\n          </tr>\n          </thead>\n          <tbody v-for=\"(index,clientEntry) in filteredEntries\" class=\"\" _v-1c4e4af6=\"\">\n          <tr _v-1c4e4af6=\"\">\n            <td colspan=\"6\" class=\"text-left text-black font-20 bg-grey-300 text-color-black pl-5\" _v-1c4e4af6=\"\">\n              <div class=\"col-md-6 text-left pl-10\" _v-1c4e4af6=\"\">{{ index }} - {{ clientEntry[0].company_code }}</div>\n              <div class=\"col-md-6 text-right pr-10\" _v-1c4e4af6=\"\">PENDING APPROVAL</div>\n            </td>\n          </tr>\n          <tr v-for=\"entry in clientEntry\" _v-1c4e4af6=\"\">\n            <td class=\"text-left table-data\" _v-1c4e4af6=\"\">\n              {{ entry.position_title }}\n            </td>\n            <td class=\"text-left table-data\" _v-1c4e4af6=\"\">\n              {{ entry.date }}\n            </td>\n            <td class=\"text-left table-data\" _v-1c4e4af6=\"\">\n              {{ entry.name }}\n            </td>\n            <td class=\"text-left table-data\" _v-1c4e4af6=\"\">\n              {{ entry.in }}\n            </td>\n            <td class=\"text-left table-data\" _v-1c4e4af6=\"\">\n              {{ entry.out }}\n            </td>\n            <td class=\"text-left table-data\" _v-1c4e4af6=\"\">\n              {{ entry.break_duration }}\n            </td>\n\n          </tr>\n          </tbody>\n        </table>\n      </div>\n    </div>\n\n  </div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  var id = "/home/shoieb/sites/elegant/resources/assets/js/vue/components/time-clock-accounting-pending-approval.vue"
  module.hot.dispose(function () {
    require("vueify-insert-css").cache["\n\n\n.search-box[_v-1c4e4af6] {\n  width: 100%;\n  height: 50px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  padding: 5px;\n  font-size: 14px;\n  color: #000;\n}\n\n.custom-checkbox[_v-1c4e4af6] {\n  height: 24px;\n  padding: 5px 10px;\n  font-size: 12px;\n  line-height: 1.6666667;\n  border-radius: 5px;\n}\n\ninput[type=\"checkbox\"][_v-1c4e4af6] {\n  accent-color: #009ACC;\n}\n\ninput[type=\"checkbox\"]#checkbox1:checked + span[_v-1c4e4af6] {\n  border-color: red;\n  background-color: red;\n}\n\n.table-data[_v-1c4e4af6] {\n  padding: 5px;\n  font-size: 16px;\n  color: #44505E;\n  font-weight: 400;\n  border-right: 2px solid #EDEEF3;\n  border-left: 2px solid #EDEEF3;\n  border-bottom: 2px solid #EDEEF3;\n}\n\n.close-modal[_v-1c4e4af6] {\n  font-size: 30px;\n  margin-top: -14.75px;\n  font-weight: 500;\n}\n\n.close-modal-29[_v-1c4e4af6] {\n  font-size: 30px;\n  margin-top: -29.75px !important;\n  font-weight: 500;\n}\n\n.close-modal-0[_v-1c4e4af6] {\n  font-size: 35px;\n  margin-top: 0 !important;\n  font-weight: 500;\n  z-index: 100;\n  color: #656565 !important;\n}\n\n.font-20[_v-1c4e4af6] {\n  font-size: 20px;\n}\n\n\n.btn-submit[_v-1c4e4af6] {\n  padding: 10px 50px !important;\n  font-size: 25px !important;\n  font-weight: 600 !important;\n  border-radius: 5px;\n}\n\n.bg-slate-custom[_v-1c4e4af6] {\n  background-color: #d6dce5;\n  border-color: #d6dce5;\n}\n\n.custom-header[_v-1c4e4af6] {\n  position: -webkit-sticky;\n  position: sticky;\n  top: 48px;\n  z-index: 100;\n}\n\n.top-65[_v-1c4e4af6] {\n  top: 65px;\n}\n\n.bg-top-1[_v-1c4e4af6] {\n  background-color: #009ACC;\n  border-color: #009ACC;\n  color: #fff;\n}\n\n.bg-top-2[_v-1c4e4af6] {\n  background-color: #fff;\n  border-color: #fff;\n  color: #fff;\n}\n\n.column-header[_v-1c4e4af6] {\n  padding: 12px !important;\n  font-size: 18px !important;\n  font-weight: 700 !important;\n  border-right: 2px solid #d6dce5;\n}\n\n.bg-top-3[_v-1c4e4af6] {\n  background-color: #202933;\n  border-color: #202933;\n  color: #fff;\n}\n\n\n.fixed-height-table[_v-1c4e4af6] {\n  max-height: 500px !important;\n  overflow-y: auto;\n}\n\n[_v-1c4e4af6]::-webkit-input-placeholder {\n  text-align: left;\n  font-size: 20px\n}\n\n[_v-1c4e4af6]:-moz-placeholder { /* Firefox 18- */\n  text-align: left;\n  font-size: 20px\n}\n\n[_v-1c4e4af6]::-moz-placeholder { /* Firefox 19+ */\n  text-align: left;\n  font-size: 20px\n}\n\n[_v-1c4e4af6]:-ms-input-placeholder {\n  text-align: left;\n  font-size: 20px\n}\n\n.client-list[_v-1c4e4af6] {\n  list-style-type: none;\n}\n\n.filter-div[_v-1c4e4af6] {\n  position: fixed;\n  top: 100px;\n}\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, module.exports.template)
  }
})()}
},{"./../../mixed/modals":10,"./../../mixed/notify":11,"vue":5,"vue-hot-reload-api":4,"vueify-insert-css":6}],88:[function(require,module,exports){
var __vueify_style__ = require("vueify-insert-css").insert("\n\n\n.search-box[_v-57669823] {\n  width: 100%;\n  height: 50px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  padding: 5px;\n  font-size: 14px;\n  color: #000;\n}\n\n.custom-checkbox[_v-57669823] {\n  height: 24px;\n  padding: 5px 10px;\n  font-size: 12px;\n  line-height: 1.6666667;\n  border-radius: 5px;\n}\n\ninput[type=\"checkbox\"][_v-57669823] {\n  accent-color: #009ACC;\n}\n\ninput[type=\"checkbox\"]#checkbox1:checked + span[_v-57669823] {\n  border-color: red;\n  background-color: red;\n}\n\n.table-data[_v-57669823] {\n  padding: 5px;\n  font-size: 16px;\n  color: #44505E;\n  font-weight: 400;\n  border-right: 2px solid #EDEEF3;\n  border-left: 2px solid #EDEEF3;\n  border-bottom: 2px solid #EDEEF3;\n}\n\n.close-modal[_v-57669823] {\n  font-size: 30px;\n  margin-top: -14.75px;\n  font-weight: 500;\n}\n\n.close-modal-29[_v-57669823] {\n  font-size: 30px;\n  margin-top: -29.75px !important;\n  font-weight: 500;\n}\n\n.close-modal-0[_v-57669823] {\n  font-size: 35px;\n  margin-top: 0 !important;\n  font-weight: 500;\n  z-index: 100;\n  color: #656565 !important;\n}\n\n.font-20[_v-57669823] {\n  font-size: 20px;\n}\n\n\n.btn-submit[_v-57669823] {\n  padding: 10px 50px !important;\n  font-size: 25px !important;\n  font-weight: 600 !important;\n  border-radius: 5px;\n}\n\n.bg-slate-custom[_v-57669823] {\n  background-color: #d6dce5;\n  border-color: #d6dce5;\n}\n\n.custom-header[_v-57669823] {\n  position: -webkit-sticky;\n  position: sticky;\n  top: 48px;\n  z-index: 100;\n}\n\n.top-65[_v-57669823] {\n  top: 65px;\n}\n\n.bg-top-1[_v-57669823] {\n  background-color: #009ACC;\n  border-color: #009ACC;\n  color: #fff;\n}\n\n.bg-top-2[_v-57669823] {\n  background-color: #fff;\n  border-color: #fff;\n  color: #fff;\n}\n\n.column-header[_v-57669823] {\n  padding: 12px !important;\n  font-size: 18px !important;\n  font-weight: 700 !important;\n  border-right: 2px solid #d6dce5;\n}\n\n.bg-top-3[_v-57669823] {\n  background-color: #202933;\n  border-color: #202933;\n  color: #fff;\n}\n\n\n.fixed-height-table[_v-57669823] {\n  //height: 500px !important;\n  max-height: 500px !important;\n  overflow-y: auto;\n}\n\n[_v-57669823]::-webkit-input-placeholder {\n  text-align: left;\n  font-size: 20px\n}\n\n[_v-57669823]:-moz-placeholder { /* Firefox 18- */\n  text-align: left;\n  font-size: 20px\n}\n\n[_v-57669823]::-moz-placeholder { /* Firefox 19+ */\n  text-align: left;\n  font-size: 20px\n}\n\n[_v-57669823]:-ms-input-placeholder {\n  text-align: left;\n  font-size: 20px\n}\n\n.client-list[_v-57669823] {\n  list-style-type: none;\n}\n\n.filter-div[_v-57669823] {\n  position: fixed;\n  top: 100px;\n}\n\n")
"use strict";

exports.__esModule = true;
var modals = require("./../../mixed/modals");
var notify = require("./../../mixed/notify");

exports["default"] = {
  data: function data() {
    return {
      entries: {},
      filteredEntries: {},
      searchedEmployees: {},
      activeEmployee: {},
      jobs: {},
      clients: {},
      type: 0,
      availableJobs: {},
      selectedJObs: {},
      ids: [],
      all: false,
      primary_phone: '',
      new_pin: ''
    };
  },
  props: ['user'],

  watch: {},
  ready: function ready() {
    this.getEntries();
  },

  events: {},

  methods: {

    filterEntries: function filterEntries(index) {
      if (index === '') {
        this.filteredEntries = this.entries;
      } else {
        this.filteredEntries = {};
        this.filteredEntries[index] = this.entries[index];
      }
    },

    getEntries: function getEntries() {
      var _this = this;

      notify.loading(true);
      this.$http.get("/api/timesheet-accounting-team-1-on-the-clock", function (response) {
        _this.entries = response;
        _this.filteredEntries = response;
        notify.loading(false);
      }).always(function () {});
    },

    /**
     * update entries marked as completed
     */
    updateEntries: function updateEntries() {
      var _this2 = this;

      notify.loading(true);
      this.$http.post("/api/update-timesheet-accounting-team-1-on-the-clock", {
        ids: this.ids
      }, function (response) {
        notify.loading(false);
        _this2.getEntries();
      }).always(function () {});
    },

    sortBy: function sortBy(field, reverse, primer) {
      var key = primer ? function (x) {
        return primer(x[field]);
      } : function (x) {
        return x[field];
      };

      reverse = !reverse ? 1 : -1;

      return function (a, b) {
        return a = key(a), b = key(b), reverse * ((a > b) - (b > a));
      };
    },

    sortUsers: function sortUsers(field, reverse) {
      var primer = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];

      console.log(field);
      this.sortOrders = reverse;
      this.sortKey = field;
      this.employees.sort(this.sortBy(field, reverse, primer));
    }

  }
};
module.exports = exports["default"];
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n  <div class=\"row\" _v-57669823=\"\">\n    <div class=\"col-md-3 col-xl-3 pt-50 pl-10\" _v-57669823=\"\">\n      <div class=\"filter-div\" _v-57669823=\"\">\n        <ul _v-57669823=\"\">\n          <li class=\"client-list cursor-pointer\" _v-57669823=\"\">\n            <span class=\"font-16 text-black p-10 pb-20\" v-on:click=\"filterEntries('')\" _v-57669823=\"\">Show All</span>\n          </li>\n          <li v-for=\"(index,clients) in entries\" class=\"client-list cursor-pointer font-16\" _v-57669823=\"\">\n          <span class=\"font-16 text-black p-10 pb-20 pr-5\" v-on:click=\"filterEntries(index)\" _v-57669823=\"\">{{\n              index\n            }}</span>\n            (<span class=\"text-blue-600\" _v-57669823=\"\">{{ entries[index].length }}</span>)\n          </li>\n        </ul>\n      </div>\n    </div>\n    <div class=\"col-md-8 col-xl-8 col-sm-12 no-padding-left no-padding-right\" _v-57669823=\"\">\n      <div class=\"col-md-12 col-sm-12  no-padding-left no-padding-right\" _v-57669823=\"\">\n        <table class=\"table table-xxs fixed-height-table\" _v-57669823=\"\">\n          <thead class=\"header custom-header\" _v-57669823=\"\">\n          <!--          <tr class=\"bg-top-1\">-->\n          <!--            <th class=\"text-center p-5 font-20 pl-10\" colspan=\"5\">-->\n          <!--              ON THE CLOCK-->\n          <!--            </th>-->\n          <!--          </tr>-->\n\n          <tr _v-57669823=\"\">\n            <th class=\"bg-top-3 text-left text-black cursor-pointer text-uppercase column-header\" _v-57669823=\"\">\n              JOB\n\n            </th>\n            <th class=\"bg-top-3 text-left text-black cursor-pointer text-uppercase column-header\" _v-57669823=\"\">\n              DATE\n            </th>\n            <th class=\"bg-top-3 text-black text-left text-uppercase column-header\" _v-57669823=\"\">EMPLOYEE</th>\n            <th class=\"bg-top-3 text-black text-left text-uppercase column-header\" _v-57669823=\"\">IN</th>\n            <th class=\"bg-top-3 text-black text-left text-uppercase column-header\" _v-57669823=\"\">BREAK</th>\n\n          </tr>\n          </thead>\n          <tbody v-for=\"(index,clientEntry) in filteredEntries\" class=\"\" _v-57669823=\"\">\n          <tr _v-57669823=\"\">\n            <td colspan=\"5\" class=\"text-left text-black font-20 bg-grey-300 text-color-black pl-5\" _v-57669823=\"\">\n              <div class=\"col-md-6 text-left pl-10\" _v-57669823=\"\">{{ index }} - {{ clientEntry[0].company_code }}</div>\n              <div class=\"col-md-6 text-right pr-10\" _v-57669823=\"\">ON THE CLOCK</div>\n            </td>\n          </tr>\n          <tr v-for=\"entry in clientEntry\" _v-57669823=\"\">\n            <td class=\"text-left table-data\" _v-57669823=\"\">\n              {{ entry.position_title }}\n            </td>\n            <td class=\"text-left table-data\" _v-57669823=\"\">\n              {{ entry.date }}\n            </td>\n            <td class=\"text-left table-data\" _v-57669823=\"\">\n              {{ entry.name }}\n            </td>\n            <td class=\"text-left table-data\" _v-57669823=\"\">\n              {{ entry.in }}\n            </td>\n            <td class=\"text-left table-data\" _v-57669823=\"\">\n              {{ entry.break_duration }}\n            </td>\n\n          </tr>\n          </tbody>\n        </table>\n      </div>\n    </div>\n\n  </div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  var id = "/home/shoieb/sites/elegant/resources/assets/js/vue/components/time-clock-accounting-team-1-on-the-clock.vue"
  module.hot.dispose(function () {
    require("vueify-insert-css").cache["\n\n\n.search-box[_v-57669823] {\n  width: 100%;\n  height: 50px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  padding: 5px;\n  font-size: 14px;\n  color: #000;\n}\n\n.custom-checkbox[_v-57669823] {\n  height: 24px;\n  padding: 5px 10px;\n  font-size: 12px;\n  line-height: 1.6666667;\n  border-radius: 5px;\n}\n\ninput[type=\"checkbox\"][_v-57669823] {\n  accent-color: #009ACC;\n}\n\ninput[type=\"checkbox\"]#checkbox1:checked + span[_v-57669823] {\n  border-color: red;\n  background-color: red;\n}\n\n.table-data[_v-57669823] {\n  padding: 5px;\n  font-size: 16px;\n  color: #44505E;\n  font-weight: 400;\n  border-right: 2px solid #EDEEF3;\n  border-left: 2px solid #EDEEF3;\n  border-bottom: 2px solid #EDEEF3;\n}\n\n.close-modal[_v-57669823] {\n  font-size: 30px;\n  margin-top: -14.75px;\n  font-weight: 500;\n}\n\n.close-modal-29[_v-57669823] {\n  font-size: 30px;\n  margin-top: -29.75px !important;\n  font-weight: 500;\n}\n\n.close-modal-0[_v-57669823] {\n  font-size: 35px;\n  margin-top: 0 !important;\n  font-weight: 500;\n  z-index: 100;\n  color: #656565 !important;\n}\n\n.font-20[_v-57669823] {\n  font-size: 20px;\n}\n\n\n.btn-submit[_v-57669823] {\n  padding: 10px 50px !important;\n  font-size: 25px !important;\n  font-weight: 600 !important;\n  border-radius: 5px;\n}\n\n.bg-slate-custom[_v-57669823] {\n  background-color: #d6dce5;\n  border-color: #d6dce5;\n}\n\n.custom-header[_v-57669823] {\n  position: -webkit-sticky;\n  position: sticky;\n  top: 48px;\n  z-index: 100;\n}\n\n.top-65[_v-57669823] {\n  top: 65px;\n}\n\n.bg-top-1[_v-57669823] {\n  background-color: #009ACC;\n  border-color: #009ACC;\n  color: #fff;\n}\n\n.bg-top-2[_v-57669823] {\n  background-color: #fff;\n  border-color: #fff;\n  color: #fff;\n}\n\n.column-header[_v-57669823] {\n  padding: 12px !important;\n  font-size: 18px !important;\n  font-weight: 700 !important;\n  border-right: 2px solid #d6dce5;\n}\n\n.bg-top-3[_v-57669823] {\n  background-color: #202933;\n  border-color: #202933;\n  color: #fff;\n}\n\n\n.fixed-height-table[_v-57669823] {\n  //height: 500px !important;\n  max-height: 500px !important;\n  overflow-y: auto;\n}\n\n[_v-57669823]::-webkit-input-placeholder {\n  text-align: left;\n  font-size: 20px\n}\n\n[_v-57669823]:-moz-placeholder { /* Firefox 18- */\n  text-align: left;\n  font-size: 20px\n}\n\n[_v-57669823]::-moz-placeholder { /* Firefox 19+ */\n  text-align: left;\n  font-size: 20px\n}\n\n[_v-57669823]:-ms-input-placeholder {\n  text-align: left;\n  font-size: 20px\n}\n\n.client-list[_v-57669823] {\n  list-style-type: none;\n}\n\n.filter-div[_v-57669823] {\n  position: fixed;\n  top: 100px;\n}\n\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, module.exports.template)
  }
})()}
},{"./../../mixed/modals":10,"./../../mixed/notify":11,"vue":5,"vue-hot-reload-api":4,"vueify-insert-css":6}],89:[function(require,module,exports){
var __vueify_style__ = require("vueify-insert-css").insert("\n.font-30[_v-bc99c3f0] {\n  color: #FFF;\n  font-size: 30px;\n}\n\n.search-box[_v-bc99c3f0] {\n  width: 100%;\n  height: 50px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  padding: 5px;\n  font-size: 14px;\n  color: #000;\n}\n\n.custom-checkbox[_v-bc99c3f0] {\n  height: 24px;\n  padding: 5px 10px;\n  font-size: 12px;\n  line-height: 1.6666667;\n  border-radius: 5px;\n}\n\ninput[type=\"checkbox\"][_v-bc99c3f0] {\n  accent-color: #009ACC;\n}\n\ninput[type=\"checkbox\"]#checkbox1:checked + span[_v-bc99c3f0] {\n  border-color: red;\n  background-color: red;\n}\n\n.table-data[_v-bc99c3f0] {\n  padding: 5px;\n  font-size: 16px;\n  color: #44505E;\n  font-weight: 400;\n  border-right: 2px solid #EDEEF3;\n  border-left: 2px solid #EDEEF3;\n  border-bottom: 2px solid #EDEEF3;\n}\n\n.font-12[_v-bc99c3f0] {\n  font-size: 12px;\n}\n\n.close-modal[_v-bc99c3f0] {\n  font-size: 30px;\n  margin-top: -14.75px;\n  font-weight: 500;\n}\n\n.close-modal-29[_v-bc99c3f0] {\n  font-size: 30px;\n  margin-top: -29.75px !important;\n  font-weight: 500;\n}\n\n.close-modal-0[_v-bc99c3f0] {\n  font-size: 35px;\n  margin-top: 0 !important;\n  font-weight: 500;\n  z-index: 100;\n  color: #656565 !important;\n}\n\n.font-20[_v-bc99c3f0] {\n  font-size: 20px;\n}\n\n\n.btn-submit[_v-bc99c3f0] {\n  padding: 10px 20px !important;\n  font-size: 20px !important;\n  font-weight: 600 !important;\n  border-radius: 5px;\n}\n\n.bg-slate-custom[_v-bc99c3f0] {\n  background-color: #d6dce5;\n  border-color: #d6dce5;\n}\n\n.custom-header[_v-bc99c3f0] {\n  position: -webkit-sticky;\n  position: sticky;\n  top: 48px;\n  z-index: 100;\n}\n\n.top-65[_v-bc99c3f0] {\n  top: 65px;\n}\n\n.bg-top-1[_v-bc99c3f0] {\n  background-color: #009ACC;\n  border-color: #009ACC;\n  color: #fff;\n}\n\n.bg-top-2[_v-bc99c3f0] {\n  background-color: #fff;\n  border-color: #fff;\n  color: #fff;\n}\n\n.column-header[_v-bc99c3f0] {\n  padding: 12px !important;\n  font-size: 18px !important;\n  font-weight: 700 !important;\n  border-right: 2px solid #d6dce5;\n}\n\n.bg-top-3[_v-bc99c3f0] {\n  background-color: #202933;\n  border-color: #202933;\n  color: #fff;\n}\n\n\n.fixed-height-table[_v-bc99c3f0] {\n  max-height: 500px !important;\n  overflow-y: auto;\n}\n\n[_v-bc99c3f0]::-webkit-input-placeholder {\n  text-align: left;\n  font-size: 20px\n}\n\n[_v-bc99c3f0]:-moz-placeholder { /* Firefox 18- */\n  text-align: left;\n  font-size: 20px\n}\n\n[_v-bc99c3f0]::-moz-placeholder { /* Firefox 19+ */\n  text-align: left;\n  font-size: 20px\n}\n\n[_v-bc99c3f0]:-ms-input-placeholder {\n  text-align: left;\n  font-size: 20px\n}\n\n.client-list[_v-bc99c3f0] {\n  list-style-type: none;\n}\n\n.filter-div[_v-bc99c3f0] {\n  position: fixed;\n  top: 100px;\n}\n\n")
"use strict";

exports.__esModule = true;
var modals = require("./../../mixed/modals");
var notify = require("./../../mixed/notify");

exports["default"] = {
  data: function data() {
    return {
      entries: {},
      filteredEntries: {},
      searchedEmployees: {},
      activeEmployee: {},
      jobs: {},
      clients: {},
      type: 0,
      availableJobs: {},
      selectedJObs: {},
      ids: [],
      all: false,
      primary_phone: '',
      new_pin: ''
    };
  },
  props: ['user', 'permission'],

  watch: {},
  ready: function ready() {
    this.getEntries();
  },

  events: {},

  methods: {

    filterEntries: function filterEntries(index) {
      if (index === '') {
        this.filteredEntries = this.entries;
      } else {
        this.filteredEntries = {};
        this.filteredEntries[index] = this.entries[index];
      }
    },

    getEntries: function getEntries() {
      var _this = this;

      notify.loading(true);
      this.$http.get("/api/timesheet-accounting-team-1-pending", function (response) {
        _this.entries = response;
        _this.filteredEntries = response;
        notify.loading(false);
      }).always(function () {});
    },

    /**
     * update entries marked as completed
     */
    updateEntries: function updateEntries() {
      var _this2 = this;

      notify.loading(true);
      this.$http.post("/api/update-timesheet-accounting-team-1-pending", {
        ids: this.ids
      }, function (response) {
        notify.loading(false);
        _this2.getEntries();
      }).always(function () {});
    },

    sortBy: function sortBy(field, reverse, primer) {
      var key = primer ? function (x) {
        return primer(x[field]);
      } : function (x) {
        return x[field];
      };

      reverse = !reverse ? 1 : -1;

      return function (a, b) {
        return a = key(a), b = key(b), reverse * ((a > b) - (b > a));
      };
    },

    sortUsers: function sortUsers(field, reverse) {
      var primer = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];

      console.log(field);
      this.sortOrders = reverse;
      this.sortKey = field;
      this.employees.sort(this.sortBy(field, reverse, primer));
    }

  }
};
module.exports = exports["default"];
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n  <div class=\"row\" _v-bc99c3f0=\"\">\n    <div class=\"col-md-3 col-xl-3 pt-50 pl-10\" _v-bc99c3f0=\"\">\n      <div class=\"filter-div\" _v-bc99c3f0=\"\">\n        <ul _v-bc99c3f0=\"\">\n          <li class=\"client-list cursor-pointer\" _v-bc99c3f0=\"\">\n            <span class=\"font-16 text-black p-10 pb-20\" v-on:click=\"filterEntries('')\" _v-bc99c3f0=\"\">Show All</span>\n          </li>\n          <li v-for=\"(index,clients) in entries\" class=\"client-list cursor-pointer font-16\" _v-bc99c3f0=\"\">\n          <span class=\"font-16 text-black p-10 pb-20 pr-5\" v-on:click=\"filterEntries(index)\" _v-bc99c3f0=\"\">{{\n              index\n            }}</span>\n            (<span class=\"text-blue-600\" _v-bc99c3f0=\"\">{{ entries[index].length }}</span>)\n          </li>\n        </ul>\n      </div>\n    </div>\n    <div class=\"col-md-8 col-xl-8 col-sm-12 no-padding-left no-padding-right\" _v-bc99c3f0=\"\">\n      <div class=\"col-md-12 col-sm-12  no-padding-left no-padding-right\" _v-bc99c3f0=\"\">\n        <table class=\"table table-xxs fixed-height-table\" _v-bc99c3f0=\"\">\n          <thead class=\"header custom-header\" _v-bc99c3f0=\"\">\n          <tr class=\"bg-top-2\" _v-bc99c3f0=\"\">\n            <th class=\"text-center text-black font-12 p-5 pl-5\" colspan=\"8\" _v-bc99c3f0=\"\">\n              <div class=\"row\" _v-bc99c3f0=\"\">\n                <div class=\"col-md-4 col-sm-4 text-left pull-left\" _v-bc99c3f0=\"\">\n                  <input type=\"text\" name=\"search\" v-model=\"query\" class=\"form-control input-lg search-box\" placeholder=\"search\" _v-bc99c3f0=\"\">\n                </div>\n                <div class=\"col-md-4 col-sm-4  p-5\" _v-bc99c3f0=\"\">\n\n                </div>\n                <div class=\"col-md-4 col-sm-4 text-right pull-right\" _v-bc99c3f0=\"\">\n                  <button class=\"btn btn-submit font-12 bg-top-1\" v-if=\"permission\" @click.prevent=\"updateEntries()\" _v-bc99c3f0=\"\">Submit\n                  </button>\n                </div>\n\n              </div>\n            </th>\n          </tr>\n\n          <!--          <tr class=\"bg-top-1\">-->\n          <!--            <th class=\"text-center p-5 font-30 pl-10\" colspan=\"8\">-->\n          <!--              APPROVED ENTRIES-->\n          <!--            </th>-->\n          <!--          </tr>-->\n\n          <tr _v-bc99c3f0=\"\">\n            <th class=\"bg-top-3 text-left text-black cursor-pointer text-uppercase column-header\" _v-bc99c3f0=\"\">\n              JOB\n\n            </th>\n            <th class=\"bg-top-3 text-left text-black cursor-pointer text-uppercase column-header\" _v-bc99c3f0=\"\">\n              DATE\n            </th>\n            <th class=\"bg-top-3 text-black text-left text-uppercase column-header\" _v-bc99c3f0=\"\">EMPLOYEE</th>\n            <th class=\"bg-top-3 text-black text-left text-uppercase column-header\" _v-bc99c3f0=\"\">IN</th>\n            <th class=\"bg-top-3 text-black text-left text-uppercase column-header\" _v-bc99c3f0=\"\">OUT</th>\n            <th class=\"bg-top-3 text-black text-left text-uppercase column-header\" _v-bc99c3f0=\"\">BREAK</th>\n            <th class=\"bg-top-3 text-black text-center text-uppercase column-header\" _v-bc99c3f0=\"\">COMPLETED</th>\n            <th class=\"bg-top-3 text-black text-left text-uppercase column-header\" _v-bc99c3f0=\"\">APPROVED BY</th>\n\n          </tr>\n          </thead>\n          <tbody v-for=\"(index,clientEntry) in filteredEntries\" class=\"\" _v-bc99c3f0=\"\">\n          <tr _v-bc99c3f0=\"\">\n            <td colspan=\"8\" class=\"text-left text-black font-20 bg-grey-300 text-color-black pl-5\" _v-bc99c3f0=\"\">\n              <div class=\"col-md-6 text-left pl-10\" _v-bc99c3f0=\"\">{{ index }} - {{ clientEntry[0].company_code }}</div>\n              <div class=\"col-md-6 text-right pr-10\" _v-bc99c3f0=\"\">APPROVED ENTRIES</div>\n            </td>\n          </tr>\n          <tr v-for=\"entry in clientEntry\" _v-bc99c3f0=\"\">\n            <td class=\"text-left table-data\" _v-bc99c3f0=\"\">\n              {{ entry.position_title }}\n            </td>\n            <td class=\"text-left table-data\" _v-bc99c3f0=\"\">\n              {{ entry.date }}\n            </td>\n            <td class=\"text-left table-data\" _v-bc99c3f0=\"\">\n              {{ entry.name }}\n            </td>\n            <td class=\"text-left table-data\" _v-bc99c3f0=\"\">\n              {{ entry.in }}\n            </td>\n            <td class=\"text-left table-data\" _v-bc99c3f0=\"\">\n              {{ entry.out }}\n            </td>\n            <td class=\"text-left table-data\" _v-bc99c3f0=\"\">\n              {{ entry.break_duration }}\n            </td>\n            <td class=\"text-left table-data\" _v-bc99c3f0=\"\">\n              <input type=\"checkbox\" name=\"\" id=\"\" v-model=\"ids\" :value=\"entry.id\" class=\"form-control custom-checkbox\" _v-bc99c3f0=\"\">\n            </td>\n            <td class=\"text-left table-data font-12 text-italic\" _v-bc99c3f0=\"\">\n              {{ entry.approved_by }}\n            </td>\n\n          </tr>\n          </tbody>\n        </table>\n      </div>\n    </div>\n\n  </div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  var id = "/home/shoieb/sites/elegant/resources/assets/js/vue/components/time-clock-accounting-team-1-pending.vue"
  module.hot.dispose(function () {
    require("vueify-insert-css").cache["\n.font-30[_v-bc99c3f0] {\n  color: #FFF;\n  font-size: 30px;\n}\n\n.search-box[_v-bc99c3f0] {\n  width: 100%;\n  height: 50px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  padding: 5px;\n  font-size: 14px;\n  color: #000;\n}\n\n.custom-checkbox[_v-bc99c3f0] {\n  height: 24px;\n  padding: 5px 10px;\n  font-size: 12px;\n  line-height: 1.6666667;\n  border-radius: 5px;\n}\n\ninput[type=\"checkbox\"][_v-bc99c3f0] {\n  accent-color: #009ACC;\n}\n\ninput[type=\"checkbox\"]#checkbox1:checked + span[_v-bc99c3f0] {\n  border-color: red;\n  background-color: red;\n}\n\n.table-data[_v-bc99c3f0] {\n  padding: 5px;\n  font-size: 16px;\n  color: #44505E;\n  font-weight: 400;\n  border-right: 2px solid #EDEEF3;\n  border-left: 2px solid #EDEEF3;\n  border-bottom: 2px solid #EDEEF3;\n}\n\n.font-12[_v-bc99c3f0] {\n  font-size: 12px;\n}\n\n.close-modal[_v-bc99c3f0] {\n  font-size: 30px;\n  margin-top: -14.75px;\n  font-weight: 500;\n}\n\n.close-modal-29[_v-bc99c3f0] {\n  font-size: 30px;\n  margin-top: -29.75px !important;\n  font-weight: 500;\n}\n\n.close-modal-0[_v-bc99c3f0] {\n  font-size: 35px;\n  margin-top: 0 !important;\n  font-weight: 500;\n  z-index: 100;\n  color: #656565 !important;\n}\n\n.font-20[_v-bc99c3f0] {\n  font-size: 20px;\n}\n\n\n.btn-submit[_v-bc99c3f0] {\n  padding: 10px 20px !important;\n  font-size: 20px !important;\n  font-weight: 600 !important;\n  border-radius: 5px;\n}\n\n.bg-slate-custom[_v-bc99c3f0] {\n  background-color: #d6dce5;\n  border-color: #d6dce5;\n}\n\n.custom-header[_v-bc99c3f0] {\n  position: -webkit-sticky;\n  position: sticky;\n  top: 48px;\n  z-index: 100;\n}\n\n.top-65[_v-bc99c3f0] {\n  top: 65px;\n}\n\n.bg-top-1[_v-bc99c3f0] {\n  background-color: #009ACC;\n  border-color: #009ACC;\n  color: #fff;\n}\n\n.bg-top-2[_v-bc99c3f0] {\n  background-color: #fff;\n  border-color: #fff;\n  color: #fff;\n}\n\n.column-header[_v-bc99c3f0] {\n  padding: 12px !important;\n  font-size: 18px !important;\n  font-weight: 700 !important;\n  border-right: 2px solid #d6dce5;\n}\n\n.bg-top-3[_v-bc99c3f0] {\n  background-color: #202933;\n  border-color: #202933;\n  color: #fff;\n}\n\n\n.fixed-height-table[_v-bc99c3f0] {\n  max-height: 500px !important;\n  overflow-y: auto;\n}\n\n[_v-bc99c3f0]::-webkit-input-placeholder {\n  text-align: left;\n  font-size: 20px\n}\n\n[_v-bc99c3f0]:-moz-placeholder { /* Firefox 18- */\n  text-align: left;\n  font-size: 20px\n}\n\n[_v-bc99c3f0]::-moz-placeholder { /* Firefox 19+ */\n  text-align: left;\n  font-size: 20px\n}\n\n[_v-bc99c3f0]:-ms-input-placeholder {\n  text-align: left;\n  font-size: 20px\n}\n\n.client-list[_v-bc99c3f0] {\n  list-style-type: none;\n}\n\n.filter-div[_v-bc99c3f0] {\n  position: fixed;\n  top: 100px;\n}\n\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, module.exports.template)
  }
})()}
},{"./../../mixed/modals":10,"./../../mixed/notify":11,"vue":5,"vue-hot-reload-api":4,"vueify-insert-css":6}],90:[function(require,module,exports){
var __vueify_style__ = require("vueify-insert-css").insert("\n\n.options[_v-d83f8c02] {\n  color: #000;\n}\n\n.search-box[_v-d83f8c02] {\n  width: 100%;\n  height: 50px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  padding: 5px;\n  font-size: 14px;\n  color: #000;\n}\n\n.custom-checkbox[_v-d83f8c02] {\n  height: 24px;\n  padding: 5px 10px;\n  font-size: 12px;\n  line-height: 1.6666667;\n  border-radius: 5px;\n}\n\ninput[type=\"checkbox\"][_v-d83f8c02] {\n  accent-color: #009ACC;\n}\n\ninput[type=\"checkbox\"]#checkbox1:checked + span[_v-d83f8c02] {\n  border-color: red;\n  background-color: red;\n}\n\n.table-data[_v-d83f8c02] {\n  padding: 5px;\n  font-size: 16px;\n  color: #44505E;\n  font-weight: 400;\n  border-right: 2px solid #EDEEF3;\n  border-left: 2px solid #EDEEF3;\n  border-bottom: 2px solid #EDEEF3;\n}\n\n.close-modal[_v-d83f8c02] {\n  font-size: 30px;\n  margin-top: -14.75px;\n  font-weight: 500;\n}\n\n.close-modal-29[_v-d83f8c02] {\n  font-size: 30px;\n  margin-top: -29.75px !important;\n  font-weight: 500;\n}\n\n.close-modal-0[_v-d83f8c02] {\n  font-size: 35px;\n  margin-top: 0 !important;\n  font-weight: 500;\n  z-index: 100;\n  color: #656565 !important;\n}\n\n.font-20[_v-d83f8c02] {\n  font-size: 20px;\n}\n\n\n.btn-submit[_v-d83f8c02] {\n  padding: 10px 50px !important;\n  font-size: 25px !important;\n  font-weight: 600 !important;\n  border-radius: 5px;\n}\n\n.bg-slate-custom[_v-d83f8c02] {\n  background-color: #d6dce5;\n  border-color: #d6dce5;\n}\n\n.custom-header[_v-d83f8c02] {\n  position: -webkit-sticky;\n  position: sticky;\n  top: 48px;\n  z-index: 100;\n}\n\n.top-65[_v-d83f8c02] {\n  top: 65px;\n}\n\n.bg-top-1[_v-d83f8c02] {\n  background-color: #43546A;\n  border-color: #43546A;\n  color: #fff;\n}\n\n.bg-top-4[_v-d83f8c02] {\n  background-color: #152A43;\n  border-color: #152A43;\n  color: #fff;\n}\n\n.column-header[_v-d83f8c02] {\n  padding: 12px !important;\n  font-size: 18px !important;\n  font-weight: 700 !important;\n  border-right: 2px solid #d6dce5;\n}\n\n.bg-top-3[_v-d83f8c02] {\n  background-color: #202933;\n  border-color: #202933;\n  color: #fff;\n}\n\n.font-30[_v-d83f8c02] {\n  font-size: 35px;\n  font-weight: 500;\n  color: #fff\n}\n\n.fixed-height-table[_v-d83f8c02] {\n  max-height: 500px !important;\n  overflow-y: auto;\n}\n\n.fixed-height-table[_v-d83f8c02] {\n  //height: 500px !important;\n  max-height: 500px !important;\n  overflow-y: auto;\n}\n\n[_v-d83f8c02]::-webkit-input-placeholder {\n  text-align: left;\n  font-size: 20px\n}\n\n[_v-d83f8c02]:-moz-placeholder { /* Firefox 18- */\n  text-align: left;\n  font-size: 20px\n}\n\n[_v-d83f8c02]::-moz-placeholder { /* Firefox 19+ */\n  text-align: left;\n  font-size: 20px\n}\n\n[_v-d83f8c02]:-ms-input-placeholder {\n  text-align: left;\n  font-size: 20px\n}\n\n")
"use strict";

exports.__esModule = true;
var modals = require("./../../mixed/modals");
var notify = require("./../../mixed/notify");

exports["default"] = {
  data: function data() {
    return {
      entries: {},
      searchedEmployees: {},
      activeEmployee: {},
      jobs: {},
      clients: {},
      type: 0,
      availableJobs: {},
      selectedJObs: {},
      ids: [],
      all: false,
      primary_phone: '',
      new_pin: '',
      start_date: '',
      end_date: '',
      start: '',
      end: '',
      weeks: 0,
      today: '',
      weekCount: null,
      dates: []
    };
  },
  props: ['user'],
  filters: {},
  watch: {
    // 'weeks': function (val) {
    //   this.getEntries();
    // }
  },
  ready: function ready() {
    this.getEntries();
  },

  events: {},

  methods: {

    changeWeekCount: function changeWeekCount() {
      this.weeks = this.weekCount;
      this.getEntries();
    },

    changeWeek: function changeWeek(val) {
      this.weeks = val;
      this.getEntries();
    },

    getEntries: function getEntries() {
      var _this = this;

      notify.loading(true);
      this.$http.get("/api/timesheet-accounting-team-1-processed?start_date=" + this.start_date + "&end_date=" + this.end_date + "&weeks=" + this.weeks, function (response) {
        _this.entries = response.entries;
        _this.start_date = response.start_date;
        _this.end_date = response.end_date;
        _this.start = response.start;
        _this.end = response.end;
        _this.today = response.today;
        _this.weeks = 0;
        _this.dates = response.dates;
        _this.weekCount = null;
        notify.loading(false);
      }).always(function () {});
    },

    sortBy: function sortBy(field, reverse, primer) {
      var key = primer ? function (x) {
        return primer(x[field]);
      } : function (x) {
        return x[field];
      };

      reverse = !reverse ? 1 : -1;

      return function (a, b) {
        return a = key(a), b = key(b), reverse * ((a > b) - (b > a));
      };
    },

    sortUsers: function sortUsers(field, reverse) {
      var primer = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];

      console.log(field);
      this.sortOrders = reverse;
      this.sortKey = field;
      this.employees.sort(this.sortBy(field, reverse, primer));
    }

  }
};
module.exports = exports["default"];
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n  <div class=\"row\" _v-d83f8c02=\"\">\n    <div class=\"col-md-2 col-xl-2\" _v-d83f8c02=\"\"></div>\n    <div class=\"col-md-8 col-xl-8 col-sm-12 no-padding-left no-padding-right\" _v-d83f8c02=\"\">\n      <div class=\"col-md-12 col-sm-12  no-padding-left no-padding-right\" _v-d83f8c02=\"\">\n        <table class=\"table table-xxs fixed-height-table\" _v-d83f8c02=\"\">\n          <thead class=\"header custom-header\" _v-d83f8c02=\"\">\n          <tr class=\"bg-top-2\" _v-d83f8c02=\"\">\n            <th class=\"text-center text-black p-5 font-20 p-5\" colspan=\"8\" _v-d83f8c02=\"\">\n              <div class=\"row\" _v-d83f8c02=\"\">\n                <div class=\"col-md-4 col-sm-4 text-left pull-left\" _v-d83f8c02=\"\">\n                  <input type=\"text\" name=\"search\" v-model=\"query\" class=\"form-control input-lg search-box\" placeholder=\"search\" _v-d83f8c02=\"\">\n                </div>\n                <div class=\"col-md-4 col-sm-4  p-5\" _v-d83f8c02=\"\">\n\n                </div>\n                <!--                <div class=\"col-md-4 col-sm-4 text-right pull-right\">-->\n                <!--                  <button class=\"btn btn-submit font-20 bg-top-1\">Submit</button>-->\n                <!--                </div>-->\n\n              </div>\n            </th>\n          </tr>\n\n          <tr class=\"bg-top-1\" _v-d83f8c02=\"\">\n            <th class=\"text-left p-5 font-20 pl-10\" colspan=\"4\" _v-d83f8c02=\"\">\n              TEAM 1 ENTRY - COMPLETED\n            </th>\n\n            <th class=\"text-right p-5 font-20 pr-20\" colspan=\"4\" _v-d83f8c02=\"\">\n              {{ today }}\n            </th>\n          </tr>\n\n          <tr class=\"bg-top-4\" _v-d83f8c02=\"\">\n            <th class=\"text-center p-5 font-30 pl-40\" colspan=\"8\" _v-d83f8c02=\"\">\n              <div class=\"row\" _v-d83f8c02=\"\">\n\n                <div class=\"col-md-10\" _v-d83f8c02=\"\">\n                  <i class=\"fa fa-caret-left font-40 cursor-pointer text-white pr-10\" @click=\"changeWeek(-1)\" _v-d83f8c02=\"\"></i>\n                  {{ start }}- {{ end }} <i class=\"fa fa-caret-right font-40 cursor-pointer text-white pl-10\" @click=\"changeWeek(1)\" _v-d83f8c02=\"\"></i>\n                </div>\n\n                <div class=\"col-md-2 pt-10\" _v-d83f8c02=\"\">\n                  <select class=\"form-control\" v-model=\"weekCount\" @click=\"changeWeekCount()\" _v-d83f8c02=\"\">\n                    <option class=\"options\" v-for=\"(index,date) in dates\" :value=\"index\" _v-d83f8c02=\"\">{{ date }}</option>\n                  </select>\n                </div>\n              </div>\n            </th>\n          </tr>\n\n          <tr _v-d83f8c02=\"\">\n            <th class=\"bg-top-3 text-left text-black text-uppercase column-header\" _v-d83f8c02=\"\">\n              CLIENT\n            </th>\n            <th class=\"bg-top-3 text-left text-black cursor-pointer text-uppercase column-header\" _v-d83f8c02=\"\">\n              JOB\n            </th>\n            <th class=\"bg-top-3 text-left text-black cursor-pointer text-uppercase column-header\" _v-d83f8c02=\"\">\n              DATE\n            </th>\n            <th class=\"bg-top-3 text-black text-left text-uppercase column-header\" _v-d83f8c02=\"\">EMPLOYEE</th>\n            <th class=\"bg-top-3 text-black text-left text-uppercase column-header\" _v-d83f8c02=\"\">IN</th>\n            <th class=\"bg-top-3 text-black text-left text-uppercase column-header\" _v-d83f8c02=\"\">OUT</th>\n            <th class=\"bg-top-3 text-black text-left text-uppercase column-header\" _v-d83f8c02=\"\">BREAK</th>\n            <th class=\"bg-top-3 text-black text-left text-uppercase column-header\" _v-d83f8c02=\"\">PROCESSED BY</th>\n\n          </tr>\n          </thead>\n          <tbody _v-d83f8c02=\"\">\n          <tr v-for=\"entry in entries\" class=\"\" _v-d83f8c02=\"\">\n            <td class=\"text-left table-data\" _v-d83f8c02=\"\">\n              {{ entry.client_name }}\n            </td>\n            <td class=\"text-left table-data\" _v-d83f8c02=\"\">\n              {{ entry.position_title }}\n            </td>\n            <td class=\"text-left table-data\" _v-d83f8c02=\"\">\n              {{ entry.date }}\n            </td>\n            <td class=\"text-left table-data\" _v-d83f8c02=\"\">\n              {{ entry.name }}\n            </td>\n            <td class=\"text-left table-data\" _v-d83f8c02=\"\">\n              {{ entry.in }}\n            </td>\n            <td class=\"text-left table-data\" _v-d83f8c02=\"\">\n              {{ entry.out }}\n            </td>\n            <td class=\"text-left table-data\" _v-d83f8c02=\"\">\n              {{ entry.break_duration }}\n            </td>\n            <td class=\"text-left table-data\" _v-d83f8c02=\"\">\n              {{ entry.user_name }}\n            </td>\n          </tr>\n          </tbody>\n        </table>\n      </div>\n    </div>\n\n  </div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  var id = "/home/shoieb/sites/elegant/resources/assets/js/vue/components/time-clock-accounting-team-1-processed.vue"
  module.hot.dispose(function () {
    require("vueify-insert-css").cache["\n\n.options[_v-d83f8c02] {\n  color: #000;\n}\n\n.search-box[_v-d83f8c02] {\n  width: 100%;\n  height: 50px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  padding: 5px;\n  font-size: 14px;\n  color: #000;\n}\n\n.custom-checkbox[_v-d83f8c02] {\n  height: 24px;\n  padding: 5px 10px;\n  font-size: 12px;\n  line-height: 1.6666667;\n  border-radius: 5px;\n}\n\ninput[type=\"checkbox\"][_v-d83f8c02] {\n  accent-color: #009ACC;\n}\n\ninput[type=\"checkbox\"]#checkbox1:checked + span[_v-d83f8c02] {\n  border-color: red;\n  background-color: red;\n}\n\n.table-data[_v-d83f8c02] {\n  padding: 5px;\n  font-size: 16px;\n  color: #44505E;\n  font-weight: 400;\n  border-right: 2px solid #EDEEF3;\n  border-left: 2px solid #EDEEF3;\n  border-bottom: 2px solid #EDEEF3;\n}\n\n.close-modal[_v-d83f8c02] {\n  font-size: 30px;\n  margin-top: -14.75px;\n  font-weight: 500;\n}\n\n.close-modal-29[_v-d83f8c02] {\n  font-size: 30px;\n  margin-top: -29.75px !important;\n  font-weight: 500;\n}\n\n.close-modal-0[_v-d83f8c02] {\n  font-size: 35px;\n  margin-top: 0 !important;\n  font-weight: 500;\n  z-index: 100;\n  color: #656565 !important;\n}\n\n.font-20[_v-d83f8c02] {\n  font-size: 20px;\n}\n\n\n.btn-submit[_v-d83f8c02] {\n  padding: 10px 50px !important;\n  font-size: 25px !important;\n  font-weight: 600 !important;\n  border-radius: 5px;\n}\n\n.bg-slate-custom[_v-d83f8c02] {\n  background-color: #d6dce5;\n  border-color: #d6dce5;\n}\n\n.custom-header[_v-d83f8c02] {\n  position: -webkit-sticky;\n  position: sticky;\n  top: 48px;\n  z-index: 100;\n}\n\n.top-65[_v-d83f8c02] {\n  top: 65px;\n}\n\n.bg-top-1[_v-d83f8c02] {\n  background-color: #43546A;\n  border-color: #43546A;\n  color: #fff;\n}\n\n.bg-top-4[_v-d83f8c02] {\n  background-color: #152A43;\n  border-color: #152A43;\n  color: #fff;\n}\n\n.column-header[_v-d83f8c02] {\n  padding: 12px !important;\n  font-size: 18px !important;\n  font-weight: 700 !important;\n  border-right: 2px solid #d6dce5;\n}\n\n.bg-top-3[_v-d83f8c02] {\n  background-color: #202933;\n  border-color: #202933;\n  color: #fff;\n}\n\n.font-30[_v-d83f8c02] {\n  font-size: 35px;\n  font-weight: 500;\n  color: #fff\n}\n\n.fixed-height-table[_v-d83f8c02] {\n  max-height: 500px !important;\n  overflow-y: auto;\n}\n\n.fixed-height-table[_v-d83f8c02] {\n  //height: 500px !important;\n  max-height: 500px !important;\n  overflow-y: auto;\n}\n\n[_v-d83f8c02]::-webkit-input-placeholder {\n  text-align: left;\n  font-size: 20px\n}\n\n[_v-d83f8c02]:-moz-placeholder { /* Firefox 18- */\n  text-align: left;\n  font-size: 20px\n}\n\n[_v-d83f8c02]::-moz-placeholder { /* Firefox 19+ */\n  text-align: left;\n  font-size: 20px\n}\n\n[_v-d83f8c02]:-ms-input-placeholder {\n  text-align: left;\n  font-size: 20px\n}\n\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, module.exports.template)
  }
})()}
},{"./../../mixed/modals":10,"./../../mixed/notify":11,"vue":5,"vue-hot-reload-api":4,"vueify-insert-css":6}],91:[function(require,module,exports){
var __vueify_style__ = require("vueify-insert-css").insert("\n.font-30[_v-df93b6ee] {\n  color: #FFF;\n  font-size: 30px;\n}\n\n.search-box[_v-df93b6ee] {\n  width: 100%;\n  height: 50px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  padding: 5px;\n  font-size: 14px;\n  color: #000;\n}\n\n.custom-checkbox[_v-df93b6ee] {\n  height: 24px;\n  padding: 5px 10px;\n  font-size: 12px;\n  line-height: 1.6666667;\n  border-radius: 5px;\n}\n\ninput[type=\"checkbox\"][_v-df93b6ee] {\n  accent-color: #009ACC;\n}\n\ninput[type=\"checkbox\"]#checkbox1:checked + span[_v-df93b6ee] {\n  border-color: red;\n  background-color: red;\n}\n\n.table-data[_v-df93b6ee] {\n  padding: 5px;\n  font-size: 16px;\n  color: #44505E;\n  font-weight: 400;\n  border-right: 2px solid #EDEEF3;\n  border-left: 2px solid #EDEEF3;\n  border-bottom: 2px solid #EDEEF3;\n}\n\n\n.font-12[_v-df93b6ee] {\n  font-size: 12px;\n}\n\n.close-modal[_v-df93b6ee] {\n  font-size: 30px;\n  margin-top: -14.75px;\n  font-weight: 500;\n}\n\n.close-modal-29[_v-df93b6ee] {\n  font-size: 30px;\n  margin-top: -29.75px !important;\n  font-weight: 500;\n}\n\n.close-modal-0[_v-df93b6ee] {\n  font-size: 35px;\n  margin-top: 0 !important;\n  font-weight: 500;\n  z-index: 100;\n  color: #656565 !important;\n}\n\n.font-20[_v-df93b6ee] {\n  font-size: 20px;\n}\n\n\n.btn-submit[_v-df93b6ee] {\n  padding: 10px 20px !important;\n  font-size: 20px !important;\n  font-weight: 600 !important;\n  border-radius: 5px;\n}\n\n.bg-slate-custom[_v-df93b6ee] {\n  background-color: #d6dce5;\n  border-color: #d6dce5;\n}\n\n.custom-header[_v-df93b6ee] {\n  position: -webkit-sticky;\n  position: sticky;\n  top: 48px;\n  z-index: 100;\n}\n\n.top-65[_v-df93b6ee] {\n  top: 65px;\n}\n\n.bg-top-1[_v-df93b6ee] {\n  background-color: #24A893;\n  border-color: #24A893;\n  color: #fff;\n}\n\n.bg-top-2[_v-df93b6ee] {\n  background-color: #fff;\n  border-color: #fff;\n  color: #fff;\n}\n\n.column-header[_v-df93b6ee] {\n  padding: 12px !important;\n  font-size: 18px !important;\n  font-weight: 700 !important;\n  border-right: 2px solid #d6dce5;\n}\n\n.bg-top-3[_v-df93b6ee] {\n  background-color: #202933;\n  border-color: #202933;\n  color: #fff;\n}\n\n\n.fixed-height-table[_v-df93b6ee] {\n  max-height: 500px !important;\n  overflow-y: auto;\n}\n\n[_v-df93b6ee]::-webkit-input-placeholder {\n  text-align: left;\n  font-size: 20px\n}\n\n[_v-df93b6ee]:-moz-placeholder { /* Firefox 18- */\n  text-align: left;\n  font-size: 20px\n}\n\n[_v-df93b6ee]::-moz-placeholder { /* Firefox 19+ */\n  text-align: left;\n  font-size: 20px\n}\n\n[_v-df93b6ee]:-ms-input-placeholder {\n  text-align: left;\n  font-size: 20px\n}\n\n.client-list[_v-df93b6ee] {\n  list-style-type: none;\n}\n\n.filter-div[_v-df93b6ee] {\n  position: fixed;\n  top: 100px;\n}\n\n")
"use strict";

exports.__esModule = true;
var modals = require("./../../mixed/modals");
var notify = require("./../../mixed/notify");

exports["default"] = {
  data: function data() {
    return {
      entries: {},
      filteredEntries: {},
      searchedEmployees: {},
      activeEmployee: {},
      jobs: {},
      clients: {},
      type: 0,
      availableJobs: {},
      selectedJObs: {},
      ids: [],
      all: false,
      primary_phone: '',
      new_pin: ''
    };
  },
  props: ['user'],
  filters: {},
  watch: {},
  ready: function ready() {
    this.getEntries();
  },

  events: {},

  methods: {

    filterEntries: function filterEntries(index) {
      if (index === '') {
        this.filteredEntries = this.entries;
      } else {
        this.filteredEntries = {};
        this.filteredEntries[index] = this.entries[index];
      }
    },

    getEntries: function getEntries() {
      var _this = this;

      notify.loading(true);
      this.$http.get("/api/timesheet-accounting-team-2-pending", function (response) {
        _this.entries = response;
        _this.filteredEntries = response;
        notify.loading(false);
      }).always(function () {});
    },

    /**
     * update entries marked as completed
     */
    updateEntries: function updateEntries() {
      var _this2 = this;

      notify.loading(true);
      this.$http.post("/api/update-timesheet-accounting-team-2-pending", {
        ids: this.ids
      }, function (response) {
        notify.loading(false);
        _this2.getEntries();
      }).always(function () {});
    },

    sortBy: function sortBy(field, reverse, primer) {
      var key = primer ? function (x) {
        return primer(x[field]);
      } : function (x) {
        return x[field];
      };

      reverse = !reverse ? 1 : -1;

      return function (a, b) {
        return a = key(a), b = key(b), reverse * ((a > b) - (b > a));
      };
    },

    sortUsers: function sortUsers(field, reverse) {
      var primer = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];

      console.log(field);
      this.sortOrders = reverse;
      this.sortKey = field;
      this.employees.sort(this.sortBy(field, reverse, primer));
    }

  }
};
module.exports = exports["default"];
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n  <div class=\"row\" _v-df93b6ee=\"\">\n    <div class=\"col-md-3 col-xl-3 pt-50 pl-10\" _v-df93b6ee=\"\">\n      <div class=\"filter-div\" _v-df93b6ee=\"\">\n        <ul _v-df93b6ee=\"\">\n          <li class=\"client-list cursor-pointer\" _v-df93b6ee=\"\">\n            <span class=\"font-16 text-black p-10 pb-20\" v-on:click=\"filterEntries('')\" _v-df93b6ee=\"\">Show All</span>\n          </li>\n          <li v-for=\"(index,clients) in entries\" class=\"client-list cursor-pointer font-16\" _v-df93b6ee=\"\">\n          <span class=\"font-16 text-black p-10 pb-20 pr-5\" v-on:click=\"filterEntries(index)\" _v-df93b6ee=\"\">{{\n              index\n            }}</span>\n            (<span class=\"text-blue-600\" _v-df93b6ee=\"\">{{ entries[index].length }}</span>)\n          </li>\n        </ul>\n      </div>\n    </div>\n    <div class=\"col-md-8 col-xl-8 col-sm-12 no-padding-left no-padding-right\" _v-df93b6ee=\"\">\n      <div class=\"col-md-12 col-sm-12  no-padding-left no-padding-right\" _v-df93b6ee=\"\">\n        <table class=\"table table-xxs fixed-height-table\" _v-df93b6ee=\"\">\n          <thead class=\"header custom-header\" _v-df93b6ee=\"\">\n          <tr class=\"bg-top-2\" _v-df93b6ee=\"\">\n            <th class=\"text-center text-black font-12 p-5 pl-5\" colspan=\"8\" _v-df93b6ee=\"\">\n              <div class=\"row\" _v-df93b6ee=\"\">\n                <div class=\"col-md-4 col-sm-4 text-left pull-left\" _v-df93b6ee=\"\">\n                  <input type=\"text\" name=\"search\" v-model=\"query\" class=\"form-control input-lg search-box\" placeholder=\"search\" _v-df93b6ee=\"\">\n                </div>\n                <div class=\"col-md-4 col-sm-4  p-5\" _v-df93b6ee=\"\">\n\n                </div>\n                <div class=\"col-md-4 col-sm-4 text-right pull-right\" _v-df93b6ee=\"\">\n                  <button class=\"btn btn-submit font-12 bg-top-1\" @click.prevent=\"updateEntries()\" _v-df93b6ee=\"\">Submit</button>\n                </div>\n\n              </div>\n            </th>\n          </tr>\n\n          <!--          <tr class=\"bg-top-1\">-->\n          <!--            <th class=\"text-center p-5 font-30 pl-10\" colspan=\"6\">-->\n          <!--              APPROVED ENTRIES-->\n          <!--            </th>-->\n          <!--          </tr>-->\n\n          <tr _v-df93b6ee=\"\">\n            <th class=\"bg-top-3 text-left text-black cursor-pointer text-uppercase column-header\" _v-df93b6ee=\"\">\n              JOB\n            </th>\n            <th class=\"bg-top-3 text-left text-black cursor-pointer text-uppercase column-header\" _v-df93b6ee=\"\">\n              DATE\n            </th>\n            <th class=\"bg-top-3 text-black text-left text-uppercase column-header\" _v-df93b6ee=\"\">EMPLOYEE</th>\n            <th class=\"bg-top-3 text-black text-left text-uppercase column-header\" _v-df93b6ee=\"\">TOTAL</th>\n            <th class=\"bg-top-3 text-black text-center text-uppercase column-header\" _v-df93b6ee=\"\">COMPLETED</th>\n            <th class=\"bg-top-3 text-black text-left text-uppercase column-header\" _v-df93b6ee=\"\">APPROVED BY</th>\n\n\n          </tr>\n          </thead>\n          <tbody v-for=\"(index,clientEntry) in filteredEntries\" _v-df93b6ee=\"\">\n          <tr _v-df93b6ee=\"\">\n            <td colspan=\"6\" class=\"text-left text-black font-20 bg-grey-300 text-color-black pl-5\" _v-df93b6ee=\"\">\n              <div class=\"col-md-6 text-left pl-10\" _v-df93b6ee=\"\">{{ index }} - {{ clientEntry[0].company_code }}</div>\n              <div class=\"col-md-6 text-right pr-10\" _v-df93b6ee=\"\">APPROVED ENTRIES</div>\n            </td>\n          </tr>\n          <tr v-for=\"entry in clientEntry\" class=\"\" _v-df93b6ee=\"\">\n            <td class=\"text-left table-data\" _v-df93b6ee=\"\">\n              {{ entry.position_title }}\n            </td>\n            <td class=\"text-left cursor-pointer table-data\" _v-df93b6ee=\"\">\n              {{ entry.date }}\n            </td>\n            <td class=\"text-left cursor-pointer table-data\" _v-df93b6ee=\"\">\n              {{ entry.name }}\n            </td>\n            <td class=\"text-left cursor-pointer table-data\" _v-df93b6ee=\"\">\n              {{ entry.duration }}\n            </td>\n            <td class=\"text-left cursor-pointer table-data\" _v-df93b6ee=\"\">\n              <input type=\"checkbox\" name=\"\" id=\"\" v-model=\"ids\" :value=\"entry.id\" class=\"form-control custom-checkbox\" _v-df93b6ee=\"\">\n            </td>\n            <td class=\"text-left table-data font-12 text-italic\" _v-df93b6ee=\"\">\n              {{ entry.approved_by }}\n            </td>\n\n          </tr>\n          </tbody>\n        </table>\n      </div>\n    </div>\n\n  </div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  var id = "/home/shoieb/sites/elegant/resources/assets/js/vue/components/time-clock-accounting-team-2-pending.vue"
  module.hot.dispose(function () {
    require("vueify-insert-css").cache["\n.font-30[_v-df93b6ee] {\n  color: #FFF;\n  font-size: 30px;\n}\n\n.search-box[_v-df93b6ee] {\n  width: 100%;\n  height: 50px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  padding: 5px;\n  font-size: 14px;\n  color: #000;\n}\n\n.custom-checkbox[_v-df93b6ee] {\n  height: 24px;\n  padding: 5px 10px;\n  font-size: 12px;\n  line-height: 1.6666667;\n  border-radius: 5px;\n}\n\ninput[type=\"checkbox\"][_v-df93b6ee] {\n  accent-color: #009ACC;\n}\n\ninput[type=\"checkbox\"]#checkbox1:checked + span[_v-df93b6ee] {\n  border-color: red;\n  background-color: red;\n}\n\n.table-data[_v-df93b6ee] {\n  padding: 5px;\n  font-size: 16px;\n  color: #44505E;\n  font-weight: 400;\n  border-right: 2px solid #EDEEF3;\n  border-left: 2px solid #EDEEF3;\n  border-bottom: 2px solid #EDEEF3;\n}\n\n\n.font-12[_v-df93b6ee] {\n  font-size: 12px;\n}\n\n.close-modal[_v-df93b6ee] {\n  font-size: 30px;\n  margin-top: -14.75px;\n  font-weight: 500;\n}\n\n.close-modal-29[_v-df93b6ee] {\n  font-size: 30px;\n  margin-top: -29.75px !important;\n  font-weight: 500;\n}\n\n.close-modal-0[_v-df93b6ee] {\n  font-size: 35px;\n  margin-top: 0 !important;\n  font-weight: 500;\n  z-index: 100;\n  color: #656565 !important;\n}\n\n.font-20[_v-df93b6ee] {\n  font-size: 20px;\n}\n\n\n.btn-submit[_v-df93b6ee] {\n  padding: 10px 20px !important;\n  font-size: 20px !important;\n  font-weight: 600 !important;\n  border-radius: 5px;\n}\n\n.bg-slate-custom[_v-df93b6ee] {\n  background-color: #d6dce5;\n  border-color: #d6dce5;\n}\n\n.custom-header[_v-df93b6ee] {\n  position: -webkit-sticky;\n  position: sticky;\n  top: 48px;\n  z-index: 100;\n}\n\n.top-65[_v-df93b6ee] {\n  top: 65px;\n}\n\n.bg-top-1[_v-df93b6ee] {\n  background-color: #24A893;\n  border-color: #24A893;\n  color: #fff;\n}\n\n.bg-top-2[_v-df93b6ee] {\n  background-color: #fff;\n  border-color: #fff;\n  color: #fff;\n}\n\n.column-header[_v-df93b6ee] {\n  padding: 12px !important;\n  font-size: 18px !important;\n  font-weight: 700 !important;\n  border-right: 2px solid #d6dce5;\n}\n\n.bg-top-3[_v-df93b6ee] {\n  background-color: #202933;\n  border-color: #202933;\n  color: #fff;\n}\n\n\n.fixed-height-table[_v-df93b6ee] {\n  max-height: 500px !important;\n  overflow-y: auto;\n}\n\n[_v-df93b6ee]::-webkit-input-placeholder {\n  text-align: left;\n  font-size: 20px\n}\n\n[_v-df93b6ee]:-moz-placeholder { /* Firefox 18- */\n  text-align: left;\n  font-size: 20px\n}\n\n[_v-df93b6ee]::-moz-placeholder { /* Firefox 19+ */\n  text-align: left;\n  font-size: 20px\n}\n\n[_v-df93b6ee]:-ms-input-placeholder {\n  text-align: left;\n  font-size: 20px\n}\n\n.client-list[_v-df93b6ee] {\n  list-style-type: none;\n}\n\n.filter-div[_v-df93b6ee] {\n  position: fixed;\n  top: 100px;\n}\n\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, module.exports.template)
  }
})()}
},{"./../../mixed/modals":10,"./../../mixed/notify":11,"vue":5,"vue-hot-reload-api":4,"vueify-insert-css":6}],92:[function(require,module,exports){
var __vueify_style__ = require("vueify-insert-css").insert("\n\n.options[_v-2488b780] {\n  color: #000;\n}\n\n.search-box[_v-2488b780] {\n  width: 100%;\n  height: 50px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  padding: 5px;\n  font-size: 14px;\n  color: #000;\n}\n\n.custom-checkbox[_v-2488b780] {\n  height: 24px;\n  padding: 5px 10px;\n  font-size: 12px;\n  line-height: 1.6666667;\n  border-radius: 5px;\n}\n\ninput[type=\"checkbox\"][_v-2488b780] {\n  accent-color: #009ACC;\n}\n\ninput[type=\"checkbox\"]#checkbox1:checked + span[_v-2488b780] {\n  border-color: red;\n  background-color: red;\n}\n\n.table-data[_v-2488b780] {\n  padding: 10px;\n  font-size: 17px;\n  color: #44505E;\n  font-weight: 400;\n  border-right: 2px solid #EDEEF3;\n  border-bottom: 2px solid #EDEEF3;\n}\n\n.close-modal[_v-2488b780] {\n  font-size: 30px;\n  margin-top: -14.75px;\n  font-weight: 500;\n}\n\n.close-modal-29[_v-2488b780] {\n  font-size: 30px;\n  margin-top: -29.75px !important;\n  font-weight: 500;\n}\n\n.close-modal-0[_v-2488b780] {\n  font-size: 35px;\n  margin-top: 0 !important;\n  font-weight: 500;\n  z-index: 100;\n  color: #656565 !important;\n}\n\n.font-20[_v-2488b780] {\n  font-size: 20px;\n}\n\n\n.btn-submit[_v-2488b780] {\n  padding: 10px 50px !important;\n  font-size: 25px !important;\n  font-weight: 600 !important;\n  border-radius: 5px;\n}\n\n.bg-slate-custom[_v-2488b780] {\n  background-color: #d6dce5;\n  border-color: #d6dce5;\n}\n\n.custom-header[_v-2488b780] {\n  position: -webkit-sticky;\n  position: sticky;\n  top: 48px;\n  z-index: 100;\n}\n\n.top-65[_v-2488b780] {\n  top: 65px;\n}\n\n.bg-top-1[_v-2488b780] {\n  background-color: #43546A;\n  border-color: #43546A;\n  color: #fff;\n}\n\n.bg-top-4[_v-2488b780] {\n  background-color: #152A43;\n  border-color: #152A43;\n  color: #fff;\n}\n\n.column-header[_v-2488b780] {\n  padding: 12px !important;\n  font-size: 18px !important;\n  font-weight: 700 !important;\n  border-right: 2px solid #d6dce5;\n}\n\n.bg-top-3[_v-2488b780] {\n  background-color: #202933;\n  border-color: #202933;\n  color: #fff;\n}\n\n.font-30[_v-2488b780] {\n  font-size: 35px;\n  font-weight: 500;\n  color: #fff\n}\n\n.fixed-height-table[_v-2488b780] {\n  //height: 500px !important;\n  max-height: 500px !important;\n  overflow-y: auto;\n}\n\n[_v-2488b780]::-webkit-input-placeholder {\n  text-align: left;\n  font-size: 20px\n}\n\n[_v-2488b780]:-moz-placeholder { /* Firefox 18- */\n  text-align: left;\n  font-size: 20px\n}\n\n[_v-2488b780]::-moz-placeholder { /* Firefox 19+ */\n  text-align: left;\n  font-size: 20px\n}\n\n[_v-2488b780]:-ms-input-placeholder {\n  text-align: left;\n  font-size: 20px\n}\n\n")
"use strict";

exports.__esModule = true;
var modals = require("./../../mixed/modals");
var notify = require("./../../mixed/notify");

exports["default"] = {
  data: function data() {
    return {
      entries: {},
      searchedEmployees: {},
      activeEmployee: {},
      jobs: {},
      clients: {},
      type: 0,
      availableJobs: {},
      selectedJObs: {},
      ids: [],
      all: false,
      primary_phone: '',
      new_pin: '',
      start_date: '',
      end_date: '',
      start: '',
      end: '',
      weeks: 0,
      today: '',
      weekCount: null,
      dates: []
    };
  },
  props: ['user'],
  filters: {},
  watch: {},
  ready: function ready() {
    this.getEntries();
  },

  events: {},

  methods: {

    changeWeekCount: function changeWeekCount() {
      this.weeks = this.weekCount;
      this.getEntries();
    },

    changeWeek: function changeWeek(val) {
      this.weeks = val;
      this.getEntries();
    },

    getEntries: function getEntries() {
      var _this = this;

      notify.loading(true);
      this.$http.get("/api/timesheet-accounting-team-2-processed?start_date=" + this.start_date + "&end_date=" + this.end_date + "&weeks=" + this.weeks, function (response) {
        _this.entries = response.entries;
        _this.start_date = response.start_date;
        _this.end_date = response.end_date;
        _this.start = response.start;
        _this.end = response.end;
        _this.weeks = 0;
        _this.today = response.today;
        _this.dates = response.dates;
        _this.weekCount = null;
        notify.loading(false);
      }).always(function () {});
    },

    sortBy: function sortBy(field, reverse, primer) {
      var key = primer ? function (x) {
        return primer(x[field]);
      } : function (x) {
        return x[field];
      };

      reverse = !reverse ? 1 : -1;

      return function (a, b) {
        return a = key(a), b = key(b), reverse * ((a > b) - (b > a));
      };
    },

    sortUsers: function sortUsers(field, reverse) {
      var primer = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];

      console.log(field);
      this.sortOrders = reverse;
      this.sortKey = field;
      this.employees.sort(this.sortBy(field, reverse, primer));
    }

  }
};
module.exports = exports["default"];
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n  <div class=\"row\" _v-2488b780=\"\">\n    <div class=\"col-md-2 col-xl-2\" _v-2488b780=\"\"></div>\n    <div class=\"col-md-8 col-xl-8 col-sm-12 no-padding-left no-padding-right\" _v-2488b780=\"\">\n      <div class=\"col-md-12 col-sm-12  no-padding-left no-padding-right\" _v-2488b780=\"\">\n        <table class=\"table table-xxs fixed-height-table\" _v-2488b780=\"\">\n          <thead class=\"header custom-header\" _v-2488b780=\"\">\n          <tr class=\"bg-top-2\" _v-2488b780=\"\">\n            <th class=\"text-center text-black p-5 font-20 p-5\" colspan=\"8\" _v-2488b780=\"\">\n              <div class=\"row\" _v-2488b780=\"\">\n                <div class=\"col-md-4 col-sm-4 text-left pull-left\" _v-2488b780=\"\">\n                  <input type=\"text\" name=\"search\" v-model=\"query\" class=\"form-control input-lg search-box\" placeholder=\"search\" _v-2488b780=\"\">\n                </div>\n                <div class=\"col-md-4 col-sm-4  p-5\" _v-2488b780=\"\">\n\n                </div>\n                <!--                <div class=\"col-md-4 col-sm-4 text-right pull-right\">-->\n                <!--                  <button class=\"btn btn-submit font-20 bg-top-1\">Submit</button>-->\n                <!--                </div>-->\n\n              </div>\n            </th>\n          </tr>\n\n          <tr class=\"bg-top-1\" _v-2488b780=\"\">\n            <th class=\"text-left p-5 font-20 pl-20\" colspan=\"3\" _v-2488b780=\"\">\n              TEAM 2 ENTRY - PROCESSED\n            </th>\n\n            <th class=\"text-right p-5 font-20 pr-20\" colspan=\"3\" _v-2488b780=\"\">\n              {{ today }}\n            </th>\n          </tr>\n\n          <tr class=\"bg-top-4\" _v-2488b780=\"\">\n            <th class=\"text-center p-5 font-20 pl-40\" colspan=\"6\" _v-2488b780=\"\">\n              <div class=\"row\" _v-2488b780=\"\">\n\n                <div class=\"col-md-10\" _v-2488b780=\"\">\n                  <i class=\"fa fa-caret-left font-40 cursor-pointer text-white pr-10\" @click=\"changeWeek(-1)\" _v-2488b780=\"\"></i>\n                  {{ start }} - {{ end }} <i class=\"fa fa-caret-right font-40 cursor-pointer text-white pl-10\" @click=\"changeWeek(1)\" _v-2488b780=\"\"></i>\n                </div>\n\n                <div class=\"col-md-2 pt-10\" _v-2488b780=\"\">\n                  <select class=\"form-control\" v-model=\"weekCount\" @click=\"changeWeekCount()\" _v-2488b780=\"\">\n                    <option class=\"options\" v-for=\"(index,date) in dates\" :value=\"index\" _v-2488b780=\"\">{{ date }}</option>\n                  </select>\n                </div>\n              </div>\n            </th>\n          </tr>\n\n          <tr _v-2488b780=\"\">\n            <th class=\"bg-top-3 text-left text-black text-uppercase column-header\" _v-2488b780=\"\">\n              CLIENT\n            </th>\n            <th class=\"bg-top-3 text-left text-black cursor-pointer text-uppercase column-header\" _v-2488b780=\"\">\n              JOB\n            </th>\n            <th class=\"bg-top-3 text-left text-black cursor-pointer text-uppercase column-header\" _v-2488b780=\"\">\n              DATE\n            </th>\n            <th class=\"bg-top-3 text-black text-left text-uppercase column-header\" _v-2488b780=\"\">EMPLOYEE</th>\n            <th class=\"bg-top-3 text-black text-left text-uppercase column-header\" _v-2488b780=\"\">TOTAL</th>\n            <th class=\"bg-top-3 text-black text-left text-uppercase column-header\" _v-2488b780=\"\">PROCESSED BY</th>\n\n          </tr>\n          </thead>\n          <tbody _v-2488b780=\"\">\n          <tr v-for=\"entry in entries\" class=\"\" _v-2488b780=\"\">\n            <td class=\"text-left table-data\" _v-2488b780=\"\">\n              {{ entry.client_name }}\n            </td>\n            <td class=\"text-left table-data\" _v-2488b780=\"\">\n              {{ entry.position_title }}\n            </td>\n            <td class=\"text-left cursor-pointer table-data\" _v-2488b780=\"\">\n              {{ entry.date }}\n            </td>\n            <td class=\"text-left cursor-pointer table-data\" _v-2488b780=\"\">\n              {{ entry.name }}\n            </td>\n            <td class=\"text-left cursor-pointer table-data\" _v-2488b780=\"\">\n              {{ entry.duration }}\n            </td>\n            <td class=\"text-left cursor-pointer table-data\" _v-2488b780=\"\">\n              {{ entry.user_name }}\n            </td>\n          </tr>\n          </tbody>\n        </table>\n      </div>\n    </div>\n\n  </div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  var id = "/home/shoieb/sites/elegant/resources/assets/js/vue/components/time-clock-accounting-team-2-processed.vue"
  module.hot.dispose(function () {
    require("vueify-insert-css").cache["\n\n.options[_v-2488b780] {\n  color: #000;\n}\n\n.search-box[_v-2488b780] {\n  width: 100%;\n  height: 50px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  padding: 5px;\n  font-size: 14px;\n  color: #000;\n}\n\n.custom-checkbox[_v-2488b780] {\n  height: 24px;\n  padding: 5px 10px;\n  font-size: 12px;\n  line-height: 1.6666667;\n  border-radius: 5px;\n}\n\ninput[type=\"checkbox\"][_v-2488b780] {\n  accent-color: #009ACC;\n}\n\ninput[type=\"checkbox\"]#checkbox1:checked + span[_v-2488b780] {\n  border-color: red;\n  background-color: red;\n}\n\n.table-data[_v-2488b780] {\n  padding: 10px;\n  font-size: 17px;\n  color: #44505E;\n  font-weight: 400;\n  border-right: 2px solid #EDEEF3;\n  border-bottom: 2px solid #EDEEF3;\n}\n\n.close-modal[_v-2488b780] {\n  font-size: 30px;\n  margin-top: -14.75px;\n  font-weight: 500;\n}\n\n.close-modal-29[_v-2488b780] {\n  font-size: 30px;\n  margin-top: -29.75px !important;\n  font-weight: 500;\n}\n\n.close-modal-0[_v-2488b780] {\n  font-size: 35px;\n  margin-top: 0 !important;\n  font-weight: 500;\n  z-index: 100;\n  color: #656565 !important;\n}\n\n.font-20[_v-2488b780] {\n  font-size: 20px;\n}\n\n\n.btn-submit[_v-2488b780] {\n  padding: 10px 50px !important;\n  font-size: 25px !important;\n  font-weight: 600 !important;\n  border-radius: 5px;\n}\n\n.bg-slate-custom[_v-2488b780] {\n  background-color: #d6dce5;\n  border-color: #d6dce5;\n}\n\n.custom-header[_v-2488b780] {\n  position: -webkit-sticky;\n  position: sticky;\n  top: 48px;\n  z-index: 100;\n}\n\n.top-65[_v-2488b780] {\n  top: 65px;\n}\n\n.bg-top-1[_v-2488b780] {\n  background-color: #43546A;\n  border-color: #43546A;\n  color: #fff;\n}\n\n.bg-top-4[_v-2488b780] {\n  background-color: #152A43;\n  border-color: #152A43;\n  color: #fff;\n}\n\n.column-header[_v-2488b780] {\n  padding: 12px !important;\n  font-size: 18px !important;\n  font-weight: 700 !important;\n  border-right: 2px solid #d6dce5;\n}\n\n.bg-top-3[_v-2488b780] {\n  background-color: #202933;\n  border-color: #202933;\n  color: #fff;\n}\n\n.font-30[_v-2488b780] {\n  font-size: 35px;\n  font-weight: 500;\n  color: #fff\n}\n\n.fixed-height-table[_v-2488b780] {\n  //height: 500px !important;\n  max-height: 500px !important;\n  overflow-y: auto;\n}\n\n[_v-2488b780]::-webkit-input-placeholder {\n  text-align: left;\n  font-size: 20px\n}\n\n[_v-2488b780]:-moz-placeholder { /* Firefox 18- */\n  text-align: left;\n  font-size: 20px\n}\n\n[_v-2488b780]::-moz-placeholder { /* Firefox 19+ */\n  text-align: left;\n  font-size: 20px\n}\n\n[_v-2488b780]:-ms-input-placeholder {\n  text-align: left;\n  font-size: 20px\n}\n\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, module.exports.template)
  }
})()}
},{"./../../mixed/modals":10,"./../../mixed/notify":11,"vue":5,"vue-hot-reload-api":4,"vueify-insert-css":6}],93:[function(require,module,exports){
"use strict";

exports.__esModule = true;
var modals = require("./../../mixed/modals");
var notify = require("./../../mixed/notify");

exports["default"] = {
  data: function data() {
    return {
      orders: {},
      startDate: "",
      currentDate: "",
      activeOrder: {},
      departments: {}
    };
  },
  filters: {},
  watch: {
    startDate: function startDate(val) {
      this.currentDate = moment(val).format("dddd MMM - DD");
      this.getTimeSheetData();
    }
  },
  ready: function ready() {
    var _this = this;

    // $(".table").fixedHeader();
    $("#blank-timesheet").click(function () {
      _this.getBlankTimeSheetList();
    });
    //this.getTimeSheetData();
  },
  events: {},
  methods: {
    totalOrder: function totalOrder(orders) {
      var total = 0;
      var departmentOrders = _.cloneDeep(orders);
      departmentOrders.map(function (order) {
        total += order.no_of_employee;
      });

      return total;
    },

    totalReconfirm: function totalReconfirm(orders) {
      var _this2 = this;

      var total = 0;
      var departmentOrders = _.cloneDeep(orders);
      departmentOrders.map(function (order) {
        var additional = _this2.countAdditionalEmployees(order.additional_employees);
        total = total + additional + order.reConfirmed;
      });

      return total;
    },

    orderStatus: function orderStatus(orders) {
      var totalOrder = this.totalOrder(orders);
      var totalReConfirm = this.totalReconfirm(orders);
      return totalOrder <= totalReConfirm ? '<span class="text-blue">Complete</span>' : '<span class="text-orange">In Process</span>';
    },

    checkCompletionStatus: function checkCompletionStatus(order) {
      return order.status ? '<span class="text-grey-300">Yes</span>' : '<span class="text-danger">No</span>';
    },

    updateCompletionStatus: function updateCompletionStatus(order) {
      this.activeOrder = _.cloneDeep(order);
      modals.showStrict("#update-completion-status-modal");
    },

    /**
     * send request to update timesheet complete status
     */
    updateStatus: function updateStatus() {
      var _this3 = this;

      this.$http.post("/api/update-timesheet-completion-status", this.activeOrder, function (response) {
        modals.hide("#update-completion-status-modal");
        _this3.getTimeSheetData();
      }).always(function () {});
    },
    /**
     * get timesheet data
     */
    getTimeSheetData: function getTimeSheetData() {
      var _this4 = this;

      notify.loading(true);
      this.$http.get("/api/timesheet-data/?start_date=" + this.startDate, function (response) {
        _this4.orders = response;
      }).always(function () {
        notify.loading(false);
      });
    },

    /**
     * get blank timesheet list and show modal
     */
    getBlankTimeSheetList: function getBlankTimeSheetList() {
      var _this5 = this;

      notify.loading(true);
      this.$http.get("/api/blank-timesheet-list", function (response) {
        _this5.departments = response;
        modals.showStrict("#blank-timesheet-modal");
      }).always(function () {
        notify.loading(false);
      });
    },

    /**
     * Count total number of additional employees
     * @param {String} employees
     */
    countAdditionalEmployees: function countAdditionalEmployees(employees) {
      if (!employees.length) return 0;

      var totalEmployees = employees.split(/\r|\r\n|\n/);
      var count = 0;
      totalEmployees.map(function (employee) {
        if (employee.length) count++;
      });
      return count ? count : 0;
    }
  }
};
module.exports = exports["default"];
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n    <div class=\"row\">\n        <div class=\"col-md-12  no-padding-left no-padding-right\">\n                <table class=\"table table-xxs\">\n                    <thead class=\"header\">\n                        <tr>\n                            <th colspan=\"3\" class=\"mt-20 mb-10 bg-slate-300\">\n                                <h1 class=\"text-uppercase text-color-black text-left\">\n                                    print timesheet\n                                </h1>\n                            </th>\n                            <th colspan=\"3\" class=\"mt-20 mb-10 bg-slate-300 text-center\">\n                                <div class=\"col-md-6\">\n                                    <div class=\"form-group mt-20 mb-10\">\n                                        <input type=\"text\" class=\"form-control pickadate-year text-black\" v-model=\"startDate\" id=\"start_date\">\n                                    </div>\n                                </div>\n                            </th>\n                            <th colspan=\"2\" class=\"mt-20 mb-10 bg-slate-300\">\n                                <button class=\"btn btn-primary pull-right text-uppercase text-black\" id=\"blank-timesheet\">Timesheet </button>\n                            </th>\n                        </tr>\n                        <tr colspan=\"8\">\n                            <th class=\"col-md-2 bg-slate-300 text-black text-uppercase text-center no-padding-left no-padding-right\"></th>\n                            <th class=\"col-md-2 bg-slate-300 text-black text-uppercase text-left\"></th>\n                            <th class=\"col-md-2 bg-slate-300 text-black text-uppercase text-center  no-padding-left\"></th>\n                            <th colspan=\"3\" class=\"col-md-2 bg-slate-300 text-black text-uppercase text-left text-red font-30\">{{ currentDate }}</th>\n                            <th class=\"col-md-2 bg-slate-300 text-black text-uppercase text-center  no-padding-left\"></th>\n                            <th class=\"col-md-2 bg-slate-300 text-black text-uppercase text-center  no-padding-left no-padding-right\"></th>\n                        </tr>\n                        <tr>\n                            <th class=\"col-md-2 bg-slate-800 text-black text-uppercase text-center no-padding-left no-padding-right\">CODE</th>\n                            <th class=\"col-md-2 bg-slate-800 text-black text-uppercase text-left\">client name</th>\n                            <th class=\"col-md-2 bg-slate-800 text-black text-uppercase text-left\">department</th>\n                            <th class=\"col-md-2 bg-slate-800 text-black text-uppercase text-center\">order</th>\n                            <th class=\"col-md-2 bg-slate-800 text-black text-uppercase text-center\">reconfirm</th>\n                            <th class=\"col-md-2 bg-slate-800 text-black text-uppercase text-center  no-padding-left\">status</th>\n                            <th class=\"col-md-2 bg-slate-800 text-black text-uppercase text-center  no-padding-left\">view</th>\n                            <th class=\"col-md-2 bg-slate-800 text-black text-uppercase text-center  no-padding-left no-padding-right\">done</th>\n                        </tr>\n                    </thead>\n                    <tbody>\n                        <tr v-for=\"(index,order) in orders\" :key=\"index\">\n                            <td class=\"text-center\">{{ order[0].company_code}}</td>\n                            <td class=\"text-left\">{{ order[0].client_name}}</td>\n                            <td class=\"text-left\">{{ order[0].department_name}}</td>\n                            <td class=\"text-center\">{{ totalOrder(order) }}</td>\n                            <td class=\"text-center\">{{ totalReconfirm(order) }}</td>\n                            <td class=\"text-center text-black\">{{{ orderStatus(order) }}}</td>\n                            <td class=\"text-center text-italic\">\n                                <a class=\"text-color-black \" :href=\"'/api/daily-timesheet/'+order[0].department_id+'?start_date='+startDate+'&amp;total='+totalOrder(order)\" target=\"_blank\">View</a>\n                            </td>\n                            <td @click=\"updateCompletionStatus(order[0])\" class=\"cursor-pointer text-center text-italic\">{{{ checkCompletionStatus(order[0]) }}}</td>\n                        </tr>\n                    </tbody>\n                </table>\n            </div>\n\n            <div class=\"modal fade\" id=\"update-completion-status-modal\">\n            <div class=\"modal-dialog modal-xs\">\n                <div class=\"modal-content\">\n                    <div class=\"modal-header bg-slate\">\n                        <button type=\"button\" class=\"close text-black text-color-black\" data-dismiss=\"modal\" aria-hidden=\"true\">×</button>\n                        <h4 class=\"modal-title\">Timesheet Send Complete</h4>\n                    </div>\n                    <div class=\"modal-body bg-slate-300\">\n                        <div class=\"form-group\">\n                            <div class=\"radio\">\n                                <label class=\"text-color-black text-black\"><input type=\"radio\" value=\"0\" v-model=\"activeOrder.status\" name=\"status\">No</label>\n                            </div>\n                            <div class=\"radio\">\n                                <label class=\"text-color-black text-black\"><input type=\"radio\" value=\"1\" v-model=\"activeOrder.status\" name=\"status\">Yes</label>\n                            </div>\n                        </div>\n                        <div class=\"form-group text-right\">\n                            <button type=\"button\" class=\"btn bg-blue-300 text-black\" @click=\"updateStatus\">Save</button>\n                        </div>\n                    </div>\n                </div>\n                <!--<div class=\"modal-footer\">-->\n                <!--<button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button>-->\n                <!--<button type=\"button\" class=\"btn btn-primary\">Save changes</button>-->\n                <!--</div>-->\n            </div><!-- /.modal-content -->\n        </div><!-- /.modal-dialog -->\n\n        <div class=\"modal fade\" id=\"blank-timesheet-modal\">\n            <div class=\"modal-dialog modal-medium\">\n                <div class=\"modal-content\">\n                    <div class=\"modal-header bg-slate\">\n                        <button type=\"button\" class=\"close text-black text-color-black\" data-dismiss=\"modal\" aria-hidden=\"true\">×</button>\n                        <h4 class=\"modal-title text-black text-color-black text-center\">BLANK TIMESHEET</h4>\n                    </div>\n                    <div class=\"modal-body\">\n                        <table class=\"table table-xs\">\n                            <thead>\n                                <tr>\n                                    <th class=\"bg-slate-800 text-black text-uppercase text-left\">client name</th>\n                                    <th class=\"bg-slate-800 text-black text-uppercase text-left\">department</th>\n                                    <th class=\"bg-danger text-black text-uppercase text-center\">daily</th>\n                                    <th class=\"bg-blue-600 text-black text-uppercase text-center\">weekly</th>\n                                </tr>\n                            </thead>\n                            <tbody>\n                                <tr v-for=\"(index,department) in departments\" :key=\"index\">\n                                    <td class=\"text-left\">{{ department.client_name }}</td>\n                                    <td class=\" text-left\">{{ department.department_name }}</td>\n                                    <td class=\"text-center text-italic cursor-pointer\"><a class=\"text-danger \" :href=\"'/api/blank-timesheet/'+department.id\" target=\"_blank\">View</a></td>\n                                    <td class=\"text-blue-600 text-center text-italic cursor-pointer\">View</td>\n                                </tr>\n                            </tbody>\n                        </table>\n                    </div>\n                </div>\n                <!--<div class=\"modal-footer\">-->\n                <!--<button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button>-->\n                <!--<button type=\"button\" class=\"btn btn-primary\">Save changes</button>-->\n                <!--</div>-->\n            </div><!-- /.modal-content -->\n        </div><!-- /.modal-dialog -->\n    </div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  var id = "/home/shoieb/sites/elegant/resources/assets/js/vue/components/timesheet.vue"
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, module.exports.template)
  }
})()}
},{"./../../mixed/modals":10,"./../../mixed/notify":11,"vue":5,"vue-hot-reload-api":4}],94:[function(require,module,exports){
"use strict";

exports.__esModule = true;
var modals = require("./../../mixed/modals");
var notify = require("./../../mixed/notify");

exports["default"] = {
  data: function data() {
    return {
      users: {},
      allUsers: {},
      activeUser: {},
      userStatus: {
        "Active and Watch List": ["Active", "Watch List"],
        "Inactive": ["Inactive"],
        "Suspended": ["Suspended"],
        "Missing Hire Date": ["Inactive", "Suspended", "Active", "Watch List"],
        "Quit and Terminated": ["Quite", "Terminated"],
        "Hired Last 45 Days": ["Active", "Watch List", "Inactive", "Suspended", "Active", "Watch List"],
        "Hired Last 90 Days": ["Active", "Watch List", "Inactive", "Suspended", "Active", "Watch List"],
        "Recently Invited": ["Active", "Watch List", "Inactive", "Suspended", "Active", "Watch List"],
        "No App Access": ["Active", "Watch List", "Inactive", "Suspended", "Active", "Watch List"],
        "All": ["Active", "Watch List", "Inactive", "Suspended", "Active", "Watch List"]
      },
      selectedStatus: "Hired Last 45 Days",
      sortOrders: true,
      sortKey: "name",
      query: '',
      employee: {},
      originalEmployee: {},
      newEmployee: {
        first_name: '',
        middle_name: '',
        last_name: '',
        primary_phone: '',
        secondary_phone: '',
        app_access: true,
        email: '',
        social_security: '',
        social_security_confirmation: ''
      },
      activeEmail: '',
      timeout: null,
      updated: false,
      note: '',
      fileUrl: ''
    };
  },
  filters: {},
  watch: {
    selectedStatus: function selectedStatus() {
      this.getUsers();
    },

    'employee': {
      handler: function handler(after, before) {

        this.updated = !(this.nullConverter(this.employee.email) === this.nullConverter(this.originalEmployee.email) && this.nullConverter(this.employee.primary_phone) === this.nullConverter(this.originalEmployee.primary_phone) && this.nullConverter(this.employee.secondary_phone) === this.nullConverter(this.originalEmployee.secondary_phone) && this.nullConverter(this.employee.app_access) == this.nullConverter(this.originalEmployee.app_access));
        console.log('updated');
      },
      deep: true
    },

    'query': function query(val, oldVal) {
      // let string = val.trim();
      // if (string) {
      //   this.users = this.allUsers.filter(function (user) {
      //         return (user.name.toLowerCase().indexOf(string) > -1) ||
      //             (user.email ? user.email.toLowerCase().indexOf(string) > -1 : '') ||
      //             (user.ss ? user.ss.toLowerCase().indexOf(string) > -1 : '') ||
      //             (user.dob ? user.dob.toLowerCase().indexOf(string) > -1 : '');
      //       }
      //   );
      // } else {
      //   this.users = this.allUsers;
      // }
    }
  },

  computed: {
    isDisabled: function isDisabled() {
      // evaluate whatever you need to determine disabled here...
      return this.newEmployee.social_security.length > 14;
    }
  },
  ready: function ready() {
    this.getUsers();
  },

  events: {},

  methods: {

    checkFormat: function checkFormat() {
      return this.newEmployee.social_security.length > 14;
    },

    employeeProfileLink: function employeeProfileLink(employee) {
      if (employee.image) {
        return 'http://0494f929b471961653ec-fc6d27d9aae55eef9b8e919dcfe05229.r57.cf5.rackcdn.com/profile/' + employee.image;
      } else {
        return '/api/employee-image/' + employee.id;
      }
    },

    /**
     * delete employee image
     */
    deleteImage: function deleteImage() {
      var _this = this;

      notify.loading(true);
      this.$http.get('/api/delete-employee-image/' + this.currentEmployee.id, '', function (response) {
        notify.loading(false);
        modals.hide('#employee_image');
        _this.$broadcast('vuetable:reload');
      }).always(function () {
        notify.loading(false);
      });
    },

    employeeImageModal: function employeeImageModal(employee) {
      $('.image-previewer').remove();
      $('<div id="" class="image-previewer mb-10" data-cropzee="cropzee-input"></div>').insertBefore("#cropzee-input");
      document.getElementById('cropzee-input').src = '';
      $("#cropzee-input").val('');
      this.employee = _.cloneDeep(employee);
      this.fileUrl = null;
      this.destroyCrop($("#cropzee-input"));
      this.imageCropUpload();
      //document.getElementById('cropzee-input').src = '';
      modals.showStrict('#employee_image');
    },

    uploadImage: function uploadImage(event) {
      var _this2 = this;

      notify.loading(true);
      var formData = new FormData();
      if (window.cropzeeReturnImage === undefined || window.cropzeeReturnImage === null) {
        var imageFile = document.querySelector('#cropzee-input');
        formData.append("image", imageFile.files[0]);
      } else {
        var blob = cropzeeGetImage('cropzee-input');
        formData.append("image", blob);
      }

      this.$http.post('/api/employee-image/' + this.employee.employee_id, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).always(function (response) {
        notify.loading(false);
        notify.success("Image uploaded successfully.");
        modals.hide('#employee_image');
        _this2.getUsers();
        // if (response == 1) {
        //   notify.loading(false);
        //   notify.success("Image uploaded successfully.");
        //   modals.hide('#employee_image');
        //   this.getUsers();
        // }
      });
    },

    destroyCrop: function destroyCrop($elem, eventNamespace) {
      var isInstantiated = !!$.data($elem.get(0));
      if (isInstantiated) {
        $.removeData($elem.get(0));
        $elem.off(eventNamespace);
        $elem.unbind('.' + eventNamespace);
      }
    },

    onChange: function onChange() {
      this.$refs.fileref.value = '';
    },

    imageCropUpload: function imageCropUpload() {
      $(document).ready(function () {
        $("#cropzee-input").cropzee({

          returnImageMode: 'blob',

          // custom aspect radio
          aspectRatio: 1.0,

          // min/max sizes
          maxSize: { width: null, height: null },

          minSize: [30, 30, '%'],

          // start size of crop region
          startSize: { width: 200, height: 200, unit: '%' },

          onCropStart: function onCropStart(data) {
            console.log(data.x, data.y, data.width, data.height);
          },
          onCropMove: function onCropMove(data) {
            console.log(data.x, data.y, data.width, data.height);
          },
          onCropEnd: function onCropEnd(data) {
            console.log(data.x, data.y, data.width, data.height);
          },
          onInitialize: function onInitialize(instance) {
            // do things here
          }

        });
      });
    },

    allNotes: function allNotes(user) {
      var notes = '';
      _.forEach(user.latest_notes, function (log) {
        notes += '<li>' + log.date + ' ' + log.user.name + ' - ' + log.note + ' </li>';
      });

      this.$nextTick(function () {
        $('[data-popup="popover"]').popover();
      });

      return notes;
    },

    showNoteModal: function showNoteModal(employee) {
      this.note = '';
      this.employee = _.cloneDeep(employee);
      modals.showStrict("#comment-modal");
    },

    updateStatus: function updateStatus() {
      var _this3 = this;

      notify.loading(true);
      this.$http.post("/api/save-user-access-note", {
        employee_id: this.employee.employee_id,
        type: 'note',
        entry_point: "User Access",
        orderIds: 0,
        note: this.note
      }, function (response) {
        //modals.hide("#comment-modal");
        modals.hide("#comment-modal");
        _this3.note = '';
        //this.getNoShowEmployees();
        _this3.getUsers();
      }).always(function () {
        notify.loading(false);
      });
    },

    nullConverter: function nullConverter(data) {
      if (data == null) {
        return '';
      }
      return data;
    },

    search: function search() {
      clearTimeout(this.timeout);
      var self = this;
      this.timeout = setTimeout(function () {
        self.selectedStatus = self.query ? 'All' : 'Hired Last 45 Days';
        self.getUsers();
      }, 800);
    },
    /**
     * send request to get list of users
     */
    getUsers: function getUsers() {
      var _this4 = this;

      notify.loading(true);
      this.$http.post("/api/user-access-list", {
        status: this.userStatus[this.selectedStatus],
        type: this.selectedStatus,
        query: this.query
      }, function (response) {
        _this4.users = response;
        _this4.allUsers = response;
        notify.loading(false);
      }).always(function () {});
    },

    /**
     * show modal to edit user information
     */
    showEditUserModal: function showEditUserModal(user) {
      this.activeUser = _.cloneDeep(user);
      if (this.activeUser.password) {
        this.activeUser.password = "**********";
      }
      modals.showStrict("#update-user-data");
    },

    showAddUserModal: function showAddUserModal() {
      this.newEmployee = {
        first_name: '',
        middle_name: '',
        last_name: '',
        primary_phone: '',
        secondary_phone: '',
        app_access: true,
        email: ''
      };
      modals.showStrict("#modal-add-employee-info");
    },

    /**
     * show modal to update employess data
     */
    editEmployeeModal: function editEmployeeModal(employee) {
      this.employee = _.cloneDeep(employee);
      this.originalEmployee = _.cloneDeep(employee);
      this.activeEmail = _.cloneDeep(employee.email);
      modals.showStrict("#modal-edit-employee-info");
    },

    editEmployee: function editEmployee() {
      var _this5 = this;

      this.$http.post('/api/update-user-access-employee-data/' + this.employee.employee_id, this.employee, function (response) {
        _this5.activeEmail = _.cloneDeep(response.email);
        _this5.employee.user_id = response.user_id;
        // modals.hide("#modal-edit-employee-info");
        _this5.getUsers();
      }).always(function () {});
    },

    sendInvitation: function sendInvitation() {
      notify.loading(true);
      this.$http.get('/api/send-employee-invitation/' + this.employee.user_id, function (response) {
        //modals.hide("#modal-edit-employee-info");
      }).always(function () {
        notify.loading(false);
      });
    },

    addEmployee: function addEmployee() {
      var _this6 = this;

      this.$http.post('/api/add-user-access-employee-data/', this.newEmployee, function (response) {
        _this6.newEmployee = {};
        modals.hide("#modal-add-employee-info");
        _this6.getUsers();
      }).always(function () {});
    },

    updateUserAccessData: function updateUserAccessData() {
      var _this7 = this;

      this.$http.post("/api/update-user-access-data", this.activeUser, function (response) {
        _this7.activeUser = {};
        modals.hide("#update-user-data");
        _this7.getUsers();
      }).always(function () {});
    },

    sortBy: function sortBy(field, reverse, primer) {
      var key = primer ? function (x) {
        return primer(x[field]);
      } : function (x) {
        return x[field];
      };

      reverse = !reverse ? 1 : -1;

      return function (a, b) {
        return a = key(a), b = key(b), reverse * ((a > b) - (b > a));
      };
    },

    sortUsers: function sortUsers(field, reverse) {
      var primer = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];

      console.log(field);
      this.sortOrders = reverse;
      this.sortKey = field;
      this.users.sort(this.sortBy(field, reverse, primer));
    }
  }
};
module.exports = exports["default"];
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n  <div class=\"row\">\n    <div class=\"col-md-12 no-padding-left no-padding-right\">\n      <table class=\"table table-xxs\">\n        <thead class=\"header\">\n        <tr>\n          <th class=\"mt-20 mb-10 bg-danger-800\" colspan=\"3\">\n            <h1 class=\"text-uppercase text-center\">APP USER ACCESS</h1>\n          </th>\n          <th class=\"mt-20 mb-10 bg-black-center max-width-300\" colspan=\"1\">\n            <div class=\"form-group mt-20 mb-10 max-width-300\">\n              <select id=\"status\" v-model=\"selectedStatus\" class=\"form-control\">\n                <option v-for=\"(index,status) in userStatus\" :key=\"index\" :value=\"index\">{{ index }}\n                </option>\n              </select>\n            </div>\n          </th>\n          <th class=\"mt-20 mb-10 text-center font-20 text-indigo-700 text-black\">\n            <input v-model=\"query\" class=\"form-control\" placeholder=\"search here\" type=\"text\" @keyup=\"search\">\n          </th>\n          <th class=\"mt-20 mb-10 text-center font-30 text-indigo-700 text-black\" colspan=\"3\">{{ selectedStatus }}\n          </th>\n          <th class=\"text-black text-center mt-20 mb-10\" colspan=\"2\"></th>\n        </tr>\n        <tr>\n          <th class=\"bg-black text-black text-uppercase text-left no-padding-right\">Status</th>\n          <th class=\"bg-black-center text-black text-uppercase text-center cursor-pointer\" @click=\"sortUsers('hire_date',!sortOrders)\">\n            Hire Date\n            <i v-if=\"sortKey === 'hire_date'\" :class=\"sortOrders ? 'fa fa-arrow-down':'fa fa-arrow-up'\"></i>\n          </th>\n          <th class=\"bg-black-center text-black text-uppercase text-center\">Phone</th>\n          <th class=\"bg-black text-black text-uppercase text-left cursor-pointer cursor-pointer\" @click=\"sortUsers('name',!sortOrders)\">\n            Employee Name\n            <i v-if=\"sortKey === 'name'\" :class=\"sortOrders ? 'fa fa-arrow-down':'fa fa-arrow-up'\"></i>\n          </th>\n          <th class=\"bg-black text-black text-uppercase text-left cursor-pointer\" @click=\"sortUsers('email',!sortOrders)\">\n            Email\n            <i v-if=\"sortKey === 'email'\" :class=\"sortOrders ? 'fa fa-arrow-down':'fa fa-arrow-up'\"></i>\n          </th>\n          <th class=\"bg-black-center text-black text-uppercase text-center\">Access</th>\n          <th class=\"bg-black-center text-black text-uppercase text-center cursor-pointer\" @click=\"sortUsers('last_app_activity',!sortOrders)\">\n            Log In\n            <i v-if=\"sortKey === 'last_app_activity'\" :class=\"sortOrders ? 'fa fa-arrow-down':'fa fa-arrow-up'\"></i>\n          </th>\n          <th class=\"bg-black-center text-black text-uppercase text-center cursor-pointer\" @click=\"sortUsers('jo_thirty_count',!sortOrders)\">\n            JO/C <span class=\"font-10\">(30)</span>\n            <i v-if=\"sortKey === 'jo_thirty_count'\" :class=\"sortOrders ? 'fa fa-arrow-down':'fa fa-arrow-up'\"></i>\n          </th>\n\n          <th class=\"bg-black-center text-black text-uppercase text-center cursor-pointer\" @click=\"sortUsers('worked_one_year_count',!sortOrders)\">\n            W/NS <span class=\"font-10\">(365)</span>\n            <i v-if=\"sortKey === 'worked_one_year_count'\" :class=\"sortOrders ? 'fa fa-arrow-down':'fa fa-arrow-up'\"></i>\n          </th>\n\n          <th class=\"bg-black-center text-black text-uppercase text-center\">Note</th>\n          <th class=\"bg-black-center text-black text-uppercase text-center\">Edit</th>\n        </tr>\n        </thead>\n        <tbody v-if=\"users.length\">\n        <tr v-for=\"(index,user) in users\" :key=\"index\">\n          <td class=\"text-left text-capitalize\">\n            <span class=\"text-black text-{{user.status.split(' ').join('-')}}\">{{ user.status.charAt(0) }}</span>\n          </td>\n          <td class=\"text-center\">\n            {{\n            user.hire_date | customDateFormat\n            'YYYY-MM-DD h:m:s'\n            'MM/DD/YYYY'\n            }}\n          </td>\n          <td class=\"text-center\">\n            <span v-if=\"user.primary_phone != '000-000-0000'\"> {{ user.primary_phone }}</span>\n          </td>\n          <td class=\"text-left font-weight-600\" v-bind:class=\"[ (user.status == 'Quit' &amp;&amp; (user.app_access =='Yes' || user.app_access =='Hold')) ? 'bg-pink-custom':'', (user.status == 'Terminated' &amp;&amp; (user.app_access =='Yes')) ? 'bg-pink-custom':'']\">{{ user.name }}\n          </td>\n          <td class=\"text-left\">{{ user.email }}</td>\n          <td :class=\"'text-app-access-'+(user.app_access?'yes':'no')\" class=\"text-center\">{{ user.app_access ? 'Yes' : 'No' }}\n          </td>\n          <td class=\"text-center\">\n              <span v-if=\"user.last_app_activity != '00/00/0000 00:00:00'\" class=\"\">{{ user.last_app_activity }}</span>\n          </td>\n          <td class=\"text-center text-black font-weight-bold\">{{ user.jo_thirty_count }} / <span :class=\"{ 'text-primary':user.confirmed_thirty_count, 'text-grey': !user.confirmed_thirty_count  }\">{{\n              user.confirmed_thirty_count\n            }}</span>\n          </td>\n          <td class=\"text-center text-black font-weight-bold\">\n            <span v-if=\"user.worked_one_year_count > 0\">{{ user.worked_one_year_count }}</span>\n            <span v-if=\"user.worked_one_year_count > 0 || user.no_show_one_year_count > 0\"> - </span>\n            <span v-if=\"user.no_show_one_year_count > 0\" :class=\"{ 'text-danger':user.no_show_one_year_count > 0,  }\">{{ user.no_show_one_year_count }}</span>\n          </td>\n          <td class=\"text-center\">\n            <span :data-content=\"allNotes(user)\" class=\"cursor-pointer text-black text-primary\" data-html=\"true\" data-placement=\"bottom\" data-popup=\"popover\" data-title=\"\" data-trigger=\"hover\" @click=\"showNoteModal(user)\">Note</span>\n          </td>\n          <td class=\"text-center\">\n              <span class=\"text-black text-indigo-600 cursor-pointer text-italic\" @click=\"editEmployeeModal(user)\">Edit</span>\n\n            <span class=\"text-black text-indigo-600 cursor-pointer text-italic pl-10\" @click=\"employeeImageModal(user)\">Image</span>\n          </td>\n        </tr>\n        </tbody>\n        <tbody v-else=\"\">\n        <tr>\n          <td class=\"text-left text-capitalize\"></td>\n          <td class=\"text-center\"></td>\n          <td class=\"text-center\"></td>\n          <td class=\"text-left\"></td>\n          <td class=\"text-left\"></td>\n          <td class=\"text-center\"></td>\n          <td class=\"text-center\"></td>\n          <td></td>\n          <td class=\"text-center text-black\">\n            <button class=\"btn btn-primary\" @click=\"showAddUserModal()\"> Add New</button>\n          </td>\n        </tr>\n        </tbody>\n      </table>\n    </div>\n\n\n    <div id=\"comment-modal\" aria-hidden=\"true\" aria-labelledby=\"exampleModalLabel\" class=\"modal fade\" role=\"dialog\" tabindex=\"-1\">\n      <div class=\"modal-dialog\" role=\"document\">\n        <div class=\"modal-content modal-grey\">\n          <div class=\"modal-header pl-10\">\n            <button aria-label=\"Close\" class=\"close close-modal\" data-dismiss=\"modal\" type=\"button\">\n              <span aria-hidden=\"true\">×</span>\n            </button>\n          </div>\n          <div class=\"modal-body no-padding-left no-padding-right\">\n\n            <div class=\"col-md-12 col-sm-12 col-xs-12\">\n              <div v-for=\"log in employee.latest_notes\">\n                <li>\n                  {{ log.date }} {{ log.user.name }} <span v-if=\"log.note\"> - {{ log.note }}</span>\n                </li>\n              </div>\n            </div>\n\n            <div class=\"col-md-12 col-sm-12 col-xs-12 p-40\">\n              <textarea id=\"\" v-model=\"note\" class=\"form-control\" cols=\"30\" name=\"\" rows=\"6\"></textarea>\n            </div>\n\n            <div class=\"col-md-12 col-sm-12 col-xs-12 pt-10 text-right\">\n              <button class=\"btn btn-primary text-black p-5 no-padding-left border-white pl-10 pr-10\" @click=\"updateStatus\">Save\n              </button>\n            </div>\n\n          </div>\n          <div class=\"modal-footer\">\n            <!--            <button class=\"btn btn-secondary\" data-dismiss=\"modal\" type=\"button\">Close</button>-->\n            <!--            <button class=\"btn btn-primary\" type=\"button\">Save changes</button>-->\n          </div>\n        </div>\n      </div>\n    </div>\n\n\n    <div id=\"modal-edit-employee-info\" class=\"modal fade\">\n      <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n          <div class=\"modal-header\">\n            <button aria-hidden=\"true\" class=\"close\" data-dismiss=\"modal\" type=\"button\">Close</button>\n          </div>\n          <div class=\"modal-body\">\n            <form action=\"#\">\n              <div class=\"col-md-12\">\n                <div class=\"panel panel-flat\">\n                  <div class=\"panel-body\">\n                    <fieldset>\n                      <legend class=\"text-semibold font-20 text-primary\">\n                        {{ employee.name }}\n                        <span class=\"pull-right text-color-black\">{{ employee.ss }}</span>\n                      </legend>\n                      <div class=\"row mb-20\">\n                        <div class=\"col-md-6\">\n                          <label>Email: <span class=\"text-danger\">*</span></label>\n                          <input v-model=\"employee.email\" class=\"form-control\" required=\"\" type=\"text\">\n                        </div>\n                        <div class=\"col-md-6\">\n                          <label>Hire Date:</label>\n                          <br>\n                          <span>\n                            {{\n                              employee.hire_date | customDateFormat\n                                  'YYYY-MM-DD h:m:s'\n                                  'MM/DD/YYYY'\n                            }}\n                          </span>\n                        </div>\n                      </div>\n                      <div class=\"row mb-20\">\n                        <div class=\"col-md-6\">\n                          <label>Primary Phone: <span class=\"text-danger\">*</span></label>\n                          <input v-model=\"employee.primary_phone\" class=\"form-control format-phone-dash\" required=\"\" type=\"text\">\n                        </div>\n                        <div class=\"col-md-6\">\n                          <label>Secondary Phone:</label>\n                          <input v-model=\"employee.secondary_phone\" class=\"form-control format-phone-dash\" type=\"text\">\n                        </div>\n                      </div>\n                      <div class=\"row mb-20\">\n                        <div class=\"col-md-6\">\n                          <span class=\"checkboxes\">\n                            <label>\n                              <input v-model=\"employee.app_access\" type=\"checkbox\" value=\"1\"> App Access\n                            </label>\n                          </span>\n                        </div>\n                      </div>\n                    </fieldset>\n                  </div>\n                </div>\n              </div>\n            </form>\n          </div>\n\n          <div class=\"modal-footer\">\n            <button v-submit=\"state\" :disabled=\"!activeEmail\" class=\"btn mr-10\" type=\"submit\" v-bind:class=\"{ 'btn-grey': !activeEmail, 'btn-primary': activeEmail }\" v-on:click.prevent=\"sendInvitation\">Send Invitation <i class=\"icon-arrow-right14 position-right\"></i></button>\n\n            <button v-submit=\"state\" :disabled=\"!updated\" class=\"btn mr-10\" type=\"submit\" v-bind:class=\"{ 'btn-grey': !updated, 'btn-primary': updated }\" v-on:click.prevent=\"editEmployee\">Save\n            </button>\n          </div>\n        </div>\n      </div>\n    </div>\n\n\n    <div id=\"modal-add-employee-info\" class=\"modal fade\">\n      <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n          <div class=\"modal-header\">\n            <button aria-hidden=\"true\" class=\"close\" data-dismiss=\"modal\" type=\"button\">Close</button>\n          </div>\n          <div class=\"modal-body\">\n            <form action=\"#\">\n              <div class=\"col-md-12\">\n                <div class=\"panel panel-flat\">\n                  <div class=\"panel-body\">\n                    <fieldset>\n                      <legend class=\"text-semibold font-20 text-primary\">Add New Employee\n                      </legend>\n                      <div class=\"row mb-20\">\n                        <div class=\"col-md-4\">\n                          <label>First Name:</label>\n                          <input v-model=\"newEmployee.first_name\" class=\"form-control\" type=\"text\">\n                        </div>\n                        <div class=\"col-md-4\">\n                          <label>Middle Name:</label>\n                          <input v-model=\"newEmployee.middle_name\" class=\"form-control\" type=\"text\">\n                        </div>\n                        <div class=\"col-md-4\">\n                          <label>Last Name:</label>\n                          <input v-model=\"newEmployee.last_name\" class=\"form-control\" type=\"text\">\n                        </div>\n                      </div>\n                      <div class=\"row mb-20\">\n                        <div class=\"col-md-6\">\n                          <label>Email: </label>\n                          <input v-model=\"newEmployee.email\" class=\"form-control\" type=\"text\">\n                        </div>\n                        <div class=\"col-md-6\">\n                          <br>\n                          <br>\n                          <span class=\"checkboxes\">\n                            <label>\n                              <input v-model=\"newEmployee.app_access\" type=\"checkbox\" value=\"Yes\"> App Access\n                            </label>\n                          </span>\n                        </div>\n                      </div>\n                      <div class=\"row mb-20\">\n                        <div class=\"col-md-6\">\n                          <label>Primary Phone:</label>\n                          <input v-model=\"newEmployee.primary_phone\" class=\"form-control format-phone-dash\" type=\"text\">\n                        </div>\n                        <div class=\"col-md-6\">\n                          <label>Secondary Phone:</label>\n                          <input v-model=\"newEmployee.secondary_phone\" class=\"form-control format-phone-dash\" type=\"text\">\n                        </div>\n                      </div>\n\n                      <div class=\"row mb-20\">\n                        <div class=\"col-md-6\">\n                          <label>Social Security:</label>\n                          <input v-model=\"newEmployee.social_security\" class=\"form-control format-ss\" type=\"password\">\n                        </div>\n                        <div class=\"col-md-6\">\n                          <label>Confirm Social Security:</label>\n                          <input v-model=\"newEmployee.social_security_confirmation\" class=\"form-control format-ss\" :disabled=\"!isDisabled\" type=\"text\">\n                        </div>\n                      </div>\n\n\n                    </fieldset>\n                  </div>\n                </div>\n              </div>\n            </form>\n          </div>\n\n          <div class=\"modal-footer\">\n            <button v-submit=\"state\" class=\"btn btn-primary mr-10\" type=\"submit\" v-on:click.prevent=\"addEmployee\">Save\n            </button>\n\n            <!--            <button class=\"btn btn-primary mr-10\" data-dismiss=\"modal\" type=\"button\"-->\n            <!--            >Cancel <i-->\n            <!--                class=\"icon-close2 position-right\"></i></button>-->\n          </div>\n        </div>\n      </div>\n    </div>\n\n\n    <div id=\"update-user-data\" class=\"modal fade\">\n      <div class=\"modal-dialog modal-lg\">\n        <div class=\"modal-content\">\n          <div class=\"modal-header bg-slate-600\">\n            <button aria-hidden=\"true\" class=\"close text-black text-color-black\" data-dismiss=\"modal\" type=\"button\">×\n            </button>\n            <h4 class=\"modal-title text-center\">{{ activeUser.name }}</h4>\n          </div>\n          <div class=\"modal-body no-padding\">\n            <div class=\"row\">\n              <div class=\"table-responsive\">\n                <div class=\"col-md-12\">\n                  <div class=\"col-md-6 p-5 bg-slate-300 text-center\">STATUS</div>\n                  <div class=\"col-md-6 p-5\">{{ activeUser.status }}</div>\n                </div>\n\n                <div class=\"col-md-12\">\n                  <div class=\"col-md-6 p-5 bg-slate-300 text-center\">HIRE DATE</div>\n                  <div class=\"col-md-6 p-5\">\n                    {{\n                    activeUser.hire_date | customDateFormat\n                    'YYYY-MM-DD h:m:s'\n                    'MM/DD/YYYY'\n                    }}\n                  </div>\n                </div>\n\n                <div class=\"col-md-12\">\n                  <div class=\"col-md-6 p-5 bg-slate-300 text-center\">END DATE</div>\n                  <div class=\"col-md-6 p-5\">{{ activeUser.end_date }}</div>\n                </div>\n\n                <div class=\"col-md-12\">\n                  <div class=\"col-md-6 p-5 bg-slate-300 text-center\">PHONE 1</div>\n                  <div class=\"col-md-6 p-5\">{{ activeUser.primary_phone }}</div>\n                </div>\n\n                <div class=\"col-md-12\">\n                  <div class=\"col-md-6 p-5 bg-slate-300 text-center\">PHONE 2</div>\n                  <div class=\"col-md-6 p-5\">{{ activeUser.secondary_phone }}</div>\n                </div>\n              </div>\n            </div>\n            <div class=\"row no-padding-right\">\n              <div class=\"col-md-2 no-padding-right\">\n                <div class=\"col-md-12 text-center text-black bg-black-center pt-20 pb-20 text-uppercase\">User Access\n                </div>\n                <div class=\"col-md-12 text-center text-black mt-20\">\n                  <span :class=\"'text-app-access-'+activeUser.app_access.toLowerCase()\" class=\"text-center font-30\">{{ activeUser.app_access }}</span>\n                </div>\n              </div>\n              <div class=\"col-md-10 col-md-10-custom bg-black\">\n                <div class=\"col-md-3 mb-10 mt-5 text-right pt-20\">\n                  <label class=\"text-black\" for=\"email\">Email</label>\n                </div>\n                <div class=\"col-md-8 mb-5 mt-5 pt-20\">\n                  <input v-model=\"activeUser.email\" class=\"form-control input-sm\" type=\"text\">\n                </div>\n                <div class=\"col-md-3 mb-5 mt-5 pt-20 text-right\">\n                  <label class=\"text-black\" for=\"password\">Password</label>\n                </div>\n                <div class=\"col-md-8 mb-5 mt-5 pt-20\">\n                  <input v-model=\"activeUser.password\" class=\"form-control input-sm\" type=\"text\">\n                </div>\n                <div class=\"col-md-3 mb-5 mt-5 pt-20 text-right\">\n                  <label class=\"text-black\" for=\"pin\">Pin</label>\n                </div>\n                <div class=\"col-md-8 mb-5 mt-5 pt-20\">\n                  <input v-model=\"activeUser.pin\" class=\"form-control input-sm\" type=\"text\">\n                </div>\n              </div>\n            </div>\n            <div class=\"p-20 bg-black text-right\">\n              <button class=\"btn bg-blue-300 text-black mr-80\" type=\"button\" @click=\"updateUserAccessData\">Update\n              </button>\n            </div>\n          </div>\n        </div>\n      </div>\n      <!--<div class=\"modal-footer\">-->\n      <!--<button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button>-->\n      <!--<button type=\"button\" class=\"btn btn-primary\">Save changes</button>-->\n      <!--</div>-->\n    </div>\n    <!-- /.modal-content -->\n\n\n    <div class=\"modal fade\" id=\"employee_image\">\n      <div class=\"modal-dialog modal-medium\">\n        <div class=\"modal-content\">\n          <div class=\"modal-header\">\n            <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\">Cancel</button>\n            <h6 class=\"text-left text-black\">Upload Image For {{\n              employee.name\n              }}</h6>\n          </div>\n          <div class=\"modal-body border-top border-grey-300\">\n            <div class=\"col-md-12\">\n\n              <div class=\"col-md-6\">\n                <h2>Selected Image</h2>\n                <div id=\"ci\" class=\"image-previewer\" data-cropzee=\"cropzee-input\"></div>\n                <input id=\"cropzee-input\" class=\"form-control mt-10\" type=\"file\" accept=\"image/*\">\n              </div>\n              <div class=\"col-md-6\">\n                <h2>Current Image</h2>\n                <img :src=\"employeeProfileLink(employee)\" width=\"400\">\n              </div>\n\n            </div>\n          </div>\n          <div class=\"modal-footer\">\n\n            <button type=\"button\" @click.prevent=\"uploadImage()\" class=\"btn btn-primary mt-15\">Upload Image\n              <i class=\"icon-arrow-right14 position-right\"></i>\n            </button>\n\n            <button type=\"button\" @click.prevent=\"deleteImage()\" class=\"btn btn-danger mt-15 ml-15\">Delete Image\n              <i class=\"icon-cross position-right\"></i>\n            </button>\n          </div>\n        </div>\n      </div>\n    </div>\n\n  </div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  var id = "/home/shoieb/sites/elegant/resources/assets/js/vue/components/user-access.vue"
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, module.exports.template)
  }
})()}
},{"./../../mixed/modals":10,"./../../mixed/notify":11,"vue":5,"vue-hot-reload-api":4}],95:[function(require,module,exports){
var __vueify_style__ = require("vueify-insert-css").insert("\n")
"use strict";

exports.__esModule = true;
var modals = require("./../../mixed/modals");
var notify = require("./../../mixed/notify");

exports["default"] = {
  data: function data() {
    return {
      state: false,
      employees: {},
      clients: {},
      allEmployees: {},
      client_id: "",
      employee_id: "",
      start_date: "",
      end_date: "",
      action: 0,
      activeEmployee: {}
    };
  },
  filters: {},
  watch: {
    clients: function clients() {
      // $("#position-client").selectric("refresh");
    },
    client_id: function client_id() {
      this.getWorkedEmployees();
    },
    employee_id: function employee_id() {
      this.getWorkedEmployees();
    },
    start_date: function start_date() {
      this.getWorkedEmployees();
    },
    end_date: function end_date() {
      this.getWorkedEmployees();
    }
  },
  ready: function ready() {
    this.getWorkedEmployees();
    this.getClientList();
    this.getEmployeeList();
  },
  events: {},
  methods: {
    getClientList: function getClientList() {
      var _this = this;

      this.$http.get("/api/order-data", "", function (response) {
        _this.clients = response;
      }).always(function () {});
    },

    getEmployeeList: function getEmployeeList() {
      var _this2 = this;

      this.$http.get("/api/worked-employee-list-data", "", function (response) {
        _this2.allEmployees = response;
      }).always(function () {});
    },

    /**
     * get employee report data
     */
    getWorkedEmployees: function getWorkedEmployees() {
      var _this3 = this;

      notify.loading(true);
      this.$http.get("/api/worked-employees?start_date=" + this.start_date + "&end_date=" + this.end_date + "&client_id=" + this.client_id + "&employee_id=" + this.employee_id, function (response) {
        _this3.employees = response;
      }).always(function () {
        notify.loading(false);
      });
    },

    /**
     * move worked employees back to no-show status
     */
    moveToNoShow: function moveToNoShow() {
      var _this4 = this;

      notify.loading(true);
      this.$http.get("/api/move-to-no-show/" + this.activeEmployee.id + "/" + this.action, function (response) {
        _this4.getWorkedEmployees();
        modals.hide("#undo-modal");
      }).always(function () {
        notify.loading(false);
      });
    },

    showUndoModal: function showUndoModal(employee) {
      this.action = 0;
      this.activeEmployee = employee;
      modals.showStrict("#undo-modal");
    }
  }
};
module.exports = exports["default"];
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n  <div class=\"row\">\n    <div class=\"col-md-7 no-padding\">\n      <h4 class=\"bg-indigo text-black text-center no-padding no-margin\">WORKED</h4>\n    </div>\n    <div class=\"col-md-7 no-padding-top no-padding-bottom bg-indigo-300\">\n      <div class=\"col-md-6\">\n        <div class=\"form-group\">\n          <label>Select Client</label>\n          <select class=\"form-control\" name=\"\" id=\"position-client\" v-select2=\"client_id\" v-model=\"client_id\">\n            <option value=\"\">Show All</option>\n            <option v-for=\"(index,client) in clients\" :key=\"index\" :value=\"client.id\">{{ client.name }}</option>\n          </select>\n        </div>\n      </div>\n      <div class=\"col-md-6\">\n        <div class=\"form-group pl-10\">\n          <label for=\"start_date\">Start Date</label>\n          <input type=\"text\" class=\"form-control pickadate-year text-black\" v-model=\"start_date\" id=\"start_date\">\n        </div>\n      </div>\n    </div>\n    <div class=\"col-md-7 no-padding-top no-padding-bottom bg-indigo-300\">\n      <div class=\"col-md-6\">\n        <div class=\"form-group\">\n          <label>Select Employee</label>\n          <select class=\"form-control\" name=\"\" id=\"employee-list\" v-select2=\"employee_id\" v-model=\"employee_id\">\n            <option value=\"\">Show All</option>\n            <option v-for=\"(index,employee) in allEmployees\" :key=\"index\" :value=\"employee.id\">{{ employee.fullName }}</option>\n          </select>\n        </div>\n      </div>\n      <div class=\"col-md-6\">\n        <div class=\"form-group pl-10\">\n          <label for=\"end_date\">End Date</label>\n          <input type=\"text\" class=\"form-control pickadate-year text-black\" v-model=\"end_date\" id=\"end_date\">\n        </div>\n      </div>\n    </div>\n    <div class=\"col-md-7 no-padding\">\n      <table class=\"table table-xxs table-bordered\">\n        <thead>\n          <tr>\n            <!--<th class=\"bg-indigo-400 text-black text-center\" colspan=\"2\">Employees</th>-->\n            <th class=\"bg-black-center text-black text-center text-uppercase\">Employee</th>\n            <th class=\"bg-black-center text-black text-center text-uppercase\">Date</th>\n            <th class=\"bg-black-center text-black text-center text-uppercase\">Job</th>\n            <th class=\"bg-black-center text-black text-center text-uppercase\">Undo</th>\n          </tr>\n        </thead>\n        <tbody v-for=\"(index,employee) in employees\" :key=\"index\">\n          <!--<tr class=\"bg-slate-300\">-->\n          <!--<td class=\"text-center\" colspan=\"4\">-->\n          <!--{{ employee[0].date| customDateFormat 'YYYY-MM-DD' 'dddd DD/MM/YY'}} {{-->\n          <!--employee[0].company_code+' '+employee[0].title }}-->\n          <!--</td>-->\n          <!--</tr>-->\n          <tr v-for=\"(ind,emp) in employee\" :key=\"ind\">\n            <td class=\"text-center\">{{ emp.first_name+' '+emp.last_name }}</td>\n            <td class=\"text-center\">{{ emp.date }}</td>\n            <td class=\"text-center\">{{ emp.company_code+' '+emp.title}}</td>\n            <td class=\"text-center\">\n              <button class=\"btn btn-info btn-xs p-2\" @click=\"showUndoModal(emp)\">Undo</button>\n            </td>\n          </tr>\n        </tbody>\n      </table>\n    </div>\n\n    <div class=\"modal fade\" id=\"undo-modal\">\n      <div class=\"modal-dialog modal-xs\">\n        <div class=\"modal-content bg-indigo-300\">\n          <div class=\"modal-header\">\n            <button type=\"button\" class=\"close text-black text-color-black\" data-dismiss=\"modal\" aria-hidden=\"true\">×</button>\n            <h4 class=\"modal-title\">Select An Action</h4>\n          </div>\n          <div class=\"modal-body bg-indigo-300\">\n            <div class=\"form-group\">\n              <div class=\"radio\">\n                <label class=\"text-color-black text-black\">\n                  <input type=\"radio\" value=\"1\" v-model=\"action\" name=\"undo\">Undo\n                </label>\n              </div>\n              <div class=\"radio\">\n                <label class=\"text-color-black text-black\">\n                  <input type=\"radio\" value=\"2\" v-model=\"action\" name=\"no-show\">No Show\n                </label>\n              </div>\n              <div class=\"radio\">\n                <label class=\"text-color-black text-black\">\n                  <input type=\"radio\" value=\"3\" v-model=\"action\" name=\"clear-record\">Clear\n                  Record\n                </label>\n              </div>\n            </div>\n            <div class=\"form-group text-right\">\n              <button type=\"button\" class=\"btn bg-green-300 text-black\" @click=\"moveToNoShow\">Submit</button>\n            </div>\n          </div>\n        </div>\n        <!--<div class=\"modal-footer\">-->\n        <!--<button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Close</button>-->\n        <!--<button type=\"button\" class=\"btn btn-primary\">Save changes</button>-->\n        <!--</div>-->\n      </div>\n      <!-- /.modal-content -->\n    </div>\n    <!-- /.modal-dialog -->\n  </div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  var id = "/home/shoieb/sites/elegant/resources/assets/js/vue/components/worked-employees.vue"
  module.hot.dispose(function () {
    require("vueify-insert-css").cache["\n"] = false
    document.head.removeChild(__vueify_style__)
  })
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, module.exports.template)
  }
})()}
},{"./../../mixed/modals":10,"./../../mixed/notify":11,"vue":5,"vue-hot-reload-api":4,"vueify-insert-css":6}],96:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});
exports['default'] = {
    'auth/login': require('./controllers/auth/login'),
    'users/user-controller': require('./controllers/users/user-controller'),
    'jobs/job-controller': require('./controllers/jobs/job-controller'),
    'employee/employee-controller': require('./controllers/employee/employee-controller'),
    'clients/client-controller': require('./controllers/client/client-controller'),
    'contacts/contact-controller': require('./controllers/client/contact-controller'),
    'departments/department-controller': require('./controllers/client/department-controller'),
    'admin/uniforms': require('./controllers/admin/uniform'),
    'admin/tools': require('./controllers/admin/tools'),
    'admin/skills': require('./controllers/admin/skills'),
    'admin/zips': require('./controllers/admin/zips'),
    'admin/cities': require('./controllers/admin/cities'),
    'admin/zones': require('./controllers/admin/zones'),
    'admin/client-groups': require('./controllers/admin/client-groups'),
    'positions/positions-controller': require('./controllers/positions/positions-controller'),
    'admin/permission': require('./controllers/admin/permission'),
    'users/change-password': require('./controllers/users/change-password'),
    'admin/roles': require('./controllers/admin/roles'),
    'admin/order': require('./controllers/admin/order'),
    'admin/dashboard': require('./controllers/admin/dashboard'),
    'admin/action-board': require('./controllers/admin/action-board2'),
    'admin/action-board-log': require('./controllers/admin/action-board-log'),
    'admin/system-messages': require('./controllers/admin/system-messages'),
    'admin/timer': require('./controllers/admin/timer'),
    'admin/action-board-settings': require('./controllers/admin/action-board-settings'),
    'admin/system-settings': require('./controllers/admin/system-settings'),
    'admin/default-rules': require('./controllers/client/components/schedules'),
    'admin/select-employees': require('./controllers/admin/select-employees'),
    'admin/devices': require('./controllers/admin/devices'),
    'admin/accounting-controller': require('./controllers/admin/accounting-controller'),
    'admin/employee-report': require('./controllers/admin/employee-report'),
    'admin/no-job-offer-log': require('./controllers/admin/no-job-offer-log'),
    'admin/re-confirmed-employees': require('./controllers/admin/re-confirmed-employees'),
    'admin/request-logger': require('./controllers/admin/request-logger'),
    'admin/schedule-rule-report': require('./controllers/admin/schedule-rule-report'),
    'admin/no-show-verification': require('./controllers/admin/no-show-verification'),
    'admin/no-response-log': require('./controllers/admin/no-respponse-log'),
    'admin/invoice-controller': require('./controllers/admin/invoice-controller'),
    'admin/view-invoice': require('./controllers/admin/view-invoice'),
    'admin/user-access': require('./controllers/admin/user-access'),
    'admin/ab-call-log': require('./controllers/admin/ab-call-log'),
    'admin/missing-employees': require('./controllers/admin/missing-employees'),
    'admin/employee-status-log-report': require('./controllers/admin/employee-status-log-report'),
    'admin/call-out-log': require('./controllers/admin/call-out-log'),
    'admin/active-employee-list': require('./controllers/admin/active-employee-list'),
    'admin/common': require('./controllers/admin/common')
};
module.exports = exports['default'];

},{"./controllers/admin/ab-call-log":97,"./controllers/admin/accounting-controller":98,"./controllers/admin/action-board-log":99,"./controllers/admin/action-board-settings":100,"./controllers/admin/action-board2":101,"./controllers/admin/active-employee-list":102,"./controllers/admin/call-out-log":103,"./controllers/admin/cities":104,"./controllers/admin/client-groups":105,"./controllers/admin/common":106,"./controllers/admin/dashboard":107,"./controllers/admin/devices":108,"./controllers/admin/employee-report":110,"./controllers/admin/employee-status-log-report":111,"./controllers/admin/invoice-controller":112,"./controllers/admin/missing-employees":113,"./controllers/admin/no-job-offer-log":114,"./controllers/admin/no-respponse-log":115,"./controllers/admin/no-show-verification":116,"./controllers/admin/order":117,"./controllers/admin/permission":118,"./controllers/admin/re-confirmed-employees":119,"./controllers/admin/request-logger":120,"./controllers/admin/roles":121,"./controllers/admin/schedule-rule-report":122,"./controllers/admin/select-employees":123,"./controllers/admin/skills":124,"./controllers/admin/system-messages":125,"./controllers/admin/system-settings":126,"./controllers/admin/timer":127,"./controllers/admin/tools":128,"./controllers/admin/uniform":129,"./controllers/admin/user-access":130,"./controllers/admin/view-invoice":131,"./controllers/admin/zips":132,"./controllers/admin/zones":133,"./controllers/auth/login":134,"./controllers/client/client-controller":135,"./controllers/client/components/schedules":137,"./controllers/client/contact-controller":138,"./controllers/client/department-controller":139,"./controllers/employee/employee-controller":140,"./controllers/jobs/job-controller":141,"./controllers/positions/positions-controller":142,"./controllers/users/change-password":143,"./controllers/users/user-controller":144}],97:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});
var notify = require('../../../mixed/notify');
var modals = require('../../../mixed/modals');
exports['default'] = Vue.extend({
    filters: {
        momentTime: function momentTime(time) {
            return moment(time, "YYYY-MM-DD HH:mm:ss").format('h:m a');
        },

        timeEarly: function timeEarly(time, early) {
            return moment(time, "YYYY-MM-DD HH:mm:ss").subtract(early, 'minutes').format('h:m a');
        },

        momentDate: function momentDate(date) {
            return moment(date, "YYYY-MM-DD").format('MM  DD');
        },

        momentMonthDay: function momentMonthDay(date) {
            return moment(date, "YYYY-MM-DD").format('MMM  D');
        },

        parseDate: function parseDate(date) {
            return moment(date, "YYYY-MM-DD").format('dddd, MM DD');
        },

        parseDateEmployeeOrder: function parseDateEmployeeOrder(date) {
            return moment(date, "YYYY-MM-DD").format('dddd, MMMM DD');
        },

        parseNumber: function parseNumber(val) {
            return parseFloat(Math.round(val * 100) / 100).toFixed(2);
        },

        momentDay: function momentDay(date) {
            return moment(date, "YYYY-MM-DD").format('ddd');
        },

        momentDateTime: function momentDateTime(dateTime) {
            return moment(dateTime, "YYYY-MM-DD HH:mm:ss").format('YYYY-MM-DD hh:mm a');
        },

        parseTime: function parseTime(dateTime) {
            return moment(dateTime, "YYYY-MM-DD HH:mm:ss").format('h:m a');
        },

        filterPhone: function filterPhone(phone) {
            if (phone) {
                return phone.replace(/\s+/g, '');
            }
        },

        parseStatus: function parseStatus(status) {
            return status.split('-').join(' ');
        },

        cap: function cap(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        },

        removeQuote: function removeQuote(string) {
            return string.replace(/'/g, '');
        }

    },
    data: function data() {
        return {
            showStatus: 1,
            state: false,
            localEmployee: {},
            employeeOrders: {},
            activeEmployee: {},
            previousWeek: 0,
            app: app,
            activeNotes: {},
            response: [],
            employeeOrder: {},
            activeOrder: 0,
            activeDate: '',
            moveStatus: 0,
            state: false,
            startDate: '',
            date: '',
            weekDates: [],
            statuses: {
                'contact': 'CONTACT',
                'confirm': 'CONFIRM',
                're-confirm': 'RE-CONFIRM',
                // 'need-change': 'NEED-CHANGE',
                // 'did-not-re-confirm': 'D.N.Rc',
                "cant-work-time": "CAN NOT",
                // "cant-work-job": "CAN'T(this job)",
                'delete': 'DELETE'
            },
            previousRecordStartDate: '',
            pendingDashboardOperations: 0,
            employeeAdditionalStatus: null,
            currentTime: null
        };
    },

    events: {},

    ready: function ready() {
        var _this = this;

        window.bus.$on("showEmployeeRecords", function (val) {
            _this.setEmployee(val);
        });

        $('#employee-order-records').on('hidden.bs.modal', function () {
            _this.employeeOrders = {};
            _this.app = 0;
            _this.resetValues();
        });
    },

    methods: {
        showTime: function showTime() {
            this.currentTime = moment.utc().utcOffset("-0400").format("hh:mm A");
            setTimeout(this.showTime, 1000);
        },

        setEmployee: function setEmployee(val) {
            var localEmployee = {};
            if (val && val !== '0') {
                localEmployee.pivot = {};
                localEmployee.pivot.employee_id = parseInt(val);
                localEmployee.id = parseInt(val);
                this.employeeOrderRecords(localEmployee, null, '', true, false);
            }
        },

        /**
        * show employee records
        * @param employee
        * @param orderId
        * @param orderDate
        * @param showModal
        * @param previousWeek
        */
        employeeOrderRecords: function employeeOrderRecords(employee, orderId) {
            var orderDate = arguments.length <= 2 || arguments[2] === undefined ? '' : arguments[2];

            var _this2 = this;

            var showModal = arguments.length <= 3 || arguments[3] === undefined ? true : arguments[3];
            var previousWeek = arguments.length <= 4 || arguments[4] === undefined ? false : arguments[4];

            notify.loading(true);
            this.previousWeek = previousWeek ? 1 : 0;
            this.activeEmployee = _.cloneDeep(employee);
            var employeeId = employee.pivot ? employee.pivot.employee_id : this.activeEmployee.id;
            this.$http.get('/api/employee-order-records/' + employeeId + '?previous_week=' + this.previousWeek + '&startDate=' + Cookies.get('startDate'), '', function (response) {
                _this2.employeeOrders = _.groupBy(_.cloneDeep(response.orders), 'day');
                _this2.app = response.app;
                if (orderId) {
                    var activeOrder = _.find(response.orders[orderDate].data, {
                        order_id: orderId
                    });
                    _this2.setEmployeeOrder(activeOrder, moment(activeOrder.order.date, "YYYY-MM-DD").format('MMM DD'));
                    _this2.setActiveDate(orderDate, false);
                }
                _this2.activeEmployee = response.employee;
                _this2.activeNotes = _.groupBy(response.employee.notes, 'category');
                _this2.response = [];
                if (showModal) {
                    modals.showStrict("#employee-order-records");
                    // $('#employee-list').prop('selectedIndex', 0).selectric('refresh');
                }
            }).always(function () {
                notify.loading(false);
            });
        },

        /**
        * set an order as active for employee orders
        * @param employeeOrder
        * @param date
        */
        setEmployeeOrder: function setEmployeeOrder(employeeOrder, date) {
            employeeOrder.status === 'move' ? this.showStatus = 0 : this.showStatus = 1;
            this.activeOrder = employeeOrder.order_id;
            this.employeeOrder = _.cloneDeep(employeeOrder);
            if (this.employeeOrder.order.uniforms.length > 0) {
                this.employeeOrder.uniforms = _.map(this.employeeOrder.order.uniforms, 'uniform');
            } else {
                if (this.employeeOrder.order.positions) this.employeeOrder.uniforms = _.map(this.employeeOrder.order.positions.uniforms, 'title');else {
                    this.employeeOrder.uniforms = [];
                }
            }
            this.activeDate = moment(this.employeeOrder.order.date, "YYYY-MM-DD").format('MMM DD');
            this.setActiveDate(date, false);
        },

        /**
         * set a date as active on employee order calender
         * @param string
         */
        setActiveDate: function setActiveDate(string) {
            var status = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];

            this.activeDate = string;
            if (status) {
                this.employeeOrder = false;
                this.activeOrder = '';
            }
        },

        /**
        * confirm process move
        * @param status
        */
        confirmProcessMove: function confirmProcessMove(status, type) {
            this.moveStatus = status;
            notify.prompt('Are you sure you want to ' + type + ' this move?', '', this.processMove);
        },

        /**
         * process move for an employee(accept/deny)
         */
        processMove: function processMove() {
            var _this3 = this;

            notify.loading(true);
            var data = {
                'employeeOrder': this.employeeOrder,
                'status': this.moveStatus
            };

            this.$http.post('/api/process-move', data, function (response) {
                notify.success('Operation Successful');
                _this3.employeeOrderRecords(_this3.activeEmployee);
                _this3.resetValues();
                _this3.getOrders();
                _this3.currentOrder = response;
            }).always(function () {
                notify.loading(false);
            });
        },

        /**
        * show modal for additional status
        */
        showAdditionalStatus: function showAdditionalStatus() {
            this.employeeAdditionalStatus = null;
            modals.showStrict("#employee-additional-status-modal");
        },

        /**
         * submit additional status
         */
        submitAdditionalStatus: function submitAdditionalStatus() {
            this.employeeOrder.status = this.employeeAdditionalStatus;
            this.updateEmployeeOrderStatus();
        },

        showAddiotnalEmployeeModal: function showAddiotnalEmployeeModal() {
            modals.showStrict("#additional-employees");
        },

        hideAdditionalEmployeeModal: function hideAdditionalEmployeeModal() {
            modals.hide("#additional-employees");
        },

        resetValues: function resetValues() {
            this.employeeOrder = false;
            this.activeDate = '';
            this.activeOrder = '';
        },

        /**
        * update status for an employee of an order
        */
        updateEmployeeOrderStatus: function updateEmployeeOrderStatus() {
            var _this4 = this;

            modals.hide("#employee-additional-status-modal");
            notify.loading(true);
            if (this.employeeOrder) {
                (function () {
                    var orderId = _this4.employeeOrder.order_id;
                    var orderDate = _this4.employeeOrder.date;
                    _this4.$http.post('/api/employee-order-status-update/' + _this4.employeeOrder.employee_order_id, {
                        status: _this4.employeeOrder.status,
                        pay_rate: _this4.employeeOrder.pay_rate
                    }, function (response) {
                        _this4.resetValues();
                        _this4.currentOrder = response;
                        _this4.employeeOrderRecords(_this4.activeEmployee, orderId, orderDate);
                    }).always(function () {
                        notify.loading(false);
                    });
                })();
            } else {
                notify.loading(false);
                notify.info('Select an order first');
            }
        },

        /**
        * generic function for closing modals
        * @param modalId
        */
        closeModal: function closeModal(modalId) {
            modals.hide(modalId);
        },

        /**
         * save employee responses
         */
        saveResponse: function saveResponse() {
            var _this5 = this;

            notify.loading(true);
            var data = {
                employee_id: this.activeEmployee.id,
                order_id: this.activeOrder ? this.activeOrder : 0,
                responses: this.response
            };
            this.$http.post('/api/save-employee-response', data, function (response) {
                modals.hide("#no-answer");
                notify.success('Employee Response Saved');
                _this5.response = [];
            }).always(function () {
                notify.loading(false);
            });
        }

    }
});
module.exports = exports['default'];

},{"../../../mixed/modals":10,"../../../mixed/notify":11}],98:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});
var notify = require('./../../../mixed/notify');

exports['default'] = Vue.extend({
    data: function data() {
        return {
            state: false
        };
    },

    events: {
        refreshTabs: function refreshTabs() {
            window.bus.$emit('refreshData');
        }
    },

    ready: function ready() {},

    methods: {}
});
module.exports = exports['default'];

},{"./../../../mixed/notify":11}],99:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});
var notify = require('./../../../mixed/notify');
var modals = require('./../../../mixed/modals');

var tableColumns = [{
    name: 'user',
    title: 'User',
    callback: 'logUser'
}, {
    name: 'order',
    title: 'Order',
    callback: 'logOrder'
}, {
    name: 'type',
    title: 'Type',
    sortField: 'type',
    callback: 'logType'
}];

// create pagination component using bootstrap styling
Vue.component('vuetable-pagination-bootstrap', {
    template: '#vuetable-pagination-bootstrap-template',
    mixins: [paginationMixin],
    methods: {
        loadPage: function loadPage(page) {
            this.$dispatch('vuetable-pagination:change-page', page);
        }
    }
});

exports['default'] = Vue.extend({
    filters: {
        customFormat: function customFormat(date, from, format) {
            return moment(date, from).format(format);
        }

    },
    data: function data() {
        return {
            sendList: {},
            query: '',
            moreParams: [],
            perPage: 150,
            columns: tableColumns,
            sortOrder: {
                field: 'id',
                direction: 'asc'
            },
            paginationInfoTemplate: 'vuetable-pagination-bootstrap',
            state: false

        };
    },

    ready: function ready() {},

    methods: {
        logOrder: function logOrder(value) {
            return value.client.company_code + ' ' + value.no_of_employee + ' ' + value.position.title + ' - ' + value.date;
        },

        logUser: function logUser(value) {
            return "<span class='text-capitalize'>" + value.name + "</span>";
        },

        logType: function logType(value) {
            return "<span class='text-capitalize'>" + value + "</span>";
        }

    }
});
module.exports = exports['default'];

},{"./../../../mixed/modals":10,"./../../../mixed/notify":11}],100:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});
var notify = require('./../../../mixed/notify');
exports['default'] = Vue.extend({
    data: function data() {
        return {
            state: false,
            settings: {}
        };
    },

    events: {},

    ready: function ready() {
        this.actionBoardSettings();
    },

    methods: {
        actionBoardSettings: function actionBoardSettings() {
            var _this = this;

            this.$http.get('/api/action-board-settings', '', function (response) {
                _this.settings = response;
            }).always(function () {});
        },

        capitalize: function capitalize(str) {
            return str.replace(/-/g, ' ');
        },

        saveActionBoardSettings: function saveActionBoardSettings() {
            var _this2 = this;

            notify.loading(true);
            this.$http.post('/api/action-board-settings', { settings: this.settings }, function (response) {
                _this2.settings = response;
            }).always(function () {
                notify.loading(false);
            });
        }
    }
});
module.exports = exports['default'];

},{"./../../../mixed/notify":11}],101:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _componentsTextNewJobVue = require('./../../components/text-new-job.vue');

var _componentsTextNewJobVue2 = _interopRequireDefault(_componentsTextNewJobVue);

var _componentsTextClientRequestVue = require('./../../components/text-client-request.vue');

var _componentsTextClientRequestVue2 = _interopRequireDefault(_componentsTextClientRequestVue);

var _componentsTextReconfirmationJobVue = require('./../../components/text-reconfirmation-job.vue');

var _componentsTextReconfirmationJobVue2 = _interopRequireDefault(_componentsTextReconfirmationJobVue);

var _componentsTextAssignmentDetailVue = require('./../../components/text-assignment-detail.vue');

var _componentsTextAssignmentDetailVue2 = _interopRequireDefault(_componentsTextAssignmentDetailVue);

var _componentsTextMoveVue = require('./../../components/text-move.vue');

var _componentsTextMoveVue2 = _interopRequireDefault(_componentsTextMoveVue);

var _componentsTextTimeChangeVue = require('./../../components/text-time-change.vue');

var _componentsTextTimeChangeVue2 = _interopRequireDefault(_componentsTextTimeChangeVue);

var _componentsTextTimeConflictVue = require('./../../components/text-time-conflict.vue');

var _componentsTextTimeConflictVue2 = _interopRequireDefault(_componentsTextTimeConflictVue);

var _componentsTextOtherChangesVue = require('./../../components/text-other-changes.vue');

var _componentsTextOtherChangesVue2 = _interopRequireDefault(_componentsTextOtherChangesVue);

var _componentsTextJobCancelVue = require('./../../components/text-job-cancel.vue');

var _componentsTextJobCancelVue2 = _interopRequireDefault(_componentsTextJobCancelVue);

var _componentsCallbNewJobVue = require('./../../components/callb-new-job.vue');

var _componentsCallbNewJobVue2 = _interopRequireDefault(_componentsCallbNewJobVue);

var _componentsCallbClientRequestVue = require('./../../components/callb-client-request.vue');

var _componentsCallbClientRequestVue2 = _interopRequireDefault(_componentsCallbClientRequestVue);

var _componentsCallbReconfirmationJobVue = require('./../../components/callb-reconfirmation-job.vue');

var _componentsCallbReconfirmationJobVue2 = _interopRequireDefault(_componentsCallbReconfirmationJobVue);

var _componentsCallbMoveVue = require('./../../components/callb-move.vue');

var _componentsCallbMoveVue2 = _interopRequireDefault(_componentsCallbMoveVue);

var _componentsCallbTimeChangeVue = require('./../../components/callb-time-change.vue');

var _componentsCallbTimeChangeVue2 = _interopRequireDefault(_componentsCallbTimeChangeVue);

var _componentsCallbTimeConflictVue = require('./../../components/callb-time-conflict.vue');

var _componentsCallbTimeConflictVue2 = _interopRequireDefault(_componentsCallbTimeConflictVue);

var _componentsCallbOtherChangesVue = require('./../../components/callb-other-changes.vue');

var _componentsCallbOtherChangesVue2 = _interopRequireDefault(_componentsCallbOtherChangesVue);

var _componentsCallbJobCancelVue = require('./../../components/callb-job-cancel.vue');

var _componentsCallbJobCancelVue2 = _interopRequireDefault(_componentsCallbJobCancelVue);

var _componentsCallActionBoardVue = require('./../../components/call-action-board.vue');

var _componentsCallActionBoardVue2 = _interopRequireDefault(_componentsCallActionBoardVue);

var _componentsCallBoardVue = require('./../../components/call-board.vue');

var _componentsCallBoardVue2 = _interopRequireDefault(_componentsCallBoardVue);

var _componentsTextJobSummaryVue = require('./../../components/text-job-summary.vue');

var _componentsTextJobSummaryVue2 = _interopRequireDefault(_componentsTextJobSummaryVue);

var notify = require('./../../../mixed/notify');
var modals = require('./../../../mixed/modals');

Vue.component('new-job-task', {
    template: '<div class="panel no-padding border-grey-800"><div class="top small"><span>{{task.employee}}</span><span>{{task.needed}}</span><span>{{task.post}}</span></div><div>{{formateDate}}</div><div><span class="panel border-grey-400 no-padding small">Need<br />{{task.remaining}}</span><span class="panel border-grey-400 no-padding small">Time Left<br />{{task.timeLeft}}</span><span class="panel border-grey-400 no-padding small">Recipient<br />{{task.recipent}}</span></div><p>\n    <button type="button" v-if="btn==1" class="btn btn-success" @click="processTask">Process</button>\n    <button type="button" v-if="btn==2" class="btn btn-warning">Process</button>\n    <button type="button" v-if="btn==3" class="btn">Process</button></p>\n<div class=""><small class="pull-right mr-5">{{timeDuration(task.addedTime)}}</small></div>\n<div class="clearfix"</div>\n\n    </div>',
    data: function data() {
        return {
            formateDate: '',
            btn: 1,
            flag: false
        };
    },
    props: ['task'],
    watch: {
        'task.user': function taskUser(val, oldVal) {
            if (val == current_user) {
                this.btn = 2;
            } else if (this.task.user != null) this.btn = 3;else this.btn = 1;
            if (this.flag == false) this.$dispatch('clearMessage', this.task);
            this.flag = false;
        }
    },
    created: function created() {

        if (this.task.date == "-") this.formateDate = "-";else if (moment.duration(moment(this.task.date).diff(moment().startOf('day'))).asDays() < 1) this.formateDate = "Today";else if (moment.duration(moment(this.task.date).diff(moment().startOf('day'))).asDays() < 2) this.formateDate = "Tomorrow";else if (moment.duration(moment(this.task.date).diff(moment().startOf('day'))).asWeeks() < 1) this.formateDate = moment(this.task.date).format("dddd");else this.formateDate = moment(this.task.date).format("MM/DD");

        if (this.task.user == current_user) {
            this.btn = 2;
            this.$dispatch('loadNew', this.task);
        } else if (this.task.user != null) this.btn = 3;else this.btn = 1;
    },
    methods: {
        processTask: function processTask() {
            this.btn = 2;
            this.flag = true;
            this.$dispatch('loadNew', this.task);
            this.$dispatch('clearProcess', this.task);
        },
        timeDuration: function timeDuration(datetime) {
            if (!datetime) return "";
            var time = moment().diff(moment(datetime), 'minutes');
            return Math.floor(time / 60) + ":" + time % 60;
            //return moment(datetime).toNow(true).format("hh:mm::ss");
        }
    },
    events: {
        setButtonActivate: function setButtonActivate(orderId) {
            if (this.task.orderId == orderId) {
                this.btn = 1;
            }
        },
        reloadNew: function reloadNew(orderId) {
            if (this.task.orderId == orderId) {
                this.$dispatch('loadNew', this.task);
            }
        }
    }
});

Vue.component('job-summary', {
    template: '<div class="panel no-padding border-grey-800 job-summary"><div class="top small"><span>Job Summary</span></div><div><span class="panel border-grey-400 no-padding small">Recipient<br />{{task.recipent}}</span></div><p>\n    <button type="button" v-if="btn==1" class="btn btn-success" @click="processTask">Process</button>\n    <button type="button" v-if="btn==2" class="btn btn-warning">Process</button>\n    <button type="button" v-if="btn==3" class="btn">Process</button></p>\n<div class=""><small class="pull-right mr-5">{{timeDuration(task.addedTime)}}</small></div>\n<div class="clearfix"</div>\n\n    </div>',
    data: function data() {
        return {
            formateDate: '',
            btn: 1,
            flag: false
        };
    },
    props: ['task'],
    watch: {
        'task.user': function taskUser(val, oldVal) {

            if (this.task.user == current_user) {
                this.btn = 2;
            } else if (this.task.user != null) this.btn = 3;else this.btn = 1;
            if (this.flag == false) this.$dispatch('clearMessage', this.task);
            this.flag = false;
        }
    },
    created: function created() {

        if (this.task.date == "-") this.formateDate = "-";else if (moment.duration(moment(this.task.date).diff(moment())).asDays() < 1) this.formateDate = "Today";else if (moment.duration(moment(this.task.date).diff(moment())).asDays() < 2) this.formateDate = "Tomorrow";else if (moment.duration(moment(this.task.date).diff(moment())).asWeeks() < 1) this.formateDate = moment(this.task.date).format("dddd");else this.formateDate = moment(this.task.date).format("MM/DD");

        if (this.task.user == current_user) {
            this.btn = 2;
            this.$dispatch('loadNew', this.task);
        } else if (this.task.user != null) this.btn = 3;else this.btn = 1;
    },
    methods: {
        processTask: function processTask() {
            this.btn = 2;
            this.flag = true;
            this.$dispatch('loadNew', this.task);
            this.$dispatch('clearProcess', this.task);
        },
        timeDuration: function timeDuration(datetime) {
            if (!datetime) return "";
            var time = moment().diff(moment(datetime), 'minutes');
            return Math.floor(time / 60) + ":" + time % 60;
            //return moment(datetime).toNow(true).format("hh:mm::ss");
        }
    },
    events: {
        setButtonActivate: function setButtonActivate(orderId) {
            if (this.task.orderId == orderId) {
                this.btn = 1;
            }
        },
        reloadNew: function reloadNew(orderId) {
            if (this.task.orderId == orderId) {
                this.$dispatch('loadNew', this.task);
            }
        }
    }
});

Vue.component('callBoard', _componentsCallBoardVue2['default']);

exports['default'] = Vue.extend({
    data: function data() {
        return {
            //employees :[]
            list: {
                newJobText: [],
                clientReqText: [],
                reconfirmationJobText: [],
                assignmentDetailsText: [],
                moveText: [],
                timeChangeText: [],
                timeConflictText: [],
                otherChangeText: [],
                jobCancelText: [],

                newJobCallb: [],
                clientReqCallb: [],
                reconfirmationJobCallb: [],
                moveCallb: [],
                timeChangeCallb: [],
                timeConflictCallb: [],
                otherChangeCallb: [],
                jobCancelCallb: []
            },
            calls: [],
            call1: [],
            call2: [],
            expired: [],
            length: {
                newJobText: null,
                jobSummaryText: null,
                reconfirmationJobText: null,
                assignmentDetailsText: null,
                clientReqText: null,
                moveText: null,
                timeChangeText: null,
                timeConflictText: null,
                otherChangeText: null,
                jobCancelText: null,

                newJobCallb: null,
                reconfirmationJobCallb: null,
                clientReqCallb: null,
                moveCallb: null,
                timeChangeCallb: null,
                timeConflictCallb: null,
                otherChangeCallb: null,
                jobCancelCallb: null
            },
            jobSummaryText: [],
            jobSummaryLength: null

        };
    },
    components: {
        textNewJob: _componentsTextNewJobVue2['default'],
        textClientRequest: _componentsTextClientRequestVue2['default'],
        textReconfirmationJob: _componentsTextReconfirmationJobVue2['default'],
        textAssignmentDetail: _componentsTextAssignmentDetailVue2['default'],
        textMove: _componentsTextMoveVue2['default'],
        textTimeChange: _componentsTextTimeChangeVue2['default'],
        textOtherChange: _componentsTextOtherChangesVue2['default'],
        textJobCancel: _componentsTextJobCancelVue2['default'],
        textTimeConflict: _componentsTextTimeConflictVue2['default'],

        callbNewJob: _componentsCallbNewJobVue2['default'],
        callbClientRequest: _componentsCallbClientRequestVue2['default'],
        callbReconfirmationJob: _componentsCallbReconfirmationJobVue2['default'],
        callbMove: _componentsCallbMoveVue2['default'],
        callbTimeChange: _componentsCallbTimeChangeVue2['default'],
        callbOtherChange: _componentsCallbOtherChangesVue2['default'],
        callbJobCancel: _componentsCallbJobCancelVue2['default'],
        callActionBoard: _componentsCallActionBoardVue2['default'],
        callbTimeConflict: _componentsCallbTimeConflictVue2['default'],
        textJobSummary: _componentsTextJobSummaryVue2['default']
    },

    ready: function ready() {
        this.loadData();
    },
    filters: {
        parseDate: function parseDate(date) {
            return moment(date, "YYYY-MM-DD").format('dddd, MM/DD');
        }
    },

    methods: {
        loadData: function loadData() {
            var self = this;

            self.$http.get('/api/action-board-load-data', '', function (response) {

                for (var key2 in self.list) {

                    self.length[key2] = null;
                    self.list[key2] = [];
                    Object.keys(response[key2]).forEach(function (k) {
                        var task = {};
                        var grp = 0;
                        var list = [];
                        task.orderId = response[key2][k].action_board_core.employee_order.order.id;
                        task.type = key2;
                        task.employee = response[key2][k].action_board_core.employee_order.order.client.company_code;
                        task.employeeName = response[key2][k].action_board_core.employee_order.order.client.name;
                        task.employeeAddr1 = response[key2][k].action_board_core.employee_order.order.client.address_line_1;
                        task.employeeAddr2 = response[key2][k].action_board_core.employee_order.order.client.address_line_2;
                        task.needed = response[key2][k].action_board_core.employee_order.order.no_of_employee;
                        task.post = response[key2][k].action_board_core.employee_order.order.position.title;
                        task.date = response[key2][k].action_board_core.employee_order.order.date;

                        task.inTime = moment(response[key2][k].action_board_core.employee_order.order.in_time).format("h:mm a");
                        task.outTime = moment(response[key2][k].action_board_core.employee_order.order.out_time).format("h:mm a");
                        task.remaining = response[key2][k].remaining;
                        task.timeLeft = moment.duration(moment(response[key2][k].action_board_core.employee_order.order.in_time).diff(moment())).humanize();
                        grp = response[key2][k].total;
                        task.addedTime = response[key2][k].send_time;
                        task.user = response[key2][k].user_id;
                        task.rate = response[key2][k].pay_rate;
                        list = response[key2][k].emplist.split(",");
                        for (var loop = 0; loop < grp / 10; loop++) {

                            var bundle = _.cloneDeep(task);
                            bundle.grp = loop;
                            if (grp - loop * 10 > 10) {
                                bundle.recipent = 10;
                                bundle.empList = list.splice(0, 10).toString();
                            } else {
                                bundle.recipent = grp - loop * 10;
                                bundle.empList = list.toString();
                            }

                            bundle.separator = task.orderId + '-' + key2 + '-' + task.user + '-' + task.rate + '-' + loop;
                            self.length[key2]++;
                            self.list[key2].push(bundle);
                        }
                    });
                }
                self.jobSummaryText = [];
                self.jobSummaryLength = null;
                Object.keys(response.jobSummary).forEach(function (k) {
                    var task = {};
                    task.orderId = null;
                    task.type = "jobSummary";
                    task.employee = "Summary";
                    task.employeeName = "Summary";
                    task.needed = "-";
                    task.post = "Summary";
                    task.date = "-";
                    task.inTime = "-";
                    task.outTime = "-";
                    task.remaining = "-";
                    task.timeLeft = "-";
                    task.recipent = response.jobSummary[k].length;
                    task.addedTime = "";
                    task.user = response.jobSummary[k][0].user_id;
                    task.rate = "";
                    task.code = k;

                    self.jobSummaryText.push(task);
                    self.jobSummaryLength++;
                });
                self.expired = response.expired;

                //self.jobSummaryText = response.jobSummary;
                //self.jobSummaryLength = response.jobSummary.length;
                Object.keys(response.callData).forEach(function (k) {
                    var employee = {
                        id: null,
                        name: null,
                        primary_phone: null,
                        secondary_phone: null,
                        email: null,
                        timeChange: {
                            earlyTime: null,
                            count: null,
                            state: null
                        },
                        timeConflict: {
                            earlyTime: null,
                            count: null,
                            state: null
                        },
                        otherChange: {
                            earlyTime: null,
                            count: null,
                            state: null
                        },
                        jobCancel: {
                            earlyTime: null,
                            count: null,
                            state: null
                        },
                        clientRequest: {
                            earlyTime: null,
                            count: null,
                            state: null
                        },
                        move: {
                            earlyTime: null,
                            count: null,
                            state: null
                        },
                        reconfirmationJob: {
                            earlyTime: null,
                            count: null,
                            state: null
                        },
                        newJob: {
                            earlyTime: null,
                            count: null,
                            state: null
                        },
                        response: []

                    };

                    employee.id = response.callData[k].id;
                    employee.name = response.callData[k].first_name + ' ' + response.callData[k].last_name;
                    employee.primary_phone = response.callData[k].primary_phone;
                    employee.secondary_phone = response.callData[k].secondary_phone;
                    employee.email = response.callData[k].email;
                    employee.user_id = response.callData[k].user_id;

                    if (response.callData[k].title == "time-change") {
                        employee.timeChange.earlyTime = self.formateDate(response.callData[k].earlyTime);
                        employee.timeChange.count = response.callData[k].count;
                        employee.timeChange.state = response.callData[k].minState;
                    } else if (response.callData[k].title == "time-conflict") {
                        employee.timeConflict.earlyTime = self.formateDate(response.callData[k].earlyTime);
                        employee.timeConflict.count = response.callData[k].count;
                        employee.timeConflict.state = response.callData[k].minState;
                    } else if (response.callData[k].title == "other-changes") {
                        employee.otherChange.earlyTime = self.formateDate(response.callData[k].earlyTime);
                        employee.otherChange.count = response.callData[k].count;
                        employee.otherChange.state = response.callData[k].minState;
                    } else if (response.callData[k].title == "job-cancel") {
                        employee.jobCancel.earlyTime = self.formateDate(response.callData[k].earlyTime);
                        employee.jobCancel.count = response.callData[k].count;
                        employee.jobCancel.state = response.callData[k].minState;
                    } else if (response.callData[k].title == "client-request") {
                        employee.clientRequest.earlyTime = self.formateDate(response.callData[k].earlyTime);
                        employee.clientRequest.count = response.callData[k].count;
                        employee.clientRequest.state = response.callData[k].minState;
                    } else if (response.callData[k].title == "move") {
                        employee.move.earlyTime = self.formateDate(response.callData[k].earlyTime);
                        employee.move.count = response.callData[k].count;
                        employee.move.state = response.callData[k].minState;
                    } else if (response.callData[k].title == "reconfirmation-job") {
                        employee.reconfirmationJob.earlyTime = self.formateDate(response.callData[k].earlyTime);
                        employee.reconfirmationJob.count = response.callData[k].count;
                        employee.reconfirmationJob.state = response.callData[k].minState;
                    } else if (response.callData[k].title == "new-job-offer") {
                        employee.newJob.earlyTime = self.formateDate(response.callData[k].earlyTime);
                        employee.newJob.count = response.callData[k].count;
                        employee.newJob.state = response.callData[k].minState;
                    } else {
                        //console.log(response.callData[k]);
                    }

                    var keyval = null;

                    for (var pos in self.calls) {
                        if (self.calls[pos].id == response.callData[k].id) keyval = pos;
                    }

                    if (keyval == null) {
                        employee.response = response.response[employee.id];
                        //console.log(employee.response);
                        self.calls.push(employee);
                    } else {
                        if (response.callData[k].title == "time-change") {
                            self.calls[keyval].timeChange.earlyTime = self.formateDate(response.callData[k].earlyTime);
                            self.calls[keyval].timeChange.count = response.callData[k].count;
                            self.calls[keyval].timeChange.state = response.callData[k].minState;
                        } else if (response.callData[k].title == "time-conflict") {
                            self.calls[keyval].timeConflict.earlyTime = self.formateDate(response.callData[k].earlyTime);
                            self.calls[keyval].timeConflict.count = response.callData[k].count;
                            self.calls[keyval].timeConflict.state = response.callData[k].minState;
                        } else if (response.callData[k].title == "other-changes") {
                            self.calls[keyval].otherChange.earlyTime = self.formateDate(response.callData[k].earlyTime);
                            self.calls[keyval].otherChange.count = response.callData[k].count;
                            self.calls[keyval].otherChange.state = response.callData[k].minState;
                        } else if (response.callData[k].title == "job-cancel") {
                            self.calls[keyval].jobCancel.earlyTime = self.formateDate(response.callData[k].earlyTime);
                            self.calls[keyval].jobCancel.count = response.callData[k].count;
                            self.calls[keyval].jobCancel.state = response.callData[k].minState;
                        } else if (response.callData[k].title == "client-request") {
                            self.calls[keyval].clientRequest.earlyTime = self.formateDate(response.callData[k].earlyTime);
                            self.calls[keyval].clientRequest.count = response.callData[k].count;
                            self.calls[keyval].clientRequest.state = response.callData[k].minState;
                        } else if (response.callData[k].title == "move") {
                            self.calls[keyval].move.earlyTime = self.formateDate(response.callData[k].earlyTime);
                            self.calls[keyval].move.count = response.callData[k].count;
                            self.calls[keyval].move.state = response.callData[k].minState;
                        } else if (response.callData[k].title == "reconfirmation-job") {
                            self.calls[keyval].reconfirmationJob.earlyTime = self.formateDate(response.callData[k].earlyTime);
                            self.calls[keyval].reconfirmationJob.count = response.callData[k].count;
                            self.calls[keyval].reconfirmationJob.state = response.callData[k].minState;
                        } else if (response.callData[k].title == "new-job-offer") {
                            self.calls[keyval].newJob.earlyTime = self.formateDate(response.callData[k].earlyTime);
                            self.calls[keyval].newJob.count = response.callData[k].count;
                            self.calls[keyval].newJob.state = response.callData[k].minState;
                        } else {
                            //console.log(response.callData[k]);
                        }
                    }

                    self.call2 = self.calls.filter(function (item) {
                        if ((item.newJob.state > 0 || item.newJob.state == null) && (item.reconfirmationJob.state > 0 || item.reconfirmationJob.state == null) && (item.move.state > 0 || item.move.state == null) && (item.clientRequest.state > 0 || item.clientRequest.state == null) && (item.jobCancel.state > 0 || item.jobCancel.state == null) && (item.otherChange.state > 0 || item.otherChange.state == null) && (item.timeConflict.state > 0 || item.timeConflict.state == null) && (item.timeChange.state > 0 || item.timeChange.state == null)) return true;else return false;
                    });
                    self.call1 = self.calls.filter(function (item) {
                        if ((item.newJob.state > 0 || item.newJob.state == null) && (item.reconfirmationJob.state > 0 || item.reconfirmationJob.state == null) && (item.move.state > 0 || item.move.state == null) && (item.clientRequest.state > 0 || item.clientRequest.state == null) && (item.jobCancel.state > 0 || item.jobCancel.state == null) && (item.otherChange.state > 0 || item.otherChange.state == null) && (item.timeConflict.state > 0 || item.timeConflict.state == null) && (item.timeChange.state > 0 || item.timeChange.state == null)) return false;else return true;
                    });
                });
            }).always(function () {});
            setTimeout(this.loadData, 120000);
        },
        formateDate: function formateDate(datetime) {
            var dated = null;

            var selection_time = moment(datetime).startOf('day');
            if (moment.duration(selection_time.diff(moment().startOf('day'))).asDays() < 1) dated = moment(datetime).format("hh:mm a");else if (moment.duration(selection_time.diff(moment().startOf('day'))).asDays() < 2) dated = "Tomorrow";else if (moment.duration(selection_time.diff(moment().startOf('day'))).asWeeks() < 1) dated = moment(datetime).format("ddd");else dated = moment(datetime).format("MM/DD");

            return dated;
        }
    },
    events: {
        'callReloadData': function callReloadData() {
            var self = this;
            self.calls = [];
            self.$http.get('/api/action-board-call-data', '', function (response) {
                Object.keys(response.callData).forEach(function (k) {
                    var employee = {
                        id: null,
                        name: null,
                        primary_phone: null,
                        secondary_phone: null,
                        email: null,
                        timeChange: {
                            earlyTime: null,
                            count: null,
                            state: null
                        },
                        timeConflict: {
                            earlyTime: null,
                            count: null,
                            state: null
                        },
                        otherChange: {
                            earlyTime: null,
                            count: null,
                            state: null
                        },
                        jobCancel: {
                            earlyTime: null,
                            count: null,
                            state: null
                        },
                        clientRequest: {
                            earlyTime: null,
                            count: null,
                            state: null
                        },
                        move: {
                            earlyTime: null,
                            count: null,
                            state: null
                        },
                        reconfirmationJob: {
                            earlyTime: null,
                            count: null,
                            state: null
                        },
                        newJob: {
                            earlyTime: null,
                            count: null,
                            state: null
                        }
                    };

                    employee.id = response.callData[k].id;
                    employee.name = response.callData[k].first_name + ' ' + response.callData[k].last_name;
                    employee.primary_phone = response.callData[k].primary_phone;
                    employee.secondary_phone = response.callData[k].secondary_phone;
                    employee.email = response.callData[k].email;
                    employee.user_id = response.callData[k].user_id;

                    if (response.callData[k].title == "time-change") {
                        employee.timeChange.earlyTime = self.formateDate(response.callData[k].earlyTime);
                        employee.timeChange.count = response.callData[k].count;
                        employee.timeChange.state = response.callData[k].minState;
                    } else if (response.callData[k].title == "time-conflict") {
                        employee.timeConflict.earlyTime = self.formateDate(response.callData[k].earlyTime);
                        employee.timeConflict.count = response.callData[k].count;
                        employee.timeConflict.state = response.callData[k].minState;
                    } else if (response.callData[k].title == "other-changes") {
                        employee.otherChange.earlyTime = self.formateDate(response.callData[k].earlyTime);
                        employee.otherChange.count = response.callData[k].count;
                        employee.otherChange.state = response.callData[k].minState;
                    } else if (response.callData[k].title == "job-cancel") {
                        employee.jobCancel.earlyTime = self.formateDate(response.callData[k].earlyTime);
                        employee.jobCancel.count = response.callData[k].count;
                        employee.jobCancel.state = response.callData[k].minState;
                    } else if (response.callData[k].title == "client-request") {
                        employee.clientRequest.earlyTime = self.formateDate(response.callData[k].earlyTime);
                        employee.clientRequest.count = response.callData[k].count;
                        employee.clientRequest.state = response.callData[k].minState;
                    } else if (response.callData[k].title == "move") {
                        employee.move.earlyTime = self.formateDate(response.callData[k].earlyTime);
                        employee.move.count = response.callData[k].count;
                        employee.move.state = response.callData[k].minState;
                    } else if (response.callData[k].title == "reconfirmation-job") {
                        employee.reconfirmationJob.earlyTime = self.formateDate(response.callData[k].earlyTime);
                        employee.reconfirmationJob.count = response.callData[k].count;
                        employee.reconfirmationJob.state = response.callData[k].minState;
                    } else if (response.callData[k].title == "new-job-offer") {
                        employee.newJob.earlyTime = self.formateDate(response.callData[k].earlyTime);
                        employee.newJob.count = response.callData[k].count;
                        employee.newJob.state = response.callData[k].minState;
                    } else {
                        // console.log(response.callData[k].title);
                    }

                    var keyval = null;
                    for (var pos in self.calls) {
                        if (self.calls[pos].id == response.callData[k].id) keyval = pos;
                    }

                    if (keyval == null) {
                        employee.response = response.response[employee.id];
                        self.calls.push(employee);
                    } else {
                        if (response.callData[k].title == "time-change") {
                            self.calls[keyval].timeChange.earlyTime = self.formateDate(response.callData[k].earlyTime);
                            self.calls[keyval].timeChange.count = response.callData[k].count;
                            self.calls[keyval].timeChange.state = response.callData[k].minState;
                        } else if (response.callData[k].title == "time-conflict") {
                            self.calls[keyval].timeConflict.earlyTime = self.formateDate(response.callData[k].earlyTime);
                            self.calls[keyval].timeConflict.count = response.callData[k].count;
                            self.calls[keyval].timeConflict.state = response.callData[k].minState;
                        } else if (response.callData[k].title == "other-changes") {
                            self.calls[keyval].otherChange.earlyTime = self.formateDate(response.callData[k].earlyTime);
                            self.calls[keyval].otherChange.count = response.callData[k].count;
                            self.calls[keyval].otherChange.state = response.callData[k].minState;
                        } else if (response.callData[k].title == "job-cancel") {
                            self.calls[keyval].jobCancel.earlyTime = self.formateDate(response.callData[k].earlyTime);
                            self.calls[keyval].jobCancel.count = response.callData[k].count;
                            self.calls[keyval].jobCancel.state = response.callData[k].minState;
                        } else if (response.callData[k].title == "client-request") {
                            self.calls[keyval].clientRequest.earlyTime = self.formateDate(response.callData[k].earlyTime);
                            self.calls[keyval].clientRequest.count = response.callData[k].count;
                            self.calls[keyval].clientRequest.state = response.callData[k].minState;
                        } else if (response.callData[k].title == "move") {
                            self.calls[keyval].move.earlyTime = self.formateDate(response.callData[k].earlyTime);
                            self.calls[keyval].move.count = response.callData[k].count;
                            self.calls[keyval].move.state = response.callData[k].minState;
                        } else if (response.callData[k].title == "reconfirmation-job") {
                            self.calls[keyval].reconfirmationJob.earlyTime = self.formateDate(response.callData[k].earlyTime);
                            self.calls[keyval].reconfirmationJob.count = response.callData[k].count;
                            self.calls[keyval].reconfirmationJob.state = response.callData[k].minState;
                        } else if (response.callData[k].title == "new-job-offer") {
                            self.calls[keyval].newJob.earlyTime = self.formateDate(response.callData[k].earlyTime);
                            self.calls[keyval].newJob.count = response.callData[k].count;
                            self.calls[keyval].newJob.state = response.callData[k].minState;
                        } else {
                            //console.log(response.callData[k].title);
                        }
                    }
                    self.call2 = self.calls.filter(function (item) {
                        if ((item.newJob.state > 0 || item.newJob.state == null) && (item.reconfirmationJob.state > 0 || item.reconfirmationJob.state == null) && (item.move.state > 0 || item.move.state == null) && (item.clientRequest.state > 0 || item.clientRequest.state == null) && (item.jobCancel.state > 0 || item.jobCancel.state == null) && (item.otherChange.state > 0 || item.otherChange.state == null) && (item.timeConflict.state > 0 || item.timeConflict.state == null) && (item.timeChange.state > 0 || item.timeChange.state == null)) return true;else return false;
                    });
                    self.call1 = self.calls.filter(function (item) {
                        if ((item.newJob.state > 0 || item.newJob.state == null) && (item.reconfirmationJob.state > 0 || item.reconfirmationJob.state == null) && (item.move.state > 0 || item.move.state == null) && (item.clientRequest.state > 0 || item.clientRequest.state == null) && (item.jobCancel.state > 0 || item.jobCancel.state == null) && (item.otherChange.state > 0 || item.otherChange.state == null) && (item.timeConflict.state > 0 || item.timeConflict.state == null) && (item.timeChange.state > 0 || item.timeChange.state == null)) return false;else return true;
                    });
                });
            }).always(function () {});
        },
        'clearProcess': function clearProcess(task) {
            for (var type in this.list) {
                for (var set in this.list[type]) {
                    if (this.list[type][set].separator == task.separator) {
                        if (this.list[type][set].user == null) this.list[type][set].user = current_user;
                    } else {
                        if (this.list[type][set].user == current_user) this.list[type][set].user = null;
                    }
                }
            }

            for (var type in this.jobSummaryText) {
                if (typeof task.code !== 'undefined' && this.jobSummaryText[type].code == task.code) {
                    if (this.jobSummaryText[type].user == null) this.jobSummaryText[type].user = current_user;
                } else {
                    if (this.jobSummaryText[type].user == current_user) this.jobSummaryText[type].user = null;
                }
            }
        },
        'counterRecount': function counterRecount(position) {
            switch (position) {
                case 1:
                    this.length.newJobText--;
                    break;
                case 2:
                    this.jobSummaryLength--;
                    break;
                case 3:
                    this.length.reconfirmationJobText--;
                    break;
                case 4:
                    this.length.assignmentDetailsText--;
                    break;
                case 5:
                    this.length.clientReqText--;
                    break;
                case 6:
                    this.length.moveText--;
                    break;
                case 7:
                    this.length.timeChangeText--;
                    break;
                case 8:
                    this.length.timeConflictText--;
                    break;
                case 9:
                    this.length.otherChangeText--;
                    break;
                case 10:
                    this.length.jobCancelText--;
                    break;

                case 11:
                    this.length.newJobCallb--;
                    break;
                case 12:
                    this.length.reconfirmationJobCallb--;
                    break;
                case 13:
                    this.length.clientReqCallb--;
                    break;
                case 14:
                    this.length.moveCallb--;
                    break;
                case 15:
                    this.length.timeChangeCallb--;
                    break;
                case 16:
                    this.length.timeConflictCallb--;
                    break;
                case 17:
                    this.length.otherChangeCallb--;
                    break;
                case 18:
                    this.length.jobCancelCallb--;
                    break;
                default:
                    console.log("wrong type");
            }
        }
    }
});
module.exports = exports['default'];

},{"./../../../mixed/modals":10,"./../../../mixed/notify":11,"./../../components/call-action-board.vue":28,"./../../components/call-board.vue":29,"./../../components/callb-client-request.vue":31,"./../../components/callb-job-cancel.vue":32,"./../../components/callb-move.vue":33,"./../../components/callb-new-job.vue":34,"./../../components/callb-other-changes.vue":35,"./../../components/callb-reconfirmation-job.vue":36,"./../../components/callb-time-change.vue":37,"./../../components/callb-time-conflict.vue":38,"./../../components/text-assignment-detail.vue":76,"./../../components/text-client-request.vue":77,"./../../components/text-job-cancel.vue":78,"./../../components/text-job-summary.vue":79,"./../../components/text-move.vue":80,"./../../components/text-new-job.vue":81,"./../../components/text-other-changes.vue":82,"./../../components/text-reconfirmation-job.vue":83,"./../../components/text-time-change.vue":84,"./../../components/text-time-conflict.vue":85}],102:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});
var notify = require('./../../../mixed/notify');

exports['default'] = Vue.extend({
    data: function data() {
        return {
            state: false
        };
    },

    events: {},

    ready: function ready() {},

    methods: {}
});
module.exports = exports['default'];

},{"./../../../mixed/notify":11}],103:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});
var notify = require('./../../../mixed/notify');

exports['default'] = Vue.extend({
    data: function data() {
        return {
            state: false
        };
    },

    events: {},

    ready: function ready() {},

    methods: {}
});
module.exports = exports['default'];

},{"./../../../mixed/notify":11}],104:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});
var notify = require('./../../../mixed/notify');
var modals = require('./../../../mixed/modals');
var editCity = typeof canEditCity !== 'undefined' && canEditCity == true ? 'icon-pencil7 text-primary-600 right-m-30' : '';
var deleteCity = typeof canDeleteCity !== 'undefined' && canDeleteCity == true ? 'icon-trash text-danger-600' : '';
var tableColumns = [{
    name: 'id',
    title: '#ID',
    sortField: 'id'
}, {
    name: 'title',
    title: 'Name',
    sortField: 'title'
}, '__actions'];

// create pagination component using bootstrap styling
Vue.component('vuetable-pagination-bootstrap', {
    template: '#vuetable-pagination-bootstrap-template',
    mixins: [paginationMixin],
    methods: {
        loadPage: function loadPage(page) {
            this.$dispatch('vuetable-pagination:change-page', page);
        }
    }
});

exports['default'] = Vue.extend({
    data: function data() {
        return {
            state: false,
            query: [],
            commonData: [],
            columns: tableColumns,
            moreParams: [],
            perPage: 500,
            city: {
                title: '',
                zips: []
            },
            currentCity: {},
            sortOrder: {
                field: 'title',
                direction: 'asc'
            },
            paginationInfoTemplate: 'vuetable-pagination-bootstrap',
            itemActions: [{
                name: 'edit-city',
                label: '',
                icon: editCity,
                'class': ''
            }, {
                name: 'delete-city',
                label: '',
                icon: deleteCity,
                'class': ''
            }]
        };
    },

    events: {
        'vuetable:action': function vuetableAction(action, data) {
            if (action == 'edit-city') {
                this.editModal(data);
            }

            if (action == 'delete-city') {
                this.confirmDelete(data);
            }
        },
        'vuetable:loading': function vuetableLoading() {
            notify.loading(true);
        },
        'vuetable:load-success': function vuetableLoadSuccess(response) {
            notify.loading(false);
        },
        'vuetable:load-error': function vuetableLoadError(response) {
            notify.loading(false);
            console.log('Load Error: ', response);
        }
    },
    ready: function ready() {
        this.currentCity = this.city;
        this.getData();
    },

    methods: {

        zipCity: function zipCity(zip) {
            return zip.city[0].city_id === this.currentCity.id;
        },

        getData: function getData() {
            var _this = this;

            this.$http.get('/api/zip-data', this.zip, function (response) {
                _this.commonData = response;
            }).always(function () {});
        },

        setFilter: function setFilter() {
            this.moreParams = ['filter=' + this.query];
            this.$nextTick(function () {
                this.$broadcast('vuetable:refresh');
            });
        },

        createCity: function createCity() {
            var _this2 = this;

            this.state = true;
            this.$http.post('/api/city', this.city, function () {
                modals.hide('#modal_add_city');
                notify.success('New City Added Successfully');
                _this2.$broadcast('vuetable:refresh');
                _this2.clearFields();
                _this2.getData();
            }).always(function () {
                _this2.state = false;
            });
        },

        editModal: function editModal(city) {
            this.currentCity = _.clone(city);
            this.currentCity.zips = _.pluck(this.currentCity.zips, 'id').map(String);
            modals.showStrict('#modal_edit_city');
        },

        editCity: function editCity() {
            var _this3 = this;

            this.state = true;
            this.$http.put('/api/city/' + this.currentCity.id, this.currentCity, function () {
                modals.hide('#modal_edit_city');
                notify.success('City Edited Successfully');
                _this3.$broadcast('vuetable:reload');
                _this3.getData();
            }).always(function () {
                _this3.state = false;
            });
        },

        confirmDelete: function confirmDelete(city) {
            this.currentCity = _.clone(city);
            notify.confirm('Are you sure you want to remove this city?', '', this.deleteCity);
        },

        deleteCity: function deleteCity() {
            var _this4 = this;

            this.$http['delete']('/api/city/' + this.currentCity.id, '', function () {
                notify.success('City Deleted');
            }).always(function () {
                _this4.$broadcast('vuetable:reload');
            });
        },

        clearFields: function clearFields() {
            this.city = {
                title: '',
                zips: []
            };
        }
    }
});
module.exports = exports['default'];

},{"./../../../mixed/modals":10,"./../../../mixed/notify":11}],105:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});
var notify = require('./../../../mixed/notify');
var modals = require('./../../../mixed/modals');

var editGroup = typeof canEditGroup !== 'undefined' && canEditGroup == true ? 'icon-pencil7 text-primary-600' : '';
var deleteGroup = typeof canDeleteGroup !== 'undefined' && canDeleteGroup == true ? 'icon-trash text-danger-600' : '';

var tableColumns = [{
    name: 'id',
    title: '#ID',
    sortField: 'id'
}, {
    name: 'title',
    title: 'Ttile',
    sortField: 'title'
}, '__actions'];

// create pagination component using bootstrap styling
Vue.component('vuetable-pagination-bootstrap', {
    template: '#vuetable-pagination-bootstrap-template',
    mixins: [paginationMixin],
    methods: {
        loadPage: function loadPage(page) {
            this.$dispatch('vuetable-pagination:change-page', page);
        }
    }
});

exports['default'] = Vue.extend({
    data: function data() {
        return {
            categories: [],
            state: false,
            group: {
                title: ''
            },
            currentGroup: {
                title: ''
            },
            query: [],
            columns: tableColumns,
            moreParams: [],
            sortOrder: {
                field: 'id',
                direction: 'asc'
            },
            paginationInfoTemplate: 'vuetable-pagination-bootstrap',
            itemActions: [{
                name: 'edit-group',
                label: '',
                icon: editGroup,
                'class': ''
            }, {
                name: 'delete-group',
                label: '',
                icon: deleteGroup,
                'class': ''
            }]
        };
    },

    events: {
        'vuetable:action': function vuetableAction(action, data) {
            console.log('vuetable:action', action, data);
            if (action == 'edit-group') {
                this.editModal(data);
            }
            if (action == 'delete-group') {
                this.confirmDelete(data);
            }
        },
        'vuetable:loading': function vuetableLoading() {
            notify.loading(true);
        },
        'vuetable:load-success': function vuetableLoadSuccess(response) {
            notify.loading(false);
        },
        'vuetable:load-error': function vuetableLoadError(response) {
            notify.loading(false);
            console.log('Load Error: ', response);
        }
    },
    ready: function ready() {
        var that = this;
        $('#modal_add_group').on('hidden.bs.modal', function () {
            that.clearFields();
        });
    },

    methods: {
        createGroup: function createGroup() {
            var _this = this;

            this.state = true;
            this.$http.post('/api/client-group', this.group, function (response) {
                modals.hide('#modal_add_group');
                notify.success('New Group Added Successfully');
                _this.$broadcast('vuetable:refresh');
            }).always(function () {
                _this.state = false;
            });
        },

        editModal: function editModal(group) {
            this.currentGroup = _.clone(group);
            modals.showStrict('#modal_edit_group');
        },

        editGroup: function editGroup() {
            var _this2 = this;

            this.state = true;
            this.$http.put('/api/client-group/' + this.currentGroup.id, this.currentGroup, function (response) {
                modals.hide('#modal_edit_group');
                notify.success('Group Edited Successfully');
                _this2.$broadcast('vuetable:reload');
            }).always(function () {
                _this2.state = false;
            });
        },

        confirmDelete: function confirmDelete(group) {
            this.currentGroup = group;
            notify.confirm('Are you sure you want to remove this group?', '', this.deleteGroup);
        },

        deleteGroup: function deleteGroup() {
            var _this3 = this;

            this.$http['delete']('/api/client-group/' + this.currentGroup.id, '', function (response) {
                //notify.success('Tool Deleted');
            }).always(function () {
                _this3.$broadcast('vuetable:reload');
            });
        },

        setFilter: function setFilter() {
            this.moreParams = ['filter=' + this.query];
            this.$nextTick(function () {
                this.$broadcast('vuetable:refresh');
            });
        },

        clearFields: function clearFields() {
            this.group = {
                title: ''
            };
        }
    }
});
module.exports = exports['default'];

},{"./../../../mixed/modals":10,"./../../../mixed/notify":11}],106:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});
var notify = require('./../../../mixed/notify');

exports['default'] = Vue.extend({
    data: function data() {
        return {
            state: false
        };
    },

    events: {},

    ready: function ready() {},

    methods: {}
});
module.exports = exports['default'];

},{"./../../../mixed/notify":11}],107:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});
var notify = require('./../../../mixed/notify');
var modals = require('./../../../mixed/modals');
var orderIdDate = new Array();
var orderIdTime = new Array();
var IDLE_TIMEOUT = typeof delay !== 'undefined' && delay == true ? delay * 60 : 300; //seconds
var idleSecondsCounter = 0;
document.onclick = function () {
    idleSecondsCounter = 0;
};
document.onmousemove = function () {
    idleSecondsCounter = 0;
};
document.onkeypress = function () {
    idleSecondsCounter = 0;
};

exports['default'] = Vue.extend({
    filters: {
        momentTime: function momentTime(time) {
            return moment(time, "YYYY-MM-DD HH:mm:ss").format('h:m a');
        },

        timeEarly: function timeEarly(time, early) {
            return moment(time, "YYYY-MM-DD HH:mm:ss").subtract(early, 'minutes').format('h:m a');
        },

        momentDate: function momentDate(date) {
            return moment(date, "YYYY-MM-DD").format('MM  DD');
        },

        momentMonthDay: function momentMonthDay(date) {
            return moment(date, "YYYY-MM-DD").format('MMM  D');
        },

        parseDate: function parseDate(date) {
            return moment(date, "YYYY-MM-DD").format('dddd, MM DD');
        },

        parseDateEmployeeOrder: function parseDateEmployeeOrder(date) {
            return moment(date, "YYYY-MM-DD").format('dddd, MMMM DD');
        },

        parseNumber: function parseNumber(val) {
            return parseFloat(Math.round(val * 100) / 100).toFixed(2);
        },

        momentDay: function momentDay(date) {
            return moment(date, "YYYY-MM-DD").format('ddd');
        },

        momentDateTime: function momentDateTime(dateTime) {
            return moment(dateTime, "YYYY-MM-DD HH:mm:ss").format('YYYY-MM-DD hh:mm a');
        },

        parseTime: function parseTime(dateTime) {
            return moment(dateTime, "YYYY-MM-DD HH:mm:ss").format('h:m a');
        },

        filterPhone: function filterPhone(phone) {
            if (phone) {
                return phone.replace(/\s+/g, '');
            }
        },

        parseStatus: function parseStatus(status) {
            return status.split('-').join(' ');
        },

        cap: function cap(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        },

        removeQuote: function removeQuote(string) {
            return string.replace(/'/g, '');
        }

    },
    data: function data() {
        return {
            showStatus: 1,
            moveStatus: 0,
            state: false,
            startDate: '',
            sorting: '',
            date: '',
            weekDates: [],
            statuses: {
                'contact': 'CONTACT',
                'confirm': 'CONFIRM',
                're-confirm': 'RE-CONFIRM',
                // 'need-change': 'NEED-CHANGE',
                // 'did-not-re-confirm': 'D.N.Rc',
                "cant-work-time": "CAN NOT",
                // "cant-work-job": "CAN'T(this job)",
                'delete': 'DELETE'
            },
            activeDate: '',
            activeOrder: '',
            currentDate: '',
            orders: {},
            clientOrders: {},
            employees: false,
            employee: '',
            employeeOrders: {},
            employeePreviousOrders: {},
            employeeOrder: false,
            activeEmployee: {},
            order: {
                client_id: '',
                position_code: '',
                max_pay_rate: null,
                no_of_employee: 0,
                in_time: '',
                out_time: '',
                date: '',
                special_instruction: '',
                source_posting_info: '',
                additional_employees: '',
                pay_rate_increase: '',
                auto_selection: 0,
                text_instruction: '',
                rate_change_impact: 0
            },
            currentOrder: {
                client_id: '',
                position_code: '',
                max_pay_rate: null,
                no_of_employee: 0,
                in_time: '',
                out_time: '',
                date: '',
                special_instruction: '',
                source_posting_info: '',
                additional_employees: '',
                pay_rate_increase: '',
                auto_selection: 1,
                text_instruction: '',
                rate_change_impact: 0
            },
            currentUniforms: [],
            uniform: '',
            activeClient: {},
            clients: {},
            client: '',
            currentClient: {},
            positions: {},
            notes: {
                accounting: '',
                personal: '',
                shifts: '',
                referral: '',
                comments: ''
            },
            activeNotes: {},
            previousWeek: false,
            response: [],
            autoSelectionOrders: [],
            autoSelectionTotals: [],
            pendingOrders: [],
            pendingOrdersAuto: [],
            pendingOrdersManual: [],
            selectedUniforms: [],
            userId: userId,
            verificationType: '',
            verificationId: '',
            verificationModal: '',
            ids: [],
            previousRecordStartDate: '',
            pendingDashboardOperations: 0,
            employeeAdditionalStatus: null,
            app: 0
        };
    },

    components: {
        'select-employee': require('./select-employees'),
        'employee-records': require('./employee-records')
    },

    computed: {
        // a computed getter
        dates: function dates() {
            var begin = moment().locale('us').weekday(1);
            var weekDates = [];
            for (var i = 0; i < 7; i++) {
                weekDates.push(begin.format('dddd'));
                begin.add(1, 'days');
            }
            return weekDates;
        }
    },
    watch: {
        'order.client_id': function orderClient_id(val) {
            this.activeClient = _.clone(_.find(this.clients, function (o) {
                return o.id == val;
            }));
        },

        'clients': function clients() {
            $('#position-client').selectric('refresh');
            $('#no-of-employee').selectric('refresh');
        },

        'activeClient': function activeClient() {
            $('#position-code').selectric('refresh');
        },

        'employees': function employees() {
            // $('#employee-list').selectric('refresh');
        },

        'order.no_of_employee': function orderNo_of_employee() {
            $('#no-of-employee').selectric('refresh');
        },

        'order.position_code': function orderPosition_code(val) {
            //this.order.max_pay_rate = val.pay_rate;
            var positionCode = val + '';
            if (positionCode) {
                var position = _.find(this.activeClient.positions, function (o) {
                    return o.position_code === positionCode;
                });
                console.log(position);
                if (position) {
                    this.order.auto_selection = position.auto_selection;
                    this.order.max_pay_rate = position.pay_rate;
                } else {
                    this.order.max_pay_rate = '';
                }
            } else {
                this.order.max_pay_rate = '';
            }
        },

        'employee': function employee(val) {
            if (val && val !== '0') {
                var activeEmployees = this.employees['Active & Watch List'];
                var otherEmployees = this.employees['Others'];
                var localEmployee = _.find(activeEmployees.concat(otherEmployees), {
                    id: parseInt(val)
                });
                localEmployee.pivot = {};
                localEmployee.pivot.employee_id = parseInt(val);
                this.employeeOrderRecords(localEmployee, null, '', true, false);
            }
        },

        'client': function client(val) {
            if (val) {
                this.getClientOrders(val);
            }
        },

        'date': function date(val) {
            Cookies.set('startDate', moment(val, "MM-DD-YYYY").format('YYYY-MM-DD'));
            //this.startDate = moment(val, "MM-DD-YYYY").format('YYYY-MM-DD');
            this.getOrders();
        },
        'order.in_time': function orderIn_time(val) {
            // var hour = moment(val, "HH:mm:ss").format('H');
            // var minute = moment(val, "HH:mm:ss").format('mm');
            // console.log(hour);
            // $('#out_time').combodate('destroy');
            // $('#out_time').combodate({
            //     minuteStep: 15,
            //     minHour: hour,
            //     format: 'HH:mm',
            //     value: moment(val, "HH:mm:ss").format('HH:mm')
            // });
            //$('#out_time').combodate('setValue', moment(val, "HH:mm:ss").format('HH:mm'));
        },

        'previousRecordStartDate': function previousRecordStartDate(val) {
            this.employeeRecordsPreviousWeek(1);
        }
    },

    events: {
        fetchOrders: function fetchOrders() {
            this.getOrders();
        },

        fetchEmployeeRecords: function fetchEmployeeRecords(employee) {
            this.employeeOrderRecords(employee, '', '', false, false);
        }
    },

    ready: function ready() {
        var _this = this;

        if (typeof Cookies.get('startDate') === 'undefined') {
            Cookies.set('startDate', '');
        }
        if (typeof Cookies.get('sorting') === 'undefined') {
            Cookies.set('sorting', '');
        }
        this.sorting = Cookies.get('sorting');
        // setTimeout(() => {
        //     window.setInterval(this.getPendingDashboardOperations, 1000 * 300);
        // }, 1000 * 30);
        window.setInterval(this.checkIdleTime, 1000);
        // this.getPendingDashboardOperations();

        $('#in_time').combodate({
            minuteStep: 15,
            minHour: 1,
            maxHour: 12
        });
        $('#out_time').combodate({
            minuteStep: 15,
            minHour: 1,
            maxHour: 12
        });
        $('#in_time_edit').combodate({
            minuteStep: 15,
            minHour: 1,
            maxHour: 12
        });
        $('#out_time_edit').combodate({
            minuteStep: 15,
            minHour: 1,
            maxHour: 12
        });

        setTimeout(function () {
            _this.getOrders(false);
        }, 10 * 1);

        setTimeout(function () {
            _this.getClients();
            _this.getEmployees();
        }, 1000 * 3);
        var that = this;

        window.bus.$on('refreshDashboard', function () {
            that.getOrders();
        });

        window.bus.$on('statusDetails', function (id, date) {
            that.removeManualSelection(id, date);
        });

        window.bus.$on('manualSelection', function (id) {
            that.selectEmployeePopup(id);
        });

        $('#employee-order-records').on('hidden.bs.modal', function () {
            $("#employee-list").val('0').trigger('change');
            that.employeeOrders = {};
            that.app = 0;
            that.resetValues();
        });

        $('#modal-edit-order').on('hidden.bs.modal', function () {
            that.getOrders();
        });

        $('#modal-add-order').on('hidden.bs.modal', function () {
            that.clearFields();
            $('#position-client').prop('selectedIndex', 0).selectric('refresh');
            $('.new-order-time').prop('selectedIndex', 0).selectric('refresh');
        });

        /**
         * trigger fetching orders which needs to add employees
         */
        $('#modal-add-employees-to-orders').on('shown.bs.modal', function () {
            // this.fetchPendingOrders();
            _this.$broadcast('fetchCompletedOrders');
        });

        $('#modal-add-employees-to-orders').on('hidden.bs.modal', function () {
            _this.autoSelectionOrders = [];
            _this.pendingOrders = [];
            _this.$broadcast('clearFetchOrderFields');
        });

        $(document).ready(function () {
            $('.new-order-time').selectric();
            // $("#position-code").selectric({
            //     onChange: function(element){
            //         alert( $(element).val() );
            //     }
            // });
            $('.new-order-time').prop('selectedIndex', 0).selectric('refresh');
        });

        // let pusher = new Pusher('a5e7c23af97b0610d9f9', {
        //     cluster: 'mt1',
        //     encrypted: true
        // });
        //
        // //Subscribe to the channel we specified in our Laravel Event
        // let channel = pusher.subscribe('es-code-updated');
        //
        // //Bind a function to a Event (the full Laravel class)
        // channel.bind('App\\Events\\CodeUpdateNotification', this.pusherMessage);
    },

    methods: {

        setSorting: function setSorting() {
            Cookies.set('sorting', Cookies.get('sorting') ? '' : 'name');
            this.sorting = Cookies.get('sorting');
            this.getOrders();
        },

        pusherMessage: function pusherMessage(data) {
            notify.success(data.message);
        },

        /**
         * fetch list of orders which needs to add employees
         */
        // fetchPendingOrders() {
        //     notify.loading(true);
        //     this.$http.get('/api/dashboard-employee-add-pending', '', (response) => {
        //         // this.pendingOrders[1] = _.forEach(response[1], function (order) {
        //         //     order.total = Math.round(((order.remaining * order.percentage) / 100));
        //         // });
        //         this.pendingOrdersAuto = response[1];
        //         this.pendingOrdersManual = response[0];
        //     }).always(() => {
        //         notify.loading(false);
        //     });
        // },

        /**
         * get list of clients
         */
        getClients: function getClients() {
            var _this2 = this;

            this.$http.get('/api/order-data', '', function (response) {
                _this2.clients = response;
            }).always(function () {});
        },

        /**
         * get list of clients
         */
        getEmployees: function getEmployees() {
            var _this3 = this;

            this.$http.get('/api/all-employee-list-data', '', function (response) {
                _this3.employees = response.employees;
            }).always(function () {});
        },

        /**
         * get orders for a week
         */
        getOrders: function getOrders() {
            var _this4 = this;

            var showLoader = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];

            orderIdDate = new Array();
            //this.orders = {};
            // orderIdTime = new Array();
            notify.loading(showLoader);
            this.$http.get('/api/dashboard-data?startDate=' + Cookies.get('startDate') + '&sorting=' + Cookies.get('sorting'), '', function (response) {
                notify.loading(false);
                _this4.orders = response.orders;
                _this4.startDate = response.startDate;
                _this4.weekDates = response.dates;
            }).always(function () {
                notify.loading(false);
            });
        },

        /**
         * set date for previous week and fetch orders
         */
        prevWeek: function prevWeek() {
            //this.startDate = moment(this.startDate, "YYYY-MM-DD").subtract(7, 'days').format("YYYY-MM-DD");
            Cookies.set('startDate', moment(this.startDate, "YYYY-MM-DD").subtract(7, 'days').format("YYYY-MM-DD"));
            this.getOrders();
        },

        /**
         * set date for next week and fetch data
         */
        nextWeek: function nextWeek() {
            //this.startDate = moment(this.startDate, "YYYY-MM-DD").add(7, 'days').format("YYYY-MM-DD");
            Cookies.set('startDate', moment(this.startDate, "YYYY-MM-DD").add(7, 'days').format("YYYY-MM-DD"));
            this.getOrders();
        },

        /**
         * send request to create a new order
         * @returns {boolean}
         */
        createOrder: function createOrder() {
            var _this5 = this;

            if (!moment(this.order.in_time, 'H:m a').isValid() || !moment(this.order.out_time, 'H:m a').isValid()) {
                notify.info('In time/Out time required.');
                return false;
            }
            var inTime = moment(this.order.date + ' ' + this.order.in_time, "YYYY-MM-DD H:m a");
            var outTime = moment(this.order.date + ' ' + this.order.out_time, "YYYY-MM-DD H:m a");
            var duration = moment.duration(outTime.diff(inTime));
            var hours = duration.asHours();
            if (hours < 1 && hours != 0) {
                outTime = outTime.add(24, 'hours');
                duration = moment.duration(outTime.diff(inTime));
                hours = duration.asHours();
            }
            if (hours > 17) {
                notify.error('Shift can not be more than 17 hrs');
                return false;
            }
            this.state = true;
            this.order.in_time = moment(this.order.in_time, "H:m a").format("HH:mm");
            this.order.out_time = moment(this.order.out_time, "H:m a").format("HH:mm");
            //this.order.position_code = this.order.position_code.position_code;
            this.$http.post('/api/order', this.order, function (response) {
                modals.hide('#modal-add-order');
                notify.success('New Order Added Successfully');
                _this5.getOrders();
                _this5.clearFields();
            }).always(function () {
                _this5.state = false;
            });
        },

        /**
         * show edit order modal
         * @param o
         */
        editModal: function editModal(o) {
            var _this6 = this;

            notify.loading(true);
            this.$http.get('/api/get-single-order/' + o.id, '', function (response) {
                _this6.currentOrder = response;
                $('#in_time_edit').combodate('setValue', moment(_this6.currentOrder.in_time, "YYYY-MM-DD HH:mm:ss").format('H:m a'), true);
                $('#out_time_edit').combodate('setValue', moment(_this6.currentOrder.out_time, "YYYY-MM-DD HH:mm:ss").format('H:m a'), true);
                $('.edit-order-time').selectric();
                _this6.setUniform(_this6.currentOrder);
                modals.showStrict("#modal-edit-order");
            }).always(function () {
                _this6.state = false;
                notify.loading(false);
            });
        },

        /**
         * set uniform for currently open order
         * @param order
         */
        setUniform: function setUniform(order) {
            if (!order.uniforms.length) {
                this.selectedUniforms = _.map(order.positions.uniforms, 'title');
            } else {
                this.selectedUniforms = _.map(order.uniforms, 'uniform');
            }
        },

        /**
         * order status details
         * @param o
         */
        statusDetails: function statusDetails(o) {
            this.currentOrder = _.cloneDeep(o);
            this.activeOrder = this.currentOrder.id;
            this.currentDate = moment(this.currentOrder.date, "YYYY-MM-DD").format('MMM DD');
            // var endTime = moment.utc(this.currentOrder.next_selection, "YYYY-MM-DD HH:mm:ss").format('YYYY-MM-DD HH:mm:ss');
            // var offset = new Date().getTimezoneOffset();
            // console.log(moment.utc().format('YYYY-MM-DD HH:mm:ss'));
            // console.log(endTime);
            // if (moment.utc(this.currentOrder.next_selection).isAfter(moment.utc())) {
            //     this.currentOrder.timeRemaining = moment.utc().preciseDiff(endTime);
            // } else {
            //     this.currentOrder.timeRemaining = "NOW";
            // }
            modals.showStrict("#status-details-modal");
        },

        removeManualSelection: function removeManualSelection(id, date) {
            var activeOrder = _.find(this.orders[date], {
                id: id
            });
            modals.hide("#modal-add-employees-to-orders");
            this.statusDetails(activeOrder);
        },

        /**
         * send request to edit an order
         * @returns {boolean}
         */
        editOrder: function editOrder() {
            var _this7 = this;

            var inTime = moment(this.currentOrder.date + ' ' + this.currentOrder.in_time, "YYYY-MM-DD H:m a");
            var outTime = moment(this.currentOrder.date + ' ' + this.currentOrder.out_time, "YYYY-MM-DD H:m a");
            var duration = moment.duration(outTime.diff(inTime));
            var hours = duration.asHours();

            if (hours < 0 && hours != 0) {
                outTime = outTime.add(24, 'hours');
                duration = moment.duration(outTime.diff(inTime));
                hours = duration.asHours();
            }
            if (hours > 17) {
                notify.error('Shift can not be more than 17 hrs');
                return false;
            }
            this.state = true;
            this.currentOrder.in_time = moment(this.currentOrder.in_time, "H:m a").format("HH:mm");
            this.currentOrder.out_time = moment(this.currentOrder.out_time, "H:m a").format("HH:mm");
            this.$http.put('/api/order/' + this.currentOrder.id, this.currentOrder, function (response) {
                modals.hide('#modal-edit-order');
                modals.hide("#additional-employees");
                notify.success('Order Edited Successfully');
                //this.getOrders();
            }).always(function () {
                _this7.state = false;
            });
        },

        /**
         * check if client already has an order
         * @param client_id
         * @param order_date
         * @returns {boolean}
         */
        checkDuplicateClient: function checkDuplicateClient(client_id, order_date) {
            var data = {
                "client_id": client_id,
                "order_date": order_date
            };
            if (_.some(orderIdDate, data)) {
                return true;
            } else {
                orderIdDate.push(data);
                return false;
            }
        },

        /**
         * check order time for clients
         * @param client_id
         * @param order_date
         * @returns {boolean}
         */
        checkDuplicateClientTime: function checkDuplicateClientTime(client_id, order_date) {
            var data = {
                "client_id": client_id,
                "order_date": order_date
            };
            if (_.some(orderIdTime, data)) {
                return true;
            } else {
                orderIdTime.push(data);
                return false;
            }
        },

        /**
         * confirmation before deleting a order
         * @param order
         */
        confirmDelete: function confirmDelete(order) {
            this.currentOrder = _.cloneDeep(order);
            notify.confirm('Are you sure you want to remove this order?', '', this.deleteOrder);
        },

        /**
         * send request to delete an order
         */
        deleteOrder: function deleteOrder() {
            var _this8 = this;

            this.$http['delete']('/api/order/' + this.currentOrder.id, '', function (response) {
                notify.success('Order Deleted');
                orderIdDate = new Array();
                _this8.getOrders();
            }).always(function () {});
        },

        /**
         * confirmation before verifying an order
         * @param type
         * @param id
         * @param modal
         */
        confirmVerifyOrder: function confirmVerifyOrder(type, id) {
            var modal = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];

            this.verificationType = type;
            this.verificationId = id;
            this.verificationModal = modal;
            notify.prompt('Are you sure you want to verify?', '', this.verifyOrder);
        },

        /**
         * verification process
         */
        verifyOrder: function verifyOrder() {
            var _this9 = this;

            this.$http.get('/api/verify-order/' + this.verificationType + '/' + this.verificationId, '', function (response) {
                //notify.success('Verification Completed');
                var verifyType = _this9.verificationType === '-' ? 'verified' : _this9.verificationType + '_verified';
                var editedBy = _this9.verificationType === '-' ? 'last_edited_by' : _this9.verificationType + '_edited_by';
                _this9.currentOrder[verifyType] = 1;
                _this9.currentOrder[editedBy] = _this9.userId;
                if (_this9.verificationModal) modals.hide(_this9.verificationModal);
                // if (this.verificationType !== '-') {
                //     this.currentOrder[this.verificationType + '_verified'] = 1;
                //     this.currentOrder[this.verificationType + '_edited_by'] = this.userId;
                // } else {
                //
                // }
                _this9.getOrders();
            }).always(function () {});
        },

        /**
         * send request to cancel an order
         * @param o
         */
        cancelOrder: function cancelOrder(o) {
            var _this10 = this;

            this.$http.get('/api/order/' + o.id, '', function (response) {
                notify.success('Order Canceled');
                orderIdDate = new Array();
                _this10.getOrders();
            }).always(function () {});
        },

        /**
         * calculate time remaining to add employee for an order
         * @param orderId
         * @param dateTime
         * @returns {boolean}
         */
        calculateRemainingHour: function calculateRemainingHour(orderId, dateTime) {
            //var endTime = moment.utc((dateTime, "YYYY-MM-DD HH:mm:ss").format('YYYY-MM-DD hh:mm:ss'));
            var offset = new Date().getTimezoneOffset();
            var endTime = moment(dateTime, "YYYY-MM-DD HH:mm:ss").format('YYYY-MM-DD HH:mm:ss');
            var diff = moment(endTime).isAfter(moment().add(offset, 'm'));
            if (diff) {
                this.setSelectionTimer(orderId, dateTime);
                return true;
            } else {
                return false;
            }
            //return moment.duration(startTime.diff(endTime)).humanize();
        },

        /**
         * determine is order in_time is in past
         * @param start
         * @returns {boolean}
         */
        calculatePastOrder: function calculatePastOrder(start) {
            var offset = new Date().getTimezoneOffset();
            var inTime = moment(start, "YYYY-MM-DD HH:mm:ss").format('YYYY-MM-DD HH:mm:ss');
            return moment(inTime).isAfter(moment().add(offset, 'm'));
        },

        /**
         * set timer for a employee selection
         * @param orderId
         * @param dateTime
         */
        setSelectionTimer: function setSelectionTimer(orderId, dateTime) {
            var endTime = moment(dateTime, "YYYY-MM-DD HH:mm:ss").format('YYYY-MM-DD HH:mm:ss');
            var offset = new Date().getTimezoneOffset();
            setInterval(function (interval) {
                var diff = moment(endTime).isAfter(moment().add(offset, 'm'));
                if (diff) {
                    //$('#timer-' + orderId).text(moment(moment().add(offset, 'm')).preciseDiff(endTime));
                } else {
                        $('#timer-' + orderId).removeClass('bg-grey-800');
                        $('#timer-' + orderId).addClass('bg-danger-400');
                        //$('#timer-' + orderId).html("<a href='#' v-on:click='processAutoSelection(" + orderId + ")'>Add New Employee Now</a>");
                    }
            }, 1000);
        },

        /**
         * automatically add employee based on auto selection rules
         */
        processAutoSelection: function processAutoSelection() {
            var _this11 = this;

            notify.loading(true);
            var data = {
                ids: this.autoSelectionOrders,
                orders: this.pendingOrdersAuto
            };
            this.$http.put('/api/assign-employee-order', data, function (response) {
                _this11.autoSelectionOrders = [];
                _this11.getOrders();
                _this11.fetchPendingOrders();
                notify.success('Employee Added');
            }).always(function () {
                notify.loading(false);
            });
        },

        /**
         * show employee records
         * @param employee
         * @param orderId
         * @param orderDate
         * @param showModal
         * @param previousWeek
         */
        employeeOrderRecords: function employeeOrderRecords(employee, orderId) {
            var orderDate = arguments.length <= 2 || arguments[2] === undefined ? '' : arguments[2];

            var _this12 = this;

            var showModal = arguments.length <= 3 || arguments[3] === undefined ? true : arguments[3];
            var previousWeek = arguments.length <= 4 || arguments[4] === undefined ? false : arguments[4];

            notify.loading(true);
            this.previousWeek = previousWeek ? 1 : 0;
            this.activeEmployee = _.cloneDeep(employee);
            var employeeId = employee.pivot ? employee.pivot.employee_id : this.activeEmployee.id;
            this.$http.get('/api/employee-order-records/' + employeeId + '?previous_week=' + this.previousWeek + '&startDate=' + Cookies.get('startDate'), '', function (response) {
                _this12.employeeOrders = _.groupBy(_.cloneDeep(response.orders), 'day');
                _this12.app = response.app;
                if (orderId) {
                    var activeOrder = _.find(response.orders[orderDate].data, {
                        order_id: orderId
                    });
                    _this12.setEmployeeOrder(activeOrder, moment(activeOrder.order.date, "YYYY-MM-DD").format('MMM DD'));
                    _this12.setActiveDate(orderDate, false);
                }
                _this12.activeEmployee = response.employee;
                _this12.activeNotes = _.groupBy(response.employee.notes, 'category');
                _this12.response = [];
                if (showModal) {
                    modals.showStrict("#employee-order-records");
                    // $('#employee-list').prop('selectedIndex', 0).selectric('refresh');
                }
            }).always(function () {
                notify.loading(false);
            });
        },

        /**
         * show records for previous week
         * @param previousWeek
         * @param orderId
         */
        employeeRecordsPreviousWeek: function employeeRecordsPreviousWeek(previousWeek) {
            var _this13 = this;

            var orderId = arguments.length <= 1 || arguments[1] === undefined ? '' : arguments[1];

            notify.loading(true);
            this.$http.get('/api/employee-order-records/' + this.activeEmployee.pivot.employee_id + '?previous_week=' + previousWeek + '&startDate=' + this.previousRecordStartDate, '', function (response) {
                _this13.employeePreviousOrders = response.orders;
                if (orderId) {
                    var activeOrder = _.find(response.orders[orderDate].data, {
                        order_id: orderId
                    });
                    _this13.setEmployeeOrder(activeOrder, moment(activeOrder.order.date, "YYYY-MM-DD").format('MMM DD'));
                }
                modals.showStrict("#employee-previous-records");
            }).always(function () {
                notify.loading(false);
            });
        },

        /**
         * show modal for employee job search
         */
        employeeJobSearch: function employeeJobSearch() {
            modals.showStrict("#employee-job-search");
            this.$broadcast('employeeJobSearchEvent');
        },

        /**
         * close previous records modal
         */
        closePreviousRecord: function closePreviousRecord() {
            modals.hide("#employee-previous-records");
        },

        /**
         * set an order as active for employee orders
         * @param employeeOrder
         * @param date
         */
        setEmployeeOrder: function setEmployeeOrder(employeeOrder, date) {
            employeeOrder.status === 'move' ? this.showStatus = 0 : this.showStatus = 1;
            this.activeOrder = employeeOrder.order_id;
            this.employeeOrder = _.cloneDeep(employeeOrder);
            if (this.employeeOrder.order.uniforms.length > 0) {
                this.employeeOrder.uniforms = _.map(this.employeeOrder.order.uniforms, 'uniform');
            } else {
                if (this.employeeOrder.order.positions) this.employeeOrder.uniforms = _.map(this.employeeOrder.order.positions.uniforms, 'title');else {
                    this.employeeOrder.uniforms = [];
                }
            }
            this.activeDate = moment(this.employeeOrder.order.date, "YYYY-MM-DD").format('MMM DD');
            this.setActiveDate(date, false);
        },

        /**
         * update status for an employee of an order
         */
        updateEmployeeOrderStatus: function updateEmployeeOrderStatus() {
            var _this14 = this;

            modals.hide("#employee-additional-status-modal");
            notify.loading(true);
            if (this.employeeOrder) {
                (function () {
                    var orderId = _this14.employeeOrder.order_id;
                    var orderDate = _this14.employeeOrder.date;
                    _this14.$http.post('/api/employee-order-status-update/' + _this14.employeeOrder.employee_order_id, {
                        status: _this14.employeeOrder.status,
                        pay_rate: _this14.employeeOrder.pay_rate
                    }, function (response) {
                        _this14.resetValues();
                        _this14.getOrders();
                        _this14.currentOrder = response;
                        _this14.employeeOrderRecords(_this14.activeEmployee, orderId, orderDate);
                    }).always(function () {
                        notify.loading(false);
                    });
                })();
            } else {
                notify.loading(false);
                notify.info('Select an order first');
            }
        },

        updateEmployeeOrderNote: function updateEmployeeOrderNote() {
            var _this15 = this;

            notify.loading(true);
            if (this.employeeOrder) {
                (function () {
                    var orderId = _this15.employeeOrder.order_id;
                    var orderDate = _this15.employeeOrder.date;
                    _this15.$http.post('/api/employee-order-note-update/' + _this15.employeeOrder.employee_order_id, {
                        note: _this15.employeeOrder.employee_note
                    }, function (response) {
                        _this15.resetValues();
                        _this15.getOrders();
                        _this15.currentOrder = response;
                        _this15.employeeOrderRecords(_this15.activeEmployee, orderId, orderDate);
                    }).always(function () {
                        notify.loading(false);
                    });
                })();
            } else {
                notify.loading(false);
                notify.info('Select an order first');
            }
        },

        /**
         * set a date as active on employee order calender
         * @param string
         */
        setActiveDate: function setActiveDate(string) {
            var status = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];

            this.activeDate = string;
            if (status) {
                this.employeeOrder = false;
                this.activeOrder = '';
            }
        },

        /**
         * set an order as active on employee order calender
         * @param string
         */
        setActiveOrder: function setActiveOrder(string) {
            this.activeOrder = string;
        },

        /**
         * clear order creation fields
         */
        clearFields: function clearFields() {
            this.order = {
                client_id: '',
                position_code: '',
                max_pay_rate: null,
                no_of_employee: 0,
                in_time: '',
                out_time: '',
                date: '',
                special_instruction: '',
                source_posting_info: '',
                pay_rate_increase: '',
                auto_selection: 1,
                text_instruction: '',
                rate_change_impact: 0
            };
        },

        resetValues: function resetValues() {
            this.employeeOrder = false;
            this.activeDate = '';
            this.activeOrder = '';
            // this.employee = 0;
            // $('#employee-list').select2({
            //     data: 0
            // });
            // $("#employee-list").val(0).change();
        },

        /**
         * show uniform edit modal(edit order)
         */
        editUniformsModal: function editUniformsModal() {
            //this.currentUniforms = _.groupBy(this.currentOrder.positions.uniforms, 'category_id');
            if (this.currentOrder.uniforms.length > 0) {
                this.$set('currentUniforms', _.map(this.currentOrder.uniforms, 'uniform'));
            } else {
                this.$set('currentUniforms', _.map(this.currentOrder.positions.uniforms, 'title'));
            }
            // var uniforms = this.selectedUniforms;
            // this.$set('currentUniforms', uniforms);

            modals.showStrict("#modal-edit-uniforms");
            this.$nextTick(function () {
                var oldIndex;
                var group = $('.sorted_table').sortable({
                    containerSelector: 'table',
                    itemPath: '> tbody',
                    itemSelector: 'tr',
                    placeholder: '<tr class="placeholder"/>',
                    group: 'sorted_table',
                    onDragStart: function onDragStart($item, container, _super) {
                        oldIndex = $item.index();
                        $item.appendTo($item.parent());
                        _super($item, container);
                    }
                });
            });
        },

        /**
         * show modal for editing text instruction
         */
        textInstructionModal: function textInstructionModal() {
            modals.showStrict("#text-instruction");
        },

        /**
         * send request to edit text instruction for an order
         */
        textInstruction: function textInstruction() {
            var _this16 = this;

            this.$http.put('/api/order-text-instruction/' + this.currentOrder.id, this.currentOrder, function (response) {
                modals.hide('#text-instruction');
                notify.success('Text Instruction Edited Successfully');
                _this16.currentOrder.text_instruction = response.text_instruction;
                _this16.currentOrder.instruction_edited_by = response.instruction_edited_by;
                _this16.currentOrder.instruction_verified = response.instruction_verified;
                //this.getOrders();
            }).always(function () {
                _this16.state = false;
            });
        },

        /**
         * show rate change impact modal(edit order)
         */
        rateChangeImpactModal: function rateChangeImpactModal() {
            modals.showStrict("#rate-change-impact");
        },

        /**
         * send request to update rate change impact(edit order)
         */
        rateChangeImpact: function rateChangeImpact() {
            var _this17 = this;

            this.$http.put('/api/order-rate-change-impact/' + this.currentOrder.id, this.currentOrder, function (response) {
                modals.hide('#rate-change-impact');
                notify.success('Order Rate Change Impact Updated');
                _this17.currentOrder.rate_edited_by = response.rate_edited_by;
                _this17.currentOrder.rate_verified = response.rate_verified;
                _this17.getOrders();
            }).always(function () {
                _this17.state = false;
            });
        },

        /**
         * add a new uniform to the list(edit order)
         */
        addUniform: function addUniform() {
            if (this.uniform) {
                this.currentUniforms.push(this.uniform);
                this.uniform = '';
            }
        },

        /**
         * send the request to save a new uniform
         */
        saveUniforms: function saveUniforms() {
            var _this18 = this;

            notify.loading(true);
            var uniforms = [];
            //push each uniforms to array
            $("span.uniforms").each(function () {
                uniforms.push($(this).html());
            });
            this.$http.put('/api/order/uniforms/' + this.currentOrder.id, {
                uniforms: uniforms
            }, function (response) {
                modals.hide("#modal-edit-uniforms");
                _this18.currentOrder.uniforms = response.uniforms;
                _this18.currentOrder.uniform_edited_by = response.uniform_edited_by;
                _this18.currentOrder.uniform_verified = response.uniform_verified;
                _this18.setUniform(response);
            }).always(function () {
                notify.loading(false);
            });
        },

        /**
         * add notes for an employee for an order
         * @param note
         * @param category
         */
        addNote: function addNote(note, category) {
            var _this19 = this;

            notify.loading(true);
            this.$http.post('/api/employee-add-note', {
                note: note,
                employeeId: this.activeEmployee.pivot.employee_id,
                category: category
            }, function (response) {
                note = '';
            }).always(function () {
                _this19.employeeOrderRecords(_this19.activeEmployee);
            });
        },

        getNotes: function getNotes() {
            this.$http.get('url', data, function (response) {}).always(function () {});
        },

        /**
         * close notes modal
         */
        closeNotes: function closeNotes() {
            modals.hide("#notes-modal");
        },

        /**
         * get orders of a client
         * @param clientId
         */
        getClientOrders: function getClientOrders(clientId) {
            var _this20 = this;

            notify.loading(true);
            this.$http.get('/api/client-orders/' + clientId, '', function (response) {
                _this20.clientOrders = response.orders;
                _this20.currentClient = response.client;
                modals.showStrict("#client-dashboard");
            }).always(function () {
                notify.loading(false);
            });
        },

        /**
         * trigger employee selection
         * @param orderId
         */
        selectEmployees: function selectEmployees(orderId) {
            this.$broadcast('triggerOrderEmployeeList', orderId);
        },

        /**
         * check user inactivity on dashboard
         */
        checkIdleTime: function checkIdleTime() {
            idleSecondsCounter++;
            if (idleSecondsCounter >= IDLE_TIMEOUT) {
                idleSecondsCounter = 0;
                this.getOrders();
            }
        },

        /**
         * generic function for closing modals
         * @param modalId
         */
        closeModal: function closeModal(modalId) {
            modals.hide(modalId);
        },

        /**
         * save employee responses
         */
        saveResponse: function saveResponse() {
            var _this21 = this;

            notify.loading(true);
            var data = {
                employee_id: this.activeEmployee.pivot.employee_id,
                order_id: this.activeEmployee.pivot.order_id,
                responses: this.response
            };
            this.$http.post('/api/save-employee-response', data, function (response) {
                modals.hide("#no-answer");
                notify.success('Employee Response Saved');
                _this21.response = [];
            }).always(function () {
                notify.loading(false);
            });
        },

        /**
         * re-arrange employees according to list
         * @param data
         * @returns {Array}
         */
        reArrangeEmployees: function reArrangeEmployees(data) {
            var order = ['re-confirm', 'confirm', 'need-change', 'move', 'did-not-re-confirm'],
                sorted = [],
                items = {},
                i;

            for (i = 0; i < data.length; i++) {
                var key = data[i].pivot.status + i;
                items[key] = data[i];
            }

            for (i = 0; i < order.length; i++) {
                for (var count = 0; count < data.length; count++) {
                    var key1 = order[i] + count;
                    if (key1 in items) sorted.push(items[key1]);
                }
            }
            return sorted;
        },
        /**
         * show rate change impact all modal
         */
        impactAllModal: function impactAllModal() {
            modals.showStrict("#impact-all");
        },

        /**
         * update impact all value
         * @param val
         */
        impactAll: function impactAll(val) {
            this.currentOrder.rate_change_impact = val;
        },

        /**
         * on click copy text (e-mail and phone number)
         * @param element
         */
        selectText: function selectText(element) {
            var doc = document,
                text = doc.getElementById(element),
                range,
                selection;
            if (doc.body.createTextRange) {
                range = document.body.createTextRange();
                range.moveToElementText(text);
                range.select();
            } else if (window.getSelection) {
                selection = window.getSelection();
                range = document.createRange();
                range.selectNodeContents(text);
                selection.removeAllRanges();
                selection.addRange(range);
            }
        },

        /**
         * show icons related to moving
         * @param employee
         * @returns {*}
         */
        moveIcons: function moveIcons() {
            var employee = arguments.length <= 0 || arguments[0] === undefined ? null : arguments[0];

            if (employee) {
                if (employee.pivot.move_from != 0 && employee.pivot.move_from == employee.pivot.order_id) {
                    return '<i class="fa fa fa-arrow-up text-danger font-10"></i>';
                }

                if (employee.pivot.move_to != 0 && employee.pivot.move_to == employee.pivot.order_id) {
                    return '<i class="fa fa fa-arrow-down text-success font-10"></i>';
                }

                return '';
            } else {
                return '<i class="fa fa-circle font-7 mr-10"></i>';
            }
        },

        /**
         * confirm process move
         * @param status
         */
        confirmProcessMove: function confirmProcessMove(status, type) {
            this.moveStatus = status;
            notify.prompt('Are you sure you want to ' + type + ' this move?', '', this.processMove);
        },

        /**
         * process move for an employee(accept/deny)
         */
        processMove: function processMove() {
            var _this22 = this;

            notify.loading(true);
            var data = {
                'employeeOrder': this.employeeOrder,
                'status': this.moveStatus
            };

            this.$http.post('/api/process-move', data, function (response) {
                notify.success('Operation Successful');
                _this22.employeeOrderRecords(_this22.activeEmployee);
                _this22.resetValues();
                _this22.getOrders();
                _this22.currentOrder = response;
            }).always(function () {
                notify.loading(false);
            });
        },

        /**
         * count properties of an object
         * @param obj
         * @returns {number}
         */
        countProperties: function countProperties(obj) {
            var count = 0;

            for (var property in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, property)) {
                    count++;
                }
            }
            return count;
        },

        /**
         * reset order timer
         */
        resetOrderTimer: function resetOrderTimer() {
            var _this23 = this;

            this.$http.get('/api/reset-order-timer/' + this.currentOrder.id, '', function (response) {
                notify.success('Timer Reset Completed');
                _this23.currentOrder = response;
                _this23.getOrders();
                var endTime = moment(_this23.currentOrder.next_selection, "YYYY-MM-DD HH:mm:ss").format('YYYY-MM-DD HH:mm:ss');
                var offset = new Date().getTimezoneOffset();
                if (moment(endTime).isAfter(moment().add(offset, 'm'))) {
                    _this23.currentOrder.timeRemaining = moment(moment().add(offset, 'm')).preciseDiff(endTime);
                } else {
                    _this23.currentOrder.timeRemaining = "NOW";
                }
            }).always(function () {
                _this23.state = false;
            });
        },

        /**
         * group selected employees by selection type
         * @param employees
         */
        groupSelectedEmployees: function groupSelectedEmployees(employees) {
            if (employees) {
                //return _.orderBy(employees, ['selection_type', 'fullName'], ['desc', 'asc']);
                return _.groupBy(employees, 'selection_type');
            }
            return [];
        },

        /**
         * remove selected employees from an order
         */
        removeSelectedEmployees: function removeSelectedEmployees() {
            var _this24 = this;

            notify.loading(true);
            this.$http.post('/api/remove-selected-employees/' + this.currentOrder.id, {
                ids: this.ids
            }, function (response) {
                _this24.currentOrder = response;
                _this24.ids = [];
            }).always(function () {
                notify.loading(false);
            });
        },

        /**
         * hide auto selection list and show select employees modal
         * @param id
         */
        selectEmployeePopup: function selectEmployeePopup(id) {
            modals.hide('#modal-add-employees-to-orders');
            this.selectEmployees(id);
        },

        /**
         * fetch list of orders which needs to add employees
         */
        getPendingDashboardOperations: function getPendingDashboardOperations() {
            var _this25 = this;

            this.$http.get("/api/dashboard-pending-order-operation", "", function (response) {
                _this25.pendingDashboardOperations = response.total;
            }).always(function () {});
        },

        /**
         * show modal for additional status
         */
        showAdditionalStatus: function showAdditionalStatus() {
            this.employeeAdditionalStatus = null;
            modals.showStrict("#employee-additional-status-modal");
        },

        /**
         * check is shift start time is in future and how many hours left
         * @param {timestamp} inTime
         */
        checkInTime: function checkInTime(inTime) {
            if (moment().isBefore(moment.utc(inTime).add(4, 'hours'))) {
                return moment.utc(inTime).diff(moment(), 'hours') + 4;
            } else {
                return 0;
            }
        },

        /**
         * submit additional status
         */
        submitAdditionalStatus: function submitAdditionalStatus() {
            this.employeeOrder.status = this.employeeAdditionalStatus;
            this.updateEmployeeOrderStatus();
        },

        showAddiotnalEmployeeModal: function showAddiotnalEmployeeModal() {
            modals.showStrict("#additional-employees");
        },

        hideAdditionalEmployeeModal: function hideAdditionalEmployeeModal() {
            modals.hide("#additional-employees");
        },

        /**
         * Count total number of additional employees
         * @param {String} employees
         */
        countAdditionalEmployees: function countAdditionalEmployees(employees) {
            var totalEmployees = employees.split(/\r|\r\n|\n/);
            var count = 0;
            totalEmployees.map(function (employee) {
                if (employee.length) count++;
            });
            return count ? count : '';
        },

        popOverContent: function popOverContent(o) {
            this.$nextTick(function () {
                $('[data-popup="popover"]').popover();
            });
            var order = _.cloneDeep(o);
            return order.special_instruction + '<br><br>' + (order.additional_employees.length ? '<div class="text-left text-black">Extra Employees</div>' : '') + order.additional_employees.split('\n').join('<br>');
        },

        /**
         * get selected employees for an order
         * @param o
         */
        setSelectedEmployees: function setSelectedEmployees(o) {
            var _this26 = this;

            if (o.selectedEmployees.length) {
                return;
            }

            notify.loading(true);
            this.$http.get('/api/order-selected-employees/' + o.id + '?sorting=' + Cookies.get('sorting'), function (response) {
                o.selectedEmployees = response;
                _this26.ids = [];
            }).always(function () {
                notify.loading(false);
            });
        }

    }
});
module.exports = exports['default'];

},{"./../../../mixed/modals":10,"./../../../mixed/notify":11,"./employee-records":109,"./select-employees":123}],108:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});
var notify = require('./../../../mixed/notify');
var modals = require('./../../../mixed/modals');

var deviceColumns = [{
    name: 'id',
    title: '#ID',
    sortField: 'id'
}, {
    name: 'name',
    title: 'Name',
    sortField: 'name'
}, {
    name: 'device_id',
    title: 'Device ID',
    sortField: 'device_id'
}, '__actions'];

// create pagination component using bootstrap styling
Vue.component('vuetable-pagination-bootstrap', {
    template: '#vuetable-pagination-bootstrap-template',
    mixins: [paginationMixin],
    methods: {
        loadPage: function loadPage(page) {
            this.$dispatch('vuetable-pagination:change-page', page);
        }
    }
});

exports['default'] = Vue.extend({
    data: function data() {
        return {
            state: false,
            categories: [],
            device: {
                name: '',
                device_id: ''
            },
            currentDevice: {
                name: '',
                device_id: ''
            },
            query: [],
            columns: deviceColumns,
            moreParams: [],
            sortOrder: {
                field: 'id',
                direction: 'asc'
            },
            paginationInfoTemplate: 'vuetable-pagination-bootstrap',
            itemActions: [{
                name: 'edit-device',
                label: '',
                icon: 'icon-pencil7 text-primary-600',
                'class': ''
            }, {
                name: 'delete-device',
                label: '',
                icon: 'icon-trash text-danger-600',
                'class': ''
            }]
        };
    },

    events: {
        'vuetable:action': function vuetableAction(action, data) {
            if (action == 'edit-device') {
                this.editModal(data);
            }
            if (action == 'delete-device') {
                this.confirmDelete(data);
            }
        },
        'vuetable:loading': function vuetableLoading() {
            notify.loading(true);
        },
        'vuetable:load-success': function vuetableLoadSuccess(response) {
            notify.loading(false);
        },
        'vuetable:load-error': function vuetableLoadError(response) {
            notify.loading(false);
            console.log('Load Error: ', response);
        }
    },
    ready: function ready() {},

    methods: {
        createDevice: function createDevice() {
            var _this = this;

            this.state = true;
            this.$http.post('/api/device', this.device, function (response) {
                modals.hide('#modal_add_device');
                notify.success('New Device Added Successfully');
                _this.$broadcast('vuetable:refresh');
            }).always(function () {
                _this.state = false;
            });
        },

        editModal: function editModal(device) {
            this.currentDevice = _.clone(device);
            modals.showStrict('#modal_edit_device');
        },

        editDevice: function editDevice() {
            var _this2 = this;

            this.state = true;
            this.$http.put('/api/device/' + this.currentDevice.id, this.currentDevice, function (response) {
                $('#modal_edit_device').modal('hide');
                notify.success('Device Edited Successfully');
                _this2.$broadcast('vuetable:reload');
            }).always(function () {
                _this2.state = false;
            });
        },

        confirmDelete: function confirmDelete(device) {
            this.currentDevice = device;
            notify.confirm('Are you sure you want to remove this device?', '', this.deleteDevice);
        },

        deleteDevice: function deleteDevice() {
            var _this3 = this;

            this.$http['delete']('/api/device/' + this.currentDevice.id, '', function (response) {}).always(function () {
                _this3.$broadcast('vuetable:reload');
            });
        },

        setFilter: function setFilter() {
            this.moreParams = ['filter=' + this.query];
            this.$nextTick(function () {
                this.$broadcast('vuetable:refresh');
            });
        },

        status: function status(val) {
            return parseInt(val) === 1 ? '<span class="label label-danger">Mandatory</span>' : '<span class="label label-success">Optional</span>';
        }
    }
});
module.exports = exports['default'];

},{"./../../../mixed/modals":10,"./../../../mixed/notify":11}],109:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});
var notify = require('./../../../mixed/notify');
var modals = require('./../../../mixed/modals');

exports['default'] = Vue.extend({
    filters: {
        timeEarly: function timeEarly(time, early) {
            return moment(time, "YYYY-MM-DD HH:mm:ss").subtract(early, 'minutes').format('h:m a');
        }
    },

    data: function data() {
        return {
            activeDate: '',
            activeOrder: '',
            currentDate: '',
            orders: {},
            clientOrders: {},
            employees: {},
            employee: '',
            employeePreviousOrders: {},
            employeeOrder: false,
            statuses: {
                'contact': 'CONTACT',
                'confirm': 'CONFIRM',
                're-confirm': 'RE-CONFIRM',
                'need-change': 'NEED-CHANGE',
                "cant-work-time": "CAN'T(this time)",
                "cant-work-job": "CAN'T(this job)",
                'delete': 'DELETE'
            }
        };
    },

    props: ['employeeOrders', 'activeEmployee', "getOrders"],

    watch: {},

    events: {
        triggerEmployeeList: function triggerEmployeeList(orderId) {
            this.orderId = orderId;
            this.getEmployees();
        }
    },

    ready: function ready() {
        //this.orderId = window.location.pathname.split('/')[3];
        //this.getEmployees();
    },

    methods: {
        setEmployeeOrder: function setEmployeeOrder(employeeOrder, string) {
            this.activeOrder = employeeOrder.order_id;
            this.employeeOrder = _.cloneDeep(employeeOrder);
            if (this.employeeOrder.order.uniforms.length > 0) {
                this.employeeOrder.uniforms = _.map(this.employeeOrder.order.uniforms, 'uniform');
            } else {
                this.employeeOrder.uniforms = _.map(this.employeeOrder.order.positions.uniforms, 'title');
            }
            this.activeDate = moment(this.employeeOrder.order.date, "YYYY-MM-DD").format('MMM DD');
        },

        updateEmployeeOrderStatus: function updateEmployeeOrderStatus() {
            var _this = this;

            notify.loading(true);
            this.$http.post('/api/employee-order-status-update/' + this.employeeOrder.employee_order_id, {
                status: this.employeeOrder.status,
                pay_rate: this.employeeOrder.pay_rate
            }, function (response) {
                _this.employeeRecordsPreviousWeek(1);
                _this.currentOrder = response;
            }).always(function () {
                notify.loading(false);
            });
        },

        setActiveDate: function setActiveDate(string) {
            this.activeDate = string;
            this.employeeOrder = false;
            this.activeOrder = '';
        },

        setActiveOrder: function setActiveOrder(string) {
            this.activeOrder = string;
        },

        /**
         * close previous records modal
         */
        closePreviousRecord: function closePreviousRecord() {
            modals.hide("#employee-previous-records");
            this.$dispatch('fetchOrders');
            this.$dispatch('fetchEmployeeRecords', this.activeEmployee);
        },

        /**
         * show records for previous week
         * @param previousWeek
         * @param orderId
         */
        employeeRecordsPreviousWeek: function employeeRecordsPreviousWeek(previousWeek) {
            var _this2 = this;

            var orderId = arguments.length <= 1 || arguments[1] === undefined ? '' : arguments[1];

            notify.loading(true);
            this.$http.get('/api/employee-order-records/' + this.activeEmployee.pivot.employee_id + '?previous_week=' + previousWeek, '', function (response) {
                _this2.employeeOrders = response.orders;
            }).always(function () {
                notify.loading(false);
            });
        }

    }
});
module.exports = exports['default'];

},{"./../../../mixed/modals":10,"./../../../mixed/notify":11}],110:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});
var notify = require('./../../../mixed/notify');

exports['default'] = Vue.extend({
    data: function data() {
        return {
            state: false
        };
    },

    events: {},

    ready: function ready() {},

    methods: {}
});
module.exports = exports['default'];

},{"./../../../mixed/notify":11}],111:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});
var notify = require('./../../../mixed/notify');

exports['default'] = Vue.extend({
    data: function data() {
        return {
            state: false
        };
    },

    events: {},

    ready: function ready() {},

    methods: {}
});
module.exports = exports['default'];

},{"./../../../mixed/notify":11}],112:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});
var notify = require('./../../../mixed/notify');

exports['default'] = Vue.extend({
    data: function data() {
        return {
            state: false
        };
    },

    events: {},

    ready: function ready() {},

    methods: {}
});
module.exports = exports['default'];

},{"./../../../mixed/notify":11}],113:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});
var notify = require('./../../../mixed/notify');

exports['default'] = Vue.extend({
    data: function data() {
        return {
            state: false,
            employees: {},
            sortOrders: true,
            sortKey: "action",
            hireDate: 1
        };
    },

    events: {},

    watch: {
        'hireDate': function hireDate(val) {
            this.getEmployees();
        }
    },

    ready: function ready() {
        this.getEmployees();
    },

    methods: {
        getEmployees: function getEmployees() {
            var _this = this;

            notify.loading(true);
            this.$http.get('/api/missing-employees?hireDate=' + this.hireDate, '', function (response) {
                _this.employees = response;
            }).always(function () {
                notify.loading(false);
            });
        },

        sortBy: function sortBy(field, reverse, primer) {
            var key = primer ? function (x) {
                return primer(x[field]);
            } : function (x) {
                return x[field];
            };

            reverse = !reverse ? 1 : -1;

            return function (a, b) {
                return a = key(a), b = key(b), reverse * ((a > b) - (b > a));
            };
        },

        sortEmployees: function sortEmployees(field, reverse) {
            var primer = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];

            this.sortOrders = reverse;
            this.sortKey = field;
            this.employees.sort(this.sortBy(field, reverse, primer));
        }
    }
});
module.exports = exports['default'];

},{"./../../../mixed/notify":11}],114:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});
var notify = require('./../../../mixed/notify');

exports['default'] = Vue.extend({
    data: function data() {
        return {
            state: false
        };
    },

    events: {},

    ready: function ready() {},

    methods: {}
});
module.exports = exports['default'];

},{"./../../../mixed/notify":11}],115:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});
var notify = require('./../../../mixed/notify');

exports['default'] = Vue.extend({
    data: function data() {
        return {
            state: false
        };
    },

    events: {},

    ready: function ready() {},

    methods: {}
});
module.exports = exports['default'];

},{"./../../../mixed/notify":11}],116:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});
var notify = require('./../../../mixed/notify');

exports['default'] = Vue.extend({
    data: function data() {
        return {
            state: false
        };
    },

    events: {},

    ready: function ready() {},

    methods: {}
});
module.exports = exports['default'];

},{"./../../../mixed/notify":11}],117:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});
var notify = require('./../../../mixed/notify');
var modals = require('./../../../mixed/modals');

var tableColumns = [{
    name: 'id',
    title: '#ID',
    sortField: 'id'
},, {
    name: 'client.name',
    title: 'Client',
    sortField: 'client_id'
}, {
    name: 'positions.title',
    title: 'Position',
    sortField: 'position_code'
}, {
    name: 'date',
    title: 'Date',
    sortField: 'date'
}, '__actions'];

// create pagination component using bootstrap styling
Vue.component('vuetable-pagination-bootstrap', {
    template: '#vuetable-pagination-bootstrap-template',
    mixins: [paginationMixin],
    methods: {
        loadPage: function loadPage(page) {
            this.$dispatch('vuetable-pagination:change-page', page);
        }
    }
});

exports['default'] = Vue.extend({
    data: function data() {
        return {
            order: {
                client_id: '',
                position_code: '',
                no_of_employee: 0,
                in_time: '',
                out_time: '',
                date: '',
                special_instruction: ''
            },
            currentOrder: {},
            activeClient: {},
            clients: {},
            positions: {},
            in_time_start: '',
            in_time_end: '',
            out_time_start: '',
            out_time_end: '',
            query: '',
            moreParams: [],
            perPage: 150,
            state: false,
            columns: tableColumns,
            sortOrder: {
                field: 'id',
                direction: 'asc'
            },
            paginationInfoTemplate: 'vuetable-pagination-bootstrap',
            itemActions: [{
                name: 'edit-order',
                label: '',
                icon: 'icon-pencil7 text-primary-600',
                'class': ''
            }, {
                name: 'delete-order',
                label: '',
                icon: 'icon-trash text-danger-600 left-m-30',
                'class': ''
            }]
        };
    },

    watch: {
        'perPage': function perPage(val, oldVal) {
            this.$broadcast('vuetable:refresh');
        },

        'order.client_id': function orderClient_id(val) {
            this.activeClient = _.clone(_.find(this.clients, function (o) {
                return o.id == val;
            }));
        }
    },

    events: {
        'vuetable:action': function vuetableAction(action, data) {
            console.log('vuetable:action', action, data);
            if (action == 'edit-order') {
                this.editModal(data);
            }

            if (action == 'delete-order') {
                this.confirmDelete(data);
            }
        },
        'vuetable:loading': function vuetableLoading() {
            notify.loading(true);
        },
        'vuetable:load-success': function vuetableLoadSuccess(response) {
            notify.loading(false);
        },
        'vuetable:load-error': function vuetableLoadError(response) {
            notify.loading(false);
            console.log('Load Error: ', response);
        }
    },

    ready: function ready() {
        $('#in_time').combodate({
            minuteStep: 15,
            minHour: 1,
            maxHour: 12
        });
        $('#out_time').combodate({
            minuteStep: 15,
            minHour: 1,
            maxHour: 12
        });
        $('#in_time_edit').combodate({
            minuteStep: 15,
            minHour: 1,
            maxHour: 12
        });
        $('#out_time_edit').combodate({
            minuteStep: 15,
            minHour: 1,
            maxHour: 12
        });
        this.getClients();
    },

    methods: {
        getClients: function getClients() {
            var _this = this;

            this.$http.get('/api/order-data', '', function (response) {
                _this.clients = response;
            }).always(function () {});
        },
        createOrder: function createOrder() {
            var _this2 = this;

            this.state = true;
            this.$http.post('/api/order', this.order, function (response) {
                modals.hide('#modal-add-order');
                notify.success('New Order Added Successfully');
                _this2.clearFields();
            }).always(function () {
                _this2.$broadcast('vuetable:reload');
                _this2.state = false;
            });
        },

        editModal: function editModal(o) {
            var that = this;
            this.currentOrder = _.clone(o);
            $('#in_time_edit').combodate('setValue', moment(that.currentOrder.in_time, "HH:mm:ss").format('HH:mm a'), true);
            $('#out_time_edit').combodate('setValue', moment(that.currentOrder.out_time, "HH:mm:ss").format('HH:mm a'), true);
            modals.showStrict("#modal-edit-order");
        },

        editOrder: function editOrder() {
            var _this3 = this;

            this.state = true;
            this.$http.put('/api/order/' + this.currentOrder.id, this.currentOrder, function (response) {
                modals.hide('#modal-edit-order');
                notify.success('Order Edited Successfully');
            }).always(function () {
                _this3.$broadcast('vuetable:reload');
                _this3.state = false;
            });
        },

        confirmDelete: function confirmDelete(order) {
            this.currentOrder = _.cloneDeep(order);
            notify.confirm('Are you sure you want to remove this order?', '', this.deleteOrder);
        },

        deleteOrder: function deleteOrder() {
            var _this4 = this;

            this.$http['delete']('/api/order/' + this.currentOrder.id, '', function (response) {
                notify.success('Order Deleted');
                orderIdDate = new Array();
                _this4.getOrders();
            }).always(function () {
                _this4.$broadcast('vuetable:reload');
            });
        },

        clearFields: function clearFields() {
            this.order = {
                client_id: '',
                position_code: '',
                no_of_employee: 0,
                in_time: '',
                out_time: '',
                date: '',
                special_instruction: ''
            };
        }
    }
});
module.exports = exports['default'];

},{"./../../../mixed/modals":10,"./../../../mixed/notify":11}],118:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});
var notify = require('./../../../mixed/notify');

exports['default'] = Vue.extend({
    data: function data() {
        return {
            role: '',
            roles: {},
            permissions: {},
            rolePermissions: [],
            state: false
        };
    },

    ready: function ready() {
        this.getData();
    },

    watch: {
        'role': function role(val, oldVal) {
            this.setRole(val);
        }
    },

    methods: {

        getData: function getData() {
            var _this = this;

            this.$http.get('/api/permission-data/', '', function (response) {
                _this.roles = response.roles;
                _this.permissions = response.permissions;
            }).always(function () {});
        },

        setRole: function setRole(val) {
            var value = parseInt(val);
            this.rolePermissions = _.pluck(_.findWhere(this.roles, { id: value }).permissions, 'id').map(String);
            console.log(this.rolePermissions);
        },

        /**
         * set permissions for a role
         */
        setPermissions: function setPermissions() {
            var _this2 = this;

            this.state = true;
            var data = {
                role: this.role,
                permissions: this.rolePermissions
            };
            this.$http.put('/api/set-permission/', data, function (response) {
                notify.success('Permission list updated successfully');
                _this2.roles = response.roles;
                _this2.permissions = response.permissions;
            }).always(function () {
                _this2.state = false;
            });
        }
    }
});
module.exports = exports['default'];

},{"./../../../mixed/notify":11}],119:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});
var notify = require('./../../../mixed/notify');

exports['default'] = Vue.extend({
    data: function data() {
        return {
            state: false
        };
    },

    events: {},

    ready: function ready() {},

    methods: {}
});
module.exports = exports['default'];

},{"./../../../mixed/notify":11}],120:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});
var notify = require('./../../../mixed/notify');
var modals = require('./../../../mixed/modals');

var columns = [{
    name: 'created_at',
    title: '<i class="fa fa-clock-o"></i> Time',
    sortField: 'created_at'
}, {
    name: 'description',
    title: '<i class="fa fa-file-text-o"></i> Description',
    sortField: 'description'
}, {
    name: 'user.name',
    title: '<i class="fa fa-user"></i> User'
}, {
    name: 'user.role_names',
    title: '<i class="fa fa-user"></i> User Type'
}, {
    name: 'method_type',
    title: '<i class="fa fa-truck"></i> METHOD',
    sortField: 'method_type',
    callback: 'methodType'
}, {
    name: 'route',
    title: '<i class="icon-map5"></i> Route',
    sortField: 'route'
}, {
    name: 'ip_address',
    title: '<i class="fa fa-map-marker"></i> IP Address',
    sortField: 'ip_address'
}, {
    name: 'user_agent',
    title: '<i class="fa fa-desktop" aria-hidden="true"></i> Device/Browser',
    sortField: 'user_agent'
}];

// create pagination component using bootstrap styling

// '__actions'
Vue.component('vuetable-pagination-bootstrap', {
    template: '#vuetable-pagination-bootstrap-template',
    mixins: [paginationMixin],
    methods: {
        loadPage: function loadPage(page) {
            this.$dispatch('vuetable-pagination:change-page', page);
        }
    }
});

exports['default'] = Vue.extend({
    data: function data() {
        return {
            query: [],
            columns: columns,
            moreParams: [],
            perPage: 150,
            sortOrder: {
                field: 'id',
                direction: 'desc'
            },
            paginationInfoTemplate: 'vuetable-pagination-bootstrap',
            methodParser: {
                GET: 'Requested data',
                POST: 'Created/Updated data',
                PUT: 'Updated data',
                PATCH: 'Updated data',
                DELETE: 'Deleted data'
            },
            filterUser: ''
        };
    },

    watch: {
        'filterUser': function filterUser(val) {
            this.setUserFilter();
        }
    },

    events: {
        'vuetable:action': function vuetableAction(action, data) {
            if (action == 'edit-device') {
                this.editModal(data);
            }
            if (action == 'delete-device') {
                this.confirmDelete(data);
            }
        },
        'vuetable:loading': function vuetableLoading() {
            notify.loading(true);
        },
        'vuetable:load-success': function vuetableLoadSuccess(response) {
            notify.loading(false);
        },
        'vuetable:load-error': function vuetableLoadError(response) {
            notify.loading(false);
        }
    },
    ready: function ready() {},

    methods: {
        setFilter: function setFilter() {
            this.moreParams = ['filter=' + this.query];
            this.$nextTick(function () {
                this.$broadcast('vuetable:refresh');
            });
        },

        methodType: function methodType(val) {
            return '<span class="label label-' + val + '">' + val + '</span>' + (' ' + this.methodParser[val]);
        },

        setUserFilter: function setUserFilter() {
            this.moreParams = ['user=' + this.filterUser];
            this.$nextTick(function () {
                this.$broadcast('vuetable:refresh');
            });
        }
    }
});
module.exports = exports['default'];

},{"./../../../mixed/modals":10,"./../../../mixed/notify":11}],121:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});
var notify = require('./../../../mixed/notify');
var modals = require('./../../../mixed/modals');
var editRole = typeof canEditRole !== 'undefined' && canEditRole == true ? 'icon-pencil7 text-primary-600 mr-10' : '';
var deleteRole = typeof canDeleteRole !== 'undefined' && canDeleteRole == true ? 'icon-trash text-danger-600' : '';
var tableColumns = [{
    name: 'id',
    title: '#ID',
    sortField: 'id'
}, {
    name: 'name',
    title: 'Name',
    sortField: 'name'
}, {
    name: 'display_name',
    title: 'Display Name',
    sortField: 'display_name'
}, '__actions'];

// create pagination component using bootstrap styling
Vue.component('vuetable-pagination-bootstrap', {
    template: '#vuetable-pagination-bootstrap-template',
    mixins: [paginationMixin],
    methods: {
        loadPage: function loadPage(page) {
            this.$dispatch('vuetable-pagination:change-page', page);
        }
    }
});

exports['default'] = Vue.extend({
    data: function data() {
        return {
            devices: {},
            selectedDevices: [],
            state: false,
            columns: tableColumns,
            perPage: 500,
            role: {
                name: '',
                display_name: ''
            },
            currentRole: {},
            sortOrder: {
                field: 'name',
                direction: 'asc'
            },
            paginationInfoTemplate: 'vuetable-pagination-bootstrap',
            itemActions: [{
                name: 'edit-role',
                label: '',
                icon: editRole,
                'class': ''
            }, {
                name: 'edit-device',
                label: '',
                icon: 'fa fa-desktop text-primary-600 right-m-30',
                'class': ''
            }]
        };
    },

    //     {
    //     name: 'delete-role',
    //     label: '',
    //     icon: deleteRole,
    //     class: ''
    // }
    events: {
        'vuetable:action': function vuetableAction(action, data) {
            if (action == 'edit-role') {
                this.editModal(data);
            }

            if (action == 'delete-role') {
                this.confirmDelete(data);
            }

            if (action == 'edit-device') {
                this.showDevices(data);
            }
        },
        'vuetable:loading': function vuetableLoading() {
            notify.loading(true);
        },
        'vuetable:load-success': function vuetableLoadSuccess(response) {
            notify.loading(false);
        },
        'vuetable:load-error': function vuetableLoadError(response) {
            notify.loading(false);
            console.log('Load Error: ', response);
        }
    },
    ready: function ready() {
        this.currentRole = this.role;
        this.getDevices();
    },

    methods: {
        getDevices: function getDevices() {
            var _this = this;

            this.$http.get('/api/devices', '', function (response) {
                _this.devices = response;
            }).always(function () {});
        },

        showDevices: function showDevices(role) {
            this.currentRole = _.clone(role);
            this.selectedDevices = _.pluck(role.devices, 'id').map(String);
            modals.showStrict("#devices");
        },

        saveDevices: function saveDevices() {
            var _this2 = this;

            this.state = true;
            var data = { ids: this.selectedDevices };
            this.$http.post('/api/role-devices/' + this.currentRole.id, data, function (response) {
                _this2.$broadcast('vuetable:refresh');
                notify.success('Device list updated');
                modals.hide("#devices");
            }).always(function () {
                _this2.state = false;
            });
        },
        createRole: function createRole() {
            var _this3 = this;

            this.state = true;
            this.$http.post('/api/role', this.role, function () {
                modals.hide('#modal_add_role');
                notify.success('New Role Added Successfully');
                _this3.$broadcast('vuetable:refresh');
                _this3.clearFields();
            }).always(function () {
                _this3.state = false;
            });
        },

        editModal: function editModal(role) {
            this.currentRole = _.clone(role);
            modals.showStrict('#modal_edit_role');
        },

        editRole: function editRole() {
            var _this4 = this;

            this.state = true;
            this.$http.put('/api/role/' + this.currentRole.id, this.currentRole, function () {
                modals.hide('#modal_edit_role');
                notify.success('Role Edited Successfully');
                _this4.$broadcast('vuetable:refresh');
            }).always(function () {
                _this4.state = false;
            });
        },

        confirmDelete: function confirmDelete(role) {
            this.currentRole = _.clone(role);
            notify.confirm('Are you sure you want to remove this role?', '', this.deleteRole);
        },

        deleteRole: function deleteRole() {
            var _this5 = this;

            this.$http['delete']('/api/role/' + this.currentRole.id, '', function () {
                notify.success('Role Deleted');
            }).always(function () {
                _this5.$broadcast('vuetable:reload');
            });
        },

        clearFields: function clearFields() {
            this.role = {
                name: '',
                display_name: ''
            };
        }
    }
});
module.exports = exports['default'];

},{"./../../../mixed/modals":10,"./../../../mixed/notify":11}],122:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});
var notify = require('./../../../mixed/notify');

exports['default'] = Vue.extend({
    data: function data() {
        return {
            state: false
        };
    },

    events: {},
    components: {
        'schedules': require('../client/components/schedules')
    },

    ready: function ready() {
        var _this = this;

        window.bus.$on('showSchedulingRule', function (position) {
            _this.showScheduleRules(position);
        });
    },

    methods: {
        showScheduleRules: function showScheduleRules(position) {
            this.$broadcast('showPositionRules', position.position_code);
        }
    }
});
module.exports = exports['default'];

},{"../client/components/schedules":137,"./../../../mixed/notify":11}],123:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});
var notify = require('./../../../mixed/notify');
var modals = require('./../../../mixed/modals');
var primarySelectedTypes = null;
var secondarySelectedTypes = null;

exports['default'] = Vue.extend({
    filters: {
        momentTime: function momentTime(time) {
            return moment(time, "HH:mm:ss").format('hh:mm A');
        },

        momentDate: function momentDate(date) {
            return moment(date, "YYYY-MM-DD").format('ddd  MM-DD-YYYY');
        },

        parseTime: function parseTime(dateTime) {
            return moment(dateTime, "YYYY-MM-DD HH:mm:ss").format('h:m a');
        }

    },

    data: function data() {
        return {
            allowedLists: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'X', 'W'],
            orderId: '',
            order: {},
            position: {},
            all: 0,
            allowNoZones: 0,
            statuses: ['confirm', 're-confirm', 'need-change', 'did-not-re-confirm'],
            rules: {},
            primary_types: [],
            secondary_types: [],
            primary_rules: [],
            secondary_rules: [],
            employees: {},
            ids: [],
            selectedEmployees: [],
            employeeToMove: {},
            addedTypes: [],
            addedTypesVar: [],
            primary_ratio: [],
            secondary_ratio: [],
            allowedTypes: [],
            primary_type_percentage: [],
            secondary_type_percentage: []
        };
    },

    watch: {},

    events: {
        triggerOrderEmployeeList: function triggerOrderEmployeeList(orderId) {
            this.orderId = orderId;
            this.getEmployees();
        }
    },

    ready: function ready() {
        var _this = this;

        //this.orderId = window.location.pathname.split('/')[3];
        //this.getEmployees();
        $('#select-employee').on('hidden.bs.modal', function () {
            primarySelectedTypes = null;
            secondarySelectedTypes = null;
            _this.resetValues();
        });
    },

    methods: {
        getEmployees: function getEmployees() {
            var _this2 = this;

            var that = this;
            this.allowedTypes = [];
            notify.loading(true);
            this.$http.get('/api/order-employee-list/' + this.orderId + '?all=' + this.all + '&allowNoZones=' + this.allowNoZones, '', function (response) {
                _this2.order = response.order;
                _this2.position = response.position;
                _this2.rules = response.rules;
                _this2.primary_types = _.values(response.primary_types);
                _this2.secondary_types = _.values(response.secondary_types);
                _this2.primary_rules = _.values(response.primary_rules);
                _this2.secondary_rules = _.values(response.secondary_rules);
                _this2.primary_type_percentage = response.primary_type_percentage;
                _this2.secondary_type_percentage = response.secondary_type_percentage;
                // this.employees = _.sortBy(response.employees, 'type');
                _this2.addedTypes = _.groupBy(_.map(_.filter(response.employees, function (employee) {
                    return that.employeeMove(employee) && that.employeeStatuses(employee);
                }), 'type'));
                _this2.addedTypesVar = _.cloneDeep(_this2.addedTypes);
                _this2.primary_ratio = response.primary_ratio;
                _this2.secondary_ratio = response.secondary_ratio;
                var ratios = response.primary_ratio;
                var allowedTypes = [];
                for (var key in ratios) {
                    var allowedPercentage = key;
                    var totalPercentage = 0;
                    ratios[key].forEach(function (ratio) {
                        if (_this2.addedTypes[ratio]) {
                            totalPercentage += _this2.addedTypes[ratio].length * 100 / _this2.order.no_of_employee;
                        }
                    });
                    if (totalPercentage == 0 || totalPercentage < allowedPercentage) {
                        ratios[key].forEach(function (r) {
                            allowedTypes.push(r);
                        });
                    }
                }
                _this2.allowedTypes = _.sortBy(allowedTypes);
                _this2.employees = _.filter(response.employees, function (employee) {
                    employee['quota'] = _.includes(_this2.allowedTypes, employee.type) ? 1 : 0;
                    return true;
                });
                modals.showStrict("#select-employee");
            }).always(function () {
                notify.loading(false);
            });
        },

        /**
         * toggle show all employees
         */
        showAll: function showAll() {
            this.all = this.all ? 0 : 1;
            this.getEmployees();
        },

        /**
         * show employees with no zones
         */
        showNoZoneEmployees: function showNoZoneEmployees() {
            this.allowNoZones = 1;
            this.getEmployees();
        },

        /**
         * add employee to order
         * @param employee
         */
        addEmployee: function addEmployee(employee) {
            var _this3 = this;

            this.$http.post('/api/add-employee-order/' + this.orderId, { employees: [employee] }, function (response) {
                _this3.getEmployees();
                _this3.$parent.getOrders();
            }).always(function () {});
        },

        /**
         * add multiple employee to an order
         */
        addMultipleEmployees: function addMultipleEmployees() {
            var _this4 = this;

            var that = this;
            var employees = _.filter(this.employees, function (o) {
                return that.ids.includes(o.id.toString());
            });
            this.$http.post('/api/add-employee-order/' + this.orderId, { employees: employees }, function (response) {
                _this4.getEmployees();
                _this4.$parent.getOrders();
                _this4.selectedEmployees = [];
                _this4.ids = [];
            }).always(function () {});
        },

        /**
         * check is employee is confirmed/re-confirmed/need-change in any of the orders
         * @param emp
         * @returns {boolean}
         */
        employeeStatuses: function employeeStatuses(emp) {
            var statuses = _.map(emp.order, 'pivot.status');
            return _.intersection(this.statuses, statuses).length > 0;
        },

        /**
         * check if employee is already added to current order
         * @param employee
         * @returns {boolean}
         */
        employeeMove: function employeeMove(employee) {
            var ids = _.map(employee.order, 'id');
            return ids.includes(this.orderId);
        },

        /**
         * check if employee is selected for an order
         * @param orderId
         * @param clientId
         * @param emp
         * @returns {boolean}
         */
        checkCurrentOrder: function checkCurrentOrder(orderId, clientId, emp) {
            var ids = _.map(emp.order, 'id');
            var clients = _.map(emp.order, 'client_id');
            return ids.includes(orderId) && clients.includes(clientId);
        },

        confirmMoveEmployee: function confirmMoveEmployee(employee) {
            this.employeeToMove = employee;
            notify.prompt('Are you sure you want to move this employee?', '', this.moveEmployee);
        },

        /**
         * mark employee to move
         * @param employee
         */
        moveEmployee: function moveEmployee() {
            var _this5 = this;

            var data = {
                'moveTo': this.orderId,
                'moveFrom': this.employeeToMove.order[0].id,
                'employeeId': this.employeeToMove.id,
                'employees': [this.employeeToMove]
            };

            this.$http.put('/api/move-employee/', data, function (response) {
                notify.success('Marked for move');
                _this5.getEmployees();
                _this5.$parent.getOrders();
            }).always(function () {});
        },

        /**
         * calculate how many can be selected from a type
         * @param type
         * @returns {number}
         */
        calculateAllowedNumber: function calculateAllowedNumber(type) {
            if (this.primary_type_percentage.hasOwnProperty(type)) return Math.round(this.primary_type_percentage[type] * this.order.no_of_employee / 100);else return 0;
        },

        /**
         * calculate confirmed employee for a type
         * @param type
         * @returns {number}
         */
        calculateConfirmedNumber: function calculateConfirmedNumber(type) {
            if (this.addedTypes.hasOwnProperty(type)) return this.addedTypes[type].length;else return 0;
        },

        // /**
        //  * calculate group confirm
        //  * @param type
        //  * @returns {number}
        //  */
        // calculateGroupConfirm(type){
        //     let that = this;
        //     if (this.primary_ratio.hasOwnProperty(this.primary_type_percentage[type])) {
        //         let total = 0;
        //         this.primary_ratio[this.primary_type_percentage[type]].forEach(function (val) {
        //             total += that.calculateConfirmedNumber(val);
        //         });
        //         return total;
        //     } else {
        //         return 0;
        //     }
        // },

        /**
         * calculate group confirm
         * @param type
         * @returns {number}
         */
        calculateGroupConfirm: function calculateGroupConfirm(type) {
            var that = this;
            var total = 0;
            this.primary_rules.forEach(function (rule) {
                if (rule.types.includes(type)) {
                    total += rule.confirmed;
                }
            });
            return total;
        },

        /**
         * calculate confirmed types for a group of types
         * @param types
         * @param total
         * @param index
         * @returns {number}
         */
        calculatePrimaryBatchConfirm: function calculatePrimaryBatchConfirm(types, total, index) {
            var counter = 0;
            if (!primarySelectedTypes) {
                primarySelectedTypes = _.cloneDeep(this.addedTypes);
            }
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = types[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var element = _step.value;

                    for (var i = 0; i < total; i++) {
                        if (primarySelectedTypes.hasOwnProperty(element)) {
                            //console.log(element);
                            if (primarySelectedTypes[element].length > 1) {
                                primarySelectedTypes[element].splice(-1);
                            } else {
                                delete primarySelectedTypes[element];
                            }
                            counter++;
                        }
                        if (counter === total) break;
                    }
                    if (counter === total) break;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator['return']) {
                        _iterator['return']();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            this.primary_rules[index].confirmed = counter;
            return counter;
        },

        /**
         * calculate confirmed types for a group of types
         * @param types
         * @param total
         * @param index
         * @returns {number}
         */
        calculateSecondaryBatchConfirm: function calculateSecondaryBatchConfirm(types, total, index) {
            var counter = 0;
            if (!secondarySelectedTypes) {
                secondarySelectedTypes = _.cloneDeep(this.addedTypes);
            }
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = types[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var element = _step2.value;

                    for (var i = 0; i < total; i++) {
                        if (secondarySelectedTypes.hasOwnProperty(element)) {
                            //console.log(element);
                            if (secondarySelectedTypes[element].length > 1) {
                                secondarySelectedTypes[element].splice(-1);
                            } else {
                                delete secondarySelectedTypes[element];
                            }
                            counter++;
                        }
                        if (counter === total) break;
                    }
                    if (counter === total) break;
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2['return']) {
                        _iterator2['return']();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            this.secondary_rules[index].confirmed = counter;
            return counter;
        },

        /**
         * reset values on modal close
         */
        resetValues: function resetValues() {
            this.rules = {};
            this.primary_types = [];
            this.secondary_types = [];
            this.primary_rules = [];
            this.secondary_rules = [];
            this.employees = {};
            this.ids = [];
            this.selectedEmployees = [];
            this.employeeToMove = {};
            this.addedTypes = [];
            this.addedTypesVar = [];
            this.primary_ratio = [];
            this.secondary_ratio = [];
            this.allowedTypes = [];
            this.primary_type_percentage = [];
            this.secondary_type_percentage = [];
            this.all = 0;
            this.allowNoZones = 0;
        }
    }
});
module.exports = exports['default'];

},{"./../../../mixed/modals":10,"./../../../mixed/notify":11}],124:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});
var notify = require('./../../../mixed/notify');
var modals = require('./../../../mixed/modals');
var editSkill = typeof canEditSkill !== 'undefined' && canEditSkill == true ? 'icon-pencil7 text-primary-600' : '';
var deleteSkill = typeof canDeleteSkill !== 'undefined' && canDeleteSkill == true ? 'icon-trash text-danger-600' : '';
var skillsColumns = [{
    name: 'id',
    title: '#ID',
    sortField: 'id'
}, {
    name: 'title',
    title: 'Ttile',
    sortField: 'title'
}, {
    name: 'category.title',
    title: 'Group',
    sortField: 'category_id'
}, '__actions'];

// create pagination component using bootstrap styling
Vue.component('vuetable-pagination-bootstrap', {
    template: '#vuetable-pagination-bootstrap-template',
    mixins: [paginationMixin],
    methods: {
        loadPage: function loadPage(page) {
            this.$dispatch('vuetable-pagination:change-page', page);
        }
    }
});

exports['default'] = Vue.extend({
    data: function data() {
        return {
            categories: [],
            state: false,
            skill: {
                title: '',
                category_id: 1
            },
            currentSkill: {
                title: '',
                category_id: 1
            },
            query: [],
            columns: skillsColumns,
            moreParams: [],
            sortOrder: {
                field: 'id',
                direction: 'asc'
            },
            paginationInfoTemplate: 'vuetable-pagination-bootstrap',
            itemActions: [{
                name: 'edit-skill',
                label: '',
                icon: editSkill,
                'class': ''
            }, {
                name: 'delete-skill',
                label: '',
                icon: deleteSkill,
                'class': ''
            }]
        };
    },

    events: {
        'vuetable:action': function vuetableAction(action, data) {
            console.log('vuetable:action', action, data);
            if (action == 'edit-skill') {
                this.editModal(data);
            }
            if (action == 'delete-skill') {
                this.confirmDelete(data);
            }
        },
        'vuetable:loading': function vuetableLoading() {
            notify.loading(true);
        },
        'vuetable:load-success': function vuetableLoadSuccess(response) {
            notify.loading(false);
        },
        'vuetable:load-error': function vuetableLoadError(response) {
            notify.loading(false);
            console.log('Load Error: ', response);
        }
    },
    ready: function ready() {
        this.getCategories();
    },

    methods: {
        createSkill: function createSkill() {
            var _this = this;

            this.state = true;
            this.$http.post('/api/skill', this.skill, function (response) {
                modals.hide('#modal_add_skills');
                notify.success('New Skill Added Successfully');
                _this.$broadcast('vuetable:refresh');
            }).always(function () {
                _this.state = false;
            });
        },

        editModal: function editModal(skill) {
            this.currentSkill = _.clone(skill);
            modals.showStrict('#modal_edit_skills');
        },

        editSkill: function editSkill() {
            var _this2 = this;

            this.state = true;
            this.$http.put('/api/skill/' + this.currentSkill.id, this.currentSkill, function (response) {
                modals.hide('#modal_edit_skills');
                notify.success('Skill Edited Successfully');
                _this2.$broadcast('vuetable:reload');
            }).always(function () {
                _this2.state = false;
            });
        },

        confirmDelete: function confirmDelete(skill) {
            this.currentSkill = skill;
            notify.confirm('Are you sure you want to remove this skill?', '', this.deleteSkill);
        },

        deleteSkill: function deleteSkill() {
            var _this3 = this;

            this.$http['delete']('/api/skill/' + this.currentSkill.id, '', function (response) {
                notify.success('Skill Deleted');
            }).always(function () {
                _this3.$broadcast('vuetable:reload');
            });
        },

        setFilter: function setFilter() {
            this.moreParams = ['filter=' + this.query];
            this.$nextTick(function () {
                this.$broadcast('vuetable:refresh');
            });
        },

        status: function status(val) {
            return parseInt(val) === 1 ? '<span class="label label-danger">Mandatory</span>' : '<span class="label label-success">Optional</span>';
        },

        getCategories: function getCategories() {
            var _this4 = this;

            this.$http.get('/api/skill-categories', '', function (response) {
                _this4.categories = response;
            }).always(function () {});
        }
    }
});
module.exports = exports['default'];

},{"./../../../mixed/modals":10,"./../../../mixed/notify":11}],125:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});
var notify = require('./../../../mixed/notify');
exports['default'] = Vue.extend({
    data: function data() {
        return {
            state: false,
            messages: {
                new_job_text: '',
                confirmation_text: '',
                special_text: '',
                message_top: '',
                message_bottom: '',
                job_summary: '',
                assign_details: '',
                manual_call_move: ''
            }
        };
    },

    events: {},

    ready: function ready() {
        this.getMessages();
    },

    methods: {
        setMessages: function setMessages() {
            var _this = this;

            notify.loading(true);
            this.state = true;
            this.$http.post('/api/system-messages', this.messages, function (response) {
                _this.messages = response.messages;
                notify.success('System messages updated');
            }).always(function () {
                _this.state = false;
                notify.loading(false);
            });
        },

        getMessages: function getMessages() {
            var _this2 = this;

            this.$http.get('/api/system-messages', '', function (response) {
                _this2.messages = response.messages;
            }).always(function () {});
        }
    }
});
module.exports = exports['default'];

},{"./../../../mixed/notify":11}],126:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});
var notify = require('./../../../mixed/notify');
exports['default'] = Vue.extend({
    data: function data() {
        return {
            state: false,
            settings: {}
        };
    },

    events: {},

    ready: function ready() {
        this.getSettingsData();
    },

    methods: {
        getSettingsData: function getSettingsData() {
            var _this = this;

            this.$http.get('/api/system-settings', '', function (response) {
                _this.settings = response.settings;
            }).always(function () {});
        },

        saveSettings: function saveSettings() {
            var _this2 = this;

            notify.loading(true);
            this.$http.post('/api/system-settings', { settings: this.settings }, function (response) {
                _this2.settings = response.settings;
                notify.success('System Settings Updated');
            }).always(function () {
                notify.loading(false);
            });
        }
    }
});
module.exports = exports['default'];

},{"./../../../mixed/notify":11}],127:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});
var notify = require('./../../../mixed/notify');
exports['default'] = Vue.extend({
    data: function data() {
        return {
            state: false,
            timers: {}
        };
    },

    events: {},

    ready: function ready() {
        this.timerData();
    },

    methods: {
        timerData: function timerData() {
            var _this = this;

            this.$http.get('/api/timer-data', '', function (response) {
                _this.timers = response;
            }).always(function () {});
        },

        saveTimerData: function saveTimerData() {
            var _this2 = this;

            notify.loading(true);
            this.$http.post('/api/timer-data', { timers: this.timers }, function (response) {
                _this2.timers = response;
            }).always(function () {
                notify.loading(false);
            });
        }
    }
});
module.exports = exports['default'];

},{"./../../../mixed/notify":11}],128:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});
var notify = require('./../../../mixed/notify');
var modals = require('./../../../mixed/modals');
var editTool = typeof canEditTool !== 'undefined' && canEditTool == true ? 'icon-pencil7 text-primary-600' : '';
var deleteTool = typeof canDeleteTool !== 'undefined' && canDeleteTool == true ? 'icon-trash text-danger-600' : '';

var toolsColumns = [{
    name: 'id',
    title: '#ID',
    sortField: 'id'
}, {
    name: 'title',
    title: 'Ttile',
    sortField: 'title'
}, {
    name: 'category.title',
    title: 'Group',
    sortField: 'category_id'
}, '__actions'];

// create pagination component using bootstrap styling
Vue.component('vuetable-pagination-bootstrap', {
    template: '#vuetable-pagination-bootstrap-template',
    mixins: [paginationMixin],
    methods: {
        loadPage: function loadPage(page) {
            this.$dispatch('vuetable-pagination:change-page', page);
        }
    }
});

exports['default'] = Vue.extend({
    data: function data() {
        return {
            categories: [],
            state: false,
            tool: {
                title: '',
                category_id: 1
            },
            currentTool: {
                title: '',
                category_id: 1
            },
            query: [],
            columns: toolsColumns,
            moreParams: [],
            sortOrder: {
                field: 'id',
                direction: 'asc'
            },
            paginationInfoTemplate: 'vuetable-pagination-bootstrap',
            itemActions: [{
                name: 'edit-tool',
                label: '',
                icon: editTool,
                'class': ''
            }, {
                name: 'delete-tool',
                label: '',
                icon: deleteTool,
                'class': ''
            }]
        };
    },

    events: {
        'vuetable:action': function vuetableAction(action, data) {
            console.log('vuetable:action', action, data);
            if (action == 'edit-tool') {
                this.editModal(data);
            }
            if (action == 'delete-tool') {
                this.confirmDelete(data);
            }
        },
        'vuetable:loading': function vuetableLoading() {
            notify.loading(true);
        },
        'vuetable:load-success': function vuetableLoadSuccess(response) {
            notify.loading(false);
        },
        'vuetable:load-error': function vuetableLoadError(response) {
            notify.loading(false);
            console.log('Load Error: ', response);
        }
    },
    ready: function ready() {
        this.getCategories();
    },

    methods: {
        createTool: function createTool() {
            var _this = this;

            this.state = true;
            this.$http.post('/api/tool', this.tool, function (response) {
                modals.hide('#modal_add_tool');
                notify.success('New Tool Added Successfully');
                _this.$broadcast('vuetable:refresh');
            }).always(function () {
                _this.state = false;
            });
        },

        editModal: function editModal(tool) {
            this.currentTool = _.clone(tool);
            modals.showStrict('#modal_edit_tool');
        },

        editTool: function editTool() {
            var _this2 = this;

            this.state = true;
            this.$http.put('/api/tool/' + this.currentTool.id, this.currentTool, function (response) {
                modals.hide('#modal_edit_tool');
                notify.success('Tool Edited Successfully');
                _this2.$broadcast('vuetable:reload');
            }).always(function () {
                _this2.state = false;
            });
        },

        confirmDelete: function confirmDelete(tool) {
            this.currentTool = tool;
            notify.confirm('Are you sure you want to remove this tool?', '', this.deleteTool);
        },

        deleteTool: function deleteTool() {
            var _this3 = this;

            this.$http['delete']('/api/tool/' + this.currentTool.id, '', function (response) {
                //notify.success('Tool Deleted');
            }).always(function () {
                _this3.$broadcast('vuetable:reload');
            });
        },

        setFilter: function setFilter() {
            this.moreParams = ['filter=' + this.query];
            this.$nextTick(function () {
                this.$broadcast('vuetable:refresh');
            });
        },

        status: function status(val) {
            return parseInt(val) === 1 ? '<span class="label label-danger">Mandatory</span>' : '<span class="label label-success">Optional</span>';
        },

        getCategories: function getCategories() {
            var _this4 = this;

            this.$http.get('/api/tool-categories', '', function (response) {
                _this4.categories = response;
            }).always(function () {});
        }
    }
});
module.exports = exports['default'];

},{"./../../../mixed/modals":10,"./../../../mixed/notify":11}],129:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});
var notify = require('./../../../mixed/notify');
var modals = require('./../../../mixed/modals');
var editUniform = typeof canEditUniform !== 'undefined' && canEditUniform == true ? 'icon-pencil7 text-primary-600' : '';
var deleteUniform = typeof canDeleteUniform !== 'undefined' && canDeleteUniform == true ? 'icon-trash text-danger-600' : '';
var uniformColumns = [{
    name: 'id',
    title: '#ID',
    sortField: 'id'
}, {
    name: 'title',
    title: 'Ttile',
    sortField: 'title'
}, {
    name: 'category.title',
    title: 'Group',
    sortField: 'category_id'
}, '__actions'];

// create pagination component using bootstrap styling
Vue.component('vuetable-pagination-bootstrap', {
    template: '#vuetable-pagination-bootstrap-template',
    mixins: [paginationMixin],
    methods: {
        loadPage: function loadPage(page) {
            this.$dispatch('vuetable-pagination:change-page', page);
        }
    }
});

exports['default'] = Vue.extend({
    data: function data() {
        return {
            state: false,
            categories: [],
            uniform: {
                title: '',
                category_id: 1
            },
            currentUniform: {
                title: '',
                category_id: 0
            },
            query: [],
            columns: uniformColumns,
            moreParams: [],
            sortOrder: {
                field: 'id',
                direction: 'asc'
            },
            paginationInfoTemplate: 'vuetable-pagination-bootstrap',
            itemActions: [{
                name: 'edit-uniform',
                label: '',
                icon: editUniform,
                'class': ''
            }, {
                name: 'delete-uniform',
                label: '',
                icon: deleteUniform,
                'class': ''
            }]
        };
    },

    events: {
        'vuetable:action': function vuetableAction(action, data) {
            if (action == 'edit-uniform') {
                this.editModal(data);
            }
            if (action == 'delete-uniform') {
                this.confirmDelete(data);
            }
        },
        'vuetable:loading': function vuetableLoading() {
            notify.loading(true);
        },
        'vuetable:load-success': function vuetableLoadSuccess(response) {
            notify.loading(false);
        },
        'vuetable:load-error': function vuetableLoadError(response) {
            notify.loading(false);
            console.log('Load Error: ', response);
        }
    },
    ready: function ready() {
        this.getCategories();
    },

    methods: {
        createUniform: function createUniform() {
            var _this = this;

            this.state = true;
            this.$http.post('/api/uniform', this.uniform, function (response) {
                modals.hide('#modal_add_uniform');
                notify.success('New Uniform Added Successfully');
                _this.$broadcast('vuetable:refresh');
            }).always(function () {
                _this.state = false;
            });
        },

        editModal: function editModal(uniform) {
            this.currentUniform = _.clone(uniform);
            modals.showStrict('#modal_edit_uniform');
        },

        editUniform: function editUniform() {
            var _this2 = this;

            this.state = true;
            this.$http.put('/api/uniform/' + this.currentUniform.id, this.currentUniform, function (response) {
                $('#modal_edit_uniform').modal('hide');
                notify.success('Uniform Edited Successfully');
                _this2.$broadcast('vuetable:reload');
            }).always(function () {
                _this2.state = false;
            });
        },

        confirmDelete: function confirmDelete(uniform) {
            this.currentUniform = uniform;
            notify.confirm('Are you sure you want to remove this uniform?', '', this.deleteUniform);
        },

        deleteUniform: function deleteUniform() {
            var _this3 = this;

            this.$http['delete']('/api/uniform/' + this.currentUniform.id, '', function (response) {}).always(function () {
                _this3.$broadcast('vuetable:reload');
            });
        },

        setFilter: function setFilter() {
            this.moreParams = ['filter=' + this.query];
            this.$nextTick(function () {
                this.$broadcast('vuetable:refresh');
            });
        },

        status: function status(val) {
            return parseInt(val) === 1 ? '<span class="label label-danger">Mandatory</span>' : '<span class="label label-success">Optional</span>';
        },

        getCategories: function getCategories() {
            var _this4 = this;

            this.$http.get('/api/uniform-categories', '', function (response) {
                _this4.categories = response;
            }).always(function () {});
        }
    }
});
module.exports = exports['default'];

},{"./../../../mixed/modals":10,"./../../../mixed/notify":11}],130:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});
var notify = require('./../../../mixed/notify');

exports['default'] = Vue.extend({
    data: function data() {
        return {
            state: false
        };
    },

    events: {},

    ready: function ready() {},

    methods: {}
});
module.exports = exports['default'];

},{"./../../../mixed/notify":11}],131:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});
var notify = require('./../../../mixed/notify');

exports['default'] = Vue.extend({
    data: function data() {
        return {
            state: false
        };
    },

    events: {},

    ready: function ready() {},

    methods: {}
});
module.exports = exports['default'];

},{"./../../../mixed/notify":11}],132:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});
var notify = require('./../../../mixed/notify');
var modals = require('./../../../mixed/modals');
var editZip = typeof canEditZip !== 'undefined' && canEditZip == true ? 'icon-pencil7 text-primary-600 right-m-30' : '';
var tableColumns = [{
    name: 'id',
    title: '#ID',
    sortField: 'id'
}, {
    name: 'zip_code',
    title: 'Zip Code',
    sortField: 'zip_code'
}, {
    name: 'city',
    title: 'City',
    'sortField': 'cities.title'
}, '__actions'];

// create pagination component using bootstrap styling
Vue.component('vuetable-pagination-bootstrap', {
    template: '#vuetable-pagination-bootstrap-template',
    mixins: [paginationMixin],
    methods: {
        loadPage: function loadPage(page) {
            this.$dispatch('vuetable-pagination:change-page', page);
        }
    }
});

exports['default'] = Vue.extend({
    data: function data() {
        return {
            commonData: [],
            employees: [],
            clients: [],
            zoneData: {
                zip_code: '',
                zone: 'A',
                zip_id: ''
            },
            state: false,
            query: [],
            perPage: 1000,
            columns: tableColumns,
            moreParams: [],
            zip: {
                zip_code: '',
                city_id: ''
            },
            currentZip: {},
            sortOrder: {
                field: 'id',
                direction: 'asc'
            },
            paginationInfoTemplate: 'vuetable-pagination-bootstrap',
            itemActions: [{
                name: 'delete-edit-zip',
                label: '',
                icon: editZip,
                'class': ''
            }]
        };
    },

    // {
    // 	name: 'view-zones',
    // 	label: '<a href="#" class="label label-info right-m-30">Zones</a>',
    // 	icon: '',
    // 	class: '',
    // },
    // {
    // 	name: 'delete-zip',
    // 	label: '',
    // 	icon: 'icon-trash text-danger-600',
    // 	class: ''
    // }
    events: {
        'vuetable:action': function vuetableAction(action, data) {
            if (action == 'delete-edit-zip') {
                this.editModal(data);
            }
            if (action == 'view-zones') {
                this.zoneModal(data);
            }
            if (action == 'delete-zip') {
                this.confirmDelete(data);
            }
        },
        'vuetable:loading': function vuetableLoading() {
            notify.loading(true);
        },
        'vuetable:load-success': function vuetableLoadSuccess(response) {
            notify.loading(false);
        },
        'vuetable:load-error': function vuetableLoadError(response) {
            notify.loading(false);
            console.log('Load Error: ', response);
        }
    },
    ready: function ready() {
        this.currentZip = this.zip;
        //this.getData();
    },

    methods: {

        getData: function getData() {
            var _this = this;

            this.$http.get('/api/zip-data', this.zip, function (response) {
                _this.commonData = response;
            }).always(function () {});
        },

        setFilter: function setFilter() {
            this.moreParams = ['filter=' + this.query];
            this.$nextTick(function () {
                this.$broadcast('vuetable:refresh');
            });
        },

        createZip: function createZip() {
            var _this2 = this;

            this.state = true;
            this.$http.post('/api/zip', this.zip, function () {
                modals.hide('#modal_add_zip');
                notify.success('New Zip Code Added Successfully');
                _this2.$broadcast('vuetable:refresh');
                _this2.clearFields();
            }).always(function () {
                _this2.state = false;
            });
        },

        editModal: function editModal(zip) {
            this.currentZip = _.clone(zip);
            //this.currentZip.city_id = this.currentZip.city != null ? this.currentZip.city.city_id : null;
            modals.showStrict('#modal_edit_zip');
        },

        editZip: function editZip() {
            var _this3 = this;

            this.state = true;
            this.$http.put('/api/zip/' + this.currentZip.id, this.currentZip, function () {
                modals.hide('#modal_edit_zip');
                notify.success('Zip Code Edited Added Successfully');
                _this3.$broadcast('vuetable:reload');
            }).always(function () {
                _this3.state = false;
            });
        },

        confirmDelete: function confirmDelete() {
            modals.hide('#modal_edit_zip');
            //this.currentZip = _.clone(zip);
            notify.confirm('Are you sure you want to remove this zip?', '', this.deleteZip);
        },

        deleteZip: function deleteZip() {
            var _this4 = this;

            this.$http['delete']('/api/zip/' + this.currentZip.id, '', function () {
                notify.success('Zip Code Deleted');
            }).always(function () {
                _this4.$broadcast('vuetable:reload');
            });
        },

        zoneModal: function zoneModal(zip) {
            this.currentZip = _.clone(zip);
            modals.showStrict('#zip_zones');
        },

        moveToZone: function moveToZone() {
            var _this5 = this;

            this.zoneData.zip_id = this.currentZip.id;
            this.state = true;
            this.$http.post('/api/zip-add-zone', this.zoneData, function (response) {
                _this5.currentZip.zone_a = response.zone_a;
                _this5.currentZip.zone_b = response.zone_b;
                _this5.currentZip.zone_c = response.zone_c;
                _this5.clearFields();
                _this5.$broadcast('vuetable:reload');
            }).always(function () {
                _this5.state = false;
            });
        },

        removeZoneZip: function removeZoneZip(code) {
            var _this6 = this;

            notify.loading(true);
            this.$http['delete']('/api/zip-remove-zone', code, function (response) {
                _this6.currentZip.zone_a = response.zone_a;
                _this6.currentZip.zone_b = response.zone_b;
                _this6.currentZip.zone_c = response.zone_c;
                notify.success('Zip Code Deleted From Zone');
            }).always(function () {
                notify.loading(false);
            });
        },

        missingZips: function missingZips() {
            var _this7 = this;

            notify.loading(true);
            this.$http.get('/api/missing-zip', '', function (response) {
                _this7.employees = response.employees;
                _this7.clients = response.clients;
                modals.show("#missing-zips");
            }).always(function () {
                notify.loading(false);
            });
        },

        clearFields: function clearFields() {
            this.zoneData = {
                zip_code: '',
                zone: 'A',
                zip_id: ''
            };

            this.zip = {
                zip_code: '',
                city_id: ''
            };
        }
    }
});
module.exports = exports['default'];

},{"./../../../mixed/modals":10,"./../../../mixed/notify":11}],133:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});
var notify = require('./../../../mixed/notify');
var modals = require('./../../../mixed/modals');
var editZone = typeof canEditZone !== 'undefined' && canEditZone == true ? '<a href="#" class="label label-info right-m-30">Zones</a>' : '';
var tableColumns = [{
    name: 'id',
    title: '#ID',
    sortField: 'id'
}, {
    name: 'client_zip',
    title: 'Zip Code',
    callback: 'zipCode',
    sortField: 'zip_code'
}, {
    name: 'city',
    title: 'City',
    sortField: 'cities.title'
}, {
    name: 'clients_count',
    title: 'Client No.',
    callback: 'clients',
    sortField: 'totalClients'
}, {
    name: 'zone_a.length',
    callback: 'zoneA',
    title: 'Zone A'
}, {
    name: 'zone_b.length',
    callback: 'zoneB',
    title: 'Zone B'
}, {
    name: 'zone_c.length',
    callback: 'zoneC',
    title: 'Zone C'
}, '__actions'];

// create pagination component using bootstrap styling
Vue.component('vuetable-pagination-bootstrap', {
    template: '#vuetable-pagination-bootstrap-template',
    mixins: [paginationMixin],
    methods: {
        loadPage: function loadPage(page) {
            this.$dispatch('vuetable-pagination:change-page', page);
        }
    }
});

exports['default'] = Vue.extend({
    data: function data() {
        return {
            showPrevious: false,
            loaded: false,
            commonData: [],
            data: {
                A: [],
                B: [],
                C: []
            },
            zoneData: {
                zone: '',
                zip_id: '',
                zips: []
            },
            state: false,
            query: [],
            cityCheck: [],
            cityCheckOld: [],
            perPage: 1000,
            columns: tableColumns,
            moreParams: [],
            zip: {
                zip_code: ''
            },
            currentZip: {},
            sortOrder: {
                field: 'cities.title',
                direction: 'asc'
            },
            paginationInfoTemplate: 'vuetable-pagination-bootstrap',
            itemActions: [{
                name: 'view-zones',
                label: editZone,
                icon: '',
                'class': ''
            }]
        };
    },

    watch: {

        'showPrevious': function showPrevious(val, oldVal) {
            this.cityCheck = [];
            var that = this;
            var response = _.cloneDeep(this.commonData);
            _.forEach(response.cities, function (city) {
                var zips = _.pluck(city.zips, 'id');
                _.forEach(zips, function (value) {
                    if (that.exists(value)) {
                        Vue.set(that.cityCheck, that.cityCheck.length, city.id);
                        return false;
                    }
                });
            });
        },

        'zoneData.zone': function zoneDataZone(val, oldVal) {
            if (val == 'A') {
                this.zoneData.zips = this.currentZip.zoneA;
                this.data.A = _.cloneDeep(this.currentZip.zoneA);
            }
            if (val == 'B') {
                this.zoneData.zips = this.currentZip.zoneB;
                this.data.B = _.cloneDeep(this.currentZip.zoneB);
            }
            if (val == 'C') {
                this.zoneData.zips = this.currentZip.zoneC;
                this.data.C = _.cloneDeep(this.currentZip.zoneC);
            }

            var that = this;
            var response = _.cloneDeep(this.commonData);
            this.cityCheck = [];
            _.forEach(response.cities, function (city) {
                var zips = _.pluck(city.zips, 'id');
                _.forEach(zips, function (value) {
                    if (that.exists(value)) {
                        Vue.set(that.cityCheck, that.cityCheck.length, city.id);
                        return false;
                    }
                });
            });
        },

        'cityCheck': function cityCheck(val, oldVal) {
            var _this = this;

            // _.forEach(val, function (value) {
            //     alert(value);
            // });
            console.log(this.cityCheck.length, this.cityCheckOld.length);
            if (this.cityCheck.length > this.cityCheckOld.length) {
                (function () {
                    // An item was added
                    var addedItem = _this.cityCheck.find(function (item) {
                        return !_this.cityCheckOld.includes(item);
                    });
                    var city = _.find(_this.commonData.cities, { 'id': addedItem });
                    var zips = _.pluck(city.zips, 'id');
                    var that = _this;
                    _.forEach(zips, function (value) {
                        if (!that.exists(value)) {
                            Vue.set(that.zoneData.zips, that.zoneData.zips.length, value + '');
                        }
                    });
                })();
            } else if (this.cityCheck.length < this.cityCheckOld.length) {
                (function () {
                    // An item was removed
                    var removedItem = _this.cityCheckOld.find(function (item) {
                        return !_this.cityCheck.includes(item);
                    });
                    var city = _.find(_this.commonData.cities, { 'id': removedItem });
                    var zips = _.pluck(city.zips, 'id');
                    var that = _this;
                    _.forEach(zips, function (value) {
                        //that.zoneData.zips = that.zoneData.zips.filter(zip => zip !== value)
                        var index = that.zoneData.zips.indexOf(value + '');
                        if (index !== -1) {
                            that.zoneData.zips.splice(index, 1);
                        }
                    });
                })();
            } else {
                console.log('No change in length, or multiple changes');
            }
            this.cityCheckOld = _.cloneDeep(this.cityCheck);
            console.log(this.zoneData.zips);
        }
    },

    events: {
        'vuetable:action': function vuetableAction(action, data) {
            if (action == 'view-zones') {
                this.zoneModal(data);
            }
        },
        'vuetable:loading': function vuetableLoading() {
            notify.loading(true);
        },
        'vuetable:load-success': function vuetableLoadSuccess(response) {
            if (!this.loaded) {
                this.currentZip = response.data.data[0];
                this.currentZip.zoneA = _.pluck(response.data.data[0].zone_a, 'child_zip_id').map(String);
                this.currentZip.zoneB = _.pluck(response.data.data[0].zone_b, 'child_zip_id').map(String);
                this.currentZip.zoneC = _.pluck(response.data.data[0].zone_c, 'child_zip_id').map(String);
            }
            notify.loading(false);
        },
        'vuetable:load-error': function vuetableLoadError(response) {
            notify.loading(false);
            console.log('Load Error: ', response);
        }
    },
    ready: function ready() {
        //this.currentZip = this.zip;
        var that = this;
        $('#zip_zones').on('hidden.bs.modal', function () {
            that.showPrevious = false;
            that.zoneData.zone = "";
            that.$broadcast('vuetable:refresh');
        });
        this.getData();
    },

    methods: {

        cityCheckChange: function cityCheckChange(val) {
            alert(val);
        },

        isEmpty: function isEmpty(obj) {
            for (var key in obj) {
                if (obj.hasOwnProperty(key)) return false;
            }
            return true;
        },

        zipCode: function zipCode(value) {
            return value.client ? '<span class="text-black text-Watch-List">' + value.zip + '</span>' : value.zip;
        },
        zoneA: function zoneA(value) {
            return value > 0 ? '<span class="badge badge-success">' + value + '</span>' : '<span class="badge badge-danger">0</span>';
        },
        zoneB: function zoneB(value) {
            return value > 0 ? '<span class="badge badge-success">' + value + '</span>' : '<span class="badge badge-danger">0</span>';
        },
        zoneC: function zoneC(value) {
            return value > 0 ? '<span class="badge badge-success">' + value + '</span>' : '<span class="badge badge-danger">0</span>';
        },

        getData: function getData() {
            var _this2 = this;

            this.$http.get('/api/zip-data', this.zip, function (response) {
                _this2.commonData = response;
            }).always(function () {});
        },

        contains: function contains(id) {
            var zipId = String(id);
            //alert(zipId);
            if (this.zoneData.zone == '') {
                return !_.contains(this.currentZip.zoneB, zipId) && !_.contains(this.currentZip.zoneC, zipId) && !_.contains(this.currentZip.zoneA, zipId);
            }

            if (this.zoneData.zone == 'A') {
                return !_.contains(this.currentZip.zoneB, zipId) && !_.contains(this.currentZip.zoneC, zipId);
            }
            if (this.zoneData.zone == 'B') {
                return !_.contains(this.currentZip.zoneA, zipId) && !_.contains(this.currentZip.zoneC, zipId);
            }
            if (this.zoneData.zone == 'C') {
                return !_.contains(this.currentZip.zoneB, zipId) && !_.contains(this.currentZip.zoneA, zipId);
            }
        },

        exists: function exists(id) {
            var zipId = String(id);
            if (this.zoneData.zone == 'A') {
                return _.contains(this.data.A, zipId);
            }
            if (this.zoneData.zone == 'B') {
                return _.contains(this.data.B, zipId);
            }
            if (this.zoneData.zone == 'C') {
                return _.contains(this.data.C, zipId);
            }
        },

        setFilter: function setFilter() {
            this.moreParams = ['filter=' + this.query];
            this.$nextTick(function () {
                this.$broadcast('vuetable:refresh');
            });
        },

        zoneModal: function zoneModal(zip) {
            var state = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];

            this.loaded = true;
            this.currentZip = _.clone(zip);
            this.currentZip.zoneA = _.pluck(zip.zone_a, 'child_zip_id').map(String);
            this.currentZip.zoneB = _.pluck(zip.zone_b, 'child_zip_id').map(String);
            this.currentZip.zoneC = _.pluck(zip.zone_c, 'child_zip_id').map(String);
            this.zoneData.zip_id = this.currentZip.id;

            //sort zips on zone a
            this.currentZip.zone_a = _.sortBy(this.currentZip.zone_a, 'zip.zip_code');

            //sort zips on zone b
            this.currentZip.zone_b = _.sortBy(this.currentZip.zone_b, 'zip.zip_code');

            //sort zips on zone c
            this.currentZip.zone_c = _.sortBy(this.currentZip.zone_c, 'zip.zip_code');

            this.zoneData.zips = this.currentZip.zoneA;

            this.clearData();

            if (state) {
                modals.showStrict('#zip_zones');
            }
        },

        moveToZone: function moveToZone() {
            var _this3 = this;

            this.zoneData.zip_id = this.currentZip.id;
            this.state = true;
            this.$http.post('/api/zip-add-zone', this.zoneData, function (response) {
                _this3.clearFields();
                _this3.$broadcast('vuetable:reload');
                _this3.zoneModal(response, false);
            }).always(function () {
                _this3.state = false;
            });
        },

        removeZoneZip: function removeZoneZip(code) {
            var _this4 = this;

            this.$http['delete']('/api/zip-remove-zone', code, function (response) {
                _this4.zoneModal(response, false);
                //notify.success('Zip Code Deleted From Zone');
            }).always(function () {
                notify.loading(false);
            });
        },

        clearFields: function clearFields() {
            this.zoneData = {
                zone: '',
                zip_id: '',
                zips: []
            };

            this.zip = {
                zip_code: ''
            };
        },

        clearData: function clearData() {
            this.data = {
                A: [],
                B: [],
                C: []
            };
        },

        clients: function clients(val) {
            return parseInt(val) ? '<span class="label label-success">' + val + '</span>' : '';
        }
    }
});
module.exports = exports['default'];

},{"./../../../mixed/modals":10,"./../../../mixed/notify":11}],134:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});
var notify = require('./../../../mixed/notify');

exports['default'] = Vue.extend({
    data: function data() {
        return {
            user: {
                email: '',
                password: '',
                remember: '',
                fingerprint: ''
            },
            state: false
        };
    },

    ready: function ready() {
        var that = this;
        ec.get("fingerprint", function (value) {
            if (typeof value == 'undefined') {
                ec.set("fingerprint", val);
                that.user.fingerprint = val;
            } else {
                that.user.fingerprint = value;
            }
        });
        //this.fingerprint = window.devicePrint;
    },

    methods: {
        /**
         * send login request
         */
        login: function login() {
            var _this = this;

            this.state = true;
            this.$http.post('/login', this.user, function (response) {
                window.location = response;
            }).always(function () {
                _this.state = false;
            });
        }
    }
});
module.exports = exports['default'];

},{"./../../../mixed/notify":11}],135:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});
var notify = require('./../../../mixed/notify');
var modals = require('./../../../mixed/modals');

var editClient = typeof canEditClient !== 'undefined' && canEditClient == true ? 'icon-pencil7 text-primary-600' : '';
var deleteClient = typeof canDeleteClient !== 'undefined' && canDeleteClient == true ? 'icon-trash text-danger-600' : '';
var departmentClient = typeof canManageClientDepartments !== 'undefined' && canManageClientDepartments == true ? '<a href="#" class="label label-primary">Departments</a>' : '';
var contactClient = typeof canManageClientContacts !== 'undefined' && canManageClientContacts == true ? '<a href="#" class="label label-info left-m-30">Contacts</a>' : '';
var positionClient = typeof canManageClientPositions !== 'undefined' && canManageClientPositions == true ? '<a href="#" class="label label-success right-m-30">Positions</a>' : '';

var tableColumns = [{
    name: 'id',
    title: '#',
    sortField: 'id'
}, {
    name: 'custom_name',
    title: 'Name',
    sortField: 'name'
}, {
    name: 'company_code',
    title: 'Code',
    sortField: 'company_code'
}, {
    name: 'phone',
    title: 'Phone',
    sortField: 'phone'
}, {
    name: 'fax',
    title: 'Fax',
    sortField: 'fax'
}, {
    name: 'client_group',
    title: 'Group',
    sortField: 'client_group_id'
}, {
    name: 'zip',
    title: 'Zip',
    sortField: 'zip'
}, {
    name: '__actions'
}];

// create pagination component using bootstrap styling
Vue.component('vuetable-pagination-bootstrap', {
    template: '#vuetable-pagination-bootstrap-template',
    mixins: [paginationMixin],
    methods: {
        loadPage: function loadPage(page) {
            this.$dispatch('vuetable-pagination:change-page', page);
        }
    }
});

exports['default'] = Vue.extend({
    data: function data() {
        return {
            days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
            selectedRow: [],
            clientObject: {
                name: '',
                client_group_id: '',
                company_code: '',
                address_line_1: '',
                address_line_2: '',
                area: '',
                city: '',
                state: '',
                zip: '',
                phone: '',
                fax: '',
                notes: '',
                weekday_start_time: '',
                weekday_end_time: '',
                sat_start_time: '',
                sat_end_time: '',
                sun_start_time: '',
                sun_end_time: '',
                status: 1,
                allow_app_access: 0,
                early_clock_in_hr: 0
            },
            client: {},
            currentClient: {
                name: '',
                client_group_id: '',
                company_code: '',
                address_line_1: '',
                address_line_2: '',
                area: '',
                city: '',
                state: '',
                zip: '',
                phone: '',
                fax: '',
                notes: '',
                weekday_start_time: '',
                weekday_end_time: '',
                sat_start_time: '',
                sat_end_time: '',
                sun_start_time: '',
                sun_end_time: '',
                default_invoice_format: '',
                invoice_week_start: '',
                status: '',
                allow_app_access: 0,
                early_clock_in_hr: 0
            },
            activeClient: {
                id: 0,
                name: '',
                company_code: '',
                address_line_1: '',
                address_line_2: '',
                area: '',
                city: '',
                state: '',
                zip: '',
                phone: '',
                fax: '',
                notes: ''
            },
            newContact: {
                first_name: '',
                last_name: '',
                middle_name: '',
                personal_title: 'Mr',
                client_id: '',
                job_title: '',
                main_phone: '',
                ext_phone: '',
                alternative_phone: '',
                direct_number: '',
                cell_phone: '',
                preffered_method: '',
                email: '',
                comments: '',
                password: '',
                timesheet_allow_all_positions: false,
                timesheet_departments: []
            },
            currentContact: {
                first_name: '',
                last_name: '',
                middle_name: '',
                personal_title: '',
                client_id: '',
                job_title: '',
                main_phone: '',
                alternative_phone: '',
                ext_phone: '',
                direct_number: '',
                cell_phone: '',
                preffered_method: '',
                email: '',
                comments: '',
                password: '',
                timesheet_allow_all_positions: 0,
                timesheet_departments: []
            },
            newDepartment: {
                name: '',
                client_id: '',
                contact_id: '',
                comments: '',
                invoice_recepient: 0,
                invoice_cc: [],
                timesheet_recepient: [],
                timesheet_collection: []
            },
            currentDepartment: {
                name: '',
                client_id: 0,
                contact_id: 0,
                comments: '',
                invoice_recepient: 0,
                invoice_cc: [],
                timesheet_recepient: [],
                timesheet_collection: []
            },
            clientDepartments: [],
            query: '',
            departments: [],
            contacts: [],
            moreParams: ['zip=' + zip + '&status=' + status],
            perPage: 200,
            state: false,
            columns: tableColumns,
            sortOrder: {
                field: 'id',
                direction: 'asc'
            },
            paginationInfoTemplate: 'vuetable-pagination-bootstrap',
            itemActions: [{
                name: 'edit-client',
                label: '',
                icon: editClient,
                'class': ''
            }, {
                name: 'view-contacts',
                label: contactClient,
                icon: '',
                'class': ''
            }, {
                name: 'view-departments',
                label: departmentClient,
                icon: '',
                'class': ''
            }, {
                name: 'current-positions',
                label: positionClient,
                icon: '',
                'class': ''
            },
            // {
            //     name: 'show-employees',
            //     label: '<a href="#" class="label label-warning right-m-30">Employees</a>',
            //     icon: '',
            //     class: ''
            // },
            {
                name: 'delete-data',
                label: '',
                icon: deleteClient,
                'class': ''
            }],
            deleteContact: false,
            deleteDepartment: false
        };
    },

    ready: function ready() {
        var _this = this;

        this.client = _.cloneDeep(this.clientObject);
        $('#modal_edit_contact').on('hidden.bs.modal', function () {
            //this.currentContact = {};
        });

        $('#modal_edit_department').on('hidden.bs.modal', function () {
            //this.currentDepartment = {};
        });
        $('#client-departments').on('hidden.bs.modal', function () {
            _this.departments = {};
            _this.currentDepartment = {};
        });
    },
    filters: {
        newLine: function newLine(val) {
            if (typeof val !== 'undefined') return val.replace(/(?:\r\n|\r|\n)/g, '<br />');
        }
    },
    components: {
        'positions': require('./components/positions')
    },
    watch: {
        perPage: function perPage(val, oldVal) {
            this.$broadcast('vuetable:refresh');
        }
    },

    events: {
        'vuetable:action': function vuetableAction(action, data) {
            console.log('vuetable:action', action, data);
            if (action === 'edit-client') {
                this.editModal(data);
            }

            if (action === 'client-group') {
                this.groupModal(data);
            }

            if (action === 'delete-data') {
                this.confirmDelete(data);
            }

            if (action === 'view-departments') {
                this.viewDepartments(data);
            }

            if (action === 'view-contacts') {
                this.viewContacts(data);
            }

            if (action === 'current-positions') {
                this.currentPositionsModal(data);
            }

            if (action === 'show-employees') {
                this.showEmployees(data);
            }
        },

        'vuetable:loading': function vuetableLoading() {
            notify.loading(true);
        },

        'vuetable:load-success': function vuetableLoadSuccess(response) {
            notify.loading(false);
        },

        'vuetable:load-error': function vuetableLoadError(response) {
            notify.loading(false);
            console.log('Load Error: ', response);
        }
    },

    methods: {
        showPositionModal: function showPositionModal(client) {
            this.currentClient = _.cloneDeep(client);
            this.$broadcast('setClientId', this.currentClient.id);
            modals.showStrict('#modal_add_position');
        },

        currentPositionsModal: function currentPositionsModal(client) {
            this.currentClient = _.cloneDeep(client);
            this.$broadcast('showPositions', this.currentClient.id);
            modals.showStrict('#modal_positions');
        },

        showEmployees: function showEmployees(client) {
            this.currentClient = _.cloneDeep(client);
            this.$broadcast('setClient', this.currentClient);
            modals.showStrict('#list-employees');
        },

        createClientModal: function createClientModal() {
            this.client = _.cloneDeep(this.clientObject);
            modals.showStrict("#modal_add_client");
        },

        createClient: function createClient() {
            var _this2 = this;

            this.state = true;
            this.client.notes = this.client.notes.replace(/(?:\r\n|\r|\n)/g, '<br />');
            this.$http.post('/api/client', this.client, function () {
                modals.hide('#modal_add_client');
                notify.success('New Client Added Successfully');
                _this2.clearFields();
            }).always(function () {
                _this2.$broadcast('vuetable:refresh');
                _this2.state = false;
            });
        },

        groupModal: function groupModal(client) {
            this.currentClient = _.cloneDeep(client);
            modals.show('#modal_client_group');
        },

        editClientGroup: function editClientGroup() {
            var _this3 = this;

            this.state = true;
            this.$http.put('/api/client-group/' + this.currentClient.id, this.currentClient, function (response) {
                modals.hide('#modal_client_group');
                notify.success('Client Group Information Edited Successfully');
            }).always(function () {
                _this3.$broadcast('vuetable:reload');
                _this3.state = false;
            });
        },

        editModal: function editModal(client) {
            var _this4 = this;

            notify.loading(true);
            this.$http.get('/api/client/' + client.id, '', function (response) {
                _this4.currentClient = _.cloneDeep(response);
                modals.showStrict('#modal_edit_client');
            }).always(function () {
                notify.loading(false);
            });
        },

        editClient: function editClient() {
            var _this5 = this;

            this.state = true;
            this.currentClient.notes = this.currentClient.notes.replace(/(?:\r\n|\r|\n)/g, '<br />');
            this.$http.put('/api/client/' + this.currentClient.id, this.currentClient, function (response) {
                modals.hide('#modal_edit_client');
                notify.success('Client Information Edited Successfully');
            }).always(function () {
                _this5.$broadcast('vuetable:reload');
                _this5.state = false;
            });
        },

        confirmDelete: function confirmDelete(client) {
            this.currentClient = client;
            notify.confirm('Are you sure you want to remove this client?', '', this.deleteClient);
        },

        deleteClient: function deleteClient() {
            var _this6 = this;

            this.$http['delete']('/api/client/' + this.currentClient.id, '', function () {
                notify.success('Client Deleted');
            }).always(function () {
                _this6.$broadcast('vuetable:reload');
            });
        },

        setFilter: function setFilter() {
            this.moreParams = ['filter=' + this.query + '&zip=' + zip];
            this.$nextTick(function () {
                this.$broadcast('vuetable:refresh');
            });
        },

        status: function status(val) {
            return parseInt(val) === 0 ? '<span class="label label-danger">Suspended</span>' : '<span class="label label-success">Active</span>';
        },

        clearFields: function clearFields() {
            this.client = {
                name: '',
                company_code: '',
                address_line_1: '',
                address_line_2: '',
                city: '',
                state: '',
                zip: '',
                phone: '',
                fax: ''
            };
        },

        fetchClientInfo: function fetchClientInfo(id) {
            this.$http.get('/api/client/' + id, '', function (response) {}).always(function () {});
        },

        /**
         * show client departments
         * @param client
         */
        viewDepartments: function viewDepartments(client) {
            var _this7 = this;

            notify.loading(true);
            this.$http.get('/api/client-departments/' + client.id, '', function (response) {
                _this7.activeClient = _.cloneDeep(response);
                _this7.departments = response.departments;
                _this7.contacts = response.contacts;
                _this7.newDepartment.client_id = _this7.activeClient.id;
                _this7.deleteDepartment = false;
                modals.showStrict('#client-departments');
            }).always(function () {
                notify.loading(false);
            });
        },

        /**
         * show contacts for a client
         * @param client
         */
        viewContacts: function viewContacts(client) {
            var _this8 = this;

            notify.loading(true);
            this.$http.get('/api/client-contacts/' + client.id, '', function (response) {
                _this8.activeClient = _.cloneDeep(response);
                _this8.contacts = response.contacts;
                _this8.newContact.client_id = _this8.activeClient.id;
                _this8.newContact.main_phone = _this8.activeClient.phone;
                _this8.deleteContact = false;
                _this8.clientDepartments = response.departments;
                modals.showStrict('#client-contacts');
            }).always(function () {
                notify.loading(false);
            });
        },

        createContact: function createContact() {
            var _this9 = this;

            this.state = true;
            this.newContact.comments = this.newContact.comments.replace(/(?:\r\n|\r|\n)/g, '<br />');
            this.$http.post('/api/contact', this.newContact, function (response) {
                _this9.contacts = response;
                modals.hide('#modal_add_contact');
                notify.success('New Contact Added Successfully');
                _this9.clearContactFields();
            }).always(function () {
                _this9.$broadcast('vuetable:refresh');
                _this9.state = false;
            });
        },

        confirmDeleteContact: function confirmDeleteContact(contact) {
            this.currentContact = contact;
            notify.confirm('Are you sure you want to remove this contact?', '', this.deleteClientContact);
        },

        deleteClientContact: function deleteClientContact() {
            var _this10 = this;

            this.$http['delete']('/api/contact/' + this.currentContact.id, '', function (response) {
                _this10.contacts.$remove(_this10.currentContact);
                notify.success('Contact Deleted');
            }).always(function () {
                _this10.$broadcast('vuetable:refresh');
            });
        },

        clearContactFields: function clearContactFields() {
            var clientId = this.newContact.client_id;
            this.newContact = {
                first_name: '',
                last_name: '',
                middle_name: '',
                personal_title: '',
                client_id: clientId,
                job_title: '',
                main_phone: '',
                alternative_phone: '',
                ext_phone: '',
                direct_number: '',
                cell_phone: '',
                preffered_method: '',
                email: '',
                comments: '',
                password: ''
            };
        },

        editContactModal: function editContactModal(contact) {
            this.currentContact = _.cloneDeep(contact);
            this.currentContact.timesheet_departments = _.pluck(contact.departments, 'id').map(String);
            this.currentContact.timesheet_allow_all_positions = !!contact.timesheet_allow_all_positions;
            modals.showStrict('#modal_edit_contact');
        },

        sendInvitation: function sendInvitation(id) {
            if (!id) {
                notify.info("Please set user account before sending invitation.");

                return false;
            }
            notify.loading(true);
            this.$http.get('/api/send-manager-invitation/' + id, function (response) {
                //modals.hide("#modal-edit-employee-info");
            }).always(function () {
                notify.loading(false);
            });
        },

        editContact: function editContact() {
            var _this11 = this;

            this.state = true;
            this.currentContact.comments = this.currentContact.comments.replace(/(?:\r\n|\r|\n)/g, '<br />');
            this.$http.put('/api/contact/' + this.currentContact.id, this.currentContact, function (response) {
                modals.hide('#client-contacts');
                modals.hide('#modal_edit_contact');
                notify.success('Contact Information Edited Successfully');
            }).always(function () {
                // this.$broadcast('vuetable:reload');
                _this11.state = false;
            });
        },

        createDepartment: function createDepartment() {
            var _this12 = this;

            this.state = true;
            this.newDepartment.comments = this.newDepartment.comments.replace(/(?:\r\n|\r|\n)/g, '<br />');
            this.$http.post('/api/department', this.newDepartment, function (response) {
                _this12.departments = response;
                modals.hide('#modal_add_department');
                notify.success('New Department Added Successfully');
                _this12.clearDepartmentForm();
            }).always(function () {
                _this12.$broadcast('vuetable:refresh');
                _this12.state = false;
            });
        },

        editDepartmentModal: function editDepartmentModal(department) {
            console.log(department);
            this.currentDepartment = _.cloneDeep(department);
            this.currentDepartment.invoice_cc = _.pluck(department.invoice, 'id').map(String);
            this.currentDepartment.timesheet_recepient = _.pluck(department.timesheet_recepient, 'id').map(String);
            this.currentDepartment.timesheet_collection = _.pluck(department.timesheet_collection, 'id').map(String);
            // $('#invoice_cc').select2({
            //     data: this.currentDepartment.invoice_cc
            // });
            // $('#timesheet_recepient').select2({
            //     data: this.currentDepartment.timesheet_recepient
            // });
            // $('#timesheet_collection').select2({
            //     data: this.currentDepartment.timesheet_collection
            // });
            modals.showStrict('#modal_edit_department');
        },

        editDepartment: function editDepartment() {
            var _this13 = this;

            this.state = true;
            this.currentDepartment.comments = this.currentDepartment.comments.replace(/(?:\r\n|\r|\n)/g, '<br />');
            this.$http.put('/api/department/' + this.currentDepartment.id, this.currentDepartment, function (response) {
                _this13.activeClient = _.cloneDeep(response);
                _this13.departments = response.departments;
                _this13.contacts = response.contacts;
                _this13.newDepartment.client_id = _this13.activeClient.id;
                _this13.deleteDepartment = false;
                modals.hide('#modal_edit_department');
                notify.success('Department Information Edited Successfully');
            }).always(function () {
                // this.$broadcast('vuetable:reload');
                _this13.state = false;
            });
        },

        confirmDeleteDepartment: function confirmDeleteDepartment(department) {
            this.currentDepartment = department;
            notify.confirm('Are you sure you want to remove this department?', '', this.deleteClientDepartment);
        },

        deleteClientDepartment: function deleteClientDepartment() {
            var _this14 = this;

            this.$http['delete']('/api/department/' + this.currentDepartment.id, '', function () {
                _this14.departments.$remove(_this14.currentDepartment);
                notify.success('Department Deleted');
            }).always(function () {
                _this14.$broadcast('vuetable:reload');
            });
        },

        clearDepartmentForm: function clearDepartmentForm() {
            var clientId = this.newDepartment.client_id;
            this.newDepartment = {
                name: '',
                contact_id: 0,
                client_id: clientId,
                comments: ''
            };
        }
    }
});
module.exports = exports['default'];

},{"./../../../mixed/modals":10,"./../../../mixed/notify":11,"./components/positions":136}],136:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});
var notify = require('./../../../../mixed/notify');
var modals = require('./../../../../mixed/modals');

/**
 * move index position for a element in an array
 * @param old_index
 * @param new_index
 * @returns array
 */
Array.prototype.move = function (old_index, new_index) {
    if (new_index >= this.length) {
        var k = new_index - this.length;
        while (k-- + 1) {
            this.push(undefined);
        }
    }
    this.splice(new_index, 0, this.splice(old_index, 1)[0]);
    return this;
};

exports['default'] = Vue.extend({

    filters: {

        maxIncrease: {
            read: function read(val) {
                return val;
            },
            write: function write(val, oldVal, rate) {
                if (val >= this.currentPosition.pay_rate) {
                    if (val - this.currentPosition.pay_rate > this.maxIncrease) {
                        return rate;
                    } else {
                        return val;
                    }
                }
                if (val <= this.currentPosition.pay_rate) {
                    if (this.currentPosition.pay_rate - val > this.maxIncrease) {
                        return rate;
                    } else {
                        return val;
                    }
                }
            }
        },

        gross: {
            read: function read(val) {
                return val;
            },
            write: function write(val, oldVal) {
                var number = +val.replace(/[^\d.]/g, '');
                if (isNaN(number)) {
                    return 0;
                } else {
                    return number > 15 ? 0 : number;
                }
            }
        },

        net: {
            read: function read(val) {
                return val;
            },
            write: function write(val, oldVal) {
                var number = +val.replace(/[^\d.]/g, '');
                if (isNaN(number)) {
                    return 0;
                } else {
                    return number >= 40 ? 0 : number;
                }
            }
        }
    },
    props: ['currentClient'],
    data: function data() {
        return {
            maxIncrease: 0,
            employeePosition: {},
            commonData: [],
            state: false,
            query: [],
            perPage: 40,
            page: 1,
            moreParams: [],
            job: 0,
            client: 0,
            department: 0,
            types: ['A', 'B', 'C', 'U'],
            currentJob: {
                pay_rate: '',
                title: ''
            },
            currentClient: {},
            currentDepartment: {},
            positions: {
                positionA: {
                    type: 'A',
                    uniforms: [],
                    tools: [],
                    skills: [],
                    grooming: [],
                    attitude: [],
                    reliability: [],
                    background: [],
                    pay_rate: 0,
                    overtime_pay_rate: 0,
                    billing_rate: 0,
                    overtime_billing_rate: 0,
                    title: '',
                    gender: ''
                },
                positionB: {
                    type: 'B',
                    uniforms: [],
                    tools: [],
                    skills: [],
                    grooming: [],
                    attitude: [],
                    reliability: [],
                    background: [],
                    pay_rate: 0,
                    overtime_pay_rate: 0,
                    billing_rate: 0,
                    overtime_billing_rate: 0,
                    title: '',
                    gender: ''
                },
                positionC: {
                    type: 'C',
                    uniforms: [],
                    tools: [],
                    skills: [],
                    grooming: [],
                    attitude: [],
                    reliability: [],
                    background: [],
                    pay_rate: 0,
                    overtime_pay_rate: 0,
                    billing_rate: 0,
                    overtime_billing_rate: 0,
                    title: '',
                    gender: ''
                }
            },
            currentPosition: {},
            data: {
                auto_selection: 1,
                positions: {},
                client_id: '',
                department_id: '',
                job_id: '',
                pay_rate: 0,
                overtime_pay_rate: 0,
                allow_overtime_pay_rate: 1,
                billing_rate: 0,
                zone_b_increased_pay: 0.50,
                zone_c_increased_pay: 1,
                overtime_billing_rate: 0,
                allow_overtime_billing_rate: 1,
                title: '',
                gender: 'Both',
                note: '',
                admin_note: '',
                employee_note: '',
                managers: [{
                    user_id: 0,
                    net: 0,
                    gross: 0,
                    per_hour: 0
                }, {
                    user_id: 0,
                    net: 0,
                    gross: 0,
                    per_hour: 0
                }, {
                    user_id: 0,
                    net: 0,
                    gross: 0,
                    per_hour: 0
                }],
                contacts: {
                    primary: '',
                    secondary: '',
                    optional: ''
                }
            },
            currentData: {
                auto_selection: 0,
                positions: {},
                client_id: '',
                department_id: '',
                job_id: '',
                pay_rate: 0,
                overtime_pay_rate: 0,
                allow_overtime_pay_rate: false,
                billing_rate: 0,
                zone_b_increased_pay: 0.50,
                zone_c_increased_pay: 1,
                overtime_billing_rate: 0,
                allow_overtime_billing_rate: false,
                minutes_early: '',
                title: '',
                gender: '',
                note: '',
                admin_note: '',
                employee_note: '',
                managers: [],
                contacts: {
                    primary: '',
                    secondary: '',
                    optional: ''
                }
            },
            managers: {},
            currentManagers: {},
            sortOrder: {
                field: 'id',
                direction: 'asc'
            },
            employees: {},
            employeesNoZone: {},
            employeesHighSalary: {},
            currentUniforms: {},
            currentTools: {},
            currentSkills: {},
            currentEmployee: {},
            clientPositions: [],
            activePosition: '',
            employeeTypes: ['D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M'],
            sortOrders: true,
            sortKey: 'action_sort',
            currentPositionCode: '',
            position: {}
        };
    },

    events: {
        setClientId: function setClientId(id) {
            this.data.client_id = id;
        },
        setClient: function setClient(client) {
            this.currentClient = _.cloneDeep(client);
        },
        showPositions: function showPositions(id) {
            this.data.client_id = id;
            this.getPositions();
        }
    },
    ready: function ready() {
        this.getData();
        this.currentPosition = _.cloneDeep(this.position);
        var that = this;
        $('#modal_add_position').on('hidden.bs.modal', function () {
            that.clearFields();
        });
        $('#list-employees').on('hidden.bs.modal', function () {
            that.activePosition = '';
            that.employees = {};
            that.perPage = 40;
            that.page = 1;
        });
    },

    components: {
        'schedules': require('./schedules')
    },

    watch: {

        'data.job_id': function dataJob_id(val, oldVal) {
            this.setCurrentJob(val);
        },

        'data.client_id': function dataClient_id(val, oldVal) {
            this.department_id = 0;
            this.setClient(val);
        },

        'data.department_id': function dataDepartment_id(val, oldVal) {
            this.currentDepartment = _.find(this.currentClient.departments, function (obj) {
                return obj.id == val;
            });
        },

        'currentData.department_id': function currentDataDepartment_id(val, oldVal) {
            this.currentDepartment = _.find(this.currentClient.departments, function (obj) {
                return obj.id == val;
            });
        },

        'data.managers[0].user_id': function dataManagers0User_id(val) {
            this.filterManagers();
        },
        'data.managers[1].user_id': function dataManagers1User_id(val) {
            this.filterManagers();
        },
        'data.managers[2].user_id': function dataManagers2User_id(val) {
            this.filterManagers();
        },

        'currentData.managers[0].user_id': function currentDataManagers0User_id(val) {
            this.filterCurrentManagers();
        },
        'currentData.managers[1].user_id': function currentDataManagers1User_id(val) {
            this.filterCurrentManagers();
        },
        'currentData.managers[2].user_id': function currentDataManagers2User_id(val) {
            this.filterCurrentManagers();
        },

        'data.pay_rate': function dataPay_rate(val) {
            this.data.overtime_pay_rate = (Number(val) * 1.5).toFixed(2);
        },

        'data.billing_rate': function dataBilling_rate(val) {
            this.data.overtime_billing_rate = (Number(val) * 1.5).toFixed(2);
        },
        'currentData.pay_rate': function currentDataPay_rate(val) {
            this.currentData.overtime_pay_rate = (Number(val) * 1.5).toFixed(2);
        },

        'currentData.billing_rate': function currentDataBilling_rate(val) {
            this.currentData.overtime_billing_rate = (Number(val) * 1.5).toFixed(2);
        },

        'activePosition': function activePosition(val) {
            if (val) {
                this.employeeModal(val, false);
            }
        }
    },

    methods: {
        showScheduleRules: function showScheduleRules(position) {
            this.position = _.cloneDeep(position);
            this.$broadcast('showPositionRules', this.position.position_code);
            // modals.showStrict('#list-schedule-employees');
        },

        filterManagers: function filterManagers() {
            var that = this;
            this.managers = _.cloneDeep(this.commonData.managers);
            this.managers = _.filter(this.managers, function (o) {
                return o.id != that.data.managers[0].user_id && o.id != that.data.managers[1].user_id && o.id != that.data.managers[2].user_id;
            });
        },

        filterCurrentManagers: function filterCurrentManagers() {
            var that = this;
            this.currentManagers = _.cloneDeep(this.commonData.managers);
            this.currentManagers = _.filter(this.currentManagers, function (o) {
                return o.id != that.currentData.managers[0].user_id && o.id != that.currentData.managers[1].user_id && o.id != that.currentData.managers[2].user_id;
            });
        },

        getData: function getData() {
            var _this = this;

            this.$http.get('/api/position-data', '', function (response) {
                _this.commonData = response;
                _this.maxIncrease = response.maxIncrease;
            }).always(function () {
                _this.managers = _this.commonData.managers;
                _this.currentManagers = _this.commonData.managers;
            });
        },

        setCurrentJob: function setCurrentJob(id) {
            this.currentJob = _.clone(_.find(this.commonData.jobs, function (o) {
                return o.id == id;
            }));
            this.setOrder();
            this.setEmptyUTS();
        },

        setUTS: function setUTS() {
            this.positions.positionA.tools = _.pluck(this.positions.positionA.tools, 'id').map(String);
            this.positions.positionA.skills = _.pluck(this.positions.positionA.skills, 'id').map(String);
            this.positions.positionA.uniforms = _.pluck(this.positions.positionA.uniforms, 'id').map(String);
            this.positions.positionA.type = "A";

            this.positions.positionB.tools = _.pluck(this.positions.positionB.tools, 'id').map(String);
            this.positions.positionB.skills = _.pluck(this.positions.positionB.skills, 'id').map(String);
            this.positions.positionB.uniforms = _.pluck(this.positions.positionB.uniforms, 'id').map(String);
            this.positions.positionB.type = "B";

            this.positions.positionC.tools = _.pluck(this.positions.positionC.tools, 'id').map(String);
            this.positions.positionC.skills = _.pluck(this.positions.positionC.skills, 'id').map(String);
            this.positions.positionC.uniforms = _.pluck(this.positions.positionC.uniforms, 'id').map(String);
            this.positions.positionC.type = "C";
        },

        setCurrentUTS: function setCurrentUTS() {
            var coreskills = _.pluck(this.currentJob.skills, 'id').map(String);
            var skillsA = _.pluck(this.currentPosition.position_a.skills, 'id').map(String);
            skillsA = _.filter(skillsA, function (o) {
                return coreskills.includes(o);
            });
            this.currentPosition.positionA.tools = _.pluck(this.currentPosition.position_a.tools, 'id').map(String);
            this.currentPosition.positionA.skills = skillsA;
            this.currentPosition.positionA.uniforms = _.pluck(this.currentPosition.position_a.uniforms, 'id').map(String);
            this.currentPosition.positionA.type = "A";

            var skillsB = _.pluck(this.currentPosition.position_b.skills, 'id').map(String);
            skillsB = _.filter(skillsB, function (o) {
                return coreskills.includes(o);
            });
            this.currentPosition.positionB.tools = _.pluck(this.currentPosition.position_b.tools, 'id').map(String);
            this.currentPosition.positionB.skills = skillsB;
            this.currentPosition.positionB.uniforms = _.pluck(this.currentPosition.position_b.uniforms, 'id').map(String);
            this.currentPosition.positionB.type = "B";

            var skillsC = _.pluck(this.currentPosition.position_c.skills, 'id').map(String);
            skillsC = _.filter(skillsC, function (o) {
                return coreskills.includes(o);
            });
            this.currentPosition.positionC.tools = _.pluck(this.currentPosition.position_c.tools, 'id').map(String);
            this.currentPosition.positionC.skills = skillsC;
            this.currentPosition.positionC.uniforms = _.pluck(this.currentPosition.position_c.uniforms, 'id').map(String);
            this.currentPosition.positionC.type = "C";
        },

        setEmptyUTS: function setEmptyUTS() {
            this.data.pay_rate = this.currentJob != null ? this.currentJob.pay_rate : '';
            //this.data.overtime_pay_rate = Number(this.data.pay_rate) * 1.5;
            this.data.billing_rate = 0;
            this.data.overtime_billing_rate = 0;
            this.data.title = this.currentJob != null ? this.currentJob.title : '';
            this.data.gender = '';
            this.positions = {
                positionA: {
                    type: 'A',
                    uniforms: [],
                    tools: [],
                    skills: [],
                    grooming: [],
                    attitude: [],
                    reliability: [],
                    background: []
                },
                positionB: {
                    type: 'B',
                    uniforms: [],
                    tools: [],
                    skills: [],
                    grooming: [],
                    attitude: [],
                    reliability: [],
                    background: []
                },
                positionC: {
                    type: 'C',
                    uniforms: [],
                    tools: [],
                    skills: [],
                    grooming: [],
                    attitude: [],
                    reliability: [],
                    background: []
                }
            };
        },

        setClient: function setClient(id) {
            this.currentClient = _.clone(_.find(this.commonData.clients, function (o) {
                return o.id == id;
            }));
        },

        createPositions: function createPositions() {
            var _this2 = this;

            this.state = true;
            this.data.positions = this.positions;
            this.$http.post('/api/position', this.data, function (response) {
                modals.hide('#modal_add_position');
                notify.success("Positions created successfully");
                _this2.getPositions(false);
            }).always(function () {
                _this2.state = false;
            });
        },

        clearFields: function clearFields() {
            // this.data.client_id = 0;
            this.data.job_id = 0;
            this.data.department_id = 0;
            this.currentJob = {
                pay_rate: '',
                title: ''
            };
        },

        confirmCopyUTS: function confirmCopyUTS() {
            notify.prompt('Are you sure you want to copy G,A,R,B,U,T,S to Position B and Position C?', '', this.copyUTS);
        },

        confirmCopyCurrentUTS: function confirmCopyCurrentUTS() {
            notify.prompt('Are you sure you want to copy G,A,R,B,U,T,S to Position B and Position C?', '', this.copyCurrentUTS);
        },

        copyUTS: function copyUTS() {
            this.positions.positionB.grooming = _.cloneDeep(this.positions.positionA.grooming);
            this.positions.positionC.grooming = _.clone(this.positions.positionA.grooming);

            this.positions.positionB.attitude = _.clone(this.positions.positionA.attitude);
            this.positions.positionC.attitude = _.clone(this.positions.positionA.attitude);

            this.positions.positionB.reliability = _.clone(this.positions.positionA.reliability);
            this.positions.positionC.reliability = _.clone(this.positions.positionA.reliability);

            this.positions.positionB.background = _.clone(this.positions.positionA.background);
            this.positions.positionC.background = _.clone(this.positions.positionA.background);

            this.positions.positionB.tools = _.clone(this.positions.positionA.tools);
            this.positions.positionC.tools = _.clone(this.positions.positionA.tools);

            this.positions.positionB.skills = _.clone(this.positions.positionA.skills);
            this.positions.positionC.skills = _.clone(this.positions.positionA.skills);

            this.positions.positionB.uniforms = _.clone(this.positions.positionA.uniforms);
            this.positions.positionC.uniforms = _.clone(this.positions.positionA.uniforms);
        },

        copyCurrentUTS: function copyCurrentUTS() {
            this.currentPosition.positionB.grooming = _.cloneDeep(this.currentPosition.positionA.grooming);
            this.currentPosition.positionC.grooming = _.clone(this.currentPosition.positionA.grooming);

            this.currentPosition.positionB.attitude = _.clone(this.currentPosition.positionA.attitude);
            this.currentPosition.positionC.attitude = _.clone(this.currentPosition.positionA.attitude);

            this.currentPosition.positionB.reliability = _.clone(this.currentPosition.positionA.reliability);
            this.currentPosition.positionC.reliability = _.clone(this.currentPosition.positionA.reliability);

            this.currentPosition.positionB.background = _.clone(this.currentPosition.positionA.background);
            this.currentPosition.positionC.background = _.clone(this.currentPosition.positionA.background);

            this.currentPosition.positionB.tools = _.clone(this.currentPosition.positionA.tools);
            this.currentPosition.positionC.tools = _.clone(this.currentPosition.positionA.tools);

            this.currentPosition.positionB.skills = _.clone(this.currentPosition.positionA.skills);
            this.currentPosition.positionC.skills = _.clone(this.currentPosition.positionA.skills);

            this.currentPosition.positionB.uniforms = _.clone(this.currentPosition.positionA.uniforms);
            this.currentPosition.positionC.uniforms = _.clone(this.currentPosition.positionA.uniforms);
        },

        arrayMove: function arrayMove(arr, fromIndex, toIndex) {
            console.log(arr);
            var element = arr[fromIndex];
            arr.splice(fromIndex, 1);
            return arr.splice(toIndex, 0, element);
        },

        setOrder: function setOrder() {
            if (_.has(this.currentJob, 'grooming')) {
                this.currentJob.grooming = _.sortBy(this.currentJob.grooming, function (val) {
                    return val;
                });
                if (this.currentJob.grooming.indexOf('A+') > 0) {
                    this.currentJob.grooming.move(1, 0);
                }
            }

            if (_.has(this.currentJob, 'attitude')) {
                this.currentJob.attitude = _.sortBy(this.currentJob.attitude, function (val) {
                    return val;
                });
                if (this.currentJob.attitude.indexOf('A+') > 0) {
                    this.currentJob.attitude.move(1, 0);
                }
            }

            if (_.has(this.currentJob, 'reliability')) {
                this.currentJob.reliability = _.sortBy(this.currentJob.reliability, function (val) {
                    return val;
                });
                if (this.currentJob.reliability.indexOf('A+') > 0) {
                    this.currentJob.reliability.move(1, 0);
                }
            }
        },

        editModal: function editModal(position) {
            var _this3 = this;

            notify.loading(true);
            this.$http.get('/api/position/' + position.position_code, '', function (response) {
                _this3.currentPosition = _.cloneDeep(response);
                _this3.currentData.managers = _.cloneDeep(_this3.currentPosition.managers);
                _this3.currentData.client_id = _this3.currentPosition.client_id;
                _this3.currentData.job_id = _this3.currentPosition.job_id;
                _this3.setCurrentJob(_this3.currentData.job_id);
                _this3.setClient(_this3.currentData.client_id);
                _this3.currentData.pay_rate = _this3.currentPosition.pay_rate;
                _this3.currentData.billing_rate = _this3.currentPosition.billing_rate;
                _this3.currentData.zone_b_increased_pay = _this3.currentPosition.zone_b_increased_pay;
                _this3.currentData.zone_c_increased_pay = _this3.currentPosition.zone_c_increased_pay;
                _this3.currentData.overtime_pay_rate = _this3.currentPosition.overtime_pay_rate;
                _this3.currentData.allow_overtime_pay_rate = _this3.currentPosition.allow_overtime_pay_rate;
                _this3.currentData.allow_overtime_billing_rate = _this3.currentPosition.allow_overtime_billing_rate;
                _this3.currentData.title = _this3.currentPosition.title;
                _this3.currentData.gender = _this3.currentPosition.gender;
                _this3.currentData.note = _this3.currentPosition.note;
                _this3.currentData.auto_selection = _this3.currentPosition.auto_selection;
                _this3.currentData.admin_note = _this3.currentPosition.admin_note;
                _this3.currentData.employee_note = _this3.currentPosition.employee_note;
                _this3.currentData.minutes_early = _this3.currentPosition.minutes_early;
                _this3.currentData.contacts.primary = _this3.currentPosition.primary_contact ? _this3.currentPosition.primary_contact.contact_id : null;
                _this3.currentData.contacts.secondary = _this3.currentPosition.secondary_contact ? _this3.currentPosition.secondary_contact.contact_id : null;
                _this3.currentData.contacts.optional = _this3.currentPosition.optional_contact ? _this3.currentPosition.optional_contact.contact_id : null;
                _this3.currentData.department_id = _this3.currentPosition.department_id;
                _this3.currentPosition.positionA = _this3.currentPosition.position_a;
                _this3.currentPosition.positionB = _this3.currentPosition.position_b;
                _this3.currentPosition.positionC = _this3.currentPosition.position_c;
                _this3.setCurrentUTS();
                modals.showStrict('#modal_edit_position');
            }).always(function () {
                notify.loading(false);
            });
        },

        editPositions: function editPositions() {
            var _this4 = this;

            this.currentData.positions = [this.currentPosition.positionA, this.currentPosition.positionB, this.currentPosition.positionC];
            this.state = true;
            this.$http.put('/api/position', this.currentData, function (response) {
                modals.hide('#modal_edit_position');
                notify.success("Positions updatd successfully");
                _this4.getPositions(false);
            }).always(function () {
                _this4.state = false;
            });
        },

        getPositions: function getPositions() {
            var _this5 = this;

            var status = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];

            if (status) {
                notify.loading(true);
            }
            this.$http.get('/api/positions-client/' + this.data.client_id, '', function (response) {
                _this5.clientPositions = response;
            }).always(function () {
                notify.loading(false);
                if (status) {
                    modals.showStrict("#modal_positions");
                }
            });
        },

        employeeModal: function employeeModal(positionCode) {
            var _this6 = this;

            var status = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];

            notify.loading(true);
            if (positionCode) {
                this.currenPositionCode = positionCode;
                this.$http.get('/api/position-employees/' + positionCode + '?per_page=' + this.perPage + '&page=' + this.page + '&order=' + this.sortOrders + '&key=' + this.sortKey, '', function (response) {
                    _this6.employees = response.employees.sort(_this6.sortBy('action_sort', false, false));
                    _this6.employeesNoZone = response.employeesNoZone.sort(_this6.sortBy('action_sort', false, false));
                    _this6.employeesHighSalary = response.employeesHighSalary.sort(_this6.sortBy('action_sort', false, false));
                    _this6.currentPosition = response.position;
                }).always(function () {
                    notify.loading(false);
                    if (status) {
                        $('.popup').popover('show');
                        modals.showStrict("#list-employees");
                    }
                });
            }
        },

        showPreviousList: function showPreviousList() {
            if (this.page > 1) {
                this.page--;
                this.employeeModal(this.currenPositionCode, false);
            }
        },

        showNextList: function showNextList() {
            this.page++;
            this.employeeModal(this.currenPositionCode, false);
        },

        /**
         * check if all uniforms are present
         * @param employee
         * @param positionUniform
         * @returns {boolean}
         */
        isUniform: function isUniform(employee, positionUniform) {
            var employeeUniforms = _.pluck(employee.uniforms, 'id').map(String);
            var positionUniforms = _.pluck(positionUniform, 'id').map(String);
            return positionUniforms.length === _.intersection(positionUniforms, employeeUniforms).length;
        },

        /**
         * check if all tools are present
         * @param employee
         * @param positionTool
         * @returns {boolean}
         */
        isTool: function isTool(employee, positionTool) {
            var employeeTools = _.pluck(employee.tools, 'id').map(String);
            var positionTools = _.pluck(positionTool, 'id').map(String);
            return positionTools.length === _.intersection(positionTools, employeeTools).length;
        },

        /**
         * show uniforms modal
         * @param employee
         * @param uniforms
         */
        showUniforms: function showUniforms(employee, uniforms) {
            this.currentEmployee = _.cloneDeep(employee);
            this.currentUniforms = uniforms;
        },

        /**
         * show tools modal
         * @param employee
         * @param tools
         * @param uniforms
         * @param skills
         */
        showUTS: function showUTS(employee, tools, uniforms, skills) {
            this.currentEmployee = _.cloneDeep(employee);
            this.currentTools = tools;
            this.currentUniforms = uniforms;
            this.currentSkills = skills;
        },

        /**
         * check if uniform exists in a list
         * @param uniform_id
         * @returns {*|T}
         */
        isU: function isU(uniform_id) {
            return _.findWhere(this.currentEmployee.uniforms, {
                id: uniform_id
            });
        },

        /**
         * check if tool exists in a list
         * @param tool_id
         * @returns {*|T}
         */
        isT: function isT(tool_id) {
            return _.findWhere(this.currentEmployee.tools, {
                id: tool_id
            });
        },

        sortBy: function sortBy(field, reverse, primer) {
            var key = primer ? function (x) {
                return primer(x[field]);
            } : function (x) {
                return x[field];
            };

            reverse = !reverse ? 1 : -1;

            return function (a, b) {
                return a = key(a), b = key(b), reverse * ((a > b) - (b > a));
            };
        },

        sortEmployee: function sortEmployee(field, reverse) {
            var primer = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];
            var type = arguments.length <= 3 || arguments[3] === undefined ? 'employees' : arguments[3];

            this.sortOrders = reverse;
            this.sortKey = field;
            if (type == 'employees') {
                this.employees.sort(this.sortBy(field, reverse, primer));
            }
            if (type == 'high-salary') {
                this.employeesHighSalary.sort(this.sortBy(field, reverse, primer));
            }
            if (type == 'no-zone') {
                this.employeesNoZone.sort(this.sortBy(field, reverse, primer));
            }
        },

        /**
         * recalculate final pay and type
         */
        calculateRate: function calculateRate(employee) {
            //job.final_pay = job.pay_rate + this.currentEmployee.increased_pay;
            employee.rate = employee.previous_rate;
            employee.type = employee.base_type;
            employee.band = '';
        },

        updateType: function updateType(employee) {
            alert('ewrewr');
        },

        savePositionEmployees: function savePositionEmployees(data) {
            var _this7 = this;

            notify.loading(true);
            this.$http.post('/api/position-employee-list', { data: data }, function (response) {
                _this7.employeeModal(_this7.currenPositionCode, false);
                notify.success('List saved successfully');
            }).always(function () {
                notify.loading(false);
            });
        }
    }
});
module.exports = exports['default'];

},{"./../../../../mixed/modals":10,"./../../../../mixed/notify":11,"./schedules":137}],137:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});
var notify = require('./../../../../mixed/notify');
var modals = require('./../../../../mixed/modals');

exports['default'] = Vue.extend({
    data: function data() {
        return {
            positionCode: 0,
            defaultCode: 0,
            switchCode: 0,
            state: false,
            employees: {},
            sortOrders: true,
            sortKey: '',
            types: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'X', 'M'],
            ranges: ['2-3'],
            selectedTypes: [],
            vipRules: {},
            use_default: 0,
            'default': false,
            current: true,
            rules: [{
                min: 0,
                max: 1,
                primary: [{
                    percentage: 100,
                    types: ['A']
                }],
                secondary: [{
                    percentage: 100,
                    types: ['A']
                }],
                confirmed: 30,
                reconfirmed: 30
            }, {
                min: 2,
                max: 3,
                primary: [{
                    percentage: 50,
                    types: ['A']
                }, {
                    percentage: 50,
                    types: ['A', 'B', 'C']
                }],
                secondary: [{
                    percentage: 50,
                    types: ['A']
                }, {
                    percentage: 50,
                    types: ['A', 'B', 'C']
                }],
                confirmed: 30,
                reconfirmed: 30
            }, {
                min: 4,
                max: 6,
                primary: [{
                    percentage: 33,
                    types: ['A']
                }, {
                    percentage: 33,
                    types: ['A', 'B', 'C']
                }, {
                    percentage: 34,
                    types: ['A', 'B', 'C', 'D']
                }],
                secondary: [{
                    percentage: 33,
                    types: ['A']
                }, {
                    percentage: 33,
                    types: ['A', 'B', 'C']
                }, {
                    percentage: 34,
                    types: ['A', 'B', 'C', 'D']
                }],
                confirmed: 30,
                reconfirmed: 30
            }, {
                min: 7,
                max: 10,
                primary: [{
                    percentage: 20,
                    types: ['A']
                }, {
                    percentage: 20,
                    types: ['A', 'B', 'C']
                }, {
                    percentage: 30,
                    types: ['A', 'B', 'C', 'D']
                }, {
                    percentage: 30,
                    types: ['A', 'B', 'C', 'D', 'E']
                }],
                secondary: [{
                    percentage: 20,
                    types: ['A']
                }, {
                    percentage: 20,
                    types: ['A', 'B', 'C']
                }, {
                    percentage: 30,
                    types: ['A', 'B', 'C', 'D']
                }, {
                    percentage: 30,
                    types: ['A', 'B', 'C', 'D', 'E']
                }],
                confirmed: 30,
                reconfirmed: 30
            }, {
                min: 11,
                max: 15,
                primary: [{
                    percentage: 15,
                    types: ['A']
                }, {
                    percentage: 15,
                    types: ['A', 'B', 'C']
                }, {
                    percentage: 35,
                    types: ['A', 'B', 'C', 'D']
                }, {
                    percentage: 35,
                    types: ['A', 'B', 'C', 'D', 'E']
                }],
                secondary: [{
                    percentage: 15,
                    types: ['A']
                }, {
                    percentage: 15,
                    types: ['A', 'B', 'C']
                }, {
                    percentage: 35,
                    types: ['A', 'B', 'C', 'D']
                }, {
                    percentage: 35,
                    types: ['A', 'B', 'C', 'D', 'E']
                }],
                confirmed: 30,
                reconfirmed: 30
            }, {
                min: 16,
                max: 25,
                primary: [{
                    percentage: 10,
                    types: ['A']
                }, {
                    percentage: 15,
                    types: ['A', 'B', 'C']
                }, {
                    percentage: 35,
                    types: ['A', 'B', 'C', 'D']
                }, {
                    percentage: 25,
                    types: ['A', 'B', 'C', 'D', 'E']
                }, {
                    percentage: 15,
                    types: ['A', 'B', 'C', 'D', 'E', 'F']
                }],
                secondary: [{
                    percentage: 10,
                    types: ['A']
                }, {
                    percentage: 15,
                    types: ['A', 'B', 'C']
                }, {
                    percentage: 35,
                    types: ['A', 'B', 'C', 'D']
                }, {
                    percentage: 25,
                    types: ['A', 'B', 'C', 'D', 'E']
                }, {
                    percentage: 15,
                    types: ['A', 'B', 'C', 'D', 'E', 'F']
                }],
                confirmed: 30,
                reconfirmed: 30
            }, {
                min: 26,
                max: 40,
                primary: [],
                secondary: [],
                confirmed: 30,
                reconfirmed: 30
            }, {
                min: 41,
                max: 60,
                primary: [],
                secondary: [],
                confirmed: 30,
                reconfirmed: 30
            }, {
                min: 61,
                max: 100,
                primary: [],
                secondary: [],
                confirmed: 30,
                reconfirmed: 30
            }, {
                min: 101,
                max: 500,
                primary: [],
                secondary: [],
                confirmed: 30,
                reconfirmed: 30
            }]
        };
    },
    props: ['position'],

    watch: {
        'use_default': function use_default(val, oldVal) {
            var useDefault = Number(val);
            if (useDefault) {
                this.showRules(0, false, false);
            } else {
                this.showRules(this.position.position_code, false, false);
            }
        },

        'defaultCode': function defaultCode(val) {
            this.positionCode = val;
            this.showRules(val, false);
        },

        'switchCode': function switchCode(val) {
            this.copyRules(val);
        }
    },

    events: {
        showPositionRules: function showPositionRules(positionCode) {
            this.showRules(positionCode);
        }
    },

    ready: function ready() {
        var that = this;
        $('#list-schedule-employees').on('hidden.bs.modal', function () {
            that.setRules();
        });
        this.vipRules = _.cloneDeep(this.rules);
        this.showRules(this.positionCode, false);
    },

    methods: {
        removePercentage: function removePercentage(rule, percentage) {
            rule.primary = _.without(rule.primary, percentage);
        },

        addPercentage: function addPercentage(rule) {
            if (rule.primary instanceof Array) {
                rule.primary.push({
                    percentage: 0,
                    types: []
                });
            } else {
                rule.primary = [];
                rule.primary.push({
                    percentage: 0,
                    types: []
                });
            }
        },

        removeSecondaryPercentage: function removeSecondaryPercentage(rule, percentage) {
            rule.secondary = _.without(rule.secondary, percentage);
        },

        addSecondaryPercentage: function addSecondaryPercentage(rule) {
            // rule.secondary.push({
            //     percentage: 0,
            //     types: []
            // });
            if (rule.secondary instanceof Array) {
                rule.secondary.push({
                    percentage: 0,
                    types: []
                });
            } else {
                rule.secondary = [];
                rule.secondary.push({
                    percentage: 0,
                    types: []
                });
            }
        },

        setCode: function setCode(code) {
            if (code == 0) {
                this['default'] = true;
                this.current = false;
            } else {
                this['default'] = false;
                this.current = true;
            }
        },

        copyRuleConfirm: function copyRuleConfirm() {
            notify.prompt('Are you sure you want to copy default rule?', '', this.copyRules);
        },

        copyRules: function copyRules() {
            var _this = this;

            var positionCode = arguments.length <= 0 || arguments[0] === undefined ? 0 : arguments[0];

            var that = this;
            this.$http.get('/api/schedule-rules/' + positionCode, '', function (response) {
                _this.setCode(response.positionCode);
                _this.current = response.current;
                if (response.regular === undefined || response.regular.length == 0) {
                    // empty
                } else {
                        var positionRules = [];
                        response.regular.forEach(function (rule) {
                            positionRules.push({
                                min: rule.min,
                                max: rule.max,
                                confirmed: rule.confirmed,
                                reconfirmed: rule.reconfirmed,
                                primary: rule.primary,
                                secondary: rule.secondary
                            });
                        });
                        _this.rules = positionRules;
                    }
                //set vip rules
                if (response.vip === undefined || response.vip.length == 0) {
                    // empty
                } else {
                        var positionRules = [];
                        response.vip.forEach(function (rule) {
                            positionRules.push({
                                min: rule.min,
                                max: rule.max,
                                confirmed: rule.confirmed,
                                reconfirmed: rule.reconfirmed,
                                primary: rule.primary,
                                secondary: rule.secondary
                            });
                        });
                        _this.vipRules = positionRules;
                    }
                _this.$nextTick(function () {
                    that.disableInput(true);
                });
            }).always(function () {
                notify.loading(false);
            });
        },

        showRules: function showRules(positionCode) {
            var _this2 = this;

            var modal = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];
            var setDefault = arguments.length <= 2 || arguments[2] === undefined ? true : arguments[2];

            //modals.showStrict('#list-schedule-employees');
            var that = this;
            if (positionCode != 0) {
                this.positionCode = positionCode;
            }
            this.setRules();
            this.setPositionDefaultRule();
            notify.loading(true);
            this.$http.get('/api/schedule-rules/' + positionCode, '', function (response) {
                _this2.setCode(response.positionCode);
                _this2['default'] = response['default'];
                _this2.current = response.current;
                if (setDefault) {
                    _this2.use_default = response.use_default;
                }
                _this2.switchCode = response.code;
                if (response.regular === undefined || response.regular.length == 0) {
                    // empty
                } else {
                        var positionRules = [];
                        response.regular.forEach(function (rule) {
                            positionRules.push({
                                min: rule.min,
                                max: rule.max,
                                confirmed: rule.confirmed,
                                reconfirmed: rule.reconfirmed,
                                primary: rule.primary,
                                secondary: rule.secondary
                            });
                        });
                        _this2.rules = positionRules;
                    }
                //set vip rules
                if (response.vip === undefined || response.vip.length == 0) {
                    // empty
                } else {
                        var positionRules = [];
                        response.vip.forEach(function (rule) {
                            positionRules.push({
                                min: rule.min,
                                max: rule.max,
                                confirmed: rule.confirmed,
                                reconfirmed: rule.reconfirmed,
                                primary: rule.primary,
                                secondary: rule.secondary
                            });
                        });
                        _this2.vipRules = positionRules;
                    }
                if (modal == true) {
                    modals.showStrict('#list-schedule-employees');
                }
                _this2.$nextTick(function () {
                    that.disableInput(true);
                    // Number(that.use_default) ? that.disableInput(true) : that.disableInput(false);
                });
            }).always(function () {
                notify.loading(false);
            });
        },

        saveRules: function saveRules() {
            var _this3 = this;

            var type = arguments.length <= 0 || arguments[0] === undefined ? 1 : arguments[0];
            var message = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];

            this.state = true;
            var ruleData = {};
            if (type == 1) {
                ruleData = {
                    rules: this.rules,
                    option: type,
                    use_default: this.use_default,
                    code: this.switchCode
                };
            } else {
                ruleData = {
                    rules: this.vipRules,
                    option: type,
                    use_default: this.use_default,
                    code: this.switchCode
                };
            }
            var position_code = '';
            if (this.position == undefined) {
                position_code = this.positionCode;
            } else {
                position_code = this.position.position_code;
            }
            this.$http.post('/api/schedule-rules/' + position_code, ruleData, function (response) {
                if (message) {
                    notify.success('Rules saved successfully');
                }
                if (_this3.use_default) {
                    _this3.showRules(0, false, false);
                } else {
                    _this3.showRules(position_code, false, false);
                }
                window.bus.$emit('getScheduleRuleReport');
            }).always(function () {
                _this3.state = false;
            });
        },

        setPositionDefaultRule: function setPositionDefaultRule() {
            var _this4 = this;

            this.$http.post('/api/position-default-rules/' + this.positionCode, { use_default: this.use_default }, function (response) {}).always(function () {
                _this4.state = false;
            });
        },

        loadScheduleEmployees: function loadScheduleEmployees(positionCode) {
            var _this5 = this;

            notify.loading(true);
            this.selectedTypes = _.sortBy(this.selectedTypes, function (val) {
                return val;
            });
            if (positionCode) {
                this.$http.post('/api/schedule-employees/' + positionCode, { types: this.selectedTypes }, function (response) {
                    _this5.employees = response.employees;
                }).always(function () {
                    notify.loading(false);
                });
            }
        },

        sortBy: function sortBy(field, reverse, primer) {
            var key = primer ? function (x) {
                return primer(x[field]);
            } : function (x) {
                return x[field];
            };

            reverse = !reverse ? 1 : -1;

            return function (a, b) {
                return a = key(a), b = key(b), reverse * ((a > b) - (b > a));
            };
        },

        sortEmployee: function sortEmployee(field, reverse) {
            var primer = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];

            this.sortOrders = reverse;
            this.sortKey = field;
            this.employees.sort(this.sortBy(field, reverse, primer));
        },

        setRules: function setRules() {
            this.rules = [{
                min: 0,
                max: 1,
                primary: [{
                    percentage: 100,
                    types: ['A']
                }],
                secondary: [{
                    percentage: 100,
                    types: ['A']
                }],
                confirmed: 30,
                reconfirmed: 30
            }, {
                min: 2,
                max: 3,
                primary: [{
                    percentage: 50,
                    types: ['A']
                }, {
                    percentage: 50,
                    types: ['A', 'B', 'C']
                }],
                secondary: [{
                    percentage: 50,
                    types: ['A']
                }, {
                    percentage: 50,
                    types: ['A', 'B', 'C']
                }],
                confirmed: 30,
                reconfirmed: 30
            }, {
                min: 4,
                max: 6,
                primary: [{
                    percentage: 33,
                    types: ['A']
                }, {
                    percentage: 33,
                    types: ['A', 'B', 'C']
                }, {
                    percentage: 34,
                    types: ['A', 'B', 'C', 'D']
                }],
                secondary: [{
                    percentage: 33,
                    types: ['A']
                }, {
                    percentage: 33,
                    types: ['A', 'B', 'C']
                }, {
                    percentage: 34,
                    types: ['A', 'B', 'C', 'D']
                }],
                confirmed: 30,
                reconfirmed: 30
            }, {
                min: 7,
                max: 10,
                primary: [{
                    percentage: 20,
                    types: ['A']
                }, {
                    percentage: 20,
                    types: ['A', 'B', 'C']
                }, {
                    percentage: 30,
                    types: ['A', 'B', 'C', 'D']
                }, {
                    percentage: 30,
                    types: ['A', 'B', 'C', 'D', 'E']
                }],
                secondary: [{
                    percentage: 20,
                    types: ['A']
                }, {
                    percentage: 20,
                    types: ['A', 'B', 'C']
                }, {
                    percentage: 30,
                    types: ['A', 'B', 'C', 'D']
                }, {
                    percentage: 30,
                    types: ['A', 'B', 'C', 'D', 'E']
                }],
                confirmed: 30,
                reconfirmed: 30
            }, {
                min: 11,
                max: 15,
                primary: [{
                    percentage: 15,
                    types: ['A']
                }, {
                    percentage: 15,
                    types: ['A', 'B', 'C']
                }, {
                    percentage: 35,
                    types: ['A', 'B', 'C', 'D']
                }, {
                    percentage: 35,
                    types: ['A', 'B', 'C', 'D', 'E']
                }],
                secondary: [{
                    percentage: 15,
                    types: ['A']
                }, {
                    percentage: 15,
                    types: ['A', 'B', 'C']
                }, {
                    percentage: 35,
                    types: ['A', 'B', 'C', 'D']
                }, {
                    percentage: 35,
                    types: ['A', 'B', 'C', 'D', 'E']
                }],
                confirmed: 30,
                reconfirmed: 30
            }, {
                min: 16,
                max: 25,
                primary: [{
                    percentage: 10,
                    types: ['A']
                }, {
                    percentage: 15,
                    types: ['A', 'B', 'C']
                }, {
                    percentage: 35,
                    types: ['A', 'B', 'C', 'D']
                }, {
                    percentage: 25,
                    types: ['A', 'B', 'C', 'D', 'E']
                }, {
                    percentage: 15,
                    types: ['A', 'B', 'C', 'D', 'E', 'F']
                }],
                secondary: [{
                    percentage: 10,
                    types: ['A']
                }, {
                    percentage: 15,
                    types: ['A', 'B', 'C']
                }, {
                    percentage: 35,
                    types: ['A', 'B', 'C', 'D']
                }, {
                    percentage: 25,
                    types: ['A', 'B', 'C', 'D', 'E']
                }, {
                    percentage: 15,
                    types: ['A', 'B', 'C', 'D', 'E', 'F']
                }],
                confirmed: 30,
                reconfirmed: 30
            }, {
                min: 26,
                max: 40,
                primary: [],
                secondary: [],
                confirmed: 30,
                reconfirmed: 30
            }, {
                min: 41,
                max: 60,
                primary: [],
                secondary: [],
                confirmed: 30,
                reconfirmed: 30
            }, {
                min: 61,
                max: 100,
                primary: [],
                secondary: [],
                confirmed: 30,
                reconfirmed: 30
            }, {
                min: 101,
                max: 500,
                primary: [],
                secondary: [],
                confirmed: 30,
                reconfirmed: 30
            }];
            this.vipRules = _.cloneDeep(this.rules);
        },
        percentageSum: function percentageSum(rules) {
            var percentage = _.reduce(rules, function (acc, o) {
                for (var p in o) acc[p] = parseFloat(p in acc ? acc[p] : 0) + parseFloat(o[p]);
                return acc;
            }, {}).percentage;
            return percentage != 100;
        },

        disableInput: function disableInput(status) {
            console.log(status);
            //$('div#list-schedule-employees input[type=checkbox]').attr('disabled', status);
            // $("#list-schedule-employees :input").prop("disabled", status);
            if (status) {
                $("div#list-schedule-employees input:checkbox").attr('disabled', 'disabled');
            } else {
                $("div#list-schedule-employees input:checkbox").removeAttr('disabled');
            }
            // $(".schedule-button").prop('disabled', status);
        }
    }
});
module.exports = exports['default'];

},{"./../../../../mixed/modals":10,"./../../../../mixed/notify":11}],138:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});
var notify = require('./../../../mixed/notify');

var tableColumns = [{
    name: 'id',
    title: '#ID',
    sortField: 'id'
}, {
    name: 'client.name',
    title: 'Client',
    sortField: 'client_id'
}, {
    name: 'name',
    title: 'Name',
    sortField: 'name'
}, {
    name: 'office_phone',
    title: 'Office Phone',
    sortField: 'office_phone'
}, {
    name: 'cell_phone',
    title: 'Cell Phone',
    sortField: 'cell_phone'
}, '__actions'];

// create pagination component using bootstrap styling
Vue.component('vuetable-pagination-bootstrap', {
    template: '#vuetable-pagination-bootstrap-template',
    mixins: [paginationMixin],
    methods: {
        loadPage: function loadPage(page) {
            this.$dispatch('vuetable-pagination:change-page', page);
        }
    }
});

exports['default'] = Vue.extend({
    data: function data() {
        return {
            clients: [],
            contact: {
                name: '',
                client_id: 0,
                title: '',
                office_phone: '',
                cell_phone: '',
                email: '',
                comments: '',
                timesheet_allow_all_positions: 0
            },
            currentContact: {
                name: '',
                client_id: '',
                title: '',
                office_phone: '',
                cell_phone: '',
                email: '',
                comments: '',
                timesheet_allow_all_positions: 0
            },
            query: '',
            moreParams: [],
            perPage: 15,
            state: false,
            columns: tableColumns,
            sortOrder: {
                field: 'id',
                direction: 'asc'
            },
            paginationInfoTemplate: 'vuetable-pagination-bootstrap',
            itemActions: [{
                name: 'edit-contact',
                label: '',
                icon: 'icon-pencil7 text-primary-600',
                'class': ''
            }, {
                name: 'delete-contact',
                label: '',
                icon: 'icon-trash text-danger-600',
                'class': ''
            }]
        };
    },

    ready: function ready() {
        this.getClients();
    },

    watch: {
        'perPage': function perPage(val, oldVal) {
            this.$broadcast('vuetable:refresh');
        }
    },

    events: {
        'vuetable:action': function vuetableAction(action, data) {
            console.log('vuetable:action', action, data);
            if (action == 'edit-contact') {
                this.editModal(data);
            }
            if (action == 'delete-contact') {
                this.confirmDelete(data);
            }
        },
        'vuetable:loading': function vuetableLoading() {
            notify.loading(true);
        },
        'vuetable:load-success': function vuetableLoadSuccess(response) {
            notify.loading(false);
        },
        'vuetable:load-error': function vuetableLoadError(response) {
            notify.loading(false);
            console.log('Load Error: ', response);
        }
    },

    methods: {
        getClients: function getClients() {
            var _this = this;

            this.$http.get('/api/clients/', '', function (response) {
                _this.clients = response;
            }).always(function () {});
        },

        createContact: function createContact() {
            var _this2 = this;

            this.state = true;
            this.$http.post('/api/contact', this.contact, function () {
                $('#modal_add_contact').modal('hide');
                notify.success('New Contact Added Successfully');
                _this2.clearFields();
            }).always(function () {
                _this2.$broadcast('vuetable:refresh');
                _this2.state = false;
            });
        },

        editModal: function editModal(contact) {
            this.currentContact = _.clone(contact);
            $('#modal_edit_contact').modal('show');
        },

        editContact: function editContact() {
            var _this3 = this;

            this.state = true;
            this.$http.put('/api/contact/' + this.currentContact.id, this.currentContact, function (response) {
                $('#modal_edit_contact').modal('hide');
                notify.success('Contact Information Edited Successfully');
            }).always(function () {
                _this3.$broadcast('vuetable:reload');
                _this3.state = false;
            });
        },

        confirmDelete: function confirmDelete(contect) {
            this.currentContact = contect;
            notify.confirm('Are you sure you want to remove this contact?', '', this.deleteContact);
        },

        deleteContact: function deleteContact() {
            var _this4 = this;

            this.$http['delete']('/api/contact/' + this.currentContact.id, '', function () {
                notify.success('Contact Deleted');
            }).always(function () {
                _this4.$broadcast('vuetable:reload');
            });
        },

        setFilter: function setFilter() {
            this.moreParams = ['filter=' + this.query];
            this.$nextTick(function () {
                this.$broadcast('vuetable:refresh');
            });
        },

        status: function status(val) {
            return parseInt(val) === 0 ? '<span class="label label-danger">Suspended</span>' : '<span class="label label-success">Active</span>';
        },

        clearFields: function clearFields() {
            this.contact = {
                name: '',
                client_id: 0,
                name: '',
                title: '',
                office_phone: '',
                cell_phone: '',
                email: '',
                comments: ''
            };
        }
    }
});
module.exports = exports['default'];

},{"./../../../mixed/notify":11}],139:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});
var notify = require('./../../../mixed/notify');

var tableColumns = [{
	name: 'id',
	title: '#ID',
	sortField: 'id'
}, {
	name: 'name',
	title: 'Name',
	sortField: 'name'
}, {
	name: 'client.name',
	title: 'Client',
	sortField: 'client_id'
}, {
	name: 'contact.name',
	title: 'Contact',
	sortField: 'contact_id'
}, '__actions'];

// create pagination component using bootstrap styling
Vue.component('vuetable-pagination-bootstrap', {
	template: '#vuetable-pagination-bootstrap-template',
	mixins: [paginationMixin],
	methods: {
		loadPage: function loadPage(page) {
			this.$dispatch('vuetable-pagination:change-page', page);
		}
	}
});

exports['default'] = Vue.extend({
	data: function data() {
		return {
			clients: [],
			contacts: [],
			department: {
				name: '',
				client_id: 0,
				contact_id: 0,
				comments: '',
				invoice: {
					recepient: '',
					cc: []
				},
				timesheet_recepient: [],
				timesheet_collection: []
			},
			currentDepartment: {
				name: '',
				client_id: 0,
				contact_id: 0,
				comments: '',
				invoice: {
					recepient: '',
					cc: []
				},
				timesheet_recepient: [],
				timesheet_collection: []
			},
			query: '',
			moreParams: [],
			perPage: 15,
			state: false,
			columns: tableColumns,
			sortOrder: {
				field: 'id',
				direction: 'asc'
			},
			paginationInfoTemplate: 'vuetable-pagination-bootstrap',
			itemActions: [{
				name: 'edit-department',
				label: '',
				icon: 'icon-pencil7 text-primary-600',
				'class': ''
			}, {
				name: 'delete-department',
				label: '',
				icon: 'icon-trash text-danger-600',
				'class': ''
			}]
		};
	},

	ready: function ready() {
		this.getRelated();
	},

	watch: {
		'perPage': function perPage(val, oldVal) {
			this.$broadcast('vuetable:refresh');
		}
	},

	events: {
		'vuetable:action': function vuetableAction(action, data) {
			console.log('vuetable:action', action, data);
			if (action == 'edit-department') {
				this.editModal(data);
			}
			if (action == 'delete-department') {
				this.confirmDelete(data);
			}
		},
		'vuetable:loading': function vuetableLoading() {
			notify.loading(true);
		},
		'vuetable:load-success': function vuetableLoadSuccess(response) {
			notify.loading(false);
		},
		'vuetable:load-error': function vuetableLoadError(response) {
			notify.loading(false);
			console.log('Load Error: ', response);
		}
	},

	methods: {
		getRelated: function getRelated() {
			var _this = this;

			this.$http.get('/api/departments/related', '', function (response) {
				_this.clients = response.clients;
				_this.contacts = response.contacts;
			}).always(function () {});
		},

		createDepartment: function createDepartment() {
			var _this2 = this;

			this.state = true;
			this.$http.post('/api/department', this.department, function () {
				$('#modal_add_department').modal('hide');
				notify.success('New Department Added Successfully');
				_this2.clearFields();
			}).always(function () {
				_this2.$broadcast('vuetable:refresh');
				_this2.state = false;
			});
		},

		editModal: function editModal(department) {
			this.currentDepartment = _.clone(department);
			$('#modal_edit_department').modal('show');
		},

		editDepartment: function editDepartment() {
			var _this3 = this;

			this.state = true;
			this.$http.put('/api/department/' + this.currentDepartment.id, this.currentDepartment, function () {
				$('#modal_edit_department').modal('hide');
				notify.success('Department Information Edited Successfully');
			}).always(function () {
				_this3.$broadcast('vuetable:reload');
				_this3.state = false;
			});
		},

		confirmDelete: function confirmDelete(department) {
			this.currentDepartment = department;
			notify.confirm('Are you sure you want to remove this department?', '', this.deleteDepartment);
		},

		deleteDepartment: function deleteDepartment() {
			var _this4 = this;

			this.$http['delete']('/api/department/' + this.currentDepartment.id, '', function () {
				notify.success('Department Deleted');
			}).always(function () {
				_this4.$broadcast('vuetable:reload');
			});
		},

		setFilter: function setFilter() {
			this.moreParams = ['filter=' + this.query];
			this.$nextTick(function () {
				this.$broadcast('vuetable:refresh');
			});
		},

		status: function status(val) {
			return parseInt(val) === 0 ? '<span class="label label-danger">Suspended</span>' : '<span class="label label-success">Active</span>';
		},

		clearFields: function clearFields() {
			this.department = {
				name: '',
				client_id: 0,
				contact_id: 0,
				comments: ''
			};
		}
	}
});
module.exports = exports['default'];

},{"./../../../mixed/notify":11}],140:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});
var notify = require('./../../../mixed/notify');
var modals = require('./../../../mixed/modals');

var editEmployee = typeof canEditEmployee !== 'undefined' && canEditEmployee == true ? '<a href="#" class="label label-primary mr-10">Edit</a>' : '';
var deleteEmployee = typeof canDeleteEmployee !== 'undefined' && canDeleteEmployee == true ? 'icon-trash text-danger-600' : '';
var manageEmployeeJobs = typeof canManageEmployeeJobs !== 'undefined' && canManageEmployeeJobs == true ? '<a href="#" class="label label-info mr-10">Jobs</a>' : '';
var manageEmployeeDetails = typeof canManageEmployeeDetails !== 'undefined' && canManageEmployeeDetails == true ? '<a href="#" class="label bg-slate-300 mr-10">Details</a>' : '';

var manageEmployeeImages = '<a href="#" class="label label-success right-m-30">Image</a>';

var tableColumns = [{
    name: 'id',
    title: 'SL#',
    sortField: 'id',
    dataHide: 'tablet'
}, {
    name: 'name',
    title: 'Name',
    sortField: 'first_name',
    dataHide: 'phone'
}, '__actions', {
    name: 'email',
    title: 'Email',
    sortField: 'email',
    dataHide: 'tablet'
}, {
    name: 'primary_phone',
    title: 'Primary Phone',
    sortField: 'primary_phone',
    dataHide: 'tablet'
}, {
    name: 'hire_date',
    title: 'Hired',
    sortField: 'hire_date',
    callback: 'formatDate',
    dataHide: 'tablet'
}, {
    name: 'zip_code',
    title: 'Zip Code',
    sortField: 'zip_code',
    dataHide: 'tablet'
}, {
    name: 'status',
    title: 'Status',
    sortField: 'status',
    callback: 'status',
    dataHide: 'phone'
}];

// create pagination component using bootstrap styling
Vue.component('vuetable-pagination-bootstrap', {
    template: '#vuetable-pagination-bootstrap-template',
    mixins: [paginationMixin],
    methods: {
        loadPage: function loadPage(page) {
            this.$dispatch('vuetable-pagination:change-page', page);
        }
    }
});

exports['default'] = Vue.extend({

    filters: {
        moment: (function (_moment) {
            function moment(_x) {
                return _moment.apply(this, arguments);
            }

            moment.toString = function () {
                return _moment.toString();
            };

            return moment;
        })(function (time) {
            return moment(time, "HH:mm:ss").format('hA');
        }),

        parseDate: function parseDate(date) {
            return moment(date).format('DD,MMM YYYY');
        },

        minimumSalary: {
            read: function read(val) {
                return val;
            },
            write: function write(val, oldVal) {
                var number = +val.replace(/[^\d.]/g, '');
                if (isNaN(number)) {
                    return null;
                } else {
                    return number > 40 ? 8 : number;
                }
            }
        },

        payRateIncrease: {
            read: function read(val) {
                return val;
            },
            write: function write(val, oldVal) {
                var number = +val.replace(/[^\d.]/g, '');
                if (isNaN(number)) {
                    return null;
                } else {
                    return number >= 10 ? 1 : number;
                }
            }
        }
    },

    data: function data() {
        return {
            fileUrl: '',
            employeeObject: {
                image: '',
                first_name: '',
                middle_name: '',
                last_name: '',
                employee_code: '',
                dob: '',
                ss: '',
                tax_id: '',
                marital_status: '',
                no_of_dependent: '',
                gender: '',
                street: '',
                apt: '',
                city: '',
                state: '',
                zip_code: '',
                primary_phone: '',
                secondary_phone: '',
                email: '',
                email_notification: 0,
                password: '',
                bank_name: '',
                routing_number: '',
                account_number: '',
                legal_status: '',
                shift_required: 3,
                max_hours: 25,
                status: 'Watch List',
                hire_date: '',
                minimum_salary: 8,
                desired_position: '',
                increased_pay: '',
                max_pay_rate: '',
                payroll_group: '',
                transportation: '',
                comments: '',
                grooming: '',
                attitude: '',
                reliability: '',
                background: '',
                partners: [],
                shifts: [],
                jobs: [],
                early: '',
                late: '',
                uniforms: [],
                tools: [],
                skills: [],
                is_draft: 0,
                recruiter_id: null
            },
            recruiters: {},
            employee: {},
            deleteDraft: false,
            currentEmployee: {},
            activeEmployee: {},
            state: false,
            days: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
            startTimes: [],
            endTimes: [],
            types: ['A+', 'A', 'B', 'C', 'U'],
            backgroundTypes: ['A', 'B', 'C', 'U'],
            options: [],
            commonData: {
                uniforms: []
            },
            demos: [],
            allSelected: false,
            allSelectedEdit: false,
            query: '',
            moreParams: ['zip=' + (zip === null ? 1 : zip)],
            perPage: 100,
            columns: tableColumns,
            sortOrder: {
                field: 'id',
                direction: 'asc'
            },
            employeeJobs: {},
            jobSize: 0,
            initiateImage: false,
            filterStatus: 'Watch List|Active',
            paginationInfoTemplate: 'vuetable-pagination-bootstrap',
            itemActions: [{
                name: 'edit-employee',
                label: editEmployee,
                icon: '',
                'class': ''
            }, {
                name: 'employee-jobs',
                label: manageEmployeeJobs,
                icon: '',
                'class': ''
            },
            //     {
            //     name: 'employee-image',
            //     label: manageEmployeeImages,
            //     icon: '',
            //     class: '',
            // },
            {
                name: 'employee-details',
                label: manageEmployeeDetails,
                icon: '',
                'class': ''
            }, {
                name: 'employee-image-2',
                label: manageEmployeeImages,
                icon: '',
                'class': ''
            }, {
                name: 'delete-employee',
                label: '',
                icon: deleteEmployee,
                'class': ''
            }]
        };
    },

    ready: function ready() {
        if (typeof Cookies.get('created') !== 'undefined') {
            notify.success(Cookies.get('created'));
            Cookies.remove('created');
        }
        this.getData();
        var that = this;
        $('#modal_add_employee').on('hidden.bs.modal', function () {
            $('.stepy-basic').stepy('step', 1);
            //that.clearFields();
        });

        $('#modal_edit_employee').on('hidden.bs.modal', function () {
            $('.stepy-basic-edit').stepy('step', 1);
            that.clearCurrentEmployee();
        });

        $('#employee_jobs').on('hidden.bs.modal', function () {
            this.employeeJobs = {};
        });
        //this.filterStatus = Cookies.get('filterStatus');
        // $('#late').combodate({
        //     minuteStep: 15,
        //     minHour: 1,
        //     maxHour: 12
        // });
        // $('#early').combodate({
        //     minuteStep: 15,
        //     minHour: 1,
        //     maxHour: 12
        // });
        // $('#late_edit').combodate({
        //     minuteStep: 15,
        //     minHour: 1,
        //     maxHour: 12
        // });
        // $('#early_edit').combodate({
        //     minuteStep: 15,
        //     minHour: 1,
        //     maxHour: 12
        // });
    },

    created: function created() {
        this.currentEmployee = _.cloneDeep(this.employeeObject);
        this.employee = _.cloneDeep(this.employeeObject);
    },

    watch: {
        'filterStatus': function filterStatus(val) {
            this.setStatus();
        }
    },

    events: {
        'vuetable:action': function vuetableAction(action, data) {
            //console.log('vuetable:action', action, data);
            if (action === 'view-employee') {
                this.viewModal(data);
            }

            if (action === 'employee-jobs') {
                this.searchJobs(data);
            }

            if (action === 'employee-image') {
                this.employeeImageModal(data);
            }

            if (action === 'employee-image-2') {
                this.employeeImageModal2(data);
            }

            if (action === 'employee-details') {
                //window.location.href = '/admin/employee-job-history/' + data.id;
                window.open('/admin/employee-job-history/' + data.id, '_blank');
            }

            if (action === 'edit-employee') {
                this.activeEmployee = data;
                this.editModal(data);
            }

            if (action === 'delete-employee') {
                this.confirmDelete(data);
            }
        },
        'vuetable:loading': function vuetableLoading() {
            notify.loading(true);
        },
        'vuetable:load-success': function vuetableLoadSuccess(response) {
            notify.loading(false);
        },
        'vuetable:load-error': function vuetableLoadError(response) {
            notify.loading(false);
            console.log('Load Error: ', response);
        }
    },

    methods: {

        formatDate: function formatDate(date) {
            //return moment(date).fromNow();
            var status = moment(date, "YYYY-MM-DD HH:mm:ss", true).isValid();
            if (status) {
                return moment(date).format('MM-DD-YYYY');
            } else {
                return "";
            }
        },

        status: function status(value) {
            return '<span class="text-black text-' + value.replace(/\s+/g, '-') + '">' + value.charAt(0) + '</span>';
        },

        viewModal: function viewModal(employee) {
            this.currentEmployee = _.clone(employee);
            this.currentEmployee.shifts = _.pluck(employee.shifts, 'id').map(String);
            modals.showStrict("#modal_view_employee");
        },

        /**
         * show modal to create employee
         */
        createModal: function createModal() {
            this.employee = _.cloneDeep(this.employeeObject);
            modals.showStrict("#modal_add_employee");
        },
        /**
         * prepare modal and show edit employee modal
         * @param data
         */
        editModal: function editModal(data) {
            var _this = this;

            notify.loading(true);
            this.$http.get('/api/employee/' + data.id, '', function (employee) {
                _this.currentEmployee = _.cloneDeep(employee);
                _this.currentEmployee.skills = _.pluck(employee.skills, 'id').map(Number);
                _this.currentEmployee.tools = _.pluck(employee.tools, 'id').map(Number);
                _this.currentEmployee.uniforms = _.pluck(employee.uniforms, 'id').map(Number);
                _this.currentEmployee.desired_position = employee.position_desired;
                _this.currentEmployee.dob = moment(_this.currentEmployee.dob).format('MM-DD-YYYY');
                _this.currentEmployee.hire_date = moment(_this.currentEmployee.hire_date).format('MM-DD-YYYY');
                modals.showStrict('#modal_edit_employee');
            }).always(function () {
                notify.loading(false);
            });
            //modals.hide('#draft_employees');
        },

        getData: function getData() {
            var _this2 = this;

            this.$http.get('/api/employee-data/', '', function (response) {
                _this2.commonData = response;
                // this.startTimes = _.uniq(_.pluck(response.shifts, 'start_time'));
                // this.endTimes = _.uniq(_.pluck(response.shifts, 'end_time'));
            }).always(function () {});
        },

        // selectAll() {
        //     if (!this.allSelected) {
        //         for (var i = 0, l = this.commonData.shifts.length; i < l; i++) {
        //             this.employee.shifts.push(String(this.commonData.shifts[i].id));
        //         }
        //     } else {
        //         this.employee.shifts = [];
        //     }
        // },

        // selectAllEdit() {
        //     if (!this.allSelectedEdit) {
        //         for (var i = 0, l = this.commonData.shifts.length; i < l; i++) {
        //             this.currentEmployee.shifts.push(String(this.commonData.shifts[i].id));
        //         }
        //     } else {
        //         this.currentEmployee.shifts = [];
        //     }
        // },

        createEmployee: function createEmployee() {
            var _this3 = this;

            this.state = true;
            this.employee.is_draft = 0;
            this.$http.post('/api/employee', this.employee, function () {
                //this.getData();
                // this.employee = _.cloneDeep(this.employeeObject);
                _this3.$broadcast('vuetable:refresh');
                modals.hide('#modal_add_employee');
                notify.success('New Employee Added Successfully');
                // Cookies.set('created', 'New Employee Added Successfully');
                // window.location.reload(true);
            }).always(function () {
                _this3.state = false;
            });
        },

        saveDraft: function saveDraft() {
            var _this4 = this;

            if (this.employee.first_name && this.employee.last_name) {
                this.state = true;
                this.employee.is_draft = 1;
                this.$http.post('/api/employee', this.employee, function () {
                    _this4.getData();
                    modals.hide('#modal_add_employee');
                    notify.success('Employee Added as Draft');
                }).always(function () {
                    _this4.$broadcast('vuetable:refresh');
                    _this4.state = false;
                });
            }
        },

        editEmployee: function editEmployee() {
            var _this5 = this;

            this.state = true;
            this.currentEmployee.is_draft = 0;
            this.currentEmployee.dob = moment(this.currentEmployee.dob).format('MM-DD-YYYY');
            this.currentEmployee.hire_date = moment(this.currentEmployee.hire_date).format('MM-DD-YYYY');
            this.$http.put('/api/employee/' + this.currentEmployee.id, this.currentEmployee, function () {
                //this.getData();
                _this5.$broadcast('vuetable:reload');
                modals.hide('#modal_edit_employee');
                modals.hide('#draft_employees');
                notify.success('Employee Information Edited Successfully');
            }).always(function () {
                _this5.state = false;
            });
        },

        confirmDelete: function confirmDelete(employee) {
            this.currentEmployee = employee;
            notify.confirm('Are you sure you want to remove this employee?', '', this.deleteEmployee);
        },

        deleteEmployee: function deleteEmployee() {
            var _this6 = this;

            this.$http['delete']('/api/employee/' + this.currentEmployee.id, '', function () {
                _this6.getData();
                notify.success('Employee Deleted');
            }).always(function () {
                _this6.$broadcast('vuetable:reload');
            });
        },

        searchJobs: function searchJobs(employee) {
            var _this7 = this;

            var show = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];

            notify.loading(true);
            this.currentEmployee = _.cloneDeep(employee);
            this.currentEmployee.jobs = _.pluck(employee.jobs, 'id').map(String);
            this.currentEmployee.totalPay = Number(this.currentEmployee.minimum_salary) + Number(this.currentEmployee.increased_pay);
            this.$http.get('/api/search-jobs/' + this.currentEmployee.id, '', function (response) {
                _this7.employeeJobs = response;
                _this7.jobSize = _.size(response);
                if (show) {
                    modals.showStrict('#employee_jobs');
                }
            }).always(function () {
                notify.loading(false);
            });
        },

        employeeProfileLink: function employeeProfileLink(employee) {
            if (employee.image) {
                return 'https://4bf7552dfc1a54163577-fc6d27d9aae55eef9b8e919dcfe05229.ssl.cf5.rackcdn.com//profile/' + employee.image;
            } else {
                return '/api/employee-image/' + employee.id;
            }
        },

        /**
         * delete employee image
         */
        deleteImage: function deleteImage() {
            var _this8 = this;

            notify.loading(true);
            this.$http.get('/api/delete-employee-image/' + this.currentEmployee.id, '', function (response) {
                notify.loading(false);
                modals.hide('#employee_image');
                _this8.$broadcast('vuetable:reload');
            }).always(function () {
                notify.loading(false);
            });
        },

        employeeImageModal: function employeeImageModal(employee) {
            $('.image-previewer').remove();
            $('<div id="" class="image-previewer mb-10" data-cropzee="cropzee-input"></div>').insertBefore("#cropzee-input");
            //document.getElementById('cropzee-input').src = '';
            $("#cropzee-input").val(null);
            this.currentEmployee = _.cloneDeep(employee);
            this.fileUrl = null;
            this.destroyCrop($("#cropzee-input"));
            this.imageCropUpload();
            document.getElementById('cropzee-input').src = '';
            modals.showStrict('#employee_image');
        },

        initiateCropee: function initiateCropee() {
            var _this9 = this;

            this.initiateImage = true;
            var image_crop = $('#upload-image').croppie({
                enableExif: true,
                viewport: {
                    width: 250,
                    height: 250,
                    type: 'circle'
                },
                boundary: {
                    width: 280,
                    height: 280
                }
            });
            $('#images').on('change', function () {
                var reader = new FileReader();
                reader.onload = function (e) {
                    image_crop.croppie('bind', {
                        url: e.target.result
                    }).then(function () {
                        console.log('Bind complete');
                    });
                };
                reader.readAsDataURL(this.files[0]);
            });

            var employee = this.currentEmployee;
            var that = this;
            $('.cropped_image').on('click', function (ev) {
                notify.loading(true);
                image_crop.croppie('result', {
                    type: 'canvas',
                    size: 'original',
                    quality: 1
                }).then(function (response) {
                    console.log(employee.id);
                    console.log(_this9.currentEmployee.id);
                    if (employee.id === _this9.currentEmployee.id) {
                        $.ajax({
                            url: "/api/employee-image-2/" + employee.id,
                            type: "POST",
                            data: { "image": response },
                            success: function success(data) {
                                notify.loading(false);
                                modals.hide("#employee_image_2");
                                notify.success("Image uploaded successfully.");
                                that.$broadcast('vuetable:reload');
                                // html = '<img src="' + response + '" />';
                                // $("#upload-image-i").html(html);
                            }
                        });
                    }
                });
            });
        },

        employeeImageModal2: function employeeImageModal2(employeeData) {
            var _this10 = this;

            this.$http.get('/api/employee/' + employeeData.id, '', function (employee) {
                _this10.currentEmployee = _.cloneDeep(employee);
                _this10.currentEmployee.skills = _.pluck(employee.skills, 'id').map(Number);
                _this10.currentEmployee.tools = _.pluck(employee.tools, 'id').map(Number);
                _this10.currentEmployee.uniforms = _.pluck(employee.uniforms, 'id').map(Number);
                _this10.currentEmployee.desired_position = employee.position_desired;
                _this10.currentEmployee.dob = moment(_this10.currentEmployee.dob).format('MM-DD-YYYY');
                _this10.currentEmployee.hire_date = moment(_this10.currentEmployee.hire_date).format('MM-DD-YYYY');
                $('#upload-image').croppie('destroy');
                _this10.initiateCropee();

                modals.showStrict('#employee_image_2');
            }).always(function () {});
        },

        uploadImage: function uploadImage(event) {
            var _this11 = this;

            notify.loading(true);
            var formData = new FormData();
            if (window.cropzeeReturnImage === undefined || window.cropzeeReturnImage === null) {
                var imageFile = document.querySelector('#cropzee-input');
                formData.append("image", imageFile.files[0]);
            } else {
                var blob = cropzeeGetImage('cropzee-input');
                formData.append("image", blob);
            }

            this.$http.post('/api/employee-image/' + this.currentEmployee.id, formData, function (response) {
                console.log(response);
            }).always(function (response) {
                console.log(response);
                if (response === 'success') {
                    notify.loading(false);
                    _this11.$broadcast('vuetable:reload');
                    modals.hide("#employee_image");
                    notify.success("Image uploaded successfully.");
                } else {
                    notify.error("Error uploading image, please try again later.");
                }
            });
        },

        destroyCrop: function destroyCrop($elem, eventNamespace) {
            var isInstantiated = !!$.data($elem.get(0));
            if (isInstantiated) {
                $.removeData($elem.get(0));
                $elem.off(eventNamespace);
                $elem.unbind('.' + eventNamespace);
            }
        },

        onChange: function onChange() {
            this.$refs.fileref.value = '';
        },

        imageCropUpload: function imageCropUpload() {
            $(document).ready(function () {

                $("#cropzee-input").cropzee({

                    returnImageMode: 'blob',

                    // custom aspect radio
                    aspectRatio: 1.0,

                    // min/max sizes
                    maxSize: { width: null, height: null },

                    minSize: [30, 30, '%'],

                    // start size of crop region
                    startSize: { width: 200, height: 200, unit: '%' }
                });
            });
        },

        //
        // onCropStart: function (data) {
        //     console.log(data.x, data.y, data.width, data.height);
        // },
        // onCropMove: function (data) {
        //     console.log(data.x, data.y, data.width, data.height);
        // },
        // onCropEnd: function (data) {
        //     console.log(data.x, data.y, data.width, data.height);
        // },
        // onInitialize: function (instance) {
        //     //alert('initialized');
        //     return false;
        // }

        /**
         * recalculate final pay
         */
        finalPay: function finalPay(job) {
            //job.final_pay = job.pay_rate + this.currentEmployee.increased_pay;
            if (this.currentEmployee.max_pay_rate > 0) {
                if (job.pay_rate + this.currentEmployee.increased_pay < this.currentEmployee.max_pay_rate) {
                    job.final_pay = job.pay_rate + this.currentEmployee.increased_pay;
                } else {
                    job.final_pay = this.currentEmployee.max_pay_rate;
                }
            } else {
                job.final_pay = job.pay_rate + this.currentEmployee.increased_pay;
            }
        },

        saveJobs: function saveJobs() {
            var _this12 = this;

            this.state = true;
            this.$http.put('/api/employee-jobs/' + this.currentEmployee.id, {
                'jobs': this.employeeJobs
            }, function (response) {
                _this12.searchJobs(response, false);
                notify.success('Employee jobs saved successfully');
            }).always(function () {
                _this12.$broadcast('vuetable:reload');
                _this12.state = false;
            });
        },

        setFilter: function setFilter() {
            this.moreParams = ['status=' + this.filterStatus + '&filter=' + this.query + '&zip=' + zip];
            this.$nextTick(function () {
                this.$broadcast('vuetable:refresh');
            });
        },

        setStatus: function setStatus() {
            //Cookies.set('filterStatus', this.filterStatus);
            this.moreParams = ['status=' + this.filterStatus + '&filter=' + this.query + '&zip=' + zip];
            this.$nextTick(function () {
                this.$broadcast('vuetable:refresh');
            });
        },

        clearFields: function clearFields() {
            this.employee = {
                first_name: '',
                middle_name: '',
                last_name: '',
                employee_code: '',
                dob: '',
                ss: '',
                tax_id: '',
                marital_status: '',
                no_of_dependent: '',
                gender: '',
                street: '',
                apt: '',
                city: '',
                state: '',
                zip_code: '',
                primary_phone: '',
                secondary_phone: '',
                email: '',
                password: '',
                bank_name: '',
                routing_number: '',
                account_number: '',
                legal_status: '',
                shift_required: 3,
                max_hours: 25,
                status: 'Watch List',
                hire_date: '',
                minimum_salary: 8,
                desired_position: '',
                increased_pay: '',
                max_pay_rate: '',
                payroll_group: '',
                transportation: '',
                comments: '',
                grooming: '',
                attitude: '',
                reliability: '',
                background: '',
                partners: [],
                shifts: [],
                jobs: [],
                early: '',
                late: '',
                uniforms: [],
                tools: [],
                skills: [],
                is_draft: 0
            };
        },
        clearCurrentEmployee: function clearCurrentEmployee() {
            this.currentEmployee = {
                first_name: '',
                middle_name: '',
                last_name: '',
                employee_code: '',
                dob: '',
                ss: '',
                tax_id: '',
                marital_status: '',
                no_of_dependent: '',
                gender: '',
                street: '',
                apt: '',
                city: '',
                state: '',
                zip_code: '',
                primary_phone: '',
                secondary_phone: '',
                email: '',
                password: '',
                bank_name: '',
                routing_number: '',
                account_number: '',
                legal_status: '',
                shift_required: 3,
                max_hours: 25,
                status: 'Watch List',
                hire_date: '',
                minimum_salary: 8,
                desired_position: '',
                increased_pay: '',
                max_pay_rate: '',
                payroll_group: '',
                transportation: '',
                comments: '',
                grooming: '',
                attitude: '',
                reliability: '',
                background: '',
                partners: [],
                shifts: [],
                jobs: [],
                early: '',
                late: '',
                uniforms: [],
                tools: [],
                skills: [],
                is_draft: 0
            };
        }
    }
});
module.exports = exports['default'];

},{"./../../../mixed/modals":10,"./../../../mixed/notify":11}],141:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});
var notify = require('./../../../mixed/notify');
var modals = require('./../../../mixed/modals');

var editJob = typeof canEditJob !== 'undefined' && canEditJob == true ? 'icon-pencil7 text-primary-600' : '';

var tableColumns = [{
    name: 'id',
    title: '#ID',
    sortField: 'id'
},, {
    name: 'title',
    title: 'Title',
    sortField: 'title'
}, {
    name: 'pay_rate',
    title: 'Pay Rate',
    sortField: 'pay_rate'
}, '__actions'];

// create pagination component using bootstrap styling
Vue.component('vuetable-pagination-bootstrap', {
    template: '#vuetable-pagination-bootstrap-template',
    mixins: [paginationMixin],
    methods: {
        loadPage: function loadPage(page) {
            this.$dispatch('vuetable-pagination:change-page', page);
        }
    }
});

exports['default'] = Vue.extend({
    data: function data() {
        return {
            state: false,
            job: {
                grooming: [],
                reliability: [],
                attitude: [],
                selectedUniforms: [],
                selectedTools: [],
                mandatorySkills: new Array(),
                optionalSkills: new Array(),
                payRate: 8
            },
            currentJob: {},
            uniforms: [],
            tools: [],
            mandatorySkills: [],
            optionalSkills: [],
            skills: [],
            types: ['A+', 'A', 'B', 'C', 'U'],
            query: '',
            moreParams: [],
            perPage: 15,
            columns: tableColumns,
            sortOrder: {
                field: 'id',
                direction: 'asc'
            },
            paginationInfoTemplate: 'vuetable-pagination-bootstrap',
            itemActions: [{
                name: 'edit-job',
                label: '',
                icon: editJob,
                'class': ''
            }]
        };
    },

    ready: function ready() {
        this.getUTS();
        this.currentJob = this.job;
    },

    watch: {
        'perPage': function perPage(val, oldVal) {
            this.$broadcast('vuetable:refresh');
        }
    },

    events: {
        'vuetable:action': function vuetableAction(action, data) {
            console.log('vuetable:action', action, data);
            if (action == 'edit-job') {
                this.editModal(data);
            }
        },
        'vuetable:loading': function vuetableLoading() {
            notify.loading(true);
        },
        'vuetable:load-success': function vuetableLoadSuccess() {
            notify.loading(false);
        },
        'vuetable:load-error': function vuetableLoadError(response) {
            notify.loading(false);
            console.log('Load Error: ', response);
        }
    },

    methods: {
        notOptional: function notOptional(value) {
            return !_.includes(this.job.optionalSkills, String(value));
        },
        notMandatory: function notMandatory(value) {
            return !_.includes(this.job.mandatorySkills, String(value));
        },
        notCurrentOptional: function notCurrentOptional(value) {
            return !_.includes(this.currentJob.optional_skills, String(value));
        },
        notCurrentMandatory: function notCurrentMandatory(value) {
            return !_.includes(this.currentJob.mandatory_skills, String(value));
        },
        getUTS: function getUTS() {
            var _this = this;

            this.$http.get('/api/uts/', '', function (response) {
                _this.mandatorySkills = response.skills;
                _this.optionalSkills = response.skills;
                _this.skills = response.skills;
                _this.tools = response.tools;
                _this.uniforms = response.uniforms;
            }).always(function () {});
        },
        editModal: function editModal(job) {
            this.currentJob = _.clone(job);
            this.currentJob.mandatory_skills = _.pluck(job.mandatory_skills, 'id').map(String);
            this.currentJob.optional_skills = _.pluck(job.optional_skills, 'id').map(String);
            this.currentJob.tools = _.pluck(job.tools, 'id').map(String);
            this.currentJob.uniforms = _.pluck(job.uniforms, 'id').map(String);
            this.currentJob.grooming == null ? this.currentJob.grooming = [] : '';
            this.currentJob.attitude == null ? this.currentJob.attitude = [] : '';
            this.currentJob.reliability == null ? this.currentJob.reliability = [] : '';
            modals.showStrict('#modal_edit_job');
        },
        createJob: function createJob() {
            var _this2 = this;

            this.state = true;
            this.$http.post('/api/job', this.job, function () {
                modals.hide('#modal_add_job');
                notify.success('New Job Added Successfully');
                _this2.$broadcast('vuetable:refresh');
                _this2.clearFields();
            }).always(function () {
                _this2.state = false;
            });
        },

        editJob: function editJob() {
            var _this3 = this;

            this.state = true;
            this.$http.put('/api/job/' + this.currentJob.id, this.currentJob, function (response) {
                modals.hide('#modal_edit_job');
                notify.success('Job edited successfully');
                _this3.$broadcast('vuetable:reload');
            }).always(function () {
                _this3.state = false;
            });
        },

        setFilter: function setFilter() {
            this.moreParams = ['filter=' + this.query];
            this.$nextTick(function () {
                this.$broadcast('vuetable:refresh');
            });
        },

        clearFields: function clearFields() {
            this.job = {
                grooming: [],
                reliability: [],
                attitude: [],
                selectedUniforms: [],
                selectedTools: [],
                selectedSkills: [],
                payRate: 8
            };
        }
    }
});
module.exports = exports['default'];

},{"./../../../mixed/modals":10,"./../../../mixed/notify":11}],142:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});
var notify = require('./../../../mixed/notify');
var modals = require('./../../../mixed/modals');

var tableColumns = [{
    name: 'id',
    title: '#ID',
    sortField: 'id'
}, {
    name: 'title',
    title: 'Title',
    sortField: 'title'
}, {
    name: 'client.name',
    title: 'Client'
}, {
    name: 'department.name',
    title: 'Department'
}, '__actions'];

/**
 * move index position for a element in an array
 * @param old_index
 * @param new_index
 * @returns array
 */
Array.prototype.move = function (old_index, new_index) {
    if (new_index >= this.length) {
        var k = new_index - this.length;
        while (k-- + 1) {
            this.push(undefined);
        }
    }
    this.splice(new_index, 0, this.splice(old_index, 1)[0]);
    return this; // for testing purposes
};

// create pagination component using bootstrap styling
Vue.component('vuetable-pagination-bootstrap', {
    template: '#vuetable-pagination-bootstrap-template',
    mixins: [paginationMixin],
    methods: {
        loadPage: function loadPage(page) {
            this.$dispatch('vuetable-pagination:change-page', page);
        }
    }
});

exports['default'] = Vue.extend({

    filters: {
        gross: {
            read: function read(val) {
                return val;
            },
            write: function write(val, oldVal) {
                var number = +val.replace(/[^\d.]/g, '');
                if (isNaN(number)) {
                    return 0;
                } else {
                    return number > 15 ? 0 : number;
                }
            }
        },

        net: {
            read: function read(val) {
                return val;
            },
            write: function write(val, oldVal) {
                var number = +val.replace(/[^\d.]/g, '');
                if (isNaN(number)) {
                    return 0;
                } else {
                    return number >= 40 ? 0 : number;
                }
            }
        }
    },

    data: function data() {
        return {
            commonData: [],
            state: false,
            query: [],
            perPage: 500,
            columns: tableColumns,
            moreParams: [],
            job: 0,
            client: 0,
            department: 0,
            types: ['A', 'B', 'C', 'U'],
            currentJob: {
                pay_rate: '',
                title: ''
            },
            currentClient: {},
            positions: {
                positionA: {
                    type: 'A',
                    uniforms: [],
                    tools: [],
                    skills: [],
                    grooming: [],
                    attitude: [],
                    reliability: [],
                    background: [],
                    pay_rate: 0,
                    overtime_pay_rate: 0,
                    billing_rate: 0,
                    overtime_billing_rate: 0,
                    title: '',
                    gender: ''
                },
                positionB: {
                    type: 'B',
                    uniforms: [],
                    tools: [],
                    skills: [],
                    grooming: [],
                    attitude: [],
                    reliability: [],
                    background: [],
                    pay_rate: 0,
                    overtime_pay_rate: 0,
                    billing_rate: 0,
                    overtime_billing_rate: 0,
                    title: '',
                    gender: ''
                },
                positionC: {
                    type: 'C',
                    uniforms: [],
                    tools: [],
                    skills: [],
                    grooming: [],
                    attitude: [],
                    reliability: [],
                    background: [],
                    pay_rate: 0,
                    overtime_pay_rate: 0,
                    billing_rate: 0,
                    overtime_billing_rate: 0,
                    title: '',
                    gender: ''
                }
            },
            currentPosition: {},
            data: {
                positions: {},
                client_id: '',
                department_id: '',
                job_id: '',
                pay_rate: 0,
                overtime_pay_rate: 0,
                allow_overtime_pay_rate: false,
                billing_rate: 0,
                overtime_billing_rate: 0,
                allow_overtime_billing_rate: false,
                title: '',
                gender: '',
                note: '',
                managers: [{
                    user_id: 0,
                    net: 0,
                    gross: 0,
                    per_hour: 0
                }, {
                    user_id: 0,
                    net: 0,
                    gross: 0,
                    per_hour: 0
                }, {
                    user_id: 0,
                    net: 0,
                    gross: 0,
                    per_hour: 0
                }],
                contacts: {
                    primary: '',
                    secondary: '',
                    optional: ''
                }
            },
            currentData: {
                positions: {},
                client_id: '',
                department_id: '',
                job_id: '',
                pay_rate: 0,
                overtime_pay_rate: 0,
                allow_overtime_pay_rate: false,
                billing_rate: 0,
                overtime_billing_rate: 0,
                allow_overtime_billing_rate: false,
                title: '',
                gender: '',
                note: '',
                managers: [],
                contacts: {
                    primary: '',
                    secondary: '',
                    optional: ''
                }
            },
            managers: {},
            currentManagers: {},
            sortOrder: {
                field: 'id',
                direction: 'asc'
            },
            employees: {},
            currentUniforms: {},
            currentTools: {},
            currentEmployee: {},
            paginationInfoTemplate: 'vuetable-pagination-bootstrap',
            itemActions: [{
                name: 'edit-position',
                label: '',
                icon: 'icon-pencil7 text-primary-600',
                'class': ''
            }, {
                name: 'list-employees',
                label: '<a href="#" class="label label-info ml-10 right-m-30">Employees</a>',
                icon: '',
                'class': ''
            }, {
                name: 'delete-position',
                label: '',
                icon: 'icon-trash text-danger-600',
                'class': ''
            }]
        };
    },

    events: {
        'vuetable:action': function vuetableAction(action, data) {

            if (action == 'edit-position') {
                this.editModal(data);
            }

            if (action == 'list-employees') {
                this.employeeModal(data);
            }

            if (action == 'delete-position') {
                this.confirmDelete(data);
            }
        },
        'vuetable:loading': function vuetableLoading() {
            notify.loading(true);
        },
        'vuetable:load-success': function vuetableLoadSuccess(response) {
            notify.loading(false);
        },
        'vuetable:load-error': function vuetableLoadError(response) {
            notify.loading(false);
            console.log('Load Error: ', response);
        }
    },
    ready: function ready() {
        this.getData();
        this.currentPosition = _.cloneDeep(this.position);
        var that = this;
        $('#modal_add_position').on('hidden.bs.modal', function () {
            that.clearFields();
        });
    },

    computed: {
        // currentManagers() {
        // 	var that = this;
        // 	var managers = _.cloneDeep(this.commonData.managers);
        // 	managers = _.filter(managers, function(o) {
        // 		return (o.id != that.currentData.managers[0].user_id && o.id != that.currentData.managers[1].user_id && o.id != that.currentData.managers[2].user_id);
        // 	});
        // 	return managers;
        // }
    },

    watch: {

        'data.job_id': function dataJob_id(val, oldVal) {
            this.setCurrentJob(val);
        },

        'data.client_id': function dataClient_id(val, oldVal) {
            this.department_id = 0;
            this.setClient(val);
        },

        'data.managers[0].user_id': function dataManagers0User_id(val) {
            this.filterManagers();
        },
        'data.managers[1].user_id': function dataManagers1User_id(val) {
            this.filterManagers();
        },
        'data.managers[2].user_id': function dataManagers2User_id(val) {
            this.filterManagers();
        },

        'currentData.managers[0].user_id': function currentDataManagers0User_id(val) {
            this.filterCurrentManagers();
        },
        'currentData.managers[1].user_id': function currentDataManagers1User_id(val) {
            this.filterCurrentManagers();
        },
        'currentData.managers[2].user_id': function currentDataManagers2User_id(val) {
            this.filterCurrentManagers();
        },

        'data.pay_rate': function dataPay_rate(val) {
            this.data.overtime_pay_rate = Number(val) * 1.5;
        },

        'data.billing_rate': function dataBilling_rate(val) {
            this.data.overtime_billing_rate = Number(val) * 1.5;
        },
        'currentData.pay_rate': function currentDataPay_rate(val) {
            this.currentData.overtime_pay_rate = Number(val) * 1.5;
        },

        'currentData.billing_rate': function currentDataBilling_rate(val) {
            this.currentData.overtime_billing_rate = Number(val) * 1.5;
        }
    },

    methods: {
        filterManagers: function filterManagers() {
            var that = this;
            this.managers = _.cloneDeep(this.commonData.managers);
            this.managers = _.filter(this.managers, function (o) {
                return o.id != that.data.managers[0].user_id && o.id != that.data.managers[1].user_id && o.id != that.data.managers[2].user_id;
            });
        },

        filterCurrentManagers: function filterCurrentManagers() {
            var that = this;
            this.currentManagers = _.cloneDeep(this.commonData.managers);
            this.currentManagers = _.filter(this.currentManagers, function (o) {
                return o.id != that.currentData.managers[0].user_id && o.id != that.currentData.managers[1].user_id && o.id != that.currentData.managers[2].user_id;
            });
        },

        getData: function getData() {
            var _this = this;

            this.$http.get('/api/position-data', '', function (response) {
                _this.commonData = response;
            }).always(function () {
                _this.managers = _this.commonData.managers;
                _this.currentManagers = _this.commonData.managers;
            });
        },

        setCurrentJob: function setCurrentJob(id) {
            this.currentJob = _.clone(_.find(this.commonData.jobs, function (o) {
                return o.id == id;
            }));
            this.setOrder();
            this.setEmptyUTS();
        },

        setUTS: function setUTS() {
            this.positions.positionA.tools = _.pluck(this.positions.positionA.tools, 'id').map(String);
            this.positions.positionA.skills = _.pluck(this.positions.positionA.skills, 'id').map(String);
            this.positions.positionA.uniforms = _.pluck(this.positions.positionA.uniforms, 'id').map(String);
            this.positions.positionA.type = "A";

            this.positions.positionB.tools = _.pluck(this.positions.positionB.tools, 'id').map(String);
            this.positions.positionB.skills = _.pluck(this.positions.positionB.skills, 'id').map(String);
            this.positions.positionB.uniforms = _.pluck(this.positions.positionB.uniforms, 'id').map(String);
            this.positions.positionB.type = "B";

            this.positions.positionC.tools = _.pluck(this.positions.positionC.tools, 'id').map(String);
            this.positions.positionC.skills = _.pluck(this.positions.positionC.skills, 'id').map(String);
            this.positions.positionC.uniforms = _.pluck(this.positions.positionC.uniforms, 'id').map(String);
            this.positions.positionC.type = "C";
        },

        setCurrentUTS: function setCurrentUTS() {
            this.currentPosition.positionA.tools = _.pluck(this.currentPosition.position_a.tools, 'id').map(String);
            this.currentPosition.positionA.skills = _.pluck(this.currentPosition.position_a.skills, 'id').map(String);
            this.currentPosition.positionA.uniforms = _.pluck(this.currentPosition.position_a.uniforms, 'id').map(String);
            this.currentPosition.positionA.type = "A";

            this.currentPosition.positionB.tools = _.pluck(this.currentPosition.position_b.tools, 'id').map(String);
            this.currentPosition.positionB.skills = _.pluck(this.currentPosition.position_b.skills, 'id').map(String);
            this.currentPosition.positionB.uniforms = _.pluck(this.currentPosition.position_b.uniforms, 'id').map(String);
            this.currentPosition.positionB.type = "B";

            this.currentPosition.positionC.tools = _.pluck(this.currentPosition.position_c.tools, 'id').map(String);
            this.currentPosition.positionC.skills = _.pluck(this.currentPosition.position_c.skills, 'id').map(String);
            this.currentPosition.positionC.uniforms = _.pluck(this.currentPosition.position_c.uniforms, 'id').map(String);
            this.currentPosition.positionC.type = "C";
        },

        setEmptyUTS: function setEmptyUTS() {
            this.data.pay_rate = this.currentJob != null ? this.currentJob.pay_rate : '';
            //this.data.overtime_pay_rate = Number(this.data.pay_rate) * 1.5;
            this.data.billing_rate = 0;
            this.data.overtime_billing_rate = 0;
            this.data.title = this.currentJob != null ? this.currentJob.title : '';
            this.data.gender = '';
            this.positions = {
                positionA: {
                    type: 'A',
                    uniforms: [],
                    tools: [],
                    skills: [],
                    grooming: [],
                    attitude: [],
                    reliability: [],
                    background: []
                },
                positionB: {
                    type: 'B',
                    uniforms: [],
                    tools: [],
                    skills: [],
                    grooming: [],
                    attitude: [],
                    reliability: [],
                    background: []
                },
                positionC: {
                    type: 'C',
                    uniforms: [],
                    tools: [],
                    skills: [],
                    grooming: [],
                    attitude: [],
                    reliability: [],
                    background: []
                }
            };
        },

        setClient: function setClient(id) {
            this.currentClient = _.clone(_.find(this.commonData.clients, function (o) {
                return o.id == id;
            }));
        },

        createPositions: function createPositions() {
            var _this2 = this;

            this.state = true;
            this.data.positions = this.positions;
            this.$http.post('/api/position', this.data, function (response) {
                modals.hide('#modal_add_position');
                notify.success("Positions created successfully");
                _this2.$broadcast('vuetable:refresh');
            }).always(function () {
                _this2.state = false;
            });
        },

        clearFields: function clearFields() {
            this.data.client_id = 0;
            this.data.job_id = 0;
            this.data.department_id = 0;
            this.currentJob = {
                pay_rate: '',
                title: ''
            };
        },

        confirmCopyUTS: function confirmCopyUTS() {
            notify.prompt('Are you sure you want to copy UTS to Position B and Position C?', '', this.copyUTS);
        },

        confirmCopyCurrentUTS: function confirmCopyCurrentUTS() {
            notify.prompt('Are you sure you want to copy UTS to Position B and Position C?', '', this.copyCurrentUTS);
        },

        copyUTS: function copyUTS() {
            console.log(this.positions.positionB.grooming);
            this.positions.positionB.grooming = _.cloneDeep(this.positions.positionA.grooming);
            this.positions.positionC.grooming = _.clone(this.positions.positionA.grooming);

            this.positions.positionB.attitude = _.clone(this.positions.positionA.attitude);
            this.positions.positionC.attitude = _.clone(this.positions.positionA.attitude);

            this.positions.positionB.reliability = _.clone(this.positions.positionA.reliability);
            this.positions.positionC.reliability = _.clone(this.positions.positionA.reliability);

            this.positions.positionB.background = _.clone(this.positions.positionA.background);
            this.positions.positionC.background = _.clone(this.positions.positionA.background);

            this.positions.positionB.tools = _.clone(this.positions.positionA.tools);
            this.positions.positionC.tools = _.clone(this.positions.positionA.tools);

            this.positions.positionB.skills = _.clone(this.positions.positionA.skills);
            this.positions.positionC.skills = _.clone(this.positions.positionA.skills);

            this.positions.positionB.uniforms = _.clone(this.positions.positionA.uniforms);
            this.positions.positionC.uniforms = _.clone(this.positions.positionA.uniforms);
        },

        copyCurrentUTS: function copyCurrentUTS() {
            this.currentPosition.positionB.tools = _.clone(this.currentPosition.positionA.tools);
            this.currentPosition.positionC.tools = _.clone(this.currentPosition.positionA.tools);

            this.currentPosition.positionB.skills = _.clone(this.currentPosition.positionA.skills);
            this.currentPosition.positionC.skills = _.clone(this.currentPosition.positionA.skills);

            this.currentPosition.positionB.uniforms = _.clone(this.currentPosition.positionA.uniforms);
            this.currentPosition.positionC.uniforms = _.clone(this.currentPosition.positionA.uniforms);
        },

        arrayMove: function arrayMove(arr, fromIndex, toIndex) {
            console.log(arr);
            var element = arr[fromIndex];
            arr.splice(fromIndex, 1);
            return arr.splice(toIndex, 0, element);
        },

        setOrder: function setOrder() {
            if (_.has(this.currentJob, 'grooming')) {
                this.currentJob.grooming = _.sortBy(this.currentJob.grooming, function (val) {
                    return val;
                });
                if (this.currentJob.grooming.indexOf('A+') > 0) {
                    this.currentJob.grooming.move(1, 0);
                }
            }

            if (_.has(this.currentJob, 'attitude')) {
                this.currentJob.attitude = _.sortBy(this.currentJob.attitude, function (val) {
                    return val;
                });
                if (this.currentJob.attitude.indexOf('A+') > 0) {
                    this.currentJob.attitude.move(1, 0);
                }
            }

            if (_.has(this.currentJob, 'reliability')) {
                this.currentJob.reliability = _.sortBy(this.currentJob.reliability, function (val) {
                    return val;
                });
                if (this.currentJob.reliability.indexOf('A+') > 0) {
                    this.currentJob.reliability.move(1, 0);
                }
            }
        },

        editModal: function editModal(position) {
            this.currentPosition = _.cloneDeep(position);
            this.currentData.managers = _.cloneDeep(this.currentPosition.managers);
            this.currentData.client_id = this.currentPosition.client_id;
            this.currentData.job_id = this.currentPosition.job_id;
            this.setCurrentJob(this.currentData.job_id);
            this.setClient(this.currentData.client_id);
            this.currentData.pay_rate = this.currentPosition.pay_rate;
            this.currentData.overtime_pay_rate = this.currentPosition.overtime_pay_rate;
            this.currentData.billing_rate = this.currentPosition.billing_rate;
            this.currentData.overtime_billing_rate = this.currentPosition.overtime_billing_rate;
            this.currentData.title = this.currentPosition.title;
            this.currentData.gender = this.currentPosition.gender;
            this.currentData.note = this.currentPosition.note;
            this.currentData.contacts.primary = this.currentPosition.primary_contact.contact_id;
            this.currentData.contacts.secondary = this.currentPosition.secondary_contact.contact_id;
            this.currentData.contacts.optional = this.currentPosition.optional_contact.contact_id;
            this.currentData.department_id = this.currentPosition.department_id;
            this.currentPosition.positionA = this.currentPosition.position_a;
            this.currentPosition.positionB = this.currentPosition.position_b;
            this.currentPosition.positionC = this.currentPosition.position_c;
            this.setCurrentUTS();
            modals.showStrict('#modal_edit_position');
        },

        editPositions: function editPositions() {
            var _this3 = this;

            this.currentData.positions = [this.currentPosition.positionA, this.currentPosition.positionB, this.currentPosition.positionC];
            this.state = true;
            this.$http.put('/api/position', this.currentData, function (response) {
                modals.hide('#modal_edit_position');
                notify.success("Positions updatd successfully");
                _this3.$broadcast('vuetable:refresh');
            }).always(function () {
                _this3.state = false;
            });
        },

        employeeModal: function employeeModal(position) {
            var _this4 = this;

            notify.loading(true);
            this.currentPosition = _.cloneDeep(position);
            this.$http.get('/api/position-employees/' + this.currentPosition.position_code, '', function (response) {
                _this4.employees = response;
            }).always(function () {
                notify.loading(false);
                $('.popup').popover('show');
                modals.showStrict("#list-employees");
            });
        },

        /**
         * check if all uniforms are present
         * @param employee
         * @param positionUniform
         * @returns {boolean}
         */
        isUniform: function isUniform(employee, positionUniform) {
            var employeeUniforms = _.pluck(employee.uniforms, 'id').map(String);
            var positionUniforms = _.pluck(positionUniform, 'id').map(String);
            return positionUniforms.length === _.intersection(positionUniforms, employeeUniforms).length;
        },

        /**
         * check if all tools are present
         * @param employee
         * @param positionTool
         * @returns {boolean}
         */
        isTool: function isTool(employee, positionTool) {
            var employeeTools = _.pluck(employee.tools, 'id').map(String);
            var positionTools = _.pluck(positionTool, 'id').map(String);
            return positionTools.length === _.intersection(positionTools, employeeTools).length;
        },

        /**
         * show uniforms modal
         * @param employee
         * @param uniforms
         */
        showUniforms: function showUniforms(employee, uniforms) {
            this.currentEmployee = _.cloneDeep(employee);
            this.currentUniforms = uniforms;
        },

        /**
         * show tools modal
         * @param employee
         * @param tools
         */
        showTools: function showTools(employee, tools) {
            this.currentEmployee = _.cloneDeep(employee);
            this.currentTools = tools;
        },

        /**
         * check if uniform exists in a list
         * @param uniform_id
         * @returns {*|T}
         */
        isU: function isU(uniform_id) {
            return _.findWhere(this.currentEmployee.uniforms, { id: uniform_id });
        },

        /**
         * check if tool exists in a list
         * @param tool_id
         * @returns {*|T}
         */
        isT: function isT(tool_id) {
            return _.findWhere(this.currentEmployee.tools, { id: tool_id });
        }
    }
});
module.exports = exports['default'];

},{"./../../../mixed/modals":10,"./../../../mixed/notify":11}],143:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});
var notify = require('./../../../mixed/notify');

exports['default'] = Vue.extend({
    data: function data() {
        return {
            data: {
                currentPassword: '',
                newPassword: '',
                newPassword_confirmation: ''
            },
            state: false
        };
    },

    methods: {

        /**
         * update user password
         */
        updatePassword: function updatePassword() {
            var _this = this;

            this.state = true;
            this.$http.put('/change-password/', this.data, function (response) {
                notify.success('Password changed successfully');
                _this.data = {
                    currentPassword: '',
                    newPassword: '',
                    newPassword_confirmation: ''
                };
            }).always(function () {
                _this.state = false;
            });
        }
    }
});
module.exports = exports['default'];

},{"./../../../mixed/notify":11}],144:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});
var notify = require('./../../../mixed/notify');
var modals = require('./../../../mixed/modals');
var edit_user = typeof canEditUser !== 'undefined' && canEditUser == true ? '<a href="#" class="label label-primary">Edit</a>' : '';
var change_password = typeof canChangePassword !== 'undefined' && canChangePassword == true ? '<a href="#" class="label label-info">Change Password</a>' : '';
var delete_user = typeof canDeleteUser !== 'undefined' && canDeleteUser == true ? '<a href="#" class="label label-danger">Delete</a>' : '';
var edit_client_list = typeof canEditUser !== 'undefined' && canEditUser == true ? '<a href="#" class="label label-primary">Clients</a>' : '';

var tableColumns = [{
    name: 'id',
    title: '#ID',
    sortField: 'id'
}, {
    name: 'name',
    title: 'UserName',
    sortField: 'name'
}, {
    name: 'email',
    title: 'Email',
    sortField: 'email'
}, {
    name: 'contact',
    title: 'Contact',
    sortField: 'contact'
}, {
    name: 'role_names',
    title: 'Role',
    callback: 'roleNames'
}, {
    name: 'status',
    title: 'Status',
    sortField: 'status',
    callback: 'status'
}, '__actions'];

// create pagination component using bootstrap styling
Vue.component('vuetable-pagination-bootstrap', {
    template: '#vuetable-pagination-bootstrap-template',
    mixins: [paginationMixin],
    methods: {
        loadPage: function loadPage(page) {
            this.$dispatch('vuetable-pagination:change-page', page);
        }
    }
});

exports['default'] = Vue.extend({
    data: function data() {
        return {
            demo: '',
            filterRole: '',
            newUser: {
                email: '',
                name: '',
                contact: '',
                password: '',
                role: [],
                status: '',
                clients: []
            },
            currentUser: {
                email: '',
                name: '',
                contact: '',
                newPassword: '',
                newPassword_confirmation: '',
                clients: [],
                role: []
            },
            clients: {},
            roles: {},
            query: '',
            moreParams: [],
            perPage: 150,
            state: false,
            columns: tableColumns,
            selectAllClients: false,
            sortOrder: {
                field: 'id',
                direction: 'asc'
            },
            paginationInfoTemplate: 'vuetable-pagination-bootstrap',
            itemActions: [{
                name: 'edit-user',
                label: edit_user,
                icon: '',
                'class': ''
            }, {
                name: 'edit-user-client',
                label: edit_client_list,
                icon: '',
                'class': ''
            }, {
                name: 'change-password',
                label: change_password,
                icon: '',
                'class': ''
            }, {
                name: 'delete-user',
                label: delete_user,
                icon: '',
                'class': ''
            }]
        };
    },

    ready: function ready() {
        var that = this;
        $('#modal_add_user').on('hidden.bs.modal', function () {
            that.clearFields();
        });
        $('#edit_client_list').on('hidden.bs.modal', function () {
            that.selectAllClients = false;
        });
        this.getClients();
        this.getRoles();
    },

    watch: {
        'perPage': function perPage(val, oldVal) {
            this.$broadcast('vuetable:refresh');
        },

        'filterRole': function filterRole() {
            this.setRole();
        },

        'selectAllClients': function selectAllClients(val) {
            if (val) {
                this.currentUser.clients = _.pluck(this.clients, 'id').map(Number);
            } else {
                this.currentUser.clients = [];
            }
        }
    },

    events: {
        'vuetable:action': function vuetableAction(action, data) {
            console.log('vuetable:action', action, data);
            if (action === 'edit-user') {
                this.editModal(data);
            }
            if (action === 'change-password') {
                this.passwordModal(data);
            }
            if (action === 'delete-user') {
                this.confirmDelete(data);
            }
            if (action === 'edit-user-client') {
                this.editClientListModal(data);
            }
        },
        'vuetable:loading': function vuetableLoading() {
            notify.loading(true);
        },
        'vuetable:load-success': function vuetableLoadSuccess(response) {
            notify.loading(false);
        },
        'vuetable:load-error': function vuetableLoadError(response) {
            notify.loading(false);
            console.log('Load Error: ', response);
        }
    },

    methods: {

        roleNames: function roleNames(val) {
            var roles = '';
            val.forEach(function (role) {
                roles += role + '<br/>';
            });
            return roles;
        },

        /**
         * get all users
         */
        getUsers: function getUsers() {
            var _this = this;

            this.$http.get('/api/users', '', function (response) {
                _this.users = response;
            }).always(function () {
                notify.loading(false);
            });
        },

        /**
         * get list of all clients
         */
        getClients: function getClients() {
            var _this2 = this;

            this.$http.get('/api/clients', '', function (response) {
                _this2.clients = response;
            }).always(function () {
                notify.loading(false);
            });
        },

        /**
         * get all roles
         */
        getRoles: function getRoles() {
            var _this3 = this;

            this.$http.get('/api/roles', '', function (response) {
                _this3.roles = response;
            }).always(function () {
                notify.loading(false);
            });
        },

        /**
         * send request to a add a new user
         */
        createUser: function createUser() {
            var _this4 = this;

            this.state = true;
            this.$http.post('/api/user', this.newUser, function () {
                modals.hide('#modal_add_user');
                notify.success('New User Added Successfully');
                _this4.$broadcast('vuetable:refresh');
                _this4.clearFields();
            }).always(function () {
                _this4.state = false;
            });
        },

        /**
         * show confirmation modal before sending delete request
         * @param {user} user
         */
        confirmDelete: function confirmDelete(user) {
            this.currentUser = user;
            notify.confirm('Are you sure you want to remove this user?', '', this.deleteUser);
        },

        deleteUser: function deleteUser() {
            var _this5 = this;

            this.$http['delete']('/api/user/' + this.currentUser.id, '', function (response) {
                notify.success('User Deleted');
            }).always(function () {
                _this5.$broadcast('vuetable:reload');
            });
        },

        editModal: function editModal(currentUser) {
            var user = _.cloneDeep(currentUser);
            this.currentUser = _.clone(user);
            this.currentUser.role = user.ids.map(Number);
            this.currentUser.clients = user.clientIds;
            var ids = user.clientIds;
            var roles = user.ids;
            // $('#editRoles').select2({
            //     data: roles
            // });
            // $("#editRoles").val(roles).change();
            // $('#editClients').select2({
            //     data: ids
            // });
            // $("#editClients").val(ids).change();
            modals.showStrict('#modal_edit_user');
        },

        editUser: function editUser() {
            var _this6 = this;

            this.state = true;
            this.$http.put('/api/user/' + this.currentUser.id, this.currentUser, function () {
                modals.hide('#modal_edit_user');
                notify.success('User information Edited');
            }).always(function () {
                _this6.state = false;
                _this6.$broadcast('vuetable:reload');
            });
        },

        editClientListModal: function editClientListModal(currentUser) {
            var user = _.cloneDeep(currentUser);
            this.currentUser = _.clone(user);
            this.currentUser.clients = user.clientIds;
            modals.showStrict('#edit_client_list');
        },

        editClientList: function editClientList() {
            var _this7 = this;

            this.state = true;
            this.$http.patch('/api/user-client-list/' + this.currentUser.id, this.currentUser, function () {
                modals.hide('#edit_client_list');
                notify.success('Client List Edited');
            }).always(function () {
                _this7.state = false;
                _this7.$broadcast('vuetable:reload');
            });
        },

        passwordModal: function passwordModal(user) {
            this.currentUser = _.clone(user);
            modals.showStrict('#change_password');
        },

        /**
         * update user password
         */
        updatePassword: function updatePassword() {
            var _this8 = this;

            this.state = true;
            this.$http.post('/api/user/' + this.currentUser.id + '/change-password', this.currentUser, function (response) {
                notify.success('Password changed successfully');
                _this8.currentUser.newPassword = '';
                _this8.currentUser.newPassword_confirmation = '';
                modals.hide("#change_password");
            }).always(function () {
                _this8.state = false;
            });
        },

        setFilter: function setFilter() {
            this.moreParams = ['filter=' + this.query];
            this.$nextTick(function () {
                this.$broadcast('vuetable:refresh');
            });
        },

        setRole: function setRole() {
            this.moreParams = ['role=' + this.filterRole];
            this.$nextTick(function () {
                this.$broadcast('vuetable:refresh');
            });
        },

        status: function status(val) {
            return parseInt(val) === 0 ? '<span class="label label-danger">Suspended</span>' : '<span class="label label-success">Active</span>';
        },

        clearFields: function clearFields() {
            this.newUser = {
                email: '',
                name: '',
                contact: '',
                password: '',
                role: [],
                status: '',
                clients: []
            };
        }
    }
});
module.exports = exports['default'];

},{"./../../../mixed/modals":10,"./../../../mixed/notify":11}],145:[function(require,module,exports){
'use strict';

Vue.directive('select-no-parse', {
    twoWay: true,
    priority: 10000,

    params: ['options'],

    bind: function bind() {
        var self = this;
        $(this.el).select2({
            data: this.params.options
        }).on('change', function () {
            self.set($(self.el).val());
        });
    },
    update: function update(value) {
        $(this.el).val(value).trigger('change');
    },
    unbind: function unbind() {
        $(this.el).off().select2('destroy');
    }
});

},{}],146:[function(require,module,exports){
'use strict';

Vue.directive('select-no-sort', {
    twoWay: true,
    priority: 10000,

    params: ['options'],

    bind: function bind() {
        var self = this;
        $(this.el).select2({
            data: this.params.options
        }).on('change', function () {
            var values = _.map($(self.el).val(), function (n) {
                return parseInt(n);
            });
            self.set($(self.el).val());
        });
    },
    update: function update(value) {
        $(this.el).val(value).trigger('change');
    },
    unbind: function unbind() {
        $(this.el).off().select2('destroy');
    }
});

},{}],147:[function(require,module,exports){
'use strict';

Vue.directive('select2', {
    twoWay: true,
    priority: 1000,

    params: ['options'],

    bind: function bind() {
        var self = this;
        $(this.el).select2({
            data: this.params.options
        }).on('change', function () {
            self.set(this.value);
        });
    },
    update: function update(value) {
        $(this.el).val(value).trigger('change');
    },
    unbind: function unbind() {
        $(this.el).off().select2('destroy');
    }
});

},{}],148:[function(require,module,exports){
'use strict';

Vue.directive('select', {
    twoWay: true,
    priority: 10000,

    params: ['options'],

    bind: function bind() {
        var self = this;
        $(this.el).select2({
            data: this.params.options
        }).on('change', function () {
            var values = _.map($(self.el).val(), function (n) {
                return parseInt(n);
            });
            self.set(values);
        });
    },
    update: function update(value) {
        $(this.el).val(value).trigger('change');
    },
    unbind: function unbind() {
        $(this.el).off().select2('destroy');
    }
});

// re-order select2 options
$(".sort-select").on("select2:select", function (evt) {
    var element = evt.params.data.element;
    var $element = $(element);

    $element.detach();
    $(this).append($element);
    $(this).trigger("change");
});

},{}],149:[function(require,module,exports){
"use strict";

// Vue.directive('selectpicker', {
//     twoWay: true,
//     deep: true,

//     bind: function() {
//         $(this.el).selectpicker().on("change", function(e) {
//             this.set($(this.el).val());
//         }.bind(this));
//     },
//     update: function(value) {
//         $(this.el).selectpicker('refresh').trigger("change");
//     },
//     unbind: function() {
//         $(this.el).off().selectpicker('destroy');
//     }
// });

},{}],150:[function(require,module,exports){
'use strict';

Vue.directive('submit', {
  initialHTML: '',
  bind: function bind() {
    this.initialHTML = $(this.el).html();
  },

  update: function update(value) {
    if (value) {
      $(this.el).html('<i class="icon-spinner9 spinner position-left"></i>');
      this.el.disabled = true;
    } else {
      $(this.el).html(this.initialHTML);
      this.el.disabled = false;
    }
  }
});

},{}],151:[function(require,module,exports){
'use strict';

Vue.directive('vue-selectric', {
    twoWay: true,
    priority: 10000,

    params: ['options'],

    bind: function bind() {
        var self = this;
        // $(this.el)
        //     .select2({
        //         data: this.params.options
        //     })
        //     .on('change', function () {
        //         self.set($(self.el).val());
        //     });
        $(this.el).selectric({
            onChange: function onChange(element) {
                self.set($(element).val());
                //alert( $(element).val() );
            }
        });
    },
    update: function update(value) {
        //$(this.el).selectric('refresh');
    },
    unbind: function unbind() {
        //$(this.el).off().select2('destroy');
    }
});

},{}],152:[function(require,module,exports){
'use strict';

Vue.filter('customDateFormat', function (date, from, format) {
    if (date) {
        return moment(date, from).format(format);
    }

    return '';
});

Vue.filter('minuteToHour', function (val) {
    return (Number(val) / 60).toFixed(2);
});

Vue.filter('payrollGroup', function (val) {
    if (val === 11) {
        return 'Advanced Pay';
    }
    if (val === 12) {
        return 'Cash Paid';
    }
    return 'Payroll Group - ' + val;
});

Vue.filter('amountPaid', function (val, rate) {
    return ((Number(val) / 60).toFixed(2) * rate).toFixed(2);
});

Vue.filter('formatNote', function (allNote) {
    var notes = allNote.split('##########');
    var fullNote = '<ul>';
    if (notes.length > 0) {
        notes.map(function (note) {
            var parts = note.split('|||');
            if (parts[parts.length - 1]) {
                fullNote += '<li>' + parts[parts.length - 1] + '</li>';
            }
        });
    }

    return fullNote + '</ul>';
});

},{}],153:[function(require,module,exports){
'use strict';

Vue.config.devtools = true;
// Vue.config.debug = false;
// Vue.config.silent = true;

require('./directives/submit');
require('./directives/select2');
require('./directives/select');
require('./directives/select-no-sort');
require('./directives/select-no-parse');
require('./directives/selectpicker');
require('./directives/vue-selectric');
require('./components');
require('./filters');

},{"./components":12,"./directives/select":147,"./directives/select-no-parse":145,"./directives/select-no-sort":146,"./directives/select2":148,"./directives/selectpicker":149,"./directives/submit":150,"./directives/vue-selectric":151,"./filters":152}]},{},[7]);
